/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1325);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(85);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1025)();
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.20.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

var hookCallback;

function hooks () {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback (callback) {
    hookCallback = callback;
}

function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}

function isObjectEmpty(obj) {
    if (Object.getOwnPropertyNames) {
        return (Object.getOwnPropertyNames(obj).length === 0);
    } else {
        var k;
        for (k in obj) {
            if (obj.hasOwnProperty(k)) {
                return false;
            }
        }
        return true;
    }
}

function isUndefined(input) {
    return input === void 0;
}

function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}

function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}

function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty           : false,
        unusedTokens    : [],
        unusedInput     : [],
        overflow        : -2,
        charsLeftOver   : 0,
        nullInput       : false,
        invalidMonth    : null,
        invalidFormat   : false,
        userInvalidated : false,
        iso             : false,
        parsedDateParts : [],
        meridiem        : null,
        rfc2822         : false,
        weekdayMismatch : false
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.weekdayMismatch &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid (flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

var updateInProgress = false;

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment (obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}

function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}

function set (config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        } else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' + (/\d{1,2}/).source);
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var defaultCalendar = {
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    nextWeek : 'dddd [at] LT',
    lastDay : '[Yesterday at] LT',
    lastWeek : '[Last] dddd [at] LT',
    sameElse : 'L'
};

function calendar (key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

var defaultLongDateFormat = {
    LTS  : 'h:mm:ss A',
    LT   : 'h:mm A',
    L    : 'MM/DD/YYYY',
    LL   : 'MMMM D, YYYY',
    LLL  : 'MMMM D, YYYY h:mm A',
    LLLL : 'dddd, MMMM D, YYYY h:mm A'
};

function longDateFormat (key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate () {
    return this._invalidDate;
}

var defaultOrdinal = '%d';
var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

function ordinal (number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future : 'in %s',
    past   : '%s ago',
    s  : 'a few seconds',
    ss : '%d seconds',
    m  : 'a minute',
    mm : '%d minutes',
    h  : 'an hour',
    hh : '%d hours',
    d  : 'a day',
    dd : '%d days',
    M  : 'a month',
    MM : '%d months',
    y  : 'a year',
    yy : '%d years'
};

function relativeTime (number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}

function pastFuture (diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias (unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({unit: u, priority: priorities[u]});
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

var formatFunctions = {};

var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken (token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var match1         = /\d/;            //       0 - 9
var match2         = /\d\d/;          //      00 - 99
var match3         = /\d{3}/;         //     000 - 999
var match4         = /\d{4}/;         //    0000 - 9999
var match6         = /[+-]?\d{6}/;    // -999999 - 999999
var match1to2      = /\d\d?/;         //       0 - 99
var match3to4      = /\d\d\d\d?/;     //     999 - 9999
var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3      = /\d{1,3}/;       //       0 - 999
var match1to4      = /\d{1,4}/;       //       0 - 9999
var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

var matchUnsigned  = /\d+/;           //       0 - inf
var matchSigned    = /[+-]?\d+/;      //    -inf - inf

var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;


var regexes = {};

function addRegexToken (token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}

function getParseRegexForToken (token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken (token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken (token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY',   4],       0, 'year');
addFormatToken(0, ['YYYYY',  5],       0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y',      matchSigned);
addRegexToken('YY',     match1to2, match2);
addRegexToken('YYYY',   match1to4, match4);
addRegexToken('YYYYY',  match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear () {
    return isLeapYear(this.year());
}

function makeGetSet (unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get (mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}

function set$1 (mom, unit, value) {
    if (mom.isValid() && !isNaN(value)) {
        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
        }
        else {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }
}

// MOMENTS

function stringGet (units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}


function stringSet (units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

function mod(n, x) {
    return ((n % x) + x) % x;
}

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

function daysInMonth(year, month) {
    if (isNaN(year) || isNaN(month)) {
        return NaN;
    }
    var modMonth = mod(month, 12);
    year += (month - modMonth) / 12;
    return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M',    match1to2);
addRegexToken('MM',   match1to2, match2);
addRegexToken('MMM',  function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths (m, format) {
    if (!m) {
        return isArray(this._months) ? this._months :
            this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}

var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort (m, format) {
    if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort :
            this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse (monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth (mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth (value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth () {
    return daysInMonth(this.year(), this.month());
}

var defaultMonthsShortRegex = matchWord;
function monthsShortRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}

var defaultMonthsRegex = matchWord;
function monthsRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}

function computeMonthsParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}

function createDate (y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date = new Date(y, m, d, h, M, s, ms);

    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
    }
    return date;
}

function createUTCDate (y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear, resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek, resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w',  match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W',  match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek (mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow : 0, // Sunday is the first day of the week.
    doy : 6  // The week that contains Jan 1st is the first week of the year.
};

function localeFirstDayOfWeek () {
    return this._week.dow;
}

function localeFirstDayOfYear () {
    return this._week.doy;
}

// MOMENTS

function getSetWeek (input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek (input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d',    match1to2);
addRegexToken('e',    match1to2);
addRegexToken('E',    match1to2);
addRegexToken('dd',   function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd',   function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd',   function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays (m, format) {
    if (!m) {
        return isArray(this._weekdays) ? this._weekdays :
            this._weekdays['standalone'];
    }
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
}

var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort (m) {
    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}

var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin (m) {
    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse (weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

var defaultWeekdaysRegex = matchWord;
function weekdaysRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}

var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}

var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}


function computeWeekdaysParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

function meridiem (token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem (isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a',  matchMeridiem);
addRegexToken('A',  matchMeridiem);
addRegexToken('H',  match1to2);
addRegexToken('h',  match1to2);
addRegexToken('k',  match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM (input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem (hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);

// months
// week
// weekdays
// meridiem
var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
};

// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return null;
}

function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
        try {
            oldLocale = globalLocale._abbr;
            var aliasedRequire = require;
            __webpack_require__(1020)("./" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {}
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale (key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
    }

    return globalLocale._abbr;
}

function defineLocale (name, config) {
    if (config !== null) {
        var parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                if (!localeFamilies[config.parentLocale]) {
                    localeFamilies[config.parentLocale] = [];
                }
                localeFamilies[config.parentLocale].push({
                    name: name,
                    config: config
                });
                return null;
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);


        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale, tmpLocale, parentConfig = baseConfig;
        // MERGE
        tmpLocale = loadLocale(name);
        if (tmpLocale != null) {
            parentConfig = tmpLocale._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale (key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys(locales);
}

function checkOverflow (m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
            -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray (config) {
    var i, date, input = [], currentDate, expectedWeekday, yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }

    // check for mismatching day of week
    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
        getParsingFlags(config).weekdayMismatch = true;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from begining of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to begining of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];

// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];

var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
function configFromISO(config) {
    var i, l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = [
        untruncateYear(yearStr),
        defaultLocaleMonthsShort.indexOf(monthStr),
        parseInt(dayStr, 10),
        parseInt(hourStr, 10),
        parseInt(minuteStr, 10)
    ];

    if (secondStr) {
        result.push(parseInt(secondStr, 10));
    }

    return result;
}

function untruncateYear(yearStr) {
    var year = parseInt(yearStr, 10);
    if (year <= 49) {
        return 2000 + year;
    } else if (year <= 999) {
        return 1900 + year;
    }
    return year;
}

function preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
}

function checkWeekday(weekdayStr, parsedInput, config) {
    if (weekdayStr) {
        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
            weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
        if (weekdayProvided !== weekdayActual) {
            getParsingFlags(config).weekdayMismatch = true;
            config._isValid = false;
            return false;
        }
    }
    return true;
}

var obsOffsets = {
    UT: 0,
    GMT: 0,
    EDT: -4 * 60,
    EST: -5 * 60,
    CDT: -5 * 60,
    CST: -6 * 60,
    MDT: -6 * 60,
    MST: -7 * 60,
    PDT: -7 * 60,
    PST: -8 * 60
};

function calculateOffset(obsOffset, militaryOffset, numOffset) {
    if (obsOffset) {
        return obsOffsets[obsOffset];
    } else if (militaryOffset) {
        // the only allowed military tz is Z
        return 0;
    } else {
        var hm = parseInt(numOffset, 10);
        var m = hm % 100, h = (hm - m) / 100;
        return h * 60 + m;
    }
}

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var match = rfc2822.exec(preprocessRFC2822(config._i));
    if (match) {
        var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
        if (!checkWeekday(match[1], parsedArray, config)) {
            return;
        }

        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);

        config._d = createUTCDate.apply(null, config._a);
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

        getParsingFlags(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    // Final attempt, use Input Fallback
    hooks.createFromInputFallback(config);
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i, parsedInput, tokens, token, skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
}


function meridiemFixWrap (locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,

        scoreToBeat,
        i,
        currentScore;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
            continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });

    configFromArray(config);
}

function createFromConfig (config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig (config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({nullInput: true});
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    }  else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC (input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

var prototypeMax = deprecate(
    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +(new Date());
};

var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

function isDurationValid(m) {
    for (var key in m) {
        if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
            return false;
        }
    }

    var unitHasDecimal = false;
    for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid$1() {
    return this._isValid;
}

function createInvalid$1() {
    return createDuration(NaN);
}

function Duration (duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible to translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration (obj) {
    return obj instanceof Duration;
}

function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// FORMATTING

function offset (token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z',  matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
        return null;
    }

    var chunk   = matches[matches.length - 1] || [];
    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ?
      0 :
      parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset (m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset (input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone (input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC (keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal (keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset () {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset (input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime () {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted () {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal () {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset () {
    return this.isValid() ? this._isUTC : false;
}

function isUtc () {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

function createDuration (input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms : input._milliseconds,
            d  : input._days,
            M  : input._months
        };
    } else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        } else {
            duration.milliseconds = input;
        }
    } else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y  : 0,
            d  : toInt(match[DATE])                         * sign,
            h  : toInt(match[HOUR])                         * sign,
            m  : toInt(match[MINUTE])                       * sign,
            s  : toInt(match[SECOND])                       * sign,
            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    } else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
        duration = {
            y : parseIso(match[2], sign),
            M : parseIso(match[3], sign),
            w : parseIso(match[4], sign),
            d : parseIso(match[5], sign),
            h : parseIso(match[6], sign),
            m : parseIso(match[7], sign),
            s : parseIso(match[8], sign)
        };
    } else if (duration == null) {// checks for null or undefined
        duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    return ret;
}

createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;

function parseIso (inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {milliseconds: 0, months: 0};

    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return {milliseconds: 0, months: 0};
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val; val = period; period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract (mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add      = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
            diff < 1 ? 'sameDay' :
            diff < 2 ? 'nextDay' :
            diff < 7 ? 'nextWeek' : 'sameElse';
}

function calendar$1 (time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}

function clone () {
    return new Moment(this);
}

function isAfter (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween (from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
}

function isSame (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}

function isSameOrAfter (input, units) {
    return this.isSame(input, units) || this.isAfter(input,units);
}

function isSameOrBefore (input, units) {
    return this.isSame(input, units) || this.isBefore(input,units);
}

function diff (input, units, asFloat) {
    var that,
        zoneDelta,
        delta, output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    switch (units) {
        case 'year': output = monthDiff(this, that) / 12; break;
        case 'month': output = monthDiff(this, that); break;
        case 'quarter': output = monthDiff(this, that) / 3; break;
        case 'second': output = (this - that) / 1e3; break; // 1000
        case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
        case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
        case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
        case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
        default: output = this - that;
    }

    return asFloat ? output : absFloor(output);
}

function monthDiff (a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2, adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString () {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString(keepOffset) {
    if (!this.isValid()) {
        return null;
    }
    var utc = keepOffset !== true;
    var m = utc ? this.clone().utc() : this;
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        if (utc) {
            return this.toDate().toISOString();
        } else {
            return new Date(this._d.valueOf()).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
    }
    return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect () {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format (inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow (withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow (withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale (key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData () {
    return this._locale;
}

function startOf (units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
        case 'date':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
    }

    // weeks are a special case
    if (units === 'week') {
        this.weekday(0);
    }
    if (units === 'isoWeek') {
        this.isoWeekday(1);
    }

    // quarters are also special
    if (units === 'quarter') {
        this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
}

function endOf (units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
        return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === 'date') {
        units = 'day';
    }

    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
}

function valueOf () {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}

function unix () {
    return Math.floor(this.valueOf() / 1000);
}

function toDate () {
    return new Date(this.valueOf());
}

function toArray () {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}

function toObject () {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}

function toJSON () {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$2 () {
    return isValid(this);
}

function parsingFlags () {
    return extend({}, getParsingFlags(this));
}

function invalidAt () {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken (token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg',     'weekYear');
addWeekYearFormatToken('ggggg',    'weekYear');
addWeekYearFormatToken('GGGG',  'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);


// PARSING

addRegexToken('G',      matchSigned);
addRegexToken('g',      matchSigned);
addRegexToken('GG',     match1to2, match2);
addRegexToken('gg',     match1to2, match2);
addRegexToken('GGGG',   match1to4, match4);
addRegexToken('gggg',   match1to4, match4);
addRegexToken('GGGGG',  match1to6, match6);
addRegexToken('ggggg',  match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
}

function getSetISOWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
}

function getISOWeeksInYear () {
    return weeksInYear(this.year(), 1, 4);
}

function getWeeksInYear () {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter (input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIOROITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D',  match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ?
      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
      locale._dayOfMonthOrdinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0]);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD',  match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear (input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m',  match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s',  match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});


// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S',    match1to3, match1);
addRegexToken('SS',   match1to3, match2);
addRegexToken('SSS',  match1to3, match3);

var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS

var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z',  0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr () {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName () {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add               = add;
proto.calendar          = calendar$1;
proto.clone             = clone;
proto.diff              = diff;
proto.endOf             = endOf;
proto.format            = format;
proto.from              = from;
proto.fromNow           = fromNow;
proto.to                = to;
proto.toNow             = toNow;
proto.get               = stringGet;
proto.invalidAt         = invalidAt;
proto.isAfter           = isAfter;
proto.isBefore          = isBefore;
proto.isBetween         = isBetween;
proto.isSame            = isSame;
proto.isSameOrAfter     = isSameOrAfter;
proto.isSameOrBefore    = isSameOrBefore;
proto.isValid           = isValid$2;
proto.lang              = lang;
proto.locale            = locale;
proto.localeData        = localeData;
proto.max               = prototypeMax;
proto.min               = prototypeMin;
proto.parsingFlags      = parsingFlags;
proto.set               = stringSet;
proto.startOf           = startOf;
proto.subtract          = subtract;
proto.toArray           = toArray;
proto.toObject          = toObject;
proto.toDate            = toDate;
proto.toISOString       = toISOString;
proto.inspect           = inspect;
proto.toJSON            = toJSON;
proto.toString          = toString;
proto.unix              = unix;
proto.valueOf           = valueOf;
proto.creationData      = creationData;

// Year
proto.year       = getSetYear;
proto.isLeapYear = getIsLeapYear;

// Week Year
proto.weekYear    = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;

// Quarter
proto.quarter = proto.quarters = getSetQuarter;

// Month
proto.month       = getSetMonth;
proto.daysInMonth = getDaysInMonth;

// Week
proto.week           = proto.weeks        = getSetWeek;
proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
proto.weeksInYear    = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;

// Day
proto.date       = getSetDayOfMonth;
proto.day        = proto.days             = getSetDayOfWeek;
proto.weekday    = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear  = getSetDayOfYear;

// Hour
proto.hour = proto.hours = getSetHour;

// Minute
proto.minute = proto.minutes = getSetMinute;

// Second
proto.second = proto.seconds = getSetSecond;

// Millisecond
proto.millisecond = proto.milliseconds = getSetMillisecond;

// Offset
proto.utcOffset            = getSetOffset;
proto.utc                  = setOffsetToUTC;
proto.local                = setOffsetToLocal;
proto.parseZone            = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST                = isDaylightSavingTime;
proto.isLocal              = isLocal;
proto.isUtcOffset          = isUtcOffset;
proto.isUtc                = isUtc;
proto.isUTC                = isUtc;

// Timezone
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;

// Deprecations
proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

function createUnix (input) {
    return createLocal(input * 1000);
}

function createInZone () {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat (string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar        = calendar;
proto$1.longDateFormat  = longDateFormat;
proto$1.invalidDate     = invalidDate;
proto$1.ordinal         = ordinal;
proto$1.preparse        = preParsePostFormat;
proto$1.postformat      = preParsePostFormat;
proto$1.relativeTime    = relativeTime;
proto$1.pastFuture      = pastFuture;
proto$1.set             = set;

// Month
proto$1.months            =        localeMonths;
proto$1.monthsShort       =        localeMonthsShort;
proto$1.monthsParse       =        localeMonthsParse;
proto$1.monthsRegex       = monthsRegex;
proto$1.monthsShortRegex  = monthsShortRegex;

// Week
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

// Day of Week
proto$1.weekdays       =        localeWeekdays;
proto$1.weekdaysMin    =        localeWeekdaysMin;
proto$1.weekdaysShort  =        localeWeekdaysShort;
proto$1.weekdaysParse  =        localeWeekdaysParse;

proto$1.weekdaysRegex       =        weekdaysRegex;
proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

// Hours
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1 (format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl (format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl (localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths (format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort (format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

// Side effect imports
hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

var mathAbs = Math.abs;

function abs () {
    var data           = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days         = mathAbs(this._days);
    this._months       = mathAbs(this._months);

    data.milliseconds  = mathAbs(data.milliseconds);
    data.seconds       = mathAbs(data.seconds);
    data.minutes       = mathAbs(data.minutes);
    data.hours         = mathAbs(data.hours);
    data.months        = mathAbs(data.months);
    data.years         = mathAbs(data.years);

    return this;
}

function addSubtract$1 (duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days         += direction * other._days;
    duration._months       += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1 (input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1 (input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble () {
    var milliseconds = this._milliseconds;
    var days         = this._days;
    var months       = this._months;
    var data         = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds           = absFloor(milliseconds / 1000);
    data.seconds      = seconds % 60;

    minutes           = absFloor(seconds / 60);
    data.minutes      = minutes % 60;

    hours             = absFloor(minutes / 60);
    data.hours        = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days   = days;
    data.months = months;
    data.years  = years;

    return this;
}

function daysToMonths (days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}

function monthsToDays (months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}

function as (units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
        days   = this._days   + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === 'month' ? months : months / 12;
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week'   : return days / 7     + milliseconds / 6048e5;
            case 'day'    : return days         + milliseconds / 864e5;
            case 'hour'   : return days * 24    + milliseconds / 36e5;
            case 'minute' : return days * 1440  + milliseconds / 6e4;
            case 'second' : return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1 () {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs (alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms');
var asSeconds      = makeAs('s');
var asMinutes      = makeAs('m');
var asHours        = makeAs('h');
var asDays         = makeAs('d');
var asWeeks        = makeAs('w');
var asMonths       = makeAs('M');
var asYears        = makeAs('y');

function clone$1 () {
    return createDuration(this);
}

function get$2 (units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds');
var seconds      = makeGetter('seconds');
var minutes      = makeGetter('minutes');
var hours        = makeGetter('hours');
var days         = makeGetter('days');
var months       = makeGetter('months');
var years        = makeGetter('years');

function weeks () {
    return absFloor(this.days() / 7);
}

var round = Math.round;
var thresholds = {
    ss: 44,         // a few seconds to seconds
    s : 45,         // seconds to minute
    m : 45,         // minutes to hour
    h : 22,         // hours to day
    d : 26,         // days to month
    M : 11          // months to year
};

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds  = round(duration.as('s'));
    var minutes  = round(duration.as('m'));
    var hours    = round(duration.as('h'));
    var days     = round(duration.as('d'));
    var months   = round(duration.as('M'));
    var years    = round(duration.as('y'));

    var a = seconds <= thresholds.ss && ['s', seconds]  ||
            seconds < thresholds.s   && ['ss', seconds] ||
            minutes <= 1             && ['m']           ||
            minutes < thresholds.m   && ['mm', minutes] ||
            hours   <= 1             && ['h']           ||
            hours   < thresholds.h   && ['hh', hours]   ||
            days    <= 1             && ['d']           ||
            days    < thresholds.d   && ['dd', days]    ||
            months  <= 1             && ['M']           ||
            months  < thresholds.M   && ['MM', months]  ||
            years   <= 1             && ['y']           || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding (roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof(roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold (threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize (withSuffix) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function sign(x) {
    return ((x > 0) - (x < 0)) || +x;
}

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000;
    var days         = abs$1(this._days);
    var months       = abs$1(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes           = absFloor(seconds / 60);
    hours             = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years  = absFloor(months / 12);
    months %= 12;


    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
    var total = this.asSeconds();

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    var totalSign = total < 0 ? '-' : '';
    var ymSign = sign(this._months) !== sign(total) ? '-' : '';
    var daysSign = sign(this._days) !== sign(total) ? '-' : '';
    var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

    return totalSign + 'P' +
        (Y ? ymSign + Y + 'Y' : '') +
        (M ? ymSign + M + 'M' : '') +
        (D ? daysSign + D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? hmsSign + h + 'H' : '') +
        (m ? hmsSign + m + 'M' : '') +
        (s ? hmsSign + s + 'S' : '');
}

var proto$2 = Duration.prototype;

proto$2.isValid        = isValid$1;
proto$2.abs            = abs;
proto$2.add            = add$1;
proto$2.subtract       = subtract$1;
proto$2.as             = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds      = asSeconds;
proto$2.asMinutes      = asMinutes;
proto$2.asHours        = asHours;
proto$2.asDays         = asDays;
proto$2.asWeeks        = asWeeks;
proto$2.asMonths       = asMonths;
proto$2.asYears        = asYears;
proto$2.valueOf        = valueOf$1;
proto$2._bubble        = bubble;
proto$2.clone          = clone$1;
proto$2.get            = get$2;
proto$2.milliseconds   = milliseconds;
proto$2.seconds        = seconds;
proto$2.minutes        = minutes;
proto$2.hours          = hours;
proto$2.days           = days;
proto$2.weeks          = weeks;
proto$2.months         = months;
proto$2.years          = years;
proto$2.humanize       = humanize;
proto$2.toISOString    = toISOString$1;
proto$2.toString       = toISOString$1;
proto$2.toJSON         = toISOString$1;
proto$2.locale         = locale;
proto$2.localeData     = localeData;

// Deprecations
proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;

// Side effect imports

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

// Side effect imports


hooks.version = '2.20.1';

setHookCallback(createLocal);

hooks.fn                    = proto;
hooks.min                   = min;
hooks.max                   = max;
hooks.now                   = now;
hooks.utc                   = createUTC;
hooks.unix                  = createUnix;
hooks.months                = listMonths;
hooks.isDate                = isDate;
hooks.locale                = getSetGlobalLocale;
hooks.invalid               = createInvalid;
hooks.duration              = createDuration;
hooks.isMoment              = isMoment;
hooks.weekdays              = listWeekdays;
hooks.parseZone             = createInZone;
hooks.localeData            = getLocale;
hooks.isDuration            = isDuration;
hooks.monthsShort           = listMonthsShort;
hooks.weekdaysMin           = listWeekdaysMin;
hooks.defineLocale          = defineLocale;
hooks.updateLocale          = updateLocale;
hooks.locales               = listLocales;
hooks.weekdaysShort         = listWeekdaysShort;
hooks.normalizeUnits        = normalizeUnits;
hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat        = getCalendarFormat;
hooks.prototype             = proto;

// currently HTML5 input type only supports 24-hour formats
hooks.HTML5_FMT = {
    DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
    DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
    DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
    DATE: 'YYYY-MM-DD',                             // <input type="date" />
    TIME: 'HH:mm',                                  // <input type="time" />
    TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
    TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
    WEEK: 'YYYY-[W]WW',                             // <input type="week" />
    MONTH: 'YYYY-MM'                                // <input type="month" />
};

return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(163)(module)))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return epsilon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return epsilon2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return pi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return halfPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return quarterPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return tau; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return degrees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return radians; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return abs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return atan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return atan2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return cos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return ceil; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return exp; });
/* unused harmony export floor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return log; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return pow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return sin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return sign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return sqrt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return tan; });
/* harmony export (immutable) */ __webpack_exports__["r"] = acos;
/* harmony export (immutable) */ __webpack_exports__["f"] = asin;
/* harmony export (immutable) */ __webpack_exports__["u"] = haversin;
var epsilon = 1e-6;
var epsilon2 = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var quarterPi = pi / 4;
var tau = pi * 2;

var degrees = 180 / pi;
var radians = pi / 180;

var abs = Math.abs;
var atan = Math.atan;
var atan2 = Math.atan2;
var cos = Math.cos;
var ceil = Math.ceil;
var exp = Math.exp;
var floor = Math.floor;
var log = Math.log;
var pow = Math.pow;
var sin = Math.sin;
var sign = Math.sign || function(x) { return x > 0 ? 1 : x < 0 ? -1 : 0; };
var sqrt = Math.sqrt;
var tan = Math.tan;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}

function asin(x) {
  return x > 1 ? halfPi : x < -1 ? -halfPi : Math.asin(x);
}

function haversin(x) {
  return (x = sin(x / 2)) * x;
}


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyFunction = __webpack_require__(30);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  (function () {
    var printWarning = function printWarning(format) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };

    warning = function warning(condition, format) {
      if (format === undefined) {
        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
      }

      if (format.indexOf('Failed Composite propType: ') === 0) {
        return; // Ignore CompositeComponent proptype check.
      }

      if (!condition) {
        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }

        printWarning.apply(undefined, [format].concat(args));
      }
    };
  })();
}

module.exports = warning;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_voronoi__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__animation__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_scales_utils__ = __webpack_require__(25);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.








var propTypes = _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_scales_utils__["i" /* getScalePropTypesByAttribute */])('x'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_scales_utils__["i" /* getScalePropTypesByAttribute */])('y'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_scales_utils__["i" /* getScalePropTypesByAttribute */])('size'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_scales_utils__["i" /* getScalePropTypesByAttribute */])('opacity'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_scales_utils__["i" /* getScalePropTypesByAttribute */])('color'), {
  width: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  data: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
  onValueMouseOver: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onValueMouseOut: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onValueClick: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onSeriesMouseOver: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onSeriesMouseOut: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onSeriesClick: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onNearestX: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onNearestXY: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  style: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  animation: __WEBPACK_IMPORTED_MODULE_3__animation__["a" /* AnimationPropType */]
});

var defaultProps = {
  className: '',
  style: {}
};

var AbstractSeries = function (_PureComponent) {
  _inherits(AbstractSeries, _PureComponent);

  _createClass(AbstractSeries, null, [{
    key: 'getParentConfig',


    /**
     * Get a default config for the parent.
     * @returns {Object} Empty config.
     */
    value: function getParentConfig() {
      return {};
    }
  }, {
    key: 'requiresSVG',

    /**
     * Tells the rest of the world that it requires SVG to work.
     * @returns {boolean} Result.
     */
    get: function get() {
      return true;
    }
  }]);

  function AbstractSeries(props) {
    _classCallCheck(this, AbstractSeries);

    var _this = _possibleConstructorReturn(this, (AbstractSeries.__proto__ || Object.getPrototypeOf(AbstractSeries)).call(this, props));

    _this._seriesMouseOverHandler = _this._seriesMouseOverHandler.bind(_this);
    _this._valueMouseOverHandler = _this._valueMouseOverHandler.bind(_this);
    _this._seriesMouseOutHandler = _this._seriesMouseOutHandler.bind(_this);
    _this._valueMouseOutHandler = _this._valueMouseOutHandler.bind(_this);
    _this._seriesClickHandler = _this._seriesClickHandler.bind(_this);
    _this._valueClickHandler = _this._valueClickHandler.bind(_this);
    return _this;
  }

  /**
   * Mouse over handler for the specific series' value.
   * @param {Object} d Value object
   * @param {Object} event Event.
   * @protected
   */


  _createClass(AbstractSeries, [{
    key: '_valueMouseOverHandler',
    value: function _valueMouseOverHandler(d, event) {
      var _props = this.props,
          onValueMouseOver = _props.onValueMouseOver,
          onSeriesMouseOver = _props.onSeriesMouseOver;

      if (onValueMouseOver) {
        onValueMouseOver(d, { event: event });
      }
      if (onSeriesMouseOver) {
        onSeriesMouseOver({ event: event });
      }
    }

    /**
     * Mouse over handler for the entire series.
     * @param {Object} event Event.
     * @protected
     */

  }, {
    key: '_seriesMouseOverHandler',
    value: function _seriesMouseOverHandler(event) {
      var onSeriesMouseOver = this.props.onSeriesMouseOver;

      if (onSeriesMouseOver) {
        onSeriesMouseOver({ event: event });
      }
    }

    /**
     * Mouse out handler for the specific series' value.
     * @param {Object} d Value object
     * @param {Object} event Event.
     * @protected
     */

  }, {
    key: '_valueMouseOutHandler',
    value: function _valueMouseOutHandler(d, event) {
      var _props2 = this.props,
          onValueMouseOut = _props2.onValueMouseOut,
          onSeriesMouseOut = _props2.onSeriesMouseOut;

      if (onValueMouseOut) {
        onValueMouseOut(d, { event: event });
      }
      if (onSeriesMouseOut) {
        onSeriesMouseOut({ event: event });
      }
    }

    /**
     * Mouse out handler for the entire series.
     * @param {Object} event Event.
     * @protected
     */

  }, {
    key: '_seriesMouseOutHandler',
    value: function _seriesMouseOutHandler(event) {
      var onSeriesMouseOut = this.props.onSeriesMouseOut;

      if (onSeriesMouseOut) {
        onSeriesMouseOut({ event: event });
      }
    }

    /**
     * Click handler for the specific series' value.
     * @param {Object} d Value object
     * @param {Object} event Event.
     * @protected
     */

  }, {
    key: '_valueClickHandler',
    value: function _valueClickHandler(d, event) {
      var _props3 = this.props,
          onValueClick = _props3.onValueClick,
          onSeriesClick = _props3.onSeriesClick;

      if (onValueClick) {
        onValueClick(d, { event: event });
      }
      if (onSeriesClick) {
        onSeriesClick({ event: event });
      }
    }

    /**
     * Click handler for the entire series.
     * @param {Object} event Event.
     * @protected
     */

  }, {
    key: '_seriesClickHandler',
    value: function _seriesClickHandler(event) {
      var onSeriesClick = this.props.onSeriesClick;

      if (onSeriesClick) {
        onSeriesClick({ event: event });
      }
    }

    /**
     * Get attribute functor.
     * @param {string} attr Attribute name
     * @returns {*} Functor.
     * @protected
     */

  }, {
    key: '_getAttributeFunctor',
    value: function _getAttributeFunctor(attr) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_scales_utils__["c" /* getAttributeFunctor */])(this.props, attr);
    }

    /**
     * Get the attr0 functor.
     * @param {string} attr Attribute name.
     * @returns {*} Functor.
     * @private
     */

  }, {
    key: '_getAttr0Functor',
    value: function _getAttr0Functor(attr) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_scales_utils__["h" /* getAttr0Functor */])(this.props, attr);
    }

    /**
     * Get the attribute value if it is available.
     * @param {string} attr Attribute name.
     * @returns {*} Attribute value if available, fallback value or undefined
     * otherwise.
     * @protected
     */

  }, {
    key: '_getAttributeValue',
    value: function _getAttributeValue(attr) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_scales_utils__["k" /* getAttributeValue */])(this.props, attr);
    }

    /**
     * Get the scale object distance by the attribute from the list of properties.
     * @param {string} attr Attribute name.
     * @returns {number} Scale distance.
     * @protected
     */

  }, {
    key: '_getScaleDistance',
    value: function _getScaleDistance(attr) {
      var scaleObject = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_scales_utils__["j" /* getScaleObjectFromProps */])(this.props, attr);
      return scaleObject ? scaleObject.distance : 0;
    }
  }, {
    key: '_getXYCoordinateInContainer',
    value: function _getXYCoordinateInContainer(event) {
      var _props4 = this.props,
          _props4$marginTop = _props4.marginTop,
          marginTop = _props4$marginTop === undefined ? 0 : _props4$marginTop,
          _props4$marginLeft = _props4.marginLeft,
          marginLeft = _props4$marginLeft === undefined ? 0 : _props4$marginLeft;
      var _event$nativeEvent = event.nativeEvent,
          clientX = _event$nativeEvent.clientX,
          clientY = _event$nativeEvent.clientY,
          currentTarget = event.currentTarget;

      var rect = currentTarget.getBoundingClientRect();
      return {
        x: clientX - rect.left - currentTarget.clientLeft - marginLeft,
        y: clientY - rect.top - currentTarget.clientTop - marginTop
      };
    }
  }, {
    key: '_handleNearestX',
    value: function _handleNearestX(event) {
      var _props5 = this.props,
          onNearestX = _props5.onNearestX,
          data = _props5.data;

      var minDistance = Number.POSITIVE_INFINITY;
      var value = null;
      var valueIndex = null;

      var coordinate = this._getXYCoordinateInContainer(event);
      var xScaleFn = this._getAttributeFunctor('x');

      data.forEach(function (item, i) {
        var currentCoordinate = xScaleFn(item);
        var newDistance = Math.abs(coordinate.x - currentCoordinate);
        if (newDistance < minDistance) {
          minDistance = newDistance;
          value = item;
          valueIndex = i;
        }
      });
      if (!value) {
        return;
      }
      onNearestX(value, {
        innerX: xScaleFn(value),
        index: valueIndex,
        event: event.nativeEvent
      });
    }
  }, {
    key: '_handleNearestXY',
    value: function _handleNearestXY(event) {
      var _props6 = this.props,
          onNearestXY = _props6.onNearestXY,
          data = _props6.data;


      var coordinate = this._getXYCoordinateInContainer(event);
      var xScaleFn = this._getAttributeFunctor('x');
      var yScaleFn = this._getAttributeFunctor('y');

      // Create a voronoi with each node center points
      var voronoiInstance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_voronoi__["a" /* voronoi */])().x(xScaleFn).y(yScaleFn);

      var foundPoint = voronoiInstance(data).find(coordinate.x, coordinate.y);
      var value = foundPoint.data;

      if (!value) {
        return;
      }
      onNearestXY(value, {
        innerX: foundPoint.x,
        innerY: foundPoint.y,
        index: foundPoint.index,
        event: event.nativeEvent
      });
    }
  }, {
    key: 'onParentMouseMove',
    value: function onParentMouseMove(event) {
      var _props7 = this.props,
          onNearestX = _props7.onNearestX,
          onNearestXY = _props7.onNearestXY,
          data = _props7.data;

      if (!onNearestX && !onNearestXY || !data) {
        return;
      }
      if (onNearestXY) {
        this._handleNearestXY(event);
      } else {
        this._handleNearestX(event);
      }
    }
  }]);

  return AbstractSeries;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]);

AbstractSeries.displayName = 'AbstractSeries';
AbstractSeries.propTypes = propTypes;
AbstractSeries.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (AbstractSeries);

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1042);


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(14), __webpack_require__(38), __webpack_require__(65), __webpack_require__(117), __webpack_require__(28), __webpack_require__(81), __webpack_require__(253), __webpack_require__(157)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('../constants/keyCodes'), require('../constants/CSSTransitionGroupTick'), require('../utils/PropTypes/invalidIf'), require('../utils/EventUtils/captureNextEvent'), require('../FontIcons/FontIcon'), require('../Helpers/IconSeparator'), require('../Inks/injectInk'), require('../Tooltips/injectTooltip'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.keyCodes, global.CSSTransitionGroupTick, global.invalidIf, global.captureNextEvent, global.FontIcon, global.IconSeparator, global.injectInk, global.injectTooltip);
    global.Button = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _keyCodes, _CSSTransitionGroupTick, _invalidIf, _captureNextEvent, _FontIcon, _IconSeparator, _injectInk, _injectTooltip) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);

  var _invalidIf2 = _interopRequireDefault(_invalidIf);

  var _captureNextEvent2 = _interopRequireDefault(_captureNextEvent);

  var _FontIcon2 = _interopRequireDefault(_FontIcon);

  var _IconSeparator2 = _interopRequireDefault(_IconSeparator);

  var _injectInk2 = _interopRequireDefault(_injectInk);

  var _injectTooltip2 = _interopRequireDefault(_injectTooltip);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Button = function (_PureComponent) {
    _inherits(Button, _PureComponent);

    function Button(props) {
      _classCallCheck(this, Button);

      var _this = _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));

      _this.state = {
        pressed: false,
        snackbar: false,
        snackbarType: null
      };

      _this._blur = _this._blur.bind(_this);
      _this._animateForSnackbar = _this._animateForSnackbar.bind(_this);
      _this._handleKeyUp = _this._handleKeyUp.bind(_this);
      _this._handleKeyDown = _this._handleKeyDown.bind(_this);
      _this._handleMouseUp = _this._handleMouseUp.bind(_this);
      _this._handleMouseDown = _this._handleMouseDown.bind(_this);
      _this._handleTouchEnd = _this._handleTouchEnd.bind(_this);
      _this._handleTouchStart = _this._handleTouchStart.bind(_this);
      _this._handleMouseOver = _this._handleMouseOver.bind(_this);
      _this._handleMouseLeave = _this._handleMouseLeave.bind(_this);
      return _this;
    }

    _createClass(Button, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (this.props.disabled && !nextProps.disabled && this.state.hover) {
          this.setState({ hover: false });
        }
      }
    }, {
      key: 'componentWillUpdate',
      value: function componentWillUpdate(nextProps, nextState) {
        var _this2 = this;

        if (!this.state.pressed && nextState.pressed) {
          this._timeout = setTimeout(function () {
            _this2._timeout = null;
            if (_this2._attemptedBlur) {
              _this2._attemptedBlur = false;

              _this2.setState({ pressed: false });
            }
          }, 450);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this._timeout) {
          clearTimeout(this._timeout);
        }

        if (this._snackbarTimeout) {
          clearTimeout(this._snackbarTimeout);
        }

        window.removeEventListener('click', this._blur);
      }
    }, {
      key: '_getType',
      value: function _getType(props) {
        if (props.flat || props.disabled && props.raised) {
          return 'flat';
        } else if (props.icon || props.disabled && props.floating) {
          return 'icon';
        } else if (props.raised) {
          return 'raised';
        } else if (props.floating) {
          return 'icon md-btn--floating';
        }

        return 'flat';
      }
    }, {
      key: '_blur',
      value: function _blur() {
        if (this.props.disabled) {
          return;
        }

        if (this._timeout) {
          this._attemptedBlur = true;
        } else {
          this.setState({ pressed: false });
        }
      }
    }, {
      key: '_handleMouseUp',
      value: function _handleMouseUp(e) {
        if (this.props.onMouseUp) {
          this.props.onMouseUp(e);
        }

        this._blur();
      }
    }, {
      key: '_handleMouseDown',
      value: function _handleMouseDown(e) {
        if (this.props.onMouseDown) {
          this.props.onMouseDown(e);
        }

        if (!this.props.disabled) {
          this.setState({ pressed: true });
        }
      }
    }, {
      key: '_handleTouchStart',
      value: function _handleTouchStart(e) {
        if (this.props.onTouchStart) {
          this.props.onTouchStart(e);
        }

        if (!this.props.disabled) {
          this.setState({ pressed: true });
        }
      }
    }, {
      key: '_handleTouchEnd',
      value: function _handleTouchEnd(e) {
        if (this.props.onTouchEnd) {
          this.props.onTouchEnd(e);
        }

        this._blur();
        (0, _captureNextEvent2.default)('mouseover');
      }
    }, {
      key: '_handleKeyUp',
      value: function _handleKeyUp(e) {
        if (this.props.onKeyUp) {
          this.props.onKeyUp(e);
        }

        if ((e.which || e.keyCode) === _keyCodes.TAB) {
          window.addEventListener('click', this._blur);
          this.setState({ pressed: true });
        }
      }
    }, {
      key: '_handleKeyDown',
      value: function _handleKeyDown(e) {
        if (this.props.onKeyDown) {
          this.props.onKeyDown(e);
        }

        if ((e.which || e.keyCode) === _keyCodes.TAB) {
          window.removeEventListener('click', this._blur);
          this.setState({ pressed: false });
        }
      }
    }, {
      key: '_handleMouseOver',
      value: function _handleMouseOver(e) {
        if (this.props.onMouseOver) {
          this.props.onMouseOver(e);
        }

        if (!this.props.disabled) {
          this.setState({ hover: true });
        }
      }
    }, {
      key: '_handleMouseLeave',
      value: function _handleMouseLeave(e) {
        if (this.props.onMouseLeave) {
          this.props.onMouseLeave(e);
        }

        if (!this.props.disabled) {
          this.setState({ hover: false });
        }
      }
    }, {
      key: '_animateForSnackbar',
      value: function _animateForSnackbar(multiline, leaveTimeout) {
        var _this3 = this;

        if (typeof leaveTimeout === 'number') {
          this._snackbarTimeout = setTimeout(function () {
            _this3._snackbarTimeout = setTimeout(function () {
              _this3._snackbarTimeout = null;

              _this3.setState({ snackbar: false });
            }, leaveTimeout + 150);

            _this3.setState({ snackbarType: null });
          }, _CSSTransitionGroupTick2.default);
        } else {
          this._snackbarTimeout = setTimeout(function () {
            _this3._snackbarTimeout = null;

            _this3.setState({ snackbar: true, snackbarType: multiline ? 'multiline-' : '' });
          }, _CSSTransitionGroupTick2.default);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _cn;

        var _props = this.props,
            className = _props.className,
            iconClassName = _props.iconClassName,
            label = _props.label,
            iconBefore = _props.iconBefore,
            href = _props.href,
            primary = _props.primary,
            secondary = _props.secondary,
            flat = _props.flat,
            raised = _props.raised,
            floating = _props.floating,
            mini = _props.mini,
            fixed = _props.fixed,
            fixedPosition = _props.fixedPosition,
            disabled = _props.disabled,
            component = _props.component,
            ink = _props.ink,
            tooltip = _props.tooltip,
            icon = _props.icon,
            forceIconSize = _props.forceIconSize,
            forceIconFontSize = _props.forceIconFontSize,
            props = _objectWithoutProperties(_props, ['className', 'iconClassName', 'label', 'iconBefore', 'href', 'primary', 'secondary', 'flat', 'raised', 'floating', 'mini', 'fixed', 'fixedPosition', 'disabled', 'component', 'ink', 'tooltip', 'icon', 'forceIconSize', 'forceIconFontSize']);

        delete props.children;
        delete props.tooltipLabel;
        delete props.tooltipPosition;

        if (href) {
          delete props.type;
        }

        var children = this.props.children;
        var _state = this.state,
            pressed = _state.pressed,
            hover = _state.hover,
            snackbar = _state.snackbar,
            snackbarType = _state.snackbarType;

        var mdBtnType = this._getType(this.props);

        var Component = component || (href ? 'a' : 'button');
        if (children || iconClassName) {
          children = _react2.default.createElement(
            _FontIcon2.default,
            { iconClassName: iconClassName, forceSize: forceIconSize, forceFontSize: forceIconFontSize },
            children
          );
        }

        if (children && label) {
          children = _react2.default.createElement(
            _IconSeparator2.default,
            { label: label, iconBefore: iconBefore },
            children
          );
        } else if (label) {
          children = label;
        }

        var raisedStyles = raised || floating;

        var themeClassNames = !disabled && (0, _classnames2.default)({
          'md-text--theme-primary md-ink--primary': !raisedStyles && primary,
          'md-text--theme-secondary md-ink--secondary': !raisedStyles && secondary,
          'md-background--primary md-background--primary-hover': raisedStyles && primary,
          'md-background--secondary md-background--secondary-hover': raisedStyles && secondary,
          'md-btn--color-primary-active': !raisedStyles && hover && primary,
          'md-btn--color-secondary-active': !raisedStyles && hover && secondary
        });
        return _react2.default.createElement(
          Component,
          _extends({}, props, {
            disabled: disabled,
            onTouchStart: this._handleTouchStart,
            onTouchEnd: this._handleTouchEnd,
            onMouseDown: this._handleMouseDown,
            onMouseUp: this._handleMouseUp,
            onKeyDown: this._handleKeyDown,
            onKeyUp: this._handleKeyUp,
            onMouseOver: this._handleMouseOver,
            onMouseLeave: this._handleMouseLeave,
            href: href,
            className: (0, _classnames2.default)('md-inline-block md-btn md-btn--' + mdBtnType, themeClassNames, (_cn = {
              'md-text': !disabled && !primary && !secondary && !icon && !floating,
              'md-text--disabled': disabled,
              'md-pointer--hover': !disabled,
              'md-btn--text': flat || raised,
              'md-btn--hover': hover && !disabled,
              'md-btn--raised-disabled': raised && disabled,
              'md-btn--raised-pressed': !disabled && raisedStyles && pressed,
              'md-btn--fixed': fixed
            }, _defineProperty(_cn, 'md-btn--fixed-' + fixedPosition, floating && fixed), _defineProperty(_cn, 'md-btn--floating-mini', floating && mini), _defineProperty(_cn, 'md-btn--floating-pressed', floating && pressed), _defineProperty(_cn, 'md-btn--snackbar-floating', snackbar), _defineProperty(_cn, 'md-btn--snackbar-floating-' + snackbarType + 'adjust', snackbar && snackbarType !== null), _cn), className)
          }),
          ink,
          tooltip,
          children
        );
      }
    }]);

    return Button;
  }(_react.PureComponent);

  Button.propTypes = {
    /**
     * An optional style to apply to the button.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply to the button.
     */
    className: _propTypes2.default.string,

    /**
     * A label to display on a `FlatButton` or a `RaisedButton`. This text can either
     * be placed before or after an optional `FontIcon` using the `iconBefore` prop.
     * This is required for `Flat` or `Raised` buttons. It is not allowed for `Icon`
     * or `Floating` buttons. Use the `tooltipLabel` prop for `Icon` or `Floating` buttons.
     */
    label: (0, _invalidIf2.default)(_propTypes2.default.node, 'icon', 'floating'),

    /**
     * A boolean if the icon should appear before or after the text for a `FlatButton` or
     * a `RaisedButton`.
     */
    iconBefore: _propTypes2.default.bool,

    /**
     * Any children used to display a `FontIcon` in any version of the button. This will
     * be used with the `iconClassName` prop. If the `iconClassName` and the `children` prop
     * are omitted, no icon will be added to the `RaisedButton` or `FlatButton`. An error
     * will be displayed for the `IconButton` or `FloatingButton`.
     */
    children: function children(props, propName, componentName) {
      for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        args[_key - 3] = arguments[_key];
      }

      var componentNameSafe = componentName || '<<anonymous>>';
      var err = _propTypes2.default.node.apply(_propTypes2.default, [props, propName, componentName].concat(args));

      var icon = props.icon || props.floating;
      var missing = !props.children && !props.iconClassName;
      if (!err && icon && missing) {
        err = new Error('You created an `' + (props.icon ? 'Icon' : 'Floating') + '` ' + componentNameSafe + ' without ' + 'having the correct props to generate an icon. Expected either the `children` prop or the ' + ('`iconClassName` prop but received children: `' + props.children + '` and iconClassName: ') + ('`' + props.iconClassName + '`.'));
      }

      return err;
    },

    /**
     * An icon className to use in an optional `FontIcon` in any version of the button. This will
     * be used with the `children` prop. If the `floating` or `icon` props are set to true, this or
     * the children are required.
     */
    iconClassName: _propTypes2.default.string,

    /**
     * The type for the button. This is required when the `component` prop is not
     * the 'a' tag, a `function`, or when the `href` prop is defined.
     */
    type: function type(props, propName, component) {
      for (var _len2 = arguments.length, args = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
        args[_key2 - 3] = arguments[_key2];
      }

      var c = props.component;
      var validator = _propTypes2.default.oneOf(['button', 'submit', 'reset']);
      if (!props.href && c !== 'a' && typeof c !== 'function') {
        validator = validator.isRequired;
      }

      return validator.apply(undefined, [props, propName, component].concat(args));
    },

    /**
     * Boolean if the button should be styled with the primary color.
     */
    primary: _propTypes2.default.bool,

    /**
     * Boolean if the button should be styled with the secondary color.
     */
    secondary: _propTypes2.default.bool,

    /**
     * Boolean if the button is disabled.
     */
    disabled: _propTypes2.default.bool,

    /**
     * An optional href for the button. This will style the `a` tag as a button.
     */
    href: _propTypes2.default.string,

    /**
     * An optional component to render the button as. This allows you to get all the styles and functionality
     * of the Button, but as a custom React component.
     */
    component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),

    /**
     * An optional function to call when the `click` event is triggered.
     */
    onClick: _propTypes2.default.func,

    /**
     * An optional function to call when the `touchstart` event is triggered.
     */
    onTouchStart: _propTypes2.default.func,

    /**
     * An optional function to call when the `touchend` event is triggered.
     */
    onTouchEnd: _propTypes2.default.func,

    /**
     * An optional function to call when the `mousedown` event is triggered.
     */
    onMouseDown: _propTypes2.default.func,

    /**
     * An optional function to call when the `mouseup` event is triggered.
     */
    onMouseUp: _propTypes2.default.func,

    /**
     * An optional function to call when the `keyup` event is triggered.
     */
    onKeyUp: _propTypes2.default.func,

    /**
     * An optional function to call when the `keydown` event is triggered.
     */
    onKeyDown: _propTypes2.default.func,

    /**
     * An optional function to call when the `mouseover` event is triggered.
     */
    onMouseOver: _propTypes2.default.func,

    /**
     * An optional function to call when the `mouseleave` event is triggered.
     */
    onMouseLeave: _propTypes2.default.func,

    /**
     * Boolean if the `FloatingButton` should be fixed to the page. This prop can
     * only be enabled if the `floating` prop is true.
     */
    fixed: (0, _invalidIf2.default)(_propTypes2.default.bool, 'flat', 'raised', 'icon'),

    /**
     * The position that the `FloatingButton` should be fixed to the page. It will
     * either be fixed to the top right, top left, bottom right, or bottom left of
     * the page. This prop is ony used if the `floating` prop and `fixed` prop are
     * `true`.
     */
    fixedPosition: _propTypes2.default.oneOf(['tr', 'tl', 'br', 'bl']).isRequired,

    /**
     * Boolean if the `FloatingButton` should be `mini`. This prop can only be used
     * when the `floating` prop is true.
     */
    mini: (0, _invalidIf2.default)(_propTypes2.default.bool, 'flat', 'raised', 'icon'),

    /**
     * Boolean if the `Button` should be styled as a `FlatButton`.
     */
    flat: _propTypes2.default.bool,

    /**
     * Boolean if the `Button` should be styled as a `RaisedButton`.
     */
    raised: _propTypes2.default.bool,

    /**
     * Boolean if the `Button` should be styled as a `IconButton`.
     */
    icon: _propTypes2.default.bool,

    /**
     * Boolean if the `Button` should be styled as a `FloatingButton`.
     */
    floating: _propTypes2.default.bool,

    /**
     * An optional label to use for the tooltip. This is normally only used for
     * `IconButton`s or `FloatingButton`s, but can be used on `FlatButton`s and
     * `RaisedButton`s if you wish. Knock yourself out!
     *
     * If this prop is omitted, no tooltip will be included.
     */
    tooltipLabel: _propTypes2.default.node,

    /**
     * An optional delay before the tooltip appears on mouse over.
     */
    tooltipDelay: _propTypes2.default.number,

    /**
     * The position for the tooltip.
     */
    tooltipPosition: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),

    /**
     * An ink from `injectInk`.
     * @access private
     */
    ink: _propTypes2.default.node,

    /**
     * A tooltip from `injectTooltip`
     * @access private
     */
    tooltip: _propTypes2.default.node,

    /**
     * Custom validator for verifying that only one type is defined and that
     * at one type is defined.
     */
    _typeValidator: function _typeValidator(props, propName, component) {
      var flat = props.flat,
          raised = props.raised,
          icon = props.icon,
          floating = props.floating;


      var defined = [raised, flat, icon, floating].filter(function (d) {
        return d;
      });
      var len = defined.length;
      if (len === 0) {
        return new Error('A material design button type must be specified in the `' + component + '` but none were ' + 'given. Valid types are `flat`, `raised`, `icon`, or `floating`.');
      } else if (len !== 1) {
        return new Error('Only one material design button type may be specified in the `' + component + '` but `' + len + '` ' + 'were given. Select only one of `flat`, `raised`, `icon`, or `floating`.');
      }

      return null;
    },

    /**
     * Either a boolean that will enforce the 24x24 size of the font icon or a number of the size
     * to enforce. This is useful when using other font icon libraries that do not have a consistent
     * size.
     */
    forceIconSize: _FontIcon2.default.propTypes.forceSize,

    /**
     * Boolean if the `forceIconSize` prop should also force the `font-size` instead of only `width` and `height`.
     */
    forceIconFontSize: _propTypes2.default.bool
  };
  Button.defaultProps = {
    type: 'button',
    iconBefore: true,
    fixedPosition: 'br'
  };
  exports.default = (0, _injectInk2.default)((0, _injectTooltip2.default)(Button));
});

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = deprecated;

var _warning = __webpack_require__(33);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var warned = {};

function deprecated(validator, reason) {
  return function validate(props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] != null) {
      var messageKey = componentName + '.' + propName;

      (0, _warning2.default)(warned[messageKey], 'The ' + location + ' `' + propFullNameSafe + '` of ' + ('`' + componentNameSafe + '` is deprecated. ' + reason + '.'));

      warned[messageKey] = true;
    }

    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      args[_key - 5] = arguments[_key];
    }

    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
  };
}

/* eslint-disable no-underscore-dangle */
function _resetWarned() {
  warned = {};
}

deprecated._resetWarned = _resetWarned;
/* eslint-enable no-underscore-dangle */

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = extractAnimatedPropValues;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnimationPropType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_interpolate__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_motion__ = __webpack_require__(1215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_motion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_motion__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var ANIMATION_PROPTYPES = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  stiffness: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  nonAnimatedProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
  damping: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]);

var propTypes = {
  animatedProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string).isRequired,
  animation: ANIMATION_PROPTYPES,
  onStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onEnd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/**
 * Format the animation style object
 * @param {Object|String} animationStyle - The animation style property, either the name of a
 * presets are one of noWobble, gentle, wobbly, stiff
 */
function getAnimationStyle() {
  var animationStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_3_react_motion__["presets"].noWobble;

  if (typeof animationStyle === 'string') {
    return __WEBPACK_IMPORTED_MODULE_3_react_motion__["presets"][animationStyle] || __WEBPACK_IMPORTED_MODULE_3_react_motion__["presets"].noWobble;
  }
  var damping = animationStyle.damping,
      stiffness = animationStyle.stiffness;

  return _extends({
    damping: damping || __WEBPACK_IMPORTED_MODULE_3_react_motion__["presets"].noWobble.damping,
    stiffness: stiffness || __WEBPACK_IMPORTED_MODULE_3_react_motion__["presets"].noWobble.stiffness
  }, animationStyle);
}

/**
 * Extract the animated props from the entire props object.
 * @param {Object} props Props.
 * @returns {Object} Object of animated props.
 */
function extractAnimatedPropValues(props) {
  var animatedProps = props.animatedProps,
      otherProps = _objectWithoutProperties(props, ['animatedProps']);

  return animatedProps.reduce(function (result, animatedPropName) {
    if (otherProps.hasOwnProperty(animatedPropName)) {
      result[animatedPropName] = otherProps[animatedPropName];
    }
    return result;
  }, {});
}

var Animation = function (_PureComponent) {
  _inherits(Animation, _PureComponent);

  function Animation(props) {
    _classCallCheck(this, Animation);

    var _this = _possibleConstructorReturn(this, (Animation.__proto__ || Object.getPrototypeOf(Animation)).call(this, props));

    _this._updateInterpolator(props);
    _this._renderChildren = _this._renderChildren.bind(_this);
    _this._motionEndHandler = _this._motionEndHandler.bind(_this);
    return _this;
  }

  _createClass(Animation, [{
    key: 'componentWillUpdate',
    value: function componentWillUpdate(props) {
      this._updateInterpolator(this.props, props);
      if (props.onStart) {
        props.onStart();
      }
    }

    /**
     * Update the interpolator function and assign it to this._interpolator.
     * @param {Object} oldProps Old props.
     * @param {Object} newProps New props.
     * @private
     */

  }, {
    key: '_updateInterpolator',
    value: function _updateInterpolator(oldProps, newProps) {
      this._interpolator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_d3_interpolate__["b" /* interpolate */])(extractAnimatedPropValues(oldProps), newProps ? extractAnimatedPropValues(newProps) : null);
    }

    /**
     * Render the child into the parent.
     * @param {Number} i Number generated by the spring.
     * @returns {React.Component} Rendered react element.
     * @private
     */

  }, {
    key: '_renderChildren',
    value: function _renderChildren(_ref) {
      var i = _ref.i;
      var children = this.props.children;

      var interpolator = this._interpolator;
      var child = __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.only(children);
      var interpolatedProps = interpolator ? interpolator(i) : interpolator;

      // interpolator doesnt play nice with deeply nested objected
      // so we expose an additional prop for situations like these, soit _data,
      // which stores the full tree and can be recombined with the sanitized version
      // after interpolation
      var data = interpolatedProps && interpolatedProps.data || null;
      if (data && child.props._data) {
        data = data.map(function (row, index) {
          var correspondingCell = child.props._data[index];
          return _extends({}, row, { parent: correspondingCell.parent, children: correspondingCell.children });
        });
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, _extends({}, child.props, interpolatedProps, {
        data: data || child.props.data || null,
        // enforce re-rendering
        _animation: Math.random()
      }));
    }
  }, {
    key: '_motionEndHandler',
    value: function _motionEndHandler() {
      if (this.props.onEnd) {
        this.props.onEnd();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var animationStyle = getAnimationStyle(this.props.animation);
      var defaultStyle = { i: 0 };
      var style = { i: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_motion__["spring"])(1, animationStyle) };
      // In order to make Motion re-run animations each time, the random key is
      // always passed.
      // TODO: find a better solution for the spring.
      var key = Math.random();
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_motion__["Motion"],
        _extends({ defaultStyle: defaultStyle, style: style, key: key }, { onRest: this._motionEndHandler }),
        this._renderChildren
      );
    }
  }]);

  return Animation;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Animation.propTypes = propTypes;
Animation.displayName = 'Animation';

/* harmony default export */ __webpack_exports__["b"] = (Animation);

var AnimationPropType = ANIMATION_PROPTYPES;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.keyCodes = mod.exports;
  }
})(this, function (exports) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var LEFT_MOUSE = exports.LEFT_MOUSE = 0;
  var RIGHT_MOUSE = exports.RIGHT_MOUSE = 2;

  var TAB = exports.TAB = 9;
  var ENTER = exports.ENTER = 13;
  var ESC = exports.ESC = 27;
  var SPACE = exports.SPACE = 32;
  var PAGE_UP = exports.PAGE_UP = 33;
  var PAGE_DOWN = exports.PAGE_DOWN = 34;
  var END = exports.END = 35;
  var HOME = exports.HOME = 36;
  var LEFT = exports.LEFT = 37;
  var UP = exports.UP = 38;
  var RIGHT = exports.RIGHT = 39;
  var DOWN = exports.DOWN = 40;

  var ZERO = exports.ZERO = 48;
  var NINE = exports.NINE = 57;
  var KEYPAD_ZERO = exports.KEYPAD_ZERO = 96;
  var KEYPAD_NINE = exports.KEYPAD_NINE = 105;
});

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var DOMProperty = __webpack_require__(79);
var ReactDOMComponentFlags = __webpack_require__(533);

var invariant = __webpack_require__(4);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var Flags = ReactDOMComponentFlags;

var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);

/**
 * Check if a given node should be cached.
 */
function shouldPrecacheNode(node, nodeID) {
  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
}

/**
 * Drill down (through composites and empty components) until we get a host or
 * host text component.
 *
 * This is pretty polymorphic but unavoidable with the current structure we have
 * for `_renderedChildren`.
 */
function getRenderedHostOrTextFromComponent(component) {
  var rendered;
  while (rendered = component._renderedComponent) {
    component = rendered;
  }
  return component;
}

/**
 * Populate `_hostNode` on the rendered host/text component with the given
 * DOM node. The passed `inst` can be a composite.
 */
function precacheNode(inst, node) {
  var hostInst = getRenderedHostOrTextFromComponent(inst);
  hostInst._hostNode = node;
  node[internalInstanceKey] = hostInst;
}

function uncacheNode(inst) {
  var node = inst._hostNode;
  if (node) {
    delete node[internalInstanceKey];
    inst._hostNode = null;
  }
}

/**
 * Populate `_hostNode` on each child of `inst`, assuming that the children
 * match up with the DOM (element) children of `node`.
 *
 * We cache entire levels at once to avoid an n^2 problem where we access the
 * children of a node sequentially and have to walk from the start to our target
 * node every time.
 *
 * Since we update `_renderedChildren` and the actual DOM at (slightly)
 * different times, we could race here and see a newer `_renderedChildren` than
 * the DOM nodes we see. To avoid this, ReactMultiChild calls
 * `prepareToManageChildren` before we change `_renderedChildren`, at which
 * time the container's child nodes are always cached (until it unmounts).
 */
function precacheChildNodes(inst, node) {
  if (inst._flags & Flags.hasCachedChildNodes) {
    return;
  }
  var children = inst._renderedChildren;
  var childNode = node.firstChild;
  outer: for (var name in children) {
    if (!children.hasOwnProperty(name)) {
      continue;
    }
    var childInst = children[name];
    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
    if (childID === 0) {
      // We're currently unmounting this child in ReactMultiChild; skip it.
      continue;
    }
    // We assume the child nodes are in the same order as the child instances.
    for (; childNode !== null; childNode = childNode.nextSibling) {
      if (shouldPrecacheNode(childNode, childID)) {
        precacheNode(childInst, childNode);
        continue outer;
      }
    }
    // We reached the end of the DOM children without finding an ID match.
     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
  }
  inst._flags |= Flags.hasCachedChildNodes;
}

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  // Walk up the tree until we find an ancestor whose instance we have cached.
  var parents = [];
  while (!node[internalInstanceKey]) {
    parents.push(node);
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var closest;
  var inst;
  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
    closest = inst;
    if (parents.length) {
      precacheChildNodes(inst, node);
    }
  }

  return closest;
}

/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */
function getInstanceFromNode(node) {
  var inst = getClosestInstanceFromNode(node);
  if (inst != null && inst._hostNode === node) {
    return inst;
  } else {
    return null;
  }
}

/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */
function getNodeFromInstance(inst) {
  // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.
  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  if (inst._hostNode) {
    return inst._hostNode;
  }

  // Walk up the tree until we find an ancestor whose DOM node we have cached.
  var parents = [];
  while (!inst._hostNode) {
    parents.push(inst);
    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
    inst = inst._hostParent;
  }

  // Now parents contains each ancestor that does *not* have a cached native
  // node, and `inst` is the deepest ancestor that does.
  for (; parents.length; inst = parents.pop()) {
    precacheChildNodes(inst, inst._hostNode);
  }

  return inst._hostNode;
}

var ReactDOMComponentTree = {
  getClosestInstanceFromNode: getClosestInstanceFromNode,
  getInstanceFromNode: getInstanceFromNode,
  getNodeFromInstance: getNodeFromInstance,
  precacheChildNodes: precacheChildNodes,
  precacheNode: precacheNode,
  uncacheNode: uncacheNode
};

module.exports = ReactDOMComponentTree;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.getField = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = getField;
  /**
   * Gets the current field for a component that can the field
   * as either uncontrolled or controlled.
   *
   * @param {Object} props - the props object.
   * @param {Object} state = the state object.
   * @param {string=} field - the field to extract a value from. Defaults to 'value'.
   *
   * @return the field's value.
   */
  function getField(props, state) {
    var field = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'value';

    return typeof props[field] !== 'undefined' ? props[field] : state[field];
  }
});

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isRequiredForA11y;
function isRequiredForA11y(validator) {
  return function validate(props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
    }

    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      args[_key - 5] = arguments[_key];
    }

    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
  };
}

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(1218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(1219);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.campaignLaunch = exports.campaignUpdated = exports.campaignUpdate = exports.campaignFetch = exports.campaignCreated = exports.createCampaign = exports.campaignClear = exports.CAMPAIGN_LAUNCH = exports.CAMPAIGN_UPDATED = exports.CAMPAIGN_UPDATE = exports.CAMPAIGN_FETCHED = exports.CAMPAIGN_FETCH = exports.CAMPAIGN_CREATED = exports.CAMPAIGN_CREATE = exports.CAMPAIGN_CLEAR = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _api = __webpack_require__(39);

var api = _interopRequireWildcard(_api);

var _shared = __webpack_require__(286);

var _reactRouterRedux = __webpack_require__(121);

var _assign = __webpack_require__(403);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var CAMPAIGN_CLEAR = exports.CAMPAIGN_CLEAR = 'CAMPAIGN_CLEAR';
var CAMPAIGN_CREATE = exports.CAMPAIGN_CREATE = 'CAMPAIGN_CREATE';
var CAMPAIGN_CREATED = exports.CAMPAIGN_CREATED = 'CAMPAIGN_CREATED';
var CAMPAIGN_FETCH = exports.CAMPAIGN_FETCH = 'CAMPAIGN_FETCH';
var CAMPAIGN_FETCHED = exports.CAMPAIGN_FETCHED = 'CAMPAIGN_FETCHED';
var CAMPAIGN_UPDATE = exports.CAMPAIGN_UPDATE = 'CAMPAIGN_UPDATE';
var CAMPAIGN_UPDATED = exports.CAMPAIGN_UPDATED = 'CAMPAIGN_UPDATED';
var CAMPAIGN_LAUNCH = exports.CAMPAIGN_LAUNCH = 'CAMPAIGN_LAUNCH';

var campaignClear = exports.campaignClear = function campaignClear() {
  return function (dispatch) {
    dispatch({ type: CAMPAIGN_CLEAR });
  };
};

var createCampaign = exports.createCampaign = function createCampaign(campaignParams) {
  return function (dispatch) {
    dispatch({ type: CAMPAIGN_CREATE });
    var defaultProps = { symptoms: [], langs: [], name: '', chat_texts: [], audios: [], mode: 'call' };
    var params = (0, _assign2.default)({}, defaultProps, campaignParams);

    api.createCampaign(params).then(function (campaign) {
      var campaignWithDefaults = _extends({}, campaign, { forwardingCondition: 'any' });
      dispatch(campaignCreated(campaignWithDefaults));
      dispatch(campaignUpdate(campaignWithDefaults));
      dispatch((0, _reactRouterRedux.push)('/campaigns/' + campaignWithDefaults.id));
    });
  };
};

var campaignCreated = exports.campaignCreated = function campaignCreated(campaign) {
  return { type: CAMPAIGN_CREATED, campaign: campaign };
};

var campaignFetch = exports.campaignFetch = function campaignFetch(id) {
  return function (dispatch) {
    dispatch({ type: CAMPAIGN_FETCH, id: id });

    api.fetchCampaign(id).then(function (campaign) {
      if (campaign.forwardingCondition == null) {
        campaign = _extends({}, campaign, { forwardingCondition: 'any' });
        dispatch(campaignUpdate(campaign));
      }
      dispatch({ type: CAMPAIGN_FETCHED, campaign: campaign });
    });
  };
};

var campaignUpdate = exports.campaignUpdate = function campaignUpdate(attrs) {
  return function (dispatch, getState) {
    var newCampaign = (0, _assign2.default)({}, getState().campaign.data, attrs);

    dispatch({ type: CAMPAIGN_UPDATED, campaign: newCampaign });
    api.updateCampaign(newCampaign).catch(function (message) {
      dispatch({ type: _shared.SERVER_ERROR, message: message });
    });
  };
};

var campaignUpdated = exports.campaignUpdated = function campaignUpdated(campaign) {
  return { type: CAMPAIGN_UPDATED, campaign: campaign };
};

var campaignLaunch = exports.campaignLaunch = function campaignLaunch(id) {
  return function (dispatch) {
    dispatch({ type: CAMPAIGN_LAUNCH, id: id });

    api.launchCampaign(id).then(function (campaign) {
      dispatch({ type: CAMPAIGN_FETCHED, campaign: campaign });
    });
  };
};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('prop-types'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.propTypes);
    global.controlled = mod.exports;
  }
})(this, function (exports, _propTypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = controlled;

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Validates the a component is fully controlled or uncontrolled.  If the given prop is not
   * `undefined`, it will check if the `funcName` is defined and a function. A missing function
   * will generate an error similar to the built-in React controlled validation message.
   *
   * @param {String} funcName - The function name to use for additional validation.
   * @param {function} validator - The PropTypes validator to use for the given prop.
   * @return {Error} an error or null.
   */
  function controlled(validator, funcName) {
    var fallbackPropName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'defaultValue';

    return function validate(props, propName, componentName, location, propFullName) {
      var componentNameSafe = componentName || '<<anonymous>>';
      var propFullNameSafe = propFullName || propName;

      for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
        args[_key - 5] = arguments[_key];
      }

      var err = validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
      if (!err && typeof props[propName] !== 'undefined' && !props.readOnly) {
        var _PropTypes$func;

        var funcError = (_PropTypes$func = _propTypes2.default.func).isRequired.apply(_PropTypes$func, [props, funcName, componentName, location, propFullName].concat(args));
        if (funcError) {
          err = new Error('You provided a `' + propFullNameSafe + '` ' + location + ' to the ' + componentNameSafe + ' without a ' + ('`' + funcName + '` handler. This will render a read only field. Set either the `' + funcName + '` ') + ('or use the `' + fallbackPropName + '` instead.'));
        }
      }

      return err;
    };
  }
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_bisect__ = __webpack_require__(309);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__src_bisect__["a"]; });
/* unused harmony reexport bisectRight */
/* unused harmony reexport bisectLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_ascending__ = __webpack_require__(72);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__src_ascending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_bisector__ = __webpack_require__(310);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__src_bisector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_cross__ = __webpack_require__(719);
/* unused harmony reexport cross */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_descending__ = __webpack_require__(720);
/* unused harmony reexport descending */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_deviation__ = __webpack_require__(311);
/* unused harmony reexport deviation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_extent__ = __webpack_require__(312);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_6__src_extent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_histogram__ = __webpack_require__(721);
/* unused harmony reexport histogram */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_threshold_freedmanDiaconis__ = __webpack_require__(731);
/* unused harmony reexport thresholdFreedmanDiaconis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_threshold_scott__ = __webpack_require__(732);
/* unused harmony reexport thresholdScott */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_threshold_sturges__ = __webpack_require__(316);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_10__src_threshold_sturges__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_max__ = __webpack_require__(723);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_11__src_max__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_mean__ = __webpack_require__(724);
/* unused harmony reexport mean */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_median__ = __webpack_require__(725);
/* unused harmony reexport median */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_merge__ = __webpack_require__(726);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_14__src_merge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_min__ = __webpack_require__(313);
/* unused harmony reexport min */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_pairs__ = __webpack_require__(314);
/* unused harmony reexport pairs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_permute__ = __webpack_require__(727);
/* unused harmony reexport permute */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_quantile__ = __webpack_require__(186);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_18__src_quantile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_range__ = __webpack_require__(315);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_19__src_range__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_scan__ = __webpack_require__(728);
/* unused harmony reexport scan */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_shuffle__ = __webpack_require__(729);
/* unused harmony reexport shuffle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_sum__ = __webpack_require__(730);
/* unused harmony reexport sum */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_ticks__ = __webpack_require__(317);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_transpose__ = __webpack_require__(318);
/* unused harmony reexport transpose */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__src_variance__ = __webpack_require__(319);
/* unused harmony reexport variance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__src_zip__ = __webpack_require__(733);
/* unused harmony reexport zip */





























/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DISCRETE_COLOR_RANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return EXTENDED_DISCRETE_COLOR_RANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CONTINUOUS_COLOR_RANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SIZE_RANGE; });
/* unused harmony export OPACITY_RANGE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return OPACITY_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_OPACITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DEFAULT_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DEFAULT_COLOR; });
/* unused harmony export DEFAULT_TICK_SIZE */
// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

var DISCRETE_COLOR_RANGE = ['#12939A', '#79C7E3', '#1A3177', '#FF9833', '#EF5D28'];

var EXTENDED_DISCRETE_COLOR_RANGE = ['#19CDD7', '#DDB27C', '#88572C', '#FF991F', '#F15C17', '#223F9A', '#DA70BF', '#125C77', '#4DC19C', '#776E57', '#12939A', '#17B8BE', '#F6D18A', '#B7885E', '#FFCB99', '#F89570', '#829AE3', '#E79FD5', '#1E96BE', '#89DAC1', '#B3AD9E'];

var CONTINUOUS_COLOR_RANGE = ['#EF5D28', '#FF9833'];

var SIZE_RANGE = [1, 10];

var OPACITY_RANGE = [0.1, 1];
var OPACITY_TYPE = 'literal';
var DEFAULT_OPACITY = 1;

var DEFAULT_SIZE = 5;

var DEFAULT_COLOR = DISCRETE_COLOR_RANGE[0];

var DEFAULT_TICK_SIZE = 7;

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isSeriesChild */
/* harmony export (immutable) */ __webpack_exports__["b"] = getSeriesChildren;
/* harmony export (immutable) */ __webpack_exports__["c"] = getStackedData;
/* harmony export (immutable) */ __webpack_exports__["d"] = getSeriesPropsFromChildren;
/* harmony export (immutable) */ __webpack_exports__["a"] = getRadialDomain;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ANIMATED_SERIES_PROPS; });
/* harmony export (immutable) */ __webpack_exports__["f"] = getStackParams;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plot_series_abstract_series__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__theme__ = __webpack_require__(22);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.






/**
 * Check if the component is series or not.
 * @param {React.Component} child Component.
 * @returns {boolean} True if the child is series, false otherwise.
 */
function isSeriesChild(child) {
  var prototype = child.type.prototype;

  return prototype instanceof __WEBPACK_IMPORTED_MODULE_1__plot_series_abstract_series__["a" /* default */];
}

/**
 * Get all series from the 'children' object of the component.
 * @param {Object} children Children.
 * @returns {Array} Array of children.
 */
function getSeriesChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.toArray(children).filter(function (child) {
    return child && isSeriesChild(child);
  });
}

/**
 * Collect the map of repetitions of the series type for all children.
 * @param {Array} children Array of children.
 * @returns {{}} Map of repetitions where sameTypeTotal is the total amount and
 * sameTypeIndex is always 0.
 */
function collectSeriesTypesInfo(children) {
  var result = {};
  children.filter(isSeriesChild).forEach(function (child) {
    var displayName = child.type.displayName;
    var cluster = child.props.cluster;

    if (!result[displayName]) {
      result[displayName] = {
        sameTypeTotal: 0,
        sameTypeIndex: 0,
        clusters: new Set()
      };
    }
    result[displayName].clusters.add(cluster);
    result[displayName].sameTypeTotal++;
  });
  return result;
}

/**
 * Check series to see if it has angular data that needs to be converted
 * @param {Array} data - an array of objects to check
 * @returns {Boolean} whether or not this series contains polar configuration
 */
function seriesHasAngleRadius() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if (!data) {
    return false;
  }
  return data.some(function (row) {
    return row.radius && row.angle;
  });
}

/**
 * Possibly convert polar coordinates to x/y for computing domain
 * @param {Array} data - an array of objects to check
 * @param {String} attr - the property being checked
 * @returns {Boolean} whether or not this series contains polar configuration
 */
function prepareData(data) {
  if (!seriesHasAngleRadius(data)) {
    return data;
  }

  return data.map(function (row) {
    return _extends({}, row, {
      x: row.radius * Math.cos(row.angle),
      y: row.radius * Math.sin(row.angle)
    });
  });
}

/**
 * Collect the stacked data for all children in use. If the children don't have
 * the data (e.g. the child is invalid series or something else), then the child
 * is skipped.
 * Each next value of attr is equal to the previous value plus the difference
 * between attr0 and attr.
 * @param {Array} children Array of children.
 * @param {string} attr Attribute to stack by.
 * @returns {Array} New array of children for the series.
 */
function getStackedData(children, attr) {
  return children.reduce(function (accumulator, series, seriesIndex) {
    // Skip the children that are not series (e.g. don't have any data).
    if (!series) {
      accumulator.result.push(null);
      return accumulator;
    }

    var _series$props = series.props,
        data = _series$props.data,
        _series$props$cluster = _series$props.cluster,
        cluster = _series$props$cluster === undefined ? 'default' : _series$props$cluster;

    var preppedData = prepareData(data, attr);

    if (!attr || !preppedData || !preppedData.length) {
      accumulator.result.push(preppedData);
      return accumulator;
    }

    var attr0 = attr + '0';

    accumulator.result.push(preppedData.map(function (d, dIndex) {
      var _extends2;

      // In case if it's the first series don't try to override any values.
      if (!accumulator.seriesPointers[cluster]) {
        return _extends({}, d);
      }
      // get the previous series in this cluster
      var prevSeries = accumulator.seriesPointers[cluster].slice().pop();
      // get the previous data point in that series
      var prevD = accumulator.result[prevSeries][dIndex];
      return _extends({}, d, (_extends2 = {}, _defineProperty(_extends2, attr0, prevD[attr]), _defineProperty(_extends2, attr, prevD[attr] + d[attr] - (d[attr0] || 0)), _extends2));
    }));
    accumulator.seriesPointers[cluster] = (accumulator.seriesPointers[cluster] || []).concat([seriesIndex]);
    return accumulator;
  }, {
    result: [],
    seriesPointers: {}
  }).result;
}

/**
 * Get the list of series props for a child.
 * @param {Array} children Array of all children.
 * @returns {Array} Array of series props for each child. If a child is not a
 * series, than it's undefined.
 */
function getSeriesPropsFromChildren(children) {
  var result = [];
  var seriesTypesInfo = collectSeriesTypesInfo(children);
  var seriesIndex = 0;
  var _opacityValue = __WEBPACK_IMPORTED_MODULE_2__theme__["a" /* DEFAULT_OPACITY */];
  children.forEach(function (child) {
    var props = void 0;
    if (isSeriesChild(child)) {
      var seriesTypeInfo = seriesTypesInfo[child.type.displayName];
      var _colorValue = __WEBPACK_IMPORTED_MODULE_2__theme__["b" /* DISCRETE_COLOR_RANGE */][seriesIndex % __WEBPACK_IMPORTED_MODULE_2__theme__["b" /* DISCRETE_COLOR_RANGE */].length];
      props = _extends({}, seriesTypeInfo, {
        seriesIndex: seriesIndex,
        ref: 'series' + seriesIndex,
        _colorValue: _colorValue,
        _opacityValue: _opacityValue
      });
      seriesTypeInfo.sameTypeIndex++;
      seriesIndex++;
      if (child.props.cluster) {
        props.cluster = child.props.cluster;
        // Using Array.from() so we can use .indexOf
        props.clusters = Array.from(seriesTypeInfo.clusters);
        props.sameTypeTotal = props.clusters.length;
        props.sameTypeIndex = props.clusters.indexOf(child.props.cluster);
      }
    }
    result.push(props);
  });
  return result;
}

/**
 * Find the max radius value from the nodes to be rendered after they have been
 * transformed into an array
 * @param {Array} data - the tree data after it has been broken into a iterable
 * it is an array of objects!
 * @returns {number} the maximum value in coordinates for the radial variable
 */
function getRadialDomain(data) {
  return data.reduce(function (res, row) {
    return Math.max(row.radius, res);
  }, 0);
}

var ANIMATED_SERIES_PROPS = ['xRange', 'xDomain', 'x', 'yRange', 'yDomain', 'y', 'colorRange', 'colorDomain', 'color', 'opacityRange', 'opacityDomain', 'opacity', 'strokeRange', 'strokeDomain', 'stroke', 'fillRange', 'fillDomain', 'fill', 'width', 'height', 'marginLeft', 'marginTop', 'marginRight', 'marginBottom', 'data', 'angleDomain', 'angleRange', 'angle', 'radiusDomain', 'radiusRange', 'radius', 'innerRadiusDomain', 'innerRadiusRange', 'innerRadius'];

function getStackParams(props) {
  var _stackBy = props._stackBy,
      valuePosAttr = props.valuePosAttr,
      cluster = props.cluster;
  var _props$sameTypeTotal = props.sameTypeTotal,
      sameTypeTotal = _props$sameTypeTotal === undefined ? 1 : _props$sameTypeTotal,
      _props$sameTypeIndex = props.sameTypeIndex,
      sameTypeIndex = _props$sameTypeIndex === undefined ? 0 : _props$sameTypeIndex;

  // If bars are stacked, but not clustering, override `sameTypeTotal` and
  // `sameTypeIndex` such that bars are stacked and not staggered.

  if (_stackBy === valuePosAttr && !cluster) {
    sameTypeTotal = 1;
    sameTypeIndex = 0;
  }
  return { sameTypeTotal: sameTypeTotal, sameTypeIndex: sameTypeIndex };
}

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = newInterval;
var t0 = new Date,
    t1 = new Date;

function newInterval(floori, offseti, count, field) {

  function interval(date) {
    return floori(date = new Date(+date)), date;
  }

  interval.floor = interval;

  interval.ceil = function(date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = function(date) {
    var d0 = interval(date),
        d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = function(date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = function(start, stop, step) {
    var range = [];
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    do range.push(new Date(+start)); while (offseti(start, step), floori(start), start < stop)
    return range;
  };

  interval.filter = function(test) {
    return newInterval(function(date) {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, function(date, step) {
      if (date >= date) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
        } else while (--step >= 0) {
          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
        }
      }
    });
  };

  if (count) {
    interval.count = function(start, end) {
      t0.setTime(+start), t1.setTime(+end);
      floori(t0), floori(t1);
      return Math.floor(count(t0, t1));
    };

    interval.every = function(step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null
          : !(step > 1) ? interval
          : interval.filter(field
              ? function(d) { return field(d) % step === 0; }
              : function(d) { return interval.count(0, d) % step === 0; });
    };
  }

  return interval;
}


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export _getSmallestDistanceIndex */
/* unused harmony export getScaleFnFromScaleObject */
/* unused harmony export getDomainByAttr */
/* unused harmony export _getScaleDistanceAndAdjustedDomain */
/* unused harmony export _adjustCategoricalScale */
/* harmony export (immutable) */ __webpack_exports__["j"] = getScaleObjectFromProps;
/* harmony export (immutable) */ __webpack_exports__["e"] = getAttributeScale;
/* harmony export (immutable) */ __webpack_exports__["c"] = getAttributeFunctor;
/* harmony export (immutable) */ __webpack_exports__["h"] = getAttr0Functor;
/* harmony export (immutable) */ __webpack_exports__["k"] = getAttributeValue;
/* harmony export (immutable) */ __webpack_exports__["i"] = getScalePropTypesByAttribute;
/* harmony export (immutable) */ __webpack_exports__["f"] = extractScalePropsFromProps;
/* harmony export (immutable) */ __webpack_exports__["b"] = getMissingScaleProps;
/* unused harmony export literalScale */
/* harmony export (immutable) */ __webpack_exports__["d"] = getFontColorFromBackground;
/* harmony export (immutable) */ __webpack_exports__["g"] = getXYPlotValues;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_scale__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_array__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_collection__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_color__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__react_utils__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_utils__ = __webpack_require__(1296);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _SCALE_FUNCTIONS;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.











/**
 * Linear scale name.
 * @type {string}
 * @const
 */
var LINEAR_SCALE_TYPE = 'linear';

/**
 * Ordinal scale name.
 * @type {string}
 * @const
 */
var ORDINAL_SCALE_TYPE = 'ordinal';

/**
 * Category scale.
 * @type {string}
 * @const
 */
var CATEGORY_SCALE_TYPE = 'category';

/**
 * Literal scale.
 * Differs slightly from d3's identity scale in that it does not coerce value
 * into numbers, it simply returns exactly what you give it
 * @type {string}
 * @const
 */
var LITERAL_SCALE_TYPE = 'literal';

/**
 * Log scale name.
 * @type {string}
 * @const
 */
var LOG_SCALE_TYPE = 'log';

/**
 * Time scale name.
 * @type {string}
 * @const
 */
var TIME_SCALE_TYPE = 'time';

/**
 * Time UTC scale name.
 * @type {string}
 * @const
 */
var TIME_UTC_SCALE_TYPE = 'time-utc';

/**
 * Scale functions that are supported in the library.
 * @type {Object}
 * @const
 */
var SCALE_FUNCTIONS = (_SCALE_FUNCTIONS = {}, _defineProperty(_SCALE_FUNCTIONS, LINEAR_SCALE_TYPE, __WEBPACK_IMPORTED_MODULE_0_d3_scale__["a" /* scaleLinear */]), _defineProperty(_SCALE_FUNCTIONS, ORDINAL_SCALE_TYPE, __WEBPACK_IMPORTED_MODULE_0_d3_scale__["b" /* scalePoint */]), _defineProperty(_SCALE_FUNCTIONS, CATEGORY_SCALE_TYPE, __WEBPACK_IMPORTED_MODULE_0_d3_scale__["c" /* scaleOrdinal */]), _defineProperty(_SCALE_FUNCTIONS, LITERAL_SCALE_TYPE, literalScale), _defineProperty(_SCALE_FUNCTIONS, LOG_SCALE_TYPE, __WEBPACK_IMPORTED_MODULE_0_d3_scale__["d" /* scaleLog */]), _defineProperty(_SCALE_FUNCTIONS, TIME_SCALE_TYPE, __WEBPACK_IMPORTED_MODULE_0_d3_scale__["e" /* scaleTime */]), _defineProperty(_SCALE_FUNCTIONS, TIME_UTC_SCALE_TYPE, __WEBPACK_IMPORTED_MODULE_0_d3_scale__["f" /* scaleUtc */]), _SCALE_FUNCTIONS);

/**
 * Attrs for which a scale can be set up at XYPlot level
 * @type {Array}
 * @const
 */

var XYPLOT_ATTR = ['color', 'fill', 'opacity', 'stroke'];

/**
 * Find the smallest distance between the values on a given scale and return
 * the index of the element, where the smallest distance was found.
 * It returns the first occurrence of i where
 * `scale(value[i]) - scale(value[i - 1])` is minimal
 * @param {Array} values Array of values.
 * @param {Object} scaleObject Scale object.
 * @returns {number} Index of an element where the smallest distance was found.
 * @private
 */
function _getSmallestDistanceIndex(values, scaleObject) {
  var scaleFn = getScaleFnFromScaleObject(scaleObject);
  var result = 0;
  if (scaleFn) {
    var nextValue = void 0;
    var currentValue = scaleFn(values[0]);
    var distance = Infinity;
    var nextDistance = void 0;

    for (var i = 1; i < values.length; i++) {
      nextValue = scaleFn(values[i]);
      nextDistance = Math.abs(nextValue - currentValue);
      if (nextDistance < distance) {
        distance = nextDistance;
        result = i;
      }
      currentValue = nextValue;
    }
  }
  return result;
}

/**
 * Crate a scale function from the scale object.
 * @param {Object} scaleObject Scale object.
 - scaleObject.domain {Array}
 - scaleObject.range {Array}
 - scaleObject.type {string}
 - scaleObject.attr {string}
 * @returns {*} Scale function.
 * @private
 */
function getScaleFnFromScaleObject(scaleObject) {
  if (!scaleObject) {
    return null;
  }
  var type = scaleObject.type,
      domain = scaleObject.domain,
      range = scaleObject.range;

  var modDomain = domain[0] === domain[1] ? domain[0] === 0 ? [-1, 0] : [-domain[0], domain[0]] : domain;
  if (type === LITERAL_SCALE_TYPE) {
    return literalScale(range[0]);
  }
  var scale = SCALE_FUNCTIONS[type]().domain(modDomain).range(range);
  if (type === ORDINAL_SCALE_TYPE) {
    scale.padding(0.5);
  }
  return scale;
}

/**
 * Get the domain from the array of data.
 * @param {Array} allData All data.
 * @param {string} attr Property name.
 * @param {string} type Scale type.
 * @returns {Array} Domain.
 * @private
 */
function getDomainByAttr(allData, attr, type) {
  var domain = void 0;
  var attr0 = attr + '0';

  // Collect both attr and available attr0 values from the array of data.
  var values = allData.reduce(function (data, d) {
    var value = d[attr];
    var value0 = d[attr0];
    if (_isDefined(value)) {
      data.push(value);
    }
    if (_isDefined(value0)) {
      data.push(value0);
    }
    return data;
  }, []);

  if (!values.length) {
    return [];
  }

  // Create proper domain depending on the type of the scale.
  if (type !== ORDINAL_SCALE_TYPE && type !== CATEGORY_SCALE_TYPE) {
    domain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_array__["a" /* extent */])(values);
  } else {
    domain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_d3_collection__["a" /* set */])(values).values();
  }
  return domain;
}

/**
 * Create custom scale object from the value. When the scale is created from
 * this object, it should return the same value all time.
 * @param {string} attr Attribute.
 * @param {*} value Value.
 * @param {string} type - the type of scale being used
 * @returns {Object} Custom scale object.
 * @private
 */
function _createScaleObjectForValue(attr, value, type) {
  if (type === LITERAL_SCALE_TYPE) {
    return {
      type: LITERAL_SCALE_TYPE,
      domain: [],
      range: [value],
      distance: 0,
      attr: attr,
      baseValue: undefined,
      isValue: true
    };
  }
  if (typeof value === 'undefined') {
    return null;
  }
  return {
    type: CATEGORY_SCALE_TYPE,
    range: [value],
    domain: [],
    distance: 0,
    attr: attr,
    baseValue: undefined,
    isValue: true
  };
}

/**
 * Create a regular scale object for a further use from the existing parameters.
 * @param {Array} domain Domain.
 * @param {Array} range Range.
 * @param {string} type Type.
 * @param {number} distance Distance.
 * @param {string} attr Attribute.
 * @param {number} baseValue Base value.
 * @returns {Object} Scale object.
 * @private
 */
function _createScaleObjectForFunction(domain, range, type, distance, attr, baseValue) {
  return {
    domain: domain,
    range: range,
    type: type,
    distance: distance,
    attr: attr,
    baseValue: baseValue,
    isValue: false
  };
}

/**
 * Get scale object from props. E. g. object like {xRange, xDomain, xDistance,
 * xType} is transformed into {range, domain, distance, type}.
 * @param {Object} props Props.
 * @param {string} attr Attribute.
 * @returns {*} Null or an object with the scale.
 * @private
 */
function _collectScaleObjectFromProps(props, attr) {
  var value = props[attr],
      fallbackValue = props['_' + attr + 'Value'],
      range = props[attr + 'Range'],
      _props$ = props[attr + 'Distance'],
      distance = _props$ === undefined ? 0 : _props$,
      baseValue = props[attr + 'BaseValue'],
      _props$2 = props[attr + 'Type'],
      type = _props$2 === undefined ? LINEAR_SCALE_TYPE : _props$2,
      noFallBack = props[attr + 'NoFallBack'];
  var domain = props[attr + 'Domain'];

  // Return value-based scale if the value is assigned.

  if (!noFallBack && typeof value !== 'undefined') {
    return _createScaleObjectForValue(attr, value, props[attr + 'Type']);
  }

  // Pick up the domain from the properties and create a new one if it's not
  // available.
  if (typeof baseValue !== 'undefined') {
    domain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__data_utils__["a" /* addValueToArray */])(domain, baseValue);
  }

  // Make sure that the minimum necessary properties exist.
  if (!range || !domain || !domain.length) {
    // Try to use the fallback value if it is available.
    return _createScaleObjectForValue(attr, fallbackValue, props[attr + 'Type']);
  }

  return _createScaleObjectForFunction(domain, range, type, distance, attr, baseValue);
}

/**
 * Compute left domain adjustment for the given values.
 * @param {Array} values Array of values.
 * @returns {number} Domain adjustment.
 * @private
 */
function _computeLeftDomainAdjustment(values) {
  if (values.length > 1) {
    return (values[1] - values[0]) / 2;
  }
  if (values.length === 1) {
    return values[0] - 0.5;
  }
  return 0;
}

/**
 * Compute right domain adjustment for the given values.
 * @param {Array} values Array of values.
 * @returns {number} Domain adjustment.
 * @private
 */
function _computeRightDomainAdjustment(values) {
  if (values.length > 1) {
    return (values[values.length - 1] - values[values.length - 2]) / 2;
  }
  if (values.length === 1) {
    return values[0] - 0.5;
  }
  return 0;
}

/**
 * Compute distance for the given values.
 * @param {Array} values Array of values.
 * @param {Array} domain Domain.
 * @param {number} bestDistIndex Index of a best distance found.
 * @param {function} scaleFn Scale function.
 * @returns {number} Domain adjustment.
 * @private
 */
function _computeScaleDistance(values, domain, bestDistIndex, scaleFn) {
  if (values.length > 1) {
    // Avoid zero indexes.
    var i = Math.max(bestDistIndex, 1);
    return Math.abs(scaleFn(values[i]) - scaleFn(values[i - 1]));
  }
  if (values.length === 1) {
    return Math.abs(scaleFn(domain[1]) - scaleFn(domain[0]));
  }
  return 0;
}

/**
 * Normilize array of values with a single value.
 * @param {Array} arr Array of data.
 * @param {Array} values Array of values.
 * @param {string} attr Attribute.
 * @param {string} type Type.
 * @private
 */
function _normalizeValues(data, values, attr, type) {
  if (type === TIME_SCALE_TYPE && values.length === 1) {
    var attr0 = data[0][attr + '0'];

    return [attr0].concat(_toConsumableArray(values));
  }

  return values;
}

/**
 * Get the distance, the smallest and the largest value of the domain.
 * @param {Array} data Array of data for the single series.
 * @param {Object} scaleObject Scale object.
 * @returns {{domain0: number, domainN: number, distance: number}} Result.
 * @private
 */
function _getScaleDistanceAndAdjustedDomain(data, scaleObject) {
  var attr = scaleObject.attr,
      domain = scaleObject.domain,
      type = scaleObject.type;


  var uniqueValues = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__data_utils__["b" /* getUniquePropertyValues */])(data, attr);

  // Fix time scale if a data has only one value.
  var values = _normalizeValues(data, uniqueValues, attr, type);

  var index = _getSmallestDistanceIndex(values, scaleObject);

  var adjustedDomain = [].concat(domain);

  adjustedDomain[0] -= _computeLeftDomainAdjustment(values);
  adjustedDomain[domain.length - 1] += _computeRightDomainAdjustment(values);
  // Fix log scale if it's too small.
  if (type === LOG_SCALE_TYPE && domain[0] <= 0) {
    adjustedDomain[0] = Math.min(domain[1] / 10, 1);
  }

  var adjustedScaleFn = getScaleFnFromScaleObject(_extends({}, scaleObject, {
    domain: adjustedDomain
  }));

  var distance = _computeScaleDistance(values, adjustedDomain, index, adjustedScaleFn);

  return {
    domain0: adjustedDomain[0],
    domainN: adjustedDomain[adjustedDomain.length - 1],
    distance: distance
  };
}

/**
 * Returns true if scale adjustments are possible for a given scale.
 * @param {Object} props Props.
 * @param {Object} scaleObject Scale object.
 * @returns {boolean} True if scale adjustments possible.
 * @private
 */
function _isScaleAdjustmentPossible(props, scaleObject) {
  var attr = scaleObject.attr;
  var _props$_adjustBy = props._adjustBy,
      adjustBy = _props$_adjustBy === undefined ? [] : _props$_adjustBy,
      _props$_adjustWhat = props._adjustWhat,
      adjustWhat = _props$_adjustWhat === undefined ? [] : _props$_adjustWhat;

  // The scale cannot be adjusted if there's no attributes to adjust, no
  // suitable values

  return adjustWhat.length && adjustBy.length && adjustBy.indexOf(attr) !== -1;
}

/**
 * Adjust continuous scales (e.g. 'linear', 'log' and 'time') by adding the
 * space from the left and right of them and by computing the best distance.
 * @param {Object} props Props.
 * @param {Object} scaleObject Scale object.
 * @returns {*} Scale object with adjustments.
 * @private
 */
function _adjustContinuousScale(props, scaleObject) {
  var allSeriesData = props._allData,
      _props$_adjustWhat2 = props._adjustWhat,
      adjustWhat = _props$_adjustWhat2 === undefined ? [] : _props$_adjustWhat2;

  // Assign the initial values.

  var domainLength = scaleObject.domain.length;
  var domain = scaleObject.domain;

  var scaleDomain0 = domain[0];
  var scaleDomainN = domain[domainLength - 1];
  var scaleDistance = scaleObject.distance;

  // Find the smallest left position of the domain, the largest right position
  // of the domain and the best distance for them.
  allSeriesData.forEach(function (data, index) {
    if (adjustWhat.indexOf(index) === -1) {
      return;
    }
    if (data && data.length) {
      var _getScaleDistanceAndA = _getScaleDistanceAndAdjustedDomain(data, scaleObject),
          domain0 = _getScaleDistanceAndA.domain0,
          domainN = _getScaleDistanceAndA.domainN,
          distance = _getScaleDistanceAndA.distance;

      scaleDomain0 = Math.min(scaleDomain0, domain0);
      scaleDomainN = Math.max(scaleDomainN, domainN);
      scaleDistance = Math.max(scaleDistance, distance);
    }
  });

  scaleObject.domain = [scaleDomain0].concat(_toConsumableArray(domain.slice(1, -1)), [scaleDomainN]);

  scaleObject.distance = scaleDistance;

  return scaleObject;
}

/**
 * Get an adjusted scale. Suitable for 'category' and 'ordinal' scales.
 * @param {Object} scaleObject Scale object.
 * @returns {*} Scale object with adjustments.
 * @private
 */
function _adjustCategoricalScale(scaleObject) {
  var scaleFn = getScaleFnFromScaleObject(scaleObject);
  var domain = scaleObject.domain,
      range = scaleObject.range;

  if (domain.length > 1) {
    scaleObject.distance = Math.abs(scaleFn(domain[1]) - scaleFn(domain[0]));
  } else {
    scaleObject.distance = Math.abs(range[1] - range[0]);
  }

  return scaleObject;
}

/**
 * Retrieve a scale object or a value from the properties passed.
 * @param {Object} props Object of props.
 * @param {string} attr Attribute.
 * @returns {*} Scale object, value or null.
 */
function getScaleObjectFromProps(props, attr) {
  // Create the initial scale object.
  var scaleObject = _collectScaleObjectFromProps(props, attr);

  if (!scaleObject) {
    return null;
  }

  // Make sure if it's possible to add space to the scale object. If not,
  // return the object immediately.
  if (!_isScaleAdjustmentPossible(props, scaleObject)) {
    return scaleObject;
  }

  var type = scaleObject.type;
  // Depending on what type the scale is, apply different adjustments. Distances
  // for the ordinal and category scales are even, equal domains cannot be
  // adjusted.

  if (type === ORDINAL_SCALE_TYPE || type === CATEGORY_SCALE_TYPE) {
    return _adjustCategoricalScale(scaleObject);
  }
  return _adjustContinuousScale(props, scaleObject);
}

/**
 * Get d3 scale for a given prop.
 * @param {Object} props Props.
 * @param {string} attr Attribute.
 * @returns {function} d3 scale function.
 */
function getAttributeScale(props, attr) {
  var scaleObject = getScaleObjectFromProps(props, attr);
  return getScaleFnFromScaleObject(scaleObject);
}

/**
 * Get the value of `attr` from the object.
 * @param {Object} d Object.
 * @param {string} attr Attribute.
 * @returns {*} Value of the point.
 * @private
 */
function _getAttrValue(d, attr) {
  return d.data ? d.data[attr] : d[attr];
}

function _isDefined(value) {
  return typeof value !== 'undefined';
}

/*
 * Adds a percentage of padding to a given domain
 * @param {Array} domain X or Y domain to pad.
 * @param {Number} padding Percentage of padding to add to domain
 * @returns {Array} Padded Domain
 */
function _padDomain(domain, padding) {
  if (!domain) {
    return domain;
  }
  if (isNaN(parseFloat(domain[0])) || isNaN(parseFloat(domain[1]))) {
    return domain;
  }

  var _domain = _slicedToArray(domain, 2),
      min = _domain[0],
      max = _domain[1];

  var domainPadding = (max - min) * (padding * 0.01);
  return [min - domainPadding, max + domainPadding];
}

/**
 * Get prop functor (either a value or a function) for a given attribute.
 * @param {Object} props Series props.
 * @param {string} attr Property name.
 * @returns {*} Function or value.
 */
function getAttributeFunctor(props, attr) {
  var scaleObject = getScaleObjectFromProps(props, attr);
  if (scaleObject) {
    var scaleFn = getScaleFnFromScaleObject(scaleObject);
    return function (d) {
      return scaleFn(_getAttrValue(d, attr));
    };
  }
  return null;
}

/**
 * Get the functor which extracts value form [attr]0 property. Use baseValue if
 * no attr0 property for a given object is defined. Fall back to domain[0] if no
 * base value is available.
 * @param {Object} props Object of props.
 * @param {string} attr Attribute name.
 * @returns {*} Function which returns value or null if no values available.
 */
function getAttr0Functor(props, attr) {
  var scaleObject = getScaleObjectFromProps(props, attr);
  if (scaleObject) {
    var attr0 = attr + '0';
    var domain = scaleObject.domain;
    var _scaleObject$baseValu = scaleObject.baseValue,
        baseValue = _scaleObject$baseValu === undefined ? domain[0] : _scaleObject$baseValu;

    var scaleFn = getScaleFnFromScaleObject(scaleObject);
    return function (d) {
      var value = _getAttrValue(d, attr0);
      return scaleFn(_isDefined(value) ? value : baseValue);
    };
  }
  return null;
}

/**
 * Tries to get the string|number value of the attr and falls back to
 * a fallback property in case if the value is a scale.
 * @param {Object} props Series props.
 * @param {string} attr Property name.
 * @returns {*} Function or value.
 */
function getAttributeValue(props, attr) {
  var scaleObject = getScaleObjectFromProps(props, attr);
  if (scaleObject) {
    if (!scaleObject.isValue && props['_' + attr + 'Value'] === undefined) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__react_utils__["a" /* warning */])('[React-vis] Cannot use data defined ' + attr + ' for this ' + 'series type. Using fallback value instead.');
    }
    return props['_' + attr + 'Value'] || scaleObject.range[0];
  }
  return null;
}

/**
 * Get prop types by the attribute.
 * @param {string} attr Attribute.
 * @returns {Object} Object of xDomain, xRange, xType, xDistance and _xValue,
 * where x is an attribute passed to the function.
 */
function getScalePropTypesByAttribute(attr) {
  var _ref;

  return _ref = {}, _defineProperty(_ref, '_' + attr + 'Value', __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any), _defineProperty(_ref, attr + 'Domain', __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array), _defineProperty(_ref, attr + 'Range', __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array), _defineProperty(_ref, attr + 'Type', __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(Object.keys(SCALE_FUNCTIONS))), _defineProperty(_ref, attr + 'Distance', __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number), _defineProperty(_ref, attr + 'BaseValue', __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any), _ref;
}

/**
 * Extract the list of scale properties from the entire props object.
 * @param {Object} props Props.
 * @param {Array<String>} attributes Array of attributes for the given
 * components (for instance, `['x', 'y', 'color']`).
 * @returns {Object} Collected props.
 */
function extractScalePropsFromProps(props, attributes) {
  var result = {};
  Object.keys(props).forEach(function (key) {
    var attr = attributes.find(function (a) {
      return key.indexOf(a) === 0 || key.indexOf('_' + a) === 0;
    });
    if (!attr) {
      return;
    }
    result[key] = props[key];
  });
  return result;
}

/**
 * Extract the missing scale props from the given data and return them as
 * an object.
 * @param {Object} props Props.
 * @param {Array} data Array of all data.
 * @param {Array<String>} attributes Array of attributes for the given
 * components (for instance, `['x', 'y', 'color']`).
 * @returns {Object} Collected props.
 */
function getMissingScaleProps(props, data, attributes) {
  var result = {};
  // Make sure that the domain is set pad it if specified
  attributes.forEach(function (attr) {
    if (!props[attr + 'Domain']) {
      result[attr + 'Domain'] = getDomainByAttr(data, attr, props[attr + 'Type']);
      if (props[attr + 'Padding']) {
        result[attr + 'Domain'] = _padDomain(result[attr + 'Domain'], props[attr + 'Padding']);
      }
    }
  });

  return result;
}

/**
 * Return a d3 scale that returns the literal value that was given to it
 * @returns {function} literal scale.
 */
function literalScale(defaultValue) {
  function scale(d) {
    if (d === undefined) {
      return defaultValue;
    }
    return d;
  }

  function response() {
    return scale;
  }

  scale.domain = response;
  scale.range = response;
  scale.unknown = response;
  scale.copy = response;

  return scale;
}

function getFontColorFromBackground(background) {
  if (background) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_d3_color__["a" /* hsl */])(background).l > 0.57 ? '#222' : '#fff';
  }
  return null;
}

/**
 * Creates fallback values for series from scales defined at XYPlot level.
 * @param {Object} props Props of the XYPlot object.
 * @param {Array<Object>} children Array of components, children of XYPlot
 * @returns {Array<Object>} Collected props.
 */

function getXYPlotValues(props, children) {
  var XYPlotScales = XYPLOT_ATTR.reduce(function (prev, attr) {
    var domain = props[attr + 'Domain'],
        range = props[attr + 'Range'],
        type = props[attr + 'Type'];


    if (domain && range && type) {
      return _extends({}, prev, _defineProperty({}, attr, SCALE_FUNCTIONS[type]().domain(domain).range(range)));
    }
    return prev;
  }, {});

  return children.map(function (child) {
    return XYPLOT_ATTR.reduce(function (prev, attr) {
      if (child.props && child.props[attr] !== undefined) {
        var scaleInput = child.props[attr];
        var scale = XYPlotScales[attr];
        var fallbackValue = scale ? scale(scaleInput) : scaleInput;
        return _extends({}, prev, _defineProperty({}, '_' + attr + 'Value', fallbackValue));
      }
      return prev;
    }, {});
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  extractScalePropsFromProps: extractScalePropsFromProps,
  getAttributeScale: getAttributeScale,
  getAttributeFunctor: getAttributeFunctor,
  getAttr0Functor: getAttr0Functor,
  getAttributeValue: getAttributeValue,
  getDomainByAttr: getDomainByAttr,
  getFontColorFromBackground: getFontColorFromBackground,
  getMissingScaleProps: getMissingScaleProps,
  getScaleObjectFromProps: getScaleObjectFromProps,
  getScalePropTypesByAttribute: getScalePropTypesByAttribute,
  getXYPlotValues: getXYPlotValues,
  literalScale: literalScale
});

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_color__ = __webpack_require__(188);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_lab__ = __webpack_require__(740);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__src_lab__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__src_lab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_cubehelix__ = __webpack_require__(739);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__src_cubehelix__["a"]; });





/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames);
    global.FontIcon = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var styles = {
    sized: { width: 24, height: 24 },
    fullySized: { width: 24, height: 24, fontSize: 24 }
  };

  /**
   * The \`FontIcon\` component is used for rendering a font-icon library's
   * icon. The default is to use the `material-icons` library, but others
   * can be used as well.
   *
   * If you are using another font-icon library that does not always create
   * icons with a perfect 1:1 scale (such as font-awesome), it is recommended
   * to update the `.md-icon` styles to set the width and height to `$md-font-icon-size`.
   * However, this will prevent different sided icons.
   *
   * \`\`\`scss
   * .md-icon.fa {
   *   height: $md-font-icon-size;
   *   width: $md-font-icon-size;
   * }
   * \`\`\`
   */

  var FontIcon = function (_PureComponent) {
    _inherits(FontIcon, _PureComponent);

    function FontIcon() {
      _classCallCheck(this, FontIcon);

      return _possibleConstructorReturn(this, (FontIcon.__proto__ || Object.getPrototypeOf(FontIcon)).apply(this, arguments));
    }

    _createClass(FontIcon, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            iconClassName = _props.iconClassName,
            className = _props.className,
            children = _props.children,
            disabled = _props.disabled,
            style = _props.style,
            forceSize = _props.forceSize,
            forceFontSize = _props.forceFontSize,
            props = _objectWithoutProperties(_props, ['iconClassName', 'className', 'children', 'disabled', 'style', 'forceSize', 'forceFontSize']);

        var mergedStyles = style;
        if (typeof forceSize === 'boolean') {
          var merge = forceFontSize ? styles.fullySized : styles.sized;
          mergedStyles = style ? _extends({}, merge, style) : merge;
        } else if (typeof forceSize === 'number') {
          var _merge = {
            fontSize: forceFontSize ? forceSize : undefined,
            height: forceSize,
            width: forceSize
          };

          mergedStyles = style ? _extends({}, _merge, style) : _merge;
        }

        return _react2.default.createElement(
          'i',
          _extends({}, props, {
            style: mergedStyles,
            className: (0, _classnames2.default)('md-icon', iconClassName, {
              'md-icon--disabled': disabled
            }, className)
          }),
          children
        );
      }
    }]);

    return FontIcon;
  }(_react.PureComponent);

  FontIcon.propTypes = {
    /**
     * An optional style to apply.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply to the `FontIcon`.
     */
    className: _propTypes2.default.string,

    /**
     * The icon font library className to use to display the icon.
     */
    iconClassName: _propTypes2.default.string.isRequired,

    /**
     * Any children required to display the icon with the font library.
     */
    children: _propTypes2.default.node,

    /**
     * Boolean if the `FontIcon` should gain the disabled colors.
     */
    disabled: _propTypes2.default.bool,

    /**
     * Either a boolean that will enforce the 24x24 size of the font icon or a number of the size
     * to enforce. This is useful when using other font icon libraries that do not have a consistent
     * size.
     */
    forceSize: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number]),

    /**
     * Boolean if the `forceSize` prop should also force the `font-size` instead of only `width` and `height`.
     */
    forceFontSize: function forceFontSize(props, propName, component) {
      for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        args[_key - 3] = arguments[_key];
      }

      var error = _propTypes2.default.bool.apply(_propTypes2.default, [props, propName, component].concat(args));
      if (!error && typeof props.forceSize === 'undefined' && props[propName]) {
        error = new Error('You provided a `forceFontSize` prop to the ' + component + ' component, without specifying the `forceSize` ' + ('prop. Either set the `forceSize` prop to a boolean or a number, or disable `' + propName + '`.'));
      }

      return error;
    }
  };
  FontIcon.defaultProps = {
    iconClassName: 'material-icons'
  };
  exports.default = FontIcon;
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__ = __webpack_require__(1241);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MemoryRouter", function() { return __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Prompt__ = __webpack_require__(1242);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Prompt", function() { return __WEBPACK_IMPORTED_MODULE_1__Prompt__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redirect__ = __webpack_require__(1243);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_2__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(607);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_3__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(275);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_4__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaticRouter__ = __webpack_require__(1244);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StaticRouter", function() { return __WEBPACK_IMPORTED_MODULE_5__StaticRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch__ = __webpack_require__(1245);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return __WEBPACK_IMPORTED_MODULE_6__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__matchPath__ = __webpack_require__(276);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matchPath", function() { return __WEBPACK_IMPORTED_MODULE_7__matchPath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__withRouter__ = __webpack_require__(1246);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_8__withRouter__["a"]; });



















/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ORIENTATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DIRECTION; });
/* harmony export (immutable) */ __webpack_exports__["c"] = getTicksTotalFromSize;
/* harmony export (immutable) */ __webpack_exports__["d"] = getTickValues;
/* unused harmony export generateFit */
/* harmony export (immutable) */ __webpack_exports__["f"] = generatePoints;
/* harmony export (immutable) */ __webpack_exports__["g"] = getAxisAngle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_scale__ = __webpack_require__(97);
// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.




var ORIENTATION = {
  TOP: 'top',
  LEFT: 'left',
  RIGHT: 'right',
  BOTTOM: 'bottom'
};

var DIRECTION = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal'
};

/**
 * Get total amount of ticks from a given size in pixels.
 * @param {number} size Size of the axis in pixels.
 * @returns {number} Total amount of ticks.
 */
function getTicksTotalFromSize(size) {
  if (size < 700) {
    if (size > 300) {
      return 10;
    }
    return 5;
  }
  return 20;
}

/**
 * Get the tick values from a given d3 scale.
 * @param {d3.scale} scale Scale function.
 * @param {number} tickTotal Total number of ticks
 * @param {Array} tickValues Array of tick values if they exist.
 * @returns {Array} Array of tick values.
 */
function getTickValues(scale, tickTotal, tickValues) {
  return !tickValues ? scale.ticks ? scale.ticks(tickTotal) : scale.domain() : tickValues;
}

/**
 * Generate a description of a decorative axis in terms of a linear equation
 * y = slope * x + offset in coordinates
 * @param {Object} axisStart Object of format {x, y} describing in coordinates
 * the start position of the decorative axis
 * @param {Object} axisEnd Object of format {x, y} describing in coordinates
 * the start position of the decorative axis
 * @returns {Number} Object describing each the line in coordinates
 */
function generateFit(axisStart, axisEnd) {
  // address the special case when the slope is infinite
  if (axisStart.x === axisEnd.x) {
    return {
      left: axisStart.y,
      right: axisEnd.y,
      slope: 0,
      offset: axisStart.x
    };
  }
  var slope = (axisStart.y - axisEnd.y) / (axisStart.x - axisEnd.x);
  return {
    left: axisStart.x,
    right: axisEnd.x,
    // generate the linear projection of the axis direction
    slope: slope,
    offset: axisStart.y - slope * axisStart.x
  };
}

/**
 * Generate a description of a decorative axis in terms of a linear equation
 * y = slope * x + offset in coordinates
 * @param props
 * props.@param {Object} axisStart Object of format {x, y} describing in coordinates
 * the start position of the decorative axis
 * props.@param {Object} axisEnd Object of format {x, y} describing in coordinates
 * the start position of the decorative axis
 * props.@param {Number} numberOfTicks The number of ticks on the axis
 * props.@param {Array.Numbers} axisDomain The values to be interpolated across for the axis
 * @returns {Number} Object describing the slope and the specific coordinates of the points
 */
function generatePoints(_ref) {
  var axisStart = _ref.axisStart,
      axisEnd = _ref.axisEnd,
      numberOfTicks = _ref.numberOfTicks,
      axisDomain = _ref.axisDomain;

  var _generateFit = generateFit(axisStart, axisEnd),
      left = _generateFit.left,
      right = _generateFit.right,
      slope = _generateFit.slope,
      offset = _generateFit.offset;
  // construct a linear band of points, then map them


  var pointSlope = (right - left) / numberOfTicks;
  var axisScale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_scale__["a" /* scaleLinear */])().domain([left, right]).range(axisDomain);

  var slopeVertical = axisStart.x === axisEnd.x;
  return {
    slope: slopeVertical ? Infinity : slope,
    points: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["i" /* range */])(left, right + pointSlope, pointSlope).map(function (val) {
      if (slopeVertical) {
        return { y: val, x: slope * val + offset, text: axisScale(val) };
      }
      return { x: val, y: slope * val + offset, text: axisScale(val) };
    })
  };
}

/**
 * Compute the angle (in radians) of a decorative axis
 * @param {Object} axisStart Object of format {x, y} describing in coordinates
 * the start position of the decorative axis
 * @param {Object} axisEnd Object of format {x, y} describing in coordinates
 * the start position of the decorative axis
 * @returns {Number} Angle in radials
 */
function getAxisAngle(axisStart, axisEnd) {
  if (axisStart.x === axisEnd.x) {
    return axisEnd.y > axisStart.y ? Math.PI / 2 : 3 * Math.PI / 2;
  }
  return Math.atan((axisEnd.y - axisStart.y) / (axisEnd.x - axisStart.x));
}

/* harmony default export */ __webpack_exports__["a"] = ({
  DIRECTION: DIRECTION,
  ORIENTATION: ORIENTATION,
  getTicksTotalFromSize: getTicksTotalFromSize,
  getTickValues: getTickValues
});

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// Trust the developer to only use ReactInstrumentation with a __DEV__ check

var debugTool = null;

if (false) {
  var ReactDebugTool = require('./ReactDebugTool');
  debugTool = ReactDebugTool;
}

module.exports = { debugTool: debugTool };

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 34 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7),
    _assign = __webpack_require__(10);

var CallbackQueue = __webpack_require__(531);
var PooledClass = __webpack_require__(61);
var ReactFeatureFlags = __webpack_require__(536);
var ReactReconciler = __webpack_require__(80);
var Transaction = __webpack_require__(149);

var invariant = __webpack_require__(4);

var dirtyComponents = [];
var updateBatchNumber = 0;
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */true);
}

_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  // Any updates enqueued while reconciling must be performed after this entire
  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
  // C, B could update twice in a single batch if C's render enqueues an update
  // to B (since B would have already updated, we should skip it, and the only
  // way we can know to do so is by checking the batch counter).
  updateBatchNumber++;

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    var markerName;
    if (ReactFeatureFlags.logTopLevelRenders) {
      var namedComponent = component;
      // Duck type TopLevelWrapper. This is probably always true.
      if (component._currentElement.type.isReactTopLevelWrapper) {
        namedComponent = component._renderedComponent;
      }
      markerName = 'React update: ' + namedComponent.getName();
      console.time(markerName);
    }

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);

    if (markerName) {
      console.timeEnd(markerName);
    }

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
  if (component._updateBatchNumber == null) {
    component._updateBatchNumber = updateBatchNumber + 1;
  }
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(28)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./FontIcon'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.FontIcon);
    global.index = mod.exports;
  }
})(this, function (exports, _FontIcon) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _FontIcon2 = _interopRequireDefault(_FontIcon);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _FontIcon2.default;
});

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(155), __webpack_require__(253)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./AccessibleFakeButton'), require('../Inks/injectInk'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.AccessibleFakeButton, global.injectInk);
    global.AccessibleFakeInkedButton = mod.exports;
  }
})(this, function (exports, _AccessibleFakeButton, _injectInk) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _AccessibleFakeButton2 = _interopRequireDefault(_AccessibleFakeButton);

  var _injectInk2 = _interopRequireDefault(_injectInk);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = (0, _injectInk2.default)(_AccessibleFakeButton2.default);
});

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.CSSTransitionGroupTick = mod.exports;
  }
})(this, function (exports) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = 17;
});

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteAuthorization = exports.fetchAuthorizations = exports.createAudio = exports.updateSubject = exports.createSubject = exports.fetchSubjects = exports.fetchTimezones = exports.fetchChannels = exports.fetchCampaigns = exports.fetchCampaign = exports.launchCampaign = exports.updateCampaign = exports.logout = exports.createCampaign = exports.Unauthorized = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

__webpack_require__(908);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Unauthorized = exports.Unauthorized = function Unauthorized(response) {
  _classCallCheck(this, Unauthorized);

  this.response = response;
};

var apiFetch = function apiFetch(url, options) {
  return fetch('/api/v1/' + url, _extends({}, options, { credentials: 'same-origin' })).then(function (response) {
    return handleResponse(response, function () {
      return response;
    });
  });
};

var apiFetchJSON = function apiFetchJSON(url, options) {
  return apiFetchJSONWithCallback(url, options, commonCallback);
};

var apiFetchJSONWithCallback = function apiFetchJSONWithCallback(url, options, responseCallback) {
  return apiFetch(url, options).then(function (response) {
    if (response.status == 204) {
      // HTTP 204: No Content
      return { json: null, response: response };
    } else {
      return response.json().then(function (json) {
        return { json: json, response: response };
      });
    }
  }).then(function (_ref) {
    var json = _ref.json,
        response = _ref.response;

    return handleResponse(response, responseCallback(json));
  });
};

var commonCallback = function commonCallback(json) {
  return function () {
    if (!json) {
      return null;
    }
    if (json.errors) {
      console.log(json.errors);
    }
    return json.data;
  };
};

var handleResponse = function handleResponse(response, callback) {
  if (response.ok) {
    return callback();
  } else if (response.status == 401 || response.status == 403) {
    return Promise.reject(new Unauthorized(response.statusText));
  } else {
    return Promise.reject(response);
  }
};

var apiPutOrPostJSON = function apiPutOrPostJSON(url, verb, body) {
  var options = {
    method: verb,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  };
  if (body) {
    options.body = JSON.stringify(body);
  }
  return apiFetchJSON(url, options);
};

var apiPostJSON = function apiPostJSON(url, body) {
  return apiPutOrPostJSON(url, 'POST', body);
};

var apiPutJSON = function apiPutJSON(url, body) {
  return apiPutOrPostJSON(url, 'PUT', body);
};

var apiDelete = function apiDelete(url) {
  return apiFetch(url, { method: 'DELETE' });
};

var apiPostFile = function apiPostFile(url, file) {
  return apiFetchJSON(url, {
    method: 'POST',
    body: newFormData(file)
  });
};

var newFormData = function newFormData(file) {
  var formData = new FormData();
  formData.append('file', file);
  return formData;
};

var createCampaign = exports.createCampaign = function createCampaign(campaign) {
  return apiPostJSON('campaigns', { campaign: campaign });
};

var logout = exports.logout = function logout(guissoLogoutUrl) {
  apiDelete('sessions').then(function () {
    window.location.href = guissoLogoutUrl;
  });
};

var updateCampaign = exports.updateCampaign = function updateCampaign(campaign) {
  return apiPutJSON('campaigns/' + campaign.id, { campaign: campaign });
};

var launchCampaign = exports.launchCampaign = function launchCampaign(id) {
  return apiPutJSON('campaigns/' + id + '/launch');
};

var fetchCampaign = exports.fetchCampaign = function fetchCampaign(id) {
  return apiFetchJSON('campaigns/' + id);
};

var fetchCampaigns = exports.fetchCampaigns = function fetchCampaigns() {
  return apiFetchJSON('campaigns');
};

var fetchChannels = exports.fetchChannels = function fetchChannels() {
  return apiFetchJSON('channels');
};

var fetchTimezones = exports.fetchTimezones = function fetchTimezones() {
  return apiFetchJSON('timezones');
};

var fetchSubjects = exports.fetchSubjects = function fetchSubjects(campaignId, limit, page) {
  return apiFetchJSONWithCallback('campaigns/' + campaignId + '/subjects/?limit=' + limit + '&page=' + page, null, function (json) {
    return function () {
      if (!json) {
        return null;
      }
      if (json.errors) {
        console.log(json.errors);
      }
      return { count: json.meta.count, subjects: json.data.subjects };
    };
  });
};

var createSubject = exports.createSubject = function createSubject(campaignId, subject) {
  return apiPostJSON('campaigns/' + campaignId + '/subjects', { subject: subject });
};

var updateSubject = exports.updateSubject = function updateSubject(campaignId, subject) {
  return apiPutJSON('campaigns/' + campaignId + '/subjects/' + subject.id, { subject: subject });
};

var createAudio = exports.createAudio = function createAudio(files) {
  return apiPostFile('audios', files[0]);
};

var fetchAuthorizations = exports.fetchAuthorizations = function fetchAuthorizations() {
  return apiFetchJSONWithCallback('authorizations', null, function (json, _) {
    return function () {
      return json;
    };
  });
};

var deleteAuthorization = exports.deleteAuthorization = function deleteAuthorization(provider, baseUrl) {
  var keepChannels = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  return apiDelete('authorizations/' + provider + '?base_url=' + encodeURIComponent(baseUrl) + '&keep_channels=' + keepChannels);
};

/***/ }),
/* 40 */
/***/ (function(module, exports) {

var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = projection;
/* harmony export (immutable) */ __webpack_exports__["b"] = projectionMutator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__clip_antimeridian__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clip_circle__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__clip_extent__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__compose__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__identity__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rotation__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__transform__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fit__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__resample__ = __webpack_require__(782);











var transformRadians = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__transform__["a" /* transformer */])({
  point: function(x, y) {
    this.stream.point(x * __WEBPACK_IMPORTED_MODULE_5__math__["g" /* radians */], y * __WEBPACK_IMPORTED_MODULE_5__math__["g" /* radians */]);
  }
});

function projection(project) {
  return projectionMutator(function() { return project; })();
}

function projectionMutator(projectAt) {
  var project,
      k = 150, // scale
      x = 480, y = 250, // translate
      dx, dy, lambda = 0, phi = 0, // center
      deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, projectRotate, // rotate
      theta = null, preclip = __WEBPACK_IMPORTED_MODULE_0__clip_antimeridian__["a" /* default */], // clip angle
      x0 = null, y0, x1, y1, postclip = __WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */], // clip extent
      delta2 = 0.5, projectResample = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__resample__["a" /* default */])(projectTransform, delta2), // precision
      cache,
      cacheStream;

  function projection(point) {
    point = projectRotate(point[0] * __WEBPACK_IMPORTED_MODULE_5__math__["g" /* radians */], point[1] * __WEBPACK_IMPORTED_MODULE_5__math__["g" /* radians */]);
    return [point[0] * k + dx, dy - point[1] * k];
  }

  function invert(point) {
    point = projectRotate.invert((point[0] - dx) / k, (dy - point[1]) / k);
    return point && [point[0] * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */], point[1] * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */]];
  }

  function projectTransform(x, y) {
    return x = project(x, y), [x[0] * k + dx, dy - x[1] * k];
  }

  projection.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = transformRadians(preclip(rotate, projectResample(postclip(cacheStream = stream))));
  };

  projection.clipAngle = function(_) {
    return arguments.length ? (preclip = +_ ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__clip_circle__["a" /* default */])(theta = _ * __WEBPACK_IMPORTED_MODULE_5__math__["g" /* radians */], 6 * __WEBPACK_IMPORTED_MODULE_5__math__["g" /* radians */]) : (theta = null, __WEBPACK_IMPORTED_MODULE_0__clip_antimeridian__["a" /* default */]), reset()) : theta * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */];
  };

  projection.clipExtent = function(_) {
    return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, __WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */]) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__clip_extent__["a" /* clipExtent */])(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };

  projection.scale = function(_) {
    return arguments.length ? (k = +_, recenter()) : k;
  };

  projection.translate = function(_) {
    return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [x, y];
  };

  projection.center = function(_) {
    return arguments.length ? (lambda = _[0] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["g" /* radians */], phi = _[1] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["g" /* radians */], recenter()) : [lambda * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */], phi * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */]];
  };

  projection.rotate = function(_) {
    return arguments.length ? (deltaLambda = _[0] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["g" /* radians */], deltaPhi = _[1] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["g" /* radians */], deltaGamma = _.length > 2 ? _[2] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["g" /* radians */] : 0, recenter()) : [deltaLambda * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */], deltaPhi * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */], deltaGamma * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */]];
  };

  projection.precision = function(_) {
    return arguments.length ? (projectResample = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__resample__["a" /* default */])(projectTransform, delta2 = _ * _), reset()) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__math__["n" /* sqrt */])(delta2);
  };

  projection.fitExtent = function(extent, object) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__fit__["a" /* fitExtent */])(projection, extent, object);
  };

  projection.fitSize = function(size, object) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__fit__["b" /* fitSize */])(projection, size, object);
  };

  function recenter() {
    projectRotate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__compose__["a" /* default */])(rotate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__rotation__["b" /* rotateRadians */])(deltaLambda, deltaPhi, deltaGamma), project);
    var center = project(lambda, phi);
    dx = x - center[0] * k;
    dy = y + center[1] * k;
    return reset();
  }

  function reset() {
    cache = cacheStream = null;
    return projection;
  }

  return function() {
    project = projectAt.apply(this, arguments);
    projection.invert = project.invert && invert;
    return recenter();
  };
}


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return durationSecond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return durationMinute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return durationHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return durationDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return durationWeek; });
var durationSecond = 1e3;
var durationMinute = 6e4;
var durationHour = 36e5;
var durationDay = 864e5;
var durationWeek = 6048e5;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(397);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(10);

var PooledClass = __webpack_require__(61);

var emptyFunction = __webpack_require__(30);
var warning = __webpack_require__(6);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';

var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
  if (false) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (false) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

_assign(SyntheticEvent.prototype, {

  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
    } else if (typeof event.returnValue !== 'unknown') {
      // eslint-disable-line valid-typeof
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
    } else if (typeof event.cancelBubble !== 'unknown') {
      // eslint-disable-line valid-typeof
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (false) {
        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (false) {
      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
    }
  }

});

SyntheticEvent.Interface = EventInterface;

if (false) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function (target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function (constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function (target, prop, value) {
            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}
/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var E = function () {};
  E.prototype = Super.prototype;
  var prototype = new E();

  _assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = _assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {object} SyntheticEvent
  * @param {String} propName
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
  }
}

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(262), __webpack_require__(12), __webpack_require__(567)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('../Subheaders'), require('react-prop-types/lib/deprecated'), require('../Menus/contextTypes'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.Subheaders, global.deprecated, global.contextTypes);
    global.List = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _Subheaders, _deprecated, _contextTypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _Subheaders2 = _interopRequireDefault(_Subheaders);

  var _deprecated2 = _interopRequireDefault(_deprecated);

  var _contextTypes2 = _interopRequireDefault(_contextTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var List = function (_PureComponent) {
    _inherits(List, _PureComponent);

    function List() {
      _classCallCheck(this, List);

      return _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).apply(this, arguments));
    }

    _createClass(List, [{
      key: 'getChildContext',
      value: function getChildContext() {
        var _context = this.context,
            listLevel = _context.listLevel,
            context = _objectWithoutProperties(_context, ['listLevel']);

        return _extends({}, context, {
          listLevel: typeof listLevel === 'undefined' ? 1 : listLevel + 1
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var _cn;

        var _props = this.props,
            className = _props.className,
            ordered = _props.ordered,
            children = _props.children,
            subheader = _props.subheader,
            primarySubheader = _props.primarySubheader,
            props = _objectWithoutProperties(_props, ['className', 'ordered', 'children', 'subheader', 'primarySubheader']);

        var _context2 = this.context,
            menuPosition = _context2.menuPosition,
            menuCascading = _context2.menuCascading,
            listLevel = _context2.listLevel;


        var subheaderEl = void 0;
        if (subheader) {
          subheaderEl = _react2.default.createElement(_Subheaders2.default, { key: 'subheader', primaryText: subheader, primary: primarySubheader });
        }

        var Component = ordered ? 'ol' : 'ul';
        return _react2.default.createElement(
          Component,
          _extends({}, props, {
            className: (0, _classnames2.default)('md-list', (_cn = {
              'md-list--menu': menuPosition,
              'md-list--menu-scrollable': menuPosition && !menuCascading,
              'md-list--menu-cascading': menuCascading,
              'md-list--menu-nested': menuPosition && listLevel
            }, _defineProperty(_cn, 'md-list--nested-' + listLevel, listLevel && !menuPosition), _defineProperty(_cn, 'md-list--menu-' + menuPosition, menuPosition), _cn), className)
          }),
          subheaderEl,
          children
        );
      }
    }]);

    return List;
  }(_react.PureComponent);

  List.propTypes = {
    /**
     * An optional style to apply to the list.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply to the list.
     */
    className: _propTypes2.default.string,

    /**
     * Boolean if this should be an ordered list (`<ol>`) component. Otherwise, it will
     * be rendered as `<ul>`.
     */
    ordered: _propTypes2.default.bool,

    /**
     * This *should* be a list of `ListItem`, `ListItemControl`, `Divider`, or
     * `Subheader`.
     */
    children: _propTypes2.default.node,
    subheader: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `Subheader` component as a child instead'),
    primarySubheader: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use the `Subheader` component as a child instead')
  };
  List.childContextTypes = _contextTypes2.default;
  List.contextTypes = _contextTypes2.default;
  exports.default = List;
});

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(120)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('../utils/PropTypes/between'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.between);
    global.Paper = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _between) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _between2 = _interopRequireDefault(_between);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Paper = function (_PureComponent) {
    _inherits(Paper, _PureComponent);

    function Paper() {
      _classCallCheck(this, Paper);

      return _possibleConstructorReturn(this, (Paper.__proto__ || Object.getPrototypeOf(Paper)).apply(this, arguments));
    }

    _createClass(Paper, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            Component = _props.component,
            zDepth = _props.zDepth,
            className = _props.className,
            raiseOnHover = _props.raiseOnHover,
            props = _objectWithoutProperties(_props, ['component', 'zDepth', 'className', 'raiseOnHover']);

        return _react2.default.createElement(Component, _extends({}, props, {
          className: (0, _classnames2.default)('md-paper md-paper--' + zDepth, {
            'md-paper--0-hover': zDepth === 0 && raiseOnHover
          }, className)
        }));
      }
    }]);

    return Paper;
  }(_react.PureComponent);

  Paper.propTypes = {
    /**
     * The component to render the paper as.
     */
    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,

    /**
     * An optional className to apply.
     */
    className: _propTypes2.default.string,

    /**
     * The depth of the paper. This should be a number between 0 - 5. If
     * the depth is 0, it will raise to a depth of 3 on hover.
     */
    zDepth: (0, _between2.default)(_propTypes2.default.number.isRequired, 0, 5),

    /**
     * Any children to display in the paper.
     */
    children: _propTypes2.default.node,

    /**
     * Boolean if the paper should raise to the `zDepth` of `3` on hover when the initial
     * `zDepth` is `0`.
     */
    raiseOnHover: _propTypes2.default.bool
  };
  Paper.defaultProps = {
    zDepth: 1,
    component: 'div'
  };
  exports.default = Paper;
});

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(84)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./TextField'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.TextField);
    global.index = mod.exports;
  }
})(this, function (exports, _TextField) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _TextField2 = _interopRequireDefault(_TextField);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _TextField2.default;
});

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {

  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null

};

module.exports = ReactCurrentOwner;

/***/ }),
/* 49 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = noop;
function noop() {}


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(69)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(49)
  , core      = __webpack_require__(40)
  , ctx       = __webpack_require__(298)
  , hide      = __webpack_require__(70)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE]
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(a, b, c){
        if(this instanceof C){
          switch(arguments.length){
            case 0: return new C;
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if(IS_PROTO){
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;

/***/ }),
/* 53 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var anObject       = __webpack_require__(88)
  , IE8_DOM_DEFINE = __webpack_require__(300)
  , toPrimitive    = __webpack_require__(182)
  , dP             = Object.defineProperty;

exports.f = __webpack_require__(51) ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(301)
  , defined = __webpack_require__(171);
module.exports = function(it){
  return IObject(defined(it));
};

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function streamGeometry(geometry, stream) {
  if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) {
    streamGeometryType[geometry.type](geometry, stream);
  }
}

var streamObjectType = {
  Feature: function(object, stream) {
    streamGeometry(object.geometry, stream);
  },
  FeatureCollection: function(object, stream) {
    var features = object.features, i = -1, n = features.length;
    while (++i < n) streamGeometry(features[i].geometry, stream);
  }
};

var streamGeometryType = {
  Sphere: function(object, stream) {
    stream.sphere();
  },
  Point: function(object, stream) {
    object = object.coordinates;
    stream.point(object[0], object[1], object[2]);
  },
  MultiPoint: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) object = coordinates[i], stream.point(object[0], object[1], object[2]);
  },
  LineString: function(object, stream) {
    streamLine(object.coordinates, stream, 0);
  },
  MultiLineString: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) streamLine(coordinates[i], stream, 0);
  },
  Polygon: function(object, stream) {
    streamPolygon(object.coordinates, stream);
  },
  MultiPolygon: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) streamPolygon(coordinates[i], stream);
  },
  GeometryCollection: function(object, stream) {
    var geometries = object.geometries, i = -1, n = geometries.length;
    while (++i < n) streamGeometry(geometries[i], stream);
  }
};

function streamLine(coordinates, stream, closed) {
  var i = -1, n = coordinates.length - closed, coordinate;
  stream.lineStart();
  while (++i < n) coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
  stream.lineEnd();
}

function streamPolygon(coordinates, stream) {
  var i = -1, n = coordinates.length;
  stream.polygonStart();
  while (++i < n) streamLine(coordinates[i], stream, 1);
  stream.polygonEnd();
}

/* harmony default export */ __webpack_exports__["a"] = (function(object, stream) {
  if (object && streamObjectType.hasOwnProperty(object.type)) {
    streamObjectType[object.type](object, stream);
  } else {
    streamGeometry(object, stream);
  }
});


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_value__ = __webpack_require__(201);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_value__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_array__ = __webpack_require__(347);
/* unused harmony reexport interpolateArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_basis__ = __webpack_require__(200);
/* unused harmony reexport interpolateBasis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_basisClosed__ = __webpack_require__(348);
/* unused harmony reexport interpolateBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_date__ = __webpack_require__(350);
/* unused harmony reexport interpolateDate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_number__ = __webpack_require__(130);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__src_number__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_object__ = __webpack_require__(351);
/* unused harmony reexport interpolateObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_round__ = __webpack_require__(811);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__src_round__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_string__ = __webpack_require__(353);
/* unused harmony reexport interpolateString */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_transform_index__ = __webpack_require__(813);
/* unused harmony reexport interpolateTransformCss */
/* unused harmony reexport interpolateTransformSvg */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_zoom__ = __webpack_require__(815);
/* unused harmony reexport interpolateZoom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_rgb__ = __webpack_require__(352);
/* unused harmony reexport interpolateRgb */
/* unused harmony reexport interpolateRgbBasis */
/* unused harmony reexport interpolateRgbBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_hsl__ = __webpack_require__(808);
/* unused harmony reexport interpolateHsl */
/* unused harmony reexport interpolateHslLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_lab__ = __webpack_require__(809);
/* unused harmony reexport interpolateLab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_hcl__ = __webpack_require__(807);
/* unused harmony reexport interpolateHcl */
/* unused harmony reexport interpolateHclLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__ = __webpack_require__(806);
/* unused harmony reexport interpolateCubehelix */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_quantize__ = __webpack_require__(810);
/* unused harmony reexport quantize */



















/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
var array = Array.prototype;

var map = array.map;
var slice = array.slice;


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function constant() {
    return x;
  };
});


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(939),
    getValue = __webpack_require__(969);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(7);

var invariant = __webpack_require__(4);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(9), __webpack_require__(597)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('react-dom'), require('react-motion'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.reactDom, global.reactMotion);
    global.Collapse = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _reactDom, _reactMotion) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Collapse = function (_PureComponent) {
    _inherits(Collapse, _PureComponent);

    function Collapse(props) {
      _classCallCheck(this, Collapse);

      var _this = _possibleConstructorReturn(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call(this, props));

      if (!props.collapsed) {
        _this.state = { initialOpen: true };
      } else {
        _this.state = { height: 0, paddingTop: 0, paddingBottom: 0 };
      }

      _this._setHeight = _this._setHeight.bind(_this);
      return _this;
    }

    _createClass(Collapse, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (this.state.initialOpen && nextProps.collapsed) {
          this.setState({ initialOpen: false });
        }
      }
    }, {
      key: '_spring',
      value: function _spring(collapsed, initialOpen, value, config) {
        var nextValue = !collapsed ? Math.max(0, value) : 0;
        if (initialOpen && !collapsed) {
          return nextValue;
        }

        return (0, _reactMotion.spring)(nextValue, config);
      }
    }, {
      key: '_setHeight',
      value: function _setHeight(child) {
        var height = 0;
        var paddingTop = 0;
        var paddingBottom = 0;
        if (child !== null) {
          var node = (0, _reactDom.findDOMNode)(child);
          var cs = window.getComputedStyle(node);
          height = node.offsetHeight;
          paddingTop = parseInt(cs.getPropertyValue('padding-top'), 10);
          paddingBottom = parseInt(cs.getPropertyValue('padding-bottom'), 10);
        }

        this.setState({ height: height, paddingTop: paddingTop, paddingBottom: paddingBottom });
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _state = this.state,
            height = _state.height,
            paddingTop = _state.paddingTop,
            paddingBottom = _state.paddingBottom,
            initialOpen = _state.initialOpen;
        var _props = this.props,
            children = _props.children,
            collapsed = _props.collapsed,
            defaultStyle = _props.defaultStyle,
            motionStyle = _props.style,
            springConfig = _props.springConfig;

        return _react2.default.createElement(
          _reactMotion.Motion,
          {
            style: _extends({}, motionStyle, {
              height: this._spring(collapsed, initialOpen, height, springConfig),
              paddingTop: this._spring(collapsed, initialOpen, paddingTop, springConfig),
              paddingBottom: this._spring(collapsed, initialOpen, paddingBottom, springConfig)
            }),
            defaultStyle: _extends({}, defaultStyle, {
              height: height,
              paddingTop: paddingTop,
              paddingBottom: paddingBottom
            })
          },
          function (style) {
            if (collapsed && !style.height) {
              return null;
            }

            var child = _react.Children.only(children);
            var nextStyle = child.props.style;
            if (collapsed || style.height !== height) {
              nextStyle = Object.assign({}, child.props.style, _extends({}, style, {
                overflow: 'hidden'
              }));
            }
            return (0, _react.cloneElement)(child, {
              ref: _this2._setHeight,
              style: nextStyle
            });
          }
        );
      }
    }]);

    return Collapse;
  }(_react.PureComponent);

  Collapse.propTypes = {
    /**
     * An optional style to merge with the `Motion` style.
     */
    style: _propTypes2.default.object,

    /**
     * An optional default style to merge with the `Motion` default style.
     */
    defaultStyle: _propTypes2.default.object,

    /**
     * Boolean if the children are currently collapsed.
     */
    collapsed: _propTypes2.default.bool.isRequired,

    /**
     * A single child to collapse or expand.
     */
    children: _propTypes2.default.element.isRequired,

    /**
     * The spring config to use for the animation.
     */
    springConfig: _propTypes2.default.object.isRequired
  };
  Collapse.defaultProps = {
    springConfig: {
      precision: 0.5
    }
  };
  exports.default = Collapse;
});

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(9), __webpack_require__(3), __webpack_require__(12), __webpack_require__(16), __webpack_require__(20), __webpack_require__(14), __webpack_require__(37), __webpack_require__(62), __webpack_require__(252), __webpack_require__(255), __webpack_require__(562), __webpack_require__(45)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('react-dom'), require('classnames'), require('react-prop-types/lib/deprecated'), require('../utils/getField'), require('../utils/PropTypes/controlled'), require('../constants/keyCodes'), require('../Helpers/AccessibleFakeInkedButton'), require('../Helpers/Collapse'), require('../FontIcons/Collapser'), require('./TileAddon'), require('./ListItemText'), require('./List'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.reactDom, global.classnames, global.deprecated, global.getField, global.controlled, global.keyCodes, global.AccessibleFakeInkedButton, global.Collapse, global.Collapser, global.TileAddon, global.ListItemText, global.List);
    global.ListItem = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _reactDom, _classnames, _deprecated, _getField, _controlled, _keyCodes, _AccessibleFakeInkedButton, _Collapse, _Collapser, _TileAddon, _ListItemText, _List) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _deprecated2 = _interopRequireDefault(_deprecated);

  var _getField2 = _interopRequireDefault(_getField);

  var _controlled2 = _interopRequireDefault(_controlled);

  var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);

  var _Collapse2 = _interopRequireDefault(_Collapse);

  var _Collapser2 = _interopRequireDefault(_Collapser);

  var _TileAddon2 = _interopRequireDefault(_TileAddon);

  var _ListItemText2 = _interopRequireDefault(_ListItemText);

  var _List2 = _interopRequireDefault(_List);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var ListItem = function (_PureComponent) {
    _inherits(ListItem, _PureComponent);

    function ListItem(props) {
      _classCallCheck(this, ListItem);

      var _this = _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).call(this, props));

      _this.state = { active: false };

      if (typeof props.isOpen === 'undefined') {
        _this.state.isOpen = typeof props.initiallyOpen !== 'undefined' ? props.initiallyOpen : !!props.defaultOpen;
      }

      _this.focus = _this.focus.bind(_this);
      _this._setTile = _this._setTile.bind(_this);
      _this._setContainer = _this._setContainer.bind(_this);
      _this._handleOutsideClick = _this._handleOutsideClick.bind(_this);
      _this._handleClick = _this._handleClick.bind(_this);
      _this._handleKeyUp = _this._handleKeyUp.bind(_this);
      _this._handleKeyDown = _this._handleKeyDown.bind(_this);
      _this._handleMouseOver = _this._handleMouseOver.bind(_this);
      _this._handleMouseLeave = _this._handleMouseLeave.bind(_this);
      _this._handleTouchStart = _this._handleTouchStart.bind(_this);
      _this._handleTouchEnd = _this._handleTouchEnd.bind(_this);
      return _this;
    }

    _createClass(ListItem, [{
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.state.active) {
          window.removeEventListener('click', this._handleOutsideClick);
        }

        if (this._touchTimeout) {
          clearTimeout(this._touchTimeout);
        }
      }
    }, {
      key: 'focus',
      value: function focus() {
        if (this._tile) {
          this._tile.focus();
        }
      }
    }, {
      key: 'blur',
      value: function blur() {
        if (this._tile) {
          this._tile.blur();
        }
      }
    }, {
      key: '_setTile',
      value: function _setTile(tile) {
        if (tile) {
          this._tile = tile;
        }
      }
    }, {
      key: '_setContainer',
      value: function _setContainer(container) {
        if (container) {
          this._container = (0, _reactDom.findDOMNode)(container);
        }
      }
    }, {
      key: '_handleOutsideClick',
      value: function _handleOutsideClick(e) {
        if (this._container && !this._container.contains(e.target)) {
          window.removeEventListener('click', this._handleOutsideClick);
          this.setState({ active: false });
        }
      }
    }, {
      key: '_handleClick',
      value: function _handleClick(e) {
        if (this.props.onClick) {
          this.props.onClick(e);
        }

        if (typeof this.state.isOpen !== 'undefined') {
          this.setState({ isOpen: !this.state.isOpen });
        }
      }
    }, {
      key: '_handleMouseOver',
      value: function _handleMouseOver(e) {
        if (this.props.onMouseOver) {
          this.props.onMouseOver(e);
        }

        if (!this.props.disabled) {
          this.setState({ active: true });
        }
      }
    }, {
      key: '_handleMouseLeave',
      value: function _handleMouseLeave(e) {
        if (this.props.onMouseLeave) {
          this.props.onMouseLeave(e);
        }

        if (!this.props.disabled) {
          this.setState({ active: false });
        }
      }
    }, {
      key: '_handleTouchStart',
      value: function _handleTouchStart(e) {
        if (this.props.onTouchStart) {
          this.props.onTouchStart(e);
        }

        this._touched = true;

        this.setState({ active: true, touchedAt: Date.now() });
      }
    }, {
      key: '_handleTouchEnd',
      value: function _handleTouchEnd(e) {
        var _this2 = this;

        if (this.props.onTouchEnd) {
          this.props.onTouchEnd(e);
        }

        var time = Date.now() - this.state.touchedAt;
        this._touchTimeout = setTimeout(function () {
          _this2._touchTimeout = null;

          _this2.setState({ active: false });
        }, time > 450 ? 0 : 450 - time);
      }
    }, {
      key: '_handleKeyUp',
      value: function _handleKeyUp(e) {
        if (this.props.onKeyUp) {
          this.props.onKeyUp(e);
        }

        if ((e.which || e.keyCode) === _keyCodes.TAB) {
          window.addEventListener('click', this._handleOutsideClick);
          this.setState({ active: true });
        }
      }
    }, {
      key: '_handleKeyDown',
      value: function _handleKeyDown(e) {
        if (this.props.onKeyDown) {
          this.props.onKeyDown(e);
        }

        if ((e.which || e.keyCode) === _keyCodes.TAB) {
          window.removeEventListener('click', this._handleOutsideClick);
          this.setState({ active: false });
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            style = _props.style,
            className = _props.className,
            tileStyle = _props.tileStyle,
            tileClassName = _props.tileClassName,
            disabled = _props.disabled,
            leftIcon = _props.leftIcon,
            leftAvatar = _props.leftAvatar,
            inset = _props.inset,
            rightIcon = _props.rightIcon,
            rightAvatar = _props.rightAvatar,
            primaryText = _props.primaryText,
            secondaryText = _props.secondaryText,
            threeLines = _props.threeLines,
            children = _props.children,
            nestedItems = _props.nestedItems,
            active = _props.active,
            activeClassName = _props.activeClassName,
            expanderIconChildren = _props.expanderIconChildren,
            expanderIconClassName = _props.expanderIconClassName,
            props = _objectWithoutProperties(_props, ['style', 'className', 'tileStyle', 'tileClassName', 'disabled', 'leftIcon', 'leftAvatar', 'inset', 'rightIcon', 'rightAvatar', 'primaryText', 'secondaryText', 'threeLines', 'children', 'nestedItems', 'active', 'activeClassName', 'expanderIconChildren', 'expanderIconClassName']);

        delete props.isOpen;
        delete props.defaultOpen;
        delete props.initiallyOpen;

        var isOpen = (0, _getField2.default)(this.props, this.state, 'isOpen');
        var leftNode = _react2.default.createElement(_TileAddon2.default, {
          key: 'left-addon',
          active: active,
          activeClassName: activeClassName,
          icon: leftIcon,
          avatar: leftAvatar
        });

        var rightNode = _react2.default.createElement(_TileAddon2.default, {
          key: 'right-addon',
          active: active,
          activeClassName: activeClassName,
          icon: rightIcon,
          avatar: rightAvatar
        });

        var nestedList = void 0;
        if (nestedItems) {
          nestedList = _react2.default.createElement(
            _Collapse2.default,
            { collapsed: !isOpen },
            _react2.default.createElement(
              _List2.default,
              null,
              nestedItems
            )
          );

          if (!rightIcon || !rightAvatar) {
            rightNode = _react2.default.createElement(_TileAddon2.default, {
              key: 'expander-addon',
              icon: _react2.default.createElement(
                _Collapser2.default,
                { flipped: isOpen, iconClassName: expanderIconClassName },
                expanderIconChildren
              ),
              avatar: null
            });
          }
        }
        var icond = !!leftIcon || !!rightIcon;
        var avatard = !!leftAvatar || !!rightAvatar;

        return _react2.default.createElement(
          'li',
          {
            style: style,
            className: (0, _classnames2.default)('md-list-item', {
              'md-list-item--nested-container': nestedItems
            }, className),
            ref: this._setContainer
          },
          _react2.default.createElement(
            _AccessibleFakeInkedButton2.default,
            _extends({}, props, {
              __SUPER_SECRET_REF__: this._setTile,
              key: 'tile',
              onClick: this._handleClick,
              onMouseOver: this._handleMouseOver,
              onMouseLeave: this._handleMouseLeave,
              onTouchStart: this._handleTouchStart,
              onTouchEnd: this._handleTouchEnd,
              onKeyDown: this._handleKeyDown,
              onKeyUp: this._handleKeyUp,
              disabled: disabled,
              style: tileStyle,
              className: (0, _classnames2.default)('md-list-tile', {
                'md-text': !disabled,
                'md-text--disabled': disabled,
                'md-list-tile--active': this.state.active && !this._touched,
                'md-list-tile--icon': !secondaryText && icond && !avatard,
                'md-list-tile--avatar': !secondaryText && avatard,
                'md-list-tile--two-lines': secondaryText && !threeLines,
                'md-list-tile--three-lines': secondaryText && threeLines,
                'md-list-item--inset': inset && !leftIcon && !leftAvatar
              }, tileClassName),
              'aria-expanded': nestedList ? isOpen : null
            }),
            leftNode,
            _react2.default.createElement(_ListItemText2.default, {
              active: active,
              activeClassName: activeClassName,
              disabled: disabled,
              primaryText: primaryText,
              secondaryText: secondaryText,
              threeLines: threeLines,
              className: (0, _classnames2.default)({
                'md-tile-content--left-icon': leftIcon,
                'md-tile-content--left-avatar': leftAvatar,
                'md-tile-content--right-padding': rightIcon || rightAvatar
              })
            }),
            rightNode,
            children
          ),
          nestedList
        );
      }
    }]);

    return ListItem;
  }(_react.PureComponent);

  ListItem.propTypes = {
    /**
     * An optional style to apply to the `li` tag.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply to the `li` tag.
     */
    className: _propTypes2.default.string,

    /**
     * An optional style to apply to the `.md-list-tile`.
     *
     * @see component
     */
    tileStyle: _propTypes2.default.object,

    /**
     * An optional className to apply to the `.md-list-tile`.
     *
     * @see component
     */
    tileClassName: _propTypes2.default.string,

    /**
     * Any additional children to display in the `.md-list-tile`. If you use this prop,
     * you will most likely need to override the `height` for the `.md-list-tile--icon`,
     * `.md-list-tile--avatar`, `.md-list-tile--two-lines`, and/or `.md-list-tile--three-lines`
     * to get it to display correctly unless the children are positioned `absolute`.
     */
    children: _propTypes2.default.node,

    /**
     * Boolean if the `ListItem` is disabled.
     */
    disabled: _propTypes2.default.bool,

    /**
     * An optional tab index for the `.md-list-tile`. If omitted, it will default to the
     * `AccessibleFakeButton`'s `tabIndex` default prop value.
     */
    tabIndex: _propTypes2.default.number,

    /**
     * The primary text to display. This will only be rendered as a single line. Any overflown
     * text will be converted to ellipsis.
     */
    primaryText: _propTypes2.default.node.isRequired,

    /**
     * An optional secondary text to display below the `primaryText`. This can be an additional
     * one or two lines. Like the `primaryText`, and overflown text will be converted to ellipsis.
     *
     * You must set the `threeLines` prop to `true` if you want this to be displayed as two lines.
     */
    secondaryText: _propTypes2.default.node,

    /**
     * An optional `FontIcon` to display to the left of the text.
     */
    leftIcon: _propTypes2.default.node,

    /**
     * Boolean if the list item should be inset as if there is a `leftIcon` or a `leftAvatar`.
     * This is used for some lists where only a parent contains the icon.
     */
    inset: _propTypes2.default.bool,

    /**
     * An optional `Avatar` to display to the left of the text. If you have a mixed `List` of
     * `FontIcon` and `Avatar`, it is recommended to set the `iconSized` prop on the `Avatar` to
     * `true` so that the `Avatar` will be scaled down to the `FontIcon` size.
     */
    leftAvatar: _propTypes2.default.node,

    /**
     * An optional `FontIcon` to display to the right of the text.
     */
    rightIcon: _propTypes2.default.node,

    /**
     * An optional `Avatar` to display to the right of the text. If you have a mixed `List` of
     * `FontIcon` and `Avatar`, it is recommended to set the `iconSized` prop on the `Avatar` to
     * `true` so that the `Avatar` will be scaled down to the `FontIcon` size.
     */
    rightAvatar: _propTypes2.default.node,

    /**
     * Boolean if the `secondaryText` should span two lines instead of one. This will include
     * three lines of text in total when including the `primaryText`.
     */
    threeLines: _propTypes2.default.bool,

    /**
     * An optional component to render the `.md-list-tile` as. This is mostly useful if you
     * want to use the `ListItem` for navigation and working with the `react-router`'s `Link`
     * component.
     */
    component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,

    /**
     * An optional list of `ListItem`, `ListItemControl`, `Divider`, or `Subheader` components
     * to render in a nested list. This will inject an expander icon to the right of the text
     * in the `.md-list-tile` that rotates 180 degrees when open.
     *
     * The nested items will be visible once the user clicks on the `ListItem`.
     *
     * @see `defaultOpen`
     * @see `isOpen`
     */
    nestedItems: _propTypes2.default.arrayOf(_propTypes2.default.node),

    /**
     * Boolean if the `nestedItems` are visible by default.
     */
    defaultOpen: _propTypes2.default.bool,

    /**
     * Boolean if the `nestedItems` are visible. This will make the `nestedItems` controlled
     * and require the `onClick` function to be defined.
     */
    isOpen: (0, _controlled2.default)(_propTypes2.default.bool, 'onClick', 'defaultOpen'),

    /**
     * Any children used to render the expander icon.
     */
    expanderIconChildren: _propTypes2.default.node,

    /**
     * An icon className to use to render the expander icon.
     */
    expanderIconClassName: _propTypes2.default.string,

    /**
     * An optional function to call when the `.md-list-tile` is clicked. This is required if the
     * `isOpen` prop is defined.
     */
    onClick: _propTypes2.default.func,

    /**
     * An optional function to call when the `.md-list-tile` triggers the `mouseover` event.
     */
    onMouseOver: _propTypes2.default.func,

    /**
     * An optional function to call when the `.md-list-tile` triggers the `mouseleave` event.
     */
    onMouseLeave: _propTypes2.default.func,

    /**
     * An optional function to call when the `.md-list-tile` triggers the `touchstart` event.
     */
    onTouchStart: _propTypes2.default.func,

    /**
     * An optional function to call when the `.md-list-tile` triggers the `touchend` event.
     */
    onTouchEnd: _propTypes2.default.func,

    /**
     * An optional function to call when the `.md-list-tile` triggers the `keydown` event.
     */
    onKeyDown: _propTypes2.default.func,

    /**
     * An optional function to call when the `.md-list-tile` triggers the `keyup` event.
     */
    onKeyUp: _propTypes2.default.func,

    /**
     * Boolean if the `ListItem` is currently active. This will apply the `activeClassName` prop
     * to the `leftIcon`, `rightIcon`, and the `primaryText`.
     */
    active: _propTypes2.default.bool,

    /**
     * The className to apply to the `leftIcon`, `rightIcon`, and `primaryText` when the `active`
     * prop is `true`.
     */
    activeClassName: _propTypes2.default.string,
    initiallyOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `defaultOpen` instead')
  };
  ListItem.defaultProps = {
    activeClassName: 'md-text--theme-primary',
    component: 'div',
    expanderIconChildren: 'keyboard_arrow_down'
  };
  exports.default = ListItem;
});

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.componentDeprecated = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = componentDeprecated;
  function componentDeprecated(reason) {
    return function validate(props, propName, componentName) {
      var componentNameSafe = componentName || '<<anonymous>>';

      return new Error('The `' + componentNameSafe + '` has been deprecated and will be removed in the next release. ' + reason);
    };
  }
});

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.invalidIf = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = invalidIf;
  /**
   * A custom validator that will throw an error if any of the `ifDefinedProps` are also defined.
   *
   * @param {function} validator - The PropTypes validator to use.
   * @param {String...} ifDefinedProps - any othe rprop names to validate against
   * @return {Error} an error or null
   */
  function invalidIf(validator) {
    for (var _len = arguments.length, ifDefinedProps = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      ifDefinedProps[_key - 1] = arguments[_key];
    }

    return function validate(props, propName, componentName, location, propFullName) {
      var componentNameSafe = componentName || '<<anonymous>>';
      var propFullNameSafe = propFullName || propName;

      for (var _len2 = arguments.length, args = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
        args[_key2 - 5] = arguments[_key2];
      }

      var err = validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
      if (err) {
        return err;
      }

      var defined = typeof props[propName] !== 'undefined' && !!props[propName];
      var othersDefined = ifDefinedProps.filter(function (name) {
        return typeof props[name] !== 'undefined' && !!props[name];
      });
      if (defined && othersDefined.length) {
        var names = '`' + othersDefined.join('`, `') + '`';
        if (othersDefined.length === 1) {
          return new Error('You provided both a `' + propFullNameSafe + '` and ' + names + ' prop to the ' + componentNameSafe + ' ' + 'but only one can be given.');
        }

        return new Error('You provided a `' + propFullNameSafe + '` ' + location + ' to the ' + componentNameSafe + ' when ' + ('the following props were defined: ' + names + '. Either remove the `' + propFullNameSafe + '` ') + 'or use the remove all the other props.');
      }

      return null;
    };
  }
});

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = __webpack_require__(277);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _CSSTransitionGroupChild = __webpack_require__(1254);

var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);

var _PropTypes = __webpack_require__(609);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  transitionName: _PropTypes.nameShape.isRequired,

  transitionAppear: _propTypes2.default.bool,
  transitionEnter: _propTypes2.default.bool,
  transitionLeave: _propTypes2.default.bool,
  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
};

var defaultProps = {
  transitionAppear: false,
  transitionEnter: true,
  transitionLeave: true
};

var CSSTransitionGroup = function (_React$Component) {
  _inherits(CSSTransitionGroup, _React$Component);

  function CSSTransitionGroup() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
        name: _this.props.transitionName,
        appear: _this.props.transitionAppear,
        enter: _this.props.transitionEnter,
        leave: _this.props.transitionLeave,
        appearTimeout: _this.props.transitionAppearTimeout,
        enterTimeout: _this.props.transitionEnterTimeout,
        leaveTimeout: _this.props.transitionLeaveTimeout
      }, child);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // We need to provide this childFactory so that
  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
  // leave while it is leaving.


  CSSTransitionGroup.prototype.render = function render() {
    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
  };

  return CSSTransitionGroup;
}(_react2.default.Component);

CSSTransitionGroup.displayName = 'CSSTransitionGroup';


CSSTransitionGroup.propTypes = propTypes;
CSSTransitionGroup.defaultProps = defaultProps;

exports.default = CSSTransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(1314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(1313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(1312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(627);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 68 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var dP         = __webpack_require__(54)
  , createDesc = __webpack_require__(123);
module.exports = __webpack_require__(51) ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var store      = __webpack_require__(179)('wks')
  , uid        = __webpack_require__(124)
  , Symbol     = __webpack_require__(49).Symbol
  , USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function(name){
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
});


/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Adds floating point numbers with twice the normal precision.
// Reference: J. R. Shewchuk, Adaptive Precision Floating-Point Arithmetic and
// Fast Robust Geometric Predicates, Discrete & Computational Geometry 18(3)
// 305–363 (1997).
// Code adapted from GeographicLib by Charles F. F. Karney,
// http://geographiclib.sourceforge.net/

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return new Adder;
});

function Adder() {
  this.reset();
}

Adder.prototype = {
  constructor: Adder,
  reset: function() {
    this.s = // rounded value
    this.t = 0; // exact error
  },
  add: function(y) {
    add(temp, y, this.t);
    add(this, temp.s, this.s);
    if (this.s) this.t += temp.t;
    else this.s = temp.t;
  },
  valueOf: function() {
    return this.s;
  }
};

var temp = new Adder;

function add(adder, a, b) {
  var x = adder.s = a + b,
      bv = x - a,
      av = x - bv;
  adder.t = (a - av) + (b - bv);
}


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
(function() {
  var getNanoSeconds, hrtime, loadTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - loadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    loadTime = getNanoSeconds();
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(109)))

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(1028)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function() {
  root.requestAnimationFrame = raf
  root.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)))

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = __webpack_require__(227);
var setInnerHTML = __webpack_require__(151);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(235);
var setTextContent = __webpack_require__(548);

var ELEMENT_NODE_TYPE = 1;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * In IE (8-11) and Edge, appending nodes with no children is dramatically
 * faster than appending a full subtree, so we essentially queue up the
 * .appendChild calls here and apply them so each node is added to its parent
 * before any children are added.
 *
 * In other browsers, doing so is slower or neutral compared to the other order
 * (in Firefox, twice as slow) so we only do this inversion in IE.
 *
 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
 */
var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);

function insertTreeChildren(tree) {
  if (!enableLazy) {
    return;
  }
  var node = tree.node;
  var children = tree.children;
  if (children.length) {
    for (var i = 0; i < children.length; i++) {
      insertTreeBefore(node, children[i], null);
    }
  } else if (tree.html != null) {
    setInnerHTML(node, tree.html);
  } else if (tree.text != null) {
    setTextContent(node, tree.text);
  }
}

var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
  // DocumentFragments aren't actually part of the DOM after insertion so
  // appending children won't update the DOM. We need to ensure the fragment
  // is properly populated first, breaking out of our lazy approach for just
  // this level. Also, some <object> plugins (like Flash Player) will read
  // <param> nodes immediately upon insertion into the DOM, so <object>
  // must also be populated prior to insertion into the DOM.
  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
    insertTreeChildren(tree);
    parentNode.insertBefore(tree.node, referenceNode);
  } else {
    parentNode.insertBefore(tree.node, referenceNode);
    insertTreeChildren(tree);
  }
});

function replaceChildWithTree(oldNode, newTree) {
  oldNode.parentNode.replaceChild(newTree.node, oldNode);
  insertTreeChildren(newTree);
}

function queueChild(parentTree, childTree) {
  if (enableLazy) {
    parentTree.children.push(childTree);
  } else {
    parentTree.node.appendChild(childTree.node);
  }
}

function queueHTML(tree, html) {
  if (enableLazy) {
    tree.html = html;
  } else {
    setInnerHTML(tree.node, html);
  }
}

function queueText(tree, text) {
  if (enableLazy) {
    tree.text = text;
  } else {
    setTextContent(tree.node, text);
  }
}

function toString() {
  return this.node.nodeName;
}

function DOMLazyTree(node) {
  return {
    node: node,
    children: [],
    html: null,
    text: null,
    toString: toString
  };
}

DOMLazyTree.insertTreeBefore = insertTreeBefore;
DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
DOMLazyTree.queueChild = queueChild;
DOMLazyTree.queueHTML = queueHTML;
DOMLazyTree.queueText = queueText;

module.exports = DOMLazyTree;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var invariant = __webpack_require__(4);

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_PROPERTY: 0x1,
  HAS_BOOLEAN_VALUE: 0x4,
  HAS_NUMERIC_VALUE: 0x8,
  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
/* eslint-enable max-len */

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {

  ID_ATTRIBUTE_NAME: 'data-reactid',
  ROOT_ATTRIBUTE_NAME: 'data-reactroot',

  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   *
   * autofocus is predefined, because adding it to the property whitelist
   * causes unintended side effects.
   *
   * @type {Object}
   */
  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactRef = __webpack_require__(1065);
var ReactInstrumentation = __webpack_require__(32);

var warning = __webpack_require__(6);

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} the containing host component instance
   * @param {?object} info about the host container
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
  ) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
      }
    }
    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
      }
    }
    return markup;
  },

  /**
   * Returns a value that can be passed to
   * ReactComponentEnvironment.replaceNodeWithMarkup.
   */
  getHostNode: function (internalInstance) {
    return internalInstance.getHostNode();
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance, safely) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
      }
    }
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent(safely);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
      }
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
      // The component's enqueued batch number should always be the current
      // batch or the following one.
       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
      return;
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
      }
    }
    internalInstance.performUpdateIfNecessary(transaction);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  }

};

module.exports = ReactReconciler;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames);
    global.IconSeparator = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var IconSeparator = function (_PureComponent) {
    _inherits(IconSeparator, _PureComponent);

    function IconSeparator() {
      _classCallCheck(this, IconSeparator);

      return _possibleConstructorReturn(this, (IconSeparator.__proto__ || Object.getPrototypeOf(IconSeparator)).apply(this, arguments));
    }

    _createClass(IconSeparator, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            className = _props.className,
            labelStyle = _props.labelStyle,
            labelClassName = _props.labelClassName,
            component = _props.component,
            label = _props.label,
            iconBefore = _props.iconBefore,
            children = _props.children,
            props = _objectWithoutProperties(_props, ['className', 'labelStyle', 'labelClassName', 'component', 'label', 'iconBefore', 'children']);

        var text = void 0;
        if ((0, _react.isValidElement)(label)) {
          var labelProps = _react.Children.only(label).props;
          text = (0, _react.cloneElement)(label, {
            className: (0, _classnames2.default)('md-icon-text', labelClassName, labelProps.className),
            style: _extends({}, labelStyle, labelProps.style)
          });
        } else {
          text = _react2.default.createElement(
            'span',
            { style: labelStyle, className: (0, _classnames2.default)('md-icon-text', labelClassName) },
            label
          );
        }

        var Component = component;

        return _react2.default.createElement(
          Component,
          _extends({}, props, { className: (0, _classnames2.default)('md-icon-separator', className) }),
          iconBefore && children,
          text,
          !iconBefore && children
        );
      }
    }]);

    return IconSeparator;
  }(_react.PureComponent);

  IconSeparator.propTypes = {
    /**
     * An optional style to apply.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply.
     */
    className: _propTypes2.default.string,

    /**
     * An optional style to apply to the label.
     */
    labelStyle: _propTypes2.default.object,

    /**
     * An optional className to apply to the label.
     */
    labelClassName: _propTypes2.default.string,

    /**
     * The label to display.
     */
    label: _propTypes2.default.node.isRequired,

    /**
     * The icon to display.
     */
    children: _propTypes2.default.node.isRequired,

    /**
     * Boolean if the icon should appear before or after the text
     */
    iconBefore: _propTypes2.default.bool,

    /**
     * The component to be rendered as.
     */
    component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired
  };
  IconSeparator.defaultProps = {
    component: 'div'
  };
  exports.default = IconSeparator;
});

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('react-dom'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.reactDom);
    global.Portal = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _reactDom) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Portal = function (_PureComponent) {
    _inherits(Portal, _PureComponent);

    function Portal(props) {
      _classCallCheck(this, Portal);

      var _this = _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).call(this, props));

      _this._portal = null;
      _this._container = null;

      _this._applyStyles = _this._applyStyles.bind(_this);
      _this._renderPortal = _this._renderPortal.bind(_this);
      _this._removePortal = _this._removePortal.bind(_this);
      return _this;
    }

    _createClass(Portal, [{
      key: 'getChildContext',
      value: function getChildContext() {
        return { isInPortal: true };
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _props = this.props,
            renderNode = _props.renderNode,
            visible = _props.visible;

        if (visible && (!this.context.isInPortal || renderNode)) {
          this._renderPortal(this.props);
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var visible = nextProps.visible,
            onOpen = nextProps.onOpen,
            renderNode = nextProps.renderNode;

        var changed = visible !== this.props.visible;
        if (changed && visible && onOpen) {
          onOpen();
        }

        if (this.context.isInPortal && !renderNode) {
          return;
        }

        if (!visible) {
          this._removePortal();
        } else {
          this._renderPortal(nextProps);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this._removePortal();
      }
    }, {
      key: '_applyStyles',
      value: function _applyStyles(props) {
        if (props.className) {
          this._container.className = props.className;
        }
      }
    }, {
      key: '_renderPortal',
      value: function _renderPortal(props) {
        if (!this._container) {
          this._container = document.createElement(props.component);

          this._applyStyles(props);
          var node = props.renderNode || document.body;
          if (props.lastChild) {
            node.appendChild(this._container);
          } else {
            node.insertBefore(this._container, node.firstChild);
          }
        } else {
          this._applyStyles(props);
        }

        this._portal = (0, _reactDom.unstable_renderSubtreeIntoContainer)(this, props.children, this._container);
      }
    }, {
      key: '_removePortal',
      value: function _removePortal() {
        if (this.props.onClose) {
          this.props.onClose();
        }

        if (this._container) {
          (0, _reactDom.unmountComponentAtNode)(this._container);
          (this.props.renderNode || document.body).removeChild(this._container);
        }

        this._portal = null;
        this._container = null;
      }
    }, {
      key: 'render',
      value: function render() {
        var isInPortal = this.context.isInPortal;
        var _props2 = this.props,
            Component = _props2.component,
            className = _props2.className,
            children = _props2.children,
            renderNode = _props2.renderNode,
            visible = _props2.visible;


        // When doing server side rendering, actualy render the component as a direct child of its parent.
        // Once it has been rendered and working client side, it will be removed correctly.
        if (visible && (typeof window === 'undefined' || isInPortal && !renderNode)) {
          return _react2.default.createElement(
            Component,
            { className: className },
            children
          );
        }

        return null;
      }
    }]);

    return Portal;
  }(_react.PureComponent);

  Portal.propTypes = {
    /**
     * An optional className to apply to the newly created `component` when visible.
     */
    className: _propTypes2.default.string,

    /**
     * Boolean if the children are visible.
     */
    visible: _propTypes2.default.bool.isRequired,

    /**
     * The children to render when visible.
     */
    children: _propTypes2.default.element,

    /**
     * The component to render as. This should be a valid DOM element.
     */
    component: _propTypes2.default.string.isRequired,

    /**
     * An optional function to call when the portal is opened.
     */
    onOpen: _propTypes2.default.func,

    /**
     * An optional function to call when the portal is closed
     */
    onClose: _propTypes2.default.func,

    /**
     * An optional DOM Node to render the portal into. The default is to render as
     * the first child in the `body`.
     */
    renderNode: _propTypes2.default.object,

    /**
     * Boolean if the portal should render the childeren as the last child of the `renderNode`
     * or `body` instead of the first.
     */
    lastChild: _propTypes2.default.bool
  };
  Portal.defaultProps = {
    component: 'span'
  };
  Portal.contextTypes = {
    isInPortal: _propTypes2.default.bool
  };
  Portal.childContextTypes = {
    isInPortal: _propTypes2.default.bool
  };
  exports.default = Portal;
});

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(12), __webpack_require__(17), __webpack_require__(16), __webpack_require__(1201), __webpack_require__(37), __webpack_require__(28), __webpack_require__(1160)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('react-prop-types/lib/deprecated'), require('react-prop-types/lib/isRequiredForA11y'), require('../utils/getField'), require('../utils/StringUtils/capitalizeFirst'), require('../Helpers/AccessibleFakeInkedButton'), require('../FontIcons/FontIcon'), require('./SwitchTrack'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.deprecated, global.isRequiredForA11y, global.getField, global.capitalizeFirst, global.AccessibleFakeInkedButton, global.FontIcon, global.SwitchTrack);
    global.SelectionControl = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _deprecated, _isRequiredForA11y, _getField, _capitalizeFirst, _AccessibleFakeInkedButton, _FontIcon, _SwitchTrack) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _deprecated2 = _interopRequireDefault(_deprecated);

  var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);

  var _getField2 = _interopRequireDefault(_getField);

  var _capitalizeFirst2 = _interopRequireDefault(_capitalizeFirst);

  var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);

  var _FontIcon2 = _interopRequireDefault(_FontIcon);

  var _SwitchTrack2 = _interopRequireDefault(_SwitchTrack);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  /**
   * Prevents a second warning from appearing when using the deprecated or a11y required
   * props by using the `__superSecretProp`.... So secret!
   */
  function preventDouble(validator) {
    return function validate(props, propName) {
      for (var _len = arguments.length, others = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        others[_key - 2] = arguments[_key];
      }

      var err = validator.apply(undefined, [props, propName].concat(others));
      if (err && props.__superSecreteProp) {
        err = null;
      }

      return err;
    };
  }

  /**
   * The `SelectionControl` component is used to render any of the `Radio`, `Checkbox`, or `Switch`
   * selection control type. This component might eventually replace all three since they use this
   * anyways. I am not sure yet though.
   */

  var SelectionControl = function (_PureComponent) {
    _inherits(SelectionControl, _PureComponent);

    function SelectionControl(props) {
      _classCallCheck(this, SelectionControl);

      var _this = _possibleConstructorReturn(this, (SelectionControl.__proto__ || Object.getPrototypeOf(SelectionControl)).call(this, props));

      _this.state = {};
      if (typeof props.checked === 'undefined') {
        _this.state.checked = !!props.defaultChecked;
      }

      _this._setInput = _this._setInput.bind(_this);
      _this._setControl = _this._setControl.bind(_this);
      _this._setContainer = _this._setContainer.bind(_this);
      _this._handleChange = _this._handleChange.bind(_this);
      _this._handleControlClick = _this._handleControlClick.bind(_this);
      _this._getIcon = _this._getIcon.bind(_this);
      return _this;
    }

    _createClass(SelectionControl, [{
      key: '_setInput',
      value: function _setInput(input) {
        this._input = input;
      }
    }, {
      key: '_setControl',
      value: function _setControl(control) {
        this._control = control;
      }
    }, {
      key: '_setContainer',
      value: function _setContainer(container) {
        this._container = container;
      }
    }, {
      key: '_getIcon',
      value: function _getIcon() {
        var _props = this.props,
            checkedIcon = _props.checkedIcon,
            uncheckedIcon = _props.uncheckedIcon,
            type = _props.type;

        var checked = (0, _getField2.default)(this.props, this.state, 'checked');
        if (checkedIcon || uncheckedIcon) {
          return checked ? checkedIcon : uncheckedIcon;
        }

        var prefix = (checked ? '' : 'un') + 'checked' + (0, _capitalizeFirst2.default)(type) + 'Icon';
        return _react2.default.createElement(
          _FontIcon2.default,
          { iconClassName: this.props[prefix + 'ClassName'] },
          this.props[prefix + 'Children']
        );
      }
    }, {
      key: '_handleChange',
      value: function _handleChange(e) {
        var _props2 = this.props,
            type = _props2.type,
            onChange = _props2.onChange;

        var checked = !(0, _getField2.default)(this.props, this.state, 'checked');
        if (onChange) {
          onChange(type === 'radio' ? e.target.value : checked, e);
        }

        if (!this._fromFakeButton && type !== 'switch' && typeof this._control.createInk === 'function') {
          // create ink doesn't exist when testing atm
          this._control.createInk();
        }
        this._fromFakeButton = false;

        if (typeof this.props.checked === 'undefined') {
          this.setState({ checked: checked });
        }
      }
    }, {
      key: '_handleControlClick',
      value: function _handleControlClick() {
        this._fromFakeButton = true;
        // Trigger the change
        this._input.click();
      }
    }, {
      key: 'render',
      value: function render() {
        var _props3 = this.props,
            id = _props3.id,
            style = _props3.style,
            className = _props3.className,
            inline = _props3.inline,
            type = _props3.type,
            name = _props3.name,
            value = _props3.value,
            disabled = _props3.disabled,
            labelBefore = _props3.labelBefore,
            onBlur = _props3.onBlur,
            onFocus = _props3.onFocus,
            tabIndex = _props3.tabIndex,
            props = _objectWithoutProperties(_props3, ['id', 'style', 'className', 'inline', 'type', 'name', 'value', 'disabled', 'labelBefore', 'onBlur', 'onFocus', 'tabIndex']);

        delete props.label;
        delete props.checked;
        delete props.onChange;
        delete props.checkedIcon;
        delete props.uncheckedIcon;
        delete props.__superSecreteProp;
        delete props.checkedRadioIconChildren;
        delete props.checkedRadioIconClassName;
        delete props.uncheckedRadioIconChildren;
        delete props.uncheckedRadioIconClassName;
        delete props.checkedCheckboxIconChildren;
        delete props.checkedCheckboxIconClassName;
        delete props.uncheckedCheckboxIconChildren;
        delete props.uncheckedCheckboxIconClassName;

        var checked = (0, _getField2.default)(this.props, this.state, 'checked');
        var isSwitch = type === 'switch';
        var label = _react2.default.createElement(
          'label',
          {
            key: 'label',
            htmlFor: id,
            className: (0, _classnames2.default)('md-selection-control-label', {
              'md-pointer--hover': !disabled,
              'md-text--disabled': disabled,
              'md-text': !disabled
            })
          },
          this.props.label
        );

        var control = void 0;
        if (isSwitch) {
          control = _react2.default.createElement(_SwitchTrack2.default, {
            disabled: disabled,
            checked: checked,
            onClick: this._handleControlClick,
            onBlur: onBlur,
            onFocus: onFocus
          });
        } else {
          control = _react2.default.createElement(
            _AccessibleFakeInkedButton2.default,
            {
              ref: this._setControl,
              onBlur: onBlur,
              onFocus: onFocus,
              disabled: disabled,
              onClick: this._handleControlClick,
              className: (0, _classnames2.default)('md-btn md-btn--icon', {
                'md-text--disabled': disabled,
                'md-text--theme-secondary': !disabled && checked,
                'md-text--secondary': !disabled && !checked
              }),
              role: type,
              'aria-checked': checked,
              tabIndex: tabIndex
            },
            this._getIcon()
          );
        }

        return _react2.default.createElement(
          'div',
          _extends({}, props, {
            ref: this._setContainer,
            style: style,
            className: (0, _classnames2.default)('md-selection-control-container', {
              'md-selection-control-container--inline': inline,
              'md-switch-container': isSwitch
            }, className)
          }),
          labelBefore && label,
          _react2.default.createElement('input', {
            ref: this._setInput,
            id: id,
            type: isSwitch ? 'checkbox' : type,
            checked: checked,
            onChange: this._handleChange,
            disabled: disabled,
            className: 'md-selection-control-input',
            name: name,
            value: value,
            'aria-hidden': true
          }),
          control,
          !labelBefore && label
        );
      }
    }]);

    return SelectionControl;
  }(_react.PureComponent);

  SelectionControl.propTypes = {
    /**
     * An id to use with the selection control. This is used for accessibility and so that the label
     * triggers the selection control toggle.
     */
    id: preventDouble((0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]))),

    /**
     * An optional style to apply to the selection control's container.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply to the selection control's container.
     */
    className: _propTypes2.default.string,

    /**
     * The type of selection control to render.
     */
    type: _propTypes2.default.oneOf(['checkbox', 'radio', 'switch']).isRequired,

    /**
     * A label to display with the selection control. This is required for accessibility and triggering
     * the toggle.
     */
    label: _propTypes2.default.node,

    /**
     * Boolean if the label should appear before the checkbox/radio icon or switch.
     */
    labelBefore: _propTypes2.default.bool,

    /**
     * A name to use for the `SelectionControl`. This is required for accessibility. If the `type`
     * is a `checkbox` and it is part of a group, it is recommended to make this a string ending
     * in `[]` so that the value can be found from `document.querySelector('input[name="someName[]"]').value`.
     */
    name: preventDouble((0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]))),

    /**
     * Boolean if the `Radio` is disabled.
     */
    disabled: _propTypes2.default.bool,

    /**
     * A function to call when the `SelectionControl` triggers the `change` event. The `onChange`
     * callback will either include:
     * - the currently changed radio's value
     * - the next checked state for the `Switch` or `Checkbox`.
     *
     * as the first paramater followed by the change event.
     *
     * ```js
     * // Radio
     * onChange(changeEvent.target.value, changeEvent);
     *
     * // Checkbox or Switch
     * onChange(changeEvent.target.checked, changeEvent);
     * ```
     */
    onChange: _propTypes2.default.func,

    /**
     * An optional function to call when the `SelectionControl` triggers the `blur` event.
     */
    onBlur: _propTypes2.default.func,

    /**
     * An optional function to call when the `SelectionControl` triggers the `focus` event.
     */
    onFocus: _propTypes2.default.func,

    /**
     * The value for the `SelectionControl`. It is not required for `Checkbox` and `Switch`,
     * but it is recommended.
     */
    value: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.string]),

    /**
     * A boolean if the `SelectionControl` is currently checked. This _really_ makes the `onChange`
     * prop required, but since there are cases you might want to have the `onChange` listener on a
     * `fieldset` or something above the component, it is never set to `required`. It will however
     * prevent updates if there is no change listener.
     */
    checked: _propTypes2.default.bool,

    /**
     * Boolean if the `Checkbox` or `Switch` are checked by default. This prop is invalid for a
     * `Radio`.
     */
    defaultChecked: _propTypes2.default.bool,

    /**
     * Boolean if the `SelectionControl` should be displayed inline instead of a block.
     */
    inline: _propTypes2.default.bool,

    /**
     * Any children used to render the checkbox checked `FontIcon`.
     */
    checkedCheckboxIconChildren: _propTypes2.default.node,

    /**
     * An icon className to use to render the checkbox checked `FontIcon`.
     */
    checkedCheckboxIconClassName: _propTypes2.default.string,

    /**
     * Any children used to render the checkbox unchecked `FontIcon`.
     */
    uncheckedCheckboxIconChildren: _propTypes2.default.node,

    /**
     * An icon className to use to render the checkbox unchecked `FontIcon`.
     */
    uncheckedCheckboxIconClassName: _propTypes2.default.string,

    /**
     * Any children used to render the radio checked `FontIcon`.
     */
    checkedRadioIconChildren: _propTypes2.default.node,

    /**
     * An icon className to use to render the radio checked `FontIcon`.
     */
    checkedRadioIconClassName: _propTypes2.default.string,

    /**
     * Any children used to render the radio unchecked `FontIcon`.
     */
    uncheckedRadioIconChildren: _propTypes2.default.node,

    /**
     * An icon className to use to render the radio unchecked `FontIcon`.
     */
    uncheckedRadioIconClassName: _propTypes2.default.string,

    /**
     * An optional tab index to apply to the selection control.
     */
    tabIndex: _propTypes2.default.number,

    checkedIcon: preventDouble((0, _deprecated2.default)(_propTypes2.default.node, 'Use the `checkedCheckboxIconChildren` and `checkedCheckboxIconClassName`  or the ' + '`checkedRadioIconChildren` and `checkedRadioIconClassName` props instead')),
    uncheckedIcon: preventDouble((0, _deprecated2.default)(_propTypes2.default.node, 'Use the `uncheckedCheckboxIconChildren` and `uncheckedCheckboxIconClassName`  or the ' + '`uncheckedRadioIconChildren` and `uncheckedRadioIconClassName` props instead')),

    /* maybe removed once upgrade again? */
    __superSecreteProp: _propTypes2.default.bool
  };
  SelectionControl.defaultProps = {
    checkedCheckboxIconChildren: 'check_box',
    uncheckedCheckboxIconChildren: 'check_box_outline_blank',
    checkedRadioIconChildren: 'radio_button_checked',
    uncheckedRadioIconChildren: 'radio_button_unchecked'
  };
  exports.default = SelectionControl;
});

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(9), __webpack_require__(3), __webpack_require__(12), __webpack_require__(17), __webpack_require__(14), __webpack_require__(20), __webpack_require__(65), __webpack_require__(1197), __webpack_require__(590), __webpack_require__(576), __webpack_require__(578), __webpack_require__(1180), __webpack_require__(1178), __webpack_require__(577)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('react-dom'), require('classnames'), require('react-prop-types/lib/deprecated'), require('react-prop-types/lib/isRequiredForA11y'), require('../constants/keyCodes'), require('../utils/PropTypes/controlled'), require('../utils/PropTypes/invalidIf'), require('../utils/PropTypes/minNumber'), require('../utils/StringUtils/addSuffix'), require('./FloatingLabel'), require('./TextFieldMessage'), require('./PasswordButton'), require('./InputField'), require('./TextFieldDivider'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.reactDom, global.classnames, global.deprecated, global.isRequiredForA11y, global.keyCodes, global.controlled, global.invalidIf, global.minNumber, global.addSuffix, global.FloatingLabel, global.TextFieldMessage, global.PasswordButton, global.InputField, global.TextFieldDivider);
    global.TextField = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _reactDom, _classnames, _deprecated, _isRequiredForA11y, _keyCodes, _controlled, _invalidIf, _minNumber, _addSuffix, _FloatingLabel, _TextFieldMessage, _PasswordButton, _InputField, _TextFieldDivider) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _deprecated2 = _interopRequireDefault(_deprecated);

  var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);

  var _controlled2 = _interopRequireDefault(_controlled);

  var _invalidIf2 = _interopRequireDefault(_invalidIf);

  var _minNumber2 = _interopRequireDefault(_minNumber);

  var _addSuffix2 = _interopRequireDefault(_addSuffix);

  var _FloatingLabel2 = _interopRequireDefault(_FloatingLabel);

  var _TextFieldMessage2 = _interopRequireDefault(_TextFieldMessage);

  var _PasswordButton2 = _interopRequireDefault(_PasswordButton);

  var _InputField2 = _interopRequireDefault(_InputField);

  var _TextFieldDivider2 = _interopRequireDefault(_TextFieldDivider);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var TextField = function (_PureComponent) {
    _inherits(TextField, _PureComponent);

    function TextField(props) {
      _classCallCheck(this, TextField);

      var _this = _possibleConstructorReturn(this, (TextField.__proto__ || Object.getPrototypeOf(TextField)).call(this, props));

      var currentLength = 0;
      if (typeof props.value !== 'undefined') {
        currentLength = props.value.length;
      } else if (typeof props.defaultValue !== 'undefined') {
        currentLength = props.defaultValue.length;
      }

      _this.state = {
        active: false,
        error: false,
        floating: !!props.defaultValue || !!props.value,
        passwordVisible: props.passwordInitiallyVisible,
        height: null,
        currentLength: currentLength
      };

      _this.focus = _this.focus.bind(_this);
      _this.getField = _this.getField.bind(_this);
      _this._blur = _this._blur.bind(_this);
      _this._setField = _this._setField.bind(_this);
      _this._setDivider = _this._setDivider.bind(_this);
      _this._setMessage = _this._setMessage.bind(_this);
      _this._setContainer = _this._setContainer.bind(_this);
      _this._setPasswordBtn = _this._setPasswordBtn.bind(_this);
      _this._setFloatingLabel = _this._setFloatingLabel.bind(_this);
      _this._handleFocus = _this._handleFocus.bind(_this);
      _this._handleChange = _this._handleChange.bind(_this);
      _this._handleKeyDown = _this._handleKeyDown.bind(_this);
      _this._handleHeightChange = _this._handleHeightChange.bind(_this);
      _this._handleOutsideClick = _this._handleOutsideClick.bind(_this);
      _this._updateMultilineHeight = _this._updateMultilineHeight.bind(_this);
      _this._togglePasswordField = _this._togglePasswordField.bind(_this);
      _this._handleContainerClick = _this._handleContainerClick.bind(_this);
      return _this;
    }

    _createClass(TextField, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (this._isMultiline(this.props)) {
          this._updateMultilineHeight();
          window.addEventListener('resize', this._updateMultilineHeight);
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var multiline = this._isMultiline(nextProps);
        if (this._isMultiline(this.props) !== multiline) {
          this._updateMultilineHeight(nextProps);
          window[(multiline ? 'add' : 'remove') + 'EventListener']('resize', this._updateMultilineHeight);
        }

        if (this.props.value !== nextProps.value) {
          var value = typeof nextProps.value !== 'undefined' ? nextProps.value.toString() : '';
          var error = this.state.error;

          if (nextProps.maxLength) {
            error = value.length > nextProps.maxLength;
          } else if (nextProps.required && error) {
            error = !value;
          }

          this.setState({
            error: error,
            floating: !!value || this.state.floating && this.state.active,
            currentLength: value.length
          });
        }
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps, prevState) {
        var _props = this.props,
            block = _props.block,
            active = _props.active;

        if (block !== prevProps.block || active !== prevProps.active || this.state.active !== prevState.active) {
          var fn = window[(active || this.state.active ? 'add' : 'remove') + 'EventListener'];
          fn('mousedown', this._handleOutsideClick);
          fn('touchstart', this._handleOutsideClick);
        }

        if (this._isMultiline(this.props) && !this._isMultiline(prevProps)) {
          this._updateMultilineHeight(this.props);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var active = this.props.active;

        var rm = window.removeEventListener;
        if (active || this.state.active) {
          rm('mousedown', this._handleOutsideClick);
          rm('touchstart', this._handleOutsideClick);
        }

        if (this._isMultiline(this.props)) {
          rm('resize', this._updateMultilineHeight);
        }
      }
    }, {
      key: 'getField',
      value: function getField() {
        return this._field.getField();
      }
    }, {
      key: 'focus',
      value: function focus() {
        this._field.focus();
      }
    }, {
      key: '_isMultiline',
      value: function _isMultiline(props) {
        return typeof props.rows !== 'undefined';
      }
    }, {
      key: '_cloneIcon',
      value: function _cloneIcon(icon, active, error, disabled, stateful, block, dir) {
        if (!icon) {
          return icon;
        }

        try {
          var iconEl = _react.Children.only(icon);
          return (0, _react.cloneElement)(iconEl, {
            key: 'icon-' + dir,
            className: (0, _classnames2.default)('md-text-field-icon', {
              'md-text-field-icon--positioned': !block,
              'md-text-field-icon--disabled': disabled,
              'md-text-field-icon--active': stateful && !error && active,
              'md-text-field-icon--error': stateful && error
            }, iconEl.props.className)
          });
        } catch (e) {
          return icon;
        }
      }
    }, {
      key: '_setField',
      value: function _setField(field) {
        if (field !== null) {
          this._field = field;
        }
      }
    }, {
      key: '_setMessage',
      value: function _setMessage(message) {
        if (message !== null) {
          this._message = (0, _reactDom.findDOMNode)(message);
        }
      }
    }, {
      key: '_setDivider',
      value: function _setDivider(divider) {
        if (divider !== null) {
          this._divider = (0, _reactDom.findDOMNode)(divider);
        }
      }
    }, {
      key: '_setContainer',
      value: function _setContainer(container) {
        if (container !== null) {
          this._node = container;
        }
      }
    }, {
      key: '_setPasswordBtn',
      value: function _setPasswordBtn(btn) {
        if (btn !== null) {
          this._password = (0, _reactDom.findDOMNode)(btn);
        }
      }
    }, {
      key: '_setFloatingLabel',
      value: function _setFloatingLabel(label) {
        if (label !== null) {
          this._label = (0, _reactDom.findDOMNode)(label);
        }
      }
    }, {
      key: '_handleContainerClick',
      value: function _handleContainerClick(e) {
        if (this.props.onClick) {
          this.props.onClick(e);
        }

        if (!this.props.disabled) {
          this.focus();
        }
      }
    }, {
      key: '_updateMultilineHeight',
      value: function _updateMultilineHeight() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
        var block = props.block;

        var multiline = this._isMultiline(props);
        if (!multiline) {
          return;
        }

        var cs = window.getComputedStyle((0, _reactDom.findDOMNode)(this._field));
        this._additionalHeight = parseInt(cs.getPropertyValue('margin-top'), 10);

        if (!block) {
          var mb = parseInt(window.getComputedStyle(this._divider).getPropertyValue('margin-bottom'), 10);
          this._additionalHeight += mb === 4 ? 12 : 16;
        }

        if (this._message) {
          this._additionalHeight += this._message.offsetHeight;
        }
      }
    }, {
      key: '_blur',
      value: function _blur() {
        var value = this._field.getValue();

        var state = { active: false, error: this.props.required && !value };
        if (!this.props.block) {
          state.floating = !!value;
        }

        this.setState(state);
      }
    }, {
      key: '_handleOutsideClick',
      value: function _handleOutsideClick(e) {
        if (!this._node.contains(e.target)) {
          this._blur();
        }
      }
    }, {
      key: '_handleFocus',
      value: function _handleFocus(e) {
        var _props2 = this.props,
            onFocus = _props2.onFocus,
            block = _props2.block;

        if (onFocus) {
          onFocus(e);
        }

        var state = { active: true };
        if (!block) {
          state.floating = true;
        }

        this.setState(state);
      }
    }, {
      key: '_handleChange',
      value: function _handleChange(e) {
        var _props3 = this.props,
            onChange = _props3.onChange,
            maxLength = _props3.maxLength,
            required = _props3.required;

        if (onChange) {
          onChange(e.target.value, e);
        }

        var currentLength = e.target.value.length;
        if (typeof maxLength !== 'undefined') {
          this.setState({ currentLength: currentLength, error: currentLength > maxLength });
        } else if (required && this.state.error) {
          this.setState({ error: !currentLength });
        }
      }
    }, {
      key: '_handleKeyDown',
      value: function _handleKeyDown(e) {
        if (this.props.onKeyDown) {
          this.props.onKeyDown(e);
        }

        if ((e.which || e.keyCode) === _keyCodes.TAB) {
          this._blur();
        }
      }
    }, {
      key: '_togglePasswordField',
      value: function _togglePasswordField() {
        this.setState({ passwordVisible: !this.state.passwordVisible }, this.focus);
      }
    }, {
      key: '_handleHeightChange',
      value: function _handleHeightChange(height) {
        if (this._additionalHeight) {
          this.setState({ height: height + this._additionalHeight });
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _state = this.state,
            currentLength = _state.currentLength,
            passwordVisible = _state.passwordVisible,
            height = _state.height;

        var _props4 = this.props,
            id = _props4.id,
            type = _props4.type,
            style = _props4.style,
            className = _props4.className,
            inputStyle = _props4.inputStyle,
            inputClassName = _props4.inputClassName,
            block = _props4.block,
            fullWidth = _props4.fullWidth,
            required = _props4.required,
            customSize = _props4.customSize,
            maxLength = _props4.maxLength,
            errorText = _props4.errorText,
            helpText = _props4.helpText,
            helpOnFocus = _props4.helpOnFocus,
            disabled = _props4.disabled,
            leftIconStateful = _props4.leftIconStateful,
            rightIconStateful = _props4.rightIconStateful,
            passwordIconChildren = _props4.passwordIconChildren,
            passwordIconClassName = _props4.passwordIconClassName,
            lineDirection = _props4.lineDirection,
            paddedBlock = _props4.paddedBlock,
            onDoubleClick = _props4.onDoubleClick,
            onTouchStart = _props4.onTouchStart,
            onTouchMove = _props4.onTouchMove,
            onTouchCancel = _props4.onTouchCancel,
            onTouchEnd = _props4.onTouchEnd,
            onMouseDown = _props4.onMouseDown,
            onMouseUp = _props4.onMouseUp,
            onMouseOver = _props4.onMouseOver,
            onMouseLeave = _props4.onMouseLeave,
            ink = _props4.ink,
            inlineIndicator = _props4.inlineIndicator,
            icon = _props4.icon,
            props = _objectWithoutProperties(_props4, ['id', 'type', 'style', 'className', 'inputStyle', 'inputClassName', 'block', 'fullWidth', 'required', 'customSize', 'maxLength', 'errorText', 'helpText', 'helpOnFocus', 'disabled', 'leftIconStateful', 'rightIconStateful', 'passwordIconChildren', 'passwordIconClassName', 'lineDirection', 'paddedBlock', 'onDoubleClick', 'onTouchStart', 'onTouchMove', 'onTouchCancel', 'onTouchEnd', 'onMouseDown', 'onMouseUp', 'onMouseOver', 'onMouseLeave', 'ink', 'inlineIndicator', 'icon']);

        delete props.label;
        delete props.placeholder;
        delete props.error;
        delete props.active;
        delete props.floating;
        delete props.leftIcon;
        delete props.rightIcon;
        delete props.adjustMinWidth;
        delete props.onClick;
        delete props.onChange;
        delete props.onKeyDown;
        delete props.onFocus;
        delete props.floatingLabel;

        var _props5 = this.props,
            label = _props5.label,
            placeholder = _props5.placeholder,
            error = _props5.error,
            active = _props5.active,
            floating = _props5.floating,
            leftIcon = _props5.leftIcon,
            rightIcon = _props5.rightIcon;

        active = active || this.state.active;
        error = error || this.state.error;
        floating = floating || this.state.floating;

        if (required) {
          if (label) {
            label = (0, _addSuffix2.default)(label, '*');
          }

          if (placeholder && !label) {
            placeholder = (0, _addSuffix2.default)(placeholder, '*');
          }
        }

        if (label && !floating) {
          placeholder = null;
        }

        leftIcon = this._cloneIcon(icon || leftIcon, active, error, disabled, leftIconStateful, block, 'left');
        if (type === 'password' && !disabled) {
          rightIcon = _react2.default.createElement(_PasswordButton2.default, {
            key: 'password-btn',
            ref: this._setPasswordBtn,
            onClick: this._togglePasswordField,
            active: active,
            passwordVisible: passwordVisible,
            iconChildren: passwordIconChildren,
            iconClassName: passwordIconClassName,
            block: block,
            floating: !!label
          });
        } else if (inlineIndicator) {
          var el = _react.Children.only(inlineIndicator);
          rightIcon = (0, _react.cloneElement)(inlineIndicator, {
            key: 'icon-right',
            className: (0, _classnames2.default)('md-text-field-inline-indicator', {
              'md-text-field-inline-indicator--floating': label,
              'md-text-field-inline-indicator--block': block
            }, el.props.className)
          });
        } else {
          rightIcon = this._cloneIcon(rightIcon, active, error, disabled, rightIconStateful, block, 'right');
        }
        var rightIconed = !!rightIcon && type !== 'password' && !inlineIndicator;

        var floatingLabel = _react2.default.createElement(_FloatingLabel2.default, {
          key: 'label',
          ref: this._setFloatingLabel,
          label: label,
          htmlFor: id,
          active: active,
          error: error,
          floating: floating,
          customSize: customSize,
          disabled: disabled,
          iconOffset: !!leftIcon
        });

        var message = _react2.default.createElement(_TextFieldMessage2.default, {
          key: 'message',
          ref: this._setMessage,
          active: active,
          error: error,
          errorText: errorText,
          helpText: helpText,
          helpOnFocus: helpOnFocus,
          block: block,
          maxLength: maxLength,
          leftIcon: !!leftIcon,
          rightIcon: !!rightIcon,
          currentLength: currentLength
        });

        var field = _react2.default.createElement(_InputField2.default, _extends({}, props, {
          key: 'field',
          ref: this._setField,
          id: id,
          type: type,
          label: label,
          style: inputStyle,
          className: inputClassName,
          disabled: disabled,
          customSize: customSize,
          fullWidth: fullWidth,
          passwordVisible: passwordVisible,
          placeholder: placeholder,
          block: block,
          onFocus: this._handleFocus,
          onKeyDown: this._handleKeyDown,
          onChange: this._handleChange,
          onHeightChange: this._handleHeightChange,
          inlineIndicator: !!inlineIndicator
        }));

        var divider = void 0;
        if (!block) {
          divider = _react2.default.createElement(_TextFieldDivider2.default, {
            key: 'text-divider',
            ref: this._setDivider,
            active: active,
            error: error,
            lineDirection: lineDirection
          });
        }

        var children = void 0;
        if (leftIcon || rightIconed) {
          children = _react2.default.createElement(
            'div',
            { key: 'icon-divider', className: 'md-text-field-icon-container' },
            leftIcon,
            _react2.default.createElement(
              'div',
              {
                key: 'divider-container',
                className: (0, _classnames2.default)('md-text-field-divider-container', {
                  'md-text-field-divider-container--grow': fullWidth
                })
              },
              field,
              divider
            ),
            rightIcon
          );
        } else {
          children = [leftIcon, field, divider, rightIcon];
        }

        children = [floatingLabel, children, message];

        var multiline = this._isMultiline(this.props);
        return _react2.default.createElement(
          'div',
          {
            ref: this._setContainer,
            style: Object.assign({}, style, { height: height }),
            className: (0, _classnames2.default)('md-text-field-container', {
              'md-inline-block': !fullWidth && !block,
              'md-full-width': block || fullWidth,
              'md-text-field-container--disabled': disabled,
              'md-text-field-container--input': typeof props.rows === 'undefined',
              'md-text-field-container--input-block': block && !multiline,
              'md-text-field-container--multiline': multiline,
              'md-text-field-container--multiline-block': multiline && block,
              'md-text-field-container--padded-block': block && paddedBlock
            }, className),
            onClick: this._handleContainerClick,
            onDoubleClick: onDoubleClick,
            onMouseOver: onMouseOver,
            onMouseLeave: onMouseLeave,
            onMouseDown: onMouseDown,
            onMouseUp: onMouseUp,
            onTouchStart: onTouchStart,
            onTouchEnd: onTouchEnd,
            onTouchCancel: onTouchCancel,
            onTouchMove: onTouchMove
          },
          ink,
          children
        );
      }
    }]);

    return TextField;
  }(_react.PureComponent);

  TextField.propTypes = {
    /**
     * An optional style to apply to the text field's container.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply to the text field's container.
     */
    className: _propTypes2.default.string,

    /**
     * An optional style to apply to the `input` or `textarea` tag.
     */
    inputStyle: _propTypes2.default.object,

    /**
     * An optional className to apply to the `input` or `textarea` tag.
     */
    inputClassName: _propTypes2.default.string,

    /**
     * An optional value to apply to the text field. This will make the component
     * controlled and require the `onChange` prop.
     */
    value: (0, _controlled2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]), 'onChange'),

    /**
     * An optional default value for the text field.
     */
    defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),

    /**
     * Boolean if the text field should be displayed as a `block`. This is equivalent to
     * the `full width` text field in the Material Design specs. This view will disable
     * floating labels and remove the text divider from the component.
     */
    block: function block(props, propName, component) {
      for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        others[_key - 3] = arguments[_key];
      }

      var err = _propTypes2.default.bool.apply(_propTypes2.default, [props, propName, component].concat(others));
      if (!err && props[propName] && props.label) {
        err = new Error('The `' + component + '` is unable to have a `label` and be displayed as `block`. ' + ('If you would like a `label` for the block `' + component + '`, please use the `placeholder` prop.'));
      }

      return err;
    },

    /**
     * Boolean if the `block` text field should include padding to the left and right of
     * the text field.
     */
    paddedBlock: _propTypes2.default.bool,

    /**
     * Boolean if the text field is currently disabled.
     */
    disabled: _propTypes2.default.bool,

    /**
     * An optional label to display with the text field. This will convert the text field
     * into a floating label text field. You can make it single line by only using the
     * `placeholder` prop.
     */
    label: _propTypes2.default.node,

    /**
     * An optional placeholder text to display in the text field. If there is no `label` prop,
     * the text field will be displayed as a single line text field. If there is a `label` prop,
     * this will only be visible when there is no value and the user focused the text field.
     */
    placeholder: _propTypes2.default.string,

    /**
     * The id for the text field.  This is required for a11y if the `label` prop is defined.
     */
    id: function id(props, propName, component) {
      for (var _len2 = arguments.length, others = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
        others[_key2 - 3] = arguments[_key2];
      }

      var validator = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
      if (typeof props.label !== 'undefined') {
        return (0, _isRequiredForA11y2.default)(validator).apply(undefined, [props, propName, component].concat(others));
      }

      return validator.apply(undefined, [props, propName, component].concat(others));
    },

    /**
     * The type for the text field. This is one of the most import props for mobile accessibility
     * as it will update the keyboard for the text type. This does not get applied on multiline
     * text fields.
     */
    type: _propTypes2.default.oneOf(['text', 'number', 'email', 'search', 'tel', 'url', 'password']).isRequired,

    /**
     * An optional function to call when the text field's container triggers the `click` event.
     */
    onClick: _propTypes2.default.func,

    /**
     * An optional function to call when the text field's container triggers the `doubleclick`
     * event.
     */
    onDoubleClick: _propTypes2.default.func,

    /**
     * An optional function to call when the text field's container triggers the `touchstart`
     * event.
     */
    onTouchStart: _propTypes2.default.func,

    /**
     * An optional function to call when the text field's container triggers the `touchmove`
     * event.
     */
    onTouchMove: _propTypes2.default.func,

    /**
     * An optional function to call when the text field's container triggers the `touchcancel`
     * event.
     */
    onTouchCancel: _propTypes2.default.func,

    /**
     * An optional function to call when the text field's container triggers the `touchend`
     * event.
     */
    onTouchEnd: _propTypes2.default.func,

    /**
     * An optional function to call when the text field's container triggers the `mousedown`
     * event.
     */
    onMouseDown: _propTypes2.default.func,

    /**
     * An optional function to call when the text field's container triggers the `mouseup`
     * event.
     */
    onMouseUp: _propTypes2.default.func,

    /**
     * An optional function to call when the text field's container triggers the `mouseover`
     * event.
     */
    onMouseOver: _propTypes2.default.func,

    /**
     * An optional function to call when the text field's container triggers the `mouseleave`
     * event.
     */
    onMouseLeave: _propTypes2.default.func,

    /**
     * An optional onChange function to call. If the `value` prop is true, this is
     * required.
     *
     * When the value changes in the text field, this will be called with the new text
     * field's value and the change event.
     *
     * ```js
     * onChange(e.target.value, e);
     * ```
     */
    onChange: _propTypes2.default.func,

    /**
     * An optional function to call when the text field is focused.
     */
    onFocus: _propTypes2.default.func,

    /**
     * An optional function to call when the text field has the `keydown` event.
     */
    onKeyDown: _propTypes2.default.func,

    /**
     * An optional boolean if the `active` state of the text field can be externally
     * modified as well. The text field is usually considered active when it gains focus.
     *
     * If this prop is set, it will check both the active prop and the active state to
     * determine if one is true.
     */
    active: _propTypes2.default.bool,

    /**
     * An optional boolean if the `error` state of the text field can be externally
     * modified as well. The text field is usually considered errored when it is required
     * and there is no value or the current length of the text field's value is greater
     * than the `maxLength` prop.
     *
     * If this prop is set, it will check both the error prop and the error state to
     * determine if one is true.
     */
    error: _propTypes2.default.bool,

    /**
     * An optional boolean if the `floating` state of the text field's floating label can be
     * externally modified as well. The floating state is true when the tet field gains focus
     * or there is a value in the text field.
     *
     * If this prop is set, it will check both the floating prop and the floating state to
     * determine if one is true.
     */
    floating: _propTypes2.default.bool,

    /**
     * Boolean if the text field is required. If the user blurs the text field while there is
     * no value and it is required, the `error` state will be set to true.
     */
    required: _propTypes2.default.bool,

    /**
     * The direction that the underline should appear from.
     */
    lineDirection: _propTypes2.default.oneOf(['left', 'center', 'right']).isRequired,

    /**
     * An optional icon to place to the left of the text field.
     */
    leftIcon: _propTypes2.default.element,

    /**
     * Boolean if the left icon should be stateful. This means that the icon will
     * gain the active or error colors with the text field.
     */
    leftIconStateful: _propTypes2.default.bool,

    /**
     * An optional icon to place to the right of the text field.
     */
    rightIcon: _propTypes2.default.element,

    /**
     * Boolean if the right icon should be stateful. This means that the icon will
     * gain the active or error colors with the text field.
     */
    rightIconStateful: _propTypes2.default.bool,

    /**
     * Any children used to display the password icon.
     */
    passwordIconChildren: _propTypes2.default.node,

    /**
     * The icon className for the password icon.
     */
    passwordIconClassName: _propTypes2.default.string,

    /**
     * Boolean if the password is initially visible.
     */
    passwordInitiallyVisible: _propTypes2.default.bool,

    /**
     * Boolean if the text field should be displayed as full width.
     */
    fullWidth: _propTypes2.default.bool,

    /**
     * The number of rows for the `multiline` text field. This value must be greater than
     * or equal to 1. When this value is set, the text field will be converted to a multiline
     * field.
     */
    rows: (0, _minNumber2.default)(1, false),

    /**
     * The maximum number of rows for a `multiline` text field. If this value is
     * `undefined`, `0`, or a number less than `0`, the multiline text field will
     * infinitely expand.
     */
    maxRows: _propTypes2.default.number,

    /**
     * An optional customsize to apply to the text field. This is used along with
     * the `$md-text-field-custom-sizes` variable. It basically applies a className of
     * `md-text-field--NAME`.
     */
    customSize: _propTypes2.default.string,

    /**
     * An optional error text to display below the text field. This will only appear when
     * the text field has the `error` state through the `error` prop, the current length
     * of the text field's value is greater than the `maxLength` prop, or the field is
     * required and the user blurs the text field with no value.
     */
    errorText: (0, _invalidIf2.default)(_propTypes2.default.node, 'block'),

    /**
     * An optional help text to display below the text field. This will always be visible
     * unless the `helpOnFocus` prop is set to true. Otherwise it will appear on focus.
     */
    helpText: (0, _invalidIf2.default)(_propTypes2.default.node, 'block'),

    /**
     * Boolean if the help text should display on focus only.
     */
    helpOnFocus: _propTypes2.default.bool,

    /**
     * An optional max length for the text field. This will insert a counter underneath the
     * text field that appears on focus.
     */
    maxLength: _propTypes2.default.number,

    /**
     * The ink when there is an injectInk above the text field. Used from the SelectField.
     *
     * @access private
     */
    ink: _propTypes2.default.node,

    /**
     * An optional element to display inside of the `TextField` to the farthest right. This will
     * position the indicator absolutely and add some additional padding to the `TextField`.
     */
    inlineIndicator: _propTypes2.default.element,

    icon: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `leftIcon` or `rightIcon` prop instead'),
    floatingLabel: (0, _deprecated2.default)(_propTypes2.default.bool, 'The `label` prop is now always floating. To create a non-floating text field, only use the `placeholder` prop'),
    adjustMinWidth: (0, _deprecated2.default)(_propTypes2.default.bool, 'Manually add a min width style instead')
  };
  TextField.defaultProps = {
    type: 'text',
    lineDirection: 'left',
    passwordIconChildren: 'remove_red_eye',
    leftIconStateful: true,
    rightIconStateful: true,
    fullWidth: true
  };
  exports.default = TextField;
});

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(10);

var ReactChildren = __webpack_require__(1299);
var ReactComponent = __webpack_require__(282);
var ReactPureComponent = __webpack_require__(1304);
var ReactClass = __webpack_require__(1300);
var ReactDOMFactories = __webpack_require__(1301);
var ReactElement = __webpack_require__(86);
var ReactPropTypes = __webpack_require__(1303);
var ReactVersion = __webpack_require__(1305);

var onlyChild = __webpack_require__(1308);
var warning = __webpack_require__(6);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;

if (false) {
  var warned = false;
  __spread = function () {
    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
    warned = true;
    return _assign.apply(null, arguments);
  };
}

var React = {

  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactComponent,
  PureComponent: ReactPureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: ReactClass.createClass,
  createFactory: createFactory,
  createMixin: function (mixin) {
    // Currently a noop. Will be used to validate and trace mixins.
    return mixin;
  },

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

// TODO: Fix tests so that this deprecation warning doesn't cause failures.
if (false) {
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        process.env.NODE_ENV !== 'production' ? warning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated. Use ' + 'the prop-types package from npm instead.') : void 0;
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });
  }
}

module.exports = React;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(10);

var ReactCurrentOwner = __webpack_require__(48);

var warning = __webpack_require__(6);
var canDefineProperty = __webpack_require__(624);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(623);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(89);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = __webpack_require__(306)
  , enumBugKeys = __webpack_require__(172);

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x === null ? NaN : +x;
});


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = spherical;
/* harmony export (immutable) */ __webpack_exports__["a"] = cartesian;
/* harmony export (immutable) */ __webpack_exports__["c"] = cartesianDot;
/* harmony export (immutable) */ __webpack_exports__["b"] = cartesianCross;
/* harmony export (immutable) */ __webpack_exports__["e"] = cartesianAddInPlace;
/* harmony export (immutable) */ __webpack_exports__["d"] = cartesianScale;
/* harmony export (immutable) */ __webpack_exports__["g"] = cartesianNormalizeInPlace;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);


function spherical(cartesian) {
  return [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(cartesian[1], cartesian[0]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["f" /* asin */])(cartesian[2])];
}

function cartesian(spherical) {
  var lambda = spherical[0], phi = spherical[1], cosPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(phi);
  return [cosPhi * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(lambda), cosPhi * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(lambda), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(phi)];
}

function cartesianDot(a, b) {
  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}

function cartesianCross(a, b) {
  return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
}

// TODO return a
function cartesianAddInPlace(a, b) {
  a[0] += b[0], a[1] += b[1], a[2] += b[2];
}

function cartesianScale(vector, k) {
  return [vector[0] * k, vector[1] * k, vector[2] * k];
}

// TODO return d
function cartesianNormalizeInPlace(d) {
  var l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
  d[0] /= l, d[1] /= l, d[2] /= l;
}


/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = azimuthalRaw;
/* harmony export (immutable) */ __webpack_exports__["a"] = azimuthalInvert;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);


function azimuthalRaw(scale) {
  return function(x, y) {
    var cx = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(x),
        cy = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(y),
        k = scale(cx * cy);
    return [
      k * cy * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(x),
      k * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(y)
    ];
  }
}

function azimuthalInvert(angle) {
  return function(x, y) {
    var z = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])(x * x + y * y),
        c = angle(z),
        sc = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(c),
        cc = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(c);
    return [
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(x * sc, z * cc),
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["f" /* asin */])(z && y * sc / z)
    ];
  }
}


/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (x1 - x0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.y0 = y0, node.y1 = y1;
    node.x0 = x0, node.x1 = x0 += node.value * k;
  }
});


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = hue;
/* harmony export (immutable) */ __webpack_exports__["c"] = gamma;
/* harmony export (immutable) */ __webpack_exports__["a"] = nogamma;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(349);


function linear(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function hue(a, b) {
  var d = b - a;
  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear(a, d) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}


/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_path__ = __webpack_require__(816);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_path__["a"]; });



/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_band__ = __webpack_require__(822);
/* unused harmony reexport scaleBand */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_band__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_identity__ = __webpack_require__(828);
/* unused harmony reexport scaleIdentity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_linear__ = __webpack_require__(99);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__src_linear__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_log__ = __webpack_require__(829);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__src_log__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_ordinal__ = __webpack_require__(356);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__src_ordinal__["a"]; });
/* unused harmony reexport scaleImplicit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_pow__ = __webpack_require__(830);
/* unused harmony reexport scalePow */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_5__src_pow__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_quantile__ = __webpack_require__(831);
/* unused harmony reexport scaleQuantile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_quantize__ = __webpack_require__(832);
/* unused harmony reexport scaleQuantize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_threshold__ = __webpack_require__(835);
/* unused harmony reexport scaleThreshold */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_time__ = __webpack_require__(357);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_9__src_time__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_utcTime__ = __webpack_require__(837);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_10__src_utcTime__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_category10__ = __webpack_require__(823);
/* unused harmony reexport schemeCategory10 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_category20b__ = __webpack_require__(825);
/* unused harmony reexport schemeCategory20b */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_category20c__ = __webpack_require__(826);
/* unused harmony reexport schemeCategory20c */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_category20__ = __webpack_require__(824);
/* unused harmony reexport schemeCategory20 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__ = __webpack_require__(827);
/* unused harmony reexport interpolateCubehelixDefault */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_rainbow__ = __webpack_require__(833);
/* unused harmony reexport interpolateRainbow */
/* unused harmony reexport interpolateWarm */
/* unused harmony reexport interpolateCool */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_viridis__ = __webpack_require__(838);
/* unused harmony reexport interpolateViridis */
/* unused harmony reexport interpolateMagma */
/* unused harmony reexport interpolateInferno */
/* unused harmony reexport interpolatePlasma */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_sequential__ = __webpack_require__(834);
/* unused harmony reexport scaleSequential */







































/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(s) {
  return s.match(/.{6}/g).map(function(x) {
    return "#" + x;
  });
});


/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = linearish;
/* harmony export (immutable) */ __webpack_exports__["a"] = linear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tickFormat__ = __webpack_require__(836);





function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function(count) {
    var d = domain();
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* ticks */])(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function(count, specifier) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__tickFormat__["a" /* default */])(domain(), count, specifier);
  };

  scale.nice = function(count) {
    if (count == null) count = 10;

    var d = domain(),
        i0 = 0,
        i1 = d.length - 1,
        start = d[i0],
        stop = d[i1],
        step;

    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }

    step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["c" /* tickIncrement */])(start, stop, count);

    if (step > 0) {
      start = Math.floor(start / step) * step;
      stop = Math.ceil(stop / step) * step;
      step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["c" /* tickIncrement */])(start, stop, count);
    } else if (step < 0) {
      start = Math.ceil(start * step) / step;
      stop = Math.floor(stop * step) / step;
      step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["c" /* tickIncrement */])(start, stop, count);
    }

    if (step > 0) {
      d[i0] = Math.floor(start / step) * step;
      d[i1] = Math.ceil(stop / step) * step;
      domain(d);
    } else if (step < 0) {
      d[i0] = Math.ceil(start * step) / step;
      d[i1] = Math.floor(stop * step) / step;
      domain(d);
    }

    return scale;
  };

  return scale;
}

function linear() {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__continuous__["b" /* deinterpolateLinear */], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["a" /* interpolateNumber */]);

  scale.copy = function() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__continuous__["c" /* copy */])(scale, linear());
  };

  return linearish(scale);
}


/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return abs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return atan2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return cos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return max; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return min; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return sin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return sqrt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epsilon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return halfPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return tau; });
/* harmony export (immutable) */ __webpack_exports__["l"] = acos;
/* harmony export (immutable) */ __webpack_exports__["k"] = asin;
var abs = Math.abs;
var atan2 = Math.atan2;
var cos = Math.cos;
var max = Math.max;
var min = Math.min;
var sin = Math.sin;
var sqrt = Math.sqrt;

var epsilon = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = 2 * pi;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}

function asin(x) {
  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
    s0 = s1, s1 = series[order[i]];
    for (j = 0; j < m; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
});


/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  var n = series.length, o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
});


/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return epsilon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return epsilon2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return beaches; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return cells; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return circles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return edges; });
/* harmony export (immutable) */ __webpack_exports__["a"] = Diagram;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Beach__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Cell__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Circle__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Edge__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RedBlackTree__ = __webpack_require__(210);






var epsilon = 1e-6;
var epsilon2 = 1e-12;
var beaches;
var cells;
var circles;
var edges;

function triangleArea(a, b, c) {
  return (a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1]);
}

function lexicographic(a, b) {
  return b[1] - a[1]
      || b[0] - a[0];
}

function Diagram(sites, extent) {
  var site = sites.sort(lexicographic).pop(),
      x,
      y,
      circle;

  edges = [];
  cells = new Array(sites.length);
  beaches = new __WEBPACK_IMPORTED_MODULE_4__RedBlackTree__["a" /* default */];
  circles = new __WEBPACK_IMPORTED_MODULE_4__RedBlackTree__["a" /* default */];

  while (true) {
    circle = __WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* firstCircle */];
    if (site && (!circle || site[1] < circle.y || (site[1] === circle.y && site[0] < circle.x))) {
      if (site[0] !== x || site[1] !== y) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__Beach__["a" /* addBeach */])(site);
        x = site[0], y = site[1];
      }
      site = sites.pop();
    } else if (circle) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__Beach__["b" /* removeBeach */])(circle.arc);
    } else {
      break;
    }
  }

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__Cell__["a" /* sortCellHalfedges */])();

  if (extent) {
    var x0 = +extent[0][0],
        y0 = +extent[0][1],
        x1 = +extent[1][0],
        y1 = +extent[1][1];
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__Edge__["a" /* clipEdges */])(x0, y0, x1, y1);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__Cell__["b" /* clipCells */])(x0, y0, x1, y1);
  }

  this.edges = edges;
  this.cells = cells;

  beaches =
  circles =
  edges =
  cells = null;
}

Diagram.prototype = {
  constructor: Diagram,

  polygons: function() {
    var edges = this.edges;

    return this.cells.map(function(cell) {
      var polygon = cell.halfedges.map(function(i) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__Cell__["c" /* cellHalfedgeStart */])(cell, edges[i]); });
      polygon.data = cell.site.data;
      return polygon;
    });
  },

  triangles: function() {
    var triangles = [],
        edges = this.edges;

    this.cells.forEach(function(cell, i) {
      if (!(m = (halfedges = cell.halfedges).length)) return;
      var site = cell.site,
          halfedges,
          j = -1,
          m,
          s0,
          e1 = edges[halfedges[m - 1]],
          s1 = e1.left === site ? e1.right : e1.left;

      while (++j < m) {
        s0 = s1;
        e1 = edges[halfedges[j]];
        s1 = e1.left === site ? e1.right : e1.left;
        if (s0 && s1 && i < s0.index && i < s1.index && triangleArea(site, s0, s1) < 0) {
          triangles.push([site.data, s0.data, s1.data]);
        }
      }
    });

    return triangles;
  },

  links: function() {
    return this.edges.filter(function(edge) {
      return edge.right;
    }).map(function(edge) {
      return {
        source: edge.left.data,
        target: edge.right.data
      };
    });
  },

  find: function(x, y, radius) {
    var that = this, i0, i1 = that._found || 0, n = that.cells.length, cell;

    // Use the previously-found cell, or start with an arbitrary one.
    while (!(cell = that.cells[i1])) if (++i1 >= n) return null;
    var dx = x - cell.site[0], dy = y - cell.site[1], d2 = dx * dx + dy * dy;

    // Traverse the half-edges to find a closer cell, if any.
    do {
      cell = that.cells[i0 = i1], i1 = null;
      cell.halfedges.forEach(function(e) {
        var edge = that.edges[e], v = edge.left;
        if ((v === cell.site || !v) && !(v = edge.right)) return;
        var vx = x - v[0], vy = y - v[1], v2 = vx * vx + vy * vy;
        if (v2 < d2) d2 = v2, i1 = v.index;
      });
    } while (i1 !== null);

    that._found = i0;

    return radius == null || d2 <= radius * radius ? cell.site : null;
  }
}


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var stripPrefix = exports.stripPrefix = function stripPrefix(path, prefix) {
  return path.indexOf(prefix) === 0 ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  pathname = decodeURI(pathname);

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = encodeURI(pathname || '/');

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(43);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(105),
    getRawTag = __webpack_require__(966),
    objectToString = __webpack_require__(994);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 107 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(926),
    baseKeys = __webpack_require__(942),
    isArrayLike = __webpack_require__(144);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 109 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var EventPluginRegistry = __webpack_require__(228);
var EventPluginUtils = __webpack_require__(229);
var ReactErrorUtils = __webpack_require__(233);

var accumulateInto = __webpack_require__(542);
var forEachAccumulated = __webpack_require__(543);
var invariant = __webpack_require__(4);

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

var getDictionaryKey = function (inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
};

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

function shouldPreventMouseEvent(name, type, props) {
  switch (name) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
      return !!(props.disabled && isInteractive(type));
    default:
      return false;
  }
}

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {

  /**
   * Methods for injecting dependencies.
   */
  injection: {

    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName

  },

  /**
   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {function} listener The callback to store.
   */
  putListener: function (inst, registrationName, listener) {
    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;

    var key = getDictionaryKey(inst);
    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[key] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(inst, registrationName, listener);
    }
  },

  /**
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (inst, registrationName) {
    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
    // live here; needs to be moved to a better place soon
    var bankForRegistrationName = listenerBank[registrationName];
    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
      return null;
    }
    var key = getDictionaryKey(inst);
    return bankForRegistrationName && bankForRegistrationName[key];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (inst, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(inst, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      var key = getDictionaryKey(inst);
      delete bankForRegistrationName[key];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {object} inst The instance, which is the source of events.
   */
  deleteAllListeners: function (inst) {
    var key = getDictionaryKey(inst);
    for (var registrationName in listenerBank) {
      if (!listenerBank.hasOwnProperty(registrationName)) {
        continue;
      }

      if (!listenerBank[registrationName][key]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(inst, registrationName);
      }

      delete listenerBank[registrationName][key];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }

};

module.exports = EventPluginHub;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(110);
var EventPluginUtils = __webpack_require__(229);

var accumulateInto = __webpack_require__(542);
var forEachAccumulated = __webpack_require__(543);
var warning = __webpack_require__(6);

var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(inst, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(inst, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(inst, phase, event) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
  }
  var listener = listenerAtPhase(inst, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    var targetInst = event._targetInst;
    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(inst, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(inst, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event._targetInst, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, from, to) {
  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();

var ReactInstanceMap = {

  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }

};

module.exports = ReactInstanceMap;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(44);

var getEventTarget = __webpack_require__(238);

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(157), __webpack_require__(252), __webpack_require__(81)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('../Tooltips/injectTooltip'), require('../FontIcons/Collapser'), require('../Helpers/IconSeparator'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.injectTooltip, global.Collapser, global.IconSeparator);
    global.TableColumn = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _injectTooltip, _Collapser, _IconSeparator) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _injectTooltip2 = _interopRequireDefault(_injectTooltip);

  var _Collapser2 = _interopRequireDefault(_Collapser);

  var _IconSeparator2 = _interopRequireDefault(_IconSeparator);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var TableColumn = function (_PureComponent) {
    _inherits(TableColumn, _PureComponent);

    function TableColumn() {
      _classCallCheck(this, TableColumn);

      return _possibleConstructorReturn(this, (TableColumn.__proto__ || Object.getPrototypeOf(TableColumn)).apply(this, arguments));
    }

    _createClass(TableColumn, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            className = _props.className,
            numeric = _props.numeric,
            adjusted = _props.adjusted,
            header = _props.header,
            children = _props.children,
            sorted = _props.sorted,
            sortIconChildren = _props.sortIconChildren,
            sortIconClassName = _props.sortIconClassName,
            tooltip = _props.tooltip,
            selectColumnHeader = _props.selectColumnHeader,
            __fixedColumn = _props.__fixedColumn,
            props = _objectWithoutProperties(_props, ['className', 'numeric', 'adjusted', 'header', 'children', 'sorted', 'sortIconChildren', 'sortIconClassName', 'tooltip', 'selectColumnHeader', '__fixedColumn']);

        var sortable = typeof sorted === 'boolean';

        var displayedChildren = children;
        if (sortable) {
          displayedChildren = _react2.default.createElement(
            _IconSeparator2.default,
            { label: children, iconBefore: true },
            _react2.default.createElement(
              _Collapser2.default,
              { flipped: !sorted, iconClassName: sortIconClassName },
              sortIconChildren
            )
          );
        }

        var Component = header ? 'th' : 'td';

        return _react2.default.createElement(
          Component,
          _extends({}, props, {
            className: (0, _classnames2.default)('md-table-column', {
              'md-table-column--header': header,
              'md-table-column--data': !header,
              'md-table-column--adjusted': adjusted,
              'md-table-column--sortable md-pointer--hover': sortable,
              'md-table-column--relative': !__fixedColumn && tooltip,
              'md-table-column--select-field': selectColumnHeader,
              'md-text': !header,
              'md-text--secondary': header,
              'md-text-left': !numeric,
              'md-text-right': numeric
            }, className)
          }),
          tooltip,
          displayedChildren
        );
      }
    }]);

    return TableColumn;
  }(_react.PureComponent);

  TableColumn.propTypes = {
    /**
     * An optional style to apply.
     */
    style: _propTypes2.default.object,

    /**
     * The optional className for the table column
     */
    className: _propTypes2.default.string,

    /**
     * The children to display in the column.
     */
    children: _propTypes2.default.node,

    /**
     * Boolean if the column is currently sorted. If this prop is not `undefined`,
     * it will add the sort icon unto this column. You will also need to use the
     * `onClick` function to toggle the `sorted` prop as well as handling the sorting
     * of data.
     *
     * This value should really only be set in the `TableHeader` component.
     */
    sorted: _propTypes2.default.bool,

    /**
     * The optional icon children to display in the sort icon.
     */
    sortIconChildren: _propTypes2.default.node,

    /**
     * The icon className for the sort icon.
     */
    sortIconClassName: _propTypes2.default.string.isRequired,

    /**
     * A boolean if the column has numeric data. It will right-align the data.
     */
    numeric: _propTypes2.default.bool,

    /**
     * Boolean if this column should be adjusted with additional padding. This *should*
     * be handled automatically by the `TableRow` component but can be set manually as well.
     */
    adjusted: _propTypes2.default.bool,

    /**
     * Boolean if this column is the `th` for a column of `SelectFieldColumn`. This will apply
     * additional styling to the column to position with the select field.
     */
    selectColumnHeader: _propTypes2.default.bool,

    /**
     * Boolean if this is a `th` component. This value **should** be set
     * automatically for you if it is in the `TableHeader` component.
     */
    header: _propTypes2.default.bool.isRequired,

    /**
     * The optional tooltip to render on hover.
     */
    tooltipLabel: _propTypes2.default.node,

    /**
     * An optional delay to apply to the tooltip before it appears.
     */
    tooltipDelay: _propTypes2.default.number,

    /**
     * The position of the tooltip.
     */
    tooltipPosition: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),

    /**
     * The injected tooltip.
     * @access private
     */
    tooltip: _propTypes2.default.node,

    /**
     * Boolean if the TableColumn is coming from the EditDialogColumn or SelectFieldColumn
     * components. When this is false, it will update the column to have `position: relative`
     * so that tooltips can be displayed.
     */
    __fixedColumn: _propTypes2.default.bool
  };
  TableColumn.defaultProps = {
    header: false,
    sortIconClassName: 'material-icons',
    sortIconChildren: 'arrow_upward'
  };
  exports.default = (0, _injectTooltip2.default)(TableColumn);
});

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(0), __webpack_require__(3), __webpack_require__(11)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('prop-types'), require('react'), require('classnames'), require('../Buttons/Button'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.propTypes, global.react, global.classnames, global.Button);
    global.DialogFooter = mod.exports;
  }
})(this, function (exports, _propTypes, _react, _classnames, _Button) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _react2 = _interopRequireDefault(_react);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _Button2 = _interopRequireDefault(_Button);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var FOOTER_PADDING = 8;

  var DialogFooter = function (_PureComponent) {
    _inherits(DialogFooter, _PureComponent);

    function DialogFooter(props) {
      _classCallCheck(this, DialogFooter);

      var _this = _possibleConstructorReturn(this, (DialogFooter.__proto__ || Object.getPrototypeOf(DialogFooter)).call(this, props));

      _this.state = { stacked: false };

      _this._toElement = _this._toElement.bind(_this);
      _this._generateActions = _this._generateActions.bind(_this);
      _this._setContainer = _this._setContainer.bind(_this);
      return _this;
    }

    _createClass(DialogFooter, [{
      key: '_setContainer',
      value: function _setContainer(container) {
        var _this2 = this;

        if (container !== null) {
          (function () {
            _this2._container = container;
            var maxWidth = (_this2._container.offsetWidth - FOOTER_PADDING * 3) / 2;

            var stacked = false;
            Array.prototype.slice.call(_this2._container.querySelectorAll('.md-btn')).some(function (_ref) {
              var offsetWidth = _ref.offsetWidth;

              stacked = offsetWidth > maxWidth;
              return stacked;
            });

            _this2.setState({ stacked: stacked });
          })();
        }
      }
    }, {
      key: '_toElement',
      value: function _toElement(action, index) {
        if ((0, _react.isValidElement)(action)) {
          var button = _react.Children.only(action);

          return (0, _react.cloneElement)(action, {
            key: button.props.key || index,
            className: (0, _classnames2.default)('md-btn--dialog', button.props.className)
          });
        }

        return _react2.default.createElement(_Button2.default, _extends({
          key: index,
          flat: true
        }, action, {
          className: (0, _classnames2.default)('md-btn--dialog', action.className)
        }));
      }
    }, {
      key: '_generateActions',
      value: function _generateActions() {
        var actions = this.props.actions;

        if (Array.isArray(actions)) {
          return actions.map(this._toElement);
        }

        return this._toElement(actions);
      }
    }, {
      key: 'render',
      value: function render() {
        var stacked = this.state.stacked;
        var className = this.props.className;

        var _props = this.props,
            children = _props.children,
            actions = _props.actions,
            props = _objectWithoutProperties(_props, ['children', 'actions']);

        delete props.className;
        delete props.onActionMount;

        if (!actions || Array.isArray(actions) && !actions.length) {
          return null;
        }

        className = (0, _classnames2.default)('md-dialog-footer', {
          'md-dialog-footer--inline': !stacked,
          'md-dialog-footer--stacked': stacked
        }, className);

        return _react2.default.createElement(
          'footer',
          _extends({}, props, { className: className, ref: this._setContainer }),
          this._generateActions(),
          children
        );
      }
    }]);

    return DialogFooter;
  }(_react.PureComponent);

  DialogFooter.propTypes = {
    style: _propTypes2.default.object,
    className: _propTypes2.default.string,
    children: _propTypes2.default.node,
    actions: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.object, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.object]))])
  };
  exports.default = DialogFooter;
});

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(9), __webpack_require__(66), __webpack_require__(3), __webpack_require__(12), __webpack_require__(567), __webpack_require__(156), __webpack_require__(38), __webpack_require__(119), __webpack_require__(118), __webpack_require__(45)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('react-dom'), require('react-transition-group/CSSTransitionGroup'), require('classnames'), require('react-prop-types/lib/deprecated'), require('./contextTypes'), require('./Positions'), require('../constants/CSSTransitionGroupTick'), require('../utils/EventUtils/handleWindowClickListeners'), require('../utils/EventUtils/handleKeyboardAccessibility'), require('../Lists/List'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.reactDom, global.CSSTransitionGroup, global.classnames, global.deprecated, global.contextTypes, global.Positions, global.CSSTransitionGroupTick, global.handleWindowClickListeners, global.handleKeyboardAccessibility, global.List);
    global.Menu = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _reactDom, _CSSTransitionGroup, _classnames, _deprecated, _contextTypes, _Positions, _CSSTransitionGroupTick, _handleWindowClickListeners, _handleKeyboardAccessibility, _List) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _deprecated2 = _interopRequireDefault(_deprecated);

  var _contextTypes2 = _interopRequireDefault(_contextTypes);

  var _Positions2 = _interopRequireDefault(_Positions);

  var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);

  var _handleWindowClickListeners2 = _interopRequireDefault(_handleWindowClickListeners);

  var _handleKeyboardAccessibility2 = _interopRequireDefault(_handleKeyboardAccessibility);

  var _List2 = _interopRequireDefault(_List);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Menu = function (_PureComponent) {
    _inherits(Menu, _PureComponent);

    function Menu(props) {
      _classCallCheck(this, Menu);

      var _this = _possibleConstructorReturn(this, (Menu.__proto__ || Object.getPrototypeOf(Menu)).call(this, props));

      _this._setList = _this._setList.bind(_this);
      _this._setContainer = _this._setContainer.bind(_this);
      _this._handleKeyDown = _this._handleKeyDown.bind(_this);
      _this._handleListClick = _this._handleListClick.bind(_this);
      _this._handleOutsideClick = _this._handleOutsideClick.bind(_this);
      return _this;
    }

    _createClass(Menu, [{
      key: 'getChildContext',
      value: function getChildContext() {
        var _props = this.props,
            menuCascading = _props.cascading,
            menuPosition = _props.position;

        return {
          menuCascading: menuCascading,
          menuPosition: menuPosition,
          listLevel: 0
        };
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        var isOpen = this.props.isOpen;

        if (isOpen) {
          (0, _handleWindowClickListeners2.default)(this._handleOutsideClick, true);
        }
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        var isOpen = this.props.isOpen;

        if (isOpen === prevProps.isOpen) {
          return;
        }

        (0, _handleWindowClickListeners2.default)(this._handleOutsideClick, isOpen);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var isOpen = this.props.isOpen;

        if (isOpen) {
          (0, _handleWindowClickListeners2.default)(this._handleOutsideClick, false);
        }

        if (this._timeout) {
          clearTimeout(this._timeout);
        }
      }
    }, {
      key: '_setList',
      value: function _setList(list) {
        if (list !== null) {
          this._list = (0, _reactDom.findDOMNode)(list);
        }

        try {
          var children = _react.Children.only(this.props.children);
          if (typeof children.ref === 'function') {
            children.ref(list);
          }
        } catch (e) {
          // do nothing
        }
      }
    }, {
      key: '_setContainer',
      value: function _setContainer(container) {
        if (container !== null) {
          this._container = (0, _reactDom.findDOMNode)(container);
        }
      }
    }, {
      key: '_handleOutsideClick',
      value: function _handleOutsideClick(e) {
        var isInContextMenu = this.props.position === _Positions2.default.CONTEXT && !this._list.contains(e.target);

        if (isInContextMenu || !this._container.contains(e.target)) {
          var _props2 = this.props,
              onClose = _props2.onClose,
              close = _props2.close;

          if (close) {
            close(e);
          } else if (onClose) {
            onClose(e);
          }
        }
      }
    }, {
      key: '_handleKeyDown',
      value: function _handleKeyDown(e) {
        (0, _handleKeyboardAccessibility2.default)(e, this._handleListClick, true, true);
      }
    }, {
      key: '_handleListClick',
      value: function _handleListClick(e) {
        var _this2 = this;

        var _props3 = this.props,
            onClose = _props3.onClose,
            close = _props3.close;


        var node = e.target;
        while (this._container.contains(node)) {
          if (!node.classList.contains('md-list-item--nested-container') && node.classList.contains('md-list-item')) {
            this._timeout = setTimeout(function () {
              _this2._timeout = null;

              if (close) {
                close(e);
              } else if (onClose) {
                onClose(e);
              }
            }, _CSSTransitionGroupTick2.default);

            return;
          }
          node = node.parentNode;
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _props4 = this.props,
            id = _props4.id,
            className = _props4.className,
            listStyle = _props4.listStyle,
            listClassName = _props4.listClassName,
            isOpen = _props4.isOpen,
            fullWidth = _props4.fullWidth,
            toggle = _props4.toggle,
            contained = _props4.contained,
            children = _props4.children,
            position = _props4.position,
            props = _objectWithoutProperties(_props4, ['id', 'className', 'listStyle', 'listClassName', 'isOpen', 'fullWidth', 'toggle', 'contained', 'children', 'position']);

        delete props.close;
        delete props.onClose;
        delete props.cascading;
        delete props.autoclose;
        delete props.listId;

        var listId = this.props.listId;

        if (!listId && id) {
          listId = id + 'List';
        }

        var menuClassName = (0, _classnames2.default)({ 'md-list--menu-contained': contained }, listClassName);
        var menuItems = void 0;
        try {
          var list = _react.Children.only(children);

          menuItems = (0, _react.cloneElement)(children, {
            id: list.props.id || listId,
            key: 'menu-list',
            className: (0, _classnames2.default)(menuClassName, list.props.className),
            onClick: this._handleListClick,
            onKeyDown: this._handleKeyDown,
            ref: this._setList
          });
        } catch (e) {
          menuItems = _react2.default.createElement(
            _List2.default,
            {
              id: listId,
              key: 'menu-list',
              style: listStyle,
              className: menuClassName,
              onKeyDown: this._handleKeyDown,
              onClick: this._handleListClick,
              ref: this._setList
            },
            children
          );
        }

        return _react2.default.createElement(
          _CSSTransitionGroup2.default,
          _extends({}, props, {
            id: id,
            ref: this._setContainer,
            className: (0, _classnames2.default)('md-inline-block md-menu-container', {
              'md-full-width': fullWidth,
              'md-menu-container--menu-below': position === _Positions2.default.BELOW
            }, className),
            'aria-haspopup': true,
            'aria-expanded': isOpen,
            'aria-owns': listId
          }),
          toggle,
          isOpen ? menuItems : null
        );
      }
    }]);

    return Menu;
  }(_react.PureComponent);

  Menu.Positions = _Positions2.default;
  Menu.propTypes = {
    /**
     * An optional id to give to the menu's container. This is used for accessibility and is
     * generally recommended.
     */
    id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),

    /**
     * An optional id to give to the `List` that gets generated when open. This is used for
     * accessibility and generally recommended. If this prop is given, the `aria-owns` attribute
     * will be added to the list.
     */
    listId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),

    /**
     * An optional style to apply to the main container for a menu.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply to the main container for a menu.
     */
    className: _propTypes2.default.string,

    /**
     * An optional style to apply to the menu's `List` once it has been toggled open.
     */
    listStyle: _propTypes2.default.object,

    /**
     * An optional className to apply to the menu's `List` once it has been toggled open.
     */
    listClassName: _propTypes2.default.string,

    /**
     * The component to render the container as.
     */
    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,

    /**
     * This can either be a single `List` component or an array of `ListItem`, `ListItemControl`,
     * `Divider`, or `Subheader` to display when the menu is open. If it is the `List` component,
     * it will be cloned with some additional class names.
     */
    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)]),

    /**
     * Boolean if the `Menu` is currently open.
     */
    isOpen: _propTypes2.default.bool.isRequired,

    /**
     * The transition name to use for the menu's enter and leave transitions
     */
    transitionName: _propTypes2.default.string.isRequired,

    /**
     * The timeout for the enter transition.
     */
    transitionEnterTimeout: _propTypes2.default.number.isRequired,

    /**
     * The timeout for the leave transition.
     */
    transitionLeaveTimeout: _propTypes2.default.number.isRequired,

    /**
     * The node to use as the toggle for the menu.
     */
    toggle: _propTypes2.default.node,

    /**
     * The position that the menu should appear from. If the position is set to
     * `Menu.Positions.CONTEXT`, the `onClose` function will be called when something
     * outside of the `List` is clicked instead of something outside of the `Menu`.
     */
    position: _propTypes2.default.oneOf([Menu.Positions.TOP_LEFT, Menu.Positions.TOP_RIGHT, Menu.Positions.BOTTOM_LEFT, Menu.Positions.BOTTOM_RIGHT, Menu.Positions.CONTEXT, Menu.Positions.BELOW]).isRequired,

    /**
     * A function used to close the menu. This is used when the user clicks outside
     * of the menu or when a `ListItem` is clicked.
     */
    onClose: _propTypes2.default.func.isRequired,

    /**
     * Boolean if the menu is cascading. This isn't really working too well yet.
     */
    cascading: _propTypes2.default.bool,

    /**
     * Boolean if the width of the `List` should be limited to the width of the `toggle`
     */
    contained: _propTypes2.default.bool,

    /**
     * Boolean if the menu should be displayed full width instead of inline.
     */
    fullWidth: _propTypes2.default.bool,

    close: (0, _deprecated2.default)(_propTypes2.default.func, 'Use `onClose` instead'),
    autoclose: (0, _deprecated2.default)(_propTypes2.default.bool, 'The menus will always autoclose as according to the specs'),
    limitHeight: (0, _deprecated2.default)(_propTypes2.default.bool, 'The menus will always be limited in height as according to the specs'),
    expanderIconClassName: (0, _deprecated2.default)(_propTypes2.default.node, 'The expander for cascading menus will now just be a simple rotate of the existing `ListItem` ' + 'expander icon'),
    expanderIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'The expander for cascading menus will now just be a simple rotate of the existing `ListItem` ' + 'expander icon')
  };
  Menu.defaultProps = {
    component: 'div',
    transitionName: 'md-menu',
    transitionEnterTimeout: 200,
    transitionLeaveTimeout: 200,
    position: Menu.Positions.TOP_RIGHT
  };
  Menu.childContextTypes = _contextTypes2.default;
  exports.default = Menu;
});

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.captureNextEvent = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = captureNextEvent;
  /**
   * This function will capture the next event and stop propagation during the
   * bubbling cycle of events. This is really only useful if you want to stop
   * the default behavior of chained events.
   *
   * @param {String} type - The event type to capture.
   * @param {Object|func=} target - Either the DOM node to target, a callback function
   *      to call once the event has been captured, or undefined. If this is undefined,
   *      the event will be captured on the window.
   * @param {func=} callback - An optional callback function to call once the event
   *      has been captured.
   */
  function captureNextEvent(type, target, callback) {
    var el = typeof target !== 'function' && target ? target : window;
    var cb = typeof target === 'function' ? target : callback;

    var capture = function capture(e) {
      e.stopPropagation();
      if (cb) {
        cb(e);
      }

      el.removeEventListener(type, capture, true);
    };

    el.addEventListener(type, capture, true);
  }
});

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(14), __webpack_require__(1202), __webpack_require__(594)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('../../constants/keyCodes'), require('../closest'), require('../isFormPartRole'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.keyCodes, global.closest, global.isFormPartRole);
    global.handleKeyboardAccessibility = mod.exports;
  }
})(this, function (exports, _keyCodes, _closest, _isFormPartRole) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = handleKeyboardAccessibility;

  var _closest2 = _interopRequireDefault(_closest);

  var _isFormPartRole2 = _interopRequireDefault(_isFormPartRole);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * A utility function for adding keyboard accessibility to elements that are not a natively
   * clickable (div, span, etc). When the space or enter key is pressed while focusing the
   * element, different flows will happen.
   *
   * - space - The click event will be triggered and the default page scrolling behavior of the
   *      spacebar will be prevented
   * - enter - If the element has a form role ('checkbox' or 'radio'), the click event will not
   *      be triggered. Instead, it will find out if the element is inside a form. If it is, it
   *      will emulate the default behavior of attempting to submit the form. If the element does
   *      not have a form role, the click event will be triggered.
   *
   * @param {Event} e - the keydown event
   * @param {function} onClick - the on click event to be triggered if space or enter was pressed
   * @param {boolean=true} listenToEnter - boolean if the enter key should be used to trigger the
   *      the click event. Even if this is true, the click event will not be triggered if the role
   *      is for a form role.
   * @param {boolean=true} listenToSpace - boolean if the space key should be used to trigger the
   *      click event.
   * @return {Boolean} true if the enter or space keys were pressed while their listener is also active.
   */
  function handleKeyboardAccessibility(e, onClick) {
    var listenToEnter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var listenToSpace = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    var key = e.which || e.keyCode;
    var space = listenToSpace && key === _keyCodes.SPACE;
    var enter = key === _keyCodes.ENTER;

    if (space) {
      // Stop page scrolling
      e.preventDefault();
    }

    if (enter && (0, _isFormPartRole2.default)(e.target)) {
      var form = (0, _closest2.default)(e.target, 'form');
      var submit = form ? form.querySelector('*[type="submit"]') : null;
      if (submit) {
        submit.click();
      }

      return true;
    }

    if (enter && listenToEnter || space) {
      onClick(e);

      return true;
    }

    return false;
  }
});

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.handleWindowClickListeners = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = handleWindowClickListeners;
  var mobileSafari = void 0;

  /**
   * Since mobile safari doesn't delegate click events to the window (it only does touch events),
   * this utility function will hack a fix to allow the delegation by updaging the body's cursor
   * to be a pointer.
   *
   * Hopefully this can be removed one day....
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile
   * @param {function} cb - the callback function to use for a window click event.
   * @param {boolean} enabled - boolean if the click event is enabled.
   */
  function handleWindowClickListeners(cb) {
    var enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (typeof mobileSafari === 'undefined' && typeof window !== 'undefined') {
      var ua = window.navigator.userAgent;
      var iOS = ua.match(/iP(ad|hone)/i);
      var webkit = ua.match(/WebKit/i);
      mobileSafari = iOS && webkit && !ua.match(/CriOS/i);

      if (mobileSafari) {
        document.body.style.cursor = 'pointer';
      }
    }

    var listener = window[(enabled ? 'add' : 'remove') + 'EventListener'];
    listener('click', cb);
  }
});

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(588)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('../NumberUtils/isBetween'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.isBetween);
    global.between = mod.exports;
  }
})(this, function (exports, _isBetween) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = between;

  var _isBetween2 = _interopRequireDefault(_isBetween);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Validates that a number is between a min and max value.
   *
   * @param {function} validator - The number validator to use.
   * @param {number} min - The min number to use.
   * @param {number} max - The max number to use.
   * @return {Error} the prop type error or null
   */
  function between(validator, min, max) {
    return function validate(props, propName, componentName, location, propFullName) {
      var componentNameSafe = componentName || '<<anonymous>>';
      var propFullNameSafe = propFullName || propName;

      for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
        args[_key - 5] = arguments[_key];
      }

      var err = validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
      var value = props[propName];
      if (!err && typeof value !== 'undefined' && !(0, _isBetween2.default)(value, min, max)) {
        err = new Error('You provided a `' + propFullNameSafe + '` ' + location + ' to the ' + componentNameSafe + ' that was ' + ('not within the range from \'' + min + ' - ' + max + '\'. `' + propFullNameSafe + '`: ' + value + '.'));
      }

      return err;
    };
  } /** @module PropTypes/between */
});

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;

var _reducer = __webpack_require__(606);

Object.defineProperty(exports, 'LOCATION_CHANGE', {
  enumerable: true,
  get: function get() {
    return _reducer.LOCATION_CHANGE;
  }
});
Object.defineProperty(exports, 'routerReducer', {
  enumerable: true,
  get: function get() {
    return _reducer.routerReducer;
  }
});

var _actions = __webpack_require__(605);

Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
  enumerable: true,
  get: function get() {
    return _actions.CALL_HISTORY_METHOD;
  }
});
Object.defineProperty(exports, 'push', {
  enumerable: true,
  get: function get() {
    return _actions.push;
  }
});
Object.defineProperty(exports, 'replace', {
  enumerable: true,
  get: function get() {
    return _actions.replace;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _actions.go;
  }
});
Object.defineProperty(exports, 'goBack', {
  enumerable: true,
  get: function get() {
    return _actions.goBack;
  }
});
Object.defineProperty(exports, 'goForward', {
  enumerable: true,
  get: function get() {
    return _actions.goForward;
  }
});
Object.defineProperty(exports, 'routerActions', {
  enumerable: true,
  get: function get() {
    return _actions.routerActions;
  }
});

var _sync = __webpack_require__(1240);

var _sync2 = _interopRequireDefault(_sync);

var _middleware = __webpack_require__(1239);

var _middleware2 = _interopRequireDefault(_middleware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.syncHistoryWithStore = _sync2['default'];
exports.routerMiddleware = _middleware2['default'];

/***/ }),
/* 122 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ }),
/* 124 */
/***/ (function(module, exports) {

var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__ = __webpack_require__(748);
/* unused harmony reexport formatDefaultLocale */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_locale__ = __webpack_require__(328);
/* unused harmony reexport formatLocale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_formatSpecifier__ = __webpack_require__(326);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__src_formatSpecifier__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_precisionFixed__ = __webpack_require__(754);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__src_precisionFixed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_precisionPrefix__ = __webpack_require__(755);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__src_precisionPrefix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_precisionRound__ = __webpack_require__(756);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__src_precisionRound__["a"]; });








/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(190);


/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(Math.abs(x)), x ? x[1] : NaN;
});


/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = rotateRadians;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(5);



function rotationIdentity(lambda, phi) {
  return [lambda > __WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */] ? lambda - __WEBPACK_IMPORTED_MODULE_1__math__["b" /* tau */] : lambda < -__WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */] ? lambda + __WEBPACK_IMPORTED_MODULE_1__math__["b" /* tau */] : lambda, phi];
}

rotationIdentity.invert = rotationIdentity;

function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
  return (deltaLambda %= __WEBPACK_IMPORTED_MODULE_1__math__["b" /* tau */]) ? (deltaPhi || deltaGamma ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */])(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma))
    : rotationLambda(deltaLambda))
    : (deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma)
    : rotationIdentity);
}

function forwardRotationLambda(deltaLambda) {
  return function(lambda, phi) {
    return lambda += deltaLambda, [lambda > __WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */] ? lambda - __WEBPACK_IMPORTED_MODULE_1__math__["b" /* tau */] : lambda < -__WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */] ? lambda + __WEBPACK_IMPORTED_MODULE_1__math__["b" /* tau */] : lambda, phi];
  };
}

function rotationLambda(deltaLambda) {
  var rotation = forwardRotationLambda(deltaLambda);
  rotation.invert = forwardRotationLambda(-deltaLambda);
  return rotation;
}

function rotationPhiGamma(deltaPhi, deltaGamma) {
  var cosDeltaPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(deltaPhi),
      sinDeltaPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(deltaPhi),
      cosDeltaGamma = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(deltaGamma),
      sinDeltaGamma = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(deltaGamma);

  function rotation(lambda, phi) {
    var cosPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(phi),
        x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(lambda) * cosPhi,
        y = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(lambda) * cosPhi,
        z = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(phi),
        k = z * cosDeltaPhi + x * sinDeltaPhi;
    return [
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* asin */])(k * cosDeltaGamma + y * sinDeltaGamma)
    ];
  }

  rotation.invert = function(lambda, phi) {
    var cosPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(phi),
        x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(lambda) * cosPhi,
        y = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(lambda) * cosPhi,
        z = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(phi),
        k = z * cosDeltaGamma - y * sinDeltaGamma;
    return [
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* asin */])(k * cosDeltaPhi - x * sinDeltaPhi)
    ];
  };

  return rotation;
}

/* harmony default export */ __webpack_exports__["a"] = (function(rotate) {
  rotate = rotateRadians(rotate[0] * __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */], rotate[1] * __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */], rotate.length > 2 ? rotate[2] * __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */] : 0);

  function forward(coordinates) {
    coordinates = rotate(coordinates[0] * __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */], coordinates[1] * __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */]);
    return coordinates[0] *= __WEBPACK_IMPORTED_MODULE_1__math__["h" /* degrees */], coordinates[1] *= __WEBPACK_IMPORTED_MODULE_1__math__["h" /* degrees */], coordinates;
  }

  forward.invert = function(coordinates) {
    coordinates = rotate.invert(coordinates[0] * __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */], coordinates[1] * __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */]);
    return coordinates[0] *= __WEBPACK_IMPORTED_MODULE_1__math__["h" /* degrees */], coordinates[1] *= __WEBPACK_IMPORTED_MODULE_1__math__["h" /* degrees */], coordinates;
  };

  return forward;
});


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = transformer;
/* unused harmony default export */ var _unused_webpack_default_export = (function(methods) {
  return {
    stream: transformer(methods)
  };
});

function transformer(methods) {
  return function(stream) {
    var s = new TransformStream;
    for (var key in methods) s[key] = methods[key];
    s.stream = stream;
    return s;
  };
}

function TransformStream() {}

TransformStream.prototype = {
  constructor: TransformStream,
  point: function(x, y) { this.stream.point(x, y); },
  sphere: function() { this.stream.sphere(); },
  lineStart: function() { this.stream.lineStart(); },
  lineEnd: function() { this.stream.lineEnd(); },
  polygonStart: function() { this.stream.polygonStart(); },
  polygonEnd: function() { this.stream.polygonEnd(); }
};


/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (y1 - y0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.x0 = x0, node.x1 = x1;
    node.y0 = y0, node.y1 = y0 += node.value * k;
  }
});


/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return a + b * t;
  };
});


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = deinterpolateLinear;
/* harmony export (immutable) */ __webpack_exports__["c"] = copy;
/* harmony export (immutable) */ __webpack_exports__["a"] = continuous;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(355);






var unit = [0, 1];

function deinterpolateLinear(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(b);
}

function deinterpolateClamp(deinterpolate) {
  return function(a, b) {
    var d = deinterpolate(a = +a, b = +b);
    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
  };
}

function reinterpolateClamp(reinterpolate) {
  return function(a, b) {
    var r = reinterpolate(a = +a, b = +b);
    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
  };
}

function bimap(domain, range, deinterpolate, reinterpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
  return function(x) { return r0(d0(x)); };
}

function polymap(domain, range, deinterpolate, reinterpolate) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = deinterpolate(domain[i], domain[i + 1]);
    r[i] = reinterpolate(range[i], range[i + 1]);
  }

  return function(x) {
    var i = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["d" /* bisect */])(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp());
}

// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
function continuous(deinterpolate, reinterpolate) {
  var domain = unit,
      range = unit,
      interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["b" /* interpolate */],
      clamp = false,
      piecewise,
      output,
      input;

  function rescale() {
    piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return (output || (output = piecewise(domain, range, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate)))(+x);
  }

  scale.invert = function(y) {
    return (input || (input = piecewise(range, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
  };

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_2__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]), rescale()) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["c" /* interpolateRound */], rescale();
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, rescale()) : clamp;
  };

  scale.interpolate = function(_) {
    return arguments.length ? (interpolate = _, rescale()) : interpolate;
  };

  return rescale();
}


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_arc__ = __webpack_require__(839);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "arc", function() { return __WEBPACK_IMPORTED_MODULE_0__src_arc__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_area__ = __webpack_require__(358);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "area", function() { return __WEBPACK_IMPORTED_MODULE_1__src_area__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_line__ = __webpack_require__(204);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "line", function() { return __WEBPACK_IMPORTED_MODULE_2__src_line__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_pie__ = __webpack_require__(860);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pie", function() { return __WEBPACK_IMPORTED_MODULE_3__src_pie__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_areaRadial__ = __webpack_require__(840);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "areaRadial", function() { return __WEBPACK_IMPORTED_MODULE_4__src_areaRadial__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "radialArea", function() { return __WEBPACK_IMPORTED_MODULE_4__src_areaRadial__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_lineRadial__ = __webpack_require__(363);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "lineRadial", function() { return __WEBPACK_IMPORTED_MODULE_5__src_lineRadial__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "radialLine", function() { return __WEBPACK_IMPORTED_MODULE_5__src_lineRadial__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_pointRadial__ = __webpack_require__(364);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pointRadial", function() { return __WEBPACK_IMPORTED_MODULE_6__src_pointRadial__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_link_index__ = __webpack_require__(852);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "linkHorizontal", function() { return __WEBPACK_IMPORTED_MODULE_7__src_link_index__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "linkVertical", function() { return __WEBPACK_IMPORTED_MODULE_7__src_link_index__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "linkRadial", function() { return __WEBPACK_IMPORTED_MODULE_7__src_link_index__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_symbol__ = __webpack_require__(862);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbol", function() { return __WEBPACK_IMPORTED_MODULE_8__src_symbol__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbols", function() { return __WEBPACK_IMPORTED_MODULE_8__src_symbol__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_symbol_circle__ = __webpack_require__(365);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolCircle", function() { return __WEBPACK_IMPORTED_MODULE_9__src_symbol_circle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_symbol_cross__ = __webpack_require__(366);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolCross", function() { return __WEBPACK_IMPORTED_MODULE_10__src_symbol_cross__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_symbol_diamond__ = __webpack_require__(367);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolDiamond", function() { return __WEBPACK_IMPORTED_MODULE_11__src_symbol_diamond__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_symbol_square__ = __webpack_require__(368);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolSquare", function() { return __WEBPACK_IMPORTED_MODULE_12__src_symbol_square__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_symbol_star__ = __webpack_require__(369);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolStar", function() { return __WEBPACK_IMPORTED_MODULE_13__src_symbol_star__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_symbol_triangle__ = __webpack_require__(370);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolTriangle", function() { return __WEBPACK_IMPORTED_MODULE_14__src_symbol_triangle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_symbol_wye__ = __webpack_require__(371);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolWye", function() { return __WEBPACK_IMPORTED_MODULE_15__src_symbol_wye__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_curve_basisClosed__ = __webpack_require__(841);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveBasisClosed", function() { return __WEBPACK_IMPORTED_MODULE_16__src_curve_basisClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_curve_basisOpen__ = __webpack_require__(842);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveBasisOpen", function() { return __WEBPACK_IMPORTED_MODULE_17__src_curve_basisOpen__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_curve_basis__ = __webpack_require__(133);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveBasis", function() { return __WEBPACK_IMPORTED_MODULE_18__src_curve_basis__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_curve_bundle__ = __webpack_require__(843);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveBundle", function() { return __WEBPACK_IMPORTED_MODULE_19__src_curve_bundle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_curve_cardinalClosed__ = __webpack_require__(360);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCardinalClosed", function() { return __WEBPACK_IMPORTED_MODULE_20__src_curve_cardinalClosed__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_curve_cardinalOpen__ = __webpack_require__(361);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCardinalOpen", function() { return __WEBPACK_IMPORTED_MODULE_21__src_curve_cardinalOpen__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_curve_cardinal__ = __webpack_require__(134);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCardinal", function() { return __WEBPACK_IMPORTED_MODULE_22__src_curve_cardinal__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_curve_catmullRomClosed__ = __webpack_require__(844);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCatmullRomClosed", function() { return __WEBPACK_IMPORTED_MODULE_23__src_curve_catmullRomClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_curve_catmullRomOpen__ = __webpack_require__(845);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCatmullRomOpen", function() { return __WEBPACK_IMPORTED_MODULE_24__src_curve_catmullRomOpen__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__src_curve_catmullRom__ = __webpack_require__(203);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCatmullRom", function() { return __WEBPACK_IMPORTED_MODULE_25__src_curve_catmullRom__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__src_curve_linearClosed__ = __webpack_require__(846);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveLinearClosed", function() { return __WEBPACK_IMPORTED_MODULE_26__src_curve_linearClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__src_curve_linear__ = __webpack_require__(135);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveLinear", function() { return __WEBPACK_IMPORTED_MODULE_27__src_curve_linear__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__src_curve_monotone__ = __webpack_require__(847);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveMonotoneX", function() { return __WEBPACK_IMPORTED_MODULE_28__src_curve_monotone__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveMonotoneY", function() { return __WEBPACK_IMPORTED_MODULE_28__src_curve_monotone__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__src_curve_natural__ = __webpack_require__(848);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveNatural", function() { return __WEBPACK_IMPORTED_MODULE_29__src_curve_natural__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__src_curve_step__ = __webpack_require__(849);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveStep", function() { return __WEBPACK_IMPORTED_MODULE_30__src_curve_step__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveStepAfter", function() { return __WEBPACK_IMPORTED_MODULE_30__src_curve_step__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveStepBefore", function() { return __WEBPACK_IMPORTED_MODULE_30__src_curve_step__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__src_stack__ = __webpack_require__(861);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stack", function() { return __WEBPACK_IMPORTED_MODULE_31__src_stack__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__src_offset_expand__ = __webpack_require__(854);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOffsetExpand", function() { return __WEBPACK_IMPORTED_MODULE_32__src_offset_expand__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__src_offset_diverging__ = __webpack_require__(853);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOffsetDiverging", function() { return __WEBPACK_IMPORTED_MODULE_33__src_offset_diverging__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__src_offset_none__ = __webpack_require__(101);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOffsetNone", function() { return __WEBPACK_IMPORTED_MODULE_34__src_offset_none__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__src_offset_silhouette__ = __webpack_require__(855);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOffsetSilhouette", function() { return __WEBPACK_IMPORTED_MODULE_35__src_offset_silhouette__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__src_offset_wiggle__ = __webpack_require__(856);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOffsetWiggle", function() { return __WEBPACK_IMPORTED_MODULE_36__src_offset_wiggle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__src_order_ascending__ = __webpack_require__(205);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderAscending", function() { return __WEBPACK_IMPORTED_MODULE_37__src_order_ascending__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__src_order_descending__ = __webpack_require__(857);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderDescending", function() { return __WEBPACK_IMPORTED_MODULE_38__src_order_descending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__src_order_insideOut__ = __webpack_require__(858);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderInsideOut", function() { return __WEBPACK_IMPORTED_MODULE_39__src_order_insideOut__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__src_order_none__ = __webpack_require__(102);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderNone", function() { return __WEBPACK_IMPORTED_MODULE_40__src_order_none__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__src_order_reverse__ = __webpack_require__(859);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderReverse", function() { return __WEBPACK_IMPORTED_MODULE_41__src_order_reverse__["a"]; });




 // Note: radialArea is deprecated!
 // Note: radialLine is deprecated!









































/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = point;
/* harmony export (immutable) */ __webpack_exports__["a"] = Basis;
function point(that, x, y) {
  that._context.bezierCurveTo(
    (2 * that._x0 + that._x1) / 3,
    (2 * that._y0 + that._y1) / 3,
    (that._x0 + 2 * that._x1) / 3,
    (that._y0 + 2 * that._y1) / 3,
    (that._x0 + 4 * that._x1 + x) / 6,
    (that._y0 + 4 * that._y1 + y) / 6
  );
}

function Basis(context) {
  this._context = context;
}

Basis.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3: point(this, this._x1, this._y1); // proceed
      case 2: this._context.lineTo(this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
      default: point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["c"] = (function(context) {
  return new Basis(context);
});


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = point;
/* harmony export (immutable) */ __webpack_exports__["a"] = Cardinal;
function point(that, x, y) {
  that._context.bezierCurveTo(
    that._x1 + that._k * (that._x2 - that._x0),
    that._y1 + that._k * (that._y2 - that._y0),
    that._x2 + that._k * (that._x1 - x),
    that._y2 + that._k * (that._y1 - y),
    that._x2,
    that._y2
  );
}

function Cardinal(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

Cardinal.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: point(this, this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
      case 2: this._point = 3; // proceed
      default: point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["c"] = ((function custom(tension) {

  function cardinal(context) {
    return new Cardinal(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function Linear(context) {
  this._context = context;
}

Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: this._context.lineTo(x, y); break;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Linear(context);
});


/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {});


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
module.exports = exports['default'];

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(980),
    listCacheDelete = __webpack_require__(981),
    listCacheGet = __webpack_require__(982),
    listCacheHas = __webpack_require__(983),
    listCacheSet = __webpack_require__(984);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(143);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(978);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(60);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(224);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 143 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(406),
    isLength = __webpack_require__(223);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 145 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(953),
    keys = __webpack_require__(108);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(10);

var EventPluginRegistry = __webpack_require__(228);
var ReactEventEmitterMixin = __webpack_require__(1057);
var ViewportMetrics = __webpack_require__(541);

var getVendorPrefixedEventName = __webpack_require__(1089);
var isEventSupported = __webpack_require__(239);

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var hasEventPageXY;
var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {

  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === 'topWheel') {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === 'topScroll') {

          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === 'topFocus' || dependency === 'topBlur') {

          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening.topBlur = true;
          isListening.topFocus = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Protect against document.createEvent() returning null
   * Some popup blocker extensions appear to do this:
   * https://github.com/facebook/react/issues/6887
   */
  supportsEventPageXY: function () {
    if (!document.createEvent) {
      return false;
    }
    var ev = document.createEvent('MouseEvent');
    return ev != null && 'pageX' in ev;
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
   * pageX/pageY isn't supported (legacy browsers).
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (hasEventPageXY === undefined) {
      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
    }
    if (!hasEventPageXY && !isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  }

});

module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(113);
var ViewportMetrics = __webpack_require__(541);

var getEventModifierState = __webpack_require__(237);

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(7);

var invariant = __webpack_require__(4);

var OBSERVED_ERROR = {};

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var TransactionImpl = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

module.exports = TransactionImpl;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * Based on the escape-html library, which is used under the MIT License below:
 *
 * Copyright (c) 2012-2013 TJ Holowaychuk
 * Copyright (c) 2015 Andreas Lubbe
 * Copyright (c) 2015 Tiancheng "Timothy" Gu
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */



// code copied and modified from escape-html
/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
// end code copied and modified from escape-html


/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  if (typeof text === 'boolean' || typeof text === 'number') {
    // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return '' + text;
  }
  return escapeHtml(text);
}

module.exports = escapeTextContentForBrowser;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(26);
var DOMNamespaces = __webpack_require__(227);

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

var createMicrosoftUnsafeLocalFunction = __webpack_require__(235);

// SVG temp container for IE lacking innerHTML
var reusableSVGContainer;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  // IE does not have innerHTML for SVG nodes, so instead we inject the
  // new markup in a temp node and then move the child nodes across into
  // the target node
  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
    var svgNode = reusableSVGContainer.firstChild;
    while (svgNode.firstChild) {
      node.appendChild(svgNode.firstChild);
    }
  } else {
    node.innerHTML = html;
  }
});

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xFEFF) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
  testElement = null;
}

module.exports = setInnerHTML;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(12), __webpack_require__(20), __webpack_require__(16), __webpack_require__(556), __webpack_require__(46), __webpack_require__(62)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('react-prop-types/lib/deprecated'), require('../utils/PropTypes/controlled'), require('../utils/getField'), require('./contextTypes'), require('../Papers/Paper'), require('../Helpers/Collapse'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.deprecated, global.controlled, global.getField, global.contextTypes, global.Paper, global.Collapse);
    global.Card = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _deprecated, _controlled, _getField, _contextTypes, _Paper, _Collapse) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _deprecated2 = _interopRequireDefault(_deprecated);

  var _controlled2 = _interopRequireDefault(_controlled);

  var _getField2 = _interopRequireDefault(_getField);

  var _contextTypes2 = _interopRequireDefault(_contextTypes);

  var _Paper2 = _interopRequireDefault(_Paper);

  var _Collapse2 = _interopRequireDefault(_Collapse);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Card = function (_PureComponent) {
    _inherits(Card, _PureComponent);

    function Card(props) {
      _classCallCheck(this, Card);

      var _this = _possibleConstructorReturn(this, (Card.__proto__ || Object.getPrototypeOf(Card)).call(this, props));

      _this.state = {
        zDepth: 1,
        expanded: typeof props.initiallyExpanded !== 'undefined' ? props.initiallyExpanded : !!props.defaultExpanded
      };
      _this._handleMouseOver = _this._handleMouseOver.bind(_this);
      _this._handleMouseLeave = _this._handleMouseLeave.bind(_this);
      _this._handleExpandClick = _this._handleExpandClick.bind(_this);
      _this._handleTouchStart = _this._handleTouchStart.bind(_this);
      return _this;
    }

    _createClass(Card, [{
      key: 'getChildContext',
      value: function getChildContext() {
        var _props = this.props,
            iconClassName = _props.iconClassName,
            iconChildren = _props.iconChildren,
            expanderTooltipLabel = _props.expanderTooltipLabel,
            expanderTooltipDelay = _props.expanderTooltipDelay,
            expanderTooltipPosition = _props.expanderTooltipPosition,
            expanderIconClassName = _props.expanderIconClassName,
            expanderIconChildren = _props.expanderIconChildren;


        var expanded = typeof this.props.isExpanded !== 'undefined' ? this.props.isExpanded : (0, _getField2.default)(this.props, this.state, 'expanded');

        return {
          expanded: expanded,
          onExpandClick: this._handleExpandClick,
          iconClassName: typeof iconClassName !== 'undefined' ? iconClassName : expanderIconClassName,
          iconChildren: typeof iconChildren !== 'undefined' ? iconChildren : expanderIconChildren,
          tooltipLabel: expanderTooltipLabel,
          tooltipDelay: expanderTooltipDelay,
          tooltipPosition: expanderTooltipPosition
        };
      }
    }, {
      key: '_handleMouseOver',
      value: function _handleMouseOver(e) {
        if (this.props.onMouseOver) {
          this.props.onMouseOver(e);
        }

        if (this.props.raise && !this._touched) {
          this.setState({ zDepth: 4 });
        }
      }
    }, {
      key: '_handleMouseLeave',
      value: function _handleMouseLeave(e) {
        if (this.props.onMouseLeave) {
          this.props.onMouseLeave(e);
        }

        this._touched = false;
        if (this.props.raise && this.state.zDepth !== 1) {
          this.setState({ zDepth: 1 });
        }
      }
    }, {
      key: '_handleTouchStart',
      value: function _handleTouchStart(e) {
        if (this.props.onTouchStart) {
          this.props.onTouchStart(e);
        }

        this._touched = true;
      }
    }, {
      key: '_handleExpandClick',
      value: function _handleExpandClick(e) {
        var onExpanderClick = this.props.onExpanderClick;

        var expanded = !(0, _getField2.default)(this.props, this.state, 'expanded');
        if (onExpanderClick) {
          onExpanderClick(expanded, e);
        }

        if (typeof this.props.expanded === 'undefined') {
          this.setState({ expanded: expanded });
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var zDepth = this.state.zDepth;

        var _props2 = this.props,
            className = _props2.className,
            raise = _props2.raise,
            tableCard = _props2.tableCard,
            children = _props2.children,
            props = _objectWithoutProperties(_props2, ['className', 'raise', 'tableCard', 'children']);

        delete props.expanded;
        delete props.isExpanded;
        delete props.onExpanderClick;
        delete props.initiallyExpanded;
        delete props.defaultExpanded;
        delete props.iconChildren;
        delete props.iconClassName;
        delete props.expanderIconChildren;
        delete props.expanderIconClassName;
        delete props.expanderTooltipLabel;
        delete props.expanderTooltipDelay;
        delete props.expanderTooltipPosition;

        var expanded = typeof this.props.isExpanded !== 'undefined' ? this.props.isExpanded : (0, _getField2.default)(this.props, this.state, 'expanded');
        var expanderIndex = -1;
        var parts = _react.Children.map(_react.Children.toArray(children), function (child, i) {
          if (!child || !child.props) {
            return child;
          } else if (expanderIndex < 0 && (child.props.isExpander || child.props.expander)) {
            expanderIndex = i;
          }

          if (!child.props.expandable) {
            return child;
          }

          var collapsed = expanderIndex === -1 || expanderIndex === i || !expanded;
          return _react2.default.createElement(
            _Collapse2.default,
            { collapsed: collapsed },
            child
          );
        });

        return _react2.default.createElement(
          _Paper2.default,
          _extends({}, props, {
            zDepth: zDepth,
            className: (0, _classnames2.default)('md-card', {
              'md-card--raise': raise,
              'md-card--table': tableCard
            }, 'md-background--card', className),
            onMouseOver: this._handleMouseOver,
            onMouseLeave: this._handleMouseLeave,
            onTouchStart: this._handleTouchStart
          }),
          parts
        );
      }
    }]);

    return Card;
  }(_react.PureComponent);

  Card.propTypes = {
    /**
     * An optional style to apply.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply to the card.
     */
    className: _propTypes2.default.string,

    /**
     * Any Card parts that should be rendered.
     */
    children: _propTypes2.default.node,

    /**
     * Boolean if the card is expanded by default when there is an expander
     * component.
     */
    defaultExpanded: _propTypes2.default.bool,

    /**
     * Boolean if the card should raise on hover when on a desktop display.
     */
    raise: _propTypes2.default.bool,

    /**
     * Boolean if the card is currently expanded. This will require the `onExpanderClick` function
     * to toggle the state. The card will become controlled if this is not `undefined`.
     */
    expanded: (0, _controlled2.default)(_propTypes2.default.bool, 'onExpanderClick', 'defaultExpanded'),

    /**
     * An optional function to call when the expander is clicked.
     */
    onExpanderClick: _propTypes2.default.func,

    /**
     * The icon className to use for the expander icon.
     */
    expanderIconClassName: _propTypes2.default.string,

    /**
     * Any icon children required for the expander icon.
     */
    expanderIconChildren: _propTypes2.default.node,

    /**
     * The tooltip position for the expander icon.
     */
    expanderTooltipPosition: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),

    /**
     * The optional tooltip to display for the expander icon.
     */
    expanderTooltipLabel: _propTypes2.default.node,

    /**
     * An optional delay before the tooltip appears for the expander icon on hover.
     */
    expanderTooltipDelay: _propTypes2.default.number,

    /**
     * Boolean if the card contains a table. It will update the styling accordingly.
     * When using the `DataTable` component, do not wrap it in a `CardText` component.
     *
     * ```js
     * <Card tableCard={true}>
     *   <CardTitle title="Example />
     *   <DataTable>
     *     ...
     *   </DataTable>
     * </Card>
     * ```
     */
    tableCard: _propTypes2.default.bool,

    /**
     * An optional function to call when the mouseover event is triggered.
     */
    onMouseOver: _propTypes2.default.func,

    /**
     * An optional function to call when the mouseleave event is triggered.
     */
    onMouseLeave: _propTypes2.default.func,

    /**
     * An optional function to call when the touchstart event is triggered.
     */
    onTouchStart: _propTypes2.default.func,
    initiallyExpanded: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `defaultExpanded` instead'),
    isExpanded: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `expanded` instead'),
    iconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `expanderIconChildren` prop instead'),
    iconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `expanderIconClassName` prop instead')
  };
  Card.defaultProps = {
    expanderIconChildren: 'keyboard_arrow_down',
    expanderIconClassName: 'material-icons',
    expanderTooltipPosition: 'left'
  };
  Card.childContextTypes = _contextTypes2.default;
  exports.default = Card;
});

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('prop-types'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.propTypes);
    global.contextTypes = mod.exports;
  }
})(this, function (exports, _propTypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = {
    uncheckedIconClassName: _propTypes2.default.string.isRequired,
    uncheckedIconChildren: _propTypes2.default.node,
    checkedIconClassName: _propTypes2.default.string.isRequired,
    checkedIconChildren: _propTypes2.default.node,
    plain: _propTypes2.default.bool,
    allSelected: _propTypes2.default.bool.isRequired,
    selectedRows: _propTypes2.default.arrayOf(_propTypes2.default.bool).isRequired,
    createCheckbox: _propTypes2.default.func.isRequired,
    removeCheckbox: _propTypes2.default.func.isRequired,
    toggleAllRows: _propTypes2.default.func.isRequired,
    toggleSelectedRow: _propTypes2.default.func.isRequired,
    baseId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    baseName: _propTypes2.default.string
  };
});

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.findTable = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = findTable;
  /**
   * Attempts fo find the base table component from an element in the table.
   * This will either be the wrapper for responsive data tables, or the table element.
   *
   * @param {Object} el - The element to traverse from
   * @param {Object} the table or null.
   */
  function findTable(el) {
    var table = void 0;
    var node = el;
    while (node && node.parentNode) {
      if (node.classList && node.classList.contains('md-data-table')) {
        // Attempt to check one more element up to see if there is a table-container
        // for responsive tables.
        table = node;
      } else if (node.classList && node.classList.contains('md-data-table--responsive')) {
        return node;
      } else if (table) {
        return table;
      }

      node = node.parentNode;
    }

    return null;
  }
});

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(9), __webpack_require__(3), __webpack_require__(14), __webpack_require__(118)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('react-dom'), require('classnames'), require('../constants/keyCodes'), require('../utils/EventUtils/handleKeyboardAccessibility'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.reactDom, global.classnames, global.keyCodes, global.handleKeyboardAccessibility);
    global.AccessibleFakeButton = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _reactDom, _classnames, _keyCodes, _handleKeyboardAccessibility) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _handleKeyboardAccessibility2 = _interopRequireDefault(_handleKeyboardAccessibility);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var AccessibleFakeButton = function (_PureComponent) {
    _inherits(AccessibleFakeButton, _PureComponent);

    function AccessibleFakeButton(props) {
      _classCallCheck(this, AccessibleFakeButton);

      var _this = _possibleConstructorReturn(this, (AccessibleFakeButton.__proto__ || Object.getPrototypeOf(AccessibleFakeButton)).call(this, props));

      _this.state = { pressed: false, tabFocused: false };
      _this._handleKeyUp = _this._handleKeyUp.bind(_this);
      _this._handleBlur = _this._handleBlur.bind(_this);
      _this._setNode = _this._setNode.bind(_this);
      _this._handleClick = _this._handleClick.bind(_this);
      _this._handleKeyDown = _this._handleKeyDown.bind(_this);
      return _this;
    }

    /**
     * Focuses the button.
     */


    _createClass(AccessibleFakeButton, [{
      key: 'focus',
      value: function focus() {
        if (this._node) {
          this._node.focus();
        }
      }
    }, {
      key: 'blur',
      value: function blur() {
        if (this._node) {
          this._node.blur();
        }
      }
    }, {
      key: '_setNode',
      value: function _setNode(node) {
        if (node) {
          this._node = (0, _reactDom.findDOMNode)(node);
        }
      }
    }, {
      key: '_handleClick',
      value: function _handleClick(e) {
        if (this.props.disabled) {
          return;
        }

        if (this.props.onClick) {
          this.props.onClick(e);
        }

        this._node.focus();
        this.setState({ pressed: !this.state.pressed });
      }
    }, {
      key: '_handleKeyDown',
      value: function _handleKeyDown(e) {
        var _props = this.props,
            disabled = _props.disabled,
            onKeyDown = _props.onKeyDown,
            listenToEnter = _props.listenToEnter,
            listenToSpace = _props.listenToSpace;

        if (disabled) {
          return;
        }

        if (onKeyDown) {
          onKeyDown(e);
        }

        (0, _handleKeyboardAccessibility2.default)(e, this._handleClick, listenToEnter, listenToSpace);
      }
    }, {
      key: '_handleKeyUp',
      value: function _handleKeyUp(e) {
        var _props2 = this.props,
            onKeyUp = _props2.onKeyUp,
            onTabFocus = _props2.onTabFocus;

        if (onKeyUp) {
          onKeyUp(e);
        }

        if ((e.which || e.keyCode) === _keyCodes.TAB) {
          if (onTabFocus) {
            onTabFocus(e);
          }

          this.setState({ tabFocused: true });
        }
      }
    }, {
      key: '_handleBlur',
      value: function _handleBlur(e) {
        if (this.props.onBlur) {
          this.props.onBlur(e);
        }

        if (this.state.tabFocused) {
          this.setState({ tabFocused: false });
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _props3 = this.props,
            Component = _props3.component,
            children = _props3.children,
            className = _props3.className,
            tabbedClassName = _props3.tabbedClassName,
            disabled = _props3.disabled,
            tabIndex = _props3.tabIndex,
            ink = _props3.ink,
            props = _objectWithoutProperties(_props3, ['component', 'children', 'className', 'tabbedClassName', 'disabled', 'tabIndex', 'ink']);

        delete props.onBlur;
        delete props.onClick;
        delete props.onKeyUp;
        delete props.onKeyDown;
        delete props.onTabFocus;
        delete props.listenToEnter;
        delete props.listenToSpace;

        var childElements = children;
        if (ink) {
          childElements = _react.Children.toArray(children);
          childElements.unshift(ink);
        }

        return _react2.default.createElement(
          Component,
          _extends({}, props, {
            ref: this._setNode,
            className: (0, _classnames2.default)('md-fake-btn', _defineProperty({
              'md-pointer--hover': !disabled
            }, tabbedClassName, tabbedClassName && this.state.tabFocused), className),
            disabled: disabled,
            tabIndex: disabled ? null : tabIndex,
            onBlur: this._handleBlur,
            onClick: this._handleClick,
            onKeyUp: this._handleKeyUp,
            onKeyDown: this._handleKeyDown,
            'aria-pressed': this.state.pressed
          }),
          childElements
        );
      }
    }]);

    return AccessibleFakeButton;
  }(_react.PureComponent);

  AccessibleFakeButton.propTypes = {
    /**
     * An optional style to apply.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply.
     */
    className: _propTypes2.default.string,

    /**
     * An optional function to call only when the button has been focused with the tab key.
     */
    tabbedClassName: _propTypes2.default.string,

    /**
     * Any children to display in the Accessible Fake Button.
     */
    children: _propTypes2.default.node,

    /**
     * An optional onClick function to call whent he user clicks the
     * button or presses space || enter.
     */
    onClick: _propTypes2.default.func,

    /**
     * An optional onKeyDown function to call.
     */
    onKeyDown: _propTypes2.default.func,

    /**
     * An optional onBlur function to call.
     */
    onBlur: _propTypes2.default.func,

    /**
     * An optional onKeyUp function to call.
     */
    onKeyUp: _propTypes2.default.func,

    /**
     * An optional function to call when the element is focused with the tab key.
     */
    onTabFocus: _propTypes2.default.func,

    /**
     * The component to render the Fake button as.
     */
    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,

    /**
     * The tab index to use for the Fake button so it is keyboard focusable.
     */
    tabIndex: _propTypes2.default.number,

    /**
     * Boolean if the Button is disabled. This will prevent tab focus.
     */
    disabled: _propTypes2.default.bool,

    /**
     * The role for the accessible fake button. It is recommended to keep it
     * the default of `button` unless you are rendering it as an `a` tag.
     */
    role: _propTypes2.default.string,

    /**
     * The ink when coming from the AccessibleFakeInkedButton
     * @access private
     */
    ink: _propTypes2.default.node,

    /**
     * Boolean if the spacebar should be used to trigger the click event. This _should_ be `true`
     * is almost all cases.
     */
    listenToSpace: _propTypes2.default.bool,

    /**
     * Boolean if the enter key should be used to trigger the click event. This _should_ be `true`
     * in most cases. By default, the param will be ignored if the `role` attribute is for a `checkbox`
     * or `radio`. When it is a checkbox or radio, it will attempt to submit the form on the enter
     * keypress instead like the native elements.
     */
    listenToEnter: _propTypes2.default.bool
  };
  AccessibleFakeButton.defaultProps = {
    component: 'div',
    tabIndex: 0,
    role: 'button',
    listenToEnter: true,
    listenToSpace: true
  };
  exports.default = AccessibleFakeButton;
});

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.Positions = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = {
    TOP_RIGHT: 'tr',
    TOP_LEFT: 'tl',
    BOTTOM_RIGHT: 'br',
    BOTTOM_LEFT: 'bl',
    CONTEXT: 'context',
    BELOW: 'below'
  };
});

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(591), __webpack_require__(1184)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('../utils/StringUtils/getDisplayName'), require('./TooltipContainer'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.getDisplayName, global.TooltipContainer);
    global.injectTooltip = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _getDisplayName, _TooltipContainer) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

  var _TooltipContainer2 = _interopRequireDefault(_TooltipContainer);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  exports.default = function (ComposedComponent) {
    var _class, _temp;

    return _temp = _class = function (_PureComponent) {
      _inherits(TooltipedComponent, _PureComponent);

      function TooltipedComponent(props) {
        _classCallCheck(this, TooltipedComponent);

        var _this = _possibleConstructorReturn(this, (TooltipedComponent.__proto__ || Object.getPrototypeOf(TooltipedComponent)).call(this, props));

        _this._composed = null;

        _this.getComposedComponent = _this.getComposedComponent.bind(_this);
        _this._setComposedComponent = _this._setComposedComponent.bind(_this);
        return _this;
      }

      /**
       * Gets the composed component as a ref. This is usefull if you need to access the ref of the
       * composed component instead of the `injectTooltip` HOC to use some publically accessible methods.
       *
       * ```js
       * <SomeInkedComponent
       *   ref={tooltipHOC => {
       *     tooltipHOC.getComposedComponent().focus();
       *   }}
       * />
       * ```
       *
       * > NOTE: This can be `null`, so make sure to do a null check before using..
       */


      _createClass(TooltipedComponent, [{
        key: 'getComposedComponent',
        value: function getComposedComponent() {
          return this._composed;
        }
      }, {
        key: '_setComposedComponent',
        value: function _setComposedComponent(component) {
          this._composed = component;
        }
      }, {
        key: 'render',
        value: function render() {
          var _props = this.props,
              tooltipLabel = _props.tooltipLabel,
              tooltipDelay = _props.tooltipDelay,
              tooltipPosition = _props.tooltipPosition,
              tooltipStyle = _props.tooltipStyle,
              tooltipClassName = _props.tooltipClassName,
              tooltipContainerStyle = _props.tooltipContainerStyle,
              tooltipContainerClassName = _props.tooltipContainerClassName,
              tooltipTransitionEnterTimeout = _props.tooltipTransitionEnterTimeout,
              tooltipTransitionLeaveTimeout = _props.tooltipTransitionLeaveTimeout,
              props = _objectWithoutProperties(_props, ['tooltipLabel', 'tooltipDelay', 'tooltipPosition', 'tooltipStyle', 'tooltipClassName', 'tooltipContainerStyle', 'tooltipContainerClassName', 'tooltipTransitionEnterTimeout', 'tooltipTransitionLeaveTimeout']);

          if (tooltipLabel) {
            props.tooltip = _react2.default.createElement(_TooltipContainer2.default, {
              key: 'tooltipContainer',
              label: tooltipLabel,
              delay: tooltipDelay,
              position: tooltipPosition,
              enterTimeout: tooltipTransitionEnterTimeout,
              leaveTimeout: tooltipTransitionLeaveTimeout,
              style: tooltipContainerStyle,
              className: tooltipContainerClassName,
              tooltipStyle: tooltipStyle,
              tooltipClassName: tooltipClassName
            });
          }

          props.ref = this._setComposedComponent;

          return _react2.default.createElement(ComposedComponent, props);
        }
      }]);

      return TooltipedComponent;
    }(_react.PureComponent), _class.displayName = (0, _getDisplayName2.default)(ComposedComponent, 'Tooltiped'), _class.propTypes = {
      /**
       * An optional style to apply to the tooltip container.
       */
      tooltipContainerStyle: _propTypes2.default.object,

      /**
       * An optional className to apply to the tooltip container.
       */
      tooltipContainerClassName: _propTypes2.default.string,

      /**
       * An optional style to apply to the tooltip itself.
       */
      tooltipStyle: _propTypes2.default.object,

      /**
       * An optional className to the tooltip itself.
       */
      tooltipClassName: _propTypes2.default.string,

      /**
       * The tooltip to display. If omitted, the `tooltip` prop will not be injected.
       */
      tooltipLabel: _propTypes2.default.node,

      /**
       * The amount of delay before the tooltip will appear on hover, touch, or keyboard focus.
       */
      tooltipDelay: _propTypes2.default.number.isRequired,

      /**
       * The position that the tooltip should appear related to the composed compoennt.
       */
      tooltipPosition: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']).isRequired,

      /**
       * The transition time for the tooltip appearing.
       */
      tooltipTransitionEnterTimeout: _propTypes2.default.number.isRequired,

      /**
       * The transition time for the tooltip disappearing.
       */
      tooltipTransitionLeaveTimeout: _propTypes2.default.number.isRequired
    }, _class.defaultProps = {
      tooltipDelay: 0,
      tooltipPosition: 'bottom',
      tooltipTransitionEnterTimeout: 150,
      tooltipTransitionLeaveTimeout: 150
    }, _temp;
  };
});

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}



exports.__esModule = true;
exports['default'] = stripStyle;

function stripStyle(style) {
  var ret = {};
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }
    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}



exports.__esModule = true;
exports['default'] = stripStyle;

function stripStyle(style) {
  var ret = {};
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }
    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__abstract_series__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__animation__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_series_utils__ = __webpack_require__(23);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.






var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--label';

var LabelSeries = function (_AbstractSeries) {
  _inherits(LabelSeries, _AbstractSeries);

  function LabelSeries() {
    _classCallCheck(this, LabelSeries);

    return _possibleConstructorReturn(this, (LabelSeries.__proto__ || Object.getPrototypeOf(LabelSeries)).apply(this, arguments));
  }

  _createClass(LabelSeries, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          animation = _props.animation,
          allowOffsetToBeReversed = _props.allowOffsetToBeReversed,
          className = _props.className,
          data = _props.data,
          marginLeft = _props.marginLeft,
          marginTop = _props.marginTop,
          rotation = _props.rotation,
          xRange = _props.xRange,
          yRange = _props.yRange;


      if (!data) {
        return null;
      }

      if (animation) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__animation__["b" /* default */],
          _extends({}, this.props, { animatedProps: __WEBPACK_IMPORTED_MODULE_4__utils_series_utils__["e" /* ANIMATED_SERIES_PROPS */] }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabelSeries, _extends({}, this.props, { animation: null }))
        );
      }

      var xFunctor = this._getAttributeFunctor('x');
      var yFunctor = this._getAttributeFunctor('y');

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        { className: predefinedClassName + ' ' + className,
          ref: 'container',
          transform: 'translate(' + marginLeft + ',' + marginTop + ')' },
        data.reduce(function (res, d, i) {
          var label = d.label,
              style = d.style,
              xOffset = d.xOffset,
              yOffset = d.yOffset;

          if (!label) {
            return res;
          }
          var xVal = xFunctor(d);
          var yVal = yFunctor(d);
          var leftOfMiddle = xVal < (xRange[1] - xRange[0]) / 2;
          var aboveMiddle = yVal < Math.abs(yRange[1] - yRange[0]) / 2;

          var x = xVal + (allowOffsetToBeReversed && leftOfMiddle ? -1 : 1) * (xOffset || 0);
          var y = yVal + (allowOffsetToBeReversed && aboveMiddle ? -1 : 1) * (yOffset || 0);
          var attrs = _extends({
            alignmentBaseline: aboveMiddle ? 'text-before-edge' : 'text-after-edge',
            className: 'rv-xy-plot__series--label-text',
            key: i,
            onClick: function onClick(e) {
              return _this2._valueClickHandler(d, e);
            },
            onMouseOver: function onMouseOver(e) {
              return _this2._valueMouseOverHandler(d, e);
            },
            onMouseOut: function onMouseOut(e) {
              return _this2._valueMouseOutHandler(d, e);
            },
            textAnchor: leftOfMiddle ? 'start' : 'end',
            x: x,
            y: y,
            transform: 'rotate(' + (d.rotation || rotation) + ',' + x + ',' + y + ')'
          }, style);
          return res.concat([__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'text',
            attrs,
            label
          )]);
        }, [])
      );
    }
  }]);

  return LabelSeries;
}(__WEBPACK_IMPORTED_MODULE_2__abstract_series__["a" /* default */]);

LabelSeries.propTypes = {
  animation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  allowOffsetToBeReversed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    angle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    radius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    xOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    yOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  })).isRequired,
  marginLeft: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  marginTop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  rotation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  xRange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number),
  yRange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number)
};
LabelSeries.defaultProps = {
  animation: false,
  rotation: 0
};
LabelSeries.displayName = 'LabelSeries';
/* harmony default export */ __webpack_exports__["a"] = (LabelSeries);

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_deep_equal__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_deep_equal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_deep_equal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_series_utils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_chart_utils__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__animation__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__theme__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__series_canvas_wrapper__ = __webpack_require__(1275);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.













var ATTRIBUTES = ['x', 'y', 'radius', 'angle', 'color', 'fill', 'stroke', 'opacity', 'size'];

var OPTIONAL_SCALE_PROPS = ['Padding'];

var DEFAULT_MARGINS = {
  left: 40,
  right: 10,
  top: 10,
  bottom: 40
};

/**
 * Remove parents from tree formatted data. deep-equal doesnt play nice with data
 * that has circular structures, so we make every node single directional by pruning the parents.
 * @param {Array} data - the data object to have circular deps resolved in
 * @returns {Array} the sanitized data
 */
function cleanseData(data) {
  return data.map(function (series) {
    if (!Array.isArray(series)) {
      return series;
    }
    return series.map(function (row) {
      return _extends({}, row, { parent: null });
    });
  });
}

/**
 * Wrapper on the deep-equal method for checking equality of next props vs current props
 * @param {Object} scaleMixins - Scale object.
 * @param {Object} nextScaleMixins - Scale object.
 * @returns {Boolean} whether or not the two mixins objects are equal
 */
function checkIfMixinsAreEqual(nextScaleMixins, scaleMixins) {
  var newMixins = _extends({}, nextScaleMixins, {
    _allData: cleanseData(nextScaleMixins._allData)
  });
  var oldMixins = _extends({}, scaleMixins, {
    _allData: cleanseData(scaleMixins._allData)
  });
  // it's hard to say if this function is reasonable?
  return __WEBPACK_IMPORTED_MODULE_2_deep_equal___default()(newMixins, oldMixins);
}

var XYPlot = function (_React$Component) {
  _inherits(XYPlot, _React$Component);

  _createClass(XYPlot, null, [{
    key: 'propTypes',
    get: function get() {
      return {
        animation: __WEBPACK_IMPORTED_MODULE_6__animation__["a" /* AnimationPropType */],
        className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        dontCheckIfEmpty: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
        height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
        margin: __WEBPACK_IMPORTED_MODULE_5__utils_chart_utils__["b" /* MarginPropType */],
        onMouseDown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
        onMouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
        onMouseLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
        onMouseMove: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
        stackBy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(ATTRIBUTES),
        style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
        width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
      };
    }
  }, {
    key: 'defaultProps',
    get: function get() {
      return {
        className: ''
      };
    }
  }]);

  function XYPlot(props) {
    _classCallCheck(this, XYPlot);

    var _this = _possibleConstructorReturn(this, (XYPlot.__proto__ || Object.getPrototypeOf(XYPlot)).call(this, props));

    _this._mouseDownHandler = _this._mouseDownHandler.bind(_this);
    _this._mouseLeaveHandler = _this._mouseLeaveHandler.bind(_this);
    _this._mouseEnterHandler = _this._mouseEnterHandler.bind(_this);
    _this._mouseMoveHandler = _this._mouseMoveHandler.bind(_this);
    var stackBy = props.stackBy;

    var children = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_series_utils__["b" /* getSeriesChildren */])(props.children);
    var data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_series_utils__["c" /* getStackedData */])(children, stackBy);
    _this.state = {
      scaleMixins: _this._getScaleMixins(data, props),
      data: data
    };
    return _this;
  }

  _createClass(XYPlot, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var children = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_series_utils__["b" /* getSeriesChildren */])(nextProps.children);
      var nextData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_series_utils__["c" /* getStackedData */])(children, nextProps.stackBy);
      var scaleMixins = this.state.scaleMixins;

      var nextScaleMixins = this._getScaleMixins(nextData, nextProps);
      if (!checkIfMixinsAreEqual(nextScaleMixins, scaleMixins)) {
        this.setState({
          scaleMixins: nextScaleMixins,
          data: nextData
        });
      }
    }

    /**
     * Trigger mouse-down related callbacks if they are available.
     * @param {React.SyntheticEvent} event Mouse down event.
     * @private
     */

  }, {
    key: '_mouseDownHandler',
    value: function _mouseDownHandler(event) {
      var _this2 = this;

      var _props = this.props,
          onMouseDown = _props.onMouseDown,
          children = _props.children;

      if (onMouseDown) {
        onMouseDown(event);
      }
      var seriesChildren = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_series_utils__["b" /* getSeriesChildren */])(children);
      seriesChildren.forEach(function (child, index) {
        var component = _this2.refs['series' + index];
        if (component && component.onParentMouseDown) {
          component.onParentMouseDown(event);
        }
      });
    }

    /**
     * Trigger movement-related callbacks if they are available.
     * @param {React.SyntheticEvent} event Mouse move event.
     * @private
     */

  }, {
    key: '_mouseMoveHandler',
    value: function _mouseMoveHandler(event) {
      var _this3 = this;

      var _props2 = this.props,
          onMouseMove = _props2.onMouseMove,
          children = _props2.children;

      if (onMouseMove) {
        onMouseMove(event);
      }
      var seriesChildren = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_series_utils__["b" /* getSeriesChildren */])(children);
      seriesChildren.forEach(function (child, index) {
        var component = _this3.refs['series' + index];
        if (component && component.onParentMouseMove) {
          component.onParentMouseMove(event);
        }
      });
    }

    /**
     * Trigger onMouseLeave handler if it was passed in props.
     * @param {Event} event Native event.
     * @private
     */

  }, {
    key: '_mouseLeaveHandler',
    value: function _mouseLeaveHandler(event) {
      var onMouseLeave = this.props.onMouseLeave;

      if (onMouseLeave) {
        onMouseLeave({ event: event });
      }
    }

    /**
     * Trigger onMouseEnter handler if it was passed in props.
     * @param {Event} event Native event.
     * @private
     */

  }, {
    key: '_mouseEnterHandler',
    value: function _mouseEnterHandler(event) {
      var onMouseEnter = this.props.onMouseEnter;

      if (onMouseEnter) {
        onMouseEnter({ event: event });
      }
    }

    /**
     * Get the list of scale-related settings that should be applied by default.
     * @param {Object} props Object of props.
     * @returns {Object} Defaults.
     * @private
     */

  }, {
    key: '_getDefaultScaleProps',
    value: function _getDefaultScaleProps(props) {
      var _getInnerDimensions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_chart_utils__["c" /* getInnerDimensions */])(props, DEFAULT_MARGINS),
          innerWidth = _getInnerDimensions.innerWidth,
          innerHeight = _getInnerDimensions.innerHeight;

      var colorRanges = ['color', 'fill', 'stroke'].reduce(function (acc, attr) {
        var range = props[attr + 'Type'] === 'category' ? __WEBPACK_IMPORTED_MODULE_7__theme__["f" /* EXTENDED_DISCRETE_COLOR_RANGE */] : __WEBPACK_IMPORTED_MODULE_7__theme__["c" /* CONTINUOUS_COLOR_RANGE */];
        return _extends({}, acc, _defineProperty({}, attr + 'Range', range));
      }, {});

      return _extends({
        xRange: [0, innerWidth],
        yRange: [innerHeight, 0]
      }, colorRanges, {
        opacityType: __WEBPACK_IMPORTED_MODULE_7__theme__["e" /* OPACITY_TYPE */],
        sizeRange: __WEBPACK_IMPORTED_MODULE_7__theme__["g" /* SIZE_RANGE */]
      });
    }

    /**
     * Get the list of optional scale-related settings
     * @param {Object} props Object of props.
     * @returns {Object} Optional Props.
     * @private
     */

  }, {
    key: '_getOptionalScaleProps',
    value: function _getOptionalScaleProps(props) {
      return Object.keys(props).filter(function (prop) {
        return OPTIONAL_SCALE_PROPS.map(function (option) {
          return prop.endsWith(option);
        }).every(function (x) {
          return x;
        });
      }).reduce(function (obj, key) {
        obj[key] = props[key];
        return obj;
      }, {});
    }

    /**
     * Get the map of scales from the props, apply defaults to them and then pass
     * them further.
     * @param {Object} data Array of all data.
     * @param {Object} props Props of the component.
     * @returns {Object} Map of scale-related props.
     * @private
     */

  }, {
    key: '_getScaleMixins',
    value: function _getScaleMixins(data, props) {
      var _ref;

      var filteredData = data.filter(function (d) {
        return d;
      });
      var allData = (_ref = []).concat.apply(_ref, _toConsumableArray(filteredData));

      var defaultScaleProps = this._getDefaultScaleProps(props);
      var optionalScaleProps = this._getOptionalScaleProps(props);
      var userScaleProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["f" /* extractScalePropsFromProps */])(props, ATTRIBUTES);
      var missingScaleProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["b" /* getMissingScaleProps */])(_extends({}, defaultScaleProps, optionalScaleProps, userScaleProps), allData, ATTRIBUTES);
      var children = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_series_utils__["b" /* getSeriesChildren */])(props.children);
      var zeroBaseProps = {};
      var adjustBy = new Set();
      var adjustWhat = new Set();
      children.forEach(function (child, index) {
        if (!child || !data[index]) {
          return;
        }
        ATTRIBUTES.forEach(function (attr) {
          var _child$type$getParent = child.type.getParentConfig(attr, child.props),
              isDomainAdjustmentNeeded = _child$type$getParent.isDomainAdjustmentNeeded,
              zeroBaseValue = _child$type$getParent.zeroBaseValue;

          if (isDomainAdjustmentNeeded) {
            adjustBy.add(attr);
            adjustWhat.add(index);
          }
          if (zeroBaseValue) {
            zeroBaseProps[attr + 'BaseValue'] = 0;
          }
        });
      });
      return _extends({}, defaultScaleProps, zeroBaseProps, userScaleProps, missingScaleProps, {
        _allData: data,
        _adjustBy: Array.from(adjustBy),
        _adjustWhat: Array.from(adjustWhat),
        _stackBy: props.stackBy
      });
    }

    /**
     * Checks if the plot is empty or not.
     * Currently checks the data only.
     * @returns {boolean} True for empty.
     * @private
     */

  }, {
    key: '_isPlotEmpty',
    value: function _isPlotEmpty() {
      var data = this.state.data;

      return !data || !data.length || !data.some(function (series) {
        return series && series.some(function (d) {
          return d;
        });
      });
    }

    /**
     * Prepare the child components (including series) for rendering.
     * @returns {Array} Array of child components.
     * @private
     */

  }, {
    key: '_getClonedChildComponents',
    value: function _getClonedChildComponents() {
      var props = this.props;
      var animation = this.props.animation;
      var _state = this.state,
          scaleMixins = _state.scaleMixins,
          data = _state.data;

      var dimensions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_chart_utils__["c" /* getInnerDimensions */])(this.props, DEFAULT_MARGINS);
      var children = __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.toArray(this.props.children);
      var seriesProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_series_utils__["d" /* getSeriesPropsFromChildren */])(children);
      var XYPlotValues = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["g" /* getXYPlotValues */])(props, children);
      return children.map(function (child, index) {
        var dataProps = null;
        if (seriesProps[index]) {
          // Get the index of the series in the list of props and retrieve
          // the data property from it.
          var seriesIndex = seriesProps[index].seriesIndex;

          dataProps = { data: data[seriesIndex] };
        }

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, _extends({}, dimensions, {
          animation: animation
        }, seriesProps[index], scaleMixins, child.props, XYPlotValues[index], dataProps));
      });
    }
  }, {
    key: 'renderCanvasComponents',
    value: function renderCanvasComponents(components, props) {
      var componentsToRender = components.filter(function (c) {
        return c && !c.type.requiresSVG && c.type.isCanvas;
      });

      if (componentsToRender.length === 0) {
        return null;
      }
      var _componentsToRender$ = componentsToRender[0].props,
          marginLeft = _componentsToRender$.marginLeft,
          marginTop = _componentsToRender$.marginTop,
          marginBottom = _componentsToRender$.marginBottom,
          marginRight = _componentsToRender$.marginRight,
          innerHeight = _componentsToRender$.innerHeight,
          innerWidth = _componentsToRender$.innerWidth;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__series_canvas_wrapper__["a" /* default */],
        {
          marginLeft: marginLeft,
          marginTop: marginTop,
          marginBottom: marginBottom,
          marginRight: marginRight,
          innerHeight: innerHeight,
          innerWidth: innerWidth
        },
        componentsToRender
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          className = _props3.className,
          dontCheckIfEmpty = _props3.dontCheckIfEmpty,
          style = _props3.style,
          width = _props3.width,
          height = _props3.height;


      if (!dontCheckIfEmpty && this._isPlotEmpty()) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
          className: 'rv-xy-plot ' + className,
          style: _extends({
            width: width + 'px',
            height: height + 'px'
          }, this.props.style) });
      }
      var components = this._getClonedChildComponents();

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          style: {
            width: width + 'px',
            height: height + 'px'
          },
          className: 'rv-xy-plot ' + className },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'svg',
          {
            className: 'rv-xy-plot__inner',
            width: width,
            height: height,
            style: style,
            onMouseDown: this._mouseDownHandler,
            onMouseMove: this._mouseMoveHandler,
            onMouseLeave: this._mouseLeaveHandler,
            onMouseEnter: this._mouseEnterHandler },
          components.filter(function (c) {
            return c && c.type.requiresSVG;
          })
        ),
        this.renderCanvasComponents(components, this.props),
        components.filter(function (c) {
          return c && !c.type.requiresSVG && !c.type.isCanvas;
        })
      );
    }
  }]);

  return XYPlot;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

XYPlot.displayName = 'XYPlot';

/* harmony default export */ __webpack_exports__["a"] = (XYPlot);

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getInnerDimensions;
/* harmony export (immutable) */ __webpack_exports__["a"] = getRadialLayoutMargin;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MarginPropType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.



/**
 * Get the dimensions of the component for the future use.
 * @param {Object} props Props.
 * @param {Object} defaultMargins Object with default margins.
 * @returns {Object} Dimensions of the component.
 */
function getInnerDimensions(props, defaultMargins) {
  var margin = props.margin,
      width = props.width,
      height = props.height;

  var marginProps = _extends({}, defaultMargins, typeof margin === 'number' ? {
    left: margin,
    right: margin,
    top: margin,
    bottom: margin
  } : margin);
  var _marginProps$left = marginProps.left,
      marginLeft = _marginProps$left === undefined ? 0 : _marginProps$left,
      _marginProps$top = marginProps.top,
      marginTop = _marginProps$top === undefined ? 0 : _marginProps$top,
      _marginProps$right = marginProps.right,
      marginRight = _marginProps$right === undefined ? 0 : _marginProps$right,
      _marginProps$bottom = marginProps.bottom,
      marginBottom = _marginProps$bottom === undefined ? 0 : _marginProps$bottom;

  return {
    marginLeft: marginLeft,
    marginTop: marginTop,
    marginRight: marginRight,
    marginBottom: marginBottom,
    innerHeight: height - marginBottom - marginTop,
    innerWidth: width - marginLeft - marginRight
  };
}

/**
 * Calculate the margin of the sunburst,
 * so it can be at the center of the container
 * @param  {Number} width - the width of the container
 * @param  {Number} height - the height of the container
 * @param  {Number} radius - the max radius of the sunburst
 * @return {Object} an object includes {bottom, left, right, top}
 */
function getRadialLayoutMargin(width, height, radius) {
  var marginX = width / 2 - radius;
  var marginY = height / 2 - radius;
  return {
    bottom: marginY,
    left: marginX,
    right: marginX,
    top: marginY
  };
}

var MarginPropType = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  left: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  top: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  right: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  bottom: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number
}), __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number]);

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.receiveCampaigns = exports.startFetchingCampaigns = exports.fetchCampaigns = exports.FETCH = exports.RECEIVE_ERROR = exports.RECEIVE = undefined;

var _api = __webpack_require__(39);

var api = _interopRequireWildcard(_api);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var RECEIVE = exports.RECEIVE = 'CAMPAIGNS_RECEIVE';
var RECEIVE_ERROR = exports.RECEIVE_ERROR = 'CAMPAIGNS_RECEIVE_ERROR';
var FETCH = exports.FETCH = 'CAMPAIGNS_FETCH';

var fetchCampaigns = exports.fetchCampaigns = function fetchCampaigns() {
  return function (dispatch, getState) {
    var state = getState();

    if (state.campaigns.fetching) {
      return;
    }

    dispatch(startFetchingCampaigns());
    return api.fetchCampaigns().then(function (response) {
      return dispatch(receiveCampaigns(response || {}));
    });
  };
};

var startFetchingCampaigns = exports.startFetchingCampaigns = function startFetchingCampaigns() {
  return {
    type: FETCH
  };
};

var receiveCampaigns = exports.receiveCampaigns = function receiveCampaigns(items) {
  return {
    type: RECEIVE,
    items: items
  };
};

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.receiveChannels = exports.startFetchingChannels = exports.fetchChannels = exports.FETCH = exports.RECEIVE_ERROR = exports.RECEIVE = undefined;

var _api = __webpack_require__(39);

var api = _interopRequireWildcard(_api);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var RECEIVE = exports.RECEIVE = 'CHANNELS_RECEIVE';
var RECEIVE_ERROR = exports.RECEIVE_ERROR = 'CHANNELS_RECEIVE_ERROR';
var FETCH = exports.FETCH = 'CHANNELS_FETCH';

var fetchChannels = exports.fetchChannels = function fetchChannels() {
  return function (dispatch, getState) {
    var state = getState();

    if (state.channels.fetching) {
      return;
    }

    dispatch(startFetchingChannels());
    return api.fetchChannels().then(function (response) {
      return dispatch(receiveChannels(response || {}));
    });
  };
};

var startFetchingChannels = exports.startFetchingChannels = function startFetchingChannels() {
  return {
    type: FETCH
  };
};

var receiveChannels = exports.receiveChannels = function receiveChannels(items) {
  return {
    type: RECEIVE,
    items: items
  };
};

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterRedux = __webpack_require__(121);

var _reactRedux = __webpack_require__(18);

var _reactMd = __webpack_require__(582);

var _AddButton = __webpack_require__(632);

var _AddButton2 = _interopRequireDefault(_AddButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IconActive = function IconActive() {
  return _react2.default.createElement('img', { src: '/images/icon.svg', width: '60', height: '60', className: 'logo' });
};

var SubNav = function (_Component) {
  _inherits(SubNav, _Component);

  function SubNav() {
    _classCallCheck(this, SubNav);

    return _possibleConstructorReturn(this, (SubNav.__proto__ || Object.getPrototypeOf(SubNav)).apply(this, arguments));
  }

  _createClass(SubNav, [{
    key: 'goToItem',
    value: function goToItem(itemIndex) {
      this.props.navigate(this.props.tabsList[itemIndex].url);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var addButton = null;
      var tabs = null;
      if (this.props.addButtonHandler) {
        addButton = _react2.default.createElement(_AddButton2.default, { onClick: this.props.addButtonHandler });
      }

      if (this.props.tabsList) {
        var tabIndex = this.props.tabsList.findIndex(function (element) {
          return element.url == window.location.pathname;
        });
        tabs = _react2.default.createElement(
          'div',
          { className: 'tabs-container' },
          _react2.default.createElement(
            _reactMd.Tabs,
            { tabId: 'tabsList', id: 'Tabs', onTabChange: function onTabChange(tabIndex) {
                return _this2.goToItem(tabIndex);
              }, activeTabIndex: tabIndex },
            this.props.tabsList.map(function (item) {
              return _react2.default.createElement(_reactMd.Tab, { key: item.label,
                label: item.label
              });
            })
          )
        );
      }

      return _react2.default.createElement(
        'nav',
        { className: 'sub-nav' },
        _react2.default.createElement(IconActive, null),
        _react2.default.createElement(
          'h1',
          null,
          this.props.children
        ),
        tabs,
        addButton
      );
    }
  }]);

  return SubNav;
}(_react.Component);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    navigate: function navigate(path) {
      return dispatch((0, _reactRouterRedux.push)(path));
    }
  };
};

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(SubNav);

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var config = exports.config = window.appConfig;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nameToCode = nameToCode;
exports.codeToName = codeToName;

var _iso = __webpack_require__(385);

var _iso2 = _interopRequireDefault(_iso);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function nameToCode(name) {
  var match = _iso2.default.find(function (l) {
    return l.name == name;
  });
  return match ? match.iso6391 : null;
}
function codeToName(code) {
  var match = _iso2.default.find(function (l) {
    return l.iso6391 == code || l.iso6393 == code;
  });
  return match ? match.name : null;
}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activeCampaignUsing = exports.isActive = undefined;

var _campaigns = __webpack_require__(164);

var actions = _interopRequireWildcard(_campaigns);

var _collection = __webpack_require__(294);

var _collection2 = _interopRequireDefault(_collection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var itemsReducer = function itemsReducer(state) {
  return state;
};

var initialState = {
  fetching: false,
  items: null,
  filter: null,
  order: null,
  sortBy: 'updated_at',
  sortAsc: false,
  page: {
    index: 0,
    size: 5
  }
};

var isActive = exports.isActive = function isActive(campaign) {
  return campaign.startedAt !== null;
};

var activeCampaignUsing = exports.activeCampaignUsing = function activeCampaignUsing(campaigns) {
  return function (channelName) {
    return campaigns.items.find(function (campaign) {
      return isActive(campaign) && campaign.channel === channelName;
    });
  };
};

exports.default = (0, _collection2.default)(actions, itemsReducer, _collection.defaultFilterProvider, initialState);

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.completedMessages = exports.getChatTextFor = exports.getAudioFileFor = exports.messagesInUse = exports.neededMessages = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _values = __webpack_require__(146);

var _values2 = _interopRequireDefault(_values);

var _flatten = __webpack_require__(220);

var _flatten2 = _interopRequireDefault(_flatten);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var neededMessages = exports.neededMessages = function neededMessages(campaign) {
  var symptoms = (campaign.symptoms || []).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        id = _ref2[0],
        name = _ref2[1];

    return name && name != '';
  }).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        id = _ref4[0],
        name = _ref4[1];

    return 'symptom:' + id;
  });

  var modeMessages = [];
  if (campaign.mode == 'chat') {
    modeMessages = ['additional_information_intro', 'educational', 'thanks'];
  } else if (campaign.mode == 'call') {
    modeMessages = ['forward', 'additional_information_intro', 'educational', 'thanks'];
  }

  var topics = ['welcome', 'identify', 'registration'].concat(symptoms).concat(modeMessages);

  if (campaign.additionalInformation == 'zero' || campaign.additionalInformation == undefined) {
    var i = topics.indexOf('additional_information_intro');
    topics.splice(i, 2);
  }

  if (campaign.additionalInformation == 'compulsory') {
    var _i = topics.indexOf('additional_information_intro');
    topics.splice(_i, 1);
  }

  var entries = {};

  var langs = campaign.langs.filter(function (lang) {
    return lang && lang != '';
  });
  langs.forEach(function (lang) {
    entries[lang] = topics.slice();
  });

  return entries;
};

var messagesInUse = exports.messagesInUse = function messagesInUse(campaign) {
  var entries = neededMessages(campaign);

  var inUse = [];

  var messages = [];
  if (campaign.mode == 'chat') {
    messages = campaign.chatTexts;
  } else if (campaign.mode == 'call') {
    messages = campaign.audios;
  }

  var welcomeMessage = messages.find(function (msg) {
    return msg[0] == 'language' && msg[1] == '';
  });
  if (welcomeMessage && welcomeMessage[2] != '') {
    inUse.push(welcomeMessage);
  }

  var _loop = function _loop(language) {
    var steps = entries[language];
    steps.forEach(function (step) {
      var msg = messages.find(function (msg) {
        return msg[0] == step && msg[1] == language;
      });
      if (msg && msg[2] != '') {
        inUse.push(msg);
      }
    });
  };

  for (var language in entries) {
    _loop(language);
  }

  return inUse;
};

var getAudioFileFor = exports.getAudioFileFor = function getAudioFileFor(messages, step, language) {
  var audio = messages.find(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 3),
        _topic = _ref6[0],
        _language = _ref6[1],
        _uuid = _ref6[2];

    return step == _topic && language == _language;
  });
  return audio && audio[2];
};

var getChatTextFor = exports.getChatTextFor = function getChatTextFor(messages, step, language) {
  var chatMessage = messages.find(function (_ref7) {
    var _ref8 = _slicedToArray(_ref7, 3),
        _topic = _ref8[0],
        _language = _ref8[1],
        _text = _ref8[2];

    return step == _topic && language == _language;
  });
  return chatMessage && chatMessage[2];
};

var completedMessages = exports.completedMessages = function completedMessages(campaign) {
  var uploadedMessages = messagesInUse(campaign).length;
  var necessaryMessages = (0, _flatten2.default)((0, _values2.default)(neededMessages(campaign))).length + 1;
  return uploadedMessages > 1 && uploadedMessages === necessaryMessages;
};

/***/ }),
/* 171 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 172 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

/***/ }),
/* 173 */
/***/ (function(module, exports) {

module.exports = {};

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports = true;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject    = __webpack_require__(88)
  , dPs         = __webpack_require__(698)
  , enumBugKeys = __webpack_require__(172)
  , IE_PROTO    = __webpack_require__(178)('IE_PROTO')
  , Empty       = function(){ /* empty */ }
  , PROTOTYPE   = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function(){
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(299)('iframe')
    , i      = enumBugKeys.length
    , lt     = '<'
    , gt     = '>'
    , iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(691).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties){
  var result;
  if(O !== null){
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty;
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 176 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(54).f
  , has = __webpack_require__(53)
  , TAG = __webpack_require__(71)('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(179)('keys')
  , uid    = __webpack_require__(124);
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(49)
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};

/***/ }),
/* 180 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(171);
module.exports = function(it){
  return Object(defined(it));
};

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(89);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var global         = __webpack_require__(49)
  , core           = __webpack_require__(40)
  , LIBRARY        = __webpack_require__(174)
  , wksExt         = __webpack_require__(184)
  , defineProperty = __webpack_require__(54).f;
module.exports = function(name){
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
};

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(71);

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(717);

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(91);


/* harmony default export */ __webpack_exports__["a"] = (function(values, p, valueof) {
  if (valueof == null) valueof = __WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */];
  if (!(n = values.length)) return;
  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
  var n,
      i = (n - 1) * p,
      i0 = Math.floor(i),
      value0 = +valueof(values[i0], i0, values),
      value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i - i0);
});


/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefix; });
var prefix = "$";

function Map() {}

Map.prototype = map.prototype = {
  constructor: Map,
  has: function(key) {
    return (prefix + key) in this;
  },
  get: function(key) {
    return this[prefix + key];
  },
  set: function(key, value) {
    this[prefix + key] = value;
    return this;
  },
  remove: function(key) {
    var property = prefix + key;
    return property in this && delete this[property];
  },
  clear: function() {
    for (var property in this) if (property[0] === prefix) delete this[property];
  },
  keys: function() {
    var keys = [];
    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
    return keys;
  },
  values: function() {
    var values = [];
    for (var property in this) if (property[0] === prefix) values.push(this[property]);
    return values;
  },
  entries: function() {
    var entries = [];
    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
    return entries;
  },
  size: function() {
    var size = 0;
    for (var property in this) if (property[0] === prefix) ++size;
    return size;
  },
  empty: function() {
    for (var property in this) if (property[0] === prefix) return false;
    return true;
  },
  each: function(f) {
    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
  }
};

function map(object, f) {
  var map = new Map;

  // Copy constructor.
  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });

  // Index array by numeric index or specified key function.
  else if (Array.isArray(object)) {
    var i = -1,
        n = object.length,
        o;

    if (f == null) while (++i < n) map.set(i, object[i]);
    else while (++i < n) map.set(f(o = object[i], i, object), o);
  }

  // Convert object to map.
  else if (object) for (var key in object) map.set(key, object[key]);

  return map;
}

/* harmony default export */ __webpack_exports__["a"] = (map);


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = Color;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return darker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return brighter; });
/* harmony export (immutable) */ __webpack_exports__["h"] = color;
/* harmony export (immutable) */ __webpack_exports__["c"] = rgbConvert;
/* harmony export (immutable) */ __webpack_exports__["g"] = rgb;
/* harmony export (immutable) */ __webpack_exports__["b"] = Rgb;
/* unused harmony export hslConvert */
/* harmony export (immutable) */ __webpack_exports__["a"] = hsl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(189);


function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex3 = /^#([0-9a-f]{3})$/,
    reHex6 = /^#([0-9a-f]{6})$/,
    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Color, color, {
  displayable: function() {
    return this.rgb().displayable();
  },
  toString: function() {
    return this.rgb() + "";
  }
});

function color(format) {
  var m;
  format = (format + "").trim().toLowerCase();
  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format])
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Rgb, rgb, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (0 <= this.r && this.r <= 255)
        && (0 <= this.g && this.g <= 255)
        && (0 <= this.b && this.b <= 255)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  toString: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(")
        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hsl, hsl, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}


/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extend;
/* harmony default export */ __webpack_exports__["a"] = (function(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
});

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}


/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimal(1.23) returns ["123", 0].
/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i, coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
});


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = clipExtent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buffer__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__line__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__polygon__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_array__ = __webpack_require__(21);






var clipMax = 1e9, clipMin = -clipMax;

// TODO Use d3-polygon’s polygonContains here for the ring check?
// TODO Eliminate duplicate buffering in clipBuffer and polygon.push?

function clipExtent(x0, y0, x1, y1) {

  function visible(x, y) {
    return x0 <= x && x <= x1 && y0 <= y && y <= y1;
  }

  function interpolate(from, to, direction, stream) {
    var a = 0, a1 = 0;
    if (from == null
        || (a = corner(from, direction)) !== (a1 = corner(to, direction))
        || comparePoint(from, to) < 0 ^ direction > 0) {
      do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
      while ((a = (a + direction + 4) % 4) !== a1);
    } else {
      stream.point(to[0], to[1]);
    }
  }

  function corner(p, direction) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["o" /* abs */])(p[0] - x0) < __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */] ? direction > 0 ? 0 : 3
        : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["o" /* abs */])(p[0] - x1) < __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */] ? direction > 0 ? 2 : 1
        : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["o" /* abs */])(p[1] - y0) < __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */] ? direction > 0 ? 1 : 0
        : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
  }

  function compareIntersection(a, b) {
    return comparePoint(a.x, b.x);
  }

  function comparePoint(a, b) {
    var ca = corner(a, 1),
        cb = corner(b, 1);
    return ca !== cb ? ca - cb
        : ca === 0 ? b[1] - a[1]
        : ca === 1 ? a[0] - b[0]
        : ca === 2 ? a[1] - b[1]
        : b[0] - a[0];
  }

  return function(stream) {
    var activeStream = stream,
        bufferStream = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__buffer__["a" /* default */])(),
        segments,
        polygon,
        ring,
        x__, y__, v__, // first point
        x_, y_, v_, // previous point
        first,
        clean;

    var clipStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: polygonStart,
      polygonEnd: polygonEnd
    };

    function point(x, y) {
      if (visible(x, y)) activeStream.point(x, y);
    }

    function polygonInside() {
      var winding = 0;

      for (var i = 0, n = polygon.length; i < n; ++i) {
        for (var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j) {
          a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
          if (a1 <= y1) { if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding; }
          else { if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding; }
        }
      }

      return winding;
    }

    // Buffer geometry within a polygon and then clip it en masse.
    function polygonStart() {
      activeStream = bufferStream, segments = [], polygon = [], clean = true;
    }

    function polygonEnd() {
      var startInside = polygonInside(),
          cleanInside = clean && startInside,
          visible = (segments = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_d3_array__["j" /* merge */])(segments)).length;
      if (cleanInside || visible) {
        stream.polygonStart();
        if (cleanInside) {
          stream.lineStart();
          interpolate(null, null, 1, stream);
          stream.lineEnd();
        }
        if (visible) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__polygon__["a" /* default */])(segments, compareIntersection, startInside, interpolate, stream);
        }
        stream.polygonEnd();
      }
      activeStream = stream, segments = polygon = ring = null;
    }

    function lineStart() {
      clipStream.point = linePoint;
      if (polygon) polygon.push(ring = []);
      first = true;
      v_ = false;
      x_ = y_ = NaN;
    }

    // TODO rather than special-case polygons, simply handle them separately.
    // Ideally, coincident intersection points should be jittered to avoid
    // clipping issues.
    function lineEnd() {
      if (segments) {
        linePoint(x__, y__);
        if (v__ && v_) bufferStream.rejoin();
        segments.push(bufferStream.result());
      }
      clipStream.point = point;
      if (v_) activeStream.lineEnd();
    }

    function linePoint(x, y) {
      var v = visible(x, y);
      if (polygon) ring.push([x, y]);
      if (first) {
        x__ = x, y__ = y, v__ = v;
        first = false;
        if (v) {
          activeStream.lineStart();
          activeStream.point(x, y);
        }
      } else {
        if (v && v_) activeStream.point(x, y);
        else {
          var a = [x_ = Math.max(clipMin, Math.min(clipMax, x_)), y_ = Math.max(clipMin, Math.min(clipMax, y_))],
              b = [x = Math.max(clipMin, Math.min(clipMax, x)), y = Math.max(clipMin, Math.min(clipMax, y))];
          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__line__["a" /* default */])(a, b, x0, y0, x1, y1)) {
            if (!v_) {
              activeStream.lineStart();
              activeStream.point(a[0], a[1]);
            }
            activeStream.point(b[0], b[1]);
            if (!v) activeStream.lineEnd();
            clean = false;
          } else if (v) {
            activeStream.lineStart();
            activeStream.point(x, y);
            clean = false;
          }
        }
      }
      x_ = x, y_ = y, v_ = v;
    }

    return clipStream;
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var x0 = 0,
      y0 = 0,
      x1 = 960,
      y1 = 500,
      cache,
      cacheStream,
      clip;

  return clip = {
    stream: function(stream) {
      return cache && cacheStream === stream ? cache : cache = clipExtent(x0, y0, x1, y1)(cacheStream = stream);
    },
    extent: function(_) {
      return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [[x0, y0], [x1, y1]];
    }
  };
});


/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = conicProjection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(41);



function conicProjection(projectAt) {
  var phi0 = 0,
      phi1 = __WEBPACK_IMPORTED_MODULE_0__math__["a" /* pi */] / 3,
      m = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* projectionMutator */])(projectAt),
      p = m(phi0, phi1);

  p.parallels = function(_) {
    return arguments.length ? m(phi0 = _[0] * __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */], phi1 = _[1] * __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */]) : [phi0 * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */], phi1 * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */]];
  };

  return p;
}


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export conicEqualAreaRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conic__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cylindricalEqualArea__ = __webpack_require__(778);




function conicEqualAreaRaw(y0, y1) {
  var sy0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(y0), n = (sy0 + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(y1)) / 2;

  // Are the parallels symmetrical around the Equator?
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["o" /* abs */])(n) < __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */]) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cylindricalEqualArea__["a" /* cylindricalEqualAreaRaw */])(y0);

  var c = 1 + sy0 * (2 * n - sy0), r0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])(c) / n;

  function project(x, y) {
    var r = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])(c - 2 * n * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(y)) / n;
    return [r * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(x *= n), r0 - r * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(x)];
  }

  project.invert = function(x, y) {
    var r0y = r0 - y;
    return [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(x, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["o" /* abs */])(r0y)) / n * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(r0y), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["f" /* asin */])((c - (x * x + r0y * r0y) * n * n) / (2 * n))];
  };

  return project;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__conic__["a" /* conicProjection */])(conicEqualAreaRaw)
      .scale(155.424)
      .center([0, 33.6442]);
});


/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fitExtent;
/* harmony export (immutable) */ __webpack_exports__["b"] = fitSize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stream__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__path_bounds__ = __webpack_require__(337);



function fitExtent(projection, extent, object) {
  var w = extent[1][0] - extent[0][0],
      h = extent[1][1] - extent[0][1],
      clip = projection.clipExtent && projection.clipExtent();

  projection
      .scale(150)
      .translate([0, 0]);

  if (clip != null) projection.clipExtent(null);

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__stream__["a" /* default */])(object, projection.stream(__WEBPACK_IMPORTED_MODULE_1__path_bounds__["a" /* default */]));

  var b = __WEBPACK_IMPORTED_MODULE_1__path_bounds__["a" /* default */].result(),
      k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])),
      x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2,
      y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;

  if (clip != null) projection.clipExtent(clip);

  return projection
      .scale(k * 150)
      .translate([x, y]);
}

function fitSize(projection, size, object) {
  return fitExtent(projection, [[0, 0], size], object);
}


/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = mercatorRaw;
/* harmony export (immutable) */ __webpack_exports__["a"] = mercatorProjection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rotation__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(41);




function mercatorRaw(lambda, phi) {
  return [lambda, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["i" /* log */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["j" /* tan */])((__WEBPACK_IMPORTED_MODULE_0__math__["k" /* halfPi */] + phi) / 2))];
}

mercatorRaw.invert = function(x, y) {
  return [x, 2 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["l" /* atan */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["m" /* exp */])(y)) - __WEBPACK_IMPORTED_MODULE_0__math__["k" /* halfPi */]];
};

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return mercatorProjection(mercatorRaw)
      .scale(961 / __WEBPACK_IMPORTED_MODULE_0__math__["b" /* tau */]);
});

function mercatorProjection(project) {
  var m = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(project),
      center = m.center,
      scale = m.scale,
      translate = m.translate,
      clipExtent = m.clipExtent,
      x0 = null, y0, x1, y1; // clip extent

  m.scale = function(_) {
    return arguments.length ? (scale(_), reclip()) : scale();
  };

  m.translate = function(_) {
    return arguments.length ? (translate(_), reclip()) : translate();
  };

  m.center = function(_) {
    return arguments.length ? (center(_), reclip()) : center();
  };

  m.clipExtent = function(_) {
    return arguments.length ? ((_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1])), reclip()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };

  function reclip() {
    var k = __WEBPACK_IMPORTED_MODULE_0__math__["a" /* pi */] * scale(),
        t = m(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__rotation__["a" /* default */])(m.rotate()).invert([0, 0]));
    return clipExtent(x0 == null
        ? [[t[0] - k, t[1] - k], [t[0] + k, t[1] + k]] : project === mercatorRaw
        ? [[Math.max(t[0] - k, x0), y0], [Math.min(t[0] + k, x1), y1]]
        : [[x0, Math.max(t[1] - k, y0)], [x1, Math.min(t[1] + k, y1)]]);
  }

  return reclip();
}


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = optional;
/* harmony export (immutable) */ __webpack_exports__["a"] = required;
function optional(f) {
  return f == null ? null : required(f);
}

function required(f) {
  if (typeof f !== "function") throw new Error;
  return f;
}


/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hierarchy;
/* harmony export (immutable) */ __webpack_exports__["c"] = computeHeight;
/* harmony export (immutable) */ __webpack_exports__["b"] = Node;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__count__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__each__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eachBefore__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eachAfter__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sum__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sort__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__path__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ancestors__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__descendants__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__leaves__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__links__ = __webpack_require__(794);












function hierarchy(data, children) {
  var root = new Node(data),
      valued = +data.value && (root.value = data.value),
      node,
      nodes = [root],
      child,
      childs,
      i,
      n;

  if (children == null) children = defaultChildren;

  while (node = nodes.pop()) {
    if (valued) node.value = +node.data.value;
    if ((childs = children(node.data)) && (n = childs.length)) {
      node.children = new Array(n);
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = node.children[i] = new Node(childs[i]));
        child.parent = node;
        child.depth = node.depth + 1;
      }
    }
  }

  return root.eachBefore(computeHeight);
}

function node_copy() {
  return hierarchy(this).eachBefore(copyData);
}

function defaultChildren(d) {
  return d.children;
}

function copyData(node) {
  node.data = node.data.data;
}

function computeHeight(node) {
  var height = 0;
  do node.height = height;
  while ((node = node.parent) && (node.height < ++height));
}

function Node(data) {
  this.data = data;
  this.depth =
  this.height = 0;
  this.parent = null;
}

Node.prototype = hierarchy.prototype = {
  constructor: Node,
  count: __WEBPACK_IMPORTED_MODULE_0__count__["a" /* default */],
  each: __WEBPACK_IMPORTED_MODULE_1__each__["a" /* default */],
  eachAfter: __WEBPACK_IMPORTED_MODULE_3__eachAfter__["a" /* default */],
  eachBefore: __WEBPACK_IMPORTED_MODULE_2__eachBefore__["a" /* default */],
  sum: __WEBPACK_IMPORTED_MODULE_4__sum__["a" /* default */],
  sort: __WEBPACK_IMPORTED_MODULE_5__sort__["a" /* default */],
  path: __WEBPACK_IMPORTED_MODULE_6__path__["a" /* default */],
  ancestors: __WEBPACK_IMPORTED_MODULE_7__ancestors__["a" /* default */],
  descendants: __WEBPACK_IMPORTED_MODULE_8__descendants__["a" /* default */],
  leaves: __WEBPACK_IMPORTED_MODULE_9__leaves__["a" /* default */],
  links: __WEBPACK_IMPORTED_MODULE_10__links__["a" /* default */],
  copy: node_copy
};


/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return phi; });
/* harmony export (immutable) */ __webpack_exports__["a"] = squarifyRatio;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dice__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slice__ = __webpack_require__(129);



var phi = (1 + Math.sqrt(5)) / 2;

function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
  var rows = [],
      nodes = parent.children,
      row,
      nodeValue,
      i0 = 0,
      i1 = 0,
      n = nodes.length,
      dx, dy,
      value = parent.value,
      sumValue,
      minValue,
      maxValue,
      newRatio,
      minRatio,
      alpha,
      beta;

  while (i0 < n) {
    dx = x1 - x0, dy = y1 - y0;

    // Find the next non-empty node.
    do sumValue = nodes[i1++].value; while (!sumValue && i1 < n);
    minValue = maxValue = sumValue;
    alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
    beta = sumValue * sumValue * alpha;
    minRatio = Math.max(maxValue / beta, beta / minValue);

    // Keep adding nodes while the aspect ratio maintains or improves.
    for (; i1 < n; ++i1) {
      sumValue += nodeValue = nodes[i1].value;
      if (nodeValue < minValue) minValue = nodeValue;
      if (nodeValue > maxValue) maxValue = nodeValue;
      beta = sumValue * sumValue * alpha;
      newRatio = Math.max(maxValue / beta, beta / minValue);
      if (newRatio > minRatio) { sumValue -= nodeValue; break; }
      minRatio = newRatio;
    }

    // Position and record the row orientation.
    rows.push(row = {value: sumValue, dice: dx < dy, children: nodes.slice(i0, i1)});
    if (row.dice) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dice__["a" /* default */])(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
    else __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__slice__["a" /* default */])(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
    value -= sumValue, i0 = i1;
  }

  return rows;
}

/* harmony default export */ __webpack_exports__["c"] = ((function custom(ratio) {

  function squarify(parent, x0, y0, x1, y1) {
    squarifyRatio(ratio, parent, x0, y0, x1, y1);
  }

  squarify.ratio = function(x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return squarify;
})(phi));


/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = basis;
function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1, t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
      + (4 - 6 * t2 + 3 * t3) * v1
      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
      + t3 * v3) / 6;
}

/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  var n = values.length - 1;
  return function(t) {
    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
        v1 = values[i],
        v2 = values[i + 1],
        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rgb__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__date__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__object__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__string__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constant__ = __webpack_require__(349);









/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__constant__["a" /* default */])(b)
      : (t === "number" ? __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]
      : t === "string" ? ((c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* color */])(b)) ? (b = c, __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]) : __WEBPACK_IMPORTED_MODULE_6__string__["a" /* default */])
      : b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* color */] ? __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]
      : b instanceof Date ? __WEBPACK_IMPORTED_MODULE_3__date__["a" /* default */]
      : Array.isArray(b) ? __WEBPACK_IMPORTED_MODULE_2__array__["a" /* default */]
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? __WEBPACK_IMPORTED_MODULE_5__object__["a" /* default */]
      : __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */])(a, b);
});


/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = point;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardinal__ = __webpack_require__(134);



function point(that, x, y) {
  var x1 = that._x1,
      y1 = that._y1,
      x2 = that._x2,
      y2 = that._y2;

  if (that._l01_a > __WEBPACK_IMPORTED_MODULE_0__math__["a" /* epsilon */]) {
    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
  }

  if (that._l23_a > __WEBPACK_IMPORTED_MODULE_0__math__["a" /* epsilon */]) {
    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
  }

  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}

function CatmullRom(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRom.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: this.point(this._x2, this._y2); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; // proceed
      default: point(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["b"] = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRom(context, alpha) : new __WEBPACK_IMPORTED_MODULE_1__cardinal__["a" /* Cardinal */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curve_linear__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__point__ = __webpack_require__(206);





/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x = __WEBPACK_IMPORTED_MODULE_3__point__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_3__point__["b" /* y */],
      defined = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(true),
      context = null,
      curve = __WEBPACK_IMPORTED_MODULE_2__curve_linear__["a" /* default */],
      output = null;

  function line(data) {
    var i,
        n = data.length,
        d,
        defined0 = false,
        buffer;

    if (context == null) output = curve(buffer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) output.lineStart();
        else output.lineEnd();
      }
      if (defined0) output.point(+x(d, i, data), +y(d, i, data));
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  line.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), line) : x;
  };

  line.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), line) : y;
  };

  line.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(!!_), line) : defined;
  };

  line.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
  };

  line.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
  };

  return line;
});


/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sum;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(102);


/* harmony default export */ __webpack_exports__["b"] = (function(series) {
  var sums = series.map(sum);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).sort(function(a, b) { return sums[a] - sums[b]; });
});

function sum(series) {
  var s = 0, i = -1, n = series.length, v;
  while (++i < n) if (v = +series[i][1]) s += v;
  return s;
}


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = x;
/* harmony export (immutable) */ __webpack_exports__["b"] = y;
function x(p) {
  return p[0];
}

function y(p) {
  return p[1];
}


/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return timeFormat; });
/* unused harmony export timeParse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return utcFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcParse; });
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__(374);


var locale;
var timeFormat;
var timeParse;
var utcFormat;
var utcParse;

defaultLocale({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function defaultLocale(definition) {
  locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* default */])(definition);
  timeFormat = locale.format;
  timeParse = locale.parse;
  utcFormat = locale.utcFormat;
  utcParse = locale.utcParse;
  return locale;
}


/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_interval__ = __webpack_require__(24);
/* unused harmony reexport timeInterval */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_millisecond__ = __webpack_require__(866);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_1__src_millisecond__["a"]; });
/* unused harmony reexport timeMilliseconds */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__src_millisecond__["a"]; });
/* unused harmony reexport utcMilliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_second__ = __webpack_require__(869);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_2__src_second__["a"]; });
/* unused harmony reexport timeSeconds */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__src_second__["a"]; });
/* unused harmony reexport utcSeconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_minute__ = __webpack_require__(867);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_3__src_minute__["a"]; });
/* unused harmony reexport timeMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_hour__ = __webpack_require__(865);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_4__src_hour__["a"]; });
/* unused harmony reexport timeHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_day__ = __webpack_require__(864);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_5__src_day__["a"]; });
/* unused harmony reexport timeDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_week__ = __webpack_require__(876);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["a"]; });
/* unused harmony reexport timeWeeks */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["a"]; });
/* unused harmony reexport timeSundays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["b"]; });
/* unused harmony reexport timeMondays */
/* unused harmony reexport timeTuesday */
/* unused harmony reexport timeTuesdays */
/* unused harmony reexport timeWednesday */
/* unused harmony reexport timeWednesdays */
/* unused harmony reexport timeThursday */
/* unused harmony reexport timeThursdays */
/* unused harmony reexport timeFriday */
/* unused harmony reexport timeFridays */
/* unused harmony reexport timeSaturday */
/* unused harmony reexport timeSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_month__ = __webpack_require__(868);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_7__src_month__["a"]; });
/* unused harmony reexport timeMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_year__ = __webpack_require__(877);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_8__src_year__["a"]; });
/* unused harmony reexport timeYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_utcMinute__ = __webpack_require__(872);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_9__src_utcMinute__["a"]; });
/* unused harmony reexport utcMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_utcHour__ = __webpack_require__(871);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_10__src_utcHour__["a"]; });
/* unused harmony reexport utcHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_utcDay__ = __webpack_require__(870);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_11__src_utcDay__["a"]; });
/* unused harmony reexport utcDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__ = __webpack_require__(874);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["a"]; });
/* unused harmony reexport utcWeeks */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["a"]; });
/* unused harmony reexport utcSundays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["b"]; });
/* unused harmony reexport utcMondays */
/* unused harmony reexport utcTuesday */
/* unused harmony reexport utcTuesdays */
/* unused harmony reexport utcWednesday */
/* unused harmony reexport utcWednesdays */
/* unused harmony reexport utcThursday */
/* unused harmony reexport utcThursdays */
/* unused harmony reexport utcFriday */
/* unused harmony reexport utcFridays */
/* unused harmony reexport utcSaturday */
/* unused harmony reexport utcSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_utcMonth__ = __webpack_require__(873);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_13__src_utcMonth__["a"]; });
/* unused harmony reexport utcMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_utcYear__ = __webpack_require__(875);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_14__src_utcYear__["a"]; });
/* unused harmony reexport utcYears */































/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createEdge;
/* harmony export (immutable) */ __webpack_exports__["b"] = createBorderEdge;
/* harmony export (immutable) */ __webpack_exports__["c"] = setEdgeEnd;
/* harmony export (immutable) */ __webpack_exports__["a"] = clipEdges;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Diagram__ = __webpack_require__(103);


function createEdge(left, right, v0, v1) {
  var edge = [null, null],
      index = __WEBPACK_IMPORTED_MODULE_0__Diagram__["d" /* edges */].push(edge) - 1;
  edge.left = left;
  edge.right = right;
  if (v0) setEdgeEnd(edge, left, right, v0);
  if (v1) setEdgeEnd(edge, right, left, v1);
  __WEBPACK_IMPORTED_MODULE_0__Diagram__["c" /* cells */][left.index].halfedges.push(index);
  __WEBPACK_IMPORTED_MODULE_0__Diagram__["c" /* cells */][right.index].halfedges.push(index);
  return edge;
}

function createBorderEdge(left, v0, v1) {
  var edge = [v0, v1];
  edge.left = left;
  return edge;
}

function setEdgeEnd(edge, left, right, vertex) {
  if (!edge[0] && !edge[1]) {
    edge[0] = vertex;
    edge.left = left;
    edge.right = right;
  } else if (edge.left === right) {
    edge[1] = vertex;
  } else {
    edge[0] = vertex;
  }
}

// Liang–Barsky line clipping.
function clipEdge(edge, x0, y0, x1, y1) {
  var a = edge[0],
      b = edge[1],
      ax = a[0],
      ay = a[1],
      bx = b[0],
      by = b[1],
      t0 = 0,
      t1 = 1,
      dx = bx - ax,
      dy = by - ay,
      r;

  r = x0 - ax;
  if (!dx && r > 0) return;
  r /= dx;
  if (dx < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dx > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = x1 - ax;
  if (!dx && r < 0) return;
  r /= dx;
  if (dx < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dx > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  r = y0 - ay;
  if (!dy && r > 0) return;
  r /= dy;
  if (dy < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dy > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = y1 - ay;
  if (!dy && r < 0) return;
  r /= dy;
  if (dy < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dy > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  if (!(t0 > 0) && !(t1 < 1)) return true; // TODO Better check?

  if (t0 > 0) edge[0] = [ax + t0 * dx, ay + t0 * dy];
  if (t1 < 1) edge[1] = [ax + t1 * dx, ay + t1 * dy];
  return true;
}

function connectEdge(edge, x0, y0, x1, y1) {
  var v1 = edge[1];
  if (v1) return true;

  var v0 = edge[0],
      left = edge.left,
      right = edge.right,
      lx = left[0],
      ly = left[1],
      rx = right[0],
      ry = right[1],
      fx = (lx + rx) / 2,
      fy = (ly + ry) / 2,
      fm,
      fb;

  if (ry === ly) {
    if (fx < x0 || fx >= x1) return;
    if (lx > rx) {
      if (!v0) v0 = [fx, y0];
      else if (v0[1] >= y1) return;
      v1 = [fx, y1];
    } else {
      if (!v0) v0 = [fx, y1];
      else if (v0[1] < y0) return;
      v1 = [fx, y0];
    }
  } else {
    fm = (lx - rx) / (ry - ly);
    fb = fy - fm * fx;
    if (fm < -1 || fm > 1) {
      if (lx > rx) {
        if (!v0) v0 = [(y0 - fb) / fm, y0];
        else if (v0[1] >= y1) return;
        v1 = [(y1 - fb) / fm, y1];
      } else {
        if (!v0) v0 = [(y1 - fb) / fm, y1];
        else if (v0[1] < y0) return;
        v1 = [(y0 - fb) / fm, y0];
      }
    } else {
      if (ly < ry) {
        if (!v0) v0 = [x0, fm * x0 + fb];
        else if (v0[0] >= x1) return;
        v1 = [x1, fm * x1 + fb];
      } else {
        if (!v0) v0 = [x1, fm * x1 + fb];
        else if (v0[0] < x0) return;
        v1 = [x0, fm * x0 + fb];
      }
    }
  }

  edge[0] = v0;
  edge[1] = v1;
  return true;
}

function clipEdges(x0, y0, x1, y1) {
  var i = __WEBPACK_IMPORTED_MODULE_0__Diagram__["d" /* edges */].length,
      edge;

  while (i--) {
    if (!connectEdge(edge = __WEBPACK_IMPORTED_MODULE_0__Diagram__["d" /* edges */][i], x0, y0, x1, y1)
        || !clipEdge(edge, x0, y0, x1, y1)
        || !(Math.abs(edge[0][0] - edge[1][0]) > __WEBPACK_IMPORTED_MODULE_0__Diagram__["b" /* epsilon */]
            || Math.abs(edge[0][1] - edge[1][1]) > __WEBPACK_IMPORTED_MODULE_0__Diagram__["b" /* epsilon */])) {
      delete __WEBPACK_IMPORTED_MODULE_0__Diagram__["d" /* edges */][i];
    }
  }
}


/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = RedBlackNode;
function RedBlackTree() {
  this._ = null; // root node
}

function RedBlackNode(node) {
  node.U = // parent node
  node.C = // color - true for red, false for black
  node.L = // left node
  node.R = // right node
  node.P = // previous node
  node.N = null; // next node
}

RedBlackTree.prototype = {
  constructor: RedBlackTree,

  insert: function(after, node) {
    var parent, grandpa, uncle;

    if (after) {
      node.P = after;
      node.N = after.N;
      if (after.N) after.N.P = node;
      after.N = node;
      if (after.R) {
        after = after.R;
        while (after.L) after = after.L;
        after.L = node;
      } else {
        after.R = node;
      }
      parent = after;
    } else if (this._) {
      after = RedBlackFirst(this._);
      node.P = null;
      node.N = after;
      after.P = after.L = node;
      parent = after;
    } else {
      node.P = node.N = null;
      this._ = node;
      parent = null;
    }
    node.L = node.R = null;
    node.U = parent;
    node.C = true;

    after = node;
    while (parent && parent.C) {
      grandpa = parent.U;
      if (parent === grandpa.L) {
        uncle = grandpa.R;
        if (uncle && uncle.C) {
          parent.C = uncle.C = false;
          grandpa.C = true;
          after = grandpa;
        } else {
          if (after === parent.R) {
            RedBlackRotateLeft(this, parent);
            after = parent;
            parent = after.U;
          }
          parent.C = false;
          grandpa.C = true;
          RedBlackRotateRight(this, grandpa);
        }
      } else {
        uncle = grandpa.L;
        if (uncle && uncle.C) {
          parent.C = uncle.C = false;
          grandpa.C = true;
          after = grandpa;
        } else {
          if (after === parent.L) {
            RedBlackRotateRight(this, parent);
            after = parent;
            parent = after.U;
          }
          parent.C = false;
          grandpa.C = true;
          RedBlackRotateLeft(this, grandpa);
        }
      }
      parent = after.U;
    }
    this._.C = false;
  },

  remove: function(node) {
    if (node.N) node.N.P = node.P;
    if (node.P) node.P.N = node.N;
    node.N = node.P = null;

    var parent = node.U,
        sibling,
        left = node.L,
        right = node.R,
        next,
        red;

    if (!left) next = right;
    else if (!right) next = left;
    else next = RedBlackFirst(right);

    if (parent) {
      if (parent.L === node) parent.L = next;
      else parent.R = next;
    } else {
      this._ = next;
    }

    if (left && right) {
      red = next.C;
      next.C = node.C;
      next.L = left;
      left.U = next;
      if (next !== right) {
        parent = next.U;
        next.U = node.U;
        node = next.R;
        parent.L = node;
        next.R = right;
        right.U = next;
      } else {
        next.U = parent;
        parent = next;
        node = next.R;
      }
    } else {
      red = node.C;
      node = next;
    }

    if (node) node.U = parent;
    if (red) return;
    if (node && node.C) { node.C = false; return; }

    do {
      if (node === this._) break;
      if (node === parent.L) {
        sibling = parent.R;
        if (sibling.C) {
          sibling.C = false;
          parent.C = true;
          RedBlackRotateLeft(this, parent);
          sibling = parent.R;
        }
        if ((sibling.L && sibling.L.C)
            || (sibling.R && sibling.R.C)) {
          if (!sibling.R || !sibling.R.C) {
            sibling.L.C = false;
            sibling.C = true;
            RedBlackRotateRight(this, sibling);
            sibling = parent.R;
          }
          sibling.C = parent.C;
          parent.C = sibling.R.C = false;
          RedBlackRotateLeft(this, parent);
          node = this._;
          break;
        }
      } else {
        sibling = parent.L;
        if (sibling.C) {
          sibling.C = false;
          parent.C = true;
          RedBlackRotateRight(this, parent);
          sibling = parent.L;
        }
        if ((sibling.L && sibling.L.C)
          || (sibling.R && sibling.R.C)) {
          if (!sibling.L || !sibling.L.C) {
            sibling.R.C = false;
            sibling.C = true;
            RedBlackRotateLeft(this, sibling);
            sibling = parent.L;
          }
          sibling.C = parent.C;
          parent.C = sibling.L.C = false;
          RedBlackRotateRight(this, parent);
          node = this._;
          break;
        }
      }
      sibling.C = true;
      node = parent;
      parent = parent.U;
    } while (!node.C);

    if (node) node.C = false;
  }
};

function RedBlackRotateLeft(tree, node) {
  var p = node,
      q = node.R,
      parent = p.U;

  if (parent) {
    if (parent.L === p) parent.L = q;
    else parent.R = q;
  } else {
    tree._ = q;
  }

  q.U = parent;
  p.U = q;
  p.R = q.L;
  if (p.R) p.R.U = p;
  q.L = p;
}

function RedBlackRotateRight(tree, node) {
  var p = node,
      q = node.L,
      parent = p.U;

  if (parent) {
    if (parent.L === p) parent.L = q;
    else parent.R = q;
  } else {
    tree._ = q;
  }

  q.U = parent;
  p.U = q;
  p.L = q.R;
  if (p.L) p.L.U = p;
  q.R = p;
}

function RedBlackFirst(node) {
  while (node.L) node = node.L;
  return node;
}

/* harmony default export */ __webpack_exports__["a"] = (RedBlackTree);


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.createLocation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resolvePathname = __webpack_require__(1315);

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

var _valueEqual = __webpack_require__(1323);

var _valueEqual2 = _interopRequireDefault(_valueEqual);

var _PathUtils = __webpack_require__(104);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = (0, _PathUtils.parsePath)(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
    }
  }

  return location;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
};

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(33);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

exports.default = createTransitionManager;

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(917);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(60),
    root = __webpack_require__(43);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(985),
    mapCacheDelete = __webpack_require__(986),
    mapCacheGet = __webpack_require__(987),
    mapCacheHas = __webpack_require__(988),
    mapCacheSet = __webpack_require__(989);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(937),
    isObjectLike = __webpack_require__(107);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 218 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(34),
    isSymbol = __webpack_require__(224);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(931);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 221 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(936),
    isObjectLike = __webpack_require__(107);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 223 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(106),
    isObjectLike = __webpack_require__(107);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(951);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMLazyTree = __webpack_require__(78);
var Danger = __webpack_require__(1034);
var ReactDOMComponentTree = __webpack_require__(15);
var ReactInstrumentation = __webpack_require__(32);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(235);
var setInnerHTML = __webpack_require__(151);
var setTextContent = __webpack_require__(548);

function getNodeAfter(parentNode, node) {
  // Special case for text components, which return [open, close] comments
  // from getHostNode.
  if (Array.isArray(node)) {
    node = node[1];
  }
  return node ? node.nextSibling : parentNode.firstChild;
}

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
  // We rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
  // we are careful to use `null`.)
  parentNode.insertBefore(childNode, referenceNode);
});

function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
}

function moveChild(parentNode, childNode, referenceNode) {
  if (Array.isArray(childNode)) {
    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
  } else {
    insertChildAt(parentNode, childNode, referenceNode);
  }
}

function removeChild(parentNode, childNode) {
  if (Array.isArray(childNode)) {
    var closingComment = childNode[1];
    childNode = childNode[0];
    removeDelimitedText(parentNode, childNode, closingComment);
    parentNode.removeChild(closingComment);
  }
  parentNode.removeChild(childNode);
}

function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
  var node = openingComment;
  while (true) {
    var nextNode = node.nextSibling;
    insertChildAt(parentNode, node, referenceNode);
    if (node === closingComment) {
      break;
    }
    node = nextNode;
  }
}

function removeDelimitedText(parentNode, startNode, closingComment) {
  while (true) {
    var node = startNode.nextSibling;
    if (node === closingComment) {
      // The closing comment is removed by ReactMultiChild.
      break;
    } else {
      parentNode.removeChild(node);
    }
  }
}

function replaceDelimitedText(openingComment, closingComment, stringText) {
  var parentNode = openingComment.parentNode;
  var nodeAfterComment = openingComment.nextSibling;
  if (nodeAfterComment === closingComment) {
    // There are no text nodes between the opening and closing comments; insert
    // a new one if stringText isn't empty.
    if (stringText) {
      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
    }
  } else {
    if (stringText) {
      // Set the text content of the first node after the opening comment, and
      // remove all following nodes up until the closing comment.
      setTextContent(nodeAfterComment, stringText);
      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
    } else {
      removeDelimitedText(parentNode, openingComment, closingComment);
    }
  }

  if (false) {
    ReactInstrumentation.debugTool.onHostOperation({
      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
      type: 'replace text',
      payload: stringText
    });
  }
}

var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
if (false) {
  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
    if (prevInstance._debugID !== 0) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: prevInstance._debugID,
        type: 'replace with',
        payload: markup.toString()
      });
    } else {
      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
      if (nextInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: nextInstance._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  };
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {

  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,

  replaceDelimitedText: replaceDelimitedText,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  processUpdates: function (parentNode, updates) {
    if (false) {
      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
    }

    for (var k = 0; k < updates.length; k++) {
      var update = updates[k];
      switch (update.type) {
        case 'INSERT_MARKUP':
          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'insert child',
              payload: { toIndex: update.toIndex, content: update.content.toString() }
            });
          }
          break;
        case 'MOVE_EXISTING':
          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'move child',
              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
            });
          }
          break;
        case 'SET_MARKUP':
          setInnerHTML(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace children',
              payload: update.content.toString()
            });
          }
          break;
        case 'TEXT_CONTENT':
          setTextContent(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace text',
              payload: update.content.toString()
            });
          }
          break;
        case 'REMOVE_NODE':
          removeChild(parentNode, update.fromNode);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'remove child',
              payload: { fromIndex: update.fromIndex }
            });
          }
          break;
      }
    }
  }

};

module.exports = DOMChildrenOperations;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = DOMNamespaces;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(7);

var invariant = __webpack_require__(4);

/**
 * Injectable ordering of event plugins.
 */
var eventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!eventPluginOrder) {
    // Wait until an `eventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var pluginModule = namesToPlugins[pluginName];
    var pluginIndex = eventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
    var publishedEvents = pluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, pluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;

  if (false) {
    var lowerCasedName = registrationName.toLowerCase();
    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
    }
  }
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {

  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Mapping from lowercase registration names to the properly cased version,
   * used to warn in the case of missing event handlers. Available
   * only in __DEV__.
   * @type {Object}
   */
  possibleRegistrationNames:  false ? {} : null,
  // Trust the developer to only use possibleRegistrationNames in __DEV__

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (injectedEventPluginOrder) {
    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
    // Clone the ordering so it cannot be dynamically mutated.
    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var pluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
        namesToPlugins[pluginName] = pluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    if (dispatchConfig.phasedRegistrationNames !== undefined) {
      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
      // that it is not undefined.
      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;

      for (var phase in phasedRegistrationNames) {
        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
          continue;
        }
        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
        if (pluginModule) {
          return pluginModule;
        }
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    eventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }

    if (false) {
      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
      for (var lowerCasedName in possibleRegistrationNames) {
        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
          delete possibleRegistrationNames[lowerCasedName];
        }
      }
    }
  }

};

module.exports = EventPluginRegistry;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var ReactErrorUtils = __webpack_require__(233);

var invariant = __webpack_require__(4);
var warning = __webpack_require__(6);

/**
 * Injected dependencies:
 */

/**
 * - `ComponentTree`: [required] Module that can convert between React instances
 *   and actual node references.
 */
var ComponentTree;
var TreeTraversal;
var injection = {
  injectComponentTree: function (Injected) {
    ComponentTree = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
    }
  },
  injectTreeTraversal: function (Injected) {
    TreeTraversal = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
    }
  }
};

function isEndish(topLevelType) {
  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
}

function isMoveish(topLevelType) {
  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
}
function isStartish(topLevelType) {
  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
}

var validateEventDispatches;
if (false) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    var instancesIsArr = Array.isArray(dispatchInstances);
    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;

    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */
function executeDispatch(event, simulated, listener, inst) {
  var type = event.type || 'unknown-event';
  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
  }
  event._dispatchListeners = null;
  event._dispatchInstances = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchInstances[i])) {
        return dispatchInstances[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchInstances)) {
      return dispatchInstances;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchInstances = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (false) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchInstance = event._dispatchInstances;
  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
  var res = dispatchListener ? dispatchListener(event) : null;
  event.currentTarget = null;
  event._dispatchListeners = null;
  event._dispatchInstances = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getInstanceFromNode: function (node) {
    return ComponentTree.getInstanceFromNode(node);
  },
  getNodeFromInstance: function (node) {
    return ComponentTree.getNodeFromInstance(node);
  },
  isAncestor: function (a, b) {
    return TreeTraversal.isAncestor(a, b);
  },
  getLowestCommonAncestor: function (a, b) {
    return TreeTraversal.getLowestCommonAncestor(a, b);
  },
  getParentInstance: function (inst) {
    return TreeTraversal.getParentInstance(inst);
  },
  traverseTwoPhase: function (target, fn, arg) {
    return TreeTraversal.traverseTwoPhase(target, fn, arg);
  },
  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
  },

  injection: injection
};

module.exports = EventPluginUtils;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var ReactPropTypesSecret = __webpack_require__(1063);
var propTypesFactory = __webpack_require__(528);

var React = __webpack_require__(85);
var PropTypes = propTypesFactory(React.isValidElement);

var invariant = __webpack_require__(4);
var warning = __webpack_require__(6);

var hasReadOnlyValue = {
  'button': true,
  'checkbox': true,
  'image': true,
  'hidden': true,
  'radio': true,
  'reset': true,
  'submit': true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: PropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(7);

var invariant = __webpack_require__(4);

var injected = false;

var ReactComponentEnvironment = {

  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkup: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }

};

module.exports = ReactComponentEnvironment;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a) {
  try {
    func(a);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (false) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
      var boundFunc = func.bind(null, a);
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var ReactCurrentOwner = __webpack_require__(48);
var ReactInstanceMap = __webpack_require__(112);
var ReactInstrumentation = __webpack_require__(32);
var ReactUpdates = __webpack_require__(35);

var invariant = __webpack_require__(4);
var warning = __webpack_require__(6);

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function formatUnexpectedArgument(arg) {
  var type = typeof arg;
  if (type !== 'object') {
    return type;
  }
  var displayName = arg.constructor && arg.constructor.name || type;
  var keys = Object.keys(arg);
  if (keys.length > 0 && keys.length < 20) {
    return displayName + ' (keys: ' + keys.join(', ') + ')';
  }
  return displayName;
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (false) {
      var ctor = publicInstance.constructor;
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
    }
    return null;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (false) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @param {string} callerName Name of the calling function in the public API.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback, callerName) {
    ReactUpdateQueue.validateCallback(callback, callerName);
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    // Future-proof 15.5
    if (callback !== undefined && callback !== null) {
      ReactUpdateQueue.validateCallback(callback, 'replaceState');
      if (internalInstance._pendingCallbacks) {
        internalInstance._pendingCallbacks.push(callback);
      } else {
        internalInstance._pendingCallbacks = [callback];
      }
    }

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    if (false) {
      ReactInstrumentation.debugTool.onSetState();
      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
    }

    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
    internalInstance._pendingElement = nextElement;
    // TODO: introduce _pendingContext instead of setting it directly.
    internalInstance._context = nextContext;
    enqueueUpdate(internalInstance);
  },

  validateCallback: function (callback, callerName) {
    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
  }

};

module.exports = ReactUpdateQueue;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals MSApp */



/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */

var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */

function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  'Alt': 'altKey',
  'Control': 'ctrlKey',
  'Meta': 'metaKey',
  'Shift': 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;

  // Normalize SVG <use> element events #4963
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(26);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */

function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
}

module.exports = shouldUpdateReactComponent;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(10);

var emptyFunction = __webpack_require__(30);
var warning = __webpack_require__(6);

var validateDOMNesting = emptyFunction;

if (false) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    current: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
      case '#document':
        return tag === 'html';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':
      case 'pre':
      case 'listing':
      case 'table':
      case 'hr':
      case 'xmp':
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    do {
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      var tagDisplayName = childTag;
      var whitespaceInfo = '';
      if (childTag === '#text') {
        if (/\S/.test(childText)) {
          tagDisplayName = 'Text nodes';
        } else {
          tagDisplayName = 'Whitespace text nodes';
          whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
        }
      } else {
        tagDisplayName = '<' + childTag + '>';
      }

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
      } else {
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
      }
    }
  };

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(11), __webpack_require__(1099), __webpack_require__(1101), __webpack_require__(1100), __webpack_require__(551)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./Button'), require('./FlatButton'), require('./RaisedButton'), require('./FloatingButton'), require('./IconButton'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.Button, global.FlatButton, global.RaisedButton, global.FloatingButton, global.IconButton);
    global.index = mod.exports;
  }
})(this, function (exports, _Button2, _FlatButton2, _RaisedButton2, _FloatingButton2, _IconButton2) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.IconButton = exports.FloatingButton = exports.RaisedButton = exports.FlatButton = exports.Button = undefined;

  var _Button3 = _interopRequireDefault(_Button2);

  var _FlatButton3 = _interopRequireDefault(_FlatButton2);

  var _RaisedButton3 = _interopRequireDefault(_RaisedButton2);

  var _FloatingButton3 = _interopRequireDefault(_FloatingButton2);

  var _IconButton3 = _interopRequireDefault(_IconButton2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _Button3.default;
  exports.Button = _Button3.default;
  exports.FlatButton = _FlatButton3.default;
  exports.RaisedButton = _RaisedButton3.default;
  exports.FloatingButton = _FloatingButton3.default;
  exports.IconButton = _IconButton3.default;
});

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(1200), __webpack_require__(65), __webpack_require__(153)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('../utils/PropTypes/requiredForA11yIfNot'), require('../utils/PropTypes/invalidIf'), require('./contextTypes'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.requiredForA11yIfNot, global.invalidIf, global.contextTypes);
    global.DataTable = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _requiredForA11yIfNot, _invalidIf, _contextTypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _requiredForA11yIfNot2 = _interopRequireDefault(_requiredForA11yIfNot);

  var _invalidIf2 = _interopRequireDefault(_invalidIf);

  var _contextTypes2 = _interopRequireDefault(_contextTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var DataTable = function (_PureComponent) {
    _inherits(DataTable, _PureComponent);

    function DataTable(props) {
      _classCallCheck(this, DataTable);

      var _this = _possibleConstructorReturn(this, (DataTable.__proto__ || Object.getPrototypeOf(DataTable)).call(this, props));

      var rows = props.defaultSelectedRows;
      _this.state = {
        allSelected: _this._allSelected(rows),
        selectedRows: rows
      };

      _this._removed = 0;
      _this._initial = true;
      _this._toggleAllRows = _this._toggleAllRows.bind(_this);
      _this._toggleSelectedRow = _this._toggleSelectedRow.bind(_this);
      _this._createCheckbox = _this._createCheckbox.bind(_this);
      _this._removeCheckbox = _this._removeCheckbox.bind(_this);
      return _this;
    }

    _createClass(DataTable, [{
      key: 'getChildContext',
      value: function getChildContext() {
        var _props = this.props,
            uncheckedIconChildren = _props.uncheckedIconChildren,
            uncheckedIconClassName = _props.uncheckedIconClassName,
            checkedIconChildren = _props.checkedIconChildren,
            checkedIconClassName = _props.checkedIconClassName,
            plain = _props.plain,
            baseId = _props.baseId;


        return {
          uncheckedIconChildren: uncheckedIconChildren,
          uncheckedIconClassName: uncheckedIconClassName,
          checkedIconChildren: checkedIconChildren,
          checkedIconClassName: checkedIconClassName,
          plain: plain,
          allSelected: this.state.allSelected,
          selectedRows: this.state.selectedRows,
          toggleAllRows: this._toggleAllRows,
          toggleSelectedRow: this._toggleSelectedRow,
          createCheckbox: this._createCheckbox,
          removeCheckbox: this._removeCheckbox,
          baseId: baseId,
          baseName: baseId + '-control'
        };
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        this._removed = 0;
        this._initial = false;
      }
    }, {
      key: '_allSelected',
      value: function _allSelected(rows) {
        var all = rows.length !== 0;
        rows.some(function (checked) {
          if (!checked) {
            all = false;
          }

          return !all;
        });

        return all;
      }
    }, {
      key: '_createCheckbox',
      value: function _createCheckbox(index) {
        var _this2 = this;

        this.setState(function (state, props) {
          var selectedRows = state.selectedRows.slice();
          // Only use the default selected rows prop on first mount. If other changes occur after,
          // default to false.
          var selected = _this2._initial && props.defaultSelectedRows[index] || false;
          selectedRows.splice(index, 0, selected);
          return { selectedRows: selectedRows, allSelected: _this2._allSelected(selectedRows) };
        });
      }
    }, {
      key: '_removeCheckbox',
      value: function _removeCheckbox(index) {
        var _this3 = this;

        this.setState(function (state) {
          // When multiple checkboxes are removed in a render cycle, they are removed in list order.
          // So to keep the index correct while removing, need to keep subract the provided index by
          // the current number of removed elements. This value gets reset to 0 after a finished cycle.
          var selectedRows = state.selectedRows.slice();
          selectedRows.splice(index - _this3._removed, 1);
          _this3._removed += 1;
          return { selectedRows: selectedRows, allSelected: _this3._allSelected(selectedRows) };
        });
      }
    }, {
      key: '_toggleAllRows',
      value: function _toggleAllRows() {
        var allSelected = !this.state.allSelected;
        if (this.props.onRowToggle) {
          this.props.onRowToggle(-1, allSelected, allSelected ? this.state.selectedRows.length : 0);
        }

        this.setState({
          allSelected: allSelected,
          selectedRows: this.state.selectedRows.map(function () {
            return allSelected;
          })
        });
      }
    }, {
      key: '_toggleSelectedRow',
      value: function _toggleSelectedRow(row) {
        var selectedRows = this.state.selectedRows.slice();
        selectedRows[row] = !selectedRows[row];
        var selectedCount = selectedRows.filter(function (selected) {
          return selected;
        }).length;

        if (this.props.onRowToggle) {
          this.props.onRowToggle(row, selectedRows[row], selectedCount);
        }

        this.setState({ selectedRows: selectedRows, allSelected: this._allSelected(selectedRows) });
      }
    }, {
      key: 'render',
      value: function render() {
        var _props2 = this.props,
            className = _props2.className,
            children = _props2.children,
            plain = _props2.plain,
            responsive = _props2.responsive,
            props = _objectWithoutProperties(_props2, ['className', 'children', 'plain', 'responsive']);

        delete props.checkedIconChildren;
        delete props.checkedIconClassName;
        delete props.uncheckedIconChildren;
        delete props.uncheckedIconClassName;
        delete props.defaultSelectedRows;
        delete props.baseId;
        delete props.onRowToggle;

        var table = _react2.default.createElement(
          'table',
          _extends({}, props, {
            className: (0, _classnames2.default)('md-data-table', {
              'md-data-table--plain': plain
            }, className)
          }),
          children
        );

        return responsive ? _react2.default.createElement(
          'div',
          { className: 'md-data-table--responsive' },
          table
        ) : table;
      }
    }]);

    return DataTable;
  }(_react.PureComponent);

  DataTable.propTypes = {
    /**
     * A base id to use for every checkbox or `EditDialogColumn` in the data table. This is
     * required for a11y if the data table is not plain.
     */
    baseId: (0, _requiredForA11yIfNot2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]), 'plain'),

    /**
     * Optional style to apply to the table.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply to the table.
     */
    className: _propTypes2.default.string,

    /**
     * The table contents to display. This *should* be a list of `TableHeader` and `TableBody`
     * components.
     */
    children: _propTypes2.default.node.isRequired,

    /**
     * An optional array of booleans denoting if a row is selected.
     * This is an associative array so the index must match the row
     * number in the `TableBody` component.
     */
    defaultSelectedRows: _propTypes2.default.arrayOf(_propTypes2.default.bool).isRequired,

    /**
     * Boolean if the table is responsive. This will wrap the table in a container
     * that allows scrolling to the right if overflow exists.
     */
    responsive: _propTypes2.default.bool.isRequired,

    /**
     * Boolean if this table should not include the checkboxes on each row.
     * This really means that the entire table is unselectable and you wish
     * to display as a normal table.
     */
    plain: _propTypes2.default.bool,

    /**
     * The icon className to use for the unchecked row icon. This value
     * will be passed down as `context`.
     */
    uncheckedIconClassName: _propTypes2.default.string.isRequired,

    /**
     * The icon children to use for the unchecked row icon. This value
     * will be passed down as `context`.
     */
    uncheckedIconChildren: _propTypes2.default.node,

    /**
     * The icon className to use for the checked row icon. This value
     * will be passed down as `context`.
     */
    checkedIconClassName: _propTypes2.default.string.isRequired,

    /**
     * The icon children to use for the checked row icon. This value
     * will be passed down as `context`.
     */
    checkedIconChildren: _propTypes2.default.node,

    /**
     * An optional function to call when a non-plain data table has a row toggled.
     * The callback will include the selected row id, the boolean if it is now selected,
     * and the count of rows that are selected. If the checkbox in the `TableHeader` was
     * clicked, the selected row id will be `-1`.
     *
     * ```js
     * onRowToggle(3, true, 8); // 4th row was toggled
     * onRowToggle(-1, true, 15); // select all checkbox was toggled on.
     * ```
     */
    onRowToggle: (0, _invalidIf2.default)(_propTypes2.default.func, 'plain')
  };
  DataTable.defaultProps = {
    uncheckedIconChildren: 'check_box_outline_blank',
    uncheckedIconClassName: 'material-icons',
    checkedIconChildren: 'check_box',
    checkedIconClassName: 'material-icons',
    defaultSelectedRows: [],
    responsive: true
  };
  DataTable.childContextTypes = _contextTypes2.default;
  exports.default = DataTable;
});

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(153)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('./contextTypes'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.contextTypes);
    global.TableBody = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _contextTypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _contextTypes2 = _interopRequireDefault(_contextTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var TableBody = function (_Component) {
    _inherits(TableBody, _Component);

    function TableBody() {
      _classCallCheck(this, TableBody);

      return _possibleConstructorReturn(this, (TableBody.__proto__ || Object.getPrototypeOf(TableBody)).apply(this, arguments));
    }

    _createClass(TableBody, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            children = _props.children,
            className = _props.className,
            props = _objectWithoutProperties(_props, ['children', 'className']);

        var _context = this.context,
            selectedRows = _context.selectedRows,
            toggleSelectedRow = _context.toggleSelectedRow;


        var rows = children ? _react.Children.map(_react.Children.toArray(children), function (row, i) {
          var uncontrolled = typeof row.props.selected === 'undefined';

          // Update the row to inject the selected prop from context if it is uncontrolled.
          // Also update the onCheckbox click function to additionally toggle the row if uncontrolled.
          return _react2.default.cloneElement(row, _extends({}, row.props, {
            index: i,
            selected: uncontrolled ? selectedRows[i] : row.props.selected,
            onCheckboxClick: function onCheckboxClick(checked, e) {
              if (row.props.onCheckboxClick) {
                row.props.onCheckboxClick(i, checked, e);
              }

              if (uncontrolled) {
                toggleSelectedRow(i);
              }
            }
          }));
        }) : null;

        return _react2.default.createElement(
          'tbody',
          _extends({}, props, { className: (0, _classnames2.default)('md-table-body', className) }),
          rows
        );
      }
    }]);

    return TableBody;
  }(_react.Component);

  TableBody.propTypes = {
    /**
     * An optional style to apply to the tbody.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply to the tbody.
     */
    className: _propTypes2.default.string,

    /**
     * A list or a single item of `TableRow` components to render.
     */
    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)])
  };
  TableBody.contextTypes = _contextTypes2.default;
  exports.default = TableBody;
});

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(153), __webpack_require__(247)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('./contextTypes'), require('./headerContextTypes'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.contextTypes, global.headerContextTypes);
    global.TableHeader = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _contextTypes, _headerContextTypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _contextTypes2 = _interopRequireDefault(_contextTypes);

  var _headerContextTypes2 = _interopRequireDefault(_headerContextTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var TableHeader = function (_Component) {
    _inherits(TableHeader, _Component);

    function TableHeader() {
      _classCallCheck(this, TableHeader);

      return _possibleConstructorReturn(this, (TableHeader.__proto__ || Object.getPrototypeOf(TableHeader)).apply(this, arguments));
    }

    _createClass(TableHeader, [{
      key: 'getChildContext',
      value: function getChildContext() {
        return _extends({}, this.context, {
          header: true
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            className = _props.className,
            children = _props.children,
            props = _objectWithoutProperties(_props, ['className', 'children']);

        var _context = this.context,
            toggleAllRows = _context.toggleAllRows,
            allSelected = _context.allSelected;

        var header = _react2.default.Children.only(children);
        var selected = typeof header.props.selected === 'undefined' ? allSelected : header.props.selected;

        var row = _react2.default.cloneElement(header, _extends({}, header.props, {
          selected: selected,
          onCheckboxClick: function onCheckboxClick(checked, e) {
            if (header.props.onCheckboxClick) {
              header.props.onCheckboxClick(-1, checked, e);
            }

            if (typeof header.props.selected === 'undefined') {
              toggleAllRows();
            }
          }
        }));

        return _react2.default.createElement(
          'thead',
          _extends({}, props, { className: (0, _classnames2.default)('md-table-header', className) }),
          row
        );
      }
    }]);

    return TableHeader;
  }(_react.Component);

  TableHeader.contextTypes = _contextTypes2.default;
  TableHeader.childContextTypes = _headerContextTypes2.default;
  TableHeader.propTypes = {
    /**
     * An optional style to apply.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply to the table header
     */
    className: _propTypes2.default.string,

    /**
     * This should be a single `TableRow` component. The `custom` validation will
     * warn you if there are more than one children given or none at all.
     */
    children: function children(props, propName, component) {
      try {
        _react2.default.Children.only(props.children);
        return null;
      } catch (e) {
        var amt = props.children ? props.children.length : 0;
        return new Error('There must only be one child in a \'' + component + '\', but ' + amt + ' were given.');
      }
    }
  };
  exports.default = TableHeader;
});

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(16), __webpack_require__(247), __webpack_require__(1114), __webpack_require__(1111)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('../utils/getField'), require('./headerContextTypes'), require('./rowContextTypes'), require('./TableCheckbox'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.getField, global.headerContextTypes, global.rowContextTypes, global.TableCheckbox);
    global.TableRow = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _getField, _headerContextTypes, _rowContextTypes, _TableCheckbox) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _getField2 = _interopRequireDefault(_getField);

  var _headerContextTypes2 = _interopRequireDefault(_headerContextTypes);

  var _rowContextTypes2 = _interopRequireDefault(_rowContextTypes);

  var _TableCheckbox2 = _interopRequireDefault(_TableCheckbox);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var TableRow = function (_Component) {
    _inherits(TableRow, _Component);

    function TableRow(props, context) {
      _classCallCheck(this, TableRow);

      var _this = _possibleConstructorReturn(this, (TableRow.__proto__ || Object.getPrototypeOf(TableRow)).call(this, props, context));

      _this.state = {
        biggest: null,
        hover: false,
        selects: []
      };

      _this._handleMouseOver = _this._handleMouseOver.bind(_this);
      _this._handleMouseLeave = _this._handleMouseLeave.bind(_this);
      _this._setLongestColumn = _this._setLongestColumn.bind(_this);
      return _this;
    }

    _createClass(TableRow, [{
      key: 'getChildContext',
      value: function getChildContext() {
        var _context = this.context,
            baseId = _context.baseId,
            context = _objectWithoutProperties(_context, ['baseId']);

        return _extends({}, context, {
          rowId: context.header ? baseId + 'CheckboxToggleAll' : '' + baseId + this.props.index
        });
      }
    }, {
      key: '_ignoreHoverState',
      value: function _ignoreHoverState(classList) {
        return classList.contains('md-list--menu') || ['md-edit-dialog', 'md-edit-dialog--active'].every(function (className) {
          return classList.contains(className);
        });
      }
    }, {
      key: '_handleMouseOver',
      value: function _handleMouseOver(e) {
        if (this.props.onMouseOver) {
          this.props.onMouseOver(e);
        }

        if (this.context.header) {
          return;
        }

        var target = e.target;
        while (target && target.parentNode) {
          if (target.classList && this._ignoreHoverState(target.classList)) {
            this.setState({ hover: false });
            return;
          }

          target = target.parentNode;
        }

        this.setState({ hover: true });
      }
    }, {
      key: '_handleMouseLeave',
      value: function _handleMouseLeave(e) {
        if (this.props.onMouseLeave) {
          this.props.onMouseLeave(e);
        }

        if (this.context.header) {
          return;
        }

        this.setState({ hover: false });
      }
    }, {
      key: '_setLongestColumn',
      value: function _setLongestColumn(row) {
        if (!row || !this.props.autoAdjust) {
          return;
        }

        var selects = [];
        var cols = Array.prototype.slice.call(row.querySelectorAll('.md-table-column'));
        var biggest = cols.reduce(function (prevBiggest, col, i) {
          selects.push(!!col.className.match(/select-field/));
          if (col.className.match(/prevent-grow/)) {
            return prevBiggest;
          }

          var width = col.offsetWidth;
          if (prevBiggest.width < width) {
            return { width: width, index: i };
          }

          return prevBiggest;
        }, { width: 0, index: 0 });

        if (this.state.biggest && this.state.biggest.index === biggest.index) {
          return;
        }

        this.setState({ biggest: biggest, selects: selects });
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _state = this.state,
            hover = _state.hover,
            biggest = _state.biggest,
            selects = _state.selects;

        var _props = this.props,
            className = _props.className,
            children = _props.children,
            selected = _props.selected,
            onCheckboxClick = _props.onCheckboxClick,
            props = _objectWithoutProperties(_props, ['className', 'children', 'selected', 'onCheckboxClick']);

        delete props.index;
        delete props.autoAdjust;

        var checkbox = void 0;
        if (!this.context.plain) {
          checkbox = _react2.default.createElement(_TableCheckbox2.default, { key: 'checkbox', checked: selected, onChange: onCheckboxClick });
        }

        var length = children.length;
        var columns = _react.Children.map(_react.Children.toArray(children), function (col, i) {
          return (0, _react.cloneElement)(col, {
            header: (0, _getField2.default)(col.props, _this2.context, 'header'),
            className: (0, _classnames2.default)({
              'md-table-column--grow': (0, _getField2.default)(col.props, _this2.context, 'header') && biggest && biggest.index === i,
              'md-table-column--adjusted': selects.length && !selects[i] && biggest && biggest.index !== i && i + 1 < length
            }, col.props.className)
          });
        });

        return _react2.default.createElement(
          'tr',
          _extends({}, props, {
            ref: this._setLongestColumn,
            className: (0, _classnames2.default)('md-table-row', className, {
              'md-table-row--hover': hover,
              'md-table-row--active': !this.context.header && selected
            }),
            onMouseOver: this._handleMouseOver,
            onMouseLeave: this._handleMouseLeave
          }),
          checkbox,
          columns
        );
      }
    }]);

    return TableRow;
  }(_react.Component);

  TableRow.propTypes = {
    /**
     * An optional style to apply.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply to the row.
     */
    className: _propTypes2.default.string,

    /**
     * A single or list of `TableColumn` to display in the table.
     *
     * > The specs "require" at least 3 columns for a non-plain data table, but that isn't
     * strictly enforced here.
     */
    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)]).isRequired,

    /**
     * An optional onClick function to call when a row is clicked.
     */
    onClick: _propTypes2.default.func,

    /**
     * A function to call when the checkbox is clicked. This
     * function will will be called with `(rowIndex, event)`. The
     * `TableBody` and `TableHeader` components will automatically
     * merge in a function to toggle the checkbox.
     */
    onCheckboxClick: _propTypes2.default.func,

    /**
     * A boolean if the row should automatically check all the `TableColumn`s in the row
     * and add the className `grow` to the one that is the biggest. You can also disable
     * individual columns by adding the className `.prevent-grow` to them.
     */
    autoAdjust: _propTypes2.default.bool.isRequired,

    /**
     * An optional function to call onMouseOver.
     */
    onMouseOver: _propTypes2.default.func,

    /**
     * An optional function to call onMouseLeave.
     */
    onMouseLeave: _propTypes2.default.func,

    /**
     * Boolean if the row is currently selected. If this value will be
     * injected by the `TableHeader` or `TableBody` component.
     */
    selected: _propTypes2.default.bool,

    /**
     * The row's index in the table. This is injected via the `TableBody` component.
     */
    index: _propTypes2.default.number
  };
  TableRow.defaultProps = {
    autoAdjust: true
  };
  TableRow.contextTypes = _headerContextTypes2.default;
  TableRow.childContextTypes = _rowContextTypes2.default;
  exports.default = TableRow;
});

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(153)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('prop-types'), require('./contextTypes'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.propTypes, global.contextTypes);
    global.headerContextTypes = mod.exports;
  }
})(this, function (exports, _propTypes, _contextTypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _contextTypes2 = _interopRequireDefault(_contextTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = Object.assign({}, _contextTypes2.default, { header: _propTypes2.default.bool });
});

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(9), __webpack_require__(66), __webpack_require__(3), __webpack_require__(12), __webpack_require__(17), __webpack_require__(14), __webpack_require__(38), __webpack_require__(16), __webpack_require__(1203), __webpack_require__(1198), __webpack_require__(1115), __webpack_require__(82)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('react-dom'), require('react-transition-group/CSSTransitionGroup'), require('classnames'), require('react-prop-types/lib/deprecated'), require('react-prop-types/lib/isRequiredForA11y'), require('../constants/keyCodes'), require('../constants/CSSTransitionGroupTick'), require('../utils/getField'), require('../utils/toggleScroll'), require('../utils/PropTypes/oneRequiredForA11y'), require('./Dialog'), require('../Helpers/Portal'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.reactDom, global.CSSTransitionGroup, global.classnames, global.deprecated, global.isRequiredForA11y, global.keyCodes, global.CSSTransitionGroupTick, global.getField, global.toggleScroll, global.oneRequiredForA11y, global.Dialog, global.Portal);
    global.DialogContainer = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _reactDom, _CSSTransitionGroup, _classnames, _deprecated, _isRequiredForA11y, _keyCodes, _CSSTransitionGroupTick, _getField, _toggleScroll, _oneRequiredForA11y, _Dialog, _Portal) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _deprecated2 = _interopRequireDefault(_deprecated);

  var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);

  var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);

  var _getField2 = _interopRequireDefault(_getField);

  var _toggleScroll2 = _interopRequireDefault(_toggleScroll);

  var _oneRequiredForA11y2 = _interopRequireDefault(_oneRequiredForA11y);

  var _Dialog2 = _interopRequireDefault(_Dialog);

  var _Portal2 = _interopRequireDefault(_Portal);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var DialogContainer = function (_PureComponent) {
    _inherits(DialogContainer, _PureComponent);

    function DialogContainer(props) {
      _classCallCheck(this, DialogContainer);

      var _this = _possibleConstructorReturn(this, (DialogContainer.__proto__ || Object.getPrototypeOf(DialogContainer)).call(this, props));

      var visible = typeof props.isOpen !== 'undefined' ? props.isOpen : props.visible;
      var dialogVisible = visible && !props.defaultVisibleTransitionable;

      _this.state = {
        active: visible && !props.fullPage,
        overlay: visible && !props.fullPage,
        portalVisible: visible,
        dialogVisible: dialogVisible
      };
      _this._setContainer = _this._setContainer.bind(_this);
      _this._handleClick = _this._handleClick.bind(_this);
      _this._handleDialogMounting = _this._handleDialogMounting.bind(_this);
      _this._mountPortal = _this._mountPortal.bind(_this);
      _this._mountDialog = _this._mountDialog.bind(_this);
      _this._unmountPortal = _this._unmountPortal.bind(_this);
      _this._handleEscClose = _this._handleEscClose.bind(_this);
      return _this;
    }
    /* eslint-disable max-len */


    _createClass(DialogContainer, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (!this.props.isOpen && !this.props.visible) {
          return;
        }

        this._mountDialog(this.props);
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var visible = typeof nextProps.isOpen !== 'undefined' ? nextProps.isOpen : nextProps.visible;
        if (this.props.isOpen === visible || this.props.visible === visible) {
          return;
        }

        var el = (0, _getField2.default)(this.props, this.context, 'renderNode') || window;
        var pageX = el.scrollX,
            pageY = el.scrollY;

        if (typeof el.scrollTop !== 'undefined' && typeof el.scrollLeft !== 'undefined') {
          pageX = el.scrollLeft;
          pageY = el.scrollTop;
        } else if (typeof el.scrollY !== 'undefined' && typeof el.scrollX !== 'undefined') {
          pageX = el.scrollX;
          pageY = el.scrollY;
        }

        this._pageX = pageX;
        this._pageY = pageY;

        if (visible) {
          this._activeElement = document.activeElement;
          this._mountPortal(nextProps);
        } else {
          this.setState({ dialogVisible: false, active: false });
        }
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        var _props = this.props,
            visible = _props.visible,
            closeOnEsc = _props.closeOnEsc,
            modal = _props.modal;

        var escapable = !modal && closeOnEsc;
        var prevEscapable = !prevProps.modal && prevProps.closeOnEsc;

        // Only going to support visible here since it was not implemented before.
        if (visible === prevProps.visible && escapable === prevEscapable) {
          return;
        }

        var add = false;
        var remove = false;

        if (escapable !== prevEscapable) {
          add = visible && escapable;
          remove = !visible || prevEscapable && !escapable;
        } else if (escapable) {
          add = visible;
          remove = !visible;
        }

        if (add) {
          window.addEventListener('keydown', this._handleEscClose);
        } else if (remove) {
          window.removeEventListener('keydown', this._handleEscClose);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.props.isOpen || this.props.visible) {
          (0, _toggleScroll2.default)(false);
        }

        if (this.props.visible && this.props.closeOnEsc && !this.props.modal) {
          window.removeEventListener('keydown', this._handleEscClose);
        }

        if (this._inTimeout) {
          clearTimeout(this._inTimeout);
        }
      }
    }, {
      key: '_setContainer',
      value: function _setContainer(container) {
        if (container !== null) {
          this._container = (0, _reactDom.findDOMNode)(container);
        }
      }
    }, {
      key: '_handleEscClose',
      value: function _handleEscClose(e) {
        if ((e.which || e.keyCode) === _keyCodes.ESC) {
          (this.props.onHide || this.props.close)(e);
        }
      }
    }, {
      key: '_mountPortal',
      value: function _mountPortal(props) {
        this._mountDialog(props);
        this.setState({ portalVisible: true });
      }
    }, {
      key: '_mountDialog',
      value: function _mountDialog(props) {
        var _this2 = this;

        var fullPage = props.fullPage,
            onShow = props.onShow;

        this._inTimeout = setTimeout(function () {
          _this2._inTimeout = fullPage ? null : setTimeout(function () {
            _this2._inTimeout = null;
            _this2.setState({ active: true });
          }, _CSSTransitionGroupTick2.default);
          _this2.setState({ dialogVisible: true, overlay: !fullPage }, onShow);
        }, _CSSTransitionGroupTick2.default);
      }
    }, {
      key: '_unmountPortal',
      value: function _unmountPortal() {
        this.setState({ portalVisible: false });
      }
    }, {
      key: '_handleClick',
      value: function _handleClick(e) {
        var visible = typeof this.props.isOpen !== 'undefined' ? this.props.isOpen : this.props.visible;
        if (this.props.modal || !visible || e.target !== this._container) {
          return;
        }

        (this.props.onHide || this.props.close)(e);
      }
    }, {
      key: '_handleDialogMounting',
      value: function _handleDialogMounting(dialog) {
        var disableScrollLocking = this.props.disableScrollLocking;

        if (dialog === null) {
          if (this._activeElement) {
            this._activeElement.focus();
          }

          if (!disableScrollLocking) {
            (0, _toggleScroll2.default)(false, this.scrollEl);
          }

          this._activeElement = null;
          this.setState({ overlay: false });
        } else {
          var container = document.querySelector('#' + this.props.id);
          if (!container || disableScrollLocking) {
            return;
          }

          var el = (0, _getField2.default)(this.props, this.context, 'renderNode');
          var node = container.parentNode;
          while (node && node.classList && !el) {
            if (node.classList.contains('md-dialog')) {
              el = node;
            }

            node = node.parentNode;
          }

          this.scrollEl = el;
          (0, _toggleScroll2.default)(true, el);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _state = this.state,
            overlay = _state.overlay,
            active = _state.active,
            dialogVisible = _state.dialogVisible,
            portalVisible = _state.portalVisible;

        var _props2 = this.props,
            style = _props2.style,
            className = _props2.className,
            dialogStyle = _props2.dialogStyle,
            dialogClassName = _props2.dialogClassName,
            modal = _props2.modal,
            fullPage = _props2.fullPage,
            component = _props2.component,
            transitionEnterTimeout = _props2.transitionEnterTimeout,
            transitionLeaveTimeout = _props2.transitionLeaveTimeout,
            lastChild = _props2.lastChild,
            props = _objectWithoutProperties(_props2, ['style', 'className', 'dialogStyle', 'dialogClassName', 'modal', 'fullPage', 'component', 'transitionEnterTimeout', 'transitionLeaveTimeout', 'lastChild']);

        delete props.renderNode;
        delete props.close;
        delete props.isOpen;
        delete props.visible;
        delete props.onShow;
        delete props.onHide;
        delete props.actionLeft;
        delete props.actionRight;
        delete props.transitionName;
        delete props.transitionEnter;
        delete props.transitionLeave;
        delete props.closeOnEsc;
        delete props.disableScrollLocking;
        delete props.defaultVisibleTransitionable;

        var renderNode = (0, _getField2.default)(this.props, this.context, 'renderNode');

        var dialog = _react2.default.createElement(_Dialog2.default, _extends({
          key: 'dialog',
          style: dialogStyle,
          className: dialogClassName,
          ref: this._handleDialogMounting,
          fullPage: fullPage
        }, props, {
          containerX: this._pageX,
          containerY: this._pageY,
          onLeave: this._unmountPortal
        }));

        return _react2.default.createElement(
          _Portal2.default,
          { visible: portalVisible, renderNode: renderNode, lastChild: lastChild },
          _react2.default.createElement(
            _CSSTransitionGroup2.default,
            {
              component: component,
              ref: this._setContainer,
              style: style,
              className: (0, _classnames2.default)('md-dialog-container', {
                'md-overlay': !fullPage && overlay,
                'md-pointer--hover': !fullPage && overlay && !modal,
                'md-overlay--active': !fullPage && active && overlay
              }, className),
              transitionName: 'md-dialog--' + (fullPage ? 'full-page' : 'centered'),
              transitionEnterTimeout: transitionEnterTimeout,
              transitionLeaveTimeout: transitionLeaveTimeout,
              onClick: this._handleClick
            },
            dialogVisible ? dialog : null
          )
        );
      }
    }]);

    return DialogContainer;
  }(_react.PureComponent);

  DialogContainer.propTypes = {
    /**
     * An id to use for the `Dialog` once it has been opened. This is used for the
     * [dialog role](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_dialog_role).
     * This is used to generate an `id` for the `title` prop when it has been defined.
     */
    id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
    /* eslint-enable max-len */

    /**
     * An optional accessibility prop to use when the `Dialog` is opened. This should be an id
     * pointing to some text that describes the content of the dialog. For accessibility
     * reasons, one of the following props must be defined:
     * - `title`
     * - `aria-describedby`
     * - `aria-labelledby`
     * - `aria-label`
     *
     * An example usage:
     *
     * ```js
     * <Dialog id="accessibleExample" visible aria-describedby="accessibleContent">
     *   <p id="accessibleContent">This is some content that describes the dialog.</p>
     * </Dialog>
     * ```
     */
    'aria-describedby': (0, _oneRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]), 'title', 'aria-labelledby', 'aria-label'),

    /**
     * An optional accessibility prop to use when the `title` prop is not given. This should be
     * an id pointing to a `h` tag that labels the dialog.
     *
     * An example usage:
     *
     * ```js
     * <Dialog visible id="accessibleExample" aria-labelledby="accessibleDialogLabel">
     *   <h2 id="accessibleDialogLabel">Some Accessible Dialog</h2>
     * </Dialog>
     * ```
     */
    'aria-labelledby': _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),

    /**
     * An optional accessibility prop to use when the `title` and `aria-labelledby` props are
     * not defined. This should be a string that describes what is in the `Dialog`.
     *
     * An example usage:
     *
     * ```js
     * <Dialog visible id="accessibleExample" aria-label="Some Accessible Dialog">
     *   <p>Lorem Ipsum</p>
     * </Dialog>
     * ```
     */
    'aria-label': _propTypes2.default.string,

    /**
     * An optional style to apply to the dialog's container.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply to the dialog's container.
     */
    className: _propTypes2.default.string,

    /**
     * An optional style to apply to the dialog itself when the `visible` prop is `true`.
     */
    dialogStyle: _propTypes2.default.object,

    /**
     * An optional className to apply to the dialog itself when the `visible` prop is `true`.
     */
    dialogClassName: _propTypes2.default.string,

    /**
     * An optional style to apply to the dialog's content.
     */
    contentStyle: _propTypes2.default.object,

    /**
     * An optional className to apply to the dialog's content.
     */
    contentClassName: _propTypes2.default.string,

    /**
     * The component to render the dialog's container in.
     */
    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,

    /**
     * The component to render the dialog's content in.
     */
    contentComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,

    /**
     * The content to display in the dialog once open.
     */
    children: _propTypes2.default.node,

    /**
     * A single action or a list of actions to display in the dialog. This can either be a list
     * of `FlatButton` props or `<Button flat {...props} />` elements.
     */
    actions: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.object, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.object]))]),

    /**
     * Bolean if the `Dialog` is current visible.
     */
    visible: _propTypes2.default.bool.isRequired,

    /**
     * An optional function to call when the `visible` prop is changed from `false` to `true`.
     */
    onShow: _propTypes2.default.func,

    /**
     * A function to call that will close the dialog. This is required when the `modal` and `fullPage`
     * props are not `true`.
     */
    onHide: function onHide(props, propName) {
      for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }

      var validator = _propTypes2.default.func;
      if (!props.modal && !props.fullPage) {
        validator = validator.isRequired;
      }

      return validator.apply(undefined, [props, propName].concat(args));
    },

    /**
     * Boolean if the dialog should behave like a modal. This means that the dialog can only
     * be closed by clicking on an action instead of also clicking on the overlay.
     */
    modal: _propTypes2.default.bool,

    /**
     * Boolean if the dialog should be displayed as a full page dialog.
     */
    fullPage: function fullPage(props, propName, componentName) {
      for (var _len2 = arguments.length, args = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
        args[_key2 - 3] = arguments[_key2];
      }

      if (typeof props[propName] === 'undefined') {
        return null;
      }
      var componentNameSafe = componentName || '<<anonymous>>';

      var err = _propTypes2.default.bool.apply(_propTypes2.default, [props, propName, componentName].concat(args));

      if (!err && typeof props.title !== 'undefined') {
        err = new Error('You provided a `title` ' + location + ' to the `' + componentNameSafe + '` when `fullPage` ' + 'has been set to true. A title for a full page dialog should be rendered as a child instead.');
      }

      return err;
    },

    /**
     * An optional pageX location to use when rendering a full page dialog. This is used to set the location
     * the dialog should appear from.
     */
    pageX: _propTypes2.default.number,

    /**
     * An optional pageY location to use when rendering a full page dialog. This is used to set the location
     * the dialog should appear from.
     */
    pageY: _propTypes2.default.number,

    /**
     * Boolean if the dialog should focus one of children once it has mounted.
     */
    focusOnMount: _propTypes2.default.bool.isRequired,

    /**
     * The transition enter timeout for the dialog.
     */
    transitionEnterTimeout: _propTypes2.default.number.isRequired,

    /**
     * The transition leave timeout for the dialog.
     */
    transitionLeaveTimeout: _propTypes2.default.number.isRequired,

    /**
     * Boolean if the dialog should be closeable by pressing the escape key.
     * This will always be considered `false` of the `modal` props is `true`.
     */
    closeOnEsc: _propTypes2.default.bool,

    /**
     * Since the `Dialog` uses the `Portal` component, you can pass an optional HTML Node to render
     * the dialog in instead of the `document.body`.
     */
    renderNode: _propTypes2.default.object,

    /**
     * Boolean if the dialog should be rendered as the last child in the `renderNode` or `body` instead
     * of as the first.
     */
    lastChild: _propTypes2.default.bool,

    /**
     * Boolean if the dialog should animate into view if it is constructed with `visible` enabled.
     *
     * This basically means that if the `Dialog` has `visible` enabled on initial page load, does it animate?
     * In some cases, it can also mean if the `Dialog` is added to the render tree with `visible` enabled,
     * does it animate?
     */
    defaultVisibleTransitionable: _propTypes2.default.bool,

    /**
     * Boolean if the Dialog should no longer try to prevent the parent container from scrolling while visible.
     * In most cases, this will attempt to prevent the main window scrolling. If this dialog is nested in another
     * dialog, it will attempt to prevent the parent dialog from scrolling.
     */
    disableScrollLocking: _propTypes2.default.bool,

    isOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `visible` instead'),
    transitionName: (0, _deprecated2.default)(_propTypes2.default.string, 'The transition name will be managed by the component'),
    transitionEnter: (0, _deprecated2.default)(_propTypes2.default.bool, 'The transition will always be enforced'),
    transitionLeave: (0, _deprecated2.default)(_propTypes2.default.bool, 'The transition will always be enforced'),
    actionLeft: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `fullPage` prop instead'),
    actionRight: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `fullPage` prop instead'),
    close: (0, _deprecated2.default)(_propTypes2.default.func, 'Use `onHide` instead.')
  };
  DialogContainer.defaultProps = {
    component: 'span',
    closeOnEsc: true,
    contentComponent: 'section',
    focusOnMount: true,
    transitionEnterTimeout: 300,
    transitionLeaveTimeout: 300,
    defaultVisibleTransitionable: false
  };
  DialogContainer.contextTypes = {
    renderNode: _propTypes2.default.object
  };
  exports.default = DialogContainer;
});

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(248)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./DialogContainer'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.DialogContainer);
    global.index = mod.exports;
  }
})(this, function (exports, _DialogContainer) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _DialogContainer2 = _interopRequireDefault(_DialogContainer);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _DialogContainer2.default;
});

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames);
    global.Divider = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Divider = function (_PureComponent) {
    _inherits(Divider, _PureComponent);

    function Divider() {
      _classCallCheck(this, Divider);

      return _possibleConstructorReturn(this, (Divider.__proto__ || Object.getPrototypeOf(Divider)).apply(this, arguments));
    }

    _createClass(Divider, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            className = _props.className,
            inset = _props.inset,
            vertical = _props.vertical,
            props = _objectWithoutProperties(_props, ['className', 'inset', 'vertical']);

        var Component = vertical ? 'div' : 'hr';

        return _react2.default.createElement(Component, _extends({}, props, {
          className: (0, _classnames2.default)('md-divider', {
            'md-divider--vertical': vertical,
            'md-divider--inset': inset
          }, className)
        }));
      }
    }]);

    return Divider;
  }(_react.PureComponent);

  Divider.propTypes = {
    /*
     * An optional style to apply to the divider.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply to the divider.
     */
    className: _propTypes2.default.string,

    /**
     * Boolean if this divider should be inset relative to it's container
     * component. This means that if it is in a `List` with `Avatar`, it
     * will start the divider  to the left of the main text in the list.
     */
    inset: _propTypes2.default.bool,

    /**
     * Boolean if the divider should be vertical instead of horizontal.
     */
    vertical: _propTypes2.default.bool
  };
  exports.default = Divider;
});

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(9), __webpack_require__(3), __webpack_require__(581), __webpack_require__(38), __webpack_require__(16), __webpack_require__(595), __webpack_require__(20), __webpack_require__(46), __webpack_require__(82), __webpack_require__(45), __webpack_require__(559), __webpack_require__(558), __webpack_require__(1118)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('react-dom'), require('classnames'), require('../constants/media'), require('../constants/CSSTransitionGroupTick'), require('../utils/getField'), require('../utils/mapToListParts'), require('../utils/PropTypes/controlled'), require('../Papers/Paper'), require('../Helpers/Portal'), require('../Lists/List'), require('./isType'), require('./DrawerTypes'), require('./Overlay'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.reactDom, global.classnames, global.media, global.CSSTransitionGroupTick, global.getField, global.mapToListParts, global.controlled, global.Paper, global.Portal, global.List, global.isType, global.DrawerTypes, global.Overlay);
    global.Drawer = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _reactDom, _classnames, _media, _CSSTransitionGroupTick, _getField, _mapToListParts, _controlled, _Paper, _Portal, _List, _isType, _DrawerTypes, _Overlay) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);

  var _getField2 = _interopRequireDefault(_getField);

  var _mapToListParts2 = _interopRequireDefault(_mapToListParts);

  var _controlled2 = _interopRequireDefault(_controlled);

  var _Paper2 = _interopRequireDefault(_Paper);

  var _Portal2 = _interopRequireDefault(_Portal);

  var _List2 = _interopRequireDefault(_List);

  var _DrawerTypes2 = _interopRequireDefault(_DrawerTypes);

  var _Overlay2 = _interopRequireDefault(_Overlay);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var oneOfDrawerTypes = _propTypes2.default.oneOf([_DrawerTypes2.default.FULL_HEIGHT, _DrawerTypes2.default.CLIPPED, _DrawerTypes2.default.FLOATING, _DrawerTypes2.default.PERSISTENT, _DrawerTypes2.default.PERSISTENT_MINI, _DrawerTypes2.default.TEMPORARY, _DrawerTypes2.default.TEMPORARY_MINI]);

  /**
   * The `Drawer` component is used for having a sliding panel of content or navigation
   * that appears from the side of a screen.
   *
   * If the `Drawer` uses any of the `_MINI` drawer types, you will need to also create another
   * `Drawer` that is not `_MINI`. Transitioning the `width` on mobile devices is very sluggish,
   * and it isn't much more work to create another drawer.
   */

  var Drawer = function (_PureComponent) {
    _inherits(Drawer, _PureComponent);

    _createClass(Drawer, null, [{
      key: 'getCurrentMedia',
      value: function getCurrentMedia() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Drawer.defaultProps;
        var mobileMinWidth = props.mobileMinWidth,
            tabletMinWidth = props.tabletMinWidth,
            desktopMinWidth = props.desktopMinWidth,
            mobileType = props.mobileType,
            tabletType = props.tabletType,
            desktopType = props.desktopType,
            constantType = props.constantType;

        if (typeof window === 'undefined') {
          var _type = constantType && props.type ? props.type : mobileType;
          return { mobile: true, tablet: false, desktop: false, type: _type };
        }

        var mobile = Drawer.matchesMedia(mobileMinWidth, tabletMinWidth - 1);
        var tablet = Drawer.matchesMedia(tabletMinWidth, desktopMinWidth);
        var desktop = Drawer.matchesMedia(desktopMinWidth);

        var type = void 0;
        if (constantType && props.type && (0, _isType.isTemporary)(props.type)) {
          type = props.type;
        } else if (desktop) {
          type = desktopType;
        } else if (tablet) {
          type = tabletType;
        } else {
          type = mobileType;
        }

        return { type: type, mobile: mobile, tablet: tablet, desktop: desktop };
      }
    }, {
      key: 'matchesMedia',
      value: function matchesMedia(min, max) {
        var media = 'screen and (min-width: ' + min + 'px)';
        if (max) {
          media += ' and (max-width: ' + max + 'px)';
        }

        return window.matchMedia(media).matches;
      }
    }]);

    function Drawer(props) {
      _classCallCheck(this, Drawer);

      var _this = _possibleConstructorReturn(this, (Drawer.__proto__ || Object.getPrototypeOf(Drawer)).call(this, props));

      var defaultVisible = props.defaultVisible,
          defaultMedia = props.defaultMedia,
          overlay = props.overlay;


      _this.state = {
        mobile: defaultMedia === 'mobile',
        tablet: defaultMedia === 'tablet',
        desktop: defaultMedia === 'desktop',
        animating: false,
        overlayActive: false,
        drawerActive: false
      };

      if (typeof props.type === 'undefined') {
        _this.state.type = props[defaultMedia + 'Type'];
      }

      var type = (0, _getField2.default)(props, _this.state, 'type');
      _this._initialFix = true;

      if (typeof props.visible === 'undefined') {
        _this.state.visible = typeof defaultVisible !== 'undefined' ? defaultVisible : (0, _isType.isPermanent)(type);
      }

      var visible = (0, _getField2.default)(props, _this.state, 'visible');

      _this.state.overlayActive = (typeof overlay !== 'undefined' ? overlay : (0, _isType.isTemporary)(type) && !_this.state.desktop) && visible;
      _this.state.drawerActive = visible;

      _this._animate = _this._animate.bind(_this);
      _this._closeDrawer = _this._closeDrawer.bind(_this);
      _this._setNavigation = _this._setNavigation.bind(_this);
      _this._handleNavClick = _this._handleNavClick.bind(_this);
      _this._updateType = _this._updateType.bind(_this);
      _this._updateMedia = _this._updateMedia.bind(_this);
      return _this;
    }

    _createClass(Drawer, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        if (typeof window !== 'undefined') {
          this._updateType(this.props);
        }
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        window.addEventListener('resize', this._updateMedia);
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var _props = this.props,
            mobileMinWidth = _props.mobileMinWidth,
            mobileType = _props.mobileType,
            tabletMinWidth = _props.tabletMinWidth,
            tabletType = _props.tabletType,
            desktopMinWidth = _props.desktopMinWidth,
            desktopType = _props.desktopType;


        if (nextProps.mobileMinWidth !== mobileMinWidth || nextProps.mobileType !== mobileType || nextProps.tabletMinWidth !== tabletMinWidth || nextProps.tabletType !== tabletType || nextProps.desktopMinWidth !== desktopMinWidth || nextProps.desktopType !== desktopType) {
          this._updateType(nextProps);
        }

        var visible = nextProps.visible,
            transitionDuration = nextProps.transitionDuration,
            overlay = nextProps.overlay;

        if (this.props.visible === nextProps.visible) {
          return;
        }

        var type = (0, _getField2.default)(nextProps, this.state, 'type');
        this._animate(visible, type, transitionDuration, overlay, this.state.desktop);
      }
    }, {
      key: 'componentWillUpdate',
      value: function componentWillUpdate(nextProps, nextState) {
        var visible = nextState.visible;

        if (typeof nextProps.visible !== 'undefined' || this.state.visible === visible) {
          return;
        }
        var type = (0, _getField2.default)(nextProps, nextState, 'type');
        this._animate(visible, type, nextProps.transitionDuration, nextProps.overlay, nextState.desktop);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this._timeout) {
          clearTimeout(this._timeout);
        }

        if (this._closeTimeout) {
          clearTimeout(this._closeTimeout);
        }

        window.removeEventListener('resize', this._updateMedia);
      }
    }, {
      key: '_updateType',
      value: function _updateType(props) {
        var onMediaTypeChange = props.onMediaTypeChange,
            onVisibilityToggle = props.onVisibilityToggle,
            overlay = props.overlay;


        var state = Drawer.getCurrentMedia(props);
        var diffType = (0, _getField2.default)(props, this.state, 'type') !== state.type;
        var diffMedia = state.mobile !== this.state.mobile || state.tablet !== this.state.tablet || state.desktop !== this.state.desktop;

        if (onMediaTypeChange && (diffType || diffMedia)) {
          onMediaTypeChange(state.type, { mobile: state.mobile, tablet: state.tablet, desktop: state.desktop });
        }

        if (diffType) {
          var visible = (0, _isType.isPermanent)(state.type);
          if (this._initialFix) {
            if (props.defaultVisible) {
              visible = props.defaultVisible;
            } else if (props.visible) {
              visible = props.visible;
            }
          }

          var prevVisible = (0, _getField2.default)(props, this.state, 'visible');
          if (onVisibilityToggle && visible !== prevVisible) {
            onVisibilityToggle(visible);
          }

          if (typeof props.visible === 'undefined') {
            state.visible = visible;
          }
        } else if (this._initialFix && diffMedia) {
          state.overlayActive = (typeof overlay !== 'undefined' ? overlay : (0, _isType.isTemporary)(state.type) && !state.desktop) && (0, _getField2.default)(props, this.state, 'visible');
        }

        if (typeof props.type !== 'undefined') {
          delete state.type;
        }

        this._initialFix = false;
        this.setState(state);
      }
    }, {
      key: '_updateMedia',
      value: function _updateMedia() {
        this._updateType(this.props);
      }
    }, {
      key: '_animate',
      value: function _animate(visible, type, timeout, overlay, desktop) {
        var _this2 = this;

        if (visible) {
          this.timeout = setTimeout(function () {
            _this2.timeout = null;

            _this2.setState({
              overlayActive: overlay || (0, _isType.isTemporary)(type) && !desktop,
              drawerActive: true,
              animating: true
            });
          }, _CSSTransitionGroupTick2.default);
        } else {
          this._timeout = setTimeout(function () {
            _this2._timeout = null;

            _this2.setState({ animating: false });
          }, timeout);
          this.setState({ animating: true, overlayActive: false, drawerActive: false });
        }
      }
    }, {
      key: '_setNavigation',
      value: function _setNavigation(navigation) {
        this._navigation = (0, _reactDom.findDOMNode)(navigation);
      }
    }, {
      key: '_handleNavClick',
      value: function _handleNavClick(e) {
        var _this3 = this;

        if (!this.props.closeOnNavItemClick || !(0, _isType.isTemporary)((0, _getField2.default)(this.props, this.state, 'type'))) {
          return;
        }

        var target = e.target;

        while (target && this._navigation.contains(target)) {
          if (target.classList.contains('md-list-tile')) {
            // Clicked a nav item that has a nested list
            if (target.getAttribute('aria-expanded') !== null) {
              return;
            }

            this._closeTimeout = setTimeout(function () {
              _this3._closeTimeout = null;

              _this3._closeDrawer(e);
            }, _CSSTransitionGroupTick2.default);
            return;
          }

          target = target.parentNode;
        }
      }
    }, {
      key: '_closeDrawer',
      value: function _closeDrawer() {
        if (this.props.onVisibilityToggle) {
          this.props.onVisibilityToggle(false);
        }

        if (typeof this.props.visible === 'undefined') {
          this.setState({ visible: false });
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _cn;

        var _state = this.state,
            overlayActive = _state.overlayActive,
            drawerActive = _state.drawerActive,
            animating = _state.animating;

        var _props2 = this.props,
            style = _props2.style,
            className = _props2.className,
            navStyle = _props2.navStyle,
            navClassName = _props2.navClassName,
            component = _props2.component,
            navItems = _props2.navItems,
            header = _props2.header,
            children = _props2.children,
            inline = _props2.inline,
            position = _props2.position,
            overlay = _props2.overlay,
            autoclose = _props2.autoclose,
            clickableDesktopOverlay = _props2.clickableDesktopOverlay,
            lastChild = _props2.lastChild,
            props = _objectWithoutProperties(_props2, ['style', 'className', 'navStyle', 'navClassName', 'component', 'navItems', 'header', 'children', 'inline', 'position', 'overlay', 'autoclose', 'clickableDesktopOverlay', 'lastChild']);

        delete props.constantType;
        delete props.renderNode;
        delete props.visible;
        delete props.defaultVisible;
        delete props.type;
        delete props.defaultMedia;
        delete props.mobileType;
        delete props.mobileMinWidth;
        delete props.tabletType;
        delete props.tabletMinWidth;
        delete props.desktopType;
        delete props.desktopMinWidth;
        delete props.transitionDuration;
        delete props.onVisibilityToggle;
        delete props.onMediaTypeChange;
        delete props.closeOnNavItemClick;

        var desktop = this.state.desktop;

        var renderNode = (0, _getField2.default)(this.props, this.context, 'renderNode');
        var visible = (0, _getField2.default)(this.props, this.state, 'visible');
        var type = (0, _getField2.default)(this.props, this.state, 'type');
        var mini = (0, _isType.isMini)(type);
        var temporary = (0, _isType.isTemporary)(type);
        var floating = _DrawerTypes2.default.FLOATING === type;
        var permanent = (0, _isType.isPermanent)(type);

        var Component = void 0;
        if (component) {
          Component = component;
        } else if (navItems) {
          Component = 'nav';
        } else {
          Component = 'aside';
        }

        var navigation = void 0;
        if (navItems) {
          navigation = _react2.default.createElement(
            _List2.default,
            {
              ref: this._setNavigation,
              key: 'navigation',
              style: navStyle,
              className: (0, _classnames2.default)('md-list--drawer', {
                'md-toolbar-relative': mini && !visible,
                'md-background': floating
              }, navClassName),
              onClick: autoclose ? this._handleNavClick : null
            },
            navItems.map(_mapToListParts2.default)
          );
        }
        var zDepth = 1;
        if (floating || inline) {
          zDepth = 0;
        } else if (temporary && visible) {
          zDepth = 5;
        }

        var overlayVisible = (!desktop || clickableDesktopOverlay) && (overlay || temporary) && (animating || visible);

        var drawer = _react2.default.createElement(
          _Paper2.default,
          _extends({}, props, {
            key: 'drawer',
            component: Component,
            zDepth: zDepth,
            raiseOnHover: false,
            style: style,
            className: (0, _classnames2.default)('md-drawer', (_cn = {}, _defineProperty(_cn, 'md-drawer--' + position, !inline), _defineProperty(_cn, 'md-drawer--fixed', !inline), _defineProperty(_cn, 'md-drawer--inline', inline), _defineProperty(_cn, 'md-drawer--active', mini || drawerActive), _defineProperty(_cn, 'md-drawer--mini', mini), _defineProperty(_cn, 'md-transition--decceleration', visible), _defineProperty(_cn, 'md-transition--acceleration', !visible), _defineProperty(_cn, 'md-background', inline || floating), _defineProperty(_cn, 'md-background--card', !floating && !inline), _cn), className)
          }),
          header,
          navigation,
          children,
          _react2.default.createElement(_Overlay2.default, {
            active: overlayActive,
            visible: overlayVisible,
            onClick: this._closeDrawer,
            renderNode: renderNode
          })
        );

        if (inline || permanent) {
          return drawer;
        }

        return _react2.default.createElement(
          _Portal2.default,
          { visible: mini || animating || visible, renderNode: renderNode, lastChild: lastChild },
          drawer
        );
      }
    }]);

    return Drawer;
  }(_react.PureComponent);

  Drawer.DrawerTypes = _DrawerTypes2.default;
  Drawer.propTypes = {
    /**
     * An optional style to apply.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply.
     */
    className: _propTypes2.default.string,

    /**
     * An optional style to apply to the `List` surrounding the `navItems`.
     */
    navStyle: _propTypes2.default.object,

    /**
     * An optional className to apply to the `List` surrounding the `navItems`.
     */
    navClassName: _propTypes2.default.string,

    /**
     * An optional component to render the drawer in. When this prop is undefined, the drawer
     * will be rendered as a `nav` if the `navItems` prop is defined, otherwise an `aside`.
     */
    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),

    /**
     * An optional list of navigation items to display in the drawer. This list can either contain
     * a valid child component for a `List` or an object used to create a `Divider`, `Subheader`,
     * or `ListItem`.
     *
     * - To create a divider in the list, set a `divider` key to `true`. Any other keys will be
     * passed to the `Divider` component.
     * - To create a subheader in the list, set the `subheader` key to `true`. Any other keys will
     * be passed to the `Subheader` component.
     * - To create a list item, just create an object with any normal `ListItem` props.
     */
    navItems: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.shape({
      divider: _propTypes2.default.bool,
      subheader: _propTypes2.default.bool,
      primaryText: _propTypes2.default.node
    })])),

    /**
     * Boolean if a temporary drawer should close when a nav item is clicked.
     */
    autoclose: _propTypes2.default.bool,

    /**
     * An optional header to display. This _should_ normally be a toolbar.
     */
    header: _propTypes2.default.node,

    /**
     * Any additional children to display after the `header` and `navItems`.
     */
    children: _propTypes2.default.node,

    /**
     * The drawer type to use when the current device matches the mobile
     * media query.
     */
    mobileType: _propTypes2.default.oneOf([Drawer.DrawerTypes.TEMPORARY, Drawer.DrawerTypes.TEMPORARY_MINI]).isRequired,

    /**
     * The min-width to use for the mobile media query.
     */
    mobileMinWidth: _propTypes2.default.number.isRequired,

    /**
     * The drawer type to use when the current device matches the tablet
     * media query.
     */
    tabletType: oneOfDrawerTypes.isRequired,

    /**
     * The min-width to use for the tablet media query.
     */
    tabletMinWidth: _propTypes2.default.number.isRequired,

    /**
     * The drawer type to use when the current device matches the desktop media
     * query.
     */
    desktopType: oneOfDrawerTypes.isRequired,

    /**
     * The min-width for a desktop screen.
     */
    desktopMinWidth: _propTypes2.default.number.isRequired,

    /**
     * An optional type to enforce across all media sizes. Since `mobile` devices are
     * included, you are required to manually specify when the `type` should be `temporary`.
     *
     * When the `type` is not one of the `temporary` types, the `onMediaTypeChange` prop
     * must be provided.
     */
    type: function type(props, propName, component) {
      for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        others[_key - 3] = arguments[_key];
      }

      var type = props[propName];
      if ((0, _isType.isTemporary)(type)) {
        return oneOfDrawerTypes.apply(undefined, [props, propName, component].concat(others));
      }

      var err = oneOfDrawerTypes.apply(undefined, [props, propName, component].concat(others));
      if (!err && typeof type !== 'undefined' && !(0, _isType.isMini)(type) && typeof props.onMediaTypeChange === 'undefined') {
        err = new Error('You provided a `' + propName + '` prop to the ' + component + ' without the `onMediaTypeChange` ' + ('handler. The `onMediaTypeChange` prop must be specified when the `' + propName + '` is not ') + 'one of the `temporary` types.');
      }

      return err;
    },

    /**
     * An optional function to call when the drawer's type changes when the screen resizes.
     * The callback will include the new `type` that should be used for the screen size,
     * and an object containing the media matches for `mobile`, `tablet`, and `desktop`.
     *
     * ```js
     * this.props.onMediaTypeChange(Drawer.DrawerTypes.TEMPORARY, {
     *   mobile: true,
     *   tablet: false,
     *   desktop: false,
     * });
     * ```
     */
    onMediaTypeChange: _propTypes2.default.func,

    /**
     * The default drawer type to display on initial render. The drawer will automatically
     * adjust itself to the correct media once it has mounted. This prop is really only useful
     * for server side rendering.
     */
    defaultMedia: _propTypes2.default.oneOf(['mobile', 'tablet', 'desktop']).isRequired,

    /**
     * Boolean if there should be a visible overlay when the drawer is visible. The default behavior
     * is to only include a visible overlay when the `type` is `TEMPORARY` or `TEMPORARY_MINI` and
     * the device is not a desktop.
     */
    overlay: _propTypes2.default.bool,

    /**
     * An optional DOM Node to render the drawer into. The default is to render as
     * the first child in the `body`.
     *
     * > This prop will not be used when the drawer is of the permanent type or `inline` is specified
     * since the `Portal` component will not be used.
     */
    renderNode: _propTypes2.default.object,

    /**
     * Boolean if the drawer should be rendered as the last child instead of the first child
     * in the `renderNode` or `body`.
     *
     * > This prop will not be used when the drawer is of the permanent type or `inline` is specified
     * since the `Portal` component will not be used.
     */
    lastChild: _propTypes2.default.bool,

    /**
     * Boolean if the drawer is visible by default. If this is omitted, the drawer will be visible
     * if the current drawer type is NOT `Drawer.DrawerTypes.TEMPORARY` or `Drawer.DrawerTypes.TEMPORARY_MINI`.
     *
     * This basically means that if you are using the default configuration, a mobile device's drawer
     * will be hidden while tablets and desktops will be visible.
     */
    defaultVisible: _propTypes2.default.bool,

    /**
     * Boolean if the drawer is visible. This will force the component to define the `onVisibilityToggle`
     * prop as well as manually updating the drawer's visibility.
     */
    visible: (0, _controlled2.default)(_propTypes2.default.bool, 'onVisibilityToggle', 'defaultVisible'),

    /**
     * An optional function to call when the visibility of the drawer is changed. The function will
     * be called with the new visibility state.
     *
     * ```js
     * onVisibilityToggle(!currentlyVisible);
     * ```
     */
    onVisibilityToggle: _propTypes2.default.func,

    /**
     * The drawer's position on the page when it is not `inline`. When the drawer's position is `left`,
     * the width will be `calc(100vw - 56px)` on mobile devices and `$md-drawer-desktop-width` on desktops.
     *
     * When the position is `right`, the width will be `100vw` for mobile devices and scaling to the drawer's
     * children width on desktops.
     */
    position: _propTypes2.default.oneOf(['left', 'right']).isRequired,

    /**
     * Boolean if the drawer should be displayed inline instead of fixed to the page. When this prop
     * is enabled, the `position` prop will not be used.
     */
    inline: _propTypes2.default.bool,

    /**
     * The `$md-drawer-transition-time` value from sass.
     */
    transitionDuration: _propTypes2.default.number.isRequired,

    /**
     * Boolean if the temporary drawer's overlay should be created on desktop screens. This is really used so that
     * the drawer will close when a user clicks anywhere on the page except in the drawer.
     */
    clickableDesktopOverlay: _propTypes2.default.bool,

    /**
     * Boolean if the navigation drawer should automatically close when a nav item has been clicked.
     */
    closeOnNavItemClick: _propTypes2.default.bool,

    /**
     * Boolean if the `type` prop should be constant across all media sizes. This is only valid if the `type` is
     * one of the temporary types.
     *
     * This will basically mean that when attempting to do a media adjustment, it will use the `type` prop instead of
     * `mobileType`, `tabletType`, and `desktopType` to determine the next drawer type.
     */
    constantType: _propTypes2.default.bool.isRequired
  };
  Drawer.defaultProps = {
    defaultMedia: 'mobile',
    mobileType: Drawer.DrawerTypes.TEMPORARY,
    mobileMinWidth: _media.MOBILE_MIN_WIDTH,
    tabletType: Drawer.DrawerTypes.PERSISTENT,
    tabletMinWidth: _media.TABLET_MIN_WIDTH,
    desktopType: Drawer.DrawerTypes.FULL_HEIGHT,
    desktopMinWidth: _media.DESKTOP_MIN_WIDTH,
    position: 'left',
    transitionDuration: 300,
    autoclose: true,
    clickableDesktopOverlay: true,
    closeOnNavItemClick: true,
    constantType: true
  };
  Drawer.contextTypes = {
    renderNode: _propTypes2.default.object
  };
  exports.default = Drawer;
});

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(28)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('./FontIcon'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.FontIcon);
    global.Collapser = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _FontIcon) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _FontIcon2 = _interopRequireDefault(_FontIcon);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Collapser = function (_PureComponent) {
    _inherits(Collapser, _PureComponent);

    function Collapser(props) {
      _classCallCheck(this, Collapser);

      var _this = _possibleConstructorReturn(this, (Collapser.__proto__ || Object.getPrototypeOf(Collapser)).call(this, props));

      _this.state = {};
      return _this;
    }

    _createClass(Collapser, [{
      key: 'render',
      value: function render() {
        var _cn;

        var _props = this.props,
            className = _props.className,
            flipped = _props.flipped,
            suffix = _props.suffix,
            suffixFlipped = _props.suffixFlipped,
            props = _objectWithoutProperties(_props, ['className', 'flipped', 'suffix', 'suffixFlipped']);

        return _react2.default.createElement(_FontIcon2.default, _extends({
          key: 'collapser'
        }, props, {
          className: (0, _classnames2.default)('md-collapser', (_cn = {
            'md-collapser--flipped': flipped && (!suffixFlipped || !suffix)
          }, _defineProperty(_cn, 'md-collapser--' + suffix, suffix), _defineProperty(_cn, 'md-collapser--' + suffix + '-flipped', suffix && flipped && suffixFlipped), _cn), className)
        }));
      }
    }]);

    return Collapser;
  }(_react.PureComponent);

  Collapser.propTypes = {
    className: _propTypes2.default.string,
    iconClassName: _propTypes2.default.string,
    children: _propTypes2.default.node,
    flipped: _propTypes2.default.bool,
    suffix: _propTypes2.default.string,
    suffixFlipped: _propTypes2.default.bool
  };
  Collapser.defaultProps = {
    children: 'keyboard_arrow_down'
  };
  exports.default = Collapser;
});

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(1130), __webpack_require__(591)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('./InkContainer'), require('../utils/StringUtils/getDisplayName'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.InkContainer, global.getDisplayName);
    global.injectInk = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _InkContainer, _getDisplayName) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _InkContainer2 = _interopRequireDefault(_InkContainer);

  var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  exports.default = function (ComposedComponent) {
    var _class, _temp;

    return _temp = _class = function (_PureComponent) {
      _inherits(InkedComponent, _PureComponent);

      function InkedComponent(props, context) {
        _classCallCheck(this, InkedComponent);

        var _this = _possibleConstructorReturn(this, (InkedComponent.__proto__ || Object.getPrototypeOf(InkedComponent)).call(this, props, context));

        _this.focus = _this.focus.bind(_this);
        _this.createInk = _this.createInk.bind(_this);
        _this.getComposedComponent = _this.getComposedComponent.bind(_this);
        _this._setInkRef = _this._setInkRef.bind(_this);
        _this._setComposedComponent = _this._setComposedComponent.bind(_this);
        return _this;
      }

      _createClass(InkedComponent, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          var ref = this.props.__SUPER_SECRET_REF__;
          // Emulate the ref callback...

          if (ref) {
            ref(this);
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          var ref = this.props.__SUPER_SECRET_REF__;
          // Emulate the ref callback...

          if (ref) {
            ref(null);
          }
        }

        /**
         * A publically accessible way to manually create an ink. This can be used with the `refs`.
         * The ink can either be created by using the `pageX` and `pageY` from a click/touch event
         * or it will be created in the center of the `ComposedComponent`.
         *
         * ```js
         * <SomeInkedComponent ref={inkHOC => inkHOC.createInk()} />
         * ```
         *
         * @param {number=} pageX - An optional pageX of the click or touch event.
         * @param {number=} pageY - An optional pageY of the click or touch event.
         */

      }, {
        key: 'createInk',
        value: function createInk(pageX, pageY) {
          if (this._inkContainer && !this.props.disabled && !this.props.inkDisabled) {
            this._inkContainer.createInk(pageX, pageY);
          }
        }

        /**
         * This will attempt to focus the composed component. If the component is disabled, nothing
         * will happen. If the `disabled` and `inkDisabled` props are not set to `true`, an ink will
         * also be created.
         *
         * ```js
         * <SomeInkedComponent ref={inkHOC => inkHOC.focus()} />
         * ```
         */

      }, {
        key: 'focus',
        value: function focus() {
          if (this._inkContainer) {
            this._inkContainer.focus();
          }
        }

        /**
         * Gets the composed component as a ref. This is usefull if you need to access the ref of the
         * composed component instead of the `injectInk` HOC to use some publically accessible methods.
         *
         * ```js
         * <SomeInkedComponent
         *   ref={inkHOC => {
         *     inkHOC.getComposedComponent().focus();
         *   }}
         * />
         * ```
         */

      }, {
        key: 'getComposedComponent',
        value: function getComposedComponent() {
          return this._composed;
        }
      }, {
        key: '_setInkRef',
        value: function _setInkRef(inkContainer) {
          if (inkContainer) {
            this._inkContainer = inkContainer;
          }
        }
      }, {
        key: '_setComposedComponent',
        value: function _setComposedComponent(component) {
          this._composed = component;
        }
      }, {
        key: 'render',
        value: function render() {
          var _props = this.props,
              inkDisabled = _props.inkDisabled,
              transitionOverlap = _props.inkTransitionOverlap,
              transitionEnterTimeout = _props.inkTransitionEnterTimeout,
              transitionLeaveTimeout = _props.inkTransitionLeaveTimeout,
              inkStyle = _props.inkStyle,
              inkClassName = _props.inkClassName,
              inkContainerStyle = _props.inkContainerStyle,
              inkContainerClassName = _props.inkContainerClassName,
              disabledInteractions = _props.disabledInteractions,
              waitForInkTransition = _props.waitForInkTransition,
              props = _objectWithoutProperties(_props, ['inkDisabled', 'inkTransitionOverlap', 'inkTransitionEnterTimeout', 'inkTransitionLeaveTimeout', 'inkStyle', 'inkClassName', 'inkContainerStyle', 'inkContainerClassName', 'disabledInteractions', 'waitForInkTransition']);

          delete props.__SUPER_SECRET_REF__;

          if (!(props.disabled || inkDisabled)) {
            props.ink = _react2.default.createElement(_InkContainer2.default, {
              ref: this._setInkRef,
              key: 'ink-container',
              style: inkContainerStyle,
              className: inkContainerClassName,
              inkStyle: inkStyle,
              inkClassName: inkClassName,
              disabledInteractions: disabledInteractions,
              transitionOverlap: transitionOverlap,
              transitionEnterTimeout: transitionEnterTimeout,
              transitionLeaveTimeout: transitionLeaveTimeout,
              waitForInkTransition: waitForInkTransition
            });
          }

          props.ref = this._setComposedComponent;

          return _react2.default.createElement(ComposedComponent, props);
        }
      }]);

      return InkedComponent;
    }(_react.PureComponent), _class.displayName = (0, _getDisplayName2.default)(ComposedComponent, 'Inked'), _class.propTypes = {
      /**
       * An optional style to apply to each ink that gets generated.
       */
      inkStyle: _propTypes2.default.object,

      /**
       * An optional className to apply to each ink that gets generated.
       */
      inkClassName: _propTypes2.default.string,

      /**
       * An optional style to apply to the ink's container.
       */
      inkContainerStyle: _propTypes2.default.object,

      /**
       * An optional className to apply to the ink's container.
       */
      inkContainerClassName: _propTypes2.default.string,

      /**
       * Boolean if the composed component or the ink is disabled.
       */
      disabled: _propTypes2.default.bool,

      /**
       * Boolean if only the ink is disabled for the composed component.
       */
      inkDisabled: _propTypes2.default.bool,

      /**
       * The time (in ms) that the enter and leave transitions for the ink should overlap.
       * This really just allows for a more _fluid_ looking ink when something is quickly
       * touched or clicked by having it fade out while growing.
       */
      inkTransitionOverlap: _propTypes2.default.number.isRequired,

      /**
       * The transition time for the ink to be considered fully entered. This should really
       * map up to whatever value you set for `$md-ink-enter-transition-time`.
       */
      inkTransitionEnterTimeout: _propTypes2.default.number.isRequired,

      /**
       * The transition time for the ink to be considered fully leaved (left?). This should really
       * map up to whatever value you set for `$md-ink-leave-transition-time`.
       */
      inkTransitionLeaveTimeout: _propTypes2.default.number.isRequired,

      /**
       * Boolean if the `ComposedComponent`'s click event only after the ink has finished transitioning
       * in and out. This is really only to get a more _fluid_ looking click event when clicking on
       * the `ComposedComponent` ends up taking it out of the view. (ex: Closing a Dialog).
       */
      waitForInkTransition: _propTypes2.default.bool,

      /**
       * An optional array of interactions that can be disabled for the ink. This is a *very* limited
       * use case where `Switches` needed the ink disabled only when using a mouse.
       */
      disabledInteractions: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['keyboard', 'mouse', 'touch'])),

      /**
       * When using inked components in a `TransitionGroup`, the ref callback is not actually invoked.
       * This is a little _hack_ to get it to work by not using `ref`, but this name.
       */
      __SUPER_SECRET_REF__: _propTypes2.default.func
    }, _class.defaultProps = {
      inkTransitionOverlap: 150,
      inkTransitionEnterTimeout: 450,
      inkTransitionLeaveTimeout: 300
    }, _temp;
  };
});

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(562), __webpack_require__(255)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('./ListItemText'), require('./TileAddon'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.ListItemText, global.TileAddon);
    global.ListItemControl = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _ListItemText, _TileAddon) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _ListItemText2 = _interopRequireDefault(_ListItemText);

  var _TileAddon2 = _interopRequireDefault(_TileAddon);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var ListItemControl = function (_PureComponent) {
    _inherits(ListItemControl, _PureComponent);

    function ListItemControl() {
      _classCallCheck(this, ListItemControl);

      return _possibleConstructorReturn(this, (ListItemControl.__proto__ || Object.getPrototypeOf(ListItemControl)).apply(this, arguments));
    }

    _createClass(ListItemControl, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            className = _props.className,
            tileStyle = _props.tileStyle,
            tileClassName = _props.tileClassName,
            primaryAction = _props.primaryAction,
            secondaryAction = _props.secondaryAction,
            primaryText = _props.primaryText,
            secondaryText = _props.secondaryText,
            threeLines = _props.threeLines,
            leftIcon = _props.leftIcon,
            leftAvatar = _props.leftAvatar,
            rightIcon = _props.rightIcon,
            rightAvatar = _props.rightAvatar,
            props = _objectWithoutProperties(_props, ['className', 'tileStyle', 'tileClassName', 'primaryAction', 'secondaryAction', 'primaryText', 'secondaryText', 'threeLines', 'leftIcon', 'leftAvatar', 'rightIcon', 'rightAvatar']);

        var control = _react.Children.only(primaryAction || secondaryAction);
        var text = _react2.default.createElement(_ListItemText2.default, {
          key: 'text',
          primaryText: control.props.label || primaryText,
          secondaryText: secondaryText,
          className: (0, _classnames2.default)({
            'md-tile-content--left-icon': leftIcon,
            'md-tile-content--left-avatar': leftAvatar,
            'md-tile-content--left-button': primaryAction,
            'md-tile-content--right-padding': primaryAction
          })
        });
        control = (0, _react.cloneElement)(control, {
          className: (0, _classnames2.default)('md-list-control', {
            'md-list-control--right': secondaryAction
          }, control.props.className),
          label: text
        });

        var leftNode = _react2.default.createElement(_TileAddon2.default, {
          key: 'left-addon',
          icon: leftIcon,
          avatar: leftAvatar
        });

        var rightNode = _react2.default.createElement(_TileAddon2.default, {
          key: 'right-addon',
          icon: rightIcon,
          avatar: rightAvatar
        });

        var icond = !!leftIcon || !!rightIcon;
        var avatard = !!leftAvatar || !!rightAvatar;

        return _react2.default.createElement(
          'li',
          _extends({}, props, { className: (0, _classnames2.default)('md-list-item', className) }),
          _react2.default.createElement(
            'div',
            {
              style: tileStyle,
              className: (0, _classnames2.default)('md-list-tile md-text', {
                'md-list-tile--icon': !secondaryText && icond && !avatard,
                'md-list-tile--avatar': !secondaryText && avatard,
                'md-list-tile--two-lines': secondaryText && !threeLines,
                'md-list-tile--three-lines': secondaryText && threeLines,
                'md-list-tile--control-left': primaryAction,
                'md-list-tile--control-right': secondaryAction
              }, tileClassName)
            },
            leftNode,
            control,
            rightNode
          )
        );
      }
    }]);

    return ListItemControl;
  }(_react.PureComponent);

  ListItemControl.propTypes = {
    /**
     * An optional style to apply to the `.md-list-item`.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply to the `.md-list-item`.
     */
    className: _propTypes2.default.string,

    /**
     * An optional style to apply to the `.md-list-tile`.
     */
    tileStyle: _propTypes2.default.object,

    /**
     * An optional className to apply to the `.md-list-tile`.
     */
    tileClassName: _propTypes2.default.string,

    /**
     * The primary text to display in the `ListItemControl`. The `primaryAction` or
     * `secondaryAction` will end up getting the `label` prop injected into it with
     * a combination of the `primaryText` and `secondaryText`. If the `primaryAction`
     * or `secondaryAction` already have a label prop, the `label` prop will be used
     * as the `primaryText`.
     */
    primaryText: _propTypes2.default.node,

    /**
     * An optional secondary text that can be displayed in the label of the `primaryAction`
     * or `secondaryAction`.
     */
    secondaryText: _propTypes2.default.node,

    /**
     * Boolean if the primary and secondary text will span three lines.
     */
    threeLines: _propTypes2.default.bool,

    /**
     * The primary action of the `ListItemControl`. This _should_ normally
     * be a type of `SelectionControl`
     */
    primaryAction: _propTypes2.default.element,

    /**
     * The secondary action of the `ListItemControl`. This _should_ normally
     * be a type of `SelectionControl`. If it is a selection control,
     * make sure to add the `labelBefore` prop to get correct positioning.
     */
    secondaryAction: _propTypes2.default.element,

    /**
     * An optional `FontIcon` to display to the left of the action.
     */
    leftIcon: _propTypes2.default.node,

    /**
     * An optional `Avatar` to display to the left of the action.
     */
    leftAvatar: _propTypes2.default.node,

    /**
     * An optional `FontIcon` to display to the right of the action.
     */
    rightIcon: _propTypes2.default.node,

    /**
     * An optional `FontIcon` to display to the right of the action.
     */
    rightAvatar: _propTypes2.default.node
  };
  exports.default = ListItemControl;
});

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames);
    global.TileAddon = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var TileAddon = function (_PureComponent) {
    _inherits(TileAddon, _PureComponent);

    function TileAddon() {
      _classCallCheck(this, TileAddon);

      return _possibleConstructorReturn(this, (TileAddon.__proto__ || Object.getPrototypeOf(TileAddon)).apply(this, arguments));
    }

    _createClass(TileAddon, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            icon = _props.icon,
            avatar = _props.avatar,
            active = _props.active,
            activeClassName = _props.activeClassName,
            style = _props.style,
            className = _props.className;

        if (!icon && !avatar) {
          return null;
        }

        var avatarIcon = false;
        if (avatar) {
          var avatarChild = _react2.default.Children.only(avatar);
          if (avatarChild.props.iconSized) {
            avatarIcon = true;
          }
        }
        return _react2.default.createElement(
          'div',
          {
            style: style,
            className: (0, _classnames2.default)('md-tile-addon', _defineProperty({
              'md-tile-addon--icon': icon || avatarIcon,
              'md-tile-addon--avatar': avatar && !avatarIcon
            }, activeClassName, active), className)
          },
          icon || avatar
        );
      }
    }]);

    return TileAddon;
  }(_react.PureComponent);

  TileAddon.propTypes = {
    style: _propTypes2.default.object,
    className: _propTypes2.default.string,
    active: _propTypes2.default.bool,
    activeClassName: _propTypes2.default.string,
    icon: _propTypes2.default.node,
    avatar: _propTypes2.default.node
  };
  exports.default = TileAddon;
});

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(46)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./Paper'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.Paper);
    global.index = mod.exports;
  }
})(this, function (exports, _Paper) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _Paper2 = _interopRequireDefault(_Paper);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _Paper2.default;
});

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames);
    global.PickerControl = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var PickerControl = function (_PureComponent) {
    _inherits(PickerControl, _PureComponent);

    function PickerControl() {
      _classCallCheck(this, PickerControl);

      return _possibleConstructorReturn(this, (PickerControl.__proto__ || Object.getPrototypeOf(PickerControl)).apply(this, arguments));
    }

    _createClass(PickerControl, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            className = _props.className,
            active = _props.active,
            props = _objectWithoutProperties(_props, ['className', 'active']);

        return _react2.default.createElement('button', _extends({}, props, {
          type: 'button',
          className: (0, _classnames2.default)('md-btn md-pointer--hover md-picker-control md-picker-text', {
            'md-picker-text--active': active
          }, className)
        }));
      }
    }]);

    return PickerControl;
  }(_react.PureComponent);

  PickerControl.propTypes = {
    className: _propTypes2.default.string,
    active: _propTypes2.default.bool.isRequired,
    onClick: _propTypes2.default.func.isRequired,
    children: _propTypes2.default.node.isRequired
  };
  exports.default = PickerControl;
});

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(9), __webpack_require__(12), __webpack_require__(17), __webpack_require__(14), __webpack_require__(16), __webpack_require__(118), __webpack_require__(20), __webpack_require__(588), __webpack_require__(590), __webpack_require__(45), __webpack_require__(63), __webpack_require__(116), __webpack_require__(156), __webpack_require__(576), __webpack_require__(578), __webpack_require__(1156)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('react-dom'), require('react-prop-types/lib/deprecated'), require('react-prop-types/lib/isRequiredForA11y'), require('../constants/keyCodes'), require('../utils/getField'), require('../utils/EventUtils/handleKeyboardAccessibility'), require('../utils/PropTypes/controlled'), require('../utils/NumberUtils/isBetween'), require('../utils/StringUtils/addSuffix'), require('../Lists/List'), require('../Lists/ListItem'), require('../Menus/Menu'), require('../Menus/Positions'), require('../TextFields/FloatingLabel'), require('../TextFields/TextFieldMessage'), require('./Field'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.reactDom, global.deprecated, global.isRequiredForA11y, global.keyCodes, global.getField, global.handleKeyboardAccessibility, global.controlled, global.isBetween, global.addSuffix, global.List, global.ListItem, global.Menu, global.Positions, global.FloatingLabel, global.TextFieldMessage, global.Field);
    global.SelectField = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _reactDom, _deprecated, _isRequiredForA11y, _keyCodes, _getField, _handleKeyboardAccessibility, _controlled, _isBetween, _addSuffix, _List, _ListItem, _Menu, _Positions, _FloatingLabel, _TextFieldMessage, _Field) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _deprecated2 = _interopRequireDefault(_deprecated);

  var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);

  var _getField2 = _interopRequireDefault(_getField);

  var _handleKeyboardAccessibility2 = _interopRequireDefault(_handleKeyboardAccessibility);

  var _controlled2 = _interopRequireDefault(_controlled);

  var _isBetween2 = _interopRequireDefault(_isBetween);

  var _addSuffix2 = _interopRequireDefault(_addSuffix);

  var _List2 = _interopRequireDefault(_List);

  var _ListItem2 = _interopRequireDefault(_ListItem);

  var _Menu2 = _interopRequireDefault(_Menu);

  var _Positions2 = _interopRequireDefault(_Positions);

  var _FloatingLabel2 = _interopRequireDefault(_FloatingLabel);

  var _TextFieldMessage2 = _interopRequireDefault(_TextFieldMessage);

  var _Field2 = _interopRequireDefault(_Field);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var VALID_LIST_ITEM_PROPS = Object.keys(_ListItem2.default.propTypes);

  var MOBILE_LIST_PADDING = 8;
  var SelectFieldPositions = Object.assign({}, _Positions2.default);
  delete SelectFieldPositions.BOTTOM_RIGHT;
  delete SelectFieldPositions.BOTTOM_LEFt;

  var SelectField = function (_PureComponent) {
    _inherits(SelectField, _PureComponent);

    function SelectField(props) {
      _classCallCheck(this, SelectField);

      var _this = _possibleConstructorReturn(this, (SelectField.__proto__ || Object.getPrototypeOf(SelectField)).call(this, props));

      _this.state = {
        active: false,
        activeIndex: _this._getActiveIndex(props, { value: props.defaultValue }),
        isOpen: typeof props.initiallyOpen !== 'undefined' ? props.initiallyOpen : !!props.defaultOpen,
        activeLabel: _this._getActiveLabel(props, typeof props.value !== 'undefined' ? props.value : props.defaultValue),
        match: null,
        lastSearch: null,
        error: false
      };

      if (typeof props.value === 'undefined') {
        _this.state.value = props.defaultValue;
      }

      _this._setMenu = _this._setMenu.bind(_this);
      _this._setField = _this._setField.bind(_this);
      _this._positionList = _this._positionList.bind(_this);
      _this._toggleOpen = _this._toggleOpen.bind(_this);
      _this._handleBlur = _this._handleBlur.bind(_this);
      _this._handleFocus = _this._handleFocus.bind(_this);
      _this._handleOpen = _this._handleOpen.bind(_this);
      _this._handleClose = _this._handleClose.bind(_this);
      _this._getActiveLabel = _this._getActiveLabel.bind(_this);
      _this._mapToListItem = _this._mapToListItem.bind(_this);
      _this._handleItemSelect = _this._handleItemSelect.bind(_this);
      _this._handleContainerClick = _this._handleContainerClick.bind(_this);
      _this._handleKeyDown = _this._handleKeyDown.bind(_this);
      _this._setMenuItem = _this._setMenuItem.bind(_this);
      _this._getActiveIndex = _this._getActiveIndex.bind(_this);
      _this._advanceFocus = _this._advanceFocus.bind(_this);
      _this._attemptItemFocus = _this._attemptItemFocus.bind(_this);
      _this._selectItemByLetter = _this._selectItemByLetter.bind(_this);
      _this._selectFirstMatch = _this._selectFirstMatch.bind(_this);

      _this._items = [];
      _this._activeItem = null;
      _this._focusedAtLeastOnce = false;
      return _this;
    }

    _createClass(SelectField, [{
      key: 'componentWillUpdate',
      value: function componentWillUpdate(nextProps, nextState) {
        var prevValue = (0, _getField2.default)(this.props, this.state, 'value');
        var value = (0, _getField2.default)(nextProps, nextState, 'value');
        var error = (0, _getField2.default)(nextProps, nextState, 'error');
        var isOpen = (0, _getField2.default)(nextProps, nextState, 'isOpen');
        var valued = !(0, _getField2.default)(nextProps, nextState, 'value');

        var state = void 0;
        if (prevValue !== value || this.props.menuItems !== nextProps.menuItems) {
          state = {
            activeLabel: this._getActiveLabel(nextProps, value)
          };
        }

        if (this._focusedAtLeastOnce && nextProps.required && !isOpen && error !== valued) {
          state = state || {};
          state.error = valued;
        }

        if (state) {
          this.setState(state);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this._matchingTimeout) {
          clearTimeout(this._matchingTimeout);
        }
      }
    }, {
      key: '_attemptItemFocus',
      value: function _attemptItemFocus(index) {
        if (index === -1) {
          return;
        }

        var item = this._items[index];
        if (item) {
          item.focus();
        }
      }
    }, {
      key: '_getActiveLabel',
      value: function _getActiveLabel(_ref, value) {
        var _this2 = this;

        var menuItems = _ref.menuItems,
            itemLabel = _ref.itemLabel,
            itemValue = _ref.itemValue;

        var activeLabel = '';
        menuItems.some(function (item) {
          activeLabel = _this2._getActiveLabelFromItem(item, value, itemLabel, itemValue);
          return activeLabel;
        });

        return activeLabel;
      }
    }, {
      key: '_getActiveLabelFromItem',
      value: function _getActiveLabelFromItem(item, value, itemLabel, itemValue) {
        switch (typeof item === 'undefined' ? 'undefined' : _typeof(item)) {
          case 'number':
          case 'string':
            if (item === value || item === parseInt(value, 10)) {
              return item;
            }

            break;
          case 'object':
            if (item[itemValue] === value || item[itemValue] === parseInt(value, 10)) {
              return item[itemLabel];
            }

            break;
          default:
        }

        return '';
      }
    }, {
      key: '_getActiveIndex',
      value: function _getActiveIndex(props, state) {
        var _this3 = this;

        var value = (0, _getField2.default)(props, state, 'value');
        if (!value) {
          return -1;
        }

        var itemLabel = props.itemLabel,
            itemValue = props.itemValue,
            menuItems = props.menuItems;

        var index = -1;
        menuItems.some(function (item, i) {
          var found = _this3._getActiveLabelFromItem(item, value, itemLabel, itemValue);
          if (found) {
            index = i;
          }

          return found;
        });

        return index;
      }
    }, {
      key: '_setMenu',
      value: function _setMenu(menu) {
        this._menu = (0, _reactDom.findDOMNode)(menu);
      }
    }, {
      key: '_setField',
      value: function _setField(field) {
        this._field = (0, _reactDom.findDOMNode)(field);
      }
    }, {
      key: '_positionList',
      value: function _positionList(listRef) {
        if (listRef === null) {
          this._items = [];
        } else if (!this._activeItem) {
          return;
        }

        var list = (0, _reactDom.findDOMNode)(listRef);
        var _props = this.props,
            position = _props.position,
            menuItems = _props.menuItems,
            toolbar = _props.toolbar;

        if (position === SelectField.Positions.BELOW || toolbar) {
          // only modify scroll distance when below
          var activeIndex = Math.min(this._activeItem, menuItems.length - 2);
          var _itemTop = list.querySelectorAll('.md-list-tile')[activeIndex].offsetTop;

          list.scrollTop = _itemTop > MOBILE_LIST_PADDING ? _itemTop : 0;
          return;
        }

        var _activeItem = this._activeItem,
            itemTop = _activeItem.offsetTop,
            itemHeight = _activeItem.offsetHeight;
        var menuHeight = this._menu.offsetHeight;

        var itemPosition = Math.max(0, itemTop - itemHeight);
        var listPadding = parseInt(window.getComputedStyle(list).getPropertyValue('padding-top'), 10);

        // Basically calculates where the current item is in the list, and attempts to make the menu
        // originate from that position.
        var x = SelectField.Positions.TOP_LEFT === position ? '0' : '100%';
        var y = (itemPosition === 0 ? 0 : menuHeight) + menuHeight / 2 + listPadding;
        var transformOrigin = x + ' ' + y + 'px';

        var top = void 0;
        if (itemPosition > 0) {
          // close enough. It is off by 4px for floating label on desktop
          top = -(itemHeight + listPadding - (menuHeight - itemHeight));
        }

        if (itemPosition > 0) {
          list.scrollTop = itemPosition;
        }

        this.setState({
          listStyle: {
            top: top,
            transformOrigin: transformOrigin
          }
        });
      }
    }, {
      key: '_handleFocus',
      value: function _handleFocus(e) {
        this._focusedAtLeastOnce = true;
        if (this.props.onFocus) {
          this.props.onFocus(e);
        }

        this.setState({ active: true });
      }
    }, {
      key: '_handleBlur',
      value: function _handleBlur(e) {
        if (this.props.onBlur) {
          this.props.onBlur(e);
        }

        var isOpen = (0, _getField2.default)(this.props, this.state, 'isOpen');
        var value = (0, _getField2.default)(this.props, this.state, 'value');

        this.setState({
          active: false,
          error: this.props.required && !isOpen && !value
        });
      }
    }, {
      key: '_handleItemSelect',
      value: function _handleItemSelect(index, v, e) {
        var _props2 = this.props,
            required = _props2.required,
            menuItems = _props2.menuItems,
            itemLabel = _props2.itemLabel,
            itemValue = _props2.itemValue,
            onChange = _props2.onChange,
            position = _props2.position;

        var number = typeof menuItems[index] === 'number' || typeof menuItems[index][itemValue] === 'number';
        var value = number ? Number(v) : v;

        var below = position === SelectField.Positions.BELOW;
        if ((0, _getField2.default)(this.props, this.state, 'value') !== value && onChange) {
          onChange(value, index, e);
        }

        var state = {
          activeIndex: below ? 0 : index,
          activeLabel: this._getActiveLabelFromItem(menuItems[index], value, itemLabel, itemValue),
          error: required && !value
        };

        if (typeof this.props.value === 'undefined') {
          state.value = value;
        }

        if (typeof this.props.isOpen === 'undefined' && e.type !== 'click') {
          state.isOpen = false;
        }

        this.setState(state);
      }
    }, {
      key: '_handleContainerClick',
      value: function _handleContainerClick(e) {
        if (this.props.onClick) {
          this.props.onClick(e);
        }

        var target = e.target;

        while (this._menu && this._menu.contains(target)) {
          if (target.dataset.id) {
            this._handleItemSelect(parseInt(target.dataset.id, 10), target.dataset.value, e);
            return;
          }

          target = target.parentNode;
        }
      }
    }, {
      key: '_toggleOpen',
      value: function _toggleOpen(e) {
        var isOpen = !(0, _getField2.default)(this.props, this.state, 'isOpen');
        if (this.props.onMenuToggle) {
          this.props.onMenuToggle(isOpen, e);
        }

        if (typeof this.props.isOpen === 'undefined') {
          this.setState({ isOpen: isOpen });
        }
      }
    }, {
      key: '_handleOpen',
      value: function _handleOpen(e) {
        if (this.props.onMenuToggle) {
          this.props.onMenuToggle(true, e);
        }

        var state = void 0;
        if (!(0, _getField2.default)(this.props, this.state, 'value') && this.state.activeIndex === -1) {
          // When there is no value, need to change the default active index to 0 instead of -1
          // so that the next DOWN arrow increments correctly
          state = { activeIndex: 0 };
        }

        if (typeof this.props.isOpen === 'undefined') {
          state = state || {};
          state.isOpen = true;
        }

        if (state) {
          this.setState(state);
        }
      }
    }, {
      key: '_handleClose',
      value: function _handleClose(e) {
        if (this.props.onMenuToggle) {
          this.props.onMenuToggle(false, e);
        }

        var state = void 0;
        if (this.props.position === SelectField.Positions.BELOW) {
          // Set the active index back to 0 since the active item will be spliced out
          // of the menu items
          state = { activeIndex: 0 };
        }

        if (typeof this.props.isOpen === 'undefined') {
          state = state || {};
          state.isOpen = false;
        }

        if (state) {
          this.setState(state);
        }
      }
    }, {
      key: '_mapToListItem',
      value: function _mapToListItem(item, i) {
        var _props3 = this.props,
            id = _props3.id,
            itemLabel = _props3.itemLabel,
            itemValueKey = _props3.itemValue,
            position = _props3.position;

        var below = position === SelectField.Positions.BELOW;
        var value = (0, _getField2.default)(this.props, this.state, 'value');

        var primaryText = '';
        var itemValue = '';
        var props = void 0;
        switch (typeof item === 'undefined' ? 'undefined' : _typeof(item)) {
          case 'number':
          case 'string':
            primaryText = item;
            itemValue = item;
            break;
          case 'object':
            primaryText = item[itemLabel];
            itemValue = typeof item[itemValueKey] !== 'undefined' ? item[itemValueKey] : item[itemLabel];
            props = Object.keys(item).reduce(function (validProps, key) {
              if (key !== itemLabel && key !== itemValueKey && key !== 'primaryText' && VALID_LIST_ITEM_PROPS.indexOf(key) !== -1) {
                validProps[key] = item[key];
              }

              return validProps;
            }, {});
            break;
          default:
        }

        var active = itemValue === value || itemValue === parseInt(value, 10);
        if (below && active) {
          return null;
        }

        return _react2.default.createElement(_ListItem2.default, _extends({}, props, {
          ref: this._setMenuItem,
          active: active,
          tabIndex: -1,
          primaryText: primaryText,
          key: item.key || i,
          role: 'option',
          id: active ? id + 'Active' : null,
          'data-id': i,
          'data-value': itemValue,
          tileStyle: below ? { paddingLeft: 24 } : undefined
        }));
      }
    }, {
      key: '_setMenuItem',
      value: function _setMenuItem(item) {
        if (!item) {
          return;
        }

        if (item.props.active) {
          this._activeItem = (0, _reactDom.findDOMNode)(item);
          item.focus();
        }

        this._items.push(item);
      }
    }, {
      key: '_handleKeyDown',
      value: function _handleKeyDown(e) {
        var key = e.which || e.keyCode;
        var isOpen = (0, _getField2.default)(this.props, this.state, 'isOpen');

        if (key === _keyCodes.UP || key === _keyCodes.DOWN) {
          e.preventDefault();

          if (!isOpen) {
            this._handleOpen(e);
            return;
          }
        }

        if (!isOpen && (0, _handleKeyboardAccessibility2.default)(e, this._handleOpen, true, true)) {
          return;
        } else if (isOpen && (key === _keyCodes.ESC || key === _keyCodes.TAB)) {
          if (this._field && key === _keyCodes.ESC) {
            this._field.focus();
          }

          this._handleClose(e);
          return;
        }

        switch (key) {
          case _keyCodes.UP:
          case _keyCodes.DOWN:
            this._advanceFocus(key === _keyCodes.UP, e);
            break;
          case _keyCodes.ENTER:
          case _keyCodes.SPACE:
            if (this._field) {
              this._field.focus();
            }

            this._handleContainerClick(e);
            break;
          default:
            this._selectItemByLetter(e, key);
        }
      }
    }, {
      key: '_advanceFocus',
      value: function _advanceFocus(decrement) {
        var _props4 = this.props,
            menuItems = _props4.menuItems,
            position = _props4.position;
        var activeIndex = this.state.activeIndex;


        var below = position === SelectField.Positions.BELOW;

        // If the select field is positioned below and there is no value, need to increment the last index
        // by one since this select field removes the active item. Need to account for that here when there
        // is no value.
        var lastIndex = menuItems.length - (below && !(0, _getField2.default)(this.props, this.state, 'value') ? 0 : 1);
        if (decrement && activeIndex <= 0 || !decrement && activeIndex >= lastIndex) {
          return;
        }

        var nextIndex = Math.max(-1, Math.min(lastIndex, activeIndex + (decrement ? -1 : 1)));
        if (nextIndex === activeIndex) {
          return;
        }

        this._attemptItemFocus(nextIndex - (below ? 1 : 0));
        if (below && decrement && nextIndex === 0) {
          return;
        }

        this.setState({ activeIndex: nextIndex });
      }
    }, {
      key: '_selectItemByLetter',
      value: function _selectItemByLetter(e, key) {
        var _this4 = this;

        var charCode = String.fromCharCode(key);
        var isLetter = charCode && charCode.match(/[A-Za-z0-9-_ ]/);
        var isKeypad = (0, _isBetween2.default)(key, _keyCodes.KEYPAD_ZERO, _keyCodes.KEYPAD_NINE);
        if (!(0, _isBetween2.default)(key, _keyCodes.ZERO, _keyCodes.NINE) && !isKeypad && !isLetter) {
          return;
        }

        var letter = isLetter ? charCode : String(key - (isKeypad ? _keyCodes.KEYPAD_ZERO : _keyCodes.ZERO));

        if (this._matchingTimeout) {
          clearTimeout(this._matchingTimeout);
        }

        this._matchingTimeout = setTimeout(function () {
          _this4._matchingTimeout = null;

          _this4.setState({ match: null, lastSearch: null });
        }, this.props.keyboardMatchingTimeout);

        this._selectFirstMatch(letter, e);
      }
    }, {
      key: '_selectFirstMatch',
      value: function _selectFirstMatch(letter, e) {
        var _props5 = this.props,
            menuItems = _props5.menuItems,
            itemLabel = _props5.itemLabel,
            itemValue = _props5.itemValue;


        var search = '' + (this.state.lastSearch || '') + letter;
        var match = -1;
        menuItems.some(function (item, i) {
          var value = String((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && item ? item[itemLabel] : item);
          if (value && value.toUpperCase().indexOf(search) === 0) {
            match = i;
          }

          return match > -1;
        });

        var activeItem = menuItems[match];

        var state = {
          match: match,
          lastSearch: search
        };

        if (match === -1) {
          this.setState(state);
          return;
        }

        state.activeLabel = (typeof activeItem === 'undefined' ? 'undefined' : _typeof(activeItem)) === 'object' ? activeItem[itemLabel] : activeItem;
        state.activeIndex = match;

        if ((0, _getField2.default)(this.props, this.state, 'isOpen')) {
          if (state.match !== this.state.match) {
            this._attemptItemFocus(state.activeIndex);
          }
        } else {
          var value = (typeof activeItem === 'undefined' ? 'undefined' : _typeof(activeItem)) === 'object' ? activeItem[itemValue] : activeItem;
          state.error = !value;

          if ((0, _getField2.default)(this.props, this.state, 'value') !== value && this.props.onChange) {
            this.props.onChange(value, state.activeIndex, e);
          }

          if (typeof this.props.value === 'undefined') {
            state.value = value;
          }
        }

        this.setState(state);
      }
    }, {
      key: 'render',
      value: function render() {
        var _state = this.state,
            activeLabel = _state.activeLabel,
            active = _state.active;

        var _props6 = this.props,
            id = _props6.id,
            style = _props6.style,
            className = _props6.className,
            listStyle = _props6.listStyle,
            listClassName = _props6.listClassName,
            inputStyle = _props6.inputStyle,
            inputClassName = _props6.inputClassName,
            disabled = _props6.disabled,
            menuItems = _props6.menuItems,
            position = _props6.position,
            stretchList = _props6.stretchList,
            errorText = _props6.errorText,
            helpText = _props6.helpText,
            helpOnFocus = _props6.helpOnFocus,
            required = _props6.required,
            fullWidth = _props6.fullWidth,
            props = _objectWithoutProperties(_props6, ['id', 'style', 'className', 'listStyle', 'listClassName', 'inputStyle', 'inputClassName', 'disabled', 'menuItems', 'position', 'stretchList', 'errorText', 'helpText', 'helpOnFocus', 'required', 'fullWidth']);

        delete props.error;
        delete props.itemLabel;
        delete props.itemValue;
        delete props.menuId;
        delete props.listId;
        delete props.defaultValue;
        delete props.value;
        delete props.isOpen;
        delete props.defaultOpen;
        delete props.keyboardMatchingTimeout;
        delete props.onMenuToggle;

        // delete deprecated
        delete props.menuStyle;
        delete props.menuClassName;
        delete props.initiallyOpen;
        delete props.floatingLabel;
        delete props.noAutoAdjust;
        delete props.adjustMinWidth;

        var _props7 = this.props,
            menuId = _props7.menuId,
            listId = _props7.listId,
            placeholder = _props7.placeholder,
            label = _props7.label,
            error = _props7.error;

        error = error || this.state.error;
        var value = (0, _getField2.default)(this.props, this.state, 'value');
        var isOpen = (0, _getField2.default)(this.props, this.state, 'isOpen');
        var below = position === SelectField.Positions.BELOW;

        if (!menuId) {
          menuId = id + 'Menu';
        }

        if (!listId) {
          listId = id + 'Values';
        }

        if (required) {
          if (label) {
            label = (0, _addSuffix2.default)(label, '*');
          }

          if (placeholder && !label) {
            placeholder = (0, _addSuffix2.default)(placeholder, '*');
          }
        }

        var toggle = [_react2.default.createElement(_FloatingLabel2.default, {
          key: 'floating-label',
          label: label,
          htmlFor: id,
          active: active || isOpen,
          error: error,
          floating: !!activeLabel || active || isOpen,
          disabled: disabled
        }), _react2.default.createElement(_Field2.default, _extends({}, props, {
          id: id,
          ref: this._setField,
          key: 'select-field',
          style: inputStyle,
          className: inputClassName,
          activeLabel: activeLabel,
          required: required,
          disabled: disabled,
          active: active || isOpen,
          below: below,
          value: value,
          label: label,
          error: error,
          placeholder: placeholder,
          onClick: this._toggleOpen,
          onFocus: this._handleFocus,
          onBlur: this._handleBlur
        })), _react2.default.createElement(_TextFieldMessage2.default, {
          key: 'message',
          active: active || isOpen,
          error: error,
          errorText: errorText,
          helpText: helpText,
          helpOnFocus: helpOnFocus,
          leftIcon: false,
          rightIcon: false
        })];

        return _react2.default.createElement(
          _Menu2.default,
          {
            id: menuId,
            position: position,
            isOpen: isOpen,
            onClose: this._handleClose,
            onClick: this._handleContainerClick,
            onKeyDown: this._handleKeyDown,
            toggle: toggle,
            style: style,
            className: (0, _classnames2.default)('md-select-field-menu', {
              'md-select-field-menu--stretch': stretchList
            }, className),
            ref: this._setMenu,
            fullWidth: fullWidth
          },
          _react2.default.createElement(
            _List2.default,
            {
              id: listId,
              role: 'listbox',
              ref: this._positionList,
              'aria-activedescendant': value ? id + 'Active' : null,
              style: _extends({}, listStyle, this.state.listStyle),
              className: listClassName
            },
            menuItems.map(this._mapToListItem).filter(function (item) {
              return item !== null;
            })
          )
        );
      }
    }]);

    return SelectField;
  }(_react.PureComponent);

  SelectField.Positions = SelectFieldPositions;
  SelectField.propTypes = {
    /**
     * An id to use for the select field. This is required for a11y. If the `menuId` and
     * `listId` are not given, this will be used to create their ids for a11y.
     */
    id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),

    /**
     * An optional name to give the select field's input.
     */
    name: _propTypes2.default.string,

    /**
     * An id to give the menu containing the select field. If this is omitted, the `id` prop
     * will be used to make this id. `${id}Menu`.
     */
    menuId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),

    /**
     * An id to give the list that appears once the menu is open. If this is omitted, the `id` prop
     * will be used to make this id. `${id}Values`.
     */
    listId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),

    /**
     * An optional style to apply to the select field's container. This is the `Menu` component.
     */
    style: _propTypes2.default.object,

    /**
     * An optional style to apply to the select field's container. This is the `Menu` component.
     */
    className: _propTypes2.default.string,

    /**
     * An optional style to apply to the select field's list of items that appear when opened.
     */
    listStyle: _propTypes2.default.object,

    /**
     * An optional className to apply to the select field's list of items that appear when opened.
     */
    listClassName: _propTypes2.default.string,

    /**
     * An optional style to apply to the select field itself.
     */
    inputStyle: _propTypes2.default.object,

    /**
     * An optional className to apply to the select field itself.
     */
    inputClassName: _propTypes2.default.string,

    /**
     * An optional value for the select field. This will require the `onChange` prop
     * to be defined since it will be a controlled component.
     */
    value: (0, _controlled2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]), 'onChange'),

    /**
     * The default value for an uncontrolled select field.
     */
    defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,

    /**
     * Boolean if the select field is open by default.
     */
    defaultOpen: _propTypes2.default.bool,

    /**
     * An optional boolean if the select field is currently open. This will make the component
     * controlled and require the `onMenuToggle` prop to be defined.
     */
    isOpen: (0, _controlled2.default)(_propTypes2.default.bool, 'onMenuToggle', 'defaultOpen'),

    /**
     * An optional function to call when the menu's open state changes. The callback will include
     * the next open state and the event that driggered it.
     *
     * ```js
     * onMenuToggle(isOpen, event);
     * ```
     */
    onMenuToggle: _propTypes2.default.func,

    /**
     * An optional function to call when the value for the select field changes. The callback will
     * include the new value, the index of the menu item that was selected, and the event that
     * triggered the change.
     *
     * ```js
     * onChange(newValue, newActiveIndex, event);
     * ```
     */
    onChange: _propTypes2.default.func,

    /**
     * A list of items to select from. This can be a mixed list of number, string,
     * or object. If the item is an object, make sure the `itemLabel` and `itemValue`
     * props match the keys in the object for the label and value.
     */
    menuItems: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.object])),

    /**
     * An optional floating label to display with the text field. This is invalid
     * if the `position` is set to `SelectField.Positions.BELOW`.
     */
    label: _propTypes2.default.node,

    /**
     * An optional placeholder to display in the select field.
     */
    placeholder: _propTypes2.default.string,

    /**
     * Boolean if the select field is disabled.
     */
    disabled: _propTypes2.default.bool,

    /**
     * The key to use for extracting a menu item's label if the menu item is an object.
     *
     * Example:
     *
     * ```js
     * const item = { something: 'My Label', somethingElse: 'value' };
     * const itemLabel = 'something';
     * const itemValue = 'somethingElse';
     * ```
     */
    itemLabel: _propTypes2.default.string.isRequired,

    /**
     * The key to use for extracting a menu item'value label if the menu item is an object.
     *
     * Example:
     *
     * ```js
     * const item = { something: 'My Label', somethingElse: 'value' };
     * const itemLabel = 'something';
     * const itemValue = 'somethingElse';
     * ```
     */
    itemValue: _propTypes2.default.string.isRequired,

    /**
     * Any children used to display the select field's drop down icon.
     */
    iconChildren: _propTypes2.default.node,

    /**
     * The icon class name to use to display the select field's drop down icon.
     */
    iconClassName: _propTypes2.default.string,

    /*
     * An optional function to call when the menu is clicked.
     */
    onClick: _propTypes2.default.func,

    /**
     * The position that the select field's options should appear from. If the position is
     * set to `BELOW`, the select field will be displayed as a button with ink instead of
     * a text field.
     */
    position: _propTypes2.default.oneOf([SelectField.Positions.TOP_LEFT, SelectField.Positions.TOP_RIGHT, SelectField.Positions.BELOW]).isRequired,

    /*
     * The direction that the select field's focus indicator should grow from.
     */
    lineDirection: _propTypes2.default.oneOf(['left', 'center', 'right']).isRequired,

    /**
     * An optional function to call when the select field is focused.
     */
    onFocus: _propTypes2.default.func,

    /**
     * An optional function to call when the select field is blurred. This
     * will also be triggered when a user selects a new item or keyboard navigates
     * through the list items.
     */
    onBlur: _propTypes2.default.func,

    /**
     * The amount of time that a list of letters should be used when finding a menu item
     * while typing. Since a user can select items by typing multiple letters in a row,
     * this will be used as the timeout for clearing those letters.
     *
     * For example:
     * - User types `g`
     *
     * Full match is now `'g'`.
     *
     * - User delays 200ms and types `u`
     *
     * Full match is now `'gu'`
     *
     * - User delays 1000ms and types `a`.
     *
     * Full match is now `'a'`
     */
    keyboardMatchingTimeout: _propTypes2.default.number.isRequired,

    /**
     * Boolean if the select field's list of menu items should stretch to at least
     * be the width of the select field.
     */
    stretchList: _propTypes2.default.bool,

    /**
     * Boolean if there has been an error for the select field. This will display
     * the `errorText`. And style the floating label and focus indicator with the
     * error color.
     */
    error: _propTypes2.default.bool,

    /**
     * An optional error text to display when the `error` prop is true.
     */
    errorText: _propTypes2.default.node,

    /**
     * An optional help text to display below the select field.
     */
    helpText: _propTypes2.default.node,

    /**
     * Boolean if the help text should only be displayed when the select field
     * has focus.
     */
    helpOnFocus: _propTypes2.default.bool,

    /**
     * Boolean if the select field is required. This will updated the label or placeholder
     * to include an asterisk.
     */
    required: _propTypes2.default.bool,

    /**
     * Boolean if the select field is in a toolbar. This will automatically be injected if the select field
     * is passed in as the `menuTitle` prop.
     */
    toolbar: _propTypes2.default.bool,

    /**
     * Boolean if the menu surrounding the select field should be full width or not.
     */
    fullWidth: _propTypes2.default.bool,

    menuStyle: (0, _deprecated2.default)(_propTypes2.default.object, 'Use `style` instead'),
    menuClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `className` instead'),
    initiallyOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `defaultOpen` instead'),
    floatingLabel: (0, _deprecated2.default)(_propTypes2.default.bool, 'A select field can only have floating labels now. Only provide the `label` prop'),
    noAutoAdjust: (0, _deprecated2.default)(_propTypes2.default.bool, 'No longer valid to use since select fields are no longer text fields'),
    adjustMinWidth: (0, _deprecated2.default)(_propTypes2.default.bool, 'No longer valid to use since select fields are no longer text fields')
  };
  SelectField.defaultProps = {
    defaultValue: '',
    itemLabel: 'label',
    itemValue: 'value',
    iconChildren: 'arrow_drop_down',
    position: SelectField.Positions.TOP_LEFT,
    lineDirection: 'left',
    keyboardMatchingTimeout: 1000,
    stretchList: true,
    menuItems: []
  };
  exports.default = SelectField;
});

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(258)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./SelectField'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.SelectField);
    global.index = mod.exports;
  }
})(this, function (exports, _SelectField) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _SelectField2 = _interopRequireDefault(_SelectField);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _SelectField2.default;
});

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(12), __webpack_require__(17), __webpack_require__(83)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('react-prop-types/lib/deprecated'), require('react-prop-types/lib/isRequiredForA11y'), require('./SelectionControl'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.deprecated, global.isRequiredForA11y, global.SelectionControl);
    global.Radio = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _deprecated, _isRequiredForA11y, _SelectionControl) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _deprecated2 = _interopRequireDefault(_deprecated);

  var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);

  var _SelectionControl2 = _interopRequireDefault(_SelectionControl);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Radio = function (_PureComponent) {
    _inherits(Radio, _PureComponent);

    function Radio() {
      _classCallCheck(this, Radio);

      return _possibleConstructorReturn(this, (Radio.__proto__ || Object.getPrototypeOf(Radio)).apply(this, arguments));
    }

    _createClass(Radio, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            checkedIconChildren = _props.checkedIconChildren,
            checkedIconClassName = _props.checkedIconClassName,
            uncheckedIconChildren = _props.uncheckedIconChildren,
            uncheckedIconClassName = _props.uncheckedIconClassName,
            props = _objectWithoutProperties(_props, ['checkedIconChildren', 'checkedIconClassName', 'uncheckedIconChildren', 'uncheckedIconClassName']);

        return _react2.default.createElement(_SelectionControl2.default, _extends({
          type: 'radio',
          checkedRadioIconChildren: checkedIconChildren,
          checkedRadioIconClassName: checkedIconClassName,
          uncheckedRadioIconChildren: uncheckedIconChildren,
          uncheckedRadioIconClassName: uncheckedIconClassName,
          __superSecreteProp: true
        }, props));
      }
    }]);

    return Radio;
  }(_react.PureComponent);

  Radio.propTypes = {
    /**
     * An id to use with the radio. This is used for accessibility and so that the label
     * triggers the radio toggle.
     */
    id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),

    /**
     * An optional style to apply to the radio's container.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply to the radio's container.
     */
    className: _propTypes2.default.string,

    /**
     * A label to display with the radio. This is required for accessibility and triggering
     * the toggle.
     */
    label: _propTypes2.default.node.isRequired,

    /**
     * Boolean if the label should appear before the radio icon.
     */
    labelBefore: _propTypes2.default.bool,

    /**
     * A name to use for the `Radio`. This is required for accessibility.
     */
    name: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),

    /**
     * Boolean if the `Radio` is disabled.
     */
    disabled: _propTypes2.default.bool,

    /**
     * A function to call when the `Radio` triggers the `change` event. The `onChange` callback
     * will include the current value of the checked `radio` and the change event.
     *
     * ```js
     * onChange(changeEvent.target.value, changeEvent);
     * ```
     */
    onChange: _propTypes2.default.func,

    /**
     * The value for the `Radio` component.
     */
    value: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.string]).isRequired,

    /**
     * A boolean if the `Radio` is currently checked.
     */
    checked: _propTypes2.default.bool.isRequired,

    /**
     * Boolean if the `Radio` should be displayed inline.
     */
    inline: _propTypes2.default.bool,

    /**
     * Any children to use for the checked `FontIcon` of the `Radio`.
     */
    checkedIconChildren: _propTypes2.default.node,

    /**
     * An icon className to use for the checked `FontIcon` of the `Radio`.
     */
    checkedIconClassName: _propTypes2.default.string,

    /**
     * Any children to use for the unchecked `FontIcon` of the `Radio`.
     */
    uncheckedIconChildren: _propTypes2.default.node,

    /**
     * An icon className to use for the unchecked `FontIcon` of the `Radio`.
     */
    uncheckedIconClassName: _propTypes2.default.string,

    checkedIcon: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `checkedIconChildren` and `checkedIconClassName` props instead.'),
    uncheckedIcon: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `uncheckedIconChildren` and `uncheckedIconClassName` props instead.')
  };
  Radio.defaultProps = {
    checkedIconChildren: 'radio_button_checked',
    uncheckedIconChildren: 'radio_button_unchecked'
  };
  exports.default = Radio;
});

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(9), __webpack_require__(3), __webpack_require__(14), __webpack_require__(16), __webpack_require__(1195), __webpack_require__(20), __webpack_require__(83)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('react-dom'), require('classnames'), require('../constants/keyCodes'), require('../utils/getField'), require('../utils/NumberUtils/minMaxLoop'), require('../utils/PropTypes/controlled'), require('./SelectionControl'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.reactDom, global.classnames, global.keyCodes, global.getField, global.minMaxLoop, global.controlled, global.SelectionControl);
    global.SelectionControlGroup = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _reactDom, _classnames, _keyCodes, _getField, _minMaxLoop, _controlled, _SelectionControl) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _getField2 = _interopRequireDefault(_getField);

  var _minMaxLoop2 = _interopRequireDefault(_minMaxLoop);

  var _controlled2 = _interopRequireDefault(_controlled);

  var _SelectionControl2 = _interopRequireDefault(_SelectionControl);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  /**
   * A custom PropTypes validator to make sure that each `control` in the `controls` prop
   * contains the given `propName`, or the `SelectionControlGroup` has defined that prop.
   */
  function requiredByAllControls(validator) {
    return function validate(props, propName, component) {
      for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        others[_key - 3] = arguments[_key];
      }

      var err = validator.apply(undefined, [props, propName, component].concat(others));

      if (!err && typeof props[propName] === 'undefined') {
        var invalids = props.controls.filter(function (c) {
          return !c[propName];
        }).map(function (_, i) {
          return i;
        });
        if (invalids.length) {
          var invalidPrefix = invalids.length === props.controls.length ? 'All `controls`' : 'The `controls` at indexes `' + invalids.join('`, `') + '`';
          var invalidMsg = invalidPrefix + ' are missing the `' + propName + '` prop.';

          err = new Error('The `' + propName + '` prop is required to make `' + component + '` accessible for users of ' + ('assistive technologies such as screen readers. Either add the `' + propName + '` to the `' + component + '` ') + ('or add the `' + propName + '` to each `control` in the `controls` prop. ' + invalidMsg));
        }
      }

      return err;
    };
  }

  /**
   * The `SelectionControlGroup` component is used to simplify the generation of a list
   * of `SelectionControl`. Any common props are extracted to this component and passed
   * to the `SelectionControl`.
   */

  var SelectionControlGroup = function (_PureComponent) {
    _inherits(SelectionControlGroup, _PureComponent);

    function SelectionControlGroup(props) {
      _classCallCheck(this, SelectionControlGroup);

      var _this = _possibleConstructorReturn(this, (SelectionControlGroup.__proto__ || Object.getPrototypeOf(SelectionControlGroup)).call(this, props));

      var radio = props.type === 'radio';
      _this.state = {};

      if (typeof props.value === 'undefined') {
        var value = props.defaultValue;

        if (typeof value === 'undefined') {
          value = radio ? props.controls[0].value : '';
        }

        _this.state.value = value;
      }

      var groupValue = (0, _getField2.default)(props, _this.state, 'value');
      props.controls.some(function (_ref, i) {
        var value = _ref.value;

        if (value === groupValue) {
          _this._activeIndex = i;
        }

        return typeof _this._activeIndex !== 'undefined';
      });

      _this._handleChange = _this._handleChange.bind(_this);
      _this._handleKeyDown = _this._handleKeyDown.bind(_this);
      return _this;
    }

    _createClass(SelectionControlGroup, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this._group = (0, _reactDom.findDOMNode)(this);
      }
    }, {
      key: '_isChecked',
      value: function _isChecked(value, controlValue, type) {
        return type === 'radio' ? value === controlValue : value.split(',').indexOf(controlValue) !== -1;
      }
    }, {
      key: '_handleChange',
      value: function _handleChange(e) {
        var value = e.target.value;
        if (this.props.type === 'checkbox') {
          var checked = e.target.checked;


          var values = (0, _getField2.default)(this.props, this.state, 'value').split(',');
          var index = values.indexOf(value);
          if (checked) {
            values.push(value);
          } else {
            values.splice(index, 1);
          }

          value = values.join(',');
        }

        if (this.props.onChange) {
          this.props.onChange(value, e);
        }

        if (typeof this.props.value === 'undefined') {
          this.setState({ value: value });
        }
      }
    }, {
      key: '_handleKeyDown',
      value: function _handleKeyDown(e) {
        if (this.props.onKeyDown) {
          this.props.onKeyDown(e);
        }

        var key = e.which || e.keyCode;
        var dec = key === _keyCodes.UP || key === _keyCodes.LEFT;
        var inc = key === _keyCodes.DOWN || key === _keyCodes.RIGHT;
        if (!this._group || !dec && !inc) {
          return;
        }

        e.preventDefault();
        var radios = this._group.querySelectorAll('*[role="radio"]');
        this._activeIndex = (0, _minMaxLoop2.default)(this._activeIndex, 0, radios.length - 1, inc);
        radios[this._activeIndex].focus();
        var value = this.props.controls[this._activeIndex].value;

        if ((0, _getField2.default)(this.props, this.state, 'value') !== value) {
          if (this.props.onChange) {
            this.props.onChange(value, e);
          }

          if (typeof this.props.value === 'undefined') {
            this.setState({ value: value });
          }
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _props = this.props,
            id = _props.id,
            name = _props.name,
            type = _props.type,
            label = _props.label,
            labelClassName = _props.labelClassName,
            className = _props.className,
            controlStyle = _props.controlStyle,
            controlClassName = _props.controlClassName,
            Component = _props.component,
            LabelComponent = _props.labelComponent,
            inline = _props.inline,
            disabled = _props.disabled,
            props = _objectWithoutProperties(_props, ['id', 'name', 'type', 'label', 'labelClassName', 'className', 'controlStyle', 'controlClassName', 'component', 'labelComponent', 'inline', 'disabled']);

        delete props.value;
        delete props.controls;
        delete props.defaultValue;

        var value = (0, _getField2.default)(this.props, this.state, 'value');
        var radio = type === 'radio';

        var controls = this.props.controls.map(function (control, i) {
          var style = control.style;
          if (controlStyle) {
            style = style ? _extends({}, controlStyle, style) : controlStyle;
          }

          var checked = _this2._isChecked(value, control.value, type);
          var controlProps = _extends({
            id: '' + id + i,
            key: 'control' + i,
            name: '' + name + (type === 'checkbox' ? '[]' : ''),
            type: type,
            inline: inline,
            disabled: disabled,
            checked: checked,
            tabIndex: checked && radio ? undefined : -1
          }, control, {
            style: style,
            className: (0, _classnames2.default)(controlClassName, control.className)
          });

          return _react2.default.createElement(_SelectionControl2.default, controlProps);
        });

        var ariaLabel = void 0;
        if (label) {
          ariaLabel = _react2.default.createElement(
            LabelComponent,
            { className: labelClassName },
            label
          );
        }

        return _react2.default.createElement(
          Component,
          _extends({}, props, {
            className: (0, _classnames2.default)('md-selection-control-group', className),
            onChange: this._handleChange,
            onKeyDown: radio ? this._handleKeyDown : null
          }),
          ariaLabel,
          controls
        );
      }
    }]);

    return SelectionControlGroup;
  }(_react.PureComponent);

  SelectionControlGroup.propTypes = {
    /**
     * An optional style to apply to the container.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply to the container.
     */
    className: _propTypes2.default.string,

    /**
     * An optional style to apply to every `SelectionControl`. This will be merged with any `style`
     * that a `control` might have.
     */
    controlStyle: _propTypes2.default.object,

    /**
     * An optional className to apply to every `SelectionControl`. This will be merged with any
     * `className` that a `control` might have.
     */
    controlClassName: _propTypes2.default.string,

    /**
     * An optional base id to apply to each `SelectionControl`. When this is included, the id for
     * each control will start with this and end with their current index. If this is ommitted,
     * each `control` in the `controls` prop *must* have an `id` prop. This is required for
     * accessibility.
     */
    id: requiredByAllControls(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),

    /**
     * The type to apply to each `SelectionControl` in the group. Only `checkbox` and `radio` is
     * valid for a grouping.
     */
    type: _propTypes2.default.oneOf(['checkbox', 'radio']).isRequired,

    /**
     * The component to render the `SelectionControlGroup` in.
     */
    component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,

    /**
     * An optional label to display above the group of `SelectionControl`s.
     */
    label: _propTypes2.default.node,

    /**
     * An optional className to apply to the node surrounding the `label` prop.
     */
    labelClassName: _propTypes2.default.string,

    /**
     * The component to render the optional `label` in.
     */
    labelComponent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,

    /**
     * An optional function to call when any `SelectionControl`'s `checked` state is changed
     * in the group. If the `type` of the group is `radio`, the `value` of the `checked` radio
     * will be given in the callback. If the `type` of the group is `checkbox`, a comma-delimited
     * string of all `checked` checkboxes values will be given.
     *
     * ```js
     * // checkbox
     * onChange('Alpha,Omega', changeEvent);
     *
     * // radio
     * onChange('Omega', changeEvent);
     * ```
     */
    onChange: _propTypes2.default.func,

    /**
     * A name to use for each `SelectionControl` in the group. If the `type` of the group is
     * `checkbox`, the name will be updated to be an array name so that using
     * `document.querySelector('input[name="yourName[]"].value` will give the comma-delimited
     * string of checked checkboxes.
     *
     * It is either required to have this prop set or every `control` in the `controls` prop to
     * have the `name` prop.
     */
    name: requiredByAllControls(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),

    /**
     * The default value for the `SelectionControlGroup`. This can either be a single value
     * or a comma-delimited string of checkbox values. When the `type` of the group is `radio`
     * and the group is uncontrolled, it is recommened to set this prop. Otherwise the first
     * value of the `controls` prop will be used as the defalt value.
     */
    defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.string]),

    /**
     * An optional value to use for the `SelectionControlGroup`. This will make the component
     * controlled and require the `onChange` prop to be defined. Like the `defaultValue`, this
     * can either be a single value or a comma-delimited list of checkbox values.
     */
    value: (0, _controlled2.default)(_propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.string]), 'onChange'),

    /**
     * A list of objects to create the `SelectControl` components. The shape of the object
     * is the `propTypes` of the `SelectionControl` component, except that `value` prop is
     * now required.
     *
     * The `SelectionControl` will inherit any inheritable props from the `SelectionControlGroup`.
     */
    controls: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      key: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
      label: _propTypes2.default.node.isRequired,
      value: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.string]).isRequired
    })).isRequired,

    /**
     * Boolean if the `SelectionControl` should be displayed inline.
     */
    inline: _propTypes2.default.bool,

    /**
     * Boolean if all the selection controls in the group are disabled.
     */
    disabled: _propTypes2.default.bool,

    /**
     * An optional function to call when the keydown event is triggered.
     */
    onKeyDown: _propTypes2.default.func
  };
  SelectionControlGroup.defaultProps = {
    component: 'fieldset',
    labelComponent: 'legend',
    labelClassName: 'md-subheading-1'
  };
  exports.default = SelectionControlGroup;
});

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(573)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./Subheader'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.Subheader);
    global.index = mod.exports;
  }
})(this, function (exports, _Subheader) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _Subheader2 = _interopRequireDefault(_Subheader);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _Subheader2.default;
});

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(589), __webpack_require__(37)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('../utils/PropTypes/oneRequired'), require('../Helpers/AccessibleFakeInkedButton'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.oneRequired, global.AccessibleFakeInkedButton);
    global.Tab = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _oneRequired, _AccessibleFakeInkedButton) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _oneRequired2 = _interopRequireDefault(_oneRequired);

  var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Tab = function (_PureComponent) {
    _inherits(Tab, _PureComponent);

    function Tab(props) {
      _classCallCheck(this, Tab);

      var _this = _possibleConstructorReturn(this, (Tab.__proto__ || Object.getPrototypeOf(Tab)).call(this, props));

      _this._handleClick = _this._handleClick.bind(_this);
      return _this;
    }

    _createClass(Tab, [{
      key: '_handleClick',
      value: function _handleClick(e) {
        if (this.props.onClick) {
          this.props.onClick(this.props.index, this.props.id, this.props.controlsId, this.props.children, e);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            id = _props.id,
            controlsId = _props.controlsId,
            className = _props.className,
            active = _props.active,
            props = _objectWithoutProperties(_props, ['id', 'controlsId', 'className', 'active']);

        delete props.index;
        delete props.icon;
        delete props.label;

        var _props2 = this.props,
            icon = _props2.icon,
            label = _props2.label;

        if (icon) {
          var iconEl = _react.Children.only(icon);
          icon = (0, _react.cloneElement)(icon, {
            className: (0, _classnames2.default)('md-icon--tab', iconEl.props.className)
          });
        }

        if ((0, _react.isValidElement)(label)) {
          var labelEl = _react.Children.only(label);
          label = (0, _react.cloneElement)(label, {
            className: (0, _classnames2.default)('md-tab-label', labelEl.props.className)
          });
        } else {
          label = _react2.default.createElement(
            'div',
            { className: 'md-tab-label' },
            label
          );
        }
        return _react2.default.createElement(
          _AccessibleFakeInkedButton2.default,
          _extends({}, props, {
            id: id,
            role: 'tab',
            onClick: this._handleClick,
            className: (0, _classnames2.default)('md-tab', {
              'md-tab--active': active,
              'md-tab--inactive': !active,
              'md-tab--icon': label && icon
            }, className),
            'aria-controls': controlsId,
            'aria-selected': active
          }),
          icon,
          label
        );
      }
    }]);

    return Tab;
  }(_react.PureComponent);

  Tab.propTypes = {
    /**
     * An id for the tab. This is required for a11y. If you use the `Tabs` component, this
     * will automatically be generated for you and injected into this component.
     */
    id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),

    /**
     * An id for a `TabPanel` that holds the children from this tab. This is required for a11y.
     * If you use the `Tabs` component, this will automatically be generated for you and injected
     * into this component.
     */
    controlsId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),

    /**
     * An optional style to apply.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply.
     */
    className: _propTypes2.default.string,

    /**
     * The component to render as.
     */
    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,

    /**
     * Any children to display once the tab has been selected.
     */
    children: _propTypes2.default.node,

    /**
     * An optional icon to display in the tab. This can either be used alone, or it
     * will be placed above the `label` if both are given.
     */
    icon: _propTypes2.default.element,

    /**
     * An optional label to display in the tab. This can either be used alone, or it
     * will be placed below the `icon` if both are given.
     */
    label: (0, _oneRequired2.default)(_propTypes2.default.node, 'icon'),

    /**
     * An optional function to call when the tab is clicked. The callback includes this tab's index,
     * id, controlsId, children, and finally click event. All the additional parameters are included
     * if you are not using the `TabsContainer` component. The `id` and `controlsId` are mainly passed
     * for accessibility.
     *
     * ```js
     * onClick(index, id, controlsId, children, event);
     * ```
     */
    onClick: _propTypes2.default.func,

    /**
     * Boolean if the tab is currently active. If you use the `Tabs` component, this is automatically
     * injected.
     */
    active: _propTypes2.default.bool,

    /**
     * Boolean if the tab is currently active. If you use the `Tabs` component, this is automatically
     * injected.
     */
    index: _propTypes2.default.number
  };
  Tab.defaultProps = {
    component: 'li'
  };
  exports.default = Tab;
});

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(9), __webpack_require__(3), __webpack_require__(17), __webpack_require__(581), __webpack_require__(16), __webpack_require__(20), __webpack_require__(1175), __webpack_require__(81), __webpack_require__(28), __webpack_require__(574), __webpack_require__(1176)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('react-dom'), require('classnames'), require('react-prop-types/lib/isRequiredForA11y'), require('../constants/media'), require('../utils/getField'), require('../utils/PropTypes/controlled'), require('./TabIndicator'), require('../Helpers/IconSeparator'), require('../FontIcons/FontIcon'), require('./MenuTab'), require('./TabOverflowButton'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.reactDom, global.classnames, global.isRequiredForA11y, global.media, global.getField, global.controlled, global.TabIndicator, global.IconSeparator, global.FontIcon, global.MenuTab, global.TabOverflowButton);
    global.Tabs = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _reactDom, _classnames, _isRequiredForA11y, _media, _getField, _controlled, _TabIndicator, _IconSeparator, _FontIcon, _MenuTab, _TabOverflowButton) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);

  var _getField2 = _interopRequireDefault(_getField);

  var _controlled2 = _interopRequireDefault(_controlled);

  var _TabIndicator2 = _interopRequireDefault(_TabIndicator);

  var _IconSeparator2 = _interopRequireDefault(_IconSeparator);

  var _FontIcon2 = _interopRequireDefault(_FontIcon);

  var _MenuTab2 = _interopRequireDefault(_MenuTab);

  var _TabOverflowButton2 = _interopRequireDefault(_TabOverflowButton);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var MOBILE_PADDING = 72;
  var DESKTOP_PADDING = 80;
  var MOBILE_TAB_MIN_WIDTH = 72;
  var DESKTOP_TAB_MIN_WIDTH = 160;

  /**
   * The `Tabs` component is used to manage the state of which tab is currently active.
   */

  var Tabs = function (_PureComponent) {
    _inherits(Tabs, _PureComponent);

    function Tabs(props) {
      _classCallCheck(this, Tabs);

      var _this = _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, props));

      var defaultTabIndex = typeof props.activeTabIndex === 'undefined' ? props.defaultTabIndex : props.activeTabIndex;
      var mobile = typeof window !== 'undefined' ? _this._isMobile(props) : props.defaultMedia !== 'desktop';
      var indicatorWidth = mobile ? MOBILE_TAB_MIN_WIDTH : DESKTOP_TAB_MIN_WIDTH;
      _this.state = {
        indicatorWidth: indicatorWidth,
        indicatorOffset: indicatorWidth * defaultTabIndex,
        indicatorVisible: true,
        overflowIndex: 0
      };

      if (typeof props.activeTabIndex === 'undefined') {
        _this.state.activeTabIndex = defaultTabIndex;
      }

      _this._setContainer = _this._setContainer.bind(_this);
      _this._positionElements = _this._positionElements.bind(_this);
      _this._scrollActiveIntoView = _this._scrollActiveIntoView.bind(_this);
      _this._handleTabChange = _this._handleTabChange.bind(_this);
      _this._nextIndexes = _this._nextIndexes.bind(_this);
      _this._showNextTabs = _this._showNextTabs.bind(_this);
      _this._showPreviousTabs = _this._showPreviousTabs.bind(_this);
      _this._mapToOverflowTabProps = _this._mapToOverflowTabProps.bind(_this);
      return _this;
    }

    _createClass(Tabs, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        window.addEventListener('resize', this._positionElements);
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (this.props.activeTabIndex !== nextProps.activeTabIndex) {
          this.setState(_extends({}, this._calcIndicatorPosition(this._container, 0, nextProps.activeTabIndex, this.state.overflowAtIndex)), this._scrollActiveIntoView);
        } else if (!this._shouldAlign(nextProps) && this._shouldAlign(this.props)) {
          this.setState({ paddingLeft: null });
        }
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps, prevState) {
        var _this2 = this;

        if (this._shouldAlign(this.props) && this.state.overflowAtIndex !== prevState.overflowAtIndex) {
          var paddingLeft = this._calcPaddingLeft(this._container, this.state.mobile);
          // Have to wait for the overflow menus to appear, then wop
          /* eslint-disable react/no-did-update-set-state */
          this.setState({ paddingLeft: paddingLeft });
        } else {
          (function () {
            var labels = _react.Children.map(_react.Children.toArray(_this2.props.children), function (_ref) {
              var label = _ref.props.label;
              return label;
            });
            var prevLabels = _react.Children.map(_react.Children.toArray(prevProps.children), function (_ref2) {
              var label = _ref2.props.label;
              return label;
            });
            if (labels.length !== prevLabels.length || labels.filter(function (_, i) {
              return labels[i] !== prevLabels[i];
            }).length) {
              _this2.setState(_extends({}, _this2._calcIndicatorPosition(_this2._container, 0, _this2.props.activeTabIndex, _this2.state.overflowAtIndex)), _this2._scrollActiveIntoView);
            }
          })();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        window.removeEventListener('resize', this._positionElements);
      }
    }, {
      key: '_shouldAlign',
      value: function _shouldAlign(props) {
        return typeof props.alignToKeyline === 'boolean' ? props.alignToKeyline : _react.Children.toArray(props.children).filter(function (child) {
          return !!child;
        }).length > 3;
      }
    }, {
      key: '_isMobile',
      value: function _isMobile(props) {
        var min = props.desktopMinWidth;

        return typeof window !== 'undefined' && !window.matchMedia('screen and (min-width: ' + min + 'px)').matches;
      }
    }, {
      key: '_calcPaddingLeft',
      value: function _calcPaddingLeft(container, mobile) {
        var mediaPadding = mobile ? MOBILE_PADDING : DESKTOP_PADDING;
        var tab = container.querySelector('.md-tab');

        var _tab$querySelector = tab.querySelector('.md-tab-label'),
            labelOffset = _tab$querySelector.offsetLeft;

        return mediaPadding - labelOffset;
      }
    }, {
      key: '_calcOverflowIndex',
      value: function _calcOverflowIndex(container) {
        var paddingLeft = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var menu = arguments[2];

        var containerWidth = container.offsetWidth;
        var overflowIndex = 0;
        if (containerWidth < container.scrollWidth) {
          (function () {
            var tabs = Array.prototype.slice.call(container.querySelectorAll('.md-tab'));
            var totalWidth = 0;
            tabs.some(function (tab, i) {
              overflowIndex = i;
              totalWidth += tab.offsetWidth;

              return totalWidth > containerWidth;
            });
          })();
        }

        return Math.max(0, overflowIndex - (menu ? 1 : 0));
      }
    }, {
      key: '_calcIndicatorPosition',
      value: function _calcIndicatorPosition(container) {
        var paddingLeft = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var activeTabIndex = arguments[2];
        var overflowAtIndex = arguments[3];

        var activeItem = void 0;
        if (typeof activeTabIndex === 'number') {
          if (overflowAtIndex > 0 && activeTabIndex >= overflowAtIndex) {
            activeItem = container.querySelector('.md-menu--tab');
          } else {
            activeItem = container.querySelectorAll('.md-tab')[activeTabIndex];
          }
        } else {
          activeItem = container.querySelector('.md-tab--active');
        }

        if (!activeItem) {
          return { indicatorVisible: false };
        }

        var _activeItem = activeItem,
            indicatorWidth = _activeItem.offsetWidth,
            indicatorOffset = _activeItem.offsetLeft;

        return {
          indicatorWidth: indicatorWidth,
          indicatorOffset: indicatorOffset + paddingLeft,
          indicatorVisible: !overflowAtIndex || overflowAtIndex > activeTabIndex
        };
      }
    }, {
      key: '_setContainer',
      value: function _setContainer(container) {
        this._container = (0, _reactDom.findDOMNode)(container);
        this._positionElements(this._container !== null);
      }
    }, {
      key: '_positionElements',
      value: function _positionElements(initialRender) {
        initialRender = typeof initialRender === 'boolean' && initialRender;
        if (!this._container) {
          return;
        }

        var _props = this.props,
            centered = _props.centered,
            overflowMenu = _props.overflowMenu;

        var mobile = this._isMobile(this.props);

        var paddingLeft = void 0;
        if (!centered && this._shouldAlign(this.props)) {
          paddingLeft = this._calcPaddingLeft(this._container, mobile);
        }

        var overflowAtIndex = void 0;
        if (!mobile) {
          overflowAtIndex = this._calcOverflowIndex(this._container, paddingLeft, overflowMenu);
        }

        var indicatorPosition = this._calcIndicatorPosition(this._container, initialRender ? paddingLeft : 0);

        this.setState(_extends({ mobile: mobile, paddingLeft: paddingLeft, overflowAtIndex: overflowAtIndex }, indicatorPosition), this._scrollActiveIntoView);
      }
    }, {
      key: '_scrollActiveIntoView',
      value: function _scrollActiveIntoView() {
        var _this3 = this;

        if (!this._container || !this.state.mobile) {
          return;
        }

        var active = this._container.querySelector('.md-tab--active');
        if (!active) {
          return;
        }

        var allTabs = Array.prototype.slice.call(this._container.querySelectorAll('.md-tab'));
        if (allTabs[0] === active) {
          this._container.scrollLeft = 0;
          return;
        }

        var _container = this._container,
            containerWidth = _container.offsetWidth,
            scrollLeft = _container.scrollLeft;
        var activeWidth = active.offsetWidth,
            activeOffset = active.offsetLeft;

        var inFullViewLeft = activeOffset - scrollLeft >= 0;
        var inFullViewRight = activeOffset + activeWidth - (containerWidth + scrollLeft) <= 0;
        if (inFullViewLeft && inFullViewRight) {
          return;
        }

        var offset = 0;
        allTabs.some(function (tab, i) {
          if (i < _this3.props.activeTabIndex) {
            offset += tab.offsetWidth;
          }

          return i < _this3.state.activeTabIndex;
        });

        this._container.scrollLeft = offset;
      }
    }, {
      key: '_handleTabChange',
      value: function _handleTabChange(index, tabId, tabControlsId, tabChildren, event) {
        if (this.props.onTabChange) {
          this.props.onTabChange(index, tabId, tabControlsId, tabChildren, event);
        }

        if (typeof this.props.activeTabIndex === 'undefined') {
          this.setState(_extends({
            activeTabIndex: index
          }, this._calcIndicatorPosition(this._container, 0, index, this.state.overflowAtIndex)));
        }
      }
    }, {
      key: '_mapToOverflowTabProps',
      value: function _mapToOverflowTabProps(tab, i) {
        var index = i + this.state.overflowAtIndex;
        var active = (0, _getField2.default)(this.props, this.state, 'activeTabIndex') === index;
        var tabEl = _react.Children.only(tab);
        var handleTabChange = this._handleTabChange;

        return {
          active: active,
          primaryText: tabEl.props.label,
          onClick: function handleClick(event) {
            var _tabEl$props = tabEl.props,
                onClick = _tabEl$props.onClick,
                id = _tabEl$props.id,
                controlsId = _tabEl$props.controlsId,
                children = _tabEl$props.children;

            if (onClick) {
              onClick(index, event);
            }

            handleTabChange(index, id, controlsId, children, event);
          }
        };
      }
    }, {
      key: '_nextIndexes',
      value: function _nextIndexes(increment) {
        var _state = this.state,
            overflowIndex = _state.overflowIndex,
            overflowAtIndex = _state.overflowAtIndex;

        var visibleAmt = (overflowAtIndex - overflowIndex) * (increment ? 1 : -1);

        this.setState({
          overflowIndex: overflowIndex + visibleAmt,
          overflowAtIndex: overflowAtIndex + visibleAmt
        });
      }
    }, {
      key: '_showNextTabs',
      value: function _showNextTabs() {
        this._nextIndexes(true);
      }
    }, {
      key: '_showPreviousTabs',
      value: function _showPreviousTabs() {
        this._nextIndexes(false);
      }
    }, {
      key: 'render',
      value: function render() {
        var _this4 = this;

        var _state2 = this.state,
            indicatorOffset = _state2.indicatorOffset,
            indicatorWidth = _state2.indicatorWidth,
            indicatorVisible = _state2.indicatorVisible,
            overflowIndex = _state2.overflowIndex,
            overflowAtIndex = _state2.overflowAtIndex,
            paddingLeft = _state2.paddingLeft;

        var _props2 = this.props,
            Component = _props2.component,
            style = _props2.style,
            className = _props2.className,
            colored = _props2.colored,
            centered = _props2.centered,
            tabId = _props2.tabId,
            overflowMenu = _props2.overflowMenu,
            overflowMenuLabel = _props2.overflowMenuLabel,
            overflowMenuIconChildren = _props2.overflowMenuIconChildren,
            overflowMenuIconClassName = _props2.overflowMenuIconClassName,
            nextIconChildren = _props2.nextIconChildren,
            nextIconClassName = _props2.nextIconClassName,
            previousIconChildren = _props2.previousIconChildren,
            previousIconClassName = _props2.previousIconClassName,
            props = _objectWithoutProperties(_props2, ['component', 'style', 'className', 'colored', 'centered', 'tabId', 'overflowMenu', 'overflowMenuLabel', 'overflowMenuIconChildren', 'overflowMenuIconClassName', 'nextIconChildren', 'nextIconClassName', 'previousIconChildren', 'previousIconClassName']);

        delete props.activeTabIndex;
        delete props.defaultTabIndex;
        delete props.defaultMedia;
        delete props.desktopMinWidth;
        delete props.onTabChange;

        var activeTabIndex = (0, _getField2.default)(this.props, this.state, 'activeTabIndex');

        var icon = false;
        var children = _react.Children.map(_react.Children.toArray(this.props.children), function (tab, index) {
          var handleOnClick = function handleOnClick(tabIndex, id, tabControlsId, tabChildren, event) {
            if (tab.props.onClick) {
              tab.props.onClick(tabId, id, tabControlsId, tabChildren, event);
            }

            _this4._handleTabChange(tabIndex, id, tabControlsId, tabChildren, event);
          };

          if (tab.props.icon) {
            icon = true;
          }

          return (0, _react.cloneElement)(tab, {
            index: index,
            id: tab.props.id || tabId + '-' + index,
            controlsId: tab.props.controlsId || tabId + '-panel-' + index,
            active: index === activeTabIndex,
            onClick: handleOnClick
          });
        });

        var overflow = void 0;
        var nextControl = void 0;
        var previousControl = void 0;
        if (overflowAtIndex) {
          var length = children.length;
          if (overflowMenu) {
            overflow = _react2.default.createElement(_MenuTab2.default, {
              id: tabId + '-overflow-menu',
              activeTabIndex: activeTabIndex,
              overflowAtIndex: overflowAtIndex,
              label: _react2.default.createElement(
                _IconSeparator2.default,
                { label: overflowMenuLabel },
                _react2.default.createElement(
                  _FontIcon2.default,
                  { iconClassName: overflowMenuIconClassName },
                  overflowMenuIconChildren
                )
              ),
              tabs: children.slice(overflowAtIndex, children.length).map(this._mapToOverflowTabProps)
            });
          }

          children = children.slice(overflowIndex, overflowAtIndex);

          if (!overflowMenu && overflowIndex > 0) {
            previousControl = _react2.default.createElement(
              _TabOverflowButton2.default,
              { iconClassName: previousIconClassName, onClick: this._showPreviousTabs, left: true, icon: icon },
              previousIconChildren
            );
          }

          if (!overflowMenu && length > 3 && overflowAtIndex + overflowIndex <= length) {
            nextControl = _react2.default.createElement(
              _TabOverflowButton2.default,
              { iconClassName: nextIconClassName, onClick: this._showNextTabs, icon: icon },
              nextIconChildren
            );
          }
        }

        return _react2.default.createElement(
          Component,
          _extends({}, props, {
            ref: this._setContainer,
            style: _extends({}, style, { paddingLeft: paddingLeft }),
            className: (0, _classnames2.default)('md-tabs', {
              'md-tabs--pagination': overflowAtIndex && !overflowMenu,
              'md-tabs--centered': centered,
              'md-background--primary': colored
            }, className),
            role: 'tablist'
          }),
          previousControl,
          children,
          nextControl,
          overflow,
          _react2.default.createElement(_TabIndicator2.default, { offset: indicatorOffset, width: indicatorWidth, visible: indicatorVisible })
        );
      }
    }]);

    return Tabs;
  }(_react.PureComponent);

  Tabs.propTypes = {
    /**
     * A base id to use for each `Tab`. When the child tabs are created, they are cloned
     * with some additional accessibility props. Each tab will get a prop with this and the
     * current index of the tab.
     */
    tabId: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),

    /**
     * An optional style to apply.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply.
     */
    className: _propTypes2.default.string,

    /**
     * The component to render the tabs in.
     */
    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,

    /**
     * This should either be a single `Tab` component or a list of `Tab` components. Unfortunately,
     * the child *must* be exactly a `Tab` component because this is unable to extract the correct
     * `label` and `children` from a custom `Tab` component.
     */
    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)]).isRequired,

    /**
     * Boolean if the tabs should be centered instead of aligned to the keyline. The tabs will
     * only be aligned to the keyline when there are more than 3 tabs and the `alignToKeyline`
     * prop is `false`.
     */
    centered: _propTypes2.default.bool,

    /**
     * Boolean if the tabs should align to a toolbar's title keyline. If this is undefined,
     * the tabs will try to align to the keyline when there are more than 3 tabs.
     */
    alignToKeyline: _propTypes2.default.bool,

    /**
     * Boolean if the tabs should be colored with the primary color. If this is false or undefined,
     * the tabs will be colored for the light or dark theme.
     */
    colored: _propTypes2.default.bool,

    /**
     * A boolean if the overflow tabs on desktop displays should appear in a menu. If this is false,
     * the additional tabs will be available by using pagination buttons.
     */
    overflowMenu: _propTypes2.default.bool,

    /**
     * An optional function to call when the active tab is changed. The callback will include
     * the new active tab index and a click event.
     *
     * ```js
     * onTabChange(newTabIndex, event);
     * ```
     */
    onTabChange: _propTypes2.default.func,

    /**
     * An optional active tab index to use. If this is defined, it will make the component controlled
     * and require the `onTabChange` prop to be defined.
     */
    activeTabIndex: (0, _controlled2.default)(_propTypes2.default.number, 'onTabChange', 'defaultTabIndex'),

    /**
     * The default tab index to use when the component is uncontrolled.
     */
    defaultTabIndex: _propTypes2.default.number.isRequired,

    /**
     * The default media to render the tabs for. This is really just used for server side rendering.
     * Once the component has mounted, it will resize automatically.
     */
    defaultMedia: _propTypes2.default.oneOf(['mobile', 'tablet', 'desktop']).isRequired,

    /**
     * The min width to use for rendering the tabs for desktops. mobile and tablet is not used
     * because they share the same styles.
     */
    desktopMinWidth: _propTypes2.default.number.isRequired,

    /**
     * When the `overflowMenu` prop is false, this will be used to render the "next slice of tabs"
     * when there are too many tabs to display at once on desktop screens.
     */
    nextIconChildren: _propTypes2.default.node,

    /**
     * When the `overflowMenu` prop is false, this will be used to render the "next slice of tabs"
     * when there are too many tabs to display at once on desktop screens.
     */
    nextIconClassName: _propTypes2.default.string,

    /**
     * When the `overflowMenu` prop is false, this will be used to render the "previous slice of tabs"
     * when there are too many tabs to display at once on desktop screens.
     */
    previousIconChildren: _propTypes2.default.node,

    /**
     * When the `overflowMenu` prop is false, this will be used to render the "previous slice of tabs"
     * when there are too many tabs to display at once on desktop screens.
     */
    previousIconClassName: _propTypes2.default.string,

    /**
     * When the `overflowMenu` prop is true, this will be used to render the `MenuTab` overflow menu.
     * This will be the text that displays as a tab.
     */
    overflowMenuLabel: _propTypes2.default.node.isRequired,

    /**
     * When the `overflowMenu` prop is true, this will be used to render the `MenuTab` overflow menu.
     * This will be to render the icon to the right of the label.
     */
    overflowMenuIconChildren: _propTypes2.default.node,

    /**
     * When the `overflowMenu` prop is true, this will be used to render the `MenuTab` overflow menu.
     * This will be to render the icon to the right of the label.
     */
    overflowMenuIconClassName: _propTypes2.default.string
  };
  Tabs.defaultProps = {
    component: 'ul',
    defaultTabIndex: 0,
    defaultMedia: 'mobile',
    desktopMinWidth: _media.DESKTOP_MIN_WIDTH,
    nextIconChildren: 'keyboard_arrow_right',
    previousIconChildren: 'keyboard_arrow_left',
    overflowMenuLabel: 'More',
    overflowMenuIconChildren: 'arrow_drop_down'
  };
  exports.default = Tabs;
});

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(9), __webpack_require__(3), __webpack_require__(1253), __webpack_require__(16), __webpack_require__(20), __webpack_require__(120), __webpack_require__(46), __webpack_require__(575)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('react-dom'), require('classnames'), require('react-swipeable-views'), require('../utils/getField'), require('../utils/PropTypes/controlled'), require('../utils/PropTypes/between'), require('../Papers/Paper'), require('./TabPanel'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.reactDom, global.classnames, global.reactSwipeableViews, global.getField, global.controlled, global.between, global.Paper, global.TabPanel);
    global.TabsContainer = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _reactDom, _classnames, _reactSwipeableViews, _getField, _controlled, _between, _Paper, _TabPanel) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _reactSwipeableViews2 = _interopRequireDefault(_reactSwipeableViews);

  var _getField2 = _interopRequireDefault(_getField);

  var _controlled2 = _interopRequireDefault(_controlled);

  var _between2 = _interopRequireDefault(_between);

  var _Paper2 = _interopRequireDefault(_Paper);

  var _TabPanel2 = _interopRequireDefault(_TabPanel);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var TabsContainer = function (_PureComponent) {
    _inherits(TabsContainer, _PureComponent);

    function TabsContainer(props) {
      _classCallCheck(this, TabsContainer);

      var _this = _possibleConstructorReturn(this, (TabsContainer.__proto__ || Object.getPrototypeOf(TabsContainer)).call(this, props));

      _this.state = {};
      if (typeof props.activeTabIndex === 'undefined') {
        _this.state.activeTabIndex = props.defaultTabIndex;
      }

      _this._handleTabChange = _this._handleTabChange.bind(_this);
      _this._handleSwipeChange = _this._handleSwipeChange.bind(_this);
      return _this;
    }

    _createClass(TabsContainer, [{
      key: '_handleTabChange',
      value: function _handleTabChange(index, tabId, tabControlsId, tabChildren, event) {
        if (this.props.onTabChange) {
          this.props.onTabChange(index, tabId, tabControlsId, tabChildren, event);
        }

        if (typeof this.props.activeTabIndex === 'undefined') {
          this.setState({ activeTabIndex: index });
        }
      }
    }, {
      key: '_handleSwipeChange',
      value: function _handleSwipeChange(activeTabIndex) {
        this._handleTabChange(activeTabIndex);
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var panelHeight = this.state.panelHeight;

        var _props = this.props,
            Component = _props.component,
            style = _props.style,
            className = _props.className,
            panelStyle = _props.panelStyle,
            panelClassName = _props.panelClassName,
            panelComponent = _props.panelComponent,
            headerStyle = _props.headerStyle,
            headerClassName = _props.headerClassName,
            slideStyle = _props.slideStyle,
            swipeableViewsStyle = _props.swipeableViewsStyle,
            swipeableViewsClassName = _props.swipeableViewsClassName,
            headerComponent = _props.headerComponent,
            headerZDepth = _props.headerZDepth,
            children = _props.children,
            colored = _props.colored,
            fixed = _props.fixed,
            labelAndIcon = _props.labelAndIcon,
            props = _objectWithoutProperties(_props, ['component', 'style', 'className', 'panelStyle', 'panelClassName', 'panelComponent', 'headerStyle', 'headerClassName', 'slideStyle', 'swipeableViewsStyle', 'swipeableViewsClassName', 'headerComponent', 'headerZDepth', 'children', 'colored', 'fixed', 'labelAndIcon']);

        delete props.toolbar;
        var toolbar = this.props.toolbar;


        var activeTabIndex = (0, _getField2.default)(this.props, this.state, 'activeTabIndex');

        var tabsEl = _react.Children.only(children);
        var tabId = tabsEl.props.tabId;
        var content = _react.Children.map(tabsEl.props.children, function (tab, index) {
          if (!tab) {
            return tab;
          }

          return _react2.default.createElement(
            _TabPanel2.default,
            {
              id: tab.props.controlsId || tabId + '-panel-' + index,
              active: activeTabIndex === index,
              style: panelStyle,
              className: panelClassName,
              component: panelComponent,
              controlledById: tab.props.id || tabId + '-' + index
            },
            tab.props.children
          );
        });

        var childrenProps = _react.Children.only(children).props;
        var tabs = (0, _react.cloneElement)(children, {
          colored: typeof childrenProps.colored !== 'undefined' ? childrenProps.colored : colored,
          onTabChange: this._handleTabChange,
          activeTabIndex: activeTabIndex
        });

        var prominentToolbar = false;
        if (toolbar) {
          var toolbarProps = _react.Children.only(toolbar).props;
          toolbar = (0, _react.cloneElement)(toolbar, {
            component: toolbarProps.component || 'div',
            colored: typeof toolbarProps.colored !== 'undefined' ? childrenProps.colored : colored
          });

          prominentToolbar = toolbarProps.prominent || toolbarProps.prominentTitle;
        }

        var header = void 0;
        if (fixed) {
          header = _react2.default.createElement(
            _Paper2.default,
            {
              style: headerStyle,
              className: (0, _classnames2.default)('md-tabs-fixed-container', headerClassName),
              zDepth: headerZDepth,
              component: headerComponent
            },
            toolbar,
            tabs
          );
        }

        return _react2.default.createElement(
          Component,
          {
            style: style,
            className: (0, _classnames2.default)('md-tabs-container', className),
            ref: function ref(container) {
              if (container) {
                var activePanel = (0, _reactDom.findDOMNode)(container).querySelector('.md-tab-panel[aria-hidden=false]');
                if (activePanel && _this2.state.panelHeight !== activePanel.offsetHeight) {
                  _this2.setState({ panelHeight: activePanel.offsetHeight });
                }
              }
            }
          },
          header,
          header ? null : toolbar,
          header ? null : tabs,
          _react2.default.createElement(
            _reactSwipeableViews2.default,
            {
              style: swipeableViewsStyle,
              className: (0, _classnames2.default)('md-tabs-content', {
                'md-tabs-content--offset': fixed,
                'md-tabs-content--offset-icon': fixed && labelAndIcon,
                'md-tabs-content--offset-toolbar': fixed && toolbar,
                'md-tabs-content--offset-toolbar-prominent': fixed && toolbar && prominentToolbar,
                'md-tabs-content--offset-toolbar-icon': fixed && toolbar && labelAndIcon,
                'md-tabs-content--offset-toolbar-prominent-icon': fixed && toolbar && labelAndIcon && prominentToolbar
              }, swipeableViewsClassName),
              slideStyle: _extends({ height: panelHeight }, slideStyle),
              index: activeTabIndex,
              onChangeIndex: this._handleSwipeChange
            },
            content
          )
        );
      }
    }]);

    return TabsContainer;
  }(_react.PureComponent);

  TabsContainer.propTypes = {
    /**
     * An optional style to apply to the container.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply to the container.
     */
    className: _propTypes2.default.string,

    /**
     * An optional style to apply to each `TabPanel` that gets generated. Each tab's children
     * will get wrapped in a `TabPanel` component.
     */
    panelStyle: _propTypes2.default.object,

    /**
     * An optional className to apply to each each `TabPanel` that gets generated. Each tab's
     * children will get wrapped in a `TabPanel` component.
     */
    panelClassName: _propTypes2.default.string,

    /**
     * An optional style to apply to the header component when the tabs are fixed to the top of the page.
     * The optional toolbar and tabs get wrapped in a `Paper` component.
     */
    headerStyle: _propTypes2.default.object,

    /**
     * An optional className to apply to the header component when the tabs are fixed to the top of the page.
     * The optional toolbar and tabs get wrapped in a `Paper` component.
     */
    headerClassName: _propTypes2.default.string,

    /**
     * An optional style to apply to the `SwipeableViews`.
     *
     * @see https://github.com/oliviertassinari/react-swipeable-views#user-content-swipeableviews-
     */
    swipeableViewsStyle: _propTypes2.default.object,

    /**
     * An optional className to apply to the `SwipeableViews` container.
     */
    swipeableViewsClassName: _propTypes2.default.string,

    /**
     * An optional style to apply to each slide component.
     *
     * @see https://github.com/oliviertassinari/react-swipeable-views#user-content-swipeableviews-
     */
    slideStyle: _propTypes2.default.object,

    /**
     * This should be a `Tabs` component with children of `Tab`. This is used to figure out which
     * tab's content is currently visible.
     */
    children: _propTypes2.default.element.isRequired,

    /**
     * The component to render the container as.
     */
    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,

    /**
     * The component to render each `TabPanel` as.
     */
    panelComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),

    /**
     * An optional toolbar to render above the tabs.
     */
    toolbar: _propTypes2.default.element,

    /**
     * An optional active tab index to use. If this is defined, the component will be controlled
     * and require the `onTabChange` prop to be defined.
     */
    activeTabIndex: (0, _controlled2.default)(_propTypes2.default.number, 'onTabChange', 'defaultTabIndex'),

    /**
     * An optional function to call when a new tab is seleced by swiping or clicking a tab. When
     * a new tab has been clicked, the callback will include the active tab index, the tab's `id`,
     * the tab's `controlsId`, the tab's `children`, and the click event.
     *
     * If the tab was changed by swiping, it will only contain the new active tab index.
     *
     * ```js
     * onTabChange(newActiveTabIndex, tabId, tabControlsId, tabChildren, event);
     * ```
     */
    onTabChange: _propTypes2.default.func,

    /**
     * The default tab index to use when the component is uncontrolled.
     */
    defaultTabIndex: _propTypes2.default.number.isRequired,

    /**
     * Boolean if the `toolbar` and `Tabs` should be cloned with `colored: true`.
     */
    colored: _propTypes2.default.bool,

    /**
     * Boolean if the tabs and the optional toolbar should be fixed to the top of the page.
     */
    fixed: _propTypes2.default.bool,

    /**
     * A boolean if a `fixed` `TabsContainer` has tabs with a label and an icon.
     */
    labelAndIcon: _propTypes2.default.bool,

    /**
     * An optional component to render the fixed tabs header as.
     */
    headerComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),

    /**
     * The zDepth for the fixed tabs header.
     */
    headerZDepth: (0, _between2.default)(_propTypes2.default.number, 0, 5)
  };
  TabsContainer.defaultProps = {
    component: 'section',
    defaultTabIndex: 0,
    headerZDepth: 1
  };
  exports.default = TabsContainer;
});

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.addDate = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = addDate;

  /**
   * Adds a given amount to a date.
   *
   * @param {date} sourceDate the date to add
   * @param {number} amt the amount to add
   * @param {string} part the date part to add to. ['D', 'M', 'Y']
   * @return a new Date with the part added or the date if the part is not valid.
   */
  function addDate(sourceDate, amt, part) {
    var date = new Date(sourceDate);

    switch (part) {
      case 'D':
        return new Date(date.setDate(date.getDate() + amt));
      case 'M':
        date.setDate(1);
        return new Date(date.setMonth(date.getMonth() + amt));
      case 'Y':
        return new Date(date.setFullYear(date.getFullYear() + amt));
      default:
        return date;
    }
  }
});

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(14)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('../../constants/keyCodes'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.keyCodes);
    global.isValidClick = mod.exports;
  }
})(this, function (exports, _keyCodes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = isValidClick;


  /**
   * Checks if an event is a valid click event by ignoring
   * any clisk that are not the left mouse button and not
   * clicks that involve the shift key.
   *
   * @param {Object} e - the event to check
   * @return {Boolean} true if the event is valid.
   */
  function isValidClick(e) {
    return e.button === _keyCodes.LEFT_MOUSE && !e.shiftKey;
  }
});

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// currently used to initiate the velocity style object to 0


exports.__esModule = true;
exports['default'] = mapToZero;

function mapToZero(obj) {
  var ret = {};
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      ret[key] = 0;
    }
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// usage assumption: currentStyle values have already been rendered but it says
// nothing of whether currentStyle is stale (see unreadPropStyle)


exports.__esModule = true;
exports['default'] = shouldStopAnimation;

function shouldStopAnimation(currentStyle, style, currentVelocity) {
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }

    if (currentVelocity[key] !== 0) {
      return false;
    }

    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
    // stepper will have already taken care of rounding precision errors, so
    // won't have such thing as 0.9999 !=== 1
    if (currentStyle[key] !== styleValue) {
      return false;
    }
  }

  return true;
}

module.exports = exports['default'];

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// stepper is used a lot. Saves allocation to return the same array wrapper.
// This is fine and danger-free against mutations because the callsite
// immediately destructures it and gets the numbers inside without passing the


exports.__esModule = true;
exports["default"] = stepper;

var reusedTuple = [0, 0];

function stepper(secondPerFrame, x, v, destX, k, b, precision) {
  // Spring stiffness, in kg / s^2

  // for animations, destX is really spring length (spring at rest). initial
  // position is considered as the stretched/compressed position of a spring
  var Fspring = -k * (x - destX);

  // Damping, in kg / s
  var Fdamper = -b * v;

  // usually we put mass here, but for animation purposes, specifying mass is a
  // bit redundant. you could simply adjust k and b accordingly
  // let a = (Fspring + Fdamper) / mass;
  var a = Fspring + Fdamper;

  var newV = v + a * secondPerFrame;
  var newX = x + newV * secondPerFrame;

  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
    reusedTuple[0] = destX;
    reusedTuple[1] = 0;
    return reusedTuple;
  }

  reusedTuple[0] = newX;
  reusedTuple[1] = newV;
  return reusedTuple;
}

module.exports = exports["default"];
// array reference around.

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// currently used to initiate the velocity style object to 0


exports.__esModule = true;
exports['default'] = mapToZero;

function mapToZero(obj) {
  var ret = {};
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      ret[key] = 0;
    }
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// usage assumption: currentStyle values have already been rendered but it says
// nothing of whether currentStyle is stale (see unreadPropStyle)


exports.__esModule = true;
exports['default'] = shouldStopAnimation;

function shouldStopAnimation(currentStyle, style, currentVelocity) {
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }

    if (currentVelocity[key] !== 0) {
      return false;
    }

    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
    // stepper will have already taken care of rounding precision errors, so
    // won't have such thing as 0.9999 !=== 1
    if (currentStyle[key] !== styleValue) {
      return false;
    }
  }

  return true;
}

module.exports = exports['default'];

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// stepper is used a lot. Saves allocation to return the same array wrapper.
// This is fine and danger-free against mutations because the callsite
// immediately destructures it and gets the numbers inside without passing the


exports.__esModule = true;
exports["default"] = stepper;

var reusedTuple = [0, 0];

function stepper(secondPerFrame, x, v, destX, k, b, precision) {
  // Spring stiffness, in kg / s^2

  // for animations, destX is really spring length (spring at rest). initial
  // position is considered as the stretched/compressed position of a spring
  var Fspring = -k * (x - destX);

  // Damping, in kg / s
  var Fdamper = -b * v;

  // usually we put mass here, but for animation purposes, specifying mass is a
  // bit redundant. you could simply adjust k and b accordingly
  // let a = (Fspring + Fdamper) / mass;
  var a = Fspring + Fdamper;

  var newV = v + a * secondPerFrame;
  var newX = x + newV * secondPerFrame;

  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
    reusedTuple[0] = destX;
    reusedTuple[1] = 0;
    return reusedTuple;
  }

  reusedTuple[0] = newX;
  reusedTuple[1] = newV;
  return reusedTuple;
}

module.exports = exports["default"];
// array reference around.

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: '/',
      url: '/',
      params: {},
      isExact: pathname === '/'
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, 'A <Router> may have only one child element');

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, 'You cannot change <Router history>');
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(1021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = '' + options.end + options.strict;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof options === 'string') options = { path: options };

  var _options = options,
      _options$path = _options.path,
      path = _options$path === undefined ? '/' : _options$path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict;

  var _compilePath = compilePath(path, { end: exact, strict: strict }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _chainFunction = __webpack_require__(679);

var _chainFunction2 = _interopRequireDefault(_chainFunction);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(33);

var _warning2 = _interopRequireDefault(_warning);

var _ChildMapping = __webpack_require__(1255);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key) {
      _this.currentlyTransitioningKeys[key] = true;

      var component = _this.childRefs[key];

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key));
      } else {
        _this._handleDoneAppearing(key);
      }
    };

    _this._handleDoneAppearing = function (key) {
      var component = _this.childRefs[key];
      if (component && component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key);
      }
    };

    _this.performEnter = function (key) {
      _this.currentlyTransitioningKeys[key] = true;

      var component = _this.childRefs[key];

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key));
      } else {
        _this._handleDoneEntering(key);
      }
    };

    _this._handleDoneEntering = function (key) {
      var component = _this.childRefs[key];
      if (component && component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key);
      }
    };

    _this.performLeave = function (key) {
      _this.currentlyTransitioningKeys[key] = true;

      var component = _this.childRefs[key];
      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key);
      }
    };

    _this._handleDoneLeaving = function (key) {
      var component = _this.childRefs[key];

      if (component && component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.performEnter(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(this.performEnter);

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(this.performLeave);
  };

  TransitionGroup.prototype.render = function render() {
    var _this2 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this2.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this2.props.childFactory(child);
        var ref = function ref(r) {
          _this2.childRefs[key] = r;
        };

         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';


TransitionGroup.propTypes = propTypes;
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_scales_utils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__animation__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_axis_utils__ = __webpack_require__(31);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.










var VERTICAL = __WEBPACK_IMPORTED_MODULE_4__utils_axis_utils__["b" /* DIRECTION */].VERTICAL,
    HORIZONTAL = __WEBPACK_IMPORTED_MODULE_4__utils_axis_utils__["b" /* DIRECTION */].HORIZONTAL;


var propTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([VERTICAL, HORIZONTAL]),
  attr: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  left: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  tickValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  tickTotal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  animation: __WEBPACK_IMPORTED_MODULE_3__animation__["a" /* AnimationPropType */],

  // generally supplied by xyplot
  marginTop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  marginBottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  marginLeft: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  marginRight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  innerWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  innerHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var defaultProps = {
  direction: VERTICAL
};

var animatedProps = ['xRange', 'yRange', 'xDomain', 'yDomain', 'width', 'height', 'marginLeft', 'marginTop', 'marginRight', 'marginBottom', 'tickTotal'];

var GridLines = function (_PureComponent) {
  _inherits(GridLines, _PureComponent);

  function GridLines() {
    _classCallCheck(this, GridLines);

    return _possibleConstructorReturn(this, (GridLines.__proto__ || Object.getPrototypeOf(GridLines)).apply(this, arguments));
  }

  _createClass(GridLines, [{
    key: '_getDefaultProps',
    value: function _getDefaultProps() {
      var _props = this.props,
          innerWidth = _props.innerWidth,
          innerHeight = _props.innerHeight,
          marginTop = _props.marginTop,
          marginLeft = _props.marginLeft,
          direction = _props.direction;

      return {
        left: marginLeft,
        top: marginTop,
        width: innerWidth,
        height: innerHeight,
        tickTotal: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_axis_utils__["c" /* getTicksTotalFromSize */])(direction === VERTICAL ? innerWidth : innerHeight)
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var animation = this.props.animation;

      if (animation) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__animation__["b" /* default */],
          _extends({}, this.props, { animatedProps: animatedProps }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GridLines, _extends({}, this.props, { animation: null }))
        );
      }

      var props = _extends({}, this._getDefaultProps(), this.props);

      var attr = props.attr,
          direction = props.direction,
          width = props.width,
          height = props.height,
          style = props.style,
          tickTotal = props.tickTotal,
          tickValues = props.tickValues,
          top = props.top,
          left = props.left;

      var isVertical = direction === VERTICAL;
      var tickXAttr = isVertical ? 'y' : 'x';
      var tickYAttr = isVertical ? 'x' : 'y';
      var length = isVertical ? height : width;

      var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_scales_utils__["e" /* getAttributeScale */])(props, attr);
      var values = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_axis_utils__["d" /* getTickValues */])(scale, tickTotal, tickValues);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        {
          transform: 'translate(' + left + ',' + top + ')',
          className: 'rv-xy-plot__grid-lines' },
        values.map(function (v, i) {
          var _pathProps;

          var pos = scale(v);
          var pathProps = (_pathProps = {}, _defineProperty(_pathProps, tickYAttr + '1', pos), _defineProperty(_pathProps, tickYAttr + '2', pos), _defineProperty(_pathProps, tickXAttr + '1', 0), _defineProperty(_pathProps, tickXAttr + '2', length), _pathProps);
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line', _extends({}, pathProps, {
            key: i,
            className: 'rv-xy-plot__grid-lines__line',
            style: style }));
        })
      );
    }
  }]);

  return GridLines;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

GridLines.displayName = 'GridLines';
GridLines.defaultProps = defaultProps;
GridLines.propTypes = propTypes;
GridLines.requiresSVG = true;

/* harmony default export */ __webpack_exports__["a"] = (GridLines);

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__animation__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_series_utils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_shape__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__abstract_series__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_scales_utils__ = __webpack_require__(25);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.












var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--arc';
var ATTRIBUTES = ['radius', 'angle'];

var defaultProps = {
  center: { x: 0, y: 0 },
  arcClassName: '',
  className: '',
  style: {}
};

/**
 * Prepare the internal representation of row for real use.
 * This is necessary because d3 insists on starting at 12 oclock and moving
 * clockwise, rather than starting at 3 oclock and moving counter clockwise
 * as one might expect from polar
 * @param {Object} row - coordinate object to be modifed
 * @return {Object} angle corrected object
 */
function modifyRow(row) {
  var radius = row.radius,
      angle = row.angle,
      angle0 = row.angle0;

  var truedAngle = -1 * angle + Math.PI / 2;
  var truedAngle0 = -1 * angle0 + Math.PI / 2;
  return _extends({}, row, {
    x: radius * Math.cos(truedAngle),
    y: radius * Math.sin(truedAngle),
    angle: truedAngle,
    angle0: truedAngle0
  });
}

var ArcSeries = function (_AbstractSeries) {
  _inherits(ArcSeries, _AbstractSeries);

  function ArcSeries(props) {
    _classCallCheck(this, ArcSeries);

    var _this = _possibleConstructorReturn(this, (ArcSeries.__proto__ || Object.getPrototypeOf(ArcSeries)).call(this, props));

    var scaleProps = _this._getAllScaleProps(props);
    _this.state = { scaleProps: scaleProps };
    return _this;
  }

  _createClass(ArcSeries, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({ scaleProps: this._getAllScaleProps(nextProps) });
    }

    /**
     * Get the map of scales from the props.
     * @param {Object} props Props.
     * @param {Array} data Array of all data.
     * @returns {Object} Map of scales.
     * @private
     */

  }, {
    key: '_getAllScaleProps',
    value: function _getAllScaleProps(props) {
      var defaultScaleProps = this._getDefaultScaleProps(props);
      var userScaleProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_scales_utils__["f" /* extractScalePropsFromProps */])(props, ATTRIBUTES);
      var missingScaleProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_scales_utils__["b" /* getMissingScaleProps */])(_extends({}, defaultScaleProps, userScaleProps), props.data, ATTRIBUTES);

      return _extends({}, defaultScaleProps, userScaleProps, missingScaleProps);
    }

    /**
     * Get the list of scale-related settings that should be applied by default.
     * @param {Object} props Object of props.
     * @returns {Object} Defaults.
     * @private
     */

  }, {
    key: '_getDefaultScaleProps',
    value: function _getDefaultScaleProps(props) {
      var innerWidth = props.innerWidth,
          innerHeight = props.innerHeight;

      var radius = Math.min(innerWidth / 2, innerHeight / 2);
      return {
        radiusRange: [0, radius],
        _radiusValue: radius,
        angleType: 'literal'
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          arcClassName = _props.arcClassName,
          animation = _props.animation,
          className = _props.className,
          center = _props.center,
          data = _props.data,
          marginLeft = _props.marginLeft,
          marginTop = _props.marginTop,
          style = _props.style;


      if (!data) {
        return null;
      }

      if (animation) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__animation__["b" /* default */],
          _extends({}, this.props, { animatedProps: __WEBPACK_IMPORTED_MODULE_3__utils_series_utils__["e" /* ANIMATED_SERIES_PROPS */] }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ArcSeries, _extends({}, this.props, { animation: null }))
        );
      }
      var scaleProps = this.state.scaleProps;
      var radiusDomain = scaleProps.radiusDomain;
      // need to generate our own functors as abstract series doesnt have anythign for us

      var radius = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_scales_utils__["c" /* getAttributeFunctor */])(scaleProps, 'radius');
      var radius0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_scales_utils__["h" /* getAttr0Functor */])(scaleProps, 'radius');
      var angle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_scales_utils__["c" /* getAttributeFunctor */])(scaleProps, 'angle');
      var angle0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_scales_utils__["h" /* getAttr0Functor */])(scaleProps, 'angle');
      // but it does have good color support!
      var fill = this._getAttributeFunctor('fill') || this._getAttributeFunctor('color');
      var stroke = this._getAttributeFunctor('stroke') || this._getAttributeFunctor('color');
      var opacity = this._getAttributeFunctor('opacity');
      var x = this._getAttributeFunctor('x');
      var y = this._getAttributeFunctor('y');

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        { className: predefinedClassName + ' ' + className,
          onMouseOver: this._seriesMouseOverHandler,
          onMouseOut: this._seriesMouseOutHandler,
          onClick: this._seriesClickHandler,
          ref: 'container',
          transform: 'translate(' + (marginLeft + x(center)) + ',' + (marginTop + y(center)) + ')' },
        data.map(function (row, i) {
          var noRadius = radiusDomain[1] === radiusDomain[0];
          var arcArg = {
            innerRadius: noRadius ? 0 : radius0(row),
            outerRadius: radius(row),
            startAngle: angle0(row) || 0,
            endAngle: angle(row)
          };
          var arcedData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_d3_shape__["arc"])();
          var rowStyle = row.style || {};
          var rowClassName = row.className || '';
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
            style: _extends({
              opacity: opacity && opacity(row),
              stroke: stroke && stroke(row),
              fill: fill && fill(row)
            }, style, rowStyle),
            onClick: function onClick(e) {
              return _this2._valueClickHandler(modifyRow(row), e);
            },
            onMouseOver: function onMouseOver(e) {
              return _this2._valueMouseOverHandler(modifyRow(row), e);
            },
            onMouseOut: function onMouseOut(e) {
              return _this2._valueMouseOutHandler(modifyRow(row), e);
            },
            key: i,
            className: predefinedClassName + '-path ' + arcClassName + ' ' + rowClassName,
            d: arcedData(arcArg)
          });
        })
      );
    }
  }]);

  return ArcSeries;
}(__WEBPACK_IMPORTED_MODULE_5__abstract_series__["a" /* default */]);

ArcSeries.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_5__abstract_series__["a" /* default */].propTypes, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_scales_utils__["i" /* getScalePropTypesByAttribute */])('radius'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_scales_utils__["i" /* getScalePropTypesByAttribute */])('angle'), {
  center: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }),
  arcClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
});
ArcSeries.defaultProps = defaultProps;
ArcSeries.displayName = 'ArcSeries';

/* harmony default export */ __webpack_exports__["a"] = (ArcSeries);

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_color__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__theme__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__abstract_series__ = __webpack_require__(8);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.







var RectSeriesCanvas = function (_AbstractSeries) {
  _inherits(RectSeriesCanvas, _AbstractSeries);

  function RectSeriesCanvas() {
    _classCallCheck(this, RectSeriesCanvas);

    return _possibleConstructorReturn(this, (RectSeriesCanvas.__proto__ || Object.getPrototypeOf(RectSeriesCanvas)).apply(this, arguments));
  }

  _createClass(RectSeriesCanvas, [{
    key: 'render',
    value: function render() {
      return null;
    }
  }], [{
    key: 'renderLayer',
    value: function renderLayer(props, ctx) {
      var data = props.data,
          linePosAttr = props.linePosAttr,
          lineSizeAttr = props.lineSizeAttr,
          marginLeft = props.marginLeft,
          marginTop = props.marginTop,
          valuePosAttr = props.valuePosAttr;

      if (!data || data.length === 0) {
        return;
      }

      var line = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["c" /* getAttributeFunctor */])(props, linePosAttr);
      var line0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["h" /* getAttr0Functor */])(props, linePosAttr);
      var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["c" /* getAttributeFunctor */])(props, valuePosAttr);
      var value0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["h" /* getAttr0Functor */])(props, valuePosAttr);
      var fill = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'fill') || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'color');
      var stroke = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'stroke') || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'color');
      var opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'opacity');

      data.forEach(function (row) {
        var fillColor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_color__["e" /* rgb */])(fill(row));
        var strokeColor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_color__["e" /* rgb */])(stroke(row));
        var rowOpacity = opacity(row) || __WEBPACK_IMPORTED_MODULE_2__theme__["a" /* DEFAULT_OPACITY */];

        var linePos = line0(row);
        var valuePos = Math.min(value0(row), value(row));
        var x = valuePosAttr === 'x' ? valuePos : linePos;
        var y = valuePosAttr === 'y' ? valuePos : linePos;

        var lineSize = Math.abs(line(row) - line0(row));
        var valueSize = Math.abs(-value0(row) + value(row));
        var height = lineSizeAttr === 'height' ? lineSize : valueSize;
        var width = lineSizeAttr === 'width' ? lineSize : valueSize;

        ctx.beginPath();
        ctx.rect(x + marginLeft, y + marginTop, width, height);
        ctx.fillStyle = 'rgba(' + fillColor.r + ', ' + fillColor.g + ', ' + fillColor.b + ', ' + rowOpacity + ')';
        ctx.fill();
        ctx.strokeStyle = 'rgba(' + strokeColor.r + ', ' + strokeColor.g + ', ' + strokeColor.b + ', ' + rowOpacity + ')';
        ctx.stroke();
      });
    }
  }, {
    key: 'requiresSVG',
    get: function get() {
      return false;
    }
  }, {
    key: 'isCanvas',
    get: function get() {
      return true;
    }
  }]);

  return RectSeriesCanvas;
}(__WEBPACK_IMPORTED_MODULE_4__abstract_series__["a" /* default */]);

RectSeriesCanvas.displayName = 'RectSeriesCanvas';
RectSeriesCanvas.defaultProps = {
  linePosAttr: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  valuePosAttr: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  lineSizeAttr: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  valueSizeAttr: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
};

RectSeriesCanvas.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_4__abstract_series__["a" /* default */].propTypes);

/* harmony default export */ __webpack_exports__["a"] = (RectSeriesCanvas);

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__animation__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_series_utils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__abstract_series__ = __webpack_require__(8);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.










var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--rect';

var RectSeries = function (_AbstractSeries) {
  _inherits(RectSeries, _AbstractSeries);

  function RectSeries() {
    _classCallCheck(this, RectSeries);

    return _possibleConstructorReturn(this, (RectSeries.__proto__ || Object.getPrototypeOf(RectSeries)).apply(this, arguments));
  }

  _createClass(RectSeries, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          animation = _props.animation,
          className = _props.className,
          data = _props.data,
          linePosAttr = _props.linePosAttr,
          lineSizeAttr = _props.lineSizeAttr,
          marginLeft = _props.marginLeft,
          marginTop = _props.marginTop,
          style = _props.style,
          valuePosAttr = _props.valuePosAttr,
          valueSizeAttr = _props.valueSizeAttr;


      if (!data) {
        return null;
      }

      if (animation) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__animation__["b" /* default */],
          _extends({}, this.props, { animatedProps: __WEBPACK_IMPORTED_MODULE_3__utils_series_utils__["e" /* ANIMATED_SERIES_PROPS */] }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RectSeries, _extends({}, this.props, { animation: null }))
        );
      }

      var lineFunctor = this._getAttributeFunctor(linePosAttr);
      var line0Functor = this._getAttr0Functor(linePosAttr);
      var valueFunctor = this._getAttributeFunctor(valuePosAttr);
      var value0Functor = this._getAttr0Functor(valuePosAttr);
      var fillFunctor = this._getAttributeFunctor('fill') || this._getAttributeFunctor('color');
      var strokeFunctor = this._getAttributeFunctor('stroke') || this._getAttributeFunctor('color');
      var opacityFunctor = this._getAttributeFunctor('opacity');

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        { className: predefinedClassName + ' ' + className,
          ref: 'container',
          transform: 'translate(' + marginLeft + ',' + marginTop + ')' },
        data.map(function (d, i) {
          var _attrs;

          var attrs = (_attrs = {
            style: _extends({
              opacity: opacityFunctor && opacityFunctor(d),
              stroke: strokeFunctor && strokeFunctor(d),
              fill: fillFunctor && fillFunctor(d)
            }, style)
          }, _defineProperty(_attrs, linePosAttr, line0Functor(d)), _defineProperty(_attrs, lineSizeAttr, Math.abs(lineFunctor(d) - line0Functor(d))), _defineProperty(_attrs, valuePosAttr, Math.min(value0Functor(d), valueFunctor(d))), _defineProperty(_attrs, valueSizeAttr, Math.abs(-value0Functor(d) + valueFunctor(d))), _defineProperty(_attrs, 'onClick', function onClick(e) {
            return _this2._valueClickHandler(d, e);
          }), _defineProperty(_attrs, 'onMouseOver', function onMouseOver(e) {
            return _this2._valueMouseOverHandler(d, e);
          }), _defineProperty(_attrs, 'onMouseOut', function onMouseOut(e) {
            return _this2._valueMouseOutHandler(d, e);
          }), _defineProperty(_attrs, 'key', i), _attrs);
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', attrs);
        })
      );
    }
  }], [{
    key: 'propTypes',
    get: function get() {
      return _extends({}, __WEBPACK_IMPORTED_MODULE_4__abstract_series__["a" /* default */].propTypes, {
        linePosAttr: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        valuePosAttr: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        lineSizeAttr: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        valueSizeAttr: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
      });
    }
  }]);

  return RectSeries;
}(__WEBPACK_IMPORTED_MODULE_4__abstract_series__["a" /* default */]);

RectSeries.displayName = 'RectSeries';

/* harmony default export */ __webpack_exports__["a"] = (RectSeries);

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(87);

var ReactNoopUpdateQueue = __webpack_require__(283);

var canDefineProperty = __webpack_require__(624);
var emptyObject = __webpack_require__(74);
var invariant = __webpack_require__(4);
var warning = __webpack_require__(6);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

module.exports = ReactComponent;

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var warning = __webpack_require__(6);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasInAuthorizations = exports.removeAuthorization = exports.toggleAuthorization = exports.addAuthorization = exports.deleteAuthorization = exports.receiveAuthorizations = exports.startFetchingAuthorizations = exports.fetchAuthorizations = exports.END_SYNCHRONIZATION = exports.BEGIN_SYNCHRONIZATION = exports.ADD_AUTHORIZATION = exports.DELETE_AUTHORIZATION = exports.RECEIVE_AUTHORIZATIONS = exports.FETCH_AUTHORIZATIONS = undefined;

var _api = __webpack_require__(39);

var api = _interopRequireWildcard(_api);

var _guisso = __webpack_require__(660);

var guissoApi = _interopRequireWildcard(_guisso);

var _config = __webpack_require__(167);

var _channels = __webpack_require__(165);

var channelActions = _interopRequireWildcard(_channels);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var FETCH_AUTHORIZATIONS = exports.FETCH_AUTHORIZATIONS = 'FETCH_AUTHORIZATIONS';
var RECEIVE_AUTHORIZATIONS = exports.RECEIVE_AUTHORIZATIONS = 'RECEIVE_AUTHORIZATIONS';
var DELETE_AUTHORIZATION = exports.DELETE_AUTHORIZATION = 'DELETE_AUTHORIZATION';
var ADD_AUTHORIZATION = exports.ADD_AUTHORIZATION = 'ADD_AUTHORIZATION';
var BEGIN_SYNCHRONIZATION = exports.BEGIN_SYNCHRONIZATION = 'BEGIN_SYNCHRONIZATION';
var END_SYNCHRONIZATION = exports.END_SYNCHRONIZATION = 'END_SYNCHRONIZATION';

var fetchAuthorizations = exports.fetchAuthorizations = function fetchAuthorizations() {
  return function (dispatch, getState) {
    var state = getState();

    if (state.authorizations.fetching) {
      return;
    }

    dispatch(startFetchingAuthorizations());
    return api.fetchAuthorizations().then(function (response) {
      return dispatch(receiveAuthorizations(response.data));
    });
  };
};

var startFetchingAuthorizations = exports.startFetchingAuthorizations = function startFetchingAuthorizations() {
  return {
    type: FETCH_AUTHORIZATIONS
  };
};

var receiveAuthorizations = exports.receiveAuthorizations = function receiveAuthorizations(authorizations) {
  return {
    type: RECEIVE_AUTHORIZATIONS,
    authorizations: authorizations
  };
};

var deleteAuthorization = exports.deleteAuthorization = function deleteAuthorization(provider, baseUrl) {
  return {
    type: DELETE_AUTHORIZATION,
    provider: provider,
    baseUrl: baseUrl
  };
};

var addAuthorization = exports.addAuthorization = function addAuthorization(provider, baseUrl) {
  return {
    type: ADD_AUTHORIZATION,
    provider: provider,
    baseUrl: baseUrl
  };
};

var toggleAuthorization = exports.toggleAuthorization = function toggleAuthorization(provider, index) {
  return function (dispatch, getState) {
    var state = getState().authorizations;

    if (state.fetching || state.items == null) {
      return;
    }

    var baseUrl = _config.config[provider][index].baseUrl;
    var currentValue = hasInAuthorizations(state, provider, index);

    if (currentValue) {
      // Turn off
      dispatch(deleteAuthorization(provider, baseUrl));
      api.deleteAuthorization(provider, baseUrl).then(function () {
        dispatch(channelActions.fetchChannels());
      }).catch(function (e) {
        dispatch(addAuthorization(provider, baseUrl));
      });
    } else {
      // Turn on
      dispatch(addAuthorization(provider, baseUrl));
      var guissoSession = guissoApi.newSession(_config.config[provider][index].guisso);
      return guissoSession.authorize('code', provider, baseUrl).then(function () {
        return guissoSession.close();
      }).then(function () {
        dispatch(channelActions.fetchChannels());
      }).catch(function (err) {
        guissoSession.close();
        dispatch(deleteAuthorization(provider, baseUrl));
        if (err) {
          throw err;
        }
      });
    }
  };
};

var removeAuthorization = exports.removeAuthorization = function removeAuthorization(provider, index) {
  return function (dispatch, getState) {
    var state = getState().authorizations;

    if (state.fetching || state.items == null) {
      return;
    }

    var baseUrl = _config.config[provider][index].baseUrl;

    dispatch(deleteAuthorization(provider, baseUrl));
    api.deleteAuthorization(provider, baseUrl, true).catch(function (e) {
      dispatch(addAuthorization(provider, baseUrl));
    });
  };
};

var hasInAuthorizations = exports.hasInAuthorizations = function hasInAuthorizations(authorizations, provider, index) {
  var baseUrl = _config.config[provider][index].baseUrl;
  return !!(authorizations.items && authorizations.items.some(function (item) {
    return item.provider == provider && item.baseUrl == baseUrl;
  }));
};

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeLang = exports.editLang = exports.addEmptyLang = exports.EMPTY_LANG_ADD = undefined;

var _campaign = __webpack_require__(19);

var EMPTY_LANG_ADD = exports.EMPTY_LANG_ADD = 'EMPTY_LANG_ADD';

var addEmptyLang = exports.addEmptyLang = function addEmptyLang() {
  return { type: EMPTY_LANG_ADD };
};

var editLang = exports.editLang = function editLang(newName, index) {
  return function (dispatch, getState) {
    var langs = getState().campaign.data.langs.slice();
    langs[index] = newName;
    dispatch((0, _campaign.campaignUpdate)({ langs: langs }));
  };
};

var removeLang = exports.removeLang = function removeLang(index) {
  return function (dispatch, getState) {
    var langs = getState().campaign.data.langs.slice();
    langs.splice(index, 1);
    dispatch((0, _campaign.campaignUpdate)({ langs: langs }));
  };
};

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SERVER_ERROR = exports.SERVER_ERROR = 'SERVER_ERROR';

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subjectUpdated = exports.updateSubject = exports.subjectFetch = exports.subjectCreated = exports.subjectEditing = exports.editSubject = exports.editingSubjectCancel = exports.createSubject = exports.SUBJECT_LAUNCH = exports.SUBJECT_UPDATED = exports.SUBJECT_UPDATE = exports.SUBJECT_EDITING = exports.SUBJECT_EDIT = exports.SUBJECT_FETCHED = exports.SUBJECT_FETCH = exports.SUBJECT_CREATED = exports.SUBJECT_CREATE = undefined;

var _api = __webpack_require__(39);

var api = _interopRequireWildcard(_api);

var _shared = __webpack_require__(286);

var _assign = __webpack_require__(403);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var SUBJECT_CREATE = exports.SUBJECT_CREATE = 'SUBJECT_CREATE';
var SUBJECT_CREATED = exports.SUBJECT_CREATED = 'SUBJECT_CREATED';
var SUBJECT_FETCH = exports.SUBJECT_FETCH = 'SUBJECT_FETCH';
var SUBJECT_FETCHED = exports.SUBJECT_FETCHED = 'SUBJECT_FETCHED';
var SUBJECT_EDIT = exports.SUBJECT_EDIT = 'SUBJECT_EDIT';
var SUBJECT_EDITING = exports.SUBJECT_EDITING = 'SUBJECT_EDITING';
var SUBJECT_UPDATE = exports.SUBJECT_UPDATE = 'SUBJECT_UPDATE';
var SUBJECT_UPDATED = exports.SUBJECT_UPDATED = 'SUBJECT_UPDATED';
var SUBJECT_LAUNCH = exports.SUBJECT_LAUNCH = 'SUBJECT_LAUNCH';

var createSubject = exports.createSubject = function createSubject(campaignId, subjectParams) {
  return function (dispatch) {
    dispatch({ type: SUBJECT_CREATE });
    var defaultProps = {};
    var params = (0, _assign2.default)({}, defaultProps, subjectParams);

    api.createSubject(campaignId, params).then(function (subject) {
      dispatch(subjectCreated(subject));
    });
  };
};

var editingSubjectCancel = exports.editingSubjectCancel = function editingSubjectCancel() {
  return { type: SUBJECT_EDIT, subject: null };
};

var editSubject = exports.editSubject = function editSubject(subject) {
  return { type: SUBJECT_EDIT, subject: subject };
};

var subjectEditing = exports.subjectEditing = function subjectEditing(fieldName, value) {
  return { type: SUBJECT_EDITING, fieldName: fieldName, value: value };
};

var subjectCreated = exports.subjectCreated = function subjectCreated(subject) {
  return { type: SUBJECT_CREATED, subject: subject };
};

var subjectFetch = exports.subjectFetch = function subjectFetch(id) {
  return function (dispatch) {
    dispatch({ type: SUBJECT_FETCH, id: id });

    api.fetchSubject(id).then(function (subject) {
      dispatch({ type: SUBJECT_FETCHED, subject: subject });
    });
  };
};

var updateSubject = exports.updateSubject = function updateSubject(campaignId, subjectParams) {
  return function (dispatch, getState) {
    var newSubject = (0, _assign2.default)({}, getState().subjects.editingSubject, subjectParams);

    api.updateSubject(campaignId, newSubject).then(function (subject) {
      dispatch({ type: SUBJECT_UPDATED, subject: subject });
    }).catch(function (message) {
      dispatch({ type: _shared.SERVER_ERROR, message: message });
    });
  };
};

var subjectUpdated = exports.subjectUpdated = function subjectUpdated(subject) {
  return { type: SUBJECT_UPDATED, subject: subject };
};

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.receiveSubjects = exports.targetPage = exports.startFetchingSubjects = exports.fetchSubjects = exports.changeTargetPage = exports.CHANGE_TARGET_PAGE = exports.FETCH = exports.RECEIVE_ERROR = exports.RECEIVE = undefined;

var _api = __webpack_require__(39);

var api = _interopRequireWildcard(_api);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var RECEIVE = exports.RECEIVE = 'SUBJECTS_RECEIVE';
var RECEIVE_ERROR = exports.RECEIVE_ERROR = 'SUBJECTS_RECEIVE_ERROR';
var FETCH = exports.FETCH = 'SUBJECTS_FETCH';
var CHANGE_TARGET_PAGE = exports.CHANGE_TARGET_PAGE = 'SUBJECTS_CHANGE_TARGET_PAGE';

var changeTargetPage = exports.changeTargetPage = function changeTargetPage(page) {
  return function (dispatch) {
    dispatch(targetPage(page));
  };
};

var fetchSubjects = exports.fetchSubjects = function fetchSubjects(campaignId, limit, page) {
  return function (dispatch) {
    dispatch(startFetchingSubjects());
    return api.fetchSubjects(campaignId, limit, page).then(function (response) {
      return dispatch(receiveSubjects(response || {}, limit, page));
    });
  };
};

var startFetchingSubjects = exports.startFetchingSubjects = function startFetchingSubjects() {
  return {
    type: FETCH
  };
};

var targetPage = exports.targetPage = function targetPage(page) {
  return {
    type: CHANGE_TARGET_PAGE,
    page: page
  };
};

var receiveSubjects = exports.receiveSubjects = function receiveSubjects(items, limit, page) {
  return {
    type: RECEIVE,
    items: items.subjects,
    count: items.count,
    limit: limit,
    page: page
  };
};

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeSymptom = exports.editSymptom = exports.addEmptySymptom = exports.EMPTY_SYMPTOM_ADD = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _campaign = __webpack_require__(19);

var EMPTY_SYMPTOM_ADD = exports.EMPTY_SYMPTOM_ADD = 'EMPTY_SYMPTOM_ADD';

var addEmptySymptom = exports.addEmptySymptom = function addEmptySymptom() {
  return { type: EMPTY_SYMPTOM_ADD };
};

var editSymptom = exports.editSymptom = function editSymptom(newName, index) {
  return function (dispatch, getState) {
    var symptoms = getState().campaign.data.symptoms.slice();

    var _symptoms$index = _slicedToArray(symptoms[index], 1),
        id = _symptoms$index[0];

    symptoms[index] = [id, newName];
    dispatch((0, _campaign.campaignUpdate)({ symptoms: symptoms }));
  };
};

var removeSymptom = exports.removeSymptom = function removeSymptom(index) {
  return function (dispatch, getState) {
    var symptoms = getState().campaign.data.symptoms.slice();
    symptoms.splice(index, 1);
    dispatch((0, _campaign.campaignUpdate)({ symptoms: symptoms }));
  };
};

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startFetchingTimezones = exports.receiveTimezones = exports.fetchTimezones = exports.FETCH_TIMEZONES = exports.RECEIVE_TIMEZONES = undefined;

var _api = __webpack_require__(39);

var api = _interopRequireWildcard(_api);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var RECEIVE_TIMEZONES = exports.RECEIVE_TIMEZONES = 'RECEIVE_TIMEZONES';
var FETCH_TIMEZONES = exports.FETCH_TIMEZONES = 'FETCH_TIMEZONES';

var fetchTimezones = exports.fetchTimezones = function fetchTimezones() {
  return function (dispatch, getState) {
    var state = getState();
    if (state.timezones.fetching) {
      return;
    }
    dispatch(startFetchingTimezones());

    return api.fetchTimezones().then(function (response) {
      dispatch(receiveTimezones(response));
    });
  };
};

var receiveTimezones = exports.receiveTimezones = function receiveTimezones(timezones) {
  return {
    type: RECEIVE_TIMEZONES,
    timezones: timezones
  };
};

var startFetchingTimezones = exports.startFetchingTimezones = function startFetchingTimezones() {
  return {
    type: FETCH_TIMEZONES
  };
};

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SubNav = __webpack_require__(166);

var _SubNav2 = _interopRequireDefault(_SubNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ActiveCampaignSubNav = function (_Component) {
  _inherits(ActiveCampaignSubNav, _Component);

  function ActiveCampaignSubNav() {
    _classCallCheck(this, ActiveCampaignSubNav);

    return _possibleConstructorReturn(this, (ActiveCampaignSubNav.__proto__ || Object.getPrototypeOf(ActiveCampaignSubNav)).apply(this, arguments));
  }

  _createClass(ActiveCampaignSubNav, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          addButtonHandler = _props.addButtonHandler,
          title = _props.title,
          campaignId = _props.campaignId;


      var tabsList = [{ label: 'Overview', url: '/campaigns/' + campaignId }, { label: 'Subjects', url: '/campaigns/' + campaignId + '/subjects' }];

      return _react2.default.createElement(
        _SubNav2.default,
        { tabsList: tabsList, addButtonHandler: addButtonHandler },
        title
      );
    }
  }]);

  return ActiveCampaignSubNav;
}(_react.Component);

exports.default = ActiveCampaignSubNav;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _UntitledIfEmpty = __webpack_require__(641);

var _UntitledIfEmpty2 = _interopRequireDefault(_UntitledIfEmpty);

var _TextFields = __webpack_require__(47);

var _TextFields2 = _interopRequireDefault(_TextFields);

var _FontIcons = __webpack_require__(36);

var _FontIcons2 = _interopRequireDefault(_FontIcons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditableTitleLabel = function (_Component) {
  _inherits(EditableTitleLabel, _Component);

  function EditableTitleLabel(props) {
    _classCallCheck(this, EditableTitleLabel);

    var _this = _possibleConstructorReturn(this, (EditableTitleLabel.__proto__ || Object.getPrototypeOf(EditableTitleLabel)).call(this, props));

    _this.state = {
      editing: false
    };
    _this.inputRef = null;
    return _this;
  }

  _createClass(EditableTitleLabel, [{
    key: 'handleClick',
    value: function handleClick() {
      if (!this.state.editing && !this.props.readOnly) {
        var editing = !this.state.editing;
        this.setState({ editing: editing });
      }
    }
  }, {
    key: 'endEdit',
    value: function endEdit() {
      this.setState({ editing: false });
    }
  }, {
    key: 'endAndSubmit',
    value: function endAndSubmit() {
      var onSubmit = this.props.onSubmit;

      this.endEdit();
      onSubmit(this.inputRef.getField().value);
    }
  }, {
    key: 'onKeyDown',
    value: function onKeyDown(event) {
      if (event.key == 'Enter') {
        this.endAndSubmit();
      } else if (event.key == 'Escape') {
        this.endEdit();
      }
    }
  }, {
    key: 'setInput',
    value: function setInput(node) {
      this.inputRef = node;

      if (node) {
        // focus element when first rendered. react-md's TextField doesn't support autofocus.
        node.focus();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          title = _props.title,
          emptyText = _props.emptyText,
          maxLength = _props.maxLength,
          hideEditingIcon = _props.hideEditingIcon;


      var icon = null;
      if ((!title || title.trim() == '') && !hideEditingIcon) {
        icon = _react2.default.createElement(
          _FontIcons2.default,
          null,
          'mode_edit'
        );
      }

      if (!this.state.editing) {
        return _react2.default.createElement(
          'a',
          { className: 'app-header-title-view', onClick: function onClick(e) {
              return _this2.handleClick(e);
            } },
          _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(_UntitledIfEmpty2.default, { text: title, emptyText: emptyText })
          ),
          icon
        );
      } else {
        return _react2.default.createElement(_TextFields2.default, {
          maxLength: maxLength,
          defaultValue: title || '',
          ref: function ref(node) {
            return _this2.setInput(node);
          },
          onKeyDown: function onKeyDown(e) {
            return _this2.onKeyDown(e);
          },
          onBlur: function onBlur(e) {
            return _this2.endAndSubmit(e);
          },
          size: 50,
          className: 'app-header-title-edit' });
      }
    }
  }]);

  return EditableTitleLabel;
}(_react.Component);

exports.default = EditableTitleLabel;


EditableTitleLabel.propTypes = {
  onSubmit: _propTypes2.default.func.isRequired,
  title: _propTypes2.default.string,
  emptyText: _propTypes2.default.string,
  readOnly: _propTypes2.default.bool,
  hideEditingIcon: _propTypes2.default.bool,
  maxLength: _propTypes2.default.number
};

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EmptyListing = function (_Component) {
  _inherits(EmptyListing, _Component);

  function EmptyListing() {
    _classCallCheck(this, EmptyListing);

    return _possibleConstructorReturn(this, (EmptyListing.__proto__ || Object.getPrototypeOf(EmptyListing)).apply(this, arguments));
  }

  _createClass(EmptyListing, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'md-text-center app-listing-no-data' },
        _react2.default.createElement(
          'div',
          { className: 'app-listing-no-data-image' },
          _react2.default.createElement('img', { src: this.props.image, width: '150px' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'app-listing-no-data-text' },
          this.props.children
        )
      );
    }
  }]);

  return EmptyListing;
}(_react.Component);

exports.default = EmptyListing;


EmptyListing.propTypes = {
  image: _propTypes2.default.string.isRequired,
  children: _propTypes2.default.node
};

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.orderedItems = exports.defaultFilterProvider = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _isEqual = __webpack_require__(1013);

var _isEqual2 = _interopRequireDefault(_isEqual);

var _values = __webpack_require__(146);

var _values2 = _interopRequireDefault(_values);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultFilterProvider = exports.defaultFilterProvider = function defaultFilterProvider(_) {
  return {};
};

exports.default = function (actions, itemsReducer, filterProvider, initialState) {
  return function (state, action) {
    state = state || initialState;
    switch (action.type) {
      case actions.FETCH:
        return fetch(state, action, filterProvider);
      case actions.RECEIVE:
        return receive(state, action, filterProvider);
      case actions.NEXT_PAGE:
        return nextPage(state);
      case actions.PREVIOUS_PAGE:
        return previousPage(state);
      case actions.SORT:
        return sortItems(state, action);
      default:
        return items(state, action, itemsReducer);
    }
  };
};

var items = function items(state, action, itemsReducer) {
  var newItems = state.items == null ? null : itemsReducer(state.items, action);

  if (newItems !== state.items) {
    var order = itemsOrder(newItems, state.sortBy, state.sortAsc);
    return _extends({}, state, {
      items: newItems,
      order: order
    });
  }

  return state;
};

var receive = function receive(state, action, filterProvider) {
  var itemsFilter = filterProvider(action);

  if ((0, _isEqual2.default)(state.filter, itemsFilter)) {
    var _items = action.items;
    var order = itemsOrder(_items, state.sortBy, state.sortAsc);
    return _extends({}, state, {
      fetching: false,
      items: _items,
      order: order
    });
  }

  return state;
};

var fetch = function fetch(state, action, filterProvider) {
  var newFilter = filterProvider(action);

  var newItems = null;

  if ((0, _isEqual2.default)(state.filter, newFilter)) {
    newItems = state.items;
  }

  return _extends({}, state, {
    fetching: true,
    filter: newFilter,
    items: newItems,
    page: _extends({}, state.page, {
      index: 0
    })
  });
};

var itemsOrder = function itemsOrder(items, sortBy, sortAsc) {
  var itemsValues = (0, _values2.default)(items);

  if (sortBy) {
    itemsValues.sort(function (p1, p2) {
      var x1 = p1[sortBy];
      var x2 = p2[sortBy];

      if (typeof x1 == 'string') {
        x1 = x1.toLowerCase();
        if (x2 == null) x2 = 'untitled';
      }
      if (typeof x2 == 'string') {
        x2 = x2.toLowerCase();
        if (x1 == null) x1 = 'untitled';
      }

      if (x1 < x2) {
        return sortAsc ? -1 : 1;
      } else if (x1 > x2) {
        return sortAsc ? 1 : -1;
      } else {
        return 0;
      }
    });
  }

  return itemsValues.map(function (p) {
    return p.id;
  });
};

var sortItems = function sortItems(state, action) {
  var sortAsc = state.sortBy == action.property ? !state.sortAsc : true;
  var sortBy = action.property;
  var order = itemsOrder(state.items, sortBy, sortAsc);
  return _extends({}, state, {
    order: order,
    sortBy: sortBy,
    sortAsc: sortAsc
  });
};

var nextPage = function nextPage(state) {
  return _extends({}, state, {
    page: _extends({}, state.page, {
      index: state.page.index + state.page.size
    })
  });
};

var previousPage = function previousPage(state) {
  return _extends({}, state, {
    page: _extends({}, state.page, {
      index: state.page.index - state.page.size
    })
  });
};

var orderedItems = exports.orderedItems = function orderedItems(items, order) {
  if (items && order) {
    return order.map(function (id) {
      return items[id];
    });
  } else {
    return null;
  }
};

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(680), __esModule: true };

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(672);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(671);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 297 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(687);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(89)
  , document = __webpack_require__(49).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(51) && !__webpack_require__(69)(function(){
  return Object.defineProperty(__webpack_require__(299)('div'), 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(297);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY        = __webpack_require__(174)
  , $export        = __webpack_require__(52)
  , redefine       = __webpack_require__(307)
  , hide           = __webpack_require__(70)
  , has            = __webpack_require__(53)
  , Iterators      = __webpack_require__(173)
  , $iterCreate    = __webpack_require__(693)
  , setToStringTag = __webpack_require__(177)
  , getPrototypeOf = __webpack_require__(305)
  , ITERATOR       = __webpack_require__(71)('iterator')
  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  , FF_ITERATOR    = '@@iterator'
  , KEYS           = 'keys'
  , VALUES         = 'values';

var returnThis = function(){ return this; };

module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
  $iterCreate(Constructor, NAME, next);
  var getMethod = function(kind){
    if(!BUGGY && kind in proto)return proto[kind];
    switch(kind){
      case KEYS: return function keys(){ return new Constructor(this, kind); };
      case VALUES: return function values(){ return new Constructor(this, kind); };
    } return function entries(){ return new Constructor(this, kind); };
  };
  var TAG        = NAME + ' Iterator'
    , DEF_VALUES = DEFAULT == VALUES
    , VALUES_BUG = false
    , proto      = Base.prototype
    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
    , $default   = $native || getMethod(DEFAULT)
    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
    , methods, key, IteratorPrototype;
  // Fix native
  if($anyNative){
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
    if(IteratorPrototype !== Object.prototype){
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if(DEF_VALUES && $native && $native.name !== VALUES){
    VALUES_BUG = true;
    $default = function values(){ return $native.call(this); };
  }
  // Define iterator
  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG]  = returnThis;
  if(DEFAULT){
    methods = {
      values:  DEF_VALUES ? $default : getMethod(VALUES),
      keys:    IS_SET     ? $default : getMethod(KEYS),
      entries: $entries
    };
    if(FORCED)for(key in methods){
      if(!(key in proto))redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var pIE            = __webpack_require__(122)
  , createDesc     = __webpack_require__(123)
  , toIObject      = __webpack_require__(55)
  , toPrimitive    = __webpack_require__(182)
  , has            = __webpack_require__(53)
  , IE8_DOM_DEFINE = __webpack_require__(300)
  , gOPD           = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(51) ? gOPD : function getOwnPropertyDescriptor(O, P){
  O = toIObject(O);
  P = toPrimitive(P, true);
  if(IE8_DOM_DEFINE)try {
    return gOPD(O, P);
  } catch(e){ /* empty */ }
  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
};

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys      = __webpack_require__(306)
  , hiddenKeys = __webpack_require__(172).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
  return $keys(O, hiddenKeys);
};

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has         = __webpack_require__(53)
  , toObject    = __webpack_require__(181)
  , IE_PROTO    = __webpack_require__(178)('IE_PROTO')
  , ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function(O){
  O = toObject(O);
  if(has(O, IE_PROTO))return O[IE_PROTO];
  if(typeof O.constructor == 'function' && O instanceof O.constructor){
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var has          = __webpack_require__(53)
  , toIObject    = __webpack_require__(55)
  , arrayIndexOf = __webpack_require__(689)(false)
  , IE_PROTO     = __webpack_require__(178)('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(70);

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
var array = Array.prototype;

var slice = array.slice;
var map = array.map;


/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bisectRight */
/* unused harmony export bisectLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisector__ = __webpack_require__(310);



var ascendingBisect = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__bisector__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]);
var bisectRight = ascendingBisect.right;
var bisectLeft = ascendingBisect.left;
/* harmony default export */ __webpack_exports__["a"] = (bisectRight);


/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(72);


/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  if (compare.length === 1) compare = ascendingComparator(compare);
  return {
    left: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) < 0) lo = mid + 1;
        else hi = mid;
      }
      return lo;
    },
    right: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) > 0) hi = mid;
        else lo = mid + 1;
      }
      return lo;
    }
  };
});

function ascendingComparator(f) {
  return function(d, x) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */])(f(d), x);
  };
}


/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__variance__ = __webpack_require__(319);


/* harmony default export */ __webpack_exports__["a"] = (function(array, f) {
  var v = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__variance__["a" /* default */])(array, f);
  return v ? Math.sqrt(v) : v;
});


/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  return [min, max];
});


/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  return min;
});


/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pair;
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, f) {
  if (f == null) f = pair;
  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
  while (i < n) pairs[i] = f(p, p = array[++i]);
  return pairs;
});

function pair(a, b) {
  return [a, b];
}


/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
});


/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
});


/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = tickIncrement;
/* harmony export (immutable) */ __webpack_exports__["a"] = tickStep;
var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

/* harmony default export */ __webpack_exports__["b"] = (function(start, stop, count) {
  var reverse = stop < start,
      i = -1,
      n,
      ticks,
      step;

  if (reverse) n = start, start = stop, stop = n;

  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    start = Math.ceil(start / step);
    stop = Math.floor(stop / step);
    ticks = new Array(n = Math.ceil(stop - start + 1));
    while (++i < n) ticks[i] = (start + i) * step;
  } else {
    start = Math.floor(start * step);
    stop = Math.ceil(stop * step);
    ticks = new Array(n = Math.ceil(start - stop + 1));
    while (++i < n) ticks[i] = (start - i) / step;
  }

  if (reverse) ticks.reverse();

  return ticks;
});

function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}


/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__min__ = __webpack_require__(313);


/* harmony default export */ __webpack_exports__["a"] = (function(matrix) {
  if (!(n = matrix.length)) return [];
  for (var i = -1, m = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__min__["a" /* default */])(matrix, length), transpose = new Array(m); ++i < m;) {
    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
      row[j] = matrix[j][i];
    }
  }
  return transpose;
});

function length(d) {
  return d.length;
}


/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(91);


/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      m = 0,
      i = -1,
      mean = 0,
      value,
      delta,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  if (m > 1) return sum / (m - 1);
});


/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_nest__ = __webpack_require__(736);
/* unused harmony reexport nest */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_set__ = __webpack_require__(737);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__src_set__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_map__ = __webpack_require__(187);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__src_map__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_keys__ = __webpack_require__(735);
/* unused harmony reexport keys */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_values__ = __webpack_require__(738);
/* unused harmony reexport values */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_entries__ = __webpack_require__(734);
/* unused harmony reexport entries */








/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deg2rad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return rad2deg; });
var deg2rad = Math.PI / 180;
var rad2deg = 180 / Math.PI;


/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var array = Array.prototype;

var slice = array.slice;


/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ascending__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__area__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constant__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__contains__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__noop__ = __webpack_require__(747);








var cases = [
  [],
  [[[1,1.5],[0.5,1]]],
  [[[1.5,1],[1,1.5]]],
  [[[1.5,1],[0.5,1]]],
  [[[1,0.5],[1.5,1]]],
  [[[1,0.5],[0.5,1]],[[1,1.5],[1.5,1]]],
  [[[1,0.5],[1,1.5]]],
  [[[1,0.5],[0.5,1]]],
  [[[0.5,1],[1,0.5]]],
  [[[1,1.5],[1,0.5]]],
  [[[0.5,1],[1,1.5]],[[1.5,1],[1,0.5]]],
  [[[1.5,1],[1,0.5]]],
  [[[0.5,1],[1.5,1]]],
  [[[1,1.5],[1.5,1]]],
  [[[0.5,1],[1,1.5]]],
  []
];

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var dx = 1,
      dy = 1,
      threshold = __WEBPACK_IMPORTED_MODULE_0_d3_array__["l" /* thresholdSturges */],
      smooth = smoothLinear;

  function contours(values) {
    var tz = threshold(values);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      var domain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["a" /* extent */])(values), start = domain[0], stop = domain[1];
      tz = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["e" /* tickStep */])(start, stop, tz);
      tz = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["i" /* range */])(Math.floor(start / tz) * tz, Math.floor(stop / tz) * tz, tz);
    } else {
      tz = tz.slice().sort(__WEBPACK_IMPORTED_MODULE_2__ascending__["a" /* default */]);
    }

    // Accumulate, smooth contour rings, assign holes to exterior rings.
    // Based on https://github.com/mbostock/shapefile/blob/v0.6.2/shp/polygon.js
    var layers = tz.map(function(value) {
      var polygons = [],
          holes = [];

      isorings(values, value, function(ring) {
        smooth(ring, values, value);
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__area__["a" /* default */])(ring) > 0) polygons.push([ring]);
        else holes.push(ring);
      });

      holes.forEach(function(hole) {
        for (var i = 0, n = polygons.length, polygon; i < n; ++i) {
          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__contains__["a" /* default */])((polygon = polygons[i])[0], hole) !== -1) {
            polygon.push(hole);
            return;
          }
        }
      });

      return polygons;
    });

    return layers.map(function(polygons, i) {
      return {
        type: "MultiPolygon",
        value: tz[i],
        coordinates: polygons
      };
    });
  }

  // Marching squares with isolines stitched into rings.
  // Based on https://github.com/topojson/topojson-client/blob/v3.0.0/src/stitch.js
  function isorings(values, value, callback) {
    var fragmentByStart = new Array,
        fragmentByEnd = new Array,
        x, y, t0, t1, t2, t3;

    // Special case for the first row (y = -1, t2 = t3 = 0).
    x = y = -1;
    t1 = values[0] >= value;
    cases[t1 << 1].forEach(stitch);
    while (++x < dx - 1) {
      t0 = t1, t1 = values[x + 1] >= value;
      cases[t0 | t1 << 1].forEach(stitch);
    }
    cases[t1 << 0].forEach(stitch);

    // General case for the intermediate rows.
    while (++y < dy - 1) {
      x = -1;
      t1 = values[y * dx + dx] >= value;
      t2 = values[y * dx] >= value;
      cases[t1 << 1 | t2 << 2].forEach(stitch);
      while (++x < dx - 1) {
        t0 = t1, t1 = values[y * dx + dx + x + 1] >= value;
        t3 = t2, t2 = values[y * dx + x + 1] >= value;
        cases[t0 | t1 << 1 | t2 << 2 | t3 << 3].forEach(stitch);
      }
      cases[t1 | t2 << 3].forEach(stitch);
    }

    // Special case for the last row (y = dy - 1, t0 = t1 = 0).
    x = -1;
    t2 = values[y * dx] >= value;
    cases[t2 << 2].forEach(stitch);
    while (++x < dx - 1) {
      t3 = t2, t2 = values[y * dx + x + 1] >= value;
      cases[t2 << 2 | t3 << 3].forEach(stitch);
    }
    cases[t2 << 3].forEach(stitch);

    function stitch(line) {
      var start = [line[0][0] + x, line[0][1] + y],
          end = [line[1][0] + x, line[1][1] + y],
          startIndex = index(start),
          endIndex = index(end),
          f, g;
      if (f = fragmentByEnd[startIndex]) {
        if (g = fragmentByStart[endIndex]) {
          delete fragmentByEnd[f.end];
          delete fragmentByStart[g.start];
          if (f === g) {
            f.ring.push(end);
            callback(f.ring);
          } else {
            fragmentByStart[f.start] = fragmentByEnd[g.end] = {start: f.start, end: g.end, ring: f.ring.concat(g.ring)};
          }
        } else {
          delete fragmentByEnd[f.end];
          f.ring.push(end);
          fragmentByEnd[f.end = endIndex] = f;
        }
      } else if (f = fragmentByStart[endIndex]) {
        if (g = fragmentByEnd[startIndex]) {
          delete fragmentByStart[f.start];
          delete fragmentByEnd[g.end];
          if (f === g) {
            f.ring.push(end);
            callback(f.ring);
          } else {
            fragmentByStart[g.start] = fragmentByEnd[f.end] = {start: g.start, end: f.end, ring: g.ring.concat(f.ring)};
          }
        } else {
          delete fragmentByStart[f.start];
          f.ring.unshift(start);
          fragmentByStart[f.start = startIndex] = f;
        }
      } else {
        fragmentByStart[startIndex] = fragmentByEnd[endIndex] = {start: startIndex, end: endIndex, ring: [start, end]};
      }
    }
  }

  function index(point) {
    return point[0] * 2 + point[1] * (dx + 1) * 4;
  }

  function smoothLinear(ring, values, value) {
    ring.forEach(function(point) {
      var x = point[0],
          y = point[1],
          xt = x | 0,
          yt = y | 0,
          v0,
          v1 = values[yt * dx + xt];
      if (x > 0 && x < dx && xt === x) {
        v0 = values[yt * dx + xt - 1];
        point[0] = x + (value - v0) / (v1 - v0) - 0.5;
      }
      if (y > 0 && y < dy && yt === y) {
        v0 = values[(yt - 1) * dx + xt];
        point[1] = y + (value - v0) / (v1 - v0) - 0.5;
      }
    });
  }

  contours.size = function(_) {
    if (!arguments.length) return [dx, dy];
    var _0 = Math.ceil(_[0]), _1 = Math.ceil(_[1]);
    if (!(_0 > 0) || !(_1 > 0)) throw new Error("invalid size");
    return dx = _0, dy = _1, contours;
  };

  contours.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__array__["a" /* slice */].call(_)) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__constant__["a" /* default */])(_), contours) : threshold;
  };

  contours.smooth = function(_) {
    return arguments.length ? (smooth = _ ? smoothLinear : __WEBPACK_IMPORTED_MODULE_6__noop__["a" /* default */], contours) : smooth === smoothLinear;
  };

  return contours;
});


/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefixExponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(190);


var prefixExponent;

/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  var d = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, Math.max(0, p + i - 1))[0]; // less than 1y!
});


/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatSpecifier;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatTypes__ = __webpack_require__(327);


// [[fill]align][sign][symbol][0][width][,][.precision][type]
var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  return new FormatSpecifier(specifier);
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);

  var match,
      fill = match[1] || " ",
      align = match[2] || ">",
      sign = match[3] || "-",
      symbol = match[4] || "",
      zero = !!match[5],
      width = match[6] && +match[6],
      comma = !!match[7],
      precision = match[8] && +match[8].slice(1),
      type = match[9] || "";

  // The "n" type is an alias for ",g".
  if (type === "n") comma = true, type = "g";

  // Map invalid types to the default format.
  else if (!__WEBPACK_IMPORTED_MODULE_0__formatTypes__["a" /* default */][type]) type = "";

  // If zero fill is specified, padding goes after sign and before digits.
  if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

  this.fill = fill;
  this.align = align;
  this.sign = sign;
  this.symbol = symbol;
  this.zero = zero;
  this.width = width;
  this.comma = comma;
  this.precision = precision;
  this.type = type;
}

FormatSpecifier.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width == null ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
      + this.type;
};


/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDefault__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatRounded__ = __webpack_require__(752);




/* harmony default export */ __webpack_exports__["a"] = ({
  "": __WEBPACK_IMPORTED_MODULE_0__formatDefault__["a" /* default */],
  "%": function(x, p) { return (x * 100).toFixed(p); },
  "b": function(x) { return Math.round(x).toString(2); },
  "c": function(x) { return x + ""; },
  "d": function(x) { return Math.round(x).toString(10); },
  "e": function(x, p) { return x.toExponential(p); },
  "f": function(x, p) { return x.toFixed(p); },
  "g": function(x, p) { return x.toPrecision(p); },
  "o": function(x) { return Math.round(x).toString(8); },
  "p": function(x, p) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__formatRounded__["a" /* default */])(x * 100, p); },
  "r": __WEBPACK_IMPORTED_MODULE_2__formatRounded__["a" /* default */],
  "s": __WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto__["a" /* default */],
  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
  "x": function(x) { return Math.round(x).toString(16); }
});


/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatGroup__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatNumerals__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__formatSpecifier__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__formatTypes__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__formatPrefixAuto__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__identity__ = __webpack_require__(753);








var prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];

/* harmony default export */ __webpack_exports__["a"] = (function(locale) {
  var group = locale.grouping && locale.thousands ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__formatGroup__["a" /* default */])(locale.grouping, locale.thousands) : __WEBPACK_IMPORTED_MODULE_6__identity__["a" /* default */],
      currency = locale.currency,
      decimal = locale.decimal,
      numerals = locale.numerals ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__formatNumerals__["a" /* default */])(locale.numerals) : __WEBPACK_IMPORTED_MODULE_6__identity__["a" /* default */],
      percent = locale.percent || "%";

  function newFormat(specifier) {
    specifier = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier__["a" /* default */])(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        type = specifier.type;

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = __WEBPACK_IMPORTED_MODULE_4__formatTypes__["a" /* default */][type],
        maybeSuffix = !type || /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision == null ? (type ? 6 : 12)
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Perform the initial formatting.
        var valueNegative = value < 0;
        value = formatType(Math.abs(value), precision);

        // If a negative value rounds to zero during formatting, treat as positive.
        if (valueNegative && +value === 0) valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = valueSuffix + (type === "s" ? prefixes[8 + __WEBPACK_IMPORTED_MODULE_5__formatPrefixAuto__["b" /* prefixExponent */] / 3] : "") + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }

      return numerals(value);
    }

    format.toString = function() {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier__["a" /* default */])(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
});


/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return areaRingSum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return areaStream; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noop__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stream__ = __webpack_require__(56);





var areaRingSum = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])();

var areaSum = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    lambda00,
    phi00,
    lambda0,
    cosPhi0,
    sinPhi0;

var areaStream = {
  point: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineStart: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineEnd: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  polygonStart: function() {
    areaRingSum.reset();
    areaStream.lineStart = areaRingStart;
    areaStream.lineEnd = areaRingEnd;
  },
  polygonEnd: function() {
    var areaRing = +areaRingSum;
    areaSum.add(areaRing < 0 ? __WEBPACK_IMPORTED_MODULE_1__math__["b" /* tau */] + areaRing : areaRing);
    this.lineStart = this.lineEnd = this.point = __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */];
  },
  sphere: function() {
    areaSum.add(__WEBPACK_IMPORTED_MODULE_1__math__["b" /* tau */]);
  }
};

function areaRingStart() {
  areaStream.point = areaPointFirst;
}

function areaRingEnd() {
  areaPoint(lambda00, phi00);
}

function areaPointFirst(lambda, phi) {
  areaStream.point = areaPoint;
  lambda00 = lambda, phi00 = phi;
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */];
  lambda0 = lambda, cosPhi0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(phi = phi / 2 + __WEBPACK_IMPORTED_MODULE_1__math__["q" /* quarterPi */]), sinPhi0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(phi);
}

function areaPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */];
  phi = phi / 2 + __WEBPACK_IMPORTED_MODULE_1__math__["q" /* quarterPi */]; // half the angular distance from south pole

  // Spherical excess E for a spherical triangle with vertices: south pole,
  // previous point, current point.  Uses a formula derived from Cagnoli’s
  // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
  var dLambda = lambda - lambda0,
      sdLambda = dLambda >= 0 ? 1 : -1,
      adLambda = sdLambda * dLambda,
      cosPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(phi),
      sinPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(phi),
      k = sinPhi0 * sinPhi,
      u = cosPhi0 * cosPhi + k * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(adLambda),
      v = k * sdLambda * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(adLambda);
  areaRingSum.add(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(v, u));

  // Advance the previous points.
  lambda0 = lambda, cosPhi0 = cosPhi, sinPhi0 = sinPhi;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(object) {
  areaSum.reset();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__stream__["a" /* default */])(object, areaStream);
  return areaSum * 2;
});


/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = circleStream;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cartesian__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rotation__ = __webpack_require__(127);





// Generates a circle centered at [0°, 0°], with a given radius and precision.
function circleStream(stream, radius, delta, direction, t0, t1) {
  if (!delta) return;
  var cosRadius = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* cos */])(radius),
      sinRadius = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sin */])(radius),
      step = direction * delta;
  if (t0 == null) {
    t0 = radius + direction * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* tau */];
    t1 = radius - step / 2;
  } else {
    t0 = circleRadius(cosRadius, t0);
    t1 = circleRadius(cosRadius, t1);
    if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* tau */];
  }
  for (var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step) {
    point = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["f" /* spherical */])([cosRadius, -sinRadius * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* cos */])(t), -sinRadius * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sin */])(t)]);
    stream.point(point[0], point[1]);
  }
}

// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
function circleRadius(cosRadius, point) {
  point = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["a" /* cartesian */])(point), point[0] -= cosRadius;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["g" /* cartesianNormalizeInPlace */])(point);
  var radius = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["r" /* acos */])(-point[1]);
  return ((-point[2] < 0 ? -radius : radius) + __WEBPACK_IMPORTED_MODULE_2__math__["b" /* tau */] - __WEBPACK_IMPORTED_MODULE_2__math__["p" /* epsilon */]) % __WEBPACK_IMPORTED_MODULE_2__math__["b" /* tau */];
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var center = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])([0, 0]),
      radius = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(90),
      precision = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(6),
      ring,
      rotate,
      stream = {point: point};

  function point(x, y) {
    ring.push(x = rotate(x, y));
    x[0] *= __WEBPACK_IMPORTED_MODULE_2__math__["h" /* degrees */], x[1] *= __WEBPACK_IMPORTED_MODULE_2__math__["h" /* degrees */];
  }

  function circle() {
    var c = center.apply(this, arguments),
        r = radius.apply(this, arguments) * __WEBPACK_IMPORTED_MODULE_2__math__["g" /* radians */],
        p = precision.apply(this, arguments) * __WEBPACK_IMPORTED_MODULE_2__math__["g" /* radians */];
    ring = [];
    rotate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__rotation__["b" /* rotateRadians */])(-c[0] * __WEBPACK_IMPORTED_MODULE_2__math__["g" /* radians */], -c[1] * __WEBPACK_IMPORTED_MODULE_2__math__["g" /* radians */], 0).invert;
    circleStream(stream, r, p, 1);
    c = {type: "Polygon", coordinates: [ring]};
    ring = rotate = null;
    return c;
  }

  circle.center = function(_) {
    return arguments.length ? (center = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])([+_[0], +_[1]]), circle) : center;
  };

  circle.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), circle) : radius;
  };

  circle.precision = function(_) {
    return arguments.length ? (precision = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), circle) : precision;
  };

  return circle;
});


/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(50);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  var lines = [],
      line;
  return {
    point: function(x, y) {
      line.push([x, y]);
    },
    lineStart: function() {
      lines.push(line = []);
    },
    lineEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
    rejoin: function() {
      if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
    },
    result: function() {
      var result = lines;
      lines = [];
      line = null;
      return result;
    }
  };
});


/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__buffer__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__polygon__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__polygonContains__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_array__ = __webpack_require__(21);






/* harmony default export */ __webpack_exports__["a"] = (function(pointVisible, clipLine, interpolate, start) {
  return function(rotate, sink) {
    var line = clipLine(sink),
        rotatedStart = rotate.invert(start[0], start[1]),
        ringBuffer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__buffer__["a" /* default */])(),
        ringSink = clipLine(ringBuffer),
        polygonStarted = false,
        polygon,
        segments,
        ring;

    var clip = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() {
        clip.point = pointRing;
        clip.lineStart = ringStart;
        clip.lineEnd = ringEnd;
        segments = [];
        polygon = [];
      },
      polygonEnd: function() {
        clip.point = point;
        clip.lineStart = lineStart;
        clip.lineEnd = lineEnd;
        segments = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_d3_array__["j" /* merge */])(segments);
        var startInside = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__polygonContains__["a" /* default */])(polygon, rotatedStart);
        if (segments.length) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__polygon__["a" /* default */])(segments, compareIntersection, startInside, interpolate, sink);
        } else if (startInside) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          interpolate(null, null, 1, sink);
          sink.lineEnd();
        }
        if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
        segments = polygon = null;
      },
      sphere: function() {
        sink.polygonStart();
        sink.lineStart();
        interpolate(null, null, 1, sink);
        sink.lineEnd();
        sink.polygonEnd();
      }
    };

    function point(lambda, phi) {
      var point = rotate(lambda, phi);
      if (pointVisible(lambda = point[0], phi = point[1])) sink.point(lambda, phi);
    }

    function pointLine(lambda, phi) {
      var point = rotate(lambda, phi);
      line.point(point[0], point[1]);
    }

    function lineStart() {
      clip.point = pointLine;
      line.lineStart();
    }

    function lineEnd() {
      clip.point = point;
      line.lineEnd();
    }

    function pointRing(lambda, phi) {
      ring.push([lambda, phi]);
      var point = rotate(lambda, phi);
      ringSink.point(point[0], point[1]);
    }

    function ringStart() {
      ringSink.lineStart();
      ring = [];
    }

    function ringEnd() {
      pointRing(ring[0][0], ring[0][1]);
      ringSink.lineEnd();

      var clean = ringSink.clean(),
          ringSegments = ringBuffer.result(),
          i, n = ringSegments.length, m,
          segment,
          point;

      ring.pop();
      polygon.push(ring);
      ring = null;

      if (!n) return;

      // No intersections.
      if (clean & 1) {
        segment = ringSegments[0];
        if ((m = segment.length - 1) > 0) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          for (i = 0; i < m; ++i) sink.point((point = segment[i])[0], point[1]);
          sink.lineEnd();
        }
        return;
      }

      // Rejoin connected segments.
      // TODO reuse ringBuffer.rejoin()?
      if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));

      segments.push(ringSegments.filter(validSegment));
    }

    return clip;
  };
});

function validSegment(segment) {
  return segment.length > 1;
}

// Intersections are sorted along the clip edge. For both antimeridian cutting
// and circle clipping, the same comparison is used.
function compareIntersection(a, b) {
  return ((a = a.x)[0] < 0 ? a[1] - __WEBPACK_IMPORTED_MODULE_2__math__["k" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_2__math__["p" /* epsilon */] : __WEBPACK_IMPORTED_MODULE_2__math__["k" /* halfPi */] - a[1])
       - ((b = b.x)[0] < 0 ? b[1] - __WEBPACK_IMPORTED_MODULE_2__math__["k" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_2__math__["p" /* epsilon */] : __WEBPACK_IMPORTED_MODULE_2__math__["k" /* halfPi */] - b[1]);
}


/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pointEqual__ = __webpack_require__(338);


function Intersection(point, points, other, entry) {
  this.x = point;
  this.z = points;
  this.o = other; // another intersection
  this.e = entry; // is an entry?
  this.v = false; // visited
  this.n = this.p = null; // next & previous
}

// A generalized polygon clipping algorithm: given a polygon that has been cut
// into its visible line segments, and rejoins the segments by interpolating
// along the clip edge.
/* harmony default export */ __webpack_exports__["a"] = (function(segments, compareIntersection, startInside, interpolate, stream) {
  var subject = [],
      clip = [],
      i,
      n;

  segments.forEach(function(segment) {
    if ((n = segment.length - 1) <= 0) return;
    var n, p0 = segment[0], p1 = segment[n], x;

    // If the first and last points of a segment are coincident, then treat as a
    // closed ring. TODO if all rings are closed, then the winding order of the
    // exterior ring should be checked.
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__pointEqual__["a" /* default */])(p0, p1)) {
      stream.lineStart();
      for (i = 0; i < n; ++i) stream.point((p0 = segment[i])[0], p0[1]);
      stream.lineEnd();
      return;
    }

    subject.push(x = new Intersection(p0, segment, null, true));
    clip.push(x.o = new Intersection(p0, null, x, false));
    subject.push(x = new Intersection(p1, segment, null, false));
    clip.push(x.o = new Intersection(p1, null, x, true));
  });

  if (!subject.length) return;

  clip.sort(compareIntersection);
  link(subject);
  link(clip);

  for (i = 0, n = clip.length; i < n; ++i) {
    clip[i].e = startInside = !startInside;
  }

  var start = subject[0],
      points,
      point;

  while (1) {
    // Find first unvisited intersection.
    var current = start,
        isSubject = true;
    while (current.v) if ((current = current.n) === start) return;
    points = current.z;
    stream.lineStart();
    do {
      current.v = current.o.v = true;
      if (current.e) {
        if (isSubject) {
          for (i = 0, n = points.length; i < n; ++i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.n.x, 1, stream);
        }
        current = current.n;
      } else {
        if (isSubject) {
          points = current.p.z;
          for (i = points.length - 1; i >= 0; --i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.p.x, -1, stream);
        }
        current = current.p;
      }
      current = current.o;
      points = current.z;
      isSubject = !isSubject;
    } while (!current.v);
    stream.lineEnd();
  }
});

function link(array) {
  if (!(n = array.length)) return;
  var n,
      i = 0,
      a = array[0],
      b;
  while (++i < n) {
    a.n = b = array[i];
    b.p = a;
    a = b;
  }
  a.n = b = array[0];
  b.p = a;
}


/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {

  function compose(x, y) {
    return x = a(x, y), b(x[0], x[1]);
  }

  if (a.invert && b.invert) compose.invert = function(x, y) {
    return x = b.invert(x, y), x && a.invert(x[0], x[1]);
  };

  return compose;
});


/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__length__ = __webpack_require__(336);


var coordinates = [null, null],
    object = {type: "LineString", coordinates: coordinates};

/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  coordinates[0] = a;
  coordinates[1] = b;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__length__["a" /* default */])(object);
});


/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noop__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stream__ = __webpack_require__(56);





var lengthSum = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    lambda0,
    sinPhi0,
    cosPhi0;

var lengthStream = {
  sphere: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  point: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineStart: lengthLineStart,
  lineEnd: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  polygonStart: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  polygonEnd: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */]
};

function lengthLineStart() {
  lengthStream.point = lengthPointFirst;
  lengthStream.lineEnd = lengthLineEnd;
}

function lengthLineEnd() {
  lengthStream.point = lengthStream.lineEnd = __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */];
}

function lengthPointFirst(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */];
  lambda0 = lambda, sinPhi0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(phi), cosPhi0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(phi);
  lengthStream.point = lengthPoint;
}

function lengthPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */];
  var sinPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(phi),
      cosPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(phi),
      delta = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])(lambda - lambda0),
      cosDelta = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(delta),
      sinDelta = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(delta),
      x = cosPhi * sinDelta,
      y = cosPhi0 * sinPhi - sinPhi0 * cosPhi * cosDelta,
      z = sinPhi0 * sinPhi + cosPhi0 * cosPhi * cosDelta;
  lengthSum.add(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["n" /* sqrt */])(x * x + y * y), z));
  lambda0 = lambda, sinPhi0 = sinPhi, cosPhi0 = cosPhi;
}

/* harmony default export */ __webpack_exports__["a"] = (function(object) {
  lengthSum.reset();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__stream__["a" /* default */])(object, lengthStream);
  return +lengthSum;
});


/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(50);


var x0 = Infinity,
    y0 = x0,
    x1 = -x0,
    y1 = x1;

var boundsStream = {
  point: boundsPoint,
  lineStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  polygonStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  polygonEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  result: function() {
    var bounds = [[x0, y0], [x1, y1]];
    x1 = y1 = -(y0 = x0 = Infinity);
    return bounds;
  }
};

function boundsPoint(x, y) {
  if (x < x0) x0 = x;
  if (x > x1) x1 = x;
  if (y < y0) y0 = y;
  if (y > y1) y1 = y;
}

/* harmony default export */ __webpack_exports__["a"] = (boundsStream);


/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["o" /* abs */])(a[0] - b[0]) < __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */] && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["o" /* abs */])(a[1] - b[1]) < __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */];
});


/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cartesian__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(5);




var sum = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])();

/* harmony default export */ __webpack_exports__["a"] = (function(polygon, point) {
  var lambda = point[0],
      phi = point[1],
      normal = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sin */])(lambda), -__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* cos */])(lambda), 0],
      angle = 0,
      winding = 0;

  sum.reset();

  for (var i = 0, n = polygon.length; i < n; ++i) {
    if (!(m = (ring = polygon[i]).length)) continue;
    var ring,
        m,
        point0 = ring[m - 1],
        lambda0 = point0[0],
        phi0 = point0[1] / 2 + __WEBPACK_IMPORTED_MODULE_2__math__["q" /* quarterPi */],
        sinPhi0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sin */])(phi0),
        cosPhi0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* cos */])(phi0);

    for (var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1) {
      var point1 = ring[j],
          lambda1 = point1[0],
          phi1 = point1[1] / 2 + __WEBPACK_IMPORTED_MODULE_2__math__["q" /* quarterPi */],
          sinPhi1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sin */])(phi1),
          cosPhi1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* cos */])(phi1),
          delta = lambda1 - lambda0,
          sign = delta >= 0 ? 1 : -1,
          absDelta = sign * delta,
          antimeridian = absDelta > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* pi */],
          k = sinPhi0 * sinPhi1;

      sum.add(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* atan2 */])(k * sign * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sin */])(absDelta), cosPhi0 * cosPhi1 + k * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* cos */])(absDelta)));
      angle += antimeridian ? delta + sign * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* tau */] : delta;

      // Are the longitudes either side of the point’s meridian (lambda),
      // and are the latitudes smaller than the parallel (phi)?
      if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
        var arc = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cartesian__["b" /* cartesianCross */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cartesian__["a" /* cartesian */])(point0), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cartesian__["a" /* cartesian */])(point1));
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cartesian__["g" /* cartesianNormalizeInPlace */])(arc);
        var intersection = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cartesian__["b" /* cartesianCross */])(normal, arc);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cartesian__["g" /* cartesianNormalizeInPlace */])(intersection);
        var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["f" /* asin */])(intersection[2]);
        if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) {
          winding += antimeridian ^ delta >= 0 ? 1 : -1;
        }
      }
    }
  }

  // First, determine whether the South pole is inside or outside:
  //
  // It is inside if:
  // * the polygon winds around it in a clockwise direction.
  // * the polygon does not (cumulatively) wind around it, but has a negative
  //   (counter-clockwise) area.
  //
  // Second, count the (signed) number of times a segment crosses a lambda
  // from the point to the South pole.  If it is zero, then the point is the
  // same side as the South pole.

  return (angle < -__WEBPACK_IMPORTED_MODULE_2__math__["p" /* epsilon */] || angle < __WEBPACK_IMPORTED_MODULE_2__math__["p" /* epsilon */] && sum < -__WEBPACK_IMPORTED_MODULE_2__math__["p" /* epsilon */]) ^ (winding & 1);
});


/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__conicEqualArea__ = __webpack_require__(194);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__conicEqualArea__["a" /* default */])()
      .parallels([29.5, 45.5])
      .scale(1070)
      .translate([480, 250])
      .rotate([96, 0])
      .center([-0.6, 38.7]);
});


/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = equirectangularRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(41);


function equirectangularRaw(lambda, phi) {
  return [lambda, phi];
}

equirectangularRaw.invert = equirectangularRaw;

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])(equirectangularRaw)
      .scale(152.63);
});


/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_cluster__ = __webpack_require__(786);
/* unused harmony reexport cluster */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_hierarchy_index__ = __webpack_require__(198);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_hierarchy_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_pack_index__ = __webpack_require__(798);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_2__src_pack_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_pack_siblings__ = __webpack_require__(345);
/* unused harmony reexport packSiblings */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_pack_enclose__ = __webpack_require__(344);
/* unused harmony reexport packEnclose */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_partition__ = __webpack_require__(799);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__src_partition__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_stratify__ = __webpack_require__(800);
/* unused harmony reexport stratify */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_tree__ = __webpack_require__(801);
/* unused harmony reexport tree */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_treemap_index__ = __webpack_require__(803);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_8__src_treemap_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_treemap_binary__ = __webpack_require__(802);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_9__src_treemap_binary__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_treemap_dice__ = __webpack_require__(94);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_10__src_treemap_dice__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_treemap_slice__ = __webpack_require__(129);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_11__src_treemap_slice__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_treemap_sliceDice__ = __webpack_require__(805);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_12__src_treemap_sliceDice__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_treemap_squarify__ = __webpack_require__(199);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_13__src_treemap_squarify__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_treemap_resquarify__ = __webpack_require__(804);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_14__src_treemap_resquarify__["a"]; });

















/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = constantZero;
function constantZero() {
  return 0;
}

/* harmony default export */ __webpack_exports__["b"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(785);


/* harmony default export */ __webpack_exports__["a"] = (function(circles) {
  var i = 0, n = (circles = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__array__["a" /* shuffle */])(__WEBPACK_IMPORTED_MODULE_0__array__["b" /* slice */].call(circles))).length, B = [], p, e;

  while (i < n) {
    p = circles[i];
    if (e && enclosesWeak(e, p)) ++i;
    else e = encloseBasis(B = extendBasis(B, p)), i = 0;
  }

  return e;
});

function extendBasis(B, p) {
  var i, j;

  if (enclosesWeakAll(p, B)) return [p];

  // If we get here then B must have at least one element.
  for (i = 0; i < B.length; ++i) {
    if (enclosesNot(p, B[i])
        && enclosesWeakAll(encloseBasis2(B[i], p), B)) {
      return [B[i], p];
    }
  }

  // If we get here then B must have at least two elements.
  for (i = 0; i < B.length - 1; ++i) {
    for (j = i + 1; j < B.length; ++j) {
      if (enclosesNot(encloseBasis2(B[i], B[j]), p)
          && enclosesNot(encloseBasis2(B[i], p), B[j])
          && enclosesNot(encloseBasis2(B[j], p), B[i])
          && enclosesWeakAll(encloseBasis3(B[i], B[j], p), B)) {
        return [B[i], B[j], p];
      }
    }
  }

  // If we get here then something is very wrong.
  throw new Error;
}

function enclosesNot(a, b) {
  var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
  return dr < 0 || dr * dr < dx * dx + dy * dy;
}

function enclosesWeak(a, b) {
  var dr = a.r - b.r + 1e-6, dx = b.x - a.x, dy = b.y - a.y;
  return dr > 0 && dr * dr > dx * dx + dy * dy;
}

function enclosesWeakAll(a, B) {
  for (var i = 0; i < B.length; ++i) {
    if (!enclosesWeak(a, B[i])) {
      return false;
    }
  }
  return true;
}

function encloseBasis(B) {
  switch (B.length) {
    case 1: return encloseBasis1(B[0]);
    case 2: return encloseBasis2(B[0], B[1]);
    case 3: return encloseBasis3(B[0], B[1], B[2]);
  }
}

function encloseBasis1(a) {
  return {
    x: a.x,
    y: a.y,
    r: a.r
  };
}

function encloseBasis2(a, b) {
  var x1 = a.x, y1 = a.y, r1 = a.r,
      x2 = b.x, y2 = b.y, r2 = b.r,
      x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1,
      l = Math.sqrt(x21 * x21 + y21 * y21);
  return {
    x: (x1 + x2 + x21 / l * r21) / 2,
    y: (y1 + y2 + y21 / l * r21) / 2,
    r: (l + r1 + r2) / 2
  };
}

function encloseBasis3(a, b, c) {
  var x1 = a.x, y1 = a.y, r1 = a.r,
      x2 = b.x, y2 = b.y, r2 = b.r,
      x3 = c.x, y3 = c.y, r3 = c.r,
      a2 = x1 - x2,
      a3 = x1 - x3,
      b2 = y1 - y2,
      b3 = y1 - y3,
      c2 = r2 - r1,
      c3 = r3 - r1,
      d1 = x1 * x1 + y1 * y1 - r1 * r1,
      d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2,
      d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3,
      ab = a3 * b2 - a2 * b3,
      xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1,
      xb = (b3 * c2 - b2 * c3) / ab,
      ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1,
      yb = (a2 * c3 - a3 * c2) / ab,
      A = xb * xb + yb * yb - 1,
      B = 2 * (r1 + xa * xb + ya * yb),
      C = xa * xa + ya * ya - r1 * r1,
      r = -(A ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
  return {
    x: x1 + xa + xb * r,
    y: y1 + ya + yb * r,
    r: r
  };
}


/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = packEnclose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enclose__ = __webpack_require__(344);


function place(a, b, c) {
  var ax = a.x,
      ay = a.y,
      da = b.r + c.r,
      db = a.r + c.r,
      dx = b.x - ax,
      dy = b.y - ay,
      dc = dx * dx + dy * dy;
  if (dc) {
    var x = 0.5 + ((db *= db) - (da *= da)) / (2 * dc),
        y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
    c.x = ax + x * dx + y * dy;
    c.y = ay + x * dy - y * dx;
  } else {
    c.x = ax + db;
    c.y = ay;
  }
}

function intersects(a, b) {
  var dx = b.x - a.x,
      dy = b.y - a.y,
      dr = a.r + b.r;
  return dr * dr - 1e-6 > dx * dx + dy * dy;
}

function score(node) {
  var a = node._,
      b = node.next._,
      ab = a.r + b.r,
      dx = (a.x * b.r + b.x * a.r) / ab,
      dy = (a.y * b.r + b.y * a.r) / ab;
  return dx * dx + dy * dy;
}

function Node(circle) {
  this._ = circle;
  this.next = null;
  this.previous = null;
}

function packEnclose(circles) {
  if (!(n = circles.length)) return 0;

  var a, b, c, n, aa, ca, i, j, k, sj, sk;

  // Place the first circle.
  a = circles[0], a.x = 0, a.y = 0;
  if (!(n > 1)) return a.r;

  // Place the second circle.
  b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
  if (!(n > 2)) return a.r + b.r;

  // Place the third circle.
  place(b, a, c = circles[2]);

  // Initialize the front-chain using the first three circles a, b and c.
  a = new Node(a), b = new Node(b), c = new Node(c);
  a.next = c.previous = b;
  b.next = a.previous = c;
  c.next = b.previous = a;

  // Attempt to place each remaining circle…
  pack: for (i = 3; i < n; ++i) {
    place(a._, b._, c = circles[i]), c = new Node(c);

    // Find the closest intersecting circle on the front-chain, if any.
    // “Closeness” is determined by linear distance along the front-chain.
    // “Ahead” or “behind” is likewise determined by linear distance.
    j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
    do {
      if (sj <= sk) {
        if (intersects(j._, c._)) {
          b = j, a.next = b, b.previous = a, --i;
          continue pack;
        }
        sj += j._.r, j = j.next;
      } else {
        if (intersects(k._, c._)) {
          a = k, a.next = b, b.previous = a, --i;
          continue pack;
        }
        sk += k._.r, k = k.previous;
      }
    } while (j !== k.next);

    // Success! Insert the new circle c between a and b.
    c.previous = a, c.next = b, a.next = b.previous = b = c;

    // Compute the new closest circle pair to the centroid.
    aa = score(a);
    while ((c = c.next) !== b) {
      if ((ca = score(c)) < aa) {
        a = c, aa = ca;
      }
    }
    b = a.next;
  }

  // Compute the enclosing circle of the front chain.
  a = [b._], c = b; while ((c = c.next) !== b) a.push(c._); c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__enclose__["a" /* default */])(a);

  // Translate the circles to put the enclosing circle around the origin.
  for (i = 0; i < n; ++i) a = circles[i], a.x -= c.x, a.y -= c.y;

  return c.r;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(circles) {
  packEnclose(circles);
  return circles;
});


/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node) {
  node.x0 = Math.round(node.x0);
  node.y0 = Math.round(node.y0);
  node.x1 = Math.round(node.x1);
  node.y1 = Math.round(node.y1);
});


/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(201);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(nb),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
});


/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(200);


/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  var n = values.length;
  return function(t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
        v0 = values[(i + n - 1) % n],
        v1 = values[i % n],
        v2 = values[(i + 1) % n],
        v3 = values[(i + 2) % n];
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__basis__["b" /* basis */])((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var d = new Date;
  return a = +a, b -= a, function(t) {
    return d.setTime(a + b * t), d;
  };
});


/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(201);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
});


/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export rgbBasis */
/* unused harmony export rgbBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basisClosed__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__color__ = __webpack_require__(95);





/* harmony default export */ __webpack_exports__["a"] = ((function rgbGamma(y) {
  var color = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__color__["c" /* gamma */])(y);

  function rgb(start, end) {
    var r = color((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* rgb */])(start)).r, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* rgb */])(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb.gamma = rgbGamma;

  return rgb;
})(1));

function rgbSpline(spline) {
  return function(colors) {
    var n = colors.length,
        r = new Array(n),
        g = new Array(n),
        b = new Array(n),
        i, color;
    for (i = 0; i < n; ++i) {
      color = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* rgb */])(colors[i]);
      r[i] = color.r || 0;
      g[i] = color.g || 0;
      b[i] = color.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color.opacity = 1;
    return function(t) {
      color.r = r(t);
      color.g = g(t);
      color.b = b(t);
      return color + "";
    };
  };
}

var rgbBasis = rgbSpline(__WEBPACK_IMPORTED_MODULE_1__basis__["a" /* default */]);
var rgbBasisClosed = rgbSpline(__WEBPACK_IMPORTED_MODULE_2__basisClosed__["a" /* default */]);


/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(130);


var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
});


/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(domain, interval) {
  domain = domain.slice();

  var i0 = 0,
      i1 = domain.length - 1,
      x0 = domain[i0],
      x1 = domain[i1],
      t;

  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }

  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
});


/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return +x;
});


/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export implicit */
/* harmony export (immutable) */ __webpack_exports__["a"] = ordinal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_collection__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(58);



var implicit = {name: "implicit"};

function ordinal(range) {
  var index = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["b" /* map */])(),
      domain = [],
      unknown = implicit;

  range = range == null ? [] : __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(range);

  function scale(d) {
    var key = d + "", i = index.get(key);
    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }
    return range[(i - 1) % range.length];
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["b" /* map */])();
    var i = -1, n = _.length, d, key;
    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
    return scale;
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), scale) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return ordinal()
        .domain(domain)
        .range(range)
        .unknown(unknown);
  };

  return scale;
}


/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = calendar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_time_format__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__array__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__continuous__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nice__ = __webpack_require__(354);








var durationSecond = 1000,
    durationMinute = durationSecond * 60,
    durationHour = durationMinute * 60,
    durationDay = durationHour * 24,
    durationWeek = durationDay * 7,
    durationMonth = durationDay * 30,
    durationYear = durationDay * 365;

function date(t) {
  return new Date(t);
}

function number(t) {
  return t instanceof Date ? +t : +new Date(+t);
}

function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__continuous__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__continuous__["b" /* deinterpolateLinear */], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["a" /* interpolateNumber */]),
      invert = scale.invert,
      domain = scale.domain;

  var formatMillisecond = format(".%L"),
      formatSecond = format(":%S"),
      formatMinute = format("%I:%M"),
      formatHour = format("%I %p"),
      formatDay = format("%a %d"),
      formatWeek = format("%b %d"),
      formatMonth = format("%B"),
      formatYear = format("%Y");

  var tickIntervals = [
    [second,  1,      durationSecond],
    [second,  5,  5 * durationSecond],
    [second, 15, 15 * durationSecond],
    [second, 30, 30 * durationSecond],
    [minute,  1,      durationMinute],
    [minute,  5,  5 * durationMinute],
    [minute, 15, 15 * durationMinute],
    [minute, 30, 30 * durationMinute],
    [  hour,  1,      durationHour  ],
    [  hour,  3,  3 * durationHour  ],
    [  hour,  6,  6 * durationHour  ],
    [  hour, 12, 12 * durationHour  ],
    [   day,  1,      durationDay   ],
    [   day,  2,  2 * durationDay   ],
    [  week,  1,      durationWeek  ],
    [ month,  1,      durationMonth ],
    [ month,  3,  3 * durationMonth ],
    [  year,  1,      durationYear  ]
  ];

  function tickFormat(date) {
    return (second(date) < date ? formatMillisecond
        : minute(date) < date ? formatSecond
        : hour(date) < date ? formatMinute
        : day(date) < date ? formatHour
        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
        : year(date) < date ? formatMonth
        : formatYear)(date);
  }

  function tickInterval(interval, start, stop, step) {
    if (interval == null) interval = 10;

    // If a desired tick count is specified, pick a reasonable tick interval
    // based on the extent of the domain and a rough estimate of tick size.
    // Otherwise, assume interval is already a time interval and use it.
    if (typeof interval === "number") {
      var target = Math.abs(stop - start) / interval,
          i = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["f" /* bisector */])(function(i) { return i[2]; }).right(tickIntervals, target);
      if (i === tickIntervals.length) {
        step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["e" /* tickStep */])(start / durationYear, stop / durationYear, interval);
        interval = year;
      } else if (i) {
        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        step = i[1];
        interval = i[0];
      } else {
        step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["e" /* tickStep */])(start, stop, interval);
        interval = millisecond;
      }
    }

    return step == null ? interval : interval.every(step);
  }

  scale.invert = function(y) {
    return new Date(invert(y));
  };

  scale.domain = function(_) {
    return arguments.length ? domain(__WEBPACK_IMPORTED_MODULE_4__array__["a" /* map */].call(_, number)) : domain().map(date);
  };

  scale.ticks = function(interval, step) {
    var d = domain(),
        t0 = d[0],
        t1 = d[d.length - 1],
        r = t1 < t0,
        t;
    if (r) t = t0, t0 = t1, t1 = t;
    t = tickInterval(interval, t0, t1, step);
    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
    return r ? t.reverse() : t;
  };

  scale.tickFormat = function(count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };

  scale.nice = function(interval, step) {
    var d = domain();
    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
        ? domain(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__nice__["a" /* default */])(d, interval))
        : scale;
  };

  scale.copy = function() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__continuous__["c" /* copy */])(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
  };

  return scale;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return calendar(__WEBPACK_IMPORTED_MODULE_2_d3_time__["j" /* timeYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["o" /* timeMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["p" /* timeWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["i" /* timeDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["q" /* timeHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["r" /* timeMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["s" /* timeSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["t" /* timeMillisecond */], __WEBPACK_IMPORTED_MODULE_3_d3_time_format__["b" /* timeFormat */]).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
});


/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curve_linear__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__line__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__point__ = __webpack_require__(206);






/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x0 = __WEBPACK_IMPORTED_MODULE_4__point__["a" /* x */],
      x1 = null,
      y0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(0),
      y1 = __WEBPACK_IMPORTED_MODULE_4__point__["b" /* y */],
      defined = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(true),
      context = null,
      curve = __WEBPACK_IMPORTED_MODULE_2__curve_linear__["a" /* default */],
      output = null;

  function area(data) {
    var i,
        j,
        k,
        n = data.length,
        d,
        defined0 = false,
        buffer,
        x0z = new Array(n),
        y0z = new Array(n);

    if (context == null) output = curve(buffer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k = i - 1; k >= j; --k) {
            output.point(x0z[k], y0z[k]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
      }
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  function arealine() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__line__["a" /* default */])().defined(defined).curve(curve).context(context);
  }

  area.x = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), x1 = null, area) : x0;
  };

  area.x0 = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : x0;
  };

  area.x1 = function(_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : x1;
  };

  area.y = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), y1 = null, area) : y0;
  };

  area.y0 = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : y0;
  };

  area.y1 = function(_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : y1;
  };

  area.lineX0 =
  area.lineY0 = function() {
    return arealine().x(x0).y(y0);
  };

  area.lineY1 = function() {
    return arealine().x(x0).y(y1);
  };

  area.lineX1 = function() {
    return arealine().x(x1).y(y0);
  };

  area.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(!!_), area) : defined;
  };

  area.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
  };

  area.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
  };

  return area;
});


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var slice = Array.prototype.slice;


/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CardinalClosed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardinal__ = __webpack_require__(134);



function CardinalClosed(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cardinal__["b" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["b"] = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalClosed(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CardinalOpen;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinal__ = __webpack_require__(134);


function CardinalOpen(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cardinal__["b" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["b"] = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalOpen(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return curveRadialLinear; });
/* harmony export (immutable) */ __webpack_exports__["a"] = curveRadial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(135);


var curveRadialLinear = curveRadial(__WEBPACK_IMPORTED_MODULE_0__linear__["a" /* default */]);

function Radial(curve) {
  this._curve = curve;
}

Radial.prototype = {
  areaStart: function() {
    this._curve.areaStart();
  },
  areaEnd: function() {
    this._curve.areaEnd();
  },
  lineStart: function() {
    this._curve.lineStart();
  },
  lineEnd: function() {
    this._curve.lineEnd();
  },
  point: function(a, r) {
    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
  }
};

function curveRadial(curve) {

  function radial(context) {
    return new Radial(curve(context));
  }

  radial._curve = curve;

  return radial;
}


/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lineRadial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curve_radial__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__line__ = __webpack_require__(204);



function lineRadial(l) {
  var c = l.curve;

  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;

  l.curve = function(_) {
    return arguments.length ? c(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["a" /* default */])(_)) : c()._curve;
  };

  return l;
}

/* harmony default export */ __webpack_exports__["b"] = (function() {
  return lineRadial(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__line__["a" /* default */])().curve(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["b" /* curveRadialLinear */]));
});


/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x, y) {
  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
});


/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(100);


/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / __WEBPACK_IMPORTED_MODULE_0__math__["b" /* pi */]);
    context.moveTo(r, 0);
    context.arc(0, 0, r, 0, __WEBPACK_IMPORTED_MODULE_0__math__["c" /* tau */]);
  }
});


/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / 5) / 2;
    context.moveTo(-3 * r, -r);
    context.lineTo(-r, -r);
    context.lineTo(-r, -3 * r);
    context.lineTo(r, -3 * r);
    context.lineTo(r, -r);
    context.lineTo(3 * r, -r);
    context.lineTo(3 * r, r);
    context.lineTo(r, r);
    context.lineTo(r, 3 * r);
    context.lineTo(-r, 3 * r);
    context.lineTo(-r, r);
    context.lineTo(-3 * r, r);
    context.closePath();
  }
});


/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var tan30 = Math.sqrt(1 / 3),
    tan30_2 = tan30 * 2;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var y = Math.sqrt(size / tan30_2),
        x = y * tan30;
    context.moveTo(0, -y);
    context.lineTo(x, 0);
    context.lineTo(0, y);
    context.lineTo(-x, 0);
    context.closePath();
  }
});


/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var w = Math.sqrt(size),
        x = -w / 2;
    context.rect(x, x, w, w);
  }
});


/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(100);


var ka = 0.89081309152928522810,
    kr = Math.sin(__WEBPACK_IMPORTED_MODULE_0__math__["b" /* pi */] / 10) / Math.sin(7 * __WEBPACK_IMPORTED_MODULE_0__math__["b" /* pi */] / 10),
    kx = Math.sin(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* tau */] / 10) * kr,
    ky = -Math.cos(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* tau */] / 10) * kr;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size * ka),
        x = kx * r,
        y = ky * r;
    context.moveTo(0, -r);
    context.lineTo(x, y);
    for (var i = 1; i < 5; ++i) {
      var a = __WEBPACK_IMPORTED_MODULE_0__math__["c" /* tau */] * i / 5,
          c = Math.cos(a),
          s = Math.sin(a);
      context.lineTo(s * r, -c * r);
      context.lineTo(c * x - s * y, s * x + c * y);
    }
    context.closePath();
  }
});


/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var sqrt3 = Math.sqrt(3);

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var y = -Math.sqrt(size / (sqrt3 * 3));
    context.moveTo(0, y * 2);
    context.lineTo(-sqrt3 * y, -y);
    context.lineTo(sqrt3 * y, -y);
    context.closePath();
  }
});


/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var c = -0.5,
    s = Math.sqrt(3) / 2,
    k = 1 / Math.sqrt(12),
    a = (k / 2 + 1) * 3;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / a),
        x0 = r / 2,
        y0 = r * k,
        x1 = x0,
        y1 = r * k + r,
        x2 = -x1,
        y2 = y1;
    context.moveTo(x0, y0);
    context.lineTo(x1, y1);
    context.lineTo(x2, y2);
    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
    context.closePath();
  }
});


/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__ = __webpack_require__(207);
/* unused harmony reexport timeFormatDefaultLocale */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["c"]; });
/* unused harmony reexport timeParse */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["a"]; });
/* unused harmony reexport utcParse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_locale__ = __webpack_require__(374);
/* unused harmony reexport timeFormatLocale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_isoFormat__ = __webpack_require__(373);
/* unused harmony reexport isoFormat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_isoParse__ = __webpack_require__(863);
/* unused harmony reexport isoParse */






/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isoSpecifier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultLocale__ = __webpack_require__(207);


var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";

function formatIsoNative(date) {
  return date.toISOString();
}

var formatIso = Date.prototype.toISOString
    ? formatIsoNative
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__defaultLocale__["a" /* utcFormat */])(isoSpecifier);

/* unused harmony default export */ var _unused_webpack_default_export = (formatIso);


/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatLocale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_time__ = __webpack_require__(208);


function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newYear(y) {
  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
}

function formatLocale(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe(locale_periods),
      periodLookup = formatLookup(locale_periods),
      weekdayRe = formatRe(locale_weekdays),
      weekdayLookup = formatLookup(locale_weekdays),
      shortWeekdayRe = formatRe(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
      monthRe = formatRe(locale_months),
      monthLookup = formatLookup(locale_months),
      shortMonthRe = formatRe(locale_shortMonths),
      shortMonthLookup = formatLookup(locale_shortMonths);

  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "S": formatSeconds,
    "U": formatWeekNumberSunday,
    "w": formatWeekdayNumber,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };

  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "S": formatUTCSeconds,
    "U": formatUTCWeekNumberSunday,
    "w": formatUTCWeekdayNumber,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };

  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "S": parseSeconds,
    "U": parseWeekNumberSunday,
    "w": parseWeekdayNumber,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function(date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
          else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, newDate) {
    return function(string) {
      var d = newYear(1900),
          i = parseSpecifier(d, specifier, string += "", 0);
      if (i != string.length) return null;

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "W" in d ? 1 : 0;
        var day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }

      // Otherwise, all fields are in local time.
      return newDate(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() { return specifier; };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", localDate);
      p.toString = function() { return specifier; };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() { return specifier; };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier, utcDate);
      p.toString = function() { return specifier; };
      return p;
    }
  };
}

var pads = {"-": "", "_": " ", "0": "0"},
    numberRe = /^\s*\d+/, // note: ignores next directive
    percentRe = /^%/,
    requoteRe = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;

function pad(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote(s) {
  return s.replace(requoteRe, "\\$&");
}

function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}

function formatLookup(names) {
  var map = {}, i = -1, n = names.length;
  while (++i < n) map[names[i].toLowerCase()] = i;
  return map;
}

function parseWeekdayNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?:\:?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function formatDayOfMonth(d, p) {
  return pad(d.getDate(), p, 2);
}

function formatHour24(d, p) {
  return pad(d.getHours(), p, 2);
}

function formatHour12(d, p) {
  return pad(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* timeDay */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["j" /* timeYear */])(d), d), p, 3);
}

function formatMilliseconds(d, p) {
  return pad(d.getMilliseconds(), p, 3);
}

function formatMonthNumber(d, p) {
  return pad(d.getMonth() + 1, p, 2);
}

function formatMinutes(d, p) {
  return pad(d.getMinutes(), p, 2);
}

function formatSeconds(d, p) {
  return pad(d.getSeconds(), p, 2);
}

function formatWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeSunday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["j" /* timeYear */])(d), d), p, 2);
}

function formatWeekdayNumber(d) {
  return d.getDay();
}

function formatWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["l" /* timeMonday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["j" /* timeYear */])(d), d), p, 2);
}

function formatYear(d, p) {
  return pad(d.getFullYear() % 100, p, 2);
}

function formatFullYear(d, p) {
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+"))
      + pad(z / 60 | 0, "0", 2)
      + pad(z % 60, "0", 2);
}

function formatUTCDayOfMonth(d, p) {
  return pad(d.getUTCDate(), p, 2);
}

function formatUTCHour24(d, p) {
  return pad(d.getUTCHours(), p, 2);
}

function formatUTCHour12(d, p) {
  return pad(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["d" /* utcDay */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* utcYear */])(d), d), p, 3);
}

function formatUTCMilliseconds(d, p) {
  return pad(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMonthNumber(d, p) {
  return pad(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes(d, p) {
  return pad(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds(d, p) {
  return pad(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["m" /* utcSunday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* utcYear */])(d), d), p, 2);
}

function formatUTCWeekdayNumber(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["n" /* utcMonday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* utcYear */])(d), d), p, 2);
}

function formatUTCYear(d, p) {
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear(d, p) {
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone() {
  return "+0000";
}

function formatLiteralPercent() {
  return "%";
}


/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_voronoi__ = __webpack_require__(881);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_voronoi__["a"]; });



/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createCell;
/* harmony export (immutable) */ __webpack_exports__["c"] = cellHalfedgeStart;
/* unused harmony export cellHalfedgeEnd */
/* harmony export (immutable) */ __webpack_exports__["a"] = sortCellHalfedges;
/* harmony export (immutable) */ __webpack_exports__["b"] = clipCells;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Edge__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Diagram__ = __webpack_require__(103);



function createCell(site) {
  return __WEBPACK_IMPORTED_MODULE_1__Diagram__["c" /* cells */][site.index] = {
    site: site,
    halfedges: []
  };
}

function cellHalfedgeAngle(cell, edge) {
  var site = cell.site,
      va = edge.left,
      vb = edge.right;
  if (site === vb) vb = va, va = site;
  if (vb) return Math.atan2(vb[1] - va[1], vb[0] - va[0]);
  if (site === va) va = edge[1], vb = edge[0];
  else va = edge[0], vb = edge[1];
  return Math.atan2(va[0] - vb[0], vb[1] - va[1]);
}

function cellHalfedgeStart(cell, edge) {
  return edge[+(edge.left !== cell.site)];
}

function cellHalfedgeEnd(cell, edge) {
  return edge[+(edge.left === cell.site)];
}

function sortCellHalfedges() {
  for (var i = 0, n = __WEBPACK_IMPORTED_MODULE_1__Diagram__["c" /* cells */].length, cell, halfedges, j, m; i < n; ++i) {
    if ((cell = __WEBPACK_IMPORTED_MODULE_1__Diagram__["c" /* cells */][i]) && (m = (halfedges = cell.halfedges).length)) {
      var index = new Array(m),
          array = new Array(m);
      for (j = 0; j < m; ++j) index[j] = j, array[j] = cellHalfedgeAngle(cell, __WEBPACK_IMPORTED_MODULE_1__Diagram__["d" /* edges */][halfedges[j]]);
      index.sort(function(i, j) { return array[j] - array[i]; });
      for (j = 0; j < m; ++j) array[j] = halfedges[index[j]];
      for (j = 0; j < m; ++j) halfedges[j] = array[j];
    }
  }
}

function clipCells(x0, y0, x1, y1) {
  var nCells = __WEBPACK_IMPORTED_MODULE_1__Diagram__["c" /* cells */].length,
      iCell,
      cell,
      site,
      iHalfedge,
      halfedges,
      nHalfedges,
      start,
      startX,
      startY,
      end,
      endX,
      endY,
      cover = true;

  for (iCell = 0; iCell < nCells; ++iCell) {
    if (cell = __WEBPACK_IMPORTED_MODULE_1__Diagram__["c" /* cells */][iCell]) {
      site = cell.site;
      halfedges = cell.halfedges;
      iHalfedge = halfedges.length;

      // Remove any dangling clipped edges.
      while (iHalfedge--) {
        if (!__WEBPACK_IMPORTED_MODULE_1__Diagram__["d" /* edges */][halfedges[iHalfedge]]) {
          halfedges.splice(iHalfedge, 1);
        }
      }

      // Insert any border edges as necessary.
      iHalfedge = 0, nHalfedges = halfedges.length;
      while (iHalfedge < nHalfedges) {
        end = cellHalfedgeEnd(cell, __WEBPACK_IMPORTED_MODULE_1__Diagram__["d" /* edges */][halfedges[iHalfedge]]), endX = end[0], endY = end[1];
        start = cellHalfedgeStart(cell, __WEBPACK_IMPORTED_MODULE_1__Diagram__["d" /* edges */][halfedges[++iHalfedge % nHalfedges]]), startX = start[0], startY = start[1];
        if (Math.abs(endX - startX) > __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* epsilon */] || Math.abs(endY - startY) > __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* epsilon */]) {
          halfedges.splice(iHalfedge, 0, __WEBPACK_IMPORTED_MODULE_1__Diagram__["d" /* edges */].push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site, end,
              Math.abs(endX - x0) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* epsilon */] && y1 - endY > __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* epsilon */] ? [x0, Math.abs(startX - x0) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* epsilon */] ? startY : y1]
              : Math.abs(endY - y1) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* epsilon */] && x1 - endX > __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* epsilon */] ? [Math.abs(startY - y1) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* epsilon */] ? startX : x1, y1]
              : Math.abs(endX - x1) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* epsilon */] && endY - y0 > __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* epsilon */] ? [x1, Math.abs(startX - x1) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* epsilon */] ? startY : y0]
              : Math.abs(endY - y0) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* epsilon */] && endX - x0 > __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* epsilon */] ? [Math.abs(startY - y0) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* epsilon */] ? startX : x0, y0]
              : null)) - 1);
          ++nHalfedges;
        }
      }

      if (nHalfedges) cover = false;
    }
  }

  // If there weren’t any edges, have the closest site cover the extent.
  // It doesn’t matter which corner of the extent we measure!
  if (cover) {
    var dx, dy, d2, dc = Infinity;

    for (iCell = 0, cover = null; iCell < nCells; ++iCell) {
      if (cell = __WEBPACK_IMPORTED_MODULE_1__Diagram__["c" /* cells */][iCell]) {
        site = cell.site;
        dx = site[0] - x0;
        dy = site[1] - y0;
        d2 = dx * dx + dy * dy;
        if (d2 < dc) dc = d2, cover = cell;
      }
    }

    if (cover) {
      var v00 = [x0, y0], v01 = [x0, y1], v11 = [x1, y1], v10 = [x1, y0];
      cover.halfedges.push(
        __WEBPACK_IMPORTED_MODULE_1__Diagram__["d" /* edges */].push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site = cover.site, v00, v01)) - 1,
        __WEBPACK_IMPORTED_MODULE_1__Diagram__["d" /* edges */].push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site, v01, v11)) - 1,
        __WEBPACK_IMPORTED_MODULE_1__Diagram__["d" /* edges */].push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site, v11, v10)) - 1,
        __WEBPACK_IMPORTED_MODULE_1__Diagram__["d" /* edges */].push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site, v10, v00)) - 1
      );
    }
  }

  // Lastly delete any cells with no edges; these were entirely clipped.
  for (iCell = 0; iCell < nCells; ++iCell) {
    if (cell = __WEBPACK_IMPORTED_MODULE_1__Diagram__["c" /* cells */][iCell]) {
      if (!cell.halfedges.length) {
        delete __WEBPACK_IMPORTED_MODULE_1__Diagram__["c" /* cells */][iCell];
      }
    }
  }
}


/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return firstCircle; });
/* harmony export (immutable) */ __webpack_exports__["c"] = attachCircle;
/* harmony export (immutable) */ __webpack_exports__["b"] = detachCircle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RedBlackTree__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Diagram__ = __webpack_require__(103);



var circlePool = [];

var firstCircle;

function Circle() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__RedBlackTree__["b" /* RedBlackNode */])(this);
  this.x =
  this.y =
  this.arc =
  this.site =
  this.cy = null;
}

function attachCircle(arc) {
  var lArc = arc.P,
      rArc = arc.N;

  if (!lArc || !rArc) return;

  var lSite = lArc.site,
      cSite = arc.site,
      rSite = rArc.site;

  if (lSite === rSite) return;

  var bx = cSite[0],
      by = cSite[1],
      ax = lSite[0] - bx,
      ay = lSite[1] - by,
      cx = rSite[0] - bx,
      cy = rSite[1] - by;

  var d = 2 * (ax * cy - ay * cx);
  if (d >= -__WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon2 */]) return;

  var ha = ax * ax + ay * ay,
      hc = cx * cx + cy * cy,
      x = (cy * ha - ay * hc) / d,
      y = (ax * hc - cx * ha) / d;

  var circle = circlePool.pop() || new Circle;
  circle.arc = arc;
  circle.site = cSite;
  circle.x = x + bx;
  circle.y = (circle.cy = y + by) + Math.sqrt(x * x + y * y); // y bottom

  arc.circle = circle;

  var before = null,
      node = __WEBPACK_IMPORTED_MODULE_1__Diagram__["g" /* circles */]._;

  while (node) {
    if (circle.y < node.y || (circle.y === node.y && circle.x <= node.x)) {
      if (node.L) node = node.L;
      else { before = node.P; break; }
    } else {
      if (node.R) node = node.R;
      else { before = node; break; }
    }
  }

  __WEBPACK_IMPORTED_MODULE_1__Diagram__["g" /* circles */].insert(before, circle);
  if (!before) firstCircle = circle;
}

function detachCircle(arc) {
  var circle = arc.circle;
  if (circle) {
    if (!circle.P) firstCircle = circle.N;
    __WEBPACK_IMPORTED_MODULE_1__Diagram__["g" /* circles */].remove(circle);
    circlePool.push(circle);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__RedBlackTree__["b" /* RedBlackNode */])(circle);
    arc.circle = null;
  }
}


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = undefined;

var _inDOM = __webpack_require__(137);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transform = 'transform';
var prefix = void 0,
    transitionEnd = void 0,
    animationEnd = void 0;
var transitionProperty = void 0,
    transitionDuration = void 0,
    transitionTiming = void 0,
    transitionDelay = void 0;
var animationName = void 0,
    animationDuration = void 0,
    animationTiming = void 0,
    animationDelay = void 0;

if (_inDOM2.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;


  exports.transform = transform = prefix + '-' + transform;
  exports.transitionProperty = transitionProperty = prefix + '-transition-property';
  exports.transitionDuration = transitionDuration = prefix + '-transition-duration';
  exports.transitionDelay = transitionDelay = prefix + '-transition-delay';
  exports.transitionTiming = transitionTiming = prefix + '-transition-timing-function';

  exports.animationName = animationName = prefix + '-animation-name';
  exports.animationDuration = animationDuration = prefix + '-animation-duration';
  exports.animationTiming = animationTiming = prefix + '-animation-delay';
  exports.animationDelay = animationDelay = prefix + '-animation-timing-function';
}

exports.transform = transform;
exports.transitionProperty = transitionProperty;
exports.transitionTiming = transitionTiming;
exports.transitionDelay = transitionDelay;
exports.transitionDuration = transitionDuration;
exports.transitionEnd = transitionEnd;
exports.animationName = animationName;
exports.animationDuration = animationDuration;
exports.animationTiming = animationTiming;
exports.animationDelay = animationDelay;
exports.animationEnd = animationEnd;
exports.default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};


function getTransitionProperties() {
  var style = document.createElement('div').style;

  var vendorMap = {
    O: function O(e) {
      return 'o' + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return 'webkit' + e;
    },
    ms: function ms(e) {
      return 'MS' + e;
    }
  };

  var vendors = Object.keys(vendorMap);

  var transitionEnd = void 0,
      animationEnd = void 0;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + 'TransitionProperty' in style) {
      prefix = '-' + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';

  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';

  style = null;

  return { animationEnd: animationEnd, transitionEnd: transitionEnd, prefix: prefix };
}

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(30);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(33);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(75);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(212);

var _PathUtils = __webpack_require__(104);

var _createTransitionManager = __webpack_require__(213);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(382);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    if (basename) path = (0, _PathUtils.stripPrefix)(path, basename);

    return _extends({}, (0, _PathUtils.parsePath)(path), {
      state: state,
      key: key
    });
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @author Titus Wormer
 * @copyright 2016 Titus Wormer
 * @license MIT
 * @module iso-639-3
 * @fileoverview ISO-639-3 codes in an accessible format.
 */



/* eslint-env commonjs */

/*
 * Expose.
 */

module.exports = __webpack_require__(907);


/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(916);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(138),
    stackClear = __webpack_require__(1002),
    stackDelete = __webpack_require__(1003),
    stackGet = __webpack_require__(1004),
    stackHas = __webpack_require__(1005),
    stackSet = __webpack_require__(1006);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 388 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 389 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 390 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(392),
    eq = __webpack_require__(143);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(395);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(394),
    toKey = __webpack_require__(142);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(34),
    isKey = __webpack_require__(219),
    stringToPath = __webpack_require__(1008),
    toString = __webpack_require__(225);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(60);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(922),
    arraySome = __webpack_require__(927),
    cacheHas = __webpack_require__(954);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)))

/***/ }),
/* 398 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 399 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(145);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 401 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 402 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(391),
    copyObject = __webpack_require__(956),
    createAssigner = __webpack_require__(958),
    isArrayLike = __webpack_require__(144),
    isPrototype = __webpack_require__(399),
    keys = __webpack_require__(108);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(225),
    upperFirst = __webpack_require__(1019);

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}

module.exports = capitalize;


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(43),
    stubFalse = __webpack_require__(1018);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(163)(module)))

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(106),
    isObject = __webpack_require__(145);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(940),
    baseUnary = __webpack_require__(952),
    nodeUtil = __webpack_require__(993);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(388),
    baseFilter = __webpack_require__(930),
    baseIteratee = __webpack_require__(941),
    isArray = __webpack_require__(34),
    negate = __webpack_require__(1015);

/**
 * The opposite of `_.filter`; this method returns the elements of `collection`
 * that `predicate` does **not** return truthy for.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.filter
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': true }
 * ];
 *
 * _.reject(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.reject(users, { 'age': 40, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.reject(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.reject(users, 'active');
 * // => objects for ['barney']
 */
function reject(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, negate(baseIteratee(predicate, 3)));
}

module.exports = reject;


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var af = moment.defineLocale('af', {
    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
    meridiemParse: /vm|nm/i,
    isPM : function (input) {
        return /^nm$/i.test(input);
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower ? 'vm' : 'VM';
        } else {
            return isLower ? 'nm' : 'NM';
        }
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Vandag om] LT',
        nextDay : '[Môre om] LT',
        nextWeek : 'dddd [om] LT',
        lastDay : '[Gister om] LT',
        lastWeek : '[Laas] dddd [om] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'oor %s',
        past : '%s gelede',
        s : '\'n paar sekondes',
        ss : '%d sekondes',
        m : '\'n minuut',
        mm : '%d minute',
        h : '\'n uur',
        hh : '%d ure',
        d : '\'n dag',
        dd : '%d dae',
        M : '\'n maand',
        MM : '%d maande',
        y : '\'n jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
    },
    week : {
        dow : 1, // Maandag is die eerste dag van die week.
        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
    }
});

return af;

})));


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Algeria) [ar-dz]
//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arDz = moment.defineLocale('ar-dz', {
    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        ss : '%d ثانية',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 4  // The week that contains Jan 1st is the first week of the year.
    }
});

return arDz;

})));


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Kuwait) [ar-kw]
//! author : Nusret Parlak: https://github.com/nusretparlak

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arKw = moment.defineLocale('ar-kw', {
    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        ss : '%d ثانية',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arKw;

})));


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Lybia) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
    '0': '0'
};
var pluralForm = function (n) {
    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
};
var plurals = {
    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
};
var pluralize = function (u) {
    return function (number, withoutSuffix, string, isFuture) {
        var f = pluralForm(number),
            str = plurals[u][pluralForm(number)];
        if (f === 2) {
            str = str[withoutSuffix ? 0 : 1];
        }
        return str.replace(/%d/i, number);
    };
};
var months = [
    'يناير',
    'فبراير',
    'مارس',
    'أبريل',
    'مايو',
    'يونيو',
    'يوليو',
    'أغسطس',
    'سبتمبر',
    'أكتوبر',
    'نوفمبر',
    'ديسمبر'
];

var arLy = moment.defineLocale('ar-ly', {
    months : months,
    monthsShort : months,
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/\u200FM/\u200FYYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم عند الساعة] LT',
        nextDay: '[غدًا عند الساعة] LT',
        nextWeek: 'dddd [عند الساعة] LT',
        lastDay: '[أمس عند الساعة] LT',
        lastWeek: 'dddd [عند الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'بعد %s',
        past : 'منذ %s',
        s : pluralize('s'),
        ss : pluralize('s'),
        m : pluralize('m'),
        mm : pluralize('m'),
        h : pluralize('h'),
        hh : pluralize('h'),
        d : pluralize('d'),
        dd : pluralize('d'),
        M : pluralize('M'),
        MM : pluralize('M'),
        y : pluralize('y'),
        yy : pluralize('y')
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arLy;

})));


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arMa = moment.defineLocale('ar-ma', {
    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        ss : '%d ثانية',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arMa;

})));


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '١',
    '2': '٢',
    '3': '٣',
    '4': '٤',
    '5': '٥',
    '6': '٦',
    '7': '٧',
    '8': '٨',
    '9': '٩',
    '0': '٠'
};
var numberMap = {
    '١': '1',
    '٢': '2',
    '٣': '3',
    '٤': '4',
    '٥': '5',
    '٦': '6',
    '٧': '7',
    '٨': '8',
    '٩': '9',
    '٠': '0'
};

var arSa = moment.defineLocale('ar-sa', {
    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        ss : '%d ثانية',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    preparse: function (string) {
        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return arSa;

})));


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arTn = moment.defineLocale('ar-tn', {
    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'في %s',
        past: 'منذ %s',
        s: 'ثوان',
        ss : '%d ثانية',
        m: 'دقيقة',
        mm: '%d دقائق',
        h: 'ساعة',
        hh: '%d ساعات',
        d: 'يوم',
        dd: '%d أيام',
        M: 'شهر',
        MM: '%d أشهر',
        y: 'سنة',
        yy: '%d سنوات'
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return arTn;

})));


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '١',
    '2': '٢',
    '3': '٣',
    '4': '٤',
    '5': '٥',
    '6': '٦',
    '7': '٧',
    '8': '٨',
    '9': '٩',
    '0': '٠'
};
var numberMap = {
    '١': '1',
    '٢': '2',
    '٣': '3',
    '٤': '4',
    '٥': '5',
    '٦': '6',
    '٧': '7',
    '٨': '8',
    '٩': '9',
    '٠': '0'
};
var pluralForm = function (n) {
    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
};
var plurals = {
    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
};
var pluralize = function (u) {
    return function (number, withoutSuffix, string, isFuture) {
        var f = pluralForm(number),
            str = plurals[u][pluralForm(number)];
        if (f === 2) {
            str = str[withoutSuffix ? 0 : 1];
        }
        return str.replace(/%d/i, number);
    };
};
var months = [
    'يناير',
    'فبراير',
    'مارس',
    'أبريل',
    'مايو',
    'يونيو',
    'يوليو',
    'أغسطس',
    'سبتمبر',
    'أكتوبر',
    'نوفمبر',
    'ديسمبر'
];

var ar = moment.defineLocale('ar', {
    months : months,
    monthsShort : months,
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/\u200FM/\u200FYYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم عند الساعة] LT',
        nextDay: '[غدًا عند الساعة] LT',
        nextWeek: 'dddd [عند الساعة] LT',
        lastDay: '[أمس عند الساعة] LT',
        lastWeek: 'dddd [عند الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'بعد %s',
        past : 'منذ %s',
        s : pluralize('s'),
        ss : pluralize('s'),
        m : pluralize('m'),
        mm : pluralize('m'),
        h : pluralize('h'),
        hh : pluralize('h'),
        d : pluralize('d'),
        dd : pluralize('d'),
        M : pluralize('M'),
        MM : pluralize('M'),
        y : pluralize('y'),
        yy : pluralize('y')
    },
    preparse: function (string) {
        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return ar;

})));


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    1: '-inci',
    5: '-inci',
    8: '-inci',
    70: '-inci',
    80: '-inci',
    2: '-nci',
    7: '-nci',
    20: '-nci',
    50: '-nci',
    3: '-üncü',
    4: '-üncü',
    100: '-üncü',
    6: '-ncı',
    9: '-uncu',
    10: '-uncu',
    30: '-uncu',
    60: '-ıncı',
    90: '-ıncı'
};

var az = moment.defineLocale('az', {
    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[bugün saat] LT',
        nextDay : '[sabah saat] LT',
        nextWeek : '[gələn həftə] dddd [saat] LT',
        lastDay : '[dünən] LT',
        lastWeek : '[keçən həftə] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s sonra',
        past : '%s əvvəl',
        s : 'birneçə saniyyə',
        ss : '%d saniyə',
        m : 'bir dəqiqə',
        mm : '%d dəqiqə',
        h : 'bir saat',
        hh : '%d saat',
        d : 'bir gün',
        dd : '%d gün',
        M : 'bir ay',
        MM : '%d ay',
        y : 'bir il',
        yy : '%d il'
    },
    meridiemParse: /gecə|səhər|gündüz|axşam/,
    isPM : function (input) {
        return /^(gündüz|axşam)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'gecə';
        } else if (hour < 12) {
            return 'səhər';
        } else if (hour < 17) {
            return 'gündüz';
        } else {
            return 'axşam';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
    ordinal : function (number) {
        if (number === 0) {  // special case for zero
            return number + '-ıncı';
        }
        var a = number % 10,
            b = number % 100 - a,
            c = number >= 100 ? 100 : null;
        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return az;

})));


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
        'dd': 'дзень_дні_дзён',
        'MM': 'месяц_месяцы_месяцаў',
        'yy': 'год_гады_гадоў'
    };
    if (key === 'm') {
        return withoutSuffix ? 'хвіліна' : 'хвіліну';
    }
    else if (key === 'h') {
        return withoutSuffix ? 'гадзіна' : 'гадзіну';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}

var be = moment.defineLocale('be', {
    months : {
        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
    },
    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
    weekdays : {
        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
    },
    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY г.',
        LLL : 'D MMMM YYYY г., HH:mm',
        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
    },
    calendar : {
        sameDay: '[Сёння ў] LT',
        nextDay: '[Заўтра ў] LT',
        lastDay: '[Учора ў] LT',
        nextWeek: function () {
            return '[У] dddd [ў] LT';
        },
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 5:
                case 6:
                    return '[У мінулую] dddd [ў] LT';
                case 1:
                case 2:
                case 4:
                    return '[У мінулы] dddd [ў] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'праз %s',
        past : '%s таму',
        s : 'некалькі секунд',
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : relativeTimeWithPlural,
        hh : relativeTimeWithPlural,
        d : 'дзень',
        dd : relativeTimeWithPlural,
        M : 'месяц',
        MM : relativeTimeWithPlural,
        y : 'год',
        yy : relativeTimeWithPlural
    },
    meridiemParse: /ночы|раніцы|дня|вечара/,
    isPM : function (input) {
        return /^(дня|вечара)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночы';
        } else if (hour < 12) {
            return 'раніцы';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечара';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
            case 'w':
            case 'W':
                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
            case 'D':
                return number + '-га';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return be;

})));


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var bg = moment.defineLocale('bg', {
    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'D.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay : '[Днес в] LT',
        nextDay : '[Утре в] LT',
        nextWeek : 'dddd [в] LT',
        lastDay : '[Вчера в] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 6:
                    return '[В изминалата] dddd [в] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[В изминалия] dddd [в] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'след %s',
        past : 'преди %s',
        s : 'няколко секунди',
        ss : '%d секунди',
        m : 'минута',
        mm : '%d минути',
        h : 'час',
        hh : '%d часа',
        d : 'ден',
        dd : '%d дни',
        M : 'месец',
        MM : '%d месеца',
        y : 'година',
        yy : '%d години'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
    ordinal : function (number) {
        var lastDigit = number % 10,
            last2Digits = number % 100;
        if (number === 0) {
            return number + '-ев';
        } else if (last2Digits === 0) {
            return number + '-ен';
        } else if (last2Digits > 10 && last2Digits < 20) {
            return number + '-ти';
        } else if (lastDigit === 1) {
            return number + '-ви';
        } else if (lastDigit === 2) {
            return number + '-ри';
        } else if (lastDigit === 7 || lastDigit === 8) {
            return number + '-ми';
        } else {
            return number + '-ти';
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return bg;

})));


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bambara [bm]
//! author : Estelle Comment : https://github.com/estellecomment

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

// Language contact person : Abdoufata Kane : https://github.com/abdoufata

var bm = moment.defineLocale('bm', {
    months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
    monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
    weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
    weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
    weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'MMMM [tile] D [san] YYYY',
        LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
        LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
    },
    calendar : {
        sameDay : '[Bi lɛrɛ] LT',
        nextDay : '[Sini lɛrɛ] LT',
        nextWeek : 'dddd [don lɛrɛ] LT',
        lastDay : '[Kunu lɛrɛ] LT',
        lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s kɔnɔ',
        past : 'a bɛ %s bɔ',
        s : 'sanga dama dama',
        ss : 'sekondi %d',
        m : 'miniti kelen',
        mm : 'miniti %d',
        h : 'lɛrɛ kelen',
        hh : 'lɛrɛ %d',
        d : 'tile kelen',
        dd : 'tile %d',
        M : 'kalo kelen',
        MM : 'kalo %d',
        y : 'san kelen',
        yy : 'san %d'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return bm;

})));


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '১',
    '2': '২',
    '3': '৩',
    '4': '৪',
    '5': '৫',
    '6': '৬',
    '7': '৭',
    '8': '৮',
    '9': '৯',
    '0': '০'
};
var numberMap = {
    '১': '1',
    '২': '2',
    '৩': '3',
    '৪': '4',
    '৫': '5',
    '৬': '6',
    '৭': '7',
    '৮': '8',
    '৯': '9',
    '০': '0'
};

var bn = moment.defineLocale('bn', {
    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
    longDateFormat : {
        LT : 'A h:mm সময়',
        LTS : 'A h:mm:ss সময়',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm সময়',
        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
    },
    calendar : {
        sameDay : '[আজ] LT',
        nextDay : '[আগামীকাল] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[গতকাল] LT',
        lastWeek : '[গত] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s পরে',
        past : '%s আগে',
        s : 'কয়েক সেকেন্ড',
        ss : '%d সেকেন্ড',
        m : 'এক মিনিট',
        mm : '%d মিনিট',
        h : 'এক ঘন্টা',
        hh : '%d ঘন্টা',
        d : 'এক দিন',
        dd : '%d দিন',
        M : 'এক মাস',
        MM : '%d মাস',
        y : 'এক বছর',
        yy : '%d বছর'
    },
    preparse: function (string) {
        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'রাত' && hour >= 4) ||
                (meridiem === 'দুপুর' && hour < 5) ||
                meridiem === 'বিকাল') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'রাত';
        } else if (hour < 10) {
            return 'সকাল';
        } else if (hour < 17) {
            return 'দুপুর';
        } else if (hour < 20) {
            return 'বিকাল';
        } else {
            return 'রাত';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return bn;

})));


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '༡',
    '2': '༢',
    '3': '༣',
    '4': '༤',
    '5': '༥',
    '6': '༦',
    '7': '༧',
    '8': '༨',
    '9': '༩',
    '0': '༠'
};
var numberMap = {
    '༡': '1',
    '༢': '2',
    '༣': '3',
    '༤': '4',
    '༥': '5',
    '༦': '6',
    '༧': '7',
    '༨': '8',
    '༩': '9',
    '༠': '0'
};

var bo = moment.defineLocale('bo', {
    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[དི་རིང] LT',
        nextDay : '[སང་ཉིན] LT',
        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
        lastDay : '[ཁ་སང] LT',
        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ལ་',
        past : '%s སྔན་ལ',
        s : 'ལམ་སང',
        ss : '%d སྐར་ཆ།',
        m : 'སྐར་མ་གཅིག',
        mm : '%d སྐར་མ',
        h : 'ཆུ་ཚོད་གཅིག',
        hh : '%d ཆུ་ཚོད',
        d : 'ཉིན་གཅིག',
        dd : '%d ཉིན་',
        M : 'ཟླ་བ་གཅིག',
        MM : '%d ཟླ་བ',
        y : 'ལོ་གཅིག',
        yy : '%d ལོ'
    },
    preparse: function (string) {
        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
                (meridiem === 'ཉིན་གུང' && hour < 5) ||
                meridiem === 'དགོང་དག') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'མཚན་མོ';
        } else if (hour < 10) {
            return 'ཞོགས་ཀས';
        } else if (hour < 17) {
            return 'ཉིན་གུང';
        } else if (hour < 20) {
            return 'དགོང་དག';
        } else {
            return 'མཚན་མོ';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return bo;

})));


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function relativeTimeWithMutation(number, withoutSuffix, key) {
    var format = {
        'mm': 'munutenn',
        'MM': 'miz',
        'dd': 'devezh'
    };
    return number + ' ' + mutation(format[key], number);
}
function specialMutationForYears(number) {
    switch (lastNumber(number)) {
        case 1:
        case 3:
        case 4:
        case 5:
        case 9:
            return number + ' bloaz';
        default:
            return number + ' vloaz';
    }
}
function lastNumber(number) {
    if (number > 9) {
        return lastNumber(number % 10);
    }
    return number;
}
function mutation(text, number) {
    if (number === 2) {
        return softMutation(text);
    }
    return text;
}
function softMutation(text) {
    var mutationTable = {
        'm': 'v',
        'b': 'v',
        'd': 'z'
    };
    if (mutationTable[text.charAt(0)] === undefined) {
        return text;
    }
    return mutationTable[text.charAt(0)] + text.substring(1);
}

var br = moment.defineLocale('br', {
    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h[e]mm A',
        LTS : 'h[e]mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D [a viz] MMMM YYYY',
        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
    },
    calendar : {
        sameDay : '[Hiziv da] LT',
        nextDay : '[Warc\'hoazh da] LT',
        nextWeek : 'dddd [da] LT',
        lastDay : '[Dec\'h da] LT',
        lastWeek : 'dddd [paset da] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'a-benn %s',
        past : '%s \'zo',
        s : 'un nebeud segondennoù',
        ss : '%d eilenn',
        m : 'ur vunutenn',
        mm : relativeTimeWithMutation,
        h : 'un eur',
        hh : '%d eur',
        d : 'un devezh',
        dd : relativeTimeWithMutation,
        M : 'ur miz',
        MM : relativeTimeWithMutation,
        y : 'ur bloaz',
        yy : specialMutationForYears
    },
    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
    ordinal : function (number) {
        var output = (number === 1) ? 'añ' : 'vet';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return br;

})));


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! based on (hr) translation by Bojan Marković

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'ss':
            if (number === 1) {
                result += 'sekunda';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sekunde';
            } else {
                result += 'sekundi';
            }
            return result;
        case 'm':
            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
        case 'mm':
            if (number === 1) {
                result += 'minuta';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'minute';
            } else {
                result += 'minuta';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'jedan sat' : 'jednog sata';
        case 'hh':
            if (number === 1) {
                result += 'sat';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sata';
            } else {
                result += 'sati';
            }
            return result;
        case 'dd':
            if (number === 1) {
                result += 'dan';
            } else {
                result += 'dana';
            }
            return result;
        case 'MM':
            if (number === 1) {
                result += 'mjesec';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'mjeseca';
            } else {
                result += 'mjeseci';
            }
            return result;
        case 'yy':
            if (number === 1) {
                result += 'godina';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'godine';
            } else {
                result += 'godina';
            }
            return result;
    }
}

var bs = moment.defineLocale('bs', {
    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danas u] LT',
        nextDay  : '[sutra u] LT',
        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[jučer u] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                    return '[prošlu] dddd [u] LT';
                case 6:
                    return '[prošle] [subote] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prošli] dddd [u] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'par sekundi',
        ss     : translate,
        m      : translate,
        mm     : translate,
        h      : translate,
        hh     : translate,
        d      : 'dan',
        dd     : translate,
        M      : 'mjesec',
        MM     : translate,
        y      : 'godinu',
        yy     : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return bs;

})));


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ca = moment.defineLocale('ca', {
    months : {
        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
        isFormat: /D[oD]?(\s)+MMMM/
    },
    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
    monthsParseExact : true,
    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
    weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM [de] YYYY',
        ll : 'D MMM YYYY',
        LLL : 'D MMMM [de] YYYY [a les] H:mm',
        lll : 'D MMM YYYY, H:mm',
        LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
        llll : 'ddd D MMM YYYY, H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        nextDay : function () {
            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        lastDay : function () {
            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'd\'aquí %s',
        past : 'fa %s',
        s : 'uns segons',
        ss : '%d segons',
        m : 'un minut',
        mm : '%d minuts',
        h : 'una hora',
        hh : '%d hores',
        d : 'un dia',
        dd : '%d dies',
        M : 'un mes',
        MM : '%d mesos',
        y : 'un any',
        yy : '%d anys'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
    ordinal : function (number, period) {
        var output = (number === 1) ? 'r' :
            (number === 2) ? 'n' :
            (number === 3) ? 'r' :
            (number === 4) ? 't' : 'è';
        if (period === 'w' || period === 'W') {
            output = 'a';
        }
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ca;

})));


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
function plural(n) {
    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':  // a few seconds / in a few seconds / a few seconds ago
            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
        case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'sekundy' : 'sekund');
            } else {
                return result + 'sekundami';
            }
            break;
        case 'm':  // a minute / in a minute / a minute ago
            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'minuty' : 'minut');
            } else {
                return result + 'minutami';
            }
            break;
        case 'h':  // an hour / in an hour / an hour ago
            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
        case 'hh': // 9 hours / in 9 hours / 9 hours ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'hodiny' : 'hodin');
            } else {
                return result + 'hodinami';
            }
            break;
        case 'd':  // a day / in a day / a day ago
            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
        case 'dd': // 9 days / in 9 days / 9 days ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'dny' : 'dní');
            } else {
                return result + 'dny';
            }
            break;
        case 'M':  // a month / in a month / a month ago
            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
        case 'MM': // 9 months / in 9 months / 9 months ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'měsíce' : 'měsíců');
            } else {
                return result + 'měsíci';
            }
            break;
        case 'y':  // a year / in a year / a year ago
            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
        case 'yy': // 9 years / in 9 years / 9 years ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'roky' : 'let');
            } else {
                return result + 'lety';
            }
            break;
    }
}

var cs = moment.defineLocale('cs', {
    months : months,
    monthsShort : monthsShort,
    monthsParse : (function (months, monthsShort) {
        var i, _monthsParse = [];
        for (i = 0; i < 12; i++) {
            // use custom parser to solve problem with July (červenec)
            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
        }
        return _monthsParse;
    }(months, monthsShort)),
    shortMonthsParse : (function (monthsShort) {
        var i, _shortMonthsParse = [];
        for (i = 0; i < 12; i++) {
            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
        }
        return _shortMonthsParse;
    }(monthsShort)),
    longMonthsParse : (function (months) {
        var i, _longMonthsParse = [];
        for (i = 0; i < 12; i++) {
            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
        }
        return _longMonthsParse;
    }(months)),
    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
    longDateFormat : {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd D. MMMM YYYY H:mm',
        l : 'D. M. YYYY'
    },
    calendar : {
        sameDay: '[dnes v] LT',
        nextDay: '[zítra v] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[v neděli v] LT';
                case 1:
                case 2:
                    return '[v] dddd [v] LT';
                case 3:
                    return '[ve středu v] LT';
                case 4:
                    return '[ve čtvrtek v] LT';
                case 5:
                    return '[v pátek v] LT';
                case 6:
                    return '[v sobotu v] LT';
            }
        },
        lastDay: '[včera v] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[minulou neděli v] LT';
                case 1:
                case 2:
                    return '[minulé] dddd [v] LT';
                case 3:
                    return '[minulou středu v] LT';
                case 4:
                case 5:
                    return '[minulý] dddd [v] LT';
                case 6:
                    return '[minulou sobotu v] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : 'před %s',
        s : translate,
        ss : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse : /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return cs;

})));


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var cv = moment.defineLocale('cv', {
    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
    },
    calendar : {
        sameDay: '[Паян] LT [сехетре]',
        nextDay: '[Ыран] LT [сехетре]',
        lastDay: '[Ӗнер] LT [сехетре]',
        nextWeek: '[Ҫитес] dddd LT [сехетре]',
        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
        sameElse: 'L'
    },
    relativeTime : {
        future : function (output) {
            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
            return output + affix;
        },
        past : '%s каялла',
        s : 'пӗр-ик ҫеккунт',
        ss : '%d ҫеккунт',
        m : 'пӗр минут',
        mm : '%d минут',
        h : 'пӗр сехет',
        hh : '%d сехет',
        d : 'пӗр кун',
        dd : '%d кун',
        M : 'пӗр уйӑх',
        MM : '%d уйӑх',
        y : 'пӗр ҫул',
        yy : '%d ҫул'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
    ordinal : '%d-мӗш',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return cv;

})));


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var cy = moment.defineLocale('cy', {
    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
    weekdaysParseExact : true,
    // time formats are the same as en-gb
    longDateFormat: {
        LT: 'HH:mm',
        LTS : 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[Heddiw am] LT',
        nextDay: '[Yfory am] LT',
        nextWeek: 'dddd [am] LT',
        lastDay: '[Ddoe am] LT',
        lastWeek: 'dddd [diwethaf am] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'mewn %s',
        past: '%s yn ôl',
        s: 'ychydig eiliadau',
        ss: '%d eiliad',
        m: 'munud',
        mm: '%d munud',
        h: 'awr',
        hh: '%d awr',
        d: 'diwrnod',
        dd: '%d diwrnod',
        M: 'mis',
        MM: '%d mis',
        y: 'blwyddyn',
        yy: '%d flynedd'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
    ordinal: function (number) {
        var b = number,
            output = '',
            lookup = [
                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
            ];
        if (b > 20) {
            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                output = 'fed'; // not 30ain, 70ain or 90ain
            } else {
                output = 'ain';
            }
        } else if (b > 0) {
            output = lookup[b];
        }
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return cy;

})));


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var da = moment.defineLocale('da', {
    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay : '[i dag kl.] LT',
        nextDay : '[i morgen kl.] LT',
        nextWeek : 'på dddd [kl.] LT',
        lastDay : '[i går kl.] LT',
        lastWeek : '[i] dddd[s kl.] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s siden',
        s : 'få sekunder',
        ss : '%d sekunder',
        m : 'et minut',
        mm : '%d minutter',
        h : 'en time',
        hh : '%d timer',
        d : 'en dag',
        dd : '%d dage',
        M : 'en måned',
        MM : '%d måneder',
        y : 'et år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return da;

})));


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var deAt = moment.defineLocale('de-at', {
    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        ss : '%d Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return deAt;

})));


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#

function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var deCh = moment.defineLocale('de-ch', {
    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        ss : '%d Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return deCh;

})));


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var de = moment.defineLocale('de', {
    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        ss : '%d Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return de;

})));


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'ޖެނުއަރީ',
    'ފެބްރުއަރީ',
    'މާރިޗު',
    'އޭޕްރީލު',
    'މޭ',
    'ޖޫން',
    'ޖުލައި',
    'އޯގަސްޓު',
    'ސެޕްޓެމްބަރު',
    'އޮކްޓޯބަރު',
    'ނޮވެމްބަރު',
    'ޑިސެމްބަރު'
];
var weekdays = [
    'އާދިއްތަ',
    'ހޯމަ',
    'އަންގާރަ',
    'ބުދަ',
    'ބުރާސްފަތި',
    'ހުކުރު',
    'ހޮނިހިރު'
];

var dv = moment.defineLocale('dv', {
    months : months,
    monthsShort : months,
    weekdays : weekdays,
    weekdaysShort : weekdays,
    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
    longDateFormat : {

        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/M/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /މކ|މފ/,
    isPM : function (input) {
        return 'މފ' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'މކ';
        } else {
            return 'މފ';
        }
    },
    calendar : {
        sameDay : '[މިއަދު] LT',
        nextDay : '[މާދަމާ] LT',
        nextWeek : 'dddd LT',
        lastDay : '[އިއްޔެ] LT',
        lastWeek : '[ފާއިތުވި] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ތެރޭގައި %s',
        past : 'ކުރިން %s',
        s : 'ސިކުންތުކޮޅެއް',
        ss : 'd% ސިކުންތު',
        m : 'މިނިޓެއް',
        mm : 'މިނިޓު %d',
        h : 'ގަޑިއިރެއް',
        hh : 'ގަޑިއިރު %d',
        d : 'ދުވަހެއް',
        dd : 'ދުވަސް %d',
        M : 'މަހެއް',
        MM : 'މަސް %d',
        y : 'އަހަރެއް',
        yy : 'އަހަރު %d'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 7,  // Sunday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return dv;

})));


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}


var el = moment.defineLocale('el', {
    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
    months : function (momentToFormat, format) {
        if (!momentToFormat) {
            return this._monthsNominativeEl;
        } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
            return this._monthsGenitiveEl[momentToFormat.month()];
        } else {
            return this._monthsNominativeEl[momentToFormat.month()];
        }
    },
    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'μμ' : 'ΜΜ';
        } else {
            return isLower ? 'πμ' : 'ΠΜ';
        }
    },
    isPM : function (input) {
        return ((input + '').toLowerCase()[0] === 'μ');
    },
    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendarEl : {
        sameDay : '[Σήμερα {}] LT',
        nextDay : '[Αύριο {}] LT',
        nextWeek : 'dddd [{}] LT',
        lastDay : '[Χθες {}] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 6:
                    return '[το προηγούμενο] dddd [{}] LT';
                default:
                    return '[την προηγούμενη] dddd [{}] LT';
            }
        },
        sameElse : 'L'
    },
    calendar : function (key, mom) {
        var output = this._calendarEl[key],
            hours = mom && mom.hours();
        if (isFunction(output)) {
            output = output.apply(mom);
        }
        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
    },
    relativeTime : {
        future : 'σε %s',
        past : '%s πριν',
        s : 'λίγα δευτερόλεπτα',
        ss : '%d δευτερόλεπτα',
        m : 'ένα λεπτό',
        mm : '%d λεπτά',
        h : 'μία ώρα',
        hh : '%d ώρες',
        d : 'μία μέρα',
        dd : '%d μέρες',
        M : 'ένας μήνας',
        MM : '%d μήνες',
        y : 'ένας χρόνος',
        yy : '%d χρόνια'
    },
    dayOfMonthOrdinalParse: /\d{1,2}η/,
    ordinal: '%dη',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4st is the first week of the year.
    }
});

return el;

})));


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enAu = moment.defineLocale('en-au', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        ss : '%d seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enAu;

})));


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enCa = moment.defineLocale('en-ca', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'YYYY-MM-DD',
        LL : 'MMMM D, YYYY',
        LLL : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        ss : '%d seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

return enCa;

})));


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enGb = moment.defineLocale('en-gb', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        ss : '%d seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enGb;

})));


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enIe = moment.defineLocale('en-ie', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        ss : '%d seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enIe;

})));


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enNz = moment.defineLocale('en-nz', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        ss : '%d seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enNz;

})));


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
//! comment : miestasmia corrected the translation by colindean

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var eo = moment.defineLocale('eo', {
    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D[-a de] MMMM, YYYY',
        LLL : 'D[-a de] MMMM, YYYY HH:mm',
        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
    },
    meridiemParse: /[ap]\.t\.m/i,
    isPM: function (input) {
        return input.charAt(0).toLowerCase() === 'p';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'p.t.m.' : 'P.T.M.';
        } else {
            return isLower ? 'a.t.m.' : 'A.T.M.';
        }
    },
    calendar : {
        sameDay : '[Hodiaŭ je] LT',
        nextDay : '[Morgaŭ je] LT',
        nextWeek : 'dddd [je] LT',
        lastDay : '[Hieraŭ je] LT',
        lastWeek : '[pasinta] dddd [je] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'post %s',
        past : 'antaŭ %s',
        s : 'sekundoj',
        ss : '%d sekundoj',
        m : 'minuto',
        mm : '%d minutoj',
        h : 'horo',
        hh : '%d horoj',
        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
        dd : '%d tagoj',
        M : 'monato',
        MM : '%d monatoj',
        y : 'jaro',
        yy : '%d jaroj'
    },
    dayOfMonthOrdinalParse: /\d{1,2}a/,
    ordinal : '%da',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return eo;

})));


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

var esDo = moment.defineLocale('es-do', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
    monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
    monthsParse: monthsParse,
    longMonthsParse: monthsParse,
    shortMonthsParse: monthsParse,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY h:mm A',
        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        ss : '%d segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return esDo;

})));


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (United States) [es-us]
//! author : bustta : https://github.com/bustta

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var esUs = moment.defineLocale('es-us', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsParseExact : true,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'MM/DD/YYYY',
        LL : 'MMMM [de] D [de] YYYY',
        LLL : 'MMMM [de] D [de] YYYY h:mm A',
        LLLL : 'dddd, MMMM [de] D [de] YYYY h:mm A'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        ss : '%d segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return esUs;

})));


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

var es = moment.defineLocale('es', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsRegex : monthsRegex,
    monthsShortRegex : monthsRegex,
    monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
    monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY H:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        ss : '%d segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return es;

})));


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
        'ss': [number + 'sekundi', number + 'sekundit'],
        'm' : ['ühe minuti', 'üks minut'],
        'mm': [number + ' minuti', number + ' minutit'],
        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
        'hh': [number + ' tunni', number + ' tundi'],
        'd' : ['ühe päeva', 'üks päev'],
        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
        'MM': [number + ' kuu', number + ' kuud'],
        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
        'yy': [number + ' aasta', number + ' aastat']
    };
    if (withoutSuffix) {
        return format[key][2] ? format[key][2] : format[key][1];
    }
    return isFuture ? format[key][0] : format[key][1];
}

var et = moment.defineLocale('et', {
    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
    longDateFormat : {
        LT   : 'H:mm',
        LTS : 'H:mm:ss',
        L    : 'DD.MM.YYYY',
        LL   : 'D. MMMM YYYY',
        LLL  : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[Täna,] LT',
        nextDay  : '[Homme,] LT',
        nextWeek : '[Järgmine] dddd LT',
        lastDay  : '[Eile,] LT',
        lastWeek : '[Eelmine] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s pärast',
        past   : '%s tagasi',
        s      : processRelativeTime,
        ss     : processRelativeTime,
        m      : processRelativeTime,
        mm     : processRelativeTime,
        h      : processRelativeTime,
        hh     : processRelativeTime,
        d      : processRelativeTime,
        dd     : '%d päeva',
        M      : processRelativeTime,
        MM     : processRelativeTime,
        y      : processRelativeTime,
        yy     : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return et;

})));


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var eu = moment.defineLocale('eu', {
    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
    monthsParseExact : true,
    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'YYYY[ko] MMMM[ren] D[a]',
        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
        l : 'YYYY-M-D',
        ll : 'YYYY[ko] MMM D[a]',
        lll : 'YYYY[ko] MMM D[a] HH:mm',
        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
    },
    calendar : {
        sameDay : '[gaur] LT[etan]',
        nextDay : '[bihar] LT[etan]',
        nextWeek : 'dddd LT[etan]',
        lastDay : '[atzo] LT[etan]',
        lastWeek : '[aurreko] dddd LT[etan]',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s barru',
        past : 'duela %s',
        s : 'segundo batzuk',
        ss : '%d segundo',
        m : 'minutu bat',
        mm : '%d minutu',
        h : 'ordu bat',
        hh : '%d ordu',
        d : 'egun bat',
        dd : '%d egun',
        M : 'hilabete bat',
        MM : '%d hilabete',
        y : 'urte bat',
        yy : '%d urte'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return eu;

})));


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '۱',
    '2': '۲',
    '3': '۳',
    '4': '۴',
    '5': '۵',
    '6': '۶',
    '7': '۷',
    '8': '۸',
    '9': '۹',
    '0': '۰'
};
var numberMap = {
    '۱': '1',
    '۲': '2',
    '۳': '3',
    '۴': '4',
    '۵': '5',
    '۶': '6',
    '۷': '7',
    '۸': '8',
    '۹': '9',
    '۰': '0'
};

var fa = moment.defineLocale('fa', {
    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    meridiemParse: /قبل از ظهر|بعد از ظهر/,
    isPM: function (input) {
        return /بعد از ظهر/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'قبل از ظهر';
        } else {
            return 'بعد از ظهر';
        }
    },
    calendar : {
        sameDay : '[امروز ساعت] LT',
        nextDay : '[فردا ساعت] LT',
        nextWeek : 'dddd [ساعت] LT',
        lastDay : '[دیروز ساعت] LT',
        lastWeek : 'dddd [پیش] [ساعت] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'در %s',
        past : '%s پیش',
        s : 'چند ثانیه',
        ss : 'ثانیه d%',
        m : 'یک دقیقه',
        mm : '%d دقیقه',
        h : 'یک ساعت',
        hh : '%d ساعت',
        d : 'یک روز',
        dd : '%d روز',
        M : 'یک ماه',
        MM : '%d ماه',
        y : 'یک سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/[۰-۹]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    dayOfMonthOrdinalParse: /\d{1,2}م/,
    ordinal : '%dم',
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12 // The week that contains Jan 1st is the first week of the year.
    }
});

return fa;

})));


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
var numbersFuture = [
        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
        numbersPast[7], numbersPast[8], numbersPast[9]
    ];
function translate(number, withoutSuffix, key, isFuture) {
    var result = '';
    switch (key) {
        case 's':
            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
        case 'ss':
            return isFuture ? 'sekunnin' : 'sekuntia';
        case 'm':
            return isFuture ? 'minuutin' : 'minuutti';
        case 'mm':
            result = isFuture ? 'minuutin' : 'minuuttia';
            break;
        case 'h':
            return isFuture ? 'tunnin' : 'tunti';
        case 'hh':
            result = isFuture ? 'tunnin' : 'tuntia';
            break;
        case 'd':
            return isFuture ? 'päivän' : 'päivä';
        case 'dd':
            result = isFuture ? 'päivän' : 'päivää';
            break;
        case 'M':
            return isFuture ? 'kuukauden' : 'kuukausi';
        case 'MM':
            result = isFuture ? 'kuukauden' : 'kuukautta';
            break;
        case 'y':
            return isFuture ? 'vuoden' : 'vuosi';
        case 'yy':
            result = isFuture ? 'vuoden' : 'vuotta';
            break;
    }
    result = verbalNumber(number, isFuture) + ' ' + result;
    return result;
}
function verbalNumber(number, isFuture) {
    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
}

var fi = moment.defineLocale('fi', {
    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'Do MMMM[ta] YYYY',
        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
        l : 'D.M.YYYY',
        ll : 'Do MMM YYYY',
        lll : 'Do MMM YYYY, [klo] HH.mm',
        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
    },
    calendar : {
        sameDay : '[tänään] [klo] LT',
        nextDay : '[huomenna] [klo] LT',
        nextWeek : 'dddd [klo] LT',
        lastDay : '[eilen] [klo] LT',
        lastWeek : '[viime] dddd[na] [klo] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s päästä',
        past : '%s sitten',
        s : translate,
        ss : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fi;

})));


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var fo = moment.defineLocale('fo', {
    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D. MMMM, YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Í dag kl.] LT',
        nextDay : '[Í morgin kl.] LT',
        nextWeek : 'dddd [kl.] LT',
        lastDay : '[Í gjár kl.] LT',
        lastWeek : '[síðstu] dddd [kl] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'um %s',
        past : '%s síðani',
        s : 'fá sekund',
        ss : '%d sekundir',
        m : 'ein minutt',
        mm : '%d minuttir',
        h : 'ein tími',
        hh : '%d tímar',
        d : 'ein dagur',
        dd : '%d dagar',
        M : 'ein mánaði',
        MM : '%d mánaðir',
        y : 'eitt ár',
        yy : '%d ár'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fo;

})));


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var frCa = moment.defineLocale('fr-ca', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        ss : '%d secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
    ordinal : function (number, period) {
        switch (period) {
            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'D':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    }
});

return frCa;

})));


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var frCh = moment.defineLocale('fr-ch', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        ss : '%d secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
    ordinal : function (number, period) {
        switch (period) {
            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'D':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return frCh;

})));


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var fr = moment.defineLocale('fr', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        ss : '%d secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
    ordinal : function (number, period) {
        switch (period) {
            // TODO: Return 'e' when day of month > 1. Move this case inside
            // block for masculine words below.
            // See https://github.com/moment/moment/issues/3375
            case 'D':
                return number + (number === 1 ? 'er' : '');

            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fr;

})));


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

var fy = moment.defineLocale('fy', {
    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },
    monthsParseExact : true,
    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[hjoed om] LT',
        nextDay: '[moarn om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[juster om] LT',
        lastWeek: '[ôfrûne] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'oer %s',
        past : '%s lyn',
        s : 'in pear sekonden',
        ss : '%d sekonden',
        m : 'ien minút',
        mm : '%d minuten',
        h : 'ien oere',
        hh : '%d oeren',
        d : 'ien dei',
        dd : '%d dagen',
        M : 'ien moanne',
        MM : '%d moannen',
        y : 'ien jier',
        yy : '%d jierren'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fy;

})));


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
];

var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];

var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];

var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];

var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

var gd = moment.defineLocale('gd', {
    months : months,
    monthsShort : monthsShort,
    monthsParseExact : true,
    weekdays : weekdays,
    weekdaysShort : weekdaysShort,
    weekdaysMin : weekdaysMin,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[An-diugh aig] LT',
        nextDay : '[A-màireach aig] LT',
        nextWeek : 'dddd [aig] LT',
        lastDay : '[An-dè aig] LT',
        lastWeek : 'dddd [seo chaidh] [aig] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ann an %s',
        past : 'bho chionn %s',
        s : 'beagan diogan',
        ss : '%d diogan',
        m : 'mionaid',
        mm : '%d mionaidean',
        h : 'uair',
        hh : '%d uairean',
        d : 'latha',
        dd : '%d latha',
        M : 'mìos',
        MM : '%d mìosan',
        y : 'bliadhna',
        yy : '%d bliadhna'
    },
    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
    ordinal : function (number) {
        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return gd;

})));


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var gl = moment.defineLocale('gl', {
    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY H:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
        },
        nextDay : function () {
            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
        },
        lastDay : function () {
            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
        },
        lastWeek : function () {
            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : function (str) {
            if (str.indexOf('un') === 0) {
                return 'n' + str;
            }
            return 'en ' + str;
        },
        past : 'hai %s',
        s : 'uns segundos',
        ss : '%d segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'unha hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return gl;

})));


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Latin script [gom-latn]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's': ['thodde secondanim', 'thodde second'],
        'ss': [number + ' secondanim', number + ' second'],
        'm': ['eka mintan', 'ek minute'],
        'mm': [number + ' mintanim', number + ' mintam'],
        'h': ['eka horan', 'ek hor'],
        'hh': [number + ' horanim', number + ' hor'],
        'd': ['eka disan', 'ek dis'],
        'dd': [number + ' disanim', number + ' dis'],
        'M': ['eka mhoinean', 'ek mhoino'],
        'MM': [number + ' mhoineanim', number + ' mhoine'],
        'y': ['eka vorsan', 'ek voros'],
        'yy': [number + ' vorsanim', number + ' vorsam']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var gomLatn = moment.defineLocale('gom-latn', {
    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'A h:mm [vazta]',
        LTS : 'A h:mm:ss [vazta]',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY A h:mm [vazta]',
        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
    },
    calendar : {
        sameDay: '[Aiz] LT',
        nextDay: '[Faleam] LT',
        nextWeek: '[Ieta to] dddd[,] LT',
        lastDay: '[Kal] LT',
        lastWeek: '[Fatlo] dddd[,] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s',
        past : '%s adim',
        s : processRelativeTime,
        ss : processRelativeTime,
        m : processRelativeTime,
        mm : processRelativeTime,
        h : processRelativeTime,
        hh : processRelativeTime,
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
    ordinal : function (number, period) {
        switch (period) {
            // the ordinal 'er' only applies to day of the month
            case 'D':
                return number + 'er';
            default:
            case 'M':
            case 'Q':
            case 'DDD':
            case 'd':
            case 'w':
            case 'W':
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    },
    meridiemParse: /rati|sokalli|donparam|sanje/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'rati') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'sokalli') {
            return hour;
        } else if (meridiem === 'donparam') {
            return hour > 12 ? hour : hour + 12;
        } else if (meridiem === 'sanje') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'rati';
        } else if (hour < 12) {
            return 'sokalli';
        } else if (hour < 16) {
            return 'donparam';
        } else if (hour < 20) {
            return 'sanje';
        } else {
            return 'rati';
        }
    }
});

return gomLatn;

})));


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Gujarati [gu]
//! author : Kaushik Thanki : https://github.com/Kaushik1987

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
        '1': '૧',
        '2': '૨',
        '3': '૩',
        '4': '૪',
        '5': '૫',
        '6': '૬',
        '7': '૭',
        '8': '૮',
        '9': '૯',
        '0': '૦'
    };
var numberMap = {
        '૧': '1',
        '૨': '2',
        '૩': '3',
        '૪': '4',
        '૫': '5',
        '૬': '6',
        '૭': '7',
        '૮': '8',
        '૯': '9',
        '૦': '0'
    };

var gu = moment.defineLocale('gu', {
    months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
    monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
    monthsParseExact: true,
    weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
    weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
    weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
    longDateFormat: {
        LT: 'A h:mm વાગ્યે',
        LTS: 'A h:mm:ss વાગ્યે',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
        LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
    },
    calendar: {
        sameDay: '[આજ] LT',
        nextDay: '[કાલે] LT',
        nextWeek: 'dddd, LT',
        lastDay: '[ગઇકાલે] LT',
        lastWeek: '[પાછલા] dddd, LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: '%s મા',
        past: '%s પેહલા',
        s: 'અમુક પળો',
        ss: '%d સેકંડ',
        m: 'એક મિનિટ',
        mm: '%d મિનિટ',
        h: 'એક કલાક',
        hh: '%d કલાક',
        d: 'એક દિવસ',
        dd: '%d દિવસ',
        M: 'એક મહિનો',
        MM: '%d મહિનો',
        y: 'એક વર્ષ',
        yy: '%d વર્ષ'
    },
    preparse: function (string) {
        return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
    meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'રાત') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'સવાર') {
            return hour;
        } else if (meridiem === 'બપોર') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'સાંજ') {
            return hour + 12;
        }
    },
    meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
            return 'રાત';
        } else if (hour < 10) {
            return 'સવાર';
        } else if (hour < 17) {
            return 'બપોર';
        } else if (hour < 20) {
            return 'સાંજ';
        } else {
            return 'રાત';
        }
    },
    week: {
        dow: 0, // Sunday is the first day of the week.
        doy: 6 // The week that contains Jan 1st is the first week of the year.
    }
});

return gu;

})));


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var he = moment.defineLocale('he', {
    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [ב]MMMM YYYY',
        LLL : 'D [ב]MMMM YYYY HH:mm',
        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
        l : 'D/M/YYYY',
        ll : 'D MMM YYYY',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd, D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[היום ב־]LT',
        nextDay : '[מחר ב־]LT',
        nextWeek : 'dddd [בשעה] LT',
        lastDay : '[אתמול ב־]LT',
        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'בעוד %s',
        past : 'לפני %s',
        s : 'מספר שניות',
        ss : '%d שניות',
        m : 'דקה',
        mm : '%d דקות',
        h : 'שעה',
        hh : function (number) {
            if (number === 2) {
                return 'שעתיים';
            }
            return number + ' שעות';
        },
        d : 'יום',
        dd : function (number) {
            if (number === 2) {
                return 'יומיים';
            }
            return number + ' ימים';
        },
        M : 'חודש',
        MM : function (number) {
            if (number === 2) {
                return 'חודשיים';
            }
            return number + ' חודשים';
        },
        y : 'שנה',
        yy : function (number) {
            if (number === 2) {
                return 'שנתיים';
            } else if (number % 10 === 0 && number !== 10) {
                return number + ' שנה';
            }
            return number + ' שנים';
        }
    },
    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
    isPM : function (input) {
        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 5) {
            return 'לפנות בוקר';
        } else if (hour < 10) {
            return 'בבוקר';
        } else if (hour < 12) {
            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
        } else if (hour < 18) {
            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
        } else {
            return 'בערב';
        }
    }
});

return he;

})));


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

var hi = moment.defineLocale('hi', {
    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
    monthsParseExact: true,
    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
    longDateFormat : {
        LT : 'A h:mm बजे',
        LTS : 'A h:mm:ss बजे',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm बजे',
        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[कल] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[कल] LT',
        lastWeek : '[पिछले] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s में',
        past : '%s पहले',
        s : 'कुछ ही क्षण',
        ss : '%d सेकंड',
        m : 'एक मिनट',
        mm : '%d मिनट',
        h : 'एक घंटा',
        hh : '%d घंटे',
        d : 'एक दिन',
        dd : '%d दिन',
        M : 'एक महीने',
        MM : '%d महीने',
        y : 'एक वर्ष',
        yy : '%d वर्ष'
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
    meridiemParse: /रात|सुबह|दोपहर|शाम/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'रात') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'सुबह') {
            return hour;
        } else if (meridiem === 'दोपहर') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'शाम') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'रात';
        } else if (hour < 10) {
            return 'सुबह';
        } else if (hour < 17) {
            return 'दोपहर';
        } else if (hour < 20) {
            return 'शाम';
        } else {
            return 'रात';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return hi;

})));


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'ss':
            if (number === 1) {
                result += 'sekunda';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sekunde';
            } else {
                result += 'sekundi';
            }
            return result;
        case 'm':
            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
        case 'mm':
            if (number === 1) {
                result += 'minuta';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'minute';
            } else {
                result += 'minuta';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'jedan sat' : 'jednog sata';
        case 'hh':
            if (number === 1) {
                result += 'sat';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sata';
            } else {
                result += 'sati';
            }
            return result;
        case 'dd':
            if (number === 1) {
                result += 'dan';
            } else {
                result += 'dana';
            }
            return result;
        case 'MM':
            if (number === 1) {
                result += 'mjesec';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'mjeseca';
            } else {
                result += 'mjeseci';
            }
            return result;
        case 'yy':
            if (number === 1) {
                result += 'godina';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'godine';
            } else {
                result += 'godina';
            }
            return result;
    }
}

var hr = moment.defineLocale('hr', {
    months : {
        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
    },
    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danas u] LT',
        nextDay  : '[sutra u] LT',
        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[jučer u] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                    return '[prošlu] dddd [u] LT';
                case 6:
                    return '[prošle] [subote] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prošli] dddd [u] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'par sekundi',
        ss     : translate,
        m      : translate,
        mm     : translate,
        h      : translate,
        hh     : translate,
        d      : 'dan',
        dd     : translate,
        M      : 'mjesec',
        MM     : translate,
        y      : 'godinu',
        yy     : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return hr;

})));


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
function translate(number, withoutSuffix, key, isFuture) {
    var num = number;
    switch (key) {
        case 's':
            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
        case 'ss':
            return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
        case 'm':
            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
        case 'mm':
            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
        case 'h':
            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
        case 'hh':
            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
        case 'd':
            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
        case 'dd':
            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
        case 'M':
            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
        case 'MM':
            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
        case 'y':
            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
        case 'yy':
            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
    }
    return '';
}
function week(isFuture) {
    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
}

var hu = moment.defineLocale('hu', {
    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'YYYY.MM.DD.',
        LL : 'YYYY. MMMM D.',
        LLL : 'YYYY. MMMM D. H:mm',
        LLLL : 'YYYY. MMMM D., dddd H:mm'
    },
    meridiemParse: /de|du/i,
    isPM: function (input) {
        return input.charAt(1).toLowerCase() === 'u';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower === true ? 'de' : 'DE';
        } else {
            return isLower === true ? 'du' : 'DU';
        }
    },
    calendar : {
        sameDay : '[ma] LT[-kor]',
        nextDay : '[holnap] LT[-kor]',
        nextWeek : function () {
            return week.call(this, true);
        },
        lastDay : '[tegnap] LT[-kor]',
        lastWeek : function () {
            return week.call(this, false);
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s múlva',
        past : '%s',
        s : translate,
        ss : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return hu;

})));


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var hyAm = moment.defineLocale('hy-am', {
    months : {
        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
    },
    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY թ.',
        LLL : 'D MMMM YYYY թ., HH:mm',
        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
    },
    calendar : {
        sameDay: '[այսօր] LT',
        nextDay: '[վաղը] LT',
        lastDay: '[երեկ] LT',
        nextWeek: function () {
            return 'dddd [օրը ժամը] LT';
        },
        lastWeek: function () {
            return '[անցած] dddd [օրը ժամը] LT';
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s հետո',
        past : '%s առաջ',
        s : 'մի քանի վայրկյան',
        ss : '%d վայրկյան',
        m : 'րոպե',
        mm : '%d րոպե',
        h : 'ժամ',
        hh : '%d ժամ',
        d : 'օր',
        dd : '%d օր',
        M : 'ամիս',
        MM : '%d ամիս',
        y : 'տարի',
        yy : '%d տարի'
    },
    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
    isPM: function (input) {
        return /^(ցերեկվա|երեկոյան)$/.test(input);
    },
    meridiem : function (hour) {
        if (hour < 4) {
            return 'գիշերվա';
        } else if (hour < 12) {
            return 'առավոտվա';
        } else if (hour < 17) {
            return 'ցերեկվա';
        } else {
            return 'երեկոյան';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'DDD':
            case 'w':
            case 'W':
            case 'DDDo':
                if (number === 1) {
                    return number + '-ին';
                }
                return number + '-րդ';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return hyAm;

})));


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var id = moment.defineLocale('id', {
    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|siang|sore|malam/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'siang') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'sore' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'siang';
        } else if (hours < 19) {
            return 'sore';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Besok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kemarin pukul] LT',
        lastWeek : 'dddd [lalu pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lalu',
        s : 'beberapa detik',
        ss : '%d detik',
        m : 'semenit',
        mm : '%d menit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return id;

})));


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(n) {
    if (n % 100 === 11) {
        return true;
    } else if (n % 10 === 1) {
        return false;
    }
    return true;
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':
            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
        case 'ss':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
            }
            return result + 'sekúnda';
        case 'm':
            return withoutSuffix ? 'mínúta' : 'mínútu';
        case 'mm':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
            } else if (withoutSuffix) {
                return result + 'mínúta';
            }
            return result + 'mínútu';
        case 'hh':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
            }
            return result + 'klukkustund';
        case 'd':
            if (withoutSuffix) {
                return 'dagur';
            }
            return isFuture ? 'dag' : 'degi';
        case 'dd':
            if (plural(number)) {
                if (withoutSuffix) {
                    return result + 'dagar';
                }
                return result + (isFuture ? 'daga' : 'dögum');
            } else if (withoutSuffix) {
                return result + 'dagur';
            }
            return result + (isFuture ? 'dag' : 'degi');
        case 'M':
            if (withoutSuffix) {
                return 'mánuður';
            }
            return isFuture ? 'mánuð' : 'mánuði';
        case 'MM':
            if (plural(number)) {
                if (withoutSuffix) {
                    return result + 'mánuðir';
                }
                return result + (isFuture ? 'mánuði' : 'mánuðum');
            } else if (withoutSuffix) {
                return result + 'mánuður';
            }
            return result + (isFuture ? 'mánuð' : 'mánuði');
        case 'y':
            return withoutSuffix || isFuture ? 'ár' : 'ári';
        case 'yy':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
            }
            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
    }
}

var is = moment.defineLocale('is', {
    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] H:mm',
        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
    },
    calendar : {
        sameDay : '[í dag kl.] LT',
        nextDay : '[á morgun kl.] LT',
        nextWeek : 'dddd [kl.] LT',
        lastDay : '[í gær kl.] LT',
        lastWeek : '[síðasta] dddd [kl.] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'eftir %s',
        past : 'fyrir %s síðan',
        s : translate,
        ss : translate,
        m : translate,
        mm : translate,
        h : 'klukkustund',
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return is;

})));


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var it = moment.defineLocale('it', {
    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Oggi alle] LT',
        nextDay: '[Domani alle] LT',
        nextWeek: 'dddd [alle] LT',
        lastDay: '[Ieri alle] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[la scorsa] dddd [alle] LT';
                default:
                    return '[lo scorso] dddd [alle] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : function (s) {
            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
        },
        past : '%s fa',
        s : 'alcuni secondi',
        ss : '%d secondi',
        m : 'un minuto',
        mm : '%d minuti',
        h : 'un\'ora',
        hh : '%d ore',
        d : 'un giorno',
        dd : '%d giorni',
        M : 'un mese',
        MM : '%d mesi',
        y : 'un anno',
        yy : '%d anni'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return it;

})));


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ja = moment.defineLocale('ja', {
    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY年M月D日',
        LLL : 'YYYY年M月D日 HH:mm',
        LLLL : 'YYYY年M月D日 HH:mm dddd',
        l : 'YYYY/MM/DD',
        ll : 'YYYY年M月D日',
        lll : 'YYYY年M月D日 HH:mm',
        llll : 'YYYY年M月D日 HH:mm dddd'
    },
    meridiemParse: /午前|午後/i,
    isPM : function (input) {
        return input === '午後';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return '午前';
        } else {
            return '午後';
        }
    },
    calendar : {
        sameDay : '[今日] LT',
        nextDay : '[明日] LT',
        nextWeek : '[来週]dddd LT',
        lastDay : '[昨日] LT',
        lastWeek : '[前週]dddd LT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse : /\d{1,2}日/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '日';
            default:
                return number;
        }
    },
    relativeTime : {
        future : '%s後',
        past : '%s前',
        s : '数秒',
        ss : '%d秒',
        m : '1分',
        mm : '%d分',
        h : '1時間',
        hh : '%d時間',
        d : '1日',
        dd : '%d日',
        M : '1ヶ月',
        MM : '%dヶ月',
        y : '1年',
        yy : '%d年'
    }
});

return ja;

})));


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Javanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var jv = moment.defineLocale('jv', {
    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /enjing|siyang|sonten|ndalu/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'enjing') {
            return hour;
        } else if (meridiem === 'siyang') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'enjing';
        } else if (hours < 15) {
            return 'siyang';
        } else if (hours < 19) {
            return 'sonten';
        } else {
            return 'ndalu';
        }
    },
    calendar : {
        sameDay : '[Dinten puniko pukul] LT',
        nextDay : '[Mbenjang pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kala wingi pukul] LT',
        lastWeek : 'dddd [kepengker pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'wonten ing %s',
        past : '%s ingkang kepengker',
        s : 'sawetawis detik',
        ss : '%d detik',
        m : 'setunggal menit',
        mm : '%d menit',
        h : 'setunggal jam',
        hh : '%d jam',
        d : 'sedinten',
        dd : '%d dinten',
        M : 'sewulan',
        MM : '%d wulan',
        y : 'setaun',
        yy : '%d taun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return jv;

})));


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ka = moment.defineLocale('ka', {
    months : {
        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
    },
    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
    weekdays : {
        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
        isFormat: /(წინა|შემდეგ)/
    },
    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[დღეს] LT[-ზე]',
        nextDay : '[ხვალ] LT[-ზე]',
        lastDay : '[გუშინ] LT[-ზე]',
        nextWeek : '[შემდეგ] dddd LT[-ზე]',
        lastWeek : '[წინა] dddd LT-ზე',
        sameElse : 'L'
    },
    relativeTime : {
        future : function (s) {
            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
                s.replace(/ი$/, 'ში') :
                s + 'ში';
        },
        past : function (s) {
            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
                return s.replace(/(ი|ე)$/, 'ის უკან');
            }
            if ((/წელი/).test(s)) {
                return s.replace(/წელი$/, 'წლის უკან');
            }
        },
        s : 'რამდენიმე წამი',
        ss : '%d წამი',
        m : 'წუთი',
        mm : '%d წუთი',
        h : 'საათი',
        hh : '%d საათი',
        d : 'დღე',
        dd : '%d დღე',
        M : 'თვე',
        MM : '%d თვე',
        y : 'წელი',
        yy : '%d წელი'
    },
    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
    ordinal : function (number) {
        if (number === 0) {
            return number;
        }
        if (number === 1) {
            return number + '-ლი';
        }
        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
            return 'მე-' + number;
        }
        return number + '-ე';
    },
    week : {
        dow : 1,
        doy : 7
    }
});

return ka;

})));


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    0: '-ші',
    1: '-ші',
    2: '-ші',
    3: '-ші',
    4: '-ші',
    5: '-ші',
    6: '-шы',
    7: '-ші',
    8: '-ші',
    9: '-шы',
    10: '-шы',
    20: '-шы',
    30: '-шы',
    40: '-шы',
    50: '-ші',
    60: '-шы',
    70: '-ші',
    80: '-ші',
    90: '-шы',
    100: '-ші'
};

var kk = moment.defineLocale('kk', {
    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Бүгін сағат] LT',
        nextDay : '[Ертең сағат] LT',
        nextWeek : 'dddd [сағат] LT',
        lastDay : '[Кеше сағат] LT',
        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ішінде',
        past : '%s бұрын',
        s : 'бірнеше секунд',
        ss : '%d секунд',
        m : 'бір минут',
        mm : '%d минут',
        h : 'бір сағат',
        hh : '%d сағат',
        d : 'бір күн',
        dd : '%d күн',
        M : 'бір ай',
        MM : '%d ай',
        y : 'бір жыл',
        yy : '%d жыл'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
    ordinal : function (number) {
        var a = number % 10,
            b = number >= 100 ? 100 : null;
        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return kk;

})));


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var km = moment.defineLocale('km', {
    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    longDateFormat: {
        LT: 'HH:mm',
        LTS : 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
        nextDay: '[ស្អែក ម៉ោង] LT',
        nextWeek: 'dddd [ម៉ោង] LT',
        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: '%sទៀត',
        past: '%sមុន',
        s: 'ប៉ុន្មានវិនាទី',
        ss: '%d វិនាទី',
        m: 'មួយនាទី',
        mm: '%d នាទី',
        h: 'មួយម៉ោង',
        hh: '%d ម៉ោង',
        d: 'មួយថ្ងៃ',
        dd: '%d ថ្ងៃ',
        M: 'មួយខែ',
        MM: '%d ខែ',
        y: 'មួយឆ្នាំ',
        yy: '%d ឆ្នាំ'
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return km;

})));


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '೧',
    '2': '೨',
    '3': '೩',
    '4': '೪',
    '5': '೫',
    '6': '೬',
    '7': '೭',
    '8': '೮',
    '9': '೯',
    '0': '೦'
};
var numberMap = {
    '೧': '1',
    '೨': '2',
    '೩': '3',
    '೪': '4',
    '೫': '5',
    '೬': '6',
    '೭': '7',
    '೮': '8',
    '೯': '9',
    '೦': '0'
};

var kn = moment.defineLocale('kn', {
    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
    monthsParseExact: true,
    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[ಇಂದು] LT',
        nextDay : '[ನಾಳೆ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ನಿನ್ನೆ] LT',
        lastWeek : '[ಕೊನೆಯ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ನಂತರ',
        past : '%s ಹಿಂದೆ',
        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
        ss : '%d ಸೆಕೆಂಡುಗಳು',
        m : 'ಒಂದು ನಿಮಿಷ',
        mm : '%d ನಿಮಿಷ',
        h : 'ಒಂದು ಗಂಟೆ',
        hh : '%d ಗಂಟೆ',
        d : 'ಒಂದು ದಿನ',
        dd : '%d ದಿನ',
        M : 'ಒಂದು ತಿಂಗಳು',
        MM : '%d ತಿಂಗಳು',
        y : 'ಒಂದು ವರ್ಷ',
        yy : '%d ವರ್ಷ'
    },
    preparse: function (string) {
        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ರಾತ್ರಿ') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
            return hour;
        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'ಸಂಜೆ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ರಾತ್ರಿ';
        } else if (hour < 10) {
            return 'ಬೆಳಿಗ್ಗೆ';
        } else if (hour < 17) {
            return 'ಮಧ್ಯಾಹ್ನ';
        } else if (hour < 20) {
            return 'ಸಂಜೆ';
        } else {
            return 'ರಾತ್ರಿ';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
    ordinal : function (number) {
        return number + 'ನೇ';
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return kn;

})));


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ko = moment.defineLocale('ko', {
    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'YYYY.MM.DD',
        LL : 'YYYY년 MMMM D일',
        LLL : 'YYYY년 MMMM D일 A h:mm',
        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
        l : 'YYYY.MM.DD',
        ll : 'YYYY년 MMMM D일',
        lll : 'YYYY년 MMMM D일 A h:mm',
        llll : 'YYYY년 MMMM D일 dddd A h:mm'
    },
    calendar : {
        sameDay : '오늘 LT',
        nextDay : '내일 LT',
        nextWeek : 'dddd LT',
        lastDay : '어제 LT',
        lastWeek : '지난주 dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s 후',
        past : '%s 전',
        s : '몇 초',
        ss : '%d초',
        m : '1분',
        mm : '%d분',
        h : '한 시간',
        hh : '%d시간',
        d : '하루',
        dd : '%d일',
        M : '한 달',
        MM : '%d달',
        y : '일 년',
        yy : '%d년'
    },
    dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '일';
            case 'M':
                return number + '월';
            case 'w':
            case 'W':
                return number + '주';
            default:
                return number;
        }
    },
    meridiemParse : /오전|오후/,
    isPM : function (token) {
        return token === '오후';
    },
    meridiem : function (hour, minute, isUpper) {
        return hour < 12 ? '오전' : '오후';
    }
});

return ko;

})));


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var suffixes = {
    0: '-чү',
    1: '-чи',
    2: '-чи',
    3: '-чү',
    4: '-чү',
    5: '-чи',
    6: '-чы',
    7: '-чи',
    8: '-чи',
    9: '-чу',
    10: '-чу',
    20: '-чы',
    30: '-чу',
    40: '-чы',
    50: '-чү',
    60: '-чы',
    70: '-чи',
    80: '-чи',
    90: '-чу',
    100: '-чү'
};

var ky = moment.defineLocale('ky', {
    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Бүгүн саат] LT',
        nextDay : '[Эртең саат] LT',
        nextWeek : 'dddd [саат] LT',
        lastDay : '[Кече саат] LT',
        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ичинде',
        past : '%s мурун',
        s : 'бирнече секунд',
        ss : '%d секунд',
        m : 'бир мүнөт',
        mm : '%d мүнөт',
        h : 'бир саат',
        hh : '%d саат',
        d : 'бир күн',
        dd : '%d күн',
        M : 'бир ай',
        MM : '%d ай',
        y : 'бир жыл',
        yy : '%d жыл'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
    ordinal : function (number) {
        var a = number % 10,
            b = number >= 100 ? 100 : null;
        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ky;

})));


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eng Minutt', 'enger Minutt'],
        'h': ['eng Stonn', 'enger Stonn'],
        'd': ['een Dag', 'engem Dag'],
        'M': ['ee Mount', 'engem Mount'],
        'y': ['ee Joer', 'engem Joer']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}
function processFutureTime(string) {
    var number = string.substr(0, string.indexOf(' '));
    if (eifelerRegelAppliesToNumber(number)) {
        return 'a ' + string;
    }
    return 'an ' + string;
}
function processPastTime(string) {
    var number = string.substr(0, string.indexOf(' '));
    if (eifelerRegelAppliesToNumber(number)) {
        return 'viru ' + string;
    }
    return 'virun ' + string;
}
/**
 * Returns true if the word before the given number loses the '-n' ending.
 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
 *
 * @param number {integer}
 * @returns {boolean}
 */
function eifelerRegelAppliesToNumber(number) {
    number = parseInt(number, 10);
    if (isNaN(number)) {
        return false;
    }
    if (number < 0) {
        // Negative Number --> always true
        return true;
    } else if (number < 10) {
        // Only 1 digit
        if (4 <= number && number <= 7) {
            return true;
        }
        return false;
    } else if (number < 100) {
        // 2 digits
        var lastDigit = number % 10, firstDigit = number / 10;
        if (lastDigit === 0) {
            return eifelerRegelAppliesToNumber(firstDigit);
        }
        return eifelerRegelAppliesToNumber(lastDigit);
    } else if (number < 10000) {
        // 3 or 4 digits --> recursively check first digit
        while (number >= 10) {
            number = number / 10;
        }
        return eifelerRegelAppliesToNumber(number);
    } else {
        // Anything larger than 4 digits: recursively check first n-3 digits
        number = number / 1000;
        return eifelerRegelAppliesToNumber(number);
    }
}

var lb = moment.defineLocale('lb', {
    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm [Auer]',
        LTS: 'H:mm:ss [Auer]',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm [Auer]',
        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
    },
    calendar: {
        sameDay: '[Haut um] LT',
        sameElse: 'L',
        nextDay: '[Muer um] LT',
        nextWeek: 'dddd [um] LT',
        lastDay: '[Gëschter um] LT',
        lastWeek: function () {
            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
            switch (this.day()) {
                case 2:
                case 4:
                    return '[Leschten] dddd [um] LT';
                default:
                    return '[Leschte] dddd [um] LT';
            }
        }
    },
    relativeTime : {
        future : processFutureTime,
        past : processPastTime,
        s : 'e puer Sekonnen',
        ss : '%d Sekonnen',
        m : processRelativeTime,
        mm : '%d Minutten',
        h : processRelativeTime,
        hh : '%d Stonnen',
        d : processRelativeTime,
        dd : '%d Deeg',
        M : processRelativeTime,
        MM : '%d Méint',
        y : processRelativeTime,
        yy : '%d Joer'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: '%d.',
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lb;

})));


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var lo = moment.defineLocale('lo', {
    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
    isPM: function (input) {
        return input === 'ຕອນແລງ';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ຕອນເຊົ້າ';
        } else {
            return 'ຕອນແລງ';
        }
    },
    calendar : {
        sameDay : '[ມື້ນີ້ເວລາ] LT',
        nextDay : '[ມື້ອື່ນເວລາ] LT',
        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ອີກ %s',
        past : '%sຜ່ານມາ',
        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
        ss : '%d ວິນາທີ' ,
        m : '1 ນາທີ',
        mm : '%d ນາທີ',
        h : '1 ຊົ່ວໂມງ',
        hh : '%d ຊົ່ວໂມງ',
        d : '1 ມື້',
        dd : '%d ມື້',
        M : '1 ເດືອນ',
        MM : '%d ເດືອນ',
        y : '1 ປີ',
        yy : '%d ປີ'
    },
    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
    ordinal : function (number) {
        return 'ທີ່' + number;
    }
});

return lo;

})));


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var units = {
    'ss' : 'sekundė_sekundžių_sekundes',
    'm' : 'minutė_minutės_minutę',
    'mm': 'minutės_minučių_minutes',
    'h' : 'valanda_valandos_valandą',
    'hh': 'valandos_valandų_valandas',
    'd' : 'diena_dienos_dieną',
    'dd': 'dienos_dienų_dienas',
    'M' : 'mėnuo_mėnesio_mėnesį',
    'MM': 'mėnesiai_mėnesių_mėnesius',
    'y' : 'metai_metų_metus',
    'yy': 'metai_metų_metus'
};
function translateSeconds(number, withoutSuffix, key, isFuture) {
    if (withoutSuffix) {
        return 'kelios sekundės';
    } else {
        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
    }
}
function translateSingular(number, withoutSuffix, key, isFuture) {
    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
}
function special(number) {
    return number % 10 === 0 || (number > 10 && number < 20);
}
function forms(key) {
    return units[key].split('_');
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    if (number === 1) {
        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
    } else if (withoutSuffix) {
        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
    } else {
        if (isFuture) {
            return result + forms(key)[1];
        } else {
            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
        }
    }
}
var lt = moment.defineLocale('lt', {
    months : {
        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
    },
    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
    weekdays : {
        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
        isFormat: /dddd HH:mm/
    },
    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'YYYY [m.] MMMM D [d.]',
        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
        l : 'YYYY-MM-DD',
        ll : 'YYYY [m.] MMMM D [d.]',
        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
    },
    calendar : {
        sameDay : '[Šiandien] LT',
        nextDay : '[Rytoj] LT',
        nextWeek : 'dddd LT',
        lastDay : '[Vakar] LT',
        lastWeek : '[Praėjusį] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'po %s',
        past : 'prieš %s',
        s : translateSeconds,
        ss : translate,
        m : translateSingular,
        mm : translate,
        h : translateSingular,
        hh : translate,
        d : translateSingular,
        dd : translate,
        M : translateSingular,
        MM : translate,
        y : translateSingular,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
    ordinal : function (number) {
        return number + '-oji';
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lt;

})));


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var units = {
    'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
    'h': 'stundas_stundām_stunda_stundas'.split('_'),
    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
    'd': 'dienas_dienām_diena_dienas'.split('_'),
    'dd': 'dienas_dienām_diena_dienas'.split('_'),
    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
    'y': 'gada_gadiem_gads_gadi'.split('_'),
    'yy': 'gada_gadiem_gads_gadi'.split('_')
};
/**
 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
 */
function format(forms, number, withoutSuffix) {
    if (withoutSuffix) {
        // E.g. "21 minūte", "3 minūtes".
        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
    } else {
        // E.g. "21 minūtes" as in "pēc 21 minūtes".
        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
    }
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    return number + ' ' + format(units[key], number, withoutSuffix);
}
function relativeTimeWithSingular(number, withoutSuffix, key) {
    return format(units[key], number, withoutSuffix);
}
function relativeSeconds(number, withoutSuffix) {
    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
}

var lv = moment.defineLocale('lv', {
    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY.',
        LL : 'YYYY. [gada] D. MMMM',
        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
    },
    calendar : {
        sameDay : '[Šodien pulksten] LT',
        nextDay : '[Rīt pulksten] LT',
        nextWeek : 'dddd [pulksten] LT',
        lastDay : '[Vakar pulksten] LT',
        lastWeek : '[Pagājušā] dddd [pulksten] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'pēc %s',
        past : 'pirms %s',
        s : relativeSeconds,
        ss : relativeTimeWithPlural,
        m : relativeTimeWithSingular,
        mm : relativeTimeWithPlural,
        h : relativeTimeWithSingular,
        hh : relativeTimeWithPlural,
        d : relativeTimeWithSingular,
        dd : relativeTimeWithPlural,
        M : relativeTimeWithSingular,
        MM : relativeTimeWithPlural,
        y : relativeTimeWithSingular,
        yy : relativeTimeWithPlural
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lv;

})));


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        ss: ['sekund', 'sekunda', 'sekundi'],
        m: ['jedan minut', 'jednog minuta'],
        mm: ['minut', 'minuta', 'minuta'],
        h: ['jedan sat', 'jednog sata'],
        hh: ['sat', 'sata', 'sati'],
        dd: ['dan', 'dana', 'dana'],
        MM: ['mjesec', 'mjeseca', 'mjeseci'],
        yy: ['godina', 'godine', 'godina']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var me = moment.defineLocale('me', {
    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact : true,
    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[danas u] LT',
        nextDay: '[sjutra u] LT',

        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[juče u] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[prošle] [nedjelje] [u] LT',
                '[prošlog] [ponedjeljka] [u] LT',
                '[prošlog] [utorka] [u] LT',
                '[prošle] [srijede] [u] LT',
                '[prošlog] [četvrtka] [u] LT',
                '[prošlog] [petka] [u] LT',
                '[prošle] [subote] [u] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'nekoliko sekundi',
        ss     : translator.translate,
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'dan',
        dd     : translator.translate,
        M      : 'mjesec',
        MM     : translator.translate,
        y      : 'godinu',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return me;

})));


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mi = moment.defineLocale('mi', {
    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY [i] HH:mm',
        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
    },
    calendar: {
        sameDay: '[i teie mahana, i] LT',
        nextDay: '[apopo i] LT',
        nextWeek: 'dddd [i] LT',
        lastDay: '[inanahi i] LT',
        lastWeek: 'dddd [whakamutunga i] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'i roto i %s',
        past: '%s i mua',
        s: 'te hēkona ruarua',
        ss: '%d hēkona',
        m: 'he meneti',
        mm: '%d meneti',
        h: 'te haora',
        hh: '%d haora',
        d: 'he ra',
        dd: '%d ra',
        M: 'he marama',
        MM: '%d marama',
        y: 'he tau',
        yy: '%d tau'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return mi;

})));


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mk = moment.defineLocale('mk', {
    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'D.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay : '[Денес во] LT',
        nextDay : '[Утре во] LT',
        nextWeek : '[Во] dddd [во] LT',
        lastDay : '[Вчера во] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 6:
                    return '[Изминатата] dddd [во] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[Изминатиот] dddd [во] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'после %s',
        past : 'пред %s',
        s : 'неколку секунди',
        ss : '%d секунди',
        m : 'минута',
        mm : '%d минути',
        h : 'час',
        hh : '%d часа',
        d : 'ден',
        dd : '%d дена',
        M : 'месец',
        MM : '%d месеци',
        y : 'година',
        yy : '%d години'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
    ordinal : function (number) {
        var lastDigit = number % 10,
            last2Digits = number % 100;
        if (number === 0) {
            return number + '-ев';
        } else if (last2Digits === 0) {
            return number + '-ен';
        } else if (last2Digits > 10 && last2Digits < 20) {
            return number + '-ти';
        } else if (lastDigit === 1) {
            return number + '-ви';
        } else if (lastDigit === 2) {
            return number + '-ри';
        } else if (lastDigit === 7 || lastDigit === 8) {
            return number + '-ми';
        } else {
            return number + '-ти';
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return mk;

})));


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ml = moment.defineLocale('ml', {
    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
    monthsParseExact : true,
    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm -നു',
        LTS : 'A h:mm:ss -നു',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm -നു',
        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
    },
    calendar : {
        sameDay : '[ഇന്ന്] LT',
        nextDay : '[നാളെ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ഇന്നലെ] LT',
        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s കഴിഞ്ഞ്',
        past : '%s മുൻപ്',
        s : 'അൽപ നിമിഷങ്ങൾ',
        ss : '%d സെക്കൻഡ്',
        m : 'ഒരു മിനിറ്റ്',
        mm : '%d മിനിറ്റ്',
        h : 'ഒരു മണിക്കൂർ',
        hh : '%d മണിക്കൂർ',
        d : 'ഒരു ദിവസം',
        dd : '%d ദിവസം',
        M : 'ഒരു മാസം',
        MM : '%d മാസം',
        y : 'ഒരു വർഷം',
        yy : '%d വർഷം'
    },
    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'രാത്രി' && hour >= 4) ||
                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                meridiem === 'വൈകുന്നേരം') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'രാത്രി';
        } else if (hour < 12) {
            return 'രാവിലെ';
        } else if (hour < 17) {
            return 'ഉച്ച കഴിഞ്ഞ്';
        } else if (hour < 20) {
            return 'വൈകുന്നേരം';
        } else {
            return 'രാത്രി';
        }
    }
});

return ml;

})));


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

function relativeTimeMr(number, withoutSuffix, string, isFuture)
{
    var output = '';
    if (withoutSuffix) {
        switch (string) {
            case 's': output = 'काही सेकंद'; break;
            case 'ss': output = '%d सेकंद'; break;
            case 'm': output = 'एक मिनिट'; break;
            case 'mm': output = '%d मिनिटे'; break;
            case 'h': output = 'एक तास'; break;
            case 'hh': output = '%d तास'; break;
            case 'd': output = 'एक दिवस'; break;
            case 'dd': output = '%d दिवस'; break;
            case 'M': output = 'एक महिना'; break;
            case 'MM': output = '%d महिने'; break;
            case 'y': output = 'एक वर्ष'; break;
            case 'yy': output = '%d वर्षे'; break;
        }
    }
    else {
        switch (string) {
            case 's': output = 'काही सेकंदां'; break;
            case 'ss': output = '%d सेकंदां'; break;
            case 'm': output = 'एका मिनिटा'; break;
            case 'mm': output = '%d मिनिटां'; break;
            case 'h': output = 'एका तासा'; break;
            case 'hh': output = '%d तासां'; break;
            case 'd': output = 'एका दिवसा'; break;
            case 'dd': output = '%d दिवसां'; break;
            case 'M': output = 'एका महिन्या'; break;
            case 'MM': output = '%d महिन्यां'; break;
            case 'y': output = 'एका वर्षा'; break;
            case 'yy': output = '%d वर्षां'; break;
        }
    }
    return output.replace(/%d/i, number);
}

var mr = moment.defineLocale('mr', {
    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
    monthsParseExact : true,
    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
    longDateFormat : {
        LT : 'A h:mm वाजता',
        LTS : 'A h:mm:ss वाजता',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm वाजता',
        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[उद्या] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[काल] LT',
        lastWeek: '[मागील] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future: '%sमध्ये',
        past: '%sपूर्वी',
        s: relativeTimeMr,
        ss: relativeTimeMr,
        m: relativeTimeMr,
        mm: relativeTimeMr,
        h: relativeTimeMr,
        hh: relativeTimeMr,
        d: relativeTimeMr,
        dd: relativeTimeMr,
        M: relativeTimeMr,
        MM: relativeTimeMr,
        y: relativeTimeMr,
        yy: relativeTimeMr
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'रात्री') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'सकाळी') {
            return hour;
        } else if (meridiem === 'दुपारी') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'सायंकाळी') {
            return hour + 12;
        }
    },
    meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
            return 'रात्री';
        } else if (hour < 10) {
            return 'सकाळी';
        } else if (hour < 17) {
            return 'दुपारी';
        } else if (hour < 20) {
            return 'सायंकाळी';
        } else {
            return 'रात्री';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return mr;

})));


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var msMy = moment.defineLocale('ms-my', {
    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|tengahari|petang|malam/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'tengahari') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'petang' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'tengahari';
        } else if (hours < 19) {
            return 'petang';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Esok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kelmarin pukul] LT',
        lastWeek : 'dddd [lepas pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lepas',
        s : 'beberapa saat',
        ss : '%d saat',
        m : 'seminit',
        mm : '%d minit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return msMy;

})));


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ms = moment.defineLocale('ms', {
    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|tengahari|petang|malam/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'tengahari') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'petang' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'tengahari';
        } else if (hours < 19) {
            return 'petang';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Esok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kelmarin pukul] LT',
        lastWeek : 'dddd [lepas pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lepas',
        s : 'beberapa saat',
        ss : '%d saat',
        m : 'seminit',
        mm : '%d minit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ms;

})));


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maltese (Malta) [mt]
//! author : Alessandro Maruccia : https://github.com/alesma

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mt = moment.defineLocale('mt', {
    months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
    monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
    weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
    weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
    weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Illum fil-]LT',
        nextDay : '[Għada fil-]LT',
        nextWeek : 'dddd [fil-]LT',
        lastDay : '[Il-bieraħ fil-]LT',
        lastWeek : 'dddd [li għadda] [fil-]LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'f’ %s',
        past : '%s ilu',
        s : 'ftit sekondi',
        ss : '%d sekondi',
        m : 'minuta',
        mm : '%d minuti',
        h : 'siegħa',
        hh : '%d siegħat',
        d : 'ġurnata',
        dd : '%d ġranet',
        M : 'xahar',
        MM : '%d xhur',
        y : 'sena',
        yy : '%d sni'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return mt;

})));


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '၁',
    '2': '၂',
    '3': '၃',
    '4': '၄',
    '5': '၅',
    '6': '၆',
    '7': '၇',
    '8': '၈',
    '9': '၉',
    '0': '၀'
};
var numberMap = {
    '၁': '1',
    '၂': '2',
    '၃': '3',
    '၄': '4',
    '၅': '5',
    '၆': '6',
    '၇': '7',
    '၈': '8',
    '၉': '9',
    '၀': '0'
};

var my = moment.defineLocale('my', {
    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[ယနေ.] LT [မှာ]',
        nextDay: '[မနက်ဖြန်] LT [မှာ]',
        nextWeek: 'dddd LT [မှာ]',
        lastDay: '[မနေ.က] LT [မှာ]',
        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'လာမည့် %s မှာ',
        past: 'လွန်ခဲ့သော %s က',
        s: 'စက္ကန်.အနည်းငယ်',
        ss : '%d စက္ကန့်',
        m: 'တစ်မိနစ်',
        mm: '%d မိနစ်',
        h: 'တစ်နာရီ',
        hh: '%d နာရီ',
        d: 'တစ်ရက်',
        dd: '%d ရက်',
        M: 'တစ်လ',
        MM: '%d လ',
        y: 'တစ်နှစ်',
        yy: '%d နှစ်'
    },
    preparse: function (string) {
        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 1st is the first week of the year.
    }
});

return my;

})));


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var nb = moment.defineLocale('nb', {
    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
    monthsParseExact : true,
    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] HH:mm',
        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay: '[i dag kl.] LT',
        nextDay: '[i morgen kl.] LT',
        nextWeek: 'dddd [kl.] LT',
        lastDay: '[i går kl.] LT',
        lastWeek: '[forrige] dddd [kl.] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s siden',
        s : 'noen sekunder',
        ss : '%d sekunder',
        m : 'ett minutt',
        mm : '%d minutter',
        h : 'en time',
        hh : '%d timer',
        d : 'en dag',
        dd : '%d dager',
        M : 'en måned',
        MM : '%d måneder',
        y : 'ett år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nb;

})));


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

var ne = moment.defineLocale('ne', {
    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
    monthsParseExact : true,
    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'Aको h:mm बजे',
        LTS : 'Aको h:mm:ss बजे',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, Aको h:mm बजे',
        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'राति') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'बिहान') {
            return hour;
        } else if (meridiem === 'दिउँसो') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'साँझ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 3) {
            return 'राति';
        } else if (hour < 12) {
            return 'बिहान';
        } else if (hour < 16) {
            return 'दिउँसो';
        } else if (hour < 20) {
            return 'साँझ';
        } else {
            return 'राति';
        }
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[भोलि] LT',
        nextWeek : '[आउँदो] dddd[,] LT',
        lastDay : '[हिजो] LT',
        lastWeek : '[गएको] dddd[,] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%sमा',
        past : '%s अगाडि',
        s : 'केही क्षण',
        ss : '%d सेकेण्ड',
        m : 'एक मिनेट',
        mm : '%d मिनेट',
        h : 'एक घण्टा',
        hh : '%d घण्टा',
        d : 'एक दिन',
        dd : '%d दिन',
        M : 'एक महिना',
        MM : '%d महिना',
        y : 'एक बर्ष',
        yy : '%d बर्ष'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return ne;

})));


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

var nlBe = moment.defineLocale('nl-be', {
    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },

    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[vandaag om] LT',
        nextDay: '[morgen om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[gisteren om] LT',
        lastWeek: '[afgelopen] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'over %s',
        past : '%s geleden',
        s : 'een paar seconden',
        ss : '%d seconden',
        m : 'één minuut',
        mm : '%d minuten',
        h : 'één uur',
        hh : '%d uur',
        d : 'één dag',
        dd : '%d dagen',
        M : 'één maand',
        MM : '%d maanden',
        y : 'één jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nlBe;

})));


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

var nl = moment.defineLocale('nl', {
    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },

    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[vandaag om] LT',
        nextDay: '[morgen om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[gisteren om] LT',
        lastWeek: '[afgelopen] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'over %s',
        past : '%s geleden',
        s : 'een paar seconden',
        ss : '%d seconden',
        m : 'één minuut',
        mm : '%d minuten',
        h : 'één uur',
        hh : '%d uur',
        d : 'één dag',
        dd : '%d dagen',
        M : 'één maand',
        MM : '%d maanden',
        y : 'één jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nl;

})));


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! author : https://github.com/mechuwind

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var nn = moment.defineLocale('nn', {
    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] H:mm',
        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay: '[I dag klokka] LT',
        nextDay: '[I morgon klokka] LT',
        nextWeek: 'dddd [klokka] LT',
        lastDay: '[I går klokka] LT',
        lastWeek: '[Føregåande] dddd [klokka] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s sidan',
        s : 'nokre sekund',
        ss : '%d sekund',
        m : 'eit minutt',
        mm : '%d minutt',
        h : 'ein time',
        hh : '%d timar',
        d : 'ein dag',
        dd : '%d dagar',
        M : 'ein månad',
        MM : '%d månader',
        y : 'eit år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nn;

})));


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '੧',
    '2': '੨',
    '3': '੩',
    '4': '੪',
    '5': '੫',
    '6': '੬',
    '7': '੭',
    '8': '੮',
    '9': '੯',
    '0': '੦'
};
var numberMap = {
    '੧': '1',
    '੨': '2',
    '੩': '3',
    '੪': '4',
    '੫': '5',
    '੬': '6',
    '੭': '7',
    '੮': '8',
    '੯': '9',
    '੦': '0'
};

var paIn = moment.defineLocale('pa-in', {
    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm ਵਜੇ',
        LTS : 'A h:mm:ss ਵਜੇ',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
    },
    calendar : {
        sameDay : '[ਅਜ] LT',
        nextDay : '[ਕਲ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ਕਲ] LT',
        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ਵਿੱਚ',
        past : '%s ਪਿਛਲੇ',
        s : 'ਕੁਝ ਸਕਿੰਟ',
        ss : '%d ਸਕਿੰਟ',
        m : 'ਇਕ ਮਿੰਟ',
        mm : '%d ਮਿੰਟ',
        h : 'ਇੱਕ ਘੰਟਾ',
        hh : '%d ਘੰਟੇ',
        d : 'ਇੱਕ ਦਿਨ',
        dd : '%d ਦਿਨ',
        M : 'ਇੱਕ ਮਹੀਨਾ',
        MM : '%d ਮਹੀਨੇ',
        y : 'ਇੱਕ ਸਾਲ',
        yy : '%d ਸਾਲ'
    },
    preparse: function (string) {
        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ਰਾਤ') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ਸਵੇਰ') {
            return hour;
        } else if (meridiem === 'ਦੁਪਹਿਰ') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'ਸ਼ਾਮ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ਰਾਤ';
        } else if (hour < 10) {
            return 'ਸਵੇਰ';
        } else if (hour < 17) {
            return 'ਦੁਪਹਿਰ';
        } else if (hour < 20) {
            return 'ਸ਼ਾਮ';
        } else {
            return 'ਰਾਤ';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return paIn;

})));


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
function plural(n) {
    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
}
function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'ss':
            return result + (plural(number) ? 'sekundy' : 'sekund');
        case 'm':
            return withoutSuffix ? 'minuta' : 'minutę';
        case 'mm':
            return result + (plural(number) ? 'minuty' : 'minut');
        case 'h':
            return withoutSuffix  ? 'godzina'  : 'godzinę';
        case 'hh':
            return result + (plural(number) ? 'godziny' : 'godzin');
        case 'MM':
            return result + (plural(number) ? 'miesiące' : 'miesięcy');
        case 'yy':
            return result + (plural(number) ? 'lata' : 'lat');
    }
}

var pl = moment.defineLocale('pl', {
    months : function (momentToFormat, format) {
        if (!momentToFormat) {
            return monthsNominative;
        } else if (format === '') {
            // Hack: if format empty we know this is used to generate
            // RegExp by moment. Give then back both valid forms of months
            // in RegExp ready format.
            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
        } else if (/D MMMM/.test(format)) {
            return monthsSubjective[momentToFormat.month()];
        } else {
            return monthsNominative[momentToFormat.month()];
        }
    },
    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Dziś o] LT',
        nextDay: '[Jutro o] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[W niedzielę o] LT';

                case 2:
                    return '[We wtorek o] LT';

                case 3:
                    return '[W środę o] LT';

                case 6:
                    return '[W sobotę o] LT';

                default:
                    return '[W] dddd [o] LT';
            }
        },
        lastDay: '[Wczoraj o] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[W zeszłą niedzielę o] LT';
                case 3:
                    return '[W zeszłą środę o] LT';
                case 6:
                    return '[W zeszłą sobotę o] LT';
                default:
                    return '[W zeszły] dddd [o] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : '%s temu',
        s : 'kilka sekund',
        ss : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : '1 dzień',
        dd : '%d dni',
        M : 'miesiąc',
        MM : translate,
        y : 'rok',
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return pl;

})));


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ptBr = moment.defineLocale('pt-br', {
    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
    },
    calendar : {
        sameDay: '[Hoje às] LT',
        nextDay: '[Amanhã às] LT',
        nextWeek: 'dddd [às] LT',
        lastDay: '[Ontem às] LT',
        lastWeek: function () {
            return (this.day() === 0 || this.day() === 6) ?
                '[Último] dddd [às] LT' : // Saturday + Sunday
                '[Última] dddd [às] LT'; // Monday - Friday
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'em %s',
        past : '%s atrás',
        s : 'poucos segundos',
        ss : '%d segundos',
        m : 'um minuto',
        mm : '%d minutos',
        h : 'uma hora',
        hh : '%d horas',
        d : 'um dia',
        dd : '%d dias',
        M : 'um mês',
        MM : '%d meses',
        y : 'um ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal : '%dº'
});

return ptBr;

})));


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var pt = moment.defineLocale('pt', {
    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY HH:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Hoje às] LT',
        nextDay: '[Amanhã às] LT',
        nextWeek: 'dddd [às] LT',
        lastDay: '[Ontem às] LT',
        lastWeek: function () {
            return (this.day() === 0 || this.day() === 6) ?
                '[Último] dddd [às] LT' : // Saturday + Sunday
                '[Última] dddd [às] LT'; // Monday - Friday
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'em %s',
        past : 'há %s',
        s : 'segundos',
        ss : '%d segundos',
        m : 'um minuto',
        mm : '%d minutos',
        h : 'uma hora',
        hh : '%d horas',
        d : 'um dia',
        dd : '%d dias',
        M : 'um mês',
        MM : '%d meses',
        y : 'um ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return pt;

})));


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
            'ss': 'secunde',
            'mm': 'minute',
            'hh': 'ore',
            'dd': 'zile',
            'MM': 'luni',
            'yy': 'ani'
        },
        separator = ' ';
    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
        separator = ' de ';
    }
    return number + separator + format[key];
}

var ro = moment.defineLocale('ro', {
    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay: '[azi la] LT',
        nextDay: '[mâine la] LT',
        nextWeek: 'dddd [la] LT',
        lastDay: '[ieri la] LT',
        lastWeek: '[fosta] dddd [la] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'peste %s',
        past : '%s în urmă',
        s : 'câteva secunde',
        ss : relativeTimeWithPlural,
        m : 'un minut',
        mm : relativeTimeWithPlural,
        h : 'o oră',
        hh : relativeTimeWithPlural,
        d : 'o zi',
        dd : relativeTimeWithPlural,
        M : 'o lună',
        MM : relativeTimeWithPlural,
        y : 'un an',
        yy : relativeTimeWithPlural
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ro;

})));


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! Author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
        'hh': 'час_часа_часов',
        'dd': 'день_дня_дней',
        'MM': 'месяц_месяца_месяцев',
        'yy': 'год_года_лет'
    };
    if (key === 'm') {
        return withoutSuffix ? 'минута' : 'минуту';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}
var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];

// http://new.gramota.ru/spravka/rules/139-prop : § 103
// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
var ru = moment.defineLocale('ru', {
    months : {
        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
    },
    monthsShort : {
        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
    },
    weekdays : {
        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
    },
    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

    // копия предыдущего
    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

    // полные названия с падежами
    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

    // Выражение, которое соотвествует только сокращённым формам
    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY г.',
        LLL : 'D MMMM YYYY г., H:mm',
        LLLL : 'dddd, D MMMM YYYY г., H:mm'
    },
    calendar : {
        sameDay: '[Сегодня в] LT',
        nextDay: '[Завтра в] LT',
        lastDay: '[Вчера в] LT',
        nextWeek: function (now) {
            if (now.week() !== this.week()) {
                switch (this.day()) {
                    case 0:
                        return '[В следующее] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[В следующий] dddd [в] LT';
                    case 3:
                    case 5:
                    case 6:
                        return '[В следующую] dddd [в] LT';
                }
            } else {
                if (this.day() === 2) {
                    return '[Во] dddd [в] LT';
                } else {
                    return '[В] dddd [в] LT';
                }
            }
        },
        lastWeek: function (now) {
            if (now.week() !== this.week()) {
                switch (this.day()) {
                    case 0:
                        return '[В прошлое] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[В прошлый] dddd [в] LT';
                    case 3:
                    case 5:
                    case 6:
                        return '[В прошлую] dddd [в] LT';
                }
            } else {
                if (this.day() === 2) {
                    return '[Во] dddd [в] LT';
                } else {
                    return '[В] dddd [в] LT';
                }
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'через %s',
        past : '%s назад',
        s : 'несколько секунд',
        ss : relativeTimeWithPlural,
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : 'час',
        hh : relativeTimeWithPlural,
        d : 'день',
        dd : relativeTimeWithPlural,
        M : 'месяц',
        MM : relativeTimeWithPlural,
        y : 'год',
        yy : relativeTimeWithPlural
    },
    meridiemParse: /ночи|утра|дня|вечера/i,
    isPM : function (input) {
        return /^(дня|вечера)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночи';
        } else if (hour < 12) {
            return 'утра';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечера';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
                return number + '-й';
            case 'D':
                return number + '-го';
            case 'w':
            case 'W':
                return number + '-я';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ru;

})));


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sindhi [sd]
//! author : Narain Sagar : https://github.com/narainsagar

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'جنوري',
    'فيبروري',
    'مارچ',
    'اپريل',
    'مئي',
    'جون',
    'جولاءِ',
    'آگسٽ',
    'سيپٽمبر',
    'آڪٽوبر',
    'نومبر',
    'ڊسمبر'
];
var days = [
    'آچر',
    'سومر',
    'اڱارو',
    'اربع',
    'خميس',
    'جمع',
    'ڇنڇر'
];

var sd = moment.defineLocale('sd', {
    months : months,
    monthsShort : months,
    weekdays : days,
    weekdaysShort : days,
    weekdaysMin : days,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd، D MMMM YYYY HH:mm'
    },
    meridiemParse: /صبح|شام/,
    isPM : function (input) {
        return 'شام' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'صبح';
        }
        return 'شام';
    },
    calendar : {
        sameDay : '[اڄ] LT',
        nextDay : '[سڀاڻي] LT',
        nextWeek : 'dddd [اڳين هفتي تي] LT',
        lastDay : '[ڪالهه] LT',
        lastWeek : '[گزريل هفتي] dddd [تي] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s پوء',
        past : '%s اڳ',
        s : 'چند سيڪنڊ',
        ss : '%d سيڪنڊ',
        m : 'هڪ منٽ',
        mm : '%d منٽ',
        h : 'هڪ ڪلاڪ',
        hh : '%d ڪلاڪ',
        d : 'هڪ ڏينهن',
        dd : '%d ڏينهن',
        M : 'هڪ مهينو',
        MM : '%d مهينا',
        y : 'هڪ سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sd;

})));


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var se = moment.defineLocale('se', {
    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'MMMM D. [b.] YYYY',
        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
    },
    calendar : {
        sameDay: '[otne ti] LT',
        nextDay: '[ihttin ti] LT',
        nextWeek: 'dddd [ti] LT',
        lastDay: '[ikte ti] LT',
        lastWeek: '[ovddit] dddd [ti] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s geažes',
        past : 'maŋit %s',
        s : 'moadde sekunddat',
        ss: '%d sekunddat',
        m : 'okta minuhta',
        mm : '%d minuhtat',
        h : 'okta diimmu',
        hh : '%d diimmut',
        d : 'okta beaivi',
        dd : '%d beaivvit',
        M : 'okta mánnu',
        MM : '%d mánut',
        y : 'okta jahki',
        yy : '%d jagit'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return se;

})));


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


/*jshint -W100*/
var si = moment.defineLocale('si', {
    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'a h:mm',
        LTS : 'a h:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY MMMM D',
        LLL : 'YYYY MMMM D, a h:mm',
        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
    },
    calendar : {
        sameDay : '[අද] LT[ට]',
        nextDay : '[හෙට] LT[ට]',
        nextWeek : 'dddd LT[ට]',
        lastDay : '[ඊයේ] LT[ට]',
        lastWeek : '[පසුගිය] dddd LT[ට]',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%sකින්',
        past : '%sකට පෙර',
        s : 'තත්පර කිහිපය',
        ss : 'තත්පර %d',
        m : 'මිනිත්තුව',
        mm : 'මිනිත්තු %d',
        h : 'පැය',
        hh : 'පැය %d',
        d : 'දිනය',
        dd : 'දින %d',
        M : 'මාසය',
        MM : 'මාස %d',
        y : 'වසර',
        yy : 'වසර %d'
    },
    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
    ordinal : function (number) {
        return number + ' වැනි';
    },
    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
    isPM : function (input) {
        return input === 'ප.ව.' || input === 'පස් වරු';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'ප.ව.' : 'පස් වරු';
        } else {
            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
        }
    }
});

return si;

})));


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
function plural(n) {
    return (n > 1) && (n < 5);
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':  // a few seconds / in a few seconds / a few seconds ago
            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
        case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'sekundy' : 'sekúnd');
            } else {
                return result + 'sekundami';
            }
            break;
        case 'm':  // a minute / in a minute / a minute ago
            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'minúty' : 'minút');
            } else {
                return result + 'minútami';
            }
            break;
        case 'h':  // an hour / in an hour / an hour ago
            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
        case 'hh': // 9 hours / in 9 hours / 9 hours ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'hodiny' : 'hodín');
            } else {
                return result + 'hodinami';
            }
            break;
        case 'd':  // a day / in a day / a day ago
            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
        case 'dd': // 9 days / in 9 days / 9 days ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'dni' : 'dní');
            } else {
                return result + 'dňami';
            }
            break;
        case 'M':  // a month / in a month / a month ago
            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
        case 'MM': // 9 months / in 9 months / 9 months ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'mesiace' : 'mesiacov');
            } else {
                return result + 'mesiacmi';
            }
            break;
        case 'y':  // a year / in a year / a year ago
            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
        case 'yy': // 9 years / in 9 years / 9 years ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'roky' : 'rokov');
            } else {
                return result + 'rokmi';
            }
            break;
    }
}

var sk = moment.defineLocale('sk', {
    months : months,
    monthsShort : monthsShort,
    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
    longDateFormat : {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay: '[dnes o] LT',
        nextDay: '[zajtra o] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[v nedeľu o] LT';
                case 1:
                case 2:
                    return '[v] dddd [o] LT';
                case 3:
                    return '[v stredu o] LT';
                case 4:
                    return '[vo štvrtok o] LT';
                case 5:
                    return '[v piatok o] LT';
                case 6:
                    return '[v sobotu o] LT';
            }
        },
        lastDay: '[včera o] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[minulú nedeľu o] LT';
                case 1:
                case 2:
                    return '[minulý] dddd [o] LT';
                case 3:
                    return '[minulú stredu o] LT';
                case 4:
                case 5:
                    return '[minulý] dddd [o] LT';
                case 6:
                    return '[minulú sobotu o] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : 'pred %s',
        s : translate,
        ss : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sk;

})));


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':
            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
        case 'ss':
            if (number === 1) {
                result += withoutSuffix ? 'sekundo' : 'sekundi';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
            } else {
                result += withoutSuffix || isFuture ? 'sekund' : 'sekund';
            }
            return result;
        case 'm':
            return withoutSuffix ? 'ena minuta' : 'eno minuto';
        case 'mm':
            if (number === 1) {
                result += withoutSuffix ? 'minuta' : 'minuto';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
            } else {
                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'ena ura' : 'eno uro';
        case 'hh':
            if (number === 1) {
                result += withoutSuffix ? 'ura' : 'uro';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'uri' : 'urama';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'ure' : 'urami';
            } else {
                result += withoutSuffix || isFuture ? 'ur' : 'urami';
            }
            return result;
        case 'd':
            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
        case 'dd':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
            } else {
                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
            }
            return result;
        case 'M':
            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
        case 'MM':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
            } else {
                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
            }
            return result;
        case 'y':
            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
        case 'yy':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'leto' : 'letom';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'leta' : 'leti';
            } else {
                result += withoutSuffix || isFuture ? 'let' : 'leti';
            }
            return result;
    }
}

var sl = moment.defineLocale('sl', {
    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danes ob] LT',
        nextDay  : '[jutri ob] LT',

        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[v] [nedeljo] [ob] LT';
                case 3:
                    return '[v] [sredo] [ob] LT';
                case 6:
                    return '[v] [soboto] [ob] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[v] dddd [ob] LT';
            }
        },
        lastDay  : '[včeraj ob] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[prejšnjo] [nedeljo] [ob] LT';
                case 3:
                    return '[prejšnjo] [sredo] [ob] LT';
                case 6:
                    return '[prejšnjo] [soboto] [ob] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prejšnji] dddd [ob] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'čez %s',
        past   : 'pred %s',
        s      : processRelativeTime,
        ss     : processRelativeTime,
        m      : processRelativeTime,
        mm     : processRelativeTime,
        h      : processRelativeTime,
        hh     : processRelativeTime,
        d      : processRelativeTime,
        dd     : processRelativeTime,
        M      : processRelativeTime,
        MM     : processRelativeTime,
        y      : processRelativeTime,
        yy     : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sl;

})));


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sq = moment.defineLocale('sq', {
    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
    weekdaysParseExact : true,
    meridiemParse: /PD|MD/,
    isPM: function (input) {
        return input.charAt(0) === 'M';
    },
    meridiem : function (hours, minutes, isLower) {
        return hours < 12 ? 'PD' : 'MD';
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Sot në] LT',
        nextDay : '[Nesër në] LT',
        nextWeek : 'dddd [në] LT',
        lastDay : '[Dje në] LT',
        lastWeek : 'dddd [e kaluar në] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'në %s',
        past : '%s më parë',
        s : 'disa sekonda',
        ss : '%d sekonda',
        m : 'një minutë',
        mm : '%d minuta',
        h : 'një orë',
        hh : '%d orë',
        d : 'një ditë',
        dd : '%d ditë',
        M : 'një muaj',
        MM : '%d muaj',
        y : 'një vit',
        yy : '%d vite'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sq;

})));


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        ss: ['секунда', 'секунде', 'секунди'],
        m: ['један минут', 'једне минуте'],
        mm: ['минут', 'минуте', 'минута'],
        h: ['један сат', 'једног сата'],
        hh: ['сат', 'сата', 'сати'],
        dd: ['дан', 'дана', 'дана'],
        MM: ['месец', 'месеца', 'месеци'],
        yy: ['година', 'године', 'година']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var srCyrl = moment.defineLocale('sr-cyrl', {
    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
    monthsParseExact: true,
    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[данас у] LT',
        nextDay: '[сутра у] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[у] [недељу] [у] LT';
                case 3:
                    return '[у] [среду] [у] LT';
                case 6:
                    return '[у] [суботу] [у] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[у] dddd [у] LT';
            }
        },
        lastDay  : '[јуче у] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[прошле] [недеље] [у] LT',
                '[прошлог] [понедељка] [у] LT',
                '[прошлог] [уторка] [у] LT',
                '[прошле] [среде] [у] LT',
                '[прошлог] [четвртка] [у] LT',
                '[прошлог] [петка] [у] LT',
                '[прошле] [суботе] [у] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'за %s',
        past   : 'пре %s',
        s      : 'неколико секунди',
        ss     : translator.translate,
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'дан',
        dd     : translator.translate,
        M      : 'месец',
        MM     : translator.translate,
        y      : 'годину',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return srCyrl;

})));


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        ss: ['sekunda', 'sekunde', 'sekundi'],
        m: ['jedan minut', 'jedne minute'],
        mm: ['minut', 'minute', 'minuta'],
        h: ['jedan sat', 'jednog sata'],
        hh: ['sat', 'sata', 'sati'],
        dd: ['dan', 'dana', 'dana'],
        MM: ['mesec', 'meseca', 'meseci'],
        yy: ['godina', 'godine', 'godina']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var sr = moment.defineLocale('sr', {
    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[danas u] LT',
        nextDay: '[sutra u] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedelju] [u] LT';
                case 3:
                    return '[u] [sredu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[juče u] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[prošle] [nedelje] [u] LT',
                '[prošlog] [ponedeljka] [u] LT',
                '[prošlog] [utorka] [u] LT',
                '[prošle] [srede] [u] LT',
                '[prošlog] [četvrtka] [u] LT',
                '[prošlog] [petka] [u] LT',
                '[prošle] [subote] [u] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'pre %s',
        s      : 'nekoliko sekundi',
        ss     : translator.translate,
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'dan',
        dd     : translator.translate,
        M      : 'mesec',
        MM     : translator.translate,
        y      : 'godinu',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sr;

})));


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var ss = moment.defineLocale('ss', {
    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Namuhla nga] LT',
        nextDay : '[Kusasa nga] LT',
        nextWeek : 'dddd [nga] LT',
        lastDay : '[Itolo nga] LT',
        lastWeek : 'dddd [leliphelile] [nga] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'nga %s',
        past : 'wenteka nga %s',
        s : 'emizuzwana lomcane',
        ss : '%d mzuzwana',
        m : 'umzuzu',
        mm : '%d emizuzu',
        h : 'lihora',
        hh : '%d emahora',
        d : 'lilanga',
        dd : '%d emalanga',
        M : 'inyanga',
        MM : '%d tinyanga',
        y : 'umnyaka',
        yy : '%d iminyaka'
    },
    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'ekuseni';
        } else if (hours < 15) {
            return 'emini';
        } else if (hours < 19) {
            return 'entsambama';
        } else {
            return 'ebusuku';
        }
    },
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ekuseni') {
            return hour;
        } else if (meridiem === 'emini') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
            if (hour === 0) {
                return 0;
            }
            return hour + 12;
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : '%d',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ss;

})));


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sv = moment.defineLocale('sv', {
    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [kl.] HH:mm',
        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Idag] LT',
        nextDay: '[Imorgon] LT',
        lastDay: '[Igår] LT',
        nextWeek: '[På] dddd LT',
        lastWeek: '[I] dddd[s] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : 'för %s sedan',
        s : 'några sekunder',
        ss : '%d sekunder',
        m : 'en minut',
        mm : '%d minuter',
        h : 'en timme',
        hh : '%d timmar',
        d : 'en dag',
        dd : '%d dagar',
        M : 'en månad',
        MM : '%d månader',
        y : 'ett år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'e' :
            (b === 1) ? 'a' :
            (b === 2) ? 'a' :
            (b === 3) ? 'e' : 'e';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sv;

})));


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sw = moment.defineLocale('sw', {
    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[leo saa] LT',
        nextDay : '[kesho saa] LT',
        nextWeek : '[wiki ijayo] dddd [saat] LT',
        lastDay : '[jana] LT',
        lastWeek : '[wiki iliyopita] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s baadaye',
        past : 'tokea %s',
        s : 'hivi punde',
        ss : 'sekunde %d',
        m : 'dakika moja',
        mm : 'dakika %d',
        h : 'saa limoja',
        hh : 'masaa %d',
        d : 'siku moja',
        dd : 'masiku %d',
        M : 'mwezi mmoja',
        MM : 'miezi %d',
        y : 'mwaka mmoja',
        yy : 'miaka %d'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sw;

})));


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '௧',
    '2': '௨',
    '3': '௩',
    '4': '௪',
    '5': '௫',
    '6': '௬',
    '7': '௭',
    '8': '௮',
    '9': '௯',
    '0': '௦'
};
var numberMap = {
    '௧': '1',
    '௨': '2',
    '௩': '3',
    '௪': '4',
    '௫': '5',
    '௬': '6',
    '௭': '7',
    '௮': '8',
    '௯': '9',
    '௦': '0'
};

var ta = moment.defineLocale('ta', {
    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, HH:mm',
        LLLL : 'dddd, D MMMM YYYY, HH:mm'
    },
    calendar : {
        sameDay : '[இன்று] LT',
        nextDay : '[நாளை] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[நேற்று] LT',
        lastWeek : '[கடந்த வாரம்] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s இல்',
        past : '%s முன்',
        s : 'ஒரு சில விநாடிகள்',
        ss : '%d விநாடிகள்',
        m : 'ஒரு நிமிடம்',
        mm : '%d நிமிடங்கள்',
        h : 'ஒரு மணி நேரம்',
        hh : '%d மணி நேரம்',
        d : 'ஒரு நாள்',
        dd : '%d நாட்கள்',
        M : 'ஒரு மாதம்',
        MM : '%d மாதங்கள்',
        y : 'ஒரு வருடம்',
        yy : '%d ஆண்டுகள்'
    },
    dayOfMonthOrdinalParse: /\d{1,2}வது/,
    ordinal : function (number) {
        return number + 'வது';
    },
    preparse: function (string) {
        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // refer http://ta.wikipedia.org/s/1er1
    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
    meridiem : function (hour, minute, isLower) {
        if (hour < 2) {
            return ' யாமம்';
        } else if (hour < 6) {
            return ' வைகறை';  // வைகறை
        } else if (hour < 10) {
            return ' காலை'; // காலை
        } else if (hour < 14) {
            return ' நண்பகல்'; // நண்பகல்
        } else if (hour < 18) {
            return ' எற்பாடு'; // எற்பாடு
        } else if (hour < 22) {
            return ' மாலை'; // மாலை
        } else {
            return ' யாமம்';
        }
    },
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'யாமம்') {
            return hour < 2 ? hour : hour + 12;
        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
            return hour;
        } else if (meridiem === 'நண்பகல்') {
            return hour >= 10 ? hour : hour + 12;
        } else {
            return hour + 12;
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return ta;

})));


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var te = moment.defineLocale('te', {
    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
    monthsParseExact : true,
    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[నేడు] LT',
        nextDay : '[రేపు] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[నిన్న] LT',
        lastWeek : '[గత] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s లో',
        past : '%s క్రితం',
        s : 'కొన్ని క్షణాలు',
        ss : '%d సెకన్లు',
        m : 'ఒక నిమిషం',
        mm : '%d నిమిషాలు',
        h : 'ఒక గంట',
        hh : '%d గంటలు',
        d : 'ఒక రోజు',
        dd : '%d రోజులు',
        M : 'ఒక నెల',
        MM : '%d నెలలు',
        y : 'ఒక సంవత్సరం',
        yy : '%d సంవత్సరాలు'
    },
    dayOfMonthOrdinalParse : /\d{1,2}వ/,
    ordinal : '%dవ',
    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'రాత్రి') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ఉదయం') {
            return hour;
        } else if (meridiem === 'మధ్యాహ్నం') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'సాయంత్రం') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'రాత్రి';
        } else if (hour < 10) {
            return 'ఉదయం';
        } else if (hour < 17) {
            return 'మధ్యాహ్నం';
        } else if (hour < 20) {
            return 'సాయంత్రం';
        } else {
            return 'రాత్రి';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return te;

})));


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tetun Dili (East Timor) [tet]
//! author : Joshua Brooks : https://github.com/joshbrooks
//! author : Onorio De J. Afonso : https://github.com/marobo

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tet = moment.defineLocale('tet', {
    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Ohin iha] LT',
        nextDay: '[Aban iha] LT',
        nextWeek: 'dddd [iha] LT',
        lastDay: '[Horiseik iha] LT',
        lastWeek: 'dddd [semana kotuk] [iha] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'iha %s',
        past : '%s liuba',
        s : 'minutu balun',
        ss : 'minutu %d',
        m : 'minutu ida',
        mm : 'minutus %d',
        h : 'horas ida',
        hh : 'horas %d',
        d : 'loron ida',
        dd : 'loron %d',
        M : 'fulan ida',
        MM : 'fulan %d',
        y : 'tinan ida',
        yy : 'tinan %d'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tet;

})));


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var th = moment.defineLocale('th', {
    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
    monthsParseExact: true,
    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY เวลา H:mm',
        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
    },
    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
    isPM: function (input) {
        return input === 'หลังเที่ยง';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ก่อนเที่ยง';
        } else {
            return 'หลังเที่ยง';
        }
    },
    calendar : {
        sameDay : '[วันนี้ เวลา] LT',
        nextDay : '[พรุ่งนี้ เวลา] LT',
        nextWeek : 'dddd[หน้า เวลา] LT',
        lastDay : '[เมื่อวานนี้ เวลา] LT',
        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'อีก %s',
        past : '%sที่แล้ว',
        s : 'ไม่กี่วินาที',
        ss : '%d วินาที',
        m : '1 นาที',
        mm : '%d นาที',
        h : '1 ชั่วโมง',
        hh : '%d ชั่วโมง',
        d : '1 วัน',
        dd : '%d วัน',
        M : '1 เดือน',
        MM : '%d เดือน',
        y : '1 ปี',
        yy : '%d ปี'
    }
});

return th;

})));


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tlPh = moment.defineLocale('tl-ph', {
    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'MM/D/YYYY',
        LL : 'MMMM D, YYYY',
        LLL : 'MMMM D, YYYY HH:mm',
        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
    },
    calendar : {
        sameDay: 'LT [ngayong araw]',
        nextDay: '[Bukas ng] LT',
        nextWeek: 'LT [sa susunod na] dddd',
        lastDay: 'LT [kahapon]',
        lastWeek: 'LT [noong nakaraang] dddd',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'sa loob ng %s',
        past : '%s ang nakalipas',
        s : 'ilang segundo',
        ss : '%d segundo',
        m : 'isang minuto',
        mm : '%d minuto',
        h : 'isang oras',
        hh : '%d oras',
        d : 'isang araw',
        dd : '%d araw',
        M : 'isang buwan',
        MM : '%d buwan',
        y : 'isang taon',
        yy : '%d taon'
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : function (number) {
        return number;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tlPh;

})));


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

function translateFuture(output) {
    var time = output;
    time = (output.indexOf('jaj') !== -1) ?
    time.slice(0, -3) + 'leS' :
    (output.indexOf('jar') !== -1) ?
    time.slice(0, -3) + 'waQ' :
    (output.indexOf('DIS') !== -1) ?
    time.slice(0, -3) + 'nem' :
    time + ' pIq';
    return time;
}

function translatePast(output) {
    var time = output;
    time = (output.indexOf('jaj') !== -1) ?
    time.slice(0, -3) + 'Hu’' :
    (output.indexOf('jar') !== -1) ?
    time.slice(0, -3) + 'wen' :
    (output.indexOf('DIS') !== -1) ?
    time.slice(0, -3) + 'ben' :
    time + ' ret';
    return time;
}

function translate(number, withoutSuffix, string, isFuture) {
    var numberNoun = numberAsNoun(number);
    switch (string) {
        case 'ss':
            return numberNoun + ' lup';
        case 'mm':
            return numberNoun + ' tup';
        case 'hh':
            return numberNoun + ' rep';
        case 'dd':
            return numberNoun + ' jaj';
        case 'MM':
            return numberNoun + ' jar';
        case 'yy':
            return numberNoun + ' DIS';
    }
}

function numberAsNoun(number) {
    var hundred = Math.floor((number % 1000) / 100),
    ten = Math.floor((number % 100) / 10),
    one = number % 10,
    word = '';
    if (hundred > 0) {
        word += numbersNouns[hundred] + 'vatlh';
    }
    if (ten > 0) {
        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
    }
    if (one > 0) {
        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
    }
    return (word === '') ? 'pagh' : word;
}

var tlh = moment.defineLocale('tlh', {
    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
    monthsParseExact : true,
    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[DaHjaj] LT',
        nextDay: '[wa’leS] LT',
        nextWeek: 'LLL',
        lastDay: '[wa’Hu’] LT',
        lastWeek: 'LLL',
        sameElse: 'L'
    },
    relativeTime : {
        future : translateFuture,
        past : translatePast,
        s : 'puS lup',
        ss : translate,
        m : 'wa’ tup',
        mm : translate,
        h : 'wa’ rep',
        hh : translate,
        d : 'wa’ jaj',
        dd : translate,
        M : 'wa’ jar',
        MM : translate,
        y : 'wa’ DIS',
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tlh;

})));


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    1: '\'inci',
    5: '\'inci',
    8: '\'inci',
    70: '\'inci',
    80: '\'inci',
    2: '\'nci',
    7: '\'nci',
    20: '\'nci',
    50: '\'nci',
    3: '\'üncü',
    4: '\'üncü',
    100: '\'üncü',
    6: '\'ncı',
    9: '\'uncu',
    10: '\'uncu',
    30: '\'uncu',
    60: '\'ıncı',
    90: '\'ıncı'
};

var tr = moment.defineLocale('tr', {
    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[bugün saat] LT',
        nextDay : '[yarın saat] LT',
        nextWeek : '[gelecek] dddd [saat] LT',
        lastDay : '[dün] LT',
        lastWeek : '[geçen] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s sonra',
        past : '%s önce',
        s : 'birkaç saniye',
        ss : '%d saniye',
        m : 'bir dakika',
        mm : '%d dakika',
        h : 'bir saat',
        hh : '%d saat',
        d : 'bir gün',
        dd : '%d gün',
        M : 'bir ay',
        MM : '%d ay',
        y : 'bir yıl',
        yy : '%d yıl'
    },
    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
    ordinal : function (number) {
        if (number === 0) {  // special case for zero
            return number + '\'ıncı';
        }
        var a = number % 10,
            b = number % 100 - a,
            c = number >= 100 ? 100 : null;
        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return tr;

})));


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
// This is currently too difficult (maybe even impossible) to add.
var tzl = moment.defineLocale('tzl', {
    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM [dallas] YYYY',
        LLL : 'D. MMMM [dallas] YYYY HH.mm',
        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
    },
    meridiemParse: /d\'o|d\'a/i,
    isPM : function (input) {
        return 'd\'o' === input.toLowerCase();
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'd\'o' : 'D\'O';
        } else {
            return isLower ? 'd\'a' : 'D\'A';
        }
    },
    calendar : {
        sameDay : '[oxhi à] LT',
        nextDay : '[demà à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[ieiri à] LT',
        lastWeek : '[sür el] dddd [lasteu à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'osprei %s',
        past : 'ja%s',
        s : processRelativeTime,
        ss : processRelativeTime,
        m : processRelativeTime,
        mm : processRelativeTime,
        h : processRelativeTime,
        hh : processRelativeTime,
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's': ['viensas secunds', '\'iensas secunds'],
        'ss': [number + ' secunds', '' + number + ' secunds'],
        'm': ['\'n míut', '\'iens míut'],
        'mm': [number + ' míuts', '' + number + ' míuts'],
        'h': ['\'n þora', '\'iensa þora'],
        'hh': [number + ' þoras', '' + number + ' þoras'],
        'd': ['\'n ziua', '\'iensa ziua'],
        'dd': [number + ' ziuas', '' + number + ' ziuas'],
        'M': ['\'n mes', '\'iens mes'],
        'MM': [number + ' mesen', '' + number + ' mesen'],
        'y': ['\'n ar', '\'iens ar'],
        'yy': [number + ' ars', '' + number + ' ars']
    };
    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
}

return tzl;

})));


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tzmLatn = moment.defineLocale('tzm-latn', {
    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[asdkh g] LT',
        nextDay: '[aska g] LT',
        nextWeek: 'dddd [g] LT',
        lastDay: '[assant g] LT',
        lastWeek: 'dddd [g] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'dadkh s yan %s',
        past : 'yan %s',
        s : 'imik',
        ss : '%d imik',
        m : 'minuḍ',
        mm : '%d minuḍ',
        h : 'saɛa',
        hh : '%d tassaɛin',
        d : 'ass',
        dd : '%d ossan',
        M : 'ayowr',
        MM : '%d iyyirn',
        y : 'asgas',
        yy : '%d isgasn'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return tzmLatn;

})));


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tzm = moment.defineLocale('tzm', {
    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
        nextWeek: 'dddd [ⴴ] LT',
        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
        lastWeek: 'dddd [ⴴ] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
        past : 'ⵢⴰⵏ %s',
        s : 'ⵉⵎⵉⴽ',
        ss : '%d ⵉⵎⵉⴽ',
        m : 'ⵎⵉⵏⵓⴺ',
        mm : '%d ⵎⵉⵏⵓⴺ',
        h : 'ⵙⴰⵄⴰ',
        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
        d : 'ⴰⵙⵙ',
        dd : '%d oⵙⵙⴰⵏ',
        M : 'ⴰⵢoⵓⵔ',
        MM : '%d ⵉⵢⵢⵉⵔⵏ',
        y : 'ⴰⵙⴳⴰⵙ',
        yy : '%d ⵉⵙⴳⴰⵙⵏ'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return tzm;

})));


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
        'dd': 'день_дні_днів',
        'MM': 'місяць_місяці_місяців',
        'yy': 'рік_роки_років'
    };
    if (key === 'm') {
        return withoutSuffix ? 'хвилина' : 'хвилину';
    }
    else if (key === 'h') {
        return withoutSuffix ? 'година' : 'годину';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}
function weekdaysCaseReplace(m, format) {
    var weekdays = {
        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
    };

    if (!m) {
        return weekdays['nominative'];
    }

    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
        'accusative' :
        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
            'genitive' :
            'nominative');
    return weekdays[nounCase][m.day()];
}
function processHoursFunction(str) {
    return function () {
        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
    };
}

var uk = moment.defineLocale('uk', {
    months : {
        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
    },
    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
    weekdays : weekdaysCaseReplace,
    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY р.',
        LLL : 'D MMMM YYYY р., HH:mm',
        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
    },
    calendar : {
        sameDay: processHoursFunction('[Сьогодні '),
        nextDay: processHoursFunction('[Завтра '),
        lastDay: processHoursFunction('[Вчора '),
        nextWeek: processHoursFunction('[У] dddd ['),
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 5:
                case 6:
                    return processHoursFunction('[Минулої] dddd [').call(this);
                case 1:
                case 2:
                case 4:
                    return processHoursFunction('[Минулого] dddd [').call(this);
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'за %s',
        past : '%s тому',
        s : 'декілька секунд',
        ss : relativeTimeWithPlural,
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : 'годину',
        hh : relativeTimeWithPlural,
        d : 'день',
        dd : relativeTimeWithPlural,
        M : 'місяць',
        MM : relativeTimeWithPlural,
        y : 'рік',
        yy : relativeTimeWithPlural
    },
    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
    meridiemParse: /ночі|ранку|дня|вечора/,
    isPM: function (input) {
        return /^(дня|вечора)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночі';
        } else if (hour < 12) {
            return 'ранку';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечора';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
            case 'w':
            case 'W':
                return number + '-й';
            case 'D':
                return number + '-го';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return uk;

})));


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'جنوری',
    'فروری',
    'مارچ',
    'اپریل',
    'مئی',
    'جون',
    'جولائی',
    'اگست',
    'ستمبر',
    'اکتوبر',
    'نومبر',
    'دسمبر'
];
var days = [
    'اتوار',
    'پیر',
    'منگل',
    'بدھ',
    'جمعرات',
    'جمعہ',
    'ہفتہ'
];

var ur = moment.defineLocale('ur', {
    months : months,
    monthsShort : months,
    weekdays : days,
    weekdaysShort : days,
    weekdaysMin : days,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd، D MMMM YYYY HH:mm'
    },
    meridiemParse: /صبح|شام/,
    isPM : function (input) {
        return 'شام' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'صبح';
        }
        return 'شام';
    },
    calendar : {
        sameDay : '[آج بوقت] LT',
        nextDay : '[کل بوقت] LT',
        nextWeek : 'dddd [بوقت] LT',
        lastDay : '[گذشتہ روز بوقت] LT',
        lastWeek : '[گذشتہ] dddd [بوقت] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s بعد',
        past : '%s قبل',
        s : 'چند سیکنڈ',
        ss : '%d سیکنڈ',
        m : 'ایک منٹ',
        mm : '%d منٹ',
        h : 'ایک گھنٹہ',
        hh : '%d گھنٹے',
        d : 'ایک دن',
        dd : '%d دن',
        M : 'ایک ماہ',
        MM : '%d ماہ',
        y : 'ایک سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ur;

})));


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek Latin [uz-latn]
//! author : Rasulbek Mirzayev : github.com/Rasulbeeek

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var uzLatn = moment.defineLocale('uz-latn', {
    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'D MMMM YYYY, dddd HH:mm'
    },
    calendar : {
        sameDay : '[Bugun soat] LT [da]',
        nextDay : '[Ertaga] LT [da]',
        nextWeek : 'dddd [kuni soat] LT [da]',
        lastDay : '[Kecha soat] LT [da]',
        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'Yaqin %s ichida',
        past : 'Bir necha %s oldin',
        s : 'soniya',
        ss : '%d soniya',
        m : 'bir daqiqa',
        mm : '%d daqiqa',
        h : 'bir soat',
        hh : '%d soat',
        d : 'bir kun',
        dd : '%d kun',
        M : 'bir oy',
        MM : '%d oy',
        y : 'bir yil',
        yy : '%d yil'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return uzLatn;

})));


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var uz = moment.defineLocale('uz', {
    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'D MMMM YYYY, dddd HH:mm'
    },
    calendar : {
        sameDay : '[Бугун соат] LT [да]',
        nextDay : '[Эртага] LT [да]',
        nextWeek : 'dddd [куни соат] LT [да]',
        lastDay : '[Кеча соат] LT [да]',
        lastWeek : '[Утган] dddd [куни соат] LT [да]',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'Якин %s ичида',
        past : 'Бир неча %s олдин',
        s : 'фурсат',
        ss : '%d фурсат',
        m : 'бир дакика',
        mm : '%d дакика',
        h : 'бир соат',
        hh : '%d соат',
        d : 'бир кун',
        dd : '%d кун',
        M : 'бир ой',
        MM : '%d ой',
        y : 'бир йил',
        yy : '%d йил'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 4th is the first week of the year.
    }
});

return uz;

})));


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var vi = moment.defineLocale('vi', {
    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
    monthsParseExact : true,
    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
    weekdaysParseExact : true,
    meridiemParse: /sa|ch/i,
    isPM : function (input) {
        return /^ch$/i.test(input);
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower ? 'sa' : 'SA';
        } else {
            return isLower ? 'ch' : 'CH';
        }
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM [năm] YYYY',
        LLL : 'D MMMM [năm] YYYY HH:mm',
        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
        l : 'DD/M/YYYY',
        ll : 'D MMM YYYY',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd, D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Hôm nay lúc] LT',
        nextDay: '[Ngày mai lúc] LT',
        nextWeek: 'dddd [tuần tới lúc] LT',
        lastDay: '[Hôm qua lúc] LT',
        lastWeek: 'dddd [tuần rồi lúc] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s tới',
        past : '%s trước',
        s : 'vài giây',
        ss : '%d giây' ,
        m : 'một phút',
        mm : '%d phút',
        h : 'một giờ',
        hh : '%d giờ',
        d : 'một ngày',
        dd : '%d ngày',
        M : 'một tháng',
        MM : '%d tháng',
        y : 'một năm',
        yy : '%d năm'
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : function (number) {
        return number;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return vi;

})));


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var xPseudo = moment.defineLocale('x-pseudo', {
    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
    monthsParseExact : true,
    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[T~ódá~ý át] LT',
        nextDay : '[T~ómó~rró~w át] LT',
        nextWeek : 'dddd [át] LT',
        lastDay : '[Ý~ést~érdá~ý át] LT',
        lastWeek : '[L~ást] dddd [át] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'í~ñ %s',
        past : '%s á~gó',
        s : 'á ~féw ~sécó~ñds',
        ss : '%d s~écóñ~ds',
        m : 'á ~míñ~úté',
        mm : '%d m~íñú~tés',
        h : 'á~ñ hó~úr',
        hh : '%d h~óúrs',
        d : 'á ~dáý',
        dd : '%d d~áýs',
        M : 'á ~móñ~th',
        MM : '%d m~óñt~hs',
        y : 'á ~ýéár',
        yy : '%d ý~éárs'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return xPseudo;

})));


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Yoruba Nigeria [yo]
//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var yo = moment.defineLocale('yo', {
    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Ònì ni] LT',
        nextDay : '[Ọ̀la ni] LT',
        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
        lastDay : '[Àna ni] LT',
        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ní %s',
        past : '%s kọjá',
        s : 'ìsẹjú aayá die',
        ss :'aayá %d',
        m : 'ìsẹjú kan',
        mm : 'ìsẹjú %d',
        h : 'wákati kan',
        hh : 'wákati %d',
        d : 'ọjọ́ kan',
        dd : 'ọjọ́ %d',
        M : 'osù kan',
        MM : 'osù %d',
        y : 'ọdún kan',
        yy : 'ọdún %d'
    },
    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
    ordinal : 'ọjọ́ %d',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return yo;

})));


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhCn = moment.defineLocale('zh-cn', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY年M月D日',
        LLL : 'YYYY年M月D日Ah点mm分',
        LLLL : 'YYYY年M月D日ddddAh点mm分',
        l : 'YYYY/M/D',
        ll : 'YYYY年M月D日',
        lll : 'YYYY年M月D日 HH:mm',
        llll : 'YYYY年M月D日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' ||
                meridiem === '上午') {
            return hour;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        } else {
            // '中午'
            return hour >= 11 ? hour : hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '日';
            case 'M':
                return number + '月';
            case 'w':
            case 'W':
                return number + '周';
            default:
                return number;
        }
    },
    relativeTime : {
        future : '%s内',
        past : '%s前',
        s : '几秒',
        ss : '%d 秒',
        m : '1 分钟',
        mm : '%d 分钟',
        h : '1 小时',
        hh : '%d 小时',
        d : '1 天',
        dd : '%d 天',
        M : '1 个月',
        MM : '%d 个月',
        y : '1 年',
        yy : '%d 年'
    },
    week : {
        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return zhCn;

})));


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhHk = moment.defineLocale('zh-hk', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY年M月D日',
        LLL : 'YYYY年M月D日 HH:mm',
        LLLL : 'YYYY年M月D日dddd HH:mm',
        l : 'YYYY/M/D',
        ll : 'YYYY年M月D日',
        lll : 'YYYY年M月D日 HH:mm',
        llll : 'YYYY年M月D日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
            return hour;
        } else if (meridiem === '中午') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd' :
            case 'D' :
            case 'DDD' :
                return number + '日';
            case 'M' :
                return number + '月';
            case 'w' :
            case 'W' :
                return number + '週';
            default :
                return number;
        }
    },
    relativeTime : {
        future : '%s內',
        past : '%s前',
        s : '幾秒',
        ss : '%d 秒',
        m : '1 分鐘',
        mm : '%d 分鐘',
        h : '1 小時',
        hh : '%d 小時',
        d : '1 天',
        dd : '%d 天',
        M : '1 個月',
        MM : '%d 個月',
        y : '1 年',
        yy : '%d 年'
    }
});

return zhHk;

})));


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhTw = moment.defineLocale('zh-tw', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY年M月D日',
        LLL : 'YYYY年M月D日 HH:mm',
        LLLL : 'YYYY年M月D日dddd HH:mm',
        l : 'YYYY/M/D',
        ll : 'YYYY年M月D日',
        lll : 'YYYY年M月D日 HH:mm',
        llll : 'YYYY年M月D日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
            return hour;
        } else if (meridiem === '中午') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd' :
            case 'D' :
            case 'DDD' :
                return number + '日';
            case 'M' :
                return number + '月';
            case 'w' :
            case 'W' :
                return number + '週';
            default :
                return number;
        }
    },
    relativeTime : {
        future : '%s內',
        past : '%s前',
        s : '幾秒',
        ss : '%d 秒',
        m : '1 分鐘',
        mm : '%d 分鐘',
        h : '1 小時',
        hh : '%d 小時',
        d : '1 天',
        dd : '%d 天',
        M : '1 個月',
        MM : '%d 個月',
        y : '1 年',
        yy : '%d 年'
    }
});

return zhTw;

})));


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(1026);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridColumn: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(7);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PooledClass = __webpack_require__(61);

var invariant = __webpack_require__(4);

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */

var CallbackQueue = function () {
  function CallbackQueue(arg) {
    _classCallCheck(this, CallbackQueue);

    this._callbacks = null;
    this._contexts = null;
    this._arg = arg;
  }

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */


  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
    this._callbacks = this._callbacks || [];
    this._callbacks.push(callback);
    this._contexts = this._contexts || [];
    this._contexts.push(context);
  };

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */


  CallbackQueue.prototype.notifyAll = function notifyAll() {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    var arg = this._arg;
    if (callbacks && contexts) {
      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i], arg);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  };

  CallbackQueue.prototype.checkpoint = function checkpoint() {
    return this._callbacks ? this._callbacks.length : 0;
  };

  CallbackQueue.prototype.rollback = function rollback(len) {
    if (this._callbacks && this._contexts) {
      this._callbacks.length = len;
      this._contexts.length = len;
    }
  };

  /**
   * Resets the internal queue.
   *
   * @internal
   */


  CallbackQueue.prototype.reset = function reset() {
    this._callbacks = null;
    this._contexts = null;
  };

  /**
   * `PooledClass` looks for this.
   */


  CallbackQueue.prototype.destructor = function destructor() {
    this.reset();
  };

  return CallbackQueue;
}();

module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(79);
var ReactDOMComponentTree = __webpack_require__(15);
var ReactInstrumentation = __webpack_require__(32);

var quoteAttributeValueForBrowser = __webpack_require__(1090);
var warning = __webpack_require__(6);

var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {

  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  createMarkupForRoot: function () {
    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
  },

  setAttributeForRoot: function (node) {
    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
        return;
      } else if (propertyInfo.mustUseProperty) {
        // Contrary to `setAttribute`, object properties are properly
        // `toString`ed by IE8/9.
        node[propertyInfo.propertyName] = value;
      } else {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
      return;
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  /**
   * Deletes an attributes from a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForAttribute: function (node, name) {
    node.removeAttribute(name);
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseProperty) {
        var propName = propertyInfo.propertyName;
        if (propertyInfo.hasBooleanValue) {
          node[propName] = false;
        } else {
          node[propName] = '';
        }
      } else {
        node.removeAttribute(propertyInfo.attributeName);
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    }

    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  }

};

module.exports = DOMPropertyOperations;

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentFlags = {
  hasCachedChildNodes: 1 << 0
};

module.exports = ReactDOMComponentFlags;

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(10);

var LinkedValueUtils = __webpack_require__(231);
var ReactDOMComponentTree = __webpack_require__(15);
var ReactUpdates = __webpack_require__(35);

var warning = __webpack_require__(6);

var didWarnValueLink = false;
var didWarnValueDefaultValue = false;

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, Boolean(props.multiple), value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  if (props.valueLink !== undefined && !didWarnValueLink) {
     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
    didWarnValueLink = true;
  }

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    var isArray = Array.isArray(props[propName]);
    if (props.multiple && !isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    } else if (!props.multiple && isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  getHostProps: function (inst, props) {
    return _assign({}, props, {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (false) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
      didWarnValueDefaultValue = true;
    }
  },

  getSelectValueContext: function (inst) {
    // ReactDOMOption looks at this initial value so the initial generated
    // markup has correct `selected` attributes
    return inst._wrapperState.initialValue;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // this value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  if (this._rootNodeID) {
    this._wrapperState.pendingUpdate = true;
  }
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyComponentFactory;

var ReactEmptyComponentInjection = {
  injectEmptyComponentFactory: function (factory) {
    emptyComponentFactory = factory;
  }
};

var ReactEmptyComponent = {
  create: function (instantiate) {
    return emptyComponentFactory(instantiate);
  }
};

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactFeatureFlags = {
  // When true, call console.time() before and .timeEnd() after each top-level
  // render (both initial renders and updates). Useful when looking at prod-mode
  // timeline profiles in Chrome, for example.
  logTopLevelRenders: false
};

module.exports = ReactFeatureFlags;

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var invariant = __webpack_require__(4);

var genericComponentClass = null;
var textComponentClass = null;

var ReactHostComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  }
};

/**
 * Get a host internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
  return new genericComponentClass(element);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactHostComponent = {
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactHostComponentInjection
};

module.exports = ReactHostComponent;

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMSelection = __webpack_require__(1050);

var containsNode = __webpack_require__(894);
var focusNode = __webpack_require__(380);
var getActiveElement = __webpack_require__(381);

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {

  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (end === undefined) {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var DOMLazyTree = __webpack_require__(78);
var DOMProperty = __webpack_require__(79);
var React = __webpack_require__(85);
var ReactBrowserEventEmitter = __webpack_require__(147);
var ReactCurrentOwner = __webpack_require__(48);
var ReactDOMComponentTree = __webpack_require__(15);
var ReactDOMContainerInfo = __webpack_require__(1044);
var ReactDOMFeatureFlags = __webpack_require__(1046);
var ReactFeatureFlags = __webpack_require__(536);
var ReactInstanceMap = __webpack_require__(112);
var ReactInstrumentation = __webpack_require__(32);
var ReactMarkupChecksum = __webpack_require__(1060);
var ReactReconciler = __webpack_require__(80);
var ReactUpdateQueue = __webpack_require__(234);
var ReactUpdates = __webpack_require__(35);

var emptyObject = __webpack_require__(74);
var instantiateReactComponent = __webpack_require__(546);
var invariant = __webpack_require__(4);
var setInnerHTML = __webpack_require__(151);
var shouldUpdateReactComponent = __webpack_require__(240);
var warning = __webpack_require__(6);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var instancesByReactRootID = {};

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
  var markerName;
  if (ReactFeatureFlags.logTopLevelRenders) {
    var wrappedElement = wrapperInstance._currentElement.props.child;
    var type = wrappedElement.type;
    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
    console.time(markerName);
  }

  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
  );

  if (markerName) {
    console.timeEnd(markerName);
  }

  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */
  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container, safely) {
  if (false) {
    ReactInstrumentation.debugTool.onBeginFlush();
  }
  ReactReconciler.unmountComponent(instance, safely);
  if (false) {
    ReactInstrumentation.debugTool.onEndFlush();
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(container) {
  var rootEl = getReactRootElementInContainer(container);
  if (rootEl) {
    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
    return !!(inst && inst._hostParent);
  }
}

/**
 * True if the supplied DOM node is a React DOM element and
 * it has been rendered by another copy of React.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM has been rendered by another copy of React
 * @internal
 */
function nodeIsRenderedByOtherInstance(container) {
  var rootEl = getReactRootElementInContainer(container);
  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
}

/**
 * True if the supplied DOM node is a valid node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid DOM node.
 * @internal
 */
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
}

/**
 * True if the supplied DOM node is a valid React node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid React DOM node.
 * @internal
 */
function isReactNode(node) {
  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
}

function getHostRootInstanceInContainer(container) {
  var rootEl = getReactRootElementInContainer(container);
  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
}

function getTopLevelWrapperInContainer(container) {
  var root = getHostRootInstanceInContainer(container);
  return root ? root._hostContainerInfo._topLevelWrapper : null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var topLevelRootCounter = 1;
var TopLevelWrapper = function () {
  this.rootID = topLevelRootCounter++;
};
TopLevelWrapper.prototype.isReactComponent = {};
if (false) {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  return this.props.child;
};
TopLevelWrapper.isReactTopLevelWrapper = true;

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {

  TopLevelWrapper: TopLevelWrapper,

  /**
   * Used by devtools. The keys are not important.
   */
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    return prevComponent;
  },

  /**
   * Render a new component into the DOM. Hooked by hooks!
   *
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
    var componentInstance = instantiateReactComponent(nextElement, false);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);

    var wrapperID = componentInstance._instance.rootID;
    instancesByReactRootID[wrapperID] = componentInstance;

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
    // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;

     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;

    var nextWrappedElement = React.createElement(TopLevelWrapper, { child: nextElement });

    var nextContext;
    if (parentComponent) {
      var parentInst = ReactInstanceMap.get(parentComponent);
      nextContext = parentInst._processChildContext(parentInst._context);
    } else {
      nextContext = emptyObject;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props.child;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        var publicInst = prevComponent._renderedComponent.getPublicInstance();
        var updatedCallback = callback && function () {
          callback.call(publicInst);
        };
        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
        return publicInst;
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);
    if (!prevComponent) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
      }

      return false;
    }
    delete instancesByReactRootID[prevComponent._instance.rootID];
    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
    return true;
  },

  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        ReactDOMComponentTree.precacheNode(instance, rootElement);
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if (false) {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;

        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      DOMLazyTree.insertTreeBefore(container, markup, null);
    } else {
      setInnerHTML(container, markup);
      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
    }

    if (false) {
      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
      if (hostNode._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: hostNode._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  }
};

module.exports = ReactMount;

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(7);

var React = __webpack_require__(85);

var invariant = __webpack_require__(4);

var ReactNodeTypes = {
  HOST: 0,
  COMPOSITE: 1,
  EMPTY: 2,

  getType: function (node) {
    if (node === null || node === false) {
      return ReactNodeTypes.EMPTY;
    } else if (React.isValidElement(node)) {
      if (typeof node.type === 'function') {
        return ReactNodeTypes.COMPOSITE;
      } else {
        return ReactNodeTypes.HOST;
      }
    }
     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
  }
};

module.exports = ReactNodeTypes;

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ViewportMetrics = {

  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }

};

module.exports = ViewportMetrics;

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(7);

var invariant = __webpack_require__(4);

/**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;

  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  if (Array.isArray(current)) {
    if (Array.isArray(next)) {
      current.push.apply(current, next);
      return current;
    }
    current.push(next);
    return current;
  }

  if (Array.isArray(next)) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */

function forEachAccumulated(arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
}

module.exports = forEachAccumulated;

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactNodeTypes = __webpack_require__(540);

function getHostComponentFromComposite(inst) {
  var type;

  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
    inst = inst._renderedComponent;
  }

  if (type === ReactNodeTypes.HOST) {
    return inst._renderedComponent;
  } else if (type === ReactNodeTypes.EMPTY) {
    return null;
  }
}

module.exports = getHostComponentFromComposite;

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(26);

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7),
    _assign = __webpack_require__(10);

var ReactCompositeComponent = __webpack_require__(1041);
var ReactEmptyComponent = __webpack_require__(535);
var ReactHostComponent = __webpack_require__(537);

var getNextDebugID = __webpack_require__(1307);
var invariant = __webpack_require__(4);
var warning = __webpack_require__(6);

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function (element) {
  this.construct(element);
};

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @param {boolean} shouldHaveDebugID
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node, shouldHaveDebugID) {
  var instance;

  if (node === null || node === false) {
    instance = ReactEmptyComponent.create(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    var type = element.type;
    if (typeof type !== 'function' && typeof type !== 'string') {
      var info = '';
      if (false) {
        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
          info += ' You likely forgot to export your component from the file ' + 'it\'s defined in.';
        }
      }
      info += getDeclarationErrorAddendum(element._owner);
       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
    }

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactHostComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);

      // We renamed this. Allow the old name for compat. :(
      if (!instance.getHostNode) {
        instance.getHostNode = instance.getNativeNode;
      }
    } else {
      instance = new ReactCompositeComponentWrapper(element);
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactHostComponent.createInstanceForText(node);
  } else {
     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
  }

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (false) {
    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (false) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
  _instantiateReactComponent: instantiateReactComponent
});

module.exports = instantiateReactComponent;

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */

var supportedInputTypes = {
  'color': true,
  'date': true,
  'datetime': true,
  'datetime-local': true,
  'email': true,
  'month': true,
  'number': true,
  'password': true,
  'range': true,
  'search': true,
  'tel': true,
  'text': true,
  'time': true,
  'url': true,
  'week': true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

module.exports = isTextInputElement;

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(26);
var escapeTextContentForBrowser = __webpack_require__(150);
var setInnerHTML = __webpack_require__(151);

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
      firstChild.nodeValue = text;
      return;
    }
  }
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      if (node.nodeType === 3) {
        node.nodeValue = text;
        return;
      }
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var ReactCurrentOwner = __webpack_require__(48);
var REACT_ELEMENT_TYPE = __webpack_require__(1056);

var getIteratorFn = __webpack_require__(1087);
var invariant = __webpack_require__(4);
var KeyEscapeUtils = __webpack_require__(230);
var warning = __webpack_require__(6);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1093)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./Autocomplete'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.Autocomplete);
    global.index = mod.exports;
  }
})(this, function (exports, _Autocomplete) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _Autocomplete2 = _interopRequireDefault(_Autocomplete);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _Autocomplete2.default;
});

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(64), __webpack_require__(28), __webpack_require__(157), __webpack_require__(11)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('../utils/PropTypes/componentDeprecated'), require('../FontIcons/FontIcon'), require('../Tooltips/injectTooltip'), require('./Button'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.componentDeprecated, global.FontIcon, global.injectTooltip, global.Button);
    global.IconButton = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _componentDeprecated, _FontIcon, _injectTooltip, _Button) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _componentDeprecated2 = _interopRequireDefault(_componentDeprecated);

  var _FontIcon2 = _interopRequireDefault(_FontIcon);

  var _injectTooltip2 = _interopRequireDefault(_injectTooltip);

  var _Button2 = _interopRequireDefault(_Button);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var IconButton = function (_PureComponent) {
    _inherits(IconButton, _PureComponent);

    function IconButton() {
      _classCallCheck(this, IconButton);

      return _possibleConstructorReturn(this, (IconButton.__proto__ || Object.getPrototypeOf(IconButton)).apply(this, arguments));
    }

    _createClass(IconButton, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            iconClassName = _props.iconClassName,
            children = _props.children,
            tooltip = _props.tooltip,
            floating = _props.floating,
            props = _objectWithoutProperties(_props, ['iconClassName', 'children', 'tooltip', 'floating']);

        delete props.tooltipLabel;
        delete props.tooltipPosition;

        return _react2.default.createElement(
          _Button2.default,
          _extends({}, props, { icon: !floating, floating: floating }),
          tooltip,
          _react2.default.createElement(
            _FontIcon2.default,
            { iconClassName: iconClassName },
            children
          )
        );
      }
    }]);

    return IconButton;
  }(_react.PureComponent);

  IconButton.propTypes = {
    /**
     * The className to use for rendering the `FontIcon`.
     */
    iconClassName: _propTypes2.default.string,

    /**
     * Any children to use to render the `FontIcon`.
     */
    children: _propTypes2.default.node,

    /**
     * An optional className to apply to the button.
     */
    className: _propTypes2.default.string,

    /**
     * The button type.
     */
    type: _propTypes2.default.string,

    /**
     * Boolean if the button is disabled.
     */
    disabled: _propTypes2.default.bool,

    /**
     * An optional href to convert the button into a link button.
     */
    href: _propTypes2.default.string,

    /**
     * An optional function to call when the button is clicked.
     */
    onClick: _propTypes2.default.func,
    /**
     * Boolean if the IconButton is floating
    floating: PropTypes.bool,
     /**
     * An optional label to use if you would like a tooltip to display
     * on hover or touch hold.
     */
    tooltipLabel: _propTypes2.default.node,

    /**
     * The position that the tooltip should be displayed relative to
     * the button.
     */
    tooltipPosition: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),

    /**
     * An optional amount of delay before the tooltip appears.
     */
    tooltipDelay: _propTypes2.default.number,

    // Inject from injectTooltip
    tooltip: _propTypes2.default.node,
    floating: _propTypes2.default.bool,

    deprecated: (0, _componentDeprecated2.default)('The behavior of the `IconButton` can be achieved with the `Button` component ' + 'without the additional bundle size. Switch to the `Button` compnent and add a ' + 'prop `icon`.')
  };
  IconButton.defaultProps = {
    type: 'button'
  };
  exports.default = (0, _injectTooltip2.default)(IconButton);
});

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(12), __webpack_require__(553)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('react-prop-types/lib/deprecated'), require('./CardExpander'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.deprecated, global.CardExpander);
    global.CardActions = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _deprecated, _CardExpander) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _deprecated2 = _interopRequireDefault(_deprecated);

  var _CardExpander2 = _interopRequireDefault(_CardExpander);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var CardActions = function (_Component) {
    _inherits(CardActions, _Component);

    function CardActions() {
      _classCallCheck(this, CardActions);

      return _possibleConstructorReturn(this, (CardActions.__proto__ || Object.getPrototypeOf(CardActions)).apply(this, arguments));
    }

    _createClass(CardActions, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            className = _props.className,
            children = _props.children,
            isExpander = _props.isExpander,
            expander = _props.expander,
            centered = _props.centered,
            stacked = _props.stacked,
            props = _objectWithoutProperties(_props, ['className', 'children', 'isExpander', 'expander', 'centered', 'stacked']);

        return _react2.default.createElement(
          'section',
          _extends({}, props, {
            className: (0, _classnames2.default)('md-dialog-footer--card', {
              'md-dialog-footer--inline': !stacked,
              'md-dialog-footer--stacked': stacked,
              'md-dialog-footer--card-centered': centered
            }, className)
          }),
          children,
          isExpander || expander && _react2.default.createElement(_CardExpander2.default, null)
        );
      }
    }]);

    return CardActions;
  }(_react.Component);

  CardActions.propTypes = {
    /**
     * Boolean if this component should act as an expander and inject the
     * `CardExpander`.
     */
    expander: _propTypes2.default.bool,

    /**
     * An optional className to apply to the actions container.
     */
    className: _propTypes2.default.string,

    /**
     * An actions to display.
     */
    children: _propTypes2.default.node,

    /**
     * Boolean if the actions should be centered.
     */
    centered: _propTypes2.default.bool,

    /**
     * Boolean if the actions should be stacked.
     */
    stacked: _propTypes2.default.bool,

    isExpander: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `expander` instead')
  };
  exports.default = CardActions;
});

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(3), __webpack_require__(556), __webpack_require__(11)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('classnames'), require('./contextTypes'), require('../Buttons/Button'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.classnames, global.contextTypes, global.Button);
    global.CardExpander = mod.exports;
  }
})(this, function (exports, _react, _classnames, _contextTypes, _Button) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _contextTypes2 = _interopRequireDefault(_contextTypes);

  var _Button2 = _interopRequireDefault(_Button);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var CardExpander = function (_Component) {
    _inherits(CardExpander, _Component);

    function CardExpander() {
      _classCallCheck(this, CardExpander);

      return _possibleConstructorReturn(this, (CardExpander.__proto__ || Object.getPrototypeOf(CardExpander)).apply(this, arguments));
    }

    _createClass(CardExpander, [{
      key: 'render',
      value: function render() {
        var _context = this.context,
            expanded = _context.expanded,
            onExpandClick = _context.onExpandClick,
            iconClassName = _context.iconClassName,
            iconChildren = _context.iconChildren,
            tooltipPosition = _context.tooltipPosition,
            tooltipLabel = _context.tooltipLabel,
            tooltipDelay = _context.tooltipDelay;


        return _react2.default.createElement(
          _Button2.default,
          {
            icon: true,
            className: (0, _classnames2.default)('md-collapser md-collapser--card', {
              'md-collapser--flipped': expanded
            }),
            onClick: onExpandClick,
            iconClassName: iconClassName,
            tooltipLabel: tooltipLabel,
            tooltipDelay: tooltipDelay,
            tooltipPosition: tooltipPosition
          },
          iconChildren
        );
      }
    }]);

    return CardExpander;
  }(_react.Component);

  CardExpander.contextTypes = _contextTypes2.default;
  exports.default = CardExpander;
});

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(12), __webpack_require__(555), __webpack_require__(553)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('react-prop-types/lib/deprecated'), require('./CardTitleBlock'), require('./CardExpander'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.deprecated, global.CardTitleBlock, global.CardExpander);
    global.CardTitle = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _deprecated, _CardTitleBlock, _CardExpander) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _deprecated2 = _interopRequireDefault(_deprecated);

  var _CardTitleBlock2 = _interopRequireDefault(_CardTitleBlock);

  var _CardExpander2 = _interopRequireDefault(_CardExpander);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var CardTitle = function (_Component) {
    _inherits(CardTitle, _Component);

    function CardTitle() {
      _classCallCheck(this, CardTitle);

      return _possibleConstructorReturn(this, (CardTitle.__proto__ || Object.getPrototypeOf(CardTitle)).apply(this, arguments));
    }

    _createClass(CardTitle, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            id = _props.id,
            style = _props.style,
            className = _props.className,
            title = _props.title,
            subtitle = _props.subtitle,
            expander = _props.expander,
            isExpander = _props.isExpander,
            children = _props.children,
            props = _objectWithoutProperties(_props, ['id', 'style', 'className', 'title', 'subtitle', 'expander', 'isExpander', 'children']);

        delete props.avatar;
        var avatar = this.props.avatar;

        if (avatar) {
          var avatarClassName = _react.Children.only(avatar).props.className;

          avatar = (0, _react.cloneElement)(avatar, {
            className: (0, _classnames2.default)('md-avatar--card', avatarClassName)
          });
        }
        return _react2.default.createElement(
          'div',
          _extends({}, props, {
            style: style,
            className: (0, _classnames2.default)('md-card-title', {
              'md-card-title--primary': !avatar
            }, className)
          }),
          avatar,
          _react2.default.createElement(_CardTitleBlock2.default, { id: id, title: title, subtitle: subtitle, avatar: !!avatar }),
          children,
          isExpander || expander && _react2.default.createElement(_CardExpander2.default, null)
        );
      }
    }]);

    return CardTitle;
  }(_react.Component);

  CardTitle.propTypes = {
    /**
     * An optional id to add to the `title`.
     */
    id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),

    /**
     * An optional style to apply.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply.
     */
    className: _propTypes2.default.string,

    /**
     * The title to display.
     */
    title: _propTypes2.default.node.isRequired,

    /**
     * An optional subtitle to display.
     */
    subtitle: _propTypes2.default.node,

    /**
     * Any additional children to display in the title block
     * after the avatar, title, and subtitle.
     */
    children: _propTypes2.default.node,

    /**
     * An optional avatar to display before the title and subtitle.
     */
    avatar: _propTypes2.default.element,

    /**
     * Boolean if the `CardTitle` component should inject a button
     * for expanding all children below it.
     */
    expander: _propTypes2.default.bool,

    isExpander: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `expander` instead')
  };
  exports.default = CardTitle;
});

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames);
    global.CardTitleBlock = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var CardTitleBlock = function (_PureComponent) {
    _inherits(CardTitleBlock, _PureComponent);

    function CardTitleBlock() {
      _classCallCheck(this, CardTitleBlock);

      return _possibleConstructorReturn(this, (CardTitleBlock.__proto__ || Object.getPrototypeOf(CardTitleBlock)).apply(this, arguments));
    }

    _createClass(CardTitleBlock, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            id = _props.id,
            subtitle = _props.subtitle,
            avatar = _props.avatar;
        var title = this.props.title;

        title = _react2.default.createElement(
          'h2',
          {
            id: id,
            className: (0, _classnames2.default)('md-card-title--title md-text', {
              'md-card-title--large': !avatar
            })
          },
          title
        );

        if (!subtitle) {
          return title;
        }

        return _react2.default.createElement(
          'div',
          { className: 'md-card-title--title-block' },
          title,
          _react2.default.createElement(
            'h3',
            { className: 'md-card-title--title md-text--secondary' },
            subtitle
          )
        );
      }
    }]);

    return CardTitleBlock;
  }(_react.PureComponent);

  CardTitleBlock.propTypes = {
    id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    title: _propTypes2.default.node.isRequired,
    subtitle: _propTypes2.default.node,
    avatar: _propTypes2.default.bool
  };
  exports.default = CardTitleBlock;
});

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('prop-types'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.propTypes);
    global.contextTypes = mod.exports;
  }
})(this, function (exports, _propTypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = {
    onExpandClick: _propTypes2.default.func,
    expanded: _propTypes2.default.bool,
    iconClassName: _propTypes2.default.string,
    iconChildren: _propTypes2.default.node,
    tooltipPosition: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
    tooltipLabel: _propTypes2.default.node,
    tooltipDelay: _propTypes2.default.number
  };
});

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(9), __webpack_require__(3), __webpack_require__(16), __webpack_require__(258), __webpack_require__(11), __webpack_require__(154)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('react-dom'), require('classnames'), require('../utils/getField'), require('../SelectFields/SelectField'), require('../Buttons/Button'), require('./findTable'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.reactDom, global.classnames, global.getField, global.SelectField, global.Button, global.findTable);
    global.TablePagination = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _reactDom, _classnames, _getField, _SelectField, _Button, _findTable) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _getField2 = _interopRequireDefault(_getField);

  var _SelectField2 = _interopRequireDefault(_SelectField);

  var _Button2 = _interopRequireDefault(_Button);

  var _findTable2 = _interopRequireDefault(_findTable);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var

  /**
   * The `TablePagination` component is used to generate the table footer that helps
   * pagination through a large dataset by limiting the number of rows per page.
   * The pagination will always be placed persistently at the bottom of the table
   * so that when a user scrolls to the right, they will always be able to use the
   * pagination.
   */
  TablePagination = function (_PureComponent) {
    _inherits(TablePagination, _PureComponent);

    function TablePagination(props, context) {
      _classCallCheck(this, TablePagination);

      var _this = _possibleConstructorReturn(this, (TablePagination.__proto__ || Object.getPrototypeOf(TablePagination)).call(this, props, context));

      var rpp = typeof props.rowsPerPage !== 'undefined' ? props.rowsPerPage : props.defaultRowsPerPage;
      var p = typeof props.page !== 'undefined' ? props.page : props.defaultPage;
      _this.state = {
        page: props.defaultPage,
        start: (p - 1) * rpp,
        rowsPerPage: props.defaultRowsPerPage,
        controlsMarginLeft: 0
      };

      _this._setControls = _this._setControls.bind(_this);
      _this._position = _this._position.bind(_this);
      _this._increment = _this._increment.bind(_this);
      _this._decrement = _this._decrement.bind(_this);
      _this._setRowsPerPage = _this._setRowsPerPage.bind(_this);
      return _this;
    }

    _createClass(TablePagination, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this._position();
        window.addEventListener('resize', this._position);
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var _props = this.props,
            rowsPerPage = _props.rowsPerPage,
            page = _props.page;

        if (page !== nextProps.page || rowsPerPage !== nextProps.rowsPerPage) {
          var rpp = (0, _getField2.default)(nextProps, this.state, 'rowsPerPage');
          var p = (0, _getField2.default)(nextProps, this.state, 'page');

          this.setState({ start: (p - 1) * rpp });
        }
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps, prevState) {
        var rows = this.props.rows;
        var _state = this.state,
            start = _state.start,
            rowsPerPage = _state.rowsPerPage;

        if (rows !== prevProps.rows || start !== prevState.start || rowsPerPage !== prevState.rowsPerPage) {
          this._position();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        window.removeEventListener('resize', this._position);
      }
    }, {
      key: '_setControls',
      value: function _setControls(controls) {
        this._controls = (0, _reactDom.findDOMNode)(controls);
      }
    }, {
      key: '_position',
      value: function _position() {
        var table = (0, _findTable2.default)((0, _reactDom.findDOMNode)(this));
        if (table) {
          this.setState({
            controlsMarginLeft: Math.max(0, table.offsetWidth - this._controls.offsetWidth)
          });
        }
      }
    }, {
      key: '_increment',
      value: function _increment() {
        var _props2 = this.props,
            rows = _props2.rows,
            onPagination = _props2.onPagination;
        var start = this.state.start;

        var rowsPerPage = (0, _getField2.default)(this.props, this.state, 'rowsPerPage');
        var page = (0, _getField2.default)(this.props, this.state, 'page');

        // Only correct multiple of rows per page
        var max = rows - rows % rowsPerPage;

        var newStart = Math.min(start + rowsPerPage, max);
        var nextPage = page + 1;

        onPagination(newStart, rowsPerPage, nextPage);
        this.setState({ start: newStart, page: nextPage });
      }
    }, {
      key: '_decrement',
      value: function _decrement() {
        var start = this.state.start;

        var page = (0, _getField2.default)(this.props, this.state, 'page');
        var rowsPerPage = (0, _getField2.default)(this.props, this.state, 'rowsPerPage');
        var newStart = Math.max(0, start - rowsPerPage);
        var nextPage = page - 1;

        this.props.onPagination(newStart, rowsPerPage, nextPage);
        this.setState({ start: newStart, page: nextPage });
      }
    }, {
      key: '_setRowsPerPage',
      value: function _setRowsPerPage(rowsPerPage) {
        var page = 1;
        var newStart = 0;
        this.props.onPagination(newStart, rowsPerPage, page);
        this.setState({ start: newStart, rowsPerPage: rowsPerPage });
      }
    }, {
      key: 'render',
      value: function render() {
        var _state2 = this.state,
            controlsMarginLeft = _state2.controlsMarginLeft,
            start = _state2.start;

        var _props3 = this.props,
            className = _props3.className,
            rows = _props3.rows,
            rowsPerPageLabel = _props3.rowsPerPageLabel,
            rowsPerPageItems = _props3.rowsPerPageItems,
            incrementIconChildren = _props3.incrementIconChildren,
            incrementIconClassName = _props3.incrementIconClassName,
            decrementIconChildren = _props3.decrementIconChildren,
            decrementIconClassName = _props3.decrementIconClassName,
            props = _objectWithoutProperties(_props3, ['className', 'rows', 'rowsPerPageLabel', 'rowsPerPageItems', 'incrementIconChildren', 'incrementIconClassName', 'decrementIconChildren', 'decrementIconClassName']);

        delete props.onPagination;
        delete props.rowsPerPage;
        delete props.defaultPage;
        delete props.defaultRowsPerPage;
        delete props.page;

        var rowsPerPage = (0, _getField2.default)(this.props, this.state, 'rowsPerPage');

        var pagination = start + 1 + '-' + Math.min(rows, start + rowsPerPage) + ' of ' + rows;
        return _react2.default.createElement(
          'tfoot',
          _extends({}, props, { className: (0, _classnames2.default)('md-table-footer', className) }),
          _react2.default.createElement(
            'tr',
            null,
            _react2.default.createElement(
              'td',
              { colSpan: '100%' },
              _react2.default.createElement(
                'div',
                {
                  ref: this._setControls,
                  className: 'md-table-pagination md-table-pagination--controls md-text',
                  style: { marginLeft: controlsMarginLeft }
                },
                rowsPerPageLabel,
                _react2.default.createElement(_SelectField2.default, {
                  id: this.context.baseId + '-pagination',
                  menuItems: rowsPerPageItems,
                  position: _SelectField2.default.Positions.BELOW,
                  inputClassName: 'md-select-field--pagination',
                  value: rowsPerPage,
                  onChange: this._setRowsPerPage
                }),
                _react2.default.createElement(
                  'span',
                  { className: 'md-table-pagination--label' },
                  pagination
                ),
                _react2.default.createElement(
                  _Button2.default,
                  {
                    icon: true,
                    onClick: this._decrement,
                    disabled: start === 0,
                    iconClassName: decrementIconClassName
                  },
                  decrementIconChildren
                ),
                _react2.default.createElement(
                  _Button2.default,
                  {
                    icon: true,
                    onClick: this._increment,
                    disabled: start + rowsPerPage >= rows,
                    iconClassName: incrementIconClassName
                  },
                  incrementIconChildren
                )
              ),
              _react2.default.createElement('div', { className: 'md-table-pagination' })
            )
          )
        );
      }
    }]);

    return TablePagination;
  }(_react.PureComponent);

  TablePagination.propTypes = {
    /**
     * An optional style to apply to the `tfoot` tag.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply to the `tfoot` tag.
     */
    className: _propTypes2.default.string,

    /**
     * A function to call when a user clicks the increment or decrement pagination
     * icon button. This function will be given the new start index and the number
     * or rows per page as well as the current page.
     *
     * ```js
     * onPagination(newStart, rowsPerPage, currentPage);
     * ```
     */
    onPagination: _propTypes2.default.func.isRequired,

    /**
     * The current value for the select field holding the number of rows per page.
     */
    rowsPerPage: _propTypes2.default.number,

    /**
     * The current page for the pagination. This will make the comonent controlled, so the only way to get pagination
     * is making sure you are updating this prop after the `onPagination` callback is called.
     *
     * Pages start from 1 instead of 0.
     */
    page: _propTypes2.default.number,

    /**
     * The default page to start from for the pagination. Pages start from 1 instead of 0.
     */
    defaultPage: _propTypes2.default.number.isRequired,

    /**
     * The default number of rows per page to display. This will be the value for the
     * `SelectField`.
     */
    defaultRowsPerPage: _propTypes2.default.number.isRequired,

    /**
     * The label to use for the rows per page `SelectField`.
     */
    rowsPerPageLabel: _propTypes2.default.node.isRequired,

    /**
     * A list of numbers for the amount of rows per page to display at a time.
     * This will be rendered into the `SelectField`.
     */
    rowsPerPageItems: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,

    /**
     * The total number of rows that can be displayed. This is the unfiltered/non-subset
     * number of rows. This is used to help calculate the increment/decrement values to
     * display and determine if the user can increment/decrement again.
     */
    rows: _propTypes2.default.number.isRequired,

    /**
     * Any children used to display the increment icon button.
     */
    incrementIconChildren: _propTypes2.default.node,

    /**
     * An icon className used to display the increment icon button.
     */
    incrementIconClassName: _propTypes2.default.string,

    /**
     * Any children used to display the decrement icon button.
     */
    decrementIconChildren: _propTypes2.default.node,

    /**
     * An icon className used to display the decrement icon button.
     */
    decrementIconClassName: _propTypes2.default.string
  };
  TablePagination.contextTypes = {
    baseId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired
  };
  TablePagination.defaultProps = {
    defaultPage: 1,
    defaultRowsPerPage: 10,
    rowsPerPageLabel: 'Rows per page:',
    rowsPerPageItems: [10, 20, 30, 40, 50, 100],
    incrementIconChildren: 'keyboard_arrow_right',
    decrementIconChildren: 'keyboard_arrow_left'
  };
  exports.default = TablePagination;
});

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.DrawerTypes = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = {
    // Permanent drawers
    FULL_HEIGHT: 'full-height',
    CLIPPED: 'clipped',
    FLOATING: 'floating',

    // Persistent drawers
    PERSISTENT: 'persistent',
    PERSISTENT_MINI: 'persistent-mini',

    // Temporary
    TEMPORARY: 'temporary',
    TEMPORARY_MINI: 'temporary-mini'
  };
});

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(558)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./DrawerTypes'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.DrawerTypes);
    global.isType = mod.exports;
  }
})(this, function (exports, _DrawerTypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.isTemporary = isTemporary;
  exports.isPersistent = isPersistent;
  exports.isPermanent = isPermanent;
  exports.isMini = isMini;

  var _DrawerTypes2 = _interopRequireDefault(_DrawerTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var FULL_HEIGHT = _DrawerTypes2.default.FULL_HEIGHT,
      CLIPPED = _DrawerTypes2.default.CLIPPED,
      FLOATING = _DrawerTypes2.default.FLOATING,
      PERSISTENT = _DrawerTypes2.default.PERSISTENT,
      PERSISTENT_MINI = _DrawerTypes2.default.PERSISTENT_MINI,
      TEMPORARY = _DrawerTypes2.default.TEMPORARY,
      TEMPORARY_MINI = _DrawerTypes2.default.TEMPORARY_MINI;
  function isTemporary(type) {
    return [TEMPORARY, TEMPORARY_MINI].indexOf(type) !== -1;
  }

  function isPersistent(type) {
    return [PERSISTENT, PERSISTENT_MINI].indexOf(type) !== -1;
  }

  function isPermanent(type) {
    return [FULL_HEIGHT, CLIPPED, FLOATING].indexOf(type) !== -1;
  }

  function isMini(type) {
    return [PERSISTENT_MINI, TEMPORARY_MINI].indexOf(type) !== -1;
  }
});

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(17), __webpack_require__(14), __webpack_require__(117), __webpack_require__(28), __webpack_require__(81), __webpack_require__(37)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('react-prop-types/lib/isRequiredForA11y'), require('../constants/keyCodes'), require('../utils/EventUtils/captureNextEvent'), require('../FontIcons/FontIcon'), require('../Helpers/IconSeparator'), require('../Helpers/AccessibleFakeInkedButton'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.isRequiredForA11y, global.keyCodes, global.captureNextEvent, global.FontIcon, global.IconSeparator, global.AccessibleFakeInkedButton);
    global.FileInput = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _isRequiredForA11y, _keyCodes, _captureNextEvent, _FontIcon, _IconSeparator, _AccessibleFakeInkedButton) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);

  var _captureNextEvent2 = _interopRequireDefault(_captureNextEvent);

  var _FontIcon2 = _interopRequireDefault(_FontIcon);

  var _IconSeparator2 = _interopRequireDefault(_IconSeparator);

  var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var FileInput = function (_PureComponent) {
    _inherits(FileInput, _PureComponent);

    function FileInput(props) {
      _classCallCheck(this, FileInput);

      var _this = _possibleConstructorReturn(this, (FileInput.__proto__ || Object.getPrototypeOf(FileInput)).call(this, props));

      _this.state = { hover: false, pressed: false };

      _this._blur = _this._blur.bind(_this);
      _this._handleChange = _this._handleChange.bind(_this);
      _this._handleKeyUp = _this._handleKeyUp.bind(_this);
      _this._handleKeyDown = _this._handleKeyDown.bind(_this);
      _this._handleMouseUp = _this._handleMouseUp.bind(_this);
      _this._handleMouseDown = _this._handleMouseDown.bind(_this);
      _this._handleTouchEnd = _this._handleTouchEnd.bind(_this);
      _this._handleTouchStart = _this._handleTouchStart.bind(_this);
      _this._handleMouseOver = _this._handleMouseOver.bind(_this);
      _this._handleMouseLeave = _this._handleMouseLeave.bind(_this);
      return _this;
    }

    _createClass(FileInput, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (this.props.disabled && !nextProps.disabled && this.state.hover) {
          this.setState({ hover: false });
        }
      }
    }, {
      key: 'componentWillUpdate',
      value: function componentWillUpdate(nextProps, nextState) {
        var _this2 = this;

        // I honestly don't remember why this was implemented, but it was copied from the Button
        // component
        if (!this.state.pressed && nextState.pressed) {
          this._timeout = setTimeout(function () {
            _this2._timeout = null;
            if (_this2._attemptedBlur) {
              _this2._attemptedBlur = false;

              _this2.setState({ pressed: false });
            }
          }, 450);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this._timeout) {
          clearTimeout(this._timeout);
        }

        window.removeEventListener('click', this._blur);
      }
    }, {
      key: '_handleChange',
      value: function _handleChange(e) {
        var _props = this.props,
            multiple = _props.multiple,
            onChange = _props.onChange;
        var files = e.target.files;

        if (!multiple) {
          onChange(files[0] || null, e);
        } else {
          onChange(Array.prototype.slice.call(files), e);
        }
      }
    }, {
      key: '_blur',
      value: function _blur() {
        if (this.props.disabled) {
          return;
        }

        if (this._timeout) {
          this._attemptedBlur = true;
        } else {
          this.setState({ pressed: false });
        }
      }
    }, {
      key: '_handleMouseUp',
      value: function _handleMouseUp(e) {
        if (this.props.onMouseUp) {
          this.props.onMouseUp(e);
        }

        this._blur();
      }
    }, {
      key: '_handleMouseDown',
      value: function _handleMouseDown(e) {
        if (this.props.onMouseDown) {
          this.props.onMouseDown(e);
        }

        if (!this.props.disabled) {
          this.setState({ pressed: true });
        }
      }
    }, {
      key: '_handleTouchStart',
      value: function _handleTouchStart(e) {
        if (this.props.onTouchStart) {
          this.props.onTouchStart(e);
        }

        if (!this.props.disabled) {
          this.setState({ pressed: true });
        }
      }
    }, {
      key: '_handleTouchEnd',
      value: function _handleTouchEnd(e) {
        if (this.props.onTouchEnd) {
          this.props.onTouchEnd(e);
        }

        this._blur();
        (0, _captureNextEvent2.default)('mouseover');
      }
    }, {
      key: '_handleKeyUp',
      value: function _handleKeyUp(e) {
        if (this.props.onKeyUp) {
          this.props.onKeyUp(e);
        }

        if ((e.which || e.keyCode) === _keyCodes.TAB) {
          window.addEventListener('click', this._blur);
          this.setState({ pressed: true });
        }
      }
    }, {
      key: '_handleKeyDown',
      value: function _handleKeyDown(e) {
        if (this.props.onKeyDown) {
          this.props.onKeyDown(e);
        }

        var key = e.which || e.keyCode;

        if (key === _keyCodes.TAB) {
          window.removeEventListener('click', this._blur);
          this.setState({ pressed: false });
        } else if (key === _keyCodes.SPACE || key === _keyCodes.ENTER) {
          e.preventDefault();
          e.target.click();
        }
      }
    }, {
      key: '_handleMouseOver',
      value: function _handleMouseOver(e) {
        if (this.props.onMouseOver) {
          this.props.onMouseOver(e);
        }

        if (!this.props.disabled) {
          this.setState({ hover: true });
        }
      }
    }, {
      key: '_handleMouseLeave',
      value: function _handleMouseLeave(e) {
        if (this.props.onMouseLeave) {
          this.props.onMouseLeave(e);
        }

        if (!this.props.disabled) {
          this.setState({ hover: false });
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _state = this.state,
            hover = _state.hover,
            pressed = _state.pressed;

        var _props2 = this.props,
            style = _props2.style,
            className = _props2.className,
            label = _props2.label,
            iconChildren = _props2.iconChildren,
            iconClassName = _props2.iconClassName,
            primary = _props2.primary,
            secondary = _props2.secondary,
            flat = _props2.flat,
            id = _props2.id,
            iconBefore = _props2.iconBefore,
            disabled = _props2.disabled,
            accept = _props2.accept,
            multiple = _props2.multiple,
            props = _objectWithoutProperties(_props2, ['style', 'className', 'label', 'iconChildren', 'iconClassName', 'primary', 'secondary', 'flat', 'id', 'iconBefore', 'disabled', 'accept', 'multiple']);

        delete props.onChange;
        delete props.onKeyUp;
        delete props.onKeyDown;
        delete props.onMouseUp;
        delete props.onMouseDown;
        delete props.onMouseOver;
        delete props.onMouseLeave;
        delete props.onTouchStart;
        delete props.onTouchEnd;

        var icon = !iconClassName && !iconChildren ? null : _react2.default.createElement(
          _FontIcon2.default,
          { iconClassName: iconClassName },
          iconChildren
        );

        var themeClassNames = !disabled && (0, _classnames2.default)({
          'md-text--theme-primary md-ink--primary': flat && primary,
          'md-text--theme-secondary md-ink--secondary': flat && secondary,
          'md-background--primary md-background--primary-hover': !flat && primary,
          'md-background--secondary md-background--secondary-hover': !flat && secondary,
          'md-btn--color-primary-active': flat && hover && primary,
          'md-btn--color-secondary-active': flat && hover && secondary
        });

        var labelChildren = label;
        if (icon) {
          labelChildren = _react2.default.createElement(
            _IconSeparator2.default,
            { label: label, iconBefore: iconBefore },
            icon
          );
        }

        return _react2.default.createElement(
          'div',
          _extends({}, props, {
            style: style,
            className: (0, _classnames2.default)('md-inline-block md-file-input-container', className)
          }),
          _react2.default.createElement(
            _AccessibleFakeInkedButton2.default,
            {
              component: 'label',
              htmlFor: id,
              disabled: disabled,
              onTouchStart: this._handleTouchStart,
              onTouchEnd: this._handleTouchEnd,
              onMouseDown: this._handleMouseDown,
              onMouseUp: this._handleMouseUp,
              onKeyDown: this._handleKeyDown,
              onKeyUp: this._handleKeyUp,
              onMouseOver: this._handleMouseOver,
              onMouseLeave: this._handleMouseLeave,
              className: (0, _classnames2.default)('md-btn md-btn--' + (flat || disabled ? 'flat' : 'raised') + ' md-btn--text', themeClassNames, {
                'md-text': !disabled,
                'md-text--disabled': disabled,
                'md-btn--raised-disabled': disabled && !flat,
                'md-btn--raised-pressed': !disabled && !flat && pressed
              })
            },
            labelChildren
          ),
          _react2.default.createElement('input', {
            multiple: multiple,
            disabled: disabled,
            id: id,
            accept: accept,
            type: 'file',
            'aria-hidden': 'true',
            className: 'md-file-input',
            onChange: this._handleChange
          })
        );
      }
    }]);

    return FileInput;
  }(_react.PureComponent);

  FileInput.propTypes = {
    /**
     * The id for the text field. This is required for a11y and to get the `input type="file"` to
     * open.
     */
    id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),

    /**
     * An optional style to apply.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply.
     */
    className: _propTypes2.default.string,

    /**
     * Boolean if the `FileInput` should be styled with the primary color.
     */
    primary: _propTypes2.default.bool,

    /**
     * Boolean if the `FileInput` should be styled with the secondary color.
     */
    secondary: _propTypes2.default.bool,

    /**
     * Boolean if the `FileInput` should be styled as a flat button instead of a
     * raised button.
     */
    flat: _propTypes2.default.bool,

    /**
     * This should be a comma separated list of Media Types that the `FileInput` can
     * accept. If this prop is left blank, any file will be accepted.
     *
     * The values can either be:
     * - A file extension
     * - audio/*
     * - video/*
     * - image/*
     * - any valid [IANA Media Type](http://www.iana.org/assignments/media-types/media-types.xhtml)
     *
     * > NOTE: IE does not enforce this.
     */
    accept: _propTypes2.default.string,

    /**
     * Boolean if multiple files will be accepted.
     */
    multiple: _propTypes2.default.bool,

    /**
     * A label to display on the `FileInput`. This will be used with the `AccessibleFakeInkedButton` component to
     * create a `<label>` for the `<input type="file">`.
     */
    label: _propTypes2.default.node.isRequired,

    /**
     * Boolean if the icons hould appear before the label.
     */
    iconBefore: _propTypes2.default.bool,

    /**
     * The icon children to use for the upload icon.
     */
    iconChildren: _propTypes2.default.node,

    /**
     * The icon className to use for the upload icon.
     */
    iconClassName: _propTypes2.default.string,

    /**
     * A function to call when the value of the input changes. This will
     * be triggered when the user selects a new file or cancels the new file selection.
     *
     * This function will be given the new [FileList](https://developer.mozilla.org/en-US/docs/Web/API/FileList)
     * as an array and the change event. If this is not a multiple file input, only the
     * newly selected File will be given instead of a list of one file. Since this is an
     * `input` tag, the user will not be able to select the same file multiple times unless
     * you manually clear the input's value.
     *
     * > NOTE: If the user hits cancel, null will be given for a single file input.
     *
     * ```js
     * onChange(files, e);
     * ```
     */
    onChange: _propTypes2.default.func.isRequired,

    /**
     * Boolean if the `FileInput` is currently disabled.
     */
    disabled: _propTypes2.default.bool,

    /**
     * An optional function to call when they keyup event is triggerred on the file input's label.
     */
    onKeyUp: _propTypes2.default.func,

    /**
     * An optional function to call when they keydown event is triggerred on the file input's label.
     */
    onKeyDown: _propTypes2.default.func,

    /**
     * An optional function to call when they mouseup event is triggerred on the file input's label.
     */
    onMouseUp: _propTypes2.default.func,

    /**
     * An optional function to call when they mousedown event is triggerred on the file input's label.
     */
    onMouseDown: _propTypes2.default.func,

    /**
     * An optional function to call when they mouseover event is triggerred on the file input's label.
     */
    onMouseOver: _propTypes2.default.func,

    /**
     * An optional function to call when they mouseleave event is triggerred on the file input's label.
     */
    onMouseLeave: _propTypes2.default.func,

    /**
     * An optional function to call when they touchend event is triggerred on the file input's label.
     */
    onTouchEnd: _propTypes2.default.func,

    /**
     * An optional function to call when they touchstart event is triggerred on the file input's label.
     */
    onTouchStart: _propTypes2.default.func
  };
  FileInput.defaultProps = {
    label: 'Select a file',
    iconChildren: 'file_upload'
  };
  exports.default = FileInput;
});

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(9), __webpack_require__(75), __webpack_require__(587)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('react-dom'), require('invariant'), require('../utils/EventUtils/isValidFocusKeypress'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.reactDom, global.invariant, global.isValidFocusKeypress);
    global.FocusContainer = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _reactDom, _invariant, _isValidFocusKeypress) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _invariant2 = _interopRequireDefault(_invariant);

  var _isValidFocusKeypress2 = _interopRequireDefault(_isValidFocusKeypress);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _toArray(arr) {
    return Array.isArray(arr) ? arr : Array.from(arr);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var hrefables = ['a', 'area'].map(function (tag) {
    return tag + '[href],';
  }).join('');
  var disableables = ['button', 'input', 'textarea', 'select'].map(function (tag) {
    return tag + ':not([disabled]),';
  }).join('');
  var FOCUSABLE_QUERY = '' + hrefables + disableables + '*[tabIndex]';

  /**
   * This component is used for keeping the focus within some container. When the container
   * is mounted and the `focusOnMount` prop is `true`, it will attempt to focus either:
   * - an element that matches `document.getElementById(this.props.initialFocus)`
   * - an element that matches `this._container.querySelector(this.props.initialFocus)`
   * - the first focusable element in it's children (if `this.props.initialFocus` is omitted)
   */

  var FocusContainer = function (_PureComponent) {
    _inherits(FocusContainer, _PureComponent);

    function FocusContainer(props) {
      _classCallCheck(this, FocusContainer);

      var _this = _possibleConstructorReturn(this, (FocusContainer.__proto__ || Object.getPrototypeOf(FocusContainer)).call(this, props));

      _this.state = {};
      _this._containFocus = _this._containFocus.bind(_this);
      _this._handleFocus = _this._handleFocus.bind(_this);
      _this._handleKeyDown = _this._handleKeyDown.bind(_this);
      _this._enableFocusTrap = _this._enableFocusTrap.bind(_this);
      _this._disableFocusTrap = _this._disableFocusTrap.bind(_this);
      _this._attemptInitialFocus = _this._attemptInitialFocus.bind(_this);
      return _this;
    }

    _createClass(FocusContainer, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (this.props.containFocus === nextProps.containFocus) {
          return;
        }

        if (this.props.containFocus) {
          this._enableFocusTrap();
          this._attemptInitialFocus();
        } else {
          this._disableFocusTrap();
        }
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        if (this._container) {
          this._focusables = Array.prototype.slice.call(this._container.querySelectorAll(FOCUSABLE_QUERY)).filter(function (el) {
            return el.tabIndex !== -1;
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this._container) {
          this._disableFocusTrap();
        }
      }
    }, {
      key: '_enableFocusTrap',
      value: function _enableFocusTrap() {
        window.addEventListener('focus', this._handleFocus, true);
        window.addEventListener('keydown', this._handleKeyDown, true);
      }
    }, {
      key: '_disableFocusTrap',
      value: function _disableFocusTrap() {
        window.removeEventListener('focus', this._handleFocus, true);
        window.removeEventListener('keydown', this._handleKeyDown, true);
      }
    }, {
      key: '_attemptInitialFocus',
      value: function _attemptInitialFocus() {
        if (!this._container) {
          return;
        }

        var initialFocus = this.props.initialFocus;


        var toFocus = initialFocus ? document.getElementById(initialFocus) || this._container.querySelector(initialFocus) : this._focusables[0];

        var debugError = void 0;
        if (!toFocus && initialFocus) {
          debugError = ' The `initialFocus` did not match a document\'s `id` or was an invalid ';
          debugError += '`querySelector` for the container. `initialFocus`: `' + initialFocus + '`. ';
          debugError += 'If this was supposed to be an `id`, make sure to prefix with the `#` symbol.';
        }

        (0, _invariant2.default)(toFocus, 'You specified that the `FocusContainer` should focus an element on mount, ' + 'but a focusable element was not found in the children. This could be because ' + 'the `initialFocus` prop is an invalid id or query selector, or the children ' + ('do not contain a valid focusable element.' + debugError));

        if (toFocus) {
          toFocus.focus();
        }
      }
    }, {
      key: '_containFocus',
      value: function _containFocus(containerRef) {
        if (containerRef === null) {
          this._container = null;
          this._disableFocusTrap();
          return;
        }

        var focusOnMount = this.props.focusOnMount;

        this._container = (0, _reactDom.findDOMNode)(containerRef);
        this._focusables = Array.prototype.slice.call(this._container.querySelectorAll(FOCUSABLE_QUERY)).filter(function (el) {
          return el.tabIndex !== -1;
        });

        if (focusOnMount) {
          this._attemptInitialFocus();
        }

        this._enableFocusTrap();
      }
    }, {
      key: '_handleFocus',
      value: function _handleFocus(e) {
        if (e.target !== window && this._shifted && this._container && !this._container.contains(e.target)) {
          // Prevent the default focus action and focus the last focusable item
          e.stopPropagation();
          this._focusables[this._focusables.length - 1].focus();
        }
      }
    }, {
      key: '_handleKeyDown',
      value: function _handleKeyDown(e) {
        this._shifted = e.shiftKey;
        if (!(0, _isValidFocusKeypress2.default)(e, this.props.additionalFocusKeys)) {
          return;
        }

        var target = e.target,
            shiftKey = e.shiftKey;

        var _focusables = _toArray(this._focusables),
            first = _focusables[0],
            focusables = _focusables.slice(1);

        var last = focusables[focusables.length - 1];

        if (shiftKey && target === first) {
          e.preventDefault();
          last.focus();
        } else if (!shiftKey && target === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            Component = _props.component,
            props = _objectWithoutProperties(_props, ['component']);

        delete props.initialFocus;
        delete props.focusOnMount;
        delete props.containFocus;
        delete props.additionalFocusKeys;

        return _react2.default.createElement(Component, _extends({}, props, { ref: this._containFocus }));
      }
    }]);

    return FocusContainer;
  }(_react.PureComponent);

  FocusContainer.propTypes = {
    /**
     * The component to render as. This can be a React DOM element or
     * a react Component.
     */
    component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,

    /**
     * An optional style to apply.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply.
     */
    className: _propTypes2.default.string,

    /**
     * The children to display.
     */
    children: _propTypes2.default.node,

    /**
     * An optional id string or a query selector string to use for the initial focus.
     * This will only be triggered if the `focusOnMount` prop is `true`. If this is
     * omitted and the `focusOnMount` prop is `true`, the first focusable element in the
     * container will be focused.
     *
     * Examples:
     *
     * ```js
     * initialFocus="#someAmazingId"
     * // or
     * initialFocus=".md-btn,.md-list-tile"
     * ```
     */
    initialFocus: _propTypes2.default.string,

    /**
     * Boolean if an element in the container should be focused when mounted.
     */
    focusOnMount: _propTypes2.default.bool,

    /**
     * An optional list of additional key codes to use for focus events.
     */
    additionalFocusKeys: _propTypes2.default.arrayOf(_propTypes2.default.number),

    /**
     * Boolean if the focus container should start or stop containing the focus within the container.
     * This is useful for changing the focus requirements after mount.
     */
    containFocus: _propTypes2.default.bool
  };
  FocusContainer.defaultProps = {
    component: 'div'
  };
  exports.default = FocusContainer;
});

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames);
    global.ListItemText = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var ListItemText = function (_PureComponent) {
    _inherits(ListItemText, _PureComponent);

    function ListItemText() {
      _classCallCheck(this, ListItemText);

      return _possibleConstructorReturn(this, (ListItemText.__proto__ || Object.getPrototypeOf(ListItemText)).apply(this, arguments));
    }

    _createClass(ListItemText, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            active = _props.active,
            activeClassName = _props.activeClassName,
            disabled = _props.disabled,
            primaryText = _props.primaryText,
            secondaryText = _props.secondaryText,
            className = _props.className,
            threeLines = _props.threeLines,
            props = _objectWithoutProperties(_props, ['active', 'activeClassName', 'disabled', 'primaryText', 'secondaryText', 'className', 'threeLines']);

        var secondaryTextNode = void 0;
        if (secondaryText) {
          secondaryTextNode = _react2.default.createElement(
            'div',
            {
              className: (0, _classnames2.default)('md-tile-text--secondary', {
                'md-text--disabled': disabled,
                'md-text--secondary': !disabled,
                'md-tile-text--three-lines': threeLines
              })
            },
            secondaryText
          );
        }

        return _react2.default.createElement(
          'div',
          _extends({}, props, { className: (0, _classnames2.default)('md-tile-content', className) }),
          _react2.default.createElement(
            'div',
            {
              className: (0, _classnames2.default)('md-tile-text--primary', _defineProperty({
                'md-text--disabled': disabled,
                'md-text': !disabled && !active
              }, activeClassName, !disabled && active))
            },
            primaryText
          ),
          secondaryTextNode
        );
      }
    }]);

    return ListItemText;
  }(_react.PureComponent);

  ListItemText.propTypes = {
    active: _propTypes2.default.bool,
    activeClassName: _propTypes2.default.string,
    disabled: _propTypes2.default.bool,
    primaryText: _propTypes2.default.node.isRequired,
    secondaryText: _propTypes2.default.node,
    className: _propTypes2.default.string,
    threeLines: _propTypes2.default.bool
  };
  exports.default = ListItemText;
});

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(45), __webpack_require__(63), __webpack_require__(254)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./List'), require('./ListItem'), require('./ListItemControl'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.List, global.ListItem, global.ListItemControl);
    global.index = mod.exports;
  }
})(this, function (exports, _List, _ListItem2, _ListItemControl2) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.ListItemControl = exports.ListItem = exports.List = undefined;

  var _List2 = _interopRequireDefault(_List);

  var _ListItem3 = _interopRequireDefault(_ListItem2);

  var _ListItemControl3 = _interopRequireDefault(_ListItemControl2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _List2.default;
  exports.List = _List2.default;
  exports.ListItem = _ListItem3.default;
  exports.ListItemControl = _ListItemControl3.default;
});

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames);
    global.Media = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  function validateAspectRatio(props, propName, component) {
    var _PropTypes$string;

    var value = props[propName];

    for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      args[_key - 3] = arguments[_key];
    }

    var err = (_PropTypes$string = _propTypes2.default.string).isRequired.apply(_PropTypes$string, [props, propName, component].concat(args));
    if (!err && value.split('-').length !== 2) {
      err = new Error('Your provided an `' + propName + '` prop to the ' + component + ' that is not a valid ' + ('aspect ratio `' + value + '`. This should be in the form of \'{width}-{height}\'.'));
    }

    return err;
  }

  /**
   * The `Media` component is used to display images, iframes, ...media. Who'da thunk?
   */

  var Media = function (_PureComponent) {
    _inherits(Media, _PureComponent);

    function Media() {
      _classCallCheck(this, Media);

      return _possibleConstructorReturn(this, (Media.__proto__ || Object.getPrototypeOf(Media)).apply(this, arguments));
    }

    _createClass(Media, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            Component = _props.component,
            className = _props.className,
            children = _props.children,
            forceAspect = _props.forceAspect,
            aspectRatio = _props.aspectRatio,
            props = _objectWithoutProperties(_props, ['component', 'className', 'children', 'forceAspect', 'aspectRatio']);

        delete props.expandable;

        return _react2.default.createElement(
          Component,
          _extends({}, props, {
            className: (0, _classnames2.default)('md-media', _defineProperty({}, 'md-media--' + aspectRatio, forceAspect), className)
          }),
          children
        );
      }
    }]);

    return Media;
  }(_react.PureComponent);

  Media.propTypes = {
    /**
     * An optional className to apply to the card media component.
     */
    className: _propTypes2.default.string,

    /**
     * Any media to display.
     */
    children: _propTypes2.default.node,

    /**
     * Boolean if the aspect ratio should be forced.
     */
    forceAspect: _propTypes2.default.bool,

    /**
     * The aspect ratio to use.
     */
    aspectRatio: validateAspectRatio,

    /**
     * Boolean if this component should be expandable when there is a `CardExpander`
     * above it in the `Card`.
     */
    expandable: _propTypes2.default.bool,

    /**
     * The component to render the card media as.
     */
    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired
  };
  Media.defaultProps = {
    forceAspect: true,
    aspectRatio: '16-9',
    component: 'section'
  };
  exports.default = Media;
});

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames);
    global.MediaOverlay = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var MediaOverlay = function (_PureComponent) {
    _inherits(MediaOverlay, _PureComponent);

    function MediaOverlay() {
      _classCallCheck(this, MediaOverlay);

      return _possibleConstructorReturn(this, (MediaOverlay.__proto__ || Object.getPrototypeOf(MediaOverlay)).apply(this, arguments));
    }

    _createClass(MediaOverlay, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            className = _props.className,
            Component = _props.component,
            props = _objectWithoutProperties(_props, ['className', 'component']);

        return _react2.default.createElement(Component, _extends({ className: (0, _classnames2.default)('md-media-overlay', className) }, props));
      }
    }]);

    return MediaOverlay;
  }(_react.PureComponent);

  MediaOverlay.propTypes = {
    /**
     * An optional style to apply to the overlay.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply to the overlay.
     */
    className: _propTypes2.default.string,

    /**
     * Any children to display in the overlay. This is _normally_ a `CardTitle` component
     * or some buttons.
     */
    children: _propTypes2.default.node,

    /**
     * The component to be rendered as.
     */
    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired
  };
  MediaOverlay.defaultProps = {
    component: 'div'
  };
  exports.default = MediaOverlay;
});

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(17), __webpack_require__(116), __webpack_require__(11), __webpack_require__(156)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('react-prop-types/lib/isRequiredForA11y'), require('./Menu'), require('../Buttons/Button'), require('./Positions'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.isRequiredForA11y, global.Menu, global.Button, global.Positions);
    global.MenuButton = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _isRequiredForA11y, _Menu, _Button, _Positions) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);

  var _Menu2 = _interopRequireDefault(_Menu);

  var _Button2 = _interopRequireDefault(_Button);

  var _Positions2 = _interopRequireDefault(_Positions);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var MenuButton = function (_PureComponent) {
    _inherits(MenuButton, _PureComponent);

    function MenuButton(props) {
      _classCallCheck(this, MenuButton);

      var _this = _possibleConstructorReturn(this, (MenuButton.__proto__ || Object.getPrototypeOf(MenuButton)).call(this, props));

      _this.state = {
        isOpen: props.defaultOpen || false
      };
      _this._toggleMenu = _this._toggleMenu.bind(_this);
      _this._closeMenu = _this._closeMenu.bind(_this);
      return _this;
    }

    _createClass(MenuButton, [{
      key: '_toggleMenu',
      value: function _toggleMenu(e) {
        var isOpen = !this.state.isOpen;
        if (this.props.onClick) {
          this.props.onClick(e);
        }

        if (this.props.onMenuToggle) {
          this.props.onMenuToggle(isOpen, e);
        }

        this.setState({ isOpen: isOpen });
      }
    }, {
      key: '_closeMenu',
      value: function _closeMenu(e) {
        if (this.props.onMenuToggle) {
          this.props.onMenuToggle(false, e);
        }

        this.setState({ isOpen: false });
      }
    }, {
      key: 'render',
      value: function render() {
        var isOpen = this.state.isOpen;

        var _props = this.props,
            id = _props.id,
            listId = _props.listId,
            buttonId = _props.buttonId,
            menuStyle = _props.menuStyle,
            menuClassName = _props.menuClassName,
            listStyle = _props.listStyle,
            listClassName = _props.listClassName,
            buttonChildren = _props.buttonChildren,
            children = _props.children,
            fullWidth = _props.fullWidth,
            position = _props.position,
            contained = _props.contained,
            transitionName = _props.transitionName,
            transitionEnterTimeout = _props.transitionEnterTimeout,
            transitionLeaveTimeout = _props.transitionLeaveTimeout,
            props = _objectWithoutProperties(_props, ['id', 'listId', 'buttonId', 'menuStyle', 'menuClassName', 'listStyle', 'listClassName', 'buttonChildren', 'children', 'fullWidth', 'position', 'contained', 'transitionName', 'transitionEnterTimeout', 'transitionLeaveTimeout']);

        delete props.onClick;
        delete props.onMenuToggle;
        delete props.defaultOpen;

        var toggle = _react2.default.createElement(
          _Button2.default,
          _extends({
            key: 'menu-button'
          }, props, {
            id: buttonId,
            onClick: this._toggleMenu
          }),
          buttonChildren
        );

        return _react2.default.createElement(
          _Menu2.default,
          {
            id: id,
            listId: listId,
            style: menuStyle,
            className: menuClassName,
            listStyle: listStyle,
            listClassName: listClassName,
            toggle: toggle,
            isOpen: isOpen,
            onClose: this._closeMenu,
            contained: contained,
            position: position,
            fullWidth: fullWidth,
            transitionName: transitionName,
            transitionEnterTimeout: transitionEnterTimeout,
            transitionLeaveTimeout: transitionLeaveTimeout
          },
          children
        );
      }
    }]);

    return MenuButton;
  }(_react.PureComponent);

  MenuButton.Positions = _Positions2.default;
  MenuButton.propTypes = {
    /**
     * An id to use for the menu button. This is required for a11y
     */
    id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),

    /**
     * An optional id to give the button instead of the menu.
     */
    buttonId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),

    /**
     * An optional id to give the list that appears in the menu.
     */
    listId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),

    /**
     * An optional style to apply to the button.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply to the button.
     */
    className: _propTypes2.default.string,

    /**
     * An optional style to apply to the menu.
     */
    menuStyle: _propTypes2.default.object,

    /**
     * An optional className to apply to the menu.
     */
    menuClassName: _propTypes2.default.string,

    /**
     * An optional style to apply to the menu's list when it is open.
     */
    listStyle: _propTypes2.default.object,

    /**
     * An optional className to apply to the menu's list when it is open.
     */
    listClassName: _propTypes2.default.string,

    /**
     * Any children used to render icons or anything else for the button.
     */
    buttonChildren: _propTypes2.default.node,

    /**
     * An optional function to call when the button is clicked.
     */
    onClick: _propTypes2.default.func,

    /**
     * An optional function to call when the menu's visiblity is toggled. The callback
     * will include the next `open` state and the click event.
     */
    onMenuToggle: _propTypes2.default.func,

    /**
     * Boolean if the MenuButton is open by default.
     */
    defaultOpen: _propTypes2.default.bool,

    /**
     * The position for the menu.
     */
    position: _propTypes2.default.oneOf([_Positions2.default.TOP_LEFT, _Positions2.default.TOP_RIGHT, _Positions2.default.BOTTOM_LEFT, _Positions2.default.BOTTOM_RIGHT, _Positions2.default.BELOW]),

    /**
     * A list of `ListItem`s to render when the Menu is toggled open.
     */
    children: _propTypes2.default.node,

    /**
     * Boolean if the `Menu` is displayed as full width.
     */
    fullWidth: _propTypes2.default.bool,

    /**
     * Boolean if the max width of the menu's list should be equal to the `Button`.
     */
    contained: _propTypes2.default.bool,

    /**
     * An optional transition name to use for the menu transitions.
     */
    transitionName: _propTypes2.default.string,

    /**
     * An optional transition leave timeout to use for the menu transitions.
     */
    transitionEnterTimeout: _propTypes2.default.number,

    /**
     * An optional transition leave timeout to use for the menu transitions.
     */
    transitionLeaveTimeout: _propTypes2.default.number
  };
  exports.default = MenuButton;
});

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(156)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('prop-types'), require('./Positions'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.propTypes, global.Positions);
    global.contextTypes = mod.exports;
  }
})(this, function (exports, _propTypes, _Positions) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _Positions2 = _interopRequireDefault(_Positions);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = {
    menuCascading: _propTypes2.default.bool,
    menuPosition: _propTypes2.default.oneOf([_Positions2.default.TOP_LEFT, _Positions2.default.TOP_RIGHT, _Positions2.default.BOTTOM_LEFT, _Positions2.default.BOTTOM_RIGHT, _Positions2.default.CONTEXT, _Positions2.default.BELOW]),
    listLevel: _propTypes2.default.number
  };
});

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(11)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('../Buttons/Button'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.Button);
    global.CloseButton = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _Button) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _Button2 = _interopRequireDefault(_Button);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var CloseButton = function (_PureComponent) {
    _inherits(CloseButton, _PureComponent);

    function CloseButton(props) {
      _classCallCheck(this, CloseButton);

      var _this = _possibleConstructorReturn(this, (CloseButton.__proto__ || Object.getPrototypeOf(CloseButton)).call(this, props));

      _this._handleClick = _this._handleClick.bind(_this);
      return _this;
    }

    _createClass(CloseButton, [{
      key: '_handleClick',
      value: function _handleClick(e) {
        if (this.props.onClick) {
          this.props.onClick(e);
        }

        if (this.context.onCloseClick) {
          this.context.onCloseClick(e);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _context = this.context,
            iconClassName = _context.closeIconClassName,
            children = _context.closeChildren;


        return _react2.default.createElement(
          _Button2.default,
          _extends({}, this.props, {
            icon: true,
            key: 'close',
            iconClassName: iconClassName,
            onClick: this._handleClick
          }),
          children
        );
      }
    }]);

    return CloseButton;
  }(_react.PureComponent);

  CloseButton.propTypes = {
    /**
     * An optional className to apply.
     */
    className: _propTypes2.default.string,

    /**
     * An optional additional function to call when the `click` event is triggered.
     */
    onClick: _propTypes2.default.func
  };
  CloseButton.contextTypes = {
    closeIconClassName: _propTypes2.default.string,
    closeChildren: _propTypes2.default.node,
    onCloseClick: _propTypes2.default.func
  };
  exports.default = CloseButton;
});

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames);
    global.JumpToContentLink = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var JumpToContentLink = function (_PureComponent) {
    _inherits(JumpToContentLink, _PureComponent);

    function JumpToContentLink(props) {
      _classCallCheck(this, JumpToContentLink);

      var _this = _possibleConstructorReturn(this, (JumpToContentLink.__proto__ || Object.getPrototypeOf(JumpToContentLink)).call(this, props));

      _this._handleClick = _this._handleClick.bind(_this);
      return _this;
    }

    _createClass(JumpToContentLink, [{
      key: '_handleClick',
      value: function _handleClick(e) {
        if (this.props.onClick) {
          this.props.onClick(e);
        }

        document.getElementById(this.context.id).focus();
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            className = _props.className,
            props = _objectWithoutProperties(_props, ['className']);

        var _context = this.context,
            id = _context.id,
            label = _context.label;

        return _react2.default.createElement(
          'a',
          _extends({}, props, {
            id: 'skipTo' + id,
            href: '#' + id,
            onClick: this._handleClick,
            className: (0, _classnames2.default)('md-content-jump', className)
          }),
          label
        );
      }
    }]);

    return JumpToContentLink;
  }(_react.PureComponent);

  JumpToContentLink.propTypes = {
    /**
     * An optional className to apply.
     */
    className: _propTypes2.default.string,

    /**
     * An optional function to call when the linked is clicked.
     */
    onClick: _propTypes2.default.func
  };
  JumpToContentLink.contextTypes = {
    id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
    label: _propTypes2.default.node.isRequired
  };
  exports.default = JumpToContentLink;
});

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(17), __webpack_require__(120)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('react-prop-types/lib/isRequiredForA11y'), require('../utils/PropTypes/between'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.isRequiredForA11y, global.between);
    global.CircularProgress = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _isRequiredForA11y, _between) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);

  var _between2 = _interopRequireDefault(_between);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var ROATE_DISTANCE = 360 * 1.75;
  var BASE_SIZE = 24; // font-icon font size

  /**
   * The `CircularProgress` component is used to give visual feedback while your app
   * is loading.
   *
   * There are two different types of circular progress bars: `Determinate` and `Indeterminate`.
   *
   * A `Determinate` circular progress bar should be used when you want to keep track of the current
   * progress. An example would be downloading a file.
   *
   * An `Indeterminate` circular progress bar should be used when you can not keep track of the progress
   * yourself. An example would be waiting for some API call to complete.
   */

  var CircularProgress = function (_PureComponent) {
    _inherits(CircularProgress, _PureComponent);

    function CircularProgress() {
      _classCallCheck(this, CircularProgress);

      return _possibleConstructorReturn(this, (CircularProgress.__proto__ || Object.getPrototypeOf(CircularProgress)).apply(this, arguments));
    }

    _createClass(CircularProgress, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            scale = _props.scale,
            style = _props.style,
            className = _props.className,
            value = _props.value,
            determinateDashoffset = _props.determinateDashoffset,
            centered = _props.centered,
            props = _objectWithoutProperties(_props, ['scale', 'style', 'className', 'value', 'determinateDashoffset', 'centered']);

        var isDeterminate = typeof value === 'number';
        var circleStyle = void 0;
        var svgStyle = style;
        if (isDeterminate) {
          var rotate = 'rotate3d(0, 0, 1, ' + ROATE_DISTANCE / 100 * value + 'deg)';
          circleStyle = {
            strokeDashoffset: determinateDashoffset - determinateDashoffset / 100 * value
          };

          svgStyle = Object.assign({}, style, {
            WebkitTransform: (0, _classnames2.default)(style.WebkitTransform, rotate),
            MozTransform: (0, _classnames2.default)(style.MozTransform, rotate),
            transform: (0, _classnames2.default)(style.transform, rotate)
          });
        }

        var accessibilityProps = {
          role: 'progressbar',
          'aria-valuemin': 0,
          'aria-valuemax': 100
        };

        if (isDeterminate) {
          accessibilityProps['aria-valuenow'] = value;
        }

        return _react2.default.createElement(
          'svg',
          _extends({}, props, accessibilityProps, {
            style: svgStyle,
            className: (0, _classnames2.default)('md-progress md-progress--circular', {
              'md-block-centered': centered,
              'md-progress--circular-determinate': isDeterminate,
              'md-progress--circular-indeterminate': !isDeterminate
            }, className),
            width: scale * BASE_SIZE,
            height: scale * BASE_SIZE,
            viewBox: '0 0 66 66'
          }),
          _react2.default.createElement('circle', {
            className: (0, _classnames2.default)('md-circular-progress-path', {
              'md-circular-progress-path--animated': !isDeterminate
            }),
            strokeWidth: '6',
            strokeLinecap: 'round',
            style: circleStyle,
            cx: '33',
            cy: '33',
            r: '30'
          })
        );
      }
    }]);

    return CircularProgress;
  }(_react.PureComponent);

  CircularProgress.propTypes = {
    /**
     * The `id` prop is required for accessibility concerns.
     * [Progress Bar Role](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_progressbar_role)
     *
     * > If the progressbar is describing the loading progress of a particular region of a page, the author
     * __SHOULD__ use aria-describedby to point to the status, and set the aria-busy attribute to true on the
     * region until it is finished loading. It is not possible for the user to alter the value of a progressbar
     * because it is always readonly.
     */
    id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),

    /* eslint-enable max-len */

    /**
     * A style object to apply to the svg. If this is a determinate `CircularProgress`,
     * the `transform` (and vendor prefixes) styles will be merged with the current
     * progress rotation.
     */
    style: _propTypes2.default.object.isRequired,

    /**
     * An optional className to apply to the svg.
     */
    className: _propTypes2.default.string,

    /**
     * The current value of the progress. If this value is defined, it will
     * be converted to a determinate circular progress. The progress will not
     * advance unless this value changes.
     *
     * This value should also be a number between 0 and 100.
     */
    value: (0, _between2.default)(_propTypes2.default.number, 0, 100),

    /**
     * The scale for the circular progress.
     */
    scale: _propTypes2.default.number.isRequired,

    /**
     * You probably don't want to update this. I'm not good at svg. This should
     * match the scss variable `$md-circular-progress-stroke-dashoffset`.
     */
    determinateDashoffset: _propTypes2.default.number.isRequired,

    /**
     * Boolean if the the progress should be centered in it's container.
     */
    centered: _propTypes2.default.bool
  };
  CircularProgress.defaultProps = {
    style: {},
    scale: 1,
    determinateDashoffset: 187,
    centered: true
  };
  exports.default = CircularProgress;
});

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(12), __webpack_require__(17), __webpack_require__(20), __webpack_require__(83)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('react-prop-types/lib/deprecated'), require('react-prop-types/lib/isRequiredForA11y'), require('../utils/PropTypes/controlled'), require('./SelectionControl'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.deprecated, global.isRequiredForA11y, global.controlled, global.SelectionControl);
    global.Switch = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _deprecated, _isRequiredForA11y, _controlled, _SelectionControl) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _deprecated2 = _interopRequireDefault(_deprecated);

  var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);

  var _controlled2 = _interopRequireDefault(_controlled);

  var _SelectionControl2 = _interopRequireDefault(_SelectionControl);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Switch = function (_PureComponent) {
    _inherits(Switch, _PureComponent);

    function Switch() {
      _classCallCheck(this, Switch);

      return _possibleConstructorReturn(this, (Switch.__proto__ || Object.getPrototypeOf(Switch)).apply(this, arguments));
    }

    _createClass(Switch, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            toggled = _props.toggled,
            defaultToggled = _props.defaultToggled,
            props = _objectWithoutProperties(_props, ['toggled', 'defaultToggled']);

        if (typeof toggled !== 'undefined' && typeof props.checked === 'undefined') {
          props.checked = toggled;
        }

        if (typeof defaultToggled !== 'undefined' && typeof props.defaultChecked === 'undefined') {
          props.defaultChecked = defaultToggled;
        }

        return _react2.default.createElement(_SelectionControl2.default, _extends({ type: 'switch' }, props, { __superSecreteProp: true }));
      }
    }]);

    return Switch;
  }(_react.PureComponent);

  Switch.propTypes = {
    /**
     * An id to use with the switch. This is used for accessibility and so that the label
     * triggers the switch toggle.
     */
    id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),

    /**
     * An optional style to apply to the switch's container.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply to the switch's container.
     */
    className: _propTypes2.default.string,

    /**
     * A label to display with the switch. This is required for accessibility and triggering
     * the toggle.
     */
    label: _propTypes2.default.node,

    /**
     * Boolean if the label should appear before the switch.
     */
    labelBefore: _propTypes2.default.bool,

    /**
     * A name to use for the `Switch`. This is required for accessibility since behind the scenes
     * the `Switch` is renders as an `<input type="checkbox" />`.
     */
    name: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),

    /**
     * Boolean if the `Switch` is disabled.
     */
    disabled: _propTypes2.default.bool,

    /**
     * An optional function to call when the `checked` state of the `Switch` changes.
     * The callback will incude the new checked state and the changeEvent.
     *
     * ```js
     * onChange(changeEvent.target.checked, changeEvent);
     * ```
     */
    onChange: _propTypes2.default.func,

    /**
     * An optional value for the `Switch`. It is recommended to use a value though.
     */
    value: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.string]),

    /**
     * Boolean if the `Switch` is checked by default.
     */
    defaultChecked: _propTypes2.default.bool,

    /**
     * A boolean if the `Switch` is currently checked. This will required the `onChange` prop
     * to be defined.
     */
    checked: (0, _controlled2.default)(_propTypes2.default.bool, 'onChange', 'defaultChecked'),

    defaultToggled: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use the `defaultChecked` prop instead'),
    toggled: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use the `checked` prop instead')
  };
  exports.default = Switch;
});

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.isInvalidAnimate = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = isInvalidAnimate;
  var gcc = 'getComposedComponent';

  /**
   * Just checks if the fab is actually a ref to the FAB Button.
   */
  function isInvalidAnimate(fab) {
    return typeof fab[gcc] !== 'function' || typeof fab[gcc]()[gcc] !== 'function' || typeof fab[gcc]()[gcc]()._animateForSnackbar !== 'function';
  }
});

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames);
    global.Subheader = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Subheader = function (_PureComponent) {
    _inherits(Subheader, _PureComponent);

    function Subheader() {
      _classCallCheck(this, Subheader);

      return _possibleConstructorReturn(this, (Subheader.__proto__ || Object.getPrototypeOf(Subheader)).apply(this, arguments));
    }

    _createClass(Subheader, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            Component = _props.component,
            inset = _props.inset,
            primary = _props.primary,
            primaryText = _props.primaryText,
            className = _props.className,
            children = _props.children,
            props = _objectWithoutProperties(_props, ['component', 'inset', 'primary', 'primaryText', 'className', 'children']);

        return _react2.default.createElement(
          Component,
          _extends({}, props, {
            className: (0, _classnames2.default)('md-subheader', {
              'md-text--secondary': !primary,
              'md-text--theme-primary': primary,
              'md-list-item--inset': inset
            }, className)
          }),
          primaryText,
          children
        );
      }
    }]);

    return Subheader;
  }(_react.PureComponent);

  Subheader.propTypes = {
    /**
     * An optional style to apply to the subheader.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply to the subheader.
     */
    className: _propTypes2.default.string,

    /**
     * Boolean if the subheader should be styled with the primary color.
     */
    primary: _propTypes2.default.bool,

    /**
     * Boolean if the subheader is inset in the list. This will add additional
     * spacing to align the subheader.
     */
    inset: _propTypes2.default.bool,

    /**
     * The primary text to use in the subheader.
     */
    primaryText: _propTypes2.default.node.isRequired,

    /**
     * Any optional children to display after the `primaryText`. This prop is
     * unrecommended.
     */
    children: _propTypes2.default.node,

    /**
     * The component to render the Subheader as.
     */
    component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired
  };
  Subheader.defaultProps = {
    component: 'li'
  };
  exports.default = Subheader;
});

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(17), __webpack_require__(116), __webpack_require__(37), __webpack_require__(595)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('react-prop-types/lib/isRequiredForA11y'), require('../Menus/Menu'), require('../Helpers/AccessibleFakeInkedButton'), require('../utils/mapToListParts'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.isRequiredForA11y, global.Menu, global.AccessibleFakeInkedButton, global.mapToListParts);
    global.MenuTab = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _isRequiredForA11y, _Menu, _AccessibleFakeInkedButton, _mapToListParts) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);

  var _Menu2 = _interopRequireDefault(_Menu);

  var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);

  var _mapToListParts2 = _interopRequireDefault(_mapToListParts);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var MenuTab = function (_PureComponent) {
    _inherits(MenuTab, _PureComponent);

    function MenuTab(props) {
      _classCallCheck(this, MenuTab);

      var _this = _possibleConstructorReturn(this, (MenuTab.__proto__ || Object.getPrototypeOf(MenuTab)).call(this, props));

      _this.state = { isOpen: false };
      _this._toggleOpen = _this._toggleOpen.bind(_this);
      _this._handleClose = _this._handleClose.bind(_this);
      return _this;
    }

    _createClass(MenuTab, [{
      key: '_toggleOpen',
      value: function _toggleOpen(e) {
        if (this.props.onClick) {
          this.props.onClick(e);
        }

        this.setState({ isOpen: !this.state.isOpen });
      }
    }, {
      key: '_handleClose',
      value: function _handleClose() {
        this.setState({ isOpen: false });
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            id = _props.id,
            style = _props.style,
            className = _props.className,
            tabStyle = _props.tabStyle,
            tabClassName = _props.tabClassName,
            tabs = _props.tabs,
            label = _props.label,
            activeTabIndex = _props.activeTabIndex,
            overflowAtIndex = _props.overflowAtIndex,
            props = _objectWithoutProperties(_props, ['id', 'style', 'className', 'tabStyle', 'tabClassName', 'tabs', 'label', 'activeTabIndex', 'overflowAtIndex']);

        var active = activeTabIndex >= overflowAtIndex;

        var tab = _react2.default.createElement(
          _AccessibleFakeInkedButton2.default,
          _extends({}, props, {
            onClick: this._toggleOpen,
            style: tabStyle,
            className: (0, _classnames2.default)('md-tab md-tab--menu', tabClassName)
          }),
          label
        );

        return _react2.default.createElement(
          _Menu2.default,
          {
            id: id,
            style: style,
            className: (0, _classnames2.default)('md-menu--tab', {
              'md-tab--active': active,
              'md-tab--inactive': !active
            }, className),
            toggle: tab,
            isOpen: this.state.isOpen,
            onClose: this._handleClose
          },
          tabs.map(_mapToListParts2.default)
        );
      }
    }]);

    return MenuTab;
  }(_react.PureComponent);

  MenuTab.propTypes = {
    /**
     * An id to give the tab's menu.
     */
    id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),

    /**
     * The current active tab index. This is used to determine which list item
     * is active in the menu, and if the styles for an active tab should be applied
     * to the menu.
     */
    activeTabIndex: _propTypes2.default.number.isRequired,

    /**
     * An tab index that caused the overflow to happen.
     */
    overflowAtIndex: _propTypes2.default.number.isRequired,

    /**
     * A list of tabs that should be rendered in the menu once opened. This can either
     * be:
     *
     * - a `ListItem`, `Divider`, or `Subheader` component
     * - a string to use as the `primaryText` for a list item
     * - an object that defines props to generate a `ListItem`, `Divider`, or `Subheader` component
     */
    tabs: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.shape({
      divider: _propTypes2.default.bool,
      subheader: _propTypes2.default.bool,
      primaryText: _propTypes2.default.node
    })])).isRequired,

    /**
     * An optional style to apply to the menu.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply to the menu.
     */
    className: _propTypes2.default.string,

    /**
     * An optional style to apply to the tab in the menu.
     */
    tabStyle: _propTypes2.default.object,

    /**
     * An optional className to apply to the tab in the menu.
     */
    tabClassName: _propTypes2.default.string,

    /**
     * An optional function to call when the tab is clicked.
     */
    onClick: _propTypes2.default.func,

    /**
     * The label to display in the tab. This should normally be some text with
     * a drop down arrow next to it.
     */
    label: _propTypes2.default.node.isRequired
  };
  exports.default = MenuTab;
});

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(17)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('react-prop-types/lib/isRequiredForA11y'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.isRequiredForA11y);
    global.TabPanel = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _isRequiredForA11y) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var TabPanel = function (_PureComponent) {
    _inherits(TabPanel, _PureComponent);

    function TabPanel() {
      _classCallCheck(this, TabPanel);

      return _possibleConstructorReturn(this, (TabPanel.__proto__ || Object.getPrototypeOf(TabPanel)).apply(this, arguments));
    }

    _createClass(TabPanel, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            Component = _props.component,
            id = _props.id,
            active = _props.active,
            className = _props.className,
            controlledById = _props.controlledById,
            children = _props.children,
            props = _objectWithoutProperties(_props, ['component', 'id', 'active', 'className', 'controlledById', 'children']);

        return _react2.default.createElement(
          Component,
          _extends({}, props, {
            id: id,
            className: (0, _classnames2.default)('md-tab-panel', className),
            role: 'tabpanel',
            'aria-hidden': !active,
            'aria-labelledby': controlledById
          }),
          children
        );
      }
    }]);

    return TabPanel;
  }(_react.PureComponent);

  TabPanel.propTypes = {
    /**
     * An id for the panel. This is used for a11y. This should equal the `controlsId`
     * of whichever tab's children will be placed in here.
     */
    id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),

    /**
     * An id for the tab that owns this panel. This should equal the `id` of whichever
     * tab's children will be placed in here.
     */
    controlledById: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),

    /**
     * An optional style to apply.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply.
     */
    className: _propTypes2.default.string,

    /**
     * The component to render the panel as.
     */
    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,

    /**
     * Boolean if the panel is currently active. This is used to generated the `aria-hidden`
     * attribute.
     */
    active: _propTypes2.default.bool,

    /**
     * Any children to display.
     */
    children: _propTypes2.default.node
  };
  TabPanel.defaultProps = {
    component: 'div'
  };
  exports.default = TabPanel;
});

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames);
    global.FloatingLabel = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var FloatingLabel = function (_PureComponent) {
    _inherits(FloatingLabel, _PureComponent);

    function FloatingLabel() {
      _classCallCheck(this, FloatingLabel);

      return _possibleConstructorReturn(this, (FloatingLabel.__proto__ || Object.getPrototypeOf(FloatingLabel)).apply(this, arguments));
    }

    _createClass(FloatingLabel, [{
      key: 'render',
      value: function render() {
        var _cn;

        var _props = this.props,
            label = _props.label,
            htmlFor = _props.htmlFor,
            className = _props.className,
            floating = _props.floating,
            active = _props.active,
            error = _props.error,
            disabled = _props.disabled,
            iconOffset = _props.iconOffset,
            customSize = _props.customSize,
            props = _objectWithoutProperties(_props, ['label', 'htmlFor', 'className', 'floating', 'active', 'error', 'disabled', 'iconOffset', 'customSize']);

        if (!label) {
          return null;
        }

        return _react2.default.createElement(
          'label',
          _extends({}, props, {
            htmlFor: htmlFor,
            className: (0, _classnames2.default)('md-floating-label', (_cn = {
              'md-floating-label--active': !error && active,
              'md-floating-label--error': !disabled && error,
              'md-floating-label--inactive': !floating,
              'md-floating-label--inactive-sized': !floating && !customSize
            }, _defineProperty(_cn, 'md-floating-label--' + customSize, customSize), _defineProperty(_cn, 'md-floating-label--inactive-' + customSize, customSize && !floating), _defineProperty(_cn, 'md-floating-label--floating', floating), _defineProperty(_cn, 'md-floating-label--disabled', disabled), _defineProperty(_cn, 'md-floating-label--icon-offset', iconOffset), _cn), className)
          }),
          label
        );
      }
    }]);

    return FloatingLabel;
  }(_react.PureComponent);

  FloatingLabel.propTypes = {
    style: _propTypes2.default.object,
    className: _propTypes2.default.string,
    label: _propTypes2.default.node,
    floating: _propTypes2.default.bool,
    error: _propTypes2.default.bool,
    active: _propTypes2.default.bool,
    disabled: _propTypes2.default.bool,
    iconOffset: _propTypes2.default.bool,
    customSize: _propTypes2.default.string,
    htmlFor: _propTypes2.default.string
  };
  exports.default = FloatingLabel;
});

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(250)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('../Dividers/Divider'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.Divider);
    global.TextFieldDivider = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _Divider) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _Divider2 = _interopRequireDefault(_Divider);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var TextFieldDivider = function (_PureComponent) {
    _inherits(TextFieldDivider, _PureComponent);

    function TextFieldDivider() {
      _classCallCheck(this, TextFieldDivider);

      return _possibleConstructorReturn(this, (TextFieldDivider.__proto__ || Object.getPrototypeOf(TextFieldDivider)).apply(this, arguments));
    }

    _createClass(TextFieldDivider, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            active = _props.active,
            error = _props.error,
            lineDirection = _props.lineDirection,
            className = _props.className,
            props = _objectWithoutProperties(_props, ['active', 'error', 'lineDirection', 'className']);

        return _react2.default.createElement(_Divider2.default, _extends({}, props, {
          className: (0, _classnames2.default)('md-divider--text-field md-divider--expand-from-' + lineDirection, {
            'md-divider--text-field-expanded': active,
            'md-divider--text-field-active': !error && active,
            'md-divider--text-field-error': error
          }, className)
        }));
      }
    }]);

    return TextFieldDivider;
  }(_react.PureComponent);

  TextFieldDivider.propTypes = {
    style: _propTypes2.default.object,
    className: _propTypes2.default.string,
    active: _propTypes2.default.bool,
    error: _propTypes2.default.bool,
    lineDirection: _propTypes2.default.oneOf(['left', 'center', 'right'])
  };
  exports.default = TextFieldDivider;
});

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(1179)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('./Message'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.Message);
    global.TextFieldMessage = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _Message) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _Message2 = _interopRequireDefault(_Message);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var TextFieldMessage = function (_PureComponent) {
    _inherits(TextFieldMessage, _PureComponent);

    function TextFieldMessage(props) {
      _classCallCheck(this, TextFieldMessage);

      var _this = _possibleConstructorReturn(this, (TextFieldMessage.__proto__ || Object.getPrototypeOf(TextFieldMessage)).call(this, props));

      _this.state = {
        message: props.error && props.errorText || props.helpText || props.errorText,
        isMessageVisible: _this._isMessageVisible(props)
      };
      return _this;
    }

    _createClass(TextFieldMessage, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var keys = ['active', 'error', 'helpOnFocus', 'helpText', 'errorText'];
        if (this._anyChanges(keys, this.props, nextProps)) {
          this.setState({
            isMessageVisible: this._isMessageVisible(nextProps),
            message: nextProps.error && nextProps.errorText || nextProps.helpText || nextProps.errorText
          });
        }
      }
    }, {
      key: '_anyChanges',
      value: function _anyChanges(keys, p1, p2) {
        var changed = false;
        keys.some(function (key) {
          if (p1[key] !== p2[key]) {
            changed = true;
          }

          return changed;
        });

        return changed;
      }
    }, {
      key: '_isMessageVisible',
      value: function _isMessageVisible(props) {
        var error = props.error,
            errorText = props.errorText,
            helpText = props.helpText,
            helpOnFocus = props.helpOnFocus,
            active = props.active;

        return (error && errorText || !!helpText) && (!helpOnFocus || active);
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            maxLength = _props.maxLength,
            error = _props.error,
            className = _props.className,
            errorText = _props.errorText,
            helpText = _props.helpText,
            currentLength = _props.currentLength,
            leftIcon = _props.leftIcon,
            rightIcon = _props.rightIcon,
            block = _props.block,
            active = _props.active;
        var _state = this.state,
            isMessageVisible = _state.isMessageVisible,
            message = _state.message;


        if (currentLength === 'undefined' || !helpText && !errorText && !maxLength) {
          return null;
        }

        return _react2.default.createElement(
          'div',
          {
            className: (0, _classnames2.default)('md-text-field-message-container', {
              'md-text-field-message-container--error': error,
              'md-text-field-message-container--count-only': !message || !isMessageVisible,
              'md-text-field-message-container--left-icon-offset': leftIcon,
              'md-text-field-message-container--right-icon-offset': rightIcon,
              'md-full-width': !block
            }, className)
          },
          _react2.default.createElement(
            _Message2.default,
            { key: 'message', active: isMessageVisible },
            message
          ),
          _react2.default.createElement(
            _Message2.default,
            { key: 'counter', className: 'md-text-field-message--counter', active: active },
            maxLength ? currentLength + ' / ' + maxLength : null
          )
        );
      }
    }]);

    return TextFieldMessage;
  }(_react.PureComponent);

  TextFieldMessage.propTypes = {
    className: _propTypes2.default.string,
    error: _propTypes2.default.bool,
    helpText: _propTypes2.default.node,
    errorText: _propTypes2.default.node,
    active: _propTypes2.default.bool,
    helpOnFocus: _propTypes2.default.bool,
    maxLength: _propTypes2.default.number,
    currentLength: _propTypes2.default.number,
    leftIcon: _propTypes2.default.bool,
    rightIcon: _propTypes2.default.bool,
    block: _propTypes2.default.bool
  };
  exports.default = TextFieldMessage;
});

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(12), __webpack_require__(65), __webpack_require__(120), __webpack_require__(46), __webpack_require__(1182)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('react-prop-types/lib/deprecated'), require('../utils/PropTypes/invalidIf'), require('../utils/PropTypes/between'), require('../Papers/Paper'), require('./ToolbarTitle'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.deprecated, global.invalidIf, global.between, global.Paper, global.ToolbarTitle);
    global.Toolbar = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _deprecated, _invalidIf, _between, _Paper, _ToolbarTitle) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _deprecated2 = _interopRequireDefault(_deprecated);

  var _invalidIf2 = _interopRequireDefault(_invalidIf);

  var _between2 = _interopRequireDefault(_between);

  var _Paper2 = _interopRequireDefault(_Paper);

  var _ToolbarTitle2 = _interopRequireDefault(_ToolbarTitle);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Toolbar = function (_PureComponent) {
    _inherits(Toolbar, _PureComponent);

    function Toolbar() {
      _classCallCheck(this, Toolbar);

      return _possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).apply(this, arguments));
    }

    _createClass(Toolbar, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            style = _props.style,
            className = _props.className,
            component = _props.component,
            titleStyle = _props.titleStyle,
            titleClassName = _props.titleClassName,
            prominentTitle = _props.prominentTitle,
            primary = _props.primary,
            secondary = _props.secondary,
            themed = _props.themed,
            singleColor = _props.singleColor,
            actions = _props.actions,
            fixed = _props.fixed,
            actionLeft = _props.actionLeft,
            actionsRight = _props.actionsRight,
            children = _props.children,
            inset = _props.inset,
            props = _objectWithoutProperties(_props, ['style', 'className', 'component', 'titleStyle', 'titleClassName', 'prominentTitle', 'primary', 'secondary', 'themed', 'singleColor', 'actions', 'fixed', 'actionLeft', 'actionsRight', 'children', 'inset']);

        delete props.nav;
        delete props.title;
        delete props.titleMenu;
        delete props.zDepth;
        delete props.colored;
        delete props.prominent;

        // delete deprecated;
        delete props.containerStyle;
        delete props.containerClassName;
        delete props.actionLeft;
        delete props.actionsRight;

        var _props2 = this.props,
            colored = _props2.colored,
            title = _props2.title,
            titleMenu = _props2.titleMenu,
            nav = _props2.nav,
            prominent = _props2.prominent,
            zDepth = _props2.zDepth;


        colored = colored || primary || secondary;
        prominent = prominent || prominentTitle;

        title = _react2.default.createElement(_ToolbarTitle2.default, {
          key: 'title',
          style: titleStyle,
          className: titleClassName,
          prominent: prominentTitle,
          offset: prominentTitle,
          title: title
        });

        if (nav || actionLeft) {
          var navEl = _react.Children.only(nav || actionLeft);
          nav = (0, _react.cloneElement)(nav, {
            className: (0, _classnames2.default)('md-btn--toolbar md-toolbar--action-left', navEl.props.className)
          });
        }

        var rightActions = void 0;
        if (actions || actionsRight) {
          rightActions = _react.Children.map(_react.Children.toArray(actions || actionsRight), function (action) {
            return (0, _react.cloneElement)(action, {
              className: (0, _classnames2.default)('md-btn--toolbar', action.props.className)
            });
          });

          rightActions = _react2.default.createElement(
            'div',
            { key: 'actions', className: 'md-cell--right md-toolbar--action-right' },
            rightActions
          );
        }

        if (titleMenu) {
          titleMenu = _react.Children.only(titleMenu);
          titleMenu = (0, _react.cloneElement)(titleMenu, {
            className: (0, _classnames2.default)('md-title md-title--toolbar md-select-field--toolbar', {
              'md-title--toolbar-offset': prominentTitle,
              'md-title--toolbar-prominent': prominentTitle
            }, titleMenu.props.className),
            position: titleMenu.props.position || 'tl',
            toolbar: true
          });
        }

        if (typeof zDepth !== 'number') {
          zDepth = fixed ? 2 : 0;
        }

        return _react2.default.createElement(
          _Paper2.default,
          _extends({}, props, {
            component: component,
            zDepth: zDepth,
            style: style,
            className: (0, _classnames2.default)('md-toolbar', {
              'md-background--primary': colored,
              'md-toolbar--themed': themed,
              'md-toolbar--text-white': singleColor && colored,
              'md-toolbar--discrete': !prominent,
              'md-toolbar--prominent': prominent,
              'md-toolbar--fixed': fixed,
              'md-toolbar--inset': inset
            }, className)
          }),
          nav,
          title,
          titleMenu,
          children,
          rightActions
        );
      }
    }]);

    return Toolbar;
  }(_react.PureComponent);

  Toolbar.propTypes = {
    /**
     * An optional style to apply to the toolbar.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply to the toolbar,
     */
    className: _propTypes2.default.string,

    /*
     * An optional style to apply to the `h2` surroudning the `title` prop.
     */
    titleStyle: _propTypes2.default.object,

    /*
     * An optional className to apply to the `h2` surroudning the `title` prop.
     */
    titleClassName: _propTypes2.default.string,

    /**
     * Boolean if the toolbar should more prominent. This will double the height of the toolbar.
     */
    prominent: _propTypes2.default.bool,

    /**
     * Boolean if the toolbar's title should be more prominent. This will move the title to the
     * second line of the toolbar. This only works when the `prominent` prop is true as well.
     */
    prominentTitle: _propTypes2.default.bool,

    /**
     * The current title of the page to show in the toolbar. It is invalid to specify both a
     * `title` and a `titleMenu`. Only one should be given.
     */
    title: (0, _invalidIf2.default)(_propTypes2.default.node, 'titleMenu'),

    /**
     * An optional title menu to display instead of the title. This should be a `SelectField` component.
     * It is cloned with some additional props, so if the `SelectField` is separated into a separate
     * component, the following props must be passed to get the correct styling: `className`, `block`,
     * `paddedBlock`, `position`.
     */
    titleMenu: _propTypes2.default.element,

    /**
     * This prop is used for rendering an optional navigation button to the left of the `title`
     * or the `titleMenu` component. This needs to be an icon `Button` because some additional props
     * are cloned into it.
     */
    nav: _propTypes2.default.element,

    /**
     * Any additional actions to display to the right of the title. This should be a list or a single
     * `Button` to display. The buttons get cloned with an additional className for toolbar styling.
     */
    actions: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)]),

    /**
     * Any children to display in the toolbar. This will be displayed between the optional title and
     * actions.
     */
    children: _propTypes2.default.node,

    /**
     * Boolean if the toolbar should be fixed to the top of the page. This will add some additional box shadow.
     */
    fixed: _propTypes2.default.bool,

    /**
     * Boolean if the nav, actions, and title should share the same color. For a `colored` or dark `themed`
     * toolbar, they will all be colored white. For a transparent or light `themed` toolbar, the colors will
     * be the `rgba(0, 0, 0, .87)`. Setting this to false will only style the title to the specific color
     * stated above.
     */
    singleColor: _propTypes2.default.bool,

    /**
     * Boolean if the toolbar should be colored based off the current theme. This will either style the background
     * to be fairly white, or fairly black. You can not specify both `themed` and `colored`.
     */
    themed: _propTypes2.default.bool,

    /**
     * Boolean if the toolbar should be colored with the `$md-primary-color`.
     */
    colored: (0, _invalidIf2.default)(_propTypes2.default.bool, 'themed'),

    /**
     * The component to render the toolbar as.
     */
    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,

    /**
     * Boolean if the toolbar is inset in the page. This will just add some margin around
     * it.
     */
    inset: _propTypes2.default.bool,

    /**
     * An optional zDepth to enforce for the toolbar. This should be a number between 0 and 5.
     * If this is omitted, the toolbar will gain a zDepth of 2 when `fixed`.
     */
    zDepth: (0, _between2.default)(_propTypes2.default.number, 0, 5),
    containerStyle: (0, _deprecated2.default)(_propTypes2.default.object, 'The `container` no longer exists in the `Toolbar`. Use the `style` prop instead'),
    containerClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'The `container` no longer exists in the `Toolbar`. Use the `className` prop instead'),
    primary: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use the `colored` prop instead'),
    secondary: (0, _deprecated2.default)(_propTypes2.default.bool, 'Toolbars can no longer be themed to the secondary color. Use the `colored` prop instead'),
    actionLeft: (0, _deprecated2.default)(_propTypes2.default.element, 'Use the `nav` prop instead'),
    actionsRight: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `menu` prop and/or the `actions` prop instead')
  };
  Toolbar.defaultProps = {
    singleColor: true,
    component: 'header'
  };
  exports.default = Toolbar;
});

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(579)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./Toolbar'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.Toolbar);
    global.index = mod.exports;
  }
})(this, function (exports, _Toolbar) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _Toolbar2 = _interopRequireDefault(_Toolbar);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _Toolbar2.default;
});

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.media = mod.exports;
  }
})(this, function (exports) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var MOBILE_MIN_WIDTH = exports.MOBILE_MIN_WIDTH = 320;
  var TABLET_MIN_WIDTH = exports.TABLET_MIN_WIDTH = 768;
  var DESKTOP_MIN_WIDTH = exports.DESKTOP_MIN_WIDTH = 1025;
});

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(550), __webpack_require__(1095), __webpack_require__(1098), __webpack_require__(242), __webpack_require__(1105), __webpack_require__(1107), __webpack_require__(1113), __webpack_require__(249), __webpack_require__(1117), __webpack_require__(1119), __webpack_require__(1123), __webpack_require__(1125), __webpack_require__(1127), __webpack_require__(36), __webpack_require__(1128), __webpack_require__(1131), __webpack_require__(563), __webpack_require__(1132), __webpack_require__(1133), __webpack_require__(1136), __webpack_require__(256), __webpack_require__(1153), __webpack_require__(1155), __webpack_require__(1161), __webpack_require__(259), __webpack_require__(1171), __webpack_require__(1163), __webpack_require__(1174), __webpack_require__(262), __webpack_require__(1177), __webpack_require__(47), __webpack_require__(580), __webpack_require__(1185)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./Autocompletes'), require('./Avatars'), require('./BottomNavigations'), require('./Buttons'), require('./Cards'), require('./Chips'), require('./DataTables'), require('./Dialogs'), require('./Dividers'), require('./Drawers'), require('./ExpansionPanels'), require('./FABTransitions'), require('./FileInputs'), require('./FontIcons'), require('./Helpers'), require('./Inks'), require('./Lists'), require('./Media'), require('./Menus'), require('./NavigationDrawers'), require('./Papers'), require('./Pickers'), require('./Progress'), require('./SelectionControls'), require('./SelectFields'), require('./Sliders'), require('./Sidebars'), require('./Snackbars'), require('./Subheaders'), require('./Tabs'), require('./TextFields'), require('./Toolbars'), require('./Tooltips'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.Autocompletes, global.Avatars, global.BottomNavigations, global.Buttons, global.Cards, global.Chips, global.DataTables, global.Dialogs, global.Dividers, global.Drawers, global.ExpansionPanels, global.FABTransitions, global.FileInputs, global.FontIcons, global.Helpers, global.Inks, global.Lists, global.Media, global.Menus, global.NavigationDrawers, global.Papers, global.Pickers, global.Progress, global.SelectionControls, global.SelectFields, global.Sliders, global.Sidebars, global.Snackbars, global.Subheaders, global.Tabs, global.TextFields, global.Toolbars, global.Tooltips);
    global.index = mod.exports;
  }
})(this, function (exports, _Autocompletes, _Avatars, _BottomNavigations, _Buttons, _Cards, _Chips, _DataTables, _Dialogs, _Dividers, _Drawers, _ExpansionPanels, _FABTransitions, _FileInputs, _FontIcons, _Helpers, _Inks, _Lists, _Media, _Menus, _NavigationDrawers, _Papers, _Pickers, _Progress, _SelectionControls, _SelectFields, _Sliders, _Sidebars, _Snackbars, _Subheaders, _Tabs, _TextFields, _Toolbars, _Tooltips) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.injectTooltip = exports.Toolbar = exports.TextField = exports.TabPanel = exports.MenuTab = exports.Tab = exports.Tabs = exports.TabsContainer = exports.Snackbar = exports.Sidebar = exports.Slider = exports.Subheader = exports.Switch = exports.Radio = exports.RadioGroup = exports.Checkbox = exports.SelectionControlGroup = exports.SelectionControl = exports.SelectField = exports.LinearProgress = exports.CircularProgress = exports.TimePicker = exports.DatePicker = exports.Paper = exports.JumpToContentLink = exports.CloseButton = exports.NavigationDrawer = exports.Menu = exports.MediaOverlay = exports.Media = exports.ListItemControl = exports.ListItem = exports.List = exports.injectInk = exports.Portal = exports.FocusContainer = exports.IconSeparator = exports.Collapse = exports.AccessibleFakeInkedButton = exports.AccessibleFakeButton = exports.FontIcon = exports.FileUpload = exports.FileInput = exports.SpeedDial = exports.ExpansionPanel = exports.ExpansionList = exports.Drawer = exports.Divider = exports.Dialog = exports.SelectFieldColumn = exports.TablePagination = exports.EditDialogColumn = exports.TableCardHeader = exports.TableColumn = exports.TableRow = exports.TableBody = exports.TableHeader = exports.DataTable = exports.Chip = exports.CardActionOverlay = exports.CardText = exports.CardActions = exports.CardMedia = exports.CardTitle = exports.Card = exports.IconButton = exports.FloatingButton = exports.RaisedButton = exports.FlatButton = exports.Button = exports.BottomNavigation = exports.Avatar = exports.Autocomplete = undefined;

  var _Autocompletes2 = _interopRequireDefault(_Autocompletes);

  var _Avatars2 = _interopRequireDefault(_Avatars);

  var _BottomNavigations2 = _interopRequireDefault(_BottomNavigations);

  var _Buttons2 = _interopRequireDefault(_Buttons);

  var _Cards2 = _interopRequireDefault(_Cards);

  var _Chips2 = _interopRequireDefault(_Chips);

  var _DataTables2 = _interopRequireDefault(_DataTables);

  var _Dialogs2 = _interopRequireDefault(_Dialogs);

  var _Dividers2 = _interopRequireDefault(_Dividers);

  var _Drawers2 = _interopRequireDefault(_Drawers);

  var _FileInputs2 = _interopRequireDefault(_FileInputs);

  var _FontIcons2 = _interopRequireDefault(_FontIcons);

  var _Inks2 = _interopRequireDefault(_Inks);

  var _Media2 = _interopRequireDefault(_Media);

  var _Menus2 = _interopRequireDefault(_Menus);

  var _NavigationDrawers2 = _interopRequireDefault(_NavigationDrawers);

  var _Papers2 = _interopRequireDefault(_Papers);

  var _SelectFields2 = _interopRequireDefault(_SelectFields);

  var _Sliders2 = _interopRequireDefault(_Sliders);

  var _Sidebars2 = _interopRequireDefault(_Sidebars);

  var _Snackbars2 = _interopRequireDefault(_Snackbars);

  var _Subheaders2 = _interopRequireDefault(_Subheaders);

  var _TextFields2 = _interopRequireDefault(_TextFields);

  var _Toolbars2 = _interopRequireDefault(_Toolbars);

  var _Tooltips2 = _interopRequireDefault(_Tooltips);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.Autocomplete = _Autocompletes2.default;
  exports.Avatar = _Avatars2.default;
  exports.BottomNavigation = _BottomNavigations2.default;
  exports.Button = _Buttons2.default;
  exports.FlatButton = _Buttons.FlatButton;
  exports.RaisedButton = _Buttons.RaisedButton;
  exports.FloatingButton = _Buttons.FloatingButton;
  exports.IconButton = _Buttons.IconButton;
  exports.Card = _Cards2.default;
  exports.CardTitle = _Cards.CardTitle;
  exports.CardMedia = _Cards.CardMedia;
  exports.CardActions = _Cards.CardActions;
  exports.CardText = _Cards.CardText;
  exports.CardActionOverlay = _Cards.CardActionOverlay;
  exports.Chip = _Chips2.default;
  exports.DataTable = _DataTables2.default;
  exports.TableHeader = _DataTables.TableHeader;
  exports.TableBody = _DataTables.TableBody;
  exports.TableRow = _DataTables.TableRow;
  exports.TableColumn = _DataTables.TableColumn;
  exports.TableCardHeader = _DataTables.TableCardHeader;
  exports.EditDialogColumn = _DataTables.EditDialogColumn;
  exports.TablePagination = _DataTables.TablePagination;
  exports.SelectFieldColumn = _DataTables.SelectFieldColumn;
  exports.Dialog = _Dialogs2.default;
  exports.Divider = _Dividers2.default;
  exports.Drawer = _Drawers2.default;
  exports.ExpansionList = _ExpansionPanels.ExpansionList;
  exports.ExpansionPanel = _ExpansionPanels.ExpansionPanel;
  exports.SpeedDial = _FABTransitions.SpeedDial;
  exports.FileInput = _FileInputs2.default;
  exports.FileUpload = _FileInputs.FileUpload;
  exports.FontIcon = _FontIcons2.default;
  exports.AccessibleFakeButton = _Helpers.AccessibleFakeButton;
  exports.AccessibleFakeInkedButton = _Helpers.AccessibleFakeInkedButton;
  exports.Collapse = _Helpers.Collapse;
  exports.IconSeparator = _Helpers.IconSeparator;
  exports.FocusContainer = _Helpers.FocusContainer;
  exports.Portal = _Helpers.Portal;
  exports.injectInk = _Inks2.default;
  exports.List = _Lists.List;
  exports.ListItem = _Lists.ListItem;
  exports.ListItemControl = _Lists.ListItemControl;
  exports.Media = _Media2.default;
  exports.MediaOverlay = _Media.MediaOverlay;
  exports.Menu = _Menus2.default;
  exports.NavigationDrawer = _NavigationDrawers2.default;
  exports.CloseButton = _NavigationDrawers.CloseButton;
  exports.JumpToContentLink = _NavigationDrawers.JumpToContentLink;
  exports.Paper = _Papers2.default;
  exports.DatePicker = _Pickers.DatePicker;
  exports.TimePicker = _Pickers.TimePicker;
  exports.CircularProgress = _Progress.CircularProgress;
  exports.LinearProgress = _Progress.LinearProgress;
  exports.SelectField = _SelectFields2.default;
  exports.SelectionControl = _SelectionControls.SelectionControl;
  exports.SelectionControlGroup = _SelectionControls.SelectionControlGroup;
  exports.Checkbox = _SelectionControls.Checkbox;
  exports.RadioGroup = _SelectionControls.RadioGroup;
  exports.Radio = _SelectionControls.Radio;
  exports.Switch = _SelectionControls.Switch;
  exports.Subheader = _Subheaders2.default;
  exports.Slider = _Sliders2.default;
  exports.Sidebar = _Sidebars2.default;
  exports.Snackbar = _Snackbars2.default;
  exports.TabsContainer = _Tabs.TabsContainer;
  exports.Tabs = _Tabs.Tabs;
  exports.Tab = _Tabs.Tab;
  exports.MenuTab = _Tabs.MenuTab;
  exports.TabPanel = _Tabs.TabPanel;
  exports.TextField = _TextFields2.default;
  exports.Toolbar = _Toolbars2.default;
  exports.injectTooltip = _Tooltips2.default;
  exports.default = {
    Autocomplete: _Autocompletes2.default,
    Avatar: _Avatars2.default,
    BottomNavigation: _BottomNavigations2.default,

    Button: _Buttons2.default,
    FlatButton: _Buttons.FlatButton,
    RaisedButton: _Buttons.RaisedButton,
    FloatingButton: _Buttons.FloatingButton,
    IconButton: _Buttons.IconButton,

    Card: _Cards2.default,
    CardTitle: _Cards.CardTitle,
    CardMedia: _Cards.CardMedia,
    CardActions: _Cards.CardActions,
    CardText: _Cards.CardText,
    CardActionOverlay: _Cards.CardActionOverlay,

    Chip: _Chips2.default,

    DataTable: _DataTables2.default,
    TableHeader: _DataTables.TableHeader,
    TableBody: _DataTables.TableBody,
    TableRow: _DataTables.TableRow,
    TableColumn: _DataTables.TableColumn,
    TableCardHeader: _DataTables.TableCardHeader,
    EditDialogColumn: _DataTables.EditDialogColumn,
    TablePagination: _DataTables.TablePagination,
    SelectFieldColumn: _DataTables.SelectFieldColumn,

    Dialog: _Dialogs2.default,
    Divider: _Dividers2.default,
    Drawer: _Drawers2.default,

    ExpansionList: _ExpansionPanels.ExpansionList,
    ExpansionPanel: _ExpansionPanels.ExpansionPanel,

    SpeedDial: _FABTransitions.SpeedDial,

    FileInput: _FileInputs2.default,
    FileUpload: _FileInputs.FileUpload,

    FontIcon: _FontIcons2.default,
    AccessibleFakeButton: _Helpers.AccessibleFakeButton,
    AccessibleFakeInkedButton: _Helpers.AccessibleFakeInkedButton,
    Collapse: _Helpers.Collapse,
    IconSeparator: _Helpers.IconSeparator,
    FocusContainer: _Helpers.FocusContainer,
    Portal: _Helpers.Portal,

    injectInk: _Inks2.default,

    List: _Lists.List,
    ListItem: _Lists.ListItem,
    ListItemControl: _Lists.ListItemControl,

    Media: _Media2.default,
    MediaOverlay: _Media.MediaOverlay,

    Menu: _Menus2.default,

    NavigationDrawer: _NavigationDrawers2.default,
    CloseButton: _NavigationDrawers.CloseButton,
    JumpToContentLink: _NavigationDrawers.JumpToContentLink,

    Paper: _Papers2.default,

    DatePicker: _Pickers.DatePicker,
    TimePicker: _Pickers.TimePicker,

    CircularProgress: _Progress.CircularProgress,
    LinearProgress: _Progress.LinearProgress,

    SelectField: _SelectFields2.default,

    SelectionControl: _SelectionControls.SelectionControl,
    SelectionControlGroup: _SelectionControls.SelectionControlGroup,
    Checkbox: _SelectionControls.Checkbox,
    RadioGroup: _SelectionControls.RadioGroup,
    Radio: _SelectionControls.Radio,
    Switch: _SelectionControls.Switch,

    Subheader: _Subheaders2.default,

    Slider: _Sliders2.default,
    Sidebar: _Sidebars2.default,
    Snackbar: _Snackbars2.default,

    TabsContainer: _Tabs.TabsContainer,
    Tabs: _Tabs.Tabs,
    Tab: _Tabs.Tab,
    MenuTab: _Tabs.MenuTab,
    TabPanel: _Tabs.TabPanel,

    TextField: _TextFields2.default,
    Toolbar: _Toolbars2.default,
    injectTooltip: _Tooltips2.default
  };
});

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.DateTimeFormat = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var DateTimeFormat = function () {
    if (typeof Intl !== 'undefined' && typeof Intl.DateTimeFormat !== 'undefined') {
      return Intl.DateTimeFormat;
    }

    // Very bad 'mock' of Intl.DateTimeFormat
    return function () {
      return (/* locales, formatOptions */{ format: function format(date) {
            return date.toLocaleString();
          } }
      );
    };
  }();

  exports.default = DateTimeFormat;
});

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.formatTime = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = formatTime;
  /**
   * Formats a date as a time string using the DateTimeFormat function and locales.
   *
   * @param {function} DateTimeFormat the DateTimeFormat function to use.
   * @param {string|string[]} locales the locales to use.
   * @param {Date} time the time to format into a string.
   * @return a string of the formatted time.
   */
  function formatTime(DateTimeFormat, locales, time) {
    return new DateTimeFormat(locales, { hour: 'numeric', minute: '2-digit' }).format(time);
  }
});

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.getDayOfWeek = mod.exports;
  }
})(this, function (exports) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = getDayOfWeek;
  /**
   * Gets a day in the week. 0 = Sunday 6 = Saturday
   *
   * @param {date} sourceDate the date to find a relative day of week from
   * @param {number} dow the day of the week to find
   * @return a new Date as the given day of week
   */
  function getDayOfWeek(sourceDate) {
    var dow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    var date = new Date(sourceDate);
    var day = date.getDay();

    var diff = date.getDate() - day + dow;
    return new Date(date.setDate(diff));
  }
});

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.stripTime = mod.exports;
  }
})(this, function (exports) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = stripTime;
  /**
   * Removes all time from a date. Only keeps year, month, and date.
   * @param {Date} date the date to strip
   * @return a new Date with the time stripped.
   */
  function stripTime(date) {
    if (!date || !(date instanceof Date)) {
      return null;
    }

    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }
});

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(14)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('../../constants/keyCodes'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.keyCodes);
    global.isValidFocusKeypress = mod.exports;
  }
})(this, function (exports, _keyCodes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = isValidFocusKeypress;


  /**
   * Checks if a keydown or keyup event's key was the TAB key or any additional valid
   * keys that were passed in.
   *
   * @param {Object} event - The event to check.
   * @param {Array.<number>=} additionalKeys - An optional array of additional key codes
   *    that are considered valid for a focus event.
   */
  function isValidFocusKeypress(event, additionalKeys) {
    var key = event.which || event.keyCode;
    return key === _keyCodes.TAB || additionalKeys && additionalKeys.indexOf(key) !== -1;
  }
});

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.isBetween = mod.exports;
  }
})(this, function (exports) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = isBetween;
  /**
   * Checks if a number is between a min and maximum (inclusive)
   *
   * @param {Number} num the number to check
   * @param {Number} min the minimum
   * @param {Number} max the maximum
   * @return {Boolean} true if the number is between the min and max (inclusive)
   */
  function isBetween(num, min, max) {
    return num >= min && num <= max;
  }
});

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.oneRequired = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = oneRequired;
  function oneRequired(validator) {
    for (var _len = arguments.length, otherPropNames = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      otherPropNames[_key - 1] = arguments[_key];
    }

    return function validate(props, propName, componentName, location, propFullName) {
      var componentNameSafe = componentName || '<<anonymous>>';
      var propFullNameSafe = propFullName || propName;
      var allPropNames = [propFullNameSafe].concat(otherPropNames);

      for (var _len2 = arguments.length, args = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
        args[_key2 - 5] = arguments[_key2];
      }

      var err = validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
      if (!err && !allPropNames.filter(function (pn) {
        return typeof props[pn] !== 'undefined';
      }).length) {
        err = new Error('One of the following props are required for the ' + componentNameSafe + ' component. ' + ('`' + allPropNames.join('`, `') + '`.'));
      }

      return err;
    };
  }
});

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.addSuffix = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = addSuffix;
  /**
   * Optionally adds a suffix to a string if it does
   * not already contain that string.
   *
   * @param {String} str - The string to modify
   * @param {String} suffix - The suffix to add
   *
   * @return {String} the string with a suffix
   */
  function addSuffix(str, suffix) {
    if (!str || typeof str !== 'string') {
      return str;
    }

    return str.indexOf(suffix) === -1 ? str.trim() + ' ' + suffix : str;
  }
});

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.getDisplayName = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = getDisplayName;

  /**
   * Gets the display name for a composed component.
   *
   * @param {function} ComposedComponent - The composed component to use
   * @return {String} the name of the composed component or 'Component'.
   */
  function getDisplayName(ComposedComponent, suffix) {
    var name = '' + (ComposedComponent.displayName || ComposedComponent.name || 'Component');

    return name.indexOf(suffix) === -1 ? '' + name + suffix : name;
  }
});

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(593)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./getPagePosition'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.getPagePosition);
    global.calcPageOffset = mod.exports;
  }
})(this, function (exports, _getPagePosition) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = calcPageOffset;

  var _getPagePosition2 = _interopRequireDefault(_getPagePosition);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Calculates the page offset of an element. If the element
   * is false-ish, an empty object will be returned.
   *
   * This is really only used for calculating an ink position.
   *
   * @param {Node} el - An html node to find a page offset for.
   * @return {Object} an object with a left and top attribute for the page
   *    offset.
   */
  function calcPageOffset(el) {
    if (!el) {
      return { left: null, right: null };
    }

    var rect = el.getBoundingClientRect();
    return {
      left: rect.left + (0, _getPagePosition2.default)('x'),
      top: rect.top + (0, _getPagePosition2.default)('y')
    };
  }
});

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.getPagePosition = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = getPagePosition;
  /**
   * Gets the current page position.
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/Window/scrollY
   * @param {String} direction - The direction that should be retrieved. This
   *    should be either 'x' or 'y'.
   * @return {number} the position of the direction on the page.
   */
  function getPagePosition(direction) {
    var scroll = 'scroll' + (direction === 'x' ? 'Left' : 'Top');
    if (typeof window.pageXOffset !== 'undefined') {
      return window['page' + direction.toUpperCase() + 'Offset'];
    } else if ((document.compatMode || '') === 'CSS1Compat') {
      return document.documentElement[scroll];
    } else {
      return document.body[scroll];
    }
  }
});

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.isFormPartRole = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = isFormPartRole;
  /**
   * A simple utility function to determine if an element has a role that should
   * be used as a form part. This is mostly used for changing the behavior of keyboard
   * events.
   *
   * A form part role is one of the following:
   * - checkbox
   * - radio
   * - listbox
   * - input
   *
   * @param {HTMLElement} el - the element to check.
   * @return {boolean} true if the element is considered an element part of a form.
   */
  function isFormPartRole(el) {
    if (!el) {
      return false;
    } else if (el.nodeName === 'INPUT') {
      return true;
    }

    var role = el.getAttribute('role');
    return role === 'checkbox' || role === 'radio' || role === 'listbox';
  }
});

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(250), __webpack_require__(573), __webpack_require__(63)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('../Dividers/Divider'), require('../Subheaders/Subheader'), require('../Lists/ListItem'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.Divider, global.Subheader, global.ListItem);
    global.mapToListParts = mod.exports;
  }
})(this, function (exports, _react, _Divider, _Subheader, _ListItem) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = mapToListParts;

  var _Divider2 = _interopRequireDefault(_Divider);

  var _Subheader2 = _interopRequireDefault(_Subheader);

  var _ListItem2 = _interopRequireDefault(_ListItem);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function mapToListParts(item, index) {
    if (typeof item === 'string') {
      return (0, _react.createElement)(_ListItem2.default, { key: item, primaryText: item });
    } else if ((0, _react.isValidElement)(item)) {
      return item;
    }

    var divider = item.divider,
        subheader = item.subheader,
        nestedItems = item.nestedItems,
        remainingProps = _objectWithoutProperties(item, ['divider', 'subheader', 'nestedItems']);

    var component = void 0;
    if (divider) {
      component = _Divider2.default;
    } else if (subheader) {
      component = _Subheader2.default;
    } else {
      component = _ListItem2.default;
    }

    var props = Object.assign({}, remainingProps, { key: item.key || index });
    if (nestedItems) {
      props.nestedItems = nestedItems.map(mapToListParts);
    }

    return (0, _react.createElement)(component, props);
  }
});

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = {
  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
  gentle: { stiffness: 120, damping: 14 },
  wobbly: { stiffness: 180, damping: 12 },
  stiff: { stiffness: 210, damping: 20 }
};
module.exports = exports["default"];

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }

var _Motion = __webpack_require__(1204);

exports.Motion = _interopRequire(_Motion);

var _StaggeredMotion = __webpack_require__(1205);

exports.StaggeredMotion = _interopRequire(_StaggeredMotion);

var _TransitionMotion = __webpack_require__(1206);

exports.TransitionMotion = _interopRequire(_TransitionMotion);

var _spring = __webpack_require__(1209);

exports.spring = _interopRequire(_spring);

var _presets = __webpack_require__(596);

exports.presets = _interopRequire(_presets);

var _stripStyle = __webpack_require__(158);

exports.stripStyle = _interopRequire(_stripStyle);

// deprecated, dummy warning function

var _reorderKeys = __webpack_require__(1208);

exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = {
  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
  gentle: { stiffness: 120, damping: 14 },
  wobbly: { stiffness: 180, damping: 12 },
  stiff: { stiffness: 210, damping: 20 }
};
module.exports = exports["default"];

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(601);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidMount` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          if (this.subscription) this.subscription.tryUnsubscribe();
          this.initSubscription();
          if (shouldHandleStateChanges) this.subscription.trySubscribe();
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(602);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(274);



function verifyPlainObject(value, displayName, methodName) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore right clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        props = _objectWithoutProperties(_props, ['replace', 'to']); // eslint-disable-line no-unused-vars

    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(1227);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BrowserRouter", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(1228);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "HashRouter", function() { return __WEBPACK_IMPORTED_MODULE_1__HashRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(603);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(1229);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MemoryRouter", function() { return __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(1230);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NavLink", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(1231);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Prompt", function() { return __WEBPACK_IMPORTED_MODULE_5__Prompt__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(1232);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(1233);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(1234);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_8__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(1235);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StaticRouter", function() { return __WEBPACK_IMPORTED_MODULE_9__StaticRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(1236);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__matchPath__ = __webpack_require__(1237);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matchPath", function() { return __WEBPACK_IMPORTED_MODULE_11__matchPath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__withRouter__ = __webpack_require__(1238);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_12__withRouter__["a"]; });



























/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */
var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';

function updateLocation(method) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return {
      type: CALL_HISTORY_METHOD,
      payload: { method: method, args: args }
    };
  };
}

/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they get to
 * your reducer and reissue them as the matching function on your history.
 */
var push = exports.push = updateLocation('push');
var replace = exports.replace = updateLocation('replace');
var go = exports.go = updateLocation('go');
var goBack = exports.goBack = updateLocation('goBack');
var goForward = exports.goForward = updateLocation('goForward');

var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.routerReducer = routerReducer;
/**
 * This action type will be dispatched when your history
 * receives a location change.
 */
var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

var initialState = {
  locationBeforeTransitions: null
};

/**
 * This reducer will update the state with the most recent location history
 * has transitioned to. This may not be in sync with the router, particularly
 * if you have asynchronously-loaded routes, so reading from and relying on
 * this state is discouraged.
 */
function routerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  if (type === LOCATION_CHANGE) {
    return _extends({}, state, { locationBeforeTransitions: payload });
  }

  return state;
}

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__matchPath__ = __webpack_require__(276);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, _ref2) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact;
    var route = _ref2.route;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    var pathname = (location || route.location).pathname;

    return path ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact }) : route.match;
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        component = _props.component,
        render = _props.render,
        children = _props.children;


    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(component && render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(component && children), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(render && children), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props2 = this.props,
        children = _props2.children,
        component = _props2.component,
        render = _props2.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    return component ? // component prop gets first priority, only called if there's a match
    match ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
    match ? render(props) : null : children ? // children come last, always called
    typeof children === 'function' ? children(props) : !Array.isArray(children) || children.length ? // Preact defaults to empty children array
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.only(children) : null : null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//  weak

exports.default = {
  RESISTANCE_COEF: 0.6,

  // This value is closed to what browsers are using internally to
  // trigger a native scroll.
  UNCERTAINTY_THRESHOLD: 3 };

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.nameShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  leaveActive: _propTypes2.default.string,
  appear: _propTypes2.default.string,
  appearActive: _propTypes2.default.string
})]);

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__discrete_color_legend_item__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__theme__ = __webpack_require__(22);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.








var propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  }), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired])).isRequired,
  onItemClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  orientation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['vertical', 'horizontal'])
};

var defaultProps = {
  className: '',
  colors: __WEBPACK_IMPORTED_MODULE_3__theme__["b" /* DISCRETE_COLOR_RANGE */],
  orientation: 'vertical'
};

/**
 * Add color information to a list of legend items.
 * @param {Array} items - list of legend items
 * @param {string} [items.title] - label of the legend item
 * @param {string} [items.color] - color of the legend item
 * @param {Array} colors - array of colors.
 * @returns {Array} Array of tick values.
 */

function fillItemsWithDefaults(items, colors) {
  return items.map(function (item, i) {
    return {
      title: item.title ? item.title : item,
      color: item.color ? item.color : colors[i % colors.length],
      disabled: Boolean(item.disabled)
    };
  });
}

function DiscreteColorLegend(_ref) {
  var colors = _ref.colors,
      initialItems = _ref.items,
      width = _ref.width,
      height = _ref.height,
      onItemClick = _ref.onItemClick,
      orientation = _ref.orientation,
      className = _ref.className;

  var updatedItems = fillItemsWithDefaults(initialItems, colors);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      className: 'rv-discrete-color-legend ' + orientation + ' ' + className,
      style: { width: width, height: height } },
    updatedItems.map(function (item, i) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__discrete_color_legend_item__["a" /* default */], _extends({}, item, {
        orientation: orientation,
        key: i,
        onClick: onItemClick ? function () {
          return onItemClick(initialItems[i], i);
        } : null }));
    })
  );
}

DiscreteColorLegend.displayName = 'DiscreteColorLegendItem';
DiscreteColorLegend.propTypes = propTypes;
DiscreteColorLegend.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (DiscreteColorLegend);

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__animation__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_axis_utils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__axis_line__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__axis_ticks__ = __webpack_require__(1263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__axis_title__ = __webpack_require__(1264);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.












var defaultAnimatedProps = ['xRange', 'yRange', 'xDomain', 'yDomain', 'width', 'height', 'marginLeft', 'marginTop', 'marginRight', 'marginBottom', 'tickSize', 'tickTotal', 'tickSizeInner', 'tickSizeOuter'];

var LEFT = __WEBPACK_IMPORTED_MODULE_3__utils_axis_utils__["e" /* ORIENTATION */].LEFT,
    RIGHT = __WEBPACK_IMPORTED_MODULE_3__utils_axis_utils__["e" /* ORIENTATION */].RIGHT,
    TOP = __WEBPACK_IMPORTED_MODULE_3__utils_axis_utils__["e" /* ORIENTATION */].TOP,
    BOTTOM = __WEBPACK_IMPORTED_MODULE_3__utils_axis_utils__["e" /* ORIENTATION */].BOTTOM;


var propTypes = {
  orientation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([LEFT, RIGHT, TOP, BOTTOM]),
  attr: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  left: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  hideTicks: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hideLine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tickLabelAngle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  tickSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  tickSizeInner: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  tickSizeOuter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  tickPadding: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  tickValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  tickFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  tickTotal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  // Not expected to be used by the users.
  // TODO: Add underscore to these properties later.
  marginTop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  marginBottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  marginLeft: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  marginRight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  innerWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  innerHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var defaultProps = {
  className: '',
  style: {},
  tickSize: 6,
  tickPadding: 8,
  orientation: BOTTOM
};

var predefinedClassName = 'rv-xy-plot__axis';
var VERTICAL_CLASS_NAME = 'rv-xy-plot__axis--vertical';
var HORIZONTAL_CLASS_NAME = 'rv-xy-plot__axis--horizontal';

var Axis = function (_PureComponent) {
  _inherits(Axis, _PureComponent);

  function Axis() {
    _classCallCheck(this, Axis);

    return _possibleConstructorReturn(this, (Axis.__proto__ || Object.getPrototypeOf(Axis)).apply(this, arguments));
  }

  _createClass(Axis, [{
    key: '_getDefaultAxisProps',


    /**
     * Define the default values depending on the data passed from the outside.
     * @returns {*} Object of default properties.
     * @private
     */
    value: function _getDefaultAxisProps() {
      var _props = this.props,
          innerWidth = _props.innerWidth,
          innerHeight = _props.innerHeight,
          marginTop = _props.marginTop,
          marginBottom = _props.marginBottom,
          marginLeft = _props.marginLeft,
          marginRight = _props.marginRight,
          orientation = _props.orientation;

      if (orientation === BOTTOM) {
        return {
          tickTotal: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_axis_utils__["c" /* getTicksTotalFromSize */])(innerWidth),
          top: innerHeight + marginTop,
          left: marginLeft,
          width: innerWidth,
          height: marginBottom
        };
      } else if (orientation === TOP) {
        return {
          tickTotal: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_axis_utils__["c" /* getTicksTotalFromSize */])(innerWidth),
          top: 0,
          left: marginLeft,
          width: innerWidth,
          height: marginTop
        };
      } else if (orientation === LEFT) {
        return {
          tickTotal: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_axis_utils__["c" /* getTicksTotalFromSize */])(innerHeight),
          top: marginTop,
          left: 0,
          width: marginLeft,
          height: innerHeight
        };
      }
      return {
        tickTotal: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_axis_utils__["c" /* getTicksTotalFromSize */])(innerHeight),
        top: marginTop,
        left: marginLeft + innerWidth,
        width: marginRight,
        height: innerHeight
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var animation = this.props.animation;


      if (animation) {
        var animatedProps = animation.nonAnimatedProps ? defaultAnimatedProps.filter(function (prop) {
          return animation.nonAnimatedProps.indexOf(prop) < 0;
        }) : defaultAnimatedProps;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__animation__["b" /* default */],
          _extends({}, this.props, { animatedProps: animatedProps }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Axis, _extends({}, this.props, { animation: null }))
        );
      }

      var props = _extends({}, this._getDefaultAxisProps(), this.props);

      var className = props.className,
          height = props.height,
          hideLine = props.hideLine,
          hideTicks = props.hideTicks,
          left = props.left,
          orientation = props.orientation,
          style = props.style,
          title = props.title,
          top = props.top,
          width = props.width;

      var isVertical = [LEFT, RIGHT].indexOf(orientation) > -1;
      var axisClassName = isVertical ? VERTICAL_CLASS_NAME : HORIZONTAL_CLASS_NAME;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        {
          transform: 'translate(' + left + ',' + top + ')',
          className: predefinedClassName + ' ' + axisClassName + ' ' + className,
          style: style },
        !hideLine && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__axis_line__["a" /* default */], {
          height: height,
          width: width,
          orientation: orientation,
          style: _extends({}, style, style.line)
        }),
        !hideTicks && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__axis_ticks__["a" /* default */], _extends({}, props, { style: _extends({}, style, style.ticks) })),
        title ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__axis_title__["a" /* default */], {
          title: title,
          height: height,
          width: width,
          style: _extends({}, style, style.title),
          orientation: orientation }) : null
      );
    }
  }]);

  return Axis;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Axis.displayName = 'Axis';
Axis.propTypes = propTypes;
Axis.defaultProps = defaultProps;
Axis.requiresSVG = true;

/* harmony default export */ __webpack_exports__["a"] = (Axis);

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__series_abstract_series__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__decorative_axis_ticks__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__animation__ = __webpack_require__(13);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.









var predefinedClassName = 'rv-xy-manipulable-axis rv-xy-plot__axis';

var animatedProps = ['xRange', 'yRange', 'xDomain', 'yDomain', 'width', 'height', 'marginLeft', 'marginTop', 'marginRight', 'marginBottom', 'tickSize', 'tickTotal', 'tickSizeInner', 'tickSizeOuter'];

var DecorativeAxis = function (_AbstractSeries) {
  _inherits(DecorativeAxis, _AbstractSeries);

  function DecorativeAxis() {
    _classCallCheck(this, DecorativeAxis);

    return _possibleConstructorReturn(this, (DecorativeAxis.__proto__ || Object.getPrototypeOf(DecorativeAxis)).apply(this, arguments));
  }

  _createClass(DecorativeAxis, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          animation = _props.animation,
          className = _props.className,
          marginLeft = _props.marginLeft,
          marginTop = _props.marginTop,
          axisStart = _props.axisStart,
          axisEnd = _props.axisEnd,
          axisDomain = _props.axisDomain,
          numberOfTicks = _props.numberOfTicks,
          tickValue = _props.tickValue,
          tickSize = _props.tickSize,
          style = _props.style;


      if (animation) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__animation__["b" /* default */],
          _extends({}, this.props, { animatedProps: animatedProps }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DecorativeAxis, _extends({}, this.props, { animation: null }))
        );
      }

      var x = this._getAttributeFunctor('x');
      var y = this._getAttributeFunctor('y');

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        { className: predefinedClassName + ' ' + className,
          ref: 'container',
          transform: 'translate(' + marginLeft + ',' + marginTop + ')' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line', _extends({}, _extends({
          x1: x({ x: axisStart.x }),
          x2: x({ x: axisEnd.x }),
          y1: y({ y: axisStart.y }),
          y2: y({ y: axisEnd.y })
        }, style.line), { className: 'rv-xy-plot__axis__line' })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          { className: 'rv-xy-manipulable-axis__ticks' },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__decorative_axis_ticks__["a" /* default */])({
            axisDomain: axisDomain,
            axisEnd: { x: x(axisEnd), y: y(axisEnd) },
            axisStart: { x: x(axisStart), y: y(axisStart) },
            numberOfTicks: numberOfTicks,
            tickValue: tickValue,
            tickSize: tickSize,
            style: style
          })
        )
      );
    }
  }]);

  return DecorativeAxis;
}(__WEBPACK_IMPORTED_MODULE_3__series_abstract_series__["a" /* default */]);

var DEFAULT_FORMAT = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["f" /* format */])('.2r');

DecorativeAxis.defaultProps = {
  className: '',
  numberOfTicks: 10,
  tickValue: function tickValue(d) {
    return DEFAULT_FORMAT(d);
  },
  tickSize: 5,
  style: {
    line: {
      strokeWidth: 1
    },
    ticks: {
      strokeWidth: 2
    },
    text: {}
  }
};
DecorativeAxis.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_3__series_abstract_series__["a" /* default */].propTypes, {
  axisDomain: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number).isRequired,
  axisEnd: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
    y: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string])
  }).isRequired,
  axisStart: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
    y: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string])
  }).isRequired,
  className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  numberOfTicks: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  tickValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  tickSize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    line: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    ticks: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    text: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  })
});
DecorativeAxis.displayName = 'DecorativeAxis';
/* harmony default export */ __webpack_exports__["a"] = (DecorativeAxis);

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_color__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__theme__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_series_utils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__abstract_series__ = __webpack_require__(8);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.








function getScaleDistance(props, attr) {
  var scaleObject = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["j" /* getScaleObjectFromProps */])(props, attr);
  return scaleObject ? scaleObject.distance : 0;
}

var BarSeriesCanvas = function (_AbstractSeries) {
  _inherits(BarSeriesCanvas, _AbstractSeries);

  function BarSeriesCanvas() {
    _classCallCheck(this, BarSeriesCanvas);

    return _possibleConstructorReturn(this, (BarSeriesCanvas.__proto__ || Object.getPrototypeOf(BarSeriesCanvas)).apply(this, arguments));
  }

  _createClass(BarSeriesCanvas, [{
    key: 'render',
    value: function render() {
      return null;
    }
  }], [{
    key: 'renderLayer',
    value: function renderLayer(props, ctx) {
      var data = props.data,
          linePosAttr = props.linePosAttr,
          lineSizeAttr = props.lineSizeAttr,
          valuePosAttr = props.valuePosAttr,
          marginTop = props.marginTop,
          marginBottom = props.marginBottom;

      if (!data || data.length === 0) {
        return;
      }

      var distance = getScaleDistance(props, linePosAttr);
      var line = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["c" /* getAttributeFunctor */])(props, linePosAttr);
      var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["c" /* getAttributeFunctor */])(props, valuePosAttr);
      var value0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["h" /* getAttr0Functor */])(props, valuePosAttr);
      var fill = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'fill') || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'color');
      var stroke = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'stroke') || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'color');
      var opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'opacity');

      var itemSize = distance / 2 * 0.85;

      var _getStackParams = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_series_utils__["f" /* getStackParams */])(props),
          sameTypeTotal = _getStackParams.sameTypeTotal,
          sameTypeIndex = _getStackParams.sameTypeIndex;

      data.forEach(function (row) {
        var fillColor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_color__["e" /* rgb */])(fill(row));
        var strokeColor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_color__["e" /* rgb */])(stroke(row));
        var rowOpacity = opacity(row) || __WEBPACK_IMPORTED_MODULE_2__theme__["a" /* DEFAULT_OPACITY */];

        var linePos = line(row) - itemSize + itemSize * 2 / sameTypeTotal * sameTypeIndex;
        var valuePos = Math.min(value0(row), value(row));
        var x = valuePosAttr === 'x' ? valuePos : linePos;
        var y = valuePosAttr === 'y' ? valuePos : linePos;

        var lineSize = itemSize * 2 / sameTypeTotal;
        var valueSize = Math.abs(-value0(row) + value(row));
        var height = lineSizeAttr === 'height' ? lineSize : valueSize;
        var width = lineSizeAttr === 'width' ? lineSize : valueSize;

        ctx.beginPath();
        ctx.rect(x + marginBottom, y + marginTop, width, height);
        ctx.fillStyle = 'rgba(' + fillColor.r + ', ' + fillColor.g + ', ' + fillColor.b + ', ' + rowOpacity + ')';
        ctx.fill();
        ctx.strokeStyle = 'rgba(' + strokeColor.r + ', ' + strokeColor.g + ', ' + strokeColor.b + ', ' + rowOpacity + ')';
        ctx.stroke();
      });
    }
  }, {
    key: 'requiresSVG',
    get: function get() {
      return false;
    }
  }, {
    key: 'isCanvas',
    get: function get() {
      return true;
    }
  }]);

  return BarSeriesCanvas;
}(__WEBPACK_IMPORTED_MODULE_5__abstract_series__["a" /* default */]);

BarSeriesCanvas.displayName = 'BarSeriesCanvas';
BarSeriesCanvas.defaultProps = {
  linePosAttr: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  valuePosAttr: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  lineSizeAttr: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  valueSizeAttr: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
};

BarSeriesCanvas.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_5__abstract_series__["a" /* default */].propTypes);

/* harmony default export */ __webpack_exports__["a"] = (BarSeriesCanvas);

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__animation__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_series_utils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__abstract_series__ = __webpack_require__(8);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.










var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--bar';

var BarSeries = function (_AbstractSeries) {
  _inherits(BarSeries, _AbstractSeries);

  function BarSeries() {
    _classCallCheck(this, BarSeries);

    return _possibleConstructorReturn(this, (BarSeries.__proto__ || Object.getPrototypeOf(BarSeries)).apply(this, arguments));
  }

  _createClass(BarSeries, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          animation = _props.animation,
          className = _props.className,
          data = _props.data,
          linePosAttr = _props.linePosAttr,
          lineSizeAttr = _props.lineSizeAttr,
          marginLeft = _props.marginLeft,
          marginTop = _props.marginTop,
          style = _props.style,
          valuePosAttr = _props.valuePosAttr,
          valueSizeAttr = _props.valueSizeAttr;


      if (!data) {
        return null;
      }

      if (animation) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__animation__["b" /* default */],
          _extends({}, this.props, { animatedProps: __WEBPACK_IMPORTED_MODULE_3__utils_series_utils__["e" /* ANIMATED_SERIES_PROPS */] }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BarSeries, _extends({}, this.props, { animation: null }))
        );
      }

      var _getStackParams = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_series_utils__["f" /* getStackParams */])(this.props),
          sameTypeTotal = _getStackParams.sameTypeTotal,
          sameTypeIndex = _getStackParams.sameTypeIndex;

      var distance = this._getScaleDistance(linePosAttr);
      var lineFunctor = this._getAttributeFunctor(linePosAttr);
      var valueFunctor = this._getAttributeFunctor(valuePosAttr);
      var value0Functor = this._getAttr0Functor(valuePosAttr);
      var fillFunctor = this._getAttributeFunctor('fill') || this._getAttributeFunctor('color');
      var strokeFunctor = this._getAttributeFunctor('stroke') || this._getAttributeFunctor('color');
      var opacityFunctor = this._getAttributeFunctor('opacity');

      var itemSize = distance / 2 * 0.85;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        { className: predefinedClassName + ' ' + className,
          ref: 'container',
          transform: 'translate(' + marginLeft + ',' + marginTop + ')' },
        data.map(function (d, i) {
          var _attrs;

          var attrs = (_attrs = {
            style: _extends({
              opacity: opacityFunctor && opacityFunctor(d),
              stroke: strokeFunctor && strokeFunctor(d),
              fill: fillFunctor && fillFunctor(d)
            }, style)
          }, _defineProperty(_attrs, linePosAttr, lineFunctor(d) - itemSize + itemSize * 2 / sameTypeTotal * sameTypeIndex), _defineProperty(_attrs, lineSizeAttr, itemSize * 2 / sameTypeTotal), _defineProperty(_attrs, valuePosAttr, Math.min(value0Functor(d), valueFunctor(d))), _defineProperty(_attrs, valueSizeAttr, Math.abs(-value0Functor(d) + valueFunctor(d))), _defineProperty(_attrs, 'onClick', function onClick(e) {
            return _this2._valueClickHandler(d, e);
          }), _defineProperty(_attrs, 'onMouseOver', function onMouseOver(e) {
            return _this2._valueMouseOverHandler(d, e);
          }), _defineProperty(_attrs, 'onMouseOut', function onMouseOut(e) {
            return _this2._valueMouseOutHandler(d, e);
          }), _defineProperty(_attrs, 'key', i), _attrs);
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', attrs);
        })
      );
    }
  }], [{
    key: 'propTypes',
    get: function get() {
      return _extends({}, __WEBPACK_IMPORTED_MODULE_4__abstract_series__["a" /* default */].propTypes, {
        linePosAttr: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        valuePosAttr: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        lineSizeAttr: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        valueSizeAttr: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        cluster: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
      });
    }
  }]);

  return BarSeries;
}(__WEBPACK_IMPORTED_MODULE_4__abstract_series__["a" /* default */]);

BarSeries.displayName = 'BarSeries';

/* harmony default export */ __webpack_exports__["a"] = (BarSeries);

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_color__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__theme__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__abstract_series__ = __webpack_require__(8);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.








var LineSeriesCanvas = function (_AbstractSeries) {
  _inherits(LineSeriesCanvas, _AbstractSeries);

  function LineSeriesCanvas() {
    _classCallCheck(this, LineSeriesCanvas);

    return _possibleConstructorReturn(this, (LineSeriesCanvas.__proto__ || Object.getPrototypeOf(LineSeriesCanvas)).apply(this, arguments));
  }

  _createClass(LineSeriesCanvas, [{
    key: 'render',
    value: function render() {
      return null;
    }
  }], [{
    key: 'renderLayer',
    value: function renderLayer(props, ctx) {
      var data = props.data,
          marginLeft = props.marginLeft,
          marginTop = props.marginTop,
          strokeWidth = props.strokeWidth,
          strokeDasharray = props.strokeDasharray;

      if (!data || data.length === 0) {
        return;
      }

      var x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'x');
      var y = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'y');
      var stroke = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["k" /* getAttributeValue */])(props, 'stroke') || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["k" /* getAttributeValue */])(props, 'color');
      var strokeColor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_color__["e" /* rgb */])(stroke);
      var newOpacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["k" /* getAttributeValue */])(props, 'opacity');
      var opacity = Number.isFinite(newOpacity) ? newOpacity : __WEBPACK_IMPORTED_MODULE_2__theme__["a" /* DEFAULT_OPACITY */];

      ctx.beginPath();
      ctx.moveTo(x(data[0]) + marginLeft, y(data[0]) + marginTop);
      data.forEach(function (row) {
        return ctx.lineTo(x(row) + marginLeft, y(row) + marginTop);
      });

      ctx.strokeStyle = 'rgba(' + strokeColor.r + ', ' + strokeColor.g + ', ' + strokeColor.b + ', ' + opacity + ')';
      ctx.lineWidth = strokeWidth;
      if (strokeDasharray) {
        ctx.setLineDash(strokeDasharray);
      }
      ctx.stroke();
      // set back to default
      ctx.lineWidth = 1;
    }
  }, {
    key: 'requiresSVG',
    get: function get() {
      return false;
    }
  }, {
    key: 'isCanvas',
    get: function get() {
      return true;
    }
  }]);

  return LineSeriesCanvas;
}(__WEBPACK_IMPORTED_MODULE_4__abstract_series__["a" /* default */]);

LineSeriesCanvas.displayName = 'LineSeriesCanvas';
LineSeriesCanvas.defaultProps = {
  strokeWidth: 1,
  strokeDasharray: ''
};

LineSeriesCanvas.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_4__abstract_series__["a" /* default */].propTypes, {
  strokeWidth: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number
});

/* harmony default export */ __webpack_exports__["a"] = (LineSeriesCanvas);

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_shape__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__animation__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__theme__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_series_utils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__abstract_series__ = __webpack_require__(8);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.











var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--line';

var STROKE_STYLES = {
  dashed: '6, 2',
  solid: null
};

var defaultProps = {
  strokeStyle: 'solid',
  style: {},
  opacity: 1,
  curve: null,
  className: ''
};

var propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_6__abstract_series__["a" /* default */].propTypes, {
  strokeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(Object.keys(STROKE_STYLES)),
  curve: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
});

var LineSeries = function (_AbstractSeries) {
  _inherits(LineSeries, _AbstractSeries);

  function LineSeries() {
    _classCallCheck(this, LineSeries);

    return _possibleConstructorReturn(this, (LineSeries.__proto__ || Object.getPrototypeOf(LineSeries)).apply(this, arguments));
  }

  _createClass(LineSeries, [{
    key: '_renderLine',
    value: function _renderLine(data, x, y, curve) {
      var line = __WEBPACK_IMPORTED_MODULE_2_d3_shape__["line"]();
      if (curve !== null) {
        if (typeof curve === 'string' && __WEBPACK_IMPORTED_MODULE_2_d3_shape__[curve]) {
          line = line.curve(__WEBPACK_IMPORTED_MODULE_2_d3_shape__[curve]);
        } else if (typeof curve === 'function') {
          line = line.curve(curve);
        }
      }
      line = line.x(x).y(y);
      return line(data);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          animation = _props.animation,
          className = _props.className,
          data = _props.data;

      if (!data) {
        return null;
      }
      if (animation) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__animation__["b" /* default */],
          _extends({}, this.props, { animatedProps: __WEBPACK_IMPORTED_MODULE_5__utils_series_utils__["e" /* ANIMATED_SERIES_PROPS */] }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LineSeries, _extends({}, this.props, { animation: null }))
        );
      }

      var _props2 = this.props,
          strokeStyle = _props2.strokeStyle,
          strokeDasharray = _props2.strokeDasharray,
          strokeWidth = _props2.strokeWidth,
          marginLeft = _props2.marginLeft,
          marginTop = _props2.marginTop,
          curve = _props2.curve,
          style = _props2.style;


      var x = this._getAttributeFunctor('x');
      var y = this._getAttributeFunctor('y');
      var stroke = this._getAttributeValue('stroke') || this._getAttributeValue('color');
      var newOpacity = this._getAttributeValue('opacity');
      var opacity = Number.isFinite(newOpacity) ? newOpacity : __WEBPACK_IMPORTED_MODULE_4__theme__["a" /* DEFAULT_OPACITY */];
      var d = this._renderLine(data, x, y, curve);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
        d: d,
        className: predefinedClassName + ' ' + className,
        transform: 'translate(' + marginLeft + ',' + marginTop + ')',
        onMouseOver: this._seriesMouseOverHandler,
        onMouseOut: this._seriesMouseOutHandler,
        onClick: this._seriesClickHandler,
        style: _extends({
          opacity: opacity,
          strokeDasharray: STROKE_STYLES[strokeStyle] || strokeDasharray,
          strokeWidth: strokeWidth,
          stroke: stroke
        }, style) });
    }
  }]);

  return LineSeries;
}(__WEBPACK_IMPORTED_MODULE_6__abstract_series__["a" /* default */]);

LineSeries.displayName = 'LineSeries';
LineSeries.defaultProps = defaultProps;
LineSeries.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (LineSeries);

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__theme__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_scales_utils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__abstract_series__ = __webpack_require__(8);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.








var MarkSeriesCanvas = function (_AbstractSeries) {
  _inherits(MarkSeriesCanvas, _AbstractSeries);

  function MarkSeriesCanvas() {
    _classCallCheck(this, MarkSeriesCanvas);

    return _possibleConstructorReturn(this, (MarkSeriesCanvas.__proto__ || Object.getPrototypeOf(MarkSeriesCanvas)).apply(this, arguments));
  }

  _createClass(MarkSeriesCanvas, [{
    key: 'render',
    value: function render() {
      return null;
    }
  }], [{
    key: 'renderLayer',
    value: function renderLayer(props, ctx) {
      var data = props.data,
          marginLeft = props.marginLeft,
          marginTop = props.marginTop;


      var x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'x');
      var y = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'y');
      var size = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'size') || function (p) {
        return __WEBPACK_IMPORTED_MODULE_1__theme__["h" /* DEFAULT_SIZE */];
      };
      var fill = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'fill') || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'color');
      var stroke = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'stroke') || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'color');
      var opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'opacity');

      data.forEach(function (row) {
        var fillColor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* rgb */])(fill(row));
        var strokeColor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* rgb */])(stroke(row));
        var rowOpacity = opacity(row) || __WEBPACK_IMPORTED_MODULE_1__theme__["a" /* DEFAULT_OPACITY */];
        ctx.beginPath();
        ctx.arc(x(row) + marginLeft, y(row) + marginTop, size(row), 0, 2 * Math.PI);
        ctx.fillStyle = 'rgba(' + fillColor.r + ', ' + fillColor.g + ', ' + fillColor.b + ', ' + rowOpacity + ')';
        ctx.fill();
        ctx.strokeStyle = 'rgba(' + strokeColor.r + ', ' + strokeColor.g + ', ' + strokeColor.b + ', ' + rowOpacity + ')';
        ctx.stroke();
      });
    }
  }, {
    key: 'requiresSVG',
    get: function get() {
      return false;
    }
  }, {
    key: 'isCanvas',
    get: function get() {
      return true;
    }
  }]);

  return MarkSeriesCanvas;
}(__WEBPACK_IMPORTED_MODULE_3__abstract_series__["a" /* default */]);

MarkSeriesCanvas.displayName = 'MarkSeriesCanvas';
MarkSeriesCanvas.defaultProps = {};

MarkSeriesCanvas.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_3__abstract_series__["a" /* default */].propTypes);

/* harmony default export */ __webpack_exports__["a"] = (MarkSeriesCanvas);

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__animation__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_series_utils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__theme__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__abstract_series__ = __webpack_require__(8);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.











var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--mark';
var DEFAULT_STROKE_WIDTH = 1;

var MarkSeries = function (_AbstractSeries) {
  _inherits(MarkSeries, _AbstractSeries);

  function MarkSeries() {
    _classCallCheck(this, MarkSeries);

    return _possibleConstructorReturn(this, (MarkSeries.__proto__ || Object.getPrototypeOf(MarkSeries)).apply(this, arguments));
  }

  _createClass(MarkSeries, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          animation = _props.animation,
          className = _props.className,
          data = _props.data,
          marginLeft = _props.marginLeft,
          marginTop = _props.marginTop,
          strokeWidth = _props.strokeWidth,
          style = _props.style;

      if (!data) {
        return null;
      }
      if (animation) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__animation__["b" /* default */],
          _extends({}, this.props, { animatedProps: __WEBPACK_IMPORTED_MODULE_3__utils_series_utils__["e" /* ANIMATED_SERIES_PROPS */] }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MarkSeries, _extends({}, this.props, { animation: null }))
        );
      }

      var sizeFunctor = this._getAttributeFunctor('size');
      var opacityFunctor = this._getAttributeFunctor('opacity');
      var fillFunctor = this._getAttributeFunctor('fill') || this._getAttributeFunctor('color');
      var strokeFunctor = this._getAttributeFunctor('stroke') || this._getAttributeFunctor('color');
      var xFunctor = this._getAttributeFunctor('x');
      var yFunctor = this._getAttributeFunctor('y');

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        { className: predefinedClassName + ' ' + className,
          ref: 'container',
          transform: 'translate(' + marginLeft + ',' + marginTop + ')' },
        data.map(function (d, i) {
          var attrs = {
            r: sizeFunctor ? sizeFunctor(d) : __WEBPACK_IMPORTED_MODULE_4__theme__["h" /* DEFAULT_SIZE */],
            cx: xFunctor(d),
            cy: yFunctor(d),
            style: _extends({
              opacity: opacityFunctor ? opacityFunctor(d) : __WEBPACK_IMPORTED_MODULE_4__theme__["a" /* DEFAULT_OPACITY */],
              stroke: strokeFunctor && strokeFunctor(d),
              fill: fillFunctor && fillFunctor(d),
              strokeWidth: strokeWidth || DEFAULT_STROKE_WIDTH
            }, style),
            key: i,
            onClick: function onClick(e) {
              return _this2._valueClickHandler(d, e);
            },
            onMouseOver: function onMouseOver(e) {
              return _this2._valueMouseOverHandler(d, e);
            },
            onMouseOut: function onMouseOut(e) {
              return _this2._valueMouseOutHandler(d, e);
            }
          };
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle', attrs);
        })
      );
    }
  }]);

  return MarkSeries;
}(__WEBPACK_IMPORTED_MODULE_5__abstract_series__["a" /* default */]);

MarkSeries.displayName = 'MarkSeries';
MarkSeries.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_5__abstract_series__["a" /* default */].propTypes, {
  strokeWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
});
/* harmony default export */ __webpack_exports__["a"] = (MarkSeries);

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__animation__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_series_utils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__abstract_series__ = __webpack_require__(8);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.








var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--polygon';
var DEFAULT_COLOR = '#12939A';

var generatePath = function generatePath(data, xFunctor, yFunctor) {
  return data.reduce(function (res, row, i) {
    return res + ' ' + (i ? 'L' : 'M') + xFunctor(row) + ' ' + yFunctor(row);
  }, '') + ' Z';
};

var PolygonSeries = function (_AbstractSeries) {
  _inherits(PolygonSeries, _AbstractSeries);

  function PolygonSeries() {
    _classCallCheck(this, PolygonSeries);

    return _possibleConstructorReturn(this, (PolygonSeries.__proto__ || Object.getPrototypeOf(PolygonSeries)).apply(this, arguments));
  }

  _createClass(PolygonSeries, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          animation = _props.animation,
          color = _props.color,
          className = _props.className,
          data = _props.data,
          marginLeft = _props.marginLeft,
          marginTop = _props.marginTop,
          style = _props.style;


      if (!data) {
        return null;
      }

      if (animation) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1__animation__["b" /* default */],
          _extends({}, this.props, { animatedProps: __WEBPACK_IMPORTED_MODULE_2__utils_series_utils__["e" /* ANIMATED_SERIES_PROPS */] }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PolygonSeries, _extends({}, this.props, { animation: null }))
        );
      }
      var xFunctor = this._getAttributeFunctor('x');
      var yFunctor = this._getAttributeFunctor('y');

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
        className: predefinedClassName + ' ' + className,
        onMouseOver: this._seriesMouseOverHandler,
        onMouseOut: this._seriesMouseOutHandler,
        onClick: this._seriesClickHandler,
        fill: color || DEFAULT_COLOR,
        style: style,
        d: generatePath(data, xFunctor, yFunctor),
        transform: 'translate(' + marginLeft + ',' + marginTop + ')',
        ref: 'container'
      });
    }
  }], [{
    key: 'propTypes',
    get: function get() {
      return _extends({}, __WEBPACK_IMPORTED_MODULE_3__abstract_series__["a" /* default */].propTypes);
    }
  }]);

  return PolygonSeries;
}(__WEBPACK_IMPORTED_MODULE_3__abstract_series__["a" /* default */]);

PolygonSeries.displayName = 'PolygonSeries';

/* harmony default export */ __webpack_exports__["a"] = (PolygonSeries);

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_voronoi__ = __webpack_require__(375);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var NOOP = function NOOP(f) {
  return f;
};

function Voronoi(_ref) {
  var className = _ref.className,
      extent = _ref.extent,
      nodes = _ref.nodes,
      onBlur = _ref.onBlur,
      _onClick = _ref.onClick,
      onHover = _ref.onHover,
      polygonStyle = _ref.polygonStyle,
      style = _ref.style,
      x = _ref.x,
      y = _ref.y;

  // Create a voronoi with each node center points
  var voronoiInstance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_d3_voronoi__["a" /* voronoi */])().x(x).y(y).extent(extent);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'g',
    { className: className + ' rv-voronoi', style: style },
    voronoiInstance.polygons(nodes).map(function (d, i) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
        className: 'rv-voronoi__cell',
        d: 'M' + d.join('L') + 'Z',
        onClick: function onClick() {
          return _onClick(d.data);
        },
        onMouseOver: function onMouseOver() {
          return onHover(d.data);
        },
        onMouseOut: function onMouseOut() {
          return onBlur(d.data);
        },
        fill: 'none',
        style: _extends({
          pointerEvents: 'all'
        }, polygonStyle),
        key: i });
    })
  );
}

Voronoi.requiresSVG = true;

Voronoi.defaultProps = {
  className: '',
  onBlur: NOOP,
  onClick: NOOP,
  onHover: NOOP,
  x: function x(d) {
    return d.x;
  },
  y: function y(d) {
    return d.y;
  }
};

Voronoi.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  extent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number)).isRequired,
  nodes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,
  onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onHover: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  x: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  y: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (Voronoi);

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* unused harmony export isReactDOMSupported */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDOMNode; });
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/* unused harmony export warnOnce */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.



var _React$version$split = __WEBPACK_IMPORTED_MODULE_0_react___default.a.version.split('.'),
    _React$version$split2 = _slicedToArray(_React$version$split, 2),
    major = _React$version$split2[0],
    minor = _React$version$split2[1];

var versionHigherThanThirteen = Number(minor) > 13 || Number(major) > 13;

var isReactDOMSupported = function isReactDOMSupported() {
  return versionHigherThanThirteen;
};

/**
 * Support React 0.13 and greater where refs are React components, not DOM
 * nodes.
 * @param {*} ref React's ref.
 * @returns {Element} DOM element.
 */
var getDOMNode = function getDOMNode(ref) {
  if (!isReactDOMSupported()) {
    return ref && ref.getDOMNode();
  }
  return ref;
};

var USED_MESSAGES = {};
var HIDDEN_PROCESSES = {
  test: true,
  production: true
};

/**
 * Warn the user about something
 * @param {String} message - the message to be shown
 * @param {Boolean} onlyShowMessageOnce - whether or not we allow the
 - message to be show multiple times
 */
function warning(message) {
  var onlyShowMessageOnce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  /* eslint-disable no-undef, no-process-env */
  if (process && HIDDEN_PROCESSES["production"]) {
    return;
  }
  /* eslint-enable no-undef, no-process-env */
  if (!onlyShowMessageOnce || !USED_MESSAGES[message]) {
    /* eslint-disable no-console */
    console.warn(message);
    /* eslint-enable no-console */
    USED_MESSAGES[message] = true;
  }
}

/**
 * Convience wrapper for warning
 * @param {String} message - the message to be shown
 */
function warnOnce(message) {
  warning(message, true);
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(109)))

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(87);

var ReactCurrentOwner = __webpack_require__(48);

var invariant = __webpack_require__(4);
var warning = __webpack_require__(6);

function isNative(fn) {
  // Based on isNative() from Lodash
  var funcToString = Function.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var reIsNative = RegExp('^' + funcToString
  // Take an example native function source for comparison
  .call(hasOwnProperty)
  // Strip regex characters so we can use it for regex
  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  // Remove hasOwnProperty from the template to make it generic
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  try {
    var source = funcToString.call(fn);
    return reIsNative.test(source);
  } catch (err) {
    return false;
  }
}

var canUseCollections =
// Array.from
typeof Array.from === 'function' &&
// Map
typeof Map === 'function' && isNative(Map) &&
// Map.prototype.keys
Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
// Set
typeof Set === 'function' && isNative(Set) &&
// Set.prototype.keys
Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

var setItem;
var getItem;
var removeItem;
var getItemIDs;
var addRoot;
var removeRoot;
var getRootIDs;

if (canUseCollections) {
  var itemMap = new Map();
  var rootIDSet = new Set();

  setItem = function (id, item) {
    itemMap.set(id, item);
  };
  getItem = function (id) {
    return itemMap.get(id);
  };
  removeItem = function (id) {
    itemMap['delete'](id);
  };
  getItemIDs = function () {
    return Array.from(itemMap.keys());
  };

  addRoot = function (id) {
    rootIDSet.add(id);
  };
  removeRoot = function (id) {
    rootIDSet['delete'](id);
  };
  getRootIDs = function () {
    return Array.from(rootIDSet.keys());
  };
} else {
  var itemByKey = {};
  var rootByKey = {};

  // Use non-numeric keys to prevent V8 performance issues:
  // https://github.com/facebook/react/pull/7232
  var getKeyFromID = function (id) {
    return '.' + id;
  };
  var getIDFromKey = function (key) {
    return parseInt(key.substr(1), 10);
  };

  setItem = function (id, item) {
    var key = getKeyFromID(id);
    itemByKey[key] = item;
  };
  getItem = function (id) {
    var key = getKeyFromID(id);
    return itemByKey[key];
  };
  removeItem = function (id) {
    var key = getKeyFromID(id);
    delete itemByKey[key];
  };
  getItemIDs = function () {
    return Object.keys(itemByKey).map(getIDFromKey);
  };

  addRoot = function (id) {
    var key = getKeyFromID(id);
    rootByKey[key] = true;
  };
  removeRoot = function (id) {
    var key = getKeyFromID(id);
    delete rootByKey[key];
  };
  getRootIDs = function () {
    return Object.keys(rootByKey).map(getIDFromKey);
  };
}

var unmountedIDs = [];

function purgeDeep(id) {
  var item = getItem(id);
  if (item) {
    var childIDs = item.childIDs;

    removeItem(id);
    childIDs.forEach(purgeDeep);
  }
}

function describeComponentFrame(name, source, ownerName) {
  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
}

function getDisplayName(element) {
  if (element == null) {
    return '#empty';
  } else if (typeof element === 'string' || typeof element === 'number') {
    return '#text';
  } else if (typeof element.type === 'string') {
    return element.type;
  } else {
    return element.type.displayName || element.type.name || 'Unknown';
  }
}

function describeID(id) {
  var name = ReactComponentTreeHook.getDisplayName(id);
  var element = ReactComponentTreeHook.getElement(id);
  var ownerID = ReactComponentTreeHook.getOwnerID(id);
  var ownerName;
  if (ownerID) {
    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
  }
   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
  return describeComponentFrame(name, element && element._source, ownerName);
}

var ReactComponentTreeHook = {
  onSetChildren: function (id, nextChildIDs) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.childIDs = nextChildIDs;

    for (var i = 0; i < nextChildIDs.length; i++) {
      var nextChildID = nextChildIDs[i];
      var nextChild = getItem(nextChildID);
      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
      if (nextChild.parentID == null) {
        nextChild.parentID = id;
        // TODO: This shouldn't be necessary but mounting a new root during in
        // componentWillMount currently causes not-yet-mounted components to
        // be purged from our tree data so their parent id is missing.
      }
      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
    }
  },
  onBeforeMountComponent: function (id, element, parentID) {
    var item = {
      element: element,
      parentID: parentID,
      text: null,
      childIDs: [],
      isMounted: false,
      updateCount: 0
    };
    setItem(id, item);
  },
  onBeforeUpdateComponent: function (id, element) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.element = element;
  },
  onMountComponent: function (id) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.isMounted = true;
    var isRoot = item.parentID === 0;
    if (isRoot) {
      addRoot(id);
    }
  },
  onUpdateComponent: function (id) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.updateCount++;
  },
  onUnmountComponent: function (id) {
    var item = getItem(id);
    if (item) {
      // We need to check if it exists.
      // `item` might not exist if it is inside an error boundary, and a sibling
      // error boundary child threw while mounting. Then this instance never
      // got a chance to mount, but it still gets an unmounting event during
      // the error boundary cleanup.
      item.isMounted = false;
      var isRoot = item.parentID === 0;
      if (isRoot) {
        removeRoot(id);
      }
    }
    unmountedIDs.push(id);
  },
  purgeUnmountedComponents: function () {
    if (ReactComponentTreeHook._preventPurging) {
      // Should only be used for testing.
      return;
    }

    for (var i = 0; i < unmountedIDs.length; i++) {
      var id = unmountedIDs[i];
      purgeDeep(id);
    }
    unmountedIDs.length = 0;
  },
  isMounted: function (id) {
    var item = getItem(id);
    return item ? item.isMounted : false;
  },
  getCurrentStackAddendum: function (topElement) {
    var info = '';
    if (topElement) {
      var name = getDisplayName(topElement);
      var owner = topElement._owner;
      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
    }

    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    info += ReactComponentTreeHook.getStackAddendumByID(id);
    return info;
  },
  getStackAddendumByID: function (id) {
    var info = '';
    while (id) {
      info += describeID(id);
      id = ReactComponentTreeHook.getParentID(id);
    }
    return info;
  },
  getChildIDs: function (id) {
    var item = getItem(id);
    return item ? item.childIDs : [];
  },
  getDisplayName: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element) {
      return null;
    }
    return getDisplayName(element);
  },
  getElement: function (id) {
    var item = getItem(id);
    return item ? item.element : null;
  },
  getOwnerID: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element || !element._owner) {
      return null;
    }
    return element._owner._debugID;
  },
  getParentID: function (id) {
    var item = getItem(id);
    return item ? item.parentID : null;
  },
  getSource: function (id) {
    var item = getItem(id);
    var element = item ? item.element : null;
    var source = element != null ? element._source : null;
    return source;
  },
  getText: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (typeof element === 'string') {
      return element;
    } else if (typeof element === 'number') {
      return '' + element;
    } else {
      return null;
    }
  },
  getUpdateCount: function (id) {
    var item = getItem(id);
    return item ? item.updateCount : 0;
  },


  getRootIDs: getRootIDs,
  getRegisteredIDs: getItemIDs
};

module.exports = ReactComponentTreeHook;

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  var last = funcs[funcs.length - 1];
  var rest = funcs.slice(0, -1);
  return function () {
    return rest.reduceRight(function (composed, f) {
      return f(composed);
    }, last.apply(undefined, arguments));
  };
}

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["a"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(1317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_symbol_observable__);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'
};

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} enhancer The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */
function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      listeners[i]();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/zenparsing/es-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = observable, _ref2;
}

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1023);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(9);

var _redux = __webpack_require__(67);

var _reactRedux = __webpack_require__(18);

var _reactRouter = __webpack_require__(29);

var _createBrowserHistory = __webpack_require__(383);

var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);

var _reactRouterRedux = __webpack_require__(121);

var _reduxThunk = __webpack_require__(1311);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reduxLogger = __webpack_require__(1310);

var _reduxLogger2 = _interopRequireDefault(_reduxLogger);

var _reducers = __webpack_require__(664);

var _reducers2 = _interopRequireDefault(_reducers);

var _Nav = __webpack_require__(637);

var _Nav2 = _interopRequireDefault(_Nav);

var _Campaign = __webpack_require__(643);

var _Campaign2 = _interopRequireDefault(_Campaign);

var _Campaigns = __webpack_require__(647);

var _Campaigns2 = _interopRequireDefault(_Campaigns);

var _Subjects = __webpack_require__(657);

var _Subjects2 = _interopRequireDefault(_Subjects);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var history = (0, _createBrowserHistory2.default)();


var store = (0, _redux.createStore)(_reducers2.default, (0, _redux.applyMiddleware)(_reduxThunk2.default, (0, _reactRouterRedux.routerMiddleware)(history), _reduxLogger2.default));

var root = document.getElementById('root');

if (root) {
  (0, _reactDom.render)(_react2.default.createElement(
    _reactRedux.Provider,
    { store: store },
    _react2.default.createElement(
      _reactRouter.Router,
      { history: history },
      _react2.default.createElement(
        'div',
        { className: 'react-container' },
        _react2.default.createElement(_Nav2.default, null),
        _react2.default.createElement(
          'main',
          null,
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _reactRouter.Switch,
              null,
              _react2.default.createElement(
                _reactRouter.Route,
                { exact: true, path: '/' },
                _react2.default.createElement(_reactRouter.Redirect, { to: '/campaigns' })
              ),
              _react2.default.createElement(_reactRouter.Route, { exact: true, path: '/campaigns', component: _Campaigns2.default }),
              _react2.default.createElement(_reactRouter.Route, { exact: true, path: '/campaigns/:id', component: _Campaign2.default }),
              _react2.default.createElement(_reactRouter.Route, { exact: true, path: '/campaigns/:campaignId/subjects', component: _Subjects2.default })
            )
          )
        )
      )
    )
  ), root);
}

/***/ }),
/* 629 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeCampaignAudio = exports.uploadCampaignAudio = exports.campaignAudioUploaded = exports.CAMPAIGN_AUDIO_UPLOADED = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _api = __webpack_require__(39);

var _campaign = __webpack_require__(19);

var _reject = __webpack_require__(408);

var _reject2 = _interopRequireDefault(_reject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var CAMPAIGN_AUDIO_UPLOADED = exports.CAMPAIGN_AUDIO_UPLOADED = 'CAMPAIGN_AUDIO_UPLOADED';

var campaignAudioUploaded = exports.campaignAudioUploaded = function campaignAudioUploaded(audioId, topic, language) {
  return { type: CAMPAIGN_AUDIO_UPLOADED, audio: audioId, topic: topic, language: language };
};

var removeAudio = function removeAudio(topic, language, audios) {
  return (0, _reject2.default)(audios, function (_ref) {
    var _ref2 = _slicedToArray(_ref, 3),
        _topic = _ref2[0],
        _language = _ref2[1],
        _uuid = _ref2[2];

    return topic == _topic && language == _language;
  });
};

var mergeAudio = function mergeAudio(id, topic, language, audios) {
  var updatedAudios = removeAudio(topic, language, audios);
  return [].concat(_toConsumableArray(updatedAudios), [[topic, language, id]]);
};

var uploadCampaignAudio = exports.uploadCampaignAudio = function uploadCampaignAudio(file, topic, language) {
  return function (dispatch, getState) {
    (0, _api.createAudio)(file).then(function (response) {
      dispatch(campaignAudioUploaded(response.id, topic, language));
      var updatedAudios = mergeAudio(response.id, topic, language, getState().campaign.data.audios);
      dispatch((0, _campaign.campaignUpdate)({ audios: updatedAudios }));
    });
  };
};

var removeCampaignAudio = exports.removeCampaignAudio = function removeCampaignAudio(topic, language) {
  return function (dispatch, getState) {
    var updatedAudios = removeAudio(topic, language, getState().campaign.data.audios);
    dispatch((0, _campaign.campaignUpdate)({ audios: updatedAudios }));
  };
};

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.editCampaignChatText = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _campaign = __webpack_require__(19);

var _reject = __webpack_require__(408);

var _reject2 = _interopRequireDefault(_reject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var removeChatText = function removeChatText(topic, language, chatTexts) {
  return (0, _reject2.default)(chatTexts, function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        _topic = _ref2[0],
        _language = _ref2[1];

    return topic == _topic && language == _language;
  });
};

var mergeChatText = function mergeChatText(text, topic, language, chatTexts) {
  var updatedChatTexts = removeChatText(topic, language, chatTexts);
  return [].concat(_toConsumableArray(updatedChatTexts), [[topic, language, text]]);
};

var editCampaignChatText = exports.editCampaignChatText = function editCampaignChatText(text, topic, language) {
  return function (dispatch, getState) {
    var updatedChatTexts = mergeChatText(text, topic, language, getState().campaign.data.chatTexts);
    dispatch((0, _campaign.campaignUpdate)({ chatTexts: updatedChatTexts }));
  };
};

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = __webpack_require__(11);

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddButton = function (_Component) {
  _inherits(AddButton, _Component);

  function AddButton() {
    _classCallCheck(this, AddButton);

    return _possibleConstructorReturn(this, (AddButton.__proto__ || Object.getPrototypeOf(AddButton)).apply(this, arguments));
  }

  _createClass(AddButton, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _Button2.default,
        {
          onClick: this.props.onClick,
          floating: true,
          secondary: true,
          className: 'md-cell--right md-cell--bottom add-button' },
        'add'
      );
    }
  }]);

  return AddButton;
}(_react.Component);

exports.default = AddButton;


AddButton.propTypes = {
  onClick: _propTypes2.default.func.isRequired
};

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDropzone = __webpack_require__(1092);

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AudioDropzone = function (_Component) {
  _inherits(AudioDropzone, _Component);

  function AudioDropzone() {
    _classCallCheck(this, AudioDropzone);

    return _possibleConstructorReturn(this, (AudioDropzone.__proto__ || Object.getPrototypeOf(AudioDropzone)).apply(this, arguments));
  }

  _createClass(AudioDropzone, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onDrop = _props.onDrop,
          onDropRejected = _props.onDropRejected,
          error = _props.error;


      var className = 'dropfile audio';
      if (error) className = className + ' error';

      return _react2.default.createElement(
        _reactDropzone2.default,
        { className: className,
          activeClassName: 'active',
          rejectClassName: 'rejectedfile',
          multiple: false,
          onDrop: onDrop,
          onDropRejected: onDropRejected,
          accept: 'audio/*' },
        this.props.children
      );
    }
  }]);

  return AudioDropzone;
}(_react.Component);

AudioDropzone.propTypes = {
  onDrop: _propTypes2.default.func,
  onDropRejected: _propTypes2.default.func,
  error: _propTypes2.default.bool,
  children: _propTypes2.default.array
};

exports.default = AudioDropzone;

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AudioPicker = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _AudioDropzone = __webpack_require__(633);

var _AudioDropzone2 = _interopRequireDefault(_AudioDropzone);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FontIcons = __webpack_require__(36);

var _FontIcons2 = _interopRequireDefault(_FontIcons);

var _Papers = __webpack_require__(256);

var _Papers2 = _interopRequireDefault(_Papers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AudioPicker = exports.AudioPicker = function (_Component) {
  _inherits(AudioPicker, _Component);

  function AudioPicker(props) {
    _classCallCheck(this, AudioPicker);

    var _this = _possibleConstructorReturn(this, (AudioPicker.__proto__ || Object.getPrototypeOf(AudioPicker)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(AudioPicker, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.file != this.file) {
        this.setState({ uploading: false });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var handleUpload = function handleUpload(file) {
        _this2.setState({ uploading: true });
        _this2.props.onUpload(file);
      };

      var uploadingControl = this.state.uploading && _react2.default.createElement(
        'span',
        null,
        'Uploading...'
      );

      var audioPlayer = this.props.file && _react2.default.createElement(
        'audio',
        { controls: true },
        _react2.default.createElement('source', { src: '/api/v1/audios/' + this.props.file, type: 'audio/mpeg' })
      );

      var action = this.props.file ? _react2.default.createElement(
        _FontIcons2.default,
        { onClick: function onClick(e) {
            e.stopPropagation();_this2.props.onRemove();
          }, className: 'pull-right cursor' },
        'close'
      ) : _react2.default.createElement(
        _FontIcons2.default,
        { className: 'pull-right cursor' },
        'file_upload'
      );

      var paperDepth = this.props.file ? 1 : 0;

      return _react2.default.createElement(
        _Papers2.default,
        { zDepth: paperDepth, className: 'md-cell md-cell--12 audio-picker rounded-corners' },
        _react2.default.createElement(
          _AudioDropzone2.default,
          { onDrop: handleUpload },
          _react2.default.createElement(
            'div',
            { className: 'md-grid' },
            _react2.default.createElement(
              'div',
              { className: 'md-cell md-cell--12' },
              action,
              _react2.default.createElement(
                'h3',
                null,
                this.props.title
              ),
              _react2.default.createElement(
                'p',
                null,
                this.props.description
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'md-grid' },
            _react2.default.createElement(
              'div',
              { className: 'md-cell md-cell--12' },
              uploadingControl || audioPlayer
            )
          )
        )
      );
    }
  }]);

  return AudioPicker;
}(_react.Component);

AudioPicker.propTypes = {
  title: _propTypes2.default.string.isRequired,
  description: _propTypes2.default.string,
  onUpload: _propTypes2.default.func.isRequired,
  onRemove: _propTypes2.default.func.isRequired,
  file: _propTypes2.default.string
};

exports.default = AudioPicker;

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatTextComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(18);

var _TextFields = __webpack_require__(47);

var _TextFields2 = _interopRequireDefault(_TextFields);

var _chat_texts = __webpack_require__(631);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChatTextComponent = exports.ChatTextComponent = function (_Component) {
  _inherits(ChatTextComponent, _Component);

  function ChatTextComponent() {
    _classCallCheck(this, ChatTextComponent);

    return _possibleConstructorReturn(this, (ChatTextComponent.__proto__ || Object.getPrototypeOf(ChatTextComponent)).apply(this, arguments));
  }

  _createClass(ChatTextComponent, [{
    key: 'onBlurChatText',
    value: function onBlurChatText(event) {
      this.props.onEditCampaignChatText(event.target.value, this.props.step, this.props.language);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'md-cell md-cell--12 audio-picker rounded-corners' },
        _react2.default.createElement(
          'div',
          { className: 'md-grid' },
          _react2.default.createElement(
            'div',
            { className: 'mdockd-cell md-cell--12' },
            _react2.default.createElement(
              'h3',
              null,
              this.props.title
            ),
            _react2.default.createElement(
              'p',
              null,
              this.props.description
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'md-grid' },
          _react2.default.createElement(
            'div',
            { className: 'md-cell md-cell--12' },
            _react2.default.createElement(_TextFields2.default, {
              rows: 2,
              defaultValue: this.props.text || '',
              onBlur: function onBlur(e) {
                return _this2.onBlurChatText(e);
              }
            })
          )
        )
      );
    }
  }]);

  return ChatTextComponent;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    step: ownProps.step,
    language: ownProps.language
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onEditCampaignChatText: function onEditCampaignChatText(text, step, language) {
      return dispatch((0, _chat_texts.editCampaignChatText)(text, step, language));
    }
  };
};

var ChatText = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ChatTextComponent);

exports.default = ChatText;

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Autocompletes = __webpack_require__(550);

var _Autocompletes2 = _interopRequireDefault(_Autocompletes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FixedAutocomplete = function (_Autocomplete) {
  _inherits(FixedAutocomplete, _Autocomplete);

  _createClass(FixedAutocomplete, [{
    key: 'fixedHandleClick',
    value: function fixedHandleClick(e) {
      var target = e.target;
      while (target && target.parentNode) {
        if (target.classList.contains('md-list-item') && target.parentNode.classList.contains('md-autocomplete-list')) {
          var items = target.parentNode.querySelectorAll('.md-list-item');
          items = Array.prototype.slice.call(items);

          return this._handleItemClick(items.indexOf(target));
        }

        target = target.parentNode;
      }

      return null;
    }
  }]);

  function FixedAutocomplete(props) {
    _classCallCheck(this, FixedAutocomplete);

    var _this = _possibleConstructorReturn(this, (FixedAutocomplete.__proto__ || Object.getPrototypeOf(FixedAutocomplete)).call(this, props));

    _this._handleClick = _this.fixedHandleClick.bind(_this);
    return _this;
  }

  return FixedAutocomplete;
}(_Autocompletes2.default);

exports.default = FixedAutocomplete;


FixedAutocomplete.propTypes = _Autocompletes2.default.propTypes;
FixedAutocomplete.defaultProps = _Autocompletes2.default.defaultProps;

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Toolbars = __webpack_require__(580);

var _Toolbars2 = _interopRequireDefault(_Toolbars);

var _MenuButton = __webpack_require__(566);

var _MenuButton2 = _interopRequireDefault(_MenuButton);

var _Button = __webpack_require__(11);

var _Button2 = _interopRequireDefault(_Button);

var _ListItem = __webpack_require__(63);

var _ListItem2 = _interopRequireDefault(_ListItem);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _api = __webpack_require__(39);

var _config = __webpack_require__(167);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserInfo = function UserInfo(_ref) {
  var displayName = _ref.displayName;
  return _react2.default.createElement(
    _MenuButton2.default,
    {
      id: 'user-menu',
      buttonChildren: 'arrow_drop_down',
      className: 'app-user-menu',
      iconBefore: false,
      label: displayName,
      position: _MenuButton2.default.Positions.BELOW,
      flat: true
    },
    _react2.default.createElement(_ListItem2.default, { primaryText: 'Preferences' }),
    _react2.default.createElement(_ListItem2.default, { onClick: function onClick() {
        return (0, _api.logout)(_config.config.logout_url);
      }, primaryText: 'Sign out' })
  );
};

UserInfo.propTypes = {
  displayName: _propTypes2.default.string
};

var UserNav = function UserNav(_ref2) {
  var displayName = _ref2.displayName;
  return _react2.default.createElement(
    'nav',
    null,
    _react2.default.createElement(
      'div',
      { className: 'sections' },
      _react2.default.createElement(_Button2.default, { href: '/campaigns', flat: true, label: 'Campaigns' })
    ),
    _react2.default.createElement(UserInfo, { displayName: displayName })
  );
};

UserNav.propTypes = {
  displayName: _propTypes2.default.string
};

exports.default = function () {
  return _react2.default.createElement(_Toolbars2.default, {
    className: 'mainToolbar',
    colored: true,
    nav: _react2.default.createElement(UserNav, { displayName: _config.config.user })
  });
};

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PositionFixer = function (_Component) {
  _inherits(PositionFixer, _Component);

  function PositionFixer(props) {
    _classCallCheck(this, PositionFixer);

    var _this = _possibleConstructorReturn(this, (PositionFixer.__proto__ || Object.getPrototypeOf(PositionFixer)).call(this, props));

    _this.recalculate = _this.recalculate.bind(_this);
    return _this;
  }

  // static defaultProps() { offset: 0 }

  _createClass(PositionFixer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('scroll', this.recalculate);
      window.addEventListener('resize', this.recalculate);
      this.recalculate();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.recalculate);
      window.removeEventListener('resize', this.recalculate);
    }
  }, {
    key: 'recalculate',
    value: function recalculate() {
      var offset = this.props.offset;
      var _refs = this.refs,
          reference = _refs.reference,
          contents = _refs.contents;

      var referenceRect = reference.getBoundingClientRect();

      // Setting decimal pixels produces small imperfections in the UI
      // Because parent element might have sizes specified in percentages
      // we copy the rounded value even when the position is not pinned.
      // This way we ensure the same box size when pinned.
      contents.style.width = Math.round(referenceRect.width) + 'px';

      if (referenceRect.top < offset) {
        contents.style.position = 'fixed';
        contents.style.top = offset + 'px';
      } else {
        contents.style.position = null;
        contents.style.top = null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      // This is to avoid margin collapsing that would affect position calculation
      // https://www.w3.org/TR/CSS2/box.html#collapsing-margins

      var referenceStyle = {
        paddingTop: '1px', marginTop: '-1px'
      };

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('div', { ref: 'reference', style: referenceStyle }),
        _react2.default.createElement(
          'div',
          { ref: 'contents' },
          children
        )
      );
    }
  }]);

  return PositionFixer;
}(_react.Component);

exports.default = PositionFixer;


PositionFixer.defaultProps = { offset: 0 };

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animatedScrollTo = exports.ScrollToLink = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = __webpack_require__(11);

var _Button2 = _interopRequireDefault(_Button);

var _jquery = __webpack_require__(909);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ScrollToLink = exports.ScrollToLink = function (_Component) {
  _inherits(ScrollToLink, _Component);

  function ScrollToLink() {
    _classCallCheck(this, ScrollToLink);

    return _possibleConstructorReturn(this, (ScrollToLink.__proto__ || Object.getPrototypeOf(ScrollToLink)).apply(this, arguments));
  }

  _createClass(ScrollToLink, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          target = _props.target;


      return _react2.default.createElement(
        _Button2.default,
        { flat: true, primary: true, className: 'scrollToLink', onClick: function onClick(e) {
            return animatedScrollTo(e, target);
          }, label: children },
        'keyboard_arrow_down'
      );
    }
  }]);

  return ScrollToLink;
}(_react.Component);

ScrollToLink.propTypes = {
  target: _propTypes2.default.string.isRequired,
  children: _propTypes2.default.node
};

var animatedScrollTo = exports.animatedScrollTo = function animatedScrollTo(e, target) {
  e.preventDefault();
  (0, _jquery2.default)('html, body').animate({
    scrollTop: (0, _jquery2.default)('#' + target).offset().top
  }, 500);
};

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TextFields = __webpack_require__(47);

var _TextFields2 = _interopRequireDefault(_TextFields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextField = function (_Component) {
  _inherits(TextField, _Component);

  function TextField(props) {
    _classCallCheck(this, TextField);

    var _this = _possibleConstructorReturn(this, (TextField.__proto__ || Object.getPrototypeOf(TextField)).call(this, props));

    _this.inputRef = null;
    return _this;
  }

  _createClass(TextField, [{
    key: 'endAndSubmit',
    value: function endAndSubmit() {
      var onSubmit = this.props.onSubmit;

      onSubmit(this.inputRef.getField().value);
    }
  }, {
    key: 'onKeyDown',
    value: function onKeyDown(event) {
      if (event.key == 'Enter') {
        this.inputRef.getField().blur();
      }
    }
  }, {
    key: 'setInput',
    value: function setInput(node) {
      this.inputRef = node;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(_TextFields2.default, _extends({}, this.props, {
        ref: function ref(node) {
          return _this2.setInput(node);
        },
        onKeyDown: function onKeyDown(e) {
          return _this2.onKeyDown(e);
        },
        onBlur: function onBlur(e) {
          return _this2.endAndSubmit();
        }
      }));
    }
  }]);

  return TextField;
}(_react.Component);

exports.default = TextField;


TextField.defaultProps = _TextFields2.default.defaultProps;

TextField.propTypes = _extends({}, _TextFields2.default.propTypes, {
  onSubmit: _propTypes2.default.func.isRequired
});

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UntitledIfEmpty = function (_Component) {
  _inherits(UntitledIfEmpty, _Component);

  function UntitledIfEmpty() {
    _classCallCheck(this, UntitledIfEmpty);

    return _possibleConstructorReturn(this, (UntitledIfEmpty.__proto__ || Object.getPrototypeOf(UntitledIfEmpty)).apply(this, arguments));
  }

  _createClass(UntitledIfEmpty, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          text = _props.text,
          _props$emptyText = _props.emptyText,
          emptyText = _props$emptyText === undefined ? 'Untitled' : _props$emptyText,
          className = _props.className;


      if (!text || text.trim() == '') {
        return _react2.default.createElement(
          'em',
          { className: className },
          emptyText
        );
      } else {
        return _react2.default.createElement(
          'span',
          { className: className },
          text
        );
      }
    }
  }]);

  return UntitledIfEmpty;
}(_react.Component);

exports.default = UntitledIfEmpty;


UntitledIfEmpty.propTypes = {
  text: _propTypes2.default.string,
  emptyText: _propTypes2.default.string,
  className: _propTypes2.default.string
};

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reactRedux = __webpack_require__(18);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _campaign = __webpack_require__(19);

var _TextFields = __webpack_require__(47);

var _TextFields2 = _interopRequireDefault(_TextFields);

var _Button = __webpack_require__(11);

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BotChannelSelectionComponent = function (_Component) {
  _inherits(BotChannelSelectionComponent, _Component);

  function BotChannelSelectionComponent() {
    _classCallCheck(this, BotChannelSelectionComponent);

    return _possibleConstructorReturn(this, (BotChannelSelectionComponent.__proto__ || Object.getPrototypeOf(BotChannelSelectionComponent)).apply(this, arguments));
  }

  _createClass(BotChannelSelectionComponent, [{
    key: 'openFbPageInfo',
    value: function openFbPageInfo() {
      window.open('https://www.facebook.com/business/products/pages');
    }
  }, {
    key: 'openFbBotInfo',
    value: function openFbBotInfo() {
      window.open('https://developers.facebook.com/docs/messenger-platform/getting-started/app-setup');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var campaign = this.props.campaign;


      return _react2.default.createElement(
        'section',
        { id: 'channel', className: 'full-height' },
        _react2.default.createElement(
          'div',
          { className: 'md-grid' },
          _react2.default.createElement(
            'div',
            { className: 'md-cell md-cell--12' },
            _react2.default.createElement(
              'h1',
              null,
              'Setup a Facebook channel'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Before the campaign can start you need to create Facebook page and then subscribe a bot.'
            ),
            _react2.default.createElement(
              _Button2.default,
              { flat: true, primary: true, label: 'Read about How to create a Facebook Page', onClick: this.openFbPageInfo },
              'info'
            ),
            _react2.default.createElement(
              _Button2.default,
              { flat: true, primary: true, label: 'Read about How to subscribe a Facebook Bot', onClick: this.openFbBotInfo },
              'info'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'md-grid' },
          _react2.default.createElement(_TextFields2.default, { label: 'Facebook Callback URL',
            id: 'facebook-callback-url',
            value: location.protocol + '//' + location.host + '/callback/facebook',
            readOnly: true
          }),
          _react2.default.createElement(_TextFields2.default, {
            label: 'Facebook Page Id',
            id: 'fb-page-id',
            defaultValue: campaign.fbPageId || '',
            onBlur: function onBlur(e) {
              return _this2.props.onEditFbPageId(e.target.value);
            }
          }),
          _react2.default.createElement(_TextFields2.default, {
            label: 'Verify Token',
            id: 'fb-verify-token',
            defaultValue: campaign.fbVerifyToken || '',
            onBlur: function onBlur(e) {
              return _this2.props.onEditFbVerifyToken(e.target.value);
            }
          }),
          _react2.default.createElement(_TextFields2.default, {
            label: 'Access Token',
            id: 'fb-access-token',
            defaultValue: campaign.fbAccessToken || '',
            onBlur: function onBlur(e) {
              return _this2.props.onEditFbAccessToken(e.target.value);
            }
          })
        )
      );
    }
  }]);

  return BotChannelSelectionComponent;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    campaign: ownProps.campaign,
    fbPageId: state.campaign.data.fbPageId,
    fbVerifyToken: state.campaign.data.fbVerifyToken,
    fbAccessToken: state.campaign.data.fbAccessToken
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onEditFbPageId: function onEditFbPageId(fbPageId) {
      return dispatch((0, _campaign.campaignUpdate)({ fbPageId: fbPageId }));
    },
    onEditFbVerifyToken: function onEditFbVerifyToken(fbVerifyToken) {
      return dispatch((0, _campaign.campaignUpdate)({ fbVerifyToken: fbVerifyToken }));
    },
    onEditFbAccessToken: function onEditFbAccessToken(fbAccessToken) {
      return dispatch((0, _campaign.campaignUpdate)({ fbAccessToken: fbAccessToken }));
    }
  };
};

var BotChannelStep = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BotChannelSelectionComponent);

exports.default = BotChannelStep;

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(67);

var _reactRedux = __webpack_require__(18);

var _campaign = __webpack_require__(19);

var actions = _interopRequireWildcard(_campaign);

var _CampaignTitle = __webpack_require__(646);

var _CampaignTitle2 = _interopRequireDefault(_CampaignTitle);

var _SubNav = __webpack_require__(166);

var _SubNav2 = _interopRequireDefault(_SubNav);

var _CampaignCreationForm = __webpack_require__(644);

var _CampaignCreationForm2 = _interopRequireDefault(_CampaignCreationForm);

var _CampaignDashboard = __webpack_require__(645);

var _CampaignDashboard2 = _interopRequireDefault(_CampaignDashboard);

var _ActiveCampaignSubNav = __webpack_require__(291);

var _ActiveCampaignSubNav2 = _interopRequireDefault(_ActiveCampaignSubNav);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Campaign = function (_Component) {
  _inherits(Campaign, _Component);

  function Campaign() {
    _classCallCheck(this, Campaign);

    return _possibleConstructorReturn(this, (Campaign.__proto__ || Object.getPrototypeOf(Campaign)).apply(this, arguments));
  }

  _createClass(Campaign, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props$campaign = this.props.campaign,
          campaignId = _props$campaign.campaignId,
          data = _props$campaign.data;


      if (this.props.id != campaignId || !data) {
        this.props.actions.campaignFetch(this.props.id);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.campaign.fetching || !this.props.campaign.data) {
        return _react2.default.createElement('div', null);
      } else {
        var content = null;
        var subNav = null;
        if (this.props.campaign.data.startedAt != undefined) {
          subNav = _react2.default.createElement(_ActiveCampaignSubNav2.default, { title: this.props.campaign.data.name, campaignId: this.props.campaign.campaignId });
          content = _react2.default.createElement(_CampaignDashboard2.default, { campaign: this.props.campaign.data,
            callStats: this.props.campaign.data.calls,
            subjectStats: this.props.campaign.data.subjects });
        } else {
          subNav = _react2.default.createElement(
            _SubNav2.default,
            null,
            _react2.default.createElement(_CampaignTitle2.default, { campaign: this.props.campaign.data })
          );
          content = _react2.default.createElement(_CampaignCreationForm2.default, { campaign: this.props.campaign.data });
        }

        return _react2.default.createElement(
          'div',
          { className: 'md-grid--no-spacing' },
          subNav,
          content
        );
      }
    }
  }]);

  return Campaign;
}(_react.Component);

Campaign.propTypes = {
  actions: _propTypes2.default.object.isRequired,
  id: _propTypes2.default.number.isRequired,
  campaign: _propTypes2.default.object.isRequired
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    id: parseInt(ownProps.match.params.id),
    campaign: state.campaign
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actions, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Campaign);

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reactRedux = __webpack_require__(18);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ScrollToLink = __webpack_require__(639);

var _PositionFixer = __webpack_require__(638);

var _PositionFixer2 = _interopRequireDefault(_PositionFixer);

var _ModeStep = __webpack_require__(652);

var _ModeStep2 = _interopRequireDefault(_ModeStep);

var _SymptomStep = __webpack_require__(654);

var _SymptomStep2 = _interopRequireDefault(_SymptomStep);

var _LanguageStep = __webpack_require__(651);

var _LanguageStep2 = _interopRequireDefault(_LanguageStep);

var _UploadAudioStep = __webpack_require__(655);

var _UploadAudioStep2 = _interopRequireDefault(_UploadAudioStep);

var _ChatTextStep = __webpack_require__(649);

var _ChatTextStep2 = _interopRequireDefault(_ChatTextStep);

var _ChannelStep = __webpack_require__(648);

var _ChannelStep2 = _interopRequireDefault(_ChannelStep);

var _BotChannelStep = __webpack_require__(642);

var _BotChannelStep2 = _interopRequireDefault(_BotChannelStep);

var _EducationalInformationStep = __webpack_require__(650);

var _EducationalInformationStep2 = _interopRequireDefault(_EducationalInformationStep);

var _MonitoringSettingsStep = __webpack_require__(653);

var _MonitoringSettingsStep2 = _interopRequireDefault(_MonitoringSettingsStep);

var _campaign = __webpack_require__(19);

var _campaigns = __webpack_require__(169);

var _List = __webpack_require__(45);

var _List2 = _interopRequireDefault(_List);

var _ListItem = __webpack_require__(63);

var _ListItem2 = _interopRequireDefault(_ListItem);

var _FontIcons = __webpack_require__(36);

var _FontIcons2 = _interopRequireDefault(_FontIcons);

var _Subheaders = __webpack_require__(262);

var _Subheaders2 = _interopRequireDefault(_Subheaders);

var _Buttons = __webpack_require__(242);

var _Buttons2 = _interopRequireDefault(_Buttons);

var _campaign2 = __webpack_require__(170);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CampaignCreationFormComponent = function (_Component) {
  _inherits(CampaignCreationFormComponent, _Component);

  function CampaignCreationFormComponent(props) {
    _classCallCheck(this, CampaignCreationFormComponent);

    var _this = _possibleConstructorReturn(this, (CampaignCreationFormComponent.__proto__ || Object.getPrototypeOf(CampaignCreationFormComponent)).call(this, props));

    _this.state = {
      attemptLaunch: false
    };
    return _this;
  }

  _createClass(CampaignCreationFormComponent, [{
    key: 'completedSymptomStep',
    value: function completedSymptomStep() {
      var campaign = this.props.campaign;

      return campaign.symptoms.filter(function (symptom) {
        return symptom[1].length > 0;
      }).length > 0 && campaign.forwardingAddress != null;
    }
  }, {
    key: 'completedEducationalInformationStep',
    value: function completedEducationalInformationStep() {
      return this.props.campaign.additionalInformation != null;
    }
  }, {
    key: 'completedMonitoringSettingsStep',
    value: function completedMonitoringSettingsStep() {
      return this.props.campaign.timezone != null && this.props.campaign.monitorDuration != null;
    }
  }, {
    key: 'completedLanguageStep',
    value: function completedLanguageStep() {
      return this.props.campaign.langs.filter(function (lang) {
        return lang.length > 0;
      }).length > 0;
    }
  }, {
    key: 'completedChannelSelectionStep',
    value: function completedChannelSelectionStep() {
      var campaign = this.props.campaign;

      if (campaign.mode == 'call') {
        return campaign.channel != null && !this.props.activeCampaignUsing(campaign.channel);
      } else {
        return campaign.fbAccessToken != null && campaign.fbPageId != null && campaign.fbVerifyToken != null;
      }
    }
  }, {
    key: 'completedModeStep',
    value: function completedModeStep() {
      return this.props.campaign.mode != null;
    }
  }, {
    key: 'launch',
    value: function launch() {
      this.setState({ attemptLaunch: true });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          completedMessages = _props.completedMessages,
          campaign = _props.campaign;


      var steps = [this.completedModeStep(), this.completedSymptomStep(), completedMessages, this.completedEducationalInformationStep(), this.completedMonitoringSettingsStep(), this.completedLanguageStep(), this.completedChannelSelectionStep()];

      var numberOfCompletedSteps = steps.filter(function (item) {
        return item === true;
      }).length;
      var percentage = (100 / steps.length * numberOfCompletedSteps).toFixed(0) + '%';

      var launchComponent = null;
      if (numberOfCompletedSteps == steps.length) {
        launchComponent = _react2.default.createElement(
          _Buttons2.default,
          { floating: true, secondary: true,
            tooltipLabel: 'Launch campaign',
            tooltipPosition: 'top',
            className: 'launch-campaign'
            // TODO: disable Launch button between click and response
            , onClick: function onClick() {
              return _this2.props.launchCampaign(campaign.id);
            } },
          'play_arrow'
        );
      }

      var messageComponent = null;
      var messageStepLeftIcon = null;
      var channelComponent = null;
      var channelStepLeftIcon = null;
      var messageStepLabel = '';
      var channelStepLabel = '';
      if (campaign.mode === 'chat') {
        messageComponent = _react2.default.createElement(
          _ChatTextStep2.default,
          { campaign: campaign },
          _react2.default.createElement(
            _ScrollToLink.ScrollToLink,
            { target: 'channel' },
            'NEXT: Setup Facebook Channel'
          )
        );
        messageStepLeftIcon = _react2.default.createElement(
          _FontIcons2.default,
          { className: 'step-icon' },
          completedMessages ? 'check_circle' : 'description'
        );
        channelStepLeftIcon = _react2.default.createElement(
          _FontIcons2.default,
          { className: 'step-icon' },
          this.completedChannelSelectionStep() ? 'check_circle' : 'chat'
        );
        channelComponent = _react2.default.createElement(_BotChannelStep2.default, { campaign: campaign });

        messageStepLabel = 'Chatbot texts';
        channelStepLabel = 'Setup Facebook Channel';
      } else if (campaign.mode === 'call') {
        messageComponent = _react2.default.createElement(
          _UploadAudioStep2.default,
          { campaign: campaign },
          _react2.default.createElement(
            _ScrollToLink.ScrollToLink,
            { target: 'channel' },
            'NEXT: Select a channel'
          )
        );
        messageStepLeftIcon = _react2.default.createElement(
          _FontIcons2.default,
          { className: 'step-icon' },
          completedMessages ? 'check_circle' : 'volume_up'
        );
        channelStepLeftIcon = _react2.default.createElement(
          _FontIcons2.default,
          { className: 'step-icon' },
          this.completedChannelSelectionStep() ? 'check_circle' : 'phone'
        );
        channelComponent = _react2.default.createElement(_ChannelStep2.default, null);

        messageStepLabel = 'Upload audio files';
        channelStepLabel = 'Select a channel';
      }

      return _react2.default.createElement(
        'div',
        { className: 'md-grid white' },
        _react2.default.createElement(
          'div',
          { className: 'md-cell md-cell--12-tablet md-cell--4-desktop md-cell--tablet-hidden ' },
          _react2.default.createElement(
            _PositionFixer2.default,
            { offset: 60 },
            _react2.default.createElement(
              'div',
              { className: 'md-paper md-paper--1 rounded-corners' },
              _react2.default.createElement(
                _List2.default,
                { className: 'wizard' },
                _react2.default.createElement(
                  _Subheaders2.default,
                  { primaryText: _react2.default.createElement(
                      'p',
                      null,
                      'Complete the following tasks to get your Campaign ready.'
                    ) },
                  _react2.default.createElement(
                    'h2',
                    null,
                    'Progress ',
                    _react2.default.createElement(
                      'span',
                      { className: 'pull-right' },
                      percentage
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'progress' },
                    _react2.default.createElement('div', { className: 'determinate', style: { width: percentage } })
                  ),
                  launchComponent
                ),
                _react2.default.createElement(_ListItem2.default, { onClick: function onClick(e) {
                    return (0, _ScrollToLink.animatedScrollTo)(e, 'mode');
                  }, leftIcon: _react2.default.createElement(
                    _FontIcons2.default,
                    { className: 'step-icon' },
                    this.completedModeStep() ? 'check_circle' : 'message'
                  ), rightIcon: _react2.default.createElement(
                    _FontIcons2.default,
                    null,
                    'keyboard_arrow_right'
                  ), primaryText: 'Voice calls or chats?', className: this.completedModeStep() ? 'blue-text' : '' }),
                _react2.default.createElement(_ListItem2.default, { onClick: function onClick(e) {
                    return (0, _ScrollToLink.animatedScrollTo)(e, 'symptoms');
                  }, leftIcon: _react2.default.createElement(
                    _FontIcons2.default,
                    { className: 'step-icon' },
                    this.completedSymptomStep() ? 'check_circle' : 'healing'
                  ), rightIcon: _react2.default.createElement(
                    _FontIcons2.default,
                    null,
                    'keyboard_arrow_right'
                  ), primaryText: 'Define the symptoms', className: this.completedSymptomStep() ? 'blue-text' : '' }),
                _react2.default.createElement(_ListItem2.default, { onClick: function onClick(e) {
                    return (0, _ScrollToLink.animatedScrollTo)(e, 'information');
                  }, leftIcon: _react2.default.createElement(
                    _FontIcons2.default,
                    { className: 'step-icon' },
                    this.completedEducationalInformationStep() ? 'check_circle' : 'info'
                  ), rightIcon: _react2.default.createElement(
                    _FontIcons2.default,
                    null,
                    'keyboard_arrow_right'
                  ), primaryText: 'Educational information', className: this.completedEducationalInformationStep() ? 'blue-text' : '' }),
                _react2.default.createElement(_ListItem2.default, { onClick: function onClick(e) {
                    return (0, _ScrollToLink.animatedScrollTo)(e, 'monitoring');
                  }, leftIcon: this.completedMonitoringSettingsStep() ? _react2.default.createElement(
                    _FontIcons2.default,
                    { className: 'step-icon' },
                    'check_circle'
                  ) : _react2.default.createElement('img', { src: '/images/campaign-black.svg', width: '24' }), rightIcon: _react2.default.createElement(
                    _FontIcons2.default,
                    null,
                    'keyboard_arrow_right'
                  ), primaryText: 'Set up monitoring settings', className: this.completedMonitoringSettingsStep() ? 'blue-text' : '' }),
                _react2.default.createElement(_ListItem2.default, { onClick: function onClick(e) {
                    return (0, _ScrollToLink.animatedScrollTo)(e, 'languages');
                  }, leftIcon: _react2.default.createElement(
                    _FontIcons2.default,
                    { className: 'step-icon' },
                    this.completedLanguageStep() ? 'check_circle' : 'translate'
                  ), rightIcon: _react2.default.createElement(
                    _FontIcons2.default,
                    null,
                    'keyboard_arrow_right'
                  ), primaryText: 'Select languages', className: this.completedLanguageStep() ? 'blue-text' : '' }),
                _react2.default.createElement(_ListItem2.default, { onClick: function onClick(e) {
                    return (0, _ScrollToLink.animatedScrollTo)(e, 'audios');
                  },
                  leftIcon: messageStepLeftIcon,
                  rightIcon: _react2.default.createElement(
                    _FontIcons2.default,
                    null,
                    'keyboard_arrow_right'
                  ),
                  primaryText: messageStepLabel,
                  className: completedMessages ? 'blue-text' : '' }),
                _react2.default.createElement(_ListItem2.default, { onClick: function onClick(e) {
                    return (0, _ScrollToLink.animatedScrollTo)(e, 'channel');
                  },
                  leftIcon: channelStepLeftIcon,
                  rightIcon: _react2.default.createElement(
                    _FontIcons2.default,
                    null,
                    'keyboard_arrow_right'
                  ),
                  primaryText: channelStepLabel,
                  className: this.completedChannelSelectionStep() ? 'blue-text' : '' })
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'md-cell md-cell--12-tablet md-cell--7-desktop md-cell--1-desktop-offset wizard-content' },
          _react2.default.createElement(
            _ModeStep2.default,
            { campaign: campaign },
            _react2.default.createElement(
              _ScrollToLink.ScrollToLink,
              { target: 'symptoms' },
              'NEXT: Define symptoms'
            )
          ),
          _react2.default.createElement(
            _SymptomStep2.default,
            { campaign: campaign },
            _react2.default.createElement(
              _ScrollToLink.ScrollToLink,
              { target: 'information' },
              'NEXT: Educational information'
            )
          ),
          _react2.default.createElement(
            _EducationalInformationStep2.default,
            null,
            _react2.default.createElement(
              _ScrollToLink.ScrollToLink,
              { target: 'monitoring' },
              'NEXT: Set up Monitoring Settings'
            )
          ),
          _react2.default.createElement(
            _MonitoringSettingsStep2.default,
            { campaign: campaign },
            _react2.default.createElement(
              _ScrollToLink.ScrollToLink,
              { target: 'languages' },
              'NEXT: Select Languages'
            )
          ),
          _react2.default.createElement(
            _LanguageStep2.default,
            null,
            _react2.default.createElement(
              _ScrollToLink.ScrollToLink,
              { target: 'audios' },
              messageStepLabel
            )
          ),
          messageComponent,
          channelComponent
        )
      );
    }
  }]);

  return CampaignCreationFormComponent;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var activeCampaignUsingChannelIfHaveCampaigns = function activeCampaignUsingChannelIfHaveCampaigns(campaigns) {
    if (campaigns && campaigns.items) {
      return (0, _campaigns.activeCampaignUsing)(campaigns);
    }
    return function () {
      return null;
    };
  };

  return {
    completedMessages: (0, _campaign2.completedMessages)(ownProps.campaign),
    activeCampaignUsing: activeCampaignUsingChannelIfHaveCampaigns(state.campaigns),
    attemptLaunch: state.attemptLaunch
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    launchCampaign: function launchCampaign(id) {
      return dispatch((0, _campaign.campaignLaunch)(id));
    }
  };
};

var CampaignCreationForm = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CampaignCreationFormComponent);

exports.default = CampaignCreationForm;

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactMd = __webpack_require__(582);

var _TextFields = __webpack_require__(47);

var _TextFields2 = _interopRequireDefault(_TextFields);

var _Button = __webpack_require__(11);

var _Button2 = _interopRequireDefault(_Button);

var _Card = __webpack_require__(152);

var _Card2 = _interopRequireDefault(_Card);

__webpack_require__(891);

var _reactVis = __webpack_require__(1256);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FlexibleXYPlot = (0, _reactVis.makeVisFlexible)(_reactVis.XYPlot);

var weekOfYear = function weekOfYear(date) {
  if (!date) {
    date = Date();
  }
  var d = new Date(date);
  d.setHours(0, 0, 0);
  d.setDate(d.getDate() + 4 - (d.getDay() || 7));
  return Math.ceil(((d - new Date(d.getFullYear(), 0, 1)) / 8.64e7 + 1) / 7);
};

var CampaignDashboard = function (_Component) {
  _inherits(CampaignDashboard, _Component);

  function CampaignDashboard() {
    _classCallCheck(this, CampaignDashboard);

    return _possibleConstructorReturn(this, (CampaignDashboard.__proto__ || Object.getPrototypeOf(CampaignDashboard)).apply(this, arguments));
  }

  _createClass(CampaignDashboard, [{
    key: 'openFbPageInfo',
    value: function openFbPageInfo() {
      window.open('https://www.facebook.com/business/products/pages');
    }
  }, {
    key: 'openFbBotInfo',
    value: function openFbBotInfo() {
      window.open('https://developers.facebook.com/docs/messenger-platform/getting-started/app-setup');
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          campaign = _props.campaign,
          subjectStats = _props.subjectStats,
          callStats = _props.callStats;


      var weeksInChart = [];
      var currentWeek = weekOfYear();
      for (var i = 12; i > 0; i--) {
        weeksInChart.push(currentWeek - i);
      }

      var actionTitle = '';
      var facebookSetupInfoComponent = null;
      if (campaign.mode === 'call') {
        actionTitle = 'Calls';
      } else if (campaign.mode === 'chat') {
        actionTitle = 'Chats';
        if (subjectStats.totalSubjects == 0) {
          facebookSetupInfoComponent = _react2.default.createElement(
            _Card2.default,
            null,
            _react2.default.createElement(
              'div',
              { className: 'md-grid' },
              _react2.default.createElement(
                'div',
                { className: 'md-cell md-cell--6' },
                _react2.default.createElement(
                  'h3',
                  null,
                  'Setup a Facebook channel'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Before the campaign can start you need to create Facebook page and then subscribe a bot.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Note: This message will disappear when you create a Subject.'
                ),
                _react2.default.createElement(
                  _Button2.default,
                  { flat: true, primary: true, label: 'Read about How to create a Facebook Page', onClick: this.openFbPageInfo },
                  'info'
                ),
                _react2.default.createElement(
                  _Button2.default,
                  { flat: true, primary: true, label: 'Read about How to subscribe a Facebook Bot', onClick: this.openFbBotInfo },
                  'info'
                ),
                _react2.default.createElement(_TextFields2.default, {
                  label: 'Facebook Callback URL',
                  id: 'facebook-callback-url',
                  value: location.protocol + '//' + location.host + '/callback/facebook',
                  readOnly: true
                }),
                _react2.default.createElement(_TextFields2.default, {
                  label: 'Facebook Page Id',
                  id: 'fb-page-id',
                  value: campaign.fbPageId,
                  readOnly: true
                }),
                _react2.default.createElement(_TextFields2.default, {
                  label: 'Verify Token',
                  id: 'fb-verify-token',
                  value: campaign.fbVerifyToken,
                  readOnly: true
                }),
                _react2.default.createElement(_TextFields2.default, {
                  label: 'Access Token',
                  id: 'fb-access-token',
                  value: campaign.fbAccessToken,
                  readOnly: true
                })
              )
            )
          );
        }
      }

      return _react2.default.createElement(
        'div',
        null,
        facebookSetupInfoComponent,
        _react2.default.createElement(
          'div',
          { className: 'md-grid' },
          _react2.default.createElement(
            'div',
            { className: 'md-cell md-cell--12' },
            _react2.default.createElement(
              'h3',
              null,
              'Campaign performance'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'md-grid' },
          _react2.default.createElement(
            'div',
            { className: 'md-cell md-cell--3 dashboard-data' },
            _react2.default.createElement(
              'div',
              { className: 'md-grid' },
              _react2.default.createElement(
                _reactMd.List,
                { className: 'md-cell md-cell--8' },
                _react2.default.createElement(_reactMd.ListItem, {
                  rightIcon: _react2.default.createElement(
                    _reactMd.FontIcon,
                    null,
                    'keyboard_arrow_right'
                  ),
                  primaryText: subjectStats.cases,
                  secondaryText: 'Cases detected',
                  className: 'red-text' }),
                _react2.default.createElement(_reactMd.ListItem, {
                  rightIcon: _react2.default.createElement(
                    _reactMd.FontIcon,
                    null,
                    'keyboard_arrow_right'
                  ),
                  primaryText: subjectStats.totalSubjects,
                  secondaryText: 'Subjects' })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'md-cell md-cell--9 dashboard-chart' },
            _react2.default.createElement(
              _reactMd.Paper,
              { zDepth: 2, className: 'white rounded-corners' },
              _react2.default.createElement(
                'h2',
                null,
                'Weekly enrolled Subjects'
              ),
              _react2.default.createElement(
                'div',
                { id: 'chart' },
                _react2.default.createElement(
                  FlexibleXYPlot,
                  {
                    xType: 'ordinal',
                    xDistance: 100,
                    stackBy: 'y' },
                  _react2.default.createElement(_reactVis.HorizontalGridLines, {
                    style: { 'stroke': '#E4E4E4' },
                    left: 12 }),
                  _react2.default.createElement(_reactVis.XAxis, { style: { text: { stroke: 'none', fill: '#A4A4A4', fontSize: 12, top: 4 } } }),
                  _react2.default.createElement(_reactVis.YAxis, { style: { text: { stroke: 'none', fill: '#A4A4A4', fontSize: 12, top: 4 } },
                    top: 20 }),
                  _react2.default.createElement(_reactVis.LineSeries, {
                    data: subjectStats.timeline,
                    color: '#4FAF54' })
                )
              )
            )
          )
        ),
        _react2.default.createElement(_reactMd.Divider, { className: 'dashboard-divider' }),
        _react2.default.createElement(
          'div',
          { className: 'md-grid' },
          _react2.default.createElement(
            'div',
            { className: 'md-cell md-cell--12' },
            _react2.default.createElement(
              'h3',
              null,
              actionTitle,
              ' performance'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'md-grid' },
          _react2.default.createElement(
            'div',
            { className: 'md-cell md-cell--3 dashboard-data' },
            _react2.default.createElement(
              'div',
              { className: 'md-grid' },
              _react2.default.createElement(
                _reactMd.List,
                { className: 'md-cell md-cell--8' },
                _react2.default.createElement(_reactMd.ListItem, {
                  rightIcon: _react2.default.createElement(
                    _reactMd.FontIcon,
                    null,
                    'keyboard_arrow_right'
                  ),
                  primaryText: callStats.today,
                  secondaryText: actionTitle + ' today' }),
                _react2.default.createElement(_reactMd.ListItem, {
                  rightIcon: _react2.default.createElement(
                    _reactMd.FontIcon,
                    null,
                    'keyboard_arrow_right'
                  ),
                  primaryText: callStats.lastWeek,
                  secondaryText: actionTitle + ' last 7 days' }),
                _react2.default.createElement(_reactMd.ListItem, {
                  rightIcon: _react2.default.createElement(
                    _reactMd.FontIcon,
                    null,
                    'keyboard_arrow_right'
                  ),
                  primaryText: callStats.successfulOverall,
                  secondaryText: 'Successful ' + actionTitle })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'md-cell md-cell--9 dashboard-chart' },
            _react2.default.createElement(
              _reactMd.Paper,
              { zDepth: 2, className: 'white rounded-corners' },
              _react2.default.createElement(
                'h2',
                null,
                'Weekly ',
                actionTitle,
                ' by status'
              ),
              _react2.default.createElement(_reactVis.DiscreteColorLegend, {
                orientation: 'horizontal',
                items: [{ title: 'Successful', color: '#4FAF54' }, { title: 'Partial', color: '#FEC12E' }] }),
              _react2.default.createElement(
                'div',
                { id: 'chart' },
                _react2.default.createElement(
                  FlexibleXYPlot,
                  {
                    xType: 'ordinal',
                    xDistance: 100,
                    stackBy: 'y' },
                  _react2.default.createElement(_reactVis.HorizontalGridLines, {
                    style: { 'stroke': '#E4E4E4' },
                    left: 12 }),
                  _react2.default.createElement(_reactVis.XAxis, { style: { text: { stroke: 'none', fill: '#A4A4A4', fontSize: 12, top: 4 } } }),
                  _react2.default.createElement(_reactVis.YAxis, { style: { text: { stroke: 'none', fill: '#A4A4A4', fontSize: 12, top: 4 } },
                    top: 20 }),
                  _react2.default.createElement(_reactVis.VerticalBarSeries, {
                    className: 'success',
                    data: callStats.timeline[0],
                    color: '#4FAF54' }),
                  _react2.default.createElement(_reactVis.VerticalBarSeries, {
                    className: 'partial',
                    data: callStats.timeline[0],
                    color: '#FEC12E' })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return CampaignDashboard;
}(_react.Component);

exports.default = CampaignDashboard;

CampaignDashboard.propTypes = {
  callStats: _propTypes2.default.object,
  subjectStats: _propTypes2.default.object,
  campaign: _propTypes2.default.object
};

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _campaign = __webpack_require__(19);

var actions = _interopRequireWildcard(_campaign);

var _EditableTitleLabel = __webpack_require__(292);

var _EditableTitleLabel2 = _interopRequireDefault(_EditableTitleLabel);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(67);

var _reactRedux = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CampaignTitle = function (_Component) {
  _inherits(CampaignTitle, _Component);

  function CampaignTitle() {
    _classCallCheck(this, CampaignTitle);

    return _possibleConstructorReturn(this, (CampaignTitle.__proto__ || Object.getPrototypeOf(CampaignTitle)).apply(this, arguments));
  }

  _createClass(CampaignTitle, [{
    key: 'handleSubmit',
    value: function handleSubmit(newName) {
      var campaign = this.props.campaign;

      if (campaign.name == newName) return;

      // trigger request to update in the server
      this.props.actions.campaignUpdate({ name: newName });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(_EditableTitleLabel2.default, {
        title: this.props.campaign.name,
        emptyText: 'Untitled campaign #' + this.props.campaign.id,
        readOnly: false,
        onSubmit: function onSubmit(title) {
          return _this2.handleSubmit(title);
        },
        maxLength: 255 });
    }
  }]);

  return CampaignTitle;
}(_react.Component);

CampaignTitle.propTypes = {
  campaign: _propTypes2.default.object,
  actions: _propTypes2.default.object.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actions, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CampaignTitle);

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _redux = __webpack_require__(67);

var _reactRedux = __webpack_require__(18);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = __webpack_require__(604);

var _reactRouterRedux = __webpack_require__(121);

var _Card = __webpack_require__(152);

var _Card2 = _interopRequireDefault(_Card);

var _DataTable = __webpack_require__(243);

var _DataTable2 = _interopRequireDefault(_DataTable);

var _TableHeader = __webpack_require__(245);

var _TableHeader2 = _interopRequireDefault(_TableHeader);

var _TableBody = __webpack_require__(244);

var _TableBody2 = _interopRequireDefault(_TableBody);

var _TableRow = __webpack_require__(246);

var _TableRow2 = _interopRequireDefault(_TableRow);

var _TableColumn = __webpack_require__(114);

var _TableColumn2 = _interopRequireDefault(_TableColumn);

var _campaigns = __webpack_require__(164);

var collectionActions = _interopRequireWildcard(_campaigns);

var _campaign = __webpack_require__(19);

var itemActions = _interopRequireWildcard(_campaign);

var _EmptyListing = __webpack_require__(293);

var _EmptyListing2 = _interopRequireDefault(_EmptyListing);

var _SubNav = __webpack_require__(166);

var _SubNav2 = _interopRequireDefault(_SubNav);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CampaignsList = function (_Component) {
  _inherits(CampaignsList, _Component);

  function CampaignsList() {
    _classCallCheck(this, CampaignsList);

    return _possibleConstructorReturn(this, (CampaignsList.__proto__ || Object.getPrototypeOf(CampaignsList)).apply(this, arguments));
  }

  _createClass(CampaignsList, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var campaigns = this.props.items || [];

      if (campaigns.length == 0) {
        return _react2.default.createElement(
          _EmptyListing2.default,
          { image: '/images/campaign.svg' },
          _react2.default.createElement(
            'h5',
            null,
            'You have no campaigns yet'
          ),
          _react2.default.createElement(
            _reactRouterDom.NavLink,
            { to: '#', onClick: this.props.createCampaign },
            'Create one'
          )
        );
      }

      return _react2.default.createElement(
        'div',
        { className: 'md-grid' },
        _react2.default.createElement(
          'div',
          { className: 'md-cell md-cell--12' },
          _react2.default.createElement(
            _Card2.default,
            { tableCard: true },
            _react2.default.createElement(
              _DataTable2.default,
              { plain: true, className: 'app-listing' },
              _react2.default.createElement(
                _TableHeader2.default,
                null,
                _react2.default.createElement(
                  _TableRow2.default,
                  null,
                  _react2.default.createElement(
                    _TableColumn2.default,
                    null,
                    'Name'
                  ),
                  _react2.default.createElement(
                    _TableColumn2.default,
                    null,
                    'Mode'
                  ),
                  _react2.default.createElement(
                    _TableColumn2.default,
                    null,
                    'Role'
                  ),
                  _react2.default.createElement(
                    _TableColumn2.default,
                    null,
                    'Last Activity'
                  )
                )
              ),
              _react2.default.createElement(
                _TableBody2.default,
                null,
                campaigns.map(function (c) {
                  return _react2.default.createElement(CampaignItem, { key: c.id, campaign: c, onClick: _this2.props.onCampaignClick });
                })
              )
            )
          )
        )
      );
    }
  }]);

  return CampaignsList;
}(_react.Component);

CampaignsList.propTypes = {
  createCampaign: _propTypes2.default.func.isRequired,
  onCampaignClick: _propTypes2.default.func.isRequired,
  items: _propTypes2.default.array
};

var CampaignItem = function (_Component2) {
  _inherits(CampaignItem, _Component2);

  function CampaignItem() {
    _classCallCheck(this, CampaignItem);

    return _possibleConstructorReturn(this, (CampaignItem.__proto__ || Object.getPrototypeOf(CampaignItem)).apply(this, arguments));
  }

  _createClass(CampaignItem, [{
    key: 'campaignName',
    value: function campaignName() {
      var name = this.props.campaign.name || '';
      if (name == '') {
        return _react2.default.createElement(
          'em',
          null,
          'Untitled Campaign #',
          this.props.campaign.id
        );
      }
      var nameMaxLength = 120;
      if (name.length > nameMaxLength) {
        return name.slice(0, nameMaxLength - 3) + '...';
      }
      return name;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var campaign = this.props.campaign;
      return _react2.default.createElement(
        _TableRow2.default,
        { className: 'pointer', onClick: function onClick() {
            return _this4.props.onClick(campaign.id);
          } },
        _react2.default.createElement(
          _TableColumn2.default,
          null,
          this.campaignName()
        ),
        _react2.default.createElement(
          _TableColumn2.default,
          null,
          campaign.mode
        ),
        _react2.default.createElement(
          _TableColumn2.default,
          null,
          '...'
        ),
        _react2.default.createElement(
          _TableColumn2.default,
          null,
          campaign.startedAt ? 'Started' : '...'
        )
      );
    }
  }]);

  return CampaignItem;
}(_react.Component);

CampaignItem.propTypes = {
  campaign: _propTypes2.default.shape({
    name: _propTypes2.default.string,
    id: _propTypes2.default.number
  }).isRequired,
  onClick: _propTypes2.default.func.isRequired
};

var Campaigns = function (_Component3) {
  _inherits(Campaigns, _Component3);

  function Campaigns() {
    _classCallCheck(this, Campaigns);

    return _possibleConstructorReturn(this, (Campaigns.__proto__ || Object.getPrototypeOf(Campaigns)).apply(this, arguments));
  }

  _createClass(Campaigns, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.collectionActions.fetchCampaigns();
    }
  }, {
    key: 'createCampaign',
    value: function createCampaign() {
      this.props.itemActions.createCampaign();
    }
  }, {
    key: 'goToCampaign',
    value: function goToCampaign(id) {
      this.props.itemActions.campaignClear();
      this.props.navigate('/campaigns/' + id);
    }
  }, {
    key: 'pageTitle',
    value: function pageTitle() {
      return 'Campaigns!';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      return _react2.default.createElement(
        'div',
        { className: 'md-grid--no-spacing' },
        _react2.default.createElement(
          _SubNav2.default,
          { addButtonHandler: function addButtonHandler() {
              return _this6.createCampaign();
            } },
          'Campaigns'
        ),
        _react2.default.createElement(CampaignsList, {
          items: this.props.campaigns.items,
          createCampaign: function createCampaign() {
            return _this6.createCampaign();
          },
          onCampaignClick: function onCampaignClick(id) {
            return _this6.goToCampaign(id);
          } })
      );
    }
  }]);

  return Campaigns;
}(_react.Component);

Campaigns.propTypes = {
  collectionActions: _propTypes2.default.object.isRequired,
  itemActions: _propTypes2.default.object.isRequired,
  campaigns: _propTypes2.default.object.isRequired,
  navigate: _propTypes2.default.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    campaigns: state.campaigns
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    collectionActions: (0, _redux.bindActionCreators)(collectionActions, dispatch),
    itemActions: (0, _redux.bindActionCreators)(itemActions, dispatch),
    navigate: function navigate(path) {
      return dispatch((0, _reactRouterRedux.push)(path));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Campaigns);

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reactRedux = __webpack_require__(18);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _campaign = __webpack_require__(19);

var _authorizations = __webpack_require__(284);

var authActions = _interopRequireWildcard(_authorizations);

var _channels = __webpack_require__(165);

var channelActions = _interopRequireWildcard(_channels);

var _campaigns = __webpack_require__(164);

var campaignActions = _interopRequireWildcard(_campaigns);

var _campaigns2 = __webpack_require__(169);

var _Papers = __webpack_require__(256);

var _Papers2 = _interopRequireDefault(_Papers);

var _Dialogs = __webpack_require__(249);

var _Dialogs2 = _interopRequireDefault(_Dialogs);

var _Lists = __webpack_require__(563);

var _Lists2 = _interopRequireDefault(_Lists);

var _ListItemControl = __webpack_require__(254);

var _ListItemControl2 = _interopRequireDefault(_ListItemControl);

var _Switch = __webpack_require__(571);

var _Switch2 = _interopRequireDefault(_Switch);

var _FontIcons = __webpack_require__(36);

var _FontIcons2 = _interopRequireDefault(_FontIcons);

var _Button = __webpack_require__(11);

var _Button2 = _interopRequireDefault(_Button);

var _SelectionControlGroup = __webpack_require__(261);

var _SelectionControlGroup2 = _interopRequireDefault(_SelectionControlGroup);

var _TextFields = __webpack_require__(47);

var _TextFields2 = _interopRequireDefault(_TextFields);

var _config = __webpack_require__(167);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChannelSelectionComponent = function (_Component) {
  _inherits(ChannelSelectionComponent, _Component);

  function ChannelSelectionComponent(props) {
    _classCallCheck(this, ChannelSelectionComponent);

    var _this = _possibleConstructorReturn(this, (ChannelSelectionComponent.__proto__ || Object.getPrototypeOf(ChannelSelectionComponent)).call(this, props));

    _this.state = {
      providerModalVisible: false
    };
    return _this;
  }

  _createClass(ChannelSelectionComponent, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.fetchAuthorizations();
      this.props.fetchChannels();
      this.props.fetchCampaigns();
    }
  }, {
    key: 'openChannelSetupInfo',
    value: function openChannelSetupInfo() {
      window.open('https://github.com/instedd/active-monitoring/wiki/Setting-up-Verboice-channels');
    }
  }, {
    key: 'openVerboiceSetup',
    value: function openVerboiceSetup() {
      window.open(_config.config['verboice'][0].baseUrl + '/channels');
    }
  }, {
    key: 'addProvider',
    value: function addProvider(event) {
      event.preventDefault();
      this.setState({ providerModalVisible: true });
    }
  }, {
    key: 'closeProviderModal',
    value: function closeProviderModal() {
      this.setState({ providerModalVisible: false });
    }
  }, {
    key: 'toggleProvider',
    value: function toggleProvider(provider, index, checked) {
      if (checked) {
        $('#' + provider + 'Modal-' + index).modal('open');
      } else {
        this.props.toggleProvider(provider, index);
      }
    }
  }, {
    key: 'turnOffProvider',
    value: function turnOffProvider(provider, index) {
      authActions.removeAuthorization(provider, index);
    }
  }, {
    key: 'deleteProvider',
    value: function deleteProvider(provider, index) {
      authActions.toggleAuthorization(provider, index);
    }
  }, {
    key: 'channelOptions',
    value: function channelOptions(channels) {
      var activeCampaignUsing = this.props.activeCampaignUsing;

      return channels.map(function (name) {
        var camp = activeCampaignUsing(name);
        return {
          label: name + (camp ? ' (in use by campaign ' + camp.name + ')' : ''), value: name, disabled: camp !== undefined };
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      if (!this.props.channels) {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _Papers2.default,
            null,
            'Loading channels...'
          )
        );
      }

      var providerSwitch = function providerSwitch(provider, index) {
        var disabled = _this2.props.authorizations.fetching;
        var checked = authActions.hasInAuthorizations(_this2.props.authorizations, provider, index);
        return _react2.default.createElement(_Switch2.default, { id: 'switch', label: '', name: 'providerSwitch', checked: checked, onChange: function onChange() {
            return _this2.toggleProvider(provider, index, false);
          }, disabled: disabled });
      };

      var multipleVerboice = _config.config['verboice'].length > 1;

      var providerModals = [];
      var verboiceProviderUI = function verboiceProviderUI(index, multiple) {
        var name = 'Verboice';
        if (multiple) name = name + ' (' + _config.config['verboice'][index].friendlyName + ')';

        return _react2.default.createElement(_ListItemControl2.default, {
          key: 'verboice-' + index,
          className: 'verboice',
          rightIcon: _react2.default.createElement(
            _FontIcons2.default,
            { onClick: function onClick() {
                return window.open(_config.config['verboice'][index].baseUrl);
              } },
            'chevron_right'
          ),
          primaryAction: providerSwitch('verboice', index),
          primaryText: name,
          secondaryText: 'Callcentric, SIP client, SIP server, Skype, Twillio'
        });
      };

      var providerUIs = [];
      for (var index in _config.config['verboice']) {
        providerUIs.push(verboiceProviderUI(index, multipleVerboice));
      }

      var channelControl = null;
      if ((this.props.channels.items || []).length > 0) {
        channelControl = _react2.default.createElement(_SelectionControlGroup2.default, {
          id: 'channel-select',
          name: 'channel-select',
          controls: this.channelOptions(this.props.channels.items),
          className: 'md-cell md-cell--12',
          type: 'radio',
          value: this.props.selectedChannel,
          onChange: function onChange(val) {
            return _this2.props.onChangeChannel(val);
          }
        });
      } else {
        if (this.props.channels.fetching || this.props.authorizations.fetching) {
          channelControl = 'Fetching available channels...';
        } else {
          if ((this.props.authorizations.items || []).length > 0) {
            channelControl = _react2.default.createElement(
              'div',
              { className: 'md-cell md-cell--12' },
              _react2.default.createElement(
                'p',
                null,
                'You don\'t have any channel available'
              ),
              _react2.default.createElement(
                _Button2.default,
                { flat: true, primary: true, label: 'Setup a channel on Verboice', onClick: this.openVerboiceSetup },
                'open_in_new'
              )
            );
          } else {
            channelControl = _react2.default.createElement(
              'p',
              { className: 'md-cell md-cell--12' },
              'You don\'t have any provider configured - select Manage Providers below to start!'
            );
          }
        }
      }

      return _react2.default.createElement(
        'section',
        { id: 'channel', className: 'full-height' },
        _react2.default.createElement(
          'div',
          { className: 'md-grid' },
          _react2.default.createElement(
            'div',
            { className: 'md-cell md-cell--12' },
            _react2.default.createElement(
              'h1',
              null,
              'Choose a channel'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Before the campaign can start you need to select a Verboice channel to receive the incoming calls.'
            ),
            _react2.default.createElement(_TextFields2.default, { label: 'Call Flow callback URL', id: 'callflow-callback-url', value: location.protocol + '//' + location.host + '/callbacks/verboice/' + this.props.campaignId, readOnly: true }),
            _react2.default.createElement(_TextFields2.default, { label: 'Project Status callback', id: 'project-status-callback', value: location.protocol + '//' + location.host + '/callbacks/verboice/' + this.props.campaignId + '/status', readOnly: true }),
            _react2.default.createElement(
              _Button2.default,
              { flat: true, primary: true, label: 'Read about channel setup', onClick: this.openChannelSetupInfo },
              'info'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'md-grid' },
          channelControl
        ),
        _react2.default.createElement(
          'div',
          { className: 'md-grid' },
          _react2.default.createElement(
            'div',
            { className: 'md-cell md-cell--8' },
            _react2.default.createElement(
              _Button2.default,
              { flat: true, label: 'Manage providers', onClick: function onClick(e) {
                  return _this2.addProvider(e);
                } },
              'settings'
            ),
            providerModals,
            _react2.default.createElement(
              _Dialogs2.default,
              { id: 'add-channel', visible: this.state.providerModalVisible, onHide: function onHide() {
                  return _this2.closeProviderModal();
                }, title: 'Manage providers', focusOnMount: false },
              _react2.default.createElement(
                _Lists2.default,
                null,
                providerUIs
              )
            )
          )
        )
      );
    }
  }]);

  return ChannelSelectionComponent;
}(_react.Component);

ChannelSelectionComponent.propTypes = {
  channels: _propTypes2.default.object,
  campaignId: _propTypes2.default.number,
  fetchAuthorizations: _propTypes2.default.func,
  fetchChannels: _propTypes2.default.func,
  fetchCampaigns: _propTypes2.default.func,
  toggleProvider: _propTypes2.default.func,
  activeCampaignUsing: _propTypes2.default.func,
  authorizations: _propTypes2.default.shape({
    fetching: _propTypes2.default.bool,
    items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      provider: _propTypes2.default.string,
      baseUrl: _propTypes2.default.string
    }))
  }),
  selectedChannel: _propTypes2.default.string,
  onChangeChannel: _propTypes2.default.func
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    channels: state.channels,
    activeCampaignUsing: (0, _campaigns2.activeCampaignUsing)(state.campaigns),
    authorizations: state.authorizations,
    selectedChannel: state.campaign.data.channel,
    campaignId: state.campaign.data.id
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onChangeChannel: function onChangeChannel(value) {
      return dispatch((0, _campaign.campaignUpdate)({ channel: value }));
    },
    toggleProvider: function toggleProvider(provider, index) {
      return dispatch(authActions.toggleAuthorization(provider, index));
    },
    fetchAuthorizations: function fetchAuthorizations() {
      return dispatch(authActions.fetchAuthorizations());
    },
    fetchChannels: function fetchChannels() {
      return dispatch(channelActions.fetchChannels());
    },
    fetchCampaigns: function fetchCampaigns() {
      return dispatch(campaignActions.fetchCampaigns());
    }
  };
};

var ChannelStep = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ChannelSelectionComponent);

exports.default = ChannelStep;

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reactRedux = __webpack_require__(18);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _values = __webpack_require__(146);

var _values2 = _interopRequireDefault(_values);

var _flatten = __webpack_require__(220);

var _flatten2 = _interopRequireDefault(_flatten);

var _capitalize = __webpack_require__(404);

var _capitalize2 = _interopRequireDefault(_capitalize);

var _campaign = __webpack_require__(170);

var _langs = __webpack_require__(168);

var _FontIcons = __webpack_require__(36);

var _FontIcons2 = _interopRequireDefault(_FontIcons);

var _Tabs = __webpack_require__(264);

var _Tabs2 = _interopRequireDefault(_Tabs);

var _Tab = __webpack_require__(263);

var _Tab2 = _interopRequireDefault(_Tab);

var _TabsContainer = __webpack_require__(265);

var _TabsContainer2 = _interopRequireDefault(_TabsContainer);

var _ChatText = __webpack_require__(635);

var _ChatText2 = _interopRequireDefault(_ChatText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MessageTextCounter = function MessageTextCounter(_ref) {
  var filled = _ref.filled,
      total = _ref.total;
  return _react2.default.createElement(
    'div',
    { className: 'md-cell md-cell--12' },
    _react2.default.createElement(
      'h3',
      { className: 'uploaded-files' },
      _react2.default.createElement(
        _FontIcons2.default,
        null,
        'note_add'
      ),
      filled,
      '/',
      total,
      ' texts filled'
    )
  );
};

var ChatTextStepComponent = function (_Component) {
  _inherits(ChatTextStepComponent, _Component);

  function ChatTextStepComponent() {
    _classCallCheck(this, ChatTextStepComponent);

    return _possibleConstructorReturn(this, (ChatTextStepComponent.__proto__ || Object.getPrototypeOf(ChatTextStepComponent)).apply(this, arguments));
  }

  _createClass(ChatTextStepComponent, [{
    key: 'getTopicTexts',
    value: function getTopicTexts(topic) {
      if (topic == 'welcome') {
        return { title: 'Welcome message', description: 'Present the objectives of this chat bot and instruct the user to send "registration" to enroll to the daily survey' };
      } else if (topic == 'identify') {
        return { title: 'Identify message', description: 'Ask subject to enter their ID' };
      } else if (topic == 'registration') {
        return { title: 'Registration message', description: 'Inform the subject that the registration number is invalid, ant that he should call to get one' };
      } else if (topic == 'educational') {
        return { title: 'Educational information', description: 'Inform the subject about additional information such as prevention measures' };
      } else if (topic == 'additional_information_intro') {
        return { title: 'Additional information introduction', description: 'Ask the subject whether they want to read some educational information' };
      } else if (topic == 'thanks') {
        return { title: 'Thank you message', description: 'Thank the subject for participating' };
      } else if (topic == 'language') {
        return { title: 'Language options', description: '' };
      } else if (topic.startsWith('symptom:')) {
        var id = topic.split(':', 2)[1];
        var matchingSymptom = this.props.symptoms.find(function (_ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
              _id = _ref3[0],
              _name = _ref3[1];

          return id == _id;
        });

        if (Array.isArray(matchingSymptom)) {
          return { title: (0, _capitalize2.default)(matchingSymptom[1]) + ' symptom question', description: 'Ask if there are any signs of this symptom.' };
        } else {
          throw new Error('Malformed symptom list');
        }
      } else {
        throw new Error('Unexpected topic: ' + topic);
      }
    }
  }, {
    key: 'renderLangTab',
    value: function renderLangTab(lang) {
      var _this2 = this;

      var _props = this.props,
          neededMessages = _props.neededMessages,
          messages = _props.messages;


      return _react2.default.createElement(
        _Tab2.default,
        { label: (0, _langs.codeToName)(lang), key: lang },
        neededMessages[lang].map(function (topic) {
          return _react2.default.createElement(_ChatText2.default, _extends({
            text: (0, _campaign.getChatTextFor)(messages, topic, lang),
            step: topic,
            language: lang,
            key: topic
          }, _this2.getTopicTexts(topic)));
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          neededMessages = _props2.neededMessages,
          messages = _props2.messages;


      var totalCopies = (0, _flatten2.default)((0, _values2.default)(neededMessages)).length + 1;

      return _react2.default.createElement(
        'section',
        { id: 'audios', className: 'full-height' },
        _react2.default.createElement(
          'div',
          { className: 'md-grid' },
          _react2.default.createElement(
            'div',
            { className: 'md-cell md-cell--12' },
            _react2.default.createElement(
              'h1',
              null,
              'Add Chatbot texts'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Add the text for each chat message. After that you will be able to test the chat flow.'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'md-grid' },
          _react2.default.createElement(MessageTextCounter, { filled: messages.length, total: totalCopies })
        ),
        _react2.default.createElement(
          'div',
          { className: 'md-grid' },
          _react2.default.createElement(
            'div',
            { className: 'md-cell md-cell--12' },
            _react2.default.createElement(_ChatText2.default, _extends({
              step: 'language',
              language: '',
              text: (0, _campaign.getChatTextFor)(messages, 'language', '')
            }, this.getTopicTexts('language')))
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'md-grid' },
          _react2.default.createElement(
            'div',
            { className: 'md-cell md-cell--12' },
            _react2.default.createElement(
              _TabsContainer2.default,
              { component: 'div', panelClassName: 'md-grid' },
              _react2.default.createElement(
                _Tabs2.default,
                { tabId: 'langs' },
                this.props.langs.filter(function (lang) {
                  return lang && lang != '';
                }).map(function (lang) {
                  return _this3.renderLangTab(lang);
                })
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'md-grid' },
          _react2.default.createElement(
            'div',
            { className: 'md-cell md-cell--12' },
            this.props.children
          )
        )
      );
    }
  }]);

  return ChatTextStepComponent;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var campaign = ownProps.campaign;
  return {
    messages: (0, _campaign.messagesInUse)(campaign),
    neededMessages: (0, _campaign.neededMessages)(campaign),
    symptoms: campaign.symptoms || [],
    langs: campaign.langs || []
  };
};

var ChatTextStep = (0, _reactRedux.connect)(mapStateToProps)(ChatTextStepComponent);

exports.default = ChatTextStep;

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reactRedux = __webpack_require__(18);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _campaign = __webpack_require__(19);

var _Radio = __webpack_require__(260);

var _Radio2 = _interopRequireDefault(_Radio);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EducationalInformationComponent = function (_Component) {
  _inherits(EducationalInformationComponent, _Component);

  function EducationalInformationComponent() {
    _classCallCheck(this, EducationalInformationComponent);

    return _possibleConstructorReturn(this, (EducationalInformationComponent.__proto__ || Object.getPrototypeOf(EducationalInformationComponent)).apply(this, arguments));
  }

  _createClass(EducationalInformationComponent, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'section',
        { id: 'information', className: 'full-height' },
        _react2.default.createElement(
          'div',
          { className: 'md-grid' },
          _react2.default.createElement(
            'div',
            { className: 'md-cell md-cell--12' },
            _react2.default.createElement(
              'h1',
              null,
              'Educational information'
            ),
            _react2.default.createElement(
              'p',
              null,
              'In case of asymptomatic subjects you can offer additional information to prevent contagion after symptoms evaluation.'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'md-grid' },
          _react2.default.createElement(
            'div',
            { className: 'md-cell md-cell--12' },
            _react2.default.createElement(_Radio2.default, {
              id: 'zero',
              name: 'zero',
              value: 'zero',
              label: 'No additional information',
              checked: this.props.additionalInformation === 'zero',
              onChange: function onChange() {
                return _this2.props.onEdit('zero');
              },
              className: 'margin-left-none'
            }),
            _react2.default.createElement(_Radio2.default, {
              id: 'optional',
              name: 'optional',
              value: 'optional',
              label: 'Optional additional information',
              checked: this.props.additionalInformation === 'optional',
              onChange: function onChange() {
                return _this2.props.onEdit('optional');
              },
              className: 'margin-left-none'
            }),
            _react2.default.createElement(_Radio2.default, {
              id: 'compulsory',
              name: 'compulsory',
              value: 'compulsory',
              label: 'Compulsory additional information',
              checked: this.props.additionalInformation === 'compulsory',
              onChange: function onChange() {
                return _this2.props.onEdit('compulsory');
              },
              className: 'margin-left-none'
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'md-grid' },
          _react2.default.createElement(
            'div',
            { className: 'md-cell md-cell--12' },
            this.props.children
          )
        )
      );
    }
  }]);

  return EducationalInformationComponent;
}(_react.Component);

EducationalInformationComponent.propTypes = {
  additionalInformation: _propTypes2.default.string,
  onEdit: _propTypes2.default.func,
  children: _propTypes2.default.element
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    additionalInformation: state.campaign.data.additionalInformation
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onEdit: function onEdit(additionalInformation) {
      return dispatch((0, _campaign.campaignUpdate)({ additionalInformation: additionalInformation }));
    }
  };
};

var EducationalInformationStep = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(EducationalInformationComponent);

exports.default = EducationalInformationStep;

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reactRedux = __webpack_require__(18);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _iso = __webpack_require__(385);

var _iso2 = _interopRequireDefault(_iso);

var _langs = __webpack_require__(285);

var _campaign = __webpack_require__(19);

var _langs2 = __webpack_require__(168);

var _Button = __webpack_require__(11);

var _Button2 = _interopRequireDefault(_Button);

var _List = __webpack_require__(45);

var _List2 = _interopRequireDefault(_List);

var _ListItemControl = __webpack_require__(254);

var _ListItemControl2 = _interopRequireDefault(_ListItemControl);

var _FontIcons = __webpack_require__(36);

var _FontIcons2 = _interopRequireDefault(_FontIcons);

var _FixedAutocomplete = __webpack_require__(636);

var _FixedAutocomplete2 = _interopRequireDefault(_FixedAutocomplete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LanguageStepComponent = function (_Component) {
  _inherits(LanguageStepComponent, _Component);

  function LanguageStepComponent() {
    _classCallCheck(this, LanguageStepComponent);

    return _possibleConstructorReturn(this, (LanguageStepComponent.__proto__ || Object.getPrototypeOf(LanguageStepComponent)).apply(this, arguments));
  }

  _createClass(LanguageStepComponent, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var languages = _iso2.default.map(function (obj) {
        return { label: obj.name, value: obj.iso6391 };
      }).filter(function (obj) {
        return obj.value != null && !_this2.props.langs.includes(obj.value);
      });

      return _react2.default.createElement(
        'section',
        { id: 'languages', className: 'full-height' },
        _react2.default.createElement(
          'div',
          { className: 'md-grid' },
          _react2.default.createElement(
            'div',
            { className: 'md-cell md-cell--12' },
            _react2.default.createElement(
              'h1',
              null,
              'Select languages'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Select all the languages the caller can choose between. Each will have their own set of audios.'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'md-grid' },
          _react2.default.createElement(
            _List2.default,
            { className: 'md-cell md-cell--12 add-language' },
            (this.props.langs || []).map(function (id, i) {
              return (
                // List item control is necessary for the autocomplete to work, and it requires primaryText
                // Issue on this is pending: https://github.com/mlaursen/react-md/issues/412
                _react2.default.createElement(_ListItemControl2.default, {
                  key: id,
                  primaryText: '',
                  rightIcon: _react2.default.createElement(
                    _FontIcons2.default,
                    { className: 'cursor', onClick: function onClick() {
                        return _this2.props.onRemove(i);
                      } },
                    'cancel'
                  ),
                  primaryAction: _react2.default.createElement(_FixedAutocomplete2.default, {
                    id: 'autocomplete' + i,
                    data: languages,
                    filter: _FixedAutocomplete2.default.caseInsensitiveFilter,
                    onAutocomplete: function onAutocomplete(lbl, j, obj) {
                      return _this2.props.onEdit(obj[j].value, i);
                    },
                    block: false,
                    dataLabel: 'label',
                    dataValue: 'value',
                    defaultValue: (0, _langs2.codeToName)(id) || ''
                  })
                })
              );
            })
          ),
          _react2.default.createElement(
            _Button2.default,
            { flat: true, label: 'Add language', className: 'btn-add-grey', onClick: this.props.onAdd },
            'add'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'md-grid' },
          _react2.default.createElement(
            'div',
            { className: 'md-cell md-cell--12' },
            this.props.children
          )
        )
      );
    }
  }]);

  return LanguageStepComponent;
}(_react.Component);

LanguageStepComponent.propTypes = {
  onRemove: _propTypes2.default.func,
  onEdit: _propTypes2.default.func,
  onAdd: _propTypes2.default.func,
  langs: _propTypes2.default.arrayOf(_propTypes2.default.string),
  children: _propTypes2.default.element
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    langs: state.campaign.data.langs
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onAdd: function onAdd() {
      return dispatch((0, _langs.addEmptyLang)());
    },
    onEdit: function onEdit(lang, index) {
      return dispatch((0, _langs.editLang)(lang, index));
    },
    onRemove: function onRemove(index) {
      return dispatch((0, _langs.removeLang)(index));
    },
    onEditForwarding: function onEditForwarding(key, value) {
      return dispatch((0, _campaign.campaignUpdate)(_defineProperty({}, key, value)));
    }
  };
};

var LanguageStep = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LanguageStepComponent);

exports.default = LanguageStep;

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reactRedux = __webpack_require__(18);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _campaign = __webpack_require__(19);

var _Radio = __webpack_require__(260);

var _Radio2 = _interopRequireDefault(_Radio);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModeStepComponent = function (_Component) {
  _inherits(ModeStepComponent, _Component);

  function ModeStepComponent() {
    _classCallCheck(this, ModeStepComponent);

    return _possibleConstructorReturn(this, (ModeStepComponent.__proto__ || Object.getPrototypeOf(ModeStepComponent)).apply(this, arguments));
  }

  _createClass(ModeStepComponent, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'section',
        { id: 'mode', className: 'full-height' },
        _react2.default.createElement(
          'div',
          { className: 'md-grid' },
          _react2.default.createElement(
            'div',
            { className: 'md-cell md-cell--12' },
            _react2.default.createElement(
              'h1',
              null,
              'Choose how you communicate with subjects'
            ),
            _react2.default.createElement(
              'p',
              null,
              'You can either communicate with them through phone calls or a Facebook Chatbot.'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'md-cell md-cell--12' },
            _react2.default.createElement(_Radio2.default, {
              id: 'call',
              name: 'call',
              value: 'call',
              label: 'ActiveMonitoring will call subjects',
              checked: this.props.mode == 'call',
              onChange: function onChange() {
                return _this2.props.onEdit('call');
              },
              className: 'margin-left-none'
            }),
            _react2.default.createElement(_Radio2.default, {
              id: 'chat',
              name: 'chat',
              value: 'chat',
              label: 'ActiveMonitoring will chat with subjects',
              checked: this.props.mode == 'chat',
              onChange: function onChange() {
                return _this2.props.onEdit('chat');
              },
              className: 'margin-left-none'
            })
          )
        )
      );
    }
  }]);

  return ModeStepComponent;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var campaign = ownProps.campaign;
  return {
    mode: campaign.mode
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onEdit: function onEdit(mode) {
      return dispatch((0, _campaign.campaignUpdate)({ mode: mode }));
    }
  };
};

var ModeStep = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ModeStepComponent);

exports.default = ModeStep;

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reactRedux = __webpack_require__(18);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _campaign = __webpack_require__(19);

var _TimeZoneDropdown = __webpack_require__(658);

var _TimeZoneDropdown2 = _interopRequireDefault(_TimeZoneDropdown);

var _TextFields = __webpack_require__(47);

var _TextFields2 = _interopRequireDefault(_TextFields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MonitoringSettingsComponent = function (_Component) {
  _inherits(MonitoringSettingsComponent, _Component);

  function MonitoringSettingsComponent() {
    _classCallCheck(this, MonitoringSettingsComponent);

    return _possibleConstructorReturn(this, (MonitoringSettingsComponent.__proto__ || Object.getPrototypeOf(MonitoringSettingsComponent)).apply(this, arguments));
  }

  _createClass(MonitoringSettingsComponent, [{
    key: 'intervalDescriptionCopy',
    value: function intervalDescriptionCopy(mode) {
      var copy = 'calls and call times';
      if (mode === 'chat') {
        copy = 'chat and chat times';
      }

      return copy;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var campaign = this.props.campaign;


      return _react2.default.createElement(
        'section',
        { id: 'monitoring', className: 'full-height' },
        _react2.default.createElement(
          'div',
          { className: 'md-grid' },
          _react2.default.createElement(
            'div',
            { className: 'md-cell md-cell--12' },
            _react2.default.createElement(
              'h1',
              null,
              'Set up monitoring settings'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Define the number of days on which care subjects will be monitored, the interval between ',
              this.intervalDescriptionCopy(campaign.mode),
              '.'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'md-grid' },
          _react2.default.createElement(
            'div',
            { className: 'md-cell md-cell--12' },
            _react2.default.createElement(_TimeZoneDropdown2.default, {
              selected: campaign.timezone || '',
              onEdit: this.props.onEditTimezone
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'md-grid' },
          _react2.default.createElement(
            'div',
            { className: 'md-cell md-cell--3' },
            _react2.default.createElement(_TextFields2.default, {
              label: 'Duration',
              id: 'monitor-duration',
              defaultValue: campaign.monitorDuration || '',
              type: 'number',
              min: 0,
              step: 1,
              onBlur: function onBlur(e) {
                return _this2.props.onEditMonitorDuration(e.target.value);
              },
              rightIcon: _react2.default.createElement(
                'span',
                null,
                'days'
              )
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'md-grid' },
          _react2.default.createElement(
            'div',
            { className: 'md-cell md-cell--12' },
            this.props.children
          )
        )
      );
    }
  }]);

  return MonitoringSettingsComponent;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    campaign: ownProps.campaign
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onEditTimezone: function onEditTimezone(timezone) {
      return dispatch((0, _campaign.campaignUpdate)({ timezone: timezone }));
    },
    onEditMonitorDuration: function onEditMonitorDuration(monitorDuration) {
      return dispatch((0, _campaign.campaignUpdate)({ monitorDuration: Number.parseInt(monitorDuration) || null }));
    }
  };
};

var MonitoringSettingsStep = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MonitoringSettingsComponent);

exports.default = MonitoringSettingsStep;

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reactRedux = __webpack_require__(18);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _symptoms = __webpack_require__(289);

var _campaign = __webpack_require__(19);

var _SelectFields = __webpack_require__(259);

var _SelectFields2 = _interopRequireDefault(_SelectFields);

var _TextField = __webpack_require__(640);

var _TextField2 = _interopRequireDefault(_TextField);

var _Button = __webpack_require__(11);

var _Button2 = _interopRequireDefault(_Button);

var _List = __webpack_require__(45);

var _List2 = _interopRequireDefault(_List);

var _ListItem = __webpack_require__(63);

var _ListItem2 = _interopRequireDefault(_ListItem);

var _EditableTitleLabel = __webpack_require__(292);

var _EditableTitleLabel2 = _interopRequireDefault(_EditableTitleLabel);

var _FontIcons = __webpack_require__(36);

var _FontIcons2 = _interopRequireDefault(_FontIcons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SymptomStepComponent = function (_Component) {
  _inherits(SymptomStepComponent, _Component);

  function SymptomStepComponent() {
    _classCallCheck(this, SymptomStepComponent);

    return _possibleConstructorReturn(this, (SymptomStepComponent.__proto__ || Object.getPrototypeOf(SymptomStepComponent)).apply(this, arguments));
  }

  _createClass(SymptomStepComponent, [{
    key: 'symptomsCopy',
    value: function symptomsCopy(mode) {
      var copy = 'upload audio';
      if (mode === 'chat') {
        copy = 'enter texts';
      }
      return 'The symptoms will be used to evaluate positive cases of the disease and send alerts to responders. Later you will be asked to ' + copy + ' explaining how to evaluate these symptoms.';
    }
  }, {
    key: 'forwardConditionCopy',
    value: function forwardConditionCopy(mode, option) {
      var action = 'Forward call';
      var condition = 'any symptom is';

      if (mode === 'chat') {
        action = 'Contact responder';
      }

      if (option === 'all') {
        condition = 'all symptoms are';
      }

      return { value: option, label: action + ' if ' + condition + ' positive' };
    }
  }, {
    key: 'forwardAddressLabel',
    value: function forwardAddressLabel(mode) {
      if (mode === 'chat') {
        return 'Contact email address';
      } else {
        return 'Forward number';
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var campaign = this.props.campaign;


      return _react2.default.createElement(
        'section',
        { id: 'symptoms', className: 'full-height' },
        _react2.default.createElement(
          'div',
          { className: 'md-grid' },
          _react2.default.createElement(
            'div',
            { className: 'md-cell md-cell--12' },
            _react2.default.createElement(
              'h1',
              null,
              'Define the symptoms'
            ),
            _react2.default.createElement(
              'p',
              null,
              this.symptomsCopy(campaign.mode)
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'md-grid' },
          _react2.default.createElement(_SelectFields2.default, {
            id: 'forwarding-condition',
            menuItems: [this.forwardConditionCopy(campaign.mode, 'any'), this.forwardConditionCopy(campaign.mode, 'all')],
            className: 'md-cell md-cell--8  md-cell--bottom',
            value: campaign.forwardingCondition || 'any',
            onChange: function onChange(val) {
              return _this2.props.onEditForwarding('forwardingCondition', val);
            }
          }),
          _react2.default.createElement(_TextField2.default, {
            id: 'forwarding-address',
            label: this.forwardAddressLabel(campaign.mode),
            className: 'md-cell md-cell--4',
            defaultValue: campaign.forwardingAddress || '',
            onSubmit: function onSubmit(val) {
              return _this2.props.onEditForwarding('forwardingAddress', val);
            }
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'md-grid' },
          _react2.default.createElement(
            _List2.default,
            { className: 'md-cell md-cell--12' },
            campaign.symptoms.map(function (_ref, i) {
              var _ref2 = _slicedToArray(_ref, 2),
                  id = _ref2[0],
                  name = _ref2[1];

              return _react2.default.createElement(_ListItem2.default, {
                key: id,
                rightIcon: _react2.default.createElement(
                  _FontIcons2.default,
                  { onClick: function onClick() {
                      return _this2.props.onRemove(i);
                    } },
                  'remove_circle'
                ),
                primaryText: _react2.default.createElement(_EditableTitleLabel2.default, {
                  title: name,
                  emptyText: 'Insert symptom',
                  readOnly: false,
                  onSubmit: function onSubmit(title) {
                    return _this2.props.onEdit(title, i);
                  },
                  hideEditingIcon: true })
              });
            })
          ),
          _react2.default.createElement(
            _Button2.default,
            { flat: true, label: 'Add symptom', className: 'btn-add-grey', onClick: this.props.onAdd },
            'add'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'md-grid' },
          _react2.default.createElement(
            'div',
            { className: 'md-cell md-cell--12' },
            this.props.children
          )
        )
      );
    }
  }]);

  return SymptomStepComponent;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    campaign: ownProps.campaign
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onAdd: function onAdd() {
      return dispatch((0, _symptoms.addEmptySymptom)());
    },
    onEdit: function onEdit(symptom, index) {
      return dispatch((0, _symptoms.editSymptom)(symptom, index));
    },
    onRemove: function onRemove(index) {
      return dispatch((0, _symptoms.removeSymptom)(index));
    },
    onEditForwarding: function onEditForwarding(key, value) {
      return dispatch((0, _campaign.campaignUpdate)(_defineProperty({}, key, value)));
    }
  };
};

var SymptomStep = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SymptomStepComponent);

exports.default = SymptomStep;

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reactRedux = __webpack_require__(18);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _values = __webpack_require__(146);

var _values2 = _interopRequireDefault(_values);

var _flatten = __webpack_require__(220);

var _flatten2 = _interopRequireDefault(_flatten);

var _capitalize = __webpack_require__(404);

var _capitalize2 = _interopRequireDefault(_capitalize);

var _campaign = __webpack_require__(170);

var _audios = __webpack_require__(630);

var _langs = __webpack_require__(168);

var _FontIcons = __webpack_require__(36);

var _FontIcons2 = _interopRequireDefault(_FontIcons);

var _Tabs = __webpack_require__(264);

var _Tabs2 = _interopRequireDefault(_Tabs);

var _Tab = __webpack_require__(263);

var _Tab2 = _interopRequireDefault(_Tab);

var _TabsContainer = __webpack_require__(265);

var _TabsContainer2 = _interopRequireDefault(_TabsContainer);

var _AudioPicker = __webpack_require__(634);

var _AudioPicker2 = _interopRequireDefault(_AudioPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AudiosUploadedCounter = function AudiosUploadedCounter(_ref) {
  var uploaded = _ref.uploaded,
      total = _ref.total;
  return _react2.default.createElement(
    'div',
    { className: 'md-cell md-cell--12' },
    _react2.default.createElement(
      'h3',
      { className: 'uploaded-files' },
      _react2.default.createElement(
        _FontIcons2.default,
        null,
        'volume_up'
      ),
      uploaded,
      '/',
      total,
      ' audio files uploaded'
    )
  );
};

AudiosUploadedCounter.propTypes = {
  uploaded: _propTypes2.default.number.isRequired,
  total: _propTypes2.default.number.isRequired
};

var UploadAudioStepComponent = function (_Component) {
  _inherits(UploadAudioStepComponent, _Component);

  function UploadAudioStepComponent() {
    _classCallCheck(this, UploadAudioStepComponent);

    return _possibleConstructorReturn(this, (UploadAudioStepComponent.__proto__ || Object.getPrototypeOf(UploadAudioStepComponent)).apply(this, arguments));
  }

  _createClass(UploadAudioStepComponent, [{
    key: 'getTopicTexts',
    value: function getTopicTexts(topic) {
      if (topic == 'welcome') {
        return { title: 'Welcome message', description: 'Present the objectives of this call' };
      } else if (topic == 'identify') {
        return { title: 'Identify message', description: 'Ask subject to dial their ID or to press # if they do not have one' };
      } else if (topic == 'registration') {
        return { title: 'Registration message', description: 'Inform the caller the call will be forwarded to an agent for registration' };
      } else if (topic == 'forward') {
        return { title: 'Forward call message', description: 'Explain that the current call will be forwarded to an agent due to positive symptoms' };
      } else if (topic == 'educational') {
        return { title: 'Educational information', description: 'Inform the caller about additional information such as prevention measures' };
      } else if (topic == 'additional_information_intro') {
        return { title: 'Additional information introduction', description: 'Ask the caller whether they want to listen to educational information: 1 for Yes, 3 for No' };
      } else if (topic == 'thanks') {
        return { title: 'Thank you message', description: 'Thank the caller for participating' };
      } else if (topic == 'language') {
        var description = this.props.langs.map(function (iso, i) {
          var countryName = (0, _langs.codeToName)(iso) || 'unknown country';
          return i + 1 + ' for ' + countryName;
        }).join(', ');
        return { title: 'Language options', description: 'List the options: ' + description };
      } else if (topic.startsWith('symptom:')) {
        var id = topic.split(':', 2)[1];
        var matchingSymptom = this.props.symptoms.find(function (_ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
              _id = _ref3[0],
              _name = _ref3[1];

          return id == _id;
        });

        if (Array.isArray(matchingSymptom)) {
          return { title: (0, _capitalize2.default)(matchingSymptom[1]) + ' symptom question', description: 'Ask if there are any signs of this symptom: 1 for Yes, 3 for No' };
        } else {
          throw new Error('Malformed symptom list');
        }
      } else {
        throw new Error('Unexpected topic: ' + topic);
      }
    }
  }, {
    key: 'renderLangTab',
    value: function renderLangTab(lang) {
      var _this2 = this;

      var _props = this.props,
          neededMessages = _props.neededMessages,
          messages = _props.messages,
          onUploadAudio = _props.onUploadAudio,
          onRemoveAudio = _props.onRemoveAudio;


      return _react2.default.createElement(
        _Tab2.default,
        { label: (0, _langs.codeToName)(lang), key: lang },
        neededMessages[lang].map(function (topic) {
          return _react2.default.createElement(_AudioPicker2.default, _extends({
            file: (0, _campaign.getAudioFileFor)(messages, topic, lang),
            onUpload: function onUpload(file) {
              return onUploadAudio(file, topic, lang);
            },
            onRemove: function onRemove() {
              return onRemoveAudio(topic, lang);
            },
            key: topic
          }, _this2.getTopicTexts(topic)));
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          neededMessages = _props2.neededMessages,
          messages = _props2.messages;


      var totalAudios = (0, _flatten2.default)((0, _values2.default)(neededMessages)).length + 1;

      return _react2.default.createElement(
        'section',
        { id: 'audios', className: 'full-height' },
        _react2.default.createElement(
          'div',
          { className: 'md-grid' },
          _react2.default.createElement(
            'div',
            { className: 'md-cell md-cell--12' },
            _react2.default.createElement(
              'h1',
              null,
              'Upload audio files'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Upload an audio file for each message. After that you will be able to test the call flow.'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'md-grid' },
          _react2.default.createElement(AudiosUploadedCounter, { uploaded: messages.length, total: totalAudios })
        ),
        _react2.default.createElement(
          'div',
          { className: 'md-grid' },
          _react2.default.createElement(
            'div',
            { className: 'md-cell md-cell--12' },
            _react2.default.createElement(_AudioPicker2.default, _extends({
              onUpload: function onUpload(file) {
                return _this3.props.onUploadAudio(file, 'language');
              },
              onRemove: function onRemove() {
                return _this3.props.onRemoveAudio('language');
              },
              file: (0, _campaign.getAudioFileFor)(this.props.messages, 'language')
            }, this.getTopicTexts('language')))
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'md-grid' },
          _react2.default.createElement(
            'div',
            { className: 'md-cell md-cell--12' },
            _react2.default.createElement(
              _TabsContainer2.default,
              { component: 'div', panelClassName: 'md-grid' },
              _react2.default.createElement(
                _Tabs2.default,
                { tabId: 'langs' },
                this.props.langs.filter(function (lang) {
                  return lang && lang != '';
                }).map(function (lang) {
                  return _this3.renderLangTab(lang);
                })
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'md-grid' },
          _react2.default.createElement(
            'div',
            { className: 'md-cell md-cell--12' },
            this.props.children
          )
        )
      );
    }
  }]);

  return UploadAudioStepComponent;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var campaign = ownProps.campaign;
  return {
    messages: (0, _campaign.messagesInUse)(campaign),
    neededMessages: (0, _campaign.neededMessages)(campaign),
    symptoms: campaign.symptoms,
    langs: campaign.langs || []
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onUploadAudio: function onUploadAudio(file, topic, language) {
      return dispatch((0, _audios.uploadCampaignAudio)(file, topic, language));
    },
    onRemoveAudio: function onRemoveAudio(topic, language) {
      return dispatch((0, _audios.removeCampaignAudio)(topic, language));
    }
  };
};

var UploadAudioStep = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UploadAudioStepComponent);

exports.default = UploadAudioStep;

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _TextFields = __webpack_require__(47);

var _TextFields2 = _interopRequireDefault(_TextFields);

var _Buttons = __webpack_require__(242);

var _Buttons2 = _interopRequireDefault(_Buttons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SubjectForm = function (_Component) {
  _inherits(SubjectForm, _Component);

  function SubjectForm() {
    _classCallCheck(this, SubjectForm);

    return _possibleConstructorReturn(this, (SubjectForm.__proto__ || Object.getPrototypeOf(SubjectForm)).apply(this, arguments));
  }

  _createClass(SubjectForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          subject = _props.subject,
          onSubmit = _props.onSubmit,
          onCancel = _props.onCancel,
          onEditContactAddress = _props.onEditContactAddress,
          onEditRegistrationIdentifier = _props.onEditRegistrationIdentifier;


      return _react2.default.createElement(
        'section',
        { id: 'subject' },
        _react2.default.createElement(
          'div',
          { className: 'md-grid' },
          _react2.default.createElement(_TextFields2.default, {
            id: 'registration-identifier',
            label: 'ID',
            className: 'md-cell md-cell--12',
            defaultValue: subject.registrationIdentifier || '',
            onBlur: function onBlur(e) {
              return onEditRegistrationIdentifier(e.target.value);
            }
          }),
          _react2.default.createElement(_TextFields2.default, {
            id: 'contact-address',
            label: 'Contact Address',
            className: 'md-cell md-cell--12',
            defaultValue: subject.contactAddress || '',
            onBlur: function onBlur(e) {
              return onEditContactAddress(e.target.value);
            }
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'md-grid' },
          _react2.default.createElement(_Buttons2.default, { primary: true, className: 'md-cell', onClick: onSubmit, raised: true, label: 'Save' }),
          _react2.default.createElement(_Buttons2.default, { secondary: true, className: 'md-cell', onClick: onCancel, flat: true, label: 'Cancel' })
        )
      );
    }
  }]);

  return SubjectForm;
}(_react.Component);

exports.default = SubjectForm;

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _redux = __webpack_require__(67);

var _reactRedux = __webpack_require__(18);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(604);

var _Card = __webpack_require__(152);

var _Card2 = _interopRequireDefault(_Card);

var _DataTable = __webpack_require__(243);

var _DataTable2 = _interopRequireDefault(_DataTable);

var _TableHeader = __webpack_require__(245);

var _TableHeader2 = _interopRequireDefault(_TableHeader);

var _TableBody = __webpack_require__(244);

var _TableBody2 = _interopRequireDefault(_TableBody);

var _TablePagination = __webpack_require__(557);

var _TablePagination2 = _interopRequireDefault(_TablePagination);

var _TableRow = __webpack_require__(246);

var _TableRow2 = _interopRequireDefault(_TableRow);

var _TableColumn = __webpack_require__(114);

var _TableColumn2 = _interopRequireDefault(_TableColumn);

var _Dialogs = __webpack_require__(249);

var _Dialogs2 = _interopRequireDefault(_Dialogs);

var _CircularProgress = __webpack_require__(570);

var _CircularProgress2 = _interopRequireDefault(_CircularProgress);

var _Button = __webpack_require__(11);

var _Button2 = _interopRequireDefault(_Button);

var _reactMoment = __webpack_require__(1210);

var _reactMoment2 = _interopRequireDefault(_reactMoment);

var _subjects = __webpack_require__(288);

var collectionActions = _interopRequireWildcard(_subjects);

var _subject = __webpack_require__(287);

var itemActions = _interopRequireWildcard(_subject);

var _campaign = __webpack_require__(19);

var campaignActions = _interopRequireWildcard(_campaign);

var _EmptyListing = __webpack_require__(293);

var _EmptyListing2 = _interopRequireDefault(_EmptyListing);

var _SubjectForm = __webpack_require__(656);

var _SubjectForm2 = _interopRequireDefault(_SubjectForm);

var _ActiveCampaignSubNav = __webpack_require__(291);

var _ActiveCampaignSubNav2 = _interopRequireDefault(_ActiveCampaignSubNav);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SubjectsList = function (_Component) {
  _inherits(SubjectsList, _Component);

  function SubjectsList() {
    _classCallCheck(this, SubjectsList);

    return _possibleConstructorReturn(this, (SubjectsList.__proto__ || Object.getPrototypeOf(SubjectsList)).apply(this, arguments));
  }

  _createClass(SubjectsList, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var subjects = this.props.items || [];
      var campaignMode = this.props.campaignMode;


      if (subjects.length == 0) {
        return _react2.default.createElement(
          _EmptyListing2.default,
          { image: '/images/person.svg' },
          _react2.default.createElement(
            'h5',
            null,
            'You have no subjects on this campaign'
          ),
          _react2.default.createElement(
            _reactRouterDom.NavLink,
            { to: '#', onClick: this.props.showSubjectForm },
            'Add subject'
          )
        );
      }

      var actionTitle = '';
      if (campaignMode === 'call') {
        actionTitle = 'Call';
      } else if (campaignMode === 'chat') {
        actionTitle = 'Message';
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _Button2.default,
          { flat: true, primary: true, label: 'Export CSV', onClick: this.props.exportCsv },
          'file_download'
        ),
        _react2.default.createElement(
          'div',
          { className: 'md-cell md-cell--12' },
          _react2.default.createElement(
            _Card2.default,
            { tableCard: true },
            _react2.default.createElement(
              _DataTable2.default,
              { plain: true, className: 'app-listing', baseId: 'subjects' },
              _react2.default.createElement(
                _TableHeader2.default,
                null,
                _react2.default.createElement(
                  _TableRow2.default,
                  null,
                  _react2.default.createElement(
                    _TableColumn2.default,
                    null,
                    'ID'
                  ),
                  _react2.default.createElement(
                    _TableColumn2.default,
                    null,
                    'Contact Address'
                  ),
                  _react2.default.createElement(
                    _TableColumn2.default,
                    null,
                    'Enroll Date'
                  ),
                  _react2.default.createElement(
                    _TableColumn2.default,
                    null,
                    'First ' + actionTitle
                  ),
                  _react2.default.createElement(
                    _TableColumn2.default,
                    null,
                    'Last ' + actionTitle
                  ),
                  _react2.default.createElement(
                    _TableColumn2.default,
                    null,
                    'Last Successful ' + actionTitle
                  ),
                  _react2.default.createElement(
                    _TableColumn2.default,
                    null,
                    'Active?'
                  )
                )
              ),
              _react2.default.createElement(
                _TableBody2.default,
                null,
                subjects.map(function (s) {
                  return _react2.default.createElement(SubjectItem, { key: s.id, subject: s, onClick: _this2.props.onSubjectClick });
                })
              ),
              _react2.default.createElement(_TablePagination2.default, {
                rows: this.props.count,
                rowsPerPage: this.props.rowsPerPage,
                rowsPerPageItems: [this.props.rowsPerPage],
                rowsPerPageLabel: '',
                page: this.props.currentPage || 1,
                onPagination: function onPagination(start, limit) {
                  return _this2.handlePagination(start, limit);
                }
              })
            )
          )
        )
      );
    }
  }, {
    key: 'handlePagination',
    value: function handlePagination(start, limit) {
      var page = start / limit + 1;
      this.props.onPageChange(page);
    }
  }]);

  return SubjectsList;
}(_react.Component);

var FormatDate = function (_Component2) {
  _inherits(FormatDate, _Component2);

  function FormatDate() {
    _classCallCheck(this, FormatDate);

    return _possibleConstructorReturn(this, (FormatDate.__proto__ || Object.getPrototypeOf(FormatDate)).apply(this, arguments));
  }

  _createClass(FormatDate, [{
    key: 'render',
    value: function render() {
      var date = this.props.date;

      if (date !== null) {
        return _react2.default.createElement(_reactMoment2.default, { format: 'MMM DD, YYYY HH:mm', date: date });
      } else {
        return _react2.default.createElement(
          'span',
          null,
          '-'
        );
      }
    }
  }]);

  return FormatDate;
}(_react.Component);

var SubjectItem = function (_Component3) {
  _inherits(SubjectItem, _Component3);

  function SubjectItem() {
    _classCallCheck(this, SubjectItem);

    return _possibleConstructorReturn(this, (SubjectItem.__proto__ || Object.getPrototypeOf(SubjectItem)).apply(this, arguments));
  }

  _createClass(SubjectItem, [{
    key: 'render',
    value: function render() {
      var _this5 = this;

      var subject = this.props.subject;
      return _react2.default.createElement(
        _TableRow2.default,
        { onClick: function onClick() {
            return _this5.props.onClick(subject);
          } },
        _react2.default.createElement(
          _TableColumn2.default,
          null,
          subject.registrationIdentifier
        ),
        _react2.default.createElement(
          _TableColumn2.default,
          null,
          subject.contactAddress
        ),
        _react2.default.createElement(
          _TableColumn2.default,
          null,
          _react2.default.createElement(FormatDate, { date: subject.enrollDate })
        ),
        _react2.default.createElement(
          _TableColumn2.default,
          null,
          _react2.default.createElement(FormatDate, { date: subject.firstCallDate })
        ),
        _react2.default.createElement(
          _TableColumn2.default,
          null,
          _react2.default.createElement(FormatDate, { date: subject.lastCallDate })
        ),
        _react2.default.createElement(
          _TableColumn2.default,
          null,
          _react2.default.createElement(FormatDate, { date: subject.lastSuccessfulCallDate })
        ),
        _react2.default.createElement(
          _TableColumn2.default,
          null,
          subject.activeCase ? 'Yes' : 'No'
        )
      );
    }
  }]);

  return SubjectItem;
}(_react.Component);

var Subjects = function (_Component4) {
  _inherits(Subjects, _Component4);

  function Subjects() {
    var _ref;

    var _temp, _this6, _ret;

    _classCallCheck(this, Subjects);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this6 = _possibleConstructorReturn(this, (_ref = Subjects.__proto__ || Object.getPrototypeOf(Subjects)).call.apply(_ref, [this].concat(args))), _this6), _this6.onEditContactAddress = function (value) {
      return _this6.onEditField('contactAddress', value);
    }, _this6.onEditRegistrationIdentifier = function (value) {
      return _this6.onEditField('registrationIdentifier', value);
    }, _temp), _possibleConstructorReturn(_this6, _ret);
  }

  _createClass(Subjects, [{
    key: 'closeSubjectFormModal',
    value: function closeSubjectFormModal() {
      this.props.itemActions.editingSubjectCancel();
    }
  }, {
    key: 'showSubjectForm',
    value: function showSubjectForm() {
      this.props.itemActions.editSubject({ contactAddress: '', registrationIdentifier: '' });
    }
  }, {
    key: 'onEditField',
    value: function onEditField(fieldName, value) {
      this.props.itemActions.subjectEditing(fieldName, value);
    }
  }, {
    key: 'goToPage',
    value: function goToPage(targetPage) {
      this.props.collectionActions.changeTargetPage(targetPage);
    }
  }, {
    key: 'fetchTargetPage',
    value: function fetchTargetPage() {
      var _props$subjects = this.props.subjects,
          limit = _props$subjects.limit,
          targetPage = _props$subjects.targetPage;

      this.props.collectionActions.fetchSubjects(this.props.campaignId, limit, targetPage);
    }
  }, {
    key: 'exportCsv',
    value: function exportCsv() {
      window.location.href = '/api/v1/campaigns/' + this.props.campaignId + '/subjects/export';
    }
  }, {
    key: 'createSubject',
    value: function createSubject() {
      if (this.props.subjects.editingSubject != null) {
        this.props.itemActions.createSubject(this.props.campaignId, this.props.subjects.editingSubject);
      } else {
        throw new Error("You can't create without editing a Subject");
      }
    }
  }, {
    key: 'updateSubject',
    value: function updateSubject() {
      if (this.props.subjects.editingSubject != null) {
        this.props.itemActions.updateSubject(this.props.campaignId, this.props.subjects.editingSubject);
      } else {
        throw new Error("You can't update without editing a Subject");
      }
    }
  }, {
    key: 'editSubject',
    value: function editSubject(subject) {
      this.props.itemActions.editSubject(subject); // Subject should work with SubjectParams due compatibility
    }
  }, {
    key: 'pageTitle',
    value: function pageTitle() {
      return 'Subjects!';
    }
  }, {
    key: 'subjectForm',
    value: function subjectForm(editingSubject) {
      var _this7 = this;

      return _react2.default.createElement(_SubjectForm2.default, {
        onSubmit: function onSubmit() {
          return editingSubject.id ? _this7.updateSubject() : _this7.createSubject();
        },
        onCancel: function onCancel() {
          return _this7.closeSubjectFormModal();
        },
        subject: editingSubject,
        onEditContactAddress: this.onEditContactAddress,
        onEditRegistrationIdentifier: this.onEditRegistrationIdentifier });
    }
  }, {
    key: 'circularProgress',
    value: function circularProgress() {
      return _react2.default.createElement(_CircularProgress2.default, { id: 'subjects-fetching-progress' });
    }
  }, {
    key: 'subjectsList',
    value: function subjectsList(campaignMode) {
      var _this8 = this;

      var _props$subjects2 = this.props.subjects,
          page = _props$subjects2.page,
          items = _props$subjects2.items,
          limit = _props$subjects2.limit,
          fetching = _props$subjects2.fetching,
          count = _props$subjects2.count;


      return _react2.default.createElement(SubjectsList, {
        items: items,
        campaignMode: campaignMode,
        count: count,
        fetching: fetching,
        currentPage: page,
        rowsPerPage: limit,
        showSubjectForm: function showSubjectForm() {
          return _this8.showSubjectForm();
        },
        exportCsv: function exportCsv() {
          return _this8.exportCsv();
        },
        onSubjectClick: function onSubjectClick(subject) {
          return _this8.editSubject(subject);
        },
        onPageChange: function onPageChange(targetPage) {
          return _this8.goToPage(targetPage);
        }
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var _props$subjects3 = this.props.subjects,
          page = _props$subjects3.page,
          targetPage = _props$subjects3.targetPage,
          fetching = _props$subjects3.fetching;

      if (page != targetPage && !fetching) {
        this.fetchTargetPage();
      }

      if (!this.props.campaign.data && !this.props.campaign.fetching) {
        this.props.campaignActions.campaignFetch(this.props.campaignId);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchTargetPage();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this9 = this;

      var _props$subjects4 = this.props.subjects,
          editingSubject = _props$subjects4.editingSubject,
          fetching = _props$subjects4.fetching;


      var campaign = this.props.campaign.data;

      var showDialog = editingSubject != null;
      var subjectForm = null;
      if (editingSubject != null) {
        subjectForm = this.subjectForm(editingSubject);
      }
      var tableOrLoadingIndicator = fetching || !campaign ? this.circularProgress() : this.subjectsList(campaign.mode);

      return _react2.default.createElement(
        'div',
        { className: 'md-grid--no-spacing' },
        _react2.default.createElement(_ActiveCampaignSubNav2.default, {
          title: campaign && campaign.name ? campaign.name : '',
          addButtonHandler: function addButtonHandler() {
            return _this9.showSubjectForm();
          },
          campaignId: this.props.campaignId
        }),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'md-grid' },
            tableOrLoadingIndicator,
            _react2.default.createElement(
              _Dialogs2.default,
              { id: 'subject-form', visible: showDialog, onHide: function onHide() {
                  return _this9.closeSubjectFormModal();
                }, title: 'Manage Subject' },
              subjectForm
            )
          )
        )
      );
    }
  }]);

  return Subjects;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    campaignId: parseInt(ownProps.match.params.campaignId),
    campaign: state.campaign,
    subjects: state.subjects
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    collectionActions: (0, _redux.bindActionCreators)(collectionActions, dispatch),
    itemActions: (0, _redux.bindActionCreators)(itemActions, dispatch),
    campaignActions: (0, _redux.bindActionCreators)(campaignActions, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Subjects);

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _timezones = __webpack_require__(290);

var _util = __webpack_require__(659);

var _SelectFields = __webpack_require__(259);

var _SelectFields2 = _interopRequireDefault(_SelectFields);

var _reactRedux = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TimezoneDropdown = function (_Component) {
  _inherits(TimezoneDropdown, _Component);

  function TimezoneDropdown() {
    _classCallCheck(this, TimezoneDropdown);

    return _possibleConstructorReturn(this, (TimezoneDropdown.__proto__ || Object.getPrototypeOf(TimezoneDropdown)).apply(this, arguments));
  }

  _createClass(TimezoneDropdown, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var dispatch = this.props.dispatch;

      dispatch((0, _timezones.fetchTimezones)());
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          timezones = _props.timezones,
          selected = _props.selected,
          onEdit = _props.onEdit,
          readOnly = _props.readOnly;


      if (!timezones || !timezones.items) {
        return _react2.default.createElement(
          'div',
          null,
          'Loading timezones...'
        );
      }

      var timezonesWithFormat = timezones.items.map(function (timezone) {
        return { value: timezone, label: (0, _util.formatTimezone)(timezone) };
      });

      return _react2.default.createElement(_SelectFields2.default, {
        id: 'timezone',
        label: 'Timezone',
        menuItems: timezonesWithFormat,
        className: 'md-cell md-cell--8  md-cell--bottom',
        value: selected,
        onChange: onEdit,
        readOnly: readOnly
      });
    }
  }]);

  return TimezoneDropdown;
}(_react.Component);

TimezoneDropdown.propTypes = {
  dispatch: _propTypes2.default.func.isRequired,
  timezones: _propTypes2.default.object,
  selected: _propTypes2.default.string,
  onEdit: _propTypes2.default.func,
  readOnly: _propTypes2.default.bool
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    timezones: state.timezones
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(TimezoneDropdown);

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var formatTimezone = exports.formatTimezone = function formatTimezone(tz) {
  var split = (tz || 'UTC').replace('_', ' ').split('/');
  switch (split.length) {
    case 2:
      return split[0] + ' - ' + split[1];
    case 3:
      return split[0] + ' - ' + split[2] + ', ' + split[1];
    default:
      return split[0];
  }
};

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newSession = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _queryString = __webpack_require__(1027);

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GuissoSession = function () {
  function GuissoSession(config) {
    _classCallCheck(this, GuissoSession);

    this.config = config;
  }

  _createClass(GuissoSession, [{
    key: 'isPopupOpen',
    value: function isPopupOpen() {
      return this.popup && !this.popup.closed;
    }
  }, {
    key: 'showPopup',
    value: function showPopup(url) {
      if (this.popup) {
        this.popup.location = url;
      } else {
        this.popup = window.open(url, '_blank', 'chrome=yes,centerscreen=yes,width=600,height=400');
        window.the_guisso_popup = this.popup;
      }
      return this.popup;
    }
  }, {
    key: 'close',
    value: function close() {
      if (this.popup) {
        this.popup.close();
        this.popup = null;
      }
    }
  }, {
    key: 'authorize',
    value: function authorize(responseType) {
      var _this = this;

      var provider = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var baseUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return new Promise(function (resolve, reject) {
        var state = provider && baseUrl ? provider + '|' + baseUrl : null;
        var authorizeUrl = _this.config.baseUrl + '/oauth2/authorize' + '?client_id=' + _this.config.clientId + '&scope=' + encodeURIComponent('app=' + _this.config.appId) + '&state=' + state + '&response_type=' + responseType + '&redirect_uri=' + encodeURIComponent(window.location.origin + '/oauth_client/callback');

        var popup = _this.showPopup(authorizeUrl);
        var watchdog = window.setInterval(function () {
          if (popup.closed) {
            reject(new Error('Popup closed before approval'));
          }
        }, 100);
        var listener = function listener(event) {
          if (event.source == popup) {
            window.removeEventListener('message', listener);
            window.clearInterval(watchdog);
            if (event.data.error && event.data.error.length > 0) {
              console.log(event.data);
              reject(event.data.error);
            } else {
              var token = _queryString2.default.parse(event.data);
              resolve(token);
            }
          }
        };
        window.addEventListener('message', listener, false);
      });
    }
  }]);

  return GuissoSession;
}();

var newSession = exports.newSession = function newSession(config) {
  return new GuissoSession(config);
};

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _authorizations = __webpack_require__(284);

var actions = _interopRequireWildcard(_authorizations);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var initialState = {
  fetching: false,
  items: null,
  synchronizing: false
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case actions.FETCH_AUTHORIZATIONS:
      return fetchAuthorizations(state);
    case actions.RECEIVE_AUTHORIZATIONS:
      return receiveAuthorizations(state, action);
    case actions.DELETE_AUTHORIZATION:
      return deleteAuthorization(state, action);
    case actions.ADD_AUTHORIZATION:
      return addAuthorization(state, action);
    case actions.BEGIN_SYNCHRONIZATION:
      return beginSynchronization(state);
    case actions.END_SYNCHRONIZATION:
      return endSynchronization(state);
    default:
      return state;
  }
};

var fetchAuthorizations = function fetchAuthorizations(state) {
  return _extends({}, state, {
    fetching: true
  });
};

var receiveAuthorizations = function receiveAuthorizations(state, action) {
  return _extends({}, state, {
    fetching: false,
    items: action.authorizations
  });
};

var deleteAuthorization = function deleteAuthorization(state, action) {
  var index = state.items.findIndex(function (item) {
    return item.provider == action.provider && item.baseUrl == action.baseUrl;
  });

  if (index == -1) {
    return state;
  }

  return _extends({}, state, {
    items: [].concat(_toConsumableArray(state.items.slice(0, index)), _toConsumableArray(state.items.slice(index + 1)))
  });
};

var addAuthorization = function addAuthorization(state, action) {
  var index = state.items.findIndex(function (item) {
    return item.provider == action.provider && item.baseUrl == action.baseUrl;
  });
  if (index != -1) {
    return state;
  }

  return _extends({}, state, {
    items: [].concat(_toConsumableArray(state.items), [{
      provider: action.provider,
      baseUrl: action.baseUrl
    }])
  });
};

var beginSynchronization = function beginSynchronization(state) {
  return _extends({}, state, {
    synchronizing: true
  });
};

var endSynchronization = function endSynchronization(state) {
  return _extends({}, state, {
    synchronizing: false
  });
};

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _campaign = __webpack_require__(19);

var actions = _interopRequireWildcard(_campaign);

var _symptoms = __webpack_require__(289);

var symptomActions = _interopRequireWildcard(_symptoms);

var _langs = __webpack_require__(285);

var languageActions = _interopRequireWildcard(_langs);

var _v = __webpack_require__(1322);

var _v2 = _interopRequireDefault(_v);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var initialState = {
  fetching: false,
  campaignId: null,
  data: null
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case actions.CAMPAIGN_CLEAR:
      return campaignClear(state, action);
    case actions.CAMPAIGN_CREATED:
      return campaignLoaded(state, action);
    case actions.CAMPAIGN_FETCH:
      return campaignFetch(state, action);
    case actions.CAMPAIGN_FETCHED:
      return campaignLoaded(state, action);
    case actions.CAMPAIGN_UPDATED:
      return campaignLoaded(state, action);
    case symptomActions.EMPTY_SYMPTOM_ADD:
      return addEmptySymptom(state);
    case languageActions.EMPTY_LANG_ADD:
      return addEmptyLang(state);
    case actions.CAMPAIGN_LAUNCH:
      return launchCampaign(state);
    default:
      return state;
  }
};

var campaignClear = function campaignClear(state) {
  return { fetching: false, campaignId: null, data: null };
};

var campaignFetch = function campaignFetch(state, id) {
  return { fetching: true, campaignId: id, data: null };
};

var campaignLoaded = function campaignLoaded(state, _ref) {
  var campaign = _ref.campaign,
      calls = _ref.calls;

  return { fetching: false, campaignId: campaign.id, data: campaign };
};

var addEmptySymptom = function addEmptySymptom(state) {
  var symptoms = state.data.symptoms || [];
  return _extends({}, state, { data: _extends({}, state.data, { symptoms: [].concat(_toConsumableArray(symptoms), [[(0, _v2.default)(), '']]) }) });
};

var addEmptyLang = function addEmptyLang(state) {
  var langs = state.data.langs || [];
  return _extends({}, state, { data: _extends({}, state.data, { langs: [].concat(_toConsumableArray(langs), ['']) }) });
};

var launchCampaign = function launchCampaign(state) {
  return _extends({}, state, { data: _extends({}, state.data, { started_at: new Date() }) });
};

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _channels = __webpack_require__(165);

var actions = _interopRequireWildcard(_channels);

var _collection = __webpack_require__(294);

var _collection2 = _interopRequireDefault(_collection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var itemsReducer = function itemsReducer(state, _) {
  return state;
};

var initialState = {
  fetching: false,
  items: null,
  filter: null,
  order: null,
  sortBy: 'name',
  sortAsc: false,
  page: {
    index: 0,
    size: 5
  }
};

exports.default = (0, _collection2.default)(actions, itemsReducer, _collection.defaultFilterProvider, initialState);

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(67);

var _reactRouterRedux = __webpack_require__(121);

var _campaign = __webpack_require__(662);

var _campaign2 = _interopRequireDefault(_campaign);

var _campaigns = __webpack_require__(169);

var _campaigns2 = _interopRequireDefault(_campaigns);

var _channels = __webpack_require__(663);

var _channels2 = _interopRequireDefault(_channels);

var _authorizations = __webpack_require__(661);

var _authorizations2 = _interopRequireDefault(_authorizations);

var _timezones = __webpack_require__(666);

var _timezones2 = _interopRequireDefault(_timezones);

var _subjects = __webpack_require__(665);

var _subjects2 = _interopRequireDefault(_subjects);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  campaign: _campaign2.default,
  campaigns: _campaigns2.default,
  channels: _channels2.default,
  authorizations: _authorizations2.default,
  timezones: _timezones2.default,
  subjects: _subjects2.default,
  router: _reactRouterRedux.routerReducer
});

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _subjects = __webpack_require__(288);

var actions = _interopRequireWildcard(_subjects);

var _subject = __webpack_require__(287);

var itemActions = _interopRequireWildcard(_subject);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  editingSubject: null,
  fetching: false,
  items: null,
  count: 0,
  filter: null,
  order: null,
  limit: 50,
  page: null,
  targetPage: 1
};

var subjectEdit = function subjectEdit(state, editingSubject) {
  return _extends({}, state, {
    editingSubject: editingSubject
  });
};

var subjectEditing = function subjectEditing(state, fieldName, value) {
  return _extends({}, state, {
    editingSubject: _extends({}, state.editingSubject, _defineProperty({}, fieldName, value))
  });
};

var subjectCreated = function subjectCreated(state, subject) {
  return _extends({}, state, {
    editingSubject: null,
    items: [].concat(_toConsumableArray(state.items), [subject]),
    count: state.count + 1
  });
};

var subjectUpdated = function subjectUpdated(state, subject) {
  var index = state.items.findIndex(function (item) {
    return item.id == subject.id;
  });
  return _extends({}, state, {
    editingSubject: null,
    items: [].concat(_toConsumableArray(state.items.slice(0, index)), [subject], _toConsumableArray(state.items.slice(index + 1)))
  });
};

var receive = function receive(state, items, count, limit, page) {
  return _extends({}, state, {
    fetching: false,
    items: items,
    count: count,
    limit: limit,
    page: page
  });
};

var fetch = function fetch(state) {
  return _extends({}, state, {
    fetching: true
  });
};

var changeTargetPage = function changeTargetPage(state, targetPage) {
  return _extends({}, state, {
    targetPage: targetPage
  });
};

exports.default = function (state, action) {
  switch (action.type) {
    case itemActions.SUBJECT_EDIT:
      return subjectEdit(state, action.subject);
    case itemActions.SUBJECT_EDITING:
      return subjectEditing(state, action.fieldName, action.value);
    case itemActions.SUBJECT_CREATED:
      return subjectCreated(state, action.subject);
    case itemActions.SUBJECT_UPDATED:
      return subjectUpdated(state, action.subject);
    case actions.FETCH:
      return fetch(state);
    case actions.RECEIVE:
      return receive(state, action.items, action.count, action.limit, action.page);
    case actions.CHANGE_TARGET_PAGE:
      return changeTargetPage(state, action.page);
    default:
      return state || initialState;
  }
};

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //  weak


var _timezones = __webpack_require__(290);

var actions = _interopRequireWildcard(_timezones);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = {
  fetching: false,
  items: null
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case actions.FETCH_TIMEZONES:
      return fetchTimezones(state);
    case actions.RECEIVE_TIMEZONES:
      return receiveTimezones(state, action);
    default:
      return state;
  }
};

var fetchTimezones = function fetchTimezones(state) {
  return _extends({}, state, {
    fetching: true
  });
};

var receiveTimezones = function receiveTimezones(state, action) {
  return _extends({}, state, {
    fetching: false,
    items: action.timezones
  });
};

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(681), __esModule: true };

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(682), __esModule: true };

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(683), __esModule: true };

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(684), __esModule: true };

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(685), __esModule: true };

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(686), __esModule: true };

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(668);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(295);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(670);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(667);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(296);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(296);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 679 */
/***/ (function(module, exports) {


module.exports = function chain(){
  var len = arguments.length
  var args = [];

  for (var i = 0; i < len; i++)
    args[i] = arguments[i]

  args = args.filter(function(fn){ return fn != null })

  if (args.length === 0) return undefined
  if (args.length === 1) return args[0]

  return args.reduce(function(current, next){
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  })
}


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(706);
module.exports = __webpack_require__(40).Object.assign;

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(707);
var $Object = __webpack_require__(40).Object;
module.exports = function create(P, D){
  return $Object.create(P, D);
};

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(708);
var $Object = __webpack_require__(40).Object;
module.exports = function defineProperty(it, key, desc){
  return $Object.defineProperty(it, key, desc);
};

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(709);
module.exports = __webpack_require__(40).Object.getPrototypeOf;

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(710);
module.exports = __webpack_require__(40).Object.setPrototypeOf;

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(713);
__webpack_require__(711);
__webpack_require__(714);
__webpack_require__(715);
module.exports = __webpack_require__(40).Symbol;

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(712);
__webpack_require__(716);
module.exports = __webpack_require__(184).f('iterator');

/***/ }),
/* 687 */
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 688 */
/***/ (function(module, exports) {

module.exports = function(){ /* empty */ };

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(55)
  , toLength  = __webpack_require__(704)
  , toIndex   = __webpack_require__(703);
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(90)
  , gOPS    = __webpack_require__(176)
  , pIE     = __webpack_require__(122);
module.exports = function(it){
  var result     = getKeys(it)
    , getSymbols = gOPS.f;
  if(getSymbols){
    var symbols = getSymbols(it)
      , isEnum  = pIE.f
      , i       = 0
      , key;
    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
  } return result;
};

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(49).document && document.documentElement;

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(297);
module.exports = Array.isArray || function isArray(arg){
  return cof(arg) == 'Array';
};

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create         = __webpack_require__(175)
  , descriptor     = __webpack_require__(123)
  , setToStringTag = __webpack_require__(177)
  , IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(70)(IteratorPrototype, __webpack_require__(71)('iterator'), function(){ return this; });

module.exports = function(Constructor, NAME, next){
  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),
/* 694 */
/***/ (function(module, exports) {

module.exports = function(done, value){
  return {value: value, done: !!done};
};

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys   = __webpack_require__(90)
  , toIObject = __webpack_require__(55);
module.exports = function(object, el){
  var O      = toIObject(object)
    , keys   = getKeys(O)
    , length = keys.length
    , index  = 0
    , key;
  while(length > index)if(O[key = keys[index++]] === el)return key;
};

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

var META     = __webpack_require__(124)('meta')
  , isObject = __webpack_require__(89)
  , has      = __webpack_require__(53)
  , setDesc  = __webpack_require__(54).f
  , id       = 0;
var isExtensible = Object.isExtensible || function(){
  return true;
};
var FREEZE = !__webpack_require__(69)(function(){
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function(it){
  setDesc(it, META, {value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  }});
};
var fastKey = function(it, create){
  // return primitive with prefix
  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return 'F';
    // not necessary to add metadata
    if(!create)return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function(it, create){
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return true;
    // not necessary to add metadata
    if(!create)return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function(it){
  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY:      META,
  NEED:     false,
  fastKey:  fastKey,
  getWeak:  getWeak,
  onFreeze: onFreeze
};

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys  = __webpack_require__(90)
  , gOPS     = __webpack_require__(176)
  , pIE      = __webpack_require__(122)
  , toObject = __webpack_require__(181)
  , IObject  = __webpack_require__(301)
  , $assign  = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(69)(function(){
  var A = {}
    , B = {}
    , S = Symbol()
    , K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function(k){ B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
  var T     = toObject(target)
    , aLen  = arguments.length
    , index = 1
    , getSymbols = gOPS.f
    , isEnum     = pIE.f;
  while(aLen > index){
    var S      = IObject(arguments[index++])
      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
      , length = keys.length
      , j      = 0
      , key;
    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
  } return T;
} : $assign;

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

var dP       = __webpack_require__(54)
  , anObject = __webpack_require__(88)
  , getKeys  = __webpack_require__(90);

module.exports = __webpack_require__(51) ? Object.defineProperties : function defineProperties(O, Properties){
  anObject(O);
  var keys   = getKeys(Properties)
    , length = keys.length
    , i = 0
    , P;
  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(55)
  , gOPN      = __webpack_require__(304).f
  , toString  = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function(it){
  try {
    return gOPN(it);
  } catch(e){
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it){
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(52)
  , core    = __webpack_require__(40)
  , fails   = __webpack_require__(69);
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(89)
  , anObject = __webpack_require__(88);
var check = function(O, proto){
  anObject(O);
  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function(test, buggy, set){
      try {
        set = __webpack_require__(298)(Function.call, __webpack_require__(303).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch(e){ buggy = true; }
      return function setPrototypeOf(O, proto){
        check(O, proto);
        if(buggy)O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(180)
  , defined   = __webpack_require__(171);
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING){
  return function(that, pos){
    var s = String(defined(that))
      , i = toInteger(pos)
      , l = s.length
      , a, b;
    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(180)
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(180)
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(688)
  , step             = __webpack_require__(694)
  , Iterators        = __webpack_require__(173)
  , toIObject        = __webpack_require__(55);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(302)(Array, 'Array', function(iterated, kind){
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , kind  = this._k
    , index = this._i++;
  if(!O || index >= O.length){
    this._t = undefined;
    return step(1);
  }
  if(kind == 'keys'  )return step(0, index);
  if(kind == 'values')return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(52);

$export($export.S + $export.F, 'Object', {assign: __webpack_require__(697)});

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(52)
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', {create: __webpack_require__(175)});

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(52);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(51), 'Object', {defineProperty: __webpack_require__(54).f});

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject        = __webpack_require__(181)
  , $getPrototypeOf = __webpack_require__(305);

__webpack_require__(700)('getPrototypeOf', function(){
  return function getPrototypeOf(it){
    return $getPrototypeOf(toObject(it));
  };
});

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(52);
$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(701).set});

/***/ }),
/* 711 */
/***/ (function(module, exports) {



/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at  = __webpack_require__(702)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(302)(String, 'String', function(iterated){
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , index = this._i
    , point;
  if(index >= O.length)return {value: undefined, done: true};
  point = $at(O, index);
  this._i += point.length;
  return {value: point, done: false};
});

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global         = __webpack_require__(49)
  , has            = __webpack_require__(53)
  , DESCRIPTORS    = __webpack_require__(51)
  , $export        = __webpack_require__(52)
  , redefine       = __webpack_require__(307)
  , META           = __webpack_require__(696).KEY
  , $fails         = __webpack_require__(69)
  , shared         = __webpack_require__(179)
  , setToStringTag = __webpack_require__(177)
  , uid            = __webpack_require__(124)
  , wks            = __webpack_require__(71)
  , wksExt         = __webpack_require__(184)
  , wksDefine      = __webpack_require__(183)
  , keyOf          = __webpack_require__(695)
  , enumKeys       = __webpack_require__(690)
  , isArray        = __webpack_require__(692)
  , anObject       = __webpack_require__(88)
  , toIObject      = __webpack_require__(55)
  , toPrimitive    = __webpack_require__(182)
  , createDesc     = __webpack_require__(123)
  , _create        = __webpack_require__(175)
  , gOPNExt        = __webpack_require__(699)
  , $GOPD          = __webpack_require__(303)
  , $DP            = __webpack_require__(54)
  , $keys          = __webpack_require__(90)
  , gOPD           = $GOPD.f
  , dP             = $DP.f
  , gOPN           = gOPNExt.f
  , $Symbol        = global.Symbol
  , $JSON          = global.JSON
  , _stringify     = $JSON && $JSON.stringify
  , PROTOTYPE      = 'prototype'
  , HIDDEN         = wks('_hidden')
  , TO_PRIMITIVE   = wks('toPrimitive')
  , isEnum         = {}.propertyIsEnumerable
  , SymbolRegistry = shared('symbol-registry')
  , AllSymbols     = shared('symbols')
  , OPSymbols      = shared('op-symbols')
  , ObjectProto    = Object[PROTOTYPE]
  , USE_NATIVE     = typeof $Symbol == 'function'
  , QObject        = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function(){
  return _create(dP({}, 'a', {
    get: function(){ return dP(this, 'a', {value: 7}).a; }
  })).a != 7;
}) ? function(it, key, D){
  var protoDesc = gOPD(ObjectProto, key);
  if(protoDesc)delete ObjectProto[key];
  dP(it, key, D);
  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function(tag){
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
  return typeof it == 'symbol';
} : function(it){
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D){
  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if(has(AllSymbols, key)){
    if(!D.enumerable){
      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
      D = _create(D, {enumerable: createDesc(0, false)});
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P){
  anObject(it);
  var keys = enumKeys(P = toIObject(P))
    , i    = 0
    , l = keys.length
    , key;
  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P){
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key){
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
  it  = toIObject(it);
  key = toPrimitive(key, true);
  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
  var D = gOPD(it, key);
  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it){
  var names  = gOPN(toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
  var IS_OP  = it === ObjectProto
    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if(!USE_NATIVE){
  $Symbol = function Symbol(){
    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function(value){
      if(this === ObjectProto)$set.call(OPSymbols, value);
      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f   = $defineProperty;
  __webpack_require__(304).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(122).f  = $propertyIsEnumerable;
  __webpack_require__(176).f = $getOwnPropertySymbols;

  if(DESCRIPTORS && !__webpack_require__(174)){
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function(name){
    return wrap(wks(name));
  }
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});

for(var symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);

for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function(key){
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key){
    if(isSymbol(key))return keyOf(SymbolRegistry, key);
    throw TypeError(key + ' is not a symbol!');
  },
  useSetter: function(){ setter = true; },
  useSimple: function(){ setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it){
    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
    var args = [it]
      , i    = 1
      , replacer, $replacer;
    while(arguments.length > i)args.push(arguments[i++]);
    replacer = args[1];
    if(typeof replacer == 'function')$replacer = replacer;
    if($replacer || !isArray(replacer))replacer = function(key, value){
      if($replacer)value = $replacer.call(this, key, value);
      if(!isSymbol(value))return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(70)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(183)('asyncIterator');

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(183)('observable');

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(705);
var global        = __webpack_require__(49)
  , hide          = __webpack_require__(70)
  , Iterators     = __webpack_require__(173)
  , TO_STRING_TAG = __webpack_require__(71)('toStringTag');

for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
  var NAME       = collections[i]
    , Collection = global[NAME]
    , proto      = Collection && Collection.prototype;
  if(proto && !proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(10);

var emptyObject = __webpack_require__(74);
var _invariant = __webpack_require__(4);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context',
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */


  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {

    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @nosideeffects
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'

  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function (Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function (Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function (Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
    },
    contextTypes: function (Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function (Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function (Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function (Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function () {} };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
         false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(specPolicy === 'OVERRIDE_BASE', 'ReactClassInterface: You are attempting to override ' + '`%s` from your class specification. Ensure that your method names ' + 'do not overlap with React methods.', name);
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED', 'ReactClassInterface: You are attempting to define ' + '`%s` on your component more than once. This conflict may be due ' + 'to a mixin.', name);
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
      }

      return;
    }

    _invariant(typeof spec !== 'function', 'ReactClass: You\'re attempting to ' + 'use a component class or function as a mixin. Instead, just use a ' + 'regular object.');
    _invariant(!isValidElement(spec), 'ReactClass: You\'re attempting to ' + 'use a component as a mixin. Instead, just use a regular object.');

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY'), 'ReactClass: Unexpected spec policy %s for key %s ' + 'when mixing in component specs.', specPolicy, name);

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }
    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(!isReserved, 'ReactClass: You are attempting to define a reserved ' + 'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' + 'as an instance property instead; it will still be accessible on the ' + 'constructor.', name);

      var isInherited = name in Constructor;
      _invariant(!isInherited, 'ReactClass: You are attempting to define ' + '`%s` on your component more than once. This conflict may be ' + 'due to a mixin.', name);
      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(one && two && typeof one === 'object' && typeof two === 'object', 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.');

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(one[key] === undefined, 'mergeIntoWithNoDuplicateKeys(): ' + 'Tried to merge two objects with the same key: `%s`. This conflict ' + 'may be due to a mixin; in particular, this may be caused by two ' + 'getInitialState() or getDefaultProps() methods returning objects ' + 'with clashing keys.', key);
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function (newThis) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
        } else if (!args.length) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedMixin = {
    componentDidMount: function () {
      this.__isMounted = true;
    },
    componentWillUnmount: function () {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {

    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function (newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function () {
      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(this.__didWarnIsMounted, '%s: isMounted is deprecated. Instead, make sure to clean up ' + 'subscriptions and pending requests in componentWillUnmount to ' + 'prevent memory leaks.', this.constructor && this.constructor.displayName || this.name || 'Component') : void 0;
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function () {};
  _assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function (props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (initialState === undefined && this.getInitialState._isMockFunction) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(typeof initialState === 'object' && !Array.isArray(initialState), '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent');

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedMixin);
    mixSpecIntoComponent(Constructor, spec);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(Constructor.prototype.render, 'createClass(...): Class specification must implement a `render` method.');

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pairs__ = __webpack_require__(314);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values0, values1, reduce) {
  var n0 = values0.length,
      n1 = values1.length,
      values = new Array(n0 * n1),
      i0,
      i1,
      i,
      value0;

  if (reduce == null) reduce = __WEBPACK_IMPORTED_MODULE_0__pairs__["a" /* pair */];

  for (i0 = i = 0; i0 < n0; ++i0) {
    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
      values[i] = reduce(value0, values1[i1]);
    }
  }

  return values;
});


/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});


/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisect__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extent__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__identity__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__range__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ticks__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__ = __webpack_require__(316);









/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var value = __WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */],
      domain = __WEBPACK_IMPORTED_MODULE_3__extent__["a" /* default */],
      threshold = __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__["a" /* default */];

  function histogram(data) {
    var i,
        n = data.length,
        x,
        values = new Array(n);

    for (i = 0; i < n; ++i) {
      values[i] = value(data[i], i, data);
    }

    var xz = domain(values),
        x0 = xz[0],
        x1 = xz[1],
        tz = threshold(values, x0, x1);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      tz = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__ticks__["a" /* tickStep */])(x0, x1, tz);
      tz = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__range__["a" /* default */])(Math.ceil(x0 / tz) * tz, Math.floor(x1 / tz) * tz, tz); // exclusive
    }

    // Remove any thresholds outside the domain.
    var m = tz.length;
    while (tz[0] <= x0) tz.shift(), --m;
    while (tz[m - 1] > x1) tz.pop(), --m;

    var bins = new Array(m + 1),
        bin;

    // Initialize bins.
    for (i = 0; i <= m; ++i) {
      bin = bins[i] = [];
      bin.x0 = i > 0 ? tz[i - 1] : x0;
      bin.x1 = i < m ? tz[i] : x1;
    }

    // Assign data to bins by value, ignoring any outside the domain.
    for (i = 0; i < n; ++i) {
      x = values[i];
      if (x0 <= x && x <= x1) {
        bins[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__bisect__["a" /* default */])(tz, x, 0, m)].push(data[i]);
      }
    }

    return bins;
  }

  histogram.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : value;
  };

  histogram.domain = function(_) {
    return arguments.length ? (domain = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])([_[0], _[1]]), histogram) : domain;
  };

  histogram.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["b" /* slice */].call(_)) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : threshold;
  };

  return histogram;
});


/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  return max;
});


/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(91);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      m = n,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) sum += value;
      else --m;
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) sum += value;
      else --m;
    }
  }

  if (m) return sum / m;
});


/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__number__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__quantile__ = __webpack_require__(186);




/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      numbers = [];

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(values[i]))) {
        numbers.push(value);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(valueof(values[i], i, values)))) {
        numbers.push(value);
      }
    }
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__quantile__["a" /* default */])(numbers.sort(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]), 0.5);
});


/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(arrays) {
  var n = arrays.length,
      m,
      i = -1,
      j = 0,
      merged,
      array;

  while (++i < n) j += arrays[i].length;
  merged = new Array(j);

  while (--n >= 0) {
    array = arrays[n];
    m = array.length;
    while (--m >= 0) {
      merged[--j] = array[m];
    }
  }

  return merged;
});


/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, indexes) {
  var i = indexes.length, permutes = new Array(i);
  while (i--) permutes[i] = array[indexes[i]];
  return permutes;
});


/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(72);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, compare) {
  if (!(n = values.length)) return;
  var n,
      i = 0,
      j = 0,
      xi,
      xj = values[j];

  if (compare == null) compare = __WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */];

  while (++i < n) {
    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
      xj = xi, j = i;
    }
  }

  if (compare(xj, xj) === 0) return j;
});


/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, i0, i1) {
  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m + i0];
    array[m + i0] = array[i + i0];
    array[i + i0] = t;
  }

  return array;
});


/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    }
  }

  else {
    while (++i < n) {
      if (value = +valueof(values[i], i, values)) sum += value;
    }
  }

  return sum;
});


/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__quantile__ = __webpack_require__(186);





/* unused harmony default export */ var _unused_webpack_default_export = (function(values, min, max) {
  values = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(values, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]).sort(__WEBPACK_IMPORTED_MODULE_1__ascending__["a" /* default */]);
  return Math.ceil((max - min) / (2 * (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.75) - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.25)) * Math.pow(values.length, -1 / 3)));
});


/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deviation__ = __webpack_require__(311);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, min, max) {
  return Math.ceil((max - min) / (3.5 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__deviation__["a" /* default */])(values) * Math.pow(values.length, -1 / 3)));
});


/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transpose__ = __webpack_require__(318);


/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__transpose__["a" /* default */])(arguments);
});


/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(map) {
  var entries = [];
  for (var key in map) entries.push({key: key, value: map[key]});
  return entries;
});


/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(map) {
  var keys = [];
  for (var key in map) keys.push(key);
  return keys;
});


/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(187);


/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var keys = [],
      sortKeys = [],
      sortValues,
      rollup,
      nest;

  function apply(array, depth, createResult, setResult) {
    if (depth >= keys.length) {
      if (sortValues != null) array.sort(sortValues);
      return rollup != null ? rollup(array) : array;
    }

    var i = -1,
        n = array.length,
        key = keys[depth++],
        keyValue,
        value,
        valuesByKey = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])(),
        values,
        result = createResult();

    while (++i < n) {
      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
        values.push(value);
      } else {
        valuesByKey.set(keyValue, [value]);
      }
    }

    valuesByKey.each(function(values, key) {
      setResult(result, key, apply(values, depth, createResult, setResult));
    });

    return result;
  }

  function entries(map, depth) {
    if (++depth > keys.length) return map;
    var array, sortKey = sortKeys[depth - 1];
    if (rollup != null && depth >= keys.length) array = map.entries();
    else array = [], map.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
  }

  return nest = {
    object: function(array) { return apply(array, 0, createObject, setObject); },
    map: function(array) { return apply(array, 0, createMap, setMap); },
    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
    key: function(d) { keys.push(d); return nest; },
    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
    sortValues: function(order) { sortValues = order; return nest; },
    rollup: function(f) { rollup = f; return nest; }
  };
});

function createObject() {
  return {};
}

function setObject(object, key, value) {
  object[key] = value;
}

function createMap() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])();
}

function setMap(map, key, value) {
  map.set(key, value);
}


/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(187);


function Set() {}

var proto = __WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */].prototype;

Set.prototype = set.prototype = {
  constructor: Set,
  has: proto.has,
  add: function(value) {
    value += "";
    this[__WEBPACK_IMPORTED_MODULE_0__map__["b" /* prefix */] + value] = value;
    return this;
  },
  remove: proto.remove,
  clear: proto.clear,
  values: proto.keys,
  size: proto.size,
  empty: proto.empty,
  each: proto.each
};

function set(object, f) {
  var set = new Set;

  // Copy constructor.
  if (object instanceof Set) object.each(function(value) { set.add(value); });

  // Otherwise, assume it’s an array.
  else if (object) {
    var i = -1, n = object.length;
    if (f == null) while (++i < n) set.add(object[i]);
    else while (++i < n) set.add(f(object[i], i, object));
  }

  return set;
}

/* harmony default export */ __webpack_exports__["a"] = (set);


/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(map) {
  var values = [];
  for (var key in map) values.push(map[key]);
  return values;
});


/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cubehelix;
/* unused harmony export Cubehelix */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(321);




var A = -0.14861,
    B = +1.78277,
    C = -0.29227,
    D = -0.90649,
    E = +1.97294,
    ED = E * D,
    EB = E * B,
    BC_DA = B * C - D * A;

function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */])) o = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* rgbConvert */])(o);
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
      bl = b - l,
      k = (E * (g - l) - C * bl) / D,
      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
      h = s ? Math.atan2(k, bl) * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* rad2deg */] - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}

function cubehelix(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}

function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Cubehelix, cubehelix, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["d" /* Color */], {
  brighter: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["e" /* brighter */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["e" /* brighter */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["f" /* darker */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["f" /* darker */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* deg2rad */],
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */](
      255 * (l + a * (A * cosh + B * sinh)),
      255 * (l + a * (C * cosh + D * sinh)),
      255 * (l + a * (E * cosh)),
      this.opacity
    );
  }
}));


/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = lab;
/* unused harmony export Lab */
/* harmony export (immutable) */ __webpack_exports__["a"] = hcl;
/* unused harmony export Hcl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(321);




var Kn = 18,
    Xn = 0.950470, // D65 standard referent
    Yn = 1,
    Zn = 1.088830,
    t0 = 4 / 29,
    t1 = 6 / 29,
    t2 = 3 * t1 * t1,
    t3 = t1 * t1 * t1;

function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) {
    var h = o.h * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* deg2rad */];
    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
  }
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */])) o = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* rgbConvert */])(o);
  var b = rgb2xyz(o.r),
      a = rgb2xyz(o.g),
      l = rgb2xyz(o.b),
      x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
      y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
      z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}

function lab(l, a, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}

function Lab(l, a, b, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Lab, lab, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["d" /* Color */], {
  brighter: function(k) {
    return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  darker: function(k) {
    return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var y = (this.l + 16) / 116,
        x = isNaN(this.a) ? y : y + this.a / 500,
        z = isNaN(this.b) ? y : y - this.b / 200;
    y = Yn * lab2xyz(y);
    x = Xn * lab2xyz(x);
    z = Zn * lab2xyz(z);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */](
      xyz2rgb( 3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
      xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z),
      xyz2rgb( 0.0556434 * x - 0.2040259 * y + 1.0572252 * z),
      this.opacity
    );
  }
}));

function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}

function lab2xyz(t) {
  return t > t1 ? t * t * t : t2 * (t - t0);
}

function xyz2rgb(x) {
  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}

function rgb2xyz(x) {
  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}

function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  var h = Math.atan2(o.b, o.a) * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* rad2deg */];
  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}

function hcl(h, c, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function Hcl(h, c, l, opacity) {
  this.h = +h;
  this.c = +c;
  this.l = +l;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hcl, hcl, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["d" /* Color */], {
  brighter: function(k) {
    return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k), this.opacity);
  },
  darker: function(k) {
    return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k), this.opacity);
  },
  rgb: function() {
    return labConvert(this).rgb();
  }
}));


/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_contours__ = __webpack_require__(324);
/* unused harmony reexport contours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_density__ = __webpack_require__(746);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__src_density__["a"]; });




/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(ring) {
  var i = 0, n = ring.length, area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];
  while (++i < n) area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
  return area;
});


/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a - b;
});


/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = blurX;
/* harmony export (immutable) */ __webpack_exports__["b"] = blurY;
// TODO Optimize edge cases.
// TODO Optimize index calculation.
// TODO Optimize arguments.
function blurX(source, target, r) {
  var n = source.width,
      m = source.height,
      w = (r << 1) + 1;
  for (var j = 0; j < m; ++j) {
    for (var i = 0, sr = 0; i < n + r; ++i) {
      if (i < n) {
        sr += source.data[i + j * n];
      }
      if (i >= r) {
        if (i >= w) {
          sr -= source.data[i - w + j * n];
        }
        target.data[i - r + j * n] = sr / Math.min(i + 1, n - 1 + w - i, w);
      }
    }
  }
}

// TODO Optimize edge cases.
// TODO Optimize index calculation.
// TODO Optimize arguments.
function blurY(source, target, r) {
  var n = source.width,
      m = source.height,
      w = (r << 1) + 1;
  for (var i = 0; i < n; ++i) {
    for (var j = 0, sr = 0; j < m + r; ++j) {
      if (j < m) {
        sr += source.data[i + j * n];
      }
      if (j >= r) {
        if (j >= w) {
          sr -= source.data[i + (j - w) * n];
        }
        target.data[i + (j - r) * n] = sr / Math.min(j + 1, m - 1 + w - j, w);
      }
    }
  }
}


/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(ring, hole) {
  var i = -1, n = hole.length, c;
  while (++i < n) if (c = ringContains(ring, hole[i])) return c;
  return 0;
});

function ringContains(ring, point) {
  var x = point[0], y = point[1], contains = -1;
  for (var i = 0, n = ring.length, j = n - 1; i < n; j = i++) {
    var pi = ring[i], xi = pi[0], yi = pi[1], pj = ring[j], xj = pj[0], yj = pj[1];
    if (segmentContains(pi, pj, point)) return 0;
    if (((yi > y) !== (yj > y)) && ((x < (xj - xi) * (y - yi) / (yj - yi) + xi))) contains = -contains;
  }
  return contains;
}

function segmentContains(a, b, c) {
  var i; return collinear(a, b, c) && within(a[i = +(a[0] === b[0])], c[i], b[i]);
}

function collinear(a, b, c) {
  return (b[0] - a[0]) * (c[1] - a[1]) === (c[0] - a[0]) * (b[1] - a[1]);
}

function within(p, q, r) {
  return p <= q && q <= r || r <= q && q <= p;
}


/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__blur__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__contours__ = __webpack_require__(324);






function defaultX(d) {
  return d[0];
}

function defaultY(d) {
  return d[1];
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x = defaultX,
      y = defaultY,
      dx = 960,
      dy = 500,
      r = 20, // blur radius
      k = 2, // log2(grid cell size)
      o = r * 3, // grid offset, to pad for blur
      n = (dx + o * 2) >> k, // grid width
      m = (dy + o * 2) >> k, // grid height
      threshold = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(20);

  function density(data) {
    var values0 = new Float32Array(n * m),
        values1 = new Float32Array(n * m);

    data.forEach(function(d, i, data) {
      var xi = (x(d, i, data) + o) >> k,
          yi = (y(d, i, data) + o) >> k;
      if (xi >= 0 && xi < n && yi >= 0 && yi < m) {
        ++values0[xi + yi * n];
      }
    });

    // TODO Optimize.
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__blur__["a" /* blurX */])({width: n, height: m, data: values0}, {width: n, height: m, data: values1}, r >> k);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__blur__["b" /* blurY */])({width: n, height: m, data: values1}, {width: n, height: m, data: values0}, r >> k);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__blur__["a" /* blurX */])({width: n, height: m, data: values0}, {width: n, height: m, data: values1}, r >> k);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__blur__["b" /* blurY */])({width: n, height: m, data: values1}, {width: n, height: m, data: values0}, r >> k);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__blur__["a" /* blurX */])({width: n, height: m, data: values0}, {width: n, height: m, data: values1}, r >> k);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__blur__["b" /* blurY */])({width: n, height: m, data: values1}, {width: n, height: m, data: values0}, r >> k);

    var tz = threshold(values0);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      var stop = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["k" /* max */])(values0);
      tz = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["e" /* tickStep */])(0, stop, tz);
      tz = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["i" /* range */])(0, Math.floor(stop / tz) * tz, tz);
      tz.shift();
    }

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__contours__["a" /* default */])()
        .thresholds(tz)
        .size([n, m])
      (values0)
        .map(transform);
  }

  function transform(geometry) {
    geometry.value *= Math.pow(2, -2 * k); // Density in points per square pixel.
    geometry.coordinates.forEach(transformPolygon);
    return geometry;
  }

  function transformPolygon(coordinates) {
    coordinates.forEach(transformRing);
  }

  function transformRing(coordinates) {
    coordinates.forEach(transformPoint);
  }

  // TODO Optimize.
  function transformPoint(coordinates) {
    coordinates[0] = coordinates[0] * Math.pow(2, k) - o;
    coordinates[1] = coordinates[1] * Math.pow(2, k) - o;
  }

  function resize() {
    o = r * 3;
    n = (dx + o * 2) >> k;
    m = (dy + o * 2) >> k;
    return density;
  }

  density.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(+_), density) : x;
  };

  density.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(+_), density) : y;
  };

  density.size = function(_) {
    if (!arguments.length) return [dx, dy];
    var _0 = Math.ceil(_[0]), _1 = Math.ceil(_[1]);
    if (!(_0 >= 0) && !(_0 >= 0)) throw new Error("invalid size");
    return dx = _0, dy = _1, resize();
  };

  density.cellSize = function(_) {
    if (!arguments.length) return 1 << k;
    if (!((_ = +_) >= 1)) throw new Error("invalid cell size");
    return k = Math.floor(Math.log(_) / Math.LN2), resize();
  };

  density.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__array__["a" /* slice */].call(_)) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(_), density) : threshold;
  };

  density.bandwidth = function(_) {
    if (!arguments.length) return Math.sqrt(r * (r + 1));
    if (!((_ = +_) >= 0)) throw new Error("invalid bandwidth");
    return r = Math.round((Math.sqrt(4 * _ * _ + 1) - 1) / 2), resize();
  };

  return density;
});


/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {});


/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return format; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatPrefix; });
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__(328);


var locale;
var format;
var formatPrefix;

defaultLocale({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});

function defaultLocale(definition) {
  locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* default */])(definition);
  format = locale.format;
  formatPrefix = locale.formatPrefix;
  return locale;
}


/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  x = x.toPrecision(p);

  out: for (var n = x.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (x[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      case "e": break out;
      default: if (i0 > 0) i0 = 0; break;
    }
  }

  return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
});


/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
});


/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
});


/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(190);


/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  var d = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
});


/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(126);


/* harmony default export */ __webpack_exports__["a"] = (function(step) {
  return Math.max(0, -__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(Math.abs(step)));
});


/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(126);


/* harmony default export */ __webpack_exports__["a"] = (function(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(value) / 3))) * 3 - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(Math.abs(step)));
});


/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(126);


/* harmony default export */ __webpack_exports__["a"] = (function(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(max) - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(step)) + 1;
});


/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_area__ = __webpack_require__(329);
/* unused harmony reexport geoArea */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_bounds__ = __webpack_require__(758);
/* unused harmony reexport geoBounds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_centroid__ = __webpack_require__(759);
/* unused harmony reexport geoCentroid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_circle__ = __webpack_require__(330);
/* unused harmony reexport geoCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_clip_extent__ = __webpack_require__(191);
/* unused harmony reexport geoClipExtent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_contains__ = __webpack_require__(764);
/* unused harmony reexport geoContains */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_distance__ = __webpack_require__(335);
/* unused harmony reexport geoDistance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_graticule__ = __webpack_require__(765);
/* unused harmony reexport geoGraticule */
/* unused harmony reexport geoGraticule10 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_interpolate__ = __webpack_require__(766);
/* unused harmony reexport geoInterpolate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_length__ = __webpack_require__(336);
/* unused harmony reexport geoLength */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_path_index__ = __webpack_require__(770);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_10__src_path_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_projection_albers__ = __webpack_require__(340);
/* unused harmony reexport geoAlbers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_projection_albersUsa__ = __webpack_require__(773);
/* unused harmony reexport geoAlbersUsa */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_projection_azimuthalEqualArea__ = __webpack_require__(774);
/* unused harmony reexport geoAzimuthalEqualArea */
/* unused harmony reexport geoAzimuthalEqualAreaRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_projection_azimuthalEquidistant__ = __webpack_require__(775);
/* unused harmony reexport geoAzimuthalEquidistant */
/* unused harmony reexport geoAzimuthalEquidistantRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_projection_conicConformal__ = __webpack_require__(776);
/* unused harmony reexport geoConicConformal */
/* unused harmony reexport geoConicConformalRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_projection_conicEqualArea__ = __webpack_require__(194);
/* unused harmony reexport geoConicEqualArea */
/* unused harmony reexport geoConicEqualAreaRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_projection_conicEquidistant__ = __webpack_require__(777);
/* unused harmony reexport geoConicEquidistant */
/* unused harmony reexport geoConicEquidistantRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_projection_equirectangular__ = __webpack_require__(341);
/* unused harmony reexport geoEquirectangular */
/* unused harmony reexport geoEquirectangularRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_projection_gnomonic__ = __webpack_require__(779);
/* unused harmony reexport geoGnomonic */
/* unused harmony reexport geoGnomonicRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_projection_identity__ = __webpack_require__(780);
/* unused harmony reexport geoIdentity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_projection_index__ = __webpack_require__(41);
/* unused harmony reexport geoProjection */
/* unused harmony reexport geoProjectionMutator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_projection_mercator__ = __webpack_require__(196);
/* unused harmony reexport geoMercator */
/* unused harmony reexport geoMercatorRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_projection_orthographic__ = __webpack_require__(781);
/* unused harmony reexport geoOrthographic */
/* unused harmony reexport geoOrthographicRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_projection_stereographic__ = __webpack_require__(783);
/* unused harmony reexport geoStereographic */
/* unused harmony reexport geoStereographicRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__src_projection_transverseMercator__ = __webpack_require__(784);
/* unused harmony reexport geoTransverseMercator */
/* unused harmony reexport geoTransverseMercatorRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__src_rotation__ = __webpack_require__(127);
/* unused harmony reexport geoRotation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__src_stream__ = __webpack_require__(56);
/* unused harmony reexport geoStream */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__src_transform__ = __webpack_require__(128);
/* unused harmony reexport geoTransform */




 // DEPRECATED! Use d3.geoIdentity().clipExtent(…).


























/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__area__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cartesian__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stream__ = __webpack_require__(56);






var lambda0, phi0, lambda1, phi1, // bounds
    lambda2, // previous lambda-coordinate
    lambda00, phi00, // first point
    p0, // previous 3D point
    deltaSum = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    ranges,
    range;

var boundsStream = {
  point: boundsPoint,
  lineStart: boundsLineStart,
  lineEnd: boundsLineEnd,
  polygonStart: function() {
    boundsStream.point = boundsRingPoint;
    boundsStream.lineStart = boundsRingStart;
    boundsStream.lineEnd = boundsRingEnd;
    deltaSum.reset();
    __WEBPACK_IMPORTED_MODULE_1__area__["a" /* areaStream */].polygonStart();
  },
  polygonEnd: function() {
    __WEBPACK_IMPORTED_MODULE_1__area__["a" /* areaStream */].polygonEnd();
    boundsStream.point = boundsPoint;
    boundsStream.lineStart = boundsLineStart;
    boundsStream.lineEnd = boundsLineEnd;
    if (__WEBPACK_IMPORTED_MODULE_1__area__["b" /* areaRingSum */] < 0) lambda0 = -(lambda1 = 180), phi0 = -(phi1 = 90);
    else if (deltaSum > __WEBPACK_IMPORTED_MODULE_3__math__["p" /* epsilon */]) phi1 = 90;
    else if (deltaSum < -__WEBPACK_IMPORTED_MODULE_3__math__["p" /* epsilon */]) phi0 = -90;
    range[0] = lambda0, range[1] = lambda1;
  }
};

function boundsPoint(lambda, phi) {
  ranges.push(range = [lambda0 = lambda, lambda1 = lambda]);
  if (phi < phi0) phi0 = phi;
  if (phi > phi1) phi1 = phi;
}

function linePoint(lambda, phi) {
  var p = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cartesian__["a" /* cartesian */])([lambda * __WEBPACK_IMPORTED_MODULE_3__math__["g" /* radians */], phi * __WEBPACK_IMPORTED_MODULE_3__math__["g" /* radians */]]);
  if (p0) {
    var normal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cartesian__["b" /* cartesianCross */])(p0, p),
        equatorial = [normal[1], -normal[0], 0],
        inflection = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cartesian__["b" /* cartesianCross */])(equatorial, normal);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cartesian__["g" /* cartesianNormalizeInPlace */])(inflection);
    inflection = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cartesian__["f" /* spherical */])(inflection);
    var delta = lambda - lambda2,
        sign = delta > 0 ? 1 : -1,
        lambdai = inflection[0] * __WEBPACK_IMPORTED_MODULE_3__math__["h" /* degrees */] * sign,
        phii,
        antimeridian = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__math__["o" /* abs */])(delta) > 180;
    if (antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
      phii = inflection[1] * __WEBPACK_IMPORTED_MODULE_3__math__["h" /* degrees */];
      if (phii > phi1) phi1 = phii;
    } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
      phii = -inflection[1] * __WEBPACK_IMPORTED_MODULE_3__math__["h" /* degrees */];
      if (phii < phi0) phi0 = phii;
    } else {
      if (phi < phi0) phi0 = phi;
      if (phi > phi1) phi1 = phi;
    }
    if (antimeridian) {
      if (lambda < lambda2) {
        if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
      } else {
        if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
      }
    } else {
      if (lambda1 >= lambda0) {
        if (lambda < lambda0) lambda0 = lambda;
        if (lambda > lambda1) lambda1 = lambda;
      } else {
        if (lambda > lambda2) {
          if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
        } else {
          if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
        }
      }
    }
  } else {
    ranges.push(range = [lambda0 = lambda, lambda1 = lambda]);
  }
  if (phi < phi0) phi0 = phi;
  if (phi > phi1) phi1 = phi;
  p0 = p, lambda2 = lambda;
}

function boundsLineStart() {
  boundsStream.point = linePoint;
}

function boundsLineEnd() {
  range[0] = lambda0, range[1] = lambda1;
  boundsStream.point = boundsPoint;
  p0 = null;
}

function boundsRingPoint(lambda, phi) {
  if (p0) {
    var delta = lambda - lambda2;
    deltaSum.add(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__math__["o" /* abs */])(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
  } else {
    lambda00 = lambda, phi00 = phi;
  }
  __WEBPACK_IMPORTED_MODULE_1__area__["a" /* areaStream */].point(lambda, phi);
  linePoint(lambda, phi);
}

function boundsRingStart() {
  __WEBPACK_IMPORTED_MODULE_1__area__["a" /* areaStream */].lineStart();
}

function boundsRingEnd() {
  boundsRingPoint(lambda00, phi00);
  __WEBPACK_IMPORTED_MODULE_1__area__["a" /* areaStream */].lineEnd();
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__math__["o" /* abs */])(deltaSum) > __WEBPACK_IMPORTED_MODULE_3__math__["p" /* epsilon */]) lambda0 = -(lambda1 = 180);
  range[0] = lambda0, range[1] = lambda1;
  p0 = null;
}

// Finds the left-right distance between two longitudes.
// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
// the distance between ±180° to be 360°.
function angle(lambda0, lambda1) {
  return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
}

function rangeCompare(a, b) {
  return a[0] - b[0];
}

function rangeContains(range, x) {
  return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(feature) {
  var i, n, a, b, merged, deltaMax, delta;

  phi1 = lambda1 = -(lambda0 = phi0 = Infinity);
  ranges = [];
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__stream__["a" /* default */])(feature, boundsStream);

  // First, sort ranges by their minimum longitudes.
  if (n = ranges.length) {
    ranges.sort(rangeCompare);

    // Then, merge any ranges that overlap.
    for (i = 1, a = ranges[0], merged = [a]; i < n; ++i) {
      b = ranges[i];
      if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
        if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
        if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
      } else {
        merged.push(a = b);
      }
    }

    // Finally, find the largest gap between the merged ranges.
    // The final bounding box will be the inverse of this gap.
    for (deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i) {
      b = merged[i];
      if ((delta = angle(a[1], b[0])) > deltaMax) deltaMax = delta, lambda0 = b[0], lambda1 = a[1];
    }
  }

  ranges = range = null;

  return lambda0 === Infinity || phi0 === Infinity
      ? [[NaN, NaN], [NaN, NaN]]
      : [[lambda0, phi0], [lambda1, phi1]];
});


/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stream__ = __webpack_require__(56);




var W0, W1,
    X0, Y0, Z0,
    X1, Y1, Z1,
    X2, Y2, Z2,
    lambda00, phi00, // first point
    x0, y0, z0; // previous point

var centroidStream = {
  sphere: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  point: centroidPoint,
  lineStart: centroidLineStart,
  lineEnd: centroidLineEnd,
  polygonStart: function() {
    centroidStream.lineStart = centroidRingStart;
    centroidStream.lineEnd = centroidRingEnd;
  },
  polygonEnd: function() {
    centroidStream.lineStart = centroidLineStart;
    centroidStream.lineEnd = centroidLineEnd;
  }
};

// Arithmetic mean of Cartesian vectors.
function centroidPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */];
  var cosPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(phi);
  centroidPointCartesian(cosPhi * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(lambda), cosPhi * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(lambda), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(phi));
}

function centroidPointCartesian(x, y, z) {
  ++W0;
  X0 += (x - X0) / W0;
  Y0 += (y - Y0) / W0;
  Z0 += (z - Z0) / W0;
}

function centroidLineStart() {
  centroidStream.point = centroidLinePointFirst;
}

function centroidLinePointFirst(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */];
  var cosPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(phi);
  x0 = cosPhi * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(lambda);
  y0 = cosPhi * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(lambda);
  z0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(phi);
  centroidStream.point = centroidLinePoint;
  centroidPointCartesian(x0, y0, z0);
}

function centroidLinePoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */];
  var cosPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(phi),
      x = cosPhi * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(lambda),
      y = cosPhi * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(lambda),
      z = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(phi),
      w = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
  W1 += w;
  X1 += w * (x0 + (x0 = x));
  Y1 += w * (y0 + (y0 = y));
  Z1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0, y0, z0);
}

function centroidLineEnd() {
  centroidStream.point = centroidPoint;
}

// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
// J. Applied Mechanics 42, 239 (1975).
function centroidRingStart() {
  centroidStream.point = centroidRingPointFirst;
}

function centroidRingEnd() {
  centroidRingPoint(lambda00, phi00);
  centroidStream.point = centroidPoint;
}

function centroidRingPointFirst(lambda, phi) {
  lambda00 = lambda, phi00 = phi;
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */];
  centroidStream.point = centroidRingPoint;
  var cosPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(phi);
  x0 = cosPhi * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(lambda);
  y0 = cosPhi * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(lambda);
  z0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(phi);
  centroidPointCartesian(x0, y0, z0);
}

function centroidRingPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */];
  var cosPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(phi),
      x = cosPhi * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(lambda),
      y = cosPhi * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(lambda),
      z = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(phi),
      cx = y0 * z - z0 * y,
      cy = z0 * x - x0 * z,
      cz = x0 * y - y0 * x,
      m = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])(cx * cx + cy * cy + cz * cz),
      w = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["f" /* asin */])(m), // line weight = angle
      v = m && -w / m; // area weight multiplier
  X2 += v * cx;
  Y2 += v * cy;
  Z2 += v * cz;
  W1 += w;
  X1 += w * (x0 + (x0 = x));
  Y1 += w * (y0 + (y0 = y));
  Z1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0, y0, z0);
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(object) {
  W0 = W1 =
  X0 = Y0 = Z0 =
  X1 = Y1 = Z1 =
  X2 = Y2 = Z2 = 0;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__stream__["a" /* default */])(object, centroidStream);

  var x = X2,
      y = Y2,
      z = Z2,
      m = x * x + y * y + z * z;

  // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
  if (m < __WEBPACK_IMPORTED_MODULE_0__math__["w" /* epsilon2 */]) {
    x = X1, y = Y1, z = Z1;
    // If the feature has zero length, fall back to arithmetic mean of point vectors.
    if (W1 < __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */]) x = X0, y = Y0, z = Z0;
    m = x * x + y * y + z * z;
    // If the feature still has an undefined ccentroid, then return.
    if (m < __WEBPACK_IMPORTED_MODULE_0__math__["w" /* epsilon2 */]) return [NaN, NaN];
  }

  return [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(y, x) * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["f" /* asin */])(z / __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])(m)) * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */]];
});


/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])(
  function() { return true; },
  clipAntimeridianLine,
  clipAntimeridianInterpolate,
  [-__WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */], -__WEBPACK_IMPORTED_MODULE_1__math__["k" /* halfPi */]]
));

// Takes a line and cuts into visible segments. Return values: 0 - there were
// intersections or the line was empty; 1 - no intersections; 2 - there were
// intersections, and the first and last segments should be rejoined.
function clipAntimeridianLine(stream) {
  var lambda0 = NaN,
      phi0 = NaN,
      sign0 = NaN,
      clean; // no intersections

  return {
    lineStart: function() {
      stream.lineStart();
      clean = 1;
    },
    point: function(lambda1, phi1) {
      var sign1 = lambda1 > 0 ? __WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */] : -__WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */],
          delta = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])(lambda1 - lambda0);
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])(delta - __WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */]) < __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */]) { // line crosses a pole
        stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? __WEBPACK_IMPORTED_MODULE_1__math__["k" /* halfPi */] : -__WEBPACK_IMPORTED_MODULE_1__math__["k" /* halfPi */]);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        stream.point(lambda1, phi0);
        clean = 0;
      } else if (sign0 !== sign1 && delta >= __WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */]) { // line crosses antimeridian
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])(lambda0 - sign0) < __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */]) lambda0 -= sign0 * __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */]; // handle degeneracies
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])(lambda1 - sign1) < __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */]) lambda1 -= sign1 * __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */];
        phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        clean = 0;
      }
      stream.point(lambda0 = lambda1, phi0 = phi1);
      sign0 = sign1;
    },
    lineEnd: function() {
      stream.lineEnd();
      lambda0 = phi0 = NaN;
    },
    clean: function() {
      return 2 - clean; // if intersections, rejoin first and last segments
    }
  };
}

function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
  var cosPhi0,
      cosPhi1,
      sinLambda0Lambda1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(lambda0 - lambda1);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])(sinLambda0Lambda1) > __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */]
      ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["l" /* atan */])((__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(phi0) * (cosPhi1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(phi1)) * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(lambda1)
          - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(phi1) * (cosPhi0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(phi0)) * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(lambda0))
          / (cosPhi0 * cosPhi1 * sinLambda0Lambda1))
      : (phi0 + phi1) / 2;
}

function clipAntimeridianInterpolate(from, to, direction, stream) {
  var phi;
  if (from == null) {
    phi = direction * __WEBPACK_IMPORTED_MODULE_1__math__["k" /* halfPi */];
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */], phi);
    stream.point(0, phi);
    stream.point(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */], phi);
    stream.point(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */], 0);
    stream.point(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */], -phi);
    stream.point(0, -phi);
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */], -phi);
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */], 0);
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */], phi);
  } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])(from[0] - to[0]) > __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */]) {
    var lambda = from[0] < to[0] ? __WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */] : -__WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */];
    phi = direction * lambda / 2;
    stream.point(-lambda, phi);
    stream.point(0, phi);
    stream.point(lambda, phi);
  } else {
    stream.point(to[0], to[1]);
  }
}


/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cartesian__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__circle__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pointEqual__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index__ = __webpack_require__(332);






/* harmony default export */ __webpack_exports__["a"] = (function(radius, delta) {
  var cr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* cos */])(radius),
      smallRadius = cr > 0,
      notHemisphere = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["o" /* abs */])(cr) > __WEBPACK_IMPORTED_MODULE_2__math__["p" /* epsilon */]; // TODO optimise for this common case

  function interpolate(from, to, direction, stream) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__circle__["a" /* circleStream */])(stream, radius, delta, direction, from, to);
  }

  function visible(lambda, phi) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* cos */])(lambda) * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* cos */])(phi) > cr;
  }

  // Takes a line and cuts into visible segments. Return values used for polygon
  // clipping: 0 - there were intersections or the line was empty; 1 - no
  // intersections 2 - there were intersections, and the first and last segments
  // should be rejoined.
  function clipLine(stream) {
    var point0, // previous point
        c0, // code for previous point
        v0, // visibility of previous point
        v00, // visibility of first point
        clean; // no intersections
    return {
      lineStart: function() {
        v00 = v0 = false;
        clean = 1;
      },
      point: function(lambda, phi) {
        var point1 = [lambda, phi],
            point2,
            v = visible(lambda, phi),
            c = smallRadius
              ? v ? 0 : code(lambda, phi)
              : v ? code(lambda + (lambda < 0 ? __WEBPACK_IMPORTED_MODULE_2__math__["a" /* pi */] : -__WEBPACK_IMPORTED_MODULE_2__math__["a" /* pi */]), phi) : 0;
        if (!point0 && (v00 = v0 = v)) stream.lineStart();
        // Handle degeneracies.
        // TODO ignore if not clipping polygons.
        if (v !== v0) {
          point2 = intersect(point0, point1);
          if (!point2 || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__pointEqual__["a" /* default */])(point0, point2) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__pointEqual__["a" /* default */])(point1, point2)) {
            point1[0] += __WEBPACK_IMPORTED_MODULE_2__math__["p" /* epsilon */];
            point1[1] += __WEBPACK_IMPORTED_MODULE_2__math__["p" /* epsilon */];
            v = visible(point1[0], point1[1]);
          }
        }
        if (v !== v0) {
          clean = 0;
          if (v) {
            // outside going in
            stream.lineStart();
            point2 = intersect(point1, point0);
            stream.point(point2[0], point2[1]);
          } else {
            // inside going out
            point2 = intersect(point0, point1);
            stream.point(point2[0], point2[1]);
            stream.lineEnd();
          }
          point0 = point2;
        } else if (notHemisphere && point0 && smallRadius ^ v) {
          var t;
          // If the codes for two points are different, or are both zero,
          // and there this segment intersects with the small circle.
          if (!(c & c0) && (t = intersect(point1, point0, true))) {
            clean = 0;
            if (smallRadius) {
              stream.lineStart();
              stream.point(t[0][0], t[0][1]);
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
            } else {
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
              stream.lineStart();
              stream.point(t[0][0], t[0][1]);
            }
          }
        }
        if (v && (!point0 || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__pointEqual__["a" /* default */])(point0, point1))) {
          stream.point(point1[0], point1[1]);
        }
        point0 = point1, v0 = v, c0 = c;
      },
      lineEnd: function() {
        if (v0) stream.lineEnd();
        point0 = null;
      },
      // Rejoin first and last segments if there were intersections and the first
      // and last points were visible.
      clean: function() {
        return clean | ((v00 && v0) << 1);
      }
    };
  }

  // Intersects the great circle between a and b with the clip circle.
  function intersect(a, b, two) {
    var pa = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["a" /* cartesian */])(a),
        pb = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["a" /* cartesian */])(b);

    // We have two planes, n1.p = d1 and n2.p = d2.
    // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
    var n1 = [1, 0, 0], // normal
        n2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["b" /* cartesianCross */])(pa, pb),
        n2n2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["c" /* cartesianDot */])(n2, n2),
        n1n2 = n2[0], // cartesianDot(n1, n2),
        determinant = n2n2 - n1n2 * n1n2;

    // Two polar points.
    if (!determinant) return !two && a;

    var c1 =  cr * n2n2 / determinant,
        c2 = -cr * n1n2 / determinant,
        n1xn2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["b" /* cartesianCross */])(n1, n2),
        A = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["d" /* cartesianScale */])(n1, c1),
        B = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["d" /* cartesianScale */])(n2, c2);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["e" /* cartesianAddInPlace */])(A, B);

    // Solve |p(t)|^2 = 1.
    var u = n1xn2,
        w = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["c" /* cartesianDot */])(A, u),
        uu = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["c" /* cartesianDot */])(u, u),
        t2 = w * w - uu * (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["c" /* cartesianDot */])(A, A) - 1);

    if (t2 < 0) return;

    var t = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["n" /* sqrt */])(t2),
        q = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["d" /* cartesianScale */])(u, (-w - t) / uu);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["e" /* cartesianAddInPlace */])(q, A);
    q = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["f" /* spherical */])(q);

    if (!two) return q;

    // Two intersection points.
    var lambda0 = a[0],
        lambda1 = b[0],
        phi0 = a[1],
        phi1 = b[1],
        z;

    if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;

    var delta = lambda1 - lambda0,
        polar = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["o" /* abs */])(delta - __WEBPACK_IMPORTED_MODULE_2__math__["a" /* pi */]) < __WEBPACK_IMPORTED_MODULE_2__math__["p" /* epsilon */],
        meridian = polar || delta < __WEBPACK_IMPORTED_MODULE_2__math__["p" /* epsilon */];

    if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;

    // Check that the first point is between a and b.
    if (meridian
        ? polar
          ? phi0 + phi1 > 0 ^ q[1] < (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["o" /* abs */])(q[0] - lambda0) < __WEBPACK_IMPORTED_MODULE_2__math__["p" /* epsilon */] ? phi0 : phi1)
          : phi0 <= q[1] && q[1] <= phi1
        : delta > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* pi */] ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
      var q1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["d" /* cartesianScale */])(u, (-w + t) / uu);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["e" /* cartesianAddInPlace */])(q1, A);
      return [q, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["f" /* spherical */])(q1)];
    }
  }

  // Generates a 4-bit vector representing the location of a point relative to
  // the small circle's bounding box.
  function code(lambda, phi) {
    var r = smallRadius ? radius : __WEBPACK_IMPORTED_MODULE_2__math__["a" /* pi */] - radius,
        code = 0;
    if (lambda < -r) code |= 1; // left
    else if (lambda > r) code |= 2; // right
    if (phi < -r) code |= 4; // below
    else if (phi > r) code |= 8; // above
    return code;
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */])(visible, clipLine, interpolate, smallRadius ? [0, -radius] : [-__WEBPACK_IMPORTED_MODULE_2__math__["a" /* pi */], radius - __WEBPACK_IMPORTED_MODULE_2__math__["a" /* pi */]]);
});


/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b, x0, y0, x1, y1) {
  var ax = a[0],
      ay = a[1],
      bx = b[0],
      by = b[1],
      t0 = 0,
      t1 = 1,
      dx = bx - ax,
      dy = by - ay,
      r;

  r = x0 - ax;
  if (!dx && r > 0) return;
  r /= dx;
  if (dx < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dx > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = x1 - ax;
  if (!dx && r < 0) return;
  r /= dx;
  if (dx < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dx > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  r = y0 - ay;
  if (!dy && r > 0) return;
  r /= dy;
  if (dy < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dy > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = y1 - ay;
  if (!dy && r < 0) return;
  r /= dy;
  if (dy < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dy > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
  if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
  return true;
});


/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polygonContains__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__distance__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(5);




var containsObjectType = {
  Feature: function(object, point) {
    return containsGeometry(object.geometry, point);
  },
  FeatureCollection: function(object, point) {
    var features = object.features, i = -1, n = features.length;
    while (++i < n) if (containsGeometry(features[i].geometry, point)) return true;
    return false;
  }
};

var containsGeometryType = {
  Sphere: function() {
    return true;
  },
  Point: function(object, point) {
    return containsPoint(object.coordinates, point);
  },
  MultiPoint: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsPoint(coordinates[i], point)) return true;
    return false;
  },
  LineString: function(object, point) {
    return containsLine(object.coordinates, point);
  },
  MultiLineString: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsLine(coordinates[i], point)) return true;
    return false;
  },
  Polygon: function(object, point) {
    return containsPolygon(object.coordinates, point);
  },
  MultiPolygon: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsPolygon(coordinates[i], point)) return true;
    return false;
  },
  GeometryCollection: function(object, point) {
    var geometries = object.geometries, i = -1, n = geometries.length;
    while (++i < n) if (containsGeometry(geometries[i], point)) return true;
    return false;
  }
};

function containsGeometry(geometry, point) {
  return geometry && containsGeometryType.hasOwnProperty(geometry.type)
      ? containsGeometryType[geometry.type](geometry, point)
      : false;
}

function containsPoint(coordinates, point) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__distance__["a" /* default */])(coordinates, point) === 0;
}

function containsLine(coordinates, point) {
  var ab = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__distance__["a" /* default */])(coordinates[0], coordinates[1]),
      ao = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__distance__["a" /* default */])(coordinates[0], point),
      ob = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__distance__["a" /* default */])(point, coordinates[1]);
  return ao + ob <= ab + __WEBPACK_IMPORTED_MODULE_2__math__["p" /* epsilon */];
}

function containsPolygon(coordinates, point) {
  return !!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__polygonContains__["a" /* default */])(coordinates.map(ringRadians), pointRadians(point));
}

function ringRadians(ring) {
  return ring = ring.map(pointRadians), ring.pop(), ring;
}

function pointRadians(point) {
  return [point[0] * __WEBPACK_IMPORTED_MODULE_2__math__["g" /* radians */], point[1] * __WEBPACK_IMPORTED_MODULE_2__math__["g" /* radians */]];
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(object, point) {
  return (object && containsObjectType.hasOwnProperty(object.type)
      ? containsObjectType[object.type]
      : containsGeometry)(object, point);
});


/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export graticule10 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(5);



function graticuleX(y0, y1, dy) {
  var y = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["i" /* range */])(y0, y1 - __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */], dy).concat(y1);
  return function(x) { return y.map(function(y) { return [x, y]; }); };
}

function graticuleY(x0, x1, dx) {
  var x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["i" /* range */])(x0, x1 - __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */], dx).concat(x1);
  return function(y) { return x.map(function(x) { return [x, y]; }); };
}

function graticule() {
  var x1, x0, X1, X0,
      y1, y0, Y1, Y0,
      dx = 10, dy = dx, DX = 90, DY = 360,
      x, y, X, Y,
      precision = 2.5;

  function graticule() {
    return {type: "MultiLineString", coordinates: lines()};
  }

  function lines() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["i" /* range */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["v" /* ceil */])(X0 / DX) * DX, X1, DX).map(X)
        .concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["i" /* range */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["v" /* ceil */])(Y0 / DY) * DY, Y1, DY).map(Y))
        .concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["i" /* range */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["v" /* ceil */])(x0 / dx) * dx, x1, dx).filter(function(x) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])(x % DX) > __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */]; }).map(x))
        .concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["i" /* range */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["v" /* ceil */])(y0 / dy) * dy, y1, dy).filter(function(y) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])(y % DY) > __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */]; }).map(y));
  }

  graticule.lines = function() {
    return lines().map(function(coordinates) { return {type: "LineString", coordinates: coordinates}; });
  };

  graticule.outline = function() {
    return {
      type: "Polygon",
      coordinates: [
        X(X0).concat(
        Y(Y1).slice(1),
        X(X1).reverse().slice(1),
        Y(Y0).reverse().slice(1))
      ]
    };
  };

  graticule.extent = function(_) {
    if (!arguments.length) return graticule.extentMinor();
    return graticule.extentMajor(_).extentMinor(_);
  };

  graticule.extentMajor = function(_) {
    if (!arguments.length) return [[X0, Y0], [X1, Y1]];
    X0 = +_[0][0], X1 = +_[1][0];
    Y0 = +_[0][1], Y1 = +_[1][1];
    if (X0 > X1) _ = X0, X0 = X1, X1 = _;
    if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
    return graticule.precision(precision);
  };

  graticule.extentMinor = function(_) {
    if (!arguments.length) return [[x0, y0], [x1, y1]];
    x0 = +_[0][0], x1 = +_[1][0];
    y0 = +_[0][1], y1 = +_[1][1];
    if (x0 > x1) _ = x0, x0 = x1, x1 = _;
    if (y0 > y1) _ = y0, y0 = y1, y1 = _;
    return graticule.precision(precision);
  };

  graticule.step = function(_) {
    if (!arguments.length) return graticule.stepMinor();
    return graticule.stepMajor(_).stepMinor(_);
  };

  graticule.stepMajor = function(_) {
    if (!arguments.length) return [DX, DY];
    DX = +_[0], DY = +_[1];
    return graticule;
  };

  graticule.stepMinor = function(_) {
    if (!arguments.length) return [dx, dy];
    dx = +_[0], dy = +_[1];
    return graticule;
  };

  graticule.precision = function(_) {
    if (!arguments.length) return precision;
    precision = +_;
    x = graticuleX(y0, y1, 90);
    y = graticuleY(x0, x1, precision);
    X = graticuleX(Y0, Y1, 90);
    Y = graticuleY(X0, X1, precision);
    return graticule;
  };

  return graticule
      .extentMajor([[-180, -90 + __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */]], [180, 90 - __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */]]])
      .extentMinor([[-180, -80 - __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */]], [180, 80 + __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */]]]);
}

function graticule10() {
  return graticule()();
}


/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);


/* unused harmony default export */ var _unused_webpack_default_export = (function(a, b) {
  var x0 = a[0] * __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */],
      y0 = a[1] * __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */],
      x1 = b[0] * __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */],
      y1 = b[1] * __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */],
      cy0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(y0),
      sy0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(y0),
      cy1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(y1),
      sy1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(y1),
      kx0 = cy0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(x0),
      ky0 = cy0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(x0),
      kx1 = cy1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(x1),
      ky1 = cy1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(x1),
      d = 2 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["f" /* asin */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* haversin */])(y1 - y0) + cy0 * cy1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* haversin */])(x1 - x0))),
      k = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(d);

  var interpolate = d ? function(t) {
    var B = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(t *= d) / k,
        A = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(d - t) / k,
        x = A * kx0 + B * kx1,
        y = A * ky0 + B * ky1,
        z = A * sy0 + B * sy1;
    return [
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(y, x) * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */],
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(z, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])(x * x + y * y)) * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */]
    ];
  } : function() {
    return [x0 * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */], y0 * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */]];
  };

  interpolate.distance = d;

  return interpolate;
});


/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noop__ = __webpack_require__(50);




var areaSum = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    areaRingSum = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    x00,
    y00,
    x0,
    y0;

var areaStream = {
  point: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineStart: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineEnd: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  polygonStart: function() {
    areaStream.lineStart = areaRingStart;
    areaStream.lineEnd = areaRingEnd;
  },
  polygonEnd: function() {
    areaStream.lineStart = areaStream.lineEnd = areaStream.point = __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */];
    areaSum.add(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])(areaRingSum));
    areaRingSum.reset();
  },
  result: function() {
    var area = areaSum / 2;
    areaSum.reset();
    return area;
  }
};

function areaRingStart() {
  areaStream.point = areaPointFirst;
}

function areaPointFirst(x, y) {
  areaStream.point = areaPoint;
  x00 = x0 = x, y00 = y0 = y;
}

function areaPoint(x, y) {
  areaRingSum.add(y0 * x - x0 * y);
  x0 = x, y0 = y;
}

function areaRingEnd() {
  areaPoint(x00, y00);
}

/* harmony default export */ __webpack_exports__["a"] = (areaStream);


/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);


// TODO Enforce positive area for exterior, negative area for interior?

var X0 = 0,
    Y0 = 0,
    Z0 = 0,
    X1 = 0,
    Y1 = 0,
    Z1 = 0,
    X2 = 0,
    Y2 = 0,
    Z2 = 0,
    x00,
    y00,
    x0,
    y0;

var centroidStream = {
  point: centroidPoint,
  lineStart: centroidLineStart,
  lineEnd: centroidLineEnd,
  polygonStart: function() {
    centroidStream.lineStart = centroidRingStart;
    centroidStream.lineEnd = centroidRingEnd;
  },
  polygonEnd: function() {
    centroidStream.point = centroidPoint;
    centroidStream.lineStart = centroidLineStart;
    centroidStream.lineEnd = centroidLineEnd;
  },
  result: function() {
    var centroid = Z2 ? [X2 / Z2, Y2 / Z2]
        : Z1 ? [X1 / Z1, Y1 / Z1]
        : Z0 ? [X0 / Z0, Y0 / Z0]
        : [NaN, NaN];
    X0 = Y0 = Z0 =
    X1 = Y1 = Z1 =
    X2 = Y2 = Z2 = 0;
    return centroid;
  }
};

function centroidPoint(x, y) {
  X0 += x;
  Y0 += y;
  ++Z0;
}

function centroidLineStart() {
  centroidStream.point = centroidPointFirstLine;
}

function centroidPointFirstLine(x, y) {
  centroidStream.point = centroidPointLine;
  centroidPoint(x0 = x, y0 = y);
}

function centroidPointLine(x, y) {
  var dx = x - x0, dy = y - y0, z = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])(dx * dx + dy * dy);
  X1 += z * (x0 + x) / 2;
  Y1 += z * (y0 + y) / 2;
  Z1 += z;
  centroidPoint(x0 = x, y0 = y);
}

function centroidLineEnd() {
  centroidStream.point = centroidPoint;
}

function centroidRingStart() {
  centroidStream.point = centroidPointFirstRing;
}

function centroidRingEnd() {
  centroidPointRing(x00, y00);
}

function centroidPointFirstRing(x, y) {
  centroidStream.point = centroidPointRing;
  centroidPoint(x00 = x0 = x, y00 = y0 = y);
}

function centroidPointRing(x, y) {
  var dx = x - x0,
      dy = y - y0,
      z = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])(dx * dx + dy * dy);

  X1 += z * (x0 + x) / 2;
  Y1 += z * (y0 + y) / 2;
  Z1 += z;

  z = y0 * x - x0 * y;
  X2 += z * (x0 + x);
  Y2 += z * (y0 + y);
  Z2 += z * 3;
  centroidPoint(x0 = x, y0 = y);
}

/* harmony default export */ __webpack_exports__["a"] = (centroidStream);


/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PathContext;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop__ = __webpack_require__(50);



function PathContext(context) {
  this._context = context;
}

PathContext.prototype = {
  _radius: 4.5,
  pointRadius: function(_) {
    return this._radius = _, this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0) this._context.closePath();
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._context.moveTo(x, y);
        this._point = 1;
        break;
      }
      case 1: {
        this._context.lineTo(x, y);
        break;
      }
      default: {
        this._context.moveTo(x + this._radius, y);
        this._context.arc(x, y, this._radius, 0, __WEBPACK_IMPORTED_MODULE_0__math__["b" /* tau */]);
        break;
      }
    }
  },
  result: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */]
};


/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stream__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__area__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bounds__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__centroid__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__context__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__measure__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__string__ = __webpack_require__(772);









/* harmony default export */ __webpack_exports__["a"] = (function(projection, context) {
  var pointRadius = 4.5,
      projectionStream,
      contextStream;

  function path(object) {
    if (object) {
      if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(contextStream));
    }
    return contextStream.result();
  }

  path.area = function(object) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_2__area__["a" /* default */]));
    return __WEBPACK_IMPORTED_MODULE_2__area__["a" /* default */].result();
  };

  path.measure = function(object) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_6__measure__["a" /* default */]));
    return __WEBPACK_IMPORTED_MODULE_6__measure__["a" /* default */].result();
  };

  path.bounds = function(object) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_3__bounds__["a" /* default */]));
    return __WEBPACK_IMPORTED_MODULE_3__bounds__["a" /* default */].result();
  };

  path.centroid = function(object) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_4__centroid__["a" /* default */]));
    return __WEBPACK_IMPORTED_MODULE_4__centroid__["a" /* default */].result();
  };

  path.projection = function(_) {
    return arguments.length ? (projectionStream = _ == null ? (projection = null, __WEBPACK_IMPORTED_MODULE_0__identity__["a" /* default */]) : (projection = _).stream, path) : projection;
  };

  path.context = function(_) {
    if (!arguments.length) return context;
    contextStream = _ == null ? (context = null, new __WEBPACK_IMPORTED_MODULE_7__string__["a" /* default */]) : new __WEBPACK_IMPORTED_MODULE_5__context__["a" /* default */](context = _);
    if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
    return path;
  };

  path.pointRadius = function(_) {
    if (!arguments.length) return pointRadius;
    pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
    return path;
  };

  return path.projection(projection).context(context);
});


/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noop__ = __webpack_require__(50);




var lengthSum = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    lengthRing,
    x00,
    y00,
    x0,
    y0;

var lengthStream = {
  point: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineStart: function() {
    lengthStream.point = lengthPointFirst;
  },
  lineEnd: function() {
    if (lengthRing) lengthPoint(x00, y00);
    lengthStream.point = __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */];
  },
  polygonStart: function() {
    lengthRing = true;
  },
  polygonEnd: function() {
    lengthRing = null;
  },
  result: function() {
    var length = +lengthSum;
    lengthSum.reset();
    return length;
  }
};

function lengthPointFirst(x, y) {
  lengthStream.point = lengthPoint;
  x00 = x0 = x, y00 = y0 = y;
}

function lengthPoint(x, y) {
  x0 -= x, y0 -= y;
  lengthSum.add(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["n" /* sqrt */])(x0 * x0 + y0 * y0));
  x0 = x, y0 = y;
}

/* harmony default export */ __webpack_exports__["a"] = (lengthStream);


/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PathString;
function PathString() {
  this._string = [];
}

PathString.prototype = {
  _radius: 4.5,
  _circle: circle(4.5),
  pointRadius: function(_) {
    if ((_ = +_) !== this._radius) this._radius = _, this._circle = null;
    return this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0) this._string.push("Z");
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._string.push("M", x, ",", y);
        this._point = 1;
        break;
      }
      case 1: {
        this._string.push("L", x, ",", y);
        break;
      }
      default: {
        if (this._circle == null) this._circle = circle(this._radius);
        this._string.push("M", x, ",", y, this._circle);
        break;
      }
    }
  },
  result: function() {
    if (this._string.length) {
      var result = this._string.join("");
      this._string = [];
      return result;
    } else {
      return null;
    }
  }
};

function circle(radius) {
  return "m0," + radius
      + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius
      + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius
      + "z";
}


/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__albers__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__conicEqualArea__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fit__ = __webpack_require__(195);





// The projections must have mutually exclusive clip regions on the sphere,
// as this will avoid emitting interleaving lines and polygons.
function multiplex(streams) {
  var n = streams.length;
  return {
    point: function(x, y) { var i = -1; while (++i < n) streams[i].point(x, y); },
    sphere: function() { var i = -1; while (++i < n) streams[i].sphere(); },
    lineStart: function() { var i = -1; while (++i < n) streams[i].lineStart(); },
    lineEnd: function() { var i = -1; while (++i < n) streams[i].lineEnd(); },
    polygonStart: function() { var i = -1; while (++i < n) streams[i].polygonStart(); },
    polygonEnd: function() { var i = -1; while (++i < n) streams[i].polygonEnd(); }
  };
}

// A composite projection for the United States, configured by default for
// 960×500. The projection also works quite well at 960×600 if you change the
// scale to 1285 and adjust the translate accordingly. The set of standard
// parallels for each region comes from USGS, which is published here:
// http://egsc.usgs.gov/isb/pubs/MapProjections/projections.html#albers
/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var cache,
      cacheStream,
      lower48 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__albers__["a" /* default */])(), lower48Point,
      alaska = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__conicEqualArea__["a" /* default */])().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), alaskaPoint, // EPSG:3338
      hawaii = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__conicEqualArea__["a" /* default */])().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), hawaiiPoint, // ESRI:102007
      point, pointStream = {point: function(x, y) { point = [x, y]; }};

  function albersUsa(coordinates) {
    var x = coordinates[0], y = coordinates[1];
    return point = null,
        (lower48Point.point(x, y), point)
        || (alaskaPoint.point(x, y), point)
        || (hawaiiPoint.point(x, y), point);
  }

  albersUsa.invert = function(coordinates) {
    var k = lower48.scale(),
        t = lower48.translate(),
        x = (coordinates[0] - t[0]) / k,
        y = (coordinates[1] - t[1]) / k;
    return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska
        : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii
        : lower48).invert(coordinates);
  };

  albersUsa.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = multiplex([lower48.stream(cacheStream = stream), alaska.stream(stream), hawaii.stream(stream)]);
  };

  albersUsa.precision = function(_) {
    if (!arguments.length) return lower48.precision();
    lower48.precision(_), alaska.precision(_), hawaii.precision(_);
    return reset();
  };

  albersUsa.scale = function(_) {
    if (!arguments.length) return lower48.scale();
    lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
    return albersUsa.translate(lower48.translate());
  };

  albersUsa.translate = function(_) {
    if (!arguments.length) return lower48.translate();
    var k = lower48.scale(), x = +_[0], y = +_[1];

    lower48Point = lower48
        .translate(_)
        .clipExtent([[x - 0.455 * k, y - 0.238 * k], [x + 0.455 * k, y + 0.238 * k]])
        .stream(pointStream);

    alaskaPoint = alaska
        .translate([x - 0.307 * k, y + 0.201 * k])
        .clipExtent([[x - 0.425 * k + __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */], y + 0.120 * k + __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */]], [x - 0.214 * k - __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */], y + 0.234 * k - __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */]]])
        .stream(pointStream);

    hawaiiPoint = hawaii
        .translate([x - 0.205 * k, y + 0.212 * k])
        .clipExtent([[x - 0.214 * k + __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */], y + 0.166 * k + __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */]], [x - 0.115 * k - __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */], y + 0.234 * k - __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */]]])
        .stream(pointStream);

    return reset();
  };

  albersUsa.fitExtent = function(extent, object) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__fit__["a" /* fitExtent */])(albersUsa, extent, object);
  };

  albersUsa.fitSize = function(size, object) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__fit__["b" /* fitSize */])(albersUsa, size, object);
  };

  function reset() {
    cache = cacheStream = null;
    return albersUsa;
  }

  return albersUsa.scale(1070);
});


/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export azimuthalEqualAreaRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(41);




var azimuthalEqualAreaRaw = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["b" /* azimuthalRaw */])(function(cxcy) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])(2 / (1 + cxcy));
});

azimuthalEqualAreaRaw.invert = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(function(z) {
  return 2 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["f" /* asin */])(z / 2);
});

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(azimuthalEqualAreaRaw)
      .scale(124.75)
      .clipAngle(180 - 1e-3);
});


/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export azimuthalEquidistantRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(41);




var azimuthalEquidistantRaw = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["b" /* azimuthalRaw */])(function(c) {
  return (c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["r" /* acos */])(c)) && c / __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(c);
});

azimuthalEquidistantRaw.invert = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(function(z) {
  return z;
});

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(azimuthalEquidistantRaw)
      .scale(79.4188)
      .clipAngle(180 - 1e-3);
});


/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export conicConformalRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conic__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mercator__ = __webpack_require__(196);




function tany(y) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["j" /* tan */])((__WEBPACK_IMPORTED_MODULE_0__math__["k" /* halfPi */] + y) / 2);
}

function conicConformalRaw(y0, y1) {
  var cy0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(y0),
      n = y0 === y1 ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(y0) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["i" /* log */])(cy0 / __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(y1)) / __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["i" /* log */])(tany(y1) / tany(y0)),
      f = cy0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* pow */])(tany(y0), n) / n;

  if (!n) return __WEBPACK_IMPORTED_MODULE_2__mercator__["b" /* mercatorRaw */];

  function project(x, y) {
    if (f > 0) { if (y < -__WEBPACK_IMPORTED_MODULE_0__math__["k" /* halfPi */] + __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */]) y = -__WEBPACK_IMPORTED_MODULE_0__math__["k" /* halfPi */] + __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */]; }
    else { if (y > __WEBPACK_IMPORTED_MODULE_0__math__["k" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */]) y = __WEBPACK_IMPORTED_MODULE_0__math__["k" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */]; }
    var r = f / __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* pow */])(tany(y), n);
    return [r * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(n * x), f - r * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(n * x)];
  }

  project.invert = function(x, y) {
    var fy = f - y, r = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(n) * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])(x * x + fy * fy);
    return [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(x, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["o" /* abs */])(fy)) / n * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(fy), 2 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["l" /* atan */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* pow */])(f / r, 1 / n)) - __WEBPACK_IMPORTED_MODULE_0__math__["k" /* halfPi */]];
  };

  return project;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__conic__["a" /* conicProjection */])(conicConformalRaw)
      .scale(109.5)
      .parallels([30, 30]);
});


/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export conicEquidistantRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conic__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__equirectangular__ = __webpack_require__(341);




function conicEquidistantRaw(y0, y1) {
  var cy0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(y0),
      n = y0 === y1 ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(y0) : (cy0 - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(y1)) / (y1 - y0),
      g = cy0 / n + y0;

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["o" /* abs */])(n) < __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */]) return __WEBPACK_IMPORTED_MODULE_2__equirectangular__["a" /* equirectangularRaw */];

  function project(x, y) {
    var gy = g - y, nx = n * x;
    return [gy * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(nx), g - gy * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(nx)];
  }

  project.invert = function(x, y) {
    var gy = g - y;
    return [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(x, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["o" /* abs */])(gy)) / n * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(gy), g - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(n) * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])(x * x + gy * gy)];
  };

  return project;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__conic__["a" /* conicProjection */])(conicEquidistantRaw)
      .scale(131.154)
      .center([0, 13.9389]);
});


/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cylindricalEqualAreaRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);


function cylindricalEqualAreaRaw(phi0) {
  var cosPhi0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(phi0);

  function forward(lambda, phi) {
    return [lambda * cosPhi0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(phi) / cosPhi0];
  }

  forward.invert = function(x, y) {
    return [x / cosPhi0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["f" /* asin */])(y * cosPhi0)];
  };

  return forward;
}


/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gnomonicRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(41);




function gnomonicRaw(x, y) {
  var cy = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(y), k = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(x) * cy;
  return [cy * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(x) / k, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(y) / k];
}

gnomonicRaw.invert = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(__WEBPACK_IMPORTED_MODULE_0__math__["l" /* atan */]);

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(gnomonicRaw)
      .scale(144.049)
      .clipAngle(60);
});


/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__clip_extent__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__identity__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transform__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fit__ = __webpack_require__(195);





function scaleTranslate(kx, ky, tx, ty) {
  return kx === 1 && ky === 1 && tx === 0 && ty === 0 ? __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */] : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__transform__["a" /* transformer */])({
    point: function(x, y) {
      this.stream.point(x * kx + tx, y * ky + ty);
    }
  });
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, transform = __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */], // scale, translate and reflect
      x0 = null, y0, x1, y1, clip = __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */], // clip extent
      cache,
      cacheStream,
      projection;

  function reset() {
    cache = cacheStream = null;
    return projection;
  }

  return projection = {
    stream: function(stream) {
      return cache && cacheStream === stream ? cache : cache = transform(clip(cacheStream = stream));
    },
    clipExtent: function(_) {
      return arguments.length ? (clip = _ == null ? (x0 = y0 = x1 = y1 = null, __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */]) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__clip_extent__["a" /* clipExtent */])(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
    },
    scale: function(_) {
      return arguments.length ? (transform = scaleTranslate((k = +_) * sx, k * sy, tx, ty), reset()) : k;
    },
    translate: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * sx, k * sy, tx = +_[0], ty = +_[1]), reset()) : [tx, ty];
    },
    reflectX: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * (sx = _ ? -1 : 1), k * sy, tx, ty), reset()) : sx < 0;
    },
    reflectY: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * sx, k * (sy = _ ? -1 : 1), tx, ty), reset()) : sy < 0;
    },
    fitExtent: function(extent, object) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__fit__["a" /* fitExtent */])(projection, extent, object);
    },
    fitSize: function(size, object) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__fit__["b" /* fitSize */])(projection, size, object);
    }
  };
});


/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export orthographicRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(41);




function orthographicRaw(x, y) {
  return [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(y) * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(x), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(y)];
}

orthographicRaw.invert = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(__WEBPACK_IMPORTED_MODULE_0__math__["f" /* asin */]);

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(orthographicRaw)
      .scale(249.5)
      .clipAngle(90 + __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */]);
});


/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cartesian__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transform__ = __webpack_require__(128);




var maxDepth = 16, // maximum depth of subdivision
    cosMinDistance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(30 * __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */]); // cos(minimum angular distance)

/* harmony default export */ __webpack_exports__["a"] = (function(project, delta2) {
  return +delta2 ? resample(project, delta2) : resampleNone(project);
});

function resampleNone(project) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__transform__["a" /* transformer */])({
    point: function(x, y) {
      x = project(x, y);
      this.stream.point(x[0], x[1]);
    }
  });
}

function resample(project, delta2) {

  function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
    var dx = x1 - x0,
        dy = y1 - y0,
        d2 = dx * dx + dy * dy;
    if (d2 > 4 * delta2 && depth--) {
      var a = a0 + a1,
          b = b0 + b1,
          c = c0 + c1,
          m = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["n" /* sqrt */])(a * a + b * b + c * c),
          phi2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* asin */])(c /= m),
          lambda2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])(c) - 1) < __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */] || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])(lambda0 - lambda1) < __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */] ? (lambda0 + lambda1) / 2 : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(b, a),
          p = project(lambda2, phi2),
          x2 = p[0],
          y2 = p[1],
          dx2 = x2 - x0,
          dy2 = y2 - y0,
          dz = dy * dx2 - dx * dy2;
      if (dz * dz / d2 > delta2 // perpendicular projected distance
          || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
          || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) { // angular distance
        resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
        stream.point(x2, y2);
        resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
      }
    }
  }
  return function(stream) {
    var lambda00, x00, y00, a00, b00, c00, // first point
        lambda0, x0, y0, a0, b0, c0; // previous point

    var resampleStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() { stream.polygonStart(); resampleStream.lineStart = ringStart; },
      polygonEnd: function() { stream.polygonEnd(); resampleStream.lineStart = lineStart; }
    };

    function point(x, y) {
      x = project(x, y);
      stream.point(x[0], x[1]);
    }

    function lineStart() {
      x0 = NaN;
      resampleStream.point = linePoint;
      stream.lineStart();
    }

    function linePoint(lambda, phi) {
      var c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["a" /* cartesian */])([lambda, phi]), p = project(lambda, phi);
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
      stream.point(x0, y0);
    }

    function lineEnd() {
      resampleStream.point = point;
      stream.lineEnd();
    }

    function ringStart() {
      lineStart();
      resampleStream.point = ringPoint;
      resampleStream.lineEnd = ringEnd;
    }

    function ringPoint(lambda, phi) {
      linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
      resampleStream.point = linePoint;
    }

    function ringEnd() {
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
      resampleStream.lineEnd = lineEnd;
      lineEnd();
    }

    return resampleStream;
  };
}


/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export stereographicRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(41);




function stereographicRaw(x, y) {
  var cy = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(y), k = 1 + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(x) * cy;
  return [cy * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(x) / k, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(y) / k];
}

stereographicRaw.invert = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(function(z) {
  return 2 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["l" /* atan */])(z);
});

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(stereographicRaw)
      .scale(250)
      .clipAngle(142);
});


/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export transverseMercatorRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mercator__ = __webpack_require__(196);



function transverseMercatorRaw(lambda, phi) {
  return [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["i" /* log */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["j" /* tan */])((__WEBPACK_IMPORTED_MODULE_0__math__["k" /* halfPi */] + phi) / 2)), -lambda];
}

transverseMercatorRaw.invert = function(x, y) {
  return [-y, 2 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["l" /* atan */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["m" /* exp */])(x)) - __WEBPACK_IMPORTED_MODULE_0__math__["k" /* halfPi */]];
};

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var m = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mercator__["a" /* mercatorProjection */])(transverseMercatorRaw),
      center = m.center,
      rotate = m.rotate;

  m.center = function(_) {
    return arguments.length ? center([-_[1], _[0]]) : (_ = center(), [_[1], -_[0]]);
  };

  m.rotate = function(_) {
    return arguments.length ? rotate([_[0], _[1], _.length > 2 ? _[2] + 90 : 90]) : (_ = rotate(), [_[0], _[1], _[2] - 90]);
  };

  return rotate([0, 0, 90])
      .scale(159.155);
});


/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
/* harmony export (immutable) */ __webpack_exports__["a"] = shuffle;
var slice = Array.prototype.slice;

function shuffle(array) {
  var m = array.length,
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m];
    array[m] = array[i];
    array[i] = t;
  }

  return array;
}


/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function defaultSeparation(a, b) {
  return a.parent === b.parent ? 1 : 2;
}

function meanX(children) {
  return children.reduce(meanXReduce, 0) / children.length;
}

function meanXReduce(x, c) {
  return x + c.x;
}

function maxY(children) {
  return 1 + children.reduce(maxYReduce, 0);
}

function maxYReduce(y, c) {
  return Math.max(y, c.y);
}

function leafLeft(node) {
  var children;
  while (children = node.children) node = children[0];
  return node;
}

function leafRight(node) {
  var children;
  while (children = node.children) node = children[children.length - 1];
  return node;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var separation = defaultSeparation,
      dx = 1,
      dy = 1,
      nodeSize = false;

  function cluster(root) {
    var previousNode,
        x = 0;

    // First walk, computing the initial x & y values.
    root.eachAfter(function(node) {
      var children = node.children;
      if (children) {
        node.x = meanX(children);
        node.y = maxY(children);
      } else {
        node.x = previousNode ? x += separation(node, previousNode) : 0;
        node.y = 0;
        previousNode = node;
      }
    });

    var left = leafLeft(root),
        right = leafRight(root),
        x0 = left.x - separation(left, right) / 2,
        x1 = right.x + separation(right, left) / 2;

    // Second walk, normalizing x & y to the desired size.
    return root.eachAfter(nodeSize ? function(node) {
      node.x = (node.x - root.x) * dx;
      node.y = (root.y - node.y) * dy;
    } : function(node) {
      node.x = (node.x - x0) / (x1 - x0) * dx;
      node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
    });
  }

  cluster.separation = function(x) {
    return arguments.length ? (separation = x, cluster) : separation;
  };

  cluster.size = function(x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? null : [dx, dy]);
  };

  cluster.nodeSize = function(x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? [dx, dy] : null);
  };

  return cluster;
});


/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var node = this, nodes = [node];
  while (node = node.parent) {
    nodes.push(node);
  }
  return nodes;
});


/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function count(node) {
  var sum = 0,
      children = node.children,
      i = children && children.length;
  if (!i) sum = 1;
  else while (--i >= 0) sum += children[i].value;
  node.value = sum;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.eachAfter(count);
});


/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var nodes = [];
  this.each(function(node) {
    nodes.push(node);
  });
  return nodes;
});


/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var node = this, current, next = [node], children, i, n;
  do {
    current = next.reverse(), next = [];
    while (node = current.pop()) {
      callback(node), children = node.children;
      if (children) for (i = 0, n = children.length; i < n; ++i) {
        next.push(children[i]);
      }
    }
  } while (next.length);
  return this;
});


/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var node = this, nodes = [node], next = [], children, i, n;
  while (node = nodes.pop()) {
    next.push(node), children = node.children;
    if (children) for (i = 0, n = children.length; i < n; ++i) {
      nodes.push(children[i]);
    }
  }
  while (node = next.pop()) {
    callback(node);
  }
  return this;
});


/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var node = this, nodes = [node], children, i;
  while (node = nodes.pop()) {
    callback(node), children = node.children;
    if (children) for (i = children.length - 1; i >= 0; --i) {
      nodes.push(children[i]);
    }
  }
  return this;
});


/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var leaves = [];
  this.eachBefore(function(node) {
    if (!node.children) {
      leaves.push(node);
    }
  });
  return leaves;
});


/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var root = this, links = [];
  root.each(function(node) {
    if (node !== root) { // Don’t include the root’s parent, if any.
      links.push({source: node.parent, target: node});
    }
  });
  return links;
});


/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(end) {
  var start = this,
      ancestor = leastCommonAncestor(start, end),
      nodes = [start];
  while (start !== ancestor) {
    start = start.parent;
    nodes.push(start);
  }
  var k = nodes.length;
  while (end !== ancestor) {
    nodes.splice(k, 0, end);
    end = end.parent;
  }
  return nodes;
});

function leastCommonAncestor(a, b) {
  if (a === b) return a;
  var aNodes = a.ancestors(),
      bNodes = b.ancestors(),
      c = null;
  a = aNodes.pop();
  b = bNodes.pop();
  while (a === b) {
    c = a;
    a = aNodes.pop();
    b = bNodes.pop();
  }
  return c;
}


/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  return this.eachBefore(function(node) {
    if (node.children) {
      node.children.sort(compare);
    }
  });
});


/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return this.eachAfter(function(node) {
    var sum = +value(node.data) || 0,
        children = node.children,
        i = children && children.length;
    while (--i >= 0) sum += children[i].value;
    node.value = sum;
  });
});


/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__siblings__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessors__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(343);




function defaultRadius(d) {
  return Math.sqrt(d.value);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var radius = null,
      dx = 1,
      dy = 1,
      padding = __WEBPACK_IMPORTED_MODULE_2__constant__["a" /* constantZero */];

  function pack(root) {
    root.x = dx / 2, root.y = dy / 2;
    if (radius) {
      root.eachBefore(radiusLeaf(radius))
          .eachAfter(packChildren(padding, 0.5))
          .eachBefore(translateChild(1));
    } else {
      root.eachBefore(radiusLeaf(defaultRadius))
          .eachAfter(packChildren(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* constantZero */], 1))
          .eachAfter(packChildren(padding, root.r / Math.min(dx, dy)))
          .eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
    }
    return root;
  }

  pack.radius = function(x) {
    return arguments.length ? (radius = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__accessors__["b" /* optional */])(x), pack) : radius;
  };

  pack.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [dx, dy];
  };

  pack.padding = function(x) {
    return arguments.length ? (padding = typeof x === "function" ? x : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["b" /* default */])(+x), pack) : padding;
  };

  return pack;
});

function radiusLeaf(radius) {
  return function(node) {
    if (!node.children) {
      node.r = Math.max(0, +radius(node) || 0);
    }
  };
}

function packChildren(padding, k) {
  return function(node) {
    if (children = node.children) {
      var children,
          i,
          n = children.length,
          r = padding(node) * k || 0,
          e;

      if (r) for (i = 0; i < n; ++i) children[i].r += r;
      e = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__siblings__["a" /* packEnclose */])(children);
      if (r) for (i = 0; i < n; ++i) children[i].r -= r;
      node.r = e + r;
    }
  };
}

function translateChild(k) {
  return function(node) {
    var parent = node.parent;
    node.r *= k;
    if (parent) {
      node.x = parent.x + k * node.x;
      node.y = parent.y + k * node.y;
    }
  };
}


/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__treemap_round__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__treemap_dice__ = __webpack_require__(94);



/* harmony default export */ __webpack_exports__["a"] = (function() {
  var dx = 1,
      dy = 1,
      padding = 0,
      round = false;

  function partition(root) {
    var n = root.height + 1;
    root.x0 =
    root.y0 = padding;
    root.x1 = dx;
    root.y1 = dy / n;
    root.eachBefore(positionNode(dy, n));
    if (round) root.eachBefore(__WEBPACK_IMPORTED_MODULE_0__treemap_round__["a" /* default */]);
    return root;
  }

  function positionNode(dy, n) {
    return function(node) {
      if (node.children) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__treemap_dice__["a" /* default */])(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
      }
      var x0 = node.x0,
          y0 = node.y0,
          x1 = node.x1 - padding,
          y1 = node.y1 - padding;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      node.x0 = x0;
      node.y0 = y0;
      node.x1 = x1;
      node.y1 = y1;
    };
  }

  partition.round = function(x) {
    return arguments.length ? (round = !!x, partition) : round;
  };

  partition.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [dx, dy];
  };

  partition.padding = function(x) {
    return arguments.length ? (padding = +x, partition) : padding;
  };

  return partition;
});


/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__accessors__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hierarchy_index__ = __webpack_require__(198);



var keyPrefix = "$", // Protect against keys like “__proto__”.
    preroot = {depth: -1},
    ambiguous = {};

function defaultId(d) {
  return d.id;
}

function defaultParentId(d) {
  return d.parentId;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var id = defaultId,
      parentId = defaultParentId;

  function stratify(data) {
    var d,
        i,
        n = data.length,
        root,
        parent,
        node,
        nodes = new Array(n),
        nodeId,
        nodeKey,
        nodeByKey = {};

    for (i = 0; i < n; ++i) {
      d = data[i], node = nodes[i] = new __WEBPACK_IMPORTED_MODULE_1__hierarchy_index__["b" /* Node */](d);
      if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
        nodeKey = keyPrefix + (node.id = nodeId);
        nodeByKey[nodeKey] = nodeKey in nodeByKey ? ambiguous : node;
      }
    }

    for (i = 0; i < n; ++i) {
      node = nodes[i], nodeId = parentId(data[i], i, data);
      if (nodeId == null || !(nodeId += "")) {
        if (root) throw new Error("multiple roots");
        root = node;
      } else {
        parent = nodeByKey[keyPrefix + nodeId];
        if (!parent) throw new Error("missing: " + nodeId);
        if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
        if (parent.children) parent.children.push(node);
        else parent.children = [node];
        node.parent = parent;
      }
    }

    if (!root) throw new Error("no root");
    root.parent = preroot;
    root.eachBefore(function(node) { node.depth = node.parent.depth + 1; --n; }).eachBefore(__WEBPACK_IMPORTED_MODULE_1__hierarchy_index__["c" /* computeHeight */]);
    root.parent = null;
    if (n > 0) throw new Error("cycle");

    return root;
  }

  stratify.id = function(x) {
    return arguments.length ? (id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__accessors__["a" /* required */])(x), stratify) : id;
  };

  stratify.parentId = function(x) {
    return arguments.length ? (parentId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__accessors__["a" /* required */])(x), stratify) : parentId;
  };

  return stratify;
});


/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hierarchy_index__ = __webpack_require__(198);


function defaultSeparation(a, b) {
  return a.parent === b.parent ? 1 : 2;
}

// function radialSeparation(a, b) {
//   return (a.parent === b.parent ? 1 : 2) / a.depth;
// }

// This function is used to traverse the left contour of a subtree (or
// subforest). It returns the successor of v on this contour. This successor is
// either given by the leftmost child of v or by the thread of v. The function
// returns null if and only if v is on the highest level of its subtree.
function nextLeft(v) {
  var children = v.children;
  return children ? children[0] : v.t;
}

// This function works analogously to nextLeft.
function nextRight(v) {
  var children = v.children;
  return children ? children[children.length - 1] : v.t;
}

// Shifts the current subtree rooted at w+. This is done by increasing
// prelim(w+) and mod(w+) by shift.
function moveSubtree(wm, wp, shift) {
  var change = shift / (wp.i - wm.i);
  wp.c -= change;
  wp.s += shift;
  wm.c += change;
  wp.z += shift;
  wp.m += shift;
}

// All other shifts, applied to the smaller subtrees between w- and w+, are
// performed by this function. To prepare the shifts, we have to adjust
// change(w+), shift(w+), and change(w-).
function executeShifts(v) {
  var shift = 0,
      change = 0,
      children = v.children,
      i = children.length,
      w;
  while (--i >= 0) {
    w = children[i];
    w.z += shift;
    w.m += shift;
    shift += w.s + (change += w.c);
  }
}

// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
// returns the specified (default) ancestor.
function nextAncestor(vim, v, ancestor) {
  return vim.a.parent === v.parent ? vim.a : ancestor;
}

function TreeNode(node, i) {
  this._ = node;
  this.parent = null;
  this.children = null;
  this.A = null; // default ancestor
  this.a = this; // ancestor
  this.z = 0; // prelim
  this.m = 0; // mod
  this.c = 0; // change
  this.s = 0; // shift
  this.t = null; // thread
  this.i = i; // number
}

TreeNode.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_0__hierarchy_index__["b" /* Node */].prototype);

function treeRoot(root) {
  var tree = new TreeNode(root, 0),
      node,
      nodes = [tree],
      child,
      children,
      i,
      n;

  while (node = nodes.pop()) {
    if (children = node._.children) {
      node.children = new Array(n = children.length);
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = node.children[i] = new TreeNode(children[i], i));
        child.parent = node;
      }
    }
  }

  (tree.parent = new TreeNode(null, 0)).children = [tree];
  return tree;
}

// Node-link tree diagram using the Reingold-Tilford "tidy" algorithm
/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var separation = defaultSeparation,
      dx = 1,
      dy = 1,
      nodeSize = null;

  function tree(root) {
    var t = treeRoot(root);

    // Compute the layout using Buchheim et al.’s algorithm.
    t.eachAfter(firstWalk), t.parent.m = -t.z;
    t.eachBefore(secondWalk);

    // If a fixed node size is specified, scale x and y.
    if (nodeSize) root.eachBefore(sizeNode);

    // If a fixed tree size is specified, scale x and y based on the extent.
    // Compute the left-most, right-most, and depth-most nodes for extents.
    else {
      var left = root,
          right = root,
          bottom = root;
      root.eachBefore(function(node) {
        if (node.x < left.x) left = node;
        if (node.x > right.x) right = node;
        if (node.depth > bottom.depth) bottom = node;
      });
      var s = left === right ? 1 : separation(left, right) / 2,
          tx = s - left.x,
          kx = dx / (right.x + s + tx),
          ky = dy / (bottom.depth || 1);
      root.eachBefore(function(node) {
        node.x = (node.x + tx) * kx;
        node.y = node.depth * ky;
      });
    }

    return root;
  }

  // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
  // applied recursively to the children of v, as well as the function
  // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
  // node v is placed to the midpoint of its outermost children.
  function firstWalk(v) {
    var children = v.children,
        siblings = v.parent.children,
        w = v.i ? siblings[v.i - 1] : null;
    if (children) {
      executeShifts(v);
      var midpoint = (children[0].z + children[children.length - 1].z) / 2;
      if (w) {
        v.z = w.z + separation(v._, w._);
        v.m = v.z - midpoint;
      } else {
        v.z = midpoint;
      }
    } else if (w) {
      v.z = w.z + separation(v._, w._);
    }
    v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
  }

  // Computes all real x-coordinates by summing up the modifiers recursively.
  function secondWalk(v) {
    v._.x = v.z + v.parent.m;
    v.m += v.parent.m;
  }

  // The core of the algorithm. Here, a new subtree is combined with the
  // previous subtrees. Threads are used to traverse the inside and outside
  // contours of the left and right subtree up to the highest common level. The
  // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
  // superscript o means outside and i means inside, the subscript - means left
  // subtree and + means right subtree. For summing up the modifiers along the
  // contour, we use respective variables si+, si-, so-, and so+. Whenever two
  // nodes of the inside contours conflict, we compute the left one of the
  // greatest uncommon ancestors using the function ANCESTOR and call MOVE
  // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
  // Finally, we add a new thread (if necessary).
  function apportion(v, w, ancestor) {
    if (w) {
      var vip = v,
          vop = v,
          vim = w,
          vom = vip.parent.children[0],
          sip = vip.m,
          sop = vop.m,
          sim = vim.m,
          som = vom.m,
          shift;
      while (vim = nextRight(vim), vip = nextLeft(vip), vim && vip) {
        vom = nextLeft(vom);
        vop = nextRight(vop);
        vop.a = v;
        shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
        if (shift > 0) {
          moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
          sip += shift;
          sop += shift;
        }
        sim += vim.m;
        sip += vip.m;
        som += vom.m;
        sop += vop.m;
      }
      if (vim && !nextRight(vop)) {
        vop.t = vim;
        vop.m += sim - sop;
      }
      if (vip && !nextLeft(vom)) {
        vom.t = vip;
        vom.m += sip - som;
        ancestor = v;
      }
    }
    return ancestor;
  }

  function sizeNode(node) {
    node.x *= dx;
    node.y = node.depth * dy;
  }

  tree.separation = function(x) {
    return arguments.length ? (separation = x, tree) : separation;
  };

  tree.size = function(x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : (nodeSize ? null : [dx, dy]);
  };

  tree.nodeSize = function(x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : (nodeSize ? [dx, dy] : null);
  };

  return tree;
});


/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      i, n = nodes.length,
      sum, sums = new Array(n + 1);

  for (sums[0] = sum = i = 0; i < n; ++i) {
    sums[i + 1] = sum += nodes[i].value;
  }

  partition(0, n, parent.value, x0, y0, x1, y1);

  function partition(i, j, value, x0, y0, x1, y1) {
    if (i >= j - 1) {
      var node = nodes[i];
      node.x0 = x0, node.y0 = y0;
      node.x1 = x1, node.y1 = y1;
      return;
    }

    var valueOffset = sums[i],
        valueTarget = (value / 2) + valueOffset,
        k = i + 1,
        hi = j - 1;

    while (k < hi) {
      var mid = k + hi >>> 1;
      if (sums[mid] < valueTarget) k = mid + 1;
      else hi = mid;
    }

    if ((valueTarget - sums[k - 1]) < (sums[k] - valueTarget) && i + 1 < k) --k;

    var valueLeft = sums[k] - valueOffset,
        valueRight = value - valueLeft;

    if ((x1 - x0) > (y1 - y0)) {
      var xk = (x0 * valueRight + x1 * valueLeft) / value;
      partition(i, k, valueLeft, x0, y0, xk, y1);
      partition(k, j, valueRight, xk, y0, x1, y1);
    } else {
      var yk = (y0 * valueRight + y1 * valueLeft) / value;
      partition(i, k, valueLeft, x0, y0, x1, yk);
      partition(k, j, valueRight, x0, yk, x1, y1);
    }
  }
});


/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__round__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__squarify__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__accessors__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__(343);





/* harmony default export */ __webpack_exports__["a"] = (function() {
  var tile = __WEBPACK_IMPORTED_MODULE_1__squarify__["c" /* default */],
      round = false,
      dx = 1,
      dy = 1,
      paddingStack = [0],
      paddingInner = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */],
      paddingTop = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */],
      paddingRight = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */],
      paddingBottom = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */],
      paddingLeft = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */];

  function treemap(root) {
    root.x0 =
    root.y0 = 0;
    root.x1 = dx;
    root.y1 = dy;
    root.eachBefore(positionNode);
    paddingStack = [0];
    if (round) root.eachBefore(__WEBPACK_IMPORTED_MODULE_0__round__["a" /* default */]);
    return root;
  }

  function positionNode(node) {
    var p = paddingStack[node.depth],
        x0 = node.x0 + p,
        y0 = node.y0 + p,
        x1 = node.x1 - p,
        y1 = node.y1 - p;
    if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
    if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
    node.x0 = x0;
    node.y0 = y0;
    node.x1 = x1;
    node.y1 = y1;
    if (node.children) {
      p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
      x0 += paddingLeft(node) - p;
      y0 += paddingTop(node) - p;
      x1 -= paddingRight(node) - p;
      y1 -= paddingBottom(node) - p;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      tile(node, x0, y0, x1, y1);
    }
  }

  treemap.round = function(x) {
    return arguments.length ? (round = !!x, treemap) : round;
  };

  treemap.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [dx, dy];
  };

  treemap.tile = function(x) {
    return arguments.length ? (tile = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__accessors__["a" /* required */])(x), treemap) : tile;
  };

  treemap.padding = function(x) {
    return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
  };

  treemap.paddingInner = function(x) {
    return arguments.length ? (paddingInner = typeof x === "function" ? x : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingInner;
  };

  treemap.paddingOuter = function(x) {
    return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
  };

  treemap.paddingTop = function(x) {
    return arguments.length ? (paddingTop = typeof x === "function" ? x : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingTop;
  };

  treemap.paddingRight = function(x) {
    return arguments.length ? (paddingRight = typeof x === "function" ? x : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingRight;
  };

  treemap.paddingBottom = function(x) {
    return arguments.length ? (paddingBottom = typeof x === "function" ? x : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingBottom;
  };

  treemap.paddingLeft = function(x) {
    return arguments.length ? (paddingLeft = typeof x === "function" ? x : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingLeft;
  };

  return treemap;
});


/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dice__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slice__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__squarify__ = __webpack_require__(199);




/* harmony default export */ __webpack_exports__["a"] = ((function custom(ratio) {

  function resquarify(parent, x0, y0, x1, y1) {
    if ((rows = parent._squarify) && (rows.ratio === ratio)) {
      var rows,
          row,
          nodes,
          i,
          j = -1,
          n,
          m = rows.length,
          value = parent.value;

      while (++j < m) {
        row = rows[j], nodes = row.children;
        for (i = row.value = 0, n = nodes.length; i < n; ++i) row.value += nodes[i].value;
        if (row.dice) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dice__["a" /* default */])(row, x0, y0, x1, y0 += (y1 - y0) * row.value / value);
        else __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__slice__["a" /* default */])(row, x0, y0, x0 += (x1 - x0) * row.value / value, y1);
        value -= row.value;
      }
    } else {
      parent._squarify = rows = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__squarify__["a" /* squarifyRatio */])(ratio, parent, x0, y0, x1, y1);
      rows.ratio = ratio;
    }
  }

  resquarify.ratio = function(x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return resquarify;
})(__WEBPACK_IMPORTED_MODULE_2__squarify__["b" /* phi */]));


/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dice__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slice__ = __webpack_require__(129);



/* harmony default export */ __webpack_exports__["a"] = (function(parent, x0, y0, x1, y1) {
  (parent.depth & 1 ? __WEBPACK_IMPORTED_MODULE_1__slice__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_0__dice__["a" /* default */])(parent, x0, y0, x1, y1);
});


/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cubehelixLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(95);



function cubehelix(hue) {
  return (function cubehelixGamma(y) {
    y = +y;

    function cubehelix(start, end) {
      var h = hue((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(start)).h, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(end)).h),
          s = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
          l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
          opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
      return function(t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + "";
      };
    }

    cubehelix.gamma = cubehelixGamma;

    return cubehelix;
  })(1);
}

/* unused harmony default export */ var _unused_webpack_default_export = (cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["b" /* hue */]));
var cubehelixLong = cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hclLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(95);



function hcl(hue) {
  return function(start, end) {
    var h = hue((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" /* hcl */])(start)).h, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" /* hcl */])(end)).h),
        c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.c, end.c),
        l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.c = c(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (hcl(__WEBPACK_IMPORTED_MODULE_1__color__["b" /* hue */]));
var hclLong = hcl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hslLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(95);



function hsl(hue) {
  return function(start, end) {
    var h = hue((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* hsl */])(start)).h, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* hsl */])(end)).h),
        s = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
        l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.s = s(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (hsl(__WEBPACK_IMPORTED_MODULE_1__color__["b" /* hue */]));
var hslLong = hsl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(95);



function lab(start, end) {
  var l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* lab */])(start)).l, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* lab */])(end)).l),
      a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.a, end.a),
      b = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.b, end.b),
      opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
  return function(t) {
    start.l = l(t);
    start.a = a(t);
    start.b = b(t);
    start.opacity = opacity(t);
    return start + "";
  };
}


/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(interpolator, n) {
  var samples = new Array(n);
  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
  return samples;
});


/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return Math.round(a + b * t);
  };
});


/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return identity; });
var degrees = 180 / Math.PI;

var identity = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

/* harmony default export */ __webpack_exports__["b"] = (function(a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
});


/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export interpolateTransformCss */
/* unused harmony export interpolateTransformSvg */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse__ = __webpack_require__(814);



function interpolateTransform(parse, pxComma, pxParen, degParen) {

  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({i: i - 4, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({i: i - 4, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function(a, b) {
    var s = [], // string constants and placeholders
        q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["a" /* parseCss */], "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["b" /* parseSvg */], ", ", ")", ")");


/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseCss;
/* harmony export (immutable) */ __webpack_exports__["b"] = parseSvg;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__decompose__ = __webpack_require__(812);


var cssNode,
    cssRoot,
    cssView,
    svgNode;

function parseCss(value) {
  if (value === "none") return __WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* identity */];
  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
  cssNode.style.transform = value;
  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
  cssRoot.removeChild(cssNode);
  value = value.slice(7, -1).split(",");
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* default */])(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}

function parseSvg(value) {
  if (value == null) return __WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* identity */];
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return __WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* identity */];
  value = value.matrix;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* default */])(value.a, value.b, value.c, value.d, value.e, value.f);
}


/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var rho = Math.SQRT2,
    rho2 = 2,
    rho4 = 4,
    epsilon2 = 1e-12;

function cosh(x) {
  return ((x = Math.exp(x)) + 1 / x) / 2;
}

function sinh(x) {
  return ((x = Math.exp(x)) - 1 / x) / 2;
}

function tanh(x) {
  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}

// p0 = [ux0, uy0, w0]
// p1 = [ux1, uy1, w1]
/* unused harmony default export */ var _unused_webpack_default_export = (function(p0, p1) {
  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
      dx = ux1 - ux0,
      dy = uy1 - uy0,
      d2 = dx * dx + dy * dy,
      i,
      S;

  // Special case for u0 ≅ u1.
  if (d2 < epsilon2) {
    S = Math.log(w1 / w0) / rho;
    i = function(t) {
      return [
        ux0 + t * dx,
        uy0 + t * dy,
        w0 * Math.exp(rho * t * S)
      ];
    }
  }

  // General case.
  else {
    var d1 = Math.sqrt(d2),
        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
    S = (r1 - r0) / rho;
    i = function(t) {
      var s = t * S,
          coshr0 = cosh(r0),
          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
      return [
        ux0 + u * dx,
        uy0 + u * dy,
        w0 * coshr0 / cosh(rho * s + r0)
      ];
    }
  }

  i.duration = S * 1000;

  return i;
});


/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var pi = Math.PI,
    tau = 2 * pi,
    epsilon = 1e-6,
    tauEpsilon = tau - epsilon;

function Path() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null; // end of current subpath
  this._ = "";
}

function path() {
  return new Path;
}

Path.prototype = path.prototype = {
  constructor: Path,
  moveTo: function(x, y) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
  },
  closePath: function() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  },
  lineTo: function(x, y) {
    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  quadraticCurveTo: function(x1, y1, x, y) {
    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  arcTo: function(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
    var x0 = this._x1,
        y0 = this._y1,
        x21 = x2 - x1,
        y21 = y2 - y1,
        x01 = x0 - x1,
        y01 = y0 - y1,
        l01_2 = x01 * x01 + y01 * y01;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x1,y1).
    if (this._x1 === null) {
      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
    else if (!(l01_2 > epsilon)) {}

    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
    // Equivalently, is (x1,y1) coincident with (x2,y2)?
    // Or, is the radius zero? Line to (x1,y1).
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Otherwise, draw an arc!
    else {
      var x20 = x2 - x0,
          y20 = y2 - y0,
          l21_2 = x21 * x21 + y21 * y21,
          l20_2 = x20 * x20 + y20 * y20,
          l21 = Math.sqrt(l21_2),
          l01 = Math.sqrt(l01_2),
          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
          t01 = l / l01,
          t21 = l / l21;

      // If the start tangent is not coincident with (x0,y0), line to.
      if (Math.abs(t01 - 1) > epsilon) {
        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
      }

      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
    }
  },
  arc: function(x, y, r, a0, a1, ccw) {
    x = +x, y = +y, r = +r;
    var dx = r * Math.cos(a0),
        dy = r * Math.sin(a0),
        x0 = x + dx,
        y0 = y + dy,
        cw = 1 ^ ccw,
        da = ccw ? a0 - a1 : a1 - a0;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x0,y0).
    if (this._x1 === null) {
      this._ += "M" + x0 + "," + y0;
    }

    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
      this._ += "L" + x0 + "," + y0;
    }

    // Is this arc empty? We’re done.
    if (!r) return;

    // Does the angle go the wrong way? Flip the direction.
    if (da < 0) da = da % tau + tau;

    // Is this a complete circle? Draw two arcs to complete the circle.
    if (da > tauEpsilon) {
      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
    }

    // Is this arc non-empty? Draw an arc!
    else if (da > epsilon) {
      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    }
  },
  rect: function(x, y, w, h) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
  },
  toString: function() {
    return this._;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (path);


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports, __webpack_require__(818), __webpack_require__(819), __webpack_require__(821)) :
  typeof define === 'function' && define.amd ? define(['exports', 'd3-array', 'd3-collection', 'd3-interpolate'], factory) :
  (factory((global.d3_sankey = global.d3_sankey || {}),global.d3_array,global.d3_collection,global.d3_interpolate));
}(this, function (exports,d3Array,d3Collection,d3Interpolate) { 'use strict';

  var version = "0.1.0";

  function sankey() {
    var sankey = {},
        nodeWidth = 24,
        nodePadding = 8,
        size = [1, 1],
        align = 'justify', // left, right, center or justify
        nodes = [],
        links = [];

    sankey.nodeWidth = function(_) {
      if (!arguments.length) return nodeWidth;
      nodeWidth = +_;
      return sankey;
    };

    sankey.nodePadding = function(_) {
      if (!arguments.length) return nodePadding;
      nodePadding = +_;
      return sankey;
    };

    sankey.nodes = function(_) {
      if (!arguments.length) return nodes;
      nodes = _;
      return sankey;
    };

    sankey.links = function(_) {
      if (!arguments.length) return links;
      links = _;
      return sankey;
    };

    sankey.size = function(_) {
      if (!arguments.length) return size;
      size = _;
      return sankey;
    };

    sankey.align = function(_) {
      if (!arguments.length) return align;
      align = _.toLowerCase();
      return sankey;
    };

    sankey.layout = function(iterations) {
      computeNodeLinks();
      computeNodeValues();
      computeNodeBreadths();
      computeNodeDepths(iterations);
      computeLinkDepths();
      return sankey;
    };

    sankey.relayout = function() {
      computeLinkDepths();
      return sankey;
    };

    sankey.link = function() {
      var curvature = .5;

      function link(d) {
        var x0 = d.source.x + d.source.dx,
            x1 = d.target.x,
            xi = d3Interpolate.number(x0, x1),
            x2 = xi(curvature),
            x3 = xi(1 - curvature),
            y0 = d.source.y + d.sy + d.dy / 2,
            y1 = d.target.y + d.ty + d.dy / 2;
        return "M" + x0 + "," + y0
             + "C" + x2 + "," + y0
             + " " + x3 + "," + y1
             + " " + x1 + "," + y1;
      }

      link.curvature = function(_) {
        if (!arguments.length) return curvature;
        curvature = +_;
        return link;
      };

      return link;
    };

    // Populate the sourceLinks and targetLinks for each node.
    // Also, if the source and target are not objects, assume they are indices.
    function computeNodeLinks() {
      nodes.forEach(function(node) {
        node.sourceLinks = [];
        node.targetLinks = [];
      });
      links.forEach(function(link) {
        var source = link.source,
            target = link.target;
        if (typeof source === "number") source = link.source = nodes[link.source];
        if (typeof target === "number") target = link.target = nodes[link.target];
        source.sourceLinks.push(link);
        target.targetLinks.push(link);
      });
    }

    // Compute the value (size) of each node by summing the associated links.
    function computeNodeValues() {
      nodes.forEach(function(node) {
        node.value = Math.max(
          d3Array.sum(node.sourceLinks, value),
          d3Array.sum(node.targetLinks, value)
        );
      });
    }

    // Iteratively assign the breadth (x-position) for each node.
    // Nodes are assigned the maximum breadth of incoming neighbors plus one;
    // nodes with no incoming links are assigned breadth zero, while
    // nodes with no outgoing links are assigned the maximum breadth.
    function computeNodeBreadths() {
      var remainingNodes = nodes,
          nextNodes,
          x = 0,
          reverse = (align === 'right'); // Reverse traversal direction

      while (remainingNodes.length) {
        nextNodes = [];
        remainingNodes.forEach(function(node) {
          node.x = x;
          node.dx = nodeWidth;

          node[reverse ? 'targetLinks' : 'sourceLinks'].forEach(function(link) {
            var nextNode = link[reverse ? 'source' : 'target'];
            if (nextNodes.indexOf(nextNode) < 0) {
              nextNodes.push(nextNode);
            }
          });
        });
        remainingNodes = nextNodes;
        ++x;
      }

      if (reverse) {
        // Flip nodes horizontally
        nodes.forEach(function(node) {
          node.x *= -1;
          node.x += x - 1;
        });
      }

      if (align === 'center') {
        moveSourcesRight();
      }
      if (align === 'justify') {
        moveSinksRight(x);
      }

      scaleNodeBreadths((size[0] - nodeWidth) / (x - 1));
    }

    function moveSourcesRight() {
      nodes.slice()
        // Pack nodes from right to left
        .sort(function(a, b) { return b.x - a.x; })
        .forEach(function(node) {
          if (!node.targetLinks.length) {
            node.x = d3Array.min(node.sourceLinks, function(d) { return d.target.x; }) - 1;
          }
        });
    }

    function moveSinksRight(x) {
      nodes.forEach(function(node) {
        if (!node.sourceLinks.length) {
          node.x = x - 1;
        }
      });
    }

    function scaleNodeBreadths(kx) {
      nodes.forEach(function(node) {
        node.x *= kx;
      });
    }

    function computeNodeDepths(iterations) {
      var nodesByBreadth = d3Collection.nest()
          .key(function(d) { return d.x; })
          .sortKeys(d3Array.ascending)
          .entries(nodes)
          .map(function(d) { return d.values; });

      //
      initializeNodeDepth();
      resolveCollisions();
      for (var alpha = 1; iterations > 0; --iterations) {
        relaxRightToLeft(alpha *= .99);
        resolveCollisions();
        relaxLeftToRight(alpha);
        resolveCollisions();
      }

      function initializeNodeDepth() {
        var ky = d3Array.min(nodesByBreadth, function(nodes) {
          return (size[1] - (nodes.length - 1) * nodePadding) / d3Array.sum(nodes, value);
        });

        nodesByBreadth.forEach(function(nodes) {
          nodes.forEach(function(node, i) {
            node.y = i;
            node.dy = node.value * ky;
          });
        });

        links.forEach(function(link) {
          link.dy = link.value * ky;
        });
      }

      function relaxLeftToRight(alpha) {
        nodesByBreadth.forEach(function(nodes) {
          nodes.forEach(function(node) {
            if (node.targetLinks.length) {
              var y = d3Array.sum(node.targetLinks, weightedSource) / d3Array.sum(node.targetLinks, value);
              node.y += (y - center(node)) * alpha;
            }
          });
        });

        function weightedSource(link) {
          return center(link.source) * link.value;
        }
      }

      function relaxRightToLeft(alpha) {
        nodesByBreadth.slice().reverse().forEach(function(nodes) {
          nodes.forEach(function(node) {
            if (node.sourceLinks.length) {
              var y = d3Array.sum(node.sourceLinks, weightedTarget) / d3Array.sum(node.sourceLinks, value);
              node.y += (y - center(node)) * alpha;
            }
          });
        });

        function weightedTarget(link) {
          return center(link.target) * link.value;
        }
      }

      function resolveCollisions() {
        nodesByBreadth.forEach(function(nodes) {
          var node,
              dy,
              y0 = 0,
              n = nodes.length,
              i;

          // Push any overlapping nodes down.
          nodes.sort(ascendingDepth);
          for (i = 0; i < n; ++i) {
            node = nodes[i];
            dy = y0 - node.y;
            if (dy > 0) node.y += dy;
            y0 = node.y + node.dy + nodePadding;
          }

          // If the bottommost node goes outside the bounds, push it back up.
          dy = y0 - nodePadding - size[1];
          if (dy > 0) {
            y0 = node.y -= dy;

            // Push any overlapping nodes back up.
            for (i = n - 2; i >= 0; --i) {
              node = nodes[i];
              dy = node.y + node.dy + nodePadding - y0;
              if (dy > 0) node.y -= dy;
              y0 = node.y;
            }
          }
        });
      }

      function ascendingDepth(a, b) {
        return a.y - b.y;
      }
    }

    function computeLinkDepths() {
      nodes.forEach(function(node) {
        node.sourceLinks.sort(ascendingTargetDepth);
        node.targetLinks.sort(ascendingSourceDepth);
      });
      nodes.forEach(function(node) {
        var sy = 0, ty = 0;
        node.sourceLinks.forEach(function(link) {
          link.sy = sy;
          sy += link.dy;
        });
        node.targetLinks.forEach(function(link) {
          link.ty = ty;
          ty += link.dy;
        });
      });

      function ascendingSourceDepth(a, b) {
        return a.source.y - b.source.y;
      }

      function ascendingTargetDepth(a, b) {
        return a.target.y - b.target.y;
      }
    }

    function center(node) {
      return node.y + node.dy / 2;
    }

    function value(link) {
      return link.value;
    }

    return sankey;
  }

  exports.version = version;
  exports.sankey = sankey;

  Object.defineProperty(exports, '__esModule', { value: true });

}));

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (factory((global.d3_array = {})));
}(this, function (exports) { 'use strict';

  function ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
  }

  function bisector(compare) {
    if (compare.length === 1) compare = ascendingComparator(compare);
    return {
      left: function(a, x, lo, hi) {
        if (lo == null) lo = 0;
        if (hi == null) hi = a.length;
        while (lo < hi) {
          var mid = lo + hi >>> 1;
          if (compare(a[mid], x) < 0) lo = mid + 1;
          else hi = mid;
        }
        return lo;
      },
      right: function(a, x, lo, hi) {
        if (lo == null) lo = 0;
        if (hi == null) hi = a.length;
        while (lo < hi) {
          var mid = lo + hi >>> 1;
          if (compare(a[mid], x) > 0) hi = mid;
          else lo = mid + 1;
        }
        return lo;
      }
    };
  }

  function ascendingComparator(f) {
    return function(d, x) {
      return ascending(f(d), x);
    };
  }

  var ascendingBisect = bisector(ascending);
  var bisectRight = ascendingBisect.right;
  var bisectLeft = ascendingBisect.left;

  function descending(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
  }

  function number$1(x) {
    return x === null ? NaN : +x;
  }

  function variance(array, f) {
    var n = array.length,
        m = 0,
        a,
        d,
        s = 0,
        i = -1,
        j = 0;

    if (f == null) {
      while (++i < n) {
        if (!isNaN(a = number$1(array[i]))) {
          d = a - m;
          m += d / ++j;
          s += d * (a - m);
        }
      }
    }

    else {
      while (++i < n) {
        if (!isNaN(a = number$1(f(array[i], i, array)))) {
          d = a - m;
          m += d / ++j;
          s += d * (a - m);
        }
      }
    }

    if (j > 1) return s / (j - 1);
  }

  function deviation(array, f) {
    var v = variance(array, f);
    return v ? Math.sqrt(v) : v;
  }

  function extent(array, f) {
    var i = -1,
        n = array.length,
        a,
        b,
        c;

    if (f == null) {
      while (++i < n) if ((b = array[i]) != null && b >= b) { a = c = b; break; }
      while (++i < n) if ((b = array[i]) != null) {
        if (a > b) a = b;
        if (c < b) c = b;
      }
    }

    else {
      while (++i < n) if ((b = f(array[i], i, array)) != null && b >= b) { a = c = b; break; }
      while (++i < n) if ((b = f(array[i], i, array)) != null) {
        if (a > b) a = b;
        if (c < b) c = b;
      }
    }

    return [a, c];
  }

  function constant(x) {
    return function() {
      return x;
    };
  }

  function identity(x) {
    return x;
  }

  function range(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

    var i = -1,
        n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
        range = new Array(n);

    while (++i < n) {
      range[i] = start + i * step;
    }

    return range;
  }

  var e10 = Math.sqrt(50);
  var e5 = Math.sqrt(10);
  var e2 = Math.sqrt(2);
  function ticks(start, stop, count) {
    var step = tickStep(start, stop, count);
    return range(
      Math.ceil(start / step) * step,
      Math.floor(stop / step) * step + step / 2, // inclusive
      step
    );
  }

  function tickStep(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count),
        step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
        error = step0 / step1;
    if (error >= e10) step1 *= 10;
    else if (error >= e5) step1 *= 5;
    else if (error >= e2) step1 *= 2;
    return stop < start ? -step1 : step1;
  }

  function sturges(values) {
    return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
  }

  function number(x) {
    return +x;
  }

  function histogram() {
    var value = identity,
        domain = extent,
        threshold = sturges;

    function histogram(data) {
      var i,
          n = data.length,
          x,
          values = new Array(n);

      // Coerce values to numbers.
      for (i = 0; i < n; ++i) {
        values[i] = +value(data[i], i, data);
      }

      var xz = domain(values),
          x0 = +xz[0],
          x1 = +xz[1],
          tz = threshold(values, x0, x1);

      // Convert number of thresholds into uniform thresholds.
      if (!Array.isArray(tz)) tz = ticks(x0, x1, +tz);

      // Coerce thresholds to numbers, ignoring any outside the domain.
      var m = tz.length;
      for (i = 0; i < m; ++i) tz[i] = +tz[i];
      while (tz[0] <= x0) tz.shift(), --m;
      while (tz[m - 1] >= x1) tz.pop(), --m;

      var bins = new Array(m + 1),
          bin;

      // Initialize bins.
      for (i = 0; i <= m; ++i) {
        bin = bins[i] = [];
        bin.x0 = i > 0 ? tz[i - 1] : x0;
        bin.x1 = i < m ? tz[i] : x1;
      }

      // Assign data to bins by value, ignoring any outside the domain.
      for (i = 0; i < n; ++i) {
        x = values[i];
        if (x0 <= x && x <= x1) {
          bins[bisectRight(tz, x, 0, m)].push(data[i]);
        }
      }

      return bins;
    }

    histogram.value = function(_) {
      return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), histogram) : value;
    };

    histogram.domain = function(_) {
      return arguments.length ? (domain = typeof _ === "function" ? _ : constant([+_[0], +_[1]]), histogram) : domain;
    };

    histogram.thresholds = function(_) {
      if (!arguments.length) return threshold;
      threshold = typeof _ === "function" ? _
          : Array.isArray(_) ? constant(Array.prototype.map.call(_, number))
          : constant(+_);
      return histogram;
    };

    return histogram;
  }

  function quantile(array, p, f) {
    if (f == null) f = number$1;
    if (!(n = array.length)) return;
    if ((p = +p) <= 0 || n < 2) return +f(array[0], 0, array);
    if (p >= 1) return +f(array[n - 1], n - 1, array);
    var n,
        h = (n - 1) * p,
        i = Math.floor(h),
        a = +f(array[i], i, array),
        b = +f(array[i + 1], i + 1, array);
    return a + (b - a) * (h - i);
  }

  function freedmanDiaconis(values, min, max) {
    values.sort(ascending);
    return Math.ceil((max - min) / (2 * (quantile(values, 0.75) - quantile(values, 0.25)) * Math.pow(values.length, -1 / 3)));
  }

  function scott(values, min, max) {
    return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
  }

  function max(array, f) {
    var i = -1,
        n = array.length,
        a,
        b;

    if (f == null) {
      while (++i < n) if ((b = array[i]) != null && b >= b) { a = b; break; }
      while (++i < n) if ((b = array[i]) != null && b > a) a = b;
    }

    else {
      while (++i < n) if ((b = f(array[i], i, array)) != null && b >= b) { a = b; break; }
      while (++i < n) if ((b = f(array[i], i, array)) != null && b > a) a = b;
    }

    return a;
  }

  function mean(array, f) {
    var s = 0,
        n = array.length,
        a,
        i = -1,
        j = n;

    if (f == null) {
      while (++i < n) if (!isNaN(a = number$1(array[i]))) s += a; else --j;
    }

    else {
      while (++i < n) if (!isNaN(a = number$1(f(array[i], i, array)))) s += a; else --j;
    }

    if (j) return s / j;
  }

  function median(array, f) {
    var numbers = [],
        n = array.length,
        a,
        i = -1;

    if (f == null) {
      while (++i < n) if (!isNaN(a = number$1(array[i]))) numbers.push(a);
    }

    else {
      while (++i < n) if (!isNaN(a = number$1(f(array[i], i, array)))) numbers.push(a);
    }

    return quantile(numbers.sort(ascending), 0.5);
  }

  function merge(arrays) {
    var n = arrays.length,
        m,
        i = -1,
        j = 0,
        merged,
        array;

    while (++i < n) j += arrays[i].length;
    merged = new Array(j);

    while (--n >= 0) {
      array = arrays[n];
      m = array.length;
      while (--m >= 0) {
        merged[--j] = array[m];
      }
    }

    return merged;
  }

  function min(array, f) {
    var i = -1,
        n = array.length,
        a,
        b;

    if (f == null) {
      while (++i < n) if ((b = array[i]) != null && b >= b) { a = b; break; }
      while (++i < n) if ((b = array[i]) != null && a > b) a = b;
    }

    else {
      while (++i < n) if ((b = f(array[i], i, array)) != null && b >= b) { a = b; break; }
      while (++i < n) if ((b = f(array[i], i, array)) != null && a > b) a = b;
    }

    return a;
  }

  function pairs(array) {
    var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
    while (i < n) pairs[i] = [p, p = array[++i]];
    return pairs;
  }

  function permute(array, indexes) {
    var i = indexes.length, permutes = new Array(i);
    while (i--) permutes[i] = array[indexes[i]];
    return permutes;
  }

  function scan(array, compare) {
    if (!(n = array.length)) return;
    var i = 0,
        n,
        j = 0,
        xi,
        xj = array[j];

    if (!compare) compare = ascending;

    while (++i < n) if (compare(xi = array[i], xj) < 0 || compare(xj, xj) !== 0) xj = xi, j = i;

    if (compare(xj, xj) === 0) return j;
  }

  function shuffle(array, i0, i1) {
    var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
        t,
        i;

    while (m) {
      i = Math.random() * m-- | 0;
      t = array[m + i0];
      array[m + i0] = array[i + i0];
      array[i + i0] = t;
    }

    return array;
  }

  function sum(array, f) {
    var s = 0,
        n = array.length,
        a,
        i = -1;

    if (f == null) {
      while (++i < n) if (a = +array[i]) s += a; // Note: zero and null are equivalent.
    }

    else {
      while (++i < n) if (a = +f(array[i], i, array)) s += a;
    }

    return s;
  }

  function transpose(matrix) {
    if (!(n = matrix.length)) return [];
    for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
      for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
        row[j] = matrix[j][i];
      }
    }
    return transpose;
  }

  function length(d) {
    return d.length;
  }

  function zip() {
    return transpose(arguments);
  }

  var version = "0.7.1";

  exports.version = version;
  exports.bisect = bisectRight;
  exports.bisectRight = bisectRight;
  exports.bisectLeft = bisectLeft;
  exports.ascending = ascending;
  exports.bisector = bisector;
  exports.descending = descending;
  exports.deviation = deviation;
  exports.extent = extent;
  exports.histogram = histogram;
  exports.thresholdFreedmanDiaconis = freedmanDiaconis;
  exports.thresholdScott = scott;
  exports.thresholdSturges = sturges;
  exports.max = max;
  exports.mean = mean;
  exports.median = median;
  exports.merge = merge;
  exports.min = min;
  exports.pairs = pairs;
  exports.permute = permute;
  exports.quantile = quantile;
  exports.range = range;
  exports.scan = scan;
  exports.shuffle = shuffle;
  exports.sum = sum;
  exports.ticks = ticks;
  exports.tickStep = tickStep;
  exports.transpose = transpose;
  exports.variance = variance;
  exports.zip = zip;

}));

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (factory((global.d3_collection = global.d3_collection || {})));
}(this, function (exports) { 'use strict';

  var prefix = "$";

  function Map() {}

  Map.prototype = map.prototype = {
    constructor: Map,
    has: function(key) {
      return (prefix + key) in this;
    },
    get: function(key) {
      return this[prefix + key];
    },
    set: function(key, value) {
      this[prefix + key] = value;
      return this;
    },
    remove: function(key) {
      var property = prefix + key;
      return property in this && delete this[property];
    },
    clear: function() {
      for (var property in this) if (property[0] === prefix) delete this[property];
    },
    keys: function() {
      var keys = [];
      for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
      return keys;
    },
    values: function() {
      var values = [];
      for (var property in this) if (property[0] === prefix) values.push(this[property]);
      return values;
    },
    entries: function() {
      var entries = [];
      for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
      return entries;
    },
    size: function() {
      var size = 0;
      for (var property in this) if (property[0] === prefix) ++size;
      return size;
    },
    empty: function() {
      for (var property in this) if (property[0] === prefix) return false;
      return true;
    },
    each: function(f) {
      for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
    }
  };

  function map(object, f) {
    var map = new Map;

    // Copy constructor.
    if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });

    // Index array by numeric index or specified key function.
    else if (Array.isArray(object)) {
      var i = -1,
          n = object.length,
          o;

      if (f == null) while (++i < n) map.set(i, object[i]);
      else while (++i < n) map.set(f(o = object[i], i, object), o);
    }

    // Convert object to map.
    else if (object) for (var key in object) map.set(key, object[key]);

    return map;
  }

  function nest() {
    var keys = [],
        sortKeys = [],
        sortValues,
        rollup,
        nest;

    function apply(array, depth, createResult, setResult) {
      if (depth >= keys.length) return rollup
          ? rollup(array) : (sortValues
          ? array.sort(sortValues)
          : array);

      var i = -1,
          n = array.length,
          key = keys[depth++],
          keyValue,
          value,
          valuesByKey = map(),
          values,
          result = createResult();

      while (++i < n) {
        if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
          values.push(value);
        } else {
          valuesByKey.set(keyValue, [value]);
        }
      }

      valuesByKey.each(function(values, key) {
        setResult(result, key, apply(values, depth, createResult, setResult));
      });

      return result;
    }

    function entries(map, depth) {
      if (depth >= keys.length) return map;

      var array = [],
          sortKey = sortKeys[depth++];

      map.each(function(value, key) {
        array.push({key: key, values: entries(value, depth)});
      });

      return sortKey
          ? array.sort(function(a, b) { return sortKey(a.key, b.key); })
          : array;
    }

    return nest = {
      object: function(array) { return apply(array, 0, createObject, setObject); },
      map: function(array) { return apply(array, 0, createMap, setMap); },
      entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
      key: function(d) { keys.push(d); return nest; },
      sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
      sortValues: function(order) { sortValues = order; return nest; },
      rollup: function(f) { rollup = f; return nest; }
    };
  }

  function createObject() {
    return {};
  }

  function setObject(object, key, value) {
    object[key] = value;
  }

  function createMap() {
    return map();
  }

  function setMap(map, key, value) {
    map.set(key, value);
  }

  function Set() {}

  var proto = map.prototype;

  Set.prototype = set.prototype = {
    constructor: Set,
    has: proto.has,
    add: function(value) {
      value += "";
      this[prefix + value] = value;
      return this;
    },
    remove: proto.remove,
    clear: proto.clear,
    values: proto.keys,
    size: proto.size,
    empty: proto.empty,
    each: proto.each
  };

  function set(object, f) {
    var set = new Set;

    // Copy constructor.
    if (object instanceof Set) object.each(function(value) { set.add(value); });

    // Otherwise, assume it’s an array.
    else if (object) {
      var i = -1, n = object.length;
      if (f == null) while (++i < n) set.add(object[i]);
      else while (++i < n) set.add(f(object[i], i, object));
    }

    return set;
  }

  function keys(map) {
    var keys = [];
    for (var key in map) keys.push(key);
    return keys;
  }

  function values(map) {
    var values = [];
    for (var key in map) values.push(map[key]);
    return values;
  }

  function entries(map) {
    var entries = [];
    for (var key in map) entries.push({key: key, value: map[key]});
    return entries;
  }

  var version = "0.1.2";

  exports.version = version;
  exports.nest = nest;
  exports.set = set;
  exports.map = map;
  exports.keys = keys;
  exports.values = values;
  exports.entries = entries;

}));

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (factory((global.d3_color = {})));
}(this, function (exports) { 'use strict';

  function Color() {}

  var darker = 0.7;
  var brighter = 1 / darker;

  var reHex3 = /^#([0-9a-f]{3})$/;
  var reHex6 = /^#([0-9a-f]{6})$/;
  var reRgbInteger = /^rgb\(\s*([-+]?\d+)\s*,\s*([-+]?\d+)\s*,\s*([-+]?\d+)\s*\)$/;
  var reRgbPercent = /^rgb\(\s*([-+]?\d+(?:\.\d+)?)%\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*\)$/;
  var reHslPercent = /^hsl\(\s*([-+]?\d+(?:\.\d+)?)\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*\)$/;
  var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
  };

  color.prototype = Color.prototype = {
    displayable: function() {
      return this.rgb().displayable();
    },
    toString: function() {
      return this.rgb() + "";
    }
  };

  function color(format) {
    var m;
    format = (format + "").trim().toLowerCase();
    return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf))) // #f00
        : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
        : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3]) // rgb(255,0,0)
        : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100) // rgb(100%,0%,0%)
        : (m = reHslPercent.exec(format)) ? new Hsl(m[1], m[2] / 100, m[3] / 100) // hsl(120,50%,50%)
        : named.hasOwnProperty(format) ? rgbn(named[format])
        : null;
  }

  function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff);
  }

  function rgb(r, g, b) {
    if (arguments.length === 1) {
      if (!(r instanceof Color)) r = color(r);
      if (r) {
        r = r.rgb();
        b = r.b;
        g = r.g;
        r = r.r;
      } else {
        r = g = b = NaN;
      }
    }
    return new Rgb(r, g, b);
  }

  function Rgb(r, g, b) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
  }

  var _rgb = rgb.prototype = Rgb.prototype = new Color;

  _rgb.brighter = function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k);
  };

  _rgb.darker = function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k);
  };

  _rgb.rgb = function() {
    return this;
  };

  _rgb.displayable = function() {
    return (0 <= this.r && this.r <= 255)
        && (0 <= this.g && this.g <= 255)
        && (0 <= this.b && this.b <= 255);
  };

  _rgb.toString = function() {
    var r = Math.round(this.r),
        g = Math.round(this.g),
        b = Math.round(this.b);
    return "#"
        + (isNaN(r) || r <= 0 ? "00" : r < 16 ? "0" + r.toString(16) : r >= 255 ? "ff" : r.toString(16))
        + (isNaN(g) || g <= 0 ? "00" : g < 16 ? "0" + g.toString(16) : g >= 255 ? "ff" : g.toString(16))
        + (isNaN(b) || b <= 0 ? "00" : b < 16 ? "0" + b.toString(16) : b >= 255 ? "ff" : b.toString(16));
  };

  function hsl(h, s, l) {
    if (arguments.length === 1) {
      if (h instanceof Hsl) {
        l = h.l;
        s = h.s;
        h = h.h;
      } else {
        if (!(h instanceof Color)) h = color(h);
        if (h) {
          if (h instanceof Hsl) return h;
          h = h.rgb();
          var r = h.r / 255,
              g = h.g / 255,
              b = h.b / 255,
              min = Math.min(r, g, b),
              max = Math.max(r, g, b),
              range = max - min;
          l = (max + min) / 2;
          if (range) {
            s = l < 0.5 ? range / (max + min) : range / (2 - max - min);
            if (r === max) h = (g - b) / range + (g < b) * 6;
            else if (g === max) h = (b - r) / range + 2;
            else h = (r - g) / range + 4;
            h *= 60;
          } else {
            h = NaN;
            s = l > 0 && l < 1 ? 0 : h;
          }
        } else {
          h = s = l = NaN;
        }
      }
    }
    return new Hsl(h, s, l);
  }

  function Hsl(h, s, l) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
  }

  var _hsl = hsl.prototype = Hsl.prototype = new Color;

  _hsl.brighter = function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k);
  };

  _hsl.darker = function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k);
  };

  _hsl.rgb = function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2)
    );
  };

  _hsl.displayable = function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1);
  };

  /* From FvD 13.37, CSS Color Module Level 3 */
  function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60
        : h < 180 ? m2
        : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
        : m1) * 255;
  }

  var deg2rad = Math.PI / 180;
  var rad2deg = 180 / Math.PI;

  var Kn = 18;
  var Xn = 0.950470;
  var Yn = 1;
  var Zn = 1.088830;
  var t0 = 4 / 29;
  var t1 = 6 / 29;
  var t2 = 3 * t1 * t1;
  var t3 = t1 * t1 * t1;
  function lab(l, a, b) {
    if (arguments.length === 1) {
      if (l instanceof Lab) {
        b = l.b;
        a = l.a;
        l = l.l;
      } else if (l instanceof Hcl) {
        var h = l.h * deg2rad;
        b = Math.sin(h) * l.c;
        a = Math.cos(h) * l.c;
        l = l.l;
      } else {
        if (!(l instanceof Rgb)) l = rgb(l);
        b = rgb2xyz(l.r);
        a = rgb2xyz(l.g);
        l = rgb2xyz(l.b);
        var x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
            y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
            z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
        b = 200 * (y - z);
        a = 500 * (x - y);
        l = 116 * y - 16;
      }
    }
    return new Lab(l, a, b);
  }

  function Lab(l, a, b) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
  }

  var _lab = lab.prototype = Lab.prototype = new Color;

  _lab.brighter = function(k) {
    return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b);
  };

  _lab.darker = function(k) {
    return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b);
  };

  _lab.rgb = function() {
    var y = (this.l + 16) / 116,
        x = isNaN(this.a) ? y : y + this.a / 500,
        z = isNaN(this.b) ? y : y - this.b / 200;
    y = Yn * lab2xyz(y);
    x = Xn * lab2xyz(x);
    z = Zn * lab2xyz(z);
    return new Rgb(
      xyz2rgb( 3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
      xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z),
      xyz2rgb( 0.0556434 * x - 0.2040259 * y + 1.0572252 * z)
    );
  };

  function xyz2lab(t) {
    return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
  }

  function lab2xyz(t) {
    return t > t1 ? t * t * t : t2 * (t - t0);
  }

  function xyz2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
  }

  function rgb2xyz(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
  }

  function hcl(h, c, l) {
    if (arguments.length === 1) {
      if (h instanceof Hcl) {
        l = h.l;
        c = h.c;
        h = h.h;
      } else {
        if (!(h instanceof Lab)) h = lab(h);
        l = h.l;
        c = Math.sqrt(h.a * h.a + h.b * h.b);
        h = Math.atan2(h.b, h.a) * rad2deg;
        if (h < 0) h += 360;
      }
    }
    return new Hcl(h, c, l);
  }

  function Hcl(h, c, l) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
  }

  var _hcl = hcl.prototype = Hcl.prototype = new Color;

  _hcl.brighter = function(k) {
    return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k));
  };

  _hcl.darker = function(k) {
    return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k));
  };

  _hcl.rgb = function() {
    return lab(this).rgb();
  };

  var A = -0.14861;
  var B = +1.78277;
  var C = -0.29227;
  var D = -0.90649;
  var E = +1.97294;
  var ED = E * D;
  var EB = E * B;
  var BC_DA = B * C - D * A;
  function cubehelix(h, s, l) {
    if (arguments.length === 1) {
      if (h instanceof Cubehelix) {
        l = h.l;
        s = h.s;
        h = h.h;
      } else {
        if (!(h instanceof Rgb)) h = rgb(h);
        var r = h.r / 255, g = h.g / 255, b = h.b / 255;
        l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB);
        var bl = b - l, k = (E * (g - l) - C * bl) / D;
        s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)); // NaN if l=0 or l=1
        h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
        if (h < 0) h += 360;
      }
    }
    return new Cubehelix(h, s, l);
  }

  function Cubehelix(h, s, l) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
  }

  var _cubehelix = cubehelix.prototype = Cubehelix.prototype = new Color;

  _cubehelix.brighter = function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Cubehelix(this.h, this.s, this.l * k);
  };

  _cubehelix.darker = function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Cubehelix(this.h, this.s, this.l * k);
  };

  _cubehelix.rgb = function() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
    return new Rgb(
      255 * (l + a * (A * cosh + B * sinh)),
      255 * (l + a * (C * cosh + D * sinh)),
      255 * (l + a * (E * cosh))
    );
  };

  var version = "0.3.4";

  exports.version = version;
  exports.color = color;
  exports.rgb = rgb;
  exports.hsl = hsl;
  exports.lab = lab;
  exports.hcl = hcl;
  exports.cubehelix = cubehelix;

}));

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports, __webpack_require__(820)) :
  typeof define === 'function' && define.amd ? define('d3-interpolate', ['exports', 'd3-color'], factory) :
  factory((global.d3_interpolate = {}),global.d3_color);
}(this, function (exports,d3Color) { 'use strict';

  function deltaHue(h1, h0) {
    var delta = h1 - h0;
    return delta > 180 || delta < -180
        ? delta - 360 * Math.round(delta / 360)
        : delta;
  };

  function cubehelixGamma(gamma) {
    return function(a, b) {
      a = d3Color.cubehelix(a);
      b = d3Color.cubehelix(b);
      var ah = isNaN(a.h) ? b.h : a.h,
          as = isNaN(a.s) ? b.s : a.s,
          al = a.l,
          bh = isNaN(b.h) ? 0 : deltaHue(b.h, ah),
          bs = isNaN(b.s) ? 0 : b.s - as,
          bl = b.l - al;
      return function(t) {
        a.h = ah + bh * t;
        a.s = as + bs * t;
        a.l = al + bl * Math.pow(t, gamma);
        return a + "";
      };
    };
  };

  function cubehelixGammaLong(gamma) {
    return function(a, b) {
      a = d3Color.cubehelix(a);
      b = d3Color.cubehelix(b);
      var ah = isNaN(a.h) ? b.h : a.h,
          as = isNaN(a.s) ? b.s : a.s,
          al = a.l,
          bh = isNaN(b.h) ? 0 : b.h - ah,
          bs = isNaN(b.s) ? 0 : b.s - as,
          bl = b.l - al;
      return function(t) {
        a.h = ah + bh * t;
        a.s = as + bs * t;
        a.l = al + bl * Math.pow(t, gamma);
        return a + "";
      };
    };
  };

  function rgb(a, b) {
    a = d3Color.rgb(a);
    b = d3Color.rgb(b);
    var ar = a.r,
        ag = a.g,
        ab = a.b,
        br = b.r - ar,
        bg = b.g - ag,
        bb = b.b - ab;
    return function(t) {
      a.r = ar + br * t;
      a.g = ag + bg * t;
      a.b = ab + bb * t;
      return a + "";
    };
  };

  function number(a, b) {
    return a = +a, b -= a, function(t) {
      return a + b * t;
    };
  };

  function object(a, b) {
    var i = {},
        c = {},
        k;

    for (k in a) {
      if (k in b) {
        i[k] = value(a[k], b[k]);
      } else {
        c[k] = a[k];
      }
    }

    for (k in b) {
      if (!(k in a)) {
        c[k] = b[k];
      }
    }

    return function(t) {
      for (k in i) c[k] = i[k](t);
      return c;
    };
  };

  var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g;
  var reB = new RegExp(reA.source, "g");
  function zero(b) {
    return function() {
      return b;
    };
  }

  function one(b) {
    return function(t) {
      return b(t) + "";
    };
  }

  function string(a, b) {
    var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
        am, // current match in a
        bm, // current match in b
        bs, // string preceding current number in b, if any
        i = -1, // index in s
        s = [], // string constants and placeholders
        q = []; // number interpolators

    // Coerce inputs to strings.
    a = a + "", b = b + "";

    // Interpolate pairs of numbers in a & b.
    while ((am = reA.exec(a))
        && (bm = reB.exec(b))) {
      if ((bs = bm.index) > bi) { // a string precedes the next number in b
        bs = b.slice(bi, bs);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
      }
      if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
        if (s[i]) s[i] += bm; // coalesce with previous string
        else s[++i] = bm;
      } else { // interpolate non-matching numbers
        s[++i] = null;
        q.push({i: i, x: number(am, bm)});
      }
      bi = reB.lastIndex;
    }

    // Add remains of b.
    if (bi < b.length) {
      bs = b.slice(bi);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }

    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? (q[0]
        ? one(q[0].x)
        : zero(b))
        : (b = q.length, function(t) {
            for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
            return s.join("");
          });
  };

  var values = [
    function(a, b) {
      var t = typeof b, c;
      return (t === "string" ? ((c = d3Color.color(b)) ? (b = c, rgb) : string)
          : b instanceof d3Color.color ? rgb
          : Array.isArray(b) ? array
          : t === "object" && isNaN(b) ? object
          : number)(a, b);
    }
  ];

  function value(a, b) {
    var i = values.length, f;
    while (--i >= 0 && !(f = values[i](a, b)));
    return f;
  };

  // TODO sparse arrays?
  function array(a, b) {
    var x = [],
        c = [],
        na = a.length,
        nb = b.length,
        n0 = Math.min(a.length, b.length),
        i;

    for (i = 0; i < n0; ++i) x.push(value(a[i], b[i]));
    for (; i < na; ++i) c[i] = a[i];
    for (; i < nb; ++i) c[i] = b[i];

    return function(t) {
      for (i = 0; i < n0; ++i) c[i] = x[i](t);
      return c;
    };
  };

  function round(a, b) {
    return a = +a, b -= a, function(t) {
      return Math.round(a + b * t);
    };
  };

  var rad2deg = 180 / Math.PI;
  var identity = {a: 1, b: 0, c: 0, d: 1, e: 0, f: 0};
  var g;
  // Compute x-scale and normalize the first row.
  // Compute shear and make second row orthogonal to first.
  // Compute y-scale and normalize the second row.
  // Finally, compute the rotation.
  function Transform(string) {
    if (!g) g = document.createElementNS("http://www.w3.org/2000/svg", "g");
    if (string) g.setAttribute("transform", string), t = g.transform.baseVal.consolidate();

    var t,
        m = t ? t.matrix : identity,
        r0 = [m.a, m.b],
        r1 = [m.c, m.d],
        kx = normalize(r0),
        kz = dot(r0, r1),
        ky = normalize(combine(r1, r0, -kz)) || 0;

    if (r0[0] * r1[1] < r1[0] * r0[1]) {
      r0[0] *= -1;
      r0[1] *= -1;
      kx *= -1;
      kz *= -1;
    }

    this.rotate = (kx ? Math.atan2(r0[1], r0[0]) : Math.atan2(-r1[0], r1[1])) * rad2deg;
    this.translate = [m.e, m.f];
    this.scale = [kx, ky];
    this.skew = ky ? Math.atan2(kz, ky) * rad2deg : 0;
  }

  function dot(a, b) {
    return a[0] * b[0] + a[1] * b[1];
  }

  function normalize(a) {
    var k = Math.sqrt(dot(a, a));
    if (k) a[0] /= k, a[1] /= k;
    return k;
  }

  function combine(a, b, k) {
    a[0] += k * b[0];
    a[1] += k * b[1];
    return a;
  }

  function pop(s) {
    return s.length ? s.pop() + "," : "";
  }

  function translate(ta, tb, s, q) {
    if (ta[0] !== tb[0] || ta[1] !== tb[1]) {
      var i = s.push("translate(", null, ",", null, ")");
      q.push({i: i - 4, x: number(ta[0], tb[0])}, {i: i - 2, x: number(ta[1], tb[1])});
    } else if (tb[0] || tb[1]) {
      s.push("translate(" + tb + ")");
    }
  }

  function rotate(ra, rb, s, q) {
    if (ra !== rb) {
      if (ra - rb > 180) rb += 360; else if (rb - ra > 180) ra += 360; // shortest path
      q.push({i: s.push(pop(s) + "rotate(", null, ")") - 2, x: number(ra, rb)});
    } else if (rb) {
      s.push(pop(s) + "rotate(" + rb + ")");
    }
  }

  function skew(wa, wb, s, q) {
    if (wa !== wb) {
      q.push({i: s.push(pop(s) + "skewX(", null, ")") - 2, x: number(wa, wb)});
    } else if (wb) {
      s.push(pop(s) + "skewX(" + wb + ")");
    }
  }

  function scale(ka, kb, s, q) {
    if (ka[0] !== kb[0] || ka[1] !== kb[1]) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({i: i - 4, x: number(ka[0], kb[0])}, {i: i - 2, x: number(ka[1], kb[1])});
    } else if (kb[0] !== 1 || kb[1] !== 1) {
      s.push(pop(s) + "scale(" + kb + ")");
    }
  }

  function transform(a, b) {
    var s = [], // string constants and placeholders
        q = []; // number interpolators
    a = new Transform(a), b = new Transform(b);
    translate(a.translate, b.translate, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skew(a.skew, b.skew, s, q);
    scale(a.scale, b.scale, s, q);
    a = b = null; // gc
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };

  var rho = Math.SQRT2;
  var rho2 = 2;
  var rho4 = 4;
  var epsilon2 = 1e-12;
  function cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
  }

  function sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
  }

  function tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
  }

  // p0 = [ux0, uy0, w0]
  // p1 = [ux1, uy1, w1]
  function zoom(p0, p1) {
    var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
        ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
        dx = ux1 - ux0,
        dy = uy1 - uy0,
        d2 = dx * dx + dy * dy,
        i,
        S;

    // Special case for u0 ≅ u1.
    if (d2 < epsilon2) {
      S = Math.log(w1 / w0) / rho;
      i = function(t) {
        return [
          ux0 + t * dx,
          uy0 + t * dy,
          w0 * Math.exp(rho * t * S)
        ];
      }
    }

    // General case.
    else {
      var d1 = Math.sqrt(d2),
          b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
          b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
          r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
          r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
      S = (r1 - r0) / rho;
      i = function(t) {
        var s = t * S,
            coshr0 = cosh(r0),
            u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
        return [
          ux0 + u * dx,
          uy0 + u * dy,
          w0 * coshr0 / cosh(rho * s + r0)
        ];
      }
    }

    i.duration = S * 1000;

    return i;
  };

  function hsl(a, b) {
    a = d3Color.hsl(a);
    b = d3Color.hsl(b);
    var ah = isNaN(a.h) ? b.h : a.h,
        as = isNaN(a.s) ? b.s : a.s,
        al = a.l,
        bh = isNaN(b.h) ? 0 : deltaHue(b.h, ah),
        bs = isNaN(b.s) ? 0 : b.s - as,
        bl = b.l - al;
    return function(t) {
      a.h = ah + bh * t;
      a.s = as + bs * t;
      a.l = al + bl * t;
      return a + "";
    };
  };

  function hslLong(a, b) {
    a = d3Color.hsl(a);
    b = d3Color.hsl(b);
    var ah = isNaN(a.h) ? b.h : a.h,
        as = isNaN(a.s) ? b.s : a.s,
        al = a.l,
        bh = isNaN(b.h) ? 0 : b.h - ah,
        bs = isNaN(b.s) ? 0 : b.s - as,
        bl = b.l - al;
    return function(t) {
      a.h = ah + bh * t;
      a.s = as + bs * t;
      a.l = al + bl * t;
      return a + "";
    };
  };

  function lab(a, b) {
    a = d3Color.lab(a);
    b = d3Color.lab(b);
    var al = a.l,
        aa = a.a,
        ab = a.b,
        bl = b.l - al,
        ba = b.a - aa,
        bb = b.b - ab;
    return function(t) {
      a.l = al + bl * t;
      a.a = aa + ba * t;
      a.b = ab + bb * t;
      return a + "";
    };
  };

  function hcl(a, b) {
    a = d3Color.hcl(a);
    b = d3Color.hcl(b);
    var ah = isNaN(a.h) ? b.h : a.h,
        ac = isNaN(a.c) ? b.c : a.c,
        al = a.l,
        bh = isNaN(b.h) ? 0 : deltaHue(b.h, ah),
        bc = isNaN(b.c) ? 0 : b.c - ac,
        bl = b.l - al;
    return function(t) {
      a.h = ah + bh * t;
      a.c = ac + bc * t;
      a.l = al + bl * t;
      return a + "";
    };
  };

  function hclLong(a, b) {
    a = d3Color.hcl(a);
    b = d3Color.hcl(b);
    var ah = isNaN(a.h) ? b.h : a.h,
        ac = isNaN(a.c) ? b.c : a.c,
        al = a.l,
        bh = isNaN(b.h) ? 0 : b.h - ah,
        bc = isNaN(b.c) ? 0 : b.c - ac,
        bl = b.l - al;
    return function(t) {
      a.h = ah + bh * t;
      a.c = ac + bc * t;
      a.l = al + bl * t;
      return a + "";
    };
  };

  var cubehelix = cubehelixGamma(1);
  var cubehelixLong = cubehelixGammaLong(1);

  var version = "0.2.1";

  exports.version = version;
  exports.cubehelix = cubehelix;
  exports.cubehelixLong = cubehelixLong;
  exports.cubehelixGamma = cubehelixGamma;
  exports.cubehelixGammaLong = cubehelixGammaLong;
  exports.array = array;
  exports.number = number;
  exports.object = object;
  exports.round = round;
  exports.string = string;
  exports.transform = transform;
  exports.values = values;
  exports.value = value;
  exports.zoom = zoom;
  exports.rgb = rgb;
  exports.hsl = hsl;
  exports.hslLong = hslLong;
  exports.lab = lab;
  exports.hcl = hcl;
  exports.hclLong = hclLong;

}));

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony export (immutable) */ __webpack_exports__["a"] = point;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ordinal__ = __webpack_require__(356);



function band() {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ordinal__["a" /* default */])().unknown(undefined),
      domain = scale.domain,
      ordinalRange = scale.range,
      range = [0, 1],
      step,
      bandwidth,
      round = false,
      paddingInner = 0,
      paddingOuter = 0,
      align = 0.5;

  delete scale.unknown;

  function rescale() {
    var n = domain().length,
        reverse = range[1] < range[0],
        start = range[reverse - 0],
        stop = range[1 - reverse];
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["i" /* range */])(n).map(function(i) { return start + step * i; });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function(_) {
    return arguments.length ? (range = [+_[0], +_[1]], rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = [+_[0], +_[1]], round = true, rescale();
  };

  scale.bandwidth = function() {
    return bandwidth;
  };

  scale.step = function() {
    return step;
  };

  scale.round = function(_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };

  scale.padding = function(_) {
    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
  };

  scale.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };

  scale.copy = function() {
    return band()
        .domain(domain())
        .range(range)
        .round(round)
        .paddingInner(paddingInner)
        .paddingOuter(paddingOuter)
        .align(align);
  };

  return rescale();
}

function pointish(scale) {
  var copy = scale.copy;

  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;

  scale.copy = function() {
    return pointish(copy());
  };

  return scale;
}

function point() {
  return pointish(band().paddingInner(1));
}


/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(98);


/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"));


/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(98);


/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5"));


/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(98);


/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6"));


/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(98);


/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9"));


/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(57);



/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["d" /* interpolateCubehelixLong */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(300, 0.5, 0.0), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(-240, 0.5, 1.0)));


/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(355);




function identity() {
  var domain = [0, 1];

  function scale(x) {
    return +x;
  }

  scale.invert = scale;

  scale.domain = scale.range = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]), scale) : domain.slice();
  };

  scale.copy = function() {
    return identity().domain(domain);
  };

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = log;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nice__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__continuous__ = __webpack_require__(131);






function deinterpolate(a, b) {
  return (b = Math.log(b / a))
      ? function(x) { return Math.log(x / a) / b; }
      : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(b);
}

function reinterpolate(a, b) {
  return a < 0
      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
}

function pow10(x) {
  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}

function powp(base) {
  return base === 10 ? pow10
      : base === Math.E ? Math.exp
      : function(x) { return Math.pow(base, x); };
}

function logp(base) {
  return base === Math.E ? Math.log
      : base === 10 && Math.log10
      || base === 2 && Math.log2
      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
}

function reflect(f) {
  return function(x) {
    return -f(-x);
  };
}

function log() {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__continuous__["a" /* default */])(deinterpolate, reinterpolate).domain([1, 10]),
      domain = scale.domain,
      base = 10,
      logs = logp(10),
      pows = powp(10);

  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
    return scale;
  }

  scale.base = function(_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.ticks = function(count) {
    var d = domain(),
        u = d[0],
        v = d[d.length - 1],
        r;

    if (r = v < u) i = u, u = v, v = i;

    var i = logs(u),
        j = logs(v),
        p,
        k,
        t,
        n = count == null ? 10 : +count,
        z = [];

    if (!(base % 1) && j - i < n) {
      i = Math.round(i) - 1, j = Math.round(j) + 1;
      if (u > 0) for (; i < j; ++i) {
        for (k = 1, p = pows(i); k < base; ++k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      } else for (; i < j; ++i) {
        for (k = base - 1, p = pows(i); k >= 1; --k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
    } else {
      z = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* ticks */])(i, j, Math.min(j - i, n)).map(pows);
    }

    return r ? z.reverse() : z;
  };

  scale.tickFormat = function(count, specifier) {
    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
    if (typeof specifier !== "function") specifier = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["f" /* format */])(specifier);
    if (count === Infinity) return specifier;
    if (count == null) count = 10;
    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
    return function(d) {
      var i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k ? specifier(d) : "";
    };
  };

  scale.nice = function() {
    return domain(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__nice__["a" /* default */])(domain(), {
      floor: function(x) { return pows(Math.floor(logs(x))); },
      ceil: function(x) { return pows(Math.ceil(logs(x))); }
    }));
  };

  scale.copy = function() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__continuous__["c" /* copy */])(scale, log().base(base));
  };

  return scale;
}


/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony export (immutable) */ __webpack_exports__["a"] = sqrt;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__(131);




function raise(x, exponent) {
  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
}

function pow() {
  var exponent = 1,
      scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" /* default */])(deinterpolate, reinterpolate),
      domain = scale.domain;

  function deinterpolate(a, b) {
    return (b = raise(b, exponent) - (a = raise(a, exponent)))
        ? function(x) { return (raise(x, exponent) - a) / b; }
        : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(b);
  }

  function reinterpolate(a, b) {
    b = raise(b, exponent) - (a = raise(a, exponent));
    return function(t) { return raise(a + b * t, 1 / exponent); };
  }

  scale.exponent = function(_) {
    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
  };

  scale.copy = function() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__continuous__["c" /* copy */])(scale, pow().exponent(exponent));
  };

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__linear__["b" /* linearish */])(scale);
}

function sqrt() {
  return pow().exponent(0.5);
}


/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(58);



function quantile() {
  var domain = [],
      range = [],
      thresholds = [];

  function rescale() {
    var i = 0, n = Math.max(1, range.length);
    thresholds = new Array(n - 1);
    while (++i < n) thresholds[i - 1] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["g" /* quantile */])(domain, i / n);
    return scale;
  }

  function scale(x) {
    if (!isNaN(x = +x)) return range[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["d" /* bisect */])(thresholds, x)];
  }

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN] : [
      i > 0 ? thresholds[i - 1] : domain[0],
      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
    ];
  };

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
    domain.sort(__WEBPACK_IMPORTED_MODULE_0_d3_array__["h" /* ascending */]);
    return rescale();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.quantiles = function() {
    return thresholds.slice();
  };

  scale.copy = function() {
    return quantile()
        .domain(domain)
        .range(range);
  };

  return scale;
}


/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linear__ = __webpack_require__(99);




function quantize() {
  var x0 = 0,
      x1 = 1,
      n = 1,
      domain = [0.5],
      range = [0, 1];

  function scale(x) {
    if (x <= x) return range[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["d" /* bisect */])(domain, x, 0, n)];
  }

  function rescale() {
    var i = -1;
    domain = new Array(n);
    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
    return scale;
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
  };

  scale.range = function(_) {
    return arguments.length ? (n = (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_)).length - 1, rescale()) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN]
        : i < 1 ? [x0, domain[0]]
        : i >= n ? [domain[n - 1], x1]
        : [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return quantize()
        .domain([x0, x1])
        .range(range);
  };

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export warm */
/* unused harmony export cool */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(57);



var warm = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["d" /* interpolateCubehelixLong */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(-100, 0.75, 0.35), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(80, 1.50, 0.8));

var cool = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["d" /* interpolateCubehelixLong */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(260, 0.75, 0.35), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(80, 1.50, 0.8));

var rainbow = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])();

/* unused harmony default export */ var _unused_webpack_default_export = (function(t) {
  if (t < 0 || t > 1) t -= Math.floor(t);
  var ts = Math.abs(t - 0.5);
  rainbow.h = 360 * t - 100;
  rainbow.s = 1.5 - 1.5 * ts;
  rainbow.l = 0.8 - 0.9 * ts;
  return rainbow + "";
});


/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(99);


function sequential(interpolator) {
  var x0 = 0,
      x1 = 1,
      clamp = false;

  function scale(x) {
    var t = (x - x0) / (x1 - x0);
    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.copy = function() {
    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
  };

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(58);



function threshold() {
  var domain = [0.5],
      range = [0, 1],
      n = 1;

  function scale(x) {
    if (x <= x) return range[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["d" /* bisect */])(domain, x, 0, n)];
  }

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return threshold()
        .domain(domain)
        .range(range);
  };

  return scale;
}


/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(125);



/* harmony default export */ __webpack_exports__["a"] = (function(domain, count, specifier) {
  var start = domain[0],
      stop = domain[domain.length - 1],
      step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["e" /* tickStep */])(start, stop, count == null ? 10 : count),
      precision;
  specifier = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" /* formatSpecifier */])(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["b" /* precisionPrefix */])(step, value))) specifier.precision = precision;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["c" /* formatPrefix */])(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["d" /* precisionRound */])(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["e" /* precisionFixed */])(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["f" /* format */])(specifier);
});


/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__time__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_time_format__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(208);




/* harmony default export */ __webpack_exports__["a"] = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__time__["b" /* calendar */])(__WEBPACK_IMPORTED_MODULE_2_d3_time__["a" /* utcYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["b" /* utcMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["c" /* utcWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["d" /* utcDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["e" /* utcHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["f" /* utcMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["g" /* utcSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["h" /* utcMillisecond */], __WEBPACK_IMPORTED_MODULE_1_d3_time_format__["a" /* utcFormat */]).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
});


/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export magma */
/* unused harmony export inferno */
/* unused harmony export plasma */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(98);


function ramp(range) {
  var n = range.length;
  return function(t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (ramp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725")));

var magma = ramp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));

var inferno = ramp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));

var plasma = ramp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));


/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(100);




function arcInnerRadius(d) {
  return d.innerRadius;
}

function arcOuterRadius(d) {
  return d.outerRadius;
}

function arcStartAngle(d) {
  return d.startAngle;
}

function arcEndAngle(d) {
  return d.endAngle;
}

function arcPadAngle(d) {
  return d && d.padAngle; // Note: optional!
}

function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0, y10 = y1 - y0,
      x32 = x3 - x2, y32 = y3 - y2,
      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
  return [x0 + t * x10, y0 + t * y10];
}

// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1,
      y01 = y0 - y1,
      lo = (cw ? rc : -rc) / __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sqrt */])(x01 * x01 + y01 * y01),
      ox = lo * y01,
      oy = -lo * x01,
      x11 = x0 + ox,
      y11 = y0 + oy,
      x10 = x1 + ox,
      y10 = y1 + oy,
      x00 = (x11 + x10) / 2,
      y00 = (y11 + y10) / 2,
      dx = x10 - x11,
      dy = y10 - y11,
      d2 = dx * dx + dy * dy,
      r = r1 - rc,
      D = x11 * y10 - x10 * y11,
      d = (dy < 0 ? -1 : 1) * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sqrt */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* max */])(0, r * r * d2 - D * D)),
      cx0 = (D * dy - dx * d) / d2,
      cy0 = (-D * dx - dy * d) / d2,
      cx1 = (D * dy + dx * d) / d2,
      cy1 = (-D * dx + dy * d) / d2,
      dx0 = cx0 - x00,
      dy0 = cy0 - y00,
      dx1 = cx1 - x00,
      dy1 = cy1 - y00;

  // Pick the closer of the two intersection points.
  // TODO Is there a faster way to determine which intersection to use?
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;

  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var innerRadius = arcInnerRadius,
      outerRadius = arcOuterRadius,
      cornerRadius = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(0),
      padRadius = null,
      startAngle = arcStartAngle,
      endAngle = arcEndAngle,
      padAngle = arcPadAngle,
      context = null;

  function arc() {
    var buffer,
        r,
        r0 = +innerRadius.apply(this, arguments),
        r1 = +outerRadius.apply(this, arguments),
        a0 = startAngle.apply(this, arguments) - __WEBPACK_IMPORTED_MODULE_2__math__["f" /* halfPi */],
        a1 = endAngle.apply(this, arguments) - __WEBPACK_IMPORTED_MODULE_2__math__["f" /* halfPi */],
        da = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* abs */])(a1 - a0),
        cw = a1 > a0;

    if (!context) context = buffer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();

    // Ensure that the outer radius is always larger than the inner radius.
    if (r1 < r0) r = r1, r1 = r0, r0 = r;

    // Is it a point?
    if (!(r1 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */])) context.moveTo(0, 0);

    // Or is it a circle or annulus?
    else if (da > __WEBPACK_IMPORTED_MODULE_2__math__["c" /* tau */] - __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
      context.moveTo(r1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(a0), r1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* sin */])(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
        context.moveTo(r0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(a1), r0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* sin */])(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    }

    // Or is it a circular or annular sector?
    else {
      var a01 = a0,
          a11 = a1,
          a00 = a0,
          a10 = a1,
          da0 = da,
          da1 = da,
          ap = padAngle.apply(this, arguments) / 2,
          rp = (ap > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) && (padRadius ? +padRadius.apply(this, arguments) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sqrt */])(r0 * r0 + r1 * r1)),
          rc = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["j" /* min */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* abs */])(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
          rc0 = rc,
          rc1 = rc,
          t0,
          t1;

      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
      if (rp > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
        var p0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* asin */])(rp / r0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* sin */])(ap)),
            p1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* asin */])(rp / r1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* sin */])(ap));
        if ((da0 -= p0 * 2) > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }

      var x01 = r1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(a01),
          y01 = r1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* sin */])(a01),
          x10 = r0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(a10),
          y10 = r0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* sin */])(a10);

      // Apply rounded corners?
      if (rc > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
        var x11 = r1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(a11),
            y11 = r1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* sin */])(a11),
            x00 = r0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(a00),
            y00 = r0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* sin */])(a00);

        // Restrict the corner radius according to the sector angle.
        if (da < __WEBPACK_IMPORTED_MODULE_2__math__["b" /* pi */]) {
          var oc = da0 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */] ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
              ax = x01 - oc[0],
              ay = y01 - oc[1],
              bx = x11 - oc[0],
              by = y11 - oc[1],
              kc = 1 / __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* sin */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* acos */])((ax * bx + ay * by) / (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sqrt */])(ax * ax + ay * ay) * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sqrt */])(bx * bx + by * by))) / 2),
              lc = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sqrt */])(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["j" /* min */])(rc, (r0 - lc) / (kc - 1));
          rc1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["j" /* min */])(rc, (r1 - lc) / (kc + 1));
        }
      }

      // Is the sector collapsed to a line?
      if (!(da1 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */])) context.moveTo(x01, y01);

      // Does the sector’s outer ring have rounded corners?
      else if (rc1 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);

        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t0.y01, t0.x01), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc1, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t0.y01, t0.x01), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r1, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t0.cy + t0.y11, t0.cx + t0.x11), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
          context.arc(t1.cx, t1.cy, rc1, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t1.y11, t1.x11), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the outer ring just a circular arc?
      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);

      // Is there no inner ring, and it’s a circular sector?
      // Or perhaps it’s an annular sector collapsed due to padding?
      if (!(r0 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) || !(da0 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */])) context.lineTo(x10, y10);

      // Does the sector’s inner ring (or point) have rounded corners?
      else if (rc0 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);

        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t0.y01, t0.x01), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t0.y01, t0.x01), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t0.cy + t0.y11, t0.cx + t0.x11), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t1.cy + t1.y11, t1.cx + t1.x11), cw);
          context.arc(t1.cx, t1.cy, rc0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t1.y11, t1.x11), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the inner ring just a circular arc?
      else context.arc(0, 0, r0, a10, a00, cw);
    }

    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  arc.centroid = function() {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - __WEBPACK_IMPORTED_MODULE_2__math__["b" /* pi */] / 2;
    return [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(a) * r, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* sin */])(a) * r];
  };

  arc.innerRadius = function(_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : innerRadius;
  };

  arc.outerRadius = function(_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : outerRadius;
  };

  arc.cornerRadius = function(_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : cornerRadius;
  };

  arc.padRadius = function(_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : padRadius;
  };

  arc.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : startAngle;
  };

  arc.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : endAngle;
  };

  arc.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : padAngle;
  };

  arc.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
  };

  return arc;
});


/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curve_radial__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__area__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lineRadial__ = __webpack_require__(363);




/* harmony default export */ __webpack_exports__["a"] = (function() {
  var a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__area__["a" /* default */])().curve(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["b" /* curveRadialLinear */]),
      c = a.curve,
      x0 = a.lineX0,
      x1 = a.lineX1,
      y0 = a.lineY0,
      y1 = a.lineY1;

  a.angle = a.x, delete a.x;
  a.startAngle = a.x0, delete a.x0;
  a.endAngle = a.x1, delete a.x1;
  a.radius = a.y, delete a.y;
  a.innerRadius = a.y0, delete a.y0;
  a.outerRadius = a.y1, delete a.y1;
  a.lineStartAngle = function() { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["a" /* lineRadial */])(x0()); }, delete a.lineX0;
  a.lineEndAngle = function() { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["a" /* lineRadial */])(x1()); }, delete a.lineX1;
  a.lineInnerRadius = function() { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["a" /* lineRadial */])(y0()); }, delete a.lineY0;
  a.lineOuterRadius = function() { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["a" /* lineRadial */])(y1()); }, delete a.lineY1;

  a.curve = function(_) {
    return arguments.length ? c(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["a" /* default */])(_)) : c()._curve;
  };

  return a;
});


/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__(133);



function BasisClosed(context) {
  this._context = context;
}

BasisClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2);
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
      default: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__basis__["b" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new BasisClosed(context);
});


/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(133);


function BasisOpen(context) {
  this._context = context;
}

BasisOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
      case 3: this._point = 4; // proceed
      default: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__basis__["b" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new BasisOpen(context);
});


/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(133);


function Bundle(context, beta) {
  this._basis = new __WEBPACK_IMPORTED_MODULE_0__basis__["a" /* Basis */](context);
  this._beta = beta;
}

Bundle.prototype = {
  lineStart: function() {
    this._x = [];
    this._y = [];
    this._basis.lineStart();
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        j = x.length - 1;

    if (j > 0) {
      var x0 = x[0],
          y0 = y[0],
          dx = x[j] - x0,
          dy = y[j] - y0,
          i = -1,
          t;

      while (++i <= j) {
        t = i / j;
        this._basis.point(
          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
        );
      }
    }

    this._x = this._y = null;
    this._basis.lineEnd();
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(beta) {

  function bundle(context) {
    return beta === 1 ? new __WEBPACK_IMPORTED_MODULE_0__basis__["a" /* Basis */](context) : new Bundle(context, beta);
  }

  bundle.beta = function(beta) {
    return custom(+beta);
  };

  return bundle;
})(0.85));


/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinalClosed__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__catmullRom__ = __webpack_require__(203);




function CatmullRomClosed(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__catmullRom__["a" /* point */])(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomClosed(context, alpha) : new __WEBPACK_IMPORTED_MODULE_0__cardinalClosed__["a" /* CardinalClosed */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinalOpen__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__catmullRom__ = __webpack_require__(203);



function CatmullRomOpen(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__catmullRom__["a" /* point */])(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomOpen(context, alpha) : new __WEBPACK_IMPORTED_MODULE_0__cardinalOpen__["a" /* CardinalOpen */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(136);


function LinearClosed(context) {
  this._context = context;
}

LinearClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._point) this._context.closePath();
  },
  point: function(x, y) {
    x = +x, y = +y;
    if (this._point) this._context.lineTo(x, y);
    else this._point = 1, this._context.moveTo(x, y);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new LinearClosed(context);
});


/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = monotoneX;
/* harmony export (immutable) */ __webpack_exports__["b"] = monotoneY;
function sign(x) {
  return x < 0 ? -1 : 1;
}

// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
  var h0 = that._x1 - that._x0,
      h1 = x2 - that._x1,
      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
      p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}

// Calculate a one-sided slope.
function slope2(that, t) {
  var h = that._x1 - that._x0;
  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}

// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point(that, t0, t1) {
  var x0 = that._x0,
      y0 = that._y0,
      x1 = that._x1,
      y1 = that._y1,
      dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}

function MonotoneX(context) {
  this._context = context;
}

MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 =
    this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x1, this._y1); break;
      case 3: point(this, this._t0, slope2(this, this._t0)); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    var t1 = NaN;

    x = +x, y = +y;
    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; point(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
      default: point(this, this._t0, t1 = slope3(this, x, y)); break;
    }

    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
    this._t0 = t1;
  }
}

function MonotoneY(context) {
  this._context = new ReflectContext(context);
}

(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
  MonotoneX.prototype.point.call(this, y, x);
};

function ReflectContext(context) {
  this._context = context;
}

ReflectContext.prototype = {
  moveTo: function(x, y) { this._context.moveTo(y, x); },
  closePath: function() { this._context.closePath(); },
  lineTo: function(x, y) { this._context.lineTo(y, x); },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
};

function monotoneX(context) {
  return new MonotoneX(context);
}

function monotoneY(context) {
  return new MonotoneY(context);
}


/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function Natural(context) {
  this._context = context;
}

Natural.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [];
    this._y = [];
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        n = x.length;

    if (n) {
      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
      if (n === 2) {
        this._context.lineTo(x[1], y[1]);
      } else {
        var px = controlPoints(x),
            py = controlPoints(y);
        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
        }
      }
    }

    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
    this._line = 1 - this._line;
    this._x = this._y = null;
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
  var i,
      n = x.length - 1,
      m,
      a = new Array(n),
      b = new Array(n),
      r = new Array(n);
  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
  a[n - 1] = r[n - 1] / b[n - 1];
  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
  b[n - 1] = (x[n] + a[n - 1]) / 2;
  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
  return [a, b];
}

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Natural(context);
});


/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = stepBefore;
/* harmony export (immutable) */ __webpack_exports__["b"] = stepAfter;
function Step(context, t) {
  this._context = context;
  this._t = t;
}

Step.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: {
        if (this._t <= 0) {
          this._context.lineTo(this._x, y);
          this._context.lineTo(x, y);
        } else {
          var x1 = this._x * (1 - this._t) + x * this._t;
          this._context.lineTo(x1, this._y);
          this._context.lineTo(x1, y);
        }
        break;
      }
    }
    this._x = x, this._y = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Step(context, 0.5);
});

function stepBefore(context) {
  return new Step(context, 0);
}

function stepAfter(context) {
  return new Step(context, 1);
}


/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});


/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(d) {
  return d;
});


/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = linkHorizontal;
/* harmony export (immutable) */ __webpack_exports__["b"] = linkVertical;
/* harmony export (immutable) */ __webpack_exports__["c"] = linkRadial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__point__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pointRadial__ = __webpack_require__(364);






function linkSource(d) {
  return d.source;
}

function linkTarget(d) {
  return d.target;
}

function link(curve) {
  var source = linkSource,
      target = linkTarget,
      x = __WEBPACK_IMPORTED_MODULE_3__point__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_3__point__["b" /* y */],
      context = null;

  function link() {
    var buffer, argv = __WEBPACK_IMPORTED_MODULE_1__array__["a" /* slice */].call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
    if (!context) context = buffer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();
    curve(context, +x.apply(this, (argv[0] = s, argv)), +y.apply(this, argv), +x.apply(this, (argv[0] = t, argv)), +y.apply(this, argv));
    if (buffer) return context = null, buffer + "" || null;
  }

  link.source = function(_) {
    return arguments.length ? (source = _, link) : source;
  };

  link.target = function(_) {
    return arguments.length ? (target = _, link) : target;
  };

  link.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(+_), link) : x;
  };

  link.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(+_), link) : y;
  };

  link.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), link) : context;
  };

  return link;
}

function curveHorizontal(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
}

function curveVertical(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
}

function curveRadial(context, x0, y0, x1, y1) {
  var p0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x0, y0),
      p1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x0, y0 = (y0 + y1) / 2),
      p2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x1, y0),
      p3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x1, y1);
  context.moveTo(p0[0], p0[1]);
  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
}

function linkHorizontal() {
  return link(curveHorizontal);
}

function linkVertical() {
  return link(curveVertical);
}

function linkRadial() {
  var l = link(curveRadial);
  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;
  return l;
}


/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
    for (yp = yn = 0, i = 0; i < n; ++i) {
      if ((dy = (d = series[order[i]][j])[1] - d[0]) >= 0) {
        d[0] = yp, d[1] = yp += dy;
      } else if (dy < 0) {
        d[1] = yn, d[0] = yn += dy;
      } else {
        d[0] = yp;
      }
    }
  }
});


/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(101);


/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(101);


/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
    s0[j][1] += s0[j][0] = -y / 2;
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(101);


/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
      var si = series[order[i]],
          sij0 = si[j][1] || 0,
          sij1 = si[j - 1][1] || 0,
          s3 = (sij0 - sij1) / 2;
      for (var k = 0; k < i; ++k) {
        var sk = series[order[k]],
            skj0 = sk[j][1] || 0,
            skj1 = sk[j - 1][1] || 0;
        s3 += skj0 - skj1;
      }
      s1 += sij0, s2 += s3 * sij0;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    if (s1) y -= s2 / s1;
  }
  s0[j - 1][1] += s0[j - 1][0] = y;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(205);


/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ascending__["b" /* default */])(series).reverse();
});


/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(205);



/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  var n = series.length,
      i,
      j,
      sums = series.map(__WEBPACK_IMPORTED_MODULE_1__ascending__["a" /* sum */]),
      order = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).sort(function(a, b) { return sums[b] - sums[a]; }),
      top = 0,
      bottom = 0,
      tops = [],
      bottoms = [];

  for (i = 0; i < n; ++i) {
    j = order[i];
    if (top < bottom) {
      top += sums[j];
      tops.push(j);
    } else {
      bottom += sums[j];
      bottoms.push(j);
    }
  }

  return bottoms.reverse().concat(tops);
});


/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(102);


/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).reverse();
});


/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__descending__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__math__ = __webpack_require__(100);





/* harmony default export */ __webpack_exports__["a"] = (function() {
  var value = __WEBPACK_IMPORTED_MODULE_2__identity__["a" /* default */],
      sortValues = __WEBPACK_IMPORTED_MODULE_1__descending__["a" /* default */],
      sort = null,
      startAngle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0),
      endAngle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__math__["c" /* tau */]),
      padAngle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0);

  function pie(data) {
    var i,
        n = data.length,
        j,
        k,
        sum = 0,
        index = new Array(n),
        arcs = new Array(n),
        a0 = +startAngle.apply(this, arguments),
        da = Math.min(__WEBPACK_IMPORTED_MODULE_3__math__["c" /* tau */], Math.max(-__WEBPACK_IMPORTED_MODULE_3__math__["c" /* tau */], endAngle.apply(this, arguments) - a0)),
        a1,
        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
        pa = p * (da < 0 ? -1 : 1),
        v;

    for (i = 0; i < n; ++i) {
      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
        sum += v;
      }
    }

    // Optionally sort the arcs by previously-computed values or by data.
    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });

    // Compute the arcs! They are stored in the original data's order.
    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
        data: data[j],
        index: i,
        value: v,
        startAngle: a0,
        endAngle: a1,
        padAngle: p
      };
    }

    return arcs;
  }

  pie.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : value;
  };

  pie.sortValues = function(_) {
    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
  };

  pie.sort = function(_) {
    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
  };

  pie.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : startAngle;
  };

  pie.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : endAngle;
  };

  pie.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : padAngle;
  };

  return pie;
});


/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__offset_none__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__order_none__ = __webpack_require__(102);





function stackValue(d, key) {
  return d[key];
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var keys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])([]),
      order = __WEBPACK_IMPORTED_MODULE_3__order_none__["a" /* default */],
      offset = __WEBPACK_IMPORTED_MODULE_2__offset_none__["a" /* default */],
      value = stackValue;

  function stack(data) {
    var kz = keys.apply(this, arguments),
        i,
        m = data.length,
        n = kz.length,
        sz = new Array(n),
        oz;

    for (i = 0; i < n; ++i) {
      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
        si[j] = sij = [0, +value(data[j], ki, j, data)];
        sij.data = data[j];
      }
      si.key = ki;
    }

    for (i = 0, oz = order(sz); i < n; ++i) {
      sz[oz[i]].index = i;
    }

    offset(sz, oz);
    return sz;
  }

  stack.keys = function(_) {
    return arguments.length ? (keys = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_)), stack) : keys;
  };

  stack.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), stack) : value;
  };

  stack.order = function(_) {
    return arguments.length ? (order = _ == null ? __WEBPACK_IMPORTED_MODULE_3__order_none__["a" /* default */] : typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_)), stack) : order;
  };

  stack.offset = function(_) {
    return arguments.length ? (offset = _ == null ? __WEBPACK_IMPORTED_MODULE_2__offset_none__["a" /* default */] : _, stack) : offset;
  };

  return stack;
});


/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return symbols; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__symbol_circle__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__symbol_cross__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__symbol_diamond__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__symbol_star__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__symbol_square__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__symbol_triangle__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__symbol_wye__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constant__ = __webpack_require__(59);










var symbols = [
  __WEBPACK_IMPORTED_MODULE_1__symbol_circle__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_2__symbol_cross__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_3__symbol_diamond__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_5__symbol_square__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_4__symbol_star__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_6__symbol_triangle__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_7__symbol_wye__["a" /* default */]
];

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var type = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__symbol_circle__["a" /* default */]),
      size = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(64),
      context = null;

  function symbol() {
    var buffer;
    if (!context) context = buffer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();
    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
    if (buffer) return context = null, buffer + "" || null;
  }

  symbol.type = function(_) {
    return arguments.length ? (type = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(_), symbol) : type;
  };

  symbol.size = function(_) {
    return arguments.length ? (size = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(+_), symbol) : size;
  };

  symbol.context = function(_) {
    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
  };

  return symbol;
});


/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isoFormat__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultLocale__ = __webpack_require__(207);



function parseIsoNative(string) {
  var date = new Date(string);
  return isNaN(date) ? null : date;
}

var parseIso = +new Date("2000-01-01T00:00:00.000Z")
    ? parseIsoNative
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__defaultLocale__["b" /* utcParse */])(__WEBPACK_IMPORTED_MODULE_0__isoFormat__["a" /* isoSpecifier */]);

/* unused harmony default export */ var _unused_webpack_default_export = (parseIso);


/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export days */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(42);



var day = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setDate(date.getDate() + step);
}, function(start, end) {
  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationDay */];
}, function(date) {
  return date.getDate() - 1;
});

/* harmony default export */ __webpack_exports__["a"] = (day);
var days = day.range;


/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(42);



var hour = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  var offset = date.getTimezoneOffset() * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */] % __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */];
  if (offset < 0) offset += __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */];
  date.setTime(Math.floor((+date - offset) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */] + offset);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */];
}, function(date) {
  return date.getHours();
});

/* harmony default export */ __webpack_exports__["a"] = (hour);
var hours = hour.range;


/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export milliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(24);


var millisecond = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function() {
  // noop
}, function(date, step) {
  date.setTime(+date + step);
}, function(start, end) {
  return end - start;
});

// An optimized implementation for this simple case.
millisecond.every = function(k) {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setTime(Math.floor(date / k) * k);
  }, function(date, step) {
    date.setTime(+date + step * k);
  }, function(start, end) {
    return (end - start) / k;
  });
};

/* harmony default export */ __webpack_exports__["a"] = (millisecond);
var milliseconds = millisecond.range;


/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export minutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(42);



var minute = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setTime(Math.floor(date / __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */];
}, function(date) {
  return date.getMinutes();
});

/* harmony default export */ __webpack_exports__["a"] = (minute);
var minutes = minute.range;


/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export months */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(24);


var month = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setMonth(date.getMonth() + step);
}, function(start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
  return date.getMonth();
});

/* harmony default export */ __webpack_exports__["a"] = (month);
var months = month.range;


/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export seconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(42);



var second = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setTime(Math.floor(date / __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationSecond */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationSecond */]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationSecond */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationSecond */];
}, function(date) {
  return date.getUTCSeconds();
});

/* harmony default export */ __webpack_exports__["a"] = (second);
var seconds = second.range;


/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(42);



var utcDay = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationDay */];
}, function(date) {
  return date.getUTCDate() - 1;
});

/* harmony default export */ __webpack_exports__["a"] = (utcDay);
var utcDays = utcDay.range;


/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(42);



var utcHour = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */];
}, function(date) {
  return date.getUTCHours();
});

/* harmony default export */ __webpack_exports__["a"] = (utcHour);
var utcHours = utcHour.range;


/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(42);



var utcMinute = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCSeconds(0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */];
}, function(date) {
  return date.getUTCMinutes();
});

/* harmony default export */ __webpack_exports__["a"] = (utcMinute);
var utcMinutes = utcMinute.range;


/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(24);


var utcMonth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
  return date.getUTCMonth();
});

/* harmony default export */ __webpack_exports__["a"] = (utcMonth);
var utcMonths = utcMonth.range;


/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return utcSunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcMonday; });
/* unused harmony export utcTuesday */
/* unused harmony export utcWednesday */
/* unused harmony export utcThursday */
/* unused harmony export utcFriday */
/* unused harmony export utcSaturday */
/* unused harmony export utcSundays */
/* unused harmony export utcMondays */
/* unused harmony export utcTuesdays */
/* unused harmony export utcWednesdays */
/* unused harmony export utcThursdays */
/* unused harmony export utcFridays */
/* unused harmony export utcSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(42);



function utcWeekday(i) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function(start, end) {
    return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["a" /* durationWeek */];
  });
}

var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);

var utcSundays = utcSunday.range;
var utcMondays = utcMonday.range;
var utcTuesdays = utcTuesday.range;
var utcWednesdays = utcWednesday.range;
var utcThursdays = utcThursday.range;
var utcFridays = utcFriday.range;
var utcSaturdays = utcSaturday.range;


/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(24);


var utcYear = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (utcYear);
var utcYears = utcYear.range;


/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return monday; });
/* unused harmony export tuesday */
/* unused harmony export wednesday */
/* unused harmony export thursday */
/* unused harmony export friday */
/* unused harmony export saturday */
/* unused harmony export sundays */
/* unused harmony export mondays */
/* unused harmony export tuesdays */
/* unused harmony export wednesdays */
/* unused harmony export thursdays */
/* unused harmony export fridays */
/* unused harmony export saturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(42);



function weekday(i) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration__["a" /* durationWeek */];
  });
}

var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);

var sundays = sunday.range;
var mondays = monday.range;
var tuesdays = tuesday.range;
var wednesdays = wednesday.range;
var thursdays = thursday.range;
var fridays = friday.range;
var saturdays = saturday.range;


/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export years */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(24);


var year = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
  return end.getFullYear() - start.getFullYear();
}, function(date) {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
year.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (year);
var years = year.range;


/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = removeBeach;
/* harmony export (immutable) */ __webpack_exports__["a"] = addBeach;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RedBlackTree__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Cell__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Circle__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Edge__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Diagram__ = __webpack_require__(103);






var beachPool = [];

function Beach() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__RedBlackTree__["b" /* RedBlackNode */])(this);
  this.edge =
  this.site =
  this.circle = null;
}

function createBeach(site) {
  var beach = beachPool.pop() || new Beach;
  beach.site = site;
  return beach;
}

function detachBeach(beach) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(beach);
  __WEBPACK_IMPORTED_MODULE_4__Diagram__["e" /* beaches */].remove(beach);
  beachPool.push(beach);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__RedBlackTree__["b" /* RedBlackNode */])(beach);
}

function removeBeach(beach) {
  var circle = beach.circle,
      x = circle.x,
      y = circle.cy,
      vertex = [x, y],
      previous = beach.P,
      next = beach.N,
      disappearing = [beach];

  detachBeach(beach);

  var lArc = previous;
  while (lArc.circle
      && Math.abs(x - lArc.circle.x) < __WEBPACK_IMPORTED_MODULE_4__Diagram__["b" /* epsilon */]
      && Math.abs(y - lArc.circle.cy) < __WEBPACK_IMPORTED_MODULE_4__Diagram__["b" /* epsilon */]) {
    previous = lArc.P;
    disappearing.unshift(lArc);
    detachBeach(lArc);
    lArc = previous;
  }

  disappearing.unshift(lArc);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(lArc);

  var rArc = next;
  while (rArc.circle
      && Math.abs(x - rArc.circle.x) < __WEBPACK_IMPORTED_MODULE_4__Diagram__["b" /* epsilon */]
      && Math.abs(y - rArc.circle.cy) < __WEBPACK_IMPORTED_MODULE_4__Diagram__["b" /* epsilon */]) {
    next = rArc.N;
    disappearing.push(rArc);
    detachBeach(rArc);
    rArc = next;
  }

  disappearing.push(rArc);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(rArc);

  var nArcs = disappearing.length,
      iArc;
  for (iArc = 1; iArc < nArcs; ++iArc) {
    rArc = disappearing[iArc];
    lArc = disappearing[iArc - 1];
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" /* setEdgeEnd */])(rArc.edge, lArc.site, rArc.site, vertex);
  }

  lArc = disappearing[0];
  rArc = disappearing[nArcs - 1];
  rArc.edge = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__Edge__["d" /* createEdge */])(lArc.site, rArc.site, null, vertex);

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Circle__["c" /* attachCircle */])(lArc);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Circle__["c" /* attachCircle */])(rArc);
}

function addBeach(site) {
  var x = site[0],
      directrix = site[1],
      lArc,
      rArc,
      dxl,
      dxr,
      node = __WEBPACK_IMPORTED_MODULE_4__Diagram__["e" /* beaches */]._;

  while (node) {
    dxl = leftBreakPoint(node, directrix) - x;
    if (dxl > __WEBPACK_IMPORTED_MODULE_4__Diagram__["b" /* epsilon */]) node = node.L; else {
      dxr = x - rightBreakPoint(node, directrix);
      if (dxr > __WEBPACK_IMPORTED_MODULE_4__Diagram__["b" /* epsilon */]) {
        if (!node.R) {
          lArc = node;
          break;
        }
        node = node.R;
      } else {
        if (dxl > -__WEBPACK_IMPORTED_MODULE_4__Diagram__["b" /* epsilon */]) {
          lArc = node.P;
          rArc = node;
        } else if (dxr > -__WEBPACK_IMPORTED_MODULE_4__Diagram__["b" /* epsilon */]) {
          lArc = node;
          rArc = node.N;
        } else {
          lArc = rArc = node;
        }
        break;
      }
    }
  }

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__Cell__["d" /* createCell */])(site);
  var newArc = createBeach(site);
  __WEBPACK_IMPORTED_MODULE_4__Diagram__["e" /* beaches */].insert(lArc, newArc);

  if (!lArc && !rArc) return;

  if (lArc === rArc) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(lArc);
    rArc = createBeach(lArc.site);
    __WEBPACK_IMPORTED_MODULE_4__Diagram__["e" /* beaches */].insert(newArc, rArc);
    newArc.edge = rArc.edge = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__Edge__["d" /* createEdge */])(lArc.site, newArc.site);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Circle__["c" /* attachCircle */])(lArc);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Circle__["c" /* attachCircle */])(rArc);
    return;
  }

  if (!rArc) { // && lArc
    newArc.edge = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__Edge__["d" /* createEdge */])(lArc.site, newArc.site);
    return;
  }

  // else lArc !== rArc
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(lArc);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(rArc);

  var lSite = lArc.site,
      ax = lSite[0],
      ay = lSite[1],
      bx = site[0] - ax,
      by = site[1] - ay,
      rSite = rArc.site,
      cx = rSite[0] - ax,
      cy = rSite[1] - ay,
      d = 2 * (bx * cy - by * cx),
      hb = bx * bx + by * by,
      hc = cx * cx + cy * cy,
      vertex = [(cy * hb - by * hc) / d + ax, (bx * hc - cx * hb) / d + ay];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" /* setEdgeEnd */])(rArc.edge, lSite, rSite, vertex);
  newArc.edge = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__Edge__["d" /* createEdge */])(lSite, site, null, vertex);
  rArc.edge = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__Edge__["d" /* createEdge */])(site, rSite, null, vertex);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Circle__["c" /* attachCircle */])(lArc);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Circle__["c" /* attachCircle */])(rArc);
}

function leftBreakPoint(arc, directrix) {
  var site = arc.site,
      rfocx = site[0],
      rfocy = site[1],
      pby2 = rfocy - directrix;

  if (!pby2) return rfocx;

  var lArc = arc.P;
  if (!lArc) return -Infinity;

  site = lArc.site;
  var lfocx = site[0],
      lfocy = site[1],
      plby2 = lfocy - directrix;

  if (!plby2) return lfocx;

  var hl = lfocx - rfocx,
      aby2 = 1 / pby2 - 1 / plby2,
      b = hl / plby2;

  if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;

  return (rfocx + lfocx) / 2;
}

function rightBreakPoint(arc, directrix) {
  var rArc = arc.N;
  if (rArc) return leftBreakPoint(rArc, directrix);
  var site = arc.site;
  return site[1] === directrix ? site[0] : Infinity;
}


/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = x;
/* harmony export (immutable) */ __webpack_exports__["b"] = y;
function x(d) {
  return d[0];
}

function y(d) {
  return d[1];
}


/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Diagram__ = __webpack_require__(103);




/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x = __WEBPACK_IMPORTED_MODULE_1__point__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_1__point__["b" /* y */],
      extent = null;

  function voronoi(data) {
    return new __WEBPACK_IMPORTED_MODULE_2__Diagram__["a" /* default */](data.map(function(d, i) {
      var s = [Math.round(x(d, i, data) / __WEBPACK_IMPORTED_MODULE_2__Diagram__["b" /* epsilon */]) * __WEBPACK_IMPORTED_MODULE_2__Diagram__["b" /* epsilon */], Math.round(y(d, i, data) / __WEBPACK_IMPORTED_MODULE_2__Diagram__["b" /* epsilon */]) * __WEBPACK_IMPORTED_MODULE_2__Diagram__["b" /* epsilon */]];
      s.index = i;
      s.data = d;
      return s;
    }), extent);
  }

  voronoi.polygons = function(data) {
    return voronoi(data).polygons();
  };

  voronoi.links = function(data) {
    return voronoi(data).links();
  };

  voronoi.triangles = function(data) {
    return voronoi(data).triangles();
  };

  voronoi.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), voronoi) : x;
  };

  voronoi.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), voronoi) : y;
  };

  voronoi.extent = function(_) {
    return arguments.length ? (extent = _ == null ? null : [[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]], voronoi) : extent && [[extent[0][0], extent[0][1]], [extent[1][0], extent[1][1]]];
  };

  voronoi.size = function(_) {
    return arguments.length ? (extent = _ == null ? null : [[0, 0], [+_[0], +_[1]]], voronoi) : extent && [extent[1][0] - extent[0][0], extent[1][1] - extent[0][1]];
  };

  return voronoi;
});


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

var pSlice = Array.prototype.slice;
var objectKeys = __webpack_require__(884);
var isArguments = __webpack_require__(883);

var deepEqual = module.exports = function (actual, expected, opts) {
  if (!opts) opts = {};
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;

  } else if (actual instanceof Date && expected instanceof Date) {
    return actual.getTime() === expected.getTime();

  // 7.3. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
    return opts.strict ? actual === expected : actual == expected;

  // 7.4. For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected, opts);
  }
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer (x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') return false;
  return true;
}

function objEquiv(a, b, opts) {
  var i, key;
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
    return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return deepEqual(a, b, opts);
  }
  if (isBuffer(a)) {
    if (!isBuffer(b)) {
      return false;
    }
    if (a.length !== b.length) return false;
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b);
  } catch (e) {//happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) return false;
  }
  return typeof a === typeof b;
}


/***/ }),
/* 883 */
/***/ (function(module, exports) {

var supportsArgumentsClass = (function(){
  return Object.prototype.toString.call(arguments)
})() == '[object Arguments]';

exports = module.exports = supportsArgumentsClass ? supported : unsupported;

exports.supported = supported;
function supported(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
};

exports.unsupported = unsupported;
function unsupported(object){
  return object &&
    typeof object == 'object' &&
    typeof object.length == 'number' &&
    Object.prototype.hasOwnProperty.call(object, 'callee') &&
    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
    false;
};


/***/ }),
/* 884 */
/***/ (function(module, exports) {

exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addClass;

var _hasClass = __webpack_require__(886);

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element)) element.className = element.className + ' ' + className;
}
module.exports = exports['default'];

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasClass;
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + element.className + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = exports["default"];

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
};

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(137);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var off = function off() {};
if (_inDOM2.default) {
  off = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.removeEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.detachEvent('on' + eventName, handler);
    };
  }();
}

exports.default = off;
module.exports = exports['default'];

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(137);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var on = function on() {};
if (_inDOM2.default) {
  on = function () {

    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.addEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.attachEvent('on' + eventName, function (e) {
        e = e || window.event;
        e.target = e.target || e.srcElement;
        e.currentTarget = node;
        handler.call(node, e);
      });
    };
  }();
}

exports.default = on;
module.exports = exports['default'];

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(137);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var cancel = 'clearTimeout';
var raf = fallback;
var compatRaf = void 0;

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};

if (_inDOM2.default) {
  vendors.some(function (vendor) {
    var rafKey = getKey(vendor, 'request');

    if (rafKey in window) {
      cancel = getKey(vendor, 'cancel');
      return raf = function raf(cb) {
        return window[rafKey](cb);
      };
    }
  });
}

/* https://github.com/component/raf */
var prev = new Date().getTime();
function fallback(fn) {
  var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);

  prev = curr;
  return req;
}

compatRaf = function compatRaf(cb) {
  return raf(cb);
};
compatRaf.cancel = function (id) {
  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
};
exports.default = compatRaf;
module.exports = exports['default'];

/***/ }),
/* 891 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



var camelize = __webpack_require__(892);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

var isTextNode = __webpack_require__(902);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var invariant = __webpack_require__(4);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/

var ExecutionEnvironment = __webpack_require__(26);

var createArrayFromMixed = __webpack_require__(895);
var getMarkupWrap = __webpack_require__(897);
var invariant = __webpack_require__(4);

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = Array.from(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/*eslint-disable fb-www/unsafe-html */

var ExecutionEnvironment = __webpack_require__(26);

var invariant = __webpack_require__(4);

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(899);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var isNode = __webpack_require__(901);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var win;

if (typeof window !== "undefined") {
    win = window;
} else if (typeof global !== "undefined") {
    win = global;
} else if (typeof self !== "undefined"){
    win = self;
} else {
    win = {};
}

module.exports = win;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)))

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(33);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(75);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(212);

var _PathUtils = __webpack_require__(104);

var _createTransitionManager = __webpack_require__(213);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(382);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: _PathUtils.stripLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  },
  slash: {
    encodePath: _PathUtils.addLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    if (basename) path = (0, _PathUtils.stripPrefix)(path, basename);

    return (0, _PathUtils.parsePath)(path);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
  };

  var push = function push(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createHashHistory;

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(33);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(104);

var _LocationUtils = __webpack_require__(212);

var _createTransitionManager = __webpack_require__(213);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = _PathUtils.createPath;

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createMemoryHistory;

/***/ }),
/* 907 */
/***/ (function(module, exports) {

module.exports = [
	{
		"name": "Ghotuo",
		"type": "living",
		"scope": "individual",
		"iso6393": "aaa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Alumu-Tesu",
		"type": "living",
		"scope": "individual",
		"iso6393": "aab",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ari",
		"type": "living",
		"scope": "individual",
		"iso6393": "aac",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Amal",
		"type": "living",
		"scope": "individual",
		"iso6393": "aad",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Arbëreshë Albanian",
		"type": "living",
		"scope": "individual",
		"iso6393": "aae",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aranadan",
		"type": "living",
		"scope": "individual",
		"iso6393": "aaf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ambrak",
		"type": "living",
		"scope": "individual",
		"iso6393": "aag",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Abu' Arapesh",
		"type": "living",
		"scope": "individual",
		"iso6393": "aah",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Arifama-Miniafia",
		"type": "living",
		"scope": "individual",
		"iso6393": "aai",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ankave",
		"type": "living",
		"scope": "individual",
		"iso6393": "aak",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Afade",
		"type": "living",
		"scope": "individual",
		"iso6393": "aal",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Anambé",
		"type": "living",
		"scope": "individual",
		"iso6393": "aan",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Algerian Saharan Arabic",
		"type": "living",
		"scope": "individual",
		"iso6393": "aao",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pará Arára",
		"type": "living",
		"scope": "individual",
		"iso6393": "aap",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Abnaki",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "aaq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Afar",
		"type": "living",
		"scope": "individual",
		"iso6393": "aar",
		"iso6392B": "aar",
		"iso6392T": "aar",
		"iso6391": "aa"
	},
	{
		"name": "Aasáx",
		"type": "living",
		"scope": "individual",
		"iso6393": "aas",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Arvanitika Albanian",
		"type": "living",
		"scope": "individual",
		"iso6393": "aat",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Abau",
		"type": "living",
		"scope": "individual",
		"iso6393": "aau",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Solong",
		"type": "living",
		"scope": "individual",
		"iso6393": "aaw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mandobo Atas",
		"type": "living",
		"scope": "individual",
		"iso6393": "aax",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Amarasi",
		"type": "living",
		"scope": "individual",
		"iso6393": "aaz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Abé",
		"type": "living",
		"scope": "individual",
		"iso6393": "aba",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bankon",
		"type": "living",
		"scope": "individual",
		"iso6393": "abb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ambala Ayta",
		"type": "living",
		"scope": "individual",
		"iso6393": "abc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Manide",
		"type": "living",
		"scope": "individual",
		"iso6393": "abd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Abnaki",
		"type": "living",
		"scope": "individual",
		"iso6393": "abe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Abai Sungai",
		"type": "living",
		"scope": "individual",
		"iso6393": "abf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Abaga",
		"type": "living",
		"scope": "individual",
		"iso6393": "abg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tajiki Arabic",
		"type": "living",
		"scope": "individual",
		"iso6393": "abh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Abidji",
		"type": "living",
		"scope": "individual",
		"iso6393": "abi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aka-Bea",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "abj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Abkhazian",
		"type": "living",
		"scope": "individual",
		"iso6393": "abk",
		"iso6392B": "abk",
		"iso6392T": "abk",
		"iso6391": "ab"
	},
	{
		"name": "Lampung Nyo",
		"type": "living",
		"scope": "individual",
		"iso6393": "abl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Abanyom",
		"type": "living",
		"scope": "individual",
		"iso6393": "abm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Abua",
		"type": "living",
		"scope": "individual",
		"iso6393": "abn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Abon",
		"type": "living",
		"scope": "individual",
		"iso6393": "abo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Abellen Ayta",
		"type": "living",
		"scope": "individual",
		"iso6393": "abp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Abaza",
		"type": "living",
		"scope": "individual",
		"iso6393": "abq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Abron",
		"type": "living",
		"scope": "individual",
		"iso6393": "abr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ambonese Malay",
		"type": "living",
		"scope": "individual",
		"iso6393": "abs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ambulas",
		"type": "living",
		"scope": "individual",
		"iso6393": "abt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Abure",
		"type": "living",
		"scope": "individual",
		"iso6393": "abu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baharna Arabic",
		"type": "living",
		"scope": "individual",
		"iso6393": "abv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pal",
		"type": "living",
		"scope": "individual",
		"iso6393": "abw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Inabaknon",
		"type": "living",
		"scope": "individual",
		"iso6393": "abx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aneme Wake",
		"type": "living",
		"scope": "individual",
		"iso6393": "aby",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Abui",
		"type": "living",
		"scope": "individual",
		"iso6393": "abz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Achagua",
		"type": "living",
		"scope": "individual",
		"iso6393": "aca",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Áncá",
		"type": "living",
		"scope": "individual",
		"iso6393": "acb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gikyode",
		"type": "living",
		"scope": "individual",
		"iso6393": "acd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Achinese",
		"type": "living",
		"scope": "individual",
		"iso6393": "ace",
		"iso6392B": "ace",
		"iso6392T": "ace",
		"iso6391": null
	},
	{
		"name": "Saint Lucian Creole French",
		"type": "living",
		"scope": "individual",
		"iso6393": "acf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Acoli",
		"type": "living",
		"scope": "individual",
		"iso6393": "ach",
		"iso6392B": "ach",
		"iso6392T": "ach",
		"iso6391": null
	},
	{
		"name": "Aka-Cari",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "aci",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aka-Kora",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ack",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Akar-Bale",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "acl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mesopotamian Arabic",
		"type": "living",
		"scope": "individual",
		"iso6393": "acm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Achang",
		"type": "living",
		"scope": "individual",
		"iso6393": "acn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Acipa",
		"type": "living",
		"scope": "individual",
		"iso6393": "acp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ta'izzi-Adeni Arabic",
		"type": "living",
		"scope": "individual",
		"iso6393": "acq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Achi",
		"type": "living",
		"scope": "individual",
		"iso6393": "acr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Acroá",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "acs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Achterhoeks",
		"type": "living",
		"scope": "individual",
		"iso6393": "act",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Achuar-Shiwiar",
		"type": "living",
		"scope": "individual",
		"iso6393": "acu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Achumawi",
		"type": "living",
		"scope": "individual",
		"iso6393": "acv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hijazi Arabic",
		"type": "living",
		"scope": "individual",
		"iso6393": "acw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Omani Arabic",
		"type": "living",
		"scope": "individual",
		"iso6393": "acx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cypriot Arabic",
		"type": "living",
		"scope": "individual",
		"iso6393": "acy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Acheron",
		"type": "living",
		"scope": "individual",
		"iso6393": "acz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Adangme",
		"type": "living",
		"scope": "individual",
		"iso6393": "ada",
		"iso6392B": "ada",
		"iso6392T": "ada",
		"iso6391": null
	},
	{
		"name": "Adabe",
		"type": "living",
		"scope": "individual",
		"iso6393": "adb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dzodinka",
		"type": "living",
		"scope": "individual",
		"iso6393": "add",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Adele",
		"type": "living",
		"scope": "individual",
		"iso6393": "ade",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dhofari Arabic",
		"type": "living",
		"scope": "individual",
		"iso6393": "adf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Andegerebinha",
		"type": "living",
		"scope": "individual",
		"iso6393": "adg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Adhola",
		"type": "living",
		"scope": "individual",
		"iso6393": "adh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Adi",
		"type": "living",
		"scope": "individual",
		"iso6393": "adi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Adioukrou",
		"type": "living",
		"scope": "individual",
		"iso6393": "adj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Galo",
		"type": "living",
		"scope": "individual",
		"iso6393": "adl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Adang",
		"type": "living",
		"scope": "individual",
		"iso6393": "adn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Abu",
		"type": "living",
		"scope": "individual",
		"iso6393": "ado",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Adangbe",
		"type": "living",
		"scope": "individual",
		"iso6393": "adq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Adonara",
		"type": "living",
		"scope": "individual",
		"iso6393": "adr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Adamorobe Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "ads",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Adnyamathanha",
		"type": "living",
		"scope": "individual",
		"iso6393": "adt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aduge",
		"type": "living",
		"scope": "individual",
		"iso6393": "adu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Amundava",
		"type": "living",
		"scope": "individual",
		"iso6393": "adw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Amdo Tibetan",
		"type": "living",
		"scope": "individual",
		"iso6393": "adx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Adyghe",
		"type": "living",
		"scope": "individual",
		"iso6393": "ady",
		"iso6392B": "ady",
		"iso6392T": "ady",
		"iso6391": null
	},
	{
		"name": "Adzera",
		"type": "living",
		"scope": "individual",
		"iso6393": "adz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Areba",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "aea",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tunisian Arabic",
		"type": "living",
		"scope": "individual",
		"iso6393": "aeb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Saidi Arabic",
		"type": "living",
		"scope": "individual",
		"iso6393": "aec",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Argentine Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "aed",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northeast Pashai",
		"type": "living",
		"scope": "individual",
		"iso6393": "aee",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Haeke",
		"type": "living",
		"scope": "individual",
		"iso6393": "aek",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ambele",
		"type": "living",
		"scope": "individual",
		"iso6393": "ael",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Arem",
		"type": "living",
		"scope": "individual",
		"iso6393": "aem",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Armenian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "aen",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aer",
		"type": "living",
		"scope": "individual",
		"iso6393": "aeq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Arrernte",
		"type": "living",
		"scope": "individual",
		"iso6393": "aer",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Alsea",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "aes",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Akeu",
		"type": "living",
		"scope": "individual",
		"iso6393": "aeu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ambakich",
		"type": "living",
		"scope": "individual",
		"iso6393": "aew",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Amele",
		"type": "living",
		"scope": "individual",
		"iso6393": "aey",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aeka",
		"type": "living",
		"scope": "individual",
		"iso6393": "aez",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gulf Arabic",
		"type": "living",
		"scope": "individual",
		"iso6393": "afb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Andai",
		"type": "living",
		"scope": "individual",
		"iso6393": "afd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Putukwam",
		"type": "living",
		"scope": "individual",
		"iso6393": "afe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Afghan Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "afg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Afrihili",
		"type": "constructed",
		"scope": "individual",
		"iso6393": "afh",
		"iso6392B": "afh",
		"iso6392T": "afh",
		"iso6391": null
	},
	{
		"name": "Akrukay",
		"type": "living",
		"scope": "individual",
		"iso6393": "afi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nanubae",
		"type": "living",
		"scope": "individual",
		"iso6393": "afk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Defaka",
		"type": "living",
		"scope": "individual",
		"iso6393": "afn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eloyi",
		"type": "living",
		"scope": "individual",
		"iso6393": "afo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tapei",
		"type": "living",
		"scope": "individual",
		"iso6393": "afp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Afrikaans",
		"type": "living",
		"scope": "individual",
		"iso6393": "afr",
		"iso6392B": "afr",
		"iso6392T": "afr",
		"iso6391": "af"
	},
	{
		"name": "Afro-Seminole Creole",
		"type": "living",
		"scope": "individual",
		"iso6393": "afs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Afitti",
		"type": "living",
		"scope": "individual",
		"iso6393": "aft",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Awutu",
		"type": "living",
		"scope": "individual",
		"iso6393": "afu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Obokuitai",
		"type": "living",
		"scope": "individual",
		"iso6393": "afz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aguano",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "aga",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Legbo",
		"type": "living",
		"scope": "individual",
		"iso6393": "agb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Agatu",
		"type": "living",
		"scope": "individual",
		"iso6393": "agc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Agarabi",
		"type": "living",
		"scope": "individual",
		"iso6393": "agd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Angal",
		"type": "living",
		"scope": "individual",
		"iso6393": "age",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Arguni",
		"type": "living",
		"scope": "individual",
		"iso6393": "agf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Angor",
		"type": "living",
		"scope": "individual",
		"iso6393": "agg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngelima",
		"type": "living",
		"scope": "individual",
		"iso6393": "agh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Agariya",
		"type": "living",
		"scope": "individual",
		"iso6393": "agi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Argobba",
		"type": "living",
		"scope": "individual",
		"iso6393": "agj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Isarog Agta",
		"type": "living",
		"scope": "individual",
		"iso6393": "agk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Fembe",
		"type": "living",
		"scope": "individual",
		"iso6393": "agl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Angaataha",
		"type": "living",
		"scope": "individual",
		"iso6393": "agm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Agutaynen",
		"type": "living",
		"scope": "individual",
		"iso6393": "agn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tainae",
		"type": "living",
		"scope": "individual",
		"iso6393": "ago",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aghem",
		"type": "living",
		"scope": "individual",
		"iso6393": "agq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aguaruna",
		"type": "living",
		"scope": "individual",
		"iso6393": "agr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Esimbi",
		"type": "living",
		"scope": "individual",
		"iso6393": "ags",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Central Cagayan Agta",
		"type": "living",
		"scope": "individual",
		"iso6393": "agt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aguacateco",
		"type": "living",
		"scope": "individual",
		"iso6393": "agu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Remontado Dumagat",
		"type": "living",
		"scope": "individual",
		"iso6393": "agv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kahua",
		"type": "living",
		"scope": "individual",
		"iso6393": "agw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aghul",
		"type": "living",
		"scope": "individual",
		"iso6393": "agx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Alta",
		"type": "living",
		"scope": "individual",
		"iso6393": "agy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mt. Iriga Agta",
		"type": "living",
		"scope": "individual",
		"iso6393": "agz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ahanta",
		"type": "living",
		"scope": "individual",
		"iso6393": "aha",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Axamb",
		"type": "living",
		"scope": "individual",
		"iso6393": "ahb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Qimant",
		"type": "living",
		"scope": "individual",
		"iso6393": "ahg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aghu",
		"type": "living",
		"scope": "individual",
		"iso6393": "ahh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tiagbamrin Aizi",
		"type": "living",
		"scope": "individual",
		"iso6393": "ahi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Akha",
		"type": "living",
		"scope": "individual",
		"iso6393": "ahk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Igo",
		"type": "living",
		"scope": "individual",
		"iso6393": "ahl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mobumrin Aizi",
		"type": "living",
		"scope": "individual",
		"iso6393": "ahm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Àhàn",
		"type": "living",
		"scope": "individual",
		"iso6393": "ahn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ahom",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "aho",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aproumu Aizi",
		"type": "living",
		"scope": "individual",
		"iso6393": "ahp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ahirani",
		"type": "living",
		"scope": "individual",
		"iso6393": "ahr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ashe",
		"type": "living",
		"scope": "individual",
		"iso6393": "ahs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ahtena",
		"type": "living",
		"scope": "individual",
		"iso6393": "aht",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Arosi",
		"type": "living",
		"scope": "individual",
		"iso6393": "aia",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ainu (China)",
		"type": "living",
		"scope": "individual",
		"iso6393": "aib",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ainbai",
		"type": "living",
		"scope": "individual",
		"iso6393": "aic",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Alngith",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "aid",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Amara",
		"type": "living",
		"scope": "individual",
		"iso6393": "aie",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Agi",
		"type": "living",
		"scope": "individual",
		"iso6393": "aif",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Antigua and Barbuda Creole English",
		"type": "living",
		"scope": "individual",
		"iso6393": "aig",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ai-Cham",
		"type": "living",
		"scope": "individual",
		"iso6393": "aih",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Assyrian Neo-Aramaic",
		"type": "living",
		"scope": "individual",
		"iso6393": "aii",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lishanid Noshan",
		"type": "living",
		"scope": "individual",
		"iso6393": "aij",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ake",
		"type": "living",
		"scope": "individual",
		"iso6393": "aik",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aimele",
		"type": "living",
		"scope": "individual",
		"iso6393": "ail",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aimol",
		"type": "living",
		"scope": "individual",
		"iso6393": "aim",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ainu (Japan)",
		"type": "living",
		"scope": "individual",
		"iso6393": "ain",
		"iso6392B": "ain",
		"iso6392T": "ain",
		"iso6391": null
	},
	{
		"name": "Aiton",
		"type": "living",
		"scope": "individual",
		"iso6393": "aio",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Burumakok",
		"type": "living",
		"scope": "individual",
		"iso6393": "aip",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aimaq",
		"type": "living",
		"scope": "individual",
		"iso6393": "aiq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Airoran",
		"type": "living",
		"scope": "individual",
		"iso6393": "air",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nataoran Amis",
		"type": "living",
		"scope": "individual",
		"iso6393": "ais",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Arikem",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ait",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aari",
		"type": "living",
		"scope": "individual",
		"iso6393": "aiw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aighon",
		"type": "living",
		"scope": "individual",
		"iso6393": "aix",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ali",
		"type": "living",
		"scope": "individual",
		"iso6393": "aiy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aja (Sudan)",
		"type": "living",
		"scope": "individual",
		"iso6393": "aja",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aja (Benin)",
		"type": "living",
		"scope": "individual",
		"iso6393": "ajg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ajië",
		"type": "living",
		"scope": "individual",
		"iso6393": "aji",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Andajin",
		"type": "living",
		"scope": "individual",
		"iso6393": "ajn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "South Levantine Arabic",
		"type": "living",
		"scope": "individual",
		"iso6393": "ajp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Judeo-Tunisian Arabic",
		"type": "living",
		"scope": "individual",
		"iso6393": "ajt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Judeo-Moroccan Arabic",
		"type": "living",
		"scope": "individual",
		"iso6393": "aju",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ajawa",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ajw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Amri Karbi",
		"type": "living",
		"scope": "individual",
		"iso6393": "ajz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Akan",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "aka",
		"iso6392B": "aka",
		"iso6392T": "aka",
		"iso6391": "ak"
	},
	{
		"name": "Batak Angkola",
		"type": "living",
		"scope": "individual",
		"iso6393": "akb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mpur",
		"type": "living",
		"scope": "individual",
		"iso6393": "akc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ukpet-Ehom",
		"type": "living",
		"scope": "individual",
		"iso6393": "akd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Akawaio",
		"type": "living",
		"scope": "individual",
		"iso6393": "ake",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Akpa",
		"type": "living",
		"scope": "individual",
		"iso6393": "akf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Anakalangu",
		"type": "living",
		"scope": "individual",
		"iso6393": "akg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Angal Heneng",
		"type": "living",
		"scope": "individual",
		"iso6393": "akh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aiome",
		"type": "living",
		"scope": "individual",
		"iso6393": "aki",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aka-Jeru",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "akj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Akkadian",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "akk",
		"iso6392B": "akk",
		"iso6392T": "akk",
		"iso6391": null
	},
	{
		"name": "Aklanon",
		"type": "living",
		"scope": "individual",
		"iso6393": "akl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aka-Bo",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "akm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Akurio",
		"type": "living",
		"scope": "individual",
		"iso6393": "ako",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Siwu",
		"type": "living",
		"scope": "individual",
		"iso6393": "akp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ak",
		"type": "living",
		"scope": "individual",
		"iso6393": "akq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Araki",
		"type": "living",
		"scope": "individual",
		"iso6393": "akr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Akaselem",
		"type": "living",
		"scope": "individual",
		"iso6393": "aks",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Akolet",
		"type": "living",
		"scope": "individual",
		"iso6393": "akt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Akum",
		"type": "living",
		"scope": "individual",
		"iso6393": "aku",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Akhvakh",
		"type": "living",
		"scope": "individual",
		"iso6393": "akv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Akwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "akw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aka-Kede",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "akx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aka-Kol",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "aky",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Alabama",
		"type": "living",
		"scope": "individual",
		"iso6393": "akz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Alago",
		"type": "living",
		"scope": "individual",
		"iso6393": "ala",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Qawasqar",
		"type": "living",
		"scope": "individual",
		"iso6393": "alc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Alladian",
		"type": "living",
		"scope": "individual",
		"iso6393": "ald",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aleut",
		"type": "living",
		"scope": "individual",
		"iso6393": "ale",
		"iso6392B": "ale",
		"iso6392T": "ale",
		"iso6391": null
	},
	{
		"name": "Alege",
		"type": "living",
		"scope": "individual",
		"iso6393": "alf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Alawa",
		"type": "living",
		"scope": "individual",
		"iso6393": "alh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Amaimon",
		"type": "living",
		"scope": "individual",
		"iso6393": "ali",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Alangan",
		"type": "living",
		"scope": "individual",
		"iso6393": "alj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Alak",
		"type": "living",
		"scope": "individual",
		"iso6393": "alk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Allar",
		"type": "living",
		"scope": "individual",
		"iso6393": "all",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Amblong",
		"type": "living",
		"scope": "individual",
		"iso6393": "alm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gheg Albanian",
		"type": "living",
		"scope": "individual",
		"iso6393": "aln",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Larike-Wakasihu",
		"type": "living",
		"scope": "individual",
		"iso6393": "alo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Alune",
		"type": "living",
		"scope": "individual",
		"iso6393": "alp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Algonquin",
		"type": "living",
		"scope": "individual",
		"iso6393": "alq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Alutor",
		"type": "living",
		"scope": "individual",
		"iso6393": "alr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tosk Albanian",
		"type": "living",
		"scope": "individual",
		"iso6393": "als",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Altai",
		"type": "living",
		"scope": "individual",
		"iso6393": "alt",
		"iso6392B": "alt",
		"iso6392T": "alt",
		"iso6391": null
	},
	{
		"name": "'Are'are",
		"type": "living",
		"scope": "individual",
		"iso6393": "alu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Alaba-K’abeena",
		"type": "living",
		"scope": "individual",
		"iso6393": "alw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Amol",
		"type": "living",
		"scope": "individual",
		"iso6393": "alx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Alyawarr",
		"type": "living",
		"scope": "individual",
		"iso6393": "aly",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Alur",
		"type": "living",
		"scope": "individual",
		"iso6393": "alz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Amanayé",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ama",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ambo",
		"type": "living",
		"scope": "individual",
		"iso6393": "amb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Amahuaca",
		"type": "living",
		"scope": "individual",
		"iso6393": "amc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yanesha'",
		"type": "living",
		"scope": "individual",
		"iso6393": "ame",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hamer-Banna",
		"type": "living",
		"scope": "individual",
		"iso6393": "amf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Amurdak",
		"type": "living",
		"scope": "individual",
		"iso6393": "amg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Amharic",
		"type": "living",
		"scope": "individual",
		"iso6393": "amh",
		"iso6392B": "amh",
		"iso6392T": "amh",
		"iso6391": "am"
	},
	{
		"name": "Amis",
		"type": "living",
		"scope": "individual",
		"iso6393": "ami",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Amdang",
		"type": "living",
		"scope": "individual",
		"iso6393": "amj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ambai",
		"type": "living",
		"scope": "individual",
		"iso6393": "amk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "War-Jaintia",
		"type": "living",
		"scope": "individual",
		"iso6393": "aml",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ama (Papua New Guinea)",
		"type": "living",
		"scope": "individual",
		"iso6393": "amm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Amanab",
		"type": "living",
		"scope": "individual",
		"iso6393": "amn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Amo",
		"type": "living",
		"scope": "individual",
		"iso6393": "amo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Alamblak",
		"type": "living",
		"scope": "individual",
		"iso6393": "amp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Amahai",
		"type": "living",
		"scope": "individual",
		"iso6393": "amq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Amarakaeri",
		"type": "living",
		"scope": "individual",
		"iso6393": "amr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Amami-Oshima",
		"type": "living",
		"scope": "individual",
		"iso6393": "ams",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Amto",
		"type": "living",
		"scope": "individual",
		"iso6393": "amt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Guerrero Amuzgo",
		"type": "living",
		"scope": "individual",
		"iso6393": "amu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ambelau",
		"type": "living",
		"scope": "individual",
		"iso6393": "amv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Neo-Aramaic",
		"type": "living",
		"scope": "individual",
		"iso6393": "amw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Anmatyerre",
		"type": "living",
		"scope": "individual",
		"iso6393": "amx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ami",
		"type": "living",
		"scope": "individual",
		"iso6393": "amy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Atampaya",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "amz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Andaqui",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ana",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Andoa",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "anb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngas",
		"type": "living",
		"scope": "individual",
		"iso6393": "anc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ansus",
		"type": "living",
		"scope": "individual",
		"iso6393": "and",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Xârâcùù",
		"type": "living",
		"scope": "individual",
		"iso6393": "ane",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Animere",
		"type": "living",
		"scope": "individual",
		"iso6393": "anf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Old English (ca. 450-1100)",
		"type": "historical",
		"scope": "individual",
		"iso6393": "ang",
		"iso6392B": "ang",
		"iso6392T": "ang",
		"iso6391": null
	},
	{
		"name": "Nend",
		"type": "living",
		"scope": "individual",
		"iso6393": "anh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Andi",
		"type": "living",
		"scope": "individual",
		"iso6393": "ani",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Anor",
		"type": "living",
		"scope": "individual",
		"iso6393": "anj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Goemai",
		"type": "living",
		"scope": "individual",
		"iso6393": "ank",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Anu-Hkongso Chin",
		"type": "living",
		"scope": "individual",
		"iso6393": "anl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Anal",
		"type": "living",
		"scope": "individual",
		"iso6393": "anm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Obolo",
		"type": "living",
		"scope": "individual",
		"iso6393": "ann",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Andoque",
		"type": "living",
		"scope": "individual",
		"iso6393": "ano",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Angika",
		"type": "living",
		"scope": "individual",
		"iso6393": "anp",
		"iso6392B": "anp",
		"iso6392T": "anp",
		"iso6391": null
	},
	{
		"name": "Jarawa (India)",
		"type": "living",
		"scope": "individual",
		"iso6393": "anq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Andh",
		"type": "living",
		"scope": "individual",
		"iso6393": "anr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Anserma",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ans",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Antakarinya",
		"type": "living",
		"scope": "individual",
		"iso6393": "ant",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Anuak",
		"type": "living",
		"scope": "individual",
		"iso6393": "anu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Denya",
		"type": "living",
		"scope": "individual",
		"iso6393": "anv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Anaang",
		"type": "living",
		"scope": "individual",
		"iso6393": "anw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Andra-Hus",
		"type": "living",
		"scope": "individual",
		"iso6393": "anx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Anyin",
		"type": "living",
		"scope": "individual",
		"iso6393": "any",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Anem",
		"type": "living",
		"scope": "individual",
		"iso6393": "anz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Angolar",
		"type": "living",
		"scope": "individual",
		"iso6393": "aoa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Abom",
		"type": "living",
		"scope": "individual",
		"iso6393": "aob",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pemon",
		"type": "living",
		"scope": "individual",
		"iso6393": "aoc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Andarum",
		"type": "living",
		"scope": "individual",
		"iso6393": "aod",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Angal Enen",
		"type": "living",
		"scope": "individual",
		"iso6393": "aoe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bragat",
		"type": "living",
		"scope": "individual",
		"iso6393": "aof",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Angoram",
		"type": "living",
		"scope": "individual",
		"iso6393": "aog",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Arma",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "aoh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Anindilyakwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "aoi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mufian",
		"type": "living",
		"scope": "individual",
		"iso6393": "aoj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Arhö",
		"type": "living",
		"scope": "individual",
		"iso6393": "aok",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Alor",
		"type": "living",
		"scope": "individual",
		"iso6393": "aol",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ömie",
		"type": "living",
		"scope": "individual",
		"iso6393": "aom",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bumbita Arapesh",
		"type": "living",
		"scope": "individual",
		"iso6393": "aon",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aore",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "aor",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Taikat",
		"type": "living",
		"scope": "individual",
		"iso6393": "aos",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Atong (India)",
		"type": "living",
		"scope": "individual",
		"iso6393": "aot",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "A'ou",
		"type": "living",
		"scope": "individual",
		"iso6393": "aou",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Atorada",
		"type": "living",
		"scope": "individual",
		"iso6393": "aox",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Uab Meto",
		"type": "living",
		"scope": "individual",
		"iso6393": "aoz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sa'a",
		"type": "living",
		"scope": "individual",
		"iso6393": "apb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "North Levantine Arabic",
		"type": "living",
		"scope": "individual",
		"iso6393": "apc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sudanese Arabic",
		"type": "living",
		"scope": "individual",
		"iso6393": "apd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bukiyip",
		"type": "living",
		"scope": "individual",
		"iso6393": "ape",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pahanan Agta",
		"type": "living",
		"scope": "individual",
		"iso6393": "apf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ampanang",
		"type": "living",
		"scope": "individual",
		"iso6393": "apg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Athpariya",
		"type": "living",
		"scope": "individual",
		"iso6393": "aph",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Apiaká",
		"type": "living",
		"scope": "individual",
		"iso6393": "api",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jicarilla Apache",
		"type": "living",
		"scope": "individual",
		"iso6393": "apj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kiowa Apache",
		"type": "living",
		"scope": "individual",
		"iso6393": "apk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lipan Apache",
		"type": "living",
		"scope": "individual",
		"iso6393": "apl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mescalero-Chiricahua Apache",
		"type": "living",
		"scope": "individual",
		"iso6393": "apm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Apinayé",
		"type": "living",
		"scope": "individual",
		"iso6393": "apn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ambul",
		"type": "living",
		"scope": "individual",
		"iso6393": "apo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Apma",
		"type": "living",
		"scope": "individual",
		"iso6393": "app",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "A-Pucikwar",
		"type": "living",
		"scope": "individual",
		"iso6393": "apq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Arop-Lokep",
		"type": "living",
		"scope": "individual",
		"iso6393": "apr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Arop-Sissano",
		"type": "living",
		"scope": "individual",
		"iso6393": "aps",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Apatani",
		"type": "living",
		"scope": "individual",
		"iso6393": "apt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Apurinã",
		"type": "living",
		"scope": "individual",
		"iso6393": "apu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Alapmunte",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "apv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Apache",
		"type": "living",
		"scope": "individual",
		"iso6393": "apw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aputai",
		"type": "living",
		"scope": "individual",
		"iso6393": "apx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Apalaí",
		"type": "living",
		"scope": "individual",
		"iso6393": "apy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Safeyoka",
		"type": "living",
		"scope": "individual",
		"iso6393": "apz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Archi",
		"type": "living",
		"scope": "individual",
		"iso6393": "aqc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ampari Dogon",
		"type": "living",
		"scope": "individual",
		"iso6393": "aqd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Arigidi",
		"type": "living",
		"scope": "individual",
		"iso6393": "aqg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Atohwaim",
		"type": "living",
		"scope": "individual",
		"iso6393": "aqm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Alta",
		"type": "living",
		"scope": "individual",
		"iso6393": "aqn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Atakapa",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "aqp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Arhâ",
		"type": "living",
		"scope": "individual",
		"iso6393": "aqr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Angaité",
		"type": "living",
		"scope": "individual",
		"iso6393": "aqt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Akuntsu",
		"type": "living",
		"scope": "individual",
		"iso6393": "aqz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Arabic",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "ara",
		"iso6392B": "ara",
		"iso6392T": "ara",
		"iso6391": "ar"
	},
	{
		"name": "Standard Arabic",
		"type": "living",
		"scope": "individual",
		"iso6393": "arb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Official Aramaic (700-300 BCE)",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "arc",
		"iso6392B": "arc",
		"iso6392T": "arc",
		"iso6391": null
	},
	{
		"name": "Arabana",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ard",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Arrarnta",
		"type": "living",
		"scope": "individual",
		"iso6393": "are",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aragonese",
		"type": "living",
		"scope": "individual",
		"iso6393": "arg",
		"iso6392B": "arg",
		"iso6392T": "arg",
		"iso6391": "an"
	},
	{
		"name": "Arhuaco",
		"type": "living",
		"scope": "individual",
		"iso6393": "arh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Arikara",
		"type": "living",
		"scope": "individual",
		"iso6393": "ari",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Arapaso",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "arj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Arikapú",
		"type": "living",
		"scope": "individual",
		"iso6393": "ark",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Arabela",
		"type": "living",
		"scope": "individual",
		"iso6393": "arl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mapudungun",
		"type": "living",
		"scope": "individual",
		"iso6393": "arn",
		"iso6392B": "arn",
		"iso6392T": "arn",
		"iso6391": null
	},
	{
		"name": "Araona",
		"type": "living",
		"scope": "individual",
		"iso6393": "aro",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Arapaho",
		"type": "living",
		"scope": "individual",
		"iso6393": "arp",
		"iso6392B": "arp",
		"iso6392T": "arp",
		"iso6391": null
	},
	{
		"name": "Algerian Arabic",
		"type": "living",
		"scope": "individual",
		"iso6393": "arq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Karo (Brazil)",
		"type": "living",
		"scope": "individual",
		"iso6393": "arr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Najdi Arabic",
		"type": "living",
		"scope": "individual",
		"iso6393": "ars",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aruá (Amazonas State)",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "aru",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Arbore",
		"type": "living",
		"scope": "individual",
		"iso6393": "arv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Arawak",
		"type": "living",
		"scope": "individual",
		"iso6393": "arw",
		"iso6392B": "arw",
		"iso6392T": "arw",
		"iso6391": null
	},
	{
		"name": "Aruá (Rodonia State)",
		"type": "living",
		"scope": "individual",
		"iso6393": "arx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Moroccan Arabic",
		"type": "living",
		"scope": "individual",
		"iso6393": "ary",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Egyptian Arabic",
		"type": "living",
		"scope": "individual",
		"iso6393": "arz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Asu (Tanzania)",
		"type": "living",
		"scope": "individual",
		"iso6393": "asa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Assiniboine",
		"type": "living",
		"scope": "individual",
		"iso6393": "asb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Casuarina Coast Asmat",
		"type": "living",
		"scope": "individual",
		"iso6393": "asc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Asas",
		"type": "living",
		"scope": "individual",
		"iso6393": "asd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "American Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "ase",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Australian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "asf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cishingini",
		"type": "living",
		"scope": "individual",
		"iso6393": "asg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Abishira",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ash",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Buruwai",
		"type": "living",
		"scope": "individual",
		"iso6393": "asi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sari",
		"type": "living",
		"scope": "individual",
		"iso6393": "asj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ashkun",
		"type": "living",
		"scope": "individual",
		"iso6393": "ask",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Asilulu",
		"type": "living",
		"scope": "individual",
		"iso6393": "asl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Assamese",
		"type": "living",
		"scope": "individual",
		"iso6393": "asm",
		"iso6392B": "asm",
		"iso6392T": "asm",
		"iso6391": "as"
	},
	{
		"name": "Xingú Asuriní",
		"type": "living",
		"scope": "individual",
		"iso6393": "asn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dano",
		"type": "living",
		"scope": "individual",
		"iso6393": "aso",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Algerian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "asp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Austrian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "asq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Asuri",
		"type": "living",
		"scope": "individual",
		"iso6393": "asr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ipulo",
		"type": "living",
		"scope": "individual",
		"iso6393": "ass",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Asturian",
		"type": "living",
		"scope": "individual",
		"iso6393": "ast",
		"iso6392B": "ast",
		"iso6392T": "ast",
		"iso6391": null
	},
	{
		"name": "Tocantins Asurini",
		"type": "living",
		"scope": "individual",
		"iso6393": "asu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Asoa",
		"type": "living",
		"scope": "individual",
		"iso6393": "asv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Australian Aborigines Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "asw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Muratayak",
		"type": "living",
		"scope": "individual",
		"iso6393": "asx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yaosakor Asmat",
		"type": "living",
		"scope": "individual",
		"iso6393": "asy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "As",
		"type": "living",
		"scope": "individual",
		"iso6393": "asz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pele-Ata",
		"type": "living",
		"scope": "individual",
		"iso6393": "ata",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zaiwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "atb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Atsahuaca",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "atc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ata Manobo",
		"type": "living",
		"scope": "individual",
		"iso6393": "atd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Atemble",
		"type": "living",
		"scope": "individual",
		"iso6393": "ate",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ivbie North-Okpela-Arhe",
		"type": "living",
		"scope": "individual",
		"iso6393": "atg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Attié",
		"type": "living",
		"scope": "individual",
		"iso6393": "ati",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Atikamekw",
		"type": "living",
		"scope": "individual",
		"iso6393": "atj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ati",
		"type": "living",
		"scope": "individual",
		"iso6393": "atk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mt. Iraya Agta",
		"type": "living",
		"scope": "individual",
		"iso6393": "atl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ata",
		"type": "living",
		"scope": "individual",
		"iso6393": "atm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ashtiani",
		"type": "living",
		"scope": "individual",
		"iso6393": "atn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Atong (Cameroon)",
		"type": "living",
		"scope": "individual",
		"iso6393": "ato",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pudtol Atta",
		"type": "living",
		"scope": "individual",
		"iso6393": "atp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aralle-Tabulahan",
		"type": "living",
		"scope": "individual",
		"iso6393": "atq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Waimiri-Atroari",
		"type": "living",
		"scope": "individual",
		"iso6393": "atr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gros Ventre",
		"type": "living",
		"scope": "individual",
		"iso6393": "ats",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pamplona Atta",
		"type": "living",
		"scope": "individual",
		"iso6393": "att",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Reel",
		"type": "living",
		"scope": "individual",
		"iso6393": "atu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Altai",
		"type": "living",
		"scope": "individual",
		"iso6393": "atv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Atsugewi",
		"type": "living",
		"scope": "individual",
		"iso6393": "atw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Arutani",
		"type": "living",
		"scope": "individual",
		"iso6393": "atx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aneityum",
		"type": "living",
		"scope": "individual",
		"iso6393": "aty",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Arta",
		"type": "living",
		"scope": "individual",
		"iso6393": "atz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Asumboa",
		"type": "living",
		"scope": "individual",
		"iso6393": "aua",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Alugu",
		"type": "living",
		"scope": "individual",
		"iso6393": "aub",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Waorani",
		"type": "living",
		"scope": "individual",
		"iso6393": "auc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Anuta",
		"type": "living",
		"scope": "individual",
		"iso6393": "aud",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aguna",
		"type": "living",
		"scope": "individual",
		"iso6393": "aug",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aushi",
		"type": "living",
		"scope": "individual",
		"iso6393": "auh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Anuki",
		"type": "living",
		"scope": "individual",
		"iso6393": "aui",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Awjilah",
		"type": "living",
		"scope": "individual",
		"iso6393": "auj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Heyo",
		"type": "living",
		"scope": "individual",
		"iso6393": "auk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aulua",
		"type": "living",
		"scope": "individual",
		"iso6393": "aul",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Asu (Nigeria)",
		"type": "living",
		"scope": "individual",
		"iso6393": "aum",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Molmo One",
		"type": "living",
		"scope": "individual",
		"iso6393": "aun",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Auyokawa",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "auo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Makayam",
		"type": "living",
		"scope": "individual",
		"iso6393": "aup",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Anus",
		"type": "living",
		"scope": "individual",
		"iso6393": "auq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aruek",
		"type": "living",
		"scope": "individual",
		"iso6393": "aur",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Austral",
		"type": "living",
		"scope": "individual",
		"iso6393": "aut",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Auye",
		"type": "living",
		"scope": "individual",
		"iso6393": "auu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Awyi",
		"type": "living",
		"scope": "individual",
		"iso6393": "auw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aurá",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "aux",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Awiyaana",
		"type": "living",
		"scope": "individual",
		"iso6393": "auy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Uzbeki Arabic",
		"type": "living",
		"scope": "individual",
		"iso6393": "auz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Avaric",
		"type": "living",
		"scope": "individual",
		"iso6393": "ava",
		"iso6392B": "ava",
		"iso6392T": "ava",
		"iso6391": "av"
	},
	{
		"name": "Avau",
		"type": "living",
		"scope": "individual",
		"iso6393": "avb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Alviri-Vidari",
		"type": "living",
		"scope": "individual",
		"iso6393": "avd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Avestan",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "ave",
		"iso6392B": "ave",
		"iso6392T": "ave",
		"iso6391": "ae"
	},
	{
		"name": "Avikam",
		"type": "living",
		"scope": "individual",
		"iso6393": "avi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kotava",
		"type": "constructed",
		"scope": "individual",
		"iso6393": "avk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Egyptian Bedawi Arabic",
		"type": "living",
		"scope": "individual",
		"iso6393": "avl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Angkamuthi",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "avm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Avatime",
		"type": "living",
		"scope": "individual",
		"iso6393": "avn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Agavotaguerra",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "avo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aushiri",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "avs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Au",
		"type": "living",
		"scope": "individual",
		"iso6393": "avt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Avokaya",
		"type": "living",
		"scope": "individual",
		"iso6393": "avu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Avá-Canoeiro",
		"type": "living",
		"scope": "individual",
		"iso6393": "avv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Awadhi",
		"type": "living",
		"scope": "individual",
		"iso6393": "awa",
		"iso6392B": "awa",
		"iso6392T": "awa",
		"iso6391": null
	},
	{
		"name": "Awa (Papua New Guinea)",
		"type": "living",
		"scope": "individual",
		"iso6393": "awb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cicipu",
		"type": "living",
		"scope": "individual",
		"iso6393": "awc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Awetí",
		"type": "living",
		"scope": "individual",
		"iso6393": "awe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Anguthimri",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "awg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Awbono",
		"type": "living",
		"scope": "individual",
		"iso6393": "awh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aekyom",
		"type": "living",
		"scope": "individual",
		"iso6393": "awi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Awabakal",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "awk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Arawum",
		"type": "living",
		"scope": "individual",
		"iso6393": "awm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Awngi",
		"type": "living",
		"scope": "individual",
		"iso6393": "awn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Awak",
		"type": "living",
		"scope": "individual",
		"iso6393": "awo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Awera",
		"type": "living",
		"scope": "individual",
		"iso6393": "awr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "South Awyu",
		"type": "living",
		"scope": "individual",
		"iso6393": "aws",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Araweté",
		"type": "living",
		"scope": "individual",
		"iso6393": "awt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Central Awyu",
		"type": "living",
		"scope": "individual",
		"iso6393": "awu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jair Awyu",
		"type": "living",
		"scope": "individual",
		"iso6393": "awv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Awun",
		"type": "living",
		"scope": "individual",
		"iso6393": "aww",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Awara",
		"type": "living",
		"scope": "individual",
		"iso6393": "awx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Edera Awyu",
		"type": "living",
		"scope": "individual",
		"iso6393": "awy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Abipon",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "axb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ayerrerenge",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "axe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mato Grosso Arára",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "axg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yaka (Central African Republic)",
		"type": "living",
		"scope": "individual",
		"iso6393": "axk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lower Southern Aranda",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "axl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Middle Armenian",
		"type": "historical",
		"scope": "individual",
		"iso6393": "axm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Xârâgurè",
		"type": "living",
		"scope": "individual",
		"iso6393": "axx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Awar",
		"type": "living",
		"scope": "individual",
		"iso6393": "aya",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ayizo Gbe",
		"type": "living",
		"scope": "individual",
		"iso6393": "ayb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Aymara",
		"type": "living",
		"scope": "individual",
		"iso6393": "ayc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ayabadhu",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ayd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ayere",
		"type": "living",
		"scope": "individual",
		"iso6393": "aye",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ginyanga",
		"type": "living",
		"scope": "individual",
		"iso6393": "ayg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hadrami Arabic",
		"type": "living",
		"scope": "individual",
		"iso6393": "ayh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Leyigha",
		"type": "living",
		"scope": "individual",
		"iso6393": "ayi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Akuku",
		"type": "living",
		"scope": "individual",
		"iso6393": "ayk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Libyan Arabic",
		"type": "living",
		"scope": "individual",
		"iso6393": "ayl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aymara",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "aym",
		"iso6392B": "aym",
		"iso6392T": "aym",
		"iso6391": "ay"
	},
	{
		"name": "Sanaani Arabic",
		"type": "living",
		"scope": "individual",
		"iso6393": "ayn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ayoreo",
		"type": "living",
		"scope": "individual",
		"iso6393": "ayo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "North Mesopotamian Arabic",
		"type": "living",
		"scope": "individual",
		"iso6393": "ayp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ayi (Papua New Guinea)",
		"type": "living",
		"scope": "individual",
		"iso6393": "ayq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Central Aymara",
		"type": "living",
		"scope": "individual",
		"iso6393": "ayr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sorsogon Ayta",
		"type": "living",
		"scope": "individual",
		"iso6393": "ays",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Magbukun Ayta",
		"type": "living",
		"scope": "individual",
		"iso6393": "ayt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ayu",
		"type": "living",
		"scope": "individual",
		"iso6393": "ayu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tayabas Ayta",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ayy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mai Brat",
		"type": "living",
		"scope": "individual",
		"iso6393": "ayz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Azha",
		"type": "living",
		"scope": "individual",
		"iso6393": "aza",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "South Azerbaijani",
		"type": "living",
		"scope": "individual",
		"iso6393": "azb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Durango Nahuatl",
		"type": "living",
		"scope": "individual",
		"iso6393": "azd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Azerbaijani",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "aze",
		"iso6392B": "aze",
		"iso6392T": "aze",
		"iso6391": "az"
	},
	{
		"name": "San Pedro Amuzgos Amuzgo",
		"type": "living",
		"scope": "individual",
		"iso6393": "azg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "North Azerbaijani",
		"type": "living",
		"scope": "individual",
		"iso6393": "azj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ipalapa Amuzgo",
		"type": "living",
		"scope": "individual",
		"iso6393": "azm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Durango Nahuatl",
		"type": "living",
		"scope": "individual",
		"iso6393": "azn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Awing",
		"type": "living",
		"scope": "individual",
		"iso6393": "azo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Faire Atta",
		"type": "living",
		"scope": "individual",
		"iso6393": "azt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Highland Puebla Nahuatl",
		"type": "living",
		"scope": "individual",
		"iso6393": "azz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Babatana",
		"type": "living",
		"scope": "individual",
		"iso6393": "baa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bainouk-Gunyuño",
		"type": "living",
		"scope": "individual",
		"iso6393": "bab",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Badui",
		"type": "living",
		"scope": "individual",
		"iso6393": "bac",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baré",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "bae",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nubaca",
		"type": "living",
		"scope": "individual",
		"iso6393": "baf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tuki",
		"type": "living",
		"scope": "individual",
		"iso6393": "bag",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bahamas Creole English",
		"type": "living",
		"scope": "individual",
		"iso6393": "bah",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Barakai",
		"type": "living",
		"scope": "individual",
		"iso6393": "baj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bashkir",
		"type": "living",
		"scope": "individual",
		"iso6393": "bak",
		"iso6392B": "bak",
		"iso6392T": "bak",
		"iso6391": "ba"
	},
	{
		"name": "Baluchi",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "bal",
		"iso6392B": "bal",
		"iso6392T": "bal",
		"iso6391": null
	},
	{
		"name": "Bambara",
		"type": "living",
		"scope": "individual",
		"iso6393": "bam",
		"iso6392B": "bam",
		"iso6392T": "bam",
		"iso6391": "bm"
	},
	{
		"name": "Balinese",
		"type": "living",
		"scope": "individual",
		"iso6393": "ban",
		"iso6392B": "ban",
		"iso6392T": "ban",
		"iso6391": null
	},
	{
		"name": "Waimaha",
		"type": "living",
		"scope": "individual",
		"iso6393": "bao",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bantawa",
		"type": "living",
		"scope": "individual",
		"iso6393": "bap",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bavarian",
		"type": "living",
		"scope": "individual",
		"iso6393": "bar",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Basa (Cameroon)",
		"type": "living",
		"scope": "individual",
		"iso6393": "bas",
		"iso6392B": "bas",
		"iso6392T": "bas",
		"iso6391": null
	},
	{
		"name": "Bada (Nigeria)",
		"type": "living",
		"scope": "individual",
		"iso6393": "bau",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Vengo",
		"type": "living",
		"scope": "individual",
		"iso6393": "bav",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bambili-Bambui",
		"type": "living",
		"scope": "individual",
		"iso6393": "baw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bamun",
		"type": "living",
		"scope": "individual",
		"iso6393": "bax",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Batuley",
		"type": "living",
		"scope": "individual",
		"iso6393": "bay",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baatonum",
		"type": "living",
		"scope": "individual",
		"iso6393": "bba",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Barai",
		"type": "living",
		"scope": "individual",
		"iso6393": "bbb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Batak Toba",
		"type": "living",
		"scope": "individual",
		"iso6393": "bbc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bau",
		"type": "living",
		"scope": "individual",
		"iso6393": "bbd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bangba",
		"type": "living",
		"scope": "individual",
		"iso6393": "bbe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baibai",
		"type": "living",
		"scope": "individual",
		"iso6393": "bbf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Barama",
		"type": "living",
		"scope": "individual",
		"iso6393": "bbg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bugan",
		"type": "living",
		"scope": "individual",
		"iso6393": "bbh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Barombi",
		"type": "living",
		"scope": "individual",
		"iso6393": "bbi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ghomálá'",
		"type": "living",
		"scope": "individual",
		"iso6393": "bbj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Babanki",
		"type": "living",
		"scope": "individual",
		"iso6393": "bbk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bats",
		"type": "living",
		"scope": "individual",
		"iso6393": "bbl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Babango",
		"type": "living",
		"scope": "individual",
		"iso6393": "bbm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Uneapa",
		"type": "living",
		"scope": "individual",
		"iso6393": "bbn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Bobo Madaré",
		"type": "living",
		"scope": "individual",
		"iso6393": "bbo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "West Central Banda",
		"type": "living",
		"scope": "individual",
		"iso6393": "bbp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bamali",
		"type": "living",
		"scope": "individual",
		"iso6393": "bbq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Girawa",
		"type": "living",
		"scope": "individual",
		"iso6393": "bbr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bakpinka",
		"type": "living",
		"scope": "individual",
		"iso6393": "bbs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mburku",
		"type": "living",
		"scope": "individual",
		"iso6393": "bbt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kulung (Nigeria)",
		"type": "living",
		"scope": "individual",
		"iso6393": "bbu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Karnai",
		"type": "living",
		"scope": "individual",
		"iso6393": "bbv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baba",
		"type": "living",
		"scope": "individual",
		"iso6393": "bbw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bubia",
		"type": "living",
		"scope": "individual",
		"iso6393": "bbx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Befang",
		"type": "living",
		"scope": "individual",
		"iso6393": "bby",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Babalia Creole Arabic",
		"type": "living",
		"scope": "individual",
		"iso6393": "bbz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Central Bai",
		"type": "living",
		"scope": "individual",
		"iso6393": "bca",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bainouk-Samik",
		"type": "living",
		"scope": "individual",
		"iso6393": "bcb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Balochi",
		"type": "living",
		"scope": "individual",
		"iso6393": "bcc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "North Babar",
		"type": "living",
		"scope": "individual",
		"iso6393": "bcd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bamenyam",
		"type": "living",
		"scope": "individual",
		"iso6393": "bce",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bamu",
		"type": "living",
		"scope": "individual",
		"iso6393": "bcf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baga Pokur",
		"type": "living",
		"scope": "individual",
		"iso6393": "bcg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bariai",
		"type": "living",
		"scope": "individual",
		"iso6393": "bch",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baoulé",
		"type": "living",
		"scope": "individual",
		"iso6393": "bci",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bardi",
		"type": "living",
		"scope": "individual",
		"iso6393": "bcj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bunaba",
		"type": "living",
		"scope": "individual",
		"iso6393": "bck",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Central Bikol",
		"type": "living",
		"scope": "individual",
		"iso6393": "bcl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bannoni",
		"type": "living",
		"scope": "individual",
		"iso6393": "bcm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bali (Nigeria)",
		"type": "living",
		"scope": "individual",
		"iso6393": "bcn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kaluli",
		"type": "living",
		"scope": "individual",
		"iso6393": "bco",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bali (Democratic Republic of Congo)",
		"type": "living",
		"scope": "individual",
		"iso6393": "bcp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bench",
		"type": "living",
		"scope": "individual",
		"iso6393": "bcq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Babine",
		"type": "living",
		"scope": "individual",
		"iso6393": "bcr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kohumono",
		"type": "living",
		"scope": "individual",
		"iso6393": "bcs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bendi",
		"type": "living",
		"scope": "individual",
		"iso6393": "bct",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Awad Bing",
		"type": "living",
		"scope": "individual",
		"iso6393": "bcu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shoo-Minda-Nye",
		"type": "living",
		"scope": "individual",
		"iso6393": "bcv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bana",
		"type": "living",
		"scope": "individual",
		"iso6393": "bcw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bacama",
		"type": "living",
		"scope": "individual",
		"iso6393": "bcy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bainouk-Gunyaamolo",
		"type": "living",
		"scope": "individual",
		"iso6393": "bcz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bayot",
		"type": "living",
		"scope": "individual",
		"iso6393": "bda",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Basap",
		"type": "living",
		"scope": "individual",
		"iso6393": "bdb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Emberá-Baudó",
		"type": "living",
		"scope": "individual",
		"iso6393": "bdc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bunama",
		"type": "living",
		"scope": "individual",
		"iso6393": "bdd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bade",
		"type": "living",
		"scope": "individual",
		"iso6393": "bde",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Biage",
		"type": "living",
		"scope": "individual",
		"iso6393": "bdf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bonggi",
		"type": "living",
		"scope": "individual",
		"iso6393": "bdg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baka (Sudan)",
		"type": "living",
		"scope": "individual",
		"iso6393": "bdh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Burun",
		"type": "living",
		"scope": "individual",
		"iso6393": "bdi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bai",
		"type": "living",
		"scope": "individual",
		"iso6393": "bdj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Budukh",
		"type": "living",
		"scope": "individual",
		"iso6393": "bdk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Indonesian Bajau",
		"type": "living",
		"scope": "individual",
		"iso6393": "bdl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Buduma",
		"type": "living",
		"scope": "individual",
		"iso6393": "bdm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baldemu",
		"type": "living",
		"scope": "individual",
		"iso6393": "bdn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Morom",
		"type": "living",
		"scope": "individual",
		"iso6393": "bdo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bende",
		"type": "living",
		"scope": "individual",
		"iso6393": "bdp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bahnar",
		"type": "living",
		"scope": "individual",
		"iso6393": "bdq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "West Coast Bajau",
		"type": "living",
		"scope": "individual",
		"iso6393": "bdr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Burunge",
		"type": "living",
		"scope": "individual",
		"iso6393": "bds",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bokoto",
		"type": "living",
		"scope": "individual",
		"iso6393": "bdt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Oroko",
		"type": "living",
		"scope": "individual",
		"iso6393": "bdu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bodo Parja",
		"type": "living",
		"scope": "individual",
		"iso6393": "bdv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baham",
		"type": "living",
		"scope": "individual",
		"iso6393": "bdw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Budong-Budong",
		"type": "living",
		"scope": "individual",
		"iso6393": "bdx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bandjalang",
		"type": "living",
		"scope": "individual",
		"iso6393": "bdy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Badeshi",
		"type": "living",
		"scope": "individual",
		"iso6393": "bdz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Beaver",
		"type": "living",
		"scope": "individual",
		"iso6393": "bea",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bebele",
		"type": "living",
		"scope": "individual",
		"iso6393": "beb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Iceve-Maci",
		"type": "living",
		"scope": "individual",
		"iso6393": "bec",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bedoanas",
		"type": "living",
		"scope": "individual",
		"iso6393": "bed",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Byangsi",
		"type": "living",
		"scope": "individual",
		"iso6393": "bee",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Benabena",
		"type": "living",
		"scope": "individual",
		"iso6393": "bef",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Belait",
		"type": "living",
		"scope": "individual",
		"iso6393": "beg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Biali",
		"type": "living",
		"scope": "individual",
		"iso6393": "beh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bekati'",
		"type": "living",
		"scope": "individual",
		"iso6393": "bei",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Beja",
		"type": "living",
		"scope": "individual",
		"iso6393": "bej",
		"iso6392B": "bej",
		"iso6392T": "bej",
		"iso6391": null
	},
	{
		"name": "Bebeli",
		"type": "living",
		"scope": "individual",
		"iso6393": "bek",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Belarusian",
		"type": "living",
		"scope": "individual",
		"iso6393": "bel",
		"iso6392B": "bel",
		"iso6392T": "bel",
		"iso6391": "be"
	},
	{
		"name": "Bemba (Zambia)",
		"type": "living",
		"scope": "individual",
		"iso6393": "bem",
		"iso6392B": "bem",
		"iso6392T": "bem",
		"iso6391": null
	},
	{
		"name": "Bengali",
		"type": "living",
		"scope": "individual",
		"iso6393": "ben",
		"iso6392B": "ben",
		"iso6392T": "ben",
		"iso6391": "bn"
	},
	{
		"name": "Beami",
		"type": "living",
		"scope": "individual",
		"iso6393": "beo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Besoa",
		"type": "living",
		"scope": "individual",
		"iso6393": "bep",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Beembe",
		"type": "living",
		"scope": "individual",
		"iso6393": "beq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Besme",
		"type": "living",
		"scope": "individual",
		"iso6393": "bes",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Guiberoua Béte",
		"type": "living",
		"scope": "individual",
		"iso6393": "bet",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Blagar",
		"type": "living",
		"scope": "individual",
		"iso6393": "beu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Daloa Bété",
		"type": "living",
		"scope": "individual",
		"iso6393": "bev",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Betawi",
		"type": "living",
		"scope": "individual",
		"iso6393": "bew",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jur Modo",
		"type": "living",
		"scope": "individual",
		"iso6393": "bex",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Beli (Papua New Guinea)",
		"type": "living",
		"scope": "individual",
		"iso6393": "bey",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bena (Tanzania)",
		"type": "living",
		"scope": "individual",
		"iso6393": "bez",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bari",
		"type": "living",
		"scope": "individual",
		"iso6393": "bfa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pauri Bareli",
		"type": "living",
		"scope": "individual",
		"iso6393": "bfb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Panyi Bai",
		"type": "living",
		"scope": "individual",
		"iso6393": "bfc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bafut",
		"type": "living",
		"scope": "individual",
		"iso6393": "bfd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Betaf",
		"type": "living",
		"scope": "individual",
		"iso6393": "bfe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bofi",
		"type": "living",
		"scope": "individual",
		"iso6393": "bff",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Busang Kayan",
		"type": "living",
		"scope": "individual",
		"iso6393": "bfg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Blafe",
		"type": "living",
		"scope": "individual",
		"iso6393": "bfh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "British Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "bfi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bafanji",
		"type": "living",
		"scope": "individual",
		"iso6393": "bfj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ban Khor Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "bfk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Banda-Ndélé",
		"type": "living",
		"scope": "individual",
		"iso6393": "bfl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mmen",
		"type": "living",
		"scope": "individual",
		"iso6393": "bfm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bunak",
		"type": "living",
		"scope": "individual",
		"iso6393": "bfn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Malba Birifor",
		"type": "living",
		"scope": "individual",
		"iso6393": "bfo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Beba",
		"type": "living",
		"scope": "individual",
		"iso6393": "bfp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Badaga",
		"type": "living",
		"scope": "individual",
		"iso6393": "bfq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bazigar",
		"type": "living",
		"scope": "individual",
		"iso6393": "bfr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Bai",
		"type": "living",
		"scope": "individual",
		"iso6393": "bfs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Balti",
		"type": "living",
		"scope": "individual",
		"iso6393": "bft",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gahri",
		"type": "living",
		"scope": "individual",
		"iso6393": "bfu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bondo",
		"type": "living",
		"scope": "individual",
		"iso6393": "bfw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bantayanon",
		"type": "living",
		"scope": "individual",
		"iso6393": "bfx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bagheli",
		"type": "living",
		"scope": "individual",
		"iso6393": "bfy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mahasu Pahari",
		"type": "living",
		"scope": "individual",
		"iso6393": "bfz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gwamhi-Wuri",
		"type": "living",
		"scope": "individual",
		"iso6393": "bga",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bobongko",
		"type": "living",
		"scope": "individual",
		"iso6393": "bgb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Haryanvi",
		"type": "living",
		"scope": "individual",
		"iso6393": "bgc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rathwi Bareli",
		"type": "living",
		"scope": "individual",
		"iso6393": "bgd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bauria",
		"type": "living",
		"scope": "individual",
		"iso6393": "bge",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bangandu",
		"type": "living",
		"scope": "individual",
		"iso6393": "bgf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bugun",
		"type": "living",
		"scope": "individual",
		"iso6393": "bgg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Giangan",
		"type": "living",
		"scope": "individual",
		"iso6393": "bgi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bangolan",
		"type": "living",
		"scope": "individual",
		"iso6393": "bgj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bit",
		"type": "living",
		"scope": "individual",
		"iso6393": "bgk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bo (Laos)",
		"type": "living",
		"scope": "individual",
		"iso6393": "bgl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Balochi",
		"type": "living",
		"scope": "individual",
		"iso6393": "bgn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baga Koga",
		"type": "living",
		"scope": "individual",
		"iso6393": "bgo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Balochi",
		"type": "living",
		"scope": "individual",
		"iso6393": "bgp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bagri",
		"type": "living",
		"scope": "individual",
		"iso6393": "bgq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bawm Chin",
		"type": "living",
		"scope": "individual",
		"iso6393": "bgr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tagabawa",
		"type": "living",
		"scope": "individual",
		"iso6393": "bgs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bughotu",
		"type": "living",
		"scope": "individual",
		"iso6393": "bgt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mbongno",
		"type": "living",
		"scope": "individual",
		"iso6393": "bgu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Warkay-Bipim",
		"type": "living",
		"scope": "individual",
		"iso6393": "bgv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bhatri",
		"type": "living",
		"scope": "individual",
		"iso6393": "bgw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Balkan Gagauz Turkish",
		"type": "living",
		"scope": "individual",
		"iso6393": "bgx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Benggoi",
		"type": "living",
		"scope": "individual",
		"iso6393": "bgy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Banggai",
		"type": "living",
		"scope": "individual",
		"iso6393": "bgz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bharia",
		"type": "living",
		"scope": "individual",
		"iso6393": "bha",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bhili",
		"type": "living",
		"scope": "individual",
		"iso6393": "bhb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Biga",
		"type": "living",
		"scope": "individual",
		"iso6393": "bhc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bhadrawahi",
		"type": "living",
		"scope": "individual",
		"iso6393": "bhd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bhaya",
		"type": "living",
		"scope": "individual",
		"iso6393": "bhe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Odiai",
		"type": "living",
		"scope": "individual",
		"iso6393": "bhf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Binandere",
		"type": "living",
		"scope": "individual",
		"iso6393": "bhg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bukharic",
		"type": "living",
		"scope": "individual",
		"iso6393": "bhh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bhilali",
		"type": "living",
		"scope": "individual",
		"iso6393": "bhi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bahing",
		"type": "living",
		"scope": "individual",
		"iso6393": "bhj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bimin",
		"type": "living",
		"scope": "individual",
		"iso6393": "bhl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bathari",
		"type": "living",
		"scope": "individual",
		"iso6393": "bhm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bohtan Neo-Aramaic",
		"type": "living",
		"scope": "individual",
		"iso6393": "bhn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bhojpuri",
		"type": "living",
		"scope": "individual",
		"iso6393": "bho",
		"iso6392B": "bho",
		"iso6392T": "bho",
		"iso6391": null
	},
	{
		"name": "Bima",
		"type": "living",
		"scope": "individual",
		"iso6393": "bhp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tukang Besi South",
		"type": "living",
		"scope": "individual",
		"iso6393": "bhq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bara Malagasy",
		"type": "living",
		"scope": "individual",
		"iso6393": "bhr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Buwal",
		"type": "living",
		"scope": "individual",
		"iso6393": "bhs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bhattiyali",
		"type": "living",
		"scope": "individual",
		"iso6393": "bht",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bhunjia",
		"type": "living",
		"scope": "individual",
		"iso6393": "bhu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bahau",
		"type": "living",
		"scope": "individual",
		"iso6393": "bhv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Biak",
		"type": "living",
		"scope": "individual",
		"iso6393": "bhw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bhalay",
		"type": "living",
		"scope": "individual",
		"iso6393": "bhx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bhele",
		"type": "living",
		"scope": "individual",
		"iso6393": "bhy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bada (Indonesia)",
		"type": "living",
		"scope": "individual",
		"iso6393": "bhz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Badimaya",
		"type": "living",
		"scope": "individual",
		"iso6393": "bia",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bissa",
		"type": "living",
		"scope": "individual",
		"iso6393": "bib",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bikaru",
		"type": "living",
		"scope": "individual",
		"iso6393": "bic",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bidiyo",
		"type": "living",
		"scope": "individual",
		"iso6393": "bid",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bepour",
		"type": "living",
		"scope": "individual",
		"iso6393": "bie",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Biafada",
		"type": "living",
		"scope": "individual",
		"iso6393": "bif",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Biangai",
		"type": "living",
		"scope": "individual",
		"iso6393": "big",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Vaghat-Ya-Bijim-Legeri",
		"type": "living",
		"scope": "individual",
		"iso6393": "bij",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bikol",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "bik",
		"iso6392B": "bik",
		"iso6392T": "bik",
		"iso6391": null
	},
	{
		"name": "Bile",
		"type": "living",
		"scope": "individual",
		"iso6393": "bil",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bimoba",
		"type": "living",
		"scope": "individual",
		"iso6393": "bim",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bini",
		"type": "living",
		"scope": "individual",
		"iso6393": "bin",
		"iso6392B": "bin",
		"iso6392T": "bin",
		"iso6391": null
	},
	{
		"name": "Nai",
		"type": "living",
		"scope": "individual",
		"iso6393": "bio",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bila",
		"type": "living",
		"scope": "individual",
		"iso6393": "bip",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bipi",
		"type": "living",
		"scope": "individual",
		"iso6393": "biq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bisorio",
		"type": "living",
		"scope": "individual",
		"iso6393": "bir",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bislama",
		"type": "living",
		"scope": "individual",
		"iso6393": "bis",
		"iso6392B": "bis",
		"iso6392T": "bis",
		"iso6391": "bi"
	},
	{
		"name": "Berinomo",
		"type": "living",
		"scope": "individual",
		"iso6393": "bit",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Biete",
		"type": "living",
		"scope": "individual",
		"iso6393": "biu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Birifor",
		"type": "living",
		"scope": "individual",
		"iso6393": "biv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kol (Cameroon)",
		"type": "living",
		"scope": "individual",
		"iso6393": "biw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bijori",
		"type": "living",
		"scope": "individual",
		"iso6393": "bix",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Birhor",
		"type": "living",
		"scope": "individual",
		"iso6393": "biy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baloi",
		"type": "living",
		"scope": "individual",
		"iso6393": "biz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Budza",
		"type": "living",
		"scope": "individual",
		"iso6393": "bja",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Banggarla",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "bjb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bariji",
		"type": "living",
		"scope": "individual",
		"iso6393": "bjc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Biao-Jiao Mien",
		"type": "living",
		"scope": "individual",
		"iso6393": "bje",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Barzani Jewish Neo-Aramaic",
		"type": "living",
		"scope": "individual",
		"iso6393": "bjf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bidyogo",
		"type": "living",
		"scope": "individual",
		"iso6393": "bjg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bahinemo",
		"type": "living",
		"scope": "individual",
		"iso6393": "bjh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Burji",
		"type": "living",
		"scope": "individual",
		"iso6393": "bji",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kanauji",
		"type": "living",
		"scope": "individual",
		"iso6393": "bjj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Barok",
		"type": "living",
		"scope": "individual",
		"iso6393": "bjk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bulu (Papua New Guinea)",
		"type": "living",
		"scope": "individual",
		"iso6393": "bjl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bajelani",
		"type": "living",
		"scope": "individual",
		"iso6393": "bjm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Banjar",
		"type": "living",
		"scope": "individual",
		"iso6393": "bjn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mid-Southern Banda",
		"type": "living",
		"scope": "individual",
		"iso6393": "bjo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Fanamaket",
		"type": "living",
		"scope": "individual",
		"iso6393": "bjp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Binumarien",
		"type": "living",
		"scope": "individual",
		"iso6393": "bjr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bajan",
		"type": "living",
		"scope": "individual",
		"iso6393": "bjs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Balanta-Ganja",
		"type": "living",
		"scope": "individual",
		"iso6393": "bjt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Busuu",
		"type": "living",
		"scope": "individual",
		"iso6393": "bju",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bedjond",
		"type": "living",
		"scope": "individual",
		"iso6393": "bjv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bakwé",
		"type": "living",
		"scope": "individual",
		"iso6393": "bjw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Banao Itneg",
		"type": "living",
		"scope": "individual",
		"iso6393": "bjx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bayali",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "bjy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baruga",
		"type": "living",
		"scope": "individual",
		"iso6393": "bjz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kyak",
		"type": "living",
		"scope": "individual",
		"iso6393": "bka",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baka (Cameroon)",
		"type": "living",
		"scope": "individual",
		"iso6393": "bkc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Binukid",
		"type": "living",
		"scope": "individual",
		"iso6393": "bkd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Beeke",
		"type": "living",
		"scope": "individual",
		"iso6393": "bkf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Buraka",
		"type": "living",
		"scope": "individual",
		"iso6393": "bkg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bakoko",
		"type": "living",
		"scope": "individual",
		"iso6393": "bkh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baki",
		"type": "living",
		"scope": "individual",
		"iso6393": "bki",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pande",
		"type": "living",
		"scope": "individual",
		"iso6393": "bkj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Brokskat",
		"type": "living",
		"scope": "individual",
		"iso6393": "bkk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Berik",
		"type": "living",
		"scope": "individual",
		"iso6393": "bkl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kom (Cameroon)",
		"type": "living",
		"scope": "individual",
		"iso6393": "bkm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bukitan",
		"type": "living",
		"scope": "individual",
		"iso6393": "bkn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kwa'",
		"type": "living",
		"scope": "individual",
		"iso6393": "bko",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Boko (Democratic Republic of Congo)",
		"type": "living",
		"scope": "individual",
		"iso6393": "bkp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bakairí",
		"type": "living",
		"scope": "individual",
		"iso6393": "bkq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bakumpai",
		"type": "living",
		"scope": "individual",
		"iso6393": "bkr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Sorsoganon",
		"type": "living",
		"scope": "individual",
		"iso6393": "bks",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Boloki",
		"type": "living",
		"scope": "individual",
		"iso6393": "bkt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Buhid",
		"type": "living",
		"scope": "individual",
		"iso6393": "bku",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bekwarra",
		"type": "living",
		"scope": "individual",
		"iso6393": "bkv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bekwel",
		"type": "living",
		"scope": "individual",
		"iso6393": "bkw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baikeno",
		"type": "living",
		"scope": "individual",
		"iso6393": "bkx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bokyi",
		"type": "living",
		"scope": "individual",
		"iso6393": "bky",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bungku",
		"type": "living",
		"scope": "individual",
		"iso6393": "bkz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Siksika",
		"type": "living",
		"scope": "individual",
		"iso6393": "bla",
		"iso6392B": "bla",
		"iso6392T": "bla",
		"iso6391": null
	},
	{
		"name": "Bilua",
		"type": "living",
		"scope": "individual",
		"iso6393": "blb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bella Coola",
		"type": "living",
		"scope": "individual",
		"iso6393": "blc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bolango",
		"type": "living",
		"scope": "individual",
		"iso6393": "bld",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Balanta-Kentohe",
		"type": "living",
		"scope": "individual",
		"iso6393": "ble",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Buol",
		"type": "living",
		"scope": "individual",
		"iso6393": "blf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Balau",
		"type": "living",
		"scope": "individual",
		"iso6393": "blg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kuwaa",
		"type": "living",
		"scope": "individual",
		"iso6393": "blh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bolia",
		"type": "living",
		"scope": "individual",
		"iso6393": "bli",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bolongan",
		"type": "living",
		"scope": "individual",
		"iso6393": "blj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pa'o Karen",
		"type": "living",
		"scope": "individual",
		"iso6393": "blk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Biloxi",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "bll",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Beli (Sudan)",
		"type": "living",
		"scope": "individual",
		"iso6393": "blm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Catanduanes Bikol",
		"type": "living",
		"scope": "individual",
		"iso6393": "bln",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Anii",
		"type": "living",
		"scope": "individual",
		"iso6393": "blo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Blablanga",
		"type": "living",
		"scope": "individual",
		"iso6393": "blp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baluan-Pam",
		"type": "living",
		"scope": "individual",
		"iso6393": "blq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Blang",
		"type": "living",
		"scope": "individual",
		"iso6393": "blr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Balaesang",
		"type": "living",
		"scope": "individual",
		"iso6393": "bls",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tai Dam",
		"type": "living",
		"scope": "individual",
		"iso6393": "blt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bolo",
		"type": "living",
		"scope": "individual",
		"iso6393": "blv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Balangao",
		"type": "living",
		"scope": "individual",
		"iso6393": "blw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mag-Indi Ayta",
		"type": "living",
		"scope": "individual",
		"iso6393": "blx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Notre",
		"type": "living",
		"scope": "individual",
		"iso6393": "bly",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Balantak",
		"type": "living",
		"scope": "individual",
		"iso6393": "blz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lame",
		"type": "living",
		"scope": "individual",
		"iso6393": "bma",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bembe",
		"type": "living",
		"scope": "individual",
		"iso6393": "bmb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Biem",
		"type": "living",
		"scope": "individual",
		"iso6393": "bmc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baga Manduri",
		"type": "living",
		"scope": "individual",
		"iso6393": "bmd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Limassa",
		"type": "living",
		"scope": "individual",
		"iso6393": "bme",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bom",
		"type": "living",
		"scope": "individual",
		"iso6393": "bmf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bamwe",
		"type": "living",
		"scope": "individual",
		"iso6393": "bmg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kein",
		"type": "living",
		"scope": "individual",
		"iso6393": "bmh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bagirmi",
		"type": "living",
		"scope": "individual",
		"iso6393": "bmi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bote-Majhi",
		"type": "living",
		"scope": "individual",
		"iso6393": "bmj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ghayavi",
		"type": "living",
		"scope": "individual",
		"iso6393": "bmk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bomboli",
		"type": "living",
		"scope": "individual",
		"iso6393": "bml",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Betsimisaraka Malagasy",
		"type": "living",
		"scope": "individual",
		"iso6393": "bmm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bina (Papua New Guinea)",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "bmn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bambalang",
		"type": "living",
		"scope": "individual",
		"iso6393": "bmo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bulgebi",
		"type": "living",
		"scope": "individual",
		"iso6393": "bmp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bomu",
		"type": "living",
		"scope": "individual",
		"iso6393": "bmq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Muinane",
		"type": "living",
		"scope": "individual",
		"iso6393": "bmr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bilma Kanuri",
		"type": "living",
		"scope": "individual",
		"iso6393": "bms",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Biao Mon",
		"type": "living",
		"scope": "individual",
		"iso6393": "bmt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Somba-Siawari",
		"type": "living",
		"scope": "individual",
		"iso6393": "bmu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bum",
		"type": "living",
		"scope": "individual",
		"iso6393": "bmv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bomwali",
		"type": "living",
		"scope": "individual",
		"iso6393": "bmw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baimak",
		"type": "living",
		"scope": "individual",
		"iso6393": "bmx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baramu",
		"type": "living",
		"scope": "individual",
		"iso6393": "bmz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bonerate",
		"type": "living",
		"scope": "individual",
		"iso6393": "bna",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bookan",
		"type": "living",
		"scope": "individual",
		"iso6393": "bnb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bontok",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "bnc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Banda (Indonesia)",
		"type": "living",
		"scope": "individual",
		"iso6393": "bnd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bintauna",
		"type": "living",
		"scope": "individual",
		"iso6393": "bne",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Masiwang",
		"type": "living",
		"scope": "individual",
		"iso6393": "bnf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Benga",
		"type": "living",
		"scope": "individual",
		"iso6393": "bng",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bangi",
		"type": "living",
		"scope": "individual",
		"iso6393": "bni",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Tawbuid",
		"type": "living",
		"scope": "individual",
		"iso6393": "bnj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bierebo",
		"type": "living",
		"scope": "individual",
		"iso6393": "bnk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Boon",
		"type": "living",
		"scope": "individual",
		"iso6393": "bnl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Batanga",
		"type": "living",
		"scope": "individual",
		"iso6393": "bnm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bunun",
		"type": "living",
		"scope": "individual",
		"iso6393": "bnn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bantoanon",
		"type": "living",
		"scope": "individual",
		"iso6393": "bno",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bola",
		"type": "living",
		"scope": "individual",
		"iso6393": "bnp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bantik",
		"type": "living",
		"scope": "individual",
		"iso6393": "bnq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Butmas-Tur",
		"type": "living",
		"scope": "individual",
		"iso6393": "bnr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bundeli",
		"type": "living",
		"scope": "individual",
		"iso6393": "bns",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bentong",
		"type": "living",
		"scope": "individual",
		"iso6393": "bnu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bonerif",
		"type": "living",
		"scope": "individual",
		"iso6393": "bnv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bisis",
		"type": "living",
		"scope": "individual",
		"iso6393": "bnw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bangubangu",
		"type": "living",
		"scope": "individual",
		"iso6393": "bnx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bintulu",
		"type": "living",
		"scope": "individual",
		"iso6393": "bny",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Beezen",
		"type": "living",
		"scope": "individual",
		"iso6393": "bnz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bora",
		"type": "living",
		"scope": "individual",
		"iso6393": "boa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aweer",
		"type": "living",
		"scope": "individual",
		"iso6393": "bob",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tibetan",
		"type": "living",
		"scope": "individual",
		"iso6393": "bod",
		"iso6392B": "tib",
		"iso6392T": "bod",
		"iso6391": "bo"
	},
	{
		"name": "Mundabli",
		"type": "living",
		"scope": "individual",
		"iso6393": "boe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bolon",
		"type": "living",
		"scope": "individual",
		"iso6393": "bof",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bamako Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "bog",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Boma",
		"type": "living",
		"scope": "individual",
		"iso6393": "boh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Barbareño",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "boi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Anjam",
		"type": "living",
		"scope": "individual",
		"iso6393": "boj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bonjo",
		"type": "living",
		"scope": "individual",
		"iso6393": "bok",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bole",
		"type": "living",
		"scope": "individual",
		"iso6393": "bol",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Berom",
		"type": "living",
		"scope": "individual",
		"iso6393": "bom",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bine",
		"type": "living",
		"scope": "individual",
		"iso6393": "bon",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tiemacèwè Bozo",
		"type": "living",
		"scope": "individual",
		"iso6393": "boo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bonkiman",
		"type": "living",
		"scope": "individual",
		"iso6393": "bop",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bogaya",
		"type": "living",
		"scope": "individual",
		"iso6393": "boq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Borôro",
		"type": "living",
		"scope": "individual",
		"iso6393": "bor",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bosnian",
		"type": "living",
		"scope": "individual",
		"iso6393": "bos",
		"iso6392B": "bos",
		"iso6392T": "bos",
		"iso6391": "bs"
	},
	{
		"name": "Bongo",
		"type": "living",
		"scope": "individual",
		"iso6393": "bot",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bondei",
		"type": "living",
		"scope": "individual",
		"iso6393": "bou",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tuwuli",
		"type": "living",
		"scope": "individual",
		"iso6393": "bov",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rema",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "bow",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Buamu",
		"type": "living",
		"scope": "individual",
		"iso6393": "box",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bodo (Central African Republic)",
		"type": "living",
		"scope": "individual",
		"iso6393": "boy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tiéyaxo Bozo",
		"type": "living",
		"scope": "individual",
		"iso6393": "boz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Daakaka",
		"type": "living",
		"scope": "individual",
		"iso6393": "bpa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Barbacoas",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "bpb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Banda-Banda",
		"type": "living",
		"scope": "individual",
		"iso6393": "bpd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bonggo",
		"type": "living",
		"scope": "individual",
		"iso6393": "bpg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Botlikh",
		"type": "living",
		"scope": "individual",
		"iso6393": "bph",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bagupi",
		"type": "living",
		"scope": "individual",
		"iso6393": "bpi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Binji",
		"type": "living",
		"scope": "individual",
		"iso6393": "bpj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Orowe",
		"type": "living",
		"scope": "individual",
		"iso6393": "bpk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Broome Pearling Lugger Pidgin",
		"type": "living",
		"scope": "individual",
		"iso6393": "bpl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Biyom",
		"type": "living",
		"scope": "individual",
		"iso6393": "bpm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dzao Min",
		"type": "living",
		"scope": "individual",
		"iso6393": "bpn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Anasi",
		"type": "living",
		"scope": "individual",
		"iso6393": "bpo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kaure",
		"type": "living",
		"scope": "individual",
		"iso6393": "bpp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Banda Malay",
		"type": "living",
		"scope": "individual",
		"iso6393": "bpq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koronadal Blaan",
		"type": "living",
		"scope": "individual",
		"iso6393": "bpr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sarangani Blaan",
		"type": "living",
		"scope": "individual",
		"iso6393": "bps",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Barrow Point",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "bpt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bongu",
		"type": "living",
		"scope": "individual",
		"iso6393": "bpu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bian Marind",
		"type": "living",
		"scope": "individual",
		"iso6393": "bpv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bo (Papua New Guinea)",
		"type": "living",
		"scope": "individual",
		"iso6393": "bpw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Palya Bareli",
		"type": "living",
		"scope": "individual",
		"iso6393": "bpx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bishnupriya",
		"type": "living",
		"scope": "individual",
		"iso6393": "bpy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bilba",
		"type": "living",
		"scope": "individual",
		"iso6393": "bpz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tchumbuli",
		"type": "living",
		"scope": "individual",
		"iso6393": "bqa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bagusa",
		"type": "living",
		"scope": "individual",
		"iso6393": "bqb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Boko (Benin)",
		"type": "living",
		"scope": "individual",
		"iso6393": "bqc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bung",
		"type": "living",
		"scope": "individual",
		"iso6393": "bqd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baga Kaloum",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "bqf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bago-Kusuntu",
		"type": "living",
		"scope": "individual",
		"iso6393": "bqg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baima",
		"type": "living",
		"scope": "individual",
		"iso6393": "bqh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bakhtiari",
		"type": "living",
		"scope": "individual",
		"iso6393": "bqi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bandial",
		"type": "living",
		"scope": "individual",
		"iso6393": "bqj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Banda-Mbrès",
		"type": "living",
		"scope": "individual",
		"iso6393": "bqk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bilakura",
		"type": "living",
		"scope": "individual",
		"iso6393": "bql",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wumboko",
		"type": "living",
		"scope": "individual",
		"iso6393": "bqm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bulgarian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "bqn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Balo",
		"type": "living",
		"scope": "individual",
		"iso6393": "bqo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Busa",
		"type": "living",
		"scope": "individual",
		"iso6393": "bqp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Biritai",
		"type": "living",
		"scope": "individual",
		"iso6393": "bqq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Burusu",
		"type": "living",
		"scope": "individual",
		"iso6393": "bqr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bosngun",
		"type": "living",
		"scope": "individual",
		"iso6393": "bqs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bamukumbit",
		"type": "living",
		"scope": "individual",
		"iso6393": "bqt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Boguru",
		"type": "living",
		"scope": "individual",
		"iso6393": "bqu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koro Wachi",
		"type": "living",
		"scope": "individual",
		"iso6393": "bqv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Buru (Nigeria)",
		"type": "living",
		"scope": "individual",
		"iso6393": "bqw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baangi",
		"type": "living",
		"scope": "individual",
		"iso6393": "bqx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bengkala Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "bqy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bakaka",
		"type": "living",
		"scope": "individual",
		"iso6393": "bqz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Braj",
		"type": "living",
		"scope": "individual",
		"iso6393": "bra",
		"iso6392B": "bra",
		"iso6392T": "bra",
		"iso6391": null
	},
	{
		"name": "Lave",
		"type": "living",
		"scope": "individual",
		"iso6393": "brb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Berbice Creole Dutch",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "brc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baraamu",
		"type": "living",
		"scope": "individual",
		"iso6393": "brd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Breton",
		"type": "living",
		"scope": "individual",
		"iso6393": "bre",
		"iso6392B": "bre",
		"iso6392T": "bre",
		"iso6391": "br"
	},
	{
		"name": "Bera",
		"type": "living",
		"scope": "individual",
		"iso6393": "brf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baure",
		"type": "living",
		"scope": "individual",
		"iso6393": "brg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Brahui",
		"type": "living",
		"scope": "individual",
		"iso6393": "brh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mokpwe",
		"type": "living",
		"scope": "individual",
		"iso6393": "bri",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bieria",
		"type": "living",
		"scope": "individual",
		"iso6393": "brj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Birked",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "brk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Birwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "brl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Barambu",
		"type": "living",
		"scope": "individual",
		"iso6393": "brm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Boruca",
		"type": "living",
		"scope": "individual",
		"iso6393": "brn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Brokkat",
		"type": "living",
		"scope": "individual",
		"iso6393": "bro",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Barapasi",
		"type": "living",
		"scope": "individual",
		"iso6393": "brp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Breri",
		"type": "living",
		"scope": "individual",
		"iso6393": "brq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Birao",
		"type": "living",
		"scope": "individual",
		"iso6393": "brr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baras",
		"type": "living",
		"scope": "individual",
		"iso6393": "brs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bitare",
		"type": "living",
		"scope": "individual",
		"iso6393": "brt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Bru",
		"type": "living",
		"scope": "individual",
		"iso6393": "bru",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Bru",
		"type": "living",
		"scope": "individual",
		"iso6393": "brv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bellari",
		"type": "living",
		"scope": "individual",
		"iso6393": "brw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bodo (India)",
		"type": "living",
		"scope": "individual",
		"iso6393": "brx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Burui",
		"type": "living",
		"scope": "individual",
		"iso6393": "bry",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bilbil",
		"type": "living",
		"scope": "individual",
		"iso6393": "brz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Abinomn",
		"type": "living",
		"scope": "individual",
		"iso6393": "bsa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Brunei Bisaya",
		"type": "living",
		"scope": "individual",
		"iso6393": "bsb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bassari",
		"type": "living",
		"scope": "individual",
		"iso6393": "bsc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wushi",
		"type": "living",
		"scope": "individual",
		"iso6393": "bse",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bauchi",
		"type": "living",
		"scope": "individual",
		"iso6393": "bsf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bashkardi",
		"type": "living",
		"scope": "individual",
		"iso6393": "bsg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kati",
		"type": "living",
		"scope": "individual",
		"iso6393": "bsh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bassossi",
		"type": "living",
		"scope": "individual",
		"iso6393": "bsi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bangwinji",
		"type": "living",
		"scope": "individual",
		"iso6393": "bsj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Burushaski",
		"type": "living",
		"scope": "individual",
		"iso6393": "bsk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Basa-Gumna",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "bsl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Busami",
		"type": "living",
		"scope": "individual",
		"iso6393": "bsm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Barasana-Eduria",
		"type": "living",
		"scope": "individual",
		"iso6393": "bsn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Buso",
		"type": "living",
		"scope": "individual",
		"iso6393": "bso",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baga Sitemu",
		"type": "living",
		"scope": "individual",
		"iso6393": "bsp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bassa",
		"type": "living",
		"scope": "individual",
		"iso6393": "bsq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bassa-Kontagora",
		"type": "living",
		"scope": "individual",
		"iso6393": "bsr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Akoose",
		"type": "living",
		"scope": "individual",
		"iso6393": "bss",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Basketo",
		"type": "living",
		"scope": "individual",
		"iso6393": "bst",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bahonsuai",
		"type": "living",
		"scope": "individual",
		"iso6393": "bsu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baga Sobané",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "bsv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baiso",
		"type": "living",
		"scope": "individual",
		"iso6393": "bsw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yangkam",
		"type": "living",
		"scope": "individual",
		"iso6393": "bsx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sabah Bisaya",
		"type": "living",
		"scope": "individual",
		"iso6393": "bsy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bata",
		"type": "living",
		"scope": "individual",
		"iso6393": "bta",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bati (Cameroon)",
		"type": "living",
		"scope": "individual",
		"iso6393": "btc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Batak Dairi",
		"type": "living",
		"scope": "individual",
		"iso6393": "btd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gamo-Ningi",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "bte",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Birgit",
		"type": "living",
		"scope": "individual",
		"iso6393": "btf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gagnoa Bété",
		"type": "living",
		"scope": "individual",
		"iso6393": "btg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Biatah Bidayuh",
		"type": "living",
		"scope": "individual",
		"iso6393": "bth",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Burate",
		"type": "living",
		"scope": "individual",
		"iso6393": "bti",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bacanese Malay",
		"type": "living",
		"scope": "individual",
		"iso6393": "btj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Batak Mandailing",
		"type": "living",
		"scope": "individual",
		"iso6393": "btm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ratagnon",
		"type": "living",
		"scope": "individual",
		"iso6393": "btn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rinconada Bikol",
		"type": "living",
		"scope": "individual",
		"iso6393": "bto",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Budibud",
		"type": "living",
		"scope": "individual",
		"iso6393": "btp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Batek",
		"type": "living",
		"scope": "individual",
		"iso6393": "btq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baetora",
		"type": "living",
		"scope": "individual",
		"iso6393": "btr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Batak Simalungun",
		"type": "living",
		"scope": "individual",
		"iso6393": "bts",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bete-Bendi",
		"type": "living",
		"scope": "individual",
		"iso6393": "btt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Batu",
		"type": "living",
		"scope": "individual",
		"iso6393": "btu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bateri",
		"type": "living",
		"scope": "individual",
		"iso6393": "btv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Butuanon",
		"type": "living",
		"scope": "individual",
		"iso6393": "btw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Batak Karo",
		"type": "living",
		"scope": "individual",
		"iso6393": "btx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bobot",
		"type": "living",
		"scope": "individual",
		"iso6393": "bty",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Batak Alas-Kluet",
		"type": "living",
		"scope": "individual",
		"iso6393": "btz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Buriat",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "bua",
		"iso6392B": "bua",
		"iso6392T": "bua",
		"iso6391": null
	},
	{
		"name": "Bua",
		"type": "living",
		"scope": "individual",
		"iso6393": "bub",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bushi",
		"type": "living",
		"scope": "individual",
		"iso6393": "buc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ntcham",
		"type": "living",
		"scope": "individual",
		"iso6393": "bud",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Beothuk",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "bue",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bushoong",
		"type": "living",
		"scope": "individual",
		"iso6393": "buf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Buginese",
		"type": "living",
		"scope": "individual",
		"iso6393": "bug",
		"iso6392B": "bug",
		"iso6392T": "bug",
		"iso6391": null
	},
	{
		"name": "Younuo Bunu",
		"type": "living",
		"scope": "individual",
		"iso6393": "buh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bongili",
		"type": "living",
		"scope": "individual",
		"iso6393": "bui",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Basa-Gurmana",
		"type": "living",
		"scope": "individual",
		"iso6393": "buj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bugawac",
		"type": "living",
		"scope": "individual",
		"iso6393": "buk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bulgarian",
		"type": "living",
		"scope": "individual",
		"iso6393": "bul",
		"iso6392B": "bul",
		"iso6392T": "bul",
		"iso6391": "bg"
	},
	{
		"name": "Bulu (Cameroon)",
		"type": "living",
		"scope": "individual",
		"iso6393": "bum",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sherbro",
		"type": "living",
		"scope": "individual",
		"iso6393": "bun",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Terei",
		"type": "living",
		"scope": "individual",
		"iso6393": "buo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Busoa",
		"type": "living",
		"scope": "individual",
		"iso6393": "bup",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Brem",
		"type": "living",
		"scope": "individual",
		"iso6393": "buq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bokobaru",
		"type": "living",
		"scope": "individual",
		"iso6393": "bus",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bungain",
		"type": "living",
		"scope": "individual",
		"iso6393": "but",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Budu",
		"type": "living",
		"scope": "individual",
		"iso6393": "buu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bun",
		"type": "living",
		"scope": "individual",
		"iso6393": "buv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bubi",
		"type": "living",
		"scope": "individual",
		"iso6393": "buw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Boghom",
		"type": "living",
		"scope": "individual",
		"iso6393": "bux",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bullom So",
		"type": "living",
		"scope": "individual",
		"iso6393": "buy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bukwen",
		"type": "living",
		"scope": "individual",
		"iso6393": "buz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Barein",
		"type": "living",
		"scope": "individual",
		"iso6393": "bva",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bube",
		"type": "living",
		"scope": "individual",
		"iso6393": "bvb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baelelea",
		"type": "living",
		"scope": "individual",
		"iso6393": "bvc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baeggu",
		"type": "living",
		"scope": "individual",
		"iso6393": "bvd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Berau Malay",
		"type": "living",
		"scope": "individual",
		"iso6393": "bve",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Boor",
		"type": "living",
		"scope": "individual",
		"iso6393": "bvf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bonkeng",
		"type": "living",
		"scope": "individual",
		"iso6393": "bvg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bure",
		"type": "living",
		"scope": "individual",
		"iso6393": "bvh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Belanda Viri",
		"type": "living",
		"scope": "individual",
		"iso6393": "bvi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baan",
		"type": "living",
		"scope": "individual",
		"iso6393": "bvj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bukat",
		"type": "living",
		"scope": "individual",
		"iso6393": "bvk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bolivian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "bvl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bamunka",
		"type": "living",
		"scope": "individual",
		"iso6393": "bvm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Buna",
		"type": "living",
		"scope": "individual",
		"iso6393": "bvn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bolgo",
		"type": "living",
		"scope": "individual",
		"iso6393": "bvo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bumang",
		"type": "living",
		"scope": "individual",
		"iso6393": "bvp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Birri",
		"type": "living",
		"scope": "individual",
		"iso6393": "bvq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Burarra",
		"type": "living",
		"scope": "individual",
		"iso6393": "bvr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bati (Indonesia)",
		"type": "living",
		"scope": "individual",
		"iso6393": "bvt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bukit Malay",
		"type": "living",
		"scope": "individual",
		"iso6393": "bvu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baniva",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "bvv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Boga",
		"type": "living",
		"scope": "individual",
		"iso6393": "bvw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dibole",
		"type": "living",
		"scope": "individual",
		"iso6393": "bvx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baybayanon",
		"type": "living",
		"scope": "individual",
		"iso6393": "bvy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bauzi",
		"type": "living",
		"scope": "individual",
		"iso6393": "bvz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bwatoo",
		"type": "living",
		"scope": "individual",
		"iso6393": "bwa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Namosi-Naitasiri-Serua",
		"type": "living",
		"scope": "individual",
		"iso6393": "bwb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bwile",
		"type": "living",
		"scope": "individual",
		"iso6393": "bwc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bwaidoka",
		"type": "living",
		"scope": "individual",
		"iso6393": "bwd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bwe Karen",
		"type": "living",
		"scope": "individual",
		"iso6393": "bwe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Boselewa",
		"type": "living",
		"scope": "individual",
		"iso6393": "bwf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Barwe",
		"type": "living",
		"scope": "individual",
		"iso6393": "bwg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bishuo",
		"type": "living",
		"scope": "individual",
		"iso6393": "bwh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baniwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "bwi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Láá Láá Bwamu",
		"type": "living",
		"scope": "individual",
		"iso6393": "bwj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bauwaki",
		"type": "living",
		"scope": "individual",
		"iso6393": "bwk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bwela",
		"type": "living",
		"scope": "individual",
		"iso6393": "bwl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Biwat",
		"type": "living",
		"scope": "individual",
		"iso6393": "bwm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wunai Bunu",
		"type": "living",
		"scope": "individual",
		"iso6393": "bwn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Boro (Ethiopia)",
		"type": "living",
		"scope": "individual",
		"iso6393": "bwo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mandobo Bawah",
		"type": "living",
		"scope": "individual",
		"iso6393": "bwp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Bobo Madaré",
		"type": "living",
		"scope": "individual",
		"iso6393": "bwq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bura-Pabir",
		"type": "living",
		"scope": "individual",
		"iso6393": "bwr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bomboma",
		"type": "living",
		"scope": "individual",
		"iso6393": "bws",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bafaw-Balong",
		"type": "living",
		"scope": "individual",
		"iso6393": "bwt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Buli (Ghana)",
		"type": "living",
		"scope": "individual",
		"iso6393": "bwu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "bww",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bu-Nao Bunu",
		"type": "living",
		"scope": "individual",
		"iso6393": "bwx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cwi Bwamu",
		"type": "living",
		"scope": "individual",
		"iso6393": "bwy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bwisi",
		"type": "living",
		"scope": "individual",
		"iso6393": "bwz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tairaha",
		"type": "living",
		"scope": "individual",
		"iso6393": "bxa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Belanda Bor",
		"type": "living",
		"scope": "individual",
		"iso6393": "bxb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Molengue",
		"type": "living",
		"scope": "individual",
		"iso6393": "bxc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pela",
		"type": "living",
		"scope": "individual",
		"iso6393": "bxd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Birale",
		"type": "living",
		"scope": "individual",
		"iso6393": "bxe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bilur",
		"type": "living",
		"scope": "individual",
		"iso6393": "bxf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bangala",
		"type": "living",
		"scope": "individual",
		"iso6393": "bxg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Buhutu",
		"type": "living",
		"scope": "individual",
		"iso6393": "bxh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pirlatapa",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "bxi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bayungu",
		"type": "living",
		"scope": "individual",
		"iso6393": "bxj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bukusu",
		"type": "living",
		"scope": "individual",
		"iso6393": "bxk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jalkunan",
		"type": "living",
		"scope": "individual",
		"iso6393": "bxl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mongolia Buriat",
		"type": "living",
		"scope": "individual",
		"iso6393": "bxm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Burduna",
		"type": "living",
		"scope": "individual",
		"iso6393": "bxn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Barikanchi",
		"type": "living",
		"scope": "individual",
		"iso6393": "bxo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bebil",
		"type": "living",
		"scope": "individual",
		"iso6393": "bxp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Beele",
		"type": "living",
		"scope": "individual",
		"iso6393": "bxq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Russia Buriat",
		"type": "living",
		"scope": "individual",
		"iso6393": "bxr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Busam",
		"type": "living",
		"scope": "individual",
		"iso6393": "bxs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "China Buriat",
		"type": "living",
		"scope": "individual",
		"iso6393": "bxu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Berakou",
		"type": "living",
		"scope": "individual",
		"iso6393": "bxv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bankagooma",
		"type": "living",
		"scope": "individual",
		"iso6393": "bxw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Binahari",
		"type": "living",
		"scope": "individual",
		"iso6393": "bxz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Batak",
		"type": "living",
		"scope": "individual",
		"iso6393": "bya",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bikya",
		"type": "living",
		"scope": "individual",
		"iso6393": "byb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ubaghara",
		"type": "living",
		"scope": "individual",
		"iso6393": "byc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Benyadu'",
		"type": "living",
		"scope": "individual",
		"iso6393": "byd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pouye",
		"type": "living",
		"scope": "individual",
		"iso6393": "bye",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bete",
		"type": "living",
		"scope": "individual",
		"iso6393": "byf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baygo",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "byg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bhujel",
		"type": "living",
		"scope": "individual",
		"iso6393": "byh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Buyu",
		"type": "living",
		"scope": "individual",
		"iso6393": "byi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bina (Nigeria)",
		"type": "living",
		"scope": "individual",
		"iso6393": "byj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Biao",
		"type": "living",
		"scope": "individual",
		"iso6393": "byk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bayono",
		"type": "living",
		"scope": "individual",
		"iso6393": "byl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bidyara",
		"type": "living",
		"scope": "individual",
		"iso6393": "bym",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bilin",
		"type": "living",
		"scope": "individual",
		"iso6393": "byn",
		"iso6392B": "byn",
		"iso6392T": "byn",
		"iso6391": null
	},
	{
		"name": "Biyo",
		"type": "living",
		"scope": "individual",
		"iso6393": "byo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bumaji",
		"type": "living",
		"scope": "individual",
		"iso6393": "byp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Basay",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "byq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baruya",
		"type": "living",
		"scope": "individual",
		"iso6393": "byr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Burak",
		"type": "living",
		"scope": "individual",
		"iso6393": "bys",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Berti",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "byt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Medumba",
		"type": "living",
		"scope": "individual",
		"iso6393": "byv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Belhariya",
		"type": "living",
		"scope": "individual",
		"iso6393": "byw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Qaqet",
		"type": "living",
		"scope": "individual",
		"iso6393": "byx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Banaro",
		"type": "living",
		"scope": "individual",
		"iso6393": "byz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bandi",
		"type": "living",
		"scope": "individual",
		"iso6393": "bza",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Andio",
		"type": "living",
		"scope": "individual",
		"iso6393": "bzb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Betsimisaraka Malagasy",
		"type": "living",
		"scope": "individual",
		"iso6393": "bzc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bribri",
		"type": "living",
		"scope": "individual",
		"iso6393": "bzd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jenaama Bozo",
		"type": "living",
		"scope": "individual",
		"iso6393": "bze",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Boikin",
		"type": "living",
		"scope": "individual",
		"iso6393": "bzf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Babuza",
		"type": "living",
		"scope": "individual",
		"iso6393": "bzg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mapos Buang",
		"type": "living",
		"scope": "individual",
		"iso6393": "bzh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bisu",
		"type": "living",
		"scope": "individual",
		"iso6393": "bzi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Belize Kriol English",
		"type": "living",
		"scope": "individual",
		"iso6393": "bzj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nicaragua Creole English",
		"type": "living",
		"scope": "individual",
		"iso6393": "bzk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Boano (Sulawesi)",
		"type": "living",
		"scope": "individual",
		"iso6393": "bzl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bolondo",
		"type": "living",
		"scope": "individual",
		"iso6393": "bzm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Boano (Maluku)",
		"type": "living",
		"scope": "individual",
		"iso6393": "bzn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bozaba",
		"type": "living",
		"scope": "individual",
		"iso6393": "bzo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kemberano",
		"type": "living",
		"scope": "individual",
		"iso6393": "bzp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Buli (Indonesia)",
		"type": "living",
		"scope": "individual",
		"iso6393": "bzq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Biri",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "bzr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Brazilian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "bzs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Brithenig",
		"type": "constructed",
		"scope": "individual",
		"iso6393": "bzt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Burmeso",
		"type": "living",
		"scope": "individual",
		"iso6393": "bzu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Naami",
		"type": "living",
		"scope": "individual",
		"iso6393": "bzv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Basa (Nigeria)",
		"type": "living",
		"scope": "individual",
		"iso6393": "bzw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kɛlɛngaxo Bozo",
		"type": "living",
		"scope": "individual",
		"iso6393": "bzx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Obanliku",
		"type": "living",
		"scope": "individual",
		"iso6393": "bzy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Evant",
		"type": "living",
		"scope": "individual",
		"iso6393": "bzz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chortí",
		"type": "living",
		"scope": "individual",
		"iso6393": "caa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Garifuna",
		"type": "living",
		"scope": "individual",
		"iso6393": "cab",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chuj",
		"type": "living",
		"scope": "individual",
		"iso6393": "cac",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Caddo",
		"type": "living",
		"scope": "individual",
		"iso6393": "cad",
		"iso6392B": "cad",
		"iso6392T": "cad",
		"iso6391": null
	},
	{
		"name": "Lehar",
		"type": "living",
		"scope": "individual",
		"iso6393": "cae",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Carrier",
		"type": "living",
		"scope": "individual",
		"iso6393": "caf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nivaclé",
		"type": "living",
		"scope": "individual",
		"iso6393": "cag",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cahuarano",
		"type": "living",
		"scope": "individual",
		"iso6393": "cah",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chané",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "caj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kaqchikel",
		"type": "living",
		"scope": "individual",
		"iso6393": "cak",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Carolinian",
		"type": "living",
		"scope": "individual",
		"iso6393": "cal",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cemuhî",
		"type": "living",
		"scope": "individual",
		"iso6393": "cam",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chambri",
		"type": "living",
		"scope": "individual",
		"iso6393": "can",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chácobo",
		"type": "living",
		"scope": "individual",
		"iso6393": "cao",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chipaya",
		"type": "living",
		"scope": "individual",
		"iso6393": "cap",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Car Nicobarese",
		"type": "living",
		"scope": "individual",
		"iso6393": "caq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Galibi Carib",
		"type": "living",
		"scope": "individual",
		"iso6393": "car",
		"iso6392B": "car",
		"iso6392T": "car",
		"iso6391": null
	},
	{
		"name": "Tsimané",
		"type": "living",
		"scope": "individual",
		"iso6393": "cas",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Catalan",
		"type": "living",
		"scope": "individual",
		"iso6393": "cat",
		"iso6392B": "cat",
		"iso6392T": "cat",
		"iso6391": "ca"
	},
	{
		"name": "Cavineña",
		"type": "living",
		"scope": "individual",
		"iso6393": "cav",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Callawalla",
		"type": "living",
		"scope": "individual",
		"iso6393": "caw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chiquitano",
		"type": "living",
		"scope": "individual",
		"iso6393": "cax",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cayuga",
		"type": "living",
		"scope": "individual",
		"iso6393": "cay",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Canichana",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "caz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cabiyarí",
		"type": "living",
		"scope": "individual",
		"iso6393": "cbb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Carapana",
		"type": "living",
		"scope": "individual",
		"iso6393": "cbc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Carijona",
		"type": "living",
		"scope": "individual",
		"iso6393": "cbd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chimila",
		"type": "living",
		"scope": "individual",
		"iso6393": "cbg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chachi",
		"type": "living",
		"scope": "individual",
		"iso6393": "cbi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ede Cabe",
		"type": "living",
		"scope": "individual",
		"iso6393": "cbj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chavacano",
		"type": "living",
		"scope": "individual",
		"iso6393": "cbk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bualkhaw Chin",
		"type": "living",
		"scope": "individual",
		"iso6393": "cbl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyahkur",
		"type": "living",
		"scope": "individual",
		"iso6393": "cbn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Izora",
		"type": "living",
		"scope": "individual",
		"iso6393": "cbo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tsucuba",
		"type": "living",
		"scope": "individual",
		"iso6393": "cbq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cashibo-Cacataibo",
		"type": "living",
		"scope": "individual",
		"iso6393": "cbr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cashinahua",
		"type": "living",
		"scope": "individual",
		"iso6393": "cbs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chayahuita",
		"type": "living",
		"scope": "individual",
		"iso6393": "cbt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Candoshi-Shapra",
		"type": "living",
		"scope": "individual",
		"iso6393": "cbu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cacua",
		"type": "living",
		"scope": "individual",
		"iso6393": "cbv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kinabalian",
		"type": "living",
		"scope": "individual",
		"iso6393": "cbw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Carabayo",
		"type": "living",
		"scope": "individual",
		"iso6393": "cby",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cauca",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "cca",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chamicuro",
		"type": "living",
		"scope": "individual",
		"iso6393": "ccc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cafundo Creole",
		"type": "living",
		"scope": "individual",
		"iso6393": "ccd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chopi",
		"type": "living",
		"scope": "individual",
		"iso6393": "cce",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Samba Daka",
		"type": "living",
		"scope": "individual",
		"iso6393": "ccg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Atsam",
		"type": "living",
		"scope": "individual",
		"iso6393": "cch",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kasanga",
		"type": "living",
		"scope": "individual",
		"iso6393": "ccj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cutchi-Swahili",
		"type": "living",
		"scope": "individual",
		"iso6393": "ccl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Malaccan Creole Malay",
		"type": "living",
		"scope": "individual",
		"iso6393": "ccm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Comaltepec Chinantec",
		"type": "living",
		"scope": "individual",
		"iso6393": "cco",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chakma",
		"type": "living",
		"scope": "individual",
		"iso6393": "ccp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cacaopera",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ccr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Choni",
		"type": "living",
		"scope": "individual",
		"iso6393": "cda",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chenchu",
		"type": "living",
		"scope": "individual",
		"iso6393": "cde",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chiru",
		"type": "living",
		"scope": "individual",
		"iso6393": "cdf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chamari",
		"type": "living",
		"scope": "individual",
		"iso6393": "cdg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chambeali",
		"type": "living",
		"scope": "individual",
		"iso6393": "cdh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chodri",
		"type": "living",
		"scope": "individual",
		"iso6393": "cdi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Churahi",
		"type": "living",
		"scope": "individual",
		"iso6393": "cdj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chepang",
		"type": "living",
		"scope": "individual",
		"iso6393": "cdm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chaudangsi",
		"type": "living",
		"scope": "individual",
		"iso6393": "cdn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Min Dong Chinese",
		"type": "living",
		"scope": "individual",
		"iso6393": "cdo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cinda-Regi-Tiyal",
		"type": "living",
		"scope": "individual",
		"iso6393": "cdr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chadian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "cds",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chadong",
		"type": "living",
		"scope": "individual",
		"iso6393": "cdy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koda",
		"type": "living",
		"scope": "individual",
		"iso6393": "cdz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lower Chehalis",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "cea",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cebuano",
		"type": "living",
		"scope": "individual",
		"iso6393": "ceb",
		"iso6392B": "ceb",
		"iso6392T": "ceb",
		"iso6391": null
	},
	{
		"name": "Chamacoco",
		"type": "living",
		"scope": "individual",
		"iso6393": "ceg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Khumi Chin",
		"type": "living",
		"scope": "individual",
		"iso6393": "cek",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cen",
		"type": "living",
		"scope": "individual",
		"iso6393": "cen",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Czech",
		"type": "living",
		"scope": "individual",
		"iso6393": "ces",
		"iso6392B": "cze",
		"iso6392T": "ces",
		"iso6391": "cs"
	},
	{
		"name": "Centúúm",
		"type": "living",
		"scope": "individual",
		"iso6393": "cet",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dijim-Bwilim",
		"type": "living",
		"scope": "individual",
		"iso6393": "cfa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cara",
		"type": "living",
		"scope": "individual",
		"iso6393": "cfd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Como Karim",
		"type": "living",
		"scope": "individual",
		"iso6393": "cfg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Falam Chin",
		"type": "living",
		"scope": "individual",
		"iso6393": "cfm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Changriwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "cga",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kagayanen",
		"type": "living",
		"scope": "individual",
		"iso6393": "cgc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chiga",
		"type": "living",
		"scope": "individual",
		"iso6393": "cgg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chocangacakha",
		"type": "living",
		"scope": "individual",
		"iso6393": "cgk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chamorro",
		"type": "living",
		"scope": "individual",
		"iso6393": "cha",
		"iso6392B": "cha",
		"iso6392T": "cha",
		"iso6391": "ch"
	},
	{
		"name": "Chibcha",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "chb",
		"iso6392B": "chb",
		"iso6392T": "chb",
		"iso6391": null
	},
	{
		"name": "Catawba",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "chc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Highland Oaxaca Chontal",
		"type": "living",
		"scope": "individual",
		"iso6393": "chd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chechen",
		"type": "living",
		"scope": "individual",
		"iso6393": "che",
		"iso6392B": "che",
		"iso6392T": "che",
		"iso6391": "ce"
	},
	{
		"name": "Tabasco Chontal",
		"type": "living",
		"scope": "individual",
		"iso6393": "chf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chagatai",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "chg",
		"iso6392B": "chg",
		"iso6392T": "chg",
		"iso6391": null
	},
	{
		"name": "Chinook",
		"type": "living",
		"scope": "individual",
		"iso6393": "chh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ojitlán Chinantec",
		"type": "living",
		"scope": "individual",
		"iso6393": "chj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chuukese",
		"type": "living",
		"scope": "individual",
		"iso6393": "chk",
		"iso6392B": "chk",
		"iso6392T": "chk",
		"iso6391": null
	},
	{
		"name": "Cahuilla",
		"type": "living",
		"scope": "individual",
		"iso6393": "chl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mari (Russia)",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "chm",
		"iso6392B": "chm",
		"iso6392T": "chm",
		"iso6391": null
	},
	{
		"name": "Chinook jargon",
		"type": "living",
		"scope": "individual",
		"iso6393": "chn",
		"iso6392B": "chn",
		"iso6392T": "chn",
		"iso6391": null
	},
	{
		"name": "Choctaw",
		"type": "living",
		"scope": "individual",
		"iso6393": "cho",
		"iso6392B": "cho",
		"iso6392T": "cho",
		"iso6391": null
	},
	{
		"name": "Chipewyan",
		"type": "living",
		"scope": "individual",
		"iso6393": "chp",
		"iso6392B": "chp",
		"iso6392T": "chp",
		"iso6391": null
	},
	{
		"name": "Quiotepec Chinantec",
		"type": "living",
		"scope": "individual",
		"iso6393": "chq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cherokee",
		"type": "living",
		"scope": "individual",
		"iso6393": "chr",
		"iso6392B": "chr",
		"iso6392T": "chr",
		"iso6391": null
	},
	{
		"name": "Cholón",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "cht",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Church Slavic",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "chu",
		"iso6392B": "chu",
		"iso6392T": "chu",
		"iso6391": "cu"
	},
	{
		"name": "Chuvash",
		"type": "living",
		"scope": "individual",
		"iso6393": "chv",
		"iso6392B": "chv",
		"iso6392T": "chv",
		"iso6391": "cv"
	},
	{
		"name": "Chuwabu",
		"type": "living",
		"scope": "individual",
		"iso6393": "chw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chantyal",
		"type": "living",
		"scope": "individual",
		"iso6393": "chx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cheyenne",
		"type": "living",
		"scope": "individual",
		"iso6393": "chy",
		"iso6392B": "chy",
		"iso6392T": "chy",
		"iso6391": null
	},
	{
		"name": "Ozumacín Chinantec",
		"type": "living",
		"scope": "individual",
		"iso6393": "chz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cia-Cia",
		"type": "living",
		"scope": "individual",
		"iso6393": "cia",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ci Gbe",
		"type": "living",
		"scope": "individual",
		"iso6393": "cib",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chickasaw",
		"type": "living",
		"scope": "individual",
		"iso6393": "cic",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chimariko",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "cid",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cineni",
		"type": "living",
		"scope": "individual",
		"iso6393": "cie",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chinali",
		"type": "living",
		"scope": "individual",
		"iso6393": "cih",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chitkuli Kinnauri",
		"type": "living",
		"scope": "individual",
		"iso6393": "cik",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cimbrian",
		"type": "living",
		"scope": "individual",
		"iso6393": "cim",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cinta Larga",
		"type": "living",
		"scope": "individual",
		"iso6393": "cin",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chiapanec",
		"type": "living",
		"scope": "individual",
		"iso6393": "cip",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tiri",
		"type": "living",
		"scope": "individual",
		"iso6393": "cir",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chippewa",
		"type": "living",
		"scope": "individual",
		"iso6393": "ciw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chaima",
		"type": "living",
		"scope": "individual",
		"iso6393": "ciy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Cham",
		"type": "living",
		"scope": "individual",
		"iso6393": "cja",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chru",
		"type": "living",
		"scope": "individual",
		"iso6393": "cje",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Upper Chehalis",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "cjh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chamalal",
		"type": "living",
		"scope": "individual",
		"iso6393": "cji",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chokwe",
		"type": "living",
		"scope": "individual",
		"iso6393": "cjk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Cham",
		"type": "living",
		"scope": "individual",
		"iso6393": "cjm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chenapian",
		"type": "living",
		"scope": "individual",
		"iso6393": "cjn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ashéninka Pajonal",
		"type": "living",
		"scope": "individual",
		"iso6393": "cjo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cabécar",
		"type": "living",
		"scope": "individual",
		"iso6393": "cjp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shor",
		"type": "living",
		"scope": "individual",
		"iso6393": "cjs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chuave",
		"type": "living",
		"scope": "individual",
		"iso6393": "cjv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jinyu Chinese",
		"type": "living",
		"scope": "individual",
		"iso6393": "cjy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Central Kurdish",
		"type": "living",
		"scope": "individual",
		"iso6393": "ckb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chak",
		"type": "living",
		"scope": "individual",
		"iso6393": "ckh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cibak",
		"type": "living",
		"scope": "individual",
		"iso6393": "ckl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kaang Chin",
		"type": "living",
		"scope": "individual",
		"iso6393": "ckn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Anufo",
		"type": "living",
		"scope": "individual",
		"iso6393": "cko",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kajakse",
		"type": "living",
		"scope": "individual",
		"iso6393": "ckq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kairak",
		"type": "living",
		"scope": "individual",
		"iso6393": "ckr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tayo",
		"type": "living",
		"scope": "individual",
		"iso6393": "cks",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chukot",
		"type": "living",
		"scope": "individual",
		"iso6393": "ckt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koasati",
		"type": "living",
		"scope": "individual",
		"iso6393": "cku",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kavalan",
		"type": "living",
		"scope": "individual",
		"iso6393": "ckv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Caka",
		"type": "living",
		"scope": "individual",
		"iso6393": "ckx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cakfem-Mushere",
		"type": "living",
		"scope": "individual",
		"iso6393": "cky",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cakchiquel-Quiché Mixed Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "ckz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ron",
		"type": "living",
		"scope": "individual",
		"iso6393": "cla",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chilcotin",
		"type": "living",
		"scope": "individual",
		"iso6393": "clc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chaldean Neo-Aramaic",
		"type": "living",
		"scope": "individual",
		"iso6393": "cld",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lealao Chinantec",
		"type": "living",
		"scope": "individual",
		"iso6393": "cle",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chilisso",
		"type": "living",
		"scope": "individual",
		"iso6393": "clh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chakali",
		"type": "living",
		"scope": "individual",
		"iso6393": "cli",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Laitu Chin",
		"type": "living",
		"scope": "individual",
		"iso6393": "clj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Idu-Mishmi",
		"type": "living",
		"scope": "individual",
		"iso6393": "clk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chala",
		"type": "living",
		"scope": "individual",
		"iso6393": "cll",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Clallam",
		"type": "living",
		"scope": "individual",
		"iso6393": "clm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lowland Oaxaca Chontal",
		"type": "living",
		"scope": "individual",
		"iso6393": "clo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lautu Chin",
		"type": "living",
		"scope": "individual",
		"iso6393": "clt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Caluyanun",
		"type": "living",
		"scope": "individual",
		"iso6393": "clu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chulym",
		"type": "living",
		"scope": "individual",
		"iso6393": "clw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Highland Chatino",
		"type": "living",
		"scope": "individual",
		"iso6393": "cly",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maa",
		"type": "living",
		"scope": "individual",
		"iso6393": "cma",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cerma",
		"type": "living",
		"scope": "individual",
		"iso6393": "cme",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Classical Mongolian",
		"type": "historical",
		"scope": "individual",
		"iso6393": "cmg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Emberá-Chamí",
		"type": "living",
		"scope": "individual",
		"iso6393": "cmi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Campalagian",
		"type": "living",
		"scope": "individual",
		"iso6393": "cml",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Michigamea",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "cmm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mandarin Chinese",
		"type": "living",
		"scope": "individual",
		"iso6393": "cmn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Central Mnong",
		"type": "living",
		"scope": "individual",
		"iso6393": "cmo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mro-Khimi Chin",
		"type": "living",
		"scope": "individual",
		"iso6393": "cmr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Messapic",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "cms",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Camtho",
		"type": "living",
		"scope": "individual",
		"iso6393": "cmt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Changthang",
		"type": "living",
		"scope": "individual",
		"iso6393": "cna",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chinbon Chin",
		"type": "living",
		"scope": "individual",
		"iso6393": "cnb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Côông",
		"type": "living",
		"scope": "individual",
		"iso6393": "cnc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Qiang",
		"type": "living",
		"scope": "individual",
		"iso6393": "cng",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hakha Chin",
		"type": "living",
		"scope": "individual",
		"iso6393": "cnh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Asháninka",
		"type": "living",
		"scope": "individual",
		"iso6393": "cni",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Khumi Chin",
		"type": "living",
		"scope": "individual",
		"iso6393": "cnk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lalana Chinantec",
		"type": "living",
		"scope": "individual",
		"iso6393": "cnl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Con",
		"type": "living",
		"scope": "individual",
		"iso6393": "cno",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Central Asmat",
		"type": "living",
		"scope": "individual",
		"iso6393": "cns",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tepetotutla Chinantec",
		"type": "living",
		"scope": "individual",
		"iso6393": "cnt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chenoua",
		"type": "living",
		"scope": "individual",
		"iso6393": "cnu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngawn Chin",
		"type": "living",
		"scope": "individual",
		"iso6393": "cnw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Middle Cornish",
		"type": "historical",
		"scope": "individual",
		"iso6393": "cnx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cocos Islands Malay",
		"type": "living",
		"scope": "individual",
		"iso6393": "coa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chicomuceltec",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "cob",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cocopa",
		"type": "living",
		"scope": "individual",
		"iso6393": "coc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cocama-Cocamilla",
		"type": "living",
		"scope": "individual",
		"iso6393": "cod",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koreguaje",
		"type": "living",
		"scope": "individual",
		"iso6393": "coe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Colorado",
		"type": "living",
		"scope": "individual",
		"iso6393": "cof",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chong",
		"type": "living",
		"scope": "individual",
		"iso6393": "cog",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chonyi-Dzihana-Kauma",
		"type": "living",
		"scope": "individual",
		"iso6393": "coh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cochimi",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "coj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Santa Teresa Cora",
		"type": "living",
		"scope": "individual",
		"iso6393": "cok",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Columbia-Wenatchi",
		"type": "living",
		"scope": "individual",
		"iso6393": "col",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Comanche",
		"type": "living",
		"scope": "individual",
		"iso6393": "com",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cofán",
		"type": "living",
		"scope": "individual",
		"iso6393": "con",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Comox",
		"type": "living",
		"scope": "individual",
		"iso6393": "coo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Coptic",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "cop",
		"iso6392B": "cop",
		"iso6392T": "cop",
		"iso6391": null
	},
	{
		"name": "Coquille",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "coq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cornish",
		"type": "living",
		"scope": "individual",
		"iso6393": "cor",
		"iso6392B": "cor",
		"iso6392T": "cor",
		"iso6391": "kw"
	},
	{
		"name": "Corsican",
		"type": "living",
		"scope": "individual",
		"iso6393": "cos",
		"iso6392B": "cos",
		"iso6392T": "cos",
		"iso6391": "co"
	},
	{
		"name": "Caquinte",
		"type": "living",
		"scope": "individual",
		"iso6393": "cot",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wamey",
		"type": "living",
		"scope": "individual",
		"iso6393": "cou",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cao Miao",
		"type": "living",
		"scope": "individual",
		"iso6393": "cov",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cowlitz",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "cow",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nanti",
		"type": "living",
		"scope": "individual",
		"iso6393": "cox",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chochotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "coz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Palantla Chinantec",
		"type": "living",
		"scope": "individual",
		"iso6393": "cpa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ucayali-Yurúa Ashéninka",
		"type": "living",
		"scope": "individual",
		"iso6393": "cpb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ajyíninka Apurucayali",
		"type": "living",
		"scope": "individual",
		"iso6393": "cpc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cappadocian Greek",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "cpg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chinese Pidgin English",
		"type": "living",
		"scope": "individual",
		"iso6393": "cpi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cherepon",
		"type": "living",
		"scope": "individual",
		"iso6393": "cpn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kpeego",
		"type": "living",
		"scope": "individual",
		"iso6393": "cpo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Capiznon",
		"type": "living",
		"scope": "individual",
		"iso6393": "cps",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pichis Ashéninka",
		"type": "living",
		"scope": "individual",
		"iso6393": "cpu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pu-Xian Chinese",
		"type": "living",
		"scope": "individual",
		"iso6393": "cpx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "South Ucayali Ashéninka",
		"type": "living",
		"scope": "individual",
		"iso6393": "cpy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chuanqiandian Cluster Miao",
		"type": "living",
		"scope": "individual",
		"iso6393": "cqd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chara",
		"type": "living",
		"scope": "individual",
		"iso6393": "cra",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Island Carib",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "crb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lonwolwol",
		"type": "living",
		"scope": "individual",
		"iso6393": "crc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Coeur d'Alene",
		"type": "living",
		"scope": "individual",
		"iso6393": "crd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cree",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "cre",
		"iso6392B": "cre",
		"iso6392T": "cre",
		"iso6391": "cr"
	},
	{
		"name": "Caramanta",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "crf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Michif",
		"type": "living",
		"scope": "individual",
		"iso6393": "crg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Crimean Tatar",
		"type": "living",
		"scope": "individual",
		"iso6393": "crh",
		"iso6392B": "crh",
		"iso6392T": "crh",
		"iso6391": null
	},
	{
		"name": "Sãotomense",
		"type": "living",
		"scope": "individual",
		"iso6393": "cri",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern East Cree",
		"type": "living",
		"scope": "individual",
		"iso6393": "crj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Plains Cree",
		"type": "living",
		"scope": "individual",
		"iso6393": "crk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern East Cree",
		"type": "living",
		"scope": "individual",
		"iso6393": "crl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Moose Cree",
		"type": "living",
		"scope": "individual",
		"iso6393": "crm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "El Nayar Cora",
		"type": "living",
		"scope": "individual",
		"iso6393": "crn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Crow",
		"type": "living",
		"scope": "individual",
		"iso6393": "cro",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Iyo'wujwa Chorote",
		"type": "living",
		"scope": "individual",
		"iso6393": "crq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Carolina Algonquian",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "crr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Seselwa Creole French",
		"type": "living",
		"scope": "individual",
		"iso6393": "crs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Iyojwa'ja Chorote",
		"type": "living",
		"scope": "individual",
		"iso6393": "crt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chaura",
		"type": "living",
		"scope": "individual",
		"iso6393": "crv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chrau",
		"type": "living",
		"scope": "individual",
		"iso6393": "crw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Carrier",
		"type": "living",
		"scope": "individual",
		"iso6393": "crx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cori",
		"type": "living",
		"scope": "individual",
		"iso6393": "cry",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cruzeño",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "crz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chiltepec Chinantec",
		"type": "living",
		"scope": "individual",
		"iso6393": "csa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kashubian",
		"type": "living",
		"scope": "individual",
		"iso6393": "csb",
		"iso6392B": "csb",
		"iso6392T": "csb",
		"iso6391": null
	},
	{
		"name": "Catalan Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "csc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chiangmai Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "csd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Czech Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "cse",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cuba Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "csf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chilean Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "csg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Asho Chin",
		"type": "living",
		"scope": "individual",
		"iso6393": "csh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Coast Miwok",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "csi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Songlai Chin",
		"type": "living",
		"scope": "individual",
		"iso6393": "csj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jola-Kasa",
		"type": "living",
		"scope": "individual",
		"iso6393": "csk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chinese Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "csl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Central Sierra Miwok",
		"type": "living",
		"scope": "individual",
		"iso6393": "csm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Colombian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "csn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sochiapam Chinantec",
		"type": "living",
		"scope": "individual",
		"iso6393": "cso",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Croatia Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "csq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Costa Rican Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "csr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Ohlone",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "css",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Ohlone",
		"type": "living",
		"scope": "individual",
		"iso6393": "cst",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sumtu Chin",
		"type": "living",
		"scope": "individual",
		"iso6393": "csv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Swampy Cree",
		"type": "living",
		"scope": "individual",
		"iso6393": "csw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Siyin Chin",
		"type": "living",
		"scope": "individual",
		"iso6393": "csy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Coos",
		"type": "living",
		"scope": "individual",
		"iso6393": "csz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tataltepec Chatino",
		"type": "living",
		"scope": "individual",
		"iso6393": "cta",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chetco",
		"type": "living",
		"scope": "individual",
		"iso6393": "ctc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tedim Chin",
		"type": "living",
		"scope": "individual",
		"iso6393": "ctd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tepinapa Chinantec",
		"type": "living",
		"scope": "individual",
		"iso6393": "cte",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chittagonian",
		"type": "living",
		"scope": "individual",
		"iso6393": "ctg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Thaiphum Chin",
		"type": "living",
		"scope": "individual",
		"iso6393": "cth",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tlacoatzintepec Chinantec",
		"type": "living",
		"scope": "individual",
		"iso6393": "ctl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chitimacha",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ctm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chhintange",
		"type": "living",
		"scope": "individual",
		"iso6393": "ctn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Emberá-Catío",
		"type": "living",
		"scope": "individual",
		"iso6393": "cto",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Highland Chatino",
		"type": "living",
		"scope": "individual",
		"iso6393": "ctp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Catanduanes Bikol",
		"type": "living",
		"scope": "individual",
		"iso6393": "cts",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wayanad Chetti",
		"type": "living",
		"scope": "individual",
		"iso6393": "ctt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chol",
		"type": "living",
		"scope": "individual",
		"iso6393": "ctu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zacatepec Chatino",
		"type": "living",
		"scope": "individual",
		"iso6393": "ctz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cua",
		"type": "living",
		"scope": "individual",
		"iso6393": "cua",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cubeo",
		"type": "living",
		"scope": "individual",
		"iso6393": "cub",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Usila Chinantec",
		"type": "living",
		"scope": "individual",
		"iso6393": "cuc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cung",
		"type": "living",
		"scope": "individual",
		"iso6393": "cug",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chuka",
		"type": "living",
		"scope": "individual",
		"iso6393": "cuh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cuiba",
		"type": "living",
		"scope": "individual",
		"iso6393": "cui",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mashco Piro",
		"type": "living",
		"scope": "individual",
		"iso6393": "cuj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "San Blas Kuna",
		"type": "living",
		"scope": "individual",
		"iso6393": "cuk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Culina",
		"type": "living",
		"scope": "individual",
		"iso6393": "cul",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cumanagoto",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "cuo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cupeño",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "cup",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cun",
		"type": "living",
		"scope": "individual",
		"iso6393": "cuq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chhulung",
		"type": "living",
		"scope": "individual",
		"iso6393": "cur",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Teutila Cuicatec",
		"type": "living",
		"scope": "individual",
		"iso6393": "cut",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tai Ya",
		"type": "living",
		"scope": "individual",
		"iso6393": "cuu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cuvok",
		"type": "living",
		"scope": "individual",
		"iso6393": "cuv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chukwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "cuw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tepeuxila Cuicatec",
		"type": "living",
		"scope": "individual",
		"iso6393": "cux",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chug",
		"type": "living",
		"scope": "individual",
		"iso6393": "cvg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Valle Nacional Chinantec",
		"type": "living",
		"scope": "individual",
		"iso6393": "cvn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kabwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "cwa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maindo",
		"type": "living",
		"scope": "individual",
		"iso6393": "cwb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Woods Cree",
		"type": "living",
		"scope": "individual",
		"iso6393": "cwd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kwere",
		"type": "living",
		"scope": "individual",
		"iso6393": "cwe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chewong",
		"type": "living",
		"scope": "individual",
		"iso6393": "cwg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kuwaataay",
		"type": "living",
		"scope": "individual",
		"iso6393": "cwt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nopala Chatino",
		"type": "living",
		"scope": "individual",
		"iso6393": "cya",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cayubaba",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "cyb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Welsh",
		"type": "living",
		"scope": "individual",
		"iso6393": "cym",
		"iso6392B": "wel",
		"iso6392T": "cym",
		"iso6391": "cy"
	},
	{
		"name": "Cuyonon",
		"type": "living",
		"scope": "individual",
		"iso6393": "cyo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Huizhou Chinese",
		"type": "living",
		"scope": "individual",
		"iso6393": "czh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Knaanic",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "czk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zenzontepec Chatino",
		"type": "living",
		"scope": "individual",
		"iso6393": "czn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Min Zhong Chinese",
		"type": "living",
		"scope": "individual",
		"iso6393": "czo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zotung Chin",
		"type": "living",
		"scope": "individual",
		"iso6393": "czt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dangaléat",
		"type": "living",
		"scope": "individual",
		"iso6393": "daa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dambi",
		"type": "living",
		"scope": "individual",
		"iso6393": "dac",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Marik",
		"type": "living",
		"scope": "individual",
		"iso6393": "dad",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Duupa",
		"type": "living",
		"scope": "individual",
		"iso6393": "dae",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dagbani",
		"type": "living",
		"scope": "individual",
		"iso6393": "dag",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gwahatike",
		"type": "living",
		"scope": "individual",
		"iso6393": "dah",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Day",
		"type": "living",
		"scope": "individual",
		"iso6393": "dai",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dar Fur Daju",
		"type": "living",
		"scope": "individual",
		"iso6393": "daj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dakota",
		"type": "living",
		"scope": "individual",
		"iso6393": "dak",
		"iso6392B": "dak",
		"iso6392T": "dak",
		"iso6391": null
	},
	{
		"name": "Dahalo",
		"type": "living",
		"scope": "individual",
		"iso6393": "dal",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Damakawa",
		"type": "living",
		"scope": "individual",
		"iso6393": "dam",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Danish",
		"type": "living",
		"scope": "individual",
		"iso6393": "dan",
		"iso6392B": "dan",
		"iso6392T": "dan",
		"iso6391": "da"
	},
	{
		"name": "Daai Chin",
		"type": "living",
		"scope": "individual",
		"iso6393": "dao",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dandami Maria",
		"type": "living",
		"scope": "individual",
		"iso6393": "daq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dargwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "dar",
		"iso6392B": "dar",
		"iso6392T": "dar",
		"iso6391": null
	},
	{
		"name": "Daho-Doo",
		"type": "living",
		"scope": "individual",
		"iso6393": "das",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dar Sila Daju",
		"type": "living",
		"scope": "individual",
		"iso6393": "dau",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Taita",
		"type": "living",
		"scope": "individual",
		"iso6393": "dav",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Davawenyo",
		"type": "living",
		"scope": "individual",
		"iso6393": "daw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dayi",
		"type": "living",
		"scope": "individual",
		"iso6393": "dax",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dao",
		"type": "living",
		"scope": "individual",
		"iso6393": "daz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bangime",
		"type": "living",
		"scope": "individual",
		"iso6393": "dba",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Deno",
		"type": "living",
		"scope": "individual",
		"iso6393": "dbb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dadiya",
		"type": "living",
		"scope": "individual",
		"iso6393": "dbd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dabe",
		"type": "living",
		"scope": "individual",
		"iso6393": "dbe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Edopi",
		"type": "living",
		"scope": "individual",
		"iso6393": "dbf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dogul Dom Dogon",
		"type": "living",
		"scope": "individual",
		"iso6393": "dbg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Doka",
		"type": "living",
		"scope": "individual",
		"iso6393": "dbi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ida'an",
		"type": "living",
		"scope": "individual",
		"iso6393": "dbj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dyirbal",
		"type": "living",
		"scope": "individual",
		"iso6393": "dbl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Duguri",
		"type": "living",
		"scope": "individual",
		"iso6393": "dbm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Duriankere",
		"type": "living",
		"scope": "individual",
		"iso6393": "dbn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dulbu",
		"type": "living",
		"scope": "individual",
		"iso6393": "dbo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Duwai",
		"type": "living",
		"scope": "individual",
		"iso6393": "dbp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Daba",
		"type": "living",
		"scope": "individual",
		"iso6393": "dbq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dabarre",
		"type": "living",
		"scope": "individual",
		"iso6393": "dbr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ben Tey Dogon",
		"type": "living",
		"scope": "individual",
		"iso6393": "dbt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bondum Dom Dogon",
		"type": "living",
		"scope": "individual",
		"iso6393": "dbu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dungu",
		"type": "living",
		"scope": "individual",
		"iso6393": "dbv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bankan Tey Dogon",
		"type": "living",
		"scope": "individual",
		"iso6393": "dbw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dibiyaso",
		"type": "living",
		"scope": "individual",
		"iso6393": "dby",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Deccan",
		"type": "living",
		"scope": "individual",
		"iso6393": "dcc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Negerhollands",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "dcr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dadi Dadi",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "dda",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dongotono",
		"type": "living",
		"scope": "individual",
		"iso6393": "ddd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Doondo",
		"type": "living",
		"scope": "individual",
		"iso6393": "dde",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Fataluku",
		"type": "living",
		"scope": "individual",
		"iso6393": "ddg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "West Goodenough",
		"type": "living",
		"scope": "individual",
		"iso6393": "ddi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jaru",
		"type": "living",
		"scope": "individual",
		"iso6393": "ddj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dendi (Benin)",
		"type": "living",
		"scope": "individual",
		"iso6393": "ddn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dido",
		"type": "living",
		"scope": "individual",
		"iso6393": "ddo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dhudhuroa",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ddr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Donno So Dogon",
		"type": "living",
		"scope": "individual",
		"iso6393": "dds",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dawera-Daweloor",
		"type": "living",
		"scope": "individual",
		"iso6393": "ddw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dagik",
		"type": "living",
		"scope": "individual",
		"iso6393": "dec",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dedua",
		"type": "living",
		"scope": "individual",
		"iso6393": "ded",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dewoin",
		"type": "living",
		"scope": "individual",
		"iso6393": "dee",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dezfuli",
		"type": "living",
		"scope": "individual",
		"iso6393": "def",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Degema",
		"type": "living",
		"scope": "individual",
		"iso6393": "deg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dehwari",
		"type": "living",
		"scope": "individual",
		"iso6393": "deh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Demisa",
		"type": "living",
		"scope": "individual",
		"iso6393": "dei",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dek",
		"type": "living",
		"scope": "individual",
		"iso6393": "dek",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Delaware",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "del",
		"iso6392B": "del",
		"iso6392T": "del",
		"iso6391": null
	},
	{
		"name": "Dem",
		"type": "living",
		"scope": "individual",
		"iso6393": "dem",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Slave (Athapascan)",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "den",
		"iso6392B": "den",
		"iso6392T": "den",
		"iso6391": null
	},
	{
		"name": "Pidgin Delaware",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "dep",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dendi (Central African Republic)",
		"type": "living",
		"scope": "individual",
		"iso6393": "deq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Deori",
		"type": "living",
		"scope": "individual",
		"iso6393": "der",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Desano",
		"type": "living",
		"scope": "individual",
		"iso6393": "des",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "German",
		"type": "living",
		"scope": "individual",
		"iso6393": "deu",
		"iso6392B": "ger",
		"iso6392T": "deu",
		"iso6391": "de"
	},
	{
		"name": "Domung",
		"type": "living",
		"scope": "individual",
		"iso6393": "dev",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dengese",
		"type": "living",
		"scope": "individual",
		"iso6393": "dez",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Dagaare",
		"type": "living",
		"scope": "individual",
		"iso6393": "dga",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bunoge Dogon",
		"type": "living",
		"scope": "individual",
		"iso6393": "dgb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Casiguran Dumagat Agta",
		"type": "living",
		"scope": "individual",
		"iso6393": "dgc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dagaari Dioula",
		"type": "living",
		"scope": "individual",
		"iso6393": "dgd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Degenan",
		"type": "living",
		"scope": "individual",
		"iso6393": "dge",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Doga",
		"type": "living",
		"scope": "individual",
		"iso6393": "dgg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dghwede",
		"type": "living",
		"scope": "individual",
		"iso6393": "dgh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Dagara",
		"type": "living",
		"scope": "individual",
		"iso6393": "dgi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dagba",
		"type": "living",
		"scope": "individual",
		"iso6393": "dgk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Andaandi",
		"type": "living",
		"scope": "individual",
		"iso6393": "dgl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dagoman",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "dgn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dogri (individual language)",
		"type": "living",
		"scope": "individual",
		"iso6393": "dgo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dogrib",
		"type": "living",
		"scope": "individual",
		"iso6393": "dgr",
		"iso6392B": "dgr",
		"iso6392T": "dgr",
		"iso6391": null
	},
	{
		"name": "Dogoso",
		"type": "living",
		"scope": "individual",
		"iso6393": "dgs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ndra'ngith",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "dgt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Degaru",
		"type": "living",
		"scope": "individual",
		"iso6393": "dgu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Daungwurrung",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "dgw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Doghoro",
		"type": "living",
		"scope": "individual",
		"iso6393": "dgx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Daga",
		"type": "living",
		"scope": "individual",
		"iso6393": "dgz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dhundari",
		"type": "living",
		"scope": "individual",
		"iso6393": "dhd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dhangu-Djangu",
		"type": "living",
		"scope": "individual",
		"iso6393": "dhg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dhimal",
		"type": "living",
		"scope": "individual",
		"iso6393": "dhi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dhalandji",
		"type": "living",
		"scope": "individual",
		"iso6393": "dhl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zemba",
		"type": "living",
		"scope": "individual",
		"iso6393": "dhm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dhanki",
		"type": "living",
		"scope": "individual",
		"iso6393": "dhn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dhodia",
		"type": "living",
		"scope": "individual",
		"iso6393": "dho",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dhargari",
		"type": "living",
		"scope": "individual",
		"iso6393": "dhr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dhaiso",
		"type": "living",
		"scope": "individual",
		"iso6393": "dhs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dhurga",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "dhu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dehu",
		"type": "living",
		"scope": "individual",
		"iso6393": "dhv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dhanwar (Nepal)",
		"type": "living",
		"scope": "individual",
		"iso6393": "dhw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dhungaloo",
		"type": "living",
		"scope": "individual",
		"iso6393": "dhx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dia",
		"type": "living",
		"scope": "individual",
		"iso6393": "dia",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "South Central Dinka",
		"type": "living",
		"scope": "individual",
		"iso6393": "dib",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lakota Dida",
		"type": "living",
		"scope": "individual",
		"iso6393": "dic",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Didinga",
		"type": "living",
		"scope": "individual",
		"iso6393": "did",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dieri",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "dif",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Digo",
		"type": "living",
		"scope": "individual",
		"iso6393": "dig",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kumiai",
		"type": "living",
		"scope": "individual",
		"iso6393": "dih",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dimbong",
		"type": "living",
		"scope": "individual",
		"iso6393": "dii",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dai",
		"type": "living",
		"scope": "individual",
		"iso6393": "dij",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southwestern Dinka",
		"type": "living",
		"scope": "individual",
		"iso6393": "dik",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dilling",
		"type": "living",
		"scope": "individual",
		"iso6393": "dil",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dime",
		"type": "living",
		"scope": "individual",
		"iso6393": "dim",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dinka",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "din",
		"iso6392B": "din",
		"iso6392T": "din",
		"iso6391": null
	},
	{
		"name": "Dibo",
		"type": "living",
		"scope": "individual",
		"iso6393": "dio",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northeastern Dinka",
		"type": "living",
		"scope": "individual",
		"iso6393": "dip",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dimli (individual language)",
		"type": "living",
		"scope": "individual",
		"iso6393": "diq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dirim",
		"type": "living",
		"scope": "individual",
		"iso6393": "dir",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dimasa",
		"type": "living",
		"scope": "individual",
		"iso6393": "dis",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dirari",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "dit",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Diriku",
		"type": "living",
		"scope": "individual",
		"iso6393": "diu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dhivehi",
		"type": "living",
		"scope": "individual",
		"iso6393": "div",
		"iso6392B": "div",
		"iso6392T": "div",
		"iso6391": "dv"
	},
	{
		"name": "Northwestern Dinka",
		"type": "living",
		"scope": "individual",
		"iso6393": "diw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dixon Reef",
		"type": "living",
		"scope": "individual",
		"iso6393": "dix",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Diuwe",
		"type": "living",
		"scope": "individual",
		"iso6393": "diy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ding",
		"type": "living",
		"scope": "individual",
		"iso6393": "diz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Djadjawurrung",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "dja",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Djinba",
		"type": "living",
		"scope": "individual",
		"iso6393": "djb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dar Daju Daju",
		"type": "living",
		"scope": "individual",
		"iso6393": "djc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Djamindjung",
		"type": "living",
		"scope": "individual",
		"iso6393": "djd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zarma",
		"type": "living",
		"scope": "individual",
		"iso6393": "dje",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Djangun",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "djf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Djinang",
		"type": "living",
		"scope": "individual",
		"iso6393": "dji",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Djeebbana",
		"type": "living",
		"scope": "individual",
		"iso6393": "djj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Maroon Creole",
		"type": "living",
		"scope": "individual",
		"iso6393": "djk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jamsay Dogon",
		"type": "living",
		"scope": "individual",
		"iso6393": "djm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Djauan",
		"type": "living",
		"scope": "individual",
		"iso6393": "djn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jangkang",
		"type": "living",
		"scope": "individual",
		"iso6393": "djo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Djambarrpuyngu",
		"type": "living",
		"scope": "individual",
		"iso6393": "djr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kapriman",
		"type": "living",
		"scope": "individual",
		"iso6393": "dju",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Djawi",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "djw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dakpakha",
		"type": "living",
		"scope": "individual",
		"iso6393": "dka",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dakka",
		"type": "living",
		"scope": "individual",
		"iso6393": "dkk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kuijau",
		"type": "living",
		"scope": "individual",
		"iso6393": "dkr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southeastern Dinka",
		"type": "living",
		"scope": "individual",
		"iso6393": "dks",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mazagway",
		"type": "living",
		"scope": "individual",
		"iso6393": "dkx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dolgan",
		"type": "living",
		"scope": "individual",
		"iso6393": "dlg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dahalik",
		"type": "living",
		"scope": "individual",
		"iso6393": "dlk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dalmatian",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "dlm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Darlong",
		"type": "living",
		"scope": "individual",
		"iso6393": "dln",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Duma",
		"type": "living",
		"scope": "individual",
		"iso6393": "dma",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mombo Dogon",
		"type": "living",
		"scope": "individual",
		"iso6393": "dmb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gavak",
		"type": "living",
		"scope": "individual",
		"iso6393": "dmc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Madhi Madhi",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "dmd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dugwor",
		"type": "living",
		"scope": "individual",
		"iso6393": "dme",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Upper Kinabatangan",
		"type": "living",
		"scope": "individual",
		"iso6393": "dmg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Domaaki",
		"type": "living",
		"scope": "individual",
		"iso6393": "dmk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dameli",
		"type": "living",
		"scope": "individual",
		"iso6393": "dml",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dama",
		"type": "living",
		"scope": "individual",
		"iso6393": "dmm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kemedzung",
		"type": "living",
		"scope": "individual",
		"iso6393": "dmo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "East Damar",
		"type": "living",
		"scope": "individual",
		"iso6393": "dmr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dampelas",
		"type": "living",
		"scope": "individual",
		"iso6393": "dms",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dubu",
		"type": "living",
		"scope": "individual",
		"iso6393": "dmu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dumpas",
		"type": "living",
		"scope": "individual",
		"iso6393": "dmv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mudburra",
		"type": "living",
		"scope": "individual",
		"iso6393": "dmw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dema",
		"type": "living",
		"scope": "individual",
		"iso6393": "dmx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Demta",
		"type": "living",
		"scope": "individual",
		"iso6393": "dmy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Upper Grand Valley Dani",
		"type": "living",
		"scope": "individual",
		"iso6393": "dna",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Daonda",
		"type": "living",
		"scope": "individual",
		"iso6393": "dnd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ndendeule",
		"type": "living",
		"scope": "individual",
		"iso6393": "dne",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dungan",
		"type": "living",
		"scope": "individual",
		"iso6393": "dng",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lower Grand Valley Dani",
		"type": "living",
		"scope": "individual",
		"iso6393": "dni",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dan",
		"type": "living",
		"scope": "individual",
		"iso6393": "dnj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dengka",
		"type": "living",
		"scope": "individual",
		"iso6393": "dnk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dzùùngoo",
		"type": "living",
		"scope": "individual",
		"iso6393": "dnn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Danaru",
		"type": "living",
		"scope": "individual",
		"iso6393": "dnr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mid Grand Valley Dani",
		"type": "living",
		"scope": "individual",
		"iso6393": "dnt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Danau",
		"type": "living",
		"scope": "individual",
		"iso6393": "dnu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Danu",
		"type": "living",
		"scope": "individual",
		"iso6393": "dnv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Dani",
		"type": "living",
		"scope": "individual",
		"iso6393": "dnw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dení",
		"type": "living",
		"scope": "individual",
		"iso6393": "dny",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dom",
		"type": "living",
		"scope": "individual",
		"iso6393": "doa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dobu",
		"type": "living",
		"scope": "individual",
		"iso6393": "dob",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Dong",
		"type": "living",
		"scope": "individual",
		"iso6393": "doc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Doe",
		"type": "living",
		"scope": "individual",
		"iso6393": "doe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Domu",
		"type": "living",
		"scope": "individual",
		"iso6393": "dof",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dong",
		"type": "living",
		"scope": "individual",
		"iso6393": "doh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dogri (macrolanguage)",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "doi",
		"iso6392B": "doi",
		"iso6392T": "doi",
		"iso6391": null
	},
	{
		"name": "Dondo",
		"type": "living",
		"scope": "individual",
		"iso6393": "dok",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Doso",
		"type": "living",
		"scope": "individual",
		"iso6393": "dol",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Toura (Papua New Guinea)",
		"type": "living",
		"scope": "individual",
		"iso6393": "don",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dongo",
		"type": "living",
		"scope": "individual",
		"iso6393": "doo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lukpa",
		"type": "living",
		"scope": "individual",
		"iso6393": "dop",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dominican Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "doq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dori'o",
		"type": "living",
		"scope": "individual",
		"iso6393": "dor",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dogosé",
		"type": "living",
		"scope": "individual",
		"iso6393": "dos",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dass",
		"type": "living",
		"scope": "individual",
		"iso6393": "dot",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dombe",
		"type": "living",
		"scope": "individual",
		"iso6393": "dov",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Doyayo",
		"type": "living",
		"scope": "individual",
		"iso6393": "dow",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bussa",
		"type": "living",
		"scope": "individual",
		"iso6393": "dox",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dompo",
		"type": "living",
		"scope": "individual",
		"iso6393": "doy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dorze",
		"type": "living",
		"scope": "individual",
		"iso6393": "doz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Papar",
		"type": "living",
		"scope": "individual",
		"iso6393": "dpp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dair",
		"type": "living",
		"scope": "individual",
		"iso6393": "drb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Minderico",
		"type": "living",
		"scope": "individual",
		"iso6393": "drc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Darmiya",
		"type": "living",
		"scope": "individual",
		"iso6393": "drd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dolpo",
		"type": "living",
		"scope": "individual",
		"iso6393": "dre",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rungus",
		"type": "living",
		"scope": "individual",
		"iso6393": "drg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "C'lela",
		"type": "living",
		"scope": "individual",
		"iso6393": "dri",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Paakantyi",
		"type": "living",
		"scope": "individual",
		"iso6393": "drl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "West Damar",
		"type": "living",
		"scope": "individual",
		"iso6393": "drn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Daro-Matu Melanau",
		"type": "living",
		"scope": "individual",
		"iso6393": "dro",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dura",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "drq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dororo",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "drr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gedeo",
		"type": "living",
		"scope": "individual",
		"iso6393": "drs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Drents",
		"type": "living",
		"scope": "individual",
		"iso6393": "drt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rukai",
		"type": "living",
		"scope": "individual",
		"iso6393": "dru",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Darai",
		"type": "living",
		"scope": "individual",
		"iso6393": "dry",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lower Sorbian",
		"type": "living",
		"scope": "individual",
		"iso6393": "dsb",
		"iso6392B": "dsb",
		"iso6392T": "dsb",
		"iso6391": null
	},
	{
		"name": "Dutch Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "dse",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Daasanach",
		"type": "living",
		"scope": "individual",
		"iso6393": "dsh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Disa",
		"type": "living",
		"scope": "individual",
		"iso6393": "dsi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Danish Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "dsl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dusner",
		"type": "living",
		"scope": "individual",
		"iso6393": "dsn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Desiya",
		"type": "living",
		"scope": "individual",
		"iso6393": "dso",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tadaksahak",
		"type": "living",
		"scope": "individual",
		"iso6393": "dsq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Daur",
		"type": "living",
		"scope": "individual",
		"iso6393": "dta",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Labuk-Kinabatangan Kadazan",
		"type": "living",
		"scope": "individual",
		"iso6393": "dtb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ditidaht",
		"type": "living",
		"scope": "individual",
		"iso6393": "dtd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Adithinngithigh",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "dth",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ana Tinga Dogon",
		"type": "living",
		"scope": "individual",
		"iso6393": "dti",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tene Kan Dogon",
		"type": "living",
		"scope": "individual",
		"iso6393": "dtk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tomo Kan Dogon",
		"type": "living",
		"scope": "individual",
		"iso6393": "dtm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Daatsʼíin",
		"type": "living",
		"scope": "individual",
		"iso6393": "dtn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tommo So Dogon",
		"type": "living",
		"scope": "individual",
		"iso6393": "dto",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kadazan Dusun",
		"type": "living",
		"scope": "individual",
		"iso6393": "dtp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lotud",
		"type": "living",
		"scope": "individual",
		"iso6393": "dtr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Toro So Dogon",
		"type": "living",
		"scope": "individual",
		"iso6393": "dts",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Toro Tegu Dogon",
		"type": "living",
		"scope": "individual",
		"iso6393": "dtt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tebul Ure Dogon",
		"type": "living",
		"scope": "individual",
		"iso6393": "dtu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dotyali",
		"type": "living",
		"scope": "individual",
		"iso6393": "dty",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Duala",
		"type": "living",
		"scope": "individual",
		"iso6393": "dua",
		"iso6392B": "dua",
		"iso6392T": "dua",
		"iso6391": null
	},
	{
		"name": "Dubli",
		"type": "living",
		"scope": "individual",
		"iso6393": "dub",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Duna",
		"type": "living",
		"scope": "individual",
		"iso6393": "duc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hun-Saare",
		"type": "living",
		"scope": "individual",
		"iso6393": "dud",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Umiray Dumaget Agta",
		"type": "living",
		"scope": "individual",
		"iso6393": "due",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dumbea",
		"type": "living",
		"scope": "individual",
		"iso6393": "duf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Duruma",
		"type": "living",
		"scope": "individual",
		"iso6393": "dug",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dungra Bhil",
		"type": "living",
		"scope": "individual",
		"iso6393": "duh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dumun",
		"type": "living",
		"scope": "individual",
		"iso6393": "dui",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Uyajitaya",
		"type": "living",
		"scope": "individual",
		"iso6393": "duk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Alabat Island Agta",
		"type": "living",
		"scope": "individual",
		"iso6393": "dul",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Middle Dutch (ca. 1050-1350)",
		"type": "historical",
		"scope": "individual",
		"iso6393": "dum",
		"iso6392B": "dum",
		"iso6392T": "dum",
		"iso6391": null
	},
	{
		"name": "Dusun Deyah",
		"type": "living",
		"scope": "individual",
		"iso6393": "dun",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dupaninan Agta",
		"type": "living",
		"scope": "individual",
		"iso6393": "duo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Duano",
		"type": "living",
		"scope": "individual",
		"iso6393": "dup",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dusun Malang",
		"type": "living",
		"scope": "individual",
		"iso6393": "duq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dii",
		"type": "living",
		"scope": "individual",
		"iso6393": "dur",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dumi",
		"type": "living",
		"scope": "individual",
		"iso6393": "dus",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Drung",
		"type": "living",
		"scope": "individual",
		"iso6393": "duu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Duvle",
		"type": "living",
		"scope": "individual",
		"iso6393": "duv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dusun Witu",
		"type": "living",
		"scope": "individual",
		"iso6393": "duw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Duungooma",
		"type": "living",
		"scope": "individual",
		"iso6393": "dux",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dicamay Agta",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "duy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Duli-Gey",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "duz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Duau",
		"type": "living",
		"scope": "individual",
		"iso6393": "dva",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Diri",
		"type": "living",
		"scope": "individual",
		"iso6393": "dwa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dawro",
		"type": "living",
		"scope": "individual",
		"iso6393": "dwr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dutton World Speedwords",
		"type": "constructed",
		"scope": "individual",
		"iso6393": "dws",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dhuwal",
		"type": "living",
		"scope": "individual",
		"iso6393": "dwu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dawawa",
		"type": "living",
		"scope": "individual",
		"iso6393": "dww",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dhuwaya",
		"type": "living",
		"scope": "individual",
		"iso6393": "dwy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dyan",
		"type": "living",
		"scope": "individual",
		"iso6393": "dya",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dyaberdyaber",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "dyb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dyugun",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "dyd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Villa Viciosa Agta",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "dyg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Djimini Senoufo",
		"type": "living",
		"scope": "individual",
		"iso6393": "dyi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yanda Dom Dogon",
		"type": "living",
		"scope": "individual",
		"iso6393": "dym",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dyangadi",
		"type": "living",
		"scope": "individual",
		"iso6393": "dyn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jola-Fonyi",
		"type": "living",
		"scope": "individual",
		"iso6393": "dyo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dyula",
		"type": "living",
		"scope": "individual",
		"iso6393": "dyu",
		"iso6392B": "dyu",
		"iso6392T": "dyu",
		"iso6391": null
	},
	{
		"name": "Dyaabugay",
		"type": "living",
		"scope": "individual",
		"iso6393": "dyy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tunzu",
		"type": "living",
		"scope": "individual",
		"iso6393": "dza",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Djiwarli",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "dze",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dazaga",
		"type": "living",
		"scope": "individual",
		"iso6393": "dzg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dzalakha",
		"type": "living",
		"scope": "individual",
		"iso6393": "dzl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dzando",
		"type": "living",
		"scope": "individual",
		"iso6393": "dzn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dzongkha",
		"type": "living",
		"scope": "individual",
		"iso6393": "dzo",
		"iso6392B": "dzo",
		"iso6392T": "dzo",
		"iso6391": "dz"
	},
	{
		"name": "Karenggapa",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "eaa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ebughu",
		"type": "living",
		"scope": "individual",
		"iso6393": "ebg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Bontok",
		"type": "living",
		"scope": "individual",
		"iso6393": "ebk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Teke-Ebo",
		"type": "living",
		"scope": "individual",
		"iso6393": "ebo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ebrié",
		"type": "living",
		"scope": "individual",
		"iso6393": "ebr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Embu",
		"type": "living",
		"scope": "individual",
		"iso6393": "ebu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eteocretan",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "ecr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ecuadorian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "ecs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eteocypriot",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "ecy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "E",
		"type": "living",
		"scope": "individual",
		"iso6393": "eee",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Efai",
		"type": "living",
		"scope": "individual",
		"iso6393": "efa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Efe",
		"type": "living",
		"scope": "individual",
		"iso6393": "efe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Efik",
		"type": "living",
		"scope": "individual",
		"iso6393": "efi",
		"iso6392B": "efi",
		"iso6392T": "efi",
		"iso6391": null
	},
	{
		"name": "Ega",
		"type": "living",
		"scope": "individual",
		"iso6393": "ega",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Emilian",
		"type": "living",
		"scope": "individual",
		"iso6393": "egl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eggon",
		"type": "living",
		"scope": "individual",
		"iso6393": "ego",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Egyptian (Ancient)",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "egy",
		"iso6392B": "egy",
		"iso6392T": "egy",
		"iso6391": null
	},
	{
		"name": "Ehueun",
		"type": "living",
		"scope": "individual",
		"iso6393": "ehu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eipomek",
		"type": "living",
		"scope": "individual",
		"iso6393": "eip",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eitiep",
		"type": "living",
		"scope": "individual",
		"iso6393": "eit",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Askopan",
		"type": "living",
		"scope": "individual",
		"iso6393": "eiv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ejamat",
		"type": "living",
		"scope": "individual",
		"iso6393": "eja",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ekajuk",
		"type": "living",
		"scope": "individual",
		"iso6393": "eka",
		"iso6392B": "eka",
		"iso6392T": "eka",
		"iso6391": null
	},
	{
		"name": "Eastern Karnic",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ekc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ekit",
		"type": "living",
		"scope": "individual",
		"iso6393": "eke",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ekari",
		"type": "living",
		"scope": "individual",
		"iso6393": "ekg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eki",
		"type": "living",
		"scope": "individual",
		"iso6393": "eki",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Standard Estonian",
		"type": "living",
		"scope": "individual",
		"iso6393": "ekk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kol (Bangladesh)",
		"type": "living",
		"scope": "individual",
		"iso6393": "ekl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Elip",
		"type": "living",
		"scope": "individual",
		"iso6393": "ekm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koti",
		"type": "living",
		"scope": "individual",
		"iso6393": "eko",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ekpeye",
		"type": "living",
		"scope": "individual",
		"iso6393": "ekp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yace",
		"type": "living",
		"scope": "individual",
		"iso6393": "ekr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Kayah",
		"type": "living",
		"scope": "individual",
		"iso6393": "eky",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Elepi",
		"type": "living",
		"scope": "individual",
		"iso6393": "ele",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "El Hugeirat",
		"type": "living",
		"scope": "individual",
		"iso6393": "elh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nding",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "eli",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Elkei",
		"type": "living",
		"scope": "individual",
		"iso6393": "elk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Modern Greek (1453-)",
		"type": "living",
		"scope": "individual",
		"iso6393": "ell",
		"iso6392B": "gre",
		"iso6392T": "ell",
		"iso6391": "el"
	},
	{
		"name": "Eleme",
		"type": "living",
		"scope": "individual",
		"iso6393": "elm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "El Molo",
		"type": "living",
		"scope": "individual",
		"iso6393": "elo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Elu",
		"type": "living",
		"scope": "individual",
		"iso6393": "elu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Elamite",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "elx",
		"iso6392B": "elx",
		"iso6392T": "elx",
		"iso6391": null
	},
	{
		"name": "Emai-Iuleha-Ora",
		"type": "living",
		"scope": "individual",
		"iso6393": "ema",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Embaloh",
		"type": "living",
		"scope": "individual",
		"iso6393": "emb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Emerillon",
		"type": "living",
		"scope": "individual",
		"iso6393": "eme",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Meohang",
		"type": "living",
		"scope": "individual",
		"iso6393": "emg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mussau-Emira",
		"type": "living",
		"scope": "individual",
		"iso6393": "emi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Maninkakan",
		"type": "living",
		"scope": "individual",
		"iso6393": "emk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mamulique",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "emm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eman",
		"type": "living",
		"scope": "individual",
		"iso6393": "emn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Emberá",
		"type": "living",
		"scope": "individual",
		"iso6393": "emp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pacific Gulf Yupik",
		"type": "living",
		"scope": "individual",
		"iso6393": "ems",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Muria",
		"type": "living",
		"scope": "individual",
		"iso6393": "emu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Emplawas",
		"type": "living",
		"scope": "individual",
		"iso6393": "emw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Erromintxela",
		"type": "living",
		"scope": "individual",
		"iso6393": "emx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Epigraphic Mayan",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "emy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Apali",
		"type": "living",
		"scope": "individual",
		"iso6393": "ena",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Markweeta",
		"type": "living",
		"scope": "individual",
		"iso6393": "enb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "En",
		"type": "living",
		"scope": "individual",
		"iso6393": "enc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ende",
		"type": "living",
		"scope": "individual",
		"iso6393": "end",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Forest Enets",
		"type": "living",
		"scope": "individual",
		"iso6393": "enf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "English",
		"type": "living",
		"scope": "individual",
		"iso6393": "eng",
		"iso6392B": "eng",
		"iso6392T": "eng",
		"iso6391": "en"
	},
	{
		"name": "Tundra Enets",
		"type": "living",
		"scope": "individual",
		"iso6393": "enh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Enlhet",
		"type": "living",
		"scope": "individual",
		"iso6393": "enl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Middle English (1100-1500)",
		"type": "historical",
		"scope": "individual",
		"iso6393": "enm",
		"iso6392B": "enm",
		"iso6392T": "enm",
		"iso6391": null
	},
	{
		"name": "Engenni",
		"type": "living",
		"scope": "individual",
		"iso6393": "enn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Enggano",
		"type": "living",
		"scope": "individual",
		"iso6393": "eno",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Enga",
		"type": "living",
		"scope": "individual",
		"iso6393": "enq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Emumu",
		"type": "living",
		"scope": "individual",
		"iso6393": "enr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Enu",
		"type": "living",
		"scope": "individual",
		"iso6393": "enu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Enwan (Edu State)",
		"type": "living",
		"scope": "individual",
		"iso6393": "env",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Enwan (Akwa Ibom State)",
		"type": "living",
		"scope": "individual",
		"iso6393": "enw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Enxet",
		"type": "living",
		"scope": "individual",
		"iso6393": "enx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Beti (Côte d'Ivoire)",
		"type": "living",
		"scope": "individual",
		"iso6393": "eot",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Epie",
		"type": "living",
		"scope": "individual",
		"iso6393": "epi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Esperanto",
		"type": "constructed",
		"scope": "individual",
		"iso6393": "epo",
		"iso6392B": "epo",
		"iso6392T": "epo",
		"iso6391": "eo"
	},
	{
		"name": "Eravallan",
		"type": "living",
		"scope": "individual",
		"iso6393": "era",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sie",
		"type": "living",
		"scope": "individual",
		"iso6393": "erg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eruwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "erh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ogea",
		"type": "living",
		"scope": "individual",
		"iso6393": "eri",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "South Efate",
		"type": "living",
		"scope": "individual",
		"iso6393": "erk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Horpa",
		"type": "living",
		"scope": "individual",
		"iso6393": "ero",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Erre",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "err",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ersu",
		"type": "living",
		"scope": "individual",
		"iso6393": "ers",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eritai",
		"type": "living",
		"scope": "individual",
		"iso6393": "ert",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Erokwanas",
		"type": "living",
		"scope": "individual",
		"iso6393": "erw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ese Ejja",
		"type": "living",
		"scope": "individual",
		"iso6393": "ese",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aheri Gondi",
		"type": "living",
		"scope": "individual",
		"iso6393": "esg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eshtehardi",
		"type": "living",
		"scope": "individual",
		"iso6393": "esh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "North Alaskan Inupiatun",
		"type": "living",
		"scope": "individual",
		"iso6393": "esi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northwest Alaska Inupiatun",
		"type": "living",
		"scope": "individual",
		"iso6393": "esk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Egypt Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "esl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Esuma",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "esm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Salvadoran Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "esn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Estonian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "eso",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Esselen",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "esq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Central Siberian Yupik",
		"type": "living",
		"scope": "individual",
		"iso6393": "ess",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Estonian",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "est",
		"iso6392B": "est",
		"iso6392T": "est",
		"iso6391": "et"
	},
	{
		"name": "Central Yupik",
		"type": "living",
		"scope": "individual",
		"iso6393": "esu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eskayan",
		"type": "living",
		"scope": "individual",
		"iso6393": "esy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Etebi",
		"type": "living",
		"scope": "individual",
		"iso6393": "etb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Etchemin",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "etc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ethiopian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "eth",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eton (Vanuatu)",
		"type": "living",
		"scope": "individual",
		"iso6393": "etn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eton (Cameroon)",
		"type": "living",
		"scope": "individual",
		"iso6393": "eto",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Edolo",
		"type": "living",
		"scope": "individual",
		"iso6393": "etr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yekhee",
		"type": "living",
		"scope": "individual",
		"iso6393": "ets",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Etruscan",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "ett",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ejagham",
		"type": "living",
		"scope": "individual",
		"iso6393": "etu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eten",
		"type": "living",
		"scope": "individual",
		"iso6393": "etx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Semimi",
		"type": "living",
		"scope": "individual",
		"iso6393": "etz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Basque",
		"type": "living",
		"scope": "individual",
		"iso6393": "eus",
		"iso6392B": "baq",
		"iso6392T": "eus",
		"iso6391": "eu"
	},
	{
		"name": "Even",
		"type": "living",
		"scope": "individual",
		"iso6393": "eve",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Uvbie",
		"type": "living",
		"scope": "individual",
		"iso6393": "evh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Evenki",
		"type": "living",
		"scope": "individual",
		"iso6393": "evn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ewe",
		"type": "living",
		"scope": "individual",
		"iso6393": "ewe",
		"iso6392B": "ewe",
		"iso6392T": "ewe",
		"iso6391": "ee"
	},
	{
		"name": "Ewondo",
		"type": "living",
		"scope": "individual",
		"iso6393": "ewo",
		"iso6392B": "ewo",
		"iso6392T": "ewo",
		"iso6391": null
	},
	{
		"name": "Extremaduran",
		"type": "living",
		"scope": "individual",
		"iso6393": "ext",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eyak",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "eya",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Keiyo",
		"type": "living",
		"scope": "individual",
		"iso6393": "eyo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ezaa",
		"type": "living",
		"scope": "individual",
		"iso6393": "eza",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Uzekwe",
		"type": "living",
		"scope": "individual",
		"iso6393": "eze",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Fasu",
		"type": "living",
		"scope": "individual",
		"iso6393": "faa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Fa d'Ambu",
		"type": "living",
		"scope": "individual",
		"iso6393": "fab",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wagi",
		"type": "living",
		"scope": "individual",
		"iso6393": "fad",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Fagani",
		"type": "living",
		"scope": "individual",
		"iso6393": "faf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Finongan",
		"type": "living",
		"scope": "individual",
		"iso6393": "fag",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baissa Fali",
		"type": "living",
		"scope": "individual",
		"iso6393": "fah",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Faiwol",
		"type": "living",
		"scope": "individual",
		"iso6393": "fai",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Faita",
		"type": "living",
		"scope": "individual",
		"iso6393": "faj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Fang (Cameroon)",
		"type": "living",
		"scope": "individual",
		"iso6393": "fak",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "South Fali",
		"type": "living",
		"scope": "individual",
		"iso6393": "fal",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Fam",
		"type": "living",
		"scope": "individual",
		"iso6393": "fam",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Fang (Equatorial Guinea)",
		"type": "living",
		"scope": "individual",
		"iso6393": "fan",
		"iso6392B": "fan",
		"iso6392T": "fan",
		"iso6391": null
	},
	{
		"name": "Faroese",
		"type": "living",
		"scope": "individual",
		"iso6393": "fao",
		"iso6392B": "fao",
		"iso6392T": "fao",
		"iso6391": "fo"
	},
	{
		"name": "Palor",
		"type": "living",
		"scope": "individual",
		"iso6393": "fap",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Fataleka",
		"type": "living",
		"scope": "individual",
		"iso6393": "far",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Persian",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "fas",
		"iso6392B": "per",
		"iso6392T": "fas",
		"iso6391": "fa"
	},
	{
		"name": "Fanti",
		"type": "living",
		"scope": "individual",
		"iso6393": "fat",
		"iso6392B": "fat",
		"iso6392T": "fat",
		"iso6391": null
	},
	{
		"name": "Fayu",
		"type": "living",
		"scope": "individual",
		"iso6393": "fau",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Fala",
		"type": "living",
		"scope": "individual",
		"iso6393": "fax",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southwestern Fars",
		"type": "living",
		"scope": "individual",
		"iso6393": "fay",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northwestern Fars",
		"type": "living",
		"scope": "individual",
		"iso6393": "faz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "West Albay Bikol",
		"type": "living",
		"scope": "individual",
		"iso6393": "fbl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Quebec Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "fcs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Feroge",
		"type": "living",
		"scope": "individual",
		"iso6393": "fer",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Foia Foia",
		"type": "living",
		"scope": "individual",
		"iso6393": "ffi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maasina Fulfulde",
		"type": "living",
		"scope": "individual",
		"iso6393": "ffm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Fongoro",
		"type": "living",
		"scope": "individual",
		"iso6393": "fgr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nobiin",
		"type": "living",
		"scope": "individual",
		"iso6393": "fia",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Fyer",
		"type": "living",
		"scope": "individual",
		"iso6393": "fie",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Fijian",
		"type": "living",
		"scope": "individual",
		"iso6393": "fij",
		"iso6392B": "fij",
		"iso6392T": "fij",
		"iso6391": "fj"
	},
	{
		"name": "Filipino",
		"type": "living",
		"scope": "individual",
		"iso6393": "fil",
		"iso6392B": "fil",
		"iso6392T": "fil",
		"iso6391": null
	},
	{
		"name": "Finnish",
		"type": "living",
		"scope": "individual",
		"iso6393": "fin",
		"iso6392B": "fin",
		"iso6392T": "fin",
		"iso6391": "fi"
	},
	{
		"name": "Fipa",
		"type": "living",
		"scope": "individual",
		"iso6393": "fip",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Firan",
		"type": "living",
		"scope": "individual",
		"iso6393": "fir",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tornedalen Finnish",
		"type": "living",
		"scope": "individual",
		"iso6393": "fit",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Fiwaga",
		"type": "living",
		"scope": "individual",
		"iso6393": "fiw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kirya-Konzəl",
		"type": "living",
		"scope": "individual",
		"iso6393": "fkk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kven Finnish",
		"type": "living",
		"scope": "individual",
		"iso6393": "fkv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kalispel-Pend d'Oreille",
		"type": "living",
		"scope": "individual",
		"iso6393": "fla",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Foau",
		"type": "living",
		"scope": "individual",
		"iso6393": "flh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Fali",
		"type": "living",
		"scope": "individual",
		"iso6393": "fli",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "North Fali",
		"type": "living",
		"scope": "individual",
		"iso6393": "fll",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Flinders Island",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "fln",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Fuliiru",
		"type": "living",
		"scope": "individual",
		"iso6393": "flr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Flaaitaal",
		"type": "living",
		"scope": "individual",
		"iso6393": "fly",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Fe'fe'",
		"type": "living",
		"scope": "individual",
		"iso6393": "fmp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Far Western Muria",
		"type": "living",
		"scope": "individual",
		"iso6393": "fmu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Fanbak",
		"type": "living",
		"scope": "individual",
		"iso6393": "fnb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Fanagalo",
		"type": "living",
		"scope": "individual",
		"iso6393": "fng",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Fania",
		"type": "living",
		"scope": "individual",
		"iso6393": "fni",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Foodo",
		"type": "living",
		"scope": "individual",
		"iso6393": "fod",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Foi",
		"type": "living",
		"scope": "individual",
		"iso6393": "foi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Foma",
		"type": "living",
		"scope": "individual",
		"iso6393": "fom",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Fon",
		"type": "living",
		"scope": "individual",
		"iso6393": "fon",
		"iso6392B": "fon",
		"iso6392T": "fon",
		"iso6391": null
	},
	{
		"name": "Fore",
		"type": "living",
		"scope": "individual",
		"iso6393": "for",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Siraya",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "fos",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Fernando Po Creole English",
		"type": "living",
		"scope": "individual",
		"iso6393": "fpe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Fas",
		"type": "living",
		"scope": "individual",
		"iso6393": "fqs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "French",
		"type": "living",
		"scope": "individual",
		"iso6393": "fra",
		"iso6392B": "fre",
		"iso6392T": "fra",
		"iso6391": "fr"
	},
	{
		"name": "Cajun French",
		"type": "living",
		"scope": "individual",
		"iso6393": "frc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Fordata",
		"type": "living",
		"scope": "individual",
		"iso6393": "frd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Frankish",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "frk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Middle French (ca. 1400-1600)",
		"type": "historical",
		"scope": "individual",
		"iso6393": "frm",
		"iso6392B": "frm",
		"iso6392T": "frm",
		"iso6391": null
	},
	{
		"name": "Old French (842-ca. 1400)",
		"type": "historical",
		"scope": "individual",
		"iso6393": "fro",
		"iso6392B": "fro",
		"iso6392T": "fro",
		"iso6391": null
	},
	{
		"name": "Arpitan",
		"type": "living",
		"scope": "individual",
		"iso6393": "frp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Forak",
		"type": "living",
		"scope": "individual",
		"iso6393": "frq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Frisian",
		"type": "living",
		"scope": "individual",
		"iso6393": "frr",
		"iso6392B": "frr",
		"iso6392T": "frr",
		"iso6391": null
	},
	{
		"name": "Eastern Frisian",
		"type": "living",
		"scope": "individual",
		"iso6393": "frs",
		"iso6392B": "frs",
		"iso6392T": "frs",
		"iso6391": null
	},
	{
		"name": "Fortsenal",
		"type": "living",
		"scope": "individual",
		"iso6393": "frt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Frisian",
		"type": "living",
		"scope": "individual",
		"iso6393": "fry",
		"iso6392B": "fry",
		"iso6392T": "fry",
		"iso6391": "fy"
	},
	{
		"name": "Finnish Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "fse",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "French Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "fsl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Finland-Swedish Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "fss",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Adamawa Fulfulde",
		"type": "living",
		"scope": "individual",
		"iso6393": "fub",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pulaar",
		"type": "living",
		"scope": "individual",
		"iso6393": "fuc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "East Futuna",
		"type": "living",
		"scope": "individual",
		"iso6393": "fud",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Borgu Fulfulde",
		"type": "living",
		"scope": "individual",
		"iso6393": "fue",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pular",
		"type": "living",
		"scope": "individual",
		"iso6393": "fuf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Niger Fulfulde",
		"type": "living",
		"scope": "individual",
		"iso6393": "fuh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bagirmi Fulfulde",
		"type": "living",
		"scope": "individual",
		"iso6393": "fui",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ko",
		"type": "living",
		"scope": "individual",
		"iso6393": "fuj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Fulah",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "ful",
		"iso6392B": "ful",
		"iso6392T": "ful",
		"iso6391": "ff"
	},
	{
		"name": "Fum",
		"type": "living",
		"scope": "individual",
		"iso6393": "fum",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Fulniô",
		"type": "living",
		"scope": "individual",
		"iso6393": "fun",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Central-Eastern Niger Fulfulde",
		"type": "living",
		"scope": "individual",
		"iso6393": "fuq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Friulian",
		"type": "living",
		"scope": "individual",
		"iso6393": "fur",
		"iso6392B": "fur",
		"iso6392T": "fur",
		"iso6391": null
	},
	{
		"name": "Futuna-Aniwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "fut",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Furu",
		"type": "living",
		"scope": "individual",
		"iso6393": "fuu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nigerian Fulfulde",
		"type": "living",
		"scope": "individual",
		"iso6393": "fuv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Fuyug",
		"type": "living",
		"scope": "individual",
		"iso6393": "fuy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Fur",
		"type": "living",
		"scope": "individual",
		"iso6393": "fvr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Fwâi",
		"type": "living",
		"scope": "individual",
		"iso6393": "fwa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Fwe",
		"type": "living",
		"scope": "individual",
		"iso6393": "fwe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ga",
		"type": "living",
		"scope": "individual",
		"iso6393": "gaa",
		"iso6392B": "gaa",
		"iso6392T": "gaa",
		"iso6391": null
	},
	{
		"name": "Gabri",
		"type": "living",
		"scope": "individual",
		"iso6393": "gab",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mixed Great Andamanese",
		"type": "living",
		"scope": "individual",
		"iso6393": "gac",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gaddang",
		"type": "living",
		"scope": "individual",
		"iso6393": "gad",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Guarequena",
		"type": "living",
		"scope": "individual",
		"iso6393": "gae",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gende",
		"type": "living",
		"scope": "individual",
		"iso6393": "gaf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gagauz",
		"type": "living",
		"scope": "individual",
		"iso6393": "gag",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Alekano",
		"type": "living",
		"scope": "individual",
		"iso6393": "gah",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Borei",
		"type": "living",
		"scope": "individual",
		"iso6393": "gai",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gadsup",
		"type": "living",
		"scope": "individual",
		"iso6393": "gaj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gamkonora",
		"type": "living",
		"scope": "individual",
		"iso6393": "gak",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Galolen",
		"type": "living",
		"scope": "individual",
		"iso6393": "gal",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kandawo",
		"type": "living",
		"scope": "individual",
		"iso6393": "gam",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gan Chinese",
		"type": "living",
		"scope": "individual",
		"iso6393": "gan",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gants",
		"type": "living",
		"scope": "individual",
		"iso6393": "gao",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gal",
		"type": "living",
		"scope": "individual",
		"iso6393": "gap",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gata'",
		"type": "living",
		"scope": "individual",
		"iso6393": "gaq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Galeya",
		"type": "living",
		"scope": "individual",
		"iso6393": "gar",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Adiwasi Garasia",
		"type": "living",
		"scope": "individual",
		"iso6393": "gas",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kenati",
		"type": "living",
		"scope": "individual",
		"iso6393": "gat",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mudhili Gadaba",
		"type": "living",
		"scope": "individual",
		"iso6393": "gau",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nobonob",
		"type": "living",
		"scope": "individual",
		"iso6393": "gaw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Borana-Arsi-Guji Oromo",
		"type": "living",
		"scope": "individual",
		"iso6393": "gax",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gayo",
		"type": "living",
		"scope": "individual",
		"iso6393": "gay",
		"iso6392B": "gay",
		"iso6392T": "gay",
		"iso6391": null
	},
	{
		"name": "West Central Oromo",
		"type": "living",
		"scope": "individual",
		"iso6393": "gaz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gbaya (Central African Republic)",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "gba",
		"iso6392B": "gba",
		"iso6392T": "gba",
		"iso6391": null
	},
	{
		"name": "Kaytetye",
		"type": "living",
		"scope": "individual",
		"iso6393": "gbb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Karadjeri",
		"type": "living",
		"scope": "individual",
		"iso6393": "gbd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Niksek",
		"type": "living",
		"scope": "individual",
		"iso6393": "gbe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gaikundi",
		"type": "living",
		"scope": "individual",
		"iso6393": "gbf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gbanziri",
		"type": "living",
		"scope": "individual",
		"iso6393": "gbg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Defi Gbe",
		"type": "living",
		"scope": "individual",
		"iso6393": "gbh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Galela",
		"type": "living",
		"scope": "individual",
		"iso6393": "gbi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bodo Gadaba",
		"type": "living",
		"scope": "individual",
		"iso6393": "gbj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gaddi",
		"type": "living",
		"scope": "individual",
		"iso6393": "gbk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gamit",
		"type": "living",
		"scope": "individual",
		"iso6393": "gbl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Garhwali",
		"type": "living",
		"scope": "individual",
		"iso6393": "gbm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mo'da",
		"type": "living",
		"scope": "individual",
		"iso6393": "gbn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Grebo",
		"type": "living",
		"scope": "individual",
		"iso6393": "gbo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gbaya-Bossangoa",
		"type": "living",
		"scope": "individual",
		"iso6393": "gbp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gbaya-Bozoum",
		"type": "living",
		"scope": "individual",
		"iso6393": "gbq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gbagyi",
		"type": "living",
		"scope": "individual",
		"iso6393": "gbr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gbesi Gbe",
		"type": "living",
		"scope": "individual",
		"iso6393": "gbs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gagadu",
		"type": "living",
		"scope": "individual",
		"iso6393": "gbu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gbanu",
		"type": "living",
		"scope": "individual",
		"iso6393": "gbv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gabi-Gabi",
		"type": "living",
		"scope": "individual",
		"iso6393": "gbw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Xwla Gbe",
		"type": "living",
		"scope": "individual",
		"iso6393": "gbx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gbari",
		"type": "living",
		"scope": "individual",
		"iso6393": "gby",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zoroastrian Dari",
		"type": "living",
		"scope": "individual",
		"iso6393": "gbz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mali",
		"type": "living",
		"scope": "individual",
		"iso6393": "gcc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ganggalida",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "gcd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Galice",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "gce",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Guadeloupean Creole French",
		"type": "living",
		"scope": "individual",
		"iso6393": "gcf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Grenadian Creole English",
		"type": "living",
		"scope": "individual",
		"iso6393": "gcl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gaina",
		"type": "living",
		"scope": "individual",
		"iso6393": "gcn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Guianese Creole French",
		"type": "living",
		"scope": "individual",
		"iso6393": "gcr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Colonia Tovar German",
		"type": "living",
		"scope": "individual",
		"iso6393": "gct",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gade Lohar",
		"type": "living",
		"scope": "individual",
		"iso6393": "gda",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pottangi Ollar Gadaba",
		"type": "living",
		"scope": "individual",
		"iso6393": "gdb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gugu Badhun",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "gdc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gedaged",
		"type": "living",
		"scope": "individual",
		"iso6393": "gdd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gude",
		"type": "living",
		"scope": "individual",
		"iso6393": "gde",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Guduf-Gava",
		"type": "living",
		"scope": "individual",
		"iso6393": "gdf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ga'dang",
		"type": "living",
		"scope": "individual",
		"iso6393": "gdg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gadjerawang",
		"type": "living",
		"scope": "individual",
		"iso6393": "gdh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gundi",
		"type": "living",
		"scope": "individual",
		"iso6393": "gdi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gurdjar",
		"type": "living",
		"scope": "individual",
		"iso6393": "gdj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gadang",
		"type": "living",
		"scope": "individual",
		"iso6393": "gdk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dirasha",
		"type": "living",
		"scope": "individual",
		"iso6393": "gdl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Laal",
		"type": "living",
		"scope": "individual",
		"iso6393": "gdm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Umanakaina",
		"type": "living",
		"scope": "individual",
		"iso6393": "gdn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ghodoberi",
		"type": "living",
		"scope": "individual",
		"iso6393": "gdo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mehri",
		"type": "living",
		"scope": "individual",
		"iso6393": "gdq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wipi",
		"type": "living",
		"scope": "individual",
		"iso6393": "gdr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ghandruk Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "gds",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kungardutyi",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "gdt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gudu",
		"type": "living",
		"scope": "individual",
		"iso6393": "gdu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Godwari",
		"type": "living",
		"scope": "individual",
		"iso6393": "gdx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Geruma",
		"type": "living",
		"scope": "individual",
		"iso6393": "gea",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kire",
		"type": "living",
		"scope": "individual",
		"iso6393": "geb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gboloo Grebo",
		"type": "living",
		"scope": "individual",
		"iso6393": "gec",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gade",
		"type": "living",
		"scope": "individual",
		"iso6393": "ged",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gengle",
		"type": "living",
		"scope": "individual",
		"iso6393": "geg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hutterite German",
		"type": "living",
		"scope": "individual",
		"iso6393": "geh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gebe",
		"type": "living",
		"scope": "individual",
		"iso6393": "gei",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gen",
		"type": "living",
		"scope": "individual",
		"iso6393": "gej",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ywom",
		"type": "living",
		"scope": "individual",
		"iso6393": "gek",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "ut-Ma'in",
		"type": "living",
		"scope": "individual",
		"iso6393": "gel",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Geme",
		"type": "living",
		"scope": "individual",
		"iso6393": "geq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Geser-Gorom",
		"type": "living",
		"scope": "individual",
		"iso6393": "ges",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eviya",
		"type": "living",
		"scope": "individual",
		"iso6393": "gev",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gera",
		"type": "living",
		"scope": "individual",
		"iso6393": "gew",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Garre",
		"type": "living",
		"scope": "individual",
		"iso6393": "gex",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Enya",
		"type": "living",
		"scope": "individual",
		"iso6393": "gey",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Geez",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "gez",
		"iso6392B": "gez",
		"iso6392T": "gez",
		"iso6391": null
	},
	{
		"name": "Patpatar",
		"type": "living",
		"scope": "individual",
		"iso6393": "gfk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gafat",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "gft",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gao",
		"type": "living",
		"scope": "individual",
		"iso6393": "gga",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gbii",
		"type": "living",
		"scope": "individual",
		"iso6393": "ggb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gugadj",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ggd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Guragone",
		"type": "living",
		"scope": "individual",
		"iso6393": "gge",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gurgula",
		"type": "living",
		"scope": "individual",
		"iso6393": "ggg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kungarakany",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ggk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ganglau",
		"type": "living",
		"scope": "individual",
		"iso6393": "ggl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gitua",
		"type": "living",
		"scope": "individual",
		"iso6393": "ggt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gagu",
		"type": "living",
		"scope": "individual",
		"iso6393": "ggu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gogodala",
		"type": "living",
		"scope": "individual",
		"iso6393": "ggw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ghadamès",
		"type": "living",
		"scope": "individual",
		"iso6393": "gha",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hiberno-Scottish Gaelic",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ghc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Ghale",
		"type": "living",
		"scope": "individual",
		"iso6393": "ghe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Ghale",
		"type": "living",
		"scope": "individual",
		"iso6393": "ghh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Geko Karen",
		"type": "living",
		"scope": "individual",
		"iso6393": "ghk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ghulfan",
		"type": "living",
		"scope": "individual",
		"iso6393": "ghl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ghanongga",
		"type": "living",
		"scope": "individual",
		"iso6393": "ghn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ghomara",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "gho",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ghera",
		"type": "living",
		"scope": "individual",
		"iso6393": "ghr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Guhu-Samane",
		"type": "living",
		"scope": "individual",
		"iso6393": "ghs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kuke",
		"type": "living",
		"scope": "individual",
		"iso6393": "ght",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kitja",
		"type": "living",
		"scope": "individual",
		"iso6393": "gia",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gibanawa",
		"type": "living",
		"scope": "individual",
		"iso6393": "gib",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gail",
		"type": "living",
		"scope": "individual",
		"iso6393": "gic",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gidar",
		"type": "living",
		"scope": "individual",
		"iso6393": "gid",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Goaria",
		"type": "living",
		"scope": "individual",
		"iso6393": "gig",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Githabul",
		"type": "living",
		"scope": "individual",
		"iso6393": "gih",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gilbertese",
		"type": "living",
		"scope": "individual",
		"iso6393": "gil",
		"iso6392B": "gil",
		"iso6392T": "gil",
		"iso6391": null
	},
	{
		"name": "Gimi (Eastern Highlands)",
		"type": "living",
		"scope": "individual",
		"iso6393": "gim",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hinukh",
		"type": "living",
		"scope": "individual",
		"iso6393": "gin",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gimi (West New Britain)",
		"type": "living",
		"scope": "individual",
		"iso6393": "gip",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Green Gelao",
		"type": "living",
		"scope": "individual",
		"iso6393": "giq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Red Gelao",
		"type": "living",
		"scope": "individual",
		"iso6393": "gir",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "North Giziga",
		"type": "living",
		"scope": "individual",
		"iso6393": "gis",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gitxsan",
		"type": "living",
		"scope": "individual",
		"iso6393": "git",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mulao",
		"type": "living",
		"scope": "individual",
		"iso6393": "giu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "White Gelao",
		"type": "living",
		"scope": "individual",
		"iso6393": "giw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gilima",
		"type": "living",
		"scope": "individual",
		"iso6393": "gix",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Giyug",
		"type": "living",
		"scope": "individual",
		"iso6393": "giy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "South Giziga",
		"type": "living",
		"scope": "individual",
		"iso6393": "giz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Geji",
		"type": "living",
		"scope": "individual",
		"iso6393": "gji",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kachi Koli",
		"type": "living",
		"scope": "individual",
		"iso6393": "gjk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gunditjmara",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "gjm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gonja",
		"type": "living",
		"scope": "individual",
		"iso6393": "gjn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gurindji Kriol",
		"type": "living",
		"scope": "individual",
		"iso6393": "gjr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gujari",
		"type": "living",
		"scope": "individual",
		"iso6393": "gju",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Guya",
		"type": "living",
		"scope": "individual",
		"iso6393": "gka",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ndai",
		"type": "living",
		"scope": "individual",
		"iso6393": "gke",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gokana",
		"type": "living",
		"scope": "individual",
		"iso6393": "gkn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kok-Nar",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "gko",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Guinea Kpelle",
		"type": "living",
		"scope": "individual",
		"iso6393": "gkp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "ǂUngkue",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "gku",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Scottish Gaelic",
		"type": "living",
		"scope": "individual",
		"iso6393": "gla",
		"iso6392B": "gla",
		"iso6392T": "gla",
		"iso6391": "gd"
	},
	{
		"name": "Bon Gula",
		"type": "living",
		"scope": "individual",
		"iso6393": "glc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nanai",
		"type": "living",
		"scope": "individual",
		"iso6393": "gld",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Irish",
		"type": "living",
		"scope": "individual",
		"iso6393": "gle",
		"iso6392B": "gle",
		"iso6392T": "gle",
		"iso6391": "ga"
	},
	{
		"name": "Galician",
		"type": "living",
		"scope": "individual",
		"iso6393": "glg",
		"iso6392B": "glg",
		"iso6392T": "glg",
		"iso6391": "gl"
	},
	{
		"name": "Northwest Pashai",
		"type": "living",
		"scope": "individual",
		"iso6393": "glh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Guliguli",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "gli",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gula Iro",
		"type": "living",
		"scope": "individual",
		"iso6393": "glj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gilaki",
		"type": "living",
		"scope": "individual",
		"iso6393": "glk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Garlali",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "gll",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Galambu",
		"type": "living",
		"scope": "individual",
		"iso6393": "glo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Glaro-Twabo",
		"type": "living",
		"scope": "individual",
		"iso6393": "glr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gula (Chad)",
		"type": "living",
		"scope": "individual",
		"iso6393": "glu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Manx",
		"type": "living",
		"scope": "individual",
		"iso6393": "glv",
		"iso6392B": "glv",
		"iso6392T": "glv",
		"iso6391": "gv"
	},
	{
		"name": "Glavda",
		"type": "living",
		"scope": "individual",
		"iso6393": "glw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gule",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "gly",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gambera",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "gma",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gula'alaa",
		"type": "living",
		"scope": "individual",
		"iso6393": "gmb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mághdì",
		"type": "living",
		"scope": "individual",
		"iso6393": "gmd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Magɨyi",
		"type": "living",
		"scope": "individual",
		"iso6393": "gmg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Middle High German (ca. 1050-1500)",
		"type": "historical",
		"scope": "individual",
		"iso6393": "gmh",
		"iso6392B": "gmh",
		"iso6392T": "gmh",
		"iso6391": null
	},
	{
		"name": "Middle Low German",
		"type": "historical",
		"scope": "individual",
		"iso6393": "gml",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gbaya-Mbodomo",
		"type": "living",
		"scope": "individual",
		"iso6393": "gmm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gimnime",
		"type": "living",
		"scope": "individual",
		"iso6393": "gmn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gumalu",
		"type": "living",
		"scope": "individual",
		"iso6393": "gmu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gamo",
		"type": "living",
		"scope": "individual",
		"iso6393": "gmv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Magoma",
		"type": "living",
		"scope": "individual",
		"iso6393": "gmx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mycenaean Greek",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "gmy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mgbolizhia",
		"type": "living",
		"scope": "individual",
		"iso6393": "gmz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kaansa",
		"type": "living",
		"scope": "individual",
		"iso6393": "gna",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gangte",
		"type": "living",
		"scope": "individual",
		"iso6393": "gnb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Guanche",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "gnc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zulgo-Gemzek",
		"type": "living",
		"scope": "individual",
		"iso6393": "gnd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ganang",
		"type": "living",
		"scope": "individual",
		"iso6393": "gne",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngangam",
		"type": "living",
		"scope": "individual",
		"iso6393": "gng",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lere",
		"type": "living",
		"scope": "individual",
		"iso6393": "gnh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gooniyandi",
		"type": "living",
		"scope": "individual",
		"iso6393": "gni",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "//Gana",
		"type": "living",
		"scope": "individual",
		"iso6393": "gnk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gangulu",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "gnl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ginuman",
		"type": "living",
		"scope": "individual",
		"iso6393": "gnm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gumatj",
		"type": "living",
		"scope": "individual",
		"iso6393": "gnn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Gondi",
		"type": "living",
		"scope": "individual",
		"iso6393": "gno",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gana",
		"type": "living",
		"scope": "individual",
		"iso6393": "gnq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gureng Gureng",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "gnr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Guntai",
		"type": "living",
		"scope": "individual",
		"iso6393": "gnt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gnau",
		"type": "living",
		"scope": "individual",
		"iso6393": "gnu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Bolivian Guaraní",
		"type": "living",
		"scope": "individual",
		"iso6393": "gnw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ganzi",
		"type": "living",
		"scope": "individual",
		"iso6393": "gnz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Guro",
		"type": "living",
		"scope": "individual",
		"iso6393": "goa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Playero",
		"type": "living",
		"scope": "individual",
		"iso6393": "gob",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gorakor",
		"type": "living",
		"scope": "individual",
		"iso6393": "goc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Godié",
		"type": "living",
		"scope": "individual",
		"iso6393": "god",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gongduk",
		"type": "living",
		"scope": "individual",
		"iso6393": "goe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gofa",
		"type": "living",
		"scope": "individual",
		"iso6393": "gof",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gogo",
		"type": "living",
		"scope": "individual",
		"iso6393": "gog",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Old High German (ca. 750-1050)",
		"type": "historical",
		"scope": "individual",
		"iso6393": "goh",
		"iso6392B": "goh",
		"iso6392T": "goh",
		"iso6391": null
	},
	{
		"name": "Gobasi",
		"type": "living",
		"scope": "individual",
		"iso6393": "goi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gowlan",
		"type": "living",
		"scope": "individual",
		"iso6393": "goj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gowli",
		"type": "living",
		"scope": "individual",
		"iso6393": "gok",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gola",
		"type": "living",
		"scope": "individual",
		"iso6393": "gol",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Goan Konkani",
		"type": "living",
		"scope": "individual",
		"iso6393": "gom",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gondi",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "gon",
		"iso6392B": "gon",
		"iso6392T": "gon",
		"iso6391": null
	},
	{
		"name": "Gone Dau",
		"type": "living",
		"scope": "individual",
		"iso6393": "goo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yeretuar",
		"type": "living",
		"scope": "individual",
		"iso6393": "gop",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gorap",
		"type": "living",
		"scope": "individual",
		"iso6393": "goq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gorontalo",
		"type": "living",
		"scope": "individual",
		"iso6393": "gor",
		"iso6392B": "gor",
		"iso6392T": "gor",
		"iso6391": null
	},
	{
		"name": "Gronings",
		"type": "living",
		"scope": "individual",
		"iso6393": "gos",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gothic",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "got",
		"iso6392B": "got",
		"iso6392T": "got",
		"iso6391": null
	},
	{
		"name": "Gavar",
		"type": "living",
		"scope": "individual",
		"iso6393": "gou",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gorowa",
		"type": "living",
		"scope": "individual",
		"iso6393": "gow",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gobu",
		"type": "living",
		"scope": "individual",
		"iso6393": "gox",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Goundo",
		"type": "living",
		"scope": "individual",
		"iso6393": "goy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gozarkhani",
		"type": "living",
		"scope": "individual",
		"iso6393": "goz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gupa-Abawa",
		"type": "living",
		"scope": "individual",
		"iso6393": "gpa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ghanaian Pidgin English",
		"type": "living",
		"scope": "individual",
		"iso6393": "gpe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Taiap",
		"type": "living",
		"scope": "individual",
		"iso6393": "gpn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ga'anda",
		"type": "living",
		"scope": "individual",
		"iso6393": "gqa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Guiqiong",
		"type": "living",
		"scope": "individual",
		"iso6393": "gqi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Guana (Brazil)",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "gqn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gor",
		"type": "living",
		"scope": "individual",
		"iso6393": "gqr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Qau",
		"type": "living",
		"scope": "individual",
		"iso6393": "gqu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rajput Garasia",
		"type": "living",
		"scope": "individual",
		"iso6393": "gra",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Grebo",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "grb",
		"iso6392B": "grb",
		"iso6392T": "grb",
		"iso6391": null
	},
	{
		"name": "Ancient Greek (to 1453)",
		"type": "historical",
		"scope": "individual",
		"iso6393": "grc",
		"iso6392B": "grc",
		"iso6392T": "grc",
		"iso6391": null
	},
	{
		"name": "Guruntum-Mbaaru",
		"type": "living",
		"scope": "individual",
		"iso6393": "grd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Madi",
		"type": "living",
		"scope": "individual",
		"iso6393": "grg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gbiri-Niragu",
		"type": "living",
		"scope": "individual",
		"iso6393": "grh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ghari",
		"type": "living",
		"scope": "individual",
		"iso6393": "gri",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Grebo",
		"type": "living",
		"scope": "individual",
		"iso6393": "grj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kota Marudu Talantang",
		"type": "living",
		"scope": "individual",
		"iso6393": "grm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Guarani",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "grn",
		"iso6392B": "grn",
		"iso6392T": "grn",
		"iso6391": "gn"
	},
	{
		"name": "Groma",
		"type": "living",
		"scope": "individual",
		"iso6393": "gro",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gorovu",
		"type": "living",
		"scope": "individual",
		"iso6393": "grq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Taznatit",
		"type": "living",
		"scope": "individual",
		"iso6393": "grr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gresi",
		"type": "living",
		"scope": "individual",
		"iso6393": "grs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Garo",
		"type": "living",
		"scope": "individual",
		"iso6393": "grt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kistane",
		"type": "living",
		"scope": "individual",
		"iso6393": "gru",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Central Grebo",
		"type": "living",
		"scope": "individual",
		"iso6393": "grv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gweda",
		"type": "living",
		"scope": "individual",
		"iso6393": "grw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Guriaso",
		"type": "living",
		"scope": "individual",
		"iso6393": "grx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Barclayville Grebo",
		"type": "living",
		"scope": "individual",
		"iso6393": "gry",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Guramalum",
		"type": "living",
		"scope": "individual",
		"iso6393": "grz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ghanaian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "gse",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "German Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "gsg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gusilay",
		"type": "living",
		"scope": "individual",
		"iso6393": "gsl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Guatemalan Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "gsm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nema",
		"type": "living",
		"scope": "individual",
		"iso6393": "gsn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southwest Gbaya",
		"type": "living",
		"scope": "individual",
		"iso6393": "gso",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wasembo",
		"type": "living",
		"scope": "individual",
		"iso6393": "gsp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Greek Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "gss",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Swiss German",
		"type": "living",
		"scope": "individual",
		"iso6393": "gsw",
		"iso6392B": "gsw",
		"iso6392T": "gsw",
		"iso6391": null
	},
	{
		"name": "Guató",
		"type": "living",
		"scope": "individual",
		"iso6393": "gta",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aghu-Tharnggala",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "gtu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shiki",
		"type": "living",
		"scope": "individual",
		"iso6393": "gua",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Guajajára",
		"type": "living",
		"scope": "individual",
		"iso6393": "gub",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wayuu",
		"type": "living",
		"scope": "individual",
		"iso6393": "guc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yocoboué Dida",
		"type": "living",
		"scope": "individual",
		"iso6393": "gud",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gurinji",
		"type": "living",
		"scope": "individual",
		"iso6393": "gue",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gupapuyngu",
		"type": "living",
		"scope": "individual",
		"iso6393": "guf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Paraguayan Guaraní",
		"type": "living",
		"scope": "individual",
		"iso6393": "gug",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Guahibo",
		"type": "living",
		"scope": "individual",
		"iso6393": "guh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Bolivian Guaraní",
		"type": "living",
		"scope": "individual",
		"iso6393": "gui",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gujarati",
		"type": "living",
		"scope": "individual",
		"iso6393": "guj",
		"iso6392B": "guj",
		"iso6392T": "guj",
		"iso6391": "gu"
	},
	{
		"name": "Gumuz",
		"type": "living",
		"scope": "individual",
		"iso6393": "guk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sea Island Creole English",
		"type": "living",
		"scope": "individual",
		"iso6393": "gul",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Guambiano",
		"type": "living",
		"scope": "individual",
		"iso6393": "gum",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mbyá Guaraní",
		"type": "living",
		"scope": "individual",
		"iso6393": "gun",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Guayabero",
		"type": "living",
		"scope": "individual",
		"iso6393": "guo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gunwinggu",
		"type": "living",
		"scope": "individual",
		"iso6393": "gup",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aché",
		"type": "living",
		"scope": "individual",
		"iso6393": "guq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Farefare",
		"type": "living",
		"scope": "individual",
		"iso6393": "gur",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Guinean Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "gus",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maléku Jaíka",
		"type": "living",
		"scope": "individual",
		"iso6393": "gut",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yanomamö",
		"type": "living",
		"scope": "individual",
		"iso6393": "guu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gun",
		"type": "living",
		"scope": "individual",
		"iso6393": "guw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gourmanchéma",
		"type": "living",
		"scope": "individual",
		"iso6393": "gux",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gusii",
		"type": "living",
		"scope": "individual",
		"iso6393": "guz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Guana (Paraguay)",
		"type": "living",
		"scope": "individual",
		"iso6393": "gva",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Guanano",
		"type": "living",
		"scope": "individual",
		"iso6393": "gvc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Duwet",
		"type": "living",
		"scope": "individual",
		"iso6393": "gve",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Golin",
		"type": "living",
		"scope": "individual",
		"iso6393": "gvf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Guajá",
		"type": "living",
		"scope": "individual",
		"iso6393": "gvj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gulay",
		"type": "living",
		"scope": "individual",
		"iso6393": "gvl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gurmana",
		"type": "living",
		"scope": "individual",
		"iso6393": "gvm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kuku-Yalanji",
		"type": "living",
		"scope": "individual",
		"iso6393": "gvn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gavião Do Jiparaná",
		"type": "living",
		"scope": "individual",
		"iso6393": "gvo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pará Gavião",
		"type": "living",
		"scope": "individual",
		"iso6393": "gvp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gurung",
		"type": "living",
		"scope": "individual",
		"iso6393": "gvr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gumawana",
		"type": "living",
		"scope": "individual",
		"iso6393": "gvs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Guyani",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "gvy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mbato",
		"type": "living",
		"scope": "individual",
		"iso6393": "gwa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "gwb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kalami",
		"type": "living",
		"scope": "individual",
		"iso6393": "gwc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gawwada",
		"type": "living",
		"scope": "individual",
		"iso6393": "gwd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gweno",
		"type": "living",
		"scope": "individual",
		"iso6393": "gwe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gowro",
		"type": "living",
		"scope": "individual",
		"iso6393": "gwf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Moo",
		"type": "living",
		"scope": "individual",
		"iso6393": "gwg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gwichʼin",
		"type": "living",
		"scope": "individual",
		"iso6393": "gwi",
		"iso6392B": "gwi",
		"iso6392T": "gwi",
		"iso6391": null
	},
	{
		"name": "/Gwi",
		"type": "living",
		"scope": "individual",
		"iso6393": "gwj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Awngthim",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "gwm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gwandara",
		"type": "living",
		"scope": "individual",
		"iso6393": "gwn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gwere",
		"type": "living",
		"scope": "individual",
		"iso6393": "gwr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gawar-Bati",
		"type": "living",
		"scope": "individual",
		"iso6393": "gwt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Guwamu",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "gwu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kwini",
		"type": "living",
		"scope": "individual",
		"iso6393": "gww",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gua",
		"type": "living",
		"scope": "individual",
		"iso6393": "gwx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wè Southern",
		"type": "living",
		"scope": "individual",
		"iso6393": "gxx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northwest Gbaya",
		"type": "living",
		"scope": "individual",
		"iso6393": "gya",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Garus",
		"type": "living",
		"scope": "individual",
		"iso6393": "gyb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kayardild",
		"type": "living",
		"scope": "individual",
		"iso6393": "gyd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gyem",
		"type": "living",
		"scope": "individual",
		"iso6393": "gye",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gungabula",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "gyf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gbayi",
		"type": "living",
		"scope": "individual",
		"iso6393": "gyg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gyele",
		"type": "living",
		"scope": "individual",
		"iso6393": "gyi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gayil",
		"type": "living",
		"scope": "individual",
		"iso6393": "gyl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngäbere",
		"type": "living",
		"scope": "individual",
		"iso6393": "gym",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Guyanese Creole English",
		"type": "living",
		"scope": "individual",
		"iso6393": "gyn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Guarayu",
		"type": "living",
		"scope": "individual",
		"iso6393": "gyr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gunya",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "gyy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ganza",
		"type": "living",
		"scope": "individual",
		"iso6393": "gza",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gazi",
		"type": "living",
		"scope": "individual",
		"iso6393": "gzi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gane",
		"type": "living",
		"scope": "individual",
		"iso6393": "gzn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Han",
		"type": "living",
		"scope": "individual",
		"iso6393": "haa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hanoi Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "hab",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gurani",
		"type": "living",
		"scope": "individual",
		"iso6393": "hac",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hatam",
		"type": "living",
		"scope": "individual",
		"iso6393": "had",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Oromo",
		"type": "living",
		"scope": "individual",
		"iso6393": "hae",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Haiphong Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "haf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hanga",
		"type": "living",
		"scope": "individual",
		"iso6393": "hag",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hahon",
		"type": "living",
		"scope": "individual",
		"iso6393": "hah",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Haida",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "hai",
		"iso6392B": "hai",
		"iso6392T": "hai",
		"iso6391": null
	},
	{
		"name": "Hajong",
		"type": "living",
		"scope": "individual",
		"iso6393": "haj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hakka Chinese",
		"type": "living",
		"scope": "individual",
		"iso6393": "hak",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Halang",
		"type": "living",
		"scope": "individual",
		"iso6393": "hal",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hewa",
		"type": "living",
		"scope": "individual",
		"iso6393": "ham",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hangaza",
		"type": "living",
		"scope": "individual",
		"iso6393": "han",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hakö",
		"type": "living",
		"scope": "individual",
		"iso6393": "hao",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hupla",
		"type": "living",
		"scope": "individual",
		"iso6393": "hap",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ha",
		"type": "living",
		"scope": "individual",
		"iso6393": "haq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Harari",
		"type": "living",
		"scope": "individual",
		"iso6393": "har",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Haisla",
		"type": "living",
		"scope": "individual",
		"iso6393": "has",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Haitian",
		"type": "living",
		"scope": "individual",
		"iso6393": "hat",
		"iso6392B": "hat",
		"iso6392T": "hat",
		"iso6391": "ht"
	},
	{
		"name": "Hausa",
		"type": "living",
		"scope": "individual",
		"iso6393": "hau",
		"iso6392B": "hau",
		"iso6392T": "hau",
		"iso6391": "ha"
	},
	{
		"name": "Havu",
		"type": "living",
		"scope": "individual",
		"iso6393": "hav",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hawaiian",
		"type": "living",
		"scope": "individual",
		"iso6393": "haw",
		"iso6392B": "haw",
		"iso6392T": "haw",
		"iso6391": null
	},
	{
		"name": "Southern Haida",
		"type": "living",
		"scope": "individual",
		"iso6393": "hax",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Haya",
		"type": "living",
		"scope": "individual",
		"iso6393": "hay",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hazaragi",
		"type": "living",
		"scope": "individual",
		"iso6393": "haz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hamba",
		"type": "living",
		"scope": "individual",
		"iso6393": "hba",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Huba",
		"type": "living",
		"scope": "individual",
		"iso6393": "hbb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Heiban",
		"type": "living",
		"scope": "individual",
		"iso6393": "hbn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ancient Hebrew",
		"type": "historical",
		"scope": "individual",
		"iso6393": "hbo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Serbo-Croatian",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "hbs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": "sh"
	},
	{
		"name": "Habu",
		"type": "living",
		"scope": "individual",
		"iso6393": "hbu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Andaman Creole Hindi",
		"type": "living",
		"scope": "individual",
		"iso6393": "hca",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Huichol",
		"type": "living",
		"scope": "individual",
		"iso6393": "hch",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Haida",
		"type": "living",
		"scope": "individual",
		"iso6393": "hdn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Honduras Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "hds",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hadiyya",
		"type": "living",
		"scope": "individual",
		"iso6393": "hdy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Qiandong Miao",
		"type": "living",
		"scope": "individual",
		"iso6393": "hea",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hebrew",
		"type": "living",
		"scope": "individual",
		"iso6393": "heb",
		"iso6392B": "heb",
		"iso6392T": "heb",
		"iso6391": "he"
	},
	{
		"name": "Herdé",
		"type": "living",
		"scope": "individual",
		"iso6393": "hed",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Helong",
		"type": "living",
		"scope": "individual",
		"iso6393": "heg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hehe",
		"type": "living",
		"scope": "individual",
		"iso6393": "heh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Heiltsuk",
		"type": "living",
		"scope": "individual",
		"iso6393": "hei",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hemba",
		"type": "living",
		"scope": "individual",
		"iso6393": "hem",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Herero",
		"type": "living",
		"scope": "individual",
		"iso6393": "her",
		"iso6392B": "her",
		"iso6392T": "her",
		"iso6391": "hz"
	},
	{
		"name": "Hai//om",
		"type": "living",
		"scope": "individual",
		"iso6393": "hgm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Haigwai",
		"type": "living",
		"scope": "individual",
		"iso6393": "hgw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hoia Hoia",
		"type": "living",
		"scope": "individual",
		"iso6393": "hhi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kerak",
		"type": "living",
		"scope": "individual",
		"iso6393": "hhr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hoyahoya",
		"type": "living",
		"scope": "individual",
		"iso6393": "hhy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lamang",
		"type": "living",
		"scope": "individual",
		"iso6393": "hia",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hibito",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "hib",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hidatsa",
		"type": "living",
		"scope": "individual",
		"iso6393": "hid",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Fiji Hindi",
		"type": "living",
		"scope": "individual",
		"iso6393": "hif",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kamwe",
		"type": "living",
		"scope": "individual",
		"iso6393": "hig",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pamosu",
		"type": "living",
		"scope": "individual",
		"iso6393": "hih",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hinduri",
		"type": "living",
		"scope": "individual",
		"iso6393": "hii",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hijuk",
		"type": "living",
		"scope": "individual",
		"iso6393": "hij",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Seit-Kaitetu",
		"type": "living",
		"scope": "individual",
		"iso6393": "hik",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hiligaynon",
		"type": "living",
		"scope": "individual",
		"iso6393": "hil",
		"iso6392B": "hil",
		"iso6392T": "hil",
		"iso6391": null
	},
	{
		"name": "Hindi",
		"type": "living",
		"scope": "individual",
		"iso6393": "hin",
		"iso6392B": "hin",
		"iso6392T": "hin",
		"iso6391": "hi"
	},
	{
		"name": "Tsoa",
		"type": "living",
		"scope": "individual",
		"iso6393": "hio",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Himarimã",
		"type": "living",
		"scope": "individual",
		"iso6393": "hir",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hittite",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "hit",
		"iso6392B": "hit",
		"iso6392T": "hit",
		"iso6391": null
	},
	{
		"name": "Hiw",
		"type": "living",
		"scope": "individual",
		"iso6393": "hiw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hixkaryána",
		"type": "living",
		"scope": "individual",
		"iso6393": "hix",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Haji",
		"type": "living",
		"scope": "individual",
		"iso6393": "hji",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kahe",
		"type": "living",
		"scope": "individual",
		"iso6393": "hka",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hunde",
		"type": "living",
		"scope": "individual",
		"iso6393": "hke",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hunjara-Kaina Ke",
		"type": "living",
		"scope": "individual",
		"iso6393": "hkk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hong Kong Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "hks",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Halia",
		"type": "living",
		"scope": "individual",
		"iso6393": "hla",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Halbi",
		"type": "living",
		"scope": "individual",
		"iso6393": "hlb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Halang Doan",
		"type": "living",
		"scope": "individual",
		"iso6393": "hld",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hlersu",
		"type": "living",
		"scope": "individual",
		"iso6393": "hle",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Matu Chin",
		"type": "living",
		"scope": "individual",
		"iso6393": "hlt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hieroglyphic Luwian",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "hlu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Mashan Hmong",
		"type": "living",
		"scope": "individual",
		"iso6393": "hma",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Humburi Senni Songhay",
		"type": "living",
		"scope": "individual",
		"iso6393": "hmb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Central Huishui Hmong",
		"type": "living",
		"scope": "individual",
		"iso6393": "hmc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Large Flowery Miao",
		"type": "living",
		"scope": "individual",
		"iso6393": "hmd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Huishui Hmong",
		"type": "living",
		"scope": "individual",
		"iso6393": "hme",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hmong Don",
		"type": "living",
		"scope": "individual",
		"iso6393": "hmf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southwestern Guiyang Hmong",
		"type": "living",
		"scope": "individual",
		"iso6393": "hmg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southwestern Huishui Hmong",
		"type": "living",
		"scope": "individual",
		"iso6393": "hmh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Huishui Hmong",
		"type": "living",
		"scope": "individual",
		"iso6393": "hmi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ge",
		"type": "living",
		"scope": "individual",
		"iso6393": "hmj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maek",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "hmk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Luopohe Hmong",
		"type": "living",
		"scope": "individual",
		"iso6393": "hml",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Central Mashan Hmong",
		"type": "living",
		"scope": "individual",
		"iso6393": "hmm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hmong",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "hmn",
		"iso6392B": "hmn",
		"iso6392T": "hmn",
		"iso6391": null
	},
	{
		"name": "Hiri Motu",
		"type": "living",
		"scope": "individual",
		"iso6393": "hmo",
		"iso6392B": "hmo",
		"iso6392T": "hmo",
		"iso6391": "ho"
	},
	{
		"name": "Northern Mashan Hmong",
		"type": "living",
		"scope": "individual",
		"iso6393": "hmp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Qiandong Miao",
		"type": "living",
		"scope": "individual",
		"iso6393": "hmq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hmar",
		"type": "living",
		"scope": "individual",
		"iso6393": "hmr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Qiandong Miao",
		"type": "living",
		"scope": "individual",
		"iso6393": "hms",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hamtai",
		"type": "living",
		"scope": "individual",
		"iso6393": "hmt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hamap",
		"type": "living",
		"scope": "individual",
		"iso6393": "hmu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hmong Dô",
		"type": "living",
		"scope": "individual",
		"iso6393": "hmv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Mashan Hmong",
		"type": "living",
		"scope": "individual",
		"iso6393": "hmw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Guiyang Hmong",
		"type": "living",
		"scope": "individual",
		"iso6393": "hmy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hmong Shua",
		"type": "living",
		"scope": "individual",
		"iso6393": "hmz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mina (Cameroon)",
		"type": "living",
		"scope": "individual",
		"iso6393": "hna",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Hindko",
		"type": "living",
		"scope": "individual",
		"iso6393": "hnd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chhattisgarhi",
		"type": "living",
		"scope": "individual",
		"iso6393": "hne",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "//Ani",
		"type": "living",
		"scope": "individual",
		"iso6393": "hnh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hani",
		"type": "living",
		"scope": "individual",
		"iso6393": "hni",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hmong Njua",
		"type": "living",
		"scope": "individual",
		"iso6393": "hnj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hanunoo",
		"type": "living",
		"scope": "individual",
		"iso6393": "hnn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Hindko",
		"type": "living",
		"scope": "individual",
		"iso6393": "hno",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Caribbean Hindustani",
		"type": "living",
		"scope": "individual",
		"iso6393": "hns",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hung",
		"type": "living",
		"scope": "individual",
		"iso6393": "hnu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hoava",
		"type": "living",
		"scope": "individual",
		"iso6393": "hoa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mari (Madang Province)",
		"type": "living",
		"scope": "individual",
		"iso6393": "hob",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ho",
		"type": "living",
		"scope": "individual",
		"iso6393": "hoc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Holma",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "hod",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Horom",
		"type": "living",
		"scope": "individual",
		"iso6393": "hoe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hobyót",
		"type": "living",
		"scope": "individual",
		"iso6393": "hoh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Holikachuk",
		"type": "living",
		"scope": "individual",
		"iso6393": "hoi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hadothi",
		"type": "living",
		"scope": "individual",
		"iso6393": "hoj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Holu",
		"type": "living",
		"scope": "individual",
		"iso6393": "hol",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Homa",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "hom",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Holoholo",
		"type": "living",
		"scope": "individual",
		"iso6393": "hoo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hopi",
		"type": "living",
		"scope": "individual",
		"iso6393": "hop",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Horo",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "hor",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ho Chi Minh City Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "hos",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hote",
		"type": "living",
		"scope": "individual",
		"iso6393": "hot",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hovongan",
		"type": "living",
		"scope": "individual",
		"iso6393": "hov",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Honi",
		"type": "living",
		"scope": "individual",
		"iso6393": "how",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Holiya",
		"type": "living",
		"scope": "individual",
		"iso6393": "hoy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hozo",
		"type": "living",
		"scope": "individual",
		"iso6393": "hoz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hpon",
		"type": "living",
		"scope": "individual",
		"iso6393": "hpo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hawai'i Sign Language (HSL)",
		"type": "living",
		"scope": "individual",
		"iso6393": "hps",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hrangkhol",
		"type": "living",
		"scope": "individual",
		"iso6393": "hra",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Niwer Mil",
		"type": "living",
		"scope": "individual",
		"iso6393": "hrc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hre",
		"type": "living",
		"scope": "individual",
		"iso6393": "hre",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Haruku",
		"type": "living",
		"scope": "individual",
		"iso6393": "hrk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Horned Miao",
		"type": "living",
		"scope": "individual",
		"iso6393": "hrm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Haroi",
		"type": "living",
		"scope": "individual",
		"iso6393": "hro",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nhirrpi",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "hrp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hértevin",
		"type": "living",
		"scope": "individual",
		"iso6393": "hrt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hruso",
		"type": "living",
		"scope": "individual",
		"iso6393": "hru",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Croatian",
		"type": "living",
		"scope": "individual",
		"iso6393": "hrv",
		"iso6392B": "hrv",
		"iso6392T": "hrv",
		"iso6391": "hr"
	},
	{
		"name": "Warwar Feni",
		"type": "living",
		"scope": "individual",
		"iso6393": "hrw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hunsrik",
		"type": "living",
		"scope": "individual",
		"iso6393": "hrx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Harzani",
		"type": "living",
		"scope": "individual",
		"iso6393": "hrz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Upper Sorbian",
		"type": "living",
		"scope": "individual",
		"iso6393": "hsb",
		"iso6392B": "hsb",
		"iso6392T": "hsb",
		"iso6391": null
	},
	{
		"name": "Hungarian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "hsh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hausa Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "hsl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Xiang Chinese",
		"type": "living",
		"scope": "individual",
		"iso6393": "hsn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Harsusi",
		"type": "living",
		"scope": "individual",
		"iso6393": "hss",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hoti",
		"type": "living",
		"scope": "individual",
		"iso6393": "hti",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Minica Huitoto",
		"type": "living",
		"scope": "individual",
		"iso6393": "hto",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hadza",
		"type": "living",
		"scope": "individual",
		"iso6393": "hts",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hitu",
		"type": "living",
		"scope": "individual",
		"iso6393": "htu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Middle Hittite",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "htx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Huambisa",
		"type": "living",
		"scope": "individual",
		"iso6393": "hub",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "=/Hua",
		"type": "living",
		"scope": "individual",
		"iso6393": "huc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Huaulu",
		"type": "living",
		"scope": "individual",
		"iso6393": "hud",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "San Francisco Del Mar Huave",
		"type": "living",
		"scope": "individual",
		"iso6393": "hue",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Humene",
		"type": "living",
		"scope": "individual",
		"iso6393": "huf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Huachipaeri",
		"type": "living",
		"scope": "individual",
		"iso6393": "hug",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Huilliche",
		"type": "living",
		"scope": "individual",
		"iso6393": "huh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Huli",
		"type": "living",
		"scope": "individual",
		"iso6393": "hui",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Guiyang Hmong",
		"type": "living",
		"scope": "individual",
		"iso6393": "huj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hulung",
		"type": "living",
		"scope": "individual",
		"iso6393": "huk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hula",
		"type": "living",
		"scope": "individual",
		"iso6393": "hul",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hungana",
		"type": "living",
		"scope": "individual",
		"iso6393": "hum",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hungarian",
		"type": "living",
		"scope": "individual",
		"iso6393": "hun",
		"iso6392B": "hun",
		"iso6392T": "hun",
		"iso6391": "hu"
	},
	{
		"name": "Hu",
		"type": "living",
		"scope": "individual",
		"iso6393": "huo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hupa",
		"type": "living",
		"scope": "individual",
		"iso6393": "hup",
		"iso6392B": "hup",
		"iso6392T": "hup",
		"iso6391": null
	},
	{
		"name": "Tsat",
		"type": "living",
		"scope": "individual",
		"iso6393": "huq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Halkomelem",
		"type": "living",
		"scope": "individual",
		"iso6393": "hur",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Huastec",
		"type": "living",
		"scope": "individual",
		"iso6393": "hus",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Humla",
		"type": "living",
		"scope": "individual",
		"iso6393": "hut",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Murui Huitoto",
		"type": "living",
		"scope": "individual",
		"iso6393": "huu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "San Mateo Del Mar Huave",
		"type": "living",
		"scope": "individual",
		"iso6393": "huv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hukumina",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "huw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nüpode Huitoto",
		"type": "living",
		"scope": "individual",
		"iso6393": "hux",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hulaulá",
		"type": "living",
		"scope": "individual",
		"iso6393": "huy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hunzib",
		"type": "living",
		"scope": "individual",
		"iso6393": "huz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Haitian Vodoun Culture Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "hvc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "San Dionisio Del Mar Huave",
		"type": "living",
		"scope": "individual",
		"iso6393": "hve",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Haveke",
		"type": "living",
		"scope": "individual",
		"iso6393": "hvk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sabu",
		"type": "living",
		"scope": "individual",
		"iso6393": "hvn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Santa María Del Mar Huave",
		"type": "living",
		"scope": "individual",
		"iso6393": "hvv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wané",
		"type": "living",
		"scope": "individual",
		"iso6393": "hwa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hawai'i Creole English",
		"type": "living",
		"scope": "individual",
		"iso6393": "hwc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hwana",
		"type": "living",
		"scope": "individual",
		"iso6393": "hwo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hya",
		"type": "living",
		"scope": "individual",
		"iso6393": "hya",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Armenian",
		"type": "living",
		"scope": "individual",
		"iso6393": "hye",
		"iso6392B": "arm",
		"iso6392T": "hye",
		"iso6391": "hy"
	},
	{
		"name": "Iaai",
		"type": "living",
		"scope": "individual",
		"iso6393": "iai",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Iatmul",
		"type": "living",
		"scope": "individual",
		"iso6393": "ian",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Purari",
		"type": "living",
		"scope": "individual",
		"iso6393": "iar",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Iban",
		"type": "living",
		"scope": "individual",
		"iso6393": "iba",
		"iso6392B": "iba",
		"iso6392T": "iba",
		"iso6391": null
	},
	{
		"name": "Ibibio",
		"type": "living",
		"scope": "individual",
		"iso6393": "ibb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Iwaidja",
		"type": "living",
		"scope": "individual",
		"iso6393": "ibd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Akpes",
		"type": "living",
		"scope": "individual",
		"iso6393": "ibe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ibanag",
		"type": "living",
		"scope": "individual",
		"iso6393": "ibg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ibaloi",
		"type": "living",
		"scope": "individual",
		"iso6393": "ibl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Agoi",
		"type": "living",
		"scope": "individual",
		"iso6393": "ibm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ibino",
		"type": "living",
		"scope": "individual",
		"iso6393": "ibn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Igbo",
		"type": "living",
		"scope": "individual",
		"iso6393": "ibo",
		"iso6392B": "ibo",
		"iso6392T": "ibo",
		"iso6391": "ig"
	},
	{
		"name": "Ibuoro",
		"type": "living",
		"scope": "individual",
		"iso6393": "ibr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ibu",
		"type": "living",
		"scope": "individual",
		"iso6393": "ibu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ibani",
		"type": "living",
		"scope": "individual",
		"iso6393": "iby",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ede Ica",
		"type": "living",
		"scope": "individual",
		"iso6393": "ica",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Etkywan",
		"type": "living",
		"scope": "individual",
		"iso6393": "ich",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Icelandic Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "icl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Islander Creole English",
		"type": "living",
		"scope": "individual",
		"iso6393": "icr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Idakho-Isukha-Tiriki",
		"type": "living",
		"scope": "individual",
		"iso6393": "ida",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Indo-Portuguese",
		"type": "living",
		"scope": "individual",
		"iso6393": "idb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Idon",
		"type": "living",
		"scope": "individual",
		"iso6393": "idc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ede Idaca",
		"type": "living",
		"scope": "individual",
		"iso6393": "idd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Idere",
		"type": "living",
		"scope": "individual",
		"iso6393": "ide",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Idi",
		"type": "living",
		"scope": "individual",
		"iso6393": "idi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ido",
		"type": "constructed",
		"scope": "individual",
		"iso6393": "ido",
		"iso6392B": "ido",
		"iso6392T": "ido",
		"iso6391": "io"
	},
	{
		"name": "Indri",
		"type": "living",
		"scope": "individual",
		"iso6393": "idr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Idesa",
		"type": "living",
		"scope": "individual",
		"iso6393": "ids",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Idaté",
		"type": "living",
		"scope": "individual",
		"iso6393": "idt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Idoma",
		"type": "living",
		"scope": "individual",
		"iso6393": "idu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Amganad Ifugao",
		"type": "living",
		"scope": "individual",
		"iso6393": "ifa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Batad Ifugao",
		"type": "living",
		"scope": "individual",
		"iso6393": "ifb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ifè",
		"type": "living",
		"scope": "individual",
		"iso6393": "ife",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ifo",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "iff",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tuwali Ifugao",
		"type": "living",
		"scope": "individual",
		"iso6393": "ifk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Teke-Fuumu",
		"type": "living",
		"scope": "individual",
		"iso6393": "ifm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mayoyao Ifugao",
		"type": "living",
		"scope": "individual",
		"iso6393": "ifu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Keley-I Kallahan",
		"type": "living",
		"scope": "individual",
		"iso6393": "ify",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ebira",
		"type": "living",
		"scope": "individual",
		"iso6393": "igb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Igede",
		"type": "living",
		"scope": "individual",
		"iso6393": "ige",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Igana",
		"type": "living",
		"scope": "individual",
		"iso6393": "igg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Igala",
		"type": "living",
		"scope": "individual",
		"iso6393": "igl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kanggape",
		"type": "living",
		"scope": "individual",
		"iso6393": "igm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ignaciano",
		"type": "living",
		"scope": "individual",
		"iso6393": "ign",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Isebe",
		"type": "living",
		"scope": "individual",
		"iso6393": "igo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Interglossa",
		"type": "constructed",
		"scope": "individual",
		"iso6393": "igs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Igwe",
		"type": "living",
		"scope": "individual",
		"iso6393": "igw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Iha Based Pidgin",
		"type": "living",
		"scope": "individual",
		"iso6393": "ihb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ihievbe",
		"type": "living",
		"scope": "individual",
		"iso6393": "ihi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Iha",
		"type": "living",
		"scope": "individual",
		"iso6393": "ihp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bidhawal",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ihw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sichuan Yi",
		"type": "living",
		"scope": "individual",
		"iso6393": "iii",
		"iso6392B": "iii",
		"iso6392T": "iii",
		"iso6391": "ii"
	},
	{
		"name": "Thiin",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "iin",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Izon",
		"type": "living",
		"scope": "individual",
		"iso6393": "ijc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Biseni",
		"type": "living",
		"scope": "individual",
		"iso6393": "ije",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ede Ije",
		"type": "living",
		"scope": "individual",
		"iso6393": "ijj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kalabari",
		"type": "living",
		"scope": "individual",
		"iso6393": "ijn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southeast Ijo",
		"type": "living",
		"scope": "individual",
		"iso6393": "ijs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Canadian Inuktitut",
		"type": "living",
		"scope": "individual",
		"iso6393": "ike",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Iko",
		"type": "living",
		"scope": "individual",
		"iso6393": "iki",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ika",
		"type": "living",
		"scope": "individual",
		"iso6393": "ikk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ikulu",
		"type": "living",
		"scope": "individual",
		"iso6393": "ikl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Olulumo-Ikom",
		"type": "living",
		"scope": "individual",
		"iso6393": "iko",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ikpeshi",
		"type": "living",
		"scope": "individual",
		"iso6393": "ikp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ikaranggal",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ikr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Inuit Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "iks",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Inuinnaqtun",
		"type": "living",
		"scope": "individual",
		"iso6393": "ikt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Inuktitut",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "iku",
		"iso6392B": "iku",
		"iso6392T": "iku",
		"iso6391": "iu"
	},
	{
		"name": "Iku-Gora-Ankwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "ikv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ikwere",
		"type": "living",
		"scope": "individual",
		"iso6393": "ikw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ik",
		"type": "living",
		"scope": "individual",
		"iso6393": "ikx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ikizu",
		"type": "living",
		"scope": "individual",
		"iso6393": "ikz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ile Ape",
		"type": "living",
		"scope": "individual",
		"iso6393": "ila",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ila",
		"type": "living",
		"scope": "individual",
		"iso6393": "ilb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Interlingue",
		"type": "constructed",
		"scope": "individual",
		"iso6393": "ile",
		"iso6392B": "ile",
		"iso6392T": "ile",
		"iso6391": "ie"
	},
	{
		"name": "Garig-Ilgar",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ilg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ili Turki",
		"type": "living",
		"scope": "individual",
		"iso6393": "ili",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ilongot",
		"type": "living",
		"scope": "individual",
		"iso6393": "ilk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Iranun (Malaysia)",
		"type": "living",
		"scope": "individual",
		"iso6393": "ilm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Iloko",
		"type": "living",
		"scope": "individual",
		"iso6393": "ilo",
		"iso6392B": "ilo",
		"iso6392T": "ilo",
		"iso6391": null
	},
	{
		"name": " Iranun (Philippines)",
		"type": "living",
		"scope": "individual",
		"iso6393": "ilp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "International Sign",
		"type": "living",
		"scope": "individual",
		"iso6393": "ils",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ili'uun",
		"type": "living",
		"scope": "individual",
		"iso6393": "ilu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ilue",
		"type": "living",
		"scope": "individual",
		"iso6393": "ilv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mala Malasar",
		"type": "living",
		"scope": "individual",
		"iso6393": "ima",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Anamgura",
		"type": "living",
		"scope": "individual",
		"iso6393": "imi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Miluk",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "iml",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Imonda",
		"type": "living",
		"scope": "individual",
		"iso6393": "imn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Imbongu",
		"type": "living",
		"scope": "individual",
		"iso6393": "imo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Imroing",
		"type": "living",
		"scope": "individual",
		"iso6393": "imr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Marsian",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "ims",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Milyan",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "imy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Interlingua (International Auxiliary Language Association)",
		"type": "constructed",
		"scope": "individual",
		"iso6393": "ina",
		"iso6392B": "ina",
		"iso6392T": "ina",
		"iso6391": "ia"
	},
	{
		"name": "Inga",
		"type": "living",
		"scope": "individual",
		"iso6393": "inb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Indonesian",
		"type": "living",
		"scope": "individual",
		"iso6393": "ind",
		"iso6392B": "ind",
		"iso6392T": "ind",
		"iso6391": "id"
	},
	{
		"name": "Degexit'an",
		"type": "living",
		"scope": "individual",
		"iso6393": "ing",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ingush",
		"type": "living",
		"scope": "individual",
		"iso6393": "inh",
		"iso6392B": "inh",
		"iso6392T": "inh",
		"iso6391": null
	},
	{
		"name": "Jungle Inga",
		"type": "living",
		"scope": "individual",
		"iso6393": "inj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Indonesian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "inl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Minaean",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "inm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Isinai",
		"type": "living",
		"scope": "individual",
		"iso6393": "inn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Inoke-Yate",
		"type": "living",
		"scope": "individual",
		"iso6393": "ino",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Iñapari",
		"type": "living",
		"scope": "individual",
		"iso6393": "inp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Indian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "ins",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Intha",
		"type": "living",
		"scope": "individual",
		"iso6393": "int",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ineseño",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "inz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Inor",
		"type": "living",
		"scope": "individual",
		"iso6393": "ior",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tuma-Irumu",
		"type": "living",
		"scope": "individual",
		"iso6393": "iou",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Iowa-Oto",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "iow",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ipili",
		"type": "living",
		"scope": "individual",
		"iso6393": "ipi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Inupiaq",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "ipk",
		"iso6392B": "ipk",
		"iso6392T": "ipk",
		"iso6391": "ik"
	},
	{
		"name": "Ipiko",
		"type": "living",
		"scope": "individual",
		"iso6393": "ipo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Iquito",
		"type": "living",
		"scope": "individual",
		"iso6393": "iqu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ikwo",
		"type": "living",
		"scope": "individual",
		"iso6393": "iqw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Iresim",
		"type": "living",
		"scope": "individual",
		"iso6393": "ire",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Irarutu",
		"type": "living",
		"scope": "individual",
		"iso6393": "irh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Irigwe",
		"type": "living",
		"scope": "individual",
		"iso6393": "iri",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Iraqw",
		"type": "living",
		"scope": "individual",
		"iso6393": "irk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Irántxe",
		"type": "living",
		"scope": "individual",
		"iso6393": "irn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ir",
		"type": "living",
		"scope": "individual",
		"iso6393": "irr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Irula",
		"type": "living",
		"scope": "individual",
		"iso6393": "iru",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kamberau",
		"type": "living",
		"scope": "individual",
		"iso6393": "irx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Iraya",
		"type": "living",
		"scope": "individual",
		"iso6393": "iry",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Isabi",
		"type": "living",
		"scope": "individual",
		"iso6393": "isa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Isconahua",
		"type": "living",
		"scope": "individual",
		"iso6393": "isc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Isnag",
		"type": "living",
		"scope": "individual",
		"iso6393": "isd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Italian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "ise",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Irish Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "isg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Esan",
		"type": "living",
		"scope": "individual",
		"iso6393": "ish",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nkem-Nkum",
		"type": "living",
		"scope": "individual",
		"iso6393": "isi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ishkashimi",
		"type": "living",
		"scope": "individual",
		"iso6393": "isk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Icelandic",
		"type": "living",
		"scope": "individual",
		"iso6393": "isl",
		"iso6392B": "ice",
		"iso6392T": "isl",
		"iso6391": "is"
	},
	{
		"name": "Masimasi",
		"type": "living",
		"scope": "individual",
		"iso6393": "ism",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Isanzu",
		"type": "living",
		"scope": "individual",
		"iso6393": "isn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Isoko",
		"type": "living",
		"scope": "individual",
		"iso6393": "iso",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Israeli Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "isr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Istriot",
		"type": "living",
		"scope": "individual",
		"iso6393": "ist",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Isu (Menchum Division)",
		"type": "living",
		"scope": "individual",
		"iso6393": "isu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Italian",
		"type": "living",
		"scope": "individual",
		"iso6393": "ita",
		"iso6392B": "ita",
		"iso6392T": "ita",
		"iso6391": "it"
	},
	{
		"name": "Binongan Itneg",
		"type": "living",
		"scope": "individual",
		"iso6393": "itb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Tidung",
		"type": "living",
		"scope": "individual",
		"iso6393": "itd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Itene",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ite",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Inlaod Itneg",
		"type": "living",
		"scope": "individual",
		"iso6393": "iti",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Judeo-Italian",
		"type": "living",
		"scope": "individual",
		"iso6393": "itk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Itelmen",
		"type": "living",
		"scope": "individual",
		"iso6393": "itl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Itu Mbon Uzo",
		"type": "living",
		"scope": "individual",
		"iso6393": "itm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Itonama",
		"type": "living",
		"scope": "individual",
		"iso6393": "ito",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Iteri",
		"type": "living",
		"scope": "individual",
		"iso6393": "itr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Isekiri",
		"type": "living",
		"scope": "individual",
		"iso6393": "its",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maeng Itneg",
		"type": "living",
		"scope": "individual",
		"iso6393": "itt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Itawit",
		"type": "living",
		"scope": "individual",
		"iso6393": "itv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ito",
		"type": "living",
		"scope": "individual",
		"iso6393": "itw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Itik",
		"type": "living",
		"scope": "individual",
		"iso6393": "itx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Moyadan Itneg",
		"type": "living",
		"scope": "individual",
		"iso6393": "ity",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Itzá",
		"type": "living",
		"scope": "individual",
		"iso6393": "itz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Iu Mien",
		"type": "living",
		"scope": "individual",
		"iso6393": "ium",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ibatan",
		"type": "living",
		"scope": "individual",
		"iso6393": "ivb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ivatan",
		"type": "living",
		"scope": "individual",
		"iso6393": "ivv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "I-Wak",
		"type": "living",
		"scope": "individual",
		"iso6393": "iwk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Iwam",
		"type": "living",
		"scope": "individual",
		"iso6393": "iwm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Iwur",
		"type": "living",
		"scope": "individual",
		"iso6393": "iwo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sepik Iwam",
		"type": "living",
		"scope": "individual",
		"iso6393": "iws",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ixcatec",
		"type": "living",
		"scope": "individual",
		"iso6393": "ixc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ixil",
		"type": "living",
		"scope": "individual",
		"iso6393": "ixl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Iyayu",
		"type": "living",
		"scope": "individual",
		"iso6393": "iya",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mesaka",
		"type": "living",
		"scope": "individual",
		"iso6393": "iyo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yaka (Congo)",
		"type": "living",
		"scope": "individual",
		"iso6393": "iyx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ingrian",
		"type": "living",
		"scope": "individual",
		"iso6393": "izh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Izere",
		"type": "living",
		"scope": "individual",
		"iso6393": "izr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Izii",
		"type": "living",
		"scope": "individual",
		"iso6393": "izz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jamamadí",
		"type": "living",
		"scope": "individual",
		"iso6393": "jaa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hyam",
		"type": "living",
		"scope": "individual",
		"iso6393": "jab",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Popti'",
		"type": "living",
		"scope": "individual",
		"iso6393": "jac",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jahanka",
		"type": "living",
		"scope": "individual",
		"iso6393": "jad",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yabem",
		"type": "living",
		"scope": "individual",
		"iso6393": "jae",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jara",
		"type": "living",
		"scope": "individual",
		"iso6393": "jaf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jah Hut",
		"type": "living",
		"scope": "individual",
		"iso6393": "jah",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zazao",
		"type": "living",
		"scope": "individual",
		"iso6393": "jaj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jakun",
		"type": "living",
		"scope": "individual",
		"iso6393": "jak",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yalahatan",
		"type": "living",
		"scope": "individual",
		"iso6393": "jal",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jamaican Creole English",
		"type": "living",
		"scope": "individual",
		"iso6393": "jam",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jandai",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "jan",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yanyuwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "jao",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yaqay",
		"type": "living",
		"scope": "individual",
		"iso6393": "jaq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "New Caledonian Javanese",
		"type": "living",
		"scope": "individual",
		"iso6393": "jas",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jakati",
		"type": "living",
		"scope": "individual",
		"iso6393": "jat",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yaur",
		"type": "living",
		"scope": "individual",
		"iso6393": "jau",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Javanese",
		"type": "living",
		"scope": "individual",
		"iso6393": "jav",
		"iso6392B": "jav",
		"iso6392T": "jav",
		"iso6391": "jv"
	},
	{
		"name": "Jambi Malay",
		"type": "living",
		"scope": "individual",
		"iso6393": "jax",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yan-nhangu",
		"type": "living",
		"scope": "individual",
		"iso6393": "jay",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jawe",
		"type": "living",
		"scope": "individual",
		"iso6393": "jaz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Judeo-Berber",
		"type": "living",
		"scope": "individual",
		"iso6393": "jbe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Badjiri",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "jbi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Arandai",
		"type": "living",
		"scope": "individual",
		"iso6393": "jbj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Barikewa",
		"type": "living",
		"scope": "individual",
		"iso6393": "jbk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nafusi",
		"type": "living",
		"scope": "individual",
		"iso6393": "jbn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lojban",
		"type": "constructed",
		"scope": "individual",
		"iso6393": "jbo",
		"iso6392B": "jbo",
		"iso6392T": "jbo",
		"iso6391": null
	},
	{
		"name": "Jofotek-Bromnya",
		"type": "living",
		"scope": "individual",
		"iso6393": "jbr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jabutí",
		"type": "living",
		"scope": "individual",
		"iso6393": "jbt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jukun Takum",
		"type": "living",
		"scope": "individual",
		"iso6393": "jbu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yawijibaya",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "jbw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jamaican Country Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "jcs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Krymchak",
		"type": "living",
		"scope": "individual",
		"iso6393": "jct",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jad",
		"type": "living",
		"scope": "individual",
		"iso6393": "jda",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jadgali",
		"type": "living",
		"scope": "individual",
		"iso6393": "jdg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Judeo-Tat",
		"type": "living",
		"scope": "individual",
		"iso6393": "jdt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jebero",
		"type": "living",
		"scope": "individual",
		"iso6393": "jeb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jerung",
		"type": "living",
		"scope": "individual",
		"iso6393": "jee",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jeng",
		"type": "living",
		"scope": "individual",
		"iso6393": "jeg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jeh",
		"type": "living",
		"scope": "individual",
		"iso6393": "jeh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yei",
		"type": "living",
		"scope": "individual",
		"iso6393": "jei",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jeri Kuo",
		"type": "living",
		"scope": "individual",
		"iso6393": "jek",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yelmek",
		"type": "living",
		"scope": "individual",
		"iso6393": "jel",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dza",
		"type": "living",
		"scope": "individual",
		"iso6393": "jen",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jere",
		"type": "living",
		"scope": "individual",
		"iso6393": "jer",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Manem",
		"type": "living",
		"scope": "individual",
		"iso6393": "jet",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jonkor Bourmataguil",
		"type": "living",
		"scope": "individual",
		"iso6393": "jeu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngbee",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "jgb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Judeo-Georgian",
		"type": "living",
		"scope": "individual",
		"iso6393": "jge",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gwak",
		"type": "living",
		"scope": "individual",
		"iso6393": "jgk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngomba",
		"type": "living",
		"scope": "individual",
		"iso6393": "jgo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jehai",
		"type": "living",
		"scope": "individual",
		"iso6393": "jhi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jhankot Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "jhs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jina",
		"type": "living",
		"scope": "individual",
		"iso6393": "jia",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jibu",
		"type": "living",
		"scope": "individual",
		"iso6393": "jib",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tol",
		"type": "living",
		"scope": "individual",
		"iso6393": "jic",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bu",
		"type": "living",
		"scope": "individual",
		"iso6393": "jid",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jilbe",
		"type": "living",
		"scope": "individual",
		"iso6393": "jie",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Djingili",
		"type": "living",
		"scope": "individual",
		"iso6393": "jig",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "sTodsde",
		"type": "living",
		"scope": "individual",
		"iso6393": "jih",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jiiddu",
		"type": "living",
		"scope": "individual",
		"iso6393": "jii",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jilim",
		"type": "living",
		"scope": "individual",
		"iso6393": "jil",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jimi (Cameroon)",
		"type": "living",
		"scope": "individual",
		"iso6393": "jim",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jiamao",
		"type": "living",
		"scope": "individual",
		"iso6393": "jio",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Guanyinqiao",
		"type": "living",
		"scope": "individual",
		"iso6393": "jiq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jita",
		"type": "living",
		"scope": "individual",
		"iso6393": "jit",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Youle Jinuo",
		"type": "living",
		"scope": "individual",
		"iso6393": "jiu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shuar",
		"type": "living",
		"scope": "individual",
		"iso6393": "jiv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Buyuan Jinuo",
		"type": "living",
		"scope": "individual",
		"iso6393": "jiy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jejueo",
		"type": "living",
		"scope": "individual",
		"iso6393": "jje",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bankal",
		"type": "living",
		"scope": "individual",
		"iso6393": "jjr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kaera",
		"type": "living",
		"scope": "individual",
		"iso6393": "jka",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mobwa Karen",
		"type": "living",
		"scope": "individual",
		"iso6393": "jkm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kubo",
		"type": "living",
		"scope": "individual",
		"iso6393": "jko",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Paku Karen",
		"type": "living",
		"scope": "individual",
		"iso6393": "jkp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koro (India)",
		"type": "living",
		"scope": "individual",
		"iso6393": "jkr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Labir",
		"type": "living",
		"scope": "individual",
		"iso6393": "jku",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngile",
		"type": "living",
		"scope": "individual",
		"iso6393": "jle",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jamaican Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "jls",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dima",
		"type": "living",
		"scope": "individual",
		"iso6393": "jma",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zumbun",
		"type": "living",
		"scope": "individual",
		"iso6393": "jmb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Machame",
		"type": "living",
		"scope": "individual",
		"iso6393": "jmc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yamdena",
		"type": "living",
		"scope": "individual",
		"iso6393": "jmd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jimi (Nigeria)",
		"type": "living",
		"scope": "individual",
		"iso6393": "jmi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jumli",
		"type": "living",
		"scope": "individual",
		"iso6393": "jml",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Makuri Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "jmn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kamara",
		"type": "living",
		"scope": "individual",
		"iso6393": "jmr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mashi (Nigeria)",
		"type": "living",
		"scope": "individual",
		"iso6393": "jms",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mouwase",
		"type": "living",
		"scope": "individual",
		"iso6393": "jmw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Juxtlahuaca Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "jmx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jangshung",
		"type": "living",
		"scope": "individual",
		"iso6393": "jna",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jandavra",
		"type": "living",
		"scope": "individual",
		"iso6393": "jnd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yangman",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "jng",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Janji",
		"type": "living",
		"scope": "individual",
		"iso6393": "jni",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yemsa",
		"type": "living",
		"scope": "individual",
		"iso6393": "jnj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rawat",
		"type": "living",
		"scope": "individual",
		"iso6393": "jnl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jaunsari",
		"type": "living",
		"scope": "individual",
		"iso6393": "jns",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Joba",
		"type": "living",
		"scope": "individual",
		"iso6393": "job",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wojenaka",
		"type": "living",
		"scope": "individual",
		"iso6393": "jod",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jogi",
		"type": "living",
		"scope": "individual",
		"iso6393": "jog",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jorá",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "jor",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jordanian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "jos",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jowulu",
		"type": "living",
		"scope": "individual",
		"iso6393": "jow",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jewish Palestinian Aramaic",
		"type": "historical",
		"scope": "individual",
		"iso6393": "jpa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Japanese",
		"type": "living",
		"scope": "individual",
		"iso6393": "jpn",
		"iso6392B": "jpn",
		"iso6392T": "jpn",
		"iso6391": "ja"
	},
	{
		"name": "Judeo-Persian",
		"type": "living",
		"scope": "individual",
		"iso6393": "jpr",
		"iso6392B": "jpr",
		"iso6392T": "jpr",
		"iso6391": null
	},
	{
		"name": "Jaqaru",
		"type": "living",
		"scope": "individual",
		"iso6393": "jqr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jarai",
		"type": "living",
		"scope": "individual",
		"iso6393": "jra",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Judeo-Arabic",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "jrb",
		"iso6392B": "jrb",
		"iso6392T": "jrb",
		"iso6391": null
	},
	{
		"name": "Jiru",
		"type": "living",
		"scope": "individual",
		"iso6393": "jrr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jorto",
		"type": "living",
		"scope": "individual",
		"iso6393": "jrt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Japrería",
		"type": "living",
		"scope": "individual",
		"iso6393": "jru",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Japanese Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "jsl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Júma",
		"type": "living",
		"scope": "individual",
		"iso6393": "jua",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wannu",
		"type": "living",
		"scope": "individual",
		"iso6393": "jub",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jurchen",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "juc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Worodougou",
		"type": "living",
		"scope": "individual",
		"iso6393": "jud",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hõne",
		"type": "living",
		"scope": "individual",
		"iso6393": "juh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngadjuri",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "jui",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wapan",
		"type": "living",
		"scope": "individual",
		"iso6393": "juk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jirel",
		"type": "living",
		"scope": "individual",
		"iso6393": "jul",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jumjum",
		"type": "living",
		"scope": "individual",
		"iso6393": "jum",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Juang",
		"type": "living",
		"scope": "individual",
		"iso6393": "jun",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jiba",
		"type": "living",
		"scope": "individual",
		"iso6393": "juo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hupdë",
		"type": "living",
		"scope": "individual",
		"iso6393": "jup",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jurúna",
		"type": "living",
		"scope": "individual",
		"iso6393": "jur",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jumla Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "jus",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jutish",
		"type": "historical",
		"scope": "individual",
		"iso6393": "jut",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ju",
		"type": "living",
		"scope": "individual",
		"iso6393": "juu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wãpha",
		"type": "living",
		"scope": "individual",
		"iso6393": "juw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Juray",
		"type": "living",
		"scope": "individual",
		"iso6393": "juy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Javindo",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "jvd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Caribbean Javanese",
		"type": "living",
		"scope": "individual",
		"iso6393": "jvn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jwira-Pepesa",
		"type": "living",
		"scope": "individual",
		"iso6393": "jwi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jiarong",
		"type": "living",
		"scope": "individual",
		"iso6393": "jya",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Judeo-Yemeni Arabic",
		"type": "living",
		"scope": "individual",
		"iso6393": "jye",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jaya",
		"type": "living",
		"scope": "individual",
		"iso6393": "jyy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kara-Kalpak",
		"type": "living",
		"scope": "individual",
		"iso6393": "kaa",
		"iso6392B": "kaa",
		"iso6392T": "kaa",
		"iso6391": null
	},
	{
		"name": "Kabyle",
		"type": "living",
		"scope": "individual",
		"iso6393": "kab",
		"iso6392B": "kab",
		"iso6392T": "kab",
		"iso6391": null
	},
	{
		"name": "Kachin",
		"type": "living",
		"scope": "individual",
		"iso6393": "kac",
		"iso6392B": "kac",
		"iso6392T": "kac",
		"iso6391": null
	},
	{
		"name": "Adara",
		"type": "living",
		"scope": "individual",
		"iso6393": "kad",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ketangalan",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "kae",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Katso",
		"type": "living",
		"scope": "individual",
		"iso6393": "kaf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kajaman",
		"type": "living",
		"scope": "individual",
		"iso6393": "kag",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kara (Central African Republic)",
		"type": "living",
		"scope": "individual",
		"iso6393": "kah",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Karekare",
		"type": "living",
		"scope": "individual",
		"iso6393": "kai",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jju",
		"type": "living",
		"scope": "individual",
		"iso6393": "kaj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kalanguya",
		"type": "living",
		"scope": "individual",
		"iso6393": "kak",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kalaallisut",
		"type": "living",
		"scope": "individual",
		"iso6393": "kal",
		"iso6392B": "kal",
		"iso6392T": "kal",
		"iso6391": "kl"
	},
	{
		"name": "Kamba (Kenya)",
		"type": "living",
		"scope": "individual",
		"iso6393": "kam",
		"iso6392B": "kam",
		"iso6392T": "kam",
		"iso6391": null
	},
	{
		"name": "Kannada",
		"type": "living",
		"scope": "individual",
		"iso6393": "kan",
		"iso6392B": "kan",
		"iso6392T": "kan",
		"iso6391": "kn"
	},
	{
		"name": "Xaasongaxango",
		"type": "living",
		"scope": "individual",
		"iso6393": "kao",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bezhta",
		"type": "living",
		"scope": "individual",
		"iso6393": "kap",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Capanahua",
		"type": "living",
		"scope": "individual",
		"iso6393": "kaq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kashmiri",
		"type": "living",
		"scope": "individual",
		"iso6393": "kas",
		"iso6392B": "kas",
		"iso6392T": "kas",
		"iso6391": "ks"
	},
	{
		"name": "Georgian",
		"type": "living",
		"scope": "individual",
		"iso6393": "kat",
		"iso6392B": "geo",
		"iso6392T": "kat",
		"iso6391": "ka"
	},
	{
		"name": "Kanuri",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "kau",
		"iso6392B": "kau",
		"iso6392T": "kau",
		"iso6391": "kr"
	},
	{
		"name": "Katukína",
		"type": "living",
		"scope": "individual",
		"iso6393": "kav",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kawi",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "kaw",
		"iso6392B": "kaw",
		"iso6392T": "kaw",
		"iso6391": null
	},
	{
		"name": "Kao",
		"type": "living",
		"scope": "individual",
		"iso6393": "kax",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kamayurá",
		"type": "living",
		"scope": "individual",
		"iso6393": "kay",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kazakh",
		"type": "living",
		"scope": "individual",
		"iso6393": "kaz",
		"iso6392B": "kaz",
		"iso6392T": "kaz",
		"iso6391": "kk"
	},
	{
		"name": "Kalarko",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "kba",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kaxuiâna",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "kbb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kadiwéu",
		"type": "living",
		"scope": "individual",
		"iso6393": "kbc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kabardian",
		"type": "living",
		"scope": "individual",
		"iso6393": "kbd",
		"iso6392B": "kbd",
		"iso6392T": "kbd",
		"iso6391": null
	},
	{
		"name": "Kanju",
		"type": "living",
		"scope": "individual",
		"iso6393": "kbe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Khamba",
		"type": "living",
		"scope": "individual",
		"iso6393": "kbg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Camsá",
		"type": "living",
		"scope": "individual",
		"iso6393": "kbh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kaptiau",
		"type": "living",
		"scope": "individual",
		"iso6393": "kbi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kari",
		"type": "living",
		"scope": "individual",
		"iso6393": "kbj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Grass Koiari",
		"type": "living",
		"scope": "individual",
		"iso6393": "kbk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kanembu",
		"type": "living",
		"scope": "individual",
		"iso6393": "kbl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Iwal",
		"type": "living",
		"scope": "individual",
		"iso6393": "kbm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kare (Central African Republic)",
		"type": "living",
		"scope": "individual",
		"iso6393": "kbn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Keliko",
		"type": "living",
		"scope": "individual",
		"iso6393": "kbo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kabiyè",
		"type": "living",
		"scope": "individual",
		"iso6393": "kbp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kamano",
		"type": "living",
		"scope": "individual",
		"iso6393": "kbq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kafa",
		"type": "living",
		"scope": "individual",
		"iso6393": "kbr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kande",
		"type": "living",
		"scope": "individual",
		"iso6393": "kbs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Abadi",
		"type": "living",
		"scope": "individual",
		"iso6393": "kbt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kabutra",
		"type": "living",
		"scope": "individual",
		"iso6393": "kbu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dera (Indonesia)",
		"type": "living",
		"scope": "individual",
		"iso6393": "kbv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kaiep",
		"type": "living",
		"scope": "individual",
		"iso6393": "kbw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ap Ma",
		"type": "living",
		"scope": "individual",
		"iso6393": "kbx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Manga Kanuri",
		"type": "living",
		"scope": "individual",
		"iso6393": "kby",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Duhwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "kbz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Khanty",
		"type": "living",
		"scope": "individual",
		"iso6393": "kca",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kawacha",
		"type": "living",
		"scope": "individual",
		"iso6393": "kcb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lubila",
		"type": "living",
		"scope": "individual",
		"iso6393": "kcc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngkâlmpw Kanum",
		"type": "living",
		"scope": "individual",
		"iso6393": "kcd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kaivi",
		"type": "living",
		"scope": "individual",
		"iso6393": "kce",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ukaan",
		"type": "living",
		"scope": "individual",
		"iso6393": "kcf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tyap",
		"type": "living",
		"scope": "individual",
		"iso6393": "kcg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Vono",
		"type": "living",
		"scope": "individual",
		"iso6393": "kch",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kamantan",
		"type": "living",
		"scope": "individual",
		"iso6393": "kci",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kobiana",
		"type": "living",
		"scope": "individual",
		"iso6393": "kcj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kalanga",
		"type": "living",
		"scope": "individual",
		"iso6393": "kck",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kela (Papua New Guinea)",
		"type": "living",
		"scope": "individual",
		"iso6393": "kcl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gula (Central African Republic)",
		"type": "living",
		"scope": "individual",
		"iso6393": "kcm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nubi",
		"type": "living",
		"scope": "individual",
		"iso6393": "kcn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kinalakna",
		"type": "living",
		"scope": "individual",
		"iso6393": "kco",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kanga",
		"type": "living",
		"scope": "individual",
		"iso6393": "kcp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kamo",
		"type": "living",
		"scope": "individual",
		"iso6393": "kcq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Katla",
		"type": "living",
		"scope": "individual",
		"iso6393": "kcr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koenoem",
		"type": "living",
		"scope": "individual",
		"iso6393": "kcs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kaian",
		"type": "living",
		"scope": "individual",
		"iso6393": "kct",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kami (Tanzania)",
		"type": "living",
		"scope": "individual",
		"iso6393": "kcu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kete",
		"type": "living",
		"scope": "individual",
		"iso6393": "kcv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kabwari",
		"type": "living",
		"scope": "individual",
		"iso6393": "kcw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kachama-Ganjule",
		"type": "living",
		"scope": "individual",
		"iso6393": "kcx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Korandje",
		"type": "living",
		"scope": "individual",
		"iso6393": "kcy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Konongo",
		"type": "living",
		"scope": "individual",
		"iso6393": "kcz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Worimi",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "kda",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kutu",
		"type": "living",
		"scope": "individual",
		"iso6393": "kdc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yankunytjatjara",
		"type": "living",
		"scope": "individual",
		"iso6393": "kdd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Makonde",
		"type": "living",
		"scope": "individual",
		"iso6393": "kde",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mamusi",
		"type": "living",
		"scope": "individual",
		"iso6393": "kdf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Seba",
		"type": "living",
		"scope": "individual",
		"iso6393": "kdg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tem",
		"type": "living",
		"scope": "individual",
		"iso6393": "kdh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kumam",
		"type": "living",
		"scope": "individual",
		"iso6393": "kdi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Karamojong",
		"type": "living",
		"scope": "individual",
		"iso6393": "kdj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Numèè",
		"type": "living",
		"scope": "individual",
		"iso6393": "kdk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tsikimba",
		"type": "living",
		"scope": "individual",
		"iso6393": "kdl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kagoma",
		"type": "living",
		"scope": "individual",
		"iso6393": "kdm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kunda",
		"type": "living",
		"scope": "individual",
		"iso6393": "kdn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kaningdon-Nindem",
		"type": "living",
		"scope": "individual",
		"iso6393": "kdp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koch",
		"type": "living",
		"scope": "individual",
		"iso6393": "kdq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Karaim",
		"type": "living",
		"scope": "individual",
		"iso6393": "kdr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kuy",
		"type": "living",
		"scope": "individual",
		"iso6393": "kdt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kadaru",
		"type": "living",
		"scope": "individual",
		"iso6393": "kdu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koneraw",
		"type": "living",
		"scope": "individual",
		"iso6393": "kdw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kam",
		"type": "living",
		"scope": "individual",
		"iso6393": "kdx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Keder",
		"type": "living",
		"scope": "individual",
		"iso6393": "kdy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kwaja",
		"type": "living",
		"scope": "individual",
		"iso6393": "kdz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kabuverdianu",
		"type": "living",
		"scope": "individual",
		"iso6393": "kea",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kélé",
		"type": "living",
		"scope": "individual",
		"iso6393": "keb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Keiga",
		"type": "living",
		"scope": "individual",
		"iso6393": "kec",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kerewe",
		"type": "living",
		"scope": "individual",
		"iso6393": "ked",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Keres",
		"type": "living",
		"scope": "individual",
		"iso6393": "kee",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kpessi",
		"type": "living",
		"scope": "individual",
		"iso6393": "kef",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tese",
		"type": "living",
		"scope": "individual",
		"iso6393": "keg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Keak",
		"type": "living",
		"scope": "individual",
		"iso6393": "keh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kei",
		"type": "living",
		"scope": "individual",
		"iso6393": "kei",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kadar",
		"type": "living",
		"scope": "individual",
		"iso6393": "kej",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kekchí",
		"type": "living",
		"scope": "individual",
		"iso6393": "kek",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kela (Democratic Republic of Congo)",
		"type": "living",
		"scope": "individual",
		"iso6393": "kel",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kemak",
		"type": "living",
		"scope": "individual",
		"iso6393": "kem",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kenyang",
		"type": "living",
		"scope": "individual",
		"iso6393": "ken",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kakwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "keo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kaikadi",
		"type": "living",
		"scope": "individual",
		"iso6393": "kep",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kamar",
		"type": "living",
		"scope": "individual",
		"iso6393": "keq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kera",
		"type": "living",
		"scope": "individual",
		"iso6393": "ker",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kugbo",
		"type": "living",
		"scope": "individual",
		"iso6393": "kes",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ket",
		"type": "living",
		"scope": "individual",
		"iso6393": "ket",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Akebu",
		"type": "living",
		"scope": "individual",
		"iso6393": "keu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kanikkaran",
		"type": "living",
		"scope": "individual",
		"iso6393": "kev",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "West Kewa",
		"type": "living",
		"scope": "individual",
		"iso6393": "kew",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kukna",
		"type": "living",
		"scope": "individual",
		"iso6393": "kex",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kupia",
		"type": "living",
		"scope": "individual",
		"iso6393": "key",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kukele",
		"type": "living",
		"scope": "individual",
		"iso6393": "kez",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kodava",
		"type": "living",
		"scope": "individual",
		"iso6393": "kfa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northwestern Kolami",
		"type": "living",
		"scope": "individual",
		"iso6393": "kfb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Konda-Dora",
		"type": "living",
		"scope": "individual",
		"iso6393": "kfc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Korra Koraga",
		"type": "living",
		"scope": "individual",
		"iso6393": "kfd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kota (India)",
		"type": "living",
		"scope": "individual",
		"iso6393": "kfe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koya",
		"type": "living",
		"scope": "individual",
		"iso6393": "kff",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kudiya",
		"type": "living",
		"scope": "individual",
		"iso6393": "kfg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kurichiya",
		"type": "living",
		"scope": "individual",
		"iso6393": "kfh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kannada Kurumba",
		"type": "living",
		"scope": "individual",
		"iso6393": "kfi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kemiehua",
		"type": "living",
		"scope": "individual",
		"iso6393": "kfj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kinnauri",
		"type": "living",
		"scope": "individual",
		"iso6393": "kfk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kung",
		"type": "living",
		"scope": "individual",
		"iso6393": "kfl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Khunsari",
		"type": "living",
		"scope": "individual",
		"iso6393": "kfm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kuk",
		"type": "living",
		"scope": "individual",
		"iso6393": "kfn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koro (Côte d'Ivoire)",
		"type": "living",
		"scope": "individual",
		"iso6393": "kfo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Korwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "kfp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Korku",
		"type": "living",
		"scope": "individual",
		"iso6393": "kfq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kachhi",
		"type": "living",
		"scope": "individual",
		"iso6393": "kfr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bilaspuri",
		"type": "living",
		"scope": "individual",
		"iso6393": "kfs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kanjari",
		"type": "living",
		"scope": "individual",
		"iso6393": "kft",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Katkari",
		"type": "living",
		"scope": "individual",
		"iso6393": "kfu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kurmukar",
		"type": "living",
		"scope": "individual",
		"iso6393": "kfv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kharam Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "kfw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kullu Pahari",
		"type": "living",
		"scope": "individual",
		"iso6393": "kfx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kumaoni",
		"type": "living",
		"scope": "individual",
		"iso6393": "kfy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koromfé",
		"type": "living",
		"scope": "individual",
		"iso6393": "kfz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koyaga",
		"type": "living",
		"scope": "individual",
		"iso6393": "kga",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kawe",
		"type": "living",
		"scope": "individual",
		"iso6393": "kgb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kataang",
		"type": "living",
		"scope": "individual",
		"iso6393": "kgd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Komering",
		"type": "living",
		"scope": "individual",
		"iso6393": "kge",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kube",
		"type": "living",
		"scope": "individual",
		"iso6393": "kgf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kusunda",
		"type": "living",
		"scope": "individual",
		"iso6393": "kgg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Selangor Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "kgi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gamale Kham",
		"type": "living",
		"scope": "individual",
		"iso6393": "kgj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kaiwá",
		"type": "living",
		"scope": "individual",
		"iso6393": "kgk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kunggari",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "kgl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Karipúna",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "kgm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Karingani",
		"type": "living",
		"scope": "individual",
		"iso6393": "kgn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Krongo",
		"type": "living",
		"scope": "individual",
		"iso6393": "kgo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kaingang",
		"type": "living",
		"scope": "individual",
		"iso6393": "kgp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kamoro",
		"type": "living",
		"scope": "individual",
		"iso6393": "kgq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Abun",
		"type": "living",
		"scope": "individual",
		"iso6393": "kgr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kumbainggar",
		"type": "living",
		"scope": "individual",
		"iso6393": "kgs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Somyev",
		"type": "living",
		"scope": "individual",
		"iso6393": "kgt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kobol",
		"type": "living",
		"scope": "individual",
		"iso6393": "kgu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Karas",
		"type": "living",
		"scope": "individual",
		"iso6393": "kgv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Karon Dori",
		"type": "living",
		"scope": "individual",
		"iso6393": "kgw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kamaru",
		"type": "living",
		"scope": "individual",
		"iso6393": "kgx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kyerung",
		"type": "living",
		"scope": "individual",
		"iso6393": "kgy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Khasi",
		"type": "living",
		"scope": "individual",
		"iso6393": "kha",
		"iso6392B": "kha",
		"iso6392T": "kha",
		"iso6391": null
	},
	{
		"name": "Lü",
		"type": "living",
		"scope": "individual",
		"iso6393": "khb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tukang Besi North",
		"type": "living",
		"scope": "individual",
		"iso6393": "khc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bädi Kanum",
		"type": "living",
		"scope": "individual",
		"iso6393": "khd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Korowai",
		"type": "living",
		"scope": "individual",
		"iso6393": "khe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Khuen",
		"type": "living",
		"scope": "individual",
		"iso6393": "khf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Khams Tibetan",
		"type": "living",
		"scope": "individual",
		"iso6393": "khg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kehu",
		"type": "living",
		"scope": "individual",
		"iso6393": "khh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kuturmi",
		"type": "living",
		"scope": "individual",
		"iso6393": "khj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Halh Mongolian",
		"type": "living",
		"scope": "individual",
		"iso6393": "khk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lusi",
		"type": "living",
		"scope": "individual",
		"iso6393": "khl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Central Khmer",
		"type": "living",
		"scope": "individual",
		"iso6393": "khm",
		"iso6392B": "khm",
		"iso6392T": "khm",
		"iso6391": "km"
	},
	{
		"name": "Khandesi",
		"type": "living",
		"scope": "individual",
		"iso6393": "khn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Khotanese",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "kho",
		"iso6392B": "kho",
		"iso6392T": "kho",
		"iso6391": null
	},
	{
		"name": "Kapori",
		"type": "living",
		"scope": "individual",
		"iso6393": "khp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koyra Chiini Songhay",
		"type": "living",
		"scope": "individual",
		"iso6393": "khq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kharia",
		"type": "living",
		"scope": "individual",
		"iso6393": "khr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kasua",
		"type": "living",
		"scope": "individual",
		"iso6393": "khs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Khamti",
		"type": "living",
		"scope": "individual",
		"iso6393": "kht",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nkhumbi",
		"type": "living",
		"scope": "individual",
		"iso6393": "khu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Khvarshi",
		"type": "living",
		"scope": "individual",
		"iso6393": "khv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Khowar",
		"type": "living",
		"scope": "individual",
		"iso6393": "khw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kanu",
		"type": "living",
		"scope": "individual",
		"iso6393": "khx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kele (Democratic Republic of Congo)",
		"type": "living",
		"scope": "individual",
		"iso6393": "khy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Keapara",
		"type": "living",
		"scope": "individual",
		"iso6393": "khz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kim",
		"type": "living",
		"scope": "individual",
		"iso6393": "kia",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koalib",
		"type": "living",
		"scope": "individual",
		"iso6393": "kib",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kickapoo",
		"type": "living",
		"scope": "individual",
		"iso6393": "kic",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koshin",
		"type": "living",
		"scope": "individual",
		"iso6393": "kid",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kibet",
		"type": "living",
		"scope": "individual",
		"iso6393": "kie",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Parbate Kham",
		"type": "living",
		"scope": "individual",
		"iso6393": "kif",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kimaama",
		"type": "living",
		"scope": "individual",
		"iso6393": "kig",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kilmeri",
		"type": "living",
		"scope": "individual",
		"iso6393": "kih",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kitsai",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "kii",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kilivila",
		"type": "living",
		"scope": "individual",
		"iso6393": "kij",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kikuyu",
		"type": "living",
		"scope": "individual",
		"iso6393": "kik",
		"iso6392B": "kik",
		"iso6392T": "kik",
		"iso6391": "ki"
	},
	{
		"name": "Kariya",
		"type": "living",
		"scope": "individual",
		"iso6393": "kil",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Karagas",
		"type": "living",
		"scope": "individual",
		"iso6393": "kim",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kinyarwanda",
		"type": "living",
		"scope": "individual",
		"iso6393": "kin",
		"iso6392B": "kin",
		"iso6392T": "kin",
		"iso6391": "rw"
	},
	{
		"name": "Kiowa",
		"type": "living",
		"scope": "individual",
		"iso6393": "kio",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sheshi Kham",
		"type": "living",
		"scope": "individual",
		"iso6393": "kip",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kosadle",
		"type": "living",
		"scope": "individual",
		"iso6393": "kiq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kirghiz",
		"type": "living",
		"scope": "individual",
		"iso6393": "kir",
		"iso6392B": "kir",
		"iso6392T": "kir",
		"iso6391": "ky"
	},
	{
		"name": "Kis",
		"type": "living",
		"scope": "individual",
		"iso6393": "kis",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Agob",
		"type": "living",
		"scope": "individual",
		"iso6393": "kit",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kirmanjki (individual language)",
		"type": "living",
		"scope": "individual",
		"iso6393": "kiu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kimbu",
		"type": "living",
		"scope": "individual",
		"iso6393": "kiv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northeast Kiwai",
		"type": "living",
		"scope": "individual",
		"iso6393": "kiw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Khiamniungan Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "kix",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kirikiri",
		"type": "living",
		"scope": "individual",
		"iso6393": "kiy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kisi",
		"type": "living",
		"scope": "individual",
		"iso6393": "kiz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mlap",
		"type": "living",
		"scope": "individual",
		"iso6393": "kja",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Q'anjob'al",
		"type": "living",
		"scope": "individual",
		"iso6393": "kjb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Coastal Konjo",
		"type": "living",
		"scope": "individual",
		"iso6393": "kjc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Kiwai",
		"type": "living",
		"scope": "individual",
		"iso6393": "kjd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kisar",
		"type": "living",
		"scope": "individual",
		"iso6393": "kje",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Khalaj",
		"type": "living",
		"scope": "individual",
		"iso6393": "kjf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Khmu",
		"type": "living",
		"scope": "individual",
		"iso6393": "kjg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Khakas",
		"type": "living",
		"scope": "individual",
		"iso6393": "kjh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zabana",
		"type": "living",
		"scope": "individual",
		"iso6393": "kji",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Khinalugh",
		"type": "living",
		"scope": "individual",
		"iso6393": "kjj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Highland Konjo",
		"type": "living",
		"scope": "individual",
		"iso6393": "kjk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Parbate Kham",
		"type": "living",
		"scope": "individual",
		"iso6393": "kjl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kháng",
		"type": "living",
		"scope": "individual",
		"iso6393": "kjm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kunjen",
		"type": "living",
		"scope": "individual",
		"iso6393": "kjn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Harijan Kinnauri",
		"type": "living",
		"scope": "individual",
		"iso6393": "kjo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pwo Eastern Karen",
		"type": "living",
		"scope": "individual",
		"iso6393": "kjp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Keres",
		"type": "living",
		"scope": "individual",
		"iso6393": "kjq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kurudu",
		"type": "living",
		"scope": "individual",
		"iso6393": "kjr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "East Kewa",
		"type": "living",
		"scope": "individual",
		"iso6393": "kjs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Phrae Pwo Karen",
		"type": "living",
		"scope": "individual",
		"iso6393": "kjt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kashaya",
		"type": "living",
		"scope": "individual",
		"iso6393": "kju",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kaikavian Literary Language",
		"type": "historical",
		"scope": "individual",
		"iso6393": "kjv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ramopa",
		"type": "living",
		"scope": "individual",
		"iso6393": "kjx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Erave",
		"type": "living",
		"scope": "individual",
		"iso6393": "kjy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bumthangkha",
		"type": "living",
		"scope": "individual",
		"iso6393": "kjz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kakanda",
		"type": "living",
		"scope": "individual",
		"iso6393": "kka",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kwerisa",
		"type": "living",
		"scope": "individual",
		"iso6393": "kkb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Odoodee",
		"type": "living",
		"scope": "individual",
		"iso6393": "kkc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kinuku",
		"type": "living",
		"scope": "individual",
		"iso6393": "kkd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kakabe",
		"type": "living",
		"scope": "individual",
		"iso6393": "kke",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kalaktang Monpa",
		"type": "living",
		"scope": "individual",
		"iso6393": "kkf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mabaka Valley Kalinga",
		"type": "living",
		"scope": "individual",
		"iso6393": "kkg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Khün",
		"type": "living",
		"scope": "individual",
		"iso6393": "kkh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kagulu",
		"type": "living",
		"scope": "individual",
		"iso6393": "kki",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kako",
		"type": "living",
		"scope": "individual",
		"iso6393": "kkj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kokota",
		"type": "living",
		"scope": "individual",
		"iso6393": "kkk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kosarek Yale",
		"type": "living",
		"scope": "individual",
		"iso6393": "kkl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kiong",
		"type": "living",
		"scope": "individual",
		"iso6393": "kkm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kon Keu",
		"type": "living",
		"scope": "individual",
		"iso6393": "kkn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Karko",
		"type": "living",
		"scope": "individual",
		"iso6393": "kko",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gugubera",
		"type": "living",
		"scope": "individual",
		"iso6393": "kkp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kaiku",
		"type": "living",
		"scope": "individual",
		"iso6393": "kkq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kir-Balar",
		"type": "living",
		"scope": "individual",
		"iso6393": "kkr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Giiwo",
		"type": "living",
		"scope": "individual",
		"iso6393": "kks",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koi",
		"type": "living",
		"scope": "individual",
		"iso6393": "kkt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tumi",
		"type": "living",
		"scope": "individual",
		"iso6393": "kku",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kangean",
		"type": "living",
		"scope": "individual",
		"iso6393": "kkv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Teke-Kukuya",
		"type": "living",
		"scope": "individual",
		"iso6393": "kkw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kohin",
		"type": "living",
		"scope": "individual",
		"iso6393": "kkx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Guguyimidjir",
		"type": "living",
		"scope": "individual",
		"iso6393": "kky",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kaska",
		"type": "living",
		"scope": "individual",
		"iso6393": "kkz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Klamath-Modoc",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "kla",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kiliwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "klb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kolbila",
		"type": "living",
		"scope": "individual",
		"iso6393": "klc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gamilaraay",
		"type": "living",
		"scope": "individual",
		"iso6393": "kld",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kulung (Nepal)",
		"type": "living",
		"scope": "individual",
		"iso6393": "kle",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kendeje",
		"type": "living",
		"scope": "individual",
		"iso6393": "klf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tagakaulo",
		"type": "living",
		"scope": "individual",
		"iso6393": "klg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Weliki",
		"type": "living",
		"scope": "individual",
		"iso6393": "klh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kalumpang",
		"type": "living",
		"scope": "individual",
		"iso6393": "kli",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Turkic Khalaj",
		"type": "living",
		"scope": "individual",
		"iso6393": "klj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kono (Nigeria)",
		"type": "living",
		"scope": "individual",
		"iso6393": "klk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kagan Kalagan",
		"type": "living",
		"scope": "individual",
		"iso6393": "kll",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Migum",
		"type": "living",
		"scope": "individual",
		"iso6393": "klm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kalenjin",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "kln",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kapya",
		"type": "living",
		"scope": "individual",
		"iso6393": "klo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kamasa",
		"type": "living",
		"scope": "individual",
		"iso6393": "klp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rumu",
		"type": "living",
		"scope": "individual",
		"iso6393": "klq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Khaling",
		"type": "living",
		"scope": "individual",
		"iso6393": "klr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kalasha",
		"type": "living",
		"scope": "individual",
		"iso6393": "kls",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nukna",
		"type": "living",
		"scope": "individual",
		"iso6393": "klt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Klao",
		"type": "living",
		"scope": "individual",
		"iso6393": "klu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maskelynes",
		"type": "living",
		"scope": "individual",
		"iso6393": "klv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lindu",
		"type": "living",
		"scope": "individual",
		"iso6393": "klw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koluwawa",
		"type": "living",
		"scope": "individual",
		"iso6393": "klx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kalao",
		"type": "living",
		"scope": "individual",
		"iso6393": "kly",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kabola",
		"type": "living",
		"scope": "individual",
		"iso6393": "klz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Konni",
		"type": "living",
		"scope": "individual",
		"iso6393": "kma",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kimbundu",
		"type": "living",
		"scope": "individual",
		"iso6393": "kmb",
		"iso6392B": "kmb",
		"iso6392T": "kmb",
		"iso6391": null
	},
	{
		"name": "Southern Dong",
		"type": "living",
		"scope": "individual",
		"iso6393": "kmc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Majukayang Kalinga",
		"type": "living",
		"scope": "individual",
		"iso6393": "kmd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bakole",
		"type": "living",
		"scope": "individual",
		"iso6393": "kme",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kare (Papua New Guinea)",
		"type": "living",
		"scope": "individual",
		"iso6393": "kmf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kâte",
		"type": "living",
		"scope": "individual",
		"iso6393": "kmg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kalam",
		"type": "living",
		"scope": "individual",
		"iso6393": "kmh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kami (Nigeria)",
		"type": "living",
		"scope": "individual",
		"iso6393": "kmi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kumarbhag Paharia",
		"type": "living",
		"scope": "individual",
		"iso6393": "kmj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Limos Kalinga",
		"type": "living",
		"scope": "individual",
		"iso6393": "kmk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tanudan Kalinga",
		"type": "living",
		"scope": "individual",
		"iso6393": "kml",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kom (India)",
		"type": "living",
		"scope": "individual",
		"iso6393": "kmm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Awtuw",
		"type": "living",
		"scope": "individual",
		"iso6393": "kmn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kwoma",
		"type": "living",
		"scope": "individual",
		"iso6393": "kmo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gimme",
		"type": "living",
		"scope": "individual",
		"iso6393": "kmp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kwama",
		"type": "living",
		"scope": "individual",
		"iso6393": "kmq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Kurdish",
		"type": "living",
		"scope": "individual",
		"iso6393": "kmr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kamasau",
		"type": "living",
		"scope": "individual",
		"iso6393": "kms",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kemtuik",
		"type": "living",
		"scope": "individual",
		"iso6393": "kmt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kanite",
		"type": "living",
		"scope": "individual",
		"iso6393": "kmu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Karipúna Creole French",
		"type": "living",
		"scope": "individual",
		"iso6393": "kmv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Komo (Democratic Republic of Congo)",
		"type": "living",
		"scope": "individual",
		"iso6393": "kmw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Waboda",
		"type": "living",
		"scope": "individual",
		"iso6393": "kmx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koma",
		"type": "living",
		"scope": "individual",
		"iso6393": "kmy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Khorasani Turkish",
		"type": "living",
		"scope": "individual",
		"iso6393": "kmz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dera (Nigeria)",
		"type": "living",
		"scope": "individual",
		"iso6393": "kna",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lubuagan Kalinga",
		"type": "living",
		"scope": "individual",
		"iso6393": "knb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Central Kanuri",
		"type": "living",
		"scope": "individual",
		"iso6393": "knc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Konda",
		"type": "living",
		"scope": "individual",
		"iso6393": "knd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kankanaey",
		"type": "living",
		"scope": "individual",
		"iso6393": "kne",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mankanya",
		"type": "living",
		"scope": "individual",
		"iso6393": "knf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koongo",
		"type": "living",
		"scope": "individual",
		"iso6393": "kng",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kanufi",
		"type": "living",
		"scope": "individual",
		"iso6393": "kni",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Kanjobal",
		"type": "living",
		"scope": "individual",
		"iso6393": "knj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kuranko",
		"type": "living",
		"scope": "individual",
		"iso6393": "knk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Keninjal",
		"type": "living",
		"scope": "individual",
		"iso6393": "knl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kanamarí",
		"type": "living",
		"scope": "individual",
		"iso6393": "knm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Konkani (individual language)",
		"type": "living",
		"scope": "individual",
		"iso6393": "knn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kono (Sierra Leone)",
		"type": "living",
		"scope": "individual",
		"iso6393": "kno",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kwanja",
		"type": "living",
		"scope": "individual",
		"iso6393": "knp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kintaq",
		"type": "living",
		"scope": "individual",
		"iso6393": "knq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kaningra",
		"type": "living",
		"scope": "individual",
		"iso6393": "knr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kensiu",
		"type": "living",
		"scope": "individual",
		"iso6393": "kns",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Panoan Katukína",
		"type": "living",
		"scope": "individual",
		"iso6393": "knt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kono (Guinea)",
		"type": "living",
		"scope": "individual",
		"iso6393": "knu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tabo",
		"type": "living",
		"scope": "individual",
		"iso6393": "knv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kung-Ekoka",
		"type": "living",
		"scope": "individual",
		"iso6393": "knw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kendayan",
		"type": "living",
		"scope": "individual",
		"iso6393": "knx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kanyok",
		"type": "living",
		"scope": "individual",
		"iso6393": "kny",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kalamsé",
		"type": "living",
		"scope": "individual",
		"iso6393": "knz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Konomala",
		"type": "living",
		"scope": "individual",
		"iso6393": "koa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kpati",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "koc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kodi",
		"type": "living",
		"scope": "individual",
		"iso6393": "kod",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kacipo-Balesi",
		"type": "living",
		"scope": "individual",
		"iso6393": "koe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kubi",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "kof",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cogui",
		"type": "living",
		"scope": "individual",
		"iso6393": "kog",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koyo",
		"type": "living",
		"scope": "individual",
		"iso6393": "koh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Komi-Permyak",
		"type": "living",
		"scope": "individual",
		"iso6393": "koi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Konkani (macrolanguage)",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "kok",
		"iso6392B": "kok",
		"iso6392T": "kok",
		"iso6391": null
	},
	{
		"name": "Kol (Papua New Guinea)",
		"type": "living",
		"scope": "individual",
		"iso6393": "kol",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Komi",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "kom",
		"iso6392B": "kom",
		"iso6392T": "kom",
		"iso6391": "kv"
	},
	{
		"name": "Kongo",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "kon",
		"iso6392B": "kon",
		"iso6392T": "kon",
		"iso6391": "kg"
	},
	{
		"name": "Konzo",
		"type": "living",
		"scope": "individual",
		"iso6393": "koo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Waube",
		"type": "living",
		"scope": "individual",
		"iso6393": "kop",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kota (Gabon)",
		"type": "living",
		"scope": "individual",
		"iso6393": "koq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Korean",
		"type": "living",
		"scope": "individual",
		"iso6393": "kor",
		"iso6392B": "kor",
		"iso6392T": "kor",
		"iso6391": "ko"
	},
	{
		"name": "Kosraean",
		"type": "living",
		"scope": "individual",
		"iso6393": "kos",
		"iso6392B": "kos",
		"iso6392T": "kos",
		"iso6391": null
	},
	{
		"name": "Lagwan",
		"type": "living",
		"scope": "individual",
		"iso6393": "kot",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koke",
		"type": "living",
		"scope": "individual",
		"iso6393": "kou",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kudu-Camo",
		"type": "living",
		"scope": "individual",
		"iso6393": "kov",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kugama",
		"type": "living",
		"scope": "individual",
		"iso6393": "kow",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koyukon",
		"type": "living",
		"scope": "individual",
		"iso6393": "koy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Korak",
		"type": "living",
		"scope": "individual",
		"iso6393": "koz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kutto",
		"type": "living",
		"scope": "individual",
		"iso6393": "kpa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mullu Kurumba",
		"type": "living",
		"scope": "individual",
		"iso6393": "kpb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Curripaco",
		"type": "living",
		"scope": "individual",
		"iso6393": "kpc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koba",
		"type": "living",
		"scope": "individual",
		"iso6393": "kpd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kpelle",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "kpe",
		"iso6392B": "kpe",
		"iso6392T": "kpe",
		"iso6391": null
	},
	{
		"name": "Komba",
		"type": "living",
		"scope": "individual",
		"iso6393": "kpf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kapingamarangi",
		"type": "living",
		"scope": "individual",
		"iso6393": "kpg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kplang",
		"type": "living",
		"scope": "individual",
		"iso6393": "kph",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kofei",
		"type": "living",
		"scope": "individual",
		"iso6393": "kpi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Karajá",
		"type": "living",
		"scope": "individual",
		"iso6393": "kpj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kpan",
		"type": "living",
		"scope": "individual",
		"iso6393": "kpk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kpala",
		"type": "living",
		"scope": "individual",
		"iso6393": "kpl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koho",
		"type": "living",
		"scope": "individual",
		"iso6393": "kpm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kepkiriwát",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "kpn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ikposo",
		"type": "living",
		"scope": "individual",
		"iso6393": "kpo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Korupun-Sela",
		"type": "living",
		"scope": "individual",
		"iso6393": "kpq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Korafe-Yegha",
		"type": "living",
		"scope": "individual",
		"iso6393": "kpr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tehit",
		"type": "living",
		"scope": "individual",
		"iso6393": "kps",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Karata",
		"type": "living",
		"scope": "individual",
		"iso6393": "kpt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kafoa",
		"type": "living",
		"scope": "individual",
		"iso6393": "kpu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Komi-Zyrian",
		"type": "living",
		"scope": "individual",
		"iso6393": "kpv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kobon",
		"type": "living",
		"scope": "individual",
		"iso6393": "kpw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mountain Koiali",
		"type": "living",
		"scope": "individual",
		"iso6393": "kpx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koryak",
		"type": "living",
		"scope": "individual",
		"iso6393": "kpy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kupsabiny",
		"type": "living",
		"scope": "individual",
		"iso6393": "kpz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mum",
		"type": "living",
		"scope": "individual",
		"iso6393": "kqa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kovai",
		"type": "living",
		"scope": "individual",
		"iso6393": "kqb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Doromu-Koki",
		"type": "living",
		"scope": "individual",
		"iso6393": "kqc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koy Sanjaq Surat",
		"type": "living",
		"scope": "individual",
		"iso6393": "kqd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kalagan",
		"type": "living",
		"scope": "individual",
		"iso6393": "kqe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kakabai",
		"type": "living",
		"scope": "individual",
		"iso6393": "kqf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Khe",
		"type": "living",
		"scope": "individual",
		"iso6393": "kqg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kisankasa",
		"type": "living",
		"scope": "individual",
		"iso6393": "kqh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koitabu",
		"type": "living",
		"scope": "individual",
		"iso6393": "kqi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koromira",
		"type": "living",
		"scope": "individual",
		"iso6393": "kqj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kotafon Gbe",
		"type": "living",
		"scope": "individual",
		"iso6393": "kqk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kyenele",
		"type": "living",
		"scope": "individual",
		"iso6393": "kql",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Khisa",
		"type": "living",
		"scope": "individual",
		"iso6393": "kqm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kaonde",
		"type": "living",
		"scope": "individual",
		"iso6393": "kqn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Krahn",
		"type": "living",
		"scope": "individual",
		"iso6393": "kqo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kimré",
		"type": "living",
		"scope": "individual",
		"iso6393": "kqp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Krenak",
		"type": "living",
		"scope": "individual",
		"iso6393": "kqq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kimaragang",
		"type": "living",
		"scope": "individual",
		"iso6393": "kqr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Kissi",
		"type": "living",
		"scope": "individual",
		"iso6393": "kqs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Klias River Kadazan",
		"type": "living",
		"scope": "individual",
		"iso6393": "kqt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Seroa",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "kqu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Okolod",
		"type": "living",
		"scope": "individual",
		"iso6393": "kqv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kandas",
		"type": "living",
		"scope": "individual",
		"iso6393": "kqw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mser",
		"type": "living",
		"scope": "individual",
		"iso6393": "kqx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koorete",
		"type": "living",
		"scope": "individual",
		"iso6393": "kqy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Korana",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "kqz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kumhali",
		"type": "living",
		"scope": "individual",
		"iso6393": "kra",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Karkin",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "krb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Karachay-Balkar",
		"type": "living",
		"scope": "individual",
		"iso6393": "krc",
		"iso6392B": "krc",
		"iso6392T": "krc",
		"iso6391": null
	},
	{
		"name": "Kairui-Midiki",
		"type": "living",
		"scope": "individual",
		"iso6393": "krd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Panará",
		"type": "living",
		"scope": "individual",
		"iso6393": "kre",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koro (Vanuatu)",
		"type": "living",
		"scope": "individual",
		"iso6393": "krf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kurama",
		"type": "living",
		"scope": "individual",
		"iso6393": "krh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Krio",
		"type": "living",
		"scope": "individual",
		"iso6393": "kri",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kinaray-A",
		"type": "living",
		"scope": "individual",
		"iso6393": "krj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kerek",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "krk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Karelian",
		"type": "living",
		"scope": "individual",
		"iso6393": "krl",
		"iso6392B": "krl",
		"iso6392T": "krl",
		"iso6391": null
	},
	{
		"name": "Krim",
		"type": "living",
		"scope": "individual",
		"iso6393": "krm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sapo",
		"type": "living",
		"scope": "individual",
		"iso6393": "krn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Korop",
		"type": "living",
		"scope": "individual",
		"iso6393": "krp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kru'ng 2",
		"type": "living",
		"scope": "individual",
		"iso6393": "krr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gbaya (Sudan)",
		"type": "living",
		"scope": "individual",
		"iso6393": "krs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tumari Kanuri",
		"type": "living",
		"scope": "individual",
		"iso6393": "krt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kurukh",
		"type": "living",
		"scope": "individual",
		"iso6393": "kru",
		"iso6392B": "kru",
		"iso6392T": "kru",
		"iso6391": null
	},
	{
		"name": "Kavet",
		"type": "living",
		"scope": "individual",
		"iso6393": "krv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Krahn",
		"type": "living",
		"scope": "individual",
		"iso6393": "krw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Karon",
		"type": "living",
		"scope": "individual",
		"iso6393": "krx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kryts",
		"type": "living",
		"scope": "individual",
		"iso6393": "kry",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sota Kanum",
		"type": "living",
		"scope": "individual",
		"iso6393": "krz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shuwa-Zamani",
		"type": "living",
		"scope": "individual",
		"iso6393": "ksa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shambala",
		"type": "living",
		"scope": "individual",
		"iso6393": "ksb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Kalinga",
		"type": "living",
		"scope": "individual",
		"iso6393": "ksc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kuanua",
		"type": "living",
		"scope": "individual",
		"iso6393": "ksd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kuni",
		"type": "living",
		"scope": "individual",
		"iso6393": "kse",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bafia",
		"type": "living",
		"scope": "individual",
		"iso6393": "ksf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kusaghe",
		"type": "living",
		"scope": "individual",
		"iso6393": "ksg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kölsch",
		"type": "living",
		"scope": "individual",
		"iso6393": "ksh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Krisa",
		"type": "living",
		"scope": "individual",
		"iso6393": "ksi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Uare",
		"type": "living",
		"scope": "individual",
		"iso6393": "ksj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kansa",
		"type": "living",
		"scope": "individual",
		"iso6393": "ksk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kumalu",
		"type": "living",
		"scope": "individual",
		"iso6393": "ksl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kumba",
		"type": "living",
		"scope": "individual",
		"iso6393": "ksm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kasiguranin",
		"type": "living",
		"scope": "individual",
		"iso6393": "ksn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kofa",
		"type": "living",
		"scope": "individual",
		"iso6393": "kso",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kaba",
		"type": "living",
		"scope": "individual",
		"iso6393": "ksp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kwaami",
		"type": "living",
		"scope": "individual",
		"iso6393": "ksq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Borong",
		"type": "living",
		"scope": "individual",
		"iso6393": "ksr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Kisi",
		"type": "living",
		"scope": "individual",
		"iso6393": "kss",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Winyé",
		"type": "living",
		"scope": "individual",
		"iso6393": "kst",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Khamyang",
		"type": "living",
		"scope": "individual",
		"iso6393": "ksu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kusu",
		"type": "living",
		"scope": "individual",
		"iso6393": "ksv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "S'gaw Karen",
		"type": "living",
		"scope": "individual",
		"iso6393": "ksw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kedang",
		"type": "living",
		"scope": "individual",
		"iso6393": "ksx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kharia Thar",
		"type": "living",
		"scope": "individual",
		"iso6393": "ksy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kodaku",
		"type": "living",
		"scope": "individual",
		"iso6393": "ksz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Katua",
		"type": "living",
		"scope": "individual",
		"iso6393": "kta",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kambaata",
		"type": "living",
		"scope": "individual",
		"iso6393": "ktb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kholok",
		"type": "living",
		"scope": "individual",
		"iso6393": "ktc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kokata",
		"type": "living",
		"scope": "individual",
		"iso6393": "ktd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nubri",
		"type": "living",
		"scope": "individual",
		"iso6393": "kte",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kwami",
		"type": "living",
		"scope": "individual",
		"iso6393": "ktf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kalkutung",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ktg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Karanga",
		"type": "living",
		"scope": "individual",
		"iso6393": "kth",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "North Muyu",
		"type": "living",
		"scope": "individual",
		"iso6393": "kti",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Plapo Krumen",
		"type": "living",
		"scope": "individual",
		"iso6393": "ktj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kaniet",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ktk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koroshi",
		"type": "living",
		"scope": "individual",
		"iso6393": "ktl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kurti",
		"type": "living",
		"scope": "individual",
		"iso6393": "ktm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Karitiâna",
		"type": "living",
		"scope": "individual",
		"iso6393": "ktn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kuot",
		"type": "living",
		"scope": "individual",
		"iso6393": "kto",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kaduo",
		"type": "living",
		"scope": "individual",
		"iso6393": "ktp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Katabaga",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ktq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "South Muyu",
		"type": "living",
		"scope": "individual",
		"iso6393": "kts",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ketum",
		"type": "living",
		"scope": "individual",
		"iso6393": "ktt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kituba (Democratic Republic of Congo)",
		"type": "living",
		"scope": "individual",
		"iso6393": "ktu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Katu",
		"type": "living",
		"scope": "individual",
		"iso6393": "ktv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kato",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ktw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kaxararí",
		"type": "living",
		"scope": "individual",
		"iso6393": "ktx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kango (Bas-Uélé District)",
		"type": "living",
		"scope": "individual",
		"iso6393": "kty",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ju/'hoan",
		"type": "living",
		"scope": "individual",
		"iso6393": "ktz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kuanyama",
		"type": "living",
		"scope": "individual",
		"iso6393": "kua",
		"iso6392B": "kua",
		"iso6392T": "kua",
		"iso6391": "kj"
	},
	{
		"name": "Kutep",
		"type": "living",
		"scope": "individual",
		"iso6393": "kub",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kwinsu",
		"type": "living",
		"scope": "individual",
		"iso6393": "kuc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "'Auhelawa",
		"type": "living",
		"scope": "individual",
		"iso6393": "kud",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kuman (Papua New Guinea)",
		"type": "living",
		"scope": "individual",
		"iso6393": "kue",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Katu",
		"type": "living",
		"scope": "individual",
		"iso6393": "kuf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kupa",
		"type": "living",
		"scope": "individual",
		"iso6393": "kug",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kushi",
		"type": "living",
		"scope": "individual",
		"iso6393": "kuh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kuikúro-Kalapálo",
		"type": "living",
		"scope": "individual",
		"iso6393": "kui",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kuria",
		"type": "living",
		"scope": "individual",
		"iso6393": "kuj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kepo'",
		"type": "living",
		"scope": "individual",
		"iso6393": "kuk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kulere",
		"type": "living",
		"scope": "individual",
		"iso6393": "kul",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kumyk",
		"type": "living",
		"scope": "individual",
		"iso6393": "kum",
		"iso6392B": "kum",
		"iso6392T": "kum",
		"iso6391": null
	},
	{
		"name": "Kunama",
		"type": "living",
		"scope": "individual",
		"iso6393": "kun",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kumukio",
		"type": "living",
		"scope": "individual",
		"iso6393": "kuo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kunimaipa",
		"type": "living",
		"scope": "individual",
		"iso6393": "kup",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Karipuna",
		"type": "living",
		"scope": "individual",
		"iso6393": "kuq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kurdish",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "kur",
		"iso6392B": "kur",
		"iso6392T": "kur",
		"iso6391": "ku"
	},
	{
		"name": "Kusaal",
		"type": "living",
		"scope": "individual",
		"iso6393": "kus",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kutenai",
		"type": "living",
		"scope": "individual",
		"iso6393": "kut",
		"iso6392B": "kut",
		"iso6392T": "kut",
		"iso6391": null
	},
	{
		"name": "Upper Kuskokwim",
		"type": "living",
		"scope": "individual",
		"iso6393": "kuu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kur",
		"type": "living",
		"scope": "individual",
		"iso6393": "kuv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kpagua",
		"type": "living",
		"scope": "individual",
		"iso6393": "kuw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kukatja",
		"type": "living",
		"scope": "individual",
		"iso6393": "kux",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kuuku-Ya'u",
		"type": "living",
		"scope": "individual",
		"iso6393": "kuy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kunza",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "kuz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bagvalal",
		"type": "living",
		"scope": "individual",
		"iso6393": "kva",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kubu",
		"type": "living",
		"scope": "individual",
		"iso6393": "kvb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kove",
		"type": "living",
		"scope": "individual",
		"iso6393": "kvc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kui (Indonesia)",
		"type": "living",
		"scope": "individual",
		"iso6393": "kvd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kalabakan",
		"type": "living",
		"scope": "individual",
		"iso6393": "kve",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kabalai",
		"type": "living",
		"scope": "individual",
		"iso6393": "kvf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kuni-Boazi",
		"type": "living",
		"scope": "individual",
		"iso6393": "kvg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Komodo",
		"type": "living",
		"scope": "individual",
		"iso6393": "kvh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kwang",
		"type": "living",
		"scope": "individual",
		"iso6393": "kvi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Psikye",
		"type": "living",
		"scope": "individual",
		"iso6393": "kvj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Korean Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "kvk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kayaw",
		"type": "living",
		"scope": "individual",
		"iso6393": "kvl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kendem",
		"type": "living",
		"scope": "individual",
		"iso6393": "kvm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Border Kuna",
		"type": "living",
		"scope": "individual",
		"iso6393": "kvn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dobel",
		"type": "living",
		"scope": "individual",
		"iso6393": "kvo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kompane",
		"type": "living",
		"scope": "individual",
		"iso6393": "kvp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Geba Karen",
		"type": "living",
		"scope": "individual",
		"iso6393": "kvq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kerinci",
		"type": "living",
		"scope": "individual",
		"iso6393": "kvr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lahta Karen",
		"type": "living",
		"scope": "individual",
		"iso6393": "kvt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yinbaw Karen",
		"type": "living",
		"scope": "individual",
		"iso6393": "kvu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kola",
		"type": "living",
		"scope": "individual",
		"iso6393": "kvv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wersing",
		"type": "living",
		"scope": "individual",
		"iso6393": "kvw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Parkari Koli",
		"type": "living",
		"scope": "individual",
		"iso6393": "kvx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yintale Karen",
		"type": "living",
		"scope": "individual",
		"iso6393": "kvy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tsakwambo",
		"type": "living",
		"scope": "individual",
		"iso6393": "kvz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dâw",
		"type": "living",
		"scope": "individual",
		"iso6393": "kwa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "kwb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Likwala",
		"type": "living",
		"scope": "individual",
		"iso6393": "kwc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kwaio",
		"type": "living",
		"scope": "individual",
		"iso6393": "kwd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kwerba",
		"type": "living",
		"scope": "individual",
		"iso6393": "kwe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kwara'ae",
		"type": "living",
		"scope": "individual",
		"iso6393": "kwf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sara Kaba Deme",
		"type": "living",
		"scope": "individual",
		"iso6393": "kwg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kowiai",
		"type": "living",
		"scope": "individual",
		"iso6393": "kwh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Awa-Cuaiquer",
		"type": "living",
		"scope": "individual",
		"iso6393": "kwi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kwanga",
		"type": "living",
		"scope": "individual",
		"iso6393": "kwj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kwakiutl",
		"type": "living",
		"scope": "individual",
		"iso6393": "kwk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kofyar",
		"type": "living",
		"scope": "individual",
		"iso6393": "kwl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kwambi",
		"type": "living",
		"scope": "individual",
		"iso6393": "kwm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kwangali",
		"type": "living",
		"scope": "individual",
		"iso6393": "kwn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kwomtari",
		"type": "living",
		"scope": "individual",
		"iso6393": "kwo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kodia",
		"type": "living",
		"scope": "individual",
		"iso6393": "kwp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kwer",
		"type": "living",
		"scope": "individual",
		"iso6393": "kwr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kwese",
		"type": "living",
		"scope": "individual",
		"iso6393": "kws",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kwesten",
		"type": "living",
		"scope": "individual",
		"iso6393": "kwt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kwakum",
		"type": "living",
		"scope": "individual",
		"iso6393": "kwu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sara Kaba Náà",
		"type": "living",
		"scope": "individual",
		"iso6393": "kwv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kwinti",
		"type": "living",
		"scope": "individual",
		"iso6393": "kww",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Khirwar",
		"type": "living",
		"scope": "individual",
		"iso6393": "kwx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "San Salvador Kongo",
		"type": "living",
		"scope": "individual",
		"iso6393": "kwy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kwadi",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "kwz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kairiru",
		"type": "living",
		"scope": "individual",
		"iso6393": "kxa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Krobu",
		"type": "living",
		"scope": "individual",
		"iso6393": "kxb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Konso",
		"type": "living",
		"scope": "individual",
		"iso6393": "kxc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Brunei",
		"type": "living",
		"scope": "individual",
		"iso6393": "kxd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Manumanaw Karen",
		"type": "living",
		"scope": "individual",
		"iso6393": "kxf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Karo (Ethiopia)",
		"type": "living",
		"scope": "individual",
		"iso6393": "kxh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Keningau Murut",
		"type": "living",
		"scope": "individual",
		"iso6393": "kxi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kulfa",
		"type": "living",
		"scope": "individual",
		"iso6393": "kxj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zayein Karen",
		"type": "living",
		"scope": "individual",
		"iso6393": "kxk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nepali Kurux",
		"type": "living",
		"scope": "individual",
		"iso6393": "kxl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Khmer",
		"type": "living",
		"scope": "individual",
		"iso6393": "kxm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kanowit-Tanjong Melanau",
		"type": "living",
		"scope": "individual",
		"iso6393": "kxn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kanoé",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "kxo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wadiyara Koli",
		"type": "living",
		"scope": "individual",
		"iso6393": "kxp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Smärky Kanum",
		"type": "living",
		"scope": "individual",
		"iso6393": "kxq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koro (Papua New Guinea)",
		"type": "living",
		"scope": "individual",
		"iso6393": "kxr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kangjia",
		"type": "living",
		"scope": "individual",
		"iso6393": "kxs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koiwat",
		"type": "living",
		"scope": "individual",
		"iso6393": "kxt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kui (India)",
		"type": "living",
		"scope": "individual",
		"iso6393": "kxu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kuvi",
		"type": "living",
		"scope": "individual",
		"iso6393": "kxv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Konai",
		"type": "living",
		"scope": "individual",
		"iso6393": "kxw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Likuba",
		"type": "living",
		"scope": "individual",
		"iso6393": "kxx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kayong",
		"type": "living",
		"scope": "individual",
		"iso6393": "kxy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kerewo",
		"type": "living",
		"scope": "individual",
		"iso6393": "kxz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kwaya",
		"type": "living",
		"scope": "individual",
		"iso6393": "kya",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Butbut Kalinga",
		"type": "living",
		"scope": "individual",
		"iso6393": "kyb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kyaka",
		"type": "living",
		"scope": "individual",
		"iso6393": "kyc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Karey",
		"type": "living",
		"scope": "individual",
		"iso6393": "kyd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Krache",
		"type": "living",
		"scope": "individual",
		"iso6393": "kye",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kouya",
		"type": "living",
		"scope": "individual",
		"iso6393": "kyf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Keyagana",
		"type": "living",
		"scope": "individual",
		"iso6393": "kyg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Karok",
		"type": "living",
		"scope": "individual",
		"iso6393": "kyh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kiput",
		"type": "living",
		"scope": "individual",
		"iso6393": "kyi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Karao",
		"type": "living",
		"scope": "individual",
		"iso6393": "kyj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kamayo",
		"type": "living",
		"scope": "individual",
		"iso6393": "kyk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kalapuya",
		"type": "living",
		"scope": "individual",
		"iso6393": "kyl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kpatili",
		"type": "living",
		"scope": "individual",
		"iso6393": "kym",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Binukidnon",
		"type": "living",
		"scope": "individual",
		"iso6393": "kyn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kelon",
		"type": "living",
		"scope": "individual",
		"iso6393": "kyo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kang",
		"type": "living",
		"scope": "individual",
		"iso6393": "kyp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kenga",
		"type": "living",
		"scope": "individual",
		"iso6393": "kyq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kuruáya",
		"type": "living",
		"scope": "individual",
		"iso6393": "kyr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baram Kayan",
		"type": "living",
		"scope": "individual",
		"iso6393": "kys",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kayagar",
		"type": "living",
		"scope": "individual",
		"iso6393": "kyt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Kayah",
		"type": "living",
		"scope": "individual",
		"iso6393": "kyu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kayort",
		"type": "living",
		"scope": "individual",
		"iso6393": "kyv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kudmali",
		"type": "living",
		"scope": "individual",
		"iso6393": "kyw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rapoisi",
		"type": "living",
		"scope": "individual",
		"iso6393": "kyx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kambaira",
		"type": "living",
		"scope": "individual",
		"iso6393": "kyy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kayabí",
		"type": "living",
		"scope": "individual",
		"iso6393": "kyz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Karaboro",
		"type": "living",
		"scope": "individual",
		"iso6393": "kza",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kaibobo",
		"type": "living",
		"scope": "individual",
		"iso6393": "kzb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bondoukou Kulango",
		"type": "living",
		"scope": "individual",
		"iso6393": "kzc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kadai",
		"type": "living",
		"scope": "individual",
		"iso6393": "kzd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kosena",
		"type": "living",
		"scope": "individual",
		"iso6393": "kze",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Da'a Kaili",
		"type": "living",
		"scope": "individual",
		"iso6393": "kzf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kikai",
		"type": "living",
		"scope": "individual",
		"iso6393": "kzg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kelabit",
		"type": "living",
		"scope": "individual",
		"iso6393": "kzi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kazukuru",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "kzk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kayeli",
		"type": "living",
		"scope": "individual",
		"iso6393": "kzl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kais",
		"type": "living",
		"scope": "individual",
		"iso6393": "kzm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kokola",
		"type": "living",
		"scope": "individual",
		"iso6393": "kzn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kaningi",
		"type": "living",
		"scope": "individual",
		"iso6393": "kzo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kaidipang",
		"type": "living",
		"scope": "individual",
		"iso6393": "kzp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kaike",
		"type": "living",
		"scope": "individual",
		"iso6393": "kzq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Karang",
		"type": "living",
		"scope": "individual",
		"iso6393": "kzr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sugut Dusun",
		"type": "living",
		"scope": "individual",
		"iso6393": "kzs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kayupulau",
		"type": "living",
		"scope": "individual",
		"iso6393": "kzu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Komyandaret",
		"type": "living",
		"scope": "individual",
		"iso6393": "kzv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Karirí-Xocó",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "kzw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kamarian",
		"type": "living",
		"scope": "individual",
		"iso6393": "kzx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kango (Tshopo District)",
		"type": "living",
		"scope": "individual",
		"iso6393": "kzy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kalabra",
		"type": "living",
		"scope": "individual",
		"iso6393": "kzz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Subanen",
		"type": "living",
		"scope": "individual",
		"iso6393": "laa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Linear A",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "lab",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lacandon",
		"type": "living",
		"scope": "individual",
		"iso6393": "lac",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ladino",
		"type": "living",
		"scope": "individual",
		"iso6393": "lad",
		"iso6392B": "lad",
		"iso6392T": "lad",
		"iso6391": null
	},
	{
		"name": "Pattani",
		"type": "living",
		"scope": "individual",
		"iso6393": "lae",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lafofa",
		"type": "living",
		"scope": "individual",
		"iso6393": "laf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Langi",
		"type": "living",
		"scope": "individual",
		"iso6393": "lag",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lahnda",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "lah",
		"iso6392B": "lah",
		"iso6392T": "lah",
		"iso6391": null
	},
	{
		"name": "Lambya",
		"type": "living",
		"scope": "individual",
		"iso6393": "lai",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lango (Uganda)",
		"type": "living",
		"scope": "individual",
		"iso6393": "laj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Laka (Nigeria)",
		"type": "living",
		"scope": "individual",
		"iso6393": "lak",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lalia",
		"type": "living",
		"scope": "individual",
		"iso6393": "lal",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lamba",
		"type": "living",
		"scope": "individual",
		"iso6393": "lam",
		"iso6392B": "lam",
		"iso6392T": "lam",
		"iso6391": null
	},
	{
		"name": "Laru",
		"type": "living",
		"scope": "individual",
		"iso6393": "lan",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lao",
		"type": "living",
		"scope": "individual",
		"iso6393": "lao",
		"iso6392B": "lao",
		"iso6392T": "lao",
		"iso6391": "lo"
	},
	{
		"name": "Laka (Chad)",
		"type": "living",
		"scope": "individual",
		"iso6393": "lap",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Qabiao",
		"type": "living",
		"scope": "individual",
		"iso6393": "laq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Larteh",
		"type": "living",
		"scope": "individual",
		"iso6393": "lar",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lama (Togo)",
		"type": "living",
		"scope": "individual",
		"iso6393": "las",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Latin",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "lat",
		"iso6392B": "lat",
		"iso6392T": "lat",
		"iso6391": "la"
	},
	{
		"name": "Laba",
		"type": "living",
		"scope": "individual",
		"iso6393": "lau",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Latvian",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "lav",
		"iso6392B": "lav",
		"iso6392T": "lav",
		"iso6391": "lv"
	},
	{
		"name": "Lauje",
		"type": "living",
		"scope": "individual",
		"iso6393": "law",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tiwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "lax",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lama Bai",
		"type": "living",
		"scope": "individual",
		"iso6393": "lay",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aribwatsa",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "laz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lui",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "lba",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Label",
		"type": "living",
		"scope": "individual",
		"iso6393": "lbb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lakkia",
		"type": "living",
		"scope": "individual",
		"iso6393": "lbc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lak",
		"type": "living",
		"scope": "individual",
		"iso6393": "lbe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tinani",
		"type": "living",
		"scope": "individual",
		"iso6393": "lbf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Laopang",
		"type": "living",
		"scope": "individual",
		"iso6393": "lbg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "La'bi",
		"type": "living",
		"scope": "individual",
		"iso6393": "lbi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ladakhi",
		"type": "living",
		"scope": "individual",
		"iso6393": "lbj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Central Bontok",
		"type": "living",
		"scope": "individual",
		"iso6393": "lbk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Libon Bikol",
		"type": "living",
		"scope": "individual",
		"iso6393": "lbl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lodhi",
		"type": "living",
		"scope": "individual",
		"iso6393": "lbm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lamet",
		"type": "living",
		"scope": "individual",
		"iso6393": "lbn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Laven",
		"type": "living",
		"scope": "individual",
		"iso6393": "lbo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wampar",
		"type": "living",
		"scope": "individual",
		"iso6393": "lbq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lohorung",
		"type": "living",
		"scope": "individual",
		"iso6393": "lbr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Libyan Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "lbs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lachi",
		"type": "living",
		"scope": "individual",
		"iso6393": "lbt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Labu",
		"type": "living",
		"scope": "individual",
		"iso6393": "lbu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lavatbura-Lamusong",
		"type": "living",
		"scope": "individual",
		"iso6393": "lbv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tolaki",
		"type": "living",
		"scope": "individual",
		"iso6393": "lbw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lawangan",
		"type": "living",
		"scope": "individual",
		"iso6393": "lbx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lamu-Lamu",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "lby",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lardil",
		"type": "living",
		"scope": "individual",
		"iso6393": "lbz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Legenyem",
		"type": "living",
		"scope": "individual",
		"iso6393": "lcc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lola",
		"type": "living",
		"scope": "individual",
		"iso6393": "lcd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Loncong",
		"type": "living",
		"scope": "individual",
		"iso6393": "lce",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lubu",
		"type": "living",
		"scope": "individual",
		"iso6393": "lcf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Luchazi",
		"type": "living",
		"scope": "individual",
		"iso6393": "lch",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lisela",
		"type": "living",
		"scope": "individual",
		"iso6393": "lcl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tungag",
		"type": "living",
		"scope": "individual",
		"iso6393": "lcm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Lawa",
		"type": "living",
		"scope": "individual",
		"iso6393": "lcp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Luhu",
		"type": "living",
		"scope": "individual",
		"iso6393": "lcq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lisabata-Nuniali",
		"type": "living",
		"scope": "individual",
		"iso6393": "lcs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kla-Dan",
		"type": "living",
		"scope": "individual",
		"iso6393": "lda",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dũya",
		"type": "living",
		"scope": "individual",
		"iso6393": "ldb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Luri",
		"type": "living",
		"scope": "individual",
		"iso6393": "ldd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lenyima",
		"type": "living",
		"scope": "individual",
		"iso6393": "ldg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lamja-Dengsa-Tola",
		"type": "living",
		"scope": "individual",
		"iso6393": "ldh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Laari",
		"type": "living",
		"scope": "individual",
		"iso6393": "ldi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lemoro",
		"type": "living",
		"scope": "individual",
		"iso6393": "ldj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Leelau",
		"type": "living",
		"scope": "individual",
		"iso6393": "ldk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kaan",
		"type": "living",
		"scope": "individual",
		"iso6393": "ldl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Landoma",
		"type": "living",
		"scope": "individual",
		"iso6393": "ldm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Láadan",
		"type": "constructed",
		"scope": "individual",
		"iso6393": "ldn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Loo",
		"type": "living",
		"scope": "individual",
		"iso6393": "ldo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tso",
		"type": "living",
		"scope": "individual",
		"iso6393": "ldp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lufu",
		"type": "living",
		"scope": "individual",
		"iso6393": "ldq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lega-Shabunda",
		"type": "living",
		"scope": "individual",
		"iso6393": "lea",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lala-Bisa",
		"type": "living",
		"scope": "individual",
		"iso6393": "leb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Leco",
		"type": "living",
		"scope": "individual",
		"iso6393": "lec",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lendu",
		"type": "living",
		"scope": "individual",
		"iso6393": "led",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lyélé",
		"type": "living",
		"scope": "individual",
		"iso6393": "lee",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lelemi",
		"type": "living",
		"scope": "individual",
		"iso6393": "lef",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lenje",
		"type": "living",
		"scope": "individual",
		"iso6393": "leh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lemio",
		"type": "living",
		"scope": "individual",
		"iso6393": "lei",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lengola",
		"type": "living",
		"scope": "individual",
		"iso6393": "lej",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Leipon",
		"type": "living",
		"scope": "individual",
		"iso6393": "lek",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lele (Democratic Republic of Congo)",
		"type": "living",
		"scope": "individual",
		"iso6393": "lel",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nomaande",
		"type": "living",
		"scope": "individual",
		"iso6393": "lem",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lenca",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "len",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Leti (Cameroon)",
		"type": "living",
		"scope": "individual",
		"iso6393": "leo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lepcha",
		"type": "living",
		"scope": "individual",
		"iso6393": "lep",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lembena",
		"type": "living",
		"scope": "individual",
		"iso6393": "leq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lenkau",
		"type": "living",
		"scope": "individual",
		"iso6393": "ler",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lese",
		"type": "living",
		"scope": "individual",
		"iso6393": "les",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lesing-Gelimi",
		"type": "living",
		"scope": "individual",
		"iso6393": "let",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kara (Papua New Guinea)",
		"type": "living",
		"scope": "individual",
		"iso6393": "leu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lamma",
		"type": "living",
		"scope": "individual",
		"iso6393": "lev",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ledo Kaili",
		"type": "living",
		"scope": "individual",
		"iso6393": "lew",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Luang",
		"type": "living",
		"scope": "individual",
		"iso6393": "lex",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lemolang",
		"type": "living",
		"scope": "individual",
		"iso6393": "ley",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lezghian",
		"type": "living",
		"scope": "individual",
		"iso6393": "lez",
		"iso6392B": "lez",
		"iso6392T": "lez",
		"iso6391": null
	},
	{
		"name": "Lefa",
		"type": "living",
		"scope": "individual",
		"iso6393": "lfa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lingua Franca Nova",
		"type": "constructed",
		"scope": "individual",
		"iso6393": "lfn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lungga",
		"type": "living",
		"scope": "individual",
		"iso6393": "lga",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Laghu",
		"type": "living",
		"scope": "individual",
		"iso6393": "lgb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lugbara",
		"type": "living",
		"scope": "individual",
		"iso6393": "lgg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Laghuu",
		"type": "living",
		"scope": "individual",
		"iso6393": "lgh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lengilu",
		"type": "living",
		"scope": "individual",
		"iso6393": "lgi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lingarak",
		"type": "living",
		"scope": "individual",
		"iso6393": "lgk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wala",
		"type": "living",
		"scope": "individual",
		"iso6393": "lgl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lega-Mwenga",
		"type": "living",
		"scope": "individual",
		"iso6393": "lgm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Opuuo",
		"type": "living",
		"scope": "individual",
		"iso6393": "lgn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Logba",
		"type": "living",
		"scope": "individual",
		"iso6393": "lgq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lengo",
		"type": "living",
		"scope": "individual",
		"iso6393": "lgr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pahi",
		"type": "living",
		"scope": "individual",
		"iso6393": "lgt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Longgu",
		"type": "living",
		"scope": "individual",
		"iso6393": "lgu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ligenza",
		"type": "living",
		"scope": "individual",
		"iso6393": "lgz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Laha (Viet Nam)",
		"type": "living",
		"scope": "individual",
		"iso6393": "lha",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Laha (Indonesia)",
		"type": "living",
		"scope": "individual",
		"iso6393": "lhh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lahu Shi",
		"type": "living",
		"scope": "individual",
		"iso6393": "lhi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lahul Lohar",
		"type": "living",
		"scope": "individual",
		"iso6393": "lhl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lhomi",
		"type": "living",
		"scope": "individual",
		"iso6393": "lhm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lahanan",
		"type": "living",
		"scope": "individual",
		"iso6393": "lhn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lhokpu",
		"type": "living",
		"scope": "individual",
		"iso6393": "lhp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mlahsö",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "lhs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lo-Toga",
		"type": "living",
		"scope": "individual",
		"iso6393": "lht",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lahu",
		"type": "living",
		"scope": "individual",
		"iso6393": "lhu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "West-Central Limba",
		"type": "living",
		"scope": "individual",
		"iso6393": "lia",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Likum",
		"type": "living",
		"scope": "individual",
		"iso6393": "lib",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hlai",
		"type": "living",
		"scope": "individual",
		"iso6393": "lic",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyindrou",
		"type": "living",
		"scope": "individual",
		"iso6393": "lid",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Likila",
		"type": "living",
		"scope": "individual",
		"iso6393": "lie",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Limbu",
		"type": "living",
		"scope": "individual",
		"iso6393": "lif",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ligbi",
		"type": "living",
		"scope": "individual",
		"iso6393": "lig",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lihir",
		"type": "living",
		"scope": "individual",
		"iso6393": "lih",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ligurian",
		"type": "living",
		"scope": "individual",
		"iso6393": "lij",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lika",
		"type": "living",
		"scope": "individual",
		"iso6393": "lik",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lillooet",
		"type": "living",
		"scope": "individual",
		"iso6393": "lil",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Limburgan",
		"type": "living",
		"scope": "individual",
		"iso6393": "lim",
		"iso6392B": "lim",
		"iso6392T": "lim",
		"iso6391": "li"
	},
	{
		"name": "Lingala",
		"type": "living",
		"scope": "individual",
		"iso6393": "lin",
		"iso6392B": "lin",
		"iso6392T": "lin",
		"iso6391": "ln"
	},
	{
		"name": "Liki",
		"type": "living",
		"scope": "individual",
		"iso6393": "lio",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sekpele",
		"type": "living",
		"scope": "individual",
		"iso6393": "lip",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Libido",
		"type": "living",
		"scope": "individual",
		"iso6393": "liq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Liberian English",
		"type": "living",
		"scope": "individual",
		"iso6393": "lir",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lisu",
		"type": "living",
		"scope": "individual",
		"iso6393": "lis",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lithuanian",
		"type": "living",
		"scope": "individual",
		"iso6393": "lit",
		"iso6392B": "lit",
		"iso6392T": "lit",
		"iso6391": "lt"
	},
	{
		"name": "Logorik",
		"type": "living",
		"scope": "individual",
		"iso6393": "liu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Liv",
		"type": "living",
		"scope": "individual",
		"iso6393": "liv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Col",
		"type": "living",
		"scope": "individual",
		"iso6393": "liw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Liabuku",
		"type": "living",
		"scope": "individual",
		"iso6393": "lix",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Banda-Bambari",
		"type": "living",
		"scope": "individual",
		"iso6393": "liy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Libinza",
		"type": "living",
		"scope": "individual",
		"iso6393": "liz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Golpa",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "lja",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rampi",
		"type": "living",
		"scope": "individual",
		"iso6393": "lje",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Laiyolo",
		"type": "living",
		"scope": "individual",
		"iso6393": "lji",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Li'o",
		"type": "living",
		"scope": "individual",
		"iso6393": "ljl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lampung Api",
		"type": "living",
		"scope": "individual",
		"iso6393": "ljp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yirandali",
		"type": "living",
		"scope": "individual",
		"iso6393": "ljw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yuru",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ljx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lakalei",
		"type": "living",
		"scope": "individual",
		"iso6393": "lka",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kabras",
		"type": "living",
		"scope": "individual",
		"iso6393": "lkb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kucong",
		"type": "living",
		"scope": "individual",
		"iso6393": "lkc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lakondê",
		"type": "living",
		"scope": "individual",
		"iso6393": "lkd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kenyi",
		"type": "living",
		"scope": "individual",
		"iso6393": "lke",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lakha",
		"type": "living",
		"scope": "individual",
		"iso6393": "lkh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Laki",
		"type": "living",
		"scope": "individual",
		"iso6393": "lki",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Remun",
		"type": "living",
		"scope": "individual",
		"iso6393": "lkj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Laeko-Libuat",
		"type": "living",
		"scope": "individual",
		"iso6393": "lkl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kalaamaya",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "lkm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lakon",
		"type": "living",
		"scope": "individual",
		"iso6393": "lkn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Khayo",
		"type": "living",
		"scope": "individual",
		"iso6393": "lko",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Päri",
		"type": "living",
		"scope": "individual",
		"iso6393": "lkr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kisa",
		"type": "living",
		"scope": "individual",
		"iso6393": "lks",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lakota",
		"type": "living",
		"scope": "individual",
		"iso6393": "lkt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kungkari",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "lku",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lokoya",
		"type": "living",
		"scope": "individual",
		"iso6393": "lky",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lala-Roba",
		"type": "living",
		"scope": "individual",
		"iso6393": "lla",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lolo",
		"type": "living",
		"scope": "individual",
		"iso6393": "llb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lele (Guinea)",
		"type": "living",
		"scope": "individual",
		"iso6393": "llc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ladin",
		"type": "living",
		"scope": "individual",
		"iso6393": "lld",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lele (Papua New Guinea)",
		"type": "living",
		"scope": "individual",
		"iso6393": "lle",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hermit",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "llf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lole",
		"type": "living",
		"scope": "individual",
		"iso6393": "llg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lamu",
		"type": "living",
		"scope": "individual",
		"iso6393": "llh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Teke-Laali",
		"type": "living",
		"scope": "individual",
		"iso6393": "lli",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ladji Ladji",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "llj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lelak",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "llk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lilau",
		"type": "living",
		"scope": "individual",
		"iso6393": "lll",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lasalimu",
		"type": "living",
		"scope": "individual",
		"iso6393": "llm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lele (Chad)",
		"type": "living",
		"scope": "individual",
		"iso6393": "lln",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Khlor",
		"type": "living",
		"scope": "individual",
		"iso6393": "llo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "North Efate",
		"type": "living",
		"scope": "individual",
		"iso6393": "llp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lolak",
		"type": "living",
		"scope": "individual",
		"iso6393": "llq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lithuanian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "lls",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lau",
		"type": "living",
		"scope": "individual",
		"iso6393": "llu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lauan",
		"type": "living",
		"scope": "individual",
		"iso6393": "llx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "East Limba",
		"type": "living",
		"scope": "individual",
		"iso6393": "lma",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Merei",
		"type": "living",
		"scope": "individual",
		"iso6393": "lmb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Limilngan",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "lmc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lumun",
		"type": "living",
		"scope": "individual",
		"iso6393": "lmd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pévé",
		"type": "living",
		"scope": "individual",
		"iso6393": "lme",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "South Lembata",
		"type": "living",
		"scope": "individual",
		"iso6393": "lmf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lamogai",
		"type": "living",
		"scope": "individual",
		"iso6393": "lmg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lambichhong",
		"type": "living",
		"scope": "individual",
		"iso6393": "lmh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lombi",
		"type": "living",
		"scope": "individual",
		"iso6393": "lmi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "West Lembata",
		"type": "living",
		"scope": "individual",
		"iso6393": "lmj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lamkang",
		"type": "living",
		"scope": "individual",
		"iso6393": "lmk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hano",
		"type": "living",
		"scope": "individual",
		"iso6393": "lml",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lambadi",
		"type": "living",
		"scope": "individual",
		"iso6393": "lmn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lombard",
		"type": "living",
		"scope": "individual",
		"iso6393": "lmo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Limbum",
		"type": "living",
		"scope": "individual",
		"iso6393": "lmp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lamatuka",
		"type": "living",
		"scope": "individual",
		"iso6393": "lmq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lamalera",
		"type": "living",
		"scope": "individual",
		"iso6393": "lmr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lamenu",
		"type": "living",
		"scope": "individual",
		"iso6393": "lmu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lomaiviti",
		"type": "living",
		"scope": "individual",
		"iso6393": "lmv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lake Miwok",
		"type": "living",
		"scope": "individual",
		"iso6393": "lmw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Laimbue",
		"type": "living",
		"scope": "individual",
		"iso6393": "lmx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lamboya",
		"type": "living",
		"scope": "individual",
		"iso6393": "lmy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lumbee",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "lmz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Langbashe",
		"type": "living",
		"scope": "individual",
		"iso6393": "lna",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mbalanhu",
		"type": "living",
		"scope": "individual",
		"iso6393": "lnb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lundayeh",
		"type": "living",
		"scope": "individual",
		"iso6393": "lnd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Langobardic",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "lng",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lanoh",
		"type": "living",
		"scope": "individual",
		"iso6393": "lnh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Daantanai'",
		"type": "living",
		"scope": "individual",
		"iso6393": "lni",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Leningitij",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "lnj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "South Central Banda",
		"type": "living",
		"scope": "individual",
		"iso6393": "lnl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Langam",
		"type": "living",
		"scope": "individual",
		"iso6393": "lnm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lorediakarkar",
		"type": "living",
		"scope": "individual",
		"iso6393": "lnn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lango (Sudan)",
		"type": "living",
		"scope": "individual",
		"iso6393": "lno",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lamnso'",
		"type": "living",
		"scope": "individual",
		"iso6393": "lns",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Longuda",
		"type": "living",
		"scope": "individual",
		"iso6393": "lnu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lanima",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "lnw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lonzo",
		"type": "living",
		"scope": "individual",
		"iso6393": "lnz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Loloda",
		"type": "living",
		"scope": "individual",
		"iso6393": "loa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lobi",
		"type": "living",
		"scope": "individual",
		"iso6393": "lob",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Inonhan",
		"type": "living",
		"scope": "individual",
		"iso6393": "loc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Saluan",
		"type": "living",
		"scope": "individual",
		"iso6393": "loe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Logol",
		"type": "living",
		"scope": "individual",
		"iso6393": "lof",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Logo",
		"type": "living",
		"scope": "individual",
		"iso6393": "log",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Narim",
		"type": "living",
		"scope": "individual",
		"iso6393": "loh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Loma (Côte d'Ivoire)",
		"type": "living",
		"scope": "individual",
		"iso6393": "loi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lou",
		"type": "living",
		"scope": "individual",
		"iso6393": "loj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Loko",
		"type": "living",
		"scope": "individual",
		"iso6393": "lok",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mongo",
		"type": "living",
		"scope": "individual",
		"iso6393": "lol",
		"iso6392B": "lol",
		"iso6392T": "lol",
		"iso6391": null
	},
	{
		"name": "Loma (Liberia)",
		"type": "living",
		"scope": "individual",
		"iso6393": "lom",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Malawi Lomwe",
		"type": "living",
		"scope": "individual",
		"iso6393": "lon",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lombo",
		"type": "living",
		"scope": "individual",
		"iso6393": "loo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lopa",
		"type": "living",
		"scope": "individual",
		"iso6393": "lop",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lobala",
		"type": "living",
		"scope": "individual",
		"iso6393": "loq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Téén",
		"type": "living",
		"scope": "individual",
		"iso6393": "lor",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Loniu",
		"type": "living",
		"scope": "individual",
		"iso6393": "los",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Otuho",
		"type": "living",
		"scope": "individual",
		"iso6393": "lot",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Louisiana Creole",
		"type": "living",
		"scope": "individual",
		"iso6393": "lou",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lopi",
		"type": "living",
		"scope": "individual",
		"iso6393": "lov",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tampias Lobu",
		"type": "living",
		"scope": "individual",
		"iso6393": "low",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Loun",
		"type": "living",
		"scope": "individual",
		"iso6393": "lox",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Loke",
		"type": "living",
		"scope": "individual",
		"iso6393": "loy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lozi",
		"type": "living",
		"scope": "individual",
		"iso6393": "loz",
		"iso6392B": "loz",
		"iso6392T": "loz",
		"iso6391": null
	},
	{
		"name": "Lelepa",
		"type": "living",
		"scope": "individual",
		"iso6393": "lpa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lepki",
		"type": "living",
		"scope": "individual",
		"iso6393": "lpe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Long Phuri Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "lpn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lipo",
		"type": "living",
		"scope": "individual",
		"iso6393": "lpo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lopit",
		"type": "living",
		"scope": "individual",
		"iso6393": "lpx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rara Bakati'",
		"type": "living",
		"scope": "individual",
		"iso6393": "lra",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Luri",
		"type": "living",
		"scope": "individual",
		"iso6393": "lrc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Laurentian",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "lre",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Laragia",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "lrg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Marachi",
		"type": "living",
		"scope": "individual",
		"iso6393": "lri",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Loarki",
		"type": "living",
		"scope": "individual",
		"iso6393": "lrk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lari",
		"type": "living",
		"scope": "individual",
		"iso6393": "lrl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Marama",
		"type": "living",
		"scope": "individual",
		"iso6393": "lrm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lorang",
		"type": "living",
		"scope": "individual",
		"iso6393": "lrn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Laro",
		"type": "living",
		"scope": "individual",
		"iso6393": "lro",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Yamphu",
		"type": "living",
		"scope": "individual",
		"iso6393": "lrr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Larantuka Malay",
		"type": "living",
		"scope": "individual",
		"iso6393": "lrt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Larevat",
		"type": "living",
		"scope": "individual",
		"iso6393": "lrv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lemerig",
		"type": "living",
		"scope": "individual",
		"iso6393": "lrz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lasgerdi",
		"type": "living",
		"scope": "individual",
		"iso6393": "lsa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lishana Deni",
		"type": "living",
		"scope": "individual",
		"iso6393": "lsd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lusengo",
		"type": "living",
		"scope": "individual",
		"iso6393": "lse",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lyons Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "lsg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lish",
		"type": "living",
		"scope": "individual",
		"iso6393": "lsh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lashi",
		"type": "living",
		"scope": "individual",
		"iso6393": "lsi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Latvian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "lsl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Saamia",
		"type": "living",
		"scope": "individual",
		"iso6393": "lsm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Laos Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "lso",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Panamanian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "lsp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aruop",
		"type": "living",
		"scope": "individual",
		"iso6393": "lsr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lasi",
		"type": "living",
		"scope": "individual",
		"iso6393": "lss",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Trinidad and Tobago Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "lst",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mauritian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "lsy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Late Middle Chinese",
		"type": "historical",
		"scope": "individual",
		"iso6393": "ltc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Latgalian",
		"type": "living",
		"scope": "individual",
		"iso6393": "ltg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Leti (Indonesia)",
		"type": "living",
		"scope": "individual",
		"iso6393": "lti",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Latundê",
		"type": "living",
		"scope": "individual",
		"iso6393": "ltn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tsotso",
		"type": "living",
		"scope": "individual",
		"iso6393": "lto",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tachoni",
		"type": "living",
		"scope": "individual",
		"iso6393": "lts",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Latu",
		"type": "living",
		"scope": "individual",
		"iso6393": "ltu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Luxembourgish",
		"type": "living",
		"scope": "individual",
		"iso6393": "ltz",
		"iso6392B": "ltz",
		"iso6392T": "ltz",
		"iso6391": "lb"
	},
	{
		"name": "Luba-Lulua",
		"type": "living",
		"scope": "individual",
		"iso6393": "lua",
		"iso6392B": "lua",
		"iso6392T": "lua",
		"iso6391": null
	},
	{
		"name": "Luba-Katanga",
		"type": "living",
		"scope": "individual",
		"iso6393": "lub",
		"iso6392B": "lub",
		"iso6392T": "lub",
		"iso6391": "lu"
	},
	{
		"name": "Aringa",
		"type": "living",
		"scope": "individual",
		"iso6393": "luc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ludian",
		"type": "living",
		"scope": "individual",
		"iso6393": "lud",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Luvale",
		"type": "living",
		"scope": "individual",
		"iso6393": "lue",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Laua",
		"type": "living",
		"scope": "individual",
		"iso6393": "luf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ganda",
		"type": "living",
		"scope": "individual",
		"iso6393": "lug",
		"iso6392B": "lug",
		"iso6392T": "lug",
		"iso6391": "lg"
	},
	{
		"name": "Luiseno",
		"type": "living",
		"scope": "individual",
		"iso6393": "lui",
		"iso6392B": "lui",
		"iso6392T": "lui",
		"iso6391": null
	},
	{
		"name": "Luna",
		"type": "living",
		"scope": "individual",
		"iso6393": "luj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lunanakha",
		"type": "living",
		"scope": "individual",
		"iso6393": "luk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Olu'bo",
		"type": "living",
		"scope": "individual",
		"iso6393": "lul",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Luimbi",
		"type": "living",
		"scope": "individual",
		"iso6393": "lum",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lunda",
		"type": "living",
		"scope": "individual",
		"iso6393": "lun",
		"iso6392B": "lun",
		"iso6392T": "lun",
		"iso6391": null
	},
	{
		"name": "Luo (Kenya and Tanzania)",
		"type": "living",
		"scope": "individual",
		"iso6393": "luo",
		"iso6392B": "luo",
		"iso6392T": "luo",
		"iso6391": null
	},
	{
		"name": "Lumbu",
		"type": "living",
		"scope": "individual",
		"iso6393": "lup",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lucumi",
		"type": "living",
		"scope": "individual",
		"iso6393": "luq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Laura",
		"type": "living",
		"scope": "individual",
		"iso6393": "lur",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lushai",
		"type": "living",
		"scope": "individual",
		"iso6393": "lus",
		"iso6392B": "lus",
		"iso6392T": "lus",
		"iso6391": null
	},
	{
		"name": "Lushootseed",
		"type": "living",
		"scope": "individual",
		"iso6393": "lut",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lumba-Yakkha",
		"type": "living",
		"scope": "individual",
		"iso6393": "luu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Luwati",
		"type": "living",
		"scope": "individual",
		"iso6393": "luv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Luo (Cameroon)",
		"type": "living",
		"scope": "individual",
		"iso6393": "luw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Luyia",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "luy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Luri",
		"type": "living",
		"scope": "individual",
		"iso6393": "luz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maku'a",
		"type": "living",
		"scope": "individual",
		"iso6393": "lva",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lavukaleve",
		"type": "living",
		"scope": "individual",
		"iso6393": "lvk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Standard Latvian",
		"type": "living",
		"scope": "individual",
		"iso6393": "lvs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Levuka",
		"type": "living",
		"scope": "individual",
		"iso6393": "lvu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lwalu",
		"type": "living",
		"scope": "individual",
		"iso6393": "lwa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lewo Eleng",
		"type": "living",
		"scope": "individual",
		"iso6393": "lwe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wanga",
		"type": "living",
		"scope": "individual",
		"iso6393": "lwg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "White Lachi",
		"type": "living",
		"scope": "individual",
		"iso6393": "lwh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Lawa",
		"type": "living",
		"scope": "individual",
		"iso6393": "lwl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Laomian",
		"type": "living",
		"scope": "individual",
		"iso6393": "lwm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Luwo",
		"type": "living",
		"scope": "individual",
		"iso6393": "lwo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lewotobi",
		"type": "living",
		"scope": "individual",
		"iso6393": "lwt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lawu",
		"type": "living",
		"scope": "individual",
		"iso6393": "lwu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lewo",
		"type": "living",
		"scope": "individual",
		"iso6393": "lww",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Layakha",
		"type": "living",
		"scope": "individual",
		"iso6393": "lya",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lyngngam",
		"type": "living",
		"scope": "individual",
		"iso6393": "lyg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Luyana",
		"type": "living",
		"scope": "individual",
		"iso6393": "lyn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Literary Chinese",
		"type": "historical",
		"scope": "individual",
		"iso6393": "lzh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Litzlitz",
		"type": "living",
		"scope": "individual",
		"iso6393": "lzl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Leinong Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "lzn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Laz",
		"type": "living",
		"scope": "individual",
		"iso6393": "lzz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "San Jerónimo Tecóatl Mazatec",
		"type": "living",
		"scope": "individual",
		"iso6393": "maa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yutanduchi Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "mab",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Madurese",
		"type": "living",
		"scope": "individual",
		"iso6393": "mad",
		"iso6392B": "mad",
		"iso6392T": "mad",
		"iso6391": null
	},
	{
		"name": "Bo-Rukul",
		"type": "living",
		"scope": "individual",
		"iso6393": "mae",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mafa",
		"type": "living",
		"scope": "individual",
		"iso6393": "maf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Magahi",
		"type": "living",
		"scope": "individual",
		"iso6393": "mag",
		"iso6392B": "mag",
		"iso6392T": "mag",
		"iso6391": null
	},
	{
		"name": "Marshallese",
		"type": "living",
		"scope": "individual",
		"iso6393": "mah",
		"iso6392B": "mah",
		"iso6392T": "mah",
		"iso6391": "mh"
	},
	{
		"name": "Maithili",
		"type": "living",
		"scope": "individual",
		"iso6393": "mai",
		"iso6392B": "mai",
		"iso6392T": "mai",
		"iso6391": null
	},
	{
		"name": "Jalapa De Díaz Mazatec",
		"type": "living",
		"scope": "individual",
		"iso6393": "maj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Makasar",
		"type": "living",
		"scope": "individual",
		"iso6393": "mak",
		"iso6392B": "mak",
		"iso6392T": "mak",
		"iso6391": null
	},
	{
		"name": "Malayalam",
		"type": "living",
		"scope": "individual",
		"iso6393": "mal",
		"iso6392B": "mal",
		"iso6392T": "mal",
		"iso6391": "ml"
	},
	{
		"name": "Mam",
		"type": "living",
		"scope": "individual",
		"iso6393": "mam",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mandingo",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "man",
		"iso6392B": "man",
		"iso6392T": "man",
		"iso6391": null
	},
	{
		"name": "Chiquihuitlán Mazatec",
		"type": "living",
		"scope": "individual",
		"iso6393": "maq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Marathi",
		"type": "living",
		"scope": "individual",
		"iso6393": "mar",
		"iso6392B": "mar",
		"iso6392T": "mar",
		"iso6391": "mr"
	},
	{
		"name": "Masai",
		"type": "living",
		"scope": "individual",
		"iso6393": "mas",
		"iso6392B": "mas",
		"iso6392T": "mas",
		"iso6391": null
	},
	{
		"name": "San Francisco Matlatzinca",
		"type": "living",
		"scope": "individual",
		"iso6393": "mat",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Huautla Mazatec",
		"type": "living",
		"scope": "individual",
		"iso6393": "mau",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sateré-Mawé",
		"type": "living",
		"scope": "individual",
		"iso6393": "mav",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mampruli",
		"type": "living",
		"scope": "individual",
		"iso6393": "maw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "North Moluccan Malay",
		"type": "living",
		"scope": "individual",
		"iso6393": "max",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Central Mazahua",
		"type": "living",
		"scope": "individual",
		"iso6393": "maz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Higaonon",
		"type": "living",
		"scope": "individual",
		"iso6393": "mba",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Bukidnon Manobo",
		"type": "living",
		"scope": "individual",
		"iso6393": "mbb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Macushi",
		"type": "living",
		"scope": "individual",
		"iso6393": "mbc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dibabawon Manobo",
		"type": "living",
		"scope": "individual",
		"iso6393": "mbd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Molale",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "mbe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baba Malay",
		"type": "living",
		"scope": "individual",
		"iso6393": "mbf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mangseng",
		"type": "living",
		"scope": "individual",
		"iso6393": "mbh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ilianen Manobo",
		"type": "living",
		"scope": "individual",
		"iso6393": "mbi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nadëb",
		"type": "living",
		"scope": "individual",
		"iso6393": "mbj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Malol",
		"type": "living",
		"scope": "individual",
		"iso6393": "mbk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maxakalí",
		"type": "living",
		"scope": "individual",
		"iso6393": "mbl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ombamba",
		"type": "living",
		"scope": "individual",
		"iso6393": "mbm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Macaguán",
		"type": "living",
		"scope": "individual",
		"iso6393": "mbn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mbo (Cameroon)",
		"type": "living",
		"scope": "individual",
		"iso6393": "mbo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Malayo",
		"type": "living",
		"scope": "individual",
		"iso6393": "mbp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maisin",
		"type": "living",
		"scope": "individual",
		"iso6393": "mbq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nukak Makú",
		"type": "living",
		"scope": "individual",
		"iso6393": "mbr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sarangani Manobo",
		"type": "living",
		"scope": "individual",
		"iso6393": "mbs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Matigsalug Manobo",
		"type": "living",
		"scope": "individual",
		"iso6393": "mbt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mbula-Bwazza",
		"type": "living",
		"scope": "individual",
		"iso6393": "mbu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mbulungish",
		"type": "living",
		"scope": "individual",
		"iso6393": "mbv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maring",
		"type": "living",
		"scope": "individual",
		"iso6393": "mbw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mari (East Sepik Province)",
		"type": "living",
		"scope": "individual",
		"iso6393": "mbx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Memoni",
		"type": "living",
		"scope": "individual",
		"iso6393": "mby",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Amoltepec Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "mbz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maca",
		"type": "living",
		"scope": "individual",
		"iso6393": "mca",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Machiguenga",
		"type": "living",
		"scope": "individual",
		"iso6393": "mcb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bitur",
		"type": "living",
		"scope": "individual",
		"iso6393": "mcc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sharanahua",
		"type": "living",
		"scope": "individual",
		"iso6393": "mcd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Itundujia Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "mce",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Matsés",
		"type": "living",
		"scope": "individual",
		"iso6393": "mcf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mapoyo",
		"type": "living",
		"scope": "individual",
		"iso6393": "mcg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maquiritari",
		"type": "living",
		"scope": "individual",
		"iso6393": "mch",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mese",
		"type": "living",
		"scope": "individual",
		"iso6393": "mci",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mvanip",
		"type": "living",
		"scope": "individual",
		"iso6393": "mcj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mbunda",
		"type": "living",
		"scope": "individual",
		"iso6393": "mck",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Macaguaje",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "mcl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Malaccan Creole Portuguese",
		"type": "living",
		"scope": "individual",
		"iso6393": "mcm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Masana",
		"type": "living",
		"scope": "individual",
		"iso6393": "mcn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Coatlán Mixe",
		"type": "living",
		"scope": "individual",
		"iso6393": "mco",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Makaa",
		"type": "living",
		"scope": "individual",
		"iso6393": "mcp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ese",
		"type": "living",
		"scope": "individual",
		"iso6393": "mcq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Menya",
		"type": "living",
		"scope": "individual",
		"iso6393": "mcr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mambai",
		"type": "living",
		"scope": "individual",
		"iso6393": "mcs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mengisa",
		"type": "living",
		"scope": "individual",
		"iso6393": "mct",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cameroon Mambila",
		"type": "living",
		"scope": "individual",
		"iso6393": "mcu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Minanibai",
		"type": "living",
		"scope": "individual",
		"iso6393": "mcv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mawa (Chad)",
		"type": "living",
		"scope": "individual",
		"iso6393": "mcw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mpiemo",
		"type": "living",
		"scope": "individual",
		"iso6393": "mcx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "South Watut",
		"type": "living",
		"scope": "individual",
		"iso6393": "mcy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mawan",
		"type": "living",
		"scope": "individual",
		"iso6393": "mcz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mada (Nigeria)",
		"type": "living",
		"scope": "individual",
		"iso6393": "mda",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Morigi",
		"type": "living",
		"scope": "individual",
		"iso6393": "mdb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Male (Papua New Guinea)",
		"type": "living",
		"scope": "individual",
		"iso6393": "mdc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mbum",
		"type": "living",
		"scope": "individual",
		"iso6393": "mdd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maba (Chad)",
		"type": "living",
		"scope": "individual",
		"iso6393": "mde",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Moksha",
		"type": "living",
		"scope": "individual",
		"iso6393": "mdf",
		"iso6392B": "mdf",
		"iso6392T": "mdf",
		"iso6391": null
	},
	{
		"name": "Massalat",
		"type": "living",
		"scope": "individual",
		"iso6393": "mdg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maguindanaon",
		"type": "living",
		"scope": "individual",
		"iso6393": "mdh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mamvu",
		"type": "living",
		"scope": "individual",
		"iso6393": "mdi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mangbetu",
		"type": "living",
		"scope": "individual",
		"iso6393": "mdj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mangbutu",
		"type": "living",
		"scope": "individual",
		"iso6393": "mdk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maltese Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "mdl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mayogo",
		"type": "living",
		"scope": "individual",
		"iso6393": "mdm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mbati",
		"type": "living",
		"scope": "individual",
		"iso6393": "mdn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mbala",
		"type": "living",
		"scope": "individual",
		"iso6393": "mdp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mbole",
		"type": "living",
		"scope": "individual",
		"iso6393": "mdq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mandar",
		"type": "living",
		"scope": "individual",
		"iso6393": "mdr",
		"iso6392B": "mdr",
		"iso6392T": "mdr",
		"iso6391": null
	},
	{
		"name": "Maria (Papua New Guinea)",
		"type": "living",
		"scope": "individual",
		"iso6393": "mds",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mbere",
		"type": "living",
		"scope": "individual",
		"iso6393": "mdt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mboko",
		"type": "living",
		"scope": "individual",
		"iso6393": "mdu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Santa Lucía Monteverde Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "mdv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mbosi",
		"type": "living",
		"scope": "individual",
		"iso6393": "mdw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dizin",
		"type": "living",
		"scope": "individual",
		"iso6393": "mdx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Male (Ethiopia)",
		"type": "living",
		"scope": "individual",
		"iso6393": "mdy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Suruí Do Pará",
		"type": "living",
		"scope": "individual",
		"iso6393": "mdz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Menka",
		"type": "living",
		"scope": "individual",
		"iso6393": "mea",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ikobi",
		"type": "living",
		"scope": "individual",
		"iso6393": "meb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mara",
		"type": "living",
		"scope": "individual",
		"iso6393": "mec",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Melpa",
		"type": "living",
		"scope": "individual",
		"iso6393": "med",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mengen",
		"type": "living",
		"scope": "individual",
		"iso6393": "mee",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Megam",
		"type": "living",
		"scope": "individual",
		"iso6393": "mef",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southwestern Tlaxiaco Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "meh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Midob",
		"type": "living",
		"scope": "individual",
		"iso6393": "mei",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Meyah",
		"type": "living",
		"scope": "individual",
		"iso6393": "mej",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mekeo",
		"type": "living",
		"scope": "individual",
		"iso6393": "mek",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Central Melanau",
		"type": "living",
		"scope": "individual",
		"iso6393": "mel",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mangala",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "mem",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mende (Sierra Leone)",
		"type": "living",
		"scope": "individual",
		"iso6393": "men",
		"iso6392B": "men",
		"iso6392T": "men",
		"iso6391": null
	},
	{
		"name": "Kedah Malay",
		"type": "living",
		"scope": "individual",
		"iso6393": "meo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Miriwung",
		"type": "living",
		"scope": "individual",
		"iso6393": "mep",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Merey",
		"type": "living",
		"scope": "individual",
		"iso6393": "meq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Meru",
		"type": "living",
		"scope": "individual",
		"iso6393": "mer",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Masmaje",
		"type": "living",
		"scope": "individual",
		"iso6393": "mes",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mato",
		"type": "living",
		"scope": "individual",
		"iso6393": "met",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Motu",
		"type": "living",
		"scope": "individual",
		"iso6393": "meu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mano",
		"type": "living",
		"scope": "individual",
		"iso6393": "mev",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maaka",
		"type": "living",
		"scope": "individual",
		"iso6393": "mew",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hassaniyya",
		"type": "living",
		"scope": "individual",
		"iso6393": "mey",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Menominee",
		"type": "living",
		"scope": "individual",
		"iso6393": "mez",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pattani Malay",
		"type": "living",
		"scope": "individual",
		"iso6393": "mfa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bangka",
		"type": "living",
		"scope": "individual",
		"iso6393": "mfb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mba",
		"type": "living",
		"scope": "individual",
		"iso6393": "mfc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mendankwe-Nkwen",
		"type": "living",
		"scope": "individual",
		"iso6393": "mfd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Morisyen",
		"type": "living",
		"scope": "individual",
		"iso6393": "mfe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Naki",
		"type": "living",
		"scope": "individual",
		"iso6393": "mff",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mogofin",
		"type": "living",
		"scope": "individual",
		"iso6393": "mfg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Matal",
		"type": "living",
		"scope": "individual",
		"iso6393": "mfh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wandala",
		"type": "living",
		"scope": "individual",
		"iso6393": "mfi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mefele",
		"type": "living",
		"scope": "individual",
		"iso6393": "mfj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "North Mofu",
		"type": "living",
		"scope": "individual",
		"iso6393": "mfk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Putai",
		"type": "living",
		"scope": "individual",
		"iso6393": "mfl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Marghi South",
		"type": "living",
		"scope": "individual",
		"iso6393": "mfm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cross River Mbembe",
		"type": "living",
		"scope": "individual",
		"iso6393": "mfn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mbe",
		"type": "living",
		"scope": "individual",
		"iso6393": "mfo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Makassar Malay",
		"type": "living",
		"scope": "individual",
		"iso6393": "mfp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Moba",
		"type": "living",
		"scope": "individual",
		"iso6393": "mfq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Marithiel",
		"type": "living",
		"scope": "individual",
		"iso6393": "mfr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mexican Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "mfs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mokerang",
		"type": "living",
		"scope": "individual",
		"iso6393": "mft",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mbwela",
		"type": "living",
		"scope": "individual",
		"iso6393": "mfu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mandjak",
		"type": "living",
		"scope": "individual",
		"iso6393": "mfv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mulaha",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "mfw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Melo",
		"type": "living",
		"scope": "individual",
		"iso6393": "mfx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mayo",
		"type": "living",
		"scope": "individual",
		"iso6393": "mfy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mabaan",
		"type": "living",
		"scope": "individual",
		"iso6393": "mfz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Middle Irish (900-1200)",
		"type": "historical",
		"scope": "individual",
		"iso6393": "mga",
		"iso6392B": "mga",
		"iso6392T": "mga",
		"iso6391": null
	},
	{
		"name": "Mararit",
		"type": "living",
		"scope": "individual",
		"iso6393": "mgb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Morokodo",
		"type": "living",
		"scope": "individual",
		"iso6393": "mgc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Moru",
		"type": "living",
		"scope": "individual",
		"iso6393": "mgd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mango",
		"type": "living",
		"scope": "individual",
		"iso6393": "mge",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maklew",
		"type": "living",
		"scope": "individual",
		"iso6393": "mgf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mpumpong",
		"type": "living",
		"scope": "individual",
		"iso6393": "mgg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Makhuwa-Meetto",
		"type": "living",
		"scope": "individual",
		"iso6393": "mgh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lijili",
		"type": "living",
		"scope": "individual",
		"iso6393": "mgi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Abureni",
		"type": "living",
		"scope": "individual",
		"iso6393": "mgj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mawes",
		"type": "living",
		"scope": "individual",
		"iso6393": "mgk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maleu-Kilenge",
		"type": "living",
		"scope": "individual",
		"iso6393": "mgl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mambae",
		"type": "living",
		"scope": "individual",
		"iso6393": "mgm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mbangi",
		"type": "living",
		"scope": "individual",
		"iso6393": "mgn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Meta'",
		"type": "living",
		"scope": "individual",
		"iso6393": "mgo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Magar",
		"type": "living",
		"scope": "individual",
		"iso6393": "mgp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Malila",
		"type": "living",
		"scope": "individual",
		"iso6393": "mgq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mambwe-Lungu",
		"type": "living",
		"scope": "individual",
		"iso6393": "mgr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Manda (Tanzania)",
		"type": "living",
		"scope": "individual",
		"iso6393": "mgs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mongol",
		"type": "living",
		"scope": "individual",
		"iso6393": "mgt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mailu",
		"type": "living",
		"scope": "individual",
		"iso6393": "mgu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Matengo",
		"type": "living",
		"scope": "individual",
		"iso6393": "mgv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Matumbi",
		"type": "living",
		"scope": "individual",
		"iso6393": "mgw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mbunga",
		"type": "living",
		"scope": "individual",
		"iso6393": "mgy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mbugwe",
		"type": "living",
		"scope": "individual",
		"iso6393": "mgz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Manda (India)",
		"type": "living",
		"scope": "individual",
		"iso6393": "mha",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mahongwe",
		"type": "living",
		"scope": "individual",
		"iso6393": "mhb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mocho",
		"type": "living",
		"scope": "individual",
		"iso6393": "mhc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mbugu",
		"type": "living",
		"scope": "individual",
		"iso6393": "mhd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Besisi",
		"type": "living",
		"scope": "individual",
		"iso6393": "mhe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mamaa",
		"type": "living",
		"scope": "individual",
		"iso6393": "mhf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Margu",
		"type": "living",
		"scope": "individual",
		"iso6393": "mhg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ma'di",
		"type": "living",
		"scope": "individual",
		"iso6393": "mhi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mogholi",
		"type": "living",
		"scope": "individual",
		"iso6393": "mhj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mungaka",
		"type": "living",
		"scope": "individual",
		"iso6393": "mhk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mauwake",
		"type": "living",
		"scope": "individual",
		"iso6393": "mhl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Makhuwa-Moniga",
		"type": "living",
		"scope": "individual",
		"iso6393": "mhm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mócheno",
		"type": "living",
		"scope": "individual",
		"iso6393": "mhn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mashi (Zambia)",
		"type": "living",
		"scope": "individual",
		"iso6393": "mho",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Balinese Malay",
		"type": "living",
		"scope": "individual",
		"iso6393": "mhp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mandan",
		"type": "living",
		"scope": "individual",
		"iso6393": "mhq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Mari",
		"type": "living",
		"scope": "individual",
		"iso6393": "mhr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Buru (Indonesia)",
		"type": "living",
		"scope": "individual",
		"iso6393": "mhs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mandahuaca",
		"type": "living",
		"scope": "individual",
		"iso6393": "mht",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Digaro-Mishmi",
		"type": "living",
		"scope": "individual",
		"iso6393": "mhu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mbukushu",
		"type": "living",
		"scope": "individual",
		"iso6393": "mhw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maru",
		"type": "living",
		"scope": "individual",
		"iso6393": "mhx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ma'anyan",
		"type": "living",
		"scope": "individual",
		"iso6393": "mhy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mor (Mor Islands)",
		"type": "living",
		"scope": "individual",
		"iso6393": "mhz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Miami",
		"type": "living",
		"scope": "individual",
		"iso6393": "mia",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Atatláhuca Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "mib",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mi'kmaq",
		"type": "living",
		"scope": "individual",
		"iso6393": "mic",
		"iso6392B": "mic",
		"iso6392T": "mic",
		"iso6391": null
	},
	{
		"name": "Mandaic",
		"type": "living",
		"scope": "individual",
		"iso6393": "mid",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ocotepec Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "mie",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mofu-Gudur",
		"type": "living",
		"scope": "individual",
		"iso6393": "mif",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "San Miguel El Grande Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "mig",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chayuco Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "mih",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chigmecatitlán Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "mii",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Abar",
		"type": "living",
		"scope": "individual",
		"iso6393": "mij",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mikasuki",
		"type": "living",
		"scope": "individual",
		"iso6393": "mik",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Peñoles Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "mil",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Alacatlatzala Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "mim",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Minangkabau",
		"type": "living",
		"scope": "individual",
		"iso6393": "min",
		"iso6392B": "min",
		"iso6392T": "min",
		"iso6391": null
	},
	{
		"name": "Pinotepa Nacional Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "mio",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Apasco-Apoala Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "mip",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mískito",
		"type": "living",
		"scope": "individual",
		"iso6393": "miq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Isthmus Mixe",
		"type": "living",
		"scope": "individual",
		"iso6393": "mir",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Uncoded languages",
		"type": "special",
		"scope": "special",
		"iso6393": "mis",
		"iso6392B": "mis",
		"iso6392T": "mis",
		"iso6391": null
	},
	{
		"name": "Southern Puebla Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "mit",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cacaloxtepec Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "miu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Akoye",
		"type": "living",
		"scope": "individual",
		"iso6393": "miw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mixtepec Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "mix",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ayutla Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "miy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Coatzospan Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "miz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Makalero",
		"type": "living",
		"scope": "individual",
		"iso6393": "mjb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "San Juan Colorado Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "mjc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northwest Maidu",
		"type": "living",
		"scope": "individual",
		"iso6393": "mjd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Muskum",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "mje",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tu",
		"type": "living",
		"scope": "individual",
		"iso6393": "mjg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mwera (Nyasa)",
		"type": "living",
		"scope": "individual",
		"iso6393": "mjh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kim Mun",
		"type": "living",
		"scope": "individual",
		"iso6393": "mji",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mawak",
		"type": "living",
		"scope": "individual",
		"iso6393": "mjj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Matukar",
		"type": "living",
		"scope": "individual",
		"iso6393": "mjk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mandeali",
		"type": "living",
		"scope": "individual",
		"iso6393": "mjl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Medebur",
		"type": "living",
		"scope": "individual",
		"iso6393": "mjm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ma (Papua New Guinea)",
		"type": "living",
		"scope": "individual",
		"iso6393": "mjn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Malankuravan",
		"type": "living",
		"scope": "individual",
		"iso6393": "mjo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Malapandaram",
		"type": "living",
		"scope": "individual",
		"iso6393": "mjp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Malaryan",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "mjq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Malavedan",
		"type": "living",
		"scope": "individual",
		"iso6393": "mjr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Miship",
		"type": "living",
		"scope": "individual",
		"iso6393": "mjs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sauria Paharia",
		"type": "living",
		"scope": "individual",
		"iso6393": "mjt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Manna-Dora",
		"type": "living",
		"scope": "individual",
		"iso6393": "mju",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mannan",
		"type": "living",
		"scope": "individual",
		"iso6393": "mjv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Karbi",
		"type": "living",
		"scope": "individual",
		"iso6393": "mjw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mahali",
		"type": "living",
		"scope": "individual",
		"iso6393": "mjx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mahican",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "mjy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Majhi",
		"type": "living",
		"scope": "individual",
		"iso6393": "mjz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mbre",
		"type": "living",
		"scope": "individual",
		"iso6393": "mka",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mal Paharia",
		"type": "living",
		"scope": "individual",
		"iso6393": "mkb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Siliput",
		"type": "living",
		"scope": "individual",
		"iso6393": "mkc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Macedonian",
		"type": "living",
		"scope": "individual",
		"iso6393": "mkd",
		"iso6392B": "mac",
		"iso6392T": "mkd",
		"iso6391": "mk"
	},
	{
		"name": "Mawchi",
		"type": "living",
		"scope": "individual",
		"iso6393": "mke",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Miya",
		"type": "living",
		"scope": "individual",
		"iso6393": "mkf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mak (China)",
		"type": "living",
		"scope": "individual",
		"iso6393": "mkg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dhatki",
		"type": "living",
		"scope": "individual",
		"iso6393": "mki",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mokilese",
		"type": "living",
		"scope": "individual",
		"iso6393": "mkj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Byep",
		"type": "living",
		"scope": "individual",
		"iso6393": "mkk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mokole",
		"type": "living",
		"scope": "individual",
		"iso6393": "mkl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Moklen",
		"type": "living",
		"scope": "individual",
		"iso6393": "mkm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kupang Malay",
		"type": "living",
		"scope": "individual",
		"iso6393": "mkn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mingang Doso",
		"type": "living",
		"scope": "individual",
		"iso6393": "mko",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Moikodi",
		"type": "living",
		"scope": "individual",
		"iso6393": "mkp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bay Miwok",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "mkq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Malas",
		"type": "living",
		"scope": "individual",
		"iso6393": "mkr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Silacayoapan Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "mks",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Vamale",
		"type": "living",
		"scope": "individual",
		"iso6393": "mkt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Konyanka Maninka",
		"type": "living",
		"scope": "individual",
		"iso6393": "mku",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mafea",
		"type": "living",
		"scope": "individual",
		"iso6393": "mkv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kituba (Congo)",
		"type": "living",
		"scope": "individual",
		"iso6393": "mkw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kinamiging Manobo",
		"type": "living",
		"scope": "individual",
		"iso6393": "mkx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "East Makian",
		"type": "living",
		"scope": "individual",
		"iso6393": "mky",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Makasae",
		"type": "living",
		"scope": "individual",
		"iso6393": "mkz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Malo",
		"type": "living",
		"scope": "individual",
		"iso6393": "mla",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mbule",
		"type": "living",
		"scope": "individual",
		"iso6393": "mlb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cao Lan",
		"type": "living",
		"scope": "individual",
		"iso6393": "mlc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Manambu",
		"type": "living",
		"scope": "individual",
		"iso6393": "mle",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mal",
		"type": "living",
		"scope": "individual",
		"iso6393": "mlf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Malagasy",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "mlg",
		"iso6392B": "mlg",
		"iso6392T": "mlg",
		"iso6391": "mg"
	},
	{
		"name": "Mape",
		"type": "living",
		"scope": "individual",
		"iso6393": "mlh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Malimpung",
		"type": "living",
		"scope": "individual",
		"iso6393": "mli",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Miltu",
		"type": "living",
		"scope": "individual",
		"iso6393": "mlj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ilwana",
		"type": "living",
		"scope": "individual",
		"iso6393": "mlk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Malua Bay",
		"type": "living",
		"scope": "individual",
		"iso6393": "mll",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mulam",
		"type": "living",
		"scope": "individual",
		"iso6393": "mlm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Malango",
		"type": "living",
		"scope": "individual",
		"iso6393": "mln",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mlomp",
		"type": "living",
		"scope": "individual",
		"iso6393": "mlo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bargam",
		"type": "living",
		"scope": "individual",
		"iso6393": "mlp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Maninkakan",
		"type": "living",
		"scope": "individual",
		"iso6393": "mlq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Vame",
		"type": "living",
		"scope": "individual",
		"iso6393": "mlr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Masalit",
		"type": "living",
		"scope": "individual",
		"iso6393": "mls",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maltese",
		"type": "living",
		"scope": "individual",
		"iso6393": "mlt",
		"iso6392B": "mlt",
		"iso6392T": "mlt",
		"iso6391": "mt"
	},
	{
		"name": "To'abaita",
		"type": "living",
		"scope": "individual",
		"iso6393": "mlu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Motlav",
		"type": "living",
		"scope": "individual",
		"iso6393": "mlv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Moloko",
		"type": "living",
		"scope": "individual",
		"iso6393": "mlw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Malfaxal",
		"type": "living",
		"scope": "individual",
		"iso6393": "mlx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Malaynon",
		"type": "living",
		"scope": "individual",
		"iso6393": "mlz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mama",
		"type": "living",
		"scope": "individual",
		"iso6393": "mma",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Momina",
		"type": "living",
		"scope": "individual",
		"iso6393": "mmb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Michoacán Mazahua",
		"type": "living",
		"scope": "individual",
		"iso6393": "mmc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maonan",
		"type": "living",
		"scope": "individual",
		"iso6393": "mmd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mae",
		"type": "living",
		"scope": "individual",
		"iso6393": "mme",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mundat",
		"type": "living",
		"scope": "individual",
		"iso6393": "mmf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "North Ambrym",
		"type": "living",
		"scope": "individual",
		"iso6393": "mmg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mehináku",
		"type": "living",
		"scope": "individual",
		"iso6393": "mmh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Musar",
		"type": "living",
		"scope": "individual",
		"iso6393": "mmi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Majhwar",
		"type": "living",
		"scope": "individual",
		"iso6393": "mmj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mukha-Dora",
		"type": "living",
		"scope": "individual",
		"iso6393": "mmk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Man Met",
		"type": "living",
		"scope": "individual",
		"iso6393": "mml",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maii",
		"type": "living",
		"scope": "individual",
		"iso6393": "mmm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mamanwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "mmn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mangga Buang",
		"type": "living",
		"scope": "individual",
		"iso6393": "mmo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Siawi",
		"type": "living",
		"scope": "individual",
		"iso6393": "mmp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Musak",
		"type": "living",
		"scope": "individual",
		"iso6393": "mmq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Xiangxi Miao",
		"type": "living",
		"scope": "individual",
		"iso6393": "mmr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Malalamai",
		"type": "living",
		"scope": "individual",
		"iso6393": "mmt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mmaala",
		"type": "living",
		"scope": "individual",
		"iso6393": "mmu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Miriti",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "mmv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Emae",
		"type": "living",
		"scope": "individual",
		"iso6393": "mmw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Madak",
		"type": "living",
		"scope": "individual",
		"iso6393": "mmx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Migaama",
		"type": "living",
		"scope": "individual",
		"iso6393": "mmy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mabaale",
		"type": "living",
		"scope": "individual",
		"iso6393": "mmz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mbula",
		"type": "living",
		"scope": "individual",
		"iso6393": "mna",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Muna",
		"type": "living",
		"scope": "individual",
		"iso6393": "mnb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Manchu",
		"type": "living",
		"scope": "individual",
		"iso6393": "mnc",
		"iso6392B": "mnc",
		"iso6392T": "mnc",
		"iso6391": null
	},
	{
		"name": "Mondé",
		"type": "living",
		"scope": "individual",
		"iso6393": "mnd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Naba",
		"type": "living",
		"scope": "individual",
		"iso6393": "mne",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mundani",
		"type": "living",
		"scope": "individual",
		"iso6393": "mnf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Mnong",
		"type": "living",
		"scope": "individual",
		"iso6393": "mng",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mono (Democratic Republic of Congo)",
		"type": "living",
		"scope": "individual",
		"iso6393": "mnh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Manipuri",
		"type": "living",
		"scope": "individual",
		"iso6393": "mni",
		"iso6392B": "mni",
		"iso6392T": "mni",
		"iso6391": null
	},
	{
		"name": "Munji",
		"type": "living",
		"scope": "individual",
		"iso6393": "mnj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mandinka",
		"type": "living",
		"scope": "individual",
		"iso6393": "mnk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tiale",
		"type": "living",
		"scope": "individual",
		"iso6393": "mnl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mapena",
		"type": "living",
		"scope": "individual",
		"iso6393": "mnm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Mnong",
		"type": "living",
		"scope": "individual",
		"iso6393": "mnn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Min Bei Chinese",
		"type": "living",
		"scope": "individual",
		"iso6393": "mnp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Minriq",
		"type": "living",
		"scope": "individual",
		"iso6393": "mnq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mono (USA)",
		"type": "living",
		"scope": "individual",
		"iso6393": "mnr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mansi",
		"type": "living",
		"scope": "individual",
		"iso6393": "mns",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mer",
		"type": "living",
		"scope": "individual",
		"iso6393": "mnu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rennell-Bellona",
		"type": "living",
		"scope": "individual",
		"iso6393": "mnv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mon",
		"type": "living",
		"scope": "individual",
		"iso6393": "mnw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Manikion",
		"type": "living",
		"scope": "individual",
		"iso6393": "mnx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Manyawa",
		"type": "living",
		"scope": "individual",
		"iso6393": "mny",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Moni",
		"type": "living",
		"scope": "individual",
		"iso6393": "mnz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mwan",
		"type": "living",
		"scope": "individual",
		"iso6393": "moa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mocoví",
		"type": "living",
		"scope": "individual",
		"iso6393": "moc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mobilian",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "mod",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Montagnais",
		"type": "living",
		"scope": "individual",
		"iso6393": "moe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mongondow",
		"type": "living",
		"scope": "individual",
		"iso6393": "mog",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mohawk",
		"type": "living",
		"scope": "individual",
		"iso6393": "moh",
		"iso6392B": "moh",
		"iso6392T": "moh",
		"iso6391": null
	},
	{
		"name": "Mboi",
		"type": "living",
		"scope": "individual",
		"iso6393": "moi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Monzombo",
		"type": "living",
		"scope": "individual",
		"iso6393": "moj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Morori",
		"type": "living",
		"scope": "individual",
		"iso6393": "mok",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mangue",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "mom",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mongolian",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "mon",
		"iso6392B": "mon",
		"iso6392T": "mon",
		"iso6391": "mn"
	},
	{
		"name": "Monom",
		"type": "living",
		"scope": "individual",
		"iso6393": "moo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mopán Maya",
		"type": "living",
		"scope": "individual",
		"iso6393": "mop",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mor (Bomberai Peninsula)",
		"type": "living",
		"scope": "individual",
		"iso6393": "moq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Moro",
		"type": "living",
		"scope": "individual",
		"iso6393": "mor",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mossi",
		"type": "living",
		"scope": "individual",
		"iso6393": "mos",
		"iso6392B": "mos",
		"iso6392T": "mos",
		"iso6391": null
	},
	{
		"name": "Barí",
		"type": "living",
		"scope": "individual",
		"iso6393": "mot",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mogum",
		"type": "living",
		"scope": "individual",
		"iso6393": "mou",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mohave",
		"type": "living",
		"scope": "individual",
		"iso6393": "mov",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Moi (Congo)",
		"type": "living",
		"scope": "individual",
		"iso6393": "mow",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Molima",
		"type": "living",
		"scope": "individual",
		"iso6393": "mox",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shekkacho",
		"type": "living",
		"scope": "individual",
		"iso6393": "moy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mukulu",
		"type": "living",
		"scope": "individual",
		"iso6393": "moz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mpoto",
		"type": "living",
		"scope": "individual",
		"iso6393": "mpa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mullukmulluk",
		"type": "living",
		"scope": "individual",
		"iso6393": "mpb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mangarayi",
		"type": "living",
		"scope": "individual",
		"iso6393": "mpc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Machinere",
		"type": "living",
		"scope": "individual",
		"iso6393": "mpd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Majang",
		"type": "living",
		"scope": "individual",
		"iso6393": "mpe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Marba",
		"type": "living",
		"scope": "individual",
		"iso6393": "mpg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maung",
		"type": "living",
		"scope": "individual",
		"iso6393": "mph",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mpade",
		"type": "living",
		"scope": "individual",
		"iso6393": "mpi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Martu Wangka",
		"type": "living",
		"scope": "individual",
		"iso6393": "mpj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mbara (Chad)",
		"type": "living",
		"scope": "individual",
		"iso6393": "mpk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Middle Watut",
		"type": "living",
		"scope": "individual",
		"iso6393": "mpl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yosondúa Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "mpm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mindiri",
		"type": "living",
		"scope": "individual",
		"iso6393": "mpn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Miu",
		"type": "living",
		"scope": "individual",
		"iso6393": "mpo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Migabac",
		"type": "living",
		"scope": "individual",
		"iso6393": "mpp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Matís",
		"type": "living",
		"scope": "individual",
		"iso6393": "mpq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Vangunu",
		"type": "living",
		"scope": "individual",
		"iso6393": "mpr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dadibi",
		"type": "living",
		"scope": "individual",
		"iso6393": "mps",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mian",
		"type": "living",
		"scope": "individual",
		"iso6393": "mpt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Makuráp",
		"type": "living",
		"scope": "individual",
		"iso6393": "mpu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mungkip",
		"type": "living",
		"scope": "individual",
		"iso6393": "mpv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mapidian",
		"type": "living",
		"scope": "individual",
		"iso6393": "mpw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Misima-Panaeati",
		"type": "living",
		"scope": "individual",
		"iso6393": "mpx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mapia",
		"type": "living",
		"scope": "individual",
		"iso6393": "mpy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mpi",
		"type": "living",
		"scope": "individual",
		"iso6393": "mpz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maba (Indonesia)",
		"type": "living",
		"scope": "individual",
		"iso6393": "mqa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mbuko",
		"type": "living",
		"scope": "individual",
		"iso6393": "mqb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mangole",
		"type": "living",
		"scope": "individual",
		"iso6393": "mqc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Matepi",
		"type": "living",
		"scope": "individual",
		"iso6393": "mqe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Momuna",
		"type": "living",
		"scope": "individual",
		"iso6393": "mqf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kota Bangun Kutai Malay",
		"type": "living",
		"scope": "individual",
		"iso6393": "mqg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tlazoyaltepec Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "mqh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mariri",
		"type": "living",
		"scope": "individual",
		"iso6393": "mqi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mamasa",
		"type": "living",
		"scope": "individual",
		"iso6393": "mqj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rajah Kabunsuwan Manobo",
		"type": "living",
		"scope": "individual",
		"iso6393": "mqk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mbelime",
		"type": "living",
		"scope": "individual",
		"iso6393": "mql",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "South Marquesan",
		"type": "living",
		"scope": "individual",
		"iso6393": "mqm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Moronene",
		"type": "living",
		"scope": "individual",
		"iso6393": "mqn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Modole",
		"type": "living",
		"scope": "individual",
		"iso6393": "mqo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Manipa",
		"type": "living",
		"scope": "individual",
		"iso6393": "mqp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Minokok",
		"type": "living",
		"scope": "individual",
		"iso6393": "mqq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mander",
		"type": "living",
		"scope": "individual",
		"iso6393": "mqr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "West Makian",
		"type": "living",
		"scope": "individual",
		"iso6393": "mqs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mok",
		"type": "living",
		"scope": "individual",
		"iso6393": "mqt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mandari",
		"type": "living",
		"scope": "individual",
		"iso6393": "mqu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mosimo",
		"type": "living",
		"scope": "individual",
		"iso6393": "mqv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Murupi",
		"type": "living",
		"scope": "individual",
		"iso6393": "mqw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mamuju",
		"type": "living",
		"scope": "individual",
		"iso6393": "mqx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Manggarai",
		"type": "living",
		"scope": "individual",
		"iso6393": "mqy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pano",
		"type": "living",
		"scope": "individual",
		"iso6393": "mqz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mlabri",
		"type": "living",
		"scope": "individual",
		"iso6393": "mra",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Marino",
		"type": "living",
		"scope": "individual",
		"iso6393": "mrb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maricopa",
		"type": "living",
		"scope": "individual",
		"iso6393": "mrc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Magar",
		"type": "living",
		"scope": "individual",
		"iso6393": "mrd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Martha's Vineyard Sign Language",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "mre",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Elseng",
		"type": "living",
		"scope": "individual",
		"iso6393": "mrf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mising",
		"type": "living",
		"scope": "individual",
		"iso6393": "mrg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mara Chin",
		"type": "living",
		"scope": "individual",
		"iso6393": "mrh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maori",
		"type": "living",
		"scope": "individual",
		"iso6393": "mri",
		"iso6392B": "mao",
		"iso6392T": "mri",
		"iso6391": "mi"
	},
	{
		"name": "Western Mari",
		"type": "living",
		"scope": "individual",
		"iso6393": "mrj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hmwaveke",
		"type": "living",
		"scope": "individual",
		"iso6393": "mrk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mortlockese",
		"type": "living",
		"scope": "individual",
		"iso6393": "mrl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Merlav",
		"type": "living",
		"scope": "individual",
		"iso6393": "mrm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cheke Holo",
		"type": "living",
		"scope": "individual",
		"iso6393": "mrn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mru",
		"type": "living",
		"scope": "individual",
		"iso6393": "mro",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Morouas",
		"type": "living",
		"scope": "individual",
		"iso6393": "mrp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "North Marquesan",
		"type": "living",
		"scope": "individual",
		"iso6393": "mrq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maria (India)",
		"type": "living",
		"scope": "individual",
		"iso6393": "mrr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maragus",
		"type": "living",
		"scope": "individual",
		"iso6393": "mrs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Marghi Central",
		"type": "living",
		"scope": "individual",
		"iso6393": "mrt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mono (Cameroon)",
		"type": "living",
		"scope": "individual",
		"iso6393": "mru",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mangareva",
		"type": "living",
		"scope": "individual",
		"iso6393": "mrv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maranao",
		"type": "living",
		"scope": "individual",
		"iso6393": "mrw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maremgi",
		"type": "living",
		"scope": "individual",
		"iso6393": "mrx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mandaya",
		"type": "living",
		"scope": "individual",
		"iso6393": "mry",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Marind",
		"type": "living",
		"scope": "individual",
		"iso6393": "mrz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Malay (macrolanguage)",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "msa",
		"iso6392B": "may",
		"iso6392T": "msa",
		"iso6391": "ms"
	},
	{
		"name": "Masbatenyo",
		"type": "living",
		"scope": "individual",
		"iso6393": "msb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sankaran Maninka",
		"type": "living",
		"scope": "individual",
		"iso6393": "msc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yucatec Maya Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "msd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Musey",
		"type": "living",
		"scope": "individual",
		"iso6393": "mse",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mekwei",
		"type": "living",
		"scope": "individual",
		"iso6393": "msf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Moraid",
		"type": "living",
		"scope": "individual",
		"iso6393": "msg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Masikoro Malagasy",
		"type": "living",
		"scope": "individual",
		"iso6393": "msh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sabah Malay",
		"type": "living",
		"scope": "individual",
		"iso6393": "msi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ma (Democratic Republic of Congo)",
		"type": "living",
		"scope": "individual",
		"iso6393": "msj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mansaka",
		"type": "living",
		"scope": "individual",
		"iso6393": "msk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Molof",
		"type": "living",
		"scope": "individual",
		"iso6393": "msl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Agusan Manobo",
		"type": "living",
		"scope": "individual",
		"iso6393": "msm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Vurës",
		"type": "living",
		"scope": "individual",
		"iso6393": "msn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mombum",
		"type": "living",
		"scope": "individual",
		"iso6393": "mso",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maritsauá",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "msp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Caac",
		"type": "living",
		"scope": "individual",
		"iso6393": "msq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mongolian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "msr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "West Masela",
		"type": "living",
		"scope": "individual",
		"iso6393": "mss",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Musom",
		"type": "living",
		"scope": "individual",
		"iso6393": "msu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maslam",
		"type": "living",
		"scope": "individual",
		"iso6393": "msv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mansoanka",
		"type": "living",
		"scope": "individual",
		"iso6393": "msw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Moresada",
		"type": "living",
		"scope": "individual",
		"iso6393": "msx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aruamu",
		"type": "living",
		"scope": "individual",
		"iso6393": "msy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Momare",
		"type": "living",
		"scope": "individual",
		"iso6393": "msz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cotabato Manobo",
		"type": "living",
		"scope": "individual",
		"iso6393": "mta",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Anyin Morofo",
		"type": "living",
		"scope": "individual",
		"iso6393": "mtb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Munit",
		"type": "living",
		"scope": "individual",
		"iso6393": "mtc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mualang",
		"type": "living",
		"scope": "individual",
		"iso6393": "mtd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mono (Solomon Islands)",
		"type": "living",
		"scope": "individual",
		"iso6393": "mte",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Murik (Papua New Guinea)",
		"type": "living",
		"scope": "individual",
		"iso6393": "mtf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Una",
		"type": "living",
		"scope": "individual",
		"iso6393": "mtg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Munggui",
		"type": "living",
		"scope": "individual",
		"iso6393": "mth",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maiwa (Papua New Guinea)",
		"type": "living",
		"scope": "individual",
		"iso6393": "mti",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Moskona",
		"type": "living",
		"scope": "individual",
		"iso6393": "mtj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mbe'",
		"type": "living",
		"scope": "individual",
		"iso6393": "mtk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Montol",
		"type": "living",
		"scope": "individual",
		"iso6393": "mtl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mator",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "mtm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Matagalpa",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "mtn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Totontepec Mixe",
		"type": "living",
		"scope": "individual",
		"iso6393": "mto",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wichí Lhamtés Nocten",
		"type": "living",
		"scope": "individual",
		"iso6393": "mtp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Muong",
		"type": "living",
		"scope": "individual",
		"iso6393": "mtq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mewari",
		"type": "living",
		"scope": "individual",
		"iso6393": "mtr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yora",
		"type": "living",
		"scope": "individual",
		"iso6393": "mts",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mota",
		"type": "living",
		"scope": "individual",
		"iso6393": "mtt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tututepec Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "mtu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Asaro'o",
		"type": "living",
		"scope": "individual",
		"iso6393": "mtv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Binukidnon",
		"type": "living",
		"scope": "individual",
		"iso6393": "mtw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tidaá Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "mtx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nabi",
		"type": "living",
		"scope": "individual",
		"iso6393": "mty",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mundang",
		"type": "living",
		"scope": "individual",
		"iso6393": "mua",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mubi",
		"type": "living",
		"scope": "individual",
		"iso6393": "mub",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ajumbu",
		"type": "living",
		"scope": "individual",
		"iso6393": "muc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mednyj Aleut",
		"type": "living",
		"scope": "individual",
		"iso6393": "mud",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Media Lengua",
		"type": "living",
		"scope": "individual",
		"iso6393": "mue",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Musgu",
		"type": "living",
		"scope": "individual",
		"iso6393": "mug",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mündü",
		"type": "living",
		"scope": "individual",
		"iso6393": "muh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Musi",
		"type": "living",
		"scope": "individual",
		"iso6393": "mui",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mabire",
		"type": "living",
		"scope": "individual",
		"iso6393": "muj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mugom",
		"type": "living",
		"scope": "individual",
		"iso6393": "muk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Multiple languages",
		"type": "special",
		"scope": "special",
		"iso6393": "mul",
		"iso6392B": "mul",
		"iso6392T": "mul",
		"iso6391": null
	},
	{
		"name": "Maiwala",
		"type": "living",
		"scope": "individual",
		"iso6393": "mum",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyong",
		"type": "living",
		"scope": "individual",
		"iso6393": "muo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Malvi",
		"type": "living",
		"scope": "individual",
		"iso6393": "mup",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Xiangxi Miao",
		"type": "living",
		"scope": "individual",
		"iso6393": "muq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Murle",
		"type": "living",
		"scope": "individual",
		"iso6393": "mur",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Creek",
		"type": "living",
		"scope": "individual",
		"iso6393": "mus",
		"iso6392B": "mus",
		"iso6392T": "mus",
		"iso6391": null
	},
	{
		"name": "Western Muria",
		"type": "living",
		"scope": "individual",
		"iso6393": "mut",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yaaku",
		"type": "living",
		"scope": "individual",
		"iso6393": "muu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Muthuvan",
		"type": "living",
		"scope": "individual",
		"iso6393": "muv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bo-Ung",
		"type": "living",
		"scope": "individual",
		"iso6393": "mux",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Muyang",
		"type": "living",
		"scope": "individual",
		"iso6393": "muy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mursi",
		"type": "living",
		"scope": "individual",
		"iso6393": "muz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Manam",
		"type": "living",
		"scope": "individual",
		"iso6393": "mva",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mattole",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "mvb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mamboru",
		"type": "living",
		"scope": "individual",
		"iso6393": "mvd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Marwari (Pakistan)",
		"type": "living",
		"scope": "individual",
		"iso6393": "mve",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Peripheral Mongolian",
		"type": "living",
		"scope": "individual",
		"iso6393": "mvf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yucuañe Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "mvg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mulgi",
		"type": "living",
		"scope": "individual",
		"iso6393": "mvh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Miyako",
		"type": "living",
		"scope": "individual",
		"iso6393": "mvi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mekmek",
		"type": "living",
		"scope": "individual",
		"iso6393": "mvk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mbara (Australia)",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "mvl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Muya",
		"type": "living",
		"scope": "individual",
		"iso6393": "mvm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Minaveha",
		"type": "living",
		"scope": "individual",
		"iso6393": "mvn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Marovo",
		"type": "living",
		"scope": "individual",
		"iso6393": "mvo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Duri",
		"type": "living",
		"scope": "individual",
		"iso6393": "mvp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Moere",
		"type": "living",
		"scope": "individual",
		"iso6393": "mvq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Marau",
		"type": "living",
		"scope": "individual",
		"iso6393": "mvr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Massep",
		"type": "living",
		"scope": "individual",
		"iso6393": "mvs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mpotovoro",
		"type": "living",
		"scope": "individual",
		"iso6393": "mvt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Marfa",
		"type": "living",
		"scope": "individual",
		"iso6393": "mvu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tagal Murut",
		"type": "living",
		"scope": "individual",
		"iso6393": "mvv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Machinga",
		"type": "living",
		"scope": "individual",
		"iso6393": "mvw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Meoswar",
		"type": "living",
		"scope": "individual",
		"iso6393": "mvx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Indus Kohistani",
		"type": "living",
		"scope": "individual",
		"iso6393": "mvy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mesqan",
		"type": "living",
		"scope": "individual",
		"iso6393": "mvz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mwatebu",
		"type": "living",
		"scope": "individual",
		"iso6393": "mwa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Juwal",
		"type": "living",
		"scope": "individual",
		"iso6393": "mwb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Are",
		"type": "living",
		"scope": "individual",
		"iso6393": "mwc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mwera (Chimwera)",
		"type": "living",
		"scope": "individual",
		"iso6393": "mwe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Murrinh-Patha",
		"type": "living",
		"scope": "individual",
		"iso6393": "mwf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aiklep",
		"type": "living",
		"scope": "individual",
		"iso6393": "mwg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mouk-Aria",
		"type": "living",
		"scope": "individual",
		"iso6393": "mwh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Labo",
		"type": "living",
		"scope": "individual",
		"iso6393": "mwi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kita Maninkakan",
		"type": "living",
		"scope": "individual",
		"iso6393": "mwk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mirandese",
		"type": "living",
		"scope": "individual",
		"iso6393": "mwl",
		"iso6392B": "mwl",
		"iso6392T": "mwl",
		"iso6391": null
	},
	{
		"name": "Sar",
		"type": "living",
		"scope": "individual",
		"iso6393": "mwm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyamwanga",
		"type": "living",
		"scope": "individual",
		"iso6393": "mwn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Central Maewo",
		"type": "living",
		"scope": "individual",
		"iso6393": "mwo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kala Lagaw Ya",
		"type": "living",
		"scope": "individual",
		"iso6393": "mwp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mün Chin",
		"type": "living",
		"scope": "individual",
		"iso6393": "mwq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Marwari",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "mwr",
		"iso6392B": "mwr",
		"iso6392T": "mwr",
		"iso6391": null
	},
	{
		"name": "Mwimbi-Muthambi",
		"type": "living",
		"scope": "individual",
		"iso6393": "mws",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Moken",
		"type": "living",
		"scope": "individual",
		"iso6393": "mwt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mittu",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "mwu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mentawai",
		"type": "living",
		"scope": "individual",
		"iso6393": "mwv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hmong Daw",
		"type": "living",
		"scope": "individual",
		"iso6393": "mww",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mediak",
		"type": "living",
		"scope": "individual",
		"iso6393": "mwx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mosiro",
		"type": "living",
		"scope": "individual",
		"iso6393": "mwy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Moingi",
		"type": "living",
		"scope": "individual",
		"iso6393": "mwz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northwest Oaxaca Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "mxa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tezoatlán Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "mxb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Manyika",
		"type": "living",
		"scope": "individual",
		"iso6393": "mxc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Modang",
		"type": "living",
		"scope": "individual",
		"iso6393": "mxd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mele-Fila",
		"type": "living",
		"scope": "individual",
		"iso6393": "mxe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Malgbe",
		"type": "living",
		"scope": "individual",
		"iso6393": "mxf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mbangala",
		"type": "living",
		"scope": "individual",
		"iso6393": "mxg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mvuba",
		"type": "living",
		"scope": "individual",
		"iso6393": "mxh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mozarabic",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "mxi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Miju-Mishmi",
		"type": "living",
		"scope": "individual",
		"iso6393": "mxj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Monumbo",
		"type": "living",
		"scope": "individual",
		"iso6393": "mxk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maxi Gbe",
		"type": "living",
		"scope": "individual",
		"iso6393": "mxl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Meramera",
		"type": "living",
		"scope": "individual",
		"iso6393": "mxm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Moi (Indonesia)",
		"type": "living",
		"scope": "individual",
		"iso6393": "mxn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mbowe",
		"type": "living",
		"scope": "individual",
		"iso6393": "mxo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tlahuitoltepec Mixe",
		"type": "living",
		"scope": "individual",
		"iso6393": "mxp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Juquila Mixe",
		"type": "living",
		"scope": "individual",
		"iso6393": "mxq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Murik (Malaysia)",
		"type": "living",
		"scope": "individual",
		"iso6393": "mxr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Huitepec Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "mxs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jamiltepec Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "mxt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mada (Cameroon)",
		"type": "living",
		"scope": "individual",
		"iso6393": "mxu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Metlatónoc Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "mxv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Namo",
		"type": "living",
		"scope": "individual",
		"iso6393": "mxw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mahou",
		"type": "living",
		"scope": "individual",
		"iso6393": "mxx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southeastern Nochixtlán Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "mxy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Central Masela",
		"type": "living",
		"scope": "individual",
		"iso6393": "mxz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Burmese",
		"type": "living",
		"scope": "individual",
		"iso6393": "mya",
		"iso6392B": "bur",
		"iso6392T": "mya",
		"iso6391": "my"
	},
	{
		"name": "Mbay",
		"type": "living",
		"scope": "individual",
		"iso6393": "myb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mayeka",
		"type": "living",
		"scope": "individual",
		"iso6393": "myc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maramba",
		"type": "living",
		"scope": "individual",
		"iso6393": "myd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Myene",
		"type": "living",
		"scope": "individual",
		"iso6393": "mye",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bambassi",
		"type": "living",
		"scope": "individual",
		"iso6393": "myf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Manta",
		"type": "living",
		"scope": "individual",
		"iso6393": "myg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Makah",
		"type": "living",
		"scope": "individual",
		"iso6393": "myh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mina (India)",
		"type": "living",
		"scope": "individual",
		"iso6393": "myi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mangayat",
		"type": "living",
		"scope": "individual",
		"iso6393": "myj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mamara Senoufo",
		"type": "living",
		"scope": "individual",
		"iso6393": "myk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Moma",
		"type": "living",
		"scope": "individual",
		"iso6393": "myl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Me'en",
		"type": "living",
		"scope": "individual",
		"iso6393": "mym",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Anfillo",
		"type": "living",
		"scope": "individual",
		"iso6393": "myo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pirahã",
		"type": "living",
		"scope": "individual",
		"iso6393": "myp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Muniche",
		"type": "living",
		"scope": "individual",
		"iso6393": "myr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mesmes",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "mys",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mundurukú",
		"type": "living",
		"scope": "individual",
		"iso6393": "myu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Erzya",
		"type": "living",
		"scope": "individual",
		"iso6393": "myv",
		"iso6392B": "myv",
		"iso6392T": "myv",
		"iso6391": null
	},
	{
		"name": "Muyuw",
		"type": "living",
		"scope": "individual",
		"iso6393": "myw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Masaaba",
		"type": "living",
		"scope": "individual",
		"iso6393": "myx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Macuna",
		"type": "living",
		"scope": "individual",
		"iso6393": "myy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Classical Mandaic",
		"type": "historical",
		"scope": "individual",
		"iso6393": "myz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Santa María Zacatepec Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "mza",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tumzabt",
		"type": "living",
		"scope": "individual",
		"iso6393": "mzb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Madagascar Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "mzc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Malimba",
		"type": "living",
		"scope": "individual",
		"iso6393": "mzd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Morawa",
		"type": "living",
		"scope": "individual",
		"iso6393": "mze",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Monastic Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "mzg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wichí Lhamtés Güisnay",
		"type": "living",
		"scope": "individual",
		"iso6393": "mzh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ixcatlán Mazatec",
		"type": "living",
		"scope": "individual",
		"iso6393": "mzi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Manya",
		"type": "living",
		"scope": "individual",
		"iso6393": "mzj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nigeria Mambila",
		"type": "living",
		"scope": "individual",
		"iso6393": "mzk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mazatlán Mixe",
		"type": "living",
		"scope": "individual",
		"iso6393": "mzl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mumuye",
		"type": "living",
		"scope": "individual",
		"iso6393": "mzm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mazanderani",
		"type": "living",
		"scope": "individual",
		"iso6393": "mzn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Matipuhy",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "mzo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Movima",
		"type": "living",
		"scope": "individual",
		"iso6393": "mzp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mori Atas",
		"type": "living",
		"scope": "individual",
		"iso6393": "mzq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Marúbo",
		"type": "living",
		"scope": "individual",
		"iso6393": "mzr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Macanese",
		"type": "living",
		"scope": "individual",
		"iso6393": "mzs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mintil",
		"type": "living",
		"scope": "individual",
		"iso6393": "mzt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Inapang",
		"type": "living",
		"scope": "individual",
		"iso6393": "mzu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Manza",
		"type": "living",
		"scope": "individual",
		"iso6393": "mzv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Deg",
		"type": "living",
		"scope": "individual",
		"iso6393": "mzw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mawayana",
		"type": "living",
		"scope": "individual",
		"iso6393": "mzx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mozambican Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "mzy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maiadomu",
		"type": "living",
		"scope": "individual",
		"iso6393": "mzz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Namla",
		"type": "living",
		"scope": "individual",
		"iso6393": "naa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Nambikuára",
		"type": "living",
		"scope": "individual",
		"iso6393": "nab",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Narak",
		"type": "living",
		"scope": "individual",
		"iso6393": "nac",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Naka'ela",
		"type": "living",
		"scope": "individual",
		"iso6393": "nae",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nabak",
		"type": "living",
		"scope": "individual",
		"iso6393": "naf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Naga Pidgin",
		"type": "living",
		"scope": "individual",
		"iso6393": "nag",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nalu",
		"type": "living",
		"scope": "individual",
		"iso6393": "naj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nakanai",
		"type": "living",
		"scope": "individual",
		"iso6393": "nak",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nalik",
		"type": "living",
		"scope": "individual",
		"iso6393": "nal",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngan'gityemerri",
		"type": "living",
		"scope": "individual",
		"iso6393": "nam",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Min Nan Chinese",
		"type": "living",
		"scope": "individual",
		"iso6393": "nan",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Naaba",
		"type": "living",
		"scope": "individual",
		"iso6393": "nao",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Neapolitan",
		"type": "living",
		"scope": "individual",
		"iso6393": "nap",
		"iso6392B": "nap",
		"iso6392T": "nap",
		"iso6391": null
	},
	{
		"name": "Khoekhoe",
		"type": "living",
		"scope": "individual",
		"iso6393": "naq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Iguta",
		"type": "living",
		"scope": "individual",
		"iso6393": "nar",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Naasioi",
		"type": "living",
		"scope": "individual",
		"iso6393": "nas",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ca̱hungwa̱rya̱",
		"type": "living",
		"scope": "individual",
		"iso6393": "nat",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nauru",
		"type": "living",
		"scope": "individual",
		"iso6393": "nau",
		"iso6392B": "nau",
		"iso6392T": "nau",
		"iso6391": "na"
	},
	{
		"name": "Navajo",
		"type": "living",
		"scope": "individual",
		"iso6393": "nav",
		"iso6392B": "nav",
		"iso6392T": "nav",
		"iso6391": "nv"
	},
	{
		"name": "Nawuri",
		"type": "living",
		"scope": "individual",
		"iso6393": "naw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nakwi",
		"type": "living",
		"scope": "individual",
		"iso6393": "nax",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Narrinyeri",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "nay",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Coatepec Nahuatl",
		"type": "living",
		"scope": "individual",
		"iso6393": "naz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyemba",
		"type": "living",
		"scope": "individual",
		"iso6393": "nba",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ndoe",
		"type": "living",
		"scope": "individual",
		"iso6393": "nbb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chang Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "nbc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngbinda",
		"type": "living",
		"scope": "individual",
		"iso6393": "nbd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Konyak Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "nbe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nagarchal",
		"type": "living",
		"scope": "individual",
		"iso6393": "nbg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngamo",
		"type": "living",
		"scope": "individual",
		"iso6393": "nbh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mao Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "nbi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngarinman",
		"type": "living",
		"scope": "individual",
		"iso6393": "nbj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nake",
		"type": "living",
		"scope": "individual",
		"iso6393": "nbk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "South Ndebele",
		"type": "living",
		"scope": "individual",
		"iso6393": "nbl",
		"iso6392B": "nbl",
		"iso6392T": "nbl",
		"iso6391": "nr"
	},
	{
		"name": "Ngbaka Ma'bo",
		"type": "living",
		"scope": "individual",
		"iso6393": "nbm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kuri",
		"type": "living",
		"scope": "individual",
		"iso6393": "nbn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nkukoli",
		"type": "living",
		"scope": "individual",
		"iso6393": "nbo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nnam",
		"type": "living",
		"scope": "individual",
		"iso6393": "nbp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nggem",
		"type": "living",
		"scope": "individual",
		"iso6393": "nbq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Numana-Nunku-Gbantu-Numbu",
		"type": "living",
		"scope": "individual",
		"iso6393": "nbr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Namibian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "nbs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Na",
		"type": "living",
		"scope": "individual",
		"iso6393": "nbt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rongmei Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "nbu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngamambo",
		"type": "living",
		"scope": "individual",
		"iso6393": "nbv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Ngbandi",
		"type": "living",
		"scope": "individual",
		"iso6393": "nbw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ningera",
		"type": "living",
		"scope": "individual",
		"iso6393": "nby",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Iyo",
		"type": "living",
		"scope": "individual",
		"iso6393": "nca",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Central Nicobarese",
		"type": "living",
		"scope": "individual",
		"iso6393": "ncb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ponam",
		"type": "living",
		"scope": "individual",
		"iso6393": "ncc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nachering",
		"type": "living",
		"scope": "individual",
		"iso6393": "ncd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yale",
		"type": "living",
		"scope": "individual",
		"iso6393": "nce",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Notsi",
		"type": "living",
		"scope": "individual",
		"iso6393": "ncf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nisga'a",
		"type": "living",
		"scope": "individual",
		"iso6393": "ncg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Central Huasteca Nahuatl",
		"type": "living",
		"scope": "individual",
		"iso6393": "nch",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Classical Nahuatl",
		"type": "historical",
		"scope": "individual",
		"iso6393": "nci",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Puebla Nahuatl",
		"type": "living",
		"scope": "individual",
		"iso6393": "ncj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nakara",
		"type": "living",
		"scope": "individual",
		"iso6393": "nck",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Michoacán Nahuatl",
		"type": "living",
		"scope": "individual",
		"iso6393": "ncl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nambo",
		"type": "living",
		"scope": "individual",
		"iso6393": "ncm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nauna",
		"type": "living",
		"scope": "individual",
		"iso6393": "ncn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sibe",
		"type": "living",
		"scope": "individual",
		"iso6393": "nco",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ndaktup",
		"type": "living",
		"scope": "individual",
		"iso6393": "ncp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ncane",
		"type": "living",
		"scope": "individual",
		"iso6393": "ncr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nicaraguan Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "ncs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chothe Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "nct",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chumburung",
		"type": "living",
		"scope": "individual",
		"iso6393": "ncu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Central Puebla Nahuatl",
		"type": "living",
		"scope": "individual",
		"iso6393": "ncx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Natchez",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ncz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ndasa",
		"type": "living",
		"scope": "individual",
		"iso6393": "nda",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kenswei Nsei",
		"type": "living",
		"scope": "individual",
		"iso6393": "ndb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ndau",
		"type": "living",
		"scope": "individual",
		"iso6393": "ndc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nde-Nsele-Nta",
		"type": "living",
		"scope": "individual",
		"iso6393": "ndd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "North Ndebele",
		"type": "living",
		"scope": "individual",
		"iso6393": "nde",
		"iso6392B": "nde",
		"iso6392T": "nde",
		"iso6391": "nd"
	},
	{
		"name": "Nadruvian",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ndf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ndengereko",
		"type": "living",
		"scope": "individual",
		"iso6393": "ndg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ndali",
		"type": "living",
		"scope": "individual",
		"iso6393": "ndh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Samba Leko",
		"type": "living",
		"scope": "individual",
		"iso6393": "ndi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ndamba",
		"type": "living",
		"scope": "individual",
		"iso6393": "ndj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ndaka",
		"type": "living",
		"scope": "individual",
		"iso6393": "ndk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ndolo",
		"type": "living",
		"scope": "individual",
		"iso6393": "ndl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ndam",
		"type": "living",
		"scope": "individual",
		"iso6393": "ndm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngundi",
		"type": "living",
		"scope": "individual",
		"iso6393": "ndn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ndonga",
		"type": "living",
		"scope": "individual",
		"iso6393": "ndo",
		"iso6392B": "ndo",
		"iso6392T": "ndo",
		"iso6391": "ng"
	},
	{
		"name": "Ndo",
		"type": "living",
		"scope": "individual",
		"iso6393": "ndp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ndombe",
		"type": "living",
		"scope": "individual",
		"iso6393": "ndq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ndoola",
		"type": "living",
		"scope": "individual",
		"iso6393": "ndr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Low German",
		"type": "living",
		"scope": "individual",
		"iso6393": "nds",
		"iso6392B": "nds",
		"iso6392T": "nds",
		"iso6391": null
	},
	{
		"name": "Ndunga",
		"type": "living",
		"scope": "individual",
		"iso6393": "ndt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dugun",
		"type": "living",
		"scope": "individual",
		"iso6393": "ndu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ndut",
		"type": "living",
		"scope": "individual",
		"iso6393": "ndv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ndobo",
		"type": "living",
		"scope": "individual",
		"iso6393": "ndw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nduga",
		"type": "living",
		"scope": "individual",
		"iso6393": "ndx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lutos",
		"type": "living",
		"scope": "individual",
		"iso6393": "ndy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ndogo",
		"type": "living",
		"scope": "individual",
		"iso6393": "ndz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Ngad'a",
		"type": "living",
		"scope": "individual",
		"iso6393": "nea",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Toura (Côte d'Ivoire)",
		"type": "living",
		"scope": "individual",
		"iso6393": "neb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nedebang",
		"type": "living",
		"scope": "individual",
		"iso6393": "nec",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nde-Gbite",
		"type": "living",
		"scope": "individual",
		"iso6393": "ned",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nêlêmwa-Nixumwak",
		"type": "living",
		"scope": "individual",
		"iso6393": "nee",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nefamese",
		"type": "living",
		"scope": "individual",
		"iso6393": "nef",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Negidal",
		"type": "living",
		"scope": "individual",
		"iso6393": "neg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyenkha",
		"type": "living",
		"scope": "individual",
		"iso6393": "neh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Neo-Hittite",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "nei",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Neko",
		"type": "living",
		"scope": "individual",
		"iso6393": "nej",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Neku",
		"type": "living",
		"scope": "individual",
		"iso6393": "nek",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nemi",
		"type": "living",
		"scope": "individual",
		"iso6393": "nem",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nengone",
		"type": "living",
		"scope": "individual",
		"iso6393": "nen",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ná-Meo",
		"type": "living",
		"scope": "individual",
		"iso6393": "neo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nepali (macrolanguage)",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "nep",
		"iso6392B": "nep",
		"iso6392T": "nep",
		"iso6391": "ne"
	},
	{
		"name": "North Central Mixe",
		"type": "living",
		"scope": "individual",
		"iso6393": "neq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yahadian",
		"type": "living",
		"scope": "individual",
		"iso6393": "ner",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bhoti Kinnauri",
		"type": "living",
		"scope": "individual",
		"iso6393": "nes",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nete",
		"type": "living",
		"scope": "individual",
		"iso6393": "net",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Neo",
		"type": "constructed",
		"scope": "individual",
		"iso6393": "neu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyaheun",
		"type": "living",
		"scope": "individual",
		"iso6393": "nev",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Newari",
		"type": "living",
		"scope": "individual",
		"iso6393": "new",
		"iso6392B": "new",
		"iso6392T": "new",
		"iso6391": null
	},
	{
		"name": "Neme",
		"type": "living",
		"scope": "individual",
		"iso6393": "nex",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Neyo",
		"type": "living",
		"scope": "individual",
		"iso6393": "ney",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nez Perce",
		"type": "living",
		"scope": "individual",
		"iso6393": "nez",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dhao",
		"type": "living",
		"scope": "individual",
		"iso6393": "nfa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ahwai",
		"type": "living",
		"scope": "individual",
		"iso6393": "nfd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ayiwo",
		"type": "living",
		"scope": "individual",
		"iso6393": "nfl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nafaanra",
		"type": "living",
		"scope": "individual",
		"iso6393": "nfr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mfumte",
		"type": "living",
		"scope": "individual",
		"iso6393": "nfu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngbaka",
		"type": "living",
		"scope": "individual",
		"iso6393": "nga",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Ngbandi",
		"type": "living",
		"scope": "individual",
		"iso6393": "ngb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngombe (Democratic Republic of Congo)",
		"type": "living",
		"scope": "individual",
		"iso6393": "ngc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngando (Central African Republic)",
		"type": "living",
		"scope": "individual",
		"iso6393": "ngd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngemba",
		"type": "living",
		"scope": "individual",
		"iso6393": "nge",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngbaka Manza",
		"type": "living",
		"scope": "individual",
		"iso6393": "ngg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "N/u",
		"type": "living",
		"scope": "individual",
		"iso6393": "ngh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngizim",
		"type": "living",
		"scope": "individual",
		"iso6393": "ngi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngie",
		"type": "living",
		"scope": "individual",
		"iso6393": "ngj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dalabon",
		"type": "living",
		"scope": "individual",
		"iso6393": "ngk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lomwe",
		"type": "living",
		"scope": "individual",
		"iso6393": "ngl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngatik Men's Creole",
		"type": "living",
		"scope": "individual",
		"iso6393": "ngm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngwo",
		"type": "living",
		"scope": "individual",
		"iso6393": "ngn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngoni",
		"type": "living",
		"scope": "individual",
		"iso6393": "ngo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngulu",
		"type": "living",
		"scope": "individual",
		"iso6393": "ngp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngurimi",
		"type": "living",
		"scope": "individual",
		"iso6393": "ngq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Engdewu",
		"type": "living",
		"scope": "individual",
		"iso6393": "ngr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gvoko",
		"type": "living",
		"scope": "individual",
		"iso6393": "ngs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngeq",
		"type": "living",
		"scope": "individual",
		"iso6393": "ngt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Guerrero Nahuatl",
		"type": "living",
		"scope": "individual",
		"iso6393": "ngu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nagumi",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ngv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngwaba",
		"type": "living",
		"scope": "individual",
		"iso6393": "ngw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nggwahyi",
		"type": "living",
		"scope": "individual",
		"iso6393": "ngx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tibea",
		"type": "living",
		"scope": "individual",
		"iso6393": "ngy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngungwel",
		"type": "living",
		"scope": "individual",
		"iso6393": "ngz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nhanda",
		"type": "living",
		"scope": "individual",
		"iso6393": "nha",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Beng",
		"type": "living",
		"scope": "individual",
		"iso6393": "nhb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tabasco Nahuatl",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "nhc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chiripá",
		"type": "living",
		"scope": "individual",
		"iso6393": "nhd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Huasteca Nahuatl",
		"type": "living",
		"scope": "individual",
		"iso6393": "nhe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nhuwala",
		"type": "living",
		"scope": "individual",
		"iso6393": "nhf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tetelcingo Nahuatl",
		"type": "living",
		"scope": "individual",
		"iso6393": "nhg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nahari",
		"type": "living",
		"scope": "individual",
		"iso6393": "nhh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zacatlán-Ahuacatlán-Tepetzintla Nahuatl",
		"type": "living",
		"scope": "individual",
		"iso6393": "nhi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Isthmus-Cosoleacaque Nahuatl",
		"type": "living",
		"scope": "individual",
		"iso6393": "nhk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Morelos Nahuatl",
		"type": "living",
		"scope": "individual",
		"iso6393": "nhm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Central Nahuatl",
		"type": "living",
		"scope": "individual",
		"iso6393": "nhn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Takuu",
		"type": "living",
		"scope": "individual",
		"iso6393": "nho",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Isthmus-Pajapan Nahuatl",
		"type": "living",
		"scope": "individual",
		"iso6393": "nhp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Huaxcaleca Nahuatl",
		"type": "living",
		"scope": "individual",
		"iso6393": "nhq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Naro",
		"type": "living",
		"scope": "individual",
		"iso6393": "nhr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ometepec Nahuatl",
		"type": "living",
		"scope": "individual",
		"iso6393": "nht",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Noone",
		"type": "living",
		"scope": "individual",
		"iso6393": "nhu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Temascaltepec Nahuatl",
		"type": "living",
		"scope": "individual",
		"iso6393": "nhv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Huasteca Nahuatl",
		"type": "living",
		"scope": "individual",
		"iso6393": "nhw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Isthmus-Mecayapan Nahuatl",
		"type": "living",
		"scope": "individual",
		"iso6393": "nhx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Oaxaca Nahuatl",
		"type": "living",
		"scope": "individual",
		"iso6393": "nhy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Santa María La Alta Nahuatl",
		"type": "living",
		"scope": "individual",
		"iso6393": "nhz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nias",
		"type": "living",
		"scope": "individual",
		"iso6393": "nia",
		"iso6392B": "nia",
		"iso6392T": "nia",
		"iso6391": null
	},
	{
		"name": "Nakame",
		"type": "living",
		"scope": "individual",
		"iso6393": "nib",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngandi",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "nid",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Niellim",
		"type": "living",
		"scope": "individual",
		"iso6393": "nie",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nek",
		"type": "living",
		"scope": "individual",
		"iso6393": "nif",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngalakan",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "nig",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyiha (Tanzania)",
		"type": "living",
		"scope": "individual",
		"iso6393": "nih",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nii",
		"type": "living",
		"scope": "individual",
		"iso6393": "nii",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngaju",
		"type": "living",
		"scope": "individual",
		"iso6393": "nij",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Nicobarese",
		"type": "living",
		"scope": "individual",
		"iso6393": "nik",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nila",
		"type": "living",
		"scope": "individual",
		"iso6393": "nil",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nilamba",
		"type": "living",
		"scope": "individual",
		"iso6393": "nim",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ninzo",
		"type": "living",
		"scope": "individual",
		"iso6393": "nin",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nganasan",
		"type": "living",
		"scope": "individual",
		"iso6393": "nio",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nandi",
		"type": "living",
		"scope": "individual",
		"iso6393": "niq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nimboran",
		"type": "living",
		"scope": "individual",
		"iso6393": "nir",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nimi",
		"type": "living",
		"scope": "individual",
		"iso6393": "nis",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southeastern Kolami",
		"type": "living",
		"scope": "individual",
		"iso6393": "nit",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Niuean",
		"type": "living",
		"scope": "individual",
		"iso6393": "niu",
		"iso6392B": "niu",
		"iso6392T": "niu",
		"iso6391": null
	},
	{
		"name": "Gilyak",
		"type": "living",
		"scope": "individual",
		"iso6393": "niv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nimo",
		"type": "living",
		"scope": "individual",
		"iso6393": "niw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hema",
		"type": "living",
		"scope": "individual",
		"iso6393": "nix",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngiti",
		"type": "living",
		"scope": "individual",
		"iso6393": "niy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ningil",
		"type": "living",
		"scope": "individual",
		"iso6393": "niz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nzanyi",
		"type": "living",
		"scope": "individual",
		"iso6393": "nja",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nocte Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "njb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ndonde Hamba",
		"type": "living",
		"scope": "individual",
		"iso6393": "njd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lotha Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "njh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gudanji",
		"type": "living",
		"scope": "individual",
		"iso6393": "nji",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Njen",
		"type": "living",
		"scope": "individual",
		"iso6393": "njj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Njalgulgule",
		"type": "living",
		"scope": "individual",
		"iso6393": "njl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Angami Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "njm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Liangmai Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "njn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ao Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "njo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Njerep",
		"type": "living",
		"scope": "individual",
		"iso6393": "njr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nisa",
		"type": "living",
		"scope": "individual",
		"iso6393": "njs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ndyuka-Trio Pidgin",
		"type": "living",
		"scope": "individual",
		"iso6393": "njt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngadjunmaya",
		"type": "living",
		"scope": "individual",
		"iso6393": "nju",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kunyi",
		"type": "living",
		"scope": "individual",
		"iso6393": "njx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Njyem",
		"type": "living",
		"scope": "individual",
		"iso6393": "njy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyishi",
		"type": "living",
		"scope": "individual",
		"iso6393": "njz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nkoya",
		"type": "living",
		"scope": "individual",
		"iso6393": "nka",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Khoibu Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "nkb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nkongho",
		"type": "living",
		"scope": "individual",
		"iso6393": "nkc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koireng",
		"type": "living",
		"scope": "individual",
		"iso6393": "nkd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Duke",
		"type": "living",
		"scope": "individual",
		"iso6393": "nke",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Inpui Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "nkf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nekgini",
		"type": "living",
		"scope": "individual",
		"iso6393": "nkg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Khezha Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "nkh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Thangal Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "nki",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nakai",
		"type": "living",
		"scope": "individual",
		"iso6393": "nkj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nokuku",
		"type": "living",
		"scope": "individual",
		"iso6393": "nkk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Namat",
		"type": "living",
		"scope": "individual",
		"iso6393": "nkm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nkangala",
		"type": "living",
		"scope": "individual",
		"iso6393": "nkn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nkonya",
		"type": "living",
		"scope": "individual",
		"iso6393": "nko",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Niuatoputapu",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "nkp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nkami",
		"type": "living",
		"scope": "individual",
		"iso6393": "nkq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nukuoro",
		"type": "living",
		"scope": "individual",
		"iso6393": "nkr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "North Asmat",
		"type": "living",
		"scope": "individual",
		"iso6393": "nks",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyika (Tanzania)",
		"type": "living",
		"scope": "individual",
		"iso6393": "nkt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bouna Kulango",
		"type": "living",
		"scope": "individual",
		"iso6393": "nku",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyika (Malawi and Zambia)",
		"type": "living",
		"scope": "individual",
		"iso6393": "nkv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nkutu",
		"type": "living",
		"scope": "individual",
		"iso6393": "nkw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nkoroo",
		"type": "living",
		"scope": "individual",
		"iso6393": "nkx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nkari",
		"type": "living",
		"scope": "individual",
		"iso6393": "nkz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngombale",
		"type": "living",
		"scope": "individual",
		"iso6393": "nla",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nalca",
		"type": "living",
		"scope": "individual",
		"iso6393": "nlc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dutch",
		"type": "living",
		"scope": "individual",
		"iso6393": "nld",
		"iso6392B": "dut",
		"iso6392T": "nld",
		"iso6391": "nl"
	},
	{
		"name": "East Nyala",
		"type": "living",
		"scope": "individual",
		"iso6393": "nle",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gela",
		"type": "living",
		"scope": "individual",
		"iso6393": "nlg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Grangali",
		"type": "living",
		"scope": "individual",
		"iso6393": "nli",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyali",
		"type": "living",
		"scope": "individual",
		"iso6393": "nlj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ninia Yali",
		"type": "living",
		"scope": "individual",
		"iso6393": "nlk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nihali",
		"type": "living",
		"scope": "individual",
		"iso6393": "nll",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngul",
		"type": "living",
		"scope": "individual",
		"iso6393": "nlo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lao Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "nlq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nchumbulu",
		"type": "living",
		"scope": "individual",
		"iso6393": "nlu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Orizaba Nahuatl",
		"type": "living",
		"scope": "individual",
		"iso6393": "nlv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Walangama",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "nlw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nahali",
		"type": "living",
		"scope": "individual",
		"iso6393": "nlx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyamal",
		"type": "living",
		"scope": "individual",
		"iso6393": "nly",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nalögo",
		"type": "living",
		"scope": "individual",
		"iso6393": "nlz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maram Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "nma",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Big Nambas",
		"type": "living",
		"scope": "individual",
		"iso6393": "nmb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngam",
		"type": "living",
		"scope": "individual",
		"iso6393": "nmc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ndumu",
		"type": "living",
		"scope": "individual",
		"iso6393": "nmd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mzieme Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "nme",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tangkhul Naga (India)",
		"type": "living",
		"scope": "individual",
		"iso6393": "nmf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kwasio",
		"type": "living",
		"scope": "individual",
		"iso6393": "nmg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Monsang Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "nmh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyam",
		"type": "living",
		"scope": "individual",
		"iso6393": "nmi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngombe (Central African Republic)",
		"type": "living",
		"scope": "individual",
		"iso6393": "nmj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Namakura",
		"type": "living",
		"scope": "individual",
		"iso6393": "nmk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ndemli",
		"type": "living",
		"scope": "individual",
		"iso6393": "nml",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Manangba",
		"type": "living",
		"scope": "individual",
		"iso6393": "nmm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "!Xóõ",
		"type": "living",
		"scope": "individual",
		"iso6393": "nmn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Moyon Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "nmo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nimanbur",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "nmp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nambya",
		"type": "living",
		"scope": "individual",
		"iso6393": "nmq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nimbari",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "nmr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Letemboi",
		"type": "living",
		"scope": "individual",
		"iso6393": "nms",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Namonuito",
		"type": "living",
		"scope": "individual",
		"iso6393": "nmt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northeast Maidu",
		"type": "living",
		"scope": "individual",
		"iso6393": "nmu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngamini",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "nmv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nimoa",
		"type": "living",
		"scope": "individual",
		"iso6393": "nmw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nama (Papua New Guinea)",
		"type": "living",
		"scope": "individual",
		"iso6393": "nmx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Namuyi",
		"type": "living",
		"scope": "individual",
		"iso6393": "nmy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nawdm",
		"type": "living",
		"scope": "individual",
		"iso6393": "nmz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyangumarta",
		"type": "living",
		"scope": "individual",
		"iso6393": "nna",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nande",
		"type": "living",
		"scope": "individual",
		"iso6393": "nnb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nancere",
		"type": "living",
		"scope": "individual",
		"iso6393": "nnc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "West Ambae",
		"type": "living",
		"scope": "individual",
		"iso6393": "nnd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngandyera",
		"type": "living",
		"scope": "individual",
		"iso6393": "nne",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngaing",
		"type": "living",
		"scope": "individual",
		"iso6393": "nnf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maring Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "nng",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngiemboon",
		"type": "living",
		"scope": "individual",
		"iso6393": "nnh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "North Nuaulu",
		"type": "living",
		"scope": "individual",
		"iso6393": "nni",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyangatom",
		"type": "living",
		"scope": "individual",
		"iso6393": "nnj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nankina",
		"type": "living",
		"scope": "individual",
		"iso6393": "nnk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Rengma Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "nnl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Namia",
		"type": "living",
		"scope": "individual",
		"iso6393": "nnm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngete",
		"type": "living",
		"scope": "individual",
		"iso6393": "nnn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Norwegian Nynorsk",
		"type": "living",
		"scope": "individual",
		"iso6393": "nno",
		"iso6392B": "nno",
		"iso6392T": "nno",
		"iso6391": "nn"
	},
	{
		"name": "Wancho Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "nnp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngindo",
		"type": "living",
		"scope": "individual",
		"iso6393": "nnq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Narungga",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "nnr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ningye",
		"type": "living",
		"scope": "individual",
		"iso6393": "nns",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nanticoke",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "nnt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dwang",
		"type": "living",
		"scope": "individual",
		"iso6393": "nnu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nugunu (Australia)",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "nnv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Nuni",
		"type": "living",
		"scope": "individual",
		"iso6393": "nnw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyangga",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "nny",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nda'nda'",
		"type": "living",
		"scope": "individual",
		"iso6393": "nnz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Woun Meu",
		"type": "living",
		"scope": "individual",
		"iso6393": "noa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Norwegian Bokmål",
		"type": "living",
		"scope": "individual",
		"iso6393": "nob",
		"iso6392B": "nob",
		"iso6392T": "nob",
		"iso6391": "nb"
	},
	{
		"name": "Nuk",
		"type": "living",
		"scope": "individual",
		"iso6393": "noc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Thai",
		"type": "living",
		"scope": "individual",
		"iso6393": "nod",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nimadi",
		"type": "living",
		"scope": "individual",
		"iso6393": "noe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nomane",
		"type": "living",
		"scope": "individual",
		"iso6393": "nof",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nogai",
		"type": "living",
		"scope": "individual",
		"iso6393": "nog",
		"iso6392B": "nog",
		"iso6392T": "nog",
		"iso6391": null
	},
	{
		"name": "Nomu",
		"type": "living",
		"scope": "individual",
		"iso6393": "noh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Noiri",
		"type": "living",
		"scope": "individual",
		"iso6393": "noi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nonuya",
		"type": "living",
		"scope": "individual",
		"iso6393": "noj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nooksack",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "nok",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nomlaki",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "nol",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nocamán",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "nom",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Old Norse",
		"type": "historical",
		"scope": "individual",
		"iso6393": "non",
		"iso6392B": "non",
		"iso6392T": "non",
		"iso6391": null
	},
	{
		"name": "Numanggang",
		"type": "living",
		"scope": "individual",
		"iso6393": "nop",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngongo",
		"type": "living",
		"scope": "individual",
		"iso6393": "noq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Norwegian",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "nor",
		"iso6392B": "nor",
		"iso6392T": "nor",
		"iso6391": "no"
	},
	{
		"name": "Eastern Nisu",
		"type": "living",
		"scope": "individual",
		"iso6393": "nos",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nomatsiguenga",
		"type": "living",
		"scope": "individual",
		"iso6393": "not",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ewage-Notu",
		"type": "living",
		"scope": "individual",
		"iso6393": "nou",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Novial",
		"type": "constructed",
		"scope": "individual",
		"iso6393": "nov",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyambo",
		"type": "living",
		"scope": "individual",
		"iso6393": "now",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Noy",
		"type": "living",
		"scope": "individual",
		"iso6393": "noy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nayi",
		"type": "living",
		"scope": "individual",
		"iso6393": "noz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nar Phu",
		"type": "living",
		"scope": "individual",
		"iso6393": "npa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nupbikha",
		"type": "living",
		"scope": "individual",
		"iso6393": "npb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ponyo-Gongwang Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "npg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Phom Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "nph",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nepali (individual language)",
		"type": "living",
		"scope": "individual",
		"iso6393": "npi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southeastern Puebla Nahuatl",
		"type": "living",
		"scope": "individual",
		"iso6393": "npl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mondropolon",
		"type": "living",
		"scope": "individual",
		"iso6393": "npn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pochuri Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "npo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nipsan",
		"type": "living",
		"scope": "individual",
		"iso6393": "nps",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Puimei Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "npu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Napu",
		"type": "living",
		"scope": "individual",
		"iso6393": "npy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Nago",
		"type": "living",
		"scope": "individual",
		"iso6393": "nqg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kura Ede Nago",
		"type": "living",
		"scope": "individual",
		"iso6393": "nqk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ndom",
		"type": "living",
		"scope": "individual",
		"iso6393": "nqm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nen",
		"type": "living",
		"scope": "individual",
		"iso6393": "nqn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "N'Ko",
		"type": "living",
		"scope": "individual",
		"iso6393": "nqo",
		"iso6392B": "nqo",
		"iso6392T": "nqo",
		"iso6391": null
	},
	{
		"name": "Kyan-Karyaw Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "nqq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Akyaung Ari Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "nqy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngom",
		"type": "living",
		"scope": "individual",
		"iso6393": "nra",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nara",
		"type": "living",
		"scope": "individual",
		"iso6393": "nrb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Noric",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "nrc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Rengma Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "nre",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jèrriais",
		"type": "living",
		"scope": "individual",
		"iso6393": "nrf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Narango",
		"type": "living",
		"scope": "individual",
		"iso6393": "nrg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chokri Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "nri",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngarla",
		"type": "living",
		"scope": "individual",
		"iso6393": "nrk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngarluma",
		"type": "living",
		"scope": "individual",
		"iso6393": "nrl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Narom",
		"type": "living",
		"scope": "individual",
		"iso6393": "nrm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Norn",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "nrn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "North Picene",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "nrp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Norra",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "nrr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Kalapuya",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "nrt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Narua",
		"type": "living",
		"scope": "individual",
		"iso6393": "nru",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngurmbur",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "nrx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lala",
		"type": "living",
		"scope": "individual",
		"iso6393": "nrz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sangtam Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "nsa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nshi",
		"type": "living",
		"scope": "individual",
		"iso6393": "nsc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Nisu",
		"type": "living",
		"scope": "individual",
		"iso6393": "nsd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nsenga",
		"type": "living",
		"scope": "individual",
		"iso6393": "nse",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northwestern Nisu",
		"type": "living",
		"scope": "individual",
		"iso6393": "nsf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngasa",
		"type": "living",
		"scope": "individual",
		"iso6393": "nsg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngoshie",
		"type": "living",
		"scope": "individual",
		"iso6393": "nsh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nigerian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "nsi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Naskapi",
		"type": "living",
		"scope": "individual",
		"iso6393": "nsk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Norwegian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "nsl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sumi Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "nsm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nehan",
		"type": "living",
		"scope": "individual",
		"iso6393": "nsn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pedi",
		"type": "living",
		"scope": "individual",
		"iso6393": "nso",
		"iso6392B": "nso",
		"iso6392T": "nso",
		"iso6391": null
	},
	{
		"name": "Nepalese Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "nsp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Sierra Miwok",
		"type": "living",
		"scope": "individual",
		"iso6393": "nsq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maritime Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "nsr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nali",
		"type": "living",
		"scope": "individual",
		"iso6393": "nss",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tase Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "nst",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sierra Negra Nahuatl",
		"type": "living",
		"scope": "individual",
		"iso6393": "nsu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southwestern Nisu",
		"type": "living",
		"scope": "individual",
		"iso6393": "nsv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Navut",
		"type": "living",
		"scope": "individual",
		"iso6393": "nsw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nsongo",
		"type": "living",
		"scope": "individual",
		"iso6393": "nsx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nasal",
		"type": "living",
		"scope": "individual",
		"iso6393": "nsy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nisenan",
		"type": "living",
		"scope": "individual",
		"iso6393": "nsz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Tidung",
		"type": "living",
		"scope": "individual",
		"iso6393": "ntd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nathembo",
		"type": "living",
		"scope": "individual",
		"iso6393": "nte",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngantangarra",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ntg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Natioro",
		"type": "living",
		"scope": "individual",
		"iso6393": "nti",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngaanyatjarra",
		"type": "living",
		"scope": "individual",
		"iso6393": "ntj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ikoma-Nata-Isenye",
		"type": "living",
		"scope": "individual",
		"iso6393": "ntk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nateni",
		"type": "living",
		"scope": "individual",
		"iso6393": "ntm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ntomba",
		"type": "living",
		"scope": "individual",
		"iso6393": "nto",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Tepehuan",
		"type": "living",
		"scope": "individual",
		"iso6393": "ntp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Delo",
		"type": "living",
		"scope": "individual",
		"iso6393": "ntr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Natügu",
		"type": "living",
		"scope": "individual",
		"iso6393": "ntu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nottoway",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ntw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tangkhul Naga (Myanmar)",
		"type": "living",
		"scope": "individual",
		"iso6393": "ntx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mantsi",
		"type": "living",
		"scope": "individual",
		"iso6393": "nty",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Natanzi",
		"type": "living",
		"scope": "individual",
		"iso6393": "ntz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yuanga",
		"type": "living",
		"scope": "individual",
		"iso6393": "nua",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nukuini",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "nuc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngala",
		"type": "living",
		"scope": "individual",
		"iso6393": "nud",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngundu",
		"type": "living",
		"scope": "individual",
		"iso6393": "nue",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nusu",
		"type": "living",
		"scope": "individual",
		"iso6393": "nuf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nungali",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "nug",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ndunda",
		"type": "living",
		"scope": "individual",
		"iso6393": "nuh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngumbi",
		"type": "living",
		"scope": "individual",
		"iso6393": "nui",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyole",
		"type": "living",
		"scope": "individual",
		"iso6393": "nuj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nuu-chah-nulth",
		"type": "living",
		"scope": "individual",
		"iso6393": "nuk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nusa Laut",
		"type": "living",
		"scope": "individual",
		"iso6393": "nul",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Niuafo'ou",
		"type": "living",
		"scope": "individual",
		"iso6393": "num",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Anong",
		"type": "living",
		"scope": "individual",
		"iso6393": "nun",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nguôn",
		"type": "living",
		"scope": "individual",
		"iso6393": "nuo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nupe-Nupe-Tako",
		"type": "living",
		"scope": "individual",
		"iso6393": "nup",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nukumanu",
		"type": "living",
		"scope": "individual",
		"iso6393": "nuq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nukuria",
		"type": "living",
		"scope": "individual",
		"iso6393": "nur",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nuer",
		"type": "living",
		"scope": "individual",
		"iso6393": "nus",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nung (Viet Nam)",
		"type": "living",
		"scope": "individual",
		"iso6393": "nut",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngbundu",
		"type": "living",
		"scope": "individual",
		"iso6393": "nuu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Nuni",
		"type": "living",
		"scope": "individual",
		"iso6393": "nuv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nguluwan",
		"type": "living",
		"scope": "individual",
		"iso6393": "nuw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mehek",
		"type": "living",
		"scope": "individual",
		"iso6393": "nux",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nunggubuyu",
		"type": "living",
		"scope": "individual",
		"iso6393": "nuy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tlamacazapa Nahuatl",
		"type": "living",
		"scope": "individual",
		"iso6393": "nuz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nasarian",
		"type": "living",
		"scope": "individual",
		"iso6393": "nvh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Namiae",
		"type": "living",
		"scope": "individual",
		"iso6393": "nvm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyokon",
		"type": "living",
		"scope": "individual",
		"iso6393": "nvo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nawathinehena",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "nwa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyabwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "nwb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Classical Newari",
		"type": "historical",
		"scope": "individual",
		"iso6393": "nwc",
		"iso6392B": "nwc",
		"iso6392T": "nwc",
		"iso6391": null
	},
	{
		"name": "Ngwe",
		"type": "living",
		"scope": "individual",
		"iso6393": "nwe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngayawung",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "nwg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southwest Tanna",
		"type": "living",
		"scope": "individual",
		"iso6393": "nwi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyamusa-Molo",
		"type": "living",
		"scope": "individual",
		"iso6393": "nwm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nauo",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "nwo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nawaru",
		"type": "living",
		"scope": "individual",
		"iso6393": "nwr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Middle Newar",
		"type": "historical",
		"scope": "individual",
		"iso6393": "nwx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nottoway-Meherrin",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "nwy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nauete",
		"type": "living",
		"scope": "individual",
		"iso6393": "nxa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngando (Democratic Republic of Congo)",
		"type": "living",
		"scope": "individual",
		"iso6393": "nxd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nage",
		"type": "living",
		"scope": "individual",
		"iso6393": "nxe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngad'a",
		"type": "living",
		"scope": "individual",
		"iso6393": "nxg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nindi",
		"type": "living",
		"scope": "individual",
		"iso6393": "nxi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koki Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "nxk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "South Nuaulu",
		"type": "living",
		"scope": "individual",
		"iso6393": "nxl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Numidian",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "nxm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngawun",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "nxn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ndambomo",
		"type": "living",
		"scope": "individual",
		"iso6393": "nxo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Naxi",
		"type": "living",
		"scope": "individual",
		"iso6393": "nxq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ninggerum",
		"type": "living",
		"scope": "individual",
		"iso6393": "nxr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Narau",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "nxu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nafri",
		"type": "living",
		"scope": "individual",
		"iso6393": "nxx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyanja",
		"type": "living",
		"scope": "individual",
		"iso6393": "nya",
		"iso6392B": "nya",
		"iso6392T": "nya",
		"iso6391": "ny"
	},
	{
		"name": "Nyangbo",
		"type": "living",
		"scope": "individual",
		"iso6393": "nyb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyanga-li",
		"type": "living",
		"scope": "individual",
		"iso6393": "nyc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyore",
		"type": "living",
		"scope": "individual",
		"iso6393": "nyd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyengo",
		"type": "living",
		"scope": "individual",
		"iso6393": "nye",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Giryama",
		"type": "living",
		"scope": "individual",
		"iso6393": "nyf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyindu",
		"type": "living",
		"scope": "individual",
		"iso6393": "nyg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyigina",
		"type": "living",
		"scope": "individual",
		"iso6393": "nyh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ama (Sudan)",
		"type": "living",
		"scope": "individual",
		"iso6393": "nyi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyanga",
		"type": "living",
		"scope": "individual",
		"iso6393": "nyj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyaneka",
		"type": "living",
		"scope": "individual",
		"iso6393": "nyk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyeu",
		"type": "living",
		"scope": "individual",
		"iso6393": "nyl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyamwezi",
		"type": "living",
		"scope": "individual",
		"iso6393": "nym",
		"iso6392B": "nym",
		"iso6392T": "nym",
		"iso6391": null
	},
	{
		"name": "Nyankole",
		"type": "living",
		"scope": "individual",
		"iso6393": "nyn",
		"iso6392B": "nyn",
		"iso6392T": "nyn",
		"iso6391": null
	},
	{
		"name": "Nyoro",
		"type": "living",
		"scope": "individual",
		"iso6393": "nyo",
		"iso6392B": "nyo",
		"iso6392T": "nyo",
		"iso6391": null
	},
	{
		"name": "Nyang'i",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "nyp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nayini",
		"type": "living",
		"scope": "individual",
		"iso6393": "nyq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyiha (Malawi)",
		"type": "living",
		"scope": "individual",
		"iso6393": "nyr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyunga",
		"type": "living",
		"scope": "individual",
		"iso6393": "nys",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyawaygi",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "nyt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyungwe",
		"type": "living",
		"scope": "individual",
		"iso6393": "nyu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyulnyul",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "nyv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyaw",
		"type": "living",
		"scope": "individual",
		"iso6393": "nyw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nganyaywana",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "nyx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyakyusa-Ngonde",
		"type": "living",
		"scope": "individual",
		"iso6393": "nyy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tigon Mbembe",
		"type": "living",
		"scope": "individual",
		"iso6393": "nza",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Njebi",
		"type": "living",
		"scope": "individual",
		"iso6393": "nzb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nzima",
		"type": "living",
		"scope": "individual",
		"iso6393": "nzi",
		"iso6392B": "nzi",
		"iso6392T": "nzi",
		"iso6391": null
	},
	{
		"name": "Nzakara",
		"type": "living",
		"scope": "individual",
		"iso6393": "nzk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zeme Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "nzm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "New Zealand Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "nzs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Teke-Nzikou",
		"type": "living",
		"scope": "individual",
		"iso6393": "nzu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nzakambay",
		"type": "living",
		"scope": "individual",
		"iso6393": "nzy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nanga Dama Dogon",
		"type": "living",
		"scope": "individual",
		"iso6393": "nzz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Orok",
		"type": "living",
		"scope": "individual",
		"iso6393": "oaa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Oroch",
		"type": "living",
		"scope": "individual",
		"iso6393": "oac",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Old Aramaic (up to 700 BCE)",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "oar",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Old Avar",
		"type": "historical",
		"scope": "individual",
		"iso6393": "oav",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Obispeño",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "obi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Bontok",
		"type": "living",
		"scope": "individual",
		"iso6393": "obk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Oblo",
		"type": "living",
		"scope": "individual",
		"iso6393": "obl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Moabite",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "obm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Obo Manobo",
		"type": "living",
		"scope": "individual",
		"iso6393": "obo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Old Burmese",
		"type": "historical",
		"scope": "individual",
		"iso6393": "obr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Old Breton",
		"type": "historical",
		"scope": "individual",
		"iso6393": "obt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Obulom",
		"type": "living",
		"scope": "individual",
		"iso6393": "obu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ocaina",
		"type": "living",
		"scope": "individual",
		"iso6393": "oca",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Old Chinese",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "och",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Occitan (post 1500)",
		"type": "living",
		"scope": "individual",
		"iso6393": "oci",
		"iso6392B": "oci",
		"iso6392T": "oci",
		"iso6391": "oc"
	},
	{
		"name": "Old Cornish",
		"type": "historical",
		"scope": "individual",
		"iso6393": "oco",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Atzingo Matlatzinca",
		"type": "living",
		"scope": "individual",
		"iso6393": "ocu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Odut",
		"type": "living",
		"scope": "individual",
		"iso6393": "oda",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Od",
		"type": "living",
		"scope": "individual",
		"iso6393": "odk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Old Dutch",
		"type": "historical",
		"scope": "individual",
		"iso6393": "odt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Odual",
		"type": "living",
		"scope": "individual",
		"iso6393": "odu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ofo",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ofo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Old Frisian",
		"type": "historical",
		"scope": "individual",
		"iso6393": "ofs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Efutop",
		"type": "living",
		"scope": "individual",
		"iso6393": "ofu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ogbia",
		"type": "living",
		"scope": "individual",
		"iso6393": "ogb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ogbah",
		"type": "living",
		"scope": "individual",
		"iso6393": "ogc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Old Georgian",
		"type": "historical",
		"scope": "individual",
		"iso6393": "oge",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ogbogolo",
		"type": "living",
		"scope": "individual",
		"iso6393": "ogg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Khana",
		"type": "living",
		"scope": "individual",
		"iso6393": "ogo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ogbronuagum",
		"type": "living",
		"scope": "individual",
		"iso6393": "ogu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Old Hittite",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "oht",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Old Hungarian",
		"type": "historical",
		"scope": "individual",
		"iso6393": "ohu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Oirata",
		"type": "living",
		"scope": "individual",
		"iso6393": "oia",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Inebu One",
		"type": "living",
		"scope": "individual",
		"iso6393": "oin",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northwestern Ojibwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "ojb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Central Ojibwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "ojc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Ojibwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "ojg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ojibwa",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "oji",
		"iso6392B": "oji",
		"iso6392T": "oji",
		"iso6391": "oj"
	},
	{
		"name": "Old Japanese",
		"type": "historical",
		"scope": "individual",
		"iso6393": "ojp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Severn Ojibwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "ojs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ontong Java",
		"type": "living",
		"scope": "individual",
		"iso6393": "ojv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Ojibwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "ojw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Okanagan",
		"type": "living",
		"scope": "individual",
		"iso6393": "oka",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Okobo",
		"type": "living",
		"scope": "individual",
		"iso6393": "okb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Okodia",
		"type": "living",
		"scope": "individual",
		"iso6393": "okd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Okpe (Southwestern Edo)",
		"type": "living",
		"scope": "individual",
		"iso6393": "oke",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koko Babangk",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "okg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koresh-e Rostam",
		"type": "living",
		"scope": "individual",
		"iso6393": "okh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Okiek",
		"type": "living",
		"scope": "individual",
		"iso6393": "oki",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Oko-Juwoi",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "okj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kwamtim One",
		"type": "living",
		"scope": "individual",
		"iso6393": "okk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Old Kentish Sign Language",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "okl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Middle Korean (10th-16th cent.)",
		"type": "historical",
		"scope": "individual",
		"iso6393": "okm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Oki-No-Erabu",
		"type": "living",
		"scope": "individual",
		"iso6393": "okn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Old Korean (3rd-9th cent.)",
		"type": "historical",
		"scope": "individual",
		"iso6393": "oko",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kirike",
		"type": "living",
		"scope": "individual",
		"iso6393": "okr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Oko-Eni-Osayen",
		"type": "living",
		"scope": "individual",
		"iso6393": "oks",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Oku",
		"type": "living",
		"scope": "individual",
		"iso6393": "oku",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Orokaiva",
		"type": "living",
		"scope": "individual",
		"iso6393": "okv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Okpe (Northwestern Edo)",
		"type": "living",
		"scope": "individual",
		"iso6393": "okx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Walungge",
		"type": "living",
		"scope": "individual",
		"iso6393": "ola",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mochi",
		"type": "living",
		"scope": "individual",
		"iso6393": "old",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Olekha",
		"type": "living",
		"scope": "individual",
		"iso6393": "ole",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Olkol",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "olk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Oloma",
		"type": "living",
		"scope": "individual",
		"iso6393": "olm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Livvi",
		"type": "living",
		"scope": "individual",
		"iso6393": "olo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Olrat",
		"type": "living",
		"scope": "individual",
		"iso6393": "olr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Old Lithuanian",
		"type": "historical",
		"scope": "individual",
		"iso6393": "olt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kuvale",
		"type": "living",
		"scope": "individual",
		"iso6393": "olu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Omaha-Ponca",
		"type": "living",
		"scope": "individual",
		"iso6393": "oma",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "East Ambae",
		"type": "living",
		"scope": "individual",
		"iso6393": "omb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mochica",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "omc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Omagua",
		"type": "living",
		"scope": "individual",
		"iso6393": "omg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Omi",
		"type": "living",
		"scope": "individual",
		"iso6393": "omi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Omok",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "omk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ombo",
		"type": "living",
		"scope": "individual",
		"iso6393": "oml",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Minoan",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "omn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Utarmbung",
		"type": "living",
		"scope": "individual",
		"iso6393": "omo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Old Manipuri",
		"type": "historical",
		"scope": "individual",
		"iso6393": "omp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Old Marathi",
		"type": "historical",
		"scope": "individual",
		"iso6393": "omr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Omotik",
		"type": "living",
		"scope": "individual",
		"iso6393": "omt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Omurano",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "omu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "South Tairora",
		"type": "living",
		"scope": "individual",
		"iso6393": "omw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Old Mon",
		"type": "historical",
		"scope": "individual",
		"iso6393": "omx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ona",
		"type": "living",
		"scope": "individual",
		"iso6393": "ona",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lingao",
		"type": "living",
		"scope": "individual",
		"iso6393": "onb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Oneida",
		"type": "living",
		"scope": "individual",
		"iso6393": "one",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Olo",
		"type": "living",
		"scope": "individual",
		"iso6393": "ong",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Onin",
		"type": "living",
		"scope": "individual",
		"iso6393": "oni",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Onjob",
		"type": "living",
		"scope": "individual",
		"iso6393": "onj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kabore One",
		"type": "living",
		"scope": "individual",
		"iso6393": "onk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Onobasulu",
		"type": "living",
		"scope": "individual",
		"iso6393": "onn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Onondaga",
		"type": "living",
		"scope": "individual",
		"iso6393": "ono",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sartang",
		"type": "living",
		"scope": "individual",
		"iso6393": "onp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern One",
		"type": "living",
		"scope": "individual",
		"iso6393": "onr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ono",
		"type": "living",
		"scope": "individual",
		"iso6393": "ons",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ontenu",
		"type": "living",
		"scope": "individual",
		"iso6393": "ont",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Unua",
		"type": "living",
		"scope": "individual",
		"iso6393": "onu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Old Nubian",
		"type": "historical",
		"scope": "individual",
		"iso6393": "onw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Onin Based Pidgin",
		"type": "living",
		"scope": "individual",
		"iso6393": "onx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tohono O'odham",
		"type": "living",
		"scope": "individual",
		"iso6393": "ood",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ong",
		"type": "living",
		"scope": "individual",
		"iso6393": "oog",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Önge",
		"type": "living",
		"scope": "individual",
		"iso6393": "oon",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Oorlams",
		"type": "living",
		"scope": "individual",
		"iso6393": "oor",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Old Ossetic",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "oos",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Okpamheri",
		"type": "living",
		"scope": "individual",
		"iso6393": "opa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kopkaka",
		"type": "living",
		"scope": "individual",
		"iso6393": "opk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Oksapmin",
		"type": "living",
		"scope": "individual",
		"iso6393": "opm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Opao",
		"type": "living",
		"scope": "individual",
		"iso6393": "opo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Opata",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "opt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ofayé",
		"type": "living",
		"scope": "individual",
		"iso6393": "opy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Oroha",
		"type": "living",
		"scope": "individual",
		"iso6393": "ora",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Orma",
		"type": "living",
		"scope": "individual",
		"iso6393": "orc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Orejón",
		"type": "living",
		"scope": "individual",
		"iso6393": "ore",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Oring",
		"type": "living",
		"scope": "individual",
		"iso6393": "org",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Oroqen",
		"type": "living",
		"scope": "individual",
		"iso6393": "orh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Oriya (macrolanguage)",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "ori",
		"iso6392B": "ori",
		"iso6392T": "ori",
		"iso6391": "or"
	},
	{
		"name": "Oromo",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "orm",
		"iso6392B": "orm",
		"iso6392T": "orm",
		"iso6391": "om"
	},
	{
		"name": "Orang Kanaq",
		"type": "living",
		"scope": "individual",
		"iso6393": "orn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Orokolo",
		"type": "living",
		"scope": "individual",
		"iso6393": "oro",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Oruma",
		"type": "living",
		"scope": "individual",
		"iso6393": "orr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Orang Seletar",
		"type": "living",
		"scope": "individual",
		"iso6393": "ors",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Adivasi Oriya",
		"type": "living",
		"scope": "individual",
		"iso6393": "ort",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ormuri",
		"type": "living",
		"scope": "individual",
		"iso6393": "oru",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Old Russian",
		"type": "historical",
		"scope": "individual",
		"iso6393": "orv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Oro Win",
		"type": "living",
		"scope": "individual",
		"iso6393": "orw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Oro",
		"type": "living",
		"scope": "individual",
		"iso6393": "orx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Odia",
		"type": "living",
		"scope": "individual",
		"iso6393": "ory",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ormu",
		"type": "living",
		"scope": "individual",
		"iso6393": "orz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Osage",
		"type": "living",
		"scope": "individual",
		"iso6393": "osa",
		"iso6392B": "osa",
		"iso6392T": "osa",
		"iso6391": null
	},
	{
		"name": "Oscan",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "osc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Osing",
		"type": "living",
		"scope": "individual",
		"iso6393": "osi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ososo",
		"type": "living",
		"scope": "individual",
		"iso6393": "oso",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Old Spanish",
		"type": "historical",
		"scope": "individual",
		"iso6393": "osp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ossetian",
		"type": "living",
		"scope": "individual",
		"iso6393": "oss",
		"iso6392B": "oss",
		"iso6392T": "oss",
		"iso6391": "os"
	},
	{
		"name": "Osatu",
		"type": "living",
		"scope": "individual",
		"iso6393": "ost",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern One",
		"type": "living",
		"scope": "individual",
		"iso6393": "osu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Old Saxon",
		"type": "historical",
		"scope": "individual",
		"iso6393": "osx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ottoman Turkish (1500-1928)",
		"type": "historical",
		"scope": "individual",
		"iso6393": "ota",
		"iso6392B": "ota",
		"iso6392T": "ota",
		"iso6391": null
	},
	{
		"name": "Old Tibetan",
		"type": "historical",
		"scope": "individual",
		"iso6393": "otb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ot Danum",
		"type": "living",
		"scope": "individual",
		"iso6393": "otd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mezquital Otomi",
		"type": "living",
		"scope": "individual",
		"iso6393": "ote",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Oti",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "oti",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Old Turkish",
		"type": "historical",
		"scope": "individual",
		"iso6393": "otk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tilapa Otomi",
		"type": "living",
		"scope": "individual",
		"iso6393": "otl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Highland Otomi",
		"type": "living",
		"scope": "individual",
		"iso6393": "otm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tenango Otomi",
		"type": "living",
		"scope": "individual",
		"iso6393": "otn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Querétaro Otomi",
		"type": "living",
		"scope": "individual",
		"iso6393": "otq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Otoro",
		"type": "living",
		"scope": "individual",
		"iso6393": "otr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Estado de México Otomi",
		"type": "living",
		"scope": "individual",
		"iso6393": "ots",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Temoaya Otomi",
		"type": "living",
		"scope": "individual",
		"iso6393": "ott",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Otuke",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "otu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ottawa",
		"type": "living",
		"scope": "individual",
		"iso6393": "otw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Texcatepec Otomi",
		"type": "living",
		"scope": "individual",
		"iso6393": "otx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Old Tamil",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "oty",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ixtenco Otomi",
		"type": "living",
		"scope": "individual",
		"iso6393": "otz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tagargrent",
		"type": "living",
		"scope": "individual",
		"iso6393": "oua",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Glio-Oubi",
		"type": "living",
		"scope": "individual",
		"iso6393": "oub",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Oune",
		"type": "living",
		"scope": "individual",
		"iso6393": "oue",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Old Uighur",
		"type": "historical",
		"scope": "individual",
		"iso6393": "oui",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ouma",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "oum",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Owiniga",
		"type": "living",
		"scope": "individual",
		"iso6393": "owi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Old Welsh",
		"type": "historical",
		"scope": "individual",
		"iso6393": "owl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Oy",
		"type": "living",
		"scope": "individual",
		"iso6393": "oyb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Oyda",
		"type": "living",
		"scope": "individual",
		"iso6393": "oyd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wayampi",
		"type": "living",
		"scope": "individual",
		"iso6393": "oym",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Oya'oya",
		"type": "living",
		"scope": "individual",
		"iso6393": "oyy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koonzime",
		"type": "living",
		"scope": "individual",
		"iso6393": "ozm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Parecís",
		"type": "living",
		"scope": "individual",
		"iso6393": "pab",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pacoh",
		"type": "living",
		"scope": "individual",
		"iso6393": "pac",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Paumarí",
		"type": "living",
		"scope": "individual",
		"iso6393": "pad",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pagibete",
		"type": "living",
		"scope": "individual",
		"iso6393": "pae",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Paranawát",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "paf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pangasinan",
		"type": "living",
		"scope": "individual",
		"iso6393": "pag",
		"iso6392B": "pag",
		"iso6392T": "pag",
		"iso6391": null
	},
	{
		"name": "Tenharim",
		"type": "living",
		"scope": "individual",
		"iso6393": "pah",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pe",
		"type": "living",
		"scope": "individual",
		"iso6393": "pai",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Parakanã",
		"type": "living",
		"scope": "individual",
		"iso6393": "pak",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pahlavi",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "pal",
		"iso6392B": "pal",
		"iso6392T": "pal",
		"iso6391": null
	},
	{
		"name": "Pampanga",
		"type": "living",
		"scope": "individual",
		"iso6393": "pam",
		"iso6392B": "pam",
		"iso6392T": "pam",
		"iso6391": null
	},
	{
		"name": "Panjabi",
		"type": "living",
		"scope": "individual",
		"iso6393": "pan",
		"iso6392B": "pan",
		"iso6392T": "pan",
		"iso6391": "pa"
	},
	{
		"name": "Northern Paiute",
		"type": "living",
		"scope": "individual",
		"iso6393": "pao",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Papiamento",
		"type": "living",
		"scope": "individual",
		"iso6393": "pap",
		"iso6392B": "pap",
		"iso6392T": "pap",
		"iso6391": null
	},
	{
		"name": "Parya",
		"type": "living",
		"scope": "individual",
		"iso6393": "paq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Panamint",
		"type": "living",
		"scope": "individual",
		"iso6393": "par",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Papasena",
		"type": "living",
		"scope": "individual",
		"iso6393": "pas",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Papitalai",
		"type": "living",
		"scope": "individual",
		"iso6393": "pat",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Palauan",
		"type": "living",
		"scope": "individual",
		"iso6393": "pau",
		"iso6392B": "pau",
		"iso6392T": "pau",
		"iso6391": null
	},
	{
		"name": "Pakaásnovos",
		"type": "living",
		"scope": "individual",
		"iso6393": "pav",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pawnee",
		"type": "living",
		"scope": "individual",
		"iso6393": "paw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pankararé",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "pax",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pech",
		"type": "living",
		"scope": "individual",
		"iso6393": "pay",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pankararú",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "paz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Páez",
		"type": "living",
		"scope": "individual",
		"iso6393": "pbb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Patamona",
		"type": "living",
		"scope": "individual",
		"iso6393": "pbc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mezontla Popoloca",
		"type": "living",
		"scope": "individual",
		"iso6393": "pbe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Coyotepec Popoloca",
		"type": "living",
		"scope": "individual",
		"iso6393": "pbf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Paraujano",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "pbg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "E'ñapa Woromaipu",
		"type": "living",
		"scope": "individual",
		"iso6393": "pbh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Parkwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "pbi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mak (Nigeria)",
		"type": "living",
		"scope": "individual",
		"iso6393": "pbl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kpasam",
		"type": "living",
		"scope": "individual",
		"iso6393": "pbn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Papel",
		"type": "living",
		"scope": "individual",
		"iso6393": "pbo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Badyara",
		"type": "living",
		"scope": "individual",
		"iso6393": "pbp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pangwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "pbr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Central Pame",
		"type": "living",
		"scope": "individual",
		"iso6393": "pbs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Pashto",
		"type": "living",
		"scope": "individual",
		"iso6393": "pbt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Pashto",
		"type": "living",
		"scope": "individual",
		"iso6393": "pbu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pnar",
		"type": "living",
		"scope": "individual",
		"iso6393": "pbv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pyu (Papua New Guinea)",
		"type": "living",
		"scope": "individual",
		"iso6393": "pby",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Santa Inés Ahuatempan Popoloca",
		"type": "living",
		"scope": "individual",
		"iso6393": "pca",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pear",
		"type": "living",
		"scope": "individual",
		"iso6393": "pcb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bouyei",
		"type": "living",
		"scope": "individual",
		"iso6393": "pcc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Picard",
		"type": "living",
		"scope": "individual",
		"iso6393": "pcd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ruching Palaung",
		"type": "living",
		"scope": "individual",
		"iso6393": "pce",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Paliyan",
		"type": "living",
		"scope": "individual",
		"iso6393": "pcf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Paniya",
		"type": "living",
		"scope": "individual",
		"iso6393": "pcg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pardhan",
		"type": "living",
		"scope": "individual",
		"iso6393": "pch",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Duruwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "pci",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Parenga",
		"type": "living",
		"scope": "individual",
		"iso6393": "pcj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Paite Chin",
		"type": "living",
		"scope": "individual",
		"iso6393": "pck",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pardhi",
		"type": "living",
		"scope": "individual",
		"iso6393": "pcl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nigerian Pidgin",
		"type": "living",
		"scope": "individual",
		"iso6393": "pcm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Piti",
		"type": "living",
		"scope": "individual",
		"iso6393": "pcn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pacahuara",
		"type": "living",
		"scope": "individual",
		"iso6393": "pcp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pyapun",
		"type": "living",
		"scope": "individual",
		"iso6393": "pcw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Anam",
		"type": "living",
		"scope": "individual",
		"iso6393": "pda",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pennsylvania German",
		"type": "living",
		"scope": "individual",
		"iso6393": "pdc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pa Di",
		"type": "living",
		"scope": "individual",
		"iso6393": "pdi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Podena",
		"type": "living",
		"scope": "individual",
		"iso6393": "pdn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Padoe",
		"type": "living",
		"scope": "individual",
		"iso6393": "pdo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Plautdietsch",
		"type": "living",
		"scope": "individual",
		"iso6393": "pdt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kayan",
		"type": "living",
		"scope": "individual",
		"iso6393": "pdu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Peranakan Indonesian",
		"type": "living",
		"scope": "individual",
		"iso6393": "pea",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Pomo",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "peb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mala (Papua New Guinea)",
		"type": "living",
		"scope": "individual",
		"iso6393": "ped",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Taje",
		"type": "living",
		"scope": "individual",
		"iso6393": "pee",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northeastern Pomo",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "pef",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pengo",
		"type": "living",
		"scope": "individual",
		"iso6393": "peg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bonan",
		"type": "living",
		"scope": "individual",
		"iso6393": "peh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chichimeca-Jonaz",
		"type": "living",
		"scope": "individual",
		"iso6393": "pei",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Pomo",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "pej",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Penchal",
		"type": "living",
		"scope": "individual",
		"iso6393": "pek",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pekal",
		"type": "living",
		"scope": "individual",
		"iso6393": "pel",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Phende",
		"type": "living",
		"scope": "individual",
		"iso6393": "pem",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Old Persian (ca. 600-400 B.C.)",
		"type": "historical",
		"scope": "individual",
		"iso6393": "peo",
		"iso6392B": "peo",
		"iso6392T": "peo",
		"iso6391": null
	},
	{
		"name": "Kunja",
		"type": "living",
		"scope": "individual",
		"iso6393": "pep",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Pomo",
		"type": "living",
		"scope": "individual",
		"iso6393": "peq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Iranian Persian",
		"type": "living",
		"scope": "individual",
		"iso6393": "pes",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pémono",
		"type": "living",
		"scope": "individual",
		"iso6393": "pev",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Petats",
		"type": "living",
		"scope": "individual",
		"iso6393": "pex",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Petjo",
		"type": "living",
		"scope": "individual",
		"iso6393": "pey",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Penan",
		"type": "living",
		"scope": "individual",
		"iso6393": "pez",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pááfang",
		"type": "living",
		"scope": "individual",
		"iso6393": "pfa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Peere",
		"type": "living",
		"scope": "individual",
		"iso6393": "pfe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pfaelzisch",
		"type": "living",
		"scope": "individual",
		"iso6393": "pfl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sudanese Creole Arabic",
		"type": "living",
		"scope": "individual",
		"iso6393": "pga",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gāndhārī",
		"type": "historical",
		"scope": "individual",
		"iso6393": "pgd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pangwali",
		"type": "living",
		"scope": "individual",
		"iso6393": "pgg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pagi",
		"type": "living",
		"scope": "individual",
		"iso6393": "pgi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rerep",
		"type": "living",
		"scope": "individual",
		"iso6393": "pgk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Primitive Irish",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "pgl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Paelignian",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "pgn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pangseng",
		"type": "living",
		"scope": "individual",
		"iso6393": "pgs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pagu",
		"type": "living",
		"scope": "individual",
		"iso6393": "pgu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Papua New Guinean Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "pgz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pa-Hng",
		"type": "living",
		"scope": "individual",
		"iso6393": "pha",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Phudagi",
		"type": "living",
		"scope": "individual",
		"iso6393": "phd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Phuong",
		"type": "living",
		"scope": "individual",
		"iso6393": "phg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Phukha",
		"type": "living",
		"scope": "individual",
		"iso6393": "phh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Phake",
		"type": "living",
		"scope": "individual",
		"iso6393": "phk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Phalura",
		"type": "living",
		"scope": "individual",
		"iso6393": "phl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Phimbi",
		"type": "living",
		"scope": "individual",
		"iso6393": "phm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Phoenician",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "phn",
		"iso6392B": "phn",
		"iso6392T": "phn",
		"iso6391": null
	},
	{
		"name": "Phunoi",
		"type": "living",
		"scope": "individual",
		"iso6393": "pho",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Phana'",
		"type": "living",
		"scope": "individual",
		"iso6393": "phq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pahari-Potwari",
		"type": "living",
		"scope": "individual",
		"iso6393": "phr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Phu Thai",
		"type": "living",
		"scope": "individual",
		"iso6393": "pht",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Phuan",
		"type": "living",
		"scope": "individual",
		"iso6393": "phu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pahlavani",
		"type": "living",
		"scope": "individual",
		"iso6393": "phv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Phangduwali",
		"type": "living",
		"scope": "individual",
		"iso6393": "phw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pima Bajo",
		"type": "living",
		"scope": "individual",
		"iso6393": "pia",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yine",
		"type": "living",
		"scope": "individual",
		"iso6393": "pib",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pinji",
		"type": "living",
		"scope": "individual",
		"iso6393": "pic",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Piaroa",
		"type": "living",
		"scope": "individual",
		"iso6393": "pid",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Piro",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "pie",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pingelapese",
		"type": "living",
		"scope": "individual",
		"iso6393": "pif",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pisabo",
		"type": "living",
		"scope": "individual",
		"iso6393": "pig",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pitcairn-Norfolk",
		"type": "living",
		"scope": "individual",
		"iso6393": "pih",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pini",
		"type": "living",
		"scope": "individual",
		"iso6393": "pii",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pijao",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "pij",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yom",
		"type": "living",
		"scope": "individual",
		"iso6393": "pil",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Powhatan",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "pim",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Piame",
		"type": "living",
		"scope": "individual",
		"iso6393": "pin",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Piapoco",
		"type": "living",
		"scope": "individual",
		"iso6393": "pio",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pero",
		"type": "living",
		"scope": "individual",
		"iso6393": "pip",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Piratapuyo",
		"type": "living",
		"scope": "individual",
		"iso6393": "pir",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pijin",
		"type": "living",
		"scope": "individual",
		"iso6393": "pis",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pitta Pitta",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "pit",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pintupi-Luritja",
		"type": "living",
		"scope": "individual",
		"iso6393": "piu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pileni",
		"type": "living",
		"scope": "individual",
		"iso6393": "piv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pimbwe",
		"type": "living",
		"scope": "individual",
		"iso6393": "piw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Piu",
		"type": "living",
		"scope": "individual",
		"iso6393": "pix",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Piya-Kwonci",
		"type": "living",
		"scope": "individual",
		"iso6393": "piy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pije",
		"type": "living",
		"scope": "individual",
		"iso6393": "piz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pitjantjatjara",
		"type": "living",
		"scope": "individual",
		"iso6393": "pjt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ardhamāgadhī Prākrit",
		"type": "historical",
		"scope": "individual",
		"iso6393": "pka",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pokomo",
		"type": "living",
		"scope": "individual",
		"iso6393": "pkb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Paekche",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "pkc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pak-Tong",
		"type": "living",
		"scope": "individual",
		"iso6393": "pkg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pankhu",
		"type": "living",
		"scope": "individual",
		"iso6393": "pkh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pakanha",
		"type": "living",
		"scope": "individual",
		"iso6393": "pkn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pökoot",
		"type": "living",
		"scope": "individual",
		"iso6393": "pko",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pukapuka",
		"type": "living",
		"scope": "individual",
		"iso6393": "pkp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Attapady Kurumba",
		"type": "living",
		"scope": "individual",
		"iso6393": "pkr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pakistan Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "pks",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maleng",
		"type": "living",
		"scope": "individual",
		"iso6393": "pkt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Paku",
		"type": "living",
		"scope": "individual",
		"iso6393": "pku",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Miani",
		"type": "living",
		"scope": "individual",
		"iso6393": "pla",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Polonombauk",
		"type": "living",
		"scope": "individual",
		"iso6393": "plb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Central Palawano",
		"type": "living",
		"scope": "individual",
		"iso6393": "plc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Polari",
		"type": "living",
		"scope": "individual",
		"iso6393": "pld",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Palu'e",
		"type": "living",
		"scope": "individual",
		"iso6393": "ple",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pilagá",
		"type": "living",
		"scope": "individual",
		"iso6393": "plg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Paulohi",
		"type": "living",
		"scope": "individual",
		"iso6393": "plh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pali",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "pli",
		"iso6392B": "pli",
		"iso6392T": "pli",
		"iso6391": "pi"
	},
	{
		"name": "Polci",
		"type": "living",
		"scope": "individual",
		"iso6393": "plj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kohistani Shina",
		"type": "living",
		"scope": "individual",
		"iso6393": "plk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shwe Palaung",
		"type": "living",
		"scope": "individual",
		"iso6393": "pll",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Palenquero",
		"type": "living",
		"scope": "individual",
		"iso6393": "pln",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Oluta Popoluca",
		"type": "living",
		"scope": "individual",
		"iso6393": "plo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Palpa",
		"type": "living",
		"scope": "individual",
		"iso6393": "plp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Palaic",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "plq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Palaka Senoufo",
		"type": "living",
		"scope": "individual",
		"iso6393": "plr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "San Marcos Tlacoyalco Popoloca",
		"type": "living",
		"scope": "individual",
		"iso6393": "pls",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Plateau Malagasy",
		"type": "living",
		"scope": "individual",
		"iso6393": "plt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Palikúr",
		"type": "living",
		"scope": "individual",
		"iso6393": "plu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southwest Palawano",
		"type": "living",
		"scope": "individual",
		"iso6393": "plv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Brooke's Point Palawano",
		"type": "living",
		"scope": "individual",
		"iso6393": "plw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bolyu",
		"type": "living",
		"scope": "individual",
		"iso6393": "ply",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Paluan",
		"type": "living",
		"scope": "individual",
		"iso6393": "plz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Paama",
		"type": "living",
		"scope": "individual",
		"iso6393": "pma",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pambia",
		"type": "living",
		"scope": "individual",
		"iso6393": "pmb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pallanganmiddang",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "pmd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pwaamei",
		"type": "living",
		"scope": "individual",
		"iso6393": "pme",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pamona",
		"type": "living",
		"scope": "individual",
		"iso6393": "pmf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Māhārāṣṭri Prākrit",
		"type": "historical",
		"scope": "individual",
		"iso6393": "pmh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Pumi",
		"type": "living",
		"scope": "individual",
		"iso6393": "pmi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Pumi",
		"type": "living",
		"scope": "individual",
		"iso6393": "pmj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pamlico",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "pmk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lingua Franca",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "pml",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pomo",
		"type": "living",
		"scope": "individual",
		"iso6393": "pmm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pam",
		"type": "living",
		"scope": "individual",
		"iso6393": "pmn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pom",
		"type": "living",
		"scope": "individual",
		"iso6393": "pmo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Pame",
		"type": "living",
		"scope": "individual",
		"iso6393": "pmq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Paynamar",
		"type": "living",
		"scope": "individual",
		"iso6393": "pmr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Piemontese",
		"type": "living",
		"scope": "individual",
		"iso6393": "pms",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tuamotuan",
		"type": "living",
		"scope": "individual",
		"iso6393": "pmt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Plains Miwok",
		"type": "living",
		"scope": "individual",
		"iso6393": "pmw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Poumei Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "pmx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Papuan Malay",
		"type": "living",
		"scope": "individual",
		"iso6393": "pmy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Pame",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "pmz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Punan Bah-Biau",
		"type": "living",
		"scope": "individual",
		"iso6393": "pna",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Panjabi",
		"type": "living",
		"scope": "individual",
		"iso6393": "pnb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pannei",
		"type": "living",
		"scope": "individual",
		"iso6393": "pnc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Penan",
		"type": "living",
		"scope": "individual",
		"iso6393": "pne",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pongu",
		"type": "living",
		"scope": "individual",
		"iso6393": "png",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Penrhyn",
		"type": "living",
		"scope": "individual",
		"iso6393": "pnh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aoheng",
		"type": "living",
		"scope": "individual",
		"iso6393": "pni",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pinjarup",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "pnj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Paunaka",
		"type": "living",
		"scope": "individual",
		"iso6393": "pnk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Paleni",
		"type": "living",
		"scope": "individual",
		"iso6393": "pnl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Punan Batu 1",
		"type": "living",
		"scope": "individual",
		"iso6393": "pnm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pinai-Hagahai",
		"type": "living",
		"scope": "individual",
		"iso6393": "pnn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Panobo",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "pno",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pancana",
		"type": "living",
		"scope": "individual",
		"iso6393": "pnp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pana (Burkina Faso)",
		"type": "living",
		"scope": "individual",
		"iso6393": "pnq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Panim",
		"type": "living",
		"scope": "individual",
		"iso6393": "pnr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ponosakan",
		"type": "living",
		"scope": "individual",
		"iso6393": "pns",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pontic",
		"type": "living",
		"scope": "individual",
		"iso6393": "pnt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jiongnai Bunu",
		"type": "living",
		"scope": "individual",
		"iso6393": "pnu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pinigura",
		"type": "living",
		"scope": "individual",
		"iso6393": "pnv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Panytyima",
		"type": "living",
		"scope": "individual",
		"iso6393": "pnw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Phong-Kniang",
		"type": "living",
		"scope": "individual",
		"iso6393": "pnx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pinyin",
		"type": "living",
		"scope": "individual",
		"iso6393": "pny",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pana (Central African Republic)",
		"type": "living",
		"scope": "individual",
		"iso6393": "pnz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Poqomam",
		"type": "living",
		"scope": "individual",
		"iso6393": "poc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "San Juan Atzingo Popoloca",
		"type": "living",
		"scope": "individual",
		"iso6393": "poe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Poke",
		"type": "living",
		"scope": "individual",
		"iso6393": "pof",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Potiguára",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "pog",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Poqomchi'",
		"type": "living",
		"scope": "individual",
		"iso6393": "poh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Highland Popoluca",
		"type": "living",
		"scope": "individual",
		"iso6393": "poi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pokangá",
		"type": "living",
		"scope": "individual",
		"iso6393": "pok",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Polish",
		"type": "living",
		"scope": "individual",
		"iso6393": "pol",
		"iso6392B": "pol",
		"iso6392T": "pol",
		"iso6391": "pl"
	},
	{
		"name": "Southeastern Pomo",
		"type": "living",
		"scope": "individual",
		"iso6393": "pom",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pohnpeian",
		"type": "living",
		"scope": "individual",
		"iso6393": "pon",
		"iso6392B": "pon",
		"iso6392T": "pon",
		"iso6391": null
	},
	{
		"name": "Central Pomo",
		"type": "living",
		"scope": "individual",
		"iso6393": "poo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pwapwâ",
		"type": "living",
		"scope": "individual",
		"iso6393": "pop",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Texistepec Popoluca",
		"type": "living",
		"scope": "individual",
		"iso6393": "poq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Portuguese",
		"type": "living",
		"scope": "individual",
		"iso6393": "por",
		"iso6392B": "por",
		"iso6392T": "por",
		"iso6391": "pt"
	},
	{
		"name": "Sayula Popoluca",
		"type": "living",
		"scope": "individual",
		"iso6393": "pos",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Potawatomi",
		"type": "living",
		"scope": "individual",
		"iso6393": "pot",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Upper Guinea Crioulo",
		"type": "living",
		"scope": "individual",
		"iso6393": "pov",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "San Felipe Otlaltepec Popoloca",
		"type": "living",
		"scope": "individual",
		"iso6393": "pow",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Polabian",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "pox",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pogolo",
		"type": "living",
		"scope": "individual",
		"iso6393": "poy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Papi",
		"type": "living",
		"scope": "individual",
		"iso6393": "ppe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Paipai",
		"type": "living",
		"scope": "individual",
		"iso6393": "ppi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Uma",
		"type": "living",
		"scope": "individual",
		"iso6393": "ppk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pipil",
		"type": "living",
		"scope": "individual",
		"iso6393": "ppl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Papuma",
		"type": "living",
		"scope": "individual",
		"iso6393": "ppm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Papapana",
		"type": "living",
		"scope": "individual",
		"iso6393": "ppn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Folopa",
		"type": "living",
		"scope": "individual",
		"iso6393": "ppo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pelende",
		"type": "living",
		"scope": "individual",
		"iso6393": "ppp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pei",
		"type": "living",
		"scope": "individual",
		"iso6393": "ppq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "San Luís Temalacayuca Popoloca",
		"type": "living",
		"scope": "individual",
		"iso6393": "pps",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pare",
		"type": "living",
		"scope": "individual",
		"iso6393": "ppt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Papora",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ppu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pa'a",
		"type": "living",
		"scope": "individual",
		"iso6393": "pqa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Malecite-Passamaquoddy",
		"type": "living",
		"scope": "individual",
		"iso6393": "pqm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lua'",
		"type": "living",
		"scope": "individual",
		"iso6393": "prb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Parachi",
		"type": "living",
		"scope": "individual",
		"iso6393": "prc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Parsi-Dari",
		"type": "living",
		"scope": "individual",
		"iso6393": "prd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Principense",
		"type": "living",
		"scope": "individual",
		"iso6393": "pre",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Paranan",
		"type": "living",
		"scope": "individual",
		"iso6393": "prf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Prussian",
		"type": "living",
		"scope": "individual",
		"iso6393": "prg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Porohanon",
		"type": "living",
		"scope": "individual",
		"iso6393": "prh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Paicî",
		"type": "living",
		"scope": "individual",
		"iso6393": "pri",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Parauk",
		"type": "living",
		"scope": "individual",
		"iso6393": "prk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Peruvian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "prl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kibiri",
		"type": "living",
		"scope": "individual",
		"iso6393": "prm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Prasuni",
		"type": "living",
		"scope": "individual",
		"iso6393": "prn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Old Provençal (to 1500)",
		"type": "historical",
		"scope": "individual",
		"iso6393": "pro",
		"iso6392B": "pro",
		"iso6392T": "pro",
		"iso6391": null
	},
	{
		"name": "Parsi",
		"type": "living",
		"scope": "individual",
		"iso6393": "prp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ashéninka Perené",
		"type": "living",
		"scope": "individual",
		"iso6393": "prq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Puri",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "prr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dari",
		"type": "living",
		"scope": "individual",
		"iso6393": "prs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Phai",
		"type": "living",
		"scope": "individual",
		"iso6393": "prt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Puragi",
		"type": "living",
		"scope": "individual",
		"iso6393": "pru",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Parawen",
		"type": "living",
		"scope": "individual",
		"iso6393": "prw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Purik",
		"type": "living",
		"scope": "individual",
		"iso6393": "prx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Providencia Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "prz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Asue Awyu",
		"type": "living",
		"scope": "individual",
		"iso6393": "psa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Persian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "psc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Plains Indian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "psd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Central Malay",
		"type": "living",
		"scope": "individual",
		"iso6393": "pse",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Penang Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "psg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southwest Pashai",
		"type": "living",
		"scope": "individual",
		"iso6393": "psh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southeast Pashai",
		"type": "living",
		"scope": "individual",
		"iso6393": "psi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Puerto Rican Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "psl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pauserna",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "psm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Panasuan",
		"type": "living",
		"scope": "individual",
		"iso6393": "psn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Polish Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "pso",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Philippine Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "psp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pasi",
		"type": "living",
		"scope": "individual",
		"iso6393": "psq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Portuguese Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "psr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kaulong",
		"type": "living",
		"scope": "individual",
		"iso6393": "pss",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Central Pashto",
		"type": "living",
		"scope": "individual",
		"iso6393": "pst",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sauraseni Prākrit",
		"type": "historical",
		"scope": "individual",
		"iso6393": "psu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Port Sandwich",
		"type": "living",
		"scope": "individual",
		"iso6393": "psw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Piscataway",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "psy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pai Tavytera",
		"type": "living",
		"scope": "individual",
		"iso6393": "pta",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pataxó Hã-Ha-Hãe",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "pth",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pintiini",
		"type": "living",
		"scope": "individual",
		"iso6393": "pti",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Patani",
		"type": "living",
		"scope": "individual",
		"iso6393": "ptn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zo'é",
		"type": "living",
		"scope": "individual",
		"iso6393": "pto",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Patep",
		"type": "living",
		"scope": "individual",
		"iso6393": "ptp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pattapu",
		"type": "living",
		"scope": "individual",
		"iso6393": "ptq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Piamatsina",
		"type": "living",
		"scope": "individual",
		"iso6393": "ptr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Enrekang",
		"type": "living",
		"scope": "individual",
		"iso6393": "ptt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bambam",
		"type": "living",
		"scope": "individual",
		"iso6393": "ptu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Port Vato",
		"type": "living",
		"scope": "individual",
		"iso6393": "ptv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pentlatch",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ptw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pathiya",
		"type": "living",
		"scope": "individual",
		"iso6393": "pty",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Highland Purepecha",
		"type": "living",
		"scope": "individual",
		"iso6393": "pua",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Purum",
		"type": "living",
		"scope": "individual",
		"iso6393": "pub",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Punan Merap",
		"type": "living",
		"scope": "individual",
		"iso6393": "puc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Punan Aput",
		"type": "living",
		"scope": "individual",
		"iso6393": "pud",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Puelche",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "pue",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Punan Merah",
		"type": "living",
		"scope": "individual",
		"iso6393": "puf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Phuie",
		"type": "living",
		"scope": "individual",
		"iso6393": "pug",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Puinave",
		"type": "living",
		"scope": "individual",
		"iso6393": "pui",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Punan Tubu",
		"type": "living",
		"scope": "individual",
		"iso6393": "puj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pu Ko",
		"type": "living",
		"scope": "individual",
		"iso6393": "puk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Puma",
		"type": "living",
		"scope": "individual",
		"iso6393": "pum",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Puoc",
		"type": "living",
		"scope": "individual",
		"iso6393": "puo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pulabu",
		"type": "living",
		"scope": "individual",
		"iso6393": "pup",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Puquina",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "puq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Puruborá",
		"type": "living",
		"scope": "individual",
		"iso6393": "pur",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pushto",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "pus",
		"iso6392B": "pus",
		"iso6392T": "pus",
		"iso6391": "ps"
	},
	{
		"name": "Putoh",
		"type": "living",
		"scope": "individual",
		"iso6393": "put",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Punu",
		"type": "living",
		"scope": "individual",
		"iso6393": "puu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Puluwatese",
		"type": "living",
		"scope": "individual",
		"iso6393": "puw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Puare",
		"type": "living",
		"scope": "individual",
		"iso6393": "pux",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Purisimeño",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "puy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pawaia",
		"type": "living",
		"scope": "individual",
		"iso6393": "pwa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Panawa",
		"type": "living",
		"scope": "individual",
		"iso6393": "pwb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gapapaiwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "pwg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Patwin",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "pwi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Molbog",
		"type": "living",
		"scope": "individual",
		"iso6393": "pwm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Paiwan",
		"type": "living",
		"scope": "individual",
		"iso6393": "pwn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pwo Western Karen",
		"type": "living",
		"scope": "individual",
		"iso6393": "pwo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Powari",
		"type": "living",
		"scope": "individual",
		"iso6393": "pwr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pwo Northern Karen",
		"type": "living",
		"scope": "individual",
		"iso6393": "pww",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Quetzaltepec Mixe",
		"type": "living",
		"scope": "individual",
		"iso6393": "pxm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pye Krumen",
		"type": "living",
		"scope": "individual",
		"iso6393": "pye",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Fyam",
		"type": "living",
		"scope": "individual",
		"iso6393": "pym",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Poyanáwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "pyn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Paraguayan Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "pys",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Puyuma",
		"type": "living",
		"scope": "individual",
		"iso6393": "pyu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pyu (Myanmar)",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "pyx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pyen",
		"type": "living",
		"scope": "individual",
		"iso6393": "pyy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Para Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "pzn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Quapaw",
		"type": "living",
		"scope": "individual",
		"iso6393": "qua",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Huallaga Huánuco Quechua",
		"type": "living",
		"scope": "individual",
		"iso6393": "qub",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "K'iche'",
		"type": "living",
		"scope": "individual",
		"iso6393": "quc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Calderón Highland Quichua",
		"type": "living",
		"scope": "individual",
		"iso6393": "qud",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Quechua",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "que",
		"iso6392B": "que",
		"iso6392T": "que",
		"iso6391": "qu"
	},
	{
		"name": "Lambayeque Quechua",
		"type": "living",
		"scope": "individual",
		"iso6393": "quf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chimborazo Highland Quichua",
		"type": "living",
		"scope": "individual",
		"iso6393": "qug",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "South Bolivian Quechua",
		"type": "living",
		"scope": "individual",
		"iso6393": "quh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Quileute",
		"type": "living",
		"scope": "individual",
		"iso6393": "qui",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chachapoyas Quechua",
		"type": "living",
		"scope": "individual",
		"iso6393": "quk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "North Bolivian Quechua",
		"type": "living",
		"scope": "individual",
		"iso6393": "qul",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sipacapense",
		"type": "living",
		"scope": "individual",
		"iso6393": "qum",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Quinault",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "qun",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Pastaza Quechua",
		"type": "living",
		"scope": "individual",
		"iso6393": "qup",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Quinqui",
		"type": "living",
		"scope": "individual",
		"iso6393": "quq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yanahuanca Pasco Quechua",
		"type": "living",
		"scope": "individual",
		"iso6393": "qur",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Santiago del Estero Quichua",
		"type": "living",
		"scope": "individual",
		"iso6393": "qus",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sacapulteco",
		"type": "living",
		"scope": "individual",
		"iso6393": "quv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tena Lowland Quichua",
		"type": "living",
		"scope": "individual",
		"iso6393": "quw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yauyos Quechua",
		"type": "living",
		"scope": "individual",
		"iso6393": "qux",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ayacucho Quechua",
		"type": "living",
		"scope": "individual",
		"iso6393": "quy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cusco Quechua",
		"type": "living",
		"scope": "individual",
		"iso6393": "quz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ambo-Pasco Quechua",
		"type": "living",
		"scope": "individual",
		"iso6393": "qva",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cajamarca Quechua",
		"type": "living",
		"scope": "individual",
		"iso6393": "qvc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Apurímac Quechua",
		"type": "living",
		"scope": "individual",
		"iso6393": "qve",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Huamalíes-Dos de Mayo Huánuco Quechua",
		"type": "living",
		"scope": "individual",
		"iso6393": "qvh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Imbabura Highland Quichua",
		"type": "living",
		"scope": "individual",
		"iso6393": "qvi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Loja Highland Quichua",
		"type": "living",
		"scope": "individual",
		"iso6393": "qvj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cajatambo North Lima Quechua",
		"type": "living",
		"scope": "individual",
		"iso6393": "qvl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Margos-Yarowilca-Lauricocha Quechua",
		"type": "living",
		"scope": "individual",
		"iso6393": "qvm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "North Junín Quechua",
		"type": "living",
		"scope": "individual",
		"iso6393": "qvn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Napo Lowland Quechua",
		"type": "living",
		"scope": "individual",
		"iso6393": "qvo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pacaraos Quechua",
		"type": "living",
		"scope": "individual",
		"iso6393": "qvp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "San Martín Quechua",
		"type": "living",
		"scope": "individual",
		"iso6393": "qvs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Huaylla Wanca Quechua",
		"type": "living",
		"scope": "individual",
		"iso6393": "qvw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Queyu",
		"type": "living",
		"scope": "individual",
		"iso6393": "qvy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Pastaza Quichua",
		"type": "living",
		"scope": "individual",
		"iso6393": "qvz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Corongo Ancash Quechua",
		"type": "living",
		"scope": "individual",
		"iso6393": "qwa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Classical Quechua",
		"type": "historical",
		"scope": "individual",
		"iso6393": "qwc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Huaylas Ancash Quechua",
		"type": "living",
		"scope": "individual",
		"iso6393": "qwh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kuman (Russia)",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "qwm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sihuas Ancash Quechua",
		"type": "living",
		"scope": "individual",
		"iso6393": "qws",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kwalhioqua-Tlatskanai",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "qwt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chiquián Ancash Quechua",
		"type": "living",
		"scope": "individual",
		"iso6393": "qxa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chincha Quechua",
		"type": "living",
		"scope": "individual",
		"iso6393": "qxc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Panao Huánuco Quechua",
		"type": "living",
		"scope": "individual",
		"iso6393": "qxh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Salasaca Highland Quichua",
		"type": "living",
		"scope": "individual",
		"iso6393": "qxl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Conchucos Ancash Quechua",
		"type": "living",
		"scope": "individual",
		"iso6393": "qxn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Conchucos Ancash Quechua",
		"type": "living",
		"scope": "individual",
		"iso6393": "qxo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Puno Quechua",
		"type": "living",
		"scope": "individual",
		"iso6393": "qxp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Qashqa'i",
		"type": "living",
		"scope": "individual",
		"iso6393": "qxq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cañar Highland Quichua",
		"type": "living",
		"scope": "individual",
		"iso6393": "qxr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Qiang",
		"type": "living",
		"scope": "individual",
		"iso6393": "qxs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Santa Ana de Tusi Pasco Quechua",
		"type": "living",
		"scope": "individual",
		"iso6393": "qxt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Arequipa-La Unión Quechua",
		"type": "living",
		"scope": "individual",
		"iso6393": "qxu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jauja Wanca Quechua",
		"type": "living",
		"scope": "individual",
		"iso6393": "qxw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Quenya",
		"type": "constructed",
		"scope": "individual",
		"iso6393": "qya",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Quiripi",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "qyp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dungmali",
		"type": "living",
		"scope": "individual",
		"iso6393": "raa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Camling",
		"type": "living",
		"scope": "individual",
		"iso6393": "rab",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rasawa",
		"type": "living",
		"scope": "individual",
		"iso6393": "rac",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rade",
		"type": "living",
		"scope": "individual",
		"iso6393": "rad",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Meohang",
		"type": "living",
		"scope": "individual",
		"iso6393": "raf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Logooli",
		"type": "living",
		"scope": "individual",
		"iso6393": "rag",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rabha",
		"type": "living",
		"scope": "individual",
		"iso6393": "rah",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ramoaaina",
		"type": "living",
		"scope": "individual",
		"iso6393": "rai",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rajasthani",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "raj",
		"iso6392B": "raj",
		"iso6392T": "raj",
		"iso6391": null
	},
	{
		"name": "Tulu-Bohuai",
		"type": "living",
		"scope": "individual",
		"iso6393": "rak",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ralte",
		"type": "living",
		"scope": "individual",
		"iso6393": "ral",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Canela",
		"type": "living",
		"scope": "individual",
		"iso6393": "ram",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Riantana",
		"type": "living",
		"scope": "individual",
		"iso6393": "ran",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rao",
		"type": "living",
		"scope": "individual",
		"iso6393": "rao",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rapanui",
		"type": "living",
		"scope": "individual",
		"iso6393": "rap",
		"iso6392B": "rap",
		"iso6392T": "rap",
		"iso6391": null
	},
	{
		"name": "Saam",
		"type": "living",
		"scope": "individual",
		"iso6393": "raq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rarotongan",
		"type": "living",
		"scope": "individual",
		"iso6393": "rar",
		"iso6392B": "rar",
		"iso6392T": "rar",
		"iso6391": null
	},
	{
		"name": "Tegali",
		"type": "living",
		"scope": "individual",
		"iso6393": "ras",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Razajerdi",
		"type": "living",
		"scope": "individual",
		"iso6393": "rat",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Raute",
		"type": "living",
		"scope": "individual",
		"iso6393": "rau",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sampang",
		"type": "living",
		"scope": "individual",
		"iso6393": "rav",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rawang",
		"type": "living",
		"scope": "individual",
		"iso6393": "raw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rang",
		"type": "living",
		"scope": "individual",
		"iso6393": "rax",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rapa",
		"type": "living",
		"scope": "individual",
		"iso6393": "ray",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rahambuu",
		"type": "living",
		"scope": "individual",
		"iso6393": "raz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rumai Palaung",
		"type": "living",
		"scope": "individual",
		"iso6393": "rbb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Bontok",
		"type": "living",
		"scope": "individual",
		"iso6393": "rbk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Miraya Bikol",
		"type": "living",
		"scope": "individual",
		"iso6393": "rbl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Barababaraba",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "rbp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Réunion Creole French",
		"type": "living",
		"scope": "individual",
		"iso6393": "rcf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rudbari",
		"type": "living",
		"scope": "individual",
		"iso6393": "rdb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rerau",
		"type": "living",
		"scope": "individual",
		"iso6393": "rea",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rembong",
		"type": "living",
		"scope": "individual",
		"iso6393": "reb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rejang Kayan",
		"type": "living",
		"scope": "individual",
		"iso6393": "ree",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kara (Tanzania)",
		"type": "living",
		"scope": "individual",
		"iso6393": "reg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Reli",
		"type": "living",
		"scope": "individual",
		"iso6393": "rei",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rejang",
		"type": "living",
		"scope": "individual",
		"iso6393": "rej",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rendille",
		"type": "living",
		"scope": "individual",
		"iso6393": "rel",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Remo",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "rem",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rengao",
		"type": "living",
		"scope": "individual",
		"iso6393": "ren",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rer Bare",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "rer",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Reshe",
		"type": "living",
		"scope": "individual",
		"iso6393": "res",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Retta",
		"type": "living",
		"scope": "individual",
		"iso6393": "ret",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Reyesano",
		"type": "living",
		"scope": "individual",
		"iso6393": "rey",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Roria",
		"type": "living",
		"scope": "individual",
		"iso6393": "rga",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Romano-Greek",
		"type": "living",
		"scope": "individual",
		"iso6393": "rge",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rangkas",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "rgk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Romagnol",
		"type": "living",
		"scope": "individual",
		"iso6393": "rgn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Resígaro",
		"type": "living",
		"scope": "individual",
		"iso6393": "rgr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Roglai",
		"type": "living",
		"scope": "individual",
		"iso6393": "rgs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ringgou",
		"type": "living",
		"scope": "individual",
		"iso6393": "rgu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rohingya",
		"type": "living",
		"scope": "individual",
		"iso6393": "rhg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yahang",
		"type": "living",
		"scope": "individual",
		"iso6393": "rhp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Riang (India)",
		"type": "living",
		"scope": "individual",
		"iso6393": "ria",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rien",
		"type": "living",
		"scope": "individual",
		"iso6393": "rie",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tarifit",
		"type": "living",
		"scope": "individual",
		"iso6393": "rif",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Riang (Myanmar)",
		"type": "living",
		"scope": "individual",
		"iso6393": "ril",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyaturu",
		"type": "living",
		"scope": "individual",
		"iso6393": "rim",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nungu",
		"type": "living",
		"scope": "individual",
		"iso6393": "rin",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ribun",
		"type": "living",
		"scope": "individual",
		"iso6393": "rir",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ritarungo",
		"type": "living",
		"scope": "individual",
		"iso6393": "rit",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Riung",
		"type": "living",
		"scope": "individual",
		"iso6393": "riu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rajong",
		"type": "living",
		"scope": "individual",
		"iso6393": "rjg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Raji",
		"type": "living",
		"scope": "individual",
		"iso6393": "rji",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rajbanshi",
		"type": "living",
		"scope": "individual",
		"iso6393": "rjs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kraol",
		"type": "living",
		"scope": "individual",
		"iso6393": "rka",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rikbaktsa",
		"type": "living",
		"scope": "individual",
		"iso6393": "rkb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rakahanga-Manihiki",
		"type": "living",
		"scope": "individual",
		"iso6393": "rkh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rakhine",
		"type": "living",
		"scope": "individual",
		"iso6393": "rki",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Marka",
		"type": "living",
		"scope": "individual",
		"iso6393": "rkm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rangpuri",
		"type": "living",
		"scope": "individual",
		"iso6393": "rkt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Arakwal",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "rkw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rama",
		"type": "living",
		"scope": "individual",
		"iso6393": "rma",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rembarunga",
		"type": "living",
		"scope": "individual",
		"iso6393": "rmb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Carpathian Romani",
		"type": "living",
		"scope": "individual",
		"iso6393": "rmc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Traveller Danish",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "rmd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Angloromani",
		"type": "living",
		"scope": "individual",
		"iso6393": "rme",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kalo Finnish Romani",
		"type": "living",
		"scope": "individual",
		"iso6393": "rmf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Traveller Norwegian",
		"type": "living",
		"scope": "individual",
		"iso6393": "rmg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Murkim",
		"type": "living",
		"scope": "individual",
		"iso6393": "rmh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lomavren",
		"type": "living",
		"scope": "individual",
		"iso6393": "rmi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Romkun",
		"type": "living",
		"scope": "individual",
		"iso6393": "rmk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baltic Romani",
		"type": "living",
		"scope": "individual",
		"iso6393": "rml",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Roma",
		"type": "living",
		"scope": "individual",
		"iso6393": "rmm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Balkan Romani",
		"type": "living",
		"scope": "individual",
		"iso6393": "rmn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sinte Romani",
		"type": "living",
		"scope": "individual",
		"iso6393": "rmo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rempi",
		"type": "living",
		"scope": "individual",
		"iso6393": "rmp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Caló",
		"type": "living",
		"scope": "individual",
		"iso6393": "rmq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Romanian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "rms",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Domari",
		"type": "living",
		"scope": "individual",
		"iso6393": "rmt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tavringer Romani",
		"type": "living",
		"scope": "individual",
		"iso6393": "rmu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Romanova",
		"type": "constructed",
		"scope": "individual",
		"iso6393": "rmv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Welsh Romani",
		"type": "living",
		"scope": "individual",
		"iso6393": "rmw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Romam",
		"type": "living",
		"scope": "individual",
		"iso6393": "rmx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Vlax Romani",
		"type": "living",
		"scope": "individual",
		"iso6393": "rmy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Marma",
		"type": "living",
		"scope": "individual",
		"iso6393": "rmz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ruund",
		"type": "living",
		"scope": "individual",
		"iso6393": "rnd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ronga",
		"type": "living",
		"scope": "individual",
		"iso6393": "rng",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ranglong",
		"type": "living",
		"scope": "individual",
		"iso6393": "rnl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Roon",
		"type": "living",
		"scope": "individual",
		"iso6393": "rnn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rongpo",
		"type": "living",
		"scope": "individual",
		"iso6393": "rnp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nari Nari",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "rnr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rungwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "rnw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tae'",
		"type": "living",
		"scope": "individual",
		"iso6393": "rob",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cacgia Roglai",
		"type": "living",
		"scope": "individual",
		"iso6393": "roc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rogo",
		"type": "living",
		"scope": "individual",
		"iso6393": "rod",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ronji",
		"type": "living",
		"scope": "individual",
		"iso6393": "roe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rombo",
		"type": "living",
		"scope": "individual",
		"iso6393": "rof",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Roglai",
		"type": "living",
		"scope": "individual",
		"iso6393": "rog",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Romansh",
		"type": "living",
		"scope": "individual",
		"iso6393": "roh",
		"iso6392B": "roh",
		"iso6392T": "roh",
		"iso6391": "rm"
	},
	{
		"name": "Romblomanon",
		"type": "living",
		"scope": "individual",
		"iso6393": "rol",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Romany",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "rom",
		"iso6392B": "rom",
		"iso6392T": "rom",
		"iso6391": null
	},
	{
		"name": "Romanian",
		"type": "living",
		"scope": "individual",
		"iso6393": "ron",
		"iso6392B": "rum",
		"iso6392T": "ron",
		"iso6391": "ro"
	},
	{
		"name": "Rotokas",
		"type": "living",
		"scope": "individual",
		"iso6393": "roo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kriol",
		"type": "living",
		"scope": "individual",
		"iso6393": "rop",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rongga",
		"type": "living",
		"scope": "individual",
		"iso6393": "ror",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Runga",
		"type": "living",
		"scope": "individual",
		"iso6393": "rou",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dela-Oenale",
		"type": "living",
		"scope": "individual",
		"iso6393": "row",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Repanbitip",
		"type": "living",
		"scope": "individual",
		"iso6393": "rpn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rapting",
		"type": "living",
		"scope": "individual",
		"iso6393": "rpt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ririo",
		"type": "living",
		"scope": "individual",
		"iso6393": "rri",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Waima",
		"type": "living",
		"scope": "individual",
		"iso6393": "rro",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Arritinngithigh",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "rrt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Romano-Serbian",
		"type": "living",
		"scope": "individual",
		"iso6393": "rsb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rennellese Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "rsi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Russian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "rsl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Miriwoong Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "rsm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rungtu Chin",
		"type": "living",
		"scope": "individual",
		"iso6393": "rtc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ratahan",
		"type": "living",
		"scope": "individual",
		"iso6393": "rth",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rotuman",
		"type": "living",
		"scope": "individual",
		"iso6393": "rtm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yurats",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "rts",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rathawi",
		"type": "living",
		"scope": "individual",
		"iso6393": "rtw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gungu",
		"type": "living",
		"scope": "individual",
		"iso6393": "rub",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ruuli",
		"type": "living",
		"scope": "individual",
		"iso6393": "ruc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rusyn",
		"type": "living",
		"scope": "individual",
		"iso6393": "rue",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Luguru",
		"type": "living",
		"scope": "individual",
		"iso6393": "ruf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Roviana",
		"type": "living",
		"scope": "individual",
		"iso6393": "rug",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ruga",
		"type": "living",
		"scope": "individual",
		"iso6393": "ruh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rufiji",
		"type": "living",
		"scope": "individual",
		"iso6393": "rui",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Che",
		"type": "living",
		"scope": "individual",
		"iso6393": "ruk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rundi",
		"type": "living",
		"scope": "individual",
		"iso6393": "run",
		"iso6392B": "run",
		"iso6392T": "run",
		"iso6391": "rn"
	},
	{
		"name": "Istro Romanian",
		"type": "living",
		"scope": "individual",
		"iso6393": "ruo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Macedo-Romanian",
		"type": "living",
		"scope": "individual",
		"iso6393": "rup",
		"iso6392B": "rup",
		"iso6392T": "rup",
		"iso6391": null
	},
	{
		"name": "Megleno Romanian",
		"type": "living",
		"scope": "individual",
		"iso6393": "ruq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Russian",
		"type": "living",
		"scope": "individual",
		"iso6393": "rus",
		"iso6392B": "rus",
		"iso6392T": "rus",
		"iso6391": "ru"
	},
	{
		"name": "Rutul",
		"type": "living",
		"scope": "individual",
		"iso6393": "rut",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lanas Lobu",
		"type": "living",
		"scope": "individual",
		"iso6393": "ruu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mala (Nigeria)",
		"type": "living",
		"scope": "individual",
		"iso6393": "ruy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ruma",
		"type": "living",
		"scope": "individual",
		"iso6393": "ruz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rawo",
		"type": "living",
		"scope": "individual",
		"iso6393": "rwa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "rwk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Amba (Uganda)",
		"type": "living",
		"scope": "individual",
		"iso6393": "rwm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rawa",
		"type": "living",
		"scope": "individual",
		"iso6393": "rwo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Marwari (India)",
		"type": "living",
		"scope": "individual",
		"iso6393": "rwr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngardi",
		"type": "living",
		"scope": "individual",
		"iso6393": "rxd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Karuwali",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "rxw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Amami-Oshima",
		"type": "living",
		"scope": "individual",
		"iso6393": "ryn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yaeyama",
		"type": "living",
		"scope": "individual",
		"iso6393": "rys",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Central Okinawan",
		"type": "living",
		"scope": "individual",
		"iso6393": "ryu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rāziḥī",
		"type": "living",
		"scope": "individual",
		"iso6393": "rzh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Saba",
		"type": "living",
		"scope": "individual",
		"iso6393": "saa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Buglere",
		"type": "living",
		"scope": "individual",
		"iso6393": "sab",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Meskwaki",
		"type": "living",
		"scope": "individual",
		"iso6393": "sac",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sandawe",
		"type": "living",
		"scope": "individual",
		"iso6393": "sad",
		"iso6392B": "sad",
		"iso6392T": "sad",
		"iso6391": null
	},
	{
		"name": "Sabanê",
		"type": "living",
		"scope": "individual",
		"iso6393": "sae",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Safaliba",
		"type": "living",
		"scope": "individual",
		"iso6393": "saf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sango",
		"type": "living",
		"scope": "individual",
		"iso6393": "sag",
		"iso6392B": "sag",
		"iso6392T": "sag",
		"iso6391": "sg"
	},
	{
		"name": "Yakut",
		"type": "living",
		"scope": "individual",
		"iso6393": "sah",
		"iso6392B": "sah",
		"iso6392T": "sah",
		"iso6391": null
	},
	{
		"name": "Sahu",
		"type": "living",
		"scope": "individual",
		"iso6393": "saj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sake",
		"type": "living",
		"scope": "individual",
		"iso6393": "sak",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Samaritan Aramaic",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "sam",
		"iso6392B": "sam",
		"iso6392T": "sam",
		"iso6391": null
	},
	{
		"name": "Sanskrit",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "san",
		"iso6392B": "san",
		"iso6392T": "san",
		"iso6391": "sa"
	},
	{
		"name": "Sause",
		"type": "living",
		"scope": "individual",
		"iso6393": "sao",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Samburu",
		"type": "living",
		"scope": "individual",
		"iso6393": "saq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Saraveca",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "sar",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sasak",
		"type": "living",
		"scope": "individual",
		"iso6393": "sas",
		"iso6392B": "sas",
		"iso6392T": "sas",
		"iso6391": null
	},
	{
		"name": "Santali",
		"type": "living",
		"scope": "individual",
		"iso6393": "sat",
		"iso6392B": "sat",
		"iso6392T": "sat",
		"iso6391": null
	},
	{
		"name": "Saleman",
		"type": "living",
		"scope": "individual",
		"iso6393": "sau",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Saafi-Saafi",
		"type": "living",
		"scope": "individual",
		"iso6393": "sav",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sawi",
		"type": "living",
		"scope": "individual",
		"iso6393": "saw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sa",
		"type": "living",
		"scope": "individual",
		"iso6393": "sax",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Saya",
		"type": "living",
		"scope": "individual",
		"iso6393": "say",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Saurashtra",
		"type": "living",
		"scope": "individual",
		"iso6393": "saz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngambay",
		"type": "living",
		"scope": "individual",
		"iso6393": "sba",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Simbo",
		"type": "living",
		"scope": "individual",
		"iso6393": "sbb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kele (Papua New Guinea)",
		"type": "living",
		"scope": "individual",
		"iso6393": "sbc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Samo",
		"type": "living",
		"scope": "individual",
		"iso6393": "sbd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Saliba",
		"type": "living",
		"scope": "individual",
		"iso6393": "sbe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chabu",
		"type": "living",
		"scope": "individual",
		"iso6393": "sbf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Seget",
		"type": "living",
		"scope": "individual",
		"iso6393": "sbg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sori-Harengan",
		"type": "living",
		"scope": "individual",
		"iso6393": "sbh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Seti",
		"type": "living",
		"scope": "individual",
		"iso6393": "sbi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Surbakhal",
		"type": "living",
		"scope": "individual",
		"iso6393": "sbj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Safwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "sbk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Botolan Sambal",
		"type": "living",
		"scope": "individual",
		"iso6393": "sbl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sagala",
		"type": "living",
		"scope": "individual",
		"iso6393": "sbm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sindhi Bhil",
		"type": "living",
		"scope": "individual",
		"iso6393": "sbn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sabüm",
		"type": "living",
		"scope": "individual",
		"iso6393": "sbo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sangu (Tanzania)",
		"type": "living",
		"scope": "individual",
		"iso6393": "sbp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sileibi",
		"type": "living",
		"scope": "individual",
		"iso6393": "sbq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sembakung Murut",
		"type": "living",
		"scope": "individual",
		"iso6393": "sbr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Subiya",
		"type": "living",
		"scope": "individual",
		"iso6393": "sbs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kimki",
		"type": "living",
		"scope": "individual",
		"iso6393": "sbt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Stod Bhoti",
		"type": "living",
		"scope": "individual",
		"iso6393": "sbu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sabine",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "sbv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Simba",
		"type": "living",
		"scope": "individual",
		"iso6393": "sbw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Seberuang",
		"type": "living",
		"scope": "individual",
		"iso6393": "sbx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Soli",
		"type": "living",
		"scope": "individual",
		"iso6393": "sby",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sara Kaba",
		"type": "living",
		"scope": "individual",
		"iso6393": "sbz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chut",
		"type": "living",
		"scope": "individual",
		"iso6393": "scb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dongxiang",
		"type": "living",
		"scope": "individual",
		"iso6393": "sce",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "San Miguel Creole French",
		"type": "living",
		"scope": "individual",
		"iso6393": "scf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sanggau",
		"type": "living",
		"scope": "individual",
		"iso6393": "scg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sakachep",
		"type": "living",
		"scope": "individual",
		"iso6393": "sch",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sri Lankan Creole Malay",
		"type": "living",
		"scope": "individual",
		"iso6393": "sci",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sadri",
		"type": "living",
		"scope": "individual",
		"iso6393": "sck",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shina",
		"type": "living",
		"scope": "individual",
		"iso6393": "scl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sicilian",
		"type": "living",
		"scope": "individual",
		"iso6393": "scn",
		"iso6392B": "scn",
		"iso6392T": "scn",
		"iso6391": null
	},
	{
		"name": "Scots",
		"type": "living",
		"scope": "individual",
		"iso6393": "sco",
		"iso6392B": "sco",
		"iso6392T": "sco",
		"iso6391": null
	},
	{
		"name": "Helambu Sherpa",
		"type": "living",
		"scope": "individual",
		"iso6393": "scp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sa'och",
		"type": "living",
		"scope": "individual",
		"iso6393": "scq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "North Slavey",
		"type": "living",
		"scope": "individual",
		"iso6393": "scs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shumcho",
		"type": "living",
		"scope": "individual",
		"iso6393": "scu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sheni",
		"type": "living",
		"scope": "individual",
		"iso6393": "scv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sha",
		"type": "living",
		"scope": "individual",
		"iso6393": "scw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sicel",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "scx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Toraja-Sa'dan",
		"type": "living",
		"scope": "individual",
		"iso6393": "sda",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shabak",
		"type": "living",
		"scope": "individual",
		"iso6393": "sdb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sassarese Sardinian",
		"type": "living",
		"scope": "individual",
		"iso6393": "sdc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Surubu",
		"type": "living",
		"scope": "individual",
		"iso6393": "sde",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sarli",
		"type": "living",
		"scope": "individual",
		"iso6393": "sdf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Savi",
		"type": "living",
		"scope": "individual",
		"iso6393": "sdg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Kurdish",
		"type": "living",
		"scope": "individual",
		"iso6393": "sdh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Suundi",
		"type": "living",
		"scope": "individual",
		"iso6393": "sdj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sos Kundi",
		"type": "living",
		"scope": "individual",
		"iso6393": "sdk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Saudi Arabian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "sdl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Semandang",
		"type": "living",
		"scope": "individual",
		"iso6393": "sdm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gallurese Sardinian",
		"type": "living",
		"scope": "individual",
		"iso6393": "sdn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bukar-Sadung Bidayuh",
		"type": "living",
		"scope": "individual",
		"iso6393": "sdo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sherdukpen",
		"type": "living",
		"scope": "individual",
		"iso6393": "sdp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Oraon Sadri",
		"type": "living",
		"scope": "individual",
		"iso6393": "sdr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sened",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "sds",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shuadit",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "sdt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sarudu",
		"type": "living",
		"scope": "individual",
		"iso6393": "sdu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sibu Melanau",
		"type": "living",
		"scope": "individual",
		"iso6393": "sdx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sallands",
		"type": "living",
		"scope": "individual",
		"iso6393": "sdz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Semai",
		"type": "living",
		"scope": "individual",
		"iso6393": "sea",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shempire Senoufo",
		"type": "living",
		"scope": "individual",
		"iso6393": "seb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sechelt",
		"type": "living",
		"scope": "individual",
		"iso6393": "sec",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sedang",
		"type": "living",
		"scope": "individual",
		"iso6393": "sed",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Seneca",
		"type": "living",
		"scope": "individual",
		"iso6393": "see",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cebaara Senoufo",
		"type": "living",
		"scope": "individual",
		"iso6393": "sef",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Segeju",
		"type": "living",
		"scope": "individual",
		"iso6393": "seg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sena",
		"type": "living",
		"scope": "individual",
		"iso6393": "seh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Seri",
		"type": "living",
		"scope": "individual",
		"iso6393": "sei",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sene",
		"type": "living",
		"scope": "individual",
		"iso6393": "sej",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sekani",
		"type": "living",
		"scope": "individual",
		"iso6393": "sek",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Selkup",
		"type": "living",
		"scope": "individual",
		"iso6393": "sel",
		"iso6392B": "sel",
		"iso6392T": "sel",
		"iso6391": null
	},
	{
		"name": "Nanerigé Sénoufo",
		"type": "living",
		"scope": "individual",
		"iso6393": "sen",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Suarmin",
		"type": "living",
		"scope": "individual",
		"iso6393": "seo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sìcìté Sénoufo",
		"type": "living",
		"scope": "individual",
		"iso6393": "sep",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Senara Sénoufo",
		"type": "living",
		"scope": "individual",
		"iso6393": "seq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Serrano",
		"type": "living",
		"scope": "individual",
		"iso6393": "ser",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koyraboro Senni Songhai",
		"type": "living",
		"scope": "individual",
		"iso6393": "ses",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sentani",
		"type": "living",
		"scope": "individual",
		"iso6393": "set",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Serui-Laut",
		"type": "living",
		"scope": "individual",
		"iso6393": "seu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyarafolo Senoufo",
		"type": "living",
		"scope": "individual",
		"iso6393": "sev",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sewa Bay",
		"type": "living",
		"scope": "individual",
		"iso6393": "sew",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Secoya",
		"type": "living",
		"scope": "individual",
		"iso6393": "sey",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Senthang Chin",
		"type": "living",
		"scope": "individual",
		"iso6393": "sez",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Langue des signes de Belgique Francophone",
		"type": "living",
		"scope": "individual",
		"iso6393": "sfb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Subanen",
		"type": "living",
		"scope": "individual",
		"iso6393": "sfe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Small Flowery Miao",
		"type": "living",
		"scope": "individual",
		"iso6393": "sfm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "South African Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "sfs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sehwi",
		"type": "living",
		"scope": "individual",
		"iso6393": "sfw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Old Irish (to 900)",
		"type": "historical",
		"scope": "individual",
		"iso6393": "sga",
		"iso6392B": "sga",
		"iso6392T": "sga",
		"iso6391": null
	},
	{
		"name": "Mag-antsi Ayta",
		"type": "living",
		"scope": "individual",
		"iso6393": "sgb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kipsigis",
		"type": "living",
		"scope": "individual",
		"iso6393": "sgc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Surigaonon",
		"type": "living",
		"scope": "individual",
		"iso6393": "sgd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Segai",
		"type": "living",
		"scope": "individual",
		"iso6393": "sge",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Swiss-German Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "sgg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shughni",
		"type": "living",
		"scope": "individual",
		"iso6393": "sgh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Suga",
		"type": "living",
		"scope": "individual",
		"iso6393": "sgi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Surgujia",
		"type": "living",
		"scope": "individual",
		"iso6393": "sgj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sangkong",
		"type": "living",
		"scope": "individual",
		"iso6393": "sgk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Singa",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "sgm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Singpho",
		"type": "living",
		"scope": "individual",
		"iso6393": "sgp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sangisari",
		"type": "living",
		"scope": "individual",
		"iso6393": "sgr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Samogitian",
		"type": "living",
		"scope": "individual",
		"iso6393": "sgs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Brokpake",
		"type": "living",
		"scope": "individual",
		"iso6393": "sgt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Salas",
		"type": "living",
		"scope": "individual",
		"iso6393": "sgu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sebat Bet Gurage",
		"type": "living",
		"scope": "individual",
		"iso6393": "sgw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sierra Leone Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "sgx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sanglechi",
		"type": "living",
		"scope": "individual",
		"iso6393": "sgy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sursurunga",
		"type": "living",
		"scope": "individual",
		"iso6393": "sgz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shall-Zwall",
		"type": "living",
		"scope": "individual",
		"iso6393": "sha",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ninam",
		"type": "living",
		"scope": "individual",
		"iso6393": "shb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sonde",
		"type": "living",
		"scope": "individual",
		"iso6393": "shc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kundal Shahi",
		"type": "living",
		"scope": "individual",
		"iso6393": "shd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sheko",
		"type": "living",
		"scope": "individual",
		"iso6393": "she",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shua",
		"type": "living",
		"scope": "individual",
		"iso6393": "shg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shoshoni",
		"type": "living",
		"scope": "individual",
		"iso6393": "shh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tachelhit",
		"type": "living",
		"scope": "individual",
		"iso6393": "shi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shatt",
		"type": "living",
		"scope": "individual",
		"iso6393": "shj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shilluk",
		"type": "living",
		"scope": "individual",
		"iso6393": "shk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shendu",
		"type": "living",
		"scope": "individual",
		"iso6393": "shl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shahrudi",
		"type": "living",
		"scope": "individual",
		"iso6393": "shm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shan",
		"type": "living",
		"scope": "individual",
		"iso6393": "shn",
		"iso6392B": "shn",
		"iso6392T": "shn",
		"iso6391": null
	},
	{
		"name": "Shanga",
		"type": "living",
		"scope": "individual",
		"iso6393": "sho",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shipibo-Conibo",
		"type": "living",
		"scope": "individual",
		"iso6393": "shp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sala",
		"type": "living",
		"scope": "individual",
		"iso6393": "shq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shi",
		"type": "living",
		"scope": "individual",
		"iso6393": "shr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shuswap",
		"type": "living",
		"scope": "individual",
		"iso6393": "shs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shasta",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "sht",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chadian Arabic",
		"type": "living",
		"scope": "individual",
		"iso6393": "shu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shehri",
		"type": "living",
		"scope": "individual",
		"iso6393": "shv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shwai",
		"type": "living",
		"scope": "individual",
		"iso6393": "shw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "She",
		"type": "living",
		"scope": "individual",
		"iso6393": "shx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tachawit",
		"type": "living",
		"scope": "individual",
		"iso6393": "shy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Syenara Senoufo",
		"type": "living",
		"scope": "individual",
		"iso6393": "shz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Akkala Sami",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "sia",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sebop",
		"type": "living",
		"scope": "individual",
		"iso6393": "sib",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sidamo",
		"type": "living",
		"scope": "individual",
		"iso6393": "sid",
		"iso6392B": "sid",
		"iso6392T": "sid",
		"iso6391": null
	},
	{
		"name": "Simaa",
		"type": "living",
		"scope": "individual",
		"iso6393": "sie",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Siamou",
		"type": "living",
		"scope": "individual",
		"iso6393": "sif",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Paasaal",
		"type": "living",
		"scope": "individual",
		"iso6393": "sig",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zire",
		"type": "living",
		"scope": "individual",
		"iso6393": "sih",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shom Peng",
		"type": "living",
		"scope": "individual",
		"iso6393": "sii",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Numbami",
		"type": "living",
		"scope": "individual",
		"iso6393": "sij",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sikiana",
		"type": "living",
		"scope": "individual",
		"iso6393": "sik",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tumulung Sisaala",
		"type": "living",
		"scope": "individual",
		"iso6393": "sil",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mende (Papua New Guinea)",
		"type": "living",
		"scope": "individual",
		"iso6393": "sim",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sinhala",
		"type": "living",
		"scope": "individual",
		"iso6393": "sin",
		"iso6392B": "sin",
		"iso6392T": "sin",
		"iso6391": "si"
	},
	{
		"name": "Sikkimese",
		"type": "living",
		"scope": "individual",
		"iso6393": "sip",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sonia",
		"type": "living",
		"scope": "individual",
		"iso6393": "siq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Siri",
		"type": "living",
		"scope": "individual",
		"iso6393": "sir",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Siuslaw",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "sis",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sinagen",
		"type": "living",
		"scope": "individual",
		"iso6393": "siu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sumariup",
		"type": "living",
		"scope": "individual",
		"iso6393": "siv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Siwai",
		"type": "living",
		"scope": "individual",
		"iso6393": "siw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sumau",
		"type": "living",
		"scope": "individual",
		"iso6393": "six",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sivandi",
		"type": "living",
		"scope": "individual",
		"iso6393": "siy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Siwi",
		"type": "living",
		"scope": "individual",
		"iso6393": "siz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Epena",
		"type": "living",
		"scope": "individual",
		"iso6393": "sja",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sajau Basap",
		"type": "living",
		"scope": "individual",
		"iso6393": "sjb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kildin Sami",
		"type": "living",
		"scope": "individual",
		"iso6393": "sjd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pite Sami",
		"type": "living",
		"scope": "individual",
		"iso6393": "sje",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Assangori",
		"type": "living",
		"scope": "individual",
		"iso6393": "sjg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kemi Sami",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "sjk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sajalong",
		"type": "living",
		"scope": "individual",
		"iso6393": "sjl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mapun",
		"type": "living",
		"scope": "individual",
		"iso6393": "sjm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sindarin",
		"type": "constructed",
		"scope": "individual",
		"iso6393": "sjn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Xibe",
		"type": "living",
		"scope": "individual",
		"iso6393": "sjo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Surjapuri",
		"type": "living",
		"scope": "individual",
		"iso6393": "sjp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Siar-Lak",
		"type": "living",
		"scope": "individual",
		"iso6393": "sjr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Senhaja De Srair",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "sjs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ter Sami",
		"type": "living",
		"scope": "individual",
		"iso6393": "sjt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ume Sami",
		"type": "living",
		"scope": "individual",
		"iso6393": "sju",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shawnee",
		"type": "living",
		"scope": "individual",
		"iso6393": "sjw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Skagit",
		"type": "living",
		"scope": "individual",
		"iso6393": "ska",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Saek",
		"type": "living",
		"scope": "individual",
		"iso6393": "skb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ma Manda",
		"type": "living",
		"scope": "individual",
		"iso6393": "skc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Sierra Miwok",
		"type": "living",
		"scope": "individual",
		"iso6393": "skd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Seke (Vanuatu)",
		"type": "living",
		"scope": "individual",
		"iso6393": "ske",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sakirabiá",
		"type": "living",
		"scope": "individual",
		"iso6393": "skf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sakalava Malagasy",
		"type": "living",
		"scope": "individual",
		"iso6393": "skg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sikule",
		"type": "living",
		"scope": "individual",
		"iso6393": "skh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sika",
		"type": "living",
		"scope": "individual",
		"iso6393": "ski",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Seke (Nepal)",
		"type": "living",
		"scope": "individual",
		"iso6393": "skj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sok",
		"type": "living",
		"scope": "individual",
		"iso6393": "skk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kutong",
		"type": "living",
		"scope": "individual",
		"iso6393": "skm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kolibugan Subanon",
		"type": "living",
		"scope": "individual",
		"iso6393": "skn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Seko Tengah",
		"type": "living",
		"scope": "individual",
		"iso6393": "sko",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sekapan",
		"type": "living",
		"scope": "individual",
		"iso6393": "skp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sininkere",
		"type": "living",
		"scope": "individual",
		"iso6393": "skq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Saraiki",
		"type": "living",
		"scope": "individual",
		"iso6393": "skr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maia",
		"type": "living",
		"scope": "individual",
		"iso6393": "sks",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sakata",
		"type": "living",
		"scope": "individual",
		"iso6393": "skt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sakao",
		"type": "living",
		"scope": "individual",
		"iso6393": "sku",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Skou",
		"type": "living",
		"scope": "individual",
		"iso6393": "skv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Skepi Creole Dutch",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "skw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Seko Padang",
		"type": "living",
		"scope": "individual",
		"iso6393": "skx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sikaiana",
		"type": "living",
		"scope": "individual",
		"iso6393": "sky",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sekar",
		"type": "living",
		"scope": "individual",
		"iso6393": "skz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sáliba",
		"type": "living",
		"scope": "individual",
		"iso6393": "slc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sissala",
		"type": "living",
		"scope": "individual",
		"iso6393": "sld",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sholaga",
		"type": "living",
		"scope": "individual",
		"iso6393": "sle",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Swiss-Italian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "slf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Selungai Murut",
		"type": "living",
		"scope": "individual",
		"iso6393": "slg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Puget Sound Salish",
		"type": "living",
		"scope": "individual",
		"iso6393": "slh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lower Silesian",
		"type": "living",
		"scope": "individual",
		"iso6393": "sli",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Salumá",
		"type": "living",
		"scope": "individual",
		"iso6393": "slj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Slovak",
		"type": "living",
		"scope": "individual",
		"iso6393": "slk",
		"iso6392B": "slo",
		"iso6392T": "slk",
		"iso6391": "sk"
	},
	{
		"name": "Salt-Yui",
		"type": "living",
		"scope": "individual",
		"iso6393": "sll",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pangutaran Sama",
		"type": "living",
		"scope": "individual",
		"iso6393": "slm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Salinan",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "sln",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lamaholot",
		"type": "living",
		"scope": "individual",
		"iso6393": "slp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Salchuq",
		"type": "living",
		"scope": "individual",
		"iso6393": "slq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Salar",
		"type": "living",
		"scope": "individual",
		"iso6393": "slr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Singapore Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "sls",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sila",
		"type": "living",
		"scope": "individual",
		"iso6393": "slt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Selaru",
		"type": "living",
		"scope": "individual",
		"iso6393": "slu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Slovenian",
		"type": "living",
		"scope": "individual",
		"iso6393": "slv",
		"iso6392B": "slv",
		"iso6392T": "slv",
		"iso6391": "sl"
	},
	{
		"name": "Sialum",
		"type": "living",
		"scope": "individual",
		"iso6393": "slw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Salampasu",
		"type": "living",
		"scope": "individual",
		"iso6393": "slx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Selayar",
		"type": "living",
		"scope": "individual",
		"iso6393": "sly",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ma'ya",
		"type": "living",
		"scope": "individual",
		"iso6393": "slz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Sami",
		"type": "living",
		"scope": "individual",
		"iso6393": "sma",
		"iso6392B": "sma",
		"iso6392T": "sma",
		"iso6391": null
	},
	{
		"name": "Simbari",
		"type": "living",
		"scope": "individual",
		"iso6393": "smb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Som",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "smc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sama",
		"type": "living",
		"scope": "individual",
		"iso6393": "smd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Sami",
		"type": "living",
		"scope": "individual",
		"iso6393": "sme",
		"iso6392B": "sme",
		"iso6392T": "sme",
		"iso6391": "se"
	},
	{
		"name": "Auwe",
		"type": "living",
		"scope": "individual",
		"iso6393": "smf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Simbali",
		"type": "living",
		"scope": "individual",
		"iso6393": "smg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Samei",
		"type": "living",
		"scope": "individual",
		"iso6393": "smh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lule Sami",
		"type": "living",
		"scope": "individual",
		"iso6393": "smj",
		"iso6392B": "smj",
		"iso6392T": "smj",
		"iso6391": null
	},
	{
		"name": "Bolinao",
		"type": "living",
		"scope": "individual",
		"iso6393": "smk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Central Sama",
		"type": "living",
		"scope": "individual",
		"iso6393": "sml",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Musasa",
		"type": "living",
		"scope": "individual",
		"iso6393": "smm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Inari Sami",
		"type": "living",
		"scope": "individual",
		"iso6393": "smn",
		"iso6392B": "smn",
		"iso6392T": "smn",
		"iso6391": null
	},
	{
		"name": "Samoan",
		"type": "living",
		"scope": "individual",
		"iso6393": "smo",
		"iso6392B": "smo",
		"iso6392T": "smo",
		"iso6391": "sm"
	},
	{
		"name": "Samaritan",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "smp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Samo",
		"type": "living",
		"scope": "individual",
		"iso6393": "smq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Simeulue",
		"type": "living",
		"scope": "individual",
		"iso6393": "smr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Skolt Sami",
		"type": "living",
		"scope": "individual",
		"iso6393": "sms",
		"iso6392B": "sms",
		"iso6392T": "sms",
		"iso6391": null
	},
	{
		"name": "Simte",
		"type": "living",
		"scope": "individual",
		"iso6393": "smt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Somray",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "smu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Samvedi",
		"type": "living",
		"scope": "individual",
		"iso6393": "smv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sumbawa",
		"type": "living",
		"scope": "individual",
		"iso6393": "smw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Samba",
		"type": "living",
		"scope": "individual",
		"iso6393": "smx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Semnani",
		"type": "living",
		"scope": "individual",
		"iso6393": "smy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Simeku",
		"type": "living",
		"scope": "individual",
		"iso6393": "smz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shona",
		"type": "living",
		"scope": "individual",
		"iso6393": "sna",
		"iso6392B": "sna",
		"iso6392T": "sna",
		"iso6391": "sn"
	},
	{
		"name": "Sebuyau",
		"type": "living",
		"scope": "individual",
		"iso6393": "snb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sinaugoro",
		"type": "living",
		"scope": "individual",
		"iso6393": "snc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sindhi",
		"type": "living",
		"scope": "individual",
		"iso6393": "snd",
		"iso6392B": "snd",
		"iso6392T": "snd",
		"iso6391": "sd"
	},
	{
		"name": "Bau Bidayuh",
		"type": "living",
		"scope": "individual",
		"iso6393": "sne",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Noon",
		"type": "living",
		"scope": "individual",
		"iso6393": "snf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sanga (Democratic Republic of Congo)",
		"type": "living",
		"scope": "individual",
		"iso6393": "sng",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shinabo",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "snh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sensi",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "sni",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Riverain Sango",
		"type": "living",
		"scope": "individual",
		"iso6393": "snj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Soninke",
		"type": "living",
		"scope": "individual",
		"iso6393": "snk",
		"iso6392B": "snk",
		"iso6392T": "snk",
		"iso6391": null
	},
	{
		"name": "Sangil",
		"type": "living",
		"scope": "individual",
		"iso6393": "snl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Ma'di",
		"type": "living",
		"scope": "individual",
		"iso6393": "snm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Siona",
		"type": "living",
		"scope": "individual",
		"iso6393": "snn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Snohomish",
		"type": "living",
		"scope": "individual",
		"iso6393": "sno",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Siane",
		"type": "living",
		"scope": "individual",
		"iso6393": "snp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sangu (Gabon)",
		"type": "living",
		"scope": "individual",
		"iso6393": "snq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sihan",
		"type": "living",
		"scope": "individual",
		"iso6393": "snr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "South West Bay",
		"type": "living",
		"scope": "individual",
		"iso6393": "sns",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Senggi",
		"type": "living",
		"scope": "individual",
		"iso6393": "snu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sa'ban",
		"type": "living",
		"scope": "individual",
		"iso6393": "snv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Selee",
		"type": "living",
		"scope": "individual",
		"iso6393": "snw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sam",
		"type": "living",
		"scope": "individual",
		"iso6393": "snx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Saniyo-Hiyewe",
		"type": "living",
		"scope": "individual",
		"iso6393": "sny",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sinsauru",
		"type": "living",
		"scope": "individual",
		"iso6393": "snz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Thai Song",
		"type": "living",
		"scope": "individual",
		"iso6393": "soa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sobei",
		"type": "living",
		"scope": "individual",
		"iso6393": "sob",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "So (Democratic Republic of Congo)",
		"type": "living",
		"scope": "individual",
		"iso6393": "soc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Songoora",
		"type": "living",
		"scope": "individual",
		"iso6393": "sod",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Songomeno",
		"type": "living",
		"scope": "individual",
		"iso6393": "soe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sogdian",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "sog",
		"iso6392B": "sog",
		"iso6392T": "sog",
		"iso6391": null
	},
	{
		"name": "Aka",
		"type": "living",
		"scope": "individual",
		"iso6393": "soh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sonha",
		"type": "living",
		"scope": "individual",
		"iso6393": "soi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Soi",
		"type": "living",
		"scope": "individual",
		"iso6393": "soj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sokoro",
		"type": "living",
		"scope": "individual",
		"iso6393": "sok",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Solos",
		"type": "living",
		"scope": "individual",
		"iso6393": "sol",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Somali",
		"type": "living",
		"scope": "individual",
		"iso6393": "som",
		"iso6392B": "som",
		"iso6392T": "som",
		"iso6391": "so"
	},
	{
		"name": "Songo",
		"type": "living",
		"scope": "individual",
		"iso6393": "soo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Songe",
		"type": "living",
		"scope": "individual",
		"iso6393": "sop",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kanasi",
		"type": "living",
		"scope": "individual",
		"iso6393": "soq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Somrai",
		"type": "living",
		"scope": "individual",
		"iso6393": "sor",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Seeku",
		"type": "living",
		"scope": "individual",
		"iso6393": "sos",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Sotho",
		"type": "living",
		"scope": "individual",
		"iso6393": "sot",
		"iso6392B": "sot",
		"iso6392T": "sot",
		"iso6391": "st"
	},
	{
		"name": "Southern Thai",
		"type": "living",
		"scope": "individual",
		"iso6393": "sou",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sonsorol",
		"type": "living",
		"scope": "individual",
		"iso6393": "sov",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sowanda",
		"type": "living",
		"scope": "individual",
		"iso6393": "sow",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Swo",
		"type": "living",
		"scope": "individual",
		"iso6393": "sox",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Miyobe",
		"type": "living",
		"scope": "individual",
		"iso6393": "soy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Temi",
		"type": "living",
		"scope": "individual",
		"iso6393": "soz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Spanish",
		"type": "living",
		"scope": "individual",
		"iso6393": "spa",
		"iso6392B": "spa",
		"iso6392T": "spa",
		"iso6391": "es"
	},
	{
		"name": "Sepa (Indonesia)",
		"type": "living",
		"scope": "individual",
		"iso6393": "spb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sapé",
		"type": "living",
		"scope": "individual",
		"iso6393": "spc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Saep",
		"type": "living",
		"scope": "individual",
		"iso6393": "spd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sepa (Papua New Guinea)",
		"type": "living",
		"scope": "individual",
		"iso6393": "spe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sian",
		"type": "living",
		"scope": "individual",
		"iso6393": "spg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Saponi",
		"type": "living",
		"scope": "individual",
		"iso6393": "spi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sengo",
		"type": "living",
		"scope": "individual",
		"iso6393": "spk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Selepet",
		"type": "living",
		"scope": "individual",
		"iso6393": "spl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Akukem",
		"type": "living",
		"scope": "individual",
		"iso6393": "spm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sanapaná",
		"type": "living",
		"scope": "individual",
		"iso6393": "spn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Spokane",
		"type": "living",
		"scope": "individual",
		"iso6393": "spo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Supyire Senoufo",
		"type": "living",
		"scope": "individual",
		"iso6393": "spp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Loreto-Ucayali Spanish",
		"type": "living",
		"scope": "individual",
		"iso6393": "spq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Saparua",
		"type": "living",
		"scope": "individual",
		"iso6393": "spr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Saposa",
		"type": "living",
		"scope": "individual",
		"iso6393": "sps",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Spiti Bhoti",
		"type": "living",
		"scope": "individual",
		"iso6393": "spt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sapuan",
		"type": "living",
		"scope": "individual",
		"iso6393": "spu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sambalpuri",
		"type": "living",
		"scope": "individual",
		"iso6393": "spv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "South Picene",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "spx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sabaot",
		"type": "living",
		"scope": "individual",
		"iso6393": "spy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shama-Sambuga",
		"type": "living",
		"scope": "individual",
		"iso6393": "sqa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shau",
		"type": "living",
		"scope": "individual",
		"iso6393": "sqh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Albanian",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "sqi",
		"iso6392B": "alb",
		"iso6392T": "sqi",
		"iso6391": "sq"
	},
	{
		"name": "Albanian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "sqk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Suma",
		"type": "living",
		"scope": "individual",
		"iso6393": "sqm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Susquehannock",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "sqn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sorkhei",
		"type": "living",
		"scope": "individual",
		"iso6393": "sqo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sou",
		"type": "living",
		"scope": "individual",
		"iso6393": "sqq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Siculo Arabic",
		"type": "historical",
		"scope": "individual",
		"iso6393": "sqr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sri Lankan Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "sqs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Soqotri",
		"type": "living",
		"scope": "individual",
		"iso6393": "sqt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Squamish",
		"type": "living",
		"scope": "individual",
		"iso6393": "squ",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Saruga",
		"type": "living",
		"scope": "individual",
		"iso6393": "sra",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sora",
		"type": "living",
		"scope": "individual",
		"iso6393": "srb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Logudorese Sardinian",
		"type": "living",
		"scope": "individual",
		"iso6393": "src",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sardinian",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "srd",
		"iso6392B": "srd",
		"iso6392T": "srd",
		"iso6391": "sc"
	},
	{
		"name": "Sara",
		"type": "living",
		"scope": "individual",
		"iso6393": "sre",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nafi",
		"type": "living",
		"scope": "individual",
		"iso6393": "srf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sulod",
		"type": "living",
		"scope": "individual",
		"iso6393": "srg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sarikoli",
		"type": "living",
		"scope": "individual",
		"iso6393": "srh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Siriano",
		"type": "living",
		"scope": "individual",
		"iso6393": "sri",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Serudung Murut",
		"type": "living",
		"scope": "individual",
		"iso6393": "srk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Isirawa",
		"type": "living",
		"scope": "individual",
		"iso6393": "srl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Saramaccan",
		"type": "living",
		"scope": "individual",
		"iso6393": "srm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sranan Tongo",
		"type": "living",
		"scope": "individual",
		"iso6393": "srn",
		"iso6392B": "srn",
		"iso6392T": "srn",
		"iso6391": null
	},
	{
		"name": "Campidanese Sardinian",
		"type": "living",
		"scope": "individual",
		"iso6393": "sro",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Serbian",
		"type": "living",
		"scope": "individual",
		"iso6393": "srp",
		"iso6392B": "srp",
		"iso6392T": "srp",
		"iso6391": "sr"
	},
	{
		"name": "Sirionó",
		"type": "living",
		"scope": "individual",
		"iso6393": "srq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Serer",
		"type": "living",
		"scope": "individual",
		"iso6393": "srr",
		"iso6392B": "srr",
		"iso6392T": "srr",
		"iso6391": null
	},
	{
		"name": "Sarsi",
		"type": "living",
		"scope": "individual",
		"iso6393": "srs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sauri",
		"type": "living",
		"scope": "individual",
		"iso6393": "srt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Suruí",
		"type": "living",
		"scope": "individual",
		"iso6393": "sru",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Sorsoganon",
		"type": "living",
		"scope": "individual",
		"iso6393": "srv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Serua",
		"type": "living",
		"scope": "individual",
		"iso6393": "srw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sirmauri",
		"type": "living",
		"scope": "individual",
		"iso6393": "srx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sera",
		"type": "living",
		"scope": "individual",
		"iso6393": "sry",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shahmirzadi",
		"type": "living",
		"scope": "individual",
		"iso6393": "srz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Sama",
		"type": "living",
		"scope": "individual",
		"iso6393": "ssb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Suba-Simbiti",
		"type": "living",
		"scope": "individual",
		"iso6393": "ssc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Siroi",
		"type": "living",
		"scope": "individual",
		"iso6393": "ssd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Balangingi",
		"type": "living",
		"scope": "individual",
		"iso6393": "sse",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Thao",
		"type": "living",
		"scope": "individual",
		"iso6393": "ssf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Seimat",
		"type": "living",
		"scope": "individual",
		"iso6393": "ssg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shihhi Arabic",
		"type": "living",
		"scope": "individual",
		"iso6393": "ssh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sansi",
		"type": "living",
		"scope": "individual",
		"iso6393": "ssi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sausi",
		"type": "living",
		"scope": "individual",
		"iso6393": "ssj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sunam",
		"type": "living",
		"scope": "individual",
		"iso6393": "ssk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Sisaala",
		"type": "living",
		"scope": "individual",
		"iso6393": "ssl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Semnam",
		"type": "living",
		"scope": "individual",
		"iso6393": "ssm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Waata",
		"type": "living",
		"scope": "individual",
		"iso6393": "ssn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sissano",
		"type": "living",
		"scope": "individual",
		"iso6393": "sso",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Spanish Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "ssp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "So'a",
		"type": "living",
		"scope": "individual",
		"iso6393": "ssq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Swiss-French Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "ssr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sô",
		"type": "living",
		"scope": "individual",
		"iso6393": "sss",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sinasina",
		"type": "living",
		"scope": "individual",
		"iso6393": "sst",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Susuami",
		"type": "living",
		"scope": "individual",
		"iso6393": "ssu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shark Bay",
		"type": "living",
		"scope": "individual",
		"iso6393": "ssv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Swati",
		"type": "living",
		"scope": "individual",
		"iso6393": "ssw",
		"iso6392B": "ssw",
		"iso6392T": "ssw",
		"iso6391": "ss"
	},
	{
		"name": "Samberigi",
		"type": "living",
		"scope": "individual",
		"iso6393": "ssx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Saho",
		"type": "living",
		"scope": "individual",
		"iso6393": "ssy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sengseng",
		"type": "living",
		"scope": "individual",
		"iso6393": "ssz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Settla",
		"type": "living",
		"scope": "individual",
		"iso6393": "sta",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Subanen",
		"type": "living",
		"scope": "individual",
		"iso6393": "stb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sentinel",
		"type": "living",
		"scope": "individual",
		"iso6393": "std",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Liana-Seti",
		"type": "living",
		"scope": "individual",
		"iso6393": "ste",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Seta",
		"type": "living",
		"scope": "individual",
		"iso6393": "stf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Trieng",
		"type": "living",
		"scope": "individual",
		"iso6393": "stg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shelta",
		"type": "living",
		"scope": "individual",
		"iso6393": "sth",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bulo Stieng",
		"type": "living",
		"scope": "individual",
		"iso6393": "sti",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Matya Samo",
		"type": "living",
		"scope": "individual",
		"iso6393": "stj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Arammba",
		"type": "living",
		"scope": "individual",
		"iso6393": "stk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Stellingwerfs",
		"type": "living",
		"scope": "individual",
		"iso6393": "stl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Setaman",
		"type": "living",
		"scope": "individual",
		"iso6393": "stm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Owa",
		"type": "living",
		"scope": "individual",
		"iso6393": "stn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Stoney",
		"type": "living",
		"scope": "individual",
		"iso6393": "sto",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southeastern Tepehuan",
		"type": "living",
		"scope": "individual",
		"iso6393": "stp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Saterfriesisch",
		"type": "living",
		"scope": "individual",
		"iso6393": "stq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Straits Salish",
		"type": "living",
		"scope": "individual",
		"iso6393": "str",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shumashti",
		"type": "living",
		"scope": "individual",
		"iso6393": "sts",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Budeh Stieng",
		"type": "living",
		"scope": "individual",
		"iso6393": "stt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Samtao",
		"type": "living",
		"scope": "individual",
		"iso6393": "stu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Silt'e",
		"type": "living",
		"scope": "individual",
		"iso6393": "stv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Satawalese",
		"type": "living",
		"scope": "individual",
		"iso6393": "stw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Siberian Tatar",
		"type": "living",
		"scope": "individual",
		"iso6393": "sty",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sulka",
		"type": "living",
		"scope": "individual",
		"iso6393": "sua",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Suku",
		"type": "living",
		"scope": "individual",
		"iso6393": "sub",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Subanon",
		"type": "living",
		"scope": "individual",
		"iso6393": "suc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Suena",
		"type": "living",
		"scope": "individual",
		"iso6393": "sue",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Suganga",
		"type": "living",
		"scope": "individual",
		"iso6393": "sug",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Suki",
		"type": "living",
		"scope": "individual",
		"iso6393": "sui",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shubi",
		"type": "living",
		"scope": "individual",
		"iso6393": "suj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sukuma",
		"type": "living",
		"scope": "individual",
		"iso6393": "suk",
		"iso6392B": "suk",
		"iso6392T": "suk",
		"iso6391": null
	},
	{
		"name": "Sundanese",
		"type": "living",
		"scope": "individual",
		"iso6393": "sun",
		"iso6392B": "sun",
		"iso6392T": "sun",
		"iso6391": "su"
	},
	{
		"name": "Suri",
		"type": "living",
		"scope": "individual",
		"iso6393": "suq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mwaghavul",
		"type": "living",
		"scope": "individual",
		"iso6393": "sur",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Susu",
		"type": "living",
		"scope": "individual",
		"iso6393": "sus",
		"iso6392B": "sus",
		"iso6392T": "sus",
		"iso6391": null
	},
	{
		"name": "Subtiaba",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "sut",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Puroik",
		"type": "living",
		"scope": "individual",
		"iso6393": "suv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sumbwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "suw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sumerian",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "sux",
		"iso6392B": "sux",
		"iso6392T": "sux",
		"iso6391": null
	},
	{
		"name": "Suyá",
		"type": "living",
		"scope": "individual",
		"iso6393": "suy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sunwar",
		"type": "living",
		"scope": "individual",
		"iso6393": "suz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Svan",
		"type": "living",
		"scope": "individual",
		"iso6393": "sva",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ulau-Suain",
		"type": "living",
		"scope": "individual",
		"iso6393": "svb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Vincentian Creole English",
		"type": "living",
		"scope": "individual",
		"iso6393": "svc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Serili",
		"type": "living",
		"scope": "individual",
		"iso6393": "sve",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Slovakian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "svk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Slavomolisano",
		"type": "living",
		"scope": "individual",
		"iso6393": "svm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Savosavo",
		"type": "living",
		"scope": "individual",
		"iso6393": "svs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Skalvian",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "svx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Swahili (macrolanguage)",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "swa",
		"iso6392B": "swa",
		"iso6392T": "swa",
		"iso6391": "sw"
	},
	{
		"name": "Maore Comorian",
		"type": "living",
		"scope": "individual",
		"iso6393": "swb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Congo Swahili",
		"type": "living",
		"scope": "individual",
		"iso6393": "swc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Swedish",
		"type": "living",
		"scope": "individual",
		"iso6393": "swe",
		"iso6392B": "swe",
		"iso6392T": "swe",
		"iso6391": "sv"
	},
	{
		"name": "Sere",
		"type": "living",
		"scope": "individual",
		"iso6393": "swf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Swabian",
		"type": "living",
		"scope": "individual",
		"iso6393": "swg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Swahili (individual language)",
		"type": "living",
		"scope": "individual",
		"iso6393": "swh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sui",
		"type": "living",
		"scope": "individual",
		"iso6393": "swi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sira",
		"type": "living",
		"scope": "individual",
		"iso6393": "swj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Malawi Sena",
		"type": "living",
		"scope": "individual",
		"iso6393": "swk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Swedish Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "swl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Samosa",
		"type": "living",
		"scope": "individual",
		"iso6393": "swm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sawknah",
		"type": "living",
		"scope": "individual",
		"iso6393": "swn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shanenawa",
		"type": "living",
		"scope": "individual",
		"iso6393": "swo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Suau",
		"type": "living",
		"scope": "individual",
		"iso6393": "swp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sharwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "swq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Saweru",
		"type": "living",
		"scope": "individual",
		"iso6393": "swr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Seluwasan",
		"type": "living",
		"scope": "individual",
		"iso6393": "sws",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sawila",
		"type": "living",
		"scope": "individual",
		"iso6393": "swt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Suwawa",
		"type": "living",
		"scope": "individual",
		"iso6393": "swu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shekhawati",
		"type": "living",
		"scope": "individual",
		"iso6393": "swv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sowa",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "sww",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Suruahá",
		"type": "living",
		"scope": "individual",
		"iso6393": "swx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sarua",
		"type": "living",
		"scope": "individual",
		"iso6393": "swy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Suba",
		"type": "living",
		"scope": "individual",
		"iso6393": "sxb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sicanian",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "sxc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sighu",
		"type": "living",
		"scope": "individual",
		"iso6393": "sxe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shixing",
		"type": "living",
		"scope": "individual",
		"iso6393": "sxg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Kalapuya",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "sxk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Selian",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "sxl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Samre",
		"type": "living",
		"scope": "individual",
		"iso6393": "sxm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sangir",
		"type": "living",
		"scope": "individual",
		"iso6393": "sxn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sorothaptic",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "sxo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Saaroa",
		"type": "living",
		"scope": "individual",
		"iso6393": "sxr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sasaru",
		"type": "living",
		"scope": "individual",
		"iso6393": "sxs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Upper Saxon",
		"type": "living",
		"scope": "individual",
		"iso6393": "sxu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Saxwe Gbe",
		"type": "living",
		"scope": "individual",
		"iso6393": "sxw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Siang",
		"type": "living",
		"scope": "individual",
		"iso6393": "sya",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Central Subanen",
		"type": "living",
		"scope": "individual",
		"iso6393": "syb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Classical Syriac",
		"type": "historical",
		"scope": "individual",
		"iso6393": "syc",
		"iso6392B": "syc",
		"iso6392T": "syc",
		"iso6391": null
	},
	{
		"name": "Seki",
		"type": "living",
		"scope": "individual",
		"iso6393": "syi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sukur",
		"type": "living",
		"scope": "individual",
		"iso6393": "syk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sylheti",
		"type": "living",
		"scope": "individual",
		"iso6393": "syl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maya Samo",
		"type": "living",
		"scope": "individual",
		"iso6393": "sym",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Senaya",
		"type": "living",
		"scope": "individual",
		"iso6393": "syn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Suoy",
		"type": "living",
		"scope": "individual",
		"iso6393": "syo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Syriac",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "syr",
		"iso6392B": "syr",
		"iso6392T": "syr",
		"iso6391": null
	},
	{
		"name": "Sinyar",
		"type": "living",
		"scope": "individual",
		"iso6393": "sys",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kagate",
		"type": "living",
		"scope": "individual",
		"iso6393": "syw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Samay",
		"type": "living",
		"scope": "individual",
		"iso6393": "syx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Al-Sayyid Bedouin Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "syy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Semelai",
		"type": "living",
		"scope": "individual",
		"iso6393": "sza",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngalum",
		"type": "living",
		"scope": "individual",
		"iso6393": "szb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Semaq Beri",
		"type": "living",
		"scope": "individual",
		"iso6393": "szc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Seru",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "szd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Seze",
		"type": "living",
		"scope": "individual",
		"iso6393": "sze",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sengele",
		"type": "living",
		"scope": "individual",
		"iso6393": "szg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Silesian",
		"type": "living",
		"scope": "individual",
		"iso6393": "szl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sula",
		"type": "living",
		"scope": "individual",
		"iso6393": "szn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Suabo",
		"type": "living",
		"scope": "individual",
		"iso6393": "szp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Isu (Fako Division)",
		"type": "living",
		"scope": "individual",
		"iso6393": "szv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sawai",
		"type": "living",
		"scope": "individual",
		"iso6393": "szw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lower Tanana",
		"type": "living",
		"scope": "individual",
		"iso6393": "taa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tabassaran",
		"type": "living",
		"scope": "individual",
		"iso6393": "tab",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lowland Tarahumara",
		"type": "living",
		"scope": "individual",
		"iso6393": "tac",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tause",
		"type": "living",
		"scope": "individual",
		"iso6393": "tad",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tariana",
		"type": "living",
		"scope": "individual",
		"iso6393": "tae",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tapirapé",
		"type": "living",
		"scope": "individual",
		"iso6393": "taf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tagoi",
		"type": "living",
		"scope": "individual",
		"iso6393": "tag",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tahitian",
		"type": "living",
		"scope": "individual",
		"iso6393": "tah",
		"iso6392B": "tah",
		"iso6392T": "tah",
		"iso6391": "ty"
	},
	{
		"name": "Eastern Tamang",
		"type": "living",
		"scope": "individual",
		"iso6393": "taj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tala",
		"type": "living",
		"scope": "individual",
		"iso6393": "tak",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tal",
		"type": "living",
		"scope": "individual",
		"iso6393": "tal",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tamil",
		"type": "living",
		"scope": "individual",
		"iso6393": "tam",
		"iso6392B": "tam",
		"iso6392T": "tam",
		"iso6391": "ta"
	},
	{
		"name": "Tangale",
		"type": "living",
		"scope": "individual",
		"iso6393": "tan",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yami",
		"type": "living",
		"scope": "individual",
		"iso6393": "tao",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Taabwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "tap",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tamasheq",
		"type": "living",
		"scope": "individual",
		"iso6393": "taq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Central Tarahumara",
		"type": "living",
		"scope": "individual",
		"iso6393": "tar",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tay Boi",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "tas",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tatar",
		"type": "living",
		"scope": "individual",
		"iso6393": "tat",
		"iso6392B": "tat",
		"iso6392T": "tat",
		"iso6391": "tt"
	},
	{
		"name": "Upper Tanana",
		"type": "living",
		"scope": "individual",
		"iso6393": "tau",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tatuyo",
		"type": "living",
		"scope": "individual",
		"iso6393": "tav",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tai",
		"type": "living",
		"scope": "individual",
		"iso6393": "taw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tamki",
		"type": "living",
		"scope": "individual",
		"iso6393": "tax",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Atayal",
		"type": "living",
		"scope": "individual",
		"iso6393": "tay",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tocho",
		"type": "living",
		"scope": "individual",
		"iso6393": "taz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aikanã",
		"type": "living",
		"scope": "individual",
		"iso6393": "tba",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tapeba",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "tbb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Takia",
		"type": "living",
		"scope": "individual",
		"iso6393": "tbc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kaki Ae",
		"type": "living",
		"scope": "individual",
		"iso6393": "tbd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tanimbili",
		"type": "living",
		"scope": "individual",
		"iso6393": "tbe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mandara",
		"type": "living",
		"scope": "individual",
		"iso6393": "tbf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "North Tairora",
		"type": "living",
		"scope": "individual",
		"iso6393": "tbg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Thurawal",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "tbh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gaam",
		"type": "living",
		"scope": "individual",
		"iso6393": "tbi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tiang",
		"type": "living",
		"scope": "individual",
		"iso6393": "tbj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Calamian Tagbanwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "tbk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tboli",
		"type": "living",
		"scope": "individual",
		"iso6393": "tbl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tagbu",
		"type": "living",
		"scope": "individual",
		"iso6393": "tbm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Barro Negro Tunebo",
		"type": "living",
		"scope": "individual",
		"iso6393": "tbn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tawala",
		"type": "living",
		"scope": "individual",
		"iso6393": "tbo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Taworta",
		"type": "living",
		"scope": "individual",
		"iso6393": "tbp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tumtum",
		"type": "living",
		"scope": "individual",
		"iso6393": "tbr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tanguat",
		"type": "living",
		"scope": "individual",
		"iso6393": "tbs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tembo (Kitembo)",
		"type": "living",
		"scope": "individual",
		"iso6393": "tbt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tubar",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "tbu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tobo",
		"type": "living",
		"scope": "individual",
		"iso6393": "tbv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tagbanwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "tbw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kapin",
		"type": "living",
		"scope": "individual",
		"iso6393": "tbx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tabaru",
		"type": "living",
		"scope": "individual",
		"iso6393": "tby",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ditammari",
		"type": "living",
		"scope": "individual",
		"iso6393": "tbz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ticuna",
		"type": "living",
		"scope": "individual",
		"iso6393": "tca",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tanacross",
		"type": "living",
		"scope": "individual",
		"iso6393": "tcb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Datooga",
		"type": "living",
		"scope": "individual",
		"iso6393": "tcc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tafi",
		"type": "living",
		"scope": "individual",
		"iso6393": "tcd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Tutchone",
		"type": "living",
		"scope": "individual",
		"iso6393": "tce",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Malinaltepec Me'phaa",
		"type": "living",
		"scope": "individual",
		"iso6393": "tcf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tamagario",
		"type": "living",
		"scope": "individual",
		"iso6393": "tcg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Turks And Caicos Creole English",
		"type": "living",
		"scope": "individual",
		"iso6393": "tch",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wára",
		"type": "living",
		"scope": "individual",
		"iso6393": "tci",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tchitchege",
		"type": "living",
		"scope": "individual",
		"iso6393": "tck",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Taman (Myanmar)",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "tcl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tanahmerah",
		"type": "living",
		"scope": "individual",
		"iso6393": "tcm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tichurong",
		"type": "living",
		"scope": "individual",
		"iso6393": "tcn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Taungyo",
		"type": "living",
		"scope": "individual",
		"iso6393": "tco",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tawr Chin",
		"type": "living",
		"scope": "individual",
		"iso6393": "tcp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kaiy",
		"type": "living",
		"scope": "individual",
		"iso6393": "tcq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Torres Strait Creole",
		"type": "living",
		"scope": "individual",
		"iso6393": "tcs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "T'en",
		"type": "living",
		"scope": "individual",
		"iso6393": "tct",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southeastern Tarahumara",
		"type": "living",
		"scope": "individual",
		"iso6393": "tcu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tecpatlán Totonac",
		"type": "living",
		"scope": "individual",
		"iso6393": "tcw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Toda",
		"type": "living",
		"scope": "individual",
		"iso6393": "tcx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tulu",
		"type": "living",
		"scope": "individual",
		"iso6393": "tcy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Thado Chin",
		"type": "living",
		"scope": "individual",
		"iso6393": "tcz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tagdal",
		"type": "living",
		"scope": "individual",
		"iso6393": "tda",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Panchpargania",
		"type": "living",
		"scope": "individual",
		"iso6393": "tdb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Emberá-Tadó",
		"type": "living",
		"scope": "individual",
		"iso6393": "tdc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tai Nüa",
		"type": "living",
		"scope": "individual",
		"iso6393": "tdd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tiranige Diga Dogon",
		"type": "living",
		"scope": "individual",
		"iso6393": "tde",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Talieng",
		"type": "living",
		"scope": "individual",
		"iso6393": "tdf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Tamang",
		"type": "living",
		"scope": "individual",
		"iso6393": "tdg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Thulung",
		"type": "living",
		"scope": "individual",
		"iso6393": "tdh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tomadino",
		"type": "living",
		"scope": "individual",
		"iso6393": "tdi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tajio",
		"type": "living",
		"scope": "individual",
		"iso6393": "tdj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tambas",
		"type": "living",
		"scope": "individual",
		"iso6393": "tdk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sur",
		"type": "living",
		"scope": "individual",
		"iso6393": "tdl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Taruma",
		"type": "living",
		"scope": "individual",
		"iso6393": "tdm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tondano",
		"type": "living",
		"scope": "individual",
		"iso6393": "tdn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Teme",
		"type": "living",
		"scope": "individual",
		"iso6393": "tdo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tita",
		"type": "living",
		"scope": "individual",
		"iso6393": "tdq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Todrah",
		"type": "living",
		"scope": "individual",
		"iso6393": "tdr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Doutai",
		"type": "living",
		"scope": "individual",
		"iso6393": "tds",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tetun Dili",
		"type": "living",
		"scope": "individual",
		"iso6393": "tdt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Toro",
		"type": "living",
		"scope": "individual",
		"iso6393": "tdv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tandroy-Mahafaly Malagasy",
		"type": "living",
		"scope": "individual",
		"iso6393": "tdx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tadyawan",
		"type": "living",
		"scope": "individual",
		"iso6393": "tdy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Temiar",
		"type": "living",
		"scope": "individual",
		"iso6393": "tea",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tetete",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "teb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Terik",
		"type": "living",
		"scope": "individual",
		"iso6393": "tec",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tepo Krumen",
		"type": "living",
		"scope": "individual",
		"iso6393": "ted",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Huehuetla Tepehua",
		"type": "living",
		"scope": "individual",
		"iso6393": "tee",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Teressa",
		"type": "living",
		"scope": "individual",
		"iso6393": "tef",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Teke-Tege",
		"type": "living",
		"scope": "individual",
		"iso6393": "teg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tehuelche",
		"type": "living",
		"scope": "individual",
		"iso6393": "teh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Torricelli",
		"type": "living",
		"scope": "individual",
		"iso6393": "tei",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ibali Teke",
		"type": "living",
		"scope": "individual",
		"iso6393": "tek",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Telugu",
		"type": "living",
		"scope": "individual",
		"iso6393": "tel",
		"iso6392B": "tel",
		"iso6392T": "tel",
		"iso6391": "te"
	},
	{
		"name": "Timne",
		"type": "living",
		"scope": "individual",
		"iso6393": "tem",
		"iso6392B": "tem",
		"iso6392T": "tem",
		"iso6391": null
	},
	{
		"name": "Tama (Colombia)",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ten",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Teso",
		"type": "living",
		"scope": "individual",
		"iso6393": "teo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tepecano",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "tep",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Temein",
		"type": "living",
		"scope": "individual",
		"iso6393": "teq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tereno",
		"type": "living",
		"scope": "individual",
		"iso6393": "ter",
		"iso6392B": "ter",
		"iso6392T": "ter",
		"iso6391": null
	},
	{
		"name": "Tengger",
		"type": "living",
		"scope": "individual",
		"iso6393": "tes",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tetum",
		"type": "living",
		"scope": "individual",
		"iso6393": "tet",
		"iso6392B": "tet",
		"iso6392T": "tet",
		"iso6391": null
	},
	{
		"name": "Soo",
		"type": "living",
		"scope": "individual",
		"iso6393": "teu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Teor",
		"type": "living",
		"scope": "individual",
		"iso6393": "tev",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tewa (USA)",
		"type": "living",
		"scope": "individual",
		"iso6393": "tew",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tennet",
		"type": "living",
		"scope": "individual",
		"iso6393": "tex",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tulishi",
		"type": "living",
		"scope": "individual",
		"iso6393": "tey",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tofin Gbe",
		"type": "living",
		"scope": "individual",
		"iso6393": "tfi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tanaina",
		"type": "living",
		"scope": "individual",
		"iso6393": "tfn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tefaro",
		"type": "living",
		"scope": "individual",
		"iso6393": "tfo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Teribe",
		"type": "living",
		"scope": "individual",
		"iso6393": "tfr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ternate",
		"type": "living",
		"scope": "individual",
		"iso6393": "tft",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sagalla",
		"type": "living",
		"scope": "individual",
		"iso6393": "tga",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tobilung",
		"type": "living",
		"scope": "individual",
		"iso6393": "tgb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tigak",
		"type": "living",
		"scope": "individual",
		"iso6393": "tgc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ciwogai",
		"type": "living",
		"scope": "individual",
		"iso6393": "tgd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Gorkha Tamang",
		"type": "living",
		"scope": "individual",
		"iso6393": "tge",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chalikha",
		"type": "living",
		"scope": "individual",
		"iso6393": "tgf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tobagonian Creole English",
		"type": "living",
		"scope": "individual",
		"iso6393": "tgh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lawunuia",
		"type": "living",
		"scope": "individual",
		"iso6393": "tgi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tagin",
		"type": "living",
		"scope": "individual",
		"iso6393": "tgj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tajik",
		"type": "living",
		"scope": "individual",
		"iso6393": "tgk",
		"iso6392B": "tgk",
		"iso6392T": "tgk",
		"iso6391": "tg"
	},
	{
		"name": "Tagalog",
		"type": "living",
		"scope": "individual",
		"iso6393": "tgl",
		"iso6392B": "tgl",
		"iso6392T": "tgl",
		"iso6391": "tl"
	},
	{
		"name": "Tandaganon",
		"type": "living",
		"scope": "individual",
		"iso6393": "tgn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sudest",
		"type": "living",
		"scope": "individual",
		"iso6393": "tgo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tangoa",
		"type": "living",
		"scope": "individual",
		"iso6393": "tgp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tring",
		"type": "living",
		"scope": "individual",
		"iso6393": "tgq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tareng",
		"type": "living",
		"scope": "individual",
		"iso6393": "tgr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nume",
		"type": "living",
		"scope": "individual",
		"iso6393": "tgs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Central Tagbanwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "tgt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tanggu",
		"type": "living",
		"scope": "individual",
		"iso6393": "tgu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tingui-Boto",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "tgv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tagwana Senoufo",
		"type": "living",
		"scope": "individual",
		"iso6393": "tgw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tagish",
		"type": "living",
		"scope": "individual",
		"iso6393": "tgx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Togoyo",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "tgy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tagalaka",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "tgz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Thai",
		"type": "living",
		"scope": "individual",
		"iso6393": "tha",
		"iso6392B": "tha",
		"iso6392T": "tha",
		"iso6391": "th"
	},
	{
		"name": "Thayore",
		"type": "living",
		"scope": "individual",
		"iso6393": "thd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chitwania Tharu",
		"type": "living",
		"scope": "individual",
		"iso6393": "the",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Thangmi",
		"type": "living",
		"scope": "individual",
		"iso6393": "thf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Tarahumara",
		"type": "living",
		"scope": "individual",
		"iso6393": "thh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tai Long",
		"type": "living",
		"scope": "individual",
		"iso6393": "thi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tharaka",
		"type": "living",
		"scope": "individual",
		"iso6393": "thk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dangaura Tharu",
		"type": "living",
		"scope": "individual",
		"iso6393": "thl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aheu",
		"type": "living",
		"scope": "individual",
		"iso6393": "thm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Thachanadan",
		"type": "living",
		"scope": "individual",
		"iso6393": "thn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Thompson",
		"type": "living",
		"scope": "individual",
		"iso6393": "thp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kochila Tharu",
		"type": "living",
		"scope": "individual",
		"iso6393": "thq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rana Tharu",
		"type": "living",
		"scope": "individual",
		"iso6393": "thr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Thakali",
		"type": "living",
		"scope": "individual",
		"iso6393": "ths",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tahltan",
		"type": "living",
		"scope": "individual",
		"iso6393": "tht",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Thuri",
		"type": "living",
		"scope": "individual",
		"iso6393": "thu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tahaggart Tamahaq",
		"type": "living",
		"scope": "individual",
		"iso6393": "thv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Thudam",
		"type": "living",
		"scope": "individual",
		"iso6393": "thw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tha",
		"type": "living",
		"scope": "individual",
		"iso6393": "thy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tayart Tamajeq",
		"type": "living",
		"scope": "individual",
		"iso6393": "thz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tidikelt Tamazight",
		"type": "living",
		"scope": "individual",
		"iso6393": "tia",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tira",
		"type": "living",
		"scope": "individual",
		"iso6393": "tic",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tifal",
		"type": "living",
		"scope": "individual",
		"iso6393": "tif",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tigre",
		"type": "living",
		"scope": "individual",
		"iso6393": "tig",
		"iso6392B": "tig",
		"iso6392T": "tig",
		"iso6391": null
	},
	{
		"name": "Timugon Murut",
		"type": "living",
		"scope": "individual",
		"iso6393": "tih",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tiene",
		"type": "living",
		"scope": "individual",
		"iso6393": "tii",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tilung",
		"type": "living",
		"scope": "individual",
		"iso6393": "tij",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tikar",
		"type": "living",
		"scope": "individual",
		"iso6393": "tik",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tillamook",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "til",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Timbe",
		"type": "living",
		"scope": "individual",
		"iso6393": "tim",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tindi",
		"type": "living",
		"scope": "individual",
		"iso6393": "tin",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Teop",
		"type": "living",
		"scope": "individual",
		"iso6393": "tio",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Trimuris",
		"type": "living",
		"scope": "individual",
		"iso6393": "tip",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tiéfo",
		"type": "living",
		"scope": "individual",
		"iso6393": "tiq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tigrinya",
		"type": "living",
		"scope": "individual",
		"iso6393": "tir",
		"iso6392B": "tir",
		"iso6392T": "tir",
		"iso6391": "ti"
	},
	{
		"name": "Masadiit Itneg",
		"type": "living",
		"scope": "individual",
		"iso6393": "tis",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tinigua",
		"type": "living",
		"scope": "individual",
		"iso6393": "tit",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Adasen",
		"type": "living",
		"scope": "individual",
		"iso6393": "tiu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tiv",
		"type": "living",
		"scope": "individual",
		"iso6393": "tiv",
		"iso6392B": "tiv",
		"iso6392T": "tiv",
		"iso6391": null
	},
	{
		"name": "Tiwi",
		"type": "living",
		"scope": "individual",
		"iso6393": "tiw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Tiwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "tix",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tiruray",
		"type": "living",
		"scope": "individual",
		"iso6393": "tiy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tai Hongjin",
		"type": "living",
		"scope": "individual",
		"iso6393": "tiz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tajuasohn",
		"type": "living",
		"scope": "individual",
		"iso6393": "tja",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tunjung",
		"type": "living",
		"scope": "individual",
		"iso6393": "tjg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Tujia",
		"type": "living",
		"scope": "individual",
		"iso6393": "tji",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tai Laing",
		"type": "living",
		"scope": "individual",
		"iso6393": "tjl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Timucua",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "tjm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tonjon",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "tjn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Temacine Tamazight",
		"type": "living",
		"scope": "individual",
		"iso6393": "tjo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Tujia",
		"type": "living",
		"scope": "individual",
		"iso6393": "tjs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tjurruru",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "tju",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Djabwurrung",
		"type": "living",
		"scope": "individual",
		"iso6393": "tjw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Truká",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "tka",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Buksa",
		"type": "living",
		"scope": "individual",
		"iso6393": "tkb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tukudede",
		"type": "living",
		"scope": "individual",
		"iso6393": "tkd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Takwane",
		"type": "living",
		"scope": "individual",
		"iso6393": "tke",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tukumanféd",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "tkf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tesaka Malagasy",
		"type": "living",
		"scope": "individual",
		"iso6393": "tkg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tokelau",
		"type": "living",
		"scope": "individual",
		"iso6393": "tkl",
		"iso6392B": "tkl",
		"iso6392T": "tkl",
		"iso6391": null
	},
	{
		"name": "Takelma",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "tkm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Toku-No-Shima",
		"type": "living",
		"scope": "individual",
		"iso6393": "tkn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tikopia",
		"type": "living",
		"scope": "individual",
		"iso6393": "tkp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tee",
		"type": "living",
		"scope": "individual",
		"iso6393": "tkq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tsakhur",
		"type": "living",
		"scope": "individual",
		"iso6393": "tkr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Takestani",
		"type": "living",
		"scope": "individual",
		"iso6393": "tks",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kathoriya Tharu",
		"type": "living",
		"scope": "individual",
		"iso6393": "tkt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Upper Necaxa Totonac",
		"type": "living",
		"scope": "individual",
		"iso6393": "tku",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mur Pano",
		"type": "living",
		"scope": "individual",
		"iso6393": "tkv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Teanu",
		"type": "living",
		"scope": "individual",
		"iso6393": "tkw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tangko",
		"type": "living",
		"scope": "individual",
		"iso6393": "tkx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Takua",
		"type": "living",
		"scope": "individual",
		"iso6393": "tkz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southwestern Tepehuan",
		"type": "living",
		"scope": "individual",
		"iso6393": "tla",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tobelo",
		"type": "living",
		"scope": "individual",
		"iso6393": "tlb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yecuatla Totonac",
		"type": "living",
		"scope": "individual",
		"iso6393": "tlc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Talaud",
		"type": "living",
		"scope": "individual",
		"iso6393": "tld",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Telefol",
		"type": "living",
		"scope": "individual",
		"iso6393": "tlf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tofanma",
		"type": "living",
		"scope": "individual",
		"iso6393": "tlg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Klingon",
		"type": "constructed",
		"scope": "individual",
		"iso6393": "tlh",
		"iso6392B": "tlh",
		"iso6392T": "tlh",
		"iso6391": null
	},
	{
		"name": "Tlingit",
		"type": "living",
		"scope": "individual",
		"iso6393": "tli",
		"iso6392B": "tli",
		"iso6392T": "tli",
		"iso6391": null
	},
	{
		"name": "Talinga-Bwisi",
		"type": "living",
		"scope": "individual",
		"iso6393": "tlj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Taloki",
		"type": "living",
		"scope": "individual",
		"iso6393": "tlk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tetela",
		"type": "living",
		"scope": "individual",
		"iso6393": "tll",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tolomako",
		"type": "living",
		"scope": "individual",
		"iso6393": "tlm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Talondo'",
		"type": "living",
		"scope": "individual",
		"iso6393": "tln",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Talodi",
		"type": "living",
		"scope": "individual",
		"iso6393": "tlo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Filomena Mata-Coahuitlán Totonac",
		"type": "living",
		"scope": "individual",
		"iso6393": "tlp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tai Loi",
		"type": "living",
		"scope": "individual",
		"iso6393": "tlq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Talise",
		"type": "living",
		"scope": "individual",
		"iso6393": "tlr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tambotalo",
		"type": "living",
		"scope": "individual",
		"iso6393": "tls",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sou Nama",
		"type": "living",
		"scope": "individual",
		"iso6393": "tlt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tulehu",
		"type": "living",
		"scope": "individual",
		"iso6393": "tlu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Taliabu",
		"type": "living",
		"scope": "individual",
		"iso6393": "tlv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Khehek",
		"type": "living",
		"scope": "individual",
		"iso6393": "tlx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Talysh",
		"type": "living",
		"scope": "individual",
		"iso6393": "tly",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tama (Chad)",
		"type": "living",
		"scope": "individual",
		"iso6393": "tma",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Katbol",
		"type": "living",
		"scope": "individual",
		"iso6393": "tmb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tumak",
		"type": "living",
		"scope": "individual",
		"iso6393": "tmc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Haruai",
		"type": "living",
		"scope": "individual",
		"iso6393": "tmd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tremembé",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "tme",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Toba-Maskoy",
		"type": "living",
		"scope": "individual",
		"iso6393": "tmf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ternateño",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "tmg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tamashek",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "tmh",
		"iso6392B": "tmh",
		"iso6392T": "tmh",
		"iso6391": null
	},
	{
		"name": "Tutuba",
		"type": "living",
		"scope": "individual",
		"iso6393": "tmi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Samarokena",
		"type": "living",
		"scope": "individual",
		"iso6393": "tmj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northwestern Tamang",
		"type": "living",
		"scope": "individual",
		"iso6393": "tmk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tamnim Citak",
		"type": "living",
		"scope": "individual",
		"iso6393": "tml",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tai Thanh",
		"type": "living",
		"scope": "individual",
		"iso6393": "tmm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Taman (Indonesia)",
		"type": "living",
		"scope": "individual",
		"iso6393": "tmn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Temoq",
		"type": "living",
		"scope": "individual",
		"iso6393": "tmo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tumleo",
		"type": "living",
		"scope": "individual",
		"iso6393": "tmq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jewish Babylonian Aramaic (ca. 200-1200 CE)",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "tmr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tima",
		"type": "living",
		"scope": "individual",
		"iso6393": "tms",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tasmate",
		"type": "living",
		"scope": "individual",
		"iso6393": "tmt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Iau",
		"type": "living",
		"scope": "individual",
		"iso6393": "tmu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tembo (Motembo)",
		"type": "living",
		"scope": "individual",
		"iso6393": "tmv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Temuan",
		"type": "living",
		"scope": "individual",
		"iso6393": "tmw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tami",
		"type": "living",
		"scope": "individual",
		"iso6393": "tmy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tamanaku",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "tmz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tacana",
		"type": "living",
		"scope": "individual",
		"iso6393": "tna",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Tunebo",
		"type": "living",
		"scope": "individual",
		"iso6393": "tnb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tanimuca-Retuarã",
		"type": "living",
		"scope": "individual",
		"iso6393": "tnc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Angosturas Tunebo",
		"type": "living",
		"scope": "individual",
		"iso6393": "tnd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tinoc Kallahan",
		"type": "living",
		"scope": "individual",
		"iso6393": "tne",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tobanga",
		"type": "living",
		"scope": "individual",
		"iso6393": "tng",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maiani",
		"type": "living",
		"scope": "individual",
		"iso6393": "tnh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tandia",
		"type": "living",
		"scope": "individual",
		"iso6393": "tni",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kwamera",
		"type": "living",
		"scope": "individual",
		"iso6393": "tnk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lenakel",
		"type": "living",
		"scope": "individual",
		"iso6393": "tnl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tabla",
		"type": "living",
		"scope": "individual",
		"iso6393": "tnm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "North Tanna",
		"type": "living",
		"scope": "individual",
		"iso6393": "tnn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Toromono",
		"type": "living",
		"scope": "individual",
		"iso6393": "tno",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Whitesands",
		"type": "living",
		"scope": "individual",
		"iso6393": "tnp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Taino",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "tnq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ménik",
		"type": "living",
		"scope": "individual",
		"iso6393": "tnr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tenis",
		"type": "living",
		"scope": "individual",
		"iso6393": "tns",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tontemboan",
		"type": "living",
		"scope": "individual",
		"iso6393": "tnt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tay Khang",
		"type": "living",
		"scope": "individual",
		"iso6393": "tnu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tangchangya",
		"type": "living",
		"scope": "individual",
		"iso6393": "tnv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tonsawang",
		"type": "living",
		"scope": "individual",
		"iso6393": "tnw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tanema",
		"type": "living",
		"scope": "individual",
		"iso6393": "tnx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tongwe",
		"type": "living",
		"scope": "individual",
		"iso6393": "tny",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ten'edn",
		"type": "living",
		"scope": "individual",
		"iso6393": "tnz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Toba",
		"type": "living",
		"scope": "individual",
		"iso6393": "tob",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Coyutla Totonac",
		"type": "living",
		"scope": "individual",
		"iso6393": "toc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Toma",
		"type": "living",
		"scope": "individual",
		"iso6393": "tod",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gizrra",
		"type": "living",
		"scope": "individual",
		"iso6393": "tof",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tonga (Nyasa)",
		"type": "living",
		"scope": "individual",
		"iso6393": "tog",
		"iso6392B": "tog",
		"iso6392T": "tog",
		"iso6391": null
	},
	{
		"name": "Gitonga",
		"type": "living",
		"scope": "individual",
		"iso6393": "toh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tonga (Zambia)",
		"type": "living",
		"scope": "individual",
		"iso6393": "toi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tojolabal",
		"type": "living",
		"scope": "individual",
		"iso6393": "toj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tolowa",
		"type": "living",
		"scope": "individual",
		"iso6393": "tol",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tombulu",
		"type": "living",
		"scope": "individual",
		"iso6393": "tom",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tonga (Tonga Islands)",
		"type": "living",
		"scope": "individual",
		"iso6393": "ton",
		"iso6392B": "ton",
		"iso6392T": "ton",
		"iso6391": "to"
	},
	{
		"name": "Xicotepec De Juárez Totonac",
		"type": "living",
		"scope": "individual",
		"iso6393": "too",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Papantla Totonac",
		"type": "living",
		"scope": "individual",
		"iso6393": "top",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Toposa",
		"type": "living",
		"scope": "individual",
		"iso6393": "toq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Togbo-Vara Banda",
		"type": "living",
		"scope": "individual",
		"iso6393": "tor",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Highland Totonac",
		"type": "living",
		"scope": "individual",
		"iso6393": "tos",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tho",
		"type": "living",
		"scope": "individual",
		"iso6393": "tou",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Upper Taromi",
		"type": "living",
		"scope": "individual",
		"iso6393": "tov",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jemez",
		"type": "living",
		"scope": "individual",
		"iso6393": "tow",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tobian",
		"type": "living",
		"scope": "individual",
		"iso6393": "tox",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Topoiyo",
		"type": "living",
		"scope": "individual",
		"iso6393": "toy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "To",
		"type": "living",
		"scope": "individual",
		"iso6393": "toz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Taupota",
		"type": "living",
		"scope": "individual",
		"iso6393": "tpa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Azoyú Me'phaa",
		"type": "living",
		"scope": "individual",
		"iso6393": "tpc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tippera",
		"type": "living",
		"scope": "individual",
		"iso6393": "tpe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tarpia",
		"type": "living",
		"scope": "individual",
		"iso6393": "tpf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kula",
		"type": "living",
		"scope": "individual",
		"iso6393": "tpg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tok Pisin",
		"type": "living",
		"scope": "individual",
		"iso6393": "tpi",
		"iso6392B": "tpi",
		"iso6392T": "tpi",
		"iso6391": null
	},
	{
		"name": "Tapieté",
		"type": "living",
		"scope": "individual",
		"iso6393": "tpj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tupinikin",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "tpk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tlacoapa Me'phaa",
		"type": "living",
		"scope": "individual",
		"iso6393": "tpl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tampulma",
		"type": "living",
		"scope": "individual",
		"iso6393": "tpm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tupinambá",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "tpn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tai Pao",
		"type": "living",
		"scope": "individual",
		"iso6393": "tpo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pisaflores Tepehua",
		"type": "living",
		"scope": "individual",
		"iso6393": "tpp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tukpa",
		"type": "living",
		"scope": "individual",
		"iso6393": "tpq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tuparí",
		"type": "living",
		"scope": "individual",
		"iso6393": "tpr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tlachichilco Tepehua",
		"type": "living",
		"scope": "individual",
		"iso6393": "tpt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tampuan",
		"type": "living",
		"scope": "individual",
		"iso6393": "tpu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tanapag",
		"type": "living",
		"scope": "individual",
		"iso6393": "tpv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tupí",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "tpw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Acatepec Me'phaa",
		"type": "living",
		"scope": "individual",
		"iso6393": "tpx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Trumai",
		"type": "living",
		"scope": "individual",
		"iso6393": "tpy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tinputz",
		"type": "living",
		"scope": "individual",
		"iso6393": "tpz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tembé",
		"type": "living",
		"scope": "individual",
		"iso6393": "tqb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lehali",
		"type": "living",
		"scope": "individual",
		"iso6393": "tql",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Turumsa",
		"type": "living",
		"scope": "individual",
		"iso6393": "tqm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tenino",
		"type": "living",
		"scope": "individual",
		"iso6393": "tqn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Toaripi",
		"type": "living",
		"scope": "individual",
		"iso6393": "tqo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tomoip",
		"type": "living",
		"scope": "individual",
		"iso6393": "tqp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tunni",
		"type": "living",
		"scope": "individual",
		"iso6393": "tqq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Torona",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "tqr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Totonac",
		"type": "living",
		"scope": "individual",
		"iso6393": "tqt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Touo",
		"type": "living",
		"scope": "individual",
		"iso6393": "tqu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tonkawa",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "tqw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tirahi",
		"type": "living",
		"scope": "individual",
		"iso6393": "tra",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Terebu",
		"type": "living",
		"scope": "individual",
		"iso6393": "trb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Copala Triqui",
		"type": "living",
		"scope": "individual",
		"iso6393": "trc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Turi",
		"type": "living",
		"scope": "individual",
		"iso6393": "trd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "East Tarangan",
		"type": "living",
		"scope": "individual",
		"iso6393": "tre",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Trinidadian Creole English",
		"type": "living",
		"scope": "individual",
		"iso6393": "trf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lishán Didán",
		"type": "living",
		"scope": "individual",
		"iso6393": "trg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Turaka",
		"type": "living",
		"scope": "individual",
		"iso6393": "trh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Trió",
		"type": "living",
		"scope": "individual",
		"iso6393": "tri",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Toram",
		"type": "living",
		"scope": "individual",
		"iso6393": "trj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Traveller Scottish",
		"type": "living",
		"scope": "individual",
		"iso6393": "trl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tregami",
		"type": "living",
		"scope": "individual",
		"iso6393": "trm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Trinitario",
		"type": "living",
		"scope": "individual",
		"iso6393": "trn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tarao Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "tro",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kok Borok",
		"type": "living",
		"scope": "individual",
		"iso6393": "trp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "San Martín Itunyoso Triqui",
		"type": "living",
		"scope": "individual",
		"iso6393": "trq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Taushiro",
		"type": "living",
		"scope": "individual",
		"iso6393": "trr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chicahuaxtla Triqui",
		"type": "living",
		"scope": "individual",
		"iso6393": "trs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tunggare",
		"type": "living",
		"scope": "individual",
		"iso6393": "trt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Turoyo",
		"type": "living",
		"scope": "individual",
		"iso6393": "tru",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Taroko",
		"type": "living",
		"scope": "individual",
		"iso6393": "trv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Torwali",
		"type": "living",
		"scope": "individual",
		"iso6393": "trw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tringgus-Sembaan Bidayuh",
		"type": "living",
		"scope": "individual",
		"iso6393": "trx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Turung",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "try",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Torá",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "trz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tsaangi",
		"type": "living",
		"scope": "individual",
		"iso6393": "tsa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tsamai",
		"type": "living",
		"scope": "individual",
		"iso6393": "tsb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tswa",
		"type": "living",
		"scope": "individual",
		"iso6393": "tsc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tsakonian",
		"type": "living",
		"scope": "individual",
		"iso6393": "tsd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tunisian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "tse",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tausug",
		"type": "living",
		"scope": "individual",
		"iso6393": "tsg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tsuvan",
		"type": "living",
		"scope": "individual",
		"iso6393": "tsh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tsimshian",
		"type": "living",
		"scope": "individual",
		"iso6393": "tsi",
		"iso6392B": "tsi",
		"iso6392T": "tsi",
		"iso6391": null
	},
	{
		"name": "Tshangla",
		"type": "living",
		"scope": "individual",
		"iso6393": "tsj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tseku",
		"type": "living",
		"scope": "individual",
		"iso6393": "tsk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ts'ün-Lao",
		"type": "living",
		"scope": "individual",
		"iso6393": "tsl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Turkish Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "tsm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tswana",
		"type": "living",
		"scope": "individual",
		"iso6393": "tsn",
		"iso6392B": "tsn",
		"iso6392T": "tsn",
		"iso6391": "tn"
	},
	{
		"name": "Tsonga",
		"type": "living",
		"scope": "individual",
		"iso6393": "tso",
		"iso6392B": "tso",
		"iso6392T": "tso",
		"iso6391": "ts"
	},
	{
		"name": "Northern Toussian",
		"type": "living",
		"scope": "individual",
		"iso6393": "tsp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Thai Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "tsq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Akei",
		"type": "living",
		"scope": "individual",
		"iso6393": "tsr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Taiwan Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "tss",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tondi Songway Kiini",
		"type": "living",
		"scope": "individual",
		"iso6393": "tst",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tsou",
		"type": "living",
		"scope": "individual",
		"iso6393": "tsu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tsogo",
		"type": "living",
		"scope": "individual",
		"iso6393": "tsv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tsishingini",
		"type": "living",
		"scope": "individual",
		"iso6393": "tsw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mubami",
		"type": "living",
		"scope": "individual",
		"iso6393": "tsx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tebul Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "tsy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Purepecha",
		"type": "living",
		"scope": "individual",
		"iso6393": "tsz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tutelo",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "tta",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gaa",
		"type": "living",
		"scope": "individual",
		"iso6393": "ttb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tektiteko",
		"type": "living",
		"scope": "individual",
		"iso6393": "ttc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tauade",
		"type": "living",
		"scope": "individual",
		"iso6393": "ttd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bwanabwana",
		"type": "living",
		"scope": "individual",
		"iso6393": "tte",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tuotomb",
		"type": "living",
		"scope": "individual",
		"iso6393": "ttf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tutong",
		"type": "living",
		"scope": "individual",
		"iso6393": "ttg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Upper Ta'oih",
		"type": "living",
		"scope": "individual",
		"iso6393": "tth",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tobati",
		"type": "living",
		"scope": "individual",
		"iso6393": "tti",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tooro",
		"type": "living",
		"scope": "individual",
		"iso6393": "ttj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Totoro",
		"type": "living",
		"scope": "individual",
		"iso6393": "ttk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Totela",
		"type": "living",
		"scope": "individual",
		"iso6393": "ttl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Tutchone",
		"type": "living",
		"scope": "individual",
		"iso6393": "ttm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Towei",
		"type": "living",
		"scope": "individual",
		"iso6393": "ttn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lower Ta'oih",
		"type": "living",
		"scope": "individual",
		"iso6393": "tto",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tombelala",
		"type": "living",
		"scope": "individual",
		"iso6393": "ttp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tawallammat Tamajaq",
		"type": "living",
		"scope": "individual",
		"iso6393": "ttq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tera",
		"type": "living",
		"scope": "individual",
		"iso6393": "ttr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northeastern Thai",
		"type": "living",
		"scope": "individual",
		"iso6393": "tts",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Muslim Tat",
		"type": "living",
		"scope": "individual",
		"iso6393": "ttt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Torau",
		"type": "living",
		"scope": "individual",
		"iso6393": "ttu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Titan",
		"type": "living",
		"scope": "individual",
		"iso6393": "ttv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Long Wat",
		"type": "living",
		"scope": "individual",
		"iso6393": "ttw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sikaritai",
		"type": "living",
		"scope": "individual",
		"iso6393": "tty",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tsum",
		"type": "living",
		"scope": "individual",
		"iso6393": "ttz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wiarumus",
		"type": "living",
		"scope": "individual",
		"iso6393": "tua",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tübatulabal",
		"type": "living",
		"scope": "individual",
		"iso6393": "tub",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mutu",
		"type": "living",
		"scope": "individual",
		"iso6393": "tuc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tuxá",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "tud",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tuyuca",
		"type": "living",
		"scope": "individual",
		"iso6393": "tue",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Central Tunebo",
		"type": "living",
		"scope": "individual",
		"iso6393": "tuf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tunia",
		"type": "living",
		"scope": "individual",
		"iso6393": "tug",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Taulil",
		"type": "living",
		"scope": "individual",
		"iso6393": "tuh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tupuri",
		"type": "living",
		"scope": "individual",
		"iso6393": "tui",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tugutil",
		"type": "living",
		"scope": "individual",
		"iso6393": "tuj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Turkmen",
		"type": "living",
		"scope": "individual",
		"iso6393": "tuk",
		"iso6392B": "tuk",
		"iso6392T": "tuk",
		"iso6391": "tk"
	},
	{
		"name": "Tula",
		"type": "living",
		"scope": "individual",
		"iso6393": "tul",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tumbuka",
		"type": "living",
		"scope": "individual",
		"iso6393": "tum",
		"iso6392B": "tum",
		"iso6392T": "tum",
		"iso6391": null
	},
	{
		"name": "Tunica",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "tun",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tucano",
		"type": "living",
		"scope": "individual",
		"iso6393": "tuo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tedaga",
		"type": "living",
		"scope": "individual",
		"iso6393": "tuq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Turkish",
		"type": "living",
		"scope": "individual",
		"iso6393": "tur",
		"iso6392B": "tur",
		"iso6392T": "tur",
		"iso6391": "tr"
	},
	{
		"name": "Tuscarora",
		"type": "living",
		"scope": "individual",
		"iso6393": "tus",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tututni",
		"type": "living",
		"scope": "individual",
		"iso6393": "tuu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Turkana",
		"type": "living",
		"scope": "individual",
		"iso6393": "tuv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tuxináwa",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "tux",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tugen",
		"type": "living",
		"scope": "individual",
		"iso6393": "tuy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Turka",
		"type": "living",
		"scope": "individual",
		"iso6393": "tuz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Vaghua",
		"type": "living",
		"scope": "individual",
		"iso6393": "tva",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tsuvadi",
		"type": "living",
		"scope": "individual",
		"iso6393": "tvd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Te'un",
		"type": "living",
		"scope": "individual",
		"iso6393": "tve",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southeast Ambrym",
		"type": "living",
		"scope": "individual",
		"iso6393": "tvk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tuvalu",
		"type": "living",
		"scope": "individual",
		"iso6393": "tvl",
		"iso6392B": "tvl",
		"iso6392T": "tvl",
		"iso6391": null
	},
	{
		"name": "Tela-Masbuar",
		"type": "living",
		"scope": "individual",
		"iso6393": "tvm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tavoyan",
		"type": "living",
		"scope": "individual",
		"iso6393": "tvn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tidore",
		"type": "living",
		"scope": "individual",
		"iso6393": "tvo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Taveta",
		"type": "living",
		"scope": "individual",
		"iso6393": "tvs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tutsa Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "tvt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tunen",
		"type": "living",
		"scope": "individual",
		"iso6393": "tvu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sedoa",
		"type": "living",
		"scope": "individual",
		"iso6393": "tvw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Timor Pidgin",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "tvy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Twana",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "twa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Tawbuid",
		"type": "living",
		"scope": "individual",
		"iso6393": "twb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Teshenawa",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "twc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Twents",
		"type": "living",
		"scope": "individual",
		"iso6393": "twd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tewa (Indonesia)",
		"type": "living",
		"scope": "individual",
		"iso6393": "twe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Tiwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "twf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tereweng",
		"type": "living",
		"scope": "individual",
		"iso6393": "twg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tai Dón",
		"type": "living",
		"scope": "individual",
		"iso6393": "twh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Twi",
		"type": "living",
		"scope": "individual",
		"iso6393": "twi",
		"iso6392B": "twi",
		"iso6392T": "twi",
		"iso6391": "tw"
	},
	{
		"name": "Tawara",
		"type": "living",
		"scope": "individual",
		"iso6393": "twl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tawang Monpa",
		"type": "living",
		"scope": "individual",
		"iso6393": "twm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Twendi",
		"type": "living",
		"scope": "individual",
		"iso6393": "twn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tswapong",
		"type": "living",
		"scope": "individual",
		"iso6393": "two",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ere",
		"type": "living",
		"scope": "individual",
		"iso6393": "twp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tasawaq",
		"type": "living",
		"scope": "individual",
		"iso6393": "twq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southwestern Tarahumara",
		"type": "living",
		"scope": "individual",
		"iso6393": "twr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Turiwára",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "twt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Termanu",
		"type": "living",
		"scope": "individual",
		"iso6393": "twu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tuwari",
		"type": "living",
		"scope": "individual",
		"iso6393": "tww",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tewe",
		"type": "living",
		"scope": "individual",
		"iso6393": "twx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tawoyan",
		"type": "living",
		"scope": "individual",
		"iso6393": "twy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tombonuo",
		"type": "living",
		"scope": "individual",
		"iso6393": "txa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tokharian B",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "txb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tsetsaut",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "txc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Totoli",
		"type": "living",
		"scope": "individual",
		"iso6393": "txe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tangut",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "txg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Thracian",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "txh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ikpeng",
		"type": "living",
		"scope": "individual",
		"iso6393": "txi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tarjumo",
		"type": "living",
		"scope": "individual",
		"iso6393": "txj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tomini",
		"type": "living",
		"scope": "individual",
		"iso6393": "txm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "West Tarangan",
		"type": "living",
		"scope": "individual",
		"iso6393": "txn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Toto",
		"type": "living",
		"scope": "individual",
		"iso6393": "txo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tii",
		"type": "living",
		"scope": "individual",
		"iso6393": "txq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tartessian",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "txr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tonsea",
		"type": "living",
		"scope": "individual",
		"iso6393": "txs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Citak",
		"type": "living",
		"scope": "individual",
		"iso6393": "txt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kayapó",
		"type": "living",
		"scope": "individual",
		"iso6393": "txu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tatana",
		"type": "living",
		"scope": "individual",
		"iso6393": "txx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tanosy Malagasy",
		"type": "living",
		"scope": "individual",
		"iso6393": "txy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tauya",
		"type": "living",
		"scope": "individual",
		"iso6393": "tya",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kyanga",
		"type": "living",
		"scope": "individual",
		"iso6393": "tye",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "O'du",
		"type": "living",
		"scope": "individual",
		"iso6393": "tyh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Teke-Tsaayi",
		"type": "living",
		"scope": "individual",
		"iso6393": "tyi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tai Do",
		"type": "living",
		"scope": "individual",
		"iso6393": "tyj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Thu Lao",
		"type": "living",
		"scope": "individual",
		"iso6393": "tyl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kombai",
		"type": "living",
		"scope": "individual",
		"iso6393": "tyn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Thaypan",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "typ",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tai Daeng",
		"type": "living",
		"scope": "individual",
		"iso6393": "tyr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tày Sa Pa",
		"type": "living",
		"scope": "individual",
		"iso6393": "tys",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tày Tac",
		"type": "living",
		"scope": "individual",
		"iso6393": "tyt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kua",
		"type": "living",
		"scope": "individual",
		"iso6393": "tyu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tuvinian",
		"type": "living",
		"scope": "individual",
		"iso6393": "tyv",
		"iso6392B": "tyv",
		"iso6392T": "tyv",
		"iso6391": null
	},
	{
		"name": "Teke-Tyee",
		"type": "living",
		"scope": "individual",
		"iso6393": "tyx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tày",
		"type": "living",
		"scope": "individual",
		"iso6393": "tyz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tanzanian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "tza",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tzeltal",
		"type": "living",
		"scope": "individual",
		"iso6393": "tzh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tz'utujil",
		"type": "living",
		"scope": "individual",
		"iso6393": "tzj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Talossan",
		"type": "constructed",
		"scope": "individual",
		"iso6393": "tzl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Central Atlas Tamazight",
		"type": "living",
		"scope": "individual",
		"iso6393": "tzm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tugun",
		"type": "living",
		"scope": "individual",
		"iso6393": "tzn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tzotzil",
		"type": "living",
		"scope": "individual",
		"iso6393": "tzo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tabriak",
		"type": "living",
		"scope": "individual",
		"iso6393": "tzx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Uamué",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "uam",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kuan",
		"type": "living",
		"scope": "individual",
		"iso6393": "uan",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tairuma",
		"type": "living",
		"scope": "individual",
		"iso6393": "uar",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ubang",
		"type": "living",
		"scope": "individual",
		"iso6393": "uba",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ubi",
		"type": "living",
		"scope": "individual",
		"iso6393": "ubi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Buhi'non Bikol",
		"type": "living",
		"scope": "individual",
		"iso6393": "ubl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ubir",
		"type": "living",
		"scope": "individual",
		"iso6393": "ubr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Umbu-Ungu",
		"type": "living",
		"scope": "individual",
		"iso6393": "ubu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ubykh",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "uby",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Uda",
		"type": "living",
		"scope": "individual",
		"iso6393": "uda",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Udihe",
		"type": "living",
		"scope": "individual",
		"iso6393": "ude",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Muduga",
		"type": "living",
		"scope": "individual",
		"iso6393": "udg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Udi",
		"type": "living",
		"scope": "individual",
		"iso6393": "udi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ujir",
		"type": "living",
		"scope": "individual",
		"iso6393": "udj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wuzlam",
		"type": "living",
		"scope": "individual",
		"iso6393": "udl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Udmurt",
		"type": "living",
		"scope": "individual",
		"iso6393": "udm",
		"iso6392B": "udm",
		"iso6392T": "udm",
		"iso6391": null
	},
	{
		"name": "Uduk",
		"type": "living",
		"scope": "individual",
		"iso6393": "udu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kioko",
		"type": "living",
		"scope": "individual",
		"iso6393": "ues",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ufim",
		"type": "living",
		"scope": "individual",
		"iso6393": "ufi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ugaritic",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "uga",
		"iso6392B": "uga",
		"iso6392T": "uga",
		"iso6391": null
	},
	{
		"name": "Kuku-Ugbanh",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ugb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ughele",
		"type": "living",
		"scope": "individual",
		"iso6393": "uge",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ugandan Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "ugn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ugong",
		"type": "living",
		"scope": "individual",
		"iso6393": "ugo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Uruguayan Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "ugy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Uhami",
		"type": "living",
		"scope": "individual",
		"iso6393": "uha",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Damal",
		"type": "living",
		"scope": "individual",
		"iso6393": "uhn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Uighur",
		"type": "living",
		"scope": "individual",
		"iso6393": "uig",
		"iso6392B": "uig",
		"iso6392T": "uig",
		"iso6391": "ug"
	},
	{
		"name": "Uisai",
		"type": "living",
		"scope": "individual",
		"iso6393": "uis",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Iyive",
		"type": "living",
		"scope": "individual",
		"iso6393": "uiv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tanjijili",
		"type": "living",
		"scope": "individual",
		"iso6393": "uji",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kaburi",
		"type": "living",
		"scope": "individual",
		"iso6393": "uka",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ukuriguma",
		"type": "living",
		"scope": "individual",
		"iso6393": "ukg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ukhwejo",
		"type": "living",
		"scope": "individual",
		"iso6393": "ukh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ukrainian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "ukl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ukpe-Bayobiri",
		"type": "living",
		"scope": "individual",
		"iso6393": "ukp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ukwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "ukq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ukrainian",
		"type": "living",
		"scope": "individual",
		"iso6393": "ukr",
		"iso6392B": "ukr",
		"iso6392T": "ukr",
		"iso6391": "uk"
	},
	{
		"name": "Urubú-Kaapor Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "uks",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ukue",
		"type": "living",
		"scope": "individual",
		"iso6393": "uku",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ukwuani-Aboh-Ndoni",
		"type": "living",
		"scope": "individual",
		"iso6393": "ukw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kuuk-Yak",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "uky",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Fungwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "ula",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ulukwumi",
		"type": "living",
		"scope": "individual",
		"iso6393": "ulb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ulch",
		"type": "living",
		"scope": "individual",
		"iso6393": "ulc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lule",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ule",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Usku",
		"type": "living",
		"scope": "individual",
		"iso6393": "ulf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ulithian",
		"type": "living",
		"scope": "individual",
		"iso6393": "uli",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Meriam",
		"type": "living",
		"scope": "individual",
		"iso6393": "ulk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ullatan",
		"type": "living",
		"scope": "individual",
		"iso6393": "ull",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ulumanda'",
		"type": "living",
		"scope": "individual",
		"iso6393": "ulm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Unserdeutsch",
		"type": "living",
		"scope": "individual",
		"iso6393": "uln",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Uma' Lung",
		"type": "living",
		"scope": "individual",
		"iso6393": "ulu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ulwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "ulw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Umatilla",
		"type": "living",
		"scope": "individual",
		"iso6393": "uma",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Umbundu",
		"type": "living",
		"scope": "individual",
		"iso6393": "umb",
		"iso6392B": "umb",
		"iso6392T": "umb",
		"iso6391": null
	},
	{
		"name": "Marrucinian",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "umc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Umbindhamu",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "umd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Umbuygamu",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "umg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ukit",
		"type": "living",
		"scope": "individual",
		"iso6393": "umi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Umon",
		"type": "living",
		"scope": "individual",
		"iso6393": "umm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Makyan Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "umn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Umotína",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "umo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Umpila",
		"type": "living",
		"scope": "individual",
		"iso6393": "ump",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Umbugarla",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "umr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pendau",
		"type": "living",
		"scope": "individual",
		"iso6393": "ums",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Munsee",
		"type": "living",
		"scope": "individual",
		"iso6393": "umu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "North Watut",
		"type": "living",
		"scope": "individual",
		"iso6393": "una",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Undetermined",
		"type": "special",
		"scope": "special",
		"iso6393": "und",
		"iso6392B": "und",
		"iso6392T": "und",
		"iso6391": null
	},
	{
		"name": "Uneme",
		"type": "living",
		"scope": "individual",
		"iso6393": "une",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngarinyin",
		"type": "living",
		"scope": "individual",
		"iso6393": "ung",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Enawené-Nawé",
		"type": "living",
		"scope": "individual",
		"iso6393": "unk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Unami",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "unm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kurnai",
		"type": "living",
		"scope": "individual",
		"iso6393": "unn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mundari",
		"type": "living",
		"scope": "individual",
		"iso6393": "unr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Unubahe",
		"type": "living",
		"scope": "individual",
		"iso6393": "unu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Munda",
		"type": "living",
		"scope": "individual",
		"iso6393": "unx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Unde Kaili",
		"type": "living",
		"scope": "individual",
		"iso6393": "unz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Umeda",
		"type": "living",
		"scope": "individual",
		"iso6393": "upi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Uripiv-Wala-Rano-Atchin",
		"type": "living",
		"scope": "individual",
		"iso6393": "upv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Urarina",
		"type": "living",
		"scope": "individual",
		"iso6393": "ura",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Urubú-Kaapor",
		"type": "living",
		"scope": "individual",
		"iso6393": "urb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Urningangg",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "urc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Urdu",
		"type": "living",
		"scope": "individual",
		"iso6393": "urd",
		"iso6392B": "urd",
		"iso6392T": "urd",
		"iso6391": "ur"
	},
	{
		"name": "Uru",
		"type": "living",
		"scope": "individual",
		"iso6393": "ure",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Uradhi",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "urf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Urigina",
		"type": "living",
		"scope": "individual",
		"iso6393": "urg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Urhobo",
		"type": "living",
		"scope": "individual",
		"iso6393": "urh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Urim",
		"type": "living",
		"scope": "individual",
		"iso6393": "uri",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Urak Lawoi'",
		"type": "living",
		"scope": "individual",
		"iso6393": "urk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Urali",
		"type": "living",
		"scope": "individual",
		"iso6393": "url",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Urapmin",
		"type": "living",
		"scope": "individual",
		"iso6393": "urm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Uruangnirin",
		"type": "living",
		"scope": "individual",
		"iso6393": "urn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ura (Papua New Guinea)",
		"type": "living",
		"scope": "individual",
		"iso6393": "uro",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Uru-Pa-In",
		"type": "living",
		"scope": "individual",
		"iso6393": "urp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lehalurup",
		"type": "living",
		"scope": "individual",
		"iso6393": "urr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Urat",
		"type": "living",
		"scope": "individual",
		"iso6393": "urt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Urumi",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "uru",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Uruava",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "urv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sop",
		"type": "living",
		"scope": "individual",
		"iso6393": "urw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Urimo",
		"type": "living",
		"scope": "individual",
		"iso6393": "urx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Orya",
		"type": "living",
		"scope": "individual",
		"iso6393": "ury",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Uru-Eu-Wau-Wau",
		"type": "living",
		"scope": "individual",
		"iso6393": "urz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Usarufa",
		"type": "living",
		"scope": "individual",
		"iso6393": "usa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ushojo",
		"type": "living",
		"scope": "individual",
		"iso6393": "ush",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Usui",
		"type": "living",
		"scope": "individual",
		"iso6393": "usi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Usaghade",
		"type": "living",
		"scope": "individual",
		"iso6393": "usk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Uspanteco",
		"type": "living",
		"scope": "individual",
		"iso6393": "usp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Uya",
		"type": "living",
		"scope": "individual",
		"iso6393": "usu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Otank",
		"type": "living",
		"scope": "individual",
		"iso6393": "uta",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ute-Southern Paiute",
		"type": "living",
		"scope": "individual",
		"iso6393": "ute",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Amba (Solomon Islands)",
		"type": "living",
		"scope": "individual",
		"iso6393": "utp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Etulo",
		"type": "living",
		"scope": "individual",
		"iso6393": "utr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Utu",
		"type": "living",
		"scope": "individual",
		"iso6393": "utu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Urum",
		"type": "living",
		"scope": "individual",
		"iso6393": "uum",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kulon-Pazeh",
		"type": "living",
		"scope": "individual",
		"iso6393": "uun",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ura (Vanuatu)",
		"type": "living",
		"scope": "individual",
		"iso6393": "uur",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "U",
		"type": "living",
		"scope": "individual",
		"iso6393": "uuu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "West Uvean",
		"type": "living",
		"scope": "individual",
		"iso6393": "uve",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Uri",
		"type": "living",
		"scope": "individual",
		"iso6393": "uvh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lote",
		"type": "living",
		"scope": "individual",
		"iso6393": "uvl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kuku-Uwanh",
		"type": "living",
		"scope": "individual",
		"iso6393": "uwa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Doko-Uyanga",
		"type": "living",
		"scope": "individual",
		"iso6393": "uya",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Uzbek",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "uzb",
		"iso6392B": "uzb",
		"iso6392T": "uzb",
		"iso6391": "uz"
	},
	{
		"name": "Northern Uzbek",
		"type": "living",
		"scope": "individual",
		"iso6393": "uzn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Uzbek",
		"type": "living",
		"scope": "individual",
		"iso6393": "uzs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Vaagri Booli",
		"type": "living",
		"scope": "individual",
		"iso6393": "vaa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Vale",
		"type": "living",
		"scope": "individual",
		"iso6393": "vae",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Vafsi",
		"type": "living",
		"scope": "individual",
		"iso6393": "vaf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Vagla",
		"type": "living",
		"scope": "individual",
		"iso6393": "vag",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Varhadi-Nagpuri",
		"type": "living",
		"scope": "individual",
		"iso6393": "vah",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Vai",
		"type": "living",
		"scope": "individual",
		"iso6393": "vai",
		"iso6392B": "vai",
		"iso6392T": "vai",
		"iso6391": null
	},
	{
		"name": "Sekele",
		"type": "living",
		"scope": "individual",
		"iso6393": "vaj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Vehes",
		"type": "living",
		"scope": "individual",
		"iso6393": "val",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Vanimo",
		"type": "living",
		"scope": "individual",
		"iso6393": "vam",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Valman",
		"type": "living",
		"scope": "individual",
		"iso6393": "van",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Vao",
		"type": "living",
		"scope": "individual",
		"iso6393": "vao",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Vaiphei",
		"type": "living",
		"scope": "individual",
		"iso6393": "vap",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Huarijio",
		"type": "living",
		"scope": "individual",
		"iso6393": "var",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Vasavi",
		"type": "living",
		"scope": "individual",
		"iso6393": "vas",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Vanuma",
		"type": "living",
		"scope": "individual",
		"iso6393": "vau",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Varli",
		"type": "living",
		"scope": "individual",
		"iso6393": "vav",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wayu",
		"type": "living",
		"scope": "individual",
		"iso6393": "vay",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southeast Babar",
		"type": "living",
		"scope": "individual",
		"iso6393": "vbb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southwestern Bontok",
		"type": "living",
		"scope": "individual",
		"iso6393": "vbk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Venetian",
		"type": "living",
		"scope": "individual",
		"iso6393": "vec",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Veddah",
		"type": "living",
		"scope": "individual",
		"iso6393": "ved",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Veluws",
		"type": "living",
		"scope": "individual",
		"iso6393": "vel",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Vemgo-Mabas",
		"type": "living",
		"scope": "individual",
		"iso6393": "vem",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Venda",
		"type": "living",
		"scope": "individual",
		"iso6393": "ven",
		"iso6392B": "ven",
		"iso6392T": "ven",
		"iso6391": "ve"
	},
	{
		"name": "Ventureño",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "veo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Veps",
		"type": "living",
		"scope": "individual",
		"iso6393": "vep",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mom Jango",
		"type": "living",
		"scope": "individual",
		"iso6393": "ver",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Vaghri",
		"type": "living",
		"scope": "individual",
		"iso6393": "vgr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Vlaamse Gebarentaal",
		"type": "living",
		"scope": "individual",
		"iso6393": "vgt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Virgin Islands Creole English",
		"type": "living",
		"scope": "individual",
		"iso6393": "vic",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Vidunda",
		"type": "living",
		"scope": "individual",
		"iso6393": "vid",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Vietnamese",
		"type": "living",
		"scope": "individual",
		"iso6393": "vie",
		"iso6392B": "vie",
		"iso6392T": "vie",
		"iso6391": "vi"
	},
	{
		"name": "Vili",
		"type": "living",
		"scope": "individual",
		"iso6393": "vif",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Viemo",
		"type": "living",
		"scope": "individual",
		"iso6393": "vig",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Vilela",
		"type": "living",
		"scope": "individual",
		"iso6393": "vil",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Vinza",
		"type": "living",
		"scope": "individual",
		"iso6393": "vin",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Vishavan",
		"type": "living",
		"scope": "individual",
		"iso6393": "vis",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Viti",
		"type": "living",
		"scope": "individual",
		"iso6393": "vit",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Iduna",
		"type": "living",
		"scope": "individual",
		"iso6393": "viv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kariyarra",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "vka",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ija-Zuba",
		"type": "living",
		"scope": "individual",
		"iso6393": "vki",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kujarge",
		"type": "living",
		"scope": "individual",
		"iso6393": "vkj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kaur",
		"type": "living",
		"scope": "individual",
		"iso6393": "vkk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kulisusu",
		"type": "living",
		"scope": "individual",
		"iso6393": "vkl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kamakan",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "vkm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kodeoha",
		"type": "living",
		"scope": "individual",
		"iso6393": "vko",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Korlai Creole Portuguese",
		"type": "living",
		"scope": "individual",
		"iso6393": "vkp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tenggarong Kutai Malay",
		"type": "living",
		"scope": "individual",
		"iso6393": "vkt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kurrama",
		"type": "living",
		"scope": "individual",
		"iso6393": "vku",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Valpei",
		"type": "living",
		"scope": "individual",
		"iso6393": "vlp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Vlaams",
		"type": "living",
		"scope": "individual",
		"iso6393": "vls",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Martuyhunira",
		"type": "living",
		"scope": "individual",
		"iso6393": "vma",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Barbaram",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "vmb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Juxtlahuaca Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "vmc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mudu Koraga",
		"type": "living",
		"scope": "individual",
		"iso6393": "vmd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "East Masela",
		"type": "living",
		"scope": "individual",
		"iso6393": "vme",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mainfränkisch",
		"type": "living",
		"scope": "individual",
		"iso6393": "vmf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lungalunga",
		"type": "living",
		"scope": "individual",
		"iso6393": "vmg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maraghei",
		"type": "living",
		"scope": "individual",
		"iso6393": "vmh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Miwa",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "vmi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ixtayutla Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "vmj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Makhuwa-Shirima",
		"type": "living",
		"scope": "individual",
		"iso6393": "vmk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Malgana",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "vml",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mitlatongo Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "vmm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Soyaltepec Mazatec",
		"type": "living",
		"scope": "individual",
		"iso6393": "vmp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Soyaltepec Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "vmq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Marenje",
		"type": "living",
		"scope": "individual",
		"iso6393": "vmr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Moksela",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "vms",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Muluridyi",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "vmu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Valley Maidu",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "vmv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Makhuwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "vmw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tamazola Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "vmx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ayautla Mazatec",
		"type": "living",
		"scope": "individual",
		"iso6393": "vmy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mazatlán Mazatec",
		"type": "living",
		"scope": "individual",
		"iso6393": "vmz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Vano",
		"type": "living",
		"scope": "individual",
		"iso6393": "vnk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Vinmavis",
		"type": "living",
		"scope": "individual",
		"iso6393": "vnm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Vunapu",
		"type": "living",
		"scope": "individual",
		"iso6393": "vnp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Volapük",
		"type": "constructed",
		"scope": "individual",
		"iso6393": "vol",
		"iso6392B": "vol",
		"iso6392T": "vol",
		"iso6391": "vo"
	},
	{
		"name": "Voro",
		"type": "living",
		"scope": "individual",
		"iso6393": "vor",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Votic",
		"type": "living",
		"scope": "individual",
		"iso6393": "vot",
		"iso6392B": "vot",
		"iso6392T": "vot",
		"iso6391": null
	},
	{
		"name": "Vera'a",
		"type": "living",
		"scope": "individual",
		"iso6393": "vra",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Võro",
		"type": "living",
		"scope": "individual",
		"iso6393": "vro",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Varisi",
		"type": "living",
		"scope": "individual",
		"iso6393": "vrs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Burmbar",
		"type": "living",
		"scope": "individual",
		"iso6393": "vrt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Moldova Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "vsi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Venezuelan Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "vsl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Valencian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "vsv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Vitou",
		"type": "living",
		"scope": "individual",
		"iso6393": "vto",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Vumbu",
		"type": "living",
		"scope": "individual",
		"iso6393": "vum",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Vunjo",
		"type": "living",
		"scope": "individual",
		"iso6393": "vun",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Vute",
		"type": "living",
		"scope": "individual",
		"iso6393": "vut",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Awa (China)",
		"type": "living",
		"scope": "individual",
		"iso6393": "vwa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Walla Walla",
		"type": "living",
		"scope": "individual",
		"iso6393": "waa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wab",
		"type": "living",
		"scope": "individual",
		"iso6393": "wab",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wasco-Wishram",
		"type": "living",
		"scope": "individual",
		"iso6393": "wac",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wandamen",
		"type": "living",
		"scope": "individual",
		"iso6393": "wad",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Walser",
		"type": "living",
		"scope": "individual",
		"iso6393": "wae",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wakoná",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "waf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wa'ema",
		"type": "living",
		"scope": "individual",
		"iso6393": "wag",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Watubela",
		"type": "living",
		"scope": "individual",
		"iso6393": "wah",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wares",
		"type": "living",
		"scope": "individual",
		"iso6393": "wai",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Waffa",
		"type": "living",
		"scope": "individual",
		"iso6393": "waj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wolaytta",
		"type": "living",
		"scope": "individual",
		"iso6393": "wal",
		"iso6392B": "wal",
		"iso6392T": "wal",
		"iso6391": null
	},
	{
		"name": "Wampanoag",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "wam",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wan",
		"type": "living",
		"scope": "individual",
		"iso6393": "wan",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wappo",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "wao",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wapishana",
		"type": "living",
		"scope": "individual",
		"iso6393": "wap",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wageman",
		"type": "living",
		"scope": "individual",
		"iso6393": "waq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Waray (Philippines)",
		"type": "living",
		"scope": "individual",
		"iso6393": "war",
		"iso6392B": "war",
		"iso6392T": "war",
		"iso6391": null
	},
	{
		"name": "Washo",
		"type": "living",
		"scope": "individual",
		"iso6393": "was",
		"iso6392B": "was",
		"iso6392T": "was",
		"iso6391": null
	},
	{
		"name": "Kaninuwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "wat",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Waurá",
		"type": "living",
		"scope": "individual",
		"iso6393": "wau",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Waka",
		"type": "living",
		"scope": "individual",
		"iso6393": "wav",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Waiwai",
		"type": "living",
		"scope": "individual",
		"iso6393": "waw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Watam",
		"type": "living",
		"scope": "individual",
		"iso6393": "wax",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wayana",
		"type": "living",
		"scope": "individual",
		"iso6393": "way",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wampur",
		"type": "living",
		"scope": "individual",
		"iso6393": "waz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Warao",
		"type": "living",
		"scope": "individual",
		"iso6393": "wba",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wabo",
		"type": "living",
		"scope": "individual",
		"iso6393": "wbb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Waritai",
		"type": "living",
		"scope": "individual",
		"iso6393": "wbe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wara",
		"type": "living",
		"scope": "individual",
		"iso6393": "wbf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wanda",
		"type": "living",
		"scope": "individual",
		"iso6393": "wbh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Vwanji",
		"type": "living",
		"scope": "individual",
		"iso6393": "wbi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Alagwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "wbj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Waigali",
		"type": "living",
		"scope": "individual",
		"iso6393": "wbk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wakhi",
		"type": "living",
		"scope": "individual",
		"iso6393": "wbl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wa",
		"type": "living",
		"scope": "individual",
		"iso6393": "wbm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Warlpiri",
		"type": "living",
		"scope": "individual",
		"iso6393": "wbp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Waddar",
		"type": "living",
		"scope": "individual",
		"iso6393": "wbq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wagdi",
		"type": "living",
		"scope": "individual",
		"iso6393": "wbr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wanman",
		"type": "living",
		"scope": "individual",
		"iso6393": "wbt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wajarri",
		"type": "living",
		"scope": "individual",
		"iso6393": "wbv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Woi",
		"type": "living",
		"scope": "individual",
		"iso6393": "wbw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yanomámi",
		"type": "living",
		"scope": "individual",
		"iso6393": "wca",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Waci Gbe",
		"type": "living",
		"scope": "individual",
		"iso6393": "wci",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wandji",
		"type": "living",
		"scope": "individual",
		"iso6393": "wdd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wadaginam",
		"type": "living",
		"scope": "individual",
		"iso6393": "wdg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wadjiginy",
		"type": "living",
		"scope": "individual",
		"iso6393": "wdj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wadikali",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "wdk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wadjigu",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "wdu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wadjabangayi",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "wdy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wewaw",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "wea",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wè Western",
		"type": "living",
		"scope": "individual",
		"iso6393": "wec",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wedau",
		"type": "living",
		"scope": "individual",
		"iso6393": "wed",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wergaia",
		"type": "living",
		"scope": "individual",
		"iso6393": "weg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Weh",
		"type": "living",
		"scope": "individual",
		"iso6393": "weh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kiunum",
		"type": "living",
		"scope": "individual",
		"iso6393": "wei",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Weme Gbe",
		"type": "living",
		"scope": "individual",
		"iso6393": "wem",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wemale",
		"type": "living",
		"scope": "individual",
		"iso6393": "weo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Westphalien",
		"type": "living",
		"scope": "individual",
		"iso6393": "wep",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Weri",
		"type": "living",
		"scope": "individual",
		"iso6393": "wer",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cameroon Pidgin",
		"type": "living",
		"scope": "individual",
		"iso6393": "wes",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Perai",
		"type": "living",
		"scope": "individual",
		"iso6393": "wet",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rawngtu Chin",
		"type": "living",
		"scope": "individual",
		"iso6393": "weu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wejewa",
		"type": "living",
		"scope": "individual",
		"iso6393": "wew",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yafi",
		"type": "living",
		"scope": "individual",
		"iso6393": "wfg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wagaya",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "wga",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wagawaga",
		"type": "living",
		"scope": "individual",
		"iso6393": "wgb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wangganguru",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "wgg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wahgi",
		"type": "living",
		"scope": "individual",
		"iso6393": "wgi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Waigeo",
		"type": "living",
		"scope": "individual",
		"iso6393": "wgo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wirangu",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "wgu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Warrgamay",
		"type": "living",
		"scope": "individual",
		"iso6393": "wgy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sou Upaa",
		"type": "living",
		"scope": "individual",
		"iso6393": "wha",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "North Wahgi",
		"type": "living",
		"scope": "individual",
		"iso6393": "whg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wahau Kenyah",
		"type": "living",
		"scope": "individual",
		"iso6393": "whk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wahau Kayan",
		"type": "living",
		"scope": "individual",
		"iso6393": "whu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Toussian",
		"type": "living",
		"scope": "individual",
		"iso6393": "wib",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wichita",
		"type": "living",
		"scope": "individual",
		"iso6393": "wic",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wik-Epa",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "wie",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wik-Keyangan",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "wif",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wik-Ngathana",
		"type": "living",
		"scope": "individual",
		"iso6393": "wig",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wik-Me'anha",
		"type": "living",
		"scope": "individual",
		"iso6393": "wih",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Minidien",
		"type": "living",
		"scope": "individual",
		"iso6393": "wii",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wik-Iiyanh",
		"type": "living",
		"scope": "individual",
		"iso6393": "wij",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wikalkan",
		"type": "living",
		"scope": "individual",
		"iso6393": "wik",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wilawila",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "wil",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wik-Mungkan",
		"type": "living",
		"scope": "individual",
		"iso6393": "wim",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ho-Chunk",
		"type": "living",
		"scope": "individual",
		"iso6393": "win",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wiraféd",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "wir",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wiru",
		"type": "living",
		"scope": "individual",
		"iso6393": "wiu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Vitu",
		"type": "living",
		"scope": "individual",
		"iso6393": "wiv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wiyot",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "wiy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Waja",
		"type": "living",
		"scope": "individual",
		"iso6393": "wja",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Warji",
		"type": "living",
		"scope": "individual",
		"iso6393": "wji",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kw'adza",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "wka",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kumbaran",
		"type": "living",
		"scope": "individual",
		"iso6393": "wkb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wakde",
		"type": "living",
		"scope": "individual",
		"iso6393": "wkd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kalanadi",
		"type": "living",
		"scope": "individual",
		"iso6393": "wkl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kunduvadi",
		"type": "living",
		"scope": "individual",
		"iso6393": "wku",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wakawaka",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "wkw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wangkayutyuru",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "wky",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Walio",
		"type": "living",
		"scope": "individual",
		"iso6393": "wla",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mwali Comorian",
		"type": "living",
		"scope": "individual",
		"iso6393": "wlc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wolane",
		"type": "living",
		"scope": "individual",
		"iso6393": "wle",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kunbarlang",
		"type": "living",
		"scope": "individual",
		"iso6393": "wlg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Waioli",
		"type": "living",
		"scope": "individual",
		"iso6393": "wli",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wailaki",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "wlk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wali (Sudan)",
		"type": "living",
		"scope": "individual",
		"iso6393": "wll",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Middle Welsh",
		"type": "historical",
		"scope": "individual",
		"iso6393": "wlm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Walloon",
		"type": "living",
		"scope": "individual",
		"iso6393": "wln",
		"iso6392B": "wln",
		"iso6392T": "wln",
		"iso6391": "wa"
	},
	{
		"name": "Wolio",
		"type": "living",
		"scope": "individual",
		"iso6393": "wlo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wailapa",
		"type": "living",
		"scope": "individual",
		"iso6393": "wlr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wallisian",
		"type": "living",
		"scope": "individual",
		"iso6393": "wls",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wuliwuli",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "wlu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wichí Lhamtés Vejoz",
		"type": "living",
		"scope": "individual",
		"iso6393": "wlv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Walak",
		"type": "living",
		"scope": "individual",
		"iso6393": "wlw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wali (Ghana)",
		"type": "living",
		"scope": "individual",
		"iso6393": "wlx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Waling",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "wly",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mawa (Nigeria)",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "wma",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wambaya",
		"type": "living",
		"scope": "individual",
		"iso6393": "wmb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wamas",
		"type": "living",
		"scope": "individual",
		"iso6393": "wmc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mamaindé",
		"type": "living",
		"scope": "individual",
		"iso6393": "wmd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wambule",
		"type": "living",
		"scope": "individual",
		"iso6393": "wme",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Waima'a",
		"type": "living",
		"scope": "individual",
		"iso6393": "wmh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wamin",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "wmi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maiwa (Indonesia)",
		"type": "living",
		"scope": "individual",
		"iso6393": "wmm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Waamwang",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "wmn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wom (Papua New Guinea)",
		"type": "living",
		"scope": "individual",
		"iso6393": "wmo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wambon",
		"type": "living",
		"scope": "individual",
		"iso6393": "wms",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Walmajarri",
		"type": "living",
		"scope": "individual",
		"iso6393": "wmt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mwani",
		"type": "living",
		"scope": "individual",
		"iso6393": "wmw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Womo",
		"type": "living",
		"scope": "individual",
		"iso6393": "wmx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wanambre",
		"type": "living",
		"scope": "individual",
		"iso6393": "wnb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wantoat",
		"type": "living",
		"scope": "individual",
		"iso6393": "wnc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wandarang",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "wnd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Waneci",
		"type": "living",
		"scope": "individual",
		"iso6393": "wne",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wanggom",
		"type": "living",
		"scope": "individual",
		"iso6393": "wng",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ndzwani Comorian",
		"type": "living",
		"scope": "individual",
		"iso6393": "wni",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wanukaka",
		"type": "living",
		"scope": "individual",
		"iso6393": "wnk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wanggamala",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "wnm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wunumara",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "wnn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wano",
		"type": "living",
		"scope": "individual",
		"iso6393": "wno",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wanap",
		"type": "living",
		"scope": "individual",
		"iso6393": "wnp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Usan",
		"type": "living",
		"scope": "individual",
		"iso6393": "wnu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wintu",
		"type": "living",
		"scope": "individual",
		"iso6393": "wnw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wanyi",
		"type": "living",
		"scope": "individual",
		"iso6393": "wny",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tyaraity",
		"type": "living",
		"scope": "individual",
		"iso6393": "woa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wè Northern",
		"type": "living",
		"scope": "individual",
		"iso6393": "wob",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wogeo",
		"type": "living",
		"scope": "individual",
		"iso6393": "woc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wolani",
		"type": "living",
		"scope": "individual",
		"iso6393": "wod",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Woleaian",
		"type": "living",
		"scope": "individual",
		"iso6393": "woe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gambian Wolof",
		"type": "living",
		"scope": "individual",
		"iso6393": "wof",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wogamusin",
		"type": "living",
		"scope": "individual",
		"iso6393": "wog",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kamang",
		"type": "living",
		"scope": "individual",
		"iso6393": "woi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Longto",
		"type": "living",
		"scope": "individual",
		"iso6393": "wok",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wolof",
		"type": "living",
		"scope": "individual",
		"iso6393": "wol",
		"iso6392B": "wol",
		"iso6392T": "wol",
		"iso6391": "wo"
	},
	{
		"name": "Wom (Nigeria)",
		"type": "living",
		"scope": "individual",
		"iso6393": "wom",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wongo",
		"type": "living",
		"scope": "individual",
		"iso6393": "won",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Manombai",
		"type": "living",
		"scope": "individual",
		"iso6393": "woo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Woria",
		"type": "living",
		"scope": "individual",
		"iso6393": "wor",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hanga Hundi",
		"type": "living",
		"scope": "individual",
		"iso6393": "wos",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wawonii",
		"type": "living",
		"scope": "individual",
		"iso6393": "wow",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Weyto",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "woy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maco",
		"type": "living",
		"scope": "individual",
		"iso6393": "wpc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Warapu",
		"type": "living",
		"scope": "individual",
		"iso6393": "wra",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Warluwara",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "wrb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Warduji",
		"type": "living",
		"scope": "individual",
		"iso6393": "wrd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Warungu",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "wrg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wiradhuri",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "wrh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wariyangga",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "wri",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Garrwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "wrk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Warlmanpa",
		"type": "living",
		"scope": "individual",
		"iso6393": "wrl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Warumungu",
		"type": "living",
		"scope": "individual",
		"iso6393": "wrm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Warnang",
		"type": "living",
		"scope": "individual",
		"iso6393": "wrn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Worrorra",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "wro",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Waropen",
		"type": "living",
		"scope": "individual",
		"iso6393": "wrp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wardaman",
		"type": "living",
		"scope": "individual",
		"iso6393": "wrr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Waris",
		"type": "living",
		"scope": "individual",
		"iso6393": "wrs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Waru",
		"type": "living",
		"scope": "individual",
		"iso6393": "wru",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Waruna",
		"type": "living",
		"scope": "individual",
		"iso6393": "wrv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gugu Warra",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "wrw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wae Rana",
		"type": "living",
		"scope": "individual",
		"iso6393": "wrx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Merwari",
		"type": "living",
		"scope": "individual",
		"iso6393": "wry",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Waray (Australia)",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "wrz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Warembori",
		"type": "living",
		"scope": "individual",
		"iso6393": "wsa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Adilabad Gondi",
		"type": "living",
		"scope": "individual",
		"iso6393": "wsg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wusi",
		"type": "living",
		"scope": "individual",
		"iso6393": "wsi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Waskia",
		"type": "living",
		"scope": "individual",
		"iso6393": "wsk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Owenia",
		"type": "living",
		"scope": "individual",
		"iso6393": "wsr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wasa",
		"type": "living",
		"scope": "individual",
		"iso6393": "wss",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wasu",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "wsu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wotapuri-Katarqalai",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "wsv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Watiwa",
		"type": "living",
		"scope": "individual",
		"iso6393": "wtf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wathawurrung",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "wth",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Berta",
		"type": "living",
		"scope": "individual",
		"iso6393": "wti",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Watakataui",
		"type": "living",
		"scope": "individual",
		"iso6393": "wtk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mewati",
		"type": "living",
		"scope": "individual",
		"iso6393": "wtm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wotu",
		"type": "living",
		"scope": "individual",
		"iso6393": "wtw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wikngenchera",
		"type": "living",
		"scope": "individual",
		"iso6393": "wua",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wunambal",
		"type": "living",
		"scope": "individual",
		"iso6393": "wub",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wudu",
		"type": "living",
		"scope": "individual",
		"iso6393": "wud",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wutunhua",
		"type": "living",
		"scope": "individual",
		"iso6393": "wuh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Silimo",
		"type": "living",
		"scope": "individual",
		"iso6393": "wul",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wumbvu",
		"type": "living",
		"scope": "individual",
		"iso6393": "wum",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bungu",
		"type": "living",
		"scope": "individual",
		"iso6393": "wun",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wurrugu",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "wur",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wutung",
		"type": "living",
		"scope": "individual",
		"iso6393": "wut",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wu Chinese",
		"type": "living",
		"scope": "individual",
		"iso6393": "wuu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wuvulu-Aua",
		"type": "living",
		"scope": "individual",
		"iso6393": "wuv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wulna",
		"type": "living",
		"scope": "individual",
		"iso6393": "wux",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wauyai",
		"type": "living",
		"scope": "individual",
		"iso6393": "wuy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Waama",
		"type": "living",
		"scope": "individual",
		"iso6393": "wwa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wakabunga",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "wwb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wetamut",
		"type": "living",
		"scope": "individual",
		"iso6393": "wwo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Warrwa",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "wwr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wawa",
		"type": "living",
		"scope": "individual",
		"iso6393": "www",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Waxianghua",
		"type": "living",
		"scope": "individual",
		"iso6393": "wxa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wardandi",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "wxw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wyandot",
		"type": "living",
		"scope": "individual",
		"iso6393": "wya",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wangaaybuwan-Ngiyambaa",
		"type": "living",
		"scope": "individual",
		"iso6393": "wyb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Woiwurrung",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "wyi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wymysorys",
		"type": "living",
		"scope": "individual",
		"iso6393": "wym",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wayoró",
		"type": "living",
		"scope": "individual",
		"iso6393": "wyr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Fijian",
		"type": "living",
		"scope": "individual",
		"iso6393": "wyy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Andalusian Arabic",
		"type": "historical",
		"scope": "individual",
		"iso6393": "xaa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sambe",
		"type": "living",
		"scope": "individual",
		"iso6393": "xab",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kachari",
		"type": "living",
		"scope": "individual",
		"iso6393": "xac",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Adai",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xad",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aequian",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xae",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aghwan",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xag",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kaimbé",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xai",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ararandewára",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xaj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Máku",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xak",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kalmyk",
		"type": "living",
		"scope": "individual",
		"iso6393": "xal",
		"iso6392B": "xal",
		"iso6392T": "xal",
		"iso6391": null
	},
	{
		"name": "/Xam",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xam",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Xamtanga",
		"type": "living",
		"scope": "individual",
		"iso6393": "xan",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Khao",
		"type": "living",
		"scope": "individual",
		"iso6393": "xao",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Apalachee",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xap",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aquitanian",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xaq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Karami",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xar",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kamas",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xas",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Katawixi",
		"type": "living",
		"scope": "individual",
		"iso6393": "xat",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kauwera",
		"type": "living",
		"scope": "individual",
		"iso6393": "xau",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Xavánte",
		"type": "living",
		"scope": "individual",
		"iso6393": "xav",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kawaiisu",
		"type": "living",
		"scope": "individual",
		"iso6393": "xaw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kayan Mahakam",
		"type": "living",
		"scope": "individual",
		"iso6393": "xay",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lower Burdekin",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xbb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bactrian",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xbc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bindal",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xbd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bigambal",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xbe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bunganditj",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xbg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kombio",
		"type": "living",
		"scope": "individual",
		"iso6393": "xbi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Birrpayi",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xbj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Middle Breton",
		"type": "historical",
		"scope": "individual",
		"iso6393": "xbm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kenaboi",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xbn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bolgarian",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xbo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bibbulman",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xbp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kambera",
		"type": "living",
		"scope": "individual",
		"iso6393": "xbr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kambiwá",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xbw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Batyala",
		"type": "living",
		"scope": "individual",
		"iso6393": "xby",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cumbric",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xcb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Camunic",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xcc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Celtiberian",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xce",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cisalpine Gaulish",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xcg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chemakum",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xch",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Classical Armenian",
		"type": "historical",
		"scope": "individual",
		"iso6393": "xcl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Comecrudo",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xcm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cotoname",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xcn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chorasmian",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xco",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Carian",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xcr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Classical Tibetan",
		"type": "historical",
		"scope": "individual",
		"iso6393": "xct",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Curonian",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xcu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chuvantsy",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xcv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Coahuilteco",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xcw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cayuse",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xcy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Darkinyung",
		"type": "living",
		"scope": "individual",
		"iso6393": "xda",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dacian",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xdc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dharuk",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xdk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Edomite",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xdm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Malayic Dayak",
		"type": "living",
		"scope": "individual",
		"iso6393": "xdy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eblan",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xeb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hdi",
		"type": "living",
		"scope": "individual",
		"iso6393": "xed",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "//Xegwi",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xeg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kelo",
		"type": "living",
		"scope": "individual",
		"iso6393": "xel",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kembayan",
		"type": "living",
		"scope": "individual",
		"iso6393": "xem",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Epi-Olmec",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xep",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Xerénte",
		"type": "living",
		"scope": "individual",
		"iso6393": "xer",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kesawai",
		"type": "living",
		"scope": "individual",
		"iso6393": "xes",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Xetá",
		"type": "living",
		"scope": "individual",
		"iso6393": "xet",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Keoru-Ahia",
		"type": "living",
		"scope": "individual",
		"iso6393": "xeu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Faliscan",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xfa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Galatian",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xga",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gbin",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xgb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gudang",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xgd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gabrielino-Fernandeño",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xgf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Goreng",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xgg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Garingbal",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xgi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Galindan",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xgl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dharumbal",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xgm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Garza",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xgr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Unggumi",
		"type": "living",
		"scope": "individual",
		"iso6393": "xgu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Guwa",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xgw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Harami",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xha",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hunnic",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xhc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hadrami",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xhd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Khetrani",
		"type": "living",
		"scope": "individual",
		"iso6393": "xhe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Xhosa",
		"type": "living",
		"scope": "individual",
		"iso6393": "xho",
		"iso6392B": "xho",
		"iso6392T": "xho",
		"iso6391": "xh"
	},
	{
		"name": "Hernican",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xhr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hattic",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xht",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hurrian",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xhu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Khua",
		"type": "living",
		"scope": "individual",
		"iso6393": "xhv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Iberian",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xib",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Xiri",
		"type": "living",
		"scope": "individual",
		"iso6393": "xii",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Illyrian",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xil",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Xinca",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xin",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Xiriâna",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xir",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kisan",
		"type": "living",
		"scope": "individual",
		"iso6393": "xis",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Indus Valley Language",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xiv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Xipaya",
		"type": "living",
		"scope": "individual",
		"iso6393": "xiy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Minjungbal",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xjb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jaitmatang",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xjt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kalkoti",
		"type": "living",
		"scope": "individual",
		"iso6393": "xka",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Nago",
		"type": "living",
		"scope": "individual",
		"iso6393": "xkb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kho'ini",
		"type": "living",
		"scope": "individual",
		"iso6393": "xkc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mendalam Kayan",
		"type": "living",
		"scope": "individual",
		"iso6393": "xkd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kereho",
		"type": "living",
		"scope": "individual",
		"iso6393": "xke",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Khengkha",
		"type": "living",
		"scope": "individual",
		"iso6393": "xkf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kagoro",
		"type": "living",
		"scope": "individual",
		"iso6393": "xkg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kenyan Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "xki",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kajali",
		"type": "living",
		"scope": "individual",
		"iso6393": "xkj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kaco'",
		"type": "living",
		"scope": "individual",
		"iso6393": "xkk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mainstream Kenyah",
		"type": "living",
		"scope": "individual",
		"iso6393": "xkl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kayan River Kayan",
		"type": "living",
		"scope": "individual",
		"iso6393": "xkn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kiorr",
		"type": "living",
		"scope": "individual",
		"iso6393": "xko",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kabatei",
		"type": "living",
		"scope": "individual",
		"iso6393": "xkp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koroni",
		"type": "living",
		"scope": "individual",
		"iso6393": "xkq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Xakriabá",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xkr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kumbewaha",
		"type": "living",
		"scope": "individual",
		"iso6393": "xks",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kantosi",
		"type": "living",
		"scope": "individual",
		"iso6393": "xkt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kaamba",
		"type": "living",
		"scope": "individual",
		"iso6393": "xku",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kgalagadi",
		"type": "living",
		"scope": "individual",
		"iso6393": "xkv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kembra",
		"type": "living",
		"scope": "individual",
		"iso6393": "xkw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Karore",
		"type": "living",
		"scope": "individual",
		"iso6393": "xkx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Uma' Lasan",
		"type": "living",
		"scope": "individual",
		"iso6393": "xky",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kurtokha",
		"type": "living",
		"scope": "individual",
		"iso6393": "xkz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kamula",
		"type": "living",
		"scope": "individual",
		"iso6393": "xla",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Loup B",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xlb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lycian",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xlc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lydian",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xld",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lemnian",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xle",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ligurian (Ancient)",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xlg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Liburnian",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xli",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Alanic",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xln",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Loup A",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xlo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lepontic",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xlp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lusitanian",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xls",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cuneiform Luwian",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xlu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Elymian",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xly",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mushungulu",
		"type": "living",
		"scope": "individual",
		"iso6393": "xma",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mbonga",
		"type": "living",
		"scope": "individual",
		"iso6393": "xmb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Makhuwa-Marrevone",
		"type": "living",
		"scope": "individual",
		"iso6393": "xmc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mbudum",
		"type": "living",
		"scope": "individual",
		"iso6393": "xmd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Median",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xme",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mingrelian",
		"type": "living",
		"scope": "individual",
		"iso6393": "xmf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mengaka",
		"type": "living",
		"scope": "individual",
		"iso6393": "xmg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kuku-Muminh",
		"type": "living",
		"scope": "individual",
		"iso6393": "xmh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Majera",
		"type": "living",
		"scope": "individual",
		"iso6393": "xmj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ancient Macedonian",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xmk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Malaysian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "xml",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Manado Malay",
		"type": "living",
		"scope": "individual",
		"iso6393": "xmm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Manichaean Middle Persian",
		"type": "historical",
		"scope": "individual",
		"iso6393": "xmn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Morerebi",
		"type": "living",
		"scope": "individual",
		"iso6393": "xmo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kuku-Mu'inh",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xmp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kuku-Mangk",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xmq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Meroitic",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xmr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Moroccan Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "xms",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Matbat",
		"type": "living",
		"scope": "individual",
		"iso6393": "xmt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kamu",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xmu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Antankarana Malagasy",
		"type": "living",
		"scope": "individual",
		"iso6393": "xmv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tsimihety Malagasy",
		"type": "living",
		"scope": "individual",
		"iso6393": "xmw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maden",
		"type": "living",
		"scope": "individual",
		"iso6393": "xmx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mayaguduna",
		"type": "living",
		"scope": "individual",
		"iso6393": "xmy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mori Bawah",
		"type": "living",
		"scope": "individual",
		"iso6393": "xmz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ancient North Arabian",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xna",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kanakanabu",
		"type": "living",
		"scope": "individual",
		"iso6393": "xnb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Middle Mongolian",
		"type": "historical",
		"scope": "individual",
		"iso6393": "xng",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kuanhua",
		"type": "living",
		"scope": "individual",
		"iso6393": "xnh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngarigu",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xni",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nganakarti",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xnk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Kankanay",
		"type": "living",
		"scope": "individual",
		"iso6393": "xnn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Anglo-Norman",
		"type": "historical",
		"scope": "individual",
		"iso6393": "xno",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kangri",
		"type": "living",
		"scope": "individual",
		"iso6393": "xnr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kanashi",
		"type": "living",
		"scope": "individual",
		"iso6393": "xns",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Narragansett",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xnt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nukunul",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xnu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyiyaparli",
		"type": "living",
		"scope": "individual",
		"iso6393": "xny",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kenzi",
		"type": "living",
		"scope": "individual",
		"iso6393": "xnz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "O'chi'chi'",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xoc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kokoda",
		"type": "living",
		"scope": "individual",
		"iso6393": "xod",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Soga",
		"type": "living",
		"scope": "individual",
		"iso6393": "xog",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kominimung",
		"type": "living",
		"scope": "individual",
		"iso6393": "xoi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Xokleng",
		"type": "living",
		"scope": "individual",
		"iso6393": "xok",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Komo (Sudan)",
		"type": "living",
		"scope": "individual",
		"iso6393": "xom",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Konkomba",
		"type": "living",
		"scope": "individual",
		"iso6393": "xon",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Xukurú",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xoo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kopar",
		"type": "living",
		"scope": "individual",
		"iso6393": "xop",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Korubo",
		"type": "living",
		"scope": "individual",
		"iso6393": "xor",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kowaki",
		"type": "living",
		"scope": "individual",
		"iso6393": "xow",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pirriya",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xpa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pecheneg",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xpc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Liberia Kpelle",
		"type": "living",
		"scope": "individual",
		"iso6393": "xpe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Phrygian",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xpg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pictish",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xpi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mpalitjanh",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xpj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kulina Pano",
		"type": "living",
		"scope": "individual",
		"iso6393": "xpk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pumpokol",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xpm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kapinawá",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xpn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pochutec",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xpo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Puyo-Paekche",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xpp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mohegan-Pequot",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xpq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Parthian",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xpr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pisidian",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xps",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Punthamara",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xpt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Punic",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xpu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Puyo",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xpy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Karakhanid",
		"type": "historical",
		"scope": "individual",
		"iso6393": "xqa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Qatabanian",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xqt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Krahô",
		"type": "living",
		"scope": "individual",
		"iso6393": "xra",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Karaboro",
		"type": "living",
		"scope": "individual",
		"iso6393": "xrb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gundungurra",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xrd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kreye",
		"type": "living",
		"scope": "individual",
		"iso6393": "xre",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Minang",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xrg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Krikati-Timbira",
		"type": "living",
		"scope": "individual",
		"iso6393": "xri",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Armazic",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xrm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Arin",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xrn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Karranga",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xrq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Raetic",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xrr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aranama-Tamique",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xrt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Marriammu",
		"type": "living",
		"scope": "individual",
		"iso6393": "xru",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Karawa",
		"type": "living",
		"scope": "individual",
		"iso6393": "xrw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sabaean",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xsa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sambal",
		"type": "living",
		"scope": "individual",
		"iso6393": "xsb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Scythian",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xsc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sidetic",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xsd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sempan",
		"type": "living",
		"scope": "individual",
		"iso6393": "xse",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Shamang",
		"type": "living",
		"scope": "individual",
		"iso6393": "xsh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sio",
		"type": "living",
		"scope": "individual",
		"iso6393": "xsi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "South Slavey",
		"type": "living",
		"scope": "individual",
		"iso6393": "xsl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kasem",
		"type": "living",
		"scope": "individual",
		"iso6393": "xsm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sanga (Nigeria)",
		"type": "living",
		"scope": "individual",
		"iso6393": "xsn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Solano",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xso",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Silopi",
		"type": "living",
		"scope": "individual",
		"iso6393": "xsp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Makhuwa-Saka",
		"type": "living",
		"scope": "individual",
		"iso6393": "xsq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sherpa",
		"type": "living",
		"scope": "individual",
		"iso6393": "xsr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Assan",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xss",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sanumá",
		"type": "living",
		"scope": "individual",
		"iso6393": "xsu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sudovian",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xsv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Saisiyat",
		"type": "living",
		"scope": "individual",
		"iso6393": "xsy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Alcozauca Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "xta",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chazumba Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "xtb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Katcha-Kadugli-Miri",
		"type": "living",
		"scope": "individual",
		"iso6393": "xtc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Diuxi-Tilantongo Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "xtd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ketengban",
		"type": "living",
		"scope": "individual",
		"iso6393": "xte",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Transalpine Gaulish",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xtg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yitha Yitha",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xth",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sinicahua Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "xti",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "San Juan Teita Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "xtj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tijaltepec Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "xtl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Magdalena Peñasco Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "xtm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Tlaxiaco Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "xtn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tokharian A",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xto",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "San Miguel Piedras Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "xtp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tumshuqese",
		"type": "historical",
		"scope": "individual",
		"iso6393": "xtq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Early Tripuri",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xtr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sindihui Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "xts",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tacahua Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "xtt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cuyamecalco Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "xtu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Thawa",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xtv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tawandê",
		"type": "living",
		"scope": "individual",
		"iso6393": "xtw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yoloxochitl Mixtec",
		"type": "living",
		"scope": "individual",
		"iso6393": "xty",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tasmanian",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xtz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Alu Kurumba",
		"type": "living",
		"scope": "individual",
		"iso6393": "xua",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Betta Kurumba",
		"type": "living",
		"scope": "individual",
		"iso6393": "xub",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Umiida",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xud",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kunigami",
		"type": "living",
		"scope": "individual",
		"iso6393": "xug",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Jennu Kurumba",
		"type": "living",
		"scope": "individual",
		"iso6393": "xuj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngunawal",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xul",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Umbrian",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xum",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Unggaranggu",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xun",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kuo",
		"type": "living",
		"scope": "individual",
		"iso6393": "xuo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Upper Umpqua",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xup",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Urartian",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xur",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kuthant",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xut",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kxoe",
		"type": "living",
		"scope": "individual",
		"iso6393": "xuu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Venetic",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xve",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kamviri",
		"type": "living",
		"scope": "individual",
		"iso6393": "xvi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Vandalic",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xvn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Volscian",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xvo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Vestinian",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xvs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kwaza",
		"type": "living",
		"scope": "individual",
		"iso6393": "xwa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Woccon",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xwc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wadi Wadi",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xwd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Xwela Gbe",
		"type": "living",
		"scope": "individual",
		"iso6393": "xwe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kwegu",
		"type": "living",
		"scope": "individual",
		"iso6393": "xwg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wajuk",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xwj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wangkumara",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xwk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Xwla Gbe",
		"type": "living",
		"scope": "individual",
		"iso6393": "xwl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Written Oirat",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xwo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kwerba Mamberamo",
		"type": "living",
		"scope": "individual",
		"iso6393": "xwr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wotjobaluk",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xwt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wemba Wemba",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xww",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Boro (Ghana)",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xxb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ke'o",
		"type": "living",
		"scope": "individual",
		"iso6393": "xxk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Minkin",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xxm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koropó",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xxr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tambora",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xxt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yaygir",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xya",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yandjibara",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xyb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mayi-Yapi",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xyj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mayi-Kulan",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xyk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yalakalore",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xyl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mayi-Thakurti",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xyt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yorta Yorta",
		"type": "living",
		"scope": "individual",
		"iso6393": "xyy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zhang-Zhung",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "xzh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zemgalian",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "xzm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ancient Zapotec",
		"type": "historical",
		"scope": "individual",
		"iso6393": "xzp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yaminahua",
		"type": "living",
		"scope": "individual",
		"iso6393": "yaa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yuhup",
		"type": "living",
		"scope": "individual",
		"iso6393": "yab",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pass Valley Yali",
		"type": "living",
		"scope": "individual",
		"iso6393": "yac",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yagua",
		"type": "living",
		"scope": "individual",
		"iso6393": "yad",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pumé",
		"type": "living",
		"scope": "individual",
		"iso6393": "yae",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yaka (Democratic Republic of Congo)",
		"type": "living",
		"scope": "individual",
		"iso6393": "yaf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yámana",
		"type": "living",
		"scope": "individual",
		"iso6393": "yag",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yazgulyam",
		"type": "living",
		"scope": "individual",
		"iso6393": "yah",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yagnobi",
		"type": "living",
		"scope": "individual",
		"iso6393": "yai",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Banda-Yangere",
		"type": "living",
		"scope": "individual",
		"iso6393": "yaj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yakama",
		"type": "living",
		"scope": "individual",
		"iso6393": "yak",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yalunka",
		"type": "living",
		"scope": "individual",
		"iso6393": "yal",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yamba",
		"type": "living",
		"scope": "individual",
		"iso6393": "yam",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mayangna",
		"type": "living",
		"scope": "individual",
		"iso6393": "yan",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yao",
		"type": "living",
		"scope": "individual",
		"iso6393": "yao",
		"iso6392B": "yao",
		"iso6392T": "yao",
		"iso6391": null
	},
	{
		"name": "Yapese",
		"type": "living",
		"scope": "individual",
		"iso6393": "yap",
		"iso6392B": "yap",
		"iso6392T": "yap",
		"iso6391": null
	},
	{
		"name": "Yaqui",
		"type": "living",
		"scope": "individual",
		"iso6393": "yaq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yabarana",
		"type": "living",
		"scope": "individual",
		"iso6393": "yar",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nugunu (Cameroon)",
		"type": "living",
		"scope": "individual",
		"iso6393": "yas",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yambeta",
		"type": "living",
		"scope": "individual",
		"iso6393": "yat",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yuwana",
		"type": "living",
		"scope": "individual",
		"iso6393": "yau",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yangben",
		"type": "living",
		"scope": "individual",
		"iso6393": "yav",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yawalapití",
		"type": "living",
		"scope": "individual",
		"iso6393": "yaw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yauma",
		"type": "living",
		"scope": "individual",
		"iso6393": "yax",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Agwagwune",
		"type": "living",
		"scope": "individual",
		"iso6393": "yay",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lokaa",
		"type": "living",
		"scope": "individual",
		"iso6393": "yaz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yala",
		"type": "living",
		"scope": "individual",
		"iso6393": "yba",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yemba",
		"type": "living",
		"scope": "individual",
		"iso6393": "ybb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "West Yugur",
		"type": "living",
		"scope": "individual",
		"iso6393": "ybe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yakha",
		"type": "living",
		"scope": "individual",
		"iso6393": "ybh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yamphu",
		"type": "living",
		"scope": "individual",
		"iso6393": "ybi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hasha",
		"type": "living",
		"scope": "individual",
		"iso6393": "ybj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bokha",
		"type": "living",
		"scope": "individual",
		"iso6393": "ybk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yukuben",
		"type": "living",
		"scope": "individual",
		"iso6393": "ybl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yaben",
		"type": "living",
		"scope": "individual",
		"iso6393": "ybm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yabaâna",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ybn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yabong",
		"type": "living",
		"scope": "individual",
		"iso6393": "ybo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yawiyo",
		"type": "living",
		"scope": "individual",
		"iso6393": "ybx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yaweyuha",
		"type": "living",
		"scope": "individual",
		"iso6393": "yby",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chesu",
		"type": "living",
		"scope": "individual",
		"iso6393": "ych",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lolopo",
		"type": "living",
		"scope": "individual",
		"iso6393": "ycl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yucuna",
		"type": "living",
		"scope": "individual",
		"iso6393": "ycn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chepya",
		"type": "living",
		"scope": "individual",
		"iso6393": "ycp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yanda",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "yda",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Yiddish",
		"type": "living",
		"scope": "individual",
		"iso6393": "ydd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yangum Dey",
		"type": "living",
		"scope": "individual",
		"iso6393": "yde",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yidgha",
		"type": "living",
		"scope": "individual",
		"iso6393": "ydg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yoidik",
		"type": "living",
		"scope": "individual",
		"iso6393": "ydk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ravula",
		"type": "living",
		"scope": "individual",
		"iso6393": "yea",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yeniche",
		"type": "living",
		"scope": "individual",
		"iso6393": "yec",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yimas",
		"type": "living",
		"scope": "individual",
		"iso6393": "yee",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yeni",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "yei",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yevanic",
		"type": "living",
		"scope": "individual",
		"iso6393": "yej",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yela",
		"type": "living",
		"scope": "individual",
		"iso6393": "yel",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tarok",
		"type": "living",
		"scope": "individual",
		"iso6393": "yer",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyankpa",
		"type": "living",
		"scope": "individual",
		"iso6393": "yes",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yetfa",
		"type": "living",
		"scope": "individual",
		"iso6393": "yet",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yerukula",
		"type": "living",
		"scope": "individual",
		"iso6393": "yeu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yapunda",
		"type": "living",
		"scope": "individual",
		"iso6393": "yev",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yeyi",
		"type": "living",
		"scope": "individual",
		"iso6393": "yey",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Malyangapa",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "yga",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yiningayi",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ygi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yangum Gel",
		"type": "living",
		"scope": "individual",
		"iso6393": "ygl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yagomi",
		"type": "living",
		"scope": "individual",
		"iso6393": "ygm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Gepo",
		"type": "living",
		"scope": "individual",
		"iso6393": "ygp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yagaria",
		"type": "living",
		"scope": "individual",
		"iso6393": "ygr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yolŋu Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "ygs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yugul",
		"type": "living",
		"scope": "individual",
		"iso6393": "ygu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yagwoia",
		"type": "living",
		"scope": "individual",
		"iso6393": "ygw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Baha Buyang",
		"type": "living",
		"scope": "individual",
		"iso6393": "yha",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Judeo-Iraqi Arabic",
		"type": "living",
		"scope": "individual",
		"iso6393": "yhd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Hlepho Phowa",
		"type": "living",
		"scope": "individual",
		"iso6393": "yhl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yan-nhaŋu Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "yhs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yinggarda",
		"type": "living",
		"scope": "individual",
		"iso6393": "yia",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yiddish",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "yid",
		"iso6392B": "yid",
		"iso6392T": "yid",
		"iso6391": "yi"
	},
	{
		"name": "Ache",
		"type": "living",
		"scope": "individual",
		"iso6393": "yif",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wusa Nasu",
		"type": "living",
		"scope": "individual",
		"iso6393": "yig",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Yiddish",
		"type": "living",
		"scope": "individual",
		"iso6393": "yih",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yidiny",
		"type": "living",
		"scope": "individual",
		"iso6393": "yii",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yindjibarndi",
		"type": "living",
		"scope": "individual",
		"iso6393": "yij",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dongshanba Lalo",
		"type": "living",
		"scope": "individual",
		"iso6393": "yik",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yindjilandji",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "yil",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yimchungru Naga",
		"type": "living",
		"scope": "individual",
		"iso6393": "yim",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yinchia",
		"type": "living",
		"scope": "individual",
		"iso6393": "yin",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Pholo",
		"type": "living",
		"scope": "individual",
		"iso6393": "yip",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Miqie",
		"type": "living",
		"scope": "individual",
		"iso6393": "yiq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "North Awyu",
		"type": "living",
		"scope": "individual",
		"iso6393": "yir",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yis",
		"type": "living",
		"scope": "individual",
		"iso6393": "yis",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Lalu",
		"type": "living",
		"scope": "individual",
		"iso6393": "yit",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Awu",
		"type": "living",
		"scope": "individual",
		"iso6393": "yiu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Nisu",
		"type": "living",
		"scope": "individual",
		"iso6393": "yiv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Axi Yi",
		"type": "living",
		"scope": "individual",
		"iso6393": "yix",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Azhe",
		"type": "living",
		"scope": "individual",
		"iso6393": "yiz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yakan",
		"type": "living",
		"scope": "individual",
		"iso6393": "yka",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Yukaghir",
		"type": "living",
		"scope": "individual",
		"iso6393": "ykg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yoke",
		"type": "living",
		"scope": "individual",
		"iso6393": "yki",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yakaikeke",
		"type": "living",
		"scope": "individual",
		"iso6393": "ykk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Khlula",
		"type": "living",
		"scope": "individual",
		"iso6393": "ykl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kap",
		"type": "living",
		"scope": "individual",
		"iso6393": "ykm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kua-nsi",
		"type": "living",
		"scope": "individual",
		"iso6393": "ykn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yasa",
		"type": "living",
		"scope": "individual",
		"iso6393": "yko",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yekora",
		"type": "living",
		"scope": "individual",
		"iso6393": "ykr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kathu",
		"type": "living",
		"scope": "individual",
		"iso6393": "ykt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kuamasi",
		"type": "living",
		"scope": "individual",
		"iso6393": "yku",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yakoma",
		"type": "living",
		"scope": "individual",
		"iso6393": "yky",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yaul",
		"type": "living",
		"scope": "individual",
		"iso6393": "yla",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yaleba",
		"type": "living",
		"scope": "individual",
		"iso6393": "ylb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yele",
		"type": "living",
		"scope": "individual",
		"iso6393": "yle",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yelogu",
		"type": "living",
		"scope": "individual",
		"iso6393": "ylg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Angguruk Yali",
		"type": "living",
		"scope": "individual",
		"iso6393": "yli",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yil",
		"type": "living",
		"scope": "individual",
		"iso6393": "yll",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Limi",
		"type": "living",
		"scope": "individual",
		"iso6393": "ylm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Langnian Buyang",
		"type": "living",
		"scope": "individual",
		"iso6393": "yln",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Naluo Yi",
		"type": "living",
		"scope": "individual",
		"iso6393": "ylo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yalarnnga",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ylr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aribwaung",
		"type": "living",
		"scope": "individual",
		"iso6393": "ylu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nyâlayu",
		"type": "living",
		"scope": "individual",
		"iso6393": "yly",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yambes",
		"type": "living",
		"scope": "individual",
		"iso6393": "ymb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Muji",
		"type": "living",
		"scope": "individual",
		"iso6393": "ymc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Muda",
		"type": "living",
		"scope": "individual",
		"iso6393": "ymd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yameo",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "yme",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yamongeri",
		"type": "living",
		"scope": "individual",
		"iso6393": "ymg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mili",
		"type": "living",
		"scope": "individual",
		"iso6393": "ymh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Moji",
		"type": "living",
		"scope": "individual",
		"iso6393": "ymi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Makwe",
		"type": "living",
		"scope": "individual",
		"iso6393": "ymk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Iamalele",
		"type": "living",
		"scope": "individual",
		"iso6393": "yml",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maay",
		"type": "living",
		"scope": "individual",
		"iso6393": "ymm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yamna",
		"type": "living",
		"scope": "individual",
		"iso6393": "ymn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yangum Mon",
		"type": "living",
		"scope": "individual",
		"iso6393": "ymo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yamap",
		"type": "living",
		"scope": "individual",
		"iso6393": "ymp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Qila Muji",
		"type": "living",
		"scope": "individual",
		"iso6393": "ymq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Malasar",
		"type": "living",
		"scope": "individual",
		"iso6393": "ymr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mysian",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "yms",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Northern Muji",
		"type": "living",
		"scope": "individual",
		"iso6393": "ymx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Muzi",
		"type": "living",
		"scope": "individual",
		"iso6393": "ymz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Aluo",
		"type": "living",
		"scope": "individual",
		"iso6393": "yna",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yandruwandha",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ynd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lang'e",
		"type": "living",
		"scope": "individual",
		"iso6393": "yne",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yango",
		"type": "living",
		"scope": "individual",
		"iso6393": "yng",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Naukan Yupik",
		"type": "living",
		"scope": "individual",
		"iso6393": "ynk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yangulam",
		"type": "living",
		"scope": "individual",
		"iso6393": "ynl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yana",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ynn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yong",
		"type": "living",
		"scope": "individual",
		"iso6393": "yno",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yendang",
		"type": "living",
		"scope": "individual",
		"iso6393": "ynq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yansi",
		"type": "living",
		"scope": "individual",
		"iso6393": "yns",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yahuna",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ynu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yoba",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "yob",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yogad",
		"type": "living",
		"scope": "individual",
		"iso6393": "yog",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yonaguni",
		"type": "living",
		"scope": "individual",
		"iso6393": "yoi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yokuts",
		"type": "living",
		"scope": "individual",
		"iso6393": "yok",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yola",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "yol",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yombe",
		"type": "living",
		"scope": "individual",
		"iso6393": "yom",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yongkom",
		"type": "living",
		"scope": "individual",
		"iso6393": "yon",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yoruba",
		"type": "living",
		"scope": "individual",
		"iso6393": "yor",
		"iso6392B": "yor",
		"iso6392T": "yor",
		"iso6391": "yo"
	},
	{
		"name": "Yotti",
		"type": "living",
		"scope": "individual",
		"iso6393": "yot",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yoron",
		"type": "living",
		"scope": "individual",
		"iso6393": "yox",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yoy",
		"type": "living",
		"scope": "individual",
		"iso6393": "yoy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Phala",
		"type": "living",
		"scope": "individual",
		"iso6393": "ypa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Labo Phowa",
		"type": "living",
		"scope": "individual",
		"iso6393": "ypb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Phola",
		"type": "living",
		"scope": "individual",
		"iso6393": "ypg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Phupha",
		"type": "living",
		"scope": "individual",
		"iso6393": "yph",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Phuma",
		"type": "living",
		"scope": "individual",
		"iso6393": "ypm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ani Phowa",
		"type": "living",
		"scope": "individual",
		"iso6393": "ypn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Alo Phola",
		"type": "living",
		"scope": "individual",
		"iso6393": "ypo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Phupa",
		"type": "living",
		"scope": "individual",
		"iso6393": "ypp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Phuza",
		"type": "living",
		"scope": "individual",
		"iso6393": "ypz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yerakai",
		"type": "living",
		"scope": "individual",
		"iso6393": "yra",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yareba",
		"type": "living",
		"scope": "individual",
		"iso6393": "yrb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yaouré",
		"type": "living",
		"scope": "individual",
		"iso6393": "yre",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nenets",
		"type": "living",
		"scope": "individual",
		"iso6393": "yrk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nhengatu",
		"type": "living",
		"scope": "individual",
		"iso6393": "yrl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yirrk-Mel",
		"type": "living",
		"scope": "individual",
		"iso6393": "yrm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yerong",
		"type": "living",
		"scope": "individual",
		"iso6393": "yrn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yaroamë",
		"type": "living",
		"scope": "individual",
		"iso6393": "yro",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yarsun",
		"type": "living",
		"scope": "individual",
		"iso6393": "yrs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yarawata",
		"type": "living",
		"scope": "individual",
		"iso6393": "yrw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yarluyandi",
		"type": "living",
		"scope": "individual",
		"iso6393": "yry",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yassic",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ysc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Samatao",
		"type": "living",
		"scope": "individual",
		"iso6393": "ysd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sonaga",
		"type": "living",
		"scope": "individual",
		"iso6393": "ysg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yugoslavian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "ysl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sani",
		"type": "living",
		"scope": "individual",
		"iso6393": "ysn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nisi (China)",
		"type": "living",
		"scope": "individual",
		"iso6393": "yso",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Lolopo",
		"type": "living",
		"scope": "individual",
		"iso6393": "ysp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sirenik Yupik",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "ysr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yessan-Mayo",
		"type": "living",
		"scope": "individual",
		"iso6393": "yss",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sanie",
		"type": "living",
		"scope": "individual",
		"iso6393": "ysy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Talu",
		"type": "living",
		"scope": "individual",
		"iso6393": "yta",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tanglang",
		"type": "living",
		"scope": "individual",
		"iso6393": "ytl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Thopho",
		"type": "living",
		"scope": "individual",
		"iso6393": "ytp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yout Wam",
		"type": "living",
		"scope": "individual",
		"iso6393": "ytw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yatay",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "yty",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yucateco",
		"type": "living",
		"scope": "individual",
		"iso6393": "yua",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yugambal",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "yub",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yuchi",
		"type": "living",
		"scope": "individual",
		"iso6393": "yuc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Judeo-Tripolitanian Arabic",
		"type": "living",
		"scope": "individual",
		"iso6393": "yud",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yue Chinese",
		"type": "living",
		"scope": "individual",
		"iso6393": "yue",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Havasupai-Walapai-Yavapai",
		"type": "living",
		"scope": "individual",
		"iso6393": "yuf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yug",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "yug",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yurutí",
		"type": "living",
		"scope": "individual",
		"iso6393": "yui",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Karkar-Yuri",
		"type": "living",
		"scope": "individual",
		"iso6393": "yuj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yuki",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "yuk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yulu",
		"type": "living",
		"scope": "individual",
		"iso6393": "yul",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Quechan",
		"type": "living",
		"scope": "individual",
		"iso6393": "yum",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bena (Nigeria)",
		"type": "living",
		"scope": "individual",
		"iso6393": "yun",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yukpa",
		"type": "living",
		"scope": "individual",
		"iso6393": "yup",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yuqui",
		"type": "living",
		"scope": "individual",
		"iso6393": "yuq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yurok",
		"type": "living",
		"scope": "individual",
		"iso6393": "yur",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yopno",
		"type": "living",
		"scope": "individual",
		"iso6393": "yut",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yau (Morobe Province)",
		"type": "living",
		"scope": "individual",
		"iso6393": "yuw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Yukaghir",
		"type": "living",
		"scope": "individual",
		"iso6393": "yux",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "East Yugur",
		"type": "living",
		"scope": "individual",
		"iso6393": "yuy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yuracare",
		"type": "living",
		"scope": "individual",
		"iso6393": "yuz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yawa",
		"type": "living",
		"scope": "individual",
		"iso6393": "yva",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yavitero",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "yvt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kalou",
		"type": "living",
		"scope": "individual",
		"iso6393": "ywa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yinhawangka",
		"type": "living",
		"scope": "individual",
		"iso6393": "ywg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Lalu",
		"type": "living",
		"scope": "individual",
		"iso6393": "ywl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yawanawa",
		"type": "living",
		"scope": "individual",
		"iso6393": "ywn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wuding-Luquan Yi",
		"type": "living",
		"scope": "individual",
		"iso6393": "ywq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yawuru",
		"type": "living",
		"scope": "individual",
		"iso6393": "ywr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Xishanba Lalo",
		"type": "living",
		"scope": "individual",
		"iso6393": "ywt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Wumeng Nasu",
		"type": "living",
		"scope": "individual",
		"iso6393": "ywu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yawarawarga",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "yww",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mayawali",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "yxa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yagara",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "yxg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yardliyawarra",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "yxl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yinwum",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "yxm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yuyu",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "yxu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yabula Yabula",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "yxy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yir Yoront",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "yyr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yau (Sandaun Province)",
		"type": "living",
		"scope": "individual",
		"iso6393": "yyu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ayizi",
		"type": "living",
		"scope": "individual",
		"iso6393": "yyz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "E'ma Buyang",
		"type": "living",
		"scope": "individual",
		"iso6393": "yzg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zokhuo",
		"type": "living",
		"scope": "individual",
		"iso6393": "yzk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sierra de Juárez Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zaa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Western Tlacolula Valley Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zab",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ocotlán Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zac",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Cajonos Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zad",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yareni Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zae",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ayoquesco Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zaf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zaghawa",
		"type": "living",
		"scope": "individual",
		"iso6393": "zag",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zangwal",
		"type": "living",
		"scope": "individual",
		"iso6393": "zah",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Isthmus Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zai",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zaramo",
		"type": "living",
		"scope": "individual",
		"iso6393": "zaj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zanaki",
		"type": "living",
		"scope": "individual",
		"iso6393": "zak",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zauzou",
		"type": "living",
		"scope": "individual",
		"iso6393": "zal",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Miahuatlán Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zam",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ozolotepec Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zao",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zapotec",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "zap",
		"iso6392B": "zap",
		"iso6392T": "zap",
		"iso6391": null
	},
	{
		"name": "Aloápam Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zaq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rincón Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zar",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Santo Domingo Albarradas Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zas",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tabaa Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zat",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zangskari",
		"type": "living",
		"scope": "individual",
		"iso6393": "zau",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yatzachi Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zav",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mitla Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zaw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Xadani Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zax",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zayse-Zergulla",
		"type": "living",
		"scope": "individual",
		"iso6393": "zay",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zari",
		"type": "living",
		"scope": "individual",
		"iso6393": "zaz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Central Berawan",
		"type": "living",
		"scope": "individual",
		"iso6393": "zbc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "East Berawan",
		"type": "living",
		"scope": "individual",
		"iso6393": "zbe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Blissymbols",
		"type": "constructed",
		"scope": "individual",
		"iso6393": "zbl",
		"iso6392B": "zbl",
		"iso6392T": "zbl",
		"iso6391": null
	},
	{
		"name": "Batui",
		"type": "living",
		"scope": "individual",
		"iso6393": "zbt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "West Berawan",
		"type": "living",
		"scope": "individual",
		"iso6393": "zbw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Coatecas Altas Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zca",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Central Hongshuihe Zhuang",
		"type": "living",
		"scope": "individual",
		"iso6393": "zch",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ngazidja Comorian",
		"type": "living",
		"scope": "individual",
		"iso6393": "zdj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zeeuws",
		"type": "living",
		"scope": "individual",
		"iso6393": "zea",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zenag",
		"type": "living",
		"scope": "individual",
		"iso6393": "zeg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Eastern Hongshuihe Zhuang",
		"type": "living",
		"scope": "individual",
		"iso6393": "zeh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zenaga",
		"type": "living",
		"scope": "individual",
		"iso6393": "zen",
		"iso6392B": "zen",
		"iso6392T": "zen",
		"iso6391": null
	},
	{
		"name": "Kinga",
		"type": "living",
		"scope": "individual",
		"iso6393": "zga",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Guibei Zhuang",
		"type": "living",
		"scope": "individual",
		"iso6393": "zgb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Standard Moroccan Tamazight",
		"type": "living",
		"scope": "individual",
		"iso6393": "zgh",
		"iso6392B": "zgh",
		"iso6392T": "zgh",
		"iso6391": null
	},
	{
		"name": "Minz Zhuang",
		"type": "living",
		"scope": "individual",
		"iso6393": "zgm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Guibian Zhuang",
		"type": "living",
		"scope": "individual",
		"iso6393": "zgn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Magori",
		"type": "living",
		"scope": "individual",
		"iso6393": "zgr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zhuang",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "zha",
		"iso6392B": "zha",
		"iso6392T": "zha",
		"iso6391": "za"
	},
	{
		"name": "Zhaba",
		"type": "living",
		"scope": "individual",
		"iso6393": "zhb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Dai Zhuang",
		"type": "living",
		"scope": "individual",
		"iso6393": "zhd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zhire",
		"type": "living",
		"scope": "individual",
		"iso6393": "zhi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Nong Zhuang",
		"type": "living",
		"scope": "individual",
		"iso6393": "zhn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chinese",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "zho",
		"iso6392B": "chi",
		"iso6392T": "zho",
		"iso6391": "zh"
	},
	{
		"name": "Zhoa",
		"type": "living",
		"scope": "individual",
		"iso6393": "zhw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zia",
		"type": "living",
		"scope": "individual",
		"iso6393": "zia",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zimbabwe Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "zib",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zimakani",
		"type": "living",
		"scope": "individual",
		"iso6393": "zik",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zialo",
		"type": "living",
		"scope": "individual",
		"iso6393": "zil",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mesme",
		"type": "living",
		"scope": "individual",
		"iso6393": "zim",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zinza",
		"type": "living",
		"scope": "individual",
		"iso6393": "zin",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Ziriya",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "zir",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zigula",
		"type": "living",
		"scope": "individual",
		"iso6393": "ziw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zizilivakan",
		"type": "living",
		"scope": "individual",
		"iso6393": "ziz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kaimbulawa",
		"type": "living",
		"scope": "individual",
		"iso6393": "zka",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koibal",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "zkb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kadu",
		"type": "living",
		"scope": "individual",
		"iso6393": "zkd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Koguryo",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "zkg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Khorezmian",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "zkh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Karankawa",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "zkk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kanan",
		"type": "living",
		"scope": "individual",
		"iso6393": "zkn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kott",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "zko",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "São Paulo Kaingáng",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "zkp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zakhring",
		"type": "living",
		"scope": "individual",
		"iso6393": "zkr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kitan",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "zkt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kaurna",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "zku",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Krevinian",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "zkv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Khazar",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "zkz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Liujiang Zhuang",
		"type": "living",
		"scope": "individual",
		"iso6393": "zlj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Malay (individual language)",
		"type": "living",
		"scope": "individual",
		"iso6393": "zlm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lianshan Zhuang",
		"type": "living",
		"scope": "individual",
		"iso6393": "zln",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Liuqian Zhuang",
		"type": "living",
		"scope": "individual",
		"iso6393": "zlq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Manda (Australia)",
		"type": "living",
		"scope": "individual",
		"iso6393": "zma",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zimba",
		"type": "living",
		"scope": "individual",
		"iso6393": "zmb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Margany",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "zmc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maridan",
		"type": "living",
		"scope": "individual",
		"iso6393": "zmd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mangerr",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "zme",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mfinu",
		"type": "living",
		"scope": "individual",
		"iso6393": "zmf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Marti Ke",
		"type": "living",
		"scope": "individual",
		"iso6393": "zmg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Makolkol",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "zmh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Negeri Sembilan Malay",
		"type": "living",
		"scope": "individual",
		"iso6393": "zmi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maridjabin",
		"type": "living",
		"scope": "individual",
		"iso6393": "zmj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mandandanyi",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "zmk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Madngele",
		"type": "living",
		"scope": "individual",
		"iso6393": "zml",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Marimanindji",
		"type": "living",
		"scope": "individual",
		"iso6393": "zmm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mbangwe",
		"type": "living",
		"scope": "individual",
		"iso6393": "zmn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Molo",
		"type": "living",
		"scope": "individual",
		"iso6393": "zmo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mpuono",
		"type": "living",
		"scope": "individual",
		"iso6393": "zmp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mituku",
		"type": "living",
		"scope": "individual",
		"iso6393": "zmq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maranunggu",
		"type": "living",
		"scope": "individual",
		"iso6393": "zmr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mbesa",
		"type": "living",
		"scope": "individual",
		"iso6393": "zms",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Maringarr",
		"type": "living",
		"scope": "individual",
		"iso6393": "zmt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Muruwari",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "zmu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mbariman-Gudhinma",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "zmv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mbo (Democratic Republic of Congo)",
		"type": "living",
		"scope": "individual",
		"iso6393": "zmw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Bomitaba",
		"type": "living",
		"scope": "individual",
		"iso6393": "zmx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mariyedi",
		"type": "living",
		"scope": "individual",
		"iso6393": "zmy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mbandja",
		"type": "living",
		"scope": "individual",
		"iso6393": "zmz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zan Gula",
		"type": "living",
		"scope": "individual",
		"iso6393": "zna",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zande (individual language)",
		"type": "living",
		"scope": "individual",
		"iso6393": "zne",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mang",
		"type": "living",
		"scope": "individual",
		"iso6393": "zng",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Manangkari",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "znk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mangas",
		"type": "living",
		"scope": "individual",
		"iso6393": "zns",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Copainalá Zoque",
		"type": "living",
		"scope": "individual",
		"iso6393": "zoc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chimalapa Zoque",
		"type": "living",
		"scope": "individual",
		"iso6393": "zoh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zou",
		"type": "living",
		"scope": "individual",
		"iso6393": "zom",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Asunción Mixtepec Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zoo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tabasco Zoque",
		"type": "living",
		"scope": "individual",
		"iso6393": "zoq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Rayón Zoque",
		"type": "living",
		"scope": "individual",
		"iso6393": "zor",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Francisco León Zoque",
		"type": "living",
		"scope": "individual",
		"iso6393": "zos",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lachiguiri Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zpa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yautepec Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zpb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Choapan Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zpc",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southeastern Ixtlán Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zpd",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Petapa Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zpe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "San Pedro Quiatoni Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zpf",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Guevea De Humboldt Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zpg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Totomachapan Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zph",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Santa María Quiegolani Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zpi",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Quiavicuzas Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zpj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tlacolulita Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zpk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lachixío Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zpl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mixtepec Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zpm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Santa Inés Yatzechi Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zpn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Amatlán Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zpo",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "El Alto Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zpp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zoogocho Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zpq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Santiago Xanica Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zpr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Coatlán Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zps",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "San Vicente Coatlán Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zpt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yalálag Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zpu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Chichicapan Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zpv",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zaniza Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zpw",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "San Baltazar Loxicha Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zpx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mazaltepec Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zpy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Texmelucan Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zpz",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Qiubei Zhuang",
		"type": "living",
		"scope": "individual",
		"iso6393": "zqe",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kara (Korea)",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "zra",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mirgan",
		"type": "living",
		"scope": "individual",
		"iso6393": "zrg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zerenkel",
		"type": "living",
		"scope": "individual",
		"iso6393": "zrn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Záparo",
		"type": "living",
		"scope": "individual",
		"iso6393": "zro",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zarphatic",
		"type": "extinct",
		"scope": "individual",
		"iso6393": "zrp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Mairasi",
		"type": "living",
		"scope": "individual",
		"iso6393": "zrs",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sarasira",
		"type": "living",
		"scope": "individual",
		"iso6393": "zsa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Kaskean",
		"type": "ancient",
		"scope": "individual",
		"iso6393": "zsk",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zambian Sign Language",
		"type": "living",
		"scope": "individual",
		"iso6393": "zsl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Standard Malay",
		"type": "living",
		"scope": "individual",
		"iso6393": "zsm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Southern Rincon Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zsr",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Sukurum",
		"type": "living",
		"scope": "individual",
		"iso6393": "zsu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Elotepec Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zte",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Xanaguía Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "ztg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Lapaguía-Guivini Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "ztl",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "San Agustín Mixtepec Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "ztm",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Santa Catarina Albarradas Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "ztn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Loxicha Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "ztp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Quioquitani-Quierí Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "ztq",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tilquiapan Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zts",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tejalapan Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "ztt",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Güilá Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "ztu",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zaachila Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "ztx",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yatee Zapotec",
		"type": "living",
		"scope": "individual",
		"iso6393": "zty",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zeem",
		"type": "living",
		"scope": "individual",
		"iso6393": "zua",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Tokano",
		"type": "living",
		"scope": "individual",
		"iso6393": "zuh",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zulu",
		"type": "living",
		"scope": "individual",
		"iso6393": "zul",
		"iso6392B": "zul",
		"iso6392T": "zul",
		"iso6391": "zu"
	},
	{
		"name": "Kumzari",
		"type": "living",
		"scope": "individual",
		"iso6393": "zum",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zuni",
		"type": "living",
		"scope": "individual",
		"iso6393": "zun",
		"iso6392B": "zun",
		"iso6392T": "zun",
		"iso6391": null
	},
	{
		"name": "Zumaya",
		"type": "living",
		"scope": "individual",
		"iso6393": "zuy",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zay",
		"type": "living",
		"scope": "individual",
		"iso6393": "zwa",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "No linguistic content",
		"type": "special",
		"scope": "special",
		"iso6393": "zxx",
		"iso6392B": "zxx",
		"iso6392T": "zxx",
		"iso6391": null
	},
	{
		"name": "Yongbei Zhuang",
		"type": "living",
		"scope": "individual",
		"iso6393": "zyb",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yang Zhuang",
		"type": "living",
		"scope": "individual",
		"iso6393": "zyg",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Youjiang Zhuang",
		"type": "living",
		"scope": "individual",
		"iso6393": "zyj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Yongnan Zhuang",
		"type": "living",
		"scope": "individual",
		"iso6393": "zyn",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zyphe Chin",
		"type": "living",
		"scope": "individual",
		"iso6393": "zyp",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	},
	{
		"name": "Zaza",
		"type": "living",
		"scope": "macrolanguage",
		"iso6393": "zza",
		"iso6392B": "zza",
		"iso6392T": "zza",
		"iso6391": null
	},
	{
		"name": "Zuojiang Zhuang",
		"type": "living",
		"scope": "individual",
		"iso6393": "zzj",
		"iso6392B": null,
		"iso6392T": null,
		"iso6391": null
	}
];

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
__webpack_require__(1324);
module.exports = self.fetch.bind(self);


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.2.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2017-03-20T18:59Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};



	function DOMEval( code, doc ) {
		doc = doc || document;

		var script = doc.createElement( "script" );

		script.text = code;
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.2.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,

	// Matches dashed string for camelizing
	rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g,

	// Used by jQuery.camelCase as callback to replace()
	fcamelCase = function( all, letter ) {
		return letter.toUpperCase();
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && Array.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isFunction: function( obj ) {
		return jQuery.type( obj ) === "function";
	},

	isWindow: function( obj ) {
		return obj != null && obj === obj.window;
	},

	isNumeric: function( obj ) {

		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&

			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {

		/* eslint-disable no-unused-vars */
		// See https://github.com/eslint/eslint/issues/6125
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	type: function( obj ) {
		if ( obj == null ) {
			return obj + "";
		}

		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		DOMEval( code );
	},

	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 13
	// Microsoft forgot to hump their vendor prefix (#9572)
	camelCase: function( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// Bind a function to a context, optionally partially applying any
	// arguments.
	proxy: function( fn, context ) {
		var tmp, args, proxy;

		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !jQuery.isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	},

	now: Date.now,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = jQuery.type( obj );

	if ( type === "function" || jQuery.isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	disabledAncestor = addCombinator(
		function( elem ) {
			return elem.disabled === true && ("form" in elem || "label" in elem);
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						disabledAncestor( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



var risSimple = /^.[^:#\[\.,]*$/;

// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( jQuery.isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Simple selector that can be filtered directly, removing non-Elements
	if ( risSimple.test( qualifier ) ) {
		return jQuery.filter( qualifier, elements, not );
	}

	// Complex selector, compare the two sets, removing non-Elements
	qualifier = jQuery.filter( qualifier, elements );
	return jQuery.grep( elements, function( elem ) {
		return ( indexOf.call( qualifier, elem ) > -1 ) !== not && elem.nodeType === 1;
	} );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( jQuery.isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( jQuery.isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
        if ( nodeName( elem, "iframe" ) ) {
            return elem.contentDocument;
        }

        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
        // Treat the template element as a regular one in browsers that
        // don't support it.
        if ( nodeName( elem, "template" ) ) {
            elem = elem.content || elem;
        }

        return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( jQuery.isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && jQuery.isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && jQuery.isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = jQuery.isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && jQuery.isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( jQuery.isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				jQuery.isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( jQuery.type( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !jQuery.isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ jQuery.camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ jQuery.camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ jQuery.camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( jQuery.camelCase );
			} else {
				key = jQuery.camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = jQuery.camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			jQuery.contains( elem.ownerDocument, elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted,
		scale = 1,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		do {

			// If previous iteration zeroed out, double until we get *something*.
			// Use string for doubling so we don't accidentally see scale as unchanged below
			scale = scale || ".5";

			// Adjust and apply
			initialInUnit = initialInUnit / scale;
			jQuery.style( elem, prop, initialInUnit + unit );

		// Update scale, tolerating zero or NaN from tween.cur()
		// Break the loop if scale is unchanged or perfect, or if we've just had enough.
		} while (
			scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
		);
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );

var rscriptType = ( /^$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( jQuery.type( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();
var documentElement = document.documentElement;



var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 only
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: jQuery.isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || jQuery.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rscriptTypeMasked = /^true\/(.*)/,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( ">tbody", elem )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	var match = rscriptTypeMasked.exec( elem.type );

	if ( match ) {
		elem.type = match[ 1 ];
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		isFunction = jQuery.isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( isFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( isFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rmargin = ( /^margin/ );

var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		div.style.cssText =
			"box-sizing:border-box;" +
			"position:relative;display:block;" +
			"margin:auto;border:1px;padding:1px;" +
			"top:1%;width:50%";
		div.innerHTML = "";
		documentElement.appendChild( container );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = divStyle.marginLeft === "2px";
		boxSizingReliableVal = divStyle.width === "4px";

		// Support: Android 4.0 - 4.3 only
		// Some styles come back with percentage values, even though they shouldn't
		div.style.marginRight = "50%";
		pixelMarginRightVal = divStyle.marginRight === "4px";

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
		"padding:0;margin-top:1px;position:absolute";
	container.appendChild( div );

	jQuery.extend( support, {
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelMarginRight: function() {
			computeStyleTests();
			return pixelMarginRightVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a property mapped along what jQuery.cssProps suggests or to
// a vendor prefixed property.
function finalPropName( name ) {
	var ret = jQuery.cssProps[ name ];
	if ( !ret ) {
		ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
	}
	return ret;
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	var i,
		val = 0;

	// If we already have the right measurement, avoid augmentation
	if ( extra === ( isBorderBox ? "border" : "content" ) ) {
		i = 4;

	// Otherwise initialize for horizontal or vertical properties
	} else {
		i = name === "width" ? 1 : 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin, so add it if we want it
		if ( extra === "margin" ) {
			val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
		}

		if ( isBorderBox ) {

			// border-box includes padding, so remove it if we want content
			if ( extra === "content" ) {
				val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// At this point, extra isn't border nor margin, so remove border
			if ( extra !== "margin" ) {
				val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		} else {

			// At this point, extra isn't content, so add padding
			val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// At this point, extra isn't content nor padding, so add border
			if ( extra !== "padding" ) {
				val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	return val;
}

function getWidthOrHeight( elem, name, extra ) {

	// Start with computed style
	var valueIsBorderBox,
		styles = getStyles( elem ),
		val = curCSS( elem, name, styles ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

	// Computed unit is not pixels. Stop here and return.
	if ( rnumnonpx.test( val ) ) {
		return val;
	}

	// Check for style in case a browser which returns unreliable values
	// for getComputedStyle silently falls back to the reliable elem.style
	valueIsBorderBox = isBorderBox &&
		( support.boxSizingReliable() || val === elem.style[ name ] );

	// Fall back to offsetWidth/Height when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	if ( val === "auto" ) {
		val = elem[ "offset" + name[ 0 ].toUpperCase() + name.slice( 1 ) ];
	}

	// Normalize "", auto, and prepare for extra
	val = parseFloat( val ) || 0;

	// Use the active box-sizing model to add/subtract irrelevant styles
	return ( val +
		augmentWidthOrHeight(
			elem,
			name,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {
		"float": "cssFloat"
	},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = jQuery.camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = jQuery.camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, name ) {
	jQuery.cssHooks[ name ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, name, extra );
						} ) :
						getWidthOrHeight( elem, name, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = extra && getStyles( elem ),
				subtract = extra && augmentWidthOrHeight(
					elem,
					name,
					extra,
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					styles
				);

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ name ] = value;
				value = jQuery.css( elem, name );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( !rmargin.test( prefix ) ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = jQuery.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 13
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = jQuery.camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( jQuery.isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					jQuery.proxy( result.stop, result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( jQuery.isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( jQuery.isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			jQuery.isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( jQuery.isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = jQuery.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://html.spec.whatwg.org/multipage/infrastructure.html#strip-and-collapse-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnothtmlwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnothtmlwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value;

		if ( typeof stateVal === "boolean" && type === "string" ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( type === "string" ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = value.match( rnothtmlwhite ) || [];

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, isFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		isFunction = jQuery.isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( isFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {

			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;
					elem[ type ]();
					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




support.focusin = "onfocusin" in window;


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = jQuery.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && jQuery.type( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = jQuery.isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( jQuery.isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 13
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available, append data to url
			if ( s.data ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( jQuery.isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( jQuery.isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var isFunction = jQuery.isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && jQuery.isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( jQuery.isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( jQuery.isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var doc, docElem, rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		rect = elem.getBoundingClientRect();

		doc = elem.ownerDocument;
		docElem = doc.documentElement;
		win = doc.defaultView;

		return {
			top: rect.top + win.pageYOffset - docElem.clientTop,
			left: rect.left + win.pageXOffset - docElem.clientLeft
		};
	},

	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
		// because it is its only offset parent
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume getBoundingClientRect is there when computed position is fixed
			offset = elem.getBoundingClientRect();

		} else {

			// Get *real* offsetParent
			offsetParent = this.offsetParent();

			// Get correct offsets
			offset = this.offset();
			if ( !nodeName( offsetParent[ 0 ], "html" ) ) {
				parentOffset = offsetParent.offset();
			}

			// Add offsetParent borders
			parentOffset = {
				top: parentOffset.top + jQuery.css( offsetParent[ 0 ], "borderTopWidth", true ),
				left: parentOffset.left + jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true )
			};
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( jQuery.isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( jQuery.isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(914);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(68)))

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(915);


/** Built-in value references. */
var getPrototype = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(386);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(911);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(60),
    root = __webpack_require__(43);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(971),
    hashDelete = __webpack_require__(972),
    hashGet = __webpack_require__(973),
    hashHas = __webpack_require__(974),
    hashSet = __webpack_require__(975);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(60),
    root = __webpack_require__(43);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(60),
    root = __webpack_require__(43);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(216),
    setCacheAdd = __webpack_require__(997),
    setCacheHas = __webpack_require__(998);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(43);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(60),
    root = __webpack_require__(43);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 925 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(950),
    isArguments = __webpack_require__(222),
    isArray = __webpack_require__(34),
    isBuffer = __webpack_require__(405),
    isIndex = __webpack_require__(218),
    isTypedArray = __webpack_require__(407);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 927 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 928 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(933),
    createBaseEach = __webpack_require__(959);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(929);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(390),
    isFlattenable = __webpack_require__(976);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(960);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(932),
    keys = __webpack_require__(108);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(390),
    isArray = __webpack_require__(34);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 935 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(106),
    isObjectLike = __webpack_require__(107);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(387),
    equalArrays = __webpack_require__(396),
    equalByTag = __webpack_require__(962),
    equalObjects = __webpack_require__(963),
    getTag = __webpack_require__(968),
    isArray = __webpack_require__(34),
    isBuffer = __webpack_require__(405),
    isTypedArray = __webpack_require__(407);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(387),
    baseIsEqual = __webpack_require__(217);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(406),
    isMasked = __webpack_require__(979),
    isObject = __webpack_require__(145),
    toSource = __webpack_require__(402);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(106),
    isLength = __webpack_require__(223),
    isObjectLike = __webpack_require__(107);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(943),
    baseMatchesProperty = __webpack_require__(944),
    identity = __webpack_require__(221),
    isArray = __webpack_require__(34),
    property = __webpack_require__(1016);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(399),
    nativeKeys = __webpack_require__(992);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(938),
    getMatchData = __webpack_require__(965),
    matchesStrictComparable = __webpack_require__(401);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(217),
    get = __webpack_require__(1011),
    hasIn = __webpack_require__(1012),
    isKey = __webpack_require__(219),
    isStrictComparable = __webpack_require__(400),
    matchesStrictComparable = __webpack_require__(401),
    toKey = __webpack_require__(142);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 945 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(393);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(221),
    overRest = __webpack_require__(996),
    setToString = __webpack_require__(1000);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(1010),
    defineProperty = __webpack_require__(395),
    identity = __webpack_require__(221);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 949 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 950 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(105),
    arrayMap = __webpack_require__(389),
    isArray = __webpack_require__(34),
    isSymbol = __webpack_require__(224);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 952 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(389);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),
/* 954 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(949);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(391),
    baseAssignValue = __webpack_require__(392);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(43);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(947),
    isIterateeCall = __webpack_require__(977);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(144);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 960 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

var castSlice = __webpack_require__(955),
    hasUnicode = __webpack_require__(398),
    stringToArray = __webpack_require__(1007),
    toString = __webpack_require__(225);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(105),
    Uint8Array = __webpack_require__(923),
    eq = __webpack_require__(143),
    equalArrays = __webpack_require__(396),
    mapToArray = __webpack_require__(990),
    setToArray = __webpack_require__(999);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(964);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(934),
    getSymbols = __webpack_require__(967),
    keys = __webpack_require__(108);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(400),
    keys = __webpack_require__(108);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(105);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(388),
    stubArray = __webpack_require__(1017);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(918),
    Map = __webpack_require__(215),
    Promise = __webpack_require__(920),
    Set = __webpack_require__(921),
    WeakMap = __webpack_require__(924),
    baseGetTag = __webpack_require__(106),
    toSource = __webpack_require__(402);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 969 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(394),
    isArguments = __webpack_require__(222),
    isArray = __webpack_require__(34),
    isIndex = __webpack_require__(218),
    isLength = __webpack_require__(223),
    toKey = __webpack_require__(142);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(141);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 972 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(141);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(141);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(141);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(105),
    isArguments = __webpack_require__(222),
    isArray = __webpack_require__(34);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(143),
    isArrayLike = __webpack_require__(144),
    isIndex = __webpack_require__(218),
    isObject = __webpack_require__(145);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 978 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(957);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 980 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(139);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(139);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(139);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(139);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(919),
    ListCache = __webpack_require__(138),
    Map = __webpack_require__(215);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(140);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(140);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(140);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(140);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 990 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(1014);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(995);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(397);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(163)(module)))

/***/ }),
/* 994 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 995 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(925);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 997 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 998 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 999 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(948),
    shortOut = __webpack_require__(1001);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 1001 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(138);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 1003 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 1004 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 1005 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(138),
    Map = __webpack_require__(215),
    MapCache = __webpack_require__(216);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(928),
    hasUnicode = __webpack_require__(398),
    unicodeToArray = __webpack_require__(1009);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(991);

/** Used to match property names within property paths. */
var reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 1009 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 1010 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(393);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(935),
    hasPath = __webpack_require__(970);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(217);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(216);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 1015 */
/***/ (function(module, exports) {

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */
function negate(predicate) {
  if (typeof predicate != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  return function() {
    var args = arguments;
    switch (args.length) {
      case 0: return !predicate.call(this);
      case 1: return !predicate.call(this, args[0]);
      case 2: return !predicate.call(this, args[0], args[1]);
      case 3: return !predicate.call(this, args[0], args[1], args[2]);
    }
    return !predicate.apply(this, args);
  };
}

module.exports = negate;


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(945),
    basePropertyDeep = __webpack_require__(946),
    isKey = __webpack_require__(219),
    toKey = __webpack_require__(142);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 1017 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 1018 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(961);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 409,
	"./af.js": 409,
	"./ar": 416,
	"./ar-dz": 410,
	"./ar-dz.js": 410,
	"./ar-kw": 411,
	"./ar-kw.js": 411,
	"./ar-ly": 412,
	"./ar-ly.js": 412,
	"./ar-ma": 413,
	"./ar-ma.js": 413,
	"./ar-sa": 414,
	"./ar-sa.js": 414,
	"./ar-tn": 415,
	"./ar-tn.js": 415,
	"./ar.js": 416,
	"./az": 417,
	"./az.js": 417,
	"./be": 418,
	"./be.js": 418,
	"./bg": 419,
	"./bg.js": 419,
	"./bm": 420,
	"./bm.js": 420,
	"./bn": 421,
	"./bn.js": 421,
	"./bo": 422,
	"./bo.js": 422,
	"./br": 423,
	"./br.js": 423,
	"./bs": 424,
	"./bs.js": 424,
	"./ca": 425,
	"./ca.js": 425,
	"./cs": 426,
	"./cs.js": 426,
	"./cv": 427,
	"./cv.js": 427,
	"./cy": 428,
	"./cy.js": 428,
	"./da": 429,
	"./da.js": 429,
	"./de": 432,
	"./de-at": 430,
	"./de-at.js": 430,
	"./de-ch": 431,
	"./de-ch.js": 431,
	"./de.js": 432,
	"./dv": 433,
	"./dv.js": 433,
	"./el": 434,
	"./el.js": 434,
	"./en-au": 435,
	"./en-au.js": 435,
	"./en-ca": 436,
	"./en-ca.js": 436,
	"./en-gb": 437,
	"./en-gb.js": 437,
	"./en-ie": 438,
	"./en-ie.js": 438,
	"./en-nz": 439,
	"./en-nz.js": 439,
	"./eo": 440,
	"./eo.js": 440,
	"./es": 443,
	"./es-do": 441,
	"./es-do.js": 441,
	"./es-us": 442,
	"./es-us.js": 442,
	"./es.js": 443,
	"./et": 444,
	"./et.js": 444,
	"./eu": 445,
	"./eu.js": 445,
	"./fa": 446,
	"./fa.js": 446,
	"./fi": 447,
	"./fi.js": 447,
	"./fo": 448,
	"./fo.js": 448,
	"./fr": 451,
	"./fr-ca": 449,
	"./fr-ca.js": 449,
	"./fr-ch": 450,
	"./fr-ch.js": 450,
	"./fr.js": 451,
	"./fy": 452,
	"./fy.js": 452,
	"./gd": 453,
	"./gd.js": 453,
	"./gl": 454,
	"./gl.js": 454,
	"./gom-latn": 455,
	"./gom-latn.js": 455,
	"./gu": 456,
	"./gu.js": 456,
	"./he": 457,
	"./he.js": 457,
	"./hi": 458,
	"./hi.js": 458,
	"./hr": 459,
	"./hr.js": 459,
	"./hu": 460,
	"./hu.js": 460,
	"./hy-am": 461,
	"./hy-am.js": 461,
	"./id": 462,
	"./id.js": 462,
	"./is": 463,
	"./is.js": 463,
	"./it": 464,
	"./it.js": 464,
	"./ja": 465,
	"./ja.js": 465,
	"./jv": 466,
	"./jv.js": 466,
	"./ka": 467,
	"./ka.js": 467,
	"./kk": 468,
	"./kk.js": 468,
	"./km": 469,
	"./km.js": 469,
	"./kn": 470,
	"./kn.js": 470,
	"./ko": 471,
	"./ko.js": 471,
	"./ky": 472,
	"./ky.js": 472,
	"./lb": 473,
	"./lb.js": 473,
	"./lo": 474,
	"./lo.js": 474,
	"./lt": 475,
	"./lt.js": 475,
	"./lv": 476,
	"./lv.js": 476,
	"./me": 477,
	"./me.js": 477,
	"./mi": 478,
	"./mi.js": 478,
	"./mk": 479,
	"./mk.js": 479,
	"./ml": 480,
	"./ml.js": 480,
	"./mr": 481,
	"./mr.js": 481,
	"./ms": 483,
	"./ms-my": 482,
	"./ms-my.js": 482,
	"./ms.js": 483,
	"./mt": 484,
	"./mt.js": 484,
	"./my": 485,
	"./my.js": 485,
	"./nb": 486,
	"./nb.js": 486,
	"./ne": 487,
	"./ne.js": 487,
	"./nl": 489,
	"./nl-be": 488,
	"./nl-be.js": 488,
	"./nl.js": 489,
	"./nn": 490,
	"./nn.js": 490,
	"./pa-in": 491,
	"./pa-in.js": 491,
	"./pl": 492,
	"./pl.js": 492,
	"./pt": 494,
	"./pt-br": 493,
	"./pt-br.js": 493,
	"./pt.js": 494,
	"./ro": 495,
	"./ro.js": 495,
	"./ru": 496,
	"./ru.js": 496,
	"./sd": 497,
	"./sd.js": 497,
	"./se": 498,
	"./se.js": 498,
	"./si": 499,
	"./si.js": 499,
	"./sk": 500,
	"./sk.js": 500,
	"./sl": 501,
	"./sl.js": 501,
	"./sq": 502,
	"./sq.js": 502,
	"./sr": 504,
	"./sr-cyrl": 503,
	"./sr-cyrl.js": 503,
	"./sr.js": 504,
	"./ss": 505,
	"./ss.js": 505,
	"./sv": 506,
	"./sv.js": 506,
	"./sw": 507,
	"./sw.js": 507,
	"./ta": 508,
	"./ta.js": 508,
	"./te": 509,
	"./te.js": 509,
	"./tet": 510,
	"./tet.js": 510,
	"./th": 511,
	"./th.js": 511,
	"./tl-ph": 512,
	"./tl-ph.js": 512,
	"./tlh": 513,
	"./tlh.js": 513,
	"./tr": 514,
	"./tr.js": 514,
	"./tzl": 515,
	"./tzl.js": 515,
	"./tzm": 517,
	"./tzm-latn": 516,
	"./tzm-latn.js": 516,
	"./tzm.js": 517,
	"./uk": 518,
	"./uk.js": 518,
	"./ur": 519,
	"./ur.js": 519,
	"./uz": 521,
	"./uz-latn": 520,
	"./uz-latn.js": 520,
	"./uz.js": 521,
	"./vi": 522,
	"./vi.js": 522,
	"./x-pseudo": 523,
	"./x-pseudo.js": 523,
	"./yo": 524,
	"./yo.js": 524,
	"./zh-cn": 525,
	"./zh-cn.js": 525,
	"./zh-hk": 526,
	"./zh-hk.js": 526,
	"./zh-tw": 527,
	"./zh-tw.js": 527
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1020;

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(1022)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 1022 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function isLinkToSubmitParent(element) {
  var isLinkTag = element.tagName === 'A';
  var shouldSubmitParent = element.getAttribute('data-submit') === 'parent';

  return isLinkTag && shouldSubmitParent;
}

function getClosestForm(element) {
  while (element && element !== document && element.nodeType === Node.ELEMENT_NODE) {
    if (element.tagName === 'FORM') {
      return element;
    }
    element = element.parentNode;
  }
  return null;
}

function didHandleSubmitLinkClick(element) {
  while (element && element.getAttribute) {
    if (isLinkToSubmitParent(element)) {
      var message = element.getAttribute('data-confirm');
      if (message === null || confirm(message)) {
        getClosestForm(element).submit();
      }
      return true;
    } else {
      element = element.parentNode;
    }
  }
  return false;
}

window.addEventListener('click', function (event) {
  if (event.target && didHandleSubmitLinkClick(event.target)) {
    event.preventDefault();
    return false;
  }
}, false);



/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



if (false) {
  var invariant = require('fbjs/lib/invariant');
  var warning = require('fbjs/lib/warning');
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(30);
var invariant = __webpack_require__(4);
var ReactPropTypesSecret = __webpack_require__(529);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(30);
var invariant = __webpack_require__(4);
var warning = __webpack_require__(6);

var ReactPropTypesSecret = __webpack_require__(529);
var checkPropTypes = __webpack_require__(1024);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(1316);
var objectAssign = __webpack_require__(10);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(109)))

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = {
  Properties: {
    // Global States and Properties
    'aria-current': 0, // state
    'aria-details': 0,
    'aria-disabled': 0, // state
    'aria-hidden': 0, // state
    'aria-invalid': 0, // state
    'aria-keyshortcuts': 0,
    'aria-label': 0,
    'aria-roledescription': 0,
    // Widget Attributes
    'aria-autocomplete': 0,
    'aria-checked': 0,
    'aria-expanded': 0,
    'aria-haspopup': 0,
    'aria-level': 0,
    'aria-modal': 0,
    'aria-multiline': 0,
    'aria-multiselectable': 0,
    'aria-orientation': 0,
    'aria-placeholder': 0,
    'aria-pressed': 0,
    'aria-readonly': 0,
    'aria-required': 0,
    'aria-selected': 0,
    'aria-sort': 0,
    'aria-valuemax': 0,
    'aria-valuemin': 0,
    'aria-valuenow': 0,
    'aria-valuetext': 0,
    // Live Region Attributes
    'aria-atomic': 0,
    'aria-busy': 0,
    'aria-live': 0,
    'aria-relevant': 0,
    // Drag-and-Drop Attributes
    'aria-dropeffect': 0,
    'aria-grabbed': 0,
    // Relationship Attributes
    'aria-activedescendant': 0,
    'aria-colcount': 0,
    'aria-colindex': 0,
    'aria-colspan': 0,
    'aria-controls': 0,
    'aria-describedby': 0,
    'aria-errormessage': 0,
    'aria-flowto': 0,
    'aria-labelledby': 0,
    'aria-owns': 0,
    'aria-posinset': 0,
    'aria-rowcount': 0,
    'aria-rowindex': 0,
    'aria-rowspan': 0,
    'aria-setsize': 0
  },
  DOMAttributeNames: {},
  DOMPropertyNames: {}
};

module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentTree = __webpack_require__(15);

var focusNode = __webpack_require__(380);

var AutoFocusUtils = {
  focusDOMComponent: function () {
    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
  }
};

module.exports = AutoFocusUtils;

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(111);
var ExecutionEnvironment = __webpack_require__(26);
var FallbackCompositionState = __webpack_require__(1037);
var SyntheticCompositionEvent = __webpack_require__(1074);
var SyntheticInputEvent = __webpack_require__(1077);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: 'onBeforeInput',
      captured: 'onBeforeInputCapture'
    },
    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionEnd',
      captured: 'onCompositionEndCapture'
    },
    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionStart',
      captured: 'onCompositionStartCapture'
    },
    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionUpdate',
      captured: 'onCompositionUpdateCapture'
    },
    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case 'topCompositionStart':
      return eventTypes.compositionStart;
    case 'topCompositionEnd':
      return eventTypes.compositionEnd;
    case 'topCompositionUpdate':
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topKeyUp':
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case 'topKeyDown':
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case 'topKeyPress':
    case 'topMouseDown':
    case 'topBlur':
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topCompositionEnd':
      return getDataFromCustomEvent(nativeEvent);
    case 'topKeyPress':
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case 'topTextInput':
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (currentComposition) {
    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case 'topPaste':
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case 'topKeyPress':
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case 'topCompositionEnd':
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {

  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(530);
var ExecutionEnvironment = __webpack_require__(26);
var ReactInstrumentation = __webpack_require__(32);

var camelizeStyleName = __webpack_require__(893);
var dangerousStyleValue = __webpack_require__(1083);
var hyphenateStyleName = __webpack_require__(900);
var memoizeStringOnly = __webpack_require__(903);
var warning = __webpack_require__(6);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function (name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function (name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function (owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function (name, value, component) {
    var owner;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {

  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */
  createMarkupForStyles: function (styles, component) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var styleValue = styles[styleName];
      if (false) {
        warnValidStyle(styleName, styleValue, component);
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */
  setValueForStyles: function (node, styles, component) {
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: component._debugID,
        type: 'update styles',
        payload: styles
      });
    }

    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      if (false) {
        warnValidStyle(styleName, styles[styleName], component);
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
      if (styleName === 'float' || styleName === 'cssFloat') {
        styleName = styleFloatAccessor;
      }
      if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }

};

module.exports = CSSPropertyOperations;

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(110);
var EventPropagators = __webpack_require__(111);
var ExecutionEnvironment = __webpack_require__(26);
var ReactDOMComponentTree = __webpack_require__(15);
var ReactUpdates = __webpack_require__(35);
var SyntheticEvent = __webpack_require__(44);

var getEventTarget = __webpack_require__(238);
var isEventSupported = __webpack_require__(239);
var isTextInputElement = __webpack_require__(547);

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: 'onChange',
      captured: 'onChangeCapture'
    },
    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
  }
};

/**
 * For IE shims
 */
var activeElement = null;
var activeElementInst = null;
var activeElementValue = null;
var activeElementValueProp = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
  EventPropagators.accumulateTwoPhaseDispatches(event);

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementInst = null;
}

function getTargetInstForChangeEvent(topLevelType, targetInst) {
  if (topLevelType === 'topChange') {
    return targetInst;
  }
}
function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.
  // IE10+ fire input events to often, such when a placeholder
  // changes or when an input with a placeholder is focused.
  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 11);
}

/**
 * (For IE <=11) Replacement getter/setter for the `value` property that gets
 * set on the active element.
 */
var newValueProp = {
  get: function () {
    return activeElementValueProp.get.call(this);
  },
  set: function (val) {
    // Cast to a string so we can do equality checks.
    activeElementValue = '' + val;
    activeElementValueProp.set.call(this, val);
  }
};

/**
 * (For IE <=11) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElementValue = target.value;
  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');

  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
  // on DOM elements
  Object.defineProperty(activeElement, 'value', newValueProp);
  if (activeElement.attachEvent) {
    activeElement.attachEvent('onpropertychange', handlePropertyChange);
  } else {
    activeElement.addEventListener('propertychange', handlePropertyChange, false);
  }
}

/**
 * (For IE <=11) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }

  // delete restores the original property definition
  delete activeElement.value;

  if (activeElement.detachEvent) {
    activeElement.detachEvent('onpropertychange', handlePropertyChange);
  } else {
    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
  }

  activeElement = null;
  activeElementInst = null;
  activeElementValue = null;
  activeElementValueProp = null;
}

/**
 * (For IE <=11) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  var value = nativeEvent.srcElement.value;
  if (value === activeElementValue) {
    return;
  }
  activeElementValue = value;

  manualDispatchChangeEvent(nativeEvent);
}

/**
 * If a `change` event should be fired, returns the target's ID.
 */
function getTargetInstForInputEvent(topLevelType, targetInst) {
  if (topLevelType === 'topInput') {
    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
    // what we want so fall through here and trigger an abstract event
    return targetInst;
  }
}

function handleEventsForInputEventIE(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9-11, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetInstForInputEventIE(topLevelType, targetInst) {
  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    if (activeElement && activeElement.value !== activeElementValue) {
      activeElementValue = activeElement.value;
      return activeElementInst;
    }
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(topLevelType, targetInst) {
  if (topLevelType === 'topClick') {
    return targetInst;
  }
}

function handleControlledInputBlur(inst, node) {
  // TODO: In IE, inst is occasionally null. Why?
  if (inst == null) {
    return;
  }

  // Fiber and ReactDOM keep wrapper state in separate places
  var state = inst._wrapperState || node._wrapperState;

  if (!state || !state.controlled || node.type !== 'number') {
    return;
  }

  // If controlled, assign the value attribute to the current value on blur
  var value = '' + node.value;
  if (node.getAttribute('value') !== value) {
    node.setAttribute('value', value);
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {

  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    var getTargetInstFunc, handleEventFunc;
    if (shouldUseChangeEvent(targetNode)) {
      if (doesChangeEventBubble) {
        getTargetInstFunc = getTargetInstForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(targetNode)) {
      if (isInputEventSupported) {
        getTargetInstFunc = getTargetInstForInputEvent;
      } else {
        getTargetInstFunc = getTargetInstForInputEventIE;
        handleEventFunc = handleEventsForInputEventIE;
      }
    } else if (shouldUseClickEvent(targetNode)) {
      getTargetInstFunc = getTargetInstForClickEvent;
    }

    if (getTargetInstFunc) {
      var inst = getTargetInstFunc(topLevelType, targetInst);
      if (inst) {
        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
        event.type = 'change';
        EventPropagators.accumulateTwoPhaseDispatches(event);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, targetNode, targetInst);
    }

    // When blurring, set the value attribute for number inputs
    if (topLevelType === 'topBlur') {
      handleControlledInputBlur(targetInst, targetNode);
    }
  }

};

module.exports = ChangeEventPlugin;

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var DOMLazyTree = __webpack_require__(78);
var ExecutionEnvironment = __webpack_require__(26);

var createNodesFromMarkup = __webpack_require__(896);
var emptyFunction = __webpack_require__(30);
var invariant = __webpack_require__(4);

var Danger = {

  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;

    if (typeof markup === 'string') {
      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
      oldChild.parentNode.replaceChild(newChild, oldChild);
    } else {
      DOMLazyTree.replaceChildWithTree(oldChild, markup);
    }
  }

};

module.exports = Danger;

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */

var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];

module.exports = DefaultEventPluginOrder;

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(111);
var ReactDOMComponentTree = __webpack_require__(15);
var SyntheticMouseEvent = __webpack_require__(148);

var eventTypes = {
  mouseEnter: {
    registrationName: 'onMouseEnter',
    dependencies: ['topMouseOut', 'topMouseOver']
  },
  mouseLeave: {
    registrationName: 'onMouseLeave',
    dependencies: ['topMouseOut', 'topMouseOver']
  }
};

var EnterLeaveEventPlugin = {

  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (nativeEventTarget.window === nativeEventTarget) {
      // `nativeEventTarget` is probably a window object.
      win = nativeEventTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = nativeEventTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    if (topLevelType === 'topMouseOut') {
      from = targetInst;
      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
    } else {
      // Moving to a node from outside the window.
      from = null;
      to = targetInst;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = fromNode;
    leave.relatedTarget = toNode;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = toNode;
    enter.relatedTarget = fromNode;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);

    return [leave, enter];
  }

};

module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(10);

var PooledClass = __webpack_require__(61);

var getTextContentAccessor = __webpack_require__(545);

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

_assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(79);

var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
  Properties: {
    /**
     * Standard Properties
     */
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: HAS_BOOLEAN_VALUE,
    allowTransparency: 0,
    alt: 0,
    // specifies target context for links with `preload` type
    as: 0,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: 0,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: HAS_BOOLEAN_VALUE,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    cite: 0,
    classID: 0,
    className: 0,
    cols: HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: HAS_BOOLEAN_VALUE,
    coords: 0,
    crossOrigin: 0,
    data: 0, // For `<object />` acts as `src`.
    dateTime: 0,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: 0,
    disabled: HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: HAS_BOOLEAN_VALUE,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: HAS_BOOLEAN_VALUE,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    // Caution; `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`.
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: 0,
    nonce: 0,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: HAS_BOOLEAN_VALUE,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: HAS_BOOLEAN_VALUE,
    referrerPolicy: 0,
    rel: 0,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: 0,
    rows: HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: HAS_NUMERIC_VALUE,
    sandbox: 0,
    scope: 0,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: 0,
    seamless: HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: 0,
    size: HAS_POSITIVE_NUMERIC_VALUE,
    sizes: 0,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: HAS_NUMERIC_VALUE,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    // Setting .type throws on non-<input> tags
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,

    /**
     * RDFa Properties
     */
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    // property is also supported for OpenGraph in meta tags.
    property: 0,
    resource: 0,
    'typeof': 0,
    vocab: 0,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: 0,
    autoCorrect: 0,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: 0,
    // color is for Safari mask-icon link
    color: 0,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: 0,
    itemScope: HAS_BOOLEAN_VALUE,
    itemType: 0,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: 0,
    itemRef: 0,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: 0,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: 0,
    // IE-only attribute that controls focus behavior
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {},
  DOMMutationMethods: {
    value: function (node, value) {
      if (value == null) {
        return node.removeAttribute('value');
      }

      // Number inputs get special treatment due to some edge cases in
      // Chrome. Let everything else assign the value attribute as normal.
      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
      if (node.type !== 'number' || node.hasAttribute('value') === false) {
        node.setAttribute('value', '' + value);
      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
        // Don't assign an attribute if validation reports bad
        // input. Chrome will clear the value. Additionally, don't
        // operate on inputs that have focus, otherwise Chrome might
        // strip off trailing decimal places and cause the user's
        // cursor position to jump to the beginning of the input.
        //
        // In ReactDOMInput, we have an onBlur event that will trigger
        // this function again when focus is lost.
        node.setAttribute('value', '' + value);
      }
    }
  }
};

module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactReconciler = __webpack_require__(80);

var instantiateReactComponent = __webpack_require__(546);
var KeyEscapeUtils = __webpack_require__(230);
var shouldUpdateReactComponent = __webpack_require__(240);
var traverseAllChildren = __webpack_require__(549);
var warning = __webpack_require__(6);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && process.env && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(622);
}

function instantiateChild(childInstances, child, name, selfDebugID) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (false) {
    if (!ReactComponentTreeHook) {
      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
    }
    if (!keyUnique) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
    }
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, true);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
  ) {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};

    if (false) {
      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
        return instantiateChild(childInsts, child, name, selfDebugID);
      }, childInstances);
    } else {
      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    }
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
  ) {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return;
    }
    var name;
    var prevChild;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
          ReactReconciler.unmountComponent(prevChild, false);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, true);
        nextChildren[name] = nextChildInstance;
        // Creating mount image now ensures refs are resolved in right order
        // (see https://github.com/facebook/react/pull/7101 for explanation).
        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
        mountImages.push(nextChildMountImage);
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        prevChild = prevChildren[name];
        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
        ReactReconciler.unmountComponent(prevChild, false);
      }
    }
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren, safely) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild, safely);
      }
    }
  }

};

module.exports = ReactChildReconciler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(109)))

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(226);
var ReactDOMIDOperations = __webpack_require__(1047);

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {

  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup

};

module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7),
    _assign = __webpack_require__(10);

var React = __webpack_require__(85);
var ReactComponentEnvironment = __webpack_require__(232);
var ReactCurrentOwner = __webpack_require__(48);
var ReactErrorUtils = __webpack_require__(233);
var ReactInstanceMap = __webpack_require__(112);
var ReactInstrumentation = __webpack_require__(32);
var ReactNodeTypes = __webpack_require__(540);
var ReactReconciler = __webpack_require__(80);

if (false) {
  var checkReactTypeSpec = require('./checkReactTypeSpec');
}

var emptyObject = __webpack_require__(74);
var invariant = __webpack_require__(4);
var shallowEqual = __webpack_require__(211);
var shouldUpdateReactComponent = __webpack_require__(240);
var warning = __webpack_require__(6);

var CompositeTypes = {
  ImpureClass: 0,
  PureClass: 1,
  StatelessFunctional: 2
};

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  var element = Component(this.props, this.context, this.updater);
  warnIfInvalidElement(Component, element);
  return element;
};

function warnIfInvalidElement(Component, element) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
  }
}

function shouldConstruct(Component) {
  return !!(Component.prototype && Component.prototype.isReactComponent);
}

function isPureComponent(Component) {
  return !!(Component.prototype && Component.prototype.isPureReactComponent);
}

// Separated into a function to contain deoptimizations caused by try/finally.
function measureLifeCyclePerf(fn, debugID, timerType) {
  if (debugID === 0) {
    // Top-level wrappers (see ReactMount) and empty components (see
    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
    // Both are implementation details that should go away in the future.
    return fn();
  }

  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
  try {
    return fn();
  } finally {
    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
  }
}

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponent = {

  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = 0;
    this._compositeType = null;
    this._instance = null;
    this._hostParent = null;
    this._hostContainerInfo = null;

    // See ReactUpdateQueue
    this._updateBatchNumber = null;
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedNodeType = null;
    this._renderedComponent = null;
    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;

    // ComponentWillUnmount shall only be called once
    this._calledComponentWillUnmount = false;

    if (false) {
      this._warnedAboutRefsInRender = false;
    }
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} hostParent
   * @param {?object} hostContainerInfo
   * @param {?object} context
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var _this = this;

    this._context = context;
    this._mountOrder = nextMountID++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var publicProps = this._currentElement.props;
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    var updateQueue = transaction.getUpdateQueue();

    // Initialize the public class
    var doConstruct = shouldConstruct(Component);
    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
    var renderedElement;

    // Support functional components
    if (!doConstruct && (inst == null || inst.render == null)) {
      renderedElement = inst;
      warnIfInvalidElement(Component, renderedElement);
      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
      inst = new StatelessComponent(Component);
      this._compositeType = CompositeTypes.StatelessFunctional;
    } else {
      if (isPureComponent(Component)) {
        this._compositeType = CompositeTypes.PureClass;
      } else {
        this._compositeType = CompositeTypes.ImpureClass;
      }
    }

    if (false) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
      }

      var propsMutated = inst.props !== publicProps;
      var componentName = Component.displayName || Component.name || 'Component';

      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = updateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (false) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    var markup;
    if (inst.unstable_handleError) {
      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } else {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }

    if (inst.componentDidMount) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(function () {
            return inst.componentDidMount();
          }, _this._debugID, 'componentDidMount');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
      }
    }

    return markup;
  },

  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
    if (false) {
      ReactCurrentOwner.current = this;
      try {
        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
    }
  },

  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
    var Component = this._currentElement.type;

    if (doConstruct) {
      if (false) {
        return measureLifeCyclePerf(function () {
          return new Component(publicProps, publicContext, updateQueue);
        }, this._debugID, 'ctor');
      } else {
        return new Component(publicProps, publicContext, updateQueue);
      }
    }

    // This can still be an instance in case of factory components
    // but we'll count this as time spent rendering as the more common case.
    if (false) {
      return measureLifeCyclePerf(function () {
        return Component(publicProps, publicContext, updateQueue);
      }, this._debugID, 'render');
    } else {
      return Component(publicProps, publicContext, updateQueue);
    }
  },

  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var markup;
    var checkpoint = transaction.checkpoint();
    try {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } catch (e) {
      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
      transaction.rollback(checkpoint);
      this._instance.unstable_handleError(e);
      if (this._pendingStateQueue) {
        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
      }
      checkpoint = transaction.checkpoint();

      this._renderedComponent.unmountComponent(true);
      transaction.rollback(checkpoint);

      // Try again - we've informed the component about the error, so they can render an error message this time.
      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }
    return markup;
  },

  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var inst = this._instance;

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (inst.componentWillMount) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillMount();
        }, debugID, 'componentWillMount');
      } else {
        inst.componentWillMount();
      }
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    var nodeType = ReactNodeTypes.getType(renderedElement);
    this._renderedNodeType = nodeType;
    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
    );
    this._renderedComponent = child;

    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);

    if (false) {
      if (debugID !== 0) {
        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
      }
    }

    return markup;
  },

  getHostNode: function () {
    return ReactReconciler.getHostNode(this._renderedComponent);
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (safely) {
    if (!this._renderedComponent) {
      return;
    }

    var inst = this._instance;

    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
      inst._calledComponentWillUnmount = true;

      if (safely) {
        var name = this.getName() + '.componentWillUnmount()';
        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
      } else {
        if (false) {
          measureLifeCyclePerf(function () {
            return inst.componentWillUnmount();
          }, this._debugID, 'componentWillUnmount');
        } else {
          inst.componentWillUnmount();
        }
      }
    }

    if (this._renderedComponent) {
      ReactReconciler.unmountComponent(this._renderedComponent, safely);
      this._renderedNodeType = null;
      this._renderedComponent = null;
      this._instance = null;
    }

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = 0;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    var maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (false) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext;

    if (inst.getChildContext) {
      if (false) {
        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
        try {
          childContext = inst.getChildContext();
        } finally {
          ReactInstrumentation.debugTool.onEndProcessingChildContext();
        }
      } else {
        childContext = inst.getChildContext();
      }
    }

    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
      if (false) {
        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
      }
      return _assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Assert that the context types are valid
   *
   * @param {object} typeSpecs Map of context field to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkContextTypes: function (typeSpecs, values, location) {
    if (false) {
      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
    }
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    } else {
      this._updateBatchNumber = null;
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;
    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;

    var willReceive = false;
    var nextContext;

    // Determine if the context has changed or not
    if (this._context === nextUnmaskedContext) {
      nextContext = inst.context;
    } else {
      nextContext = this._processContext(nextUnmaskedContext);
      willReceive = true;
    }

    var prevProps = prevParentElement.props;
    var nextProps = nextParentElement.props;

    // Not a simple state update but a props update
    if (prevParentElement !== nextParentElement) {
      willReceive = true;
    }

    // An update here will schedule an update but immediately set
    // _pendingStateQueue which will ensure that any state updates gets
    // immediately reconciled instead of waiting for the next batch.
    if (willReceive && inst.componentWillReceiveProps) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillReceiveProps(nextProps, nextContext);
        }, this._debugID, 'componentWillReceiveProps');
      } else {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);
    var shouldUpdate = true;

    if (!this._pendingForceUpdate) {
      if (inst.shouldComponentUpdate) {
        if (false) {
          shouldUpdate = measureLifeCyclePerf(function () {
            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
          }, this._debugID, 'shouldComponentUpdate');
        } else {
          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
        }
      } else {
        if (this._compositeType === CompositeTypes.PureClass) {
          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
        }
      }
    }

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
    }

    this._updateBatchNumber = null;
    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = _assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var _this2 = this;

    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillUpdate(nextProps, nextState, nextContext);
        }, this._debugID, 'componentWillUpdate');
      } else {
        inst.componentWillUpdate(nextProps, nextState, nextContext);
      }
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
      }
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
      ReactReconciler.unmountComponent(prevComponentInstance, false);

      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
      this._renderedNodeType = nodeType;
      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
      );
      this._renderedComponent = child;

      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);

      if (false) {
        if (debugID !== 0) {
          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
        }
      }

      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
    }
  },

  /**
   * Overridden in shallow rendering.
   *
   * @protected
   */
  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedElement;

    if (false) {
      renderedElement = measureLifeCyclePerf(function () {
        return inst.render();
      }, this._debugID, 'render');
    } else {
      renderedElement = inst.render();
    }

    if (false) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (renderedElement === undefined && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedElement = null;
      }
    }

    return renderedElement;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedElement;
    if ("production" !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
      ReactCurrentOwner.current = this;
      try {
        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;

    return renderedElement;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
    var publicComponentInstance = component.getPublicInstance();
    if (false) {
      var componentName = component && component.getName ? component.getName() : 'a component';
      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (this._compositeType === CompositeTypes.StatelessFunctional) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null

};

module.exports = ReactCompositeComponent;

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/



var ReactDOMComponentTree = __webpack_require__(15);
var ReactDefaultInjection = __webpack_require__(1055);
var ReactMount = __webpack_require__(539);
var ReactReconciler = __webpack_require__(80);
var ReactUpdates = __webpack_require__(35);
var ReactVersion = __webpack_require__(1068);

var findDOMNode = __webpack_require__(1084);
var getHostComponentFromComposite = __webpack_require__(544);
var renderSubtreeIntoContainer = __webpack_require__(1091);
var warning = __webpack_require__(6);

ReactDefaultInjection.inject();

var ReactDOM = {
  findDOMNode: findDOMNode,
  render: ReactMount.render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    ComponentTree: {
      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
      getNodeFromInstance: function (inst) {
        // inst is an internal instance (but could be a composite)
        if (inst._renderedComponent) {
          inst = getHostComponentFromComposite(inst);
        }
        if (inst) {
          return ReactDOMComponentTree.getNodeFromInstance(inst);
        } else {
          return null;
        }
      }
    },
    Mount: ReactMount,
    Reconciler: ReactReconciler
  });
}

if (false) {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {

    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        // Firefox does not have the issue with devtools loaded over file://
        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    var testFunc = function testFn() {};
    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
        break;
      }
    }
  }
}

if (false) {
  var ReactInstrumentation = require('./ReactInstrumentation');
  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');

  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
}

module.exports = ReactDOM;

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* global hasOwnProperty:true */



var _prodInvariant = __webpack_require__(7),
    _assign = __webpack_require__(10);

var AutoFocusUtils = __webpack_require__(1030);
var CSSPropertyOperations = __webpack_require__(1032);
var DOMLazyTree = __webpack_require__(78);
var DOMNamespaces = __webpack_require__(227);
var DOMProperty = __webpack_require__(79);
var DOMPropertyOperations = __webpack_require__(532);
var EventPluginHub = __webpack_require__(110);
var EventPluginRegistry = __webpack_require__(228);
var ReactBrowserEventEmitter = __webpack_require__(147);
var ReactDOMComponentFlags = __webpack_require__(533);
var ReactDOMComponentTree = __webpack_require__(15);
var ReactDOMInput = __webpack_require__(1048);
var ReactDOMOption = __webpack_require__(1049);
var ReactDOMSelect = __webpack_require__(534);
var ReactDOMTextarea = __webpack_require__(1052);
var ReactInstrumentation = __webpack_require__(32);
var ReactMultiChild = __webpack_require__(1061);
var ReactServerRenderingTransaction = __webpack_require__(1066);

var emptyFunction = __webpack_require__(30);
var escapeTextContentForBrowser = __webpack_require__(150);
var invariant = __webpack_require__(4);
var isEventSupported = __webpack_require__(239);
var shallowEqual = __webpack_require__(211);
var validateDOMNesting = __webpack_require__(241);
var warning = __webpack_require__(6);

var Flags = ReactDOMComponentFlags;
var deleteListener = EventPluginHub.deleteListener;
var getNode = ReactDOMComponentTree.getNodeFromInstance;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = EventPluginRegistry.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { 'string': true, 'number': true };

var STYLE = 'style';
var HTML = '__html';
var RESERVED_PROPS = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null
};

// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
var DOC_FRAGMENT_TYPE = 11;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined because undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (voidElementTags[component._tag]) {
    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
  }
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
  }
  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
}

function enqueuePutListener(inst, registrationName, listener, transaction) {
  if (transaction instanceof ReactServerRenderingTransaction) {
    return;
  }
  if (false) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
  }
  var containerInfo = inst._hostContainerInfo;
  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
  listenTo(registrationName, doc);
  transaction.getReactMountReady().enqueue(putListener, {
    inst: inst,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
}

function inputPostMount() {
  var inst = this;
  ReactDOMInput.postMountWrapper(inst);
}

function textareaPostMount() {
  var inst = this;
  ReactDOMTextarea.postMountWrapper(inst);
}

function optionPostMount() {
  var inst = this;
  ReactDOMOption.postMountWrapper(inst);
}

var setAndValidateContentChildDev = emptyFunction;
if (false) {
  setAndValidateContentChildDev = function (content) {
    var hasExistingContent = this._contentDebugID != null;
    var debugID = this._debugID;
    // This ID represents the inlined child that has no backing instance:
    var contentDebugID = -debugID;

    if (content == null) {
      if (hasExistingContent) {
        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
      }
      this._contentDebugID = null;
      return;
    }

    validateDOMNesting(null, String(content), this, this._ancestorInfo);
    this._contentDebugID = contentDebugID;
    if (hasExistingContent) {
      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
    } else {
      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
    }
  };
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
  var node = getNode(inst);
  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;

  switch (inst._tag) {
    case 'iframe':
    case 'object':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'video':
    case 'audio':

      inst._wrapperState.listeners = [];
      // Create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
        }
      }
      break;
    case 'source':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
      break;
    case 'input':
    case 'select':
    case 'textarea':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
      break;
  }
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.

var omittedCloseTags = {
  'area': true,
  'base': true,
  'br': true,
  'col': true,
  'embed': true,
  'hr': true,
  'img': true,
  'input': true,
  'keygen': true,
  'link': true,
  'meta': true,
  'param': true,
  'source': true,
  'track': true,
  'wbr': true
};

var newlineEatingTags = {
  'listing': true,
  'pre': true,
  'textarea': true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  'menuitem': true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = {}.hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
    validatedTagCache[tag] = true;
  }
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

var globalIdCounter = 1;

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(element) {
  var tag = element.type;
  validateDangerousTag(tag);
  this._currentElement = element;
  this._tag = tag.toLowerCase();
  this._namespaceURI = null;
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._hostNode = null;
  this._hostParent = null;
  this._rootNodeID = 0;
  this._domID = 0;
  this._hostContainerInfo = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._flags = 0;
  if (false) {
    this._ancestorInfo = null;
    setAndValidateContentChildDev.call(this, null);
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {

  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?ReactDOMComponent} the parent component instance
   * @param {?object} info about the host container
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    this._rootNodeID = globalIdCounter++;
    this._domID = hostContainerInfo._idCounter++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, hostParent);
        props = ReactDOMInput.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, hostParent);
        props = ReactDOMOption.getHostProps(this, props);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, hostParent);
        props = ReactDOMSelect.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, hostParent);
        props = ReactDOMTextarea.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
    }

    assertValidProps(this, props);

    // We create tags in the namespace of their parent container, except HTML
    // tags get no namespace.
    var namespaceURI;
    var parentTag;
    if (hostParent != null) {
      namespaceURI = hostParent._namespaceURI;
      parentTag = hostParent._tag;
    } else if (hostContainerInfo._tag) {
      namespaceURI = hostContainerInfo._namespaceURI;
      parentTag = hostContainerInfo._tag;
    }
    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
      namespaceURI = DOMNamespaces.html;
    }
    if (namespaceURI === DOMNamespaces.html) {
      if (this._tag === 'svg') {
        namespaceURI = DOMNamespaces.svg;
      } else if (this._tag === 'math') {
        namespaceURI = DOMNamespaces.mathml;
      }
    }
    this._namespaceURI = namespaceURI;

    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo._tag) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(this._tag, null, this, parentInfo);
      }
      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var el;
      if (namespaceURI === DOMNamespaces.html) {
        if (this._tag === 'script') {
          // Create the script via .innerHTML so its "parser-inserted" flag is
          // set to true and it does not execute
          var div = ownerDocument.createElement('div');
          var type = this._currentElement.type;
          div.innerHTML = '<' + type + '></' + type + '>';
          el = div.removeChild(div.firstChild);
        } else if (props.is) {
          el = ownerDocument.createElement(this._currentElement.type, props.is);
        } else {
          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
          // See discussion in https://github.com/facebook/react/pull/6896
          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
          el = ownerDocument.createElement(this._currentElement.type);
        }
      } else {
        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
      }
      ReactDOMComponentTree.precacheNode(this, el);
      this._flags |= Flags.hasCachedChildNodes;
      if (!this._hostParent) {
        DOMPropertyOperations.setAttributeForRoot(el);
      }
      this._updateDOMProperties(null, props, transaction);
      var lazyTree = DOMLazyTree(el);
      this._createInitialChildren(transaction, props, context, lazyTree);
      mountImage = lazyTree;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(inputPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'textarea':
        transaction.getReactMountReady().enqueue(textareaPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'select':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'button':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'option':
        transaction.getReactMountReady().enqueue(optionPostMount, this);
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (false) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = _assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    if (!this._hostParent) {
      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
    }
    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
    return ret;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
        if (false) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, lazyTree) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      // TODO: Validate that text is allowed as a child of this node
      if (contentToUse != null) {
        // Avoid setting textContent when the text is empty. In IE11 setting
        // textContent on a text area will cause the placeholder to not
        // show within the textarea until it has been focused and blurred again.
        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
        if (contentToUse !== '') {
          if (false) {
            setAndValidateContentChildDev.call(this, contentToUse);
          }
          DOMLazyTree.queueText(lazyTree, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'input':
        lastProps = ReactDOMInput.getHostProps(this, lastProps);
        nextProps = ReactDOMInput.getHostProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getHostProps(this, lastProps);
        nextProps = ReactDOMOption.getHostProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
        break;
      case 'textarea':
        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
        break;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    switch (this._tag) {
      case 'input':
        // Update the wrapper around inputs *after* updating props. This has to
        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
        // raise warnings and prevent the new value from being assigned.
        ReactDOMInput.updateWrapper(this);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        break;
      case 'select':
        // <select> value update needs to occur after <option> children
        // reconciliation
        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
        break;
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, lastProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (false) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = _assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        var node = getNode(this);
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertently setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
        if (false) {
          setAndValidateContentChildDev.call(this, nextContent);
        }
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    } else if (nextChildren != null) {
      if (false) {
        setAndValidateContentChildDev.call(this, null);
      }

      this.updateChildren(nextChildren, transaction, context);
    }
  },

  getHostNode: function () {
    return getNode(this);
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function (safely) {
    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
        break;
    }

    this.unmountChildren(safely);
    ReactDOMComponentTree.uncacheNode(this);
    EventPluginHub.deleteAllListeners(this);
    this._rootNodeID = 0;
    this._domID = 0;
    this._wrapperState = null;

    if (false) {
      setAndValidateContentChildDev.call(this, null);
    }
  },

  getPublicInstance: function () {
    return getNode(this);
  }

};

_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var validateDOMNesting = __webpack_require__(241);

var DOC_NODE_TYPE = 9;

function ReactDOMContainerInfo(topLevelWrapper, node) {
  var info = {
    _topLevelWrapper: topLevelWrapper,
    _idCounter: 1,
    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
    _node: node,
    _tag: node ? node.nodeName.toLowerCase() : null,
    _namespaceURI: node ? node.namespaceURI : null
  };
  if (false) {
    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
  }
  return info;
}

module.exports = ReactDOMContainerInfo;

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(10);

var DOMLazyTree = __webpack_require__(78);
var ReactDOMComponentTree = __webpack_require__(15);

var ReactDOMEmptyComponent = function (instantiate) {
  // ReactCompositeComponent uses this:
  this._currentElement = null;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;
  this._hostContainerInfo = null;
  this._domID = 0;
};
_assign(ReactDOMEmptyComponent.prototype, {
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var domID = hostContainerInfo._idCounter++;
    this._domID = domID;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var nodeValue = ' react-empty: ' + this._domID + ' ';
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var node = ownerDocument.createComment(nodeValue);
      ReactDOMComponentTree.precacheNode(this, node);
      return DOMLazyTree(node);
    } else {
      if (transaction.renderToStaticMarkup) {
        // Normally we'd insert a comment node, but since this is a situation
        // where React won't take over (static pages), we can simply return
        // nothing.
        return '';
      }
      return '<!--' + nodeValue + '-->';
    }
  },
  receiveComponent: function () {},
  getHostNode: function () {
    return ReactDOMComponentTree.getNodeFromInstance(this);
  },
  unmountComponent: function () {
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMFeatureFlags = {
  useCreateElement: true,
  useFiber: false
};

module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(226);
var ReactDOMComponentTree = __webpack_require__(15);

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {

  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
    DOMChildrenOperations.processUpdates(node, updates);
  }
};

module.exports = ReactDOMIDOperations;

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7),
    _assign = __webpack_require__(10);

var DOMPropertyOperations = __webpack_require__(532);
var LinkedValueUtils = __webpack_require__(231);
var ReactDOMComponentTree = __webpack_require__(15);
var ReactUpdates = __webpack_require__(35);

var invariant = __webpack_require__(4);
var warning = __webpack_require__(6);

var didWarnValueLink = false;
var didWarnCheckedLink = false;
var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}

/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getHostProps: function (inst, props) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var hostProps = _assign({
      // Make sure we set .type before any other properties (setting .value
      // before .type means .value is lost in IE11 and below)
      type: undefined,
      // Make sure we set .step before .value (setting .value before .step
      // means .value is rounded on mount, based upon step precision)
      step: undefined,
      // Make sure we set .min & .max before .value (to ensure proper order
      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
      min: undefined,
      max: undefined
    }, props, {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);

      var owner = inst._currentElement._owner;

      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnCheckedLink = true;
      }
      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnCheckedDefaultChecked = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnValueDefaultValue = true;
      }
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
      initialValue: props.value != null ? props.value : defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      controlled: isControlled(props)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    if (false) {
      var controlled = isControlled(props);
      var owner = inst._currentElement._owner;

      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnUncontrolledToControlled = true;
      }
      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnControlledToUncontrolled = true;
      }
    }

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      if (value === 0 && node.value === '') {
        node.value = '0';
        // Note: IE9 reports a number inputs as 'text', so check props instead.
      } else if (props.type === 'number') {
        // Simulate `input.valueAsNumber`. IE9 does not support it
        var valueAsNumber = parseFloat(node.value, 10) || 0;

        // eslint-disable-next-line
        if (value != valueAsNumber) {
          // Cast `value` to a string to ensure the value is set correctly. While
          // browsers typically do this as necessary, jsdom doesn't.
          node.value = '' + value;
        }
        // eslint-disable-next-line
      } else if (value != node.value) {
        // Cast `value` to a string to ensure the value is set correctly. While
        // browsers typically do this as necessary, jsdom doesn't.
        node.value = '' + value;
      }
    } else {
      if (props.value == null && props.defaultValue != null) {
        // In Chrome, assigning defaultValue to certain input types triggers input validation.
        // For number inputs, the display value loses trailing decimal points. For email inputs,
        // Chrome raises "The specified value <x> is not a valid email address".
        //
        // Here we check to see if the defaultValue has actually changed, avoiding these problems
        // when the user is inputting text
        //
        // https://github.com/facebook/react/issues/7253
        if (node.defaultValue !== '' + props.defaultValue) {
          node.defaultValue = '' + props.defaultValue;
        }
      }
      if (props.checked == null && props.defaultChecked != null) {
        node.defaultChecked = !!props.defaultChecked;
      }
    }
  },

  postMountWrapper: function (inst) {
    var props = inst._currentElement.props;

    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Detach value from defaultValue. We won't do anything if we're working on
    // submit or reset inputs as those values & defaultValues are linked. They
    // are not resetable nodes so this operation doesn't matter and actually
    // removes browser-default values (eg "Submit Query") when no value is
    // provided.

    switch (props.type) {
      case 'submit':
      case 'reset':
        break;
      case 'color':
      case 'date':
      case 'datetime':
      case 'datetime-local':
      case 'month':
      case 'time':
      case 'week':
        // This fixes the no-show issue on iOS Safari and Android Chrome:
        // https://github.com/facebook/react/issues/7233
        node.value = '';
        node.value = node.defaultValue;
        break;
      default:
        node.value = node.value;
        break;
    }

    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
    // this is needed to work around a chrome bug where setting defaultChecked
    // will sometimes influence the value of checked (even after detachment).
    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
    // We need to temporarily unset name to avoid disrupting radio button groups.
    var name = node.name;
    if (name !== '') {
      node.name = '';
    }
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !node.defaultChecked;
    if (name !== '') {
      node.name = name;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.
      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(10);

var React = __webpack_require__(85);
var ReactDOMComponentTree = __webpack_require__(15);
var ReactDOMSelect = __webpack_require__(534);

var warning = __webpack_require__(6);
var didWarnInvalidOptionChildren = false;

function flattenChildren(children) {
  var content = '';

  // Flatten children and warn if they aren't strings or numbers;
  // invalid types are ignored.
  React.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }
    if (typeof child === 'string' || typeof child === 'number') {
      content += child;
    } else if (!didWarnInvalidOptionChildren) {
      didWarnInvalidOptionChildren = true;
       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
    }
  });

  return content;
}

/**
 * Implements an <option> host component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, hostParent) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
    }

    // Look up whether this option is 'selected'
    var selectValue = null;
    if (hostParent != null) {
      var selectParent = hostParent;

      if (selectParent._tag === 'optgroup') {
        selectParent = selectParent._hostParent;
      }

      if (selectParent != null && selectParent._tag === 'select') {
        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
      }
    }

    // If the value is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      var value;
      if (props.value != null) {
        value = props.value + '';
      } else {
        value = flattenChildren(props.children);
      }
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  postMountWrapper: function (inst) {
    // value="" should make a value attribute (#6219)
    var props = inst._currentElement.props;
    if (props.value != null) {
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      node.setAttribute('value', props.value);
    }
  },

  getHostProps: function (inst, props) {
    var hostProps = _assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      hostProps.selected = inst._wrapperState.selected;
    }

    var content = flattenChildren(props.children);

    if (content) {
      hostProps.children = content;
    }

    return hostProps;
  }

};

module.exports = ReactDOMOption;

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(26);

var getNodeForCharacterOffset = __webpack_require__(1088);
var getTextContentAccessor = __webpack_require__(545);

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (offsets.end === undefined) {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7),
    _assign = __webpack_require__(10);

var DOMChildrenOperations = __webpack_require__(226);
var DOMLazyTree = __webpack_require__(78);
var ReactDOMComponentTree = __webpack_require__(15);

var escapeTextContentForBrowser = __webpack_require__(150);
var invariant = __webpack_require__(4);
var validateDOMNesting = __webpack_require__(241);

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings between comment nodes so that they
 * can undergo the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (text) {
  // TODO: This is really a ReactText (ReactNode), not a ReactElement
  this._currentElement = text;
  this._stringText = '' + text;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;

  // Properties
  this._domID = 0;
  this._mountIndex = 0;
  this._closingComment = null;
  this._commentNodes = null;
};

_assign(ReactDOMTextComponent.prototype, {

  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo != null) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(null, this._stringText, this, parentInfo);
      }
    }

    var domID = hostContainerInfo._idCounter++;
    var openingValue = ' react-text: ' + domID + ' ';
    var closingValue = ' /react-text ';
    this._domID = domID;
    this._hostParent = hostParent;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var openingComment = ownerDocument.createComment(openingValue);
      var closingComment = ownerDocument.createComment(closingValue);
      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
      if (this._stringText) {
        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
      }
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
      ReactDOMComponentTree.precacheNode(this, openingComment);
      this._closingComment = closingComment;
      return lazyTree;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this between comment nodes for the reasons stated
        // above, but since this is a situation where React won't take over
        // (static pages), we can simply return the text as it is.
        return escapedText;
      }

      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var commentNodes = this.getHostNode();
        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
      }
    }
  },

  getHostNode: function () {
    var hostNode = this._commentNodes;
    if (hostNode) {
      return hostNode;
    }
    if (!this._closingComment) {
      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
      var node = openingComment.nextSibling;
      while (true) {
        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
          this._closingComment = node;
          break;
        }
        node = node.nextSibling;
      }
    }
    hostNode = [this._hostNode, this._closingComment];
    this._commentNodes = hostNode;
    return hostNode;
  },

  unmountComponent: function () {
    this._closingComment = null;
    this._commentNodes = null;
    ReactDOMComponentTree.uncacheNode(this);
  }

});

module.exports = ReactDOMTextComponent;

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7),
    _assign = __webpack_require__(10);

var LinkedValueUtils = __webpack_require__(231);
var ReactDOMComponentTree = __webpack_require__(15);
var ReactUpdates = __webpack_require__(35);

var invariant = __webpack_require__(4);
var warning = __webpack_require__(6);

var didWarnValueLink = false;
var didWarnValDefaultVal = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getHostProps: function (inst, props) {
    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.  We could add a check in setTextContent
    // to only set the value if/when the value differs from the node value (which would
    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
    // The value can be a boolean or object so that's why it's forced to be a string.
    var hostProps = _assign({}, props, {
      value: undefined,
      defaultValue: undefined,
      children: '' + inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
        didWarnValDefaultVal = true;
      }
    }

    var value = LinkedValueUtils.getValue(props);
    var initialValue = value;

    // Only bother fetching default value if we're going to use it
    if (value == null) {
      var defaultValue = props.defaultValue;
      // TODO (yungsters): Remove support for children content in <textarea>.
      var children = props.children;
      if (children != null) {
        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
        }
        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
        if (Array.isArray(children)) {
          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
          children = children[0];
        }

        defaultValue = '' + children;
      }
      if (defaultValue == null) {
        defaultValue = '';
      }
      initialValue = defaultValue;
    }

    inst._wrapperState = {
      initialValue: '' + initialValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
      if (props.defaultValue == null) {
        node.defaultValue = newValue;
      }
    }
    if (props.defaultValue != null) {
      node.defaultValue = props.defaultValue;
    }
  },

  postMountWrapper: function (inst) {
    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var textContent = node.textContent;

    // Only set node.value if textContent is equal to the expected
    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
    // will populate textContent as well.
    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
    if (textContent === inst._wrapperState.initialValue) {
      node.value = textContent;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var invariant = __webpack_require__(4);

/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */
function getLowestCommonAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  var depthA = 0;
  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
    depthA++;
  }
  var depthB = 0;
  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
    depthB++;
  }

  // If A is deeper, crawl up.
  while (depthA - depthB > 0) {
    instA = instA._hostParent;
    depthA--;
  }

  // If B is deeper, crawl up.
  while (depthB - depthA > 0) {
    instB = instB._hostParent;
    depthB--;
  }

  // Walk in lockstep until we find a match.
  var depth = depthA;
  while (depth--) {
    if (instA === instB) {
      return instA;
    }
    instA = instA._hostParent;
    instB = instB._hostParent;
  }
  return null;
}

/**
 * Return if A is an ancestor of B.
 */
function isAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;

  while (instB) {
    if (instB === instA) {
      return true;
    }
    instB = instB._hostParent;
  }
  return false;
}

/**
 * Return the parent instance of the passed-in instance.
 */
function getParentInstance(inst) {
  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;

  return inst._hostParent;
}

/**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */
function traverseTwoPhase(inst, fn, arg) {
  var path = [];
  while (inst) {
    path.push(inst);
    inst = inst._hostParent;
  }
  var i;
  for (i = path.length; i-- > 0;) {
    fn(path[i], 'captured', arg);
  }
  for (i = 0; i < path.length; i++) {
    fn(path[i], 'bubbled', arg);
  }
}

/**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */
function traverseEnterLeave(from, to, fn, argFrom, argTo) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;
  var pathFrom = [];
  while (from && from !== common) {
    pathFrom.push(from);
    from = from._hostParent;
  }
  var pathTo = [];
  while (to && to !== common) {
    pathTo.push(to);
    to = to._hostParent;
  }
  var i;
  for (i = 0; i < pathFrom.length; i++) {
    fn(pathFrom[i], 'bubbled', argFrom);
  }
  for (i = pathTo.length; i-- > 0;) {
    fn(pathTo[i], 'captured', argTo);
  }
}

module.exports = {
  isAncestor: isAncestor,
  getLowestCommonAncestor: getLowestCommonAncestor,
  getParentInstance: getParentInstance,
  traverseTwoPhase: traverseTwoPhase,
  traverseEnterLeave: traverseEnterLeave
};

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(10);

var ReactUpdates = __webpack_require__(35);
var Transaction = __webpack_require__(149);

var emptyFunction = __webpack_require__(30);

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      return callback(a, b, c, d, e);
    } else {
      return transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = __webpack_require__(1029);
var BeforeInputEventPlugin = __webpack_require__(1031);
var ChangeEventPlugin = __webpack_require__(1033);
var DefaultEventPluginOrder = __webpack_require__(1035);
var EnterLeaveEventPlugin = __webpack_require__(1036);
var HTMLDOMPropertyConfig = __webpack_require__(1038);
var ReactComponentBrowserEnvironment = __webpack_require__(1040);
var ReactDOMComponent = __webpack_require__(1043);
var ReactDOMComponentTree = __webpack_require__(15);
var ReactDOMEmptyComponent = __webpack_require__(1045);
var ReactDOMTreeTraversal = __webpack_require__(1053);
var ReactDOMTextComponent = __webpack_require__(1051);
var ReactDefaultBatchingStrategy = __webpack_require__(1054);
var ReactEventListener = __webpack_require__(1058);
var ReactInjection = __webpack_require__(1059);
var ReactReconcileTransaction = __webpack_require__(1064);
var SVGDOMPropertyConfig = __webpack_require__(1069);
var SelectEventPlugin = __webpack_require__(1070);
var SimpleEventPlugin = __webpack_require__(1071);

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
    return new ReactDOMEmptyComponent(instantiate);
  });

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
}

module.exports = {
  inject: inject
};

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(110);

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {

  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   */
  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(10);

var EventListener = __webpack_require__(379);
var ExecutionEnvironment = __webpack_require__(26);
var PooledClass = __webpack_require__(61);
var ReactDOMComponentTree = __webpack_require__(15);
var ReactUpdates = __webpack_require__(35);

var getEventTarget = __webpack_require__(238);
var getUnboundedScrollPosition = __webpack_require__(898);

/**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */
function findParent(inst) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  while (inst._hostParent) {
    inst = inst._hostParent;
  }
  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
  var container = rootNode.parentNode;
  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
_assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = targetInst;
  do {
    bookKeeping.ancestors.push(ancestor);
    ancestor = ancestor && findParent(ancestor);
  } while (ancestor);

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    targetInst = bookKeeping.ancestors[i];
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(79);
var EventPluginHub = __webpack_require__(110);
var EventPluginUtils = __webpack_require__(229);
var ReactComponentEnvironment = __webpack_require__(232);
var ReactEmptyComponent = __webpack_require__(535);
var ReactBrowserEventEmitter = __webpack_require__(147);
var ReactHostComponent = __webpack_require__(537);
var ReactUpdates = __webpack_require__(35);

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventPluginUtils: EventPluginUtils.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  HostComponent: ReactHostComponent.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var adler32 = __webpack_require__(1082);

var TAG_END = /\/?>/;
var COMMENT_START = /^<\!\-\-/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags, comments and self-closing tags)
    if (COMMENT_START.test(markup)) {
      return markup;
    } else {
      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
    }
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var ReactComponentEnvironment = __webpack_require__(232);
var ReactInstanceMap = __webpack_require__(112);
var ReactInstrumentation = __webpack_require__(32);

var ReactCurrentOwner = __webpack_require__(48);
var ReactReconciler = __webpack_require__(80);
var ReactChildReconciler = __webpack_require__(1039);

var emptyFunction = __webpack_require__(30);
var flattenChildren = __webpack_require__(1085);
var invariant = __webpack_require__(4);

/**
 * Make an update for markup to be rendered and inserted at a supplied index.
 *
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function makeInsertMarkup(markup, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'INSERT_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for moving an existing element to another index.
 *
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function makeMove(child, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'MOVE_EXISTING',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: ReactReconciler.getHostNode(child),
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for removing an element at an index.
 *
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function makeRemove(child, node) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'REMOVE_NODE',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: node,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the markup of a node.
 *
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function makeSetMarkup(markup) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'SET_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the text content.
 *
 * @param {string} textContent Text content to set.
 * @private
 */
function makeTextContent(textContent) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'TEXT_CONTENT',
    content: textContent,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Push an update, if any, onto the queue. Creates a new queue if none is
 * passed and always returns the queue. Mutative.
 */
function enqueue(queue, update) {
  if (update) {
    queue = queue || [];
    queue.push(update);
  }
  return queue;
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue(inst, updateQueue) {
  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
}

var setChildrenForInstrumentation = emptyFunction;
if (false) {
  var getDebugID = function (inst) {
    if (!inst._debugID) {
      // Check for ART-like instances. TODO: This is silly/gross.
      var internal;
      if (internal = ReactInstanceMap.get(inst)) {
        inst = internal;
      }
    }
    return inst._debugID;
  };
  setChildrenForInstrumentation = function (children) {
    var debugID = getDebugID(this);
    // TODO: React Native empty components are also multichild.
    // This means they still get into this method but don't have _debugID.
    if (debugID !== 0) {
      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
        return children[key]._debugID;
      }) : []);
    }
  };
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {

  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {

    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (false) {
        var selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
      var nextChildren;
      var selfDebugID = 0;
      if (false) {
        selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
          return nextChildren;
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
      return nextChildren;
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;

      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          var selfDebugID = 0;
          if (false) {
            selfDebugID = getDebugID(this);
          }
          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }

      if (false) {
        setChildrenForInstrumentation.call(this, children);
      }

      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      // Set new text content.
      var updates = [makeTextContent(nextContent)];
      processQueue(this, updates);
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      var updates = [makeSetMarkup(nextMarkup)];
      processQueue(this, updates);
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      // Hook used by React ART
      this._updateChildren(nextNestedChildrenElements, transaction, context);
    },

    /**
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var removedNodes = {};
      var mountImages = [];
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
      if (!nextChildren && !prevChildren) {
        return;
      }
      var updates = null;
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var nextIndex = 0;
      var lastIndex = 0;
      // `nextMountIndex` will increment for each newly mounted child.
      var nextMountIndex = 0;
      var lastPlacedNode = null;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            // The `removedNodes` loop below will actually remove the child.
          }
          // The child must be instantiated before it's mounted.
          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
          nextMountIndex++;
        }
        nextIndex++;
        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
      }
      // Remove children that are no longer present.
      for (name in removedNodes) {
        if (removedNodes.hasOwnProperty(name)) {
          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
        }
      }
      if (updates) {
        processQueue(this, updates);
      }
      this._renderedChildren = nextChildren;

      if (false) {
        setChildrenForInstrumentation.call(this, nextChildren);
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted. It does not actually perform any
     * backend operations.
     *
     * @internal
     */
    unmountChildren: function (safely) {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren, safely);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, afterNode, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        return makeMove(child, afterNode, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, afterNode, mountImage) {
      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child, node) {
      return makeRemove(child, node);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
      child._mountIndex = index;
      return this.createChild(child, afterNode, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child, node) {
      var update = this.removeChild(child, node);
      child._mountIndex = null;
      return update;
    }

  }

};

module.exports = ReactMultiChild;

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(7);

var invariant = __webpack_require__(4);

/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid owner.
 * @final
 */
function isValidOwner(object) {
  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
}

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {
  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
    var ownerPublicInstance = owner.getPublicInstance();
    // Check that `component`'s owner is still alive and that `component` is still the current ref
    // because we do not want to detach the ref if another component stole it.
    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }

};

module.exports = ReactOwner;

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(10);

var CallbackQueue = __webpack_require__(531);
var PooledClass = __webpack_require__(61);
var ReactBrowserEventEmitter = __webpack_require__(147);
var ReactInputSelection = __webpack_require__(538);
var ReactInstrumentation = __webpack_require__(32);
var Transaction = __webpack_require__(149);
var ReactUpdateQueue = __webpack_require__(234);

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(useCreateElement) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactDOMTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return ReactUpdateQueue;
  },

  /**
   * Save current transaction state -- if the return value from this method is
   * passed to `rollback`, the transaction will be reset to that state.
   */
  checkpoint: function () {
    // reactMountReady is the our only stateful wrapper
    return this.reactMountReady.checkpoint();
  },

  rollback: function (checkpoint) {
    this.reactMountReady.rollback(checkpoint);
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactOwner = __webpack_require__(1062);

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevRef = null;
  var prevOwner = null;
  if (prevElement !== null && typeof prevElement === 'object') {
    prevRef = prevElement.ref;
    prevOwner = prevElement._owner;
  }

  var nextRef = null;
  var nextOwner = null;
  if (nextElement !== null && typeof nextElement === 'object') {
    nextRef = nextElement.ref;
    nextOwner = nextElement._owner;
  }

  return prevRef !== nextRef ||
  // If owner changes but we have an unchanged function ref, don't update refs
  typeof nextRef === 'string' && nextOwner !== prevOwner;
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(10);

var PooledClass = __webpack_require__(61);
var Transaction = __webpack_require__(149);
var ReactInstrumentation = __webpack_require__(32);
var ReactServerUpdateQueue = __webpack_require__(1067);

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

var noopCallbackQueue = {
  enqueue: function () {}
};

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.useCreateElement = false;
  this.updateQueue = new ReactServerUpdateQueue(this);
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return noopCallbackQueue;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return this.updateQueue;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {},

  checkpoint: function () {},

  rollback: function () {}
};

_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactUpdateQueue = __webpack_require__(234);

var warning = __webpack_require__(6);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the update queue used for server rendering.
 * It delegates to ReactUpdateQueue while server rendering is in progress and
 * switches to ReactNoopUpdateQueue after the transaction has completed.
 * @class ReactServerUpdateQueue
 * @param {Transaction} transaction
 */

var ReactServerUpdateQueue = function () {
  function ReactServerUpdateQueue(transaction) {
    _classCallCheck(this, ReactServerUpdateQueue);

    this.transaction = transaction;
  }

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */


  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
    return false;
  };

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
    }
  };

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
    } else {
      warnNoop(publicInstance, 'forceUpdate');
    }
  };

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} completeState Next state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
    } else {
      warnNoop(publicInstance, 'replaceState');
    }
  };

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} partialState Next partial state to be merged with state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
    } else {
      warnNoop(publicInstance, 'setState');
    }
  };

  return ReactServerUpdateQueue;
}();

module.exports = ReactServerUpdateQueue;

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.5.4';

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var ATTRS = {
  accentHeight: 'accent-height',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 'alignment-baseline',
  allowReorder: 'allowReorder',
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 'arabic-form',
  ascent: 0,
  attributeName: 'attributeName',
  attributeType: 'attributeType',
  autoReverse: 'autoReverse',
  azimuth: 0,
  baseFrequency: 'baseFrequency',
  baseProfile: 'baseProfile',
  baselineShift: 'baseline-shift',
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 'calcMode',
  capHeight: 'cap-height',
  clip: 0,
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  clipPathUnits: 'clipPathUnits',
  colorInterpolation: 'color-interpolation',
  colorInterpolationFilters: 'color-interpolation-filters',
  colorProfile: 'color-profile',
  colorRendering: 'color-rendering',
  contentScriptType: 'contentScriptType',
  contentStyleType: 'contentStyleType',
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 'diffuseConstant',
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 'dominant-baseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 'edgeMode',
  elevation: 0,
  enableBackground: 'enable-background',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 'externalResourcesRequired',
  fill: 0,
  fillOpacity: 'fill-opacity',
  fillRule: 'fill-rule',
  filter: 0,
  filterRes: 'filterRes',
  filterUnits: 'filterUnits',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  focusable: 0,
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontVariant: 'font-variant',
  fontWeight: 'font-weight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 'glyph-name',
  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  glyphRef: 'glyphRef',
  gradientTransform: 'gradientTransform',
  gradientUnits: 'gradientUnits',
  hanging: 0,
  horizAdvX: 'horiz-adv-x',
  horizOriginX: 'horiz-origin-x',
  ideographic: 0,
  imageRendering: 'image-rendering',
  'in': 0,
  in2: 0,
  intercept: 0,
  k: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  kernelMatrix: 'kernelMatrix',
  kernelUnitLength: 'kernelUnitLength',
  kerning: 0,
  keyPoints: 'keyPoints',
  keySplines: 'keySplines',
  keyTimes: 'keyTimes',
  lengthAdjust: 'lengthAdjust',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  limitingConeAngle: 'limitingConeAngle',
  local: 0,
  markerEnd: 'marker-end',
  markerMid: 'marker-mid',
  markerStart: 'marker-start',
  markerHeight: 'markerHeight',
  markerUnits: 'markerUnits',
  markerWidth: 'markerWidth',
  mask: 0,
  maskContentUnits: 'maskContentUnits',
  maskUnits: 'maskUnits',
  mathematical: 0,
  mode: 0,
  numOctaves: 'numOctaves',
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 'overline-position',
  overlineThickness: 'overline-thickness',
  paintOrder: 'paint-order',
  panose1: 'panose-1',
  pathLength: 'pathLength',
  patternContentUnits: 'patternContentUnits',
  patternTransform: 'patternTransform',
  patternUnits: 'patternUnits',
  pointerEvents: 'pointer-events',
  points: 0,
  pointsAtX: 'pointsAtX',
  pointsAtY: 'pointsAtY',
  pointsAtZ: 'pointsAtZ',
  preserveAlpha: 'preserveAlpha',
  preserveAspectRatio: 'preserveAspectRatio',
  primitiveUnits: 'primitiveUnits',
  r: 0,
  radius: 0,
  refX: 'refX',
  refY: 'refY',
  renderingIntent: 'rendering-intent',
  repeatCount: 'repeatCount',
  repeatDur: 'repeatDur',
  requiredExtensions: 'requiredExtensions',
  requiredFeatures: 'requiredFeatures',
  restart: 0,
  result: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  seed: 0,
  shapeRendering: 'shape-rendering',
  slope: 0,
  spacing: 0,
  specularConstant: 'specularConstant',
  specularExponent: 'specularExponent',
  speed: 0,
  spreadMethod: 'spreadMethod',
  startOffset: 'startOffset',
  stdDeviation: 'stdDeviation',
  stemh: 0,
  stemv: 0,
  stitchTiles: 'stitchTiles',
  stopColor: 'stop-color',
  stopOpacity: 'stop-opacity',
  strikethroughPosition: 'strikethrough-position',
  strikethroughThickness: 'strikethrough-thickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 'stroke-dasharray',
  strokeDashoffset: 'stroke-dashoffset',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  surfaceScale: 'surfaceScale',
  systemLanguage: 'systemLanguage',
  tableValues: 'tableValues',
  targetX: 'targetX',
  targetY: 'targetY',
  textAnchor: 'text-anchor',
  textDecoration: 'text-decoration',
  textRendering: 'text-rendering',
  textLength: 'textLength',
  to: 0,
  transform: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 'underline-position',
  underlineThickness: 'underline-thickness',
  unicode: 0,
  unicodeBidi: 'unicode-bidi',
  unicodeRange: 'unicode-range',
  unitsPerEm: 'units-per-em',
  vAlphabetic: 'v-alphabetic',
  vHanging: 'v-hanging',
  vIdeographic: 'v-ideographic',
  vMathematical: 'v-mathematical',
  values: 0,
  vectorEffect: 'vector-effect',
  version: 0,
  vertAdvY: 'vert-adv-y',
  vertOriginX: 'vert-origin-x',
  vertOriginY: 'vert-origin-y',
  viewBox: 'viewBox',
  viewTarget: 'viewTarget',
  visibility: 0,
  widths: 0,
  wordSpacing: 'word-spacing',
  writingMode: 'writing-mode',
  x: 0,
  xHeight: 'x-height',
  x1: 0,
  x2: 0,
  xChannelSelector: 'xChannelSelector',
  xlinkActuate: 'xlink:actuate',
  xlinkArcrole: 'xlink:arcrole',
  xlinkHref: 'xlink:href',
  xlinkRole: 'xlink:role',
  xlinkShow: 'xlink:show',
  xlinkTitle: 'xlink:title',
  xlinkType: 'xlink:type',
  xmlBase: 'xml:base',
  xmlns: 0,
  xmlnsXlink: 'xmlns:xlink',
  xmlLang: 'xml:lang',
  xmlSpace: 'xml:space',
  y: 0,
  y1: 0,
  y2: 0,
  yChannelSelector: 'yChannelSelector',
  z: 0,
  zoomAndPan: 'zoomAndPan'
};

var SVGDOMPropertyConfig = {
  Properties: {},
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {}
};

Object.keys(ATTRS).forEach(function (key) {
  SVGDOMPropertyConfig.Properties[key] = 0;
  if (ATTRS[key]) {
    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
  }
});

module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(111);
var ExecutionEnvironment = __webpack_require__(26);
var ReactDOMComponentTree = __webpack_require__(15);
var ReactInputSelection = __webpack_require__(538);
var SyntheticEvent = __webpack_require__(44);

var getActiveElement = __webpack_require__(381);
var isTextInputElement = __webpack_require__(547);
var shallowEqual = __webpack_require__(211);

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: 'onSelect',
      captured: 'onSelectCapture'
    },
    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
  }
};

var activeElement = null;
var activeElementInst = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events. See #3639.
var hasListener = false;

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {

  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    switch (topLevelType) {
      // Track the input node that has focus.
      case 'topFocus':
        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
          activeElement = targetNode;
          activeElementInst = targetInst;
          lastSelection = null;
        }
        break;
      case 'topBlur':
        activeElement = null;
        activeElementInst = null;
        lastSelection = null;
        break;

      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case 'topMouseDown':
        mouseDown = true;
        break;
      case 'topContextMenu':
      case 'topMouseUp':
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);

      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case 'topSelectionChange':
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case 'topKeyDown':
      case 'topKeyUp':
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (inst, registrationName, listener) {
    if (registrationName === 'onSelect') {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(7);

var EventListener = __webpack_require__(379);
var EventPropagators = __webpack_require__(111);
var ReactDOMComponentTree = __webpack_require__(15);
var SyntheticAnimationEvent = __webpack_require__(1072);
var SyntheticClipboardEvent = __webpack_require__(1073);
var SyntheticEvent = __webpack_require__(44);
var SyntheticFocusEvent = __webpack_require__(1076);
var SyntheticKeyboardEvent = __webpack_require__(1078);
var SyntheticMouseEvent = __webpack_require__(148);
var SyntheticDragEvent = __webpack_require__(1075);
var SyntheticTouchEvent = __webpack_require__(1079);
var SyntheticTransitionEvent = __webpack_require__(1080);
var SyntheticUIEvent = __webpack_require__(113);
var SyntheticWheelEvent = __webpack_require__(1081);

var emptyFunction = __webpack_require__(30);
var getEventCharCode = __webpack_require__(236);
var invariant = __webpack_require__(4);

/**
 * Turns
 * ['abort', ...]
 * into
 * eventTypes = {
 *   'abort': {
 *     phasedRegistrationNames: {
 *       bubbled: 'onAbort',
 *       captured: 'onAbortCapture',
 *     },
 *     dependencies: ['topAbort'],
 *   },
 *   ...
 * };
 * topLevelEventsToDispatchConfig = {
 *   'topAbort': { sameConfig }
 * };
 */
var eventTypes = {};
var topLevelEventsToDispatchConfig = {};
['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
  var onEvent = 'on' + capitalizedEvent;
  var topEvent = 'top' + capitalizedEvent;

  var type = {
    phasedRegistrationNames: {
      bubbled: onEvent,
      captured: onEvent + 'Capture'
    },
    dependencies: [topEvent]
  };
  eventTypes[event] = type;
  topLevelEventsToDispatchConfig[topEvent] = type;
});

var onClickListeners = {};

function getDictionaryKey(inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
}

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

var SimpleEventPlugin = {

  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case 'topAbort':
      case 'topCanPlay':
      case 'topCanPlayThrough':
      case 'topDurationChange':
      case 'topEmptied':
      case 'topEncrypted':
      case 'topEnded':
      case 'topError':
      case 'topInput':
      case 'topInvalid':
      case 'topLoad':
      case 'topLoadedData':
      case 'topLoadedMetadata':
      case 'topLoadStart':
      case 'topPause':
      case 'topPlay':
      case 'topPlaying':
      case 'topProgress':
      case 'topRateChange':
      case 'topReset':
      case 'topSeeked':
      case 'topSeeking':
      case 'topStalled':
      case 'topSubmit':
      case 'topSuspend':
      case 'topTimeUpdate':
      case 'topVolumeChange':
      case 'topWaiting':
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case 'topKeyPress':
        // Firefox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case 'topKeyDown':
      case 'topKeyUp':
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case 'topBlur':
      case 'topFocus':
        EventConstructor = SyntheticFocusEvent;
        break;
      case 'topClick':
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case 'topDoubleClick':
      case 'topMouseDown':
      case 'topMouseMove':
      case 'topMouseUp':
      // TODO: Disabled elements should not respond to mouse events
      /* falls through */
      case 'topMouseOut':
      case 'topMouseOver':
      case 'topContextMenu':
        EventConstructor = SyntheticMouseEvent;
        break;
      case 'topDrag':
      case 'topDragEnd':
      case 'topDragEnter':
      case 'topDragExit':
      case 'topDragLeave':
      case 'topDragOver':
      case 'topDragStart':
      case 'topDrop':
        EventConstructor = SyntheticDragEvent;
        break;
      case 'topTouchCancel':
      case 'topTouchEnd':
      case 'topTouchMove':
      case 'topTouchStart':
        EventConstructor = SyntheticTouchEvent;
        break;
      case 'topAnimationEnd':
      case 'topAnimationIteration':
      case 'topAnimationStart':
        EventConstructor = SyntheticAnimationEvent;
        break;
      case 'topTransitionEnd':
        EventConstructor = SyntheticTransitionEvent;
        break;
      case 'topScroll':
        EventConstructor = SyntheticUIEvent;
        break;
      case 'topWheel':
        EventConstructor = SyntheticWheelEvent;
        break;
      case 'topCopy':
      case 'topCut':
      case 'topPaste':
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (inst, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      if (!onClickListeners[key]) {
        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (inst, registrationName) {
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      onClickListeners[key].remove();
      delete onClickListeners[key];
    }
  }

};

module.exports = SimpleEventPlugin;

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(44);

/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */
var AnimationEventInterface = {
  animationName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);

module.exports = SyntheticAnimationEvent;

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(44);

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(44);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(148);

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(113);

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(44);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(113);

var getEventCharCode = __webpack_require__(236);
var getEventKey = __webpack_require__(1086);
var getEventModifierState = __webpack_require__(237);

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(113);

var getEventModifierState = __webpack_require__(237);

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(44);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */
var TransitionEventInterface = {
  propertyName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);

module.exports = SyntheticTransitionEvent;

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(148);

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX :
    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY :
    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY :
    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    var n = Math.min(i + 4096, m);
    for (; i < n; i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(530);
var warning = __webpack_require__(6);

var isUnitlessNumber = CSSProperty.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var ReactCurrentOwner = __webpack_require__(48);
var ReactDOMComponentTree = __webpack_require__(15);
var ReactInstanceMap = __webpack_require__(112);

var getHostComponentFromComposite = __webpack_require__(544);
var invariant = __webpack_require__(4);
var warning = __webpack_require__(6);

/**
 * Returns the DOM node rendered by this element.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if (false) {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }

  var inst = ReactInstanceMap.get(componentOrElement);
  if (inst) {
    inst = getHostComponentFromComposite(inst);
    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
  }

  if (typeof componentOrElement.render === 'function') {
     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
  } else {
     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
  }
}

module.exports = findDOMNode;

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var KeyEscapeUtils = __webpack_require__(230);
var traverseAllChildren = __webpack_require__(549);
var warning = __webpack_require__(6);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && process.env && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(622);
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && typeof traverseContext === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (false) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
      }
      if (!keyUnique) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (false) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(109)))

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var getEventCharCode = __webpack_require__(236);

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  'Esc': 'Escape',
  'Spacebar': ' ',
  'Left': 'ArrowLeft',
  'Up': 'ArrowUp',
  'Right': 'ArrowRight',
  'Down': 'ArrowDown',
  'Del': 'Delete',
  'Win': 'OS',
  'Menu': 'ContextMenu',
  'Apps': 'ContextMenu',
  'Scroll': 'ScrollLock',
  'MozPrintableKey': 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(26);

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var escapeTextContentForBrowser = __webpack_require__(150);

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactMount = __webpack_require__(539);

module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(0), __webpack_require__(1));
	else if(typeof define === 'function' && define.amd)
		define(["react", "prop-types"], factory);
	else if(typeof exports === 'object')
		exports["Dropzone"] = factory(require("react"), require("prop-types"));
	else
		root["Dropzone"] = factory(root["react"], root["prop-types"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _attrAccept = __webpack_require__(4);
	
	var _attrAccept2 = _interopRequireDefault(_attrAccept);
	
	var _getDataTransferItems = __webpack_require__(5);
	
	var _getDataTransferItems2 = _interopRequireDefault(_getDataTransferItems);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint prefer-template: 0 */
	
	var supportMultiple = typeof document !== 'undefined' && document && document.createElement ? 'multiple' in document.createElement('input') : true;
	
	function fileAccepted(file, accept) {
	  // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
	  // that MIME type will always be accepted
	  return file.type === 'application/x-moz-file' || (0, _attrAccept2.default)(file, accept);
	}
	
	var Dropzone = function (_React$Component) {
	  _inherits(Dropzone, _React$Component);
	
	  _createClass(Dropzone, null, [{
	    key: 'onDocumentDragOver',
	    value: function onDocumentDragOver(e) {
	      // allow the entire document to be a drag target
	      e.preventDefault();
	    }
	  }]);
	
	  function Dropzone(props, context) {
	    _classCallCheck(this, Dropzone);
	
	    var _this = _possibleConstructorReturn(this, (Dropzone.__proto__ || Object.getPrototypeOf(Dropzone)).call(this, props, context));
	
	    _this.renderChildren = function (children, isDragActive, isDragReject) {
	      if (typeof children === 'function') {
	        return children(_extends({}, _this.state, { isDragActive: isDragActive, isDragReject: isDragReject }));
	      }
	      return children;
	    };
	
	    _this.onClick = _this.onClick.bind(_this);
	    _this.onDocumentDrop = _this.onDocumentDrop.bind(_this);
	    _this.onDragStart = _this.onDragStart.bind(_this);
	    _this.onDragEnter = _this.onDragEnter.bind(_this);
	    _this.onDragLeave = _this.onDragLeave.bind(_this);
	    _this.onDragOver = _this.onDragOver.bind(_this);
	    _this.onDrop = _this.onDrop.bind(_this);
	    _this.onFileDialogCancel = _this.onFileDialogCancel.bind(_this);
	    _this.setRef = _this.setRef.bind(_this);
	    _this.isFileDialogActive = false;
	    _this.state = {
	      draggedFiles: [],
	      acceptedFiles: [],
	      rejectedFiles: []
	    };
	    return _this;
	  }
	
	  _createClass(Dropzone, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var preventDropOnDocument = this.props.preventDropOnDocument;
	
	      this.dragTargets = [];
	
	      if (preventDropOnDocument) {
	        document.addEventListener('dragover', Dropzone.onDocumentDragOver, false);
	        document.addEventListener('drop', this.onDocumentDrop, false);
	      }
	      // Tried implementing addEventListener, but didn't work out
	      document.body.onfocus = this.onFileDialogCancel;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var preventDropOnDocument = this.props.preventDropOnDocument;
	
	      if (preventDropOnDocument) {
	        document.removeEventListener('dragover', Dropzone.onDocumentDragOver);
	        document.removeEventListener('drop', this.onDocumentDrop);
	      }
	      // Can be replaced with removeEventListener, if addEventListener works
	      document.body.onfocus = null;
	    }
	  }, {
	    key: 'onDocumentDrop',
	    value: function onDocumentDrop(e) {
	      if (this.node.contains(e.target)) {
	        // if we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
	        return;
	      }
	      e.preventDefault();
	      this.dragTargets = [];
	    }
	  }, {
	    key: 'onDragStart',
	    value: function onDragStart(e) {
	      if (this.props.onDragStart) {
	        this.props.onDragStart.call(this, e);
	      }
	    }
	  }, {
	    key: 'onDragEnter',
	    value: function onDragEnter(e) {
	      e.preventDefault();
	
	      // Count the dropzone and any children that are entered.
	      if (this.dragTargets.indexOf(e.target) === -1) {
	        this.dragTargets.push(e.target);
	      }
	
	      this.setState({ draggedFiles: (0, _getDataTransferItems2.default)(e) });
	
	      if (this.props.onDragEnter) {
	        this.props.onDragEnter.call(this, e);
	      }
	    }
	  }, {
	    key: 'onDragOver',
	    value: function onDragOver(e) {
	      // eslint-disable-line class-methods-use-this
	      e.preventDefault();
	      e.stopPropagation();
	      try {
	        e.dataTransfer.dropEffect = 'copy'; // eslint-disable-line no-param-reassign
	      } catch (err) {
	        // continue regardless of error
	      }
	
	      if (this.props.onDragOver) {
	        this.props.onDragOver.call(this, e);
	      }
	      return false;
	    }
	  }, {
	    key: 'onDragLeave',
	    value: function onDragLeave(e) {
	      var _this2 = this;
	
	      e.preventDefault();
	
	      // Only deactivate once the dropzone and all children have been left.
	      this.dragTargets = this.dragTargets.filter(function (el) {
	        return el !== e.target && _this2.node.contains(el);
	      });
	      if (this.dragTargets.length > 0) {
	        return;
	      }
	
	      // Clear dragging files state
	      this.setState({ draggedFiles: [] });
	
	      if (this.props.onDragLeave) {
	        this.props.onDragLeave.call(this, e);
	      }
	    }
	  }, {
	    key: 'onDrop',
	    value: function onDrop(e) {
	      var _this3 = this;
	
	      var _props = this.props,
	          onDrop = _props.onDrop,
	          onDropAccepted = _props.onDropAccepted,
	          onDropRejected = _props.onDropRejected,
	          multiple = _props.multiple,
	          disablePreview = _props.disablePreview,
	          accept = _props.accept;
	
	      var fileList = (0, _getDataTransferItems2.default)(e);
	      var acceptedFiles = [];
	      var rejectedFiles = [];
	
	      // Stop default browser behavior
	      e.preventDefault();
	
	      // Reset the counter along with the drag on a drop.
	      this.dragTargets = [];
	      this.isFileDialogActive = false;
	
	      fileList.forEach(function (file) {
	        if (!disablePreview) {
	          try {
	            file.preview = window.URL.createObjectURL(file); // eslint-disable-line no-param-reassign
	          } catch (err) {
	            if (process.env.NODE_ENV !== 'production') {
	              console.error('Failed to generate preview for file', file, err); // eslint-disable-line no-console
	            }
	          }
	        }
	
	        if (fileAccepted(file, accept) && _this3.fileMatchSize(file)) {
	          acceptedFiles.push(file);
	        } else {
	          rejectedFiles.push(file);
	        }
	      });
	
	      if (!multiple) {
	        // if not in multi mode add any extra accepted files to rejected.
	        // This will allow end users to easily ignore a multi file drop in "single" mode.
	        rejectedFiles.push.apply(rejectedFiles, _toConsumableArray(acceptedFiles.splice(1)));
	      }
	
	      if (onDrop) {
	        onDrop.call(this, acceptedFiles, rejectedFiles, e);
	      }
	
	      if (rejectedFiles.length > 0 && onDropRejected) {
	        onDropRejected.call(this, rejectedFiles, e);
	      }
	
	      if (acceptedFiles.length > 0 && onDropAccepted) {
	        onDropAccepted.call(this, acceptedFiles, e);
	      }
	
	      // Clear files value
	      this.draggedFiles = null;
	
	      // Reset drag state
	      this.setState({
	        draggedFiles: [],
	        acceptedFiles: acceptedFiles,
	        rejectedFiles: rejectedFiles
	      });
	    }
	  }, {
	    key: 'onClick',
	    value: function onClick(e) {
	      var _props2 = this.props,
	          onClick = _props2.onClick,
	          disableClick = _props2.disableClick;
	
	      if (!disableClick) {
	        e.stopPropagation();
	        this.open();
	        if (onClick) {
	          onClick.call(this, e);
	        }
	      }
	    }
	  }, {
	    key: 'onFileDialogCancel',
	    value: function onFileDialogCancel() {
	      // timeout will not recognize context of this method
	      var onFileDialogCancel = this.props.onFileDialogCancel;
	      var fileInputEl = this.fileInputEl;
	      var isFileDialogActive = this.isFileDialogActive;
	      // execute the timeout only if the onFileDialogCancel is defined and FileDialog
	      // is opened in the browser
	
	      if (onFileDialogCancel && isFileDialogActive) {
	        setTimeout(function () {
	          // Returns an object as FileList
	          var FileList = fileInputEl.files;
	          if (!FileList.length) {
	            isFileDialogActive = false;
	            onFileDialogCancel();
	          }
	        }, 300);
	      }
	    }
	  }, {
	    key: 'setRef',
	    value: function setRef(ref) {
	      this.node = ref;
	    }
	  }, {
	    key: 'fileMatchSize',
	    value: function fileMatchSize(file) {
	      return file.size <= this.props.maxSize && file.size >= this.props.minSize;
	    }
	  }, {
	    key: 'allFilesAccepted',
	    value: function allFilesAccepted(files) {
	      var _this4 = this;
	
	      return files.every(function (file) {
	        return fileAccepted(file, _this4.props.accept);
	      });
	    }
	
	    /**
	     * Open system file upload dialog.
	     *
	     * @public
	     */
	
	  }, {
	    key: 'open',
	    value: function open() {
	      this.isFileDialogActive = true;
	      this.fileInputEl.value = null;
	      this.fileInputEl.click();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _props3 = this.props,
	          accept = _props3.accept,
	          activeClassName = _props3.activeClassName,
	          inputProps = _props3.inputProps,
	          multiple = _props3.multiple,
	          name = _props3.name,
	          rejectClassName = _props3.rejectClassName,
	          children = _props3.children,
	          rest = _objectWithoutProperties(_props3, ['accept', 'activeClassName', 'inputProps', 'multiple', 'name', 'rejectClassName', 'children']);
	
	      var activeStyle = rest.activeStyle,
	          className = rest.className,
	          rejectStyle = rest.rejectStyle,
	          style = rest.style,
	          props = _objectWithoutProperties(rest, ['activeStyle', 'className', 'rejectStyle', 'style']);
	
	      var draggedFiles = this.state.draggedFiles;
	
	      var filesCount = draggedFiles.length;
	      var isMultipleAllowed = multiple || filesCount <= 1;
	      var isDragActive = filesCount > 0 && this.allFilesAccepted(draggedFiles);
	      var isDragReject = filesCount > 0 && (!isDragActive || !isMultipleAllowed);
	
	      className = className || '';
	
	      if (isDragActive && activeClassName) {
	        className += ' ' + activeClassName;
	      }
	      if (isDragReject && rejectClassName) {
	        className += ' ' + rejectClassName;
	      }
	
	      if (!className && !style && !activeStyle && !rejectStyle) {
	        style = {
	          width: 200,
	          height: 200,
	          borderWidth: 2,
	          borderColor: '#666',
	          borderStyle: 'dashed',
	          borderRadius: 5
	        };
	        activeStyle = {
	          borderStyle: 'solid',
	          borderColor: '#6c6',
	          backgroundColor: '#eee'
	        };
	        rejectStyle = {
	          borderStyle: 'solid',
	          borderColor: '#c66',
	          backgroundColor: '#eee'
	        };
	      }
	
	      var appliedStyle = void 0;
	      if (activeStyle && isDragActive) {
	        appliedStyle = _extends({}, style, activeStyle);
	      } else if (rejectStyle && isDragReject) {
	        appliedStyle = _extends({}, style, rejectStyle);
	      } else {
	        appliedStyle = _extends({}, style);
	      }
	
	      var inputAttributes = {
	        accept: accept,
	        type: 'file',
	        style: { display: 'none' },
	        multiple: supportMultiple && multiple,
	        ref: function ref(el) {
	          return _this5.fileInputEl = el;
	        }, // eslint-disable-line
	        onChange: this.onDrop
	      };
	
	      if (name && name.length) {
	        inputAttributes.name = name;
	      }
	
	      // Remove custom properties before passing them to the wrapper div element
	      var customProps = ['acceptedFiles', 'preventDropOnDocument', 'disablePreview', 'disableClick', 'onDropAccepted', 'onDropRejected', 'onFileDialogCancel', 'maxSize', 'minSize'];
	      var divProps = _extends({}, props);
	      customProps.forEach(function (prop) {
	        return delete divProps[prop];
	      });
	
	      return _react2.default.createElement(
	        'div',
	        _extends({
	          className: className,
	          style: appliedStyle
	        }, divProps /* expand user provided props first so event handlers are never overridden */, {
	          onClick: this.onClick,
	          onDragStart: this.onDragStart,
	          onDragEnter: this.onDragEnter,
	          onDragOver: this.onDragOver,
	          onDragLeave: this.onDragLeave,
	          onDrop: this.onDrop,
	          ref: this.setRef
	        }),
	        this.renderChildren(children, isDragActive, isDragReject),
	        _react2.default.createElement('input', _extends({}, inputProps /* expand user provided inputProps first so inputAttributes override them */, inputAttributes))
	      );
	    }
	  }]);
	
	  return Dropzone;
	}(_react2.default.Component);
	
	Dropzone.propTypes = {
	  /**
	   * Allow specific types of files. See https://github.com/okonet/attr-accept for more information.
	   * Keep in mind that mime type determination is not reliable accross platforms. CSV files,
	   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
	   * Windows. In some cases there might not be a mime type set at all.
	   * See: https://github.com/okonet/react-dropzone/issues/276
	   */
	  accept: _propTypes2.default.string,
	
	  /**
	   * Contents of the dropzone
	   */
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
	
	  /**
	   * Disallow clicking on the dropzone container to open file dialog
	   */
	  disableClick: _propTypes2.default.bool,
	
	  /**
	   * Enable/disable preview generation
	   */
	  disablePreview: _propTypes2.default.bool,
	
	  /**
	   * If false, allow dropped items to take over the current browser window
	   */
	  preventDropOnDocument: _propTypes2.default.bool,
	
	  /**
	   * Pass additional attributes to the `<input type="file"/>` tag
	   */
	  inputProps: _propTypes2.default.object,
	
	  /**
	   * Allow dropping multiple files
	   */
	  multiple: _propTypes2.default.bool,
	
	  /**
	   * `name` attribute for the input tag
	   */
	  name: _propTypes2.default.string,
	
	  /**
	   * Maximum file size
	   */
	  maxSize: _propTypes2.default.number,
	
	  /**
	   * Minimum file size
	   */
	  minSize: _propTypes2.default.number,
	
	  /**
	   * className
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * className for accepted state
	   */
	  activeClassName: _propTypes2.default.string,
	
	  /**
	   * className for rejected state
	   */
	  rejectClassName: _propTypes2.default.string,
	
	  /**
	   * CSS styles to apply
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * CSS styles to apply when drop will be accepted
	   */
	  activeStyle: _propTypes2.default.object,
	
	  /**
	   * CSS styles to apply when drop will be rejected
	   */
	  rejectStyle: _propTypes2.default.object,
	
	  /**
	   * onClick callback
	   * @param {Event} event
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * onDrop callback
	   */
	  onDrop: _propTypes2.default.func,
	
	  /**
	   * onDropAccepted callback
	   */
	  onDropAccepted: _propTypes2.default.func,
	
	  /**
	   * onDropRejected callback
	   */
	  onDropRejected: _propTypes2.default.func,
	
	  /**
	   * onDragStart callback
	   */
	  onDragStart: _propTypes2.default.func,
	
	  /**
	   * onDragEnter callback
	   */
	  onDragEnter: _propTypes2.default.func,
	
	  /**
	   * onDragOver callback
	   */
	  onDragOver: _propTypes2.default.func,
	
	  /**
	   * onDragLeave callback
	   */
	  onDragLeave: _propTypes2.default.func,
	
	  /**
	   * Provide a callback on clicking the cancel button of the file dialog
	   */
	  onFileDialogCancel: _propTypes2.default.func
	};
	
	Dropzone.defaultProps = {
	  preventDropOnDocument: true,
	  disablePreview: false,
	  disableClick: false,
	  multiple: true,
	  maxSize: Infinity,
	  minSize: 0
	};
	
	exports.default = Dropzone;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	module.exports=function(t){function n(e){if(r[e])return r[e].exports;var o=r[e]={exports:{},id:e,loaded:!1};return t[e].call(o.exports,o,o.exports,n),o.loaded=!0,o.exports}var r={};return n.m=t,n.c=r,n.p="",n(0)}([function(t,n,r){"use strict";n.__esModule=!0,r(8),r(9),n["default"]=function(t,n){if(t&&n){var r=function(){var r=Array.isArray(n)?n:n.split(","),e=t.name||"",o=t.type||"",i=o.replace(/\/.*$/,"");return{v:r.some(function(t){var n=t.trim();return"."===n.charAt(0)?e.toLowerCase().endsWith(n.toLowerCase()):/\/\*$/.test(n)?i===n.replace(/\/.*$/,""):o===n})}}();if("object"==typeof r)return r.v}return!0},t.exports=n["default"]},function(t,n){var r=t.exports={version:"1.2.2"};"number"==typeof __e&&(__e=r)},function(t,n){var r=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=r)},function(t,n,r){var e=r(2),o=r(1),i=r(4),u=r(19),c="prototype",f=function(t,n){return function(){return t.apply(n,arguments)}},s=function(t,n,r){var a,p,l,y,d=t&s.G,h=t&s.P,v=d?e:t&s.S?e[n]||(e[n]={}):(e[n]||{})[c],x=d?o:o[n]||(o[n]={});d&&(r=n);for(a in r)p=!(t&s.F)&&v&&a in v,l=(p?v:r)[a],y=t&s.B&&p?f(l,e):h&&"function"==typeof l?f(Function.call,l):l,v&&!p&&u(v,a,l),x[a]!=l&&i(x,a,y),h&&((x[c]||(x[c]={}))[a]=l)};e.core=o,s.F=1,s.G=2,s.S=4,s.P=8,s.B=16,s.W=32,t.exports=s},function(t,n,r){var e=r(5),o=r(18);t.exports=r(22)?function(t,n,r){return e.setDesc(t,n,o(1,r))}:function(t,n,r){return t[n]=r,t}},function(t,n){var r=Object;t.exports={create:r.create,getProto:r.getPrototypeOf,isEnum:{}.propertyIsEnumerable,getDesc:r.getOwnPropertyDescriptor,setDesc:r.defineProperty,setDescs:r.defineProperties,getKeys:r.keys,getNames:r.getOwnPropertyNames,getSymbols:r.getOwnPropertySymbols,each:[].forEach}},function(t,n){var r=0,e=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++r+e).toString(36))}},function(t,n,r){var e=r(20)("wks"),o=r(2).Symbol;t.exports=function(t){return e[t]||(e[t]=o&&o[t]||(o||r(6))("Symbol."+t))}},function(t,n,r){r(26),t.exports=r(1).Array.some},function(t,n,r){r(25),t.exports=r(1).String.endsWith},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,n){var r={}.toString;t.exports=function(t){return r.call(t).slice(8,-1)}},function(t,n,r){var e=r(10);t.exports=function(t,n,r){if(e(t),void 0===n)return t;switch(r){case 1:return function(r){return t.call(n,r)};case 2:return function(r,e){return t.call(n,r,e)};case 3:return function(r,e,o){return t.call(n,r,e,o)}}return function(){return t.apply(n,arguments)}}},function(t,n){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,n,r){t.exports=function(t){var n=/./;try{"/./"[t](n)}catch(e){try{return n[r(7)("match")]=!1,!"/./"[t](n)}catch(o){}}return!0}},function(t,n){t.exports=function(t){try{return!!t()}catch(n){return!0}}},function(t,n){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,n,r){var e=r(16),o=r(11),i=r(7)("match");t.exports=function(t){var n;return e(t)&&(void 0!==(n=t[i])?!!n:"RegExp"==o(t))}},function(t,n){t.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}}},function(t,n,r){var e=r(2),o=r(4),i=r(6)("src"),u="toString",c=Function[u],f=(""+c).split(u);r(1).inspectSource=function(t){return c.call(t)},(t.exports=function(t,n,r,u){"function"==typeof r&&(o(r,i,t[n]?""+t[n]:f.join(String(n))),"name"in r||(r.name=n)),t===e?t[n]=r:(u||delete t[n],o(t,n,r))})(Function.prototype,u,function(){return"function"==typeof this&&this[i]||c.call(this)})},function(t,n,r){var e=r(2),o="__core-js_shared__",i=e[o]||(e[o]={});t.exports=function(t){return i[t]||(i[t]={})}},function(t,n,r){var e=r(17),o=r(13);t.exports=function(t,n,r){if(e(n))throw TypeError("String#"+r+" doesn't accept regex!");return String(o(t))}},function(t,n,r){t.exports=!r(15)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,n){var r=Math.ceil,e=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?e:r)(t)}},function(t,n,r){var e=r(23),o=Math.min;t.exports=function(t){return t>0?o(e(t),9007199254740991):0}},function(t,n,r){"use strict";var e=r(3),o=r(24),i=r(21),u="endsWith",c=""[u];e(e.P+e.F*r(14)(u),"String",{endsWith:function(t){var n=i(this,t,u),r=arguments,e=r.length>1?r[1]:void 0,f=o(n.length),s=void 0===e?f:Math.min(o(e),f),a=String(t);return c?c.call(n,a,s):n.slice(s-a.length,s)===a}})},function(t,n,r){var e=r(5),o=r(3),i=r(1).Array||Array,u={},c=function(t,n){e.each.call(t.split(","),function(t){void 0==n&&t in i?u[t]=i[t]:t in[]&&(u[t]=r(12)(Function.call,[][t],n))})};c("pop,reverse,shift,keys,values,entries",1),c("indexOf,every,some,forEach,map,filter,find,findIndex,includes",3),c("join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill"),o(o.S,"Array",u)}]);

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDataTransferFiles;
	function getDataTransferFiles(event) {
	  var dataTransferItemsList = [];
	  if (event.dataTransfer) {
	    var dt = event.dataTransfer;
	    if (dt.files && dt.files.length) {
	      dataTransferItemsList = dt.files;
	    } else if (dt.items && dt.items.length) {
	      // During the drag even the dataTransfer.files is null
	      // but Chrome implements some drag store, which is accesible via dataTransfer.items
	      dataTransferItemsList = dt.items;
	    }
	  } else if (event.target && event.target.files) {
	    dataTransferItemsList = event.target.files;
	  }
	  // Convert from DataTransferItemsList to the native Array
	  return Array.prototype.slice.call(dataTransferItemsList);
	}
	module.exports = exports["default"];

/***/ })
/******/ ])
});
;
//# sourceMappingURL=index.js.map

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(9), __webpack_require__(66), __webpack_require__(3), __webpack_require__(20), __webpack_require__(16), __webpack_require__(14), __webpack_require__(63), __webpack_require__(116), __webpack_require__(84)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('react-dom'), require('react-transition-group/CSSTransitionGroup'), require('classnames'), require('../utils/PropTypes/controlled'), require('../utils/getField'), require('../constants/keyCodes'), require('../Lists/ListItem'), require('../Menus/Menu'), require('../TextFields/TextField'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.reactDom, global.CSSTransitionGroup, global.classnames, global.controlled, global.getField, global.keyCodes, global.ListItem, global.Menu, global.TextField);
    global.Autocomplete = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _reactDom, _CSSTransitionGroup, _classnames, _controlled, _getField, _keyCodes, _ListItem, _Menu, _TextField) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _controlled2 = _interopRequireDefault(_controlled);

  var _getField2 = _interopRequireDefault(_getField);

  var _ListItem2 = _interopRequireDefault(_ListItem);

  var _Menu2 = _interopRequireDefault(_Menu);

  var _TextField2 = _interopRequireDefault(_TextField);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Autocomplete = function (_PureComponent) {
    _inherits(Autocomplete, _PureComponent);

    _createClass(Autocomplete, null, [{
      key: 'caseInsensitiveFilter',
      value: function caseInsensitiveFilter(haystack, filterText, dataLabel) {
        var needle = filterText.toLowerCase();

        return haystack.filter(function (hay) {
          if (hay === null || typeof hay === 'undefined') {
            return false;
          } else if (_react2.default.isValidElement(hay)) {
            return true;
          }

          var value = void 0;
          switch (typeof hay === 'undefined' ? 'undefined' : _typeof(hay)) {
            case 'string':
            case 'number':
              value = hay.toString();
              break;
            default:
              value = hay[dataLabel];
          }

          return value && value.toLowerCase().indexOf(needle) !== -1;
        });
      }
    }, {
      key: 'fuzzyFilter',
      value: function fuzzyFilter(haystack, needle, dataLabel) {
        // Create an amazing regex that matches the letters in order
        // and escapes any strings that could be part of a regex.
        var reg = new RegExp(('' + needle).split('').join('\\w*').replace(/(\(|\||\)|\\(?!w\*)|\[|\|-|\.|\^|\+|\$|\?|^(?!w)\*)/g, '\\$1')
        // Couldn't get the matching of two '*' working, so replace them here..
        .replace(/\*\*/g, '*\\*'), 'i');

        return haystack.filter(function (hay) {
          if (hay === null || typeof hay === 'undefined') {
            return false;
          } else if (_react2.default.isValidElement(hay)) {
            return true;
          }

          var value = void 0;
          switch (typeof hay === 'undefined' ? 'undefined' : _typeof(hay)) {
            case 'string':
            case 'number':
              value = hay.toString();
              break;
            default:
              value = hay[dataLabel];
          }

          return value && value.match(reg);
        });
      }
    }, {
      key: 'findIgnoreCase',
      value: function findIgnoreCase(haystack, value, dataLabel) {
        var needle = value ? value.toLowerCase() : '';

        if (!needle) {
          return needle;
        }

        var suggestion = '';
        haystack.some(function (hay) {
          if (hay === null || typeof hay === 'undefined' || _react2.default.isValidElement(hay)) {
            return false;
          }

          var hayStr = (typeof hay === 'undefined' ? 'undefined' : _typeof(hay)) === 'object' ? hay[dataLabel] : hay.toString();

          if (hayStr.toLowerCase().indexOf(needle) === 0) {
            suggestion = hayStr;
          }

          return suggestion;
        });

        return suggestion;
      }
    }]);

    function Autocomplete(props) {
      _classCallCheck(this, Autocomplete);

      var _this = _possibleConstructorReturn(this, (Autocomplete.__proto__ || Object.getPrototypeOf(Autocomplete)).call(this, props));

      var defaultValue = props.defaultValue,
          data = props.data,
          dataLabel = props.dataLabel,
          filter = props.filter;


      var matches = [];
      if (defaultValue && filter) {
        matches = filter(data, defaultValue, dataLabel);
      } else if (!filter) {
        matches = data;
      }

      _this.state = {
        value: defaultValue,
        matches: matches,
        isOpen: false,
        matchIndex: -1,
        manualFocus: false,
        suggestionIndex: -1
      };

      _this._setField = _this._setField.bind(_this);
      _this._setMenu = _this._setMenu.bind(_this);
      _this._setSuggestion = _this._setSuggestion.bind(_this);
      _this._close = _this._close.bind(_this);
      _this._updateFont = _this._updateFont.bind(_this);
      _this._handleBlur = _this._handleBlur.bind(_this);
      _this._handleFocus = _this._handleFocus.bind(_this);
      _this._handleClick = _this._handleClick.bind(_this);
      _this._handleChange = _this._handleChange.bind(_this);
      _this._handleItemClick = _this._handleItemClick.bind(_this);
      _this._handleTouchStart = _this._handleTouchStart.bind(_this);
      _this._handleMenuKeyDown = _this._handleMenuKeyDown.bind(_this);
      _this._handleTextFieldKeyDown = _this._handleTextFieldKeyDown.bind(_this);
      _this._focusSuggestion = _this._focusSuggestion.bind(_this);
      _this._findInlineSuggestions = _this._findInlineSuggestions.bind(_this);
      _this._mapToListItem = _this._mapToListItem.bind(_this);
      _this._toggleMenu = _this._toggleMenu.bind(_this);
      _this._updateSuggestionStyle = _this._updateSuggestionStyle.bind(_this);
      return _this;
    }

    _createClass(Autocomplete, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (this.props.inline) {
          window.addEventListener('resize', this._updateFont);
        }
      }
    }, {
      key: 'componentWillUpdate',
      value: function componentWillUpdate(nextProps, nextState) {
        if (this.state.isOpen !== nextState.isOpen) {
          var menuFn = nextProps['onMenu' + (nextState.isOpen ? 'Open' : 'Close')];
          if (menuFn) {
            menuFn();
          }
        }

        if (this.props.inline !== nextProps.inline) {
          if (nextProps.inline) {
            this._updateFont();
            window.addEventListener('resize', this._updateFont);
          } else {
            window.removeEventListener('resize', this._updateFont);
          }
        }

        if (nextProps.data !== this.props.data || nextProps.value !== this.props.value) {
          var data = nextProps.data,
              filter = nextProps.filter,
              dataLabel = nextProps.dataLabel;

          var value = (0, _getField2.default)(nextProps, nextState, 'value');

          var matches = filter ? filter(data, value, dataLabel) : data;
          var next = { matches: matches };
          if (nextState.focus) {
            next.isOpen = !!matches.length;
          }

          this.setState(next);
        }
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps, prevState) {
        var suggestion = this.state.suggestion;

        this._updateSuggestionStyle(suggestion && !prevState.suggestion, !suggestion && prevState.suggestion);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.props.inline) {
          window.removeEventListener('resize', this._updateFont);
        }
      }
    }, {
      key: '_updateSuggestionStyle',
      value: function _updateSuggestionStyle(isNew, isDeleted) {
        if (isNew) {
          var msg = (0, _reactDom.findDOMNode)(this).querySelector('.md-text-field-message');

          if (msg) {
            var cs = window.getComputedStyle(this._suggestion);
            var bottom = parseInt(cs.getPropertyValue('bottom'), 10) + msg.offsetHeight;

            this.setState({
              suggestionStyle: Object.assign({}, this.state.suggestionStyle, { bottom: bottom })
            });
          }
        } else if (isDeleted) {
          var suggestionStyle = Object.assign({}, this.state.suggestionStyle);
          delete suggestionStyle.bottom;

          this.setState({ suggestionStyle: suggestionStyle });
        }
      }
    }, {
      key: '_updateFont',
      value: function _updateFont() {
        if (this._field) {
          var cs = window.getComputedStyle(this._field);
          this.setState({
            fontSize: parseInt(cs.getPropertyValue('font-size'), 10),
            font: cs.getPropertyValue('font')
          });
        }
      }
    }, {
      key: '_close',
      value: function _close() {
        if (this.props.onBlur) {
          this.props.onBlur();
        }

        this.setState({ focus: false, isOpen: false });
      }
    }, {
      key: '_handleChange',
      value: function _handleChange(value, event) {
        var _props = this.props,
            onChange = _props.onChange,
            filter = _props.filter,
            findInlineSuggestion = _props.findInlineSuggestion,
            data = _props.data,
            dataLabel = _props.dataLabel,
            inline = _props.inline;


        if (onChange) {
          onChange(value, event);
        }

        if (inline) {
          // If findInlineSuggestion does not exist, assume that `onChange` will handle it.
          return findInlineSuggestion ? this._findInlineSuggestions(value) : null;
        }

        var isOpen = this.state.isOpen;

        var matches = value ? this.state.matches : [];
        if (value && filter) {
          matches = filter(data, value, dataLabel);
        }

        if (filter) {
          isOpen = !!matches.length;
        }

        return this.setState({ matches: matches, isOpen: isOpen, value: value });
      }
    }, {
      key: '_handleFocus',
      value: function _handleFocus(e) {
        if (this.props.onFocus) {
          this.props.onFocus(e);
        }

        this.setState({
          matchIndex: -1,
          isOpen: !this.state.manualFocus && !!(0, _getField2.default)(this.props, this.state, 'value') && !!this.state.matches.length,
          manualFocus: false,
          focus: true
        });
      }
    }, {
      key: '_handleBlur',
      value: function _handleBlur(e) {
        if (this.props.inline) {
          if (this.props.onBlur) {
            this.props.onBlur(e);
          }

          this.setState({ focus: false });
        }
      }
    }, {
      key: '_handleTextFieldKeyDown',
      value: function _handleTextFieldKeyDown(e) {
        var _props2 = this.props,
            inline = _props2.inline,
            data = _props2.data,
            dataLabel = _props2.dataLabel,
            onKeyDown = _props2.onKeyDown,
            onAutocomplete = _props2.onAutocomplete;
        var suggestionIndex = this.state.suggestionIndex;


        var key = e.which || e.keyCode;
        if (onKeyDown) {
          onKeyDown(e);
        }

        if (inline && key === _keyCodes.TAB && suggestionIndex !== -1) {
          // Autocomplete the text field
          e.preventDefault();

          var value = data[suggestionIndex];
          if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
            value = value[dataLabel];
          }

          if (onAutocomplete) {
            onAutocomplete(value, suggestionIndex, this.state.matches);
          }

          this.setState({
            value: value,
            suggestion: '',
            suggestionIndex: -1,
            tabbed: true
          });
        }
      }
    }, {
      key: '_handleMenuKeyDown',
      value: function _handleMenuKeyDown(e) {
        var key = e.which || e.keyCode;
        if (key === _keyCodes.TAB) {
          if (this.props.onBlur) {
            this.props.onBlur();
          }

          this.setState({ isOpen: false });
        } else if (key === _keyCodes.UP || key === _keyCodes.DOWN) {
          this._focusSuggestion(key === _keyCodes.UP, e);
        } else if ((key === _keyCodes.ENTER || key === _keyCodes.SPACE) && e.target.classList.contains('md-list-tile')) {
          // Prevent any form submissions
          e.preventDefault();

          // Need to emulate the click event since the default enter/space don't work for some reason
          e.target.click();
          this._handleItemClick(this.state.matchIndex);
        }
      }
    }, {
      key: '_handleClick',
      value: function _handleClick(e) {
        var target = e.target;
        while (target && target.parentNode) {
          if (target.classList.contains('md-list-item')) {
            var items = target.parentNode.querySelectorAll('.md-list-item');
            items = Array.prototype.slice.call(items);

            return this._handleItemClick(items.indexOf(target));
          }

          target = target.parentNode;
        }

        return null;
      }
    }, {
      key: '_handleItemClick',
      value: function _handleItemClick(index) {
        var _this2 = this;

        if (index === -1) {
          return;
        }

        var matches = this.state.matches;
        var _props3 = this.props,
            data = _props3.data,
            dataLabel = _props3.dataLabel,
            filter = _props3.filter,
            onAutocomplete = _props3.onAutocomplete,
            clearOnAutocomplete = _props3.clearOnAutocomplete;

        var value = matches.filter(function (m) {
          return !_react2.default.isValidElement(m);
        })[index];
        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
          value = value[dataLabel];
        }

        if (onAutocomplete) {
          onAutocomplete(value, index, matches);
        }

        value = clearOnAutocomplete ? '' : value;
        this.setState({
          isOpen: false,
          manualFocus: true,
          matches: filter ? filter(data, value, dataLabel) : matches,
          value: value
        }, function () {
          _this2._field.focus();
        });
      }
    }, {
      key: '_focusSuggestion',
      value: function _focusSuggestion(negative, e) {
        e.preventDefault();
        var _state = this.state,
            matchIndex = _state.matchIndex,
            matches = _state.matches;

        var l = matches.length;

        var index = void 0;
        if (negative && matchIndex === -1 || !negative && matchIndex >= l) {
          return;
        } else if (negative) {
          index = matchIndex - 1;
          if (index === -1) {
            this._field.focus();
          }
        } else {
          index = Math.min(l, matchIndex + 1);
        }

        if (index !== -1 && index !== matchIndex) {
          var item = this._menu.querySelectorAll('.md-list-tile')[index];
          if (item) {
            item.focus();
          }
        }

        this.setState({ matchIndex: index });
      }
    }, {
      key: '_findInlineSuggestions',
      value: function _findInlineSuggestions(value) {
        var _props4 = this.props,
            data = _props4.data,
            dataLabel = _props4.dataLabel,
            findInlineSuggestion = _props4.findInlineSuggestion;
        var _state2 = this.state,
            font = _state2.font,
            fontSize = _state2.fontSize;
        var suggestionStyle = this.state.suggestionStyle;


        var suggestion = findInlineSuggestion(data, value, dataLabel);
        if ((typeof suggestion === 'undefined' ? 'undefined' : _typeof(suggestion)) === 'object') {
          throw new Error('`findInlineSuggestion` should return a string or a number, but got an object.', suggestion);
        }

        var suggestionIndex = -1;

        if (suggestion) {
          // Find index of suggestion
          data.some(function (datum, i) {
            var d = (typeof dataum === 'undefined' ? 'undefined' : _typeof(dataum)) === 'object' ? datum[dataLabel] : datum;
            if (d === suggestion) {
              suggestionIndex = i;
            }

            return suggestionIndex !== -1;
          });

          // Strip already used letters
          suggestion = suggestion.toString().substring(value.length, suggestion.length);

          // Calculate distance to move the suggestion to already existing text
          var canvas = document.createElement('canvas');
          var context = canvas.getContext('2d');

          if (context) {
            // context doesn't exist in jsdom with jest
            context.font = font;
            var padding = this.props.block ? fontSize * 1.5 : 8;

            // Update suggestion style to be offset and not expand past text field
            var left = context.measureText(value).width + padding;
            suggestionStyle = Object.assign({}, suggestionStyle, { left: left });
          }
        }

        this.setState({ value: value, suggestion: suggestion, suggestionIndex: suggestionIndex, suggestionStyle: suggestionStyle, tabbed: false });
      }
    }, {
      key: '_mapToListItem',
      value: function _mapToListItem(match) {
        if (_react2.default.isValidElement(match)) {
          return match;
        }

        var _props5 = this.props,
            dataLabel = _props5.dataLabel,
            dataValue = _props5.dataValue,
            deleteKeys = _props5.deleteKeys;

        var props = void 0;
        switch (typeof match === 'undefined' ? 'undefined' : _typeof(match)) {
          case 'string':
          case 'number':
            props = {
              key: match,
              primaryText: match
            };
            break;
          default:
            props = _extends({}, match, {
              key: match.key || dataValue && match[dataValue] || match[dataLabel],
              primaryText: match[dataLabel]
            });

            if (typeof deleteKeys === 'string') {
              delete props[deleteKeys];
            } else if (Array.isArray(deleteKeys)) {
              deleteKeys.forEach(function (key) {
                delete props[key];
              });
            }

        }

        // Allows focus, but does not let tab focus. This is so up and down keys work.
        return _react2.default.createElement(_ListItem2.default, _extends({ tabIndex: -1 }, props));
      }
    }, {
      key: '_toggleMenu',
      value: function _toggleMenu(e) {
        if (this.props.onMouseDown) {
          this.props.onMouseDown(e);
        }

        if (!this.props.inline && this.state.matches.length && (0, _getField2.default)(this.props, this.state, 'value')) {
          this.setState({ isOpen: !this.state.isOpen });
        }
      }
    }, {
      key: '_handleTouchStart',
      value: function _handleTouchStart(e) {
        var target = e.target;
        var _props6 = this.props,
            data = _props6.data,
            dataLabel = _props6.dataLabel,
            onAutocomplete = _props6.onAutocomplete;
        var _state3 = this.state,
            suggestionIndex = _state3.suggestionIndex,
            suggestion = _state3.suggestion;

        if (target.classList.contains('md-autocomplete-suggestion') && suggestion) {
          var value = data[suggestionIndex];
          if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
            value = value[dataLabel];
          }

          if (onAutocomplete) {
            onAutocomplete(value, suggestionIndex, data);
          }

          this.setState({
            value: value,
            suggestion: '',
            suggestionIndex: -1,
            tabbed: true
          });
        }
      }
    }, {
      key: '_setField',
      value: function _setField(field) {
        if (field) {
          this._field = field.getField();

          if (this.props.inline) {
            this._updateFont();
          }
        }
      }
    }, {
      key: '_setMenu',
      value: function _setMenu(menu) {
        this._menu = (0, _reactDom.findDOMNode)(menu);
      }
    }, {
      key: '_setSuggestion',
      value: function _setSuggestion(suggestion) {
        this._suggestion = suggestion;
      }
    }, {
      key: 'render',
      value: function render() {
        var _state4 = this.state,
            isOpen = _state4.isOpen,
            matches = _state4.matches,
            tabbed = _state4.tabbed,
            focus = _state4.focus,
            suggestionStyle = _state4.suggestionStyle;

        var _props7 = this.props,
            fullWidth = _props7.fullWidth,
            block = _props7.block,
            style = _props7.style,
            className = _props7.className,
            listStyle = _props7.listStyle,
            listClassName = _props7.listClassName,
            textFieldStyle = _props7.textFieldStyle,
            textFieldClassName = _props7.textFieldClassName,
            inline = _props7.inline,
            props = _objectWithoutProperties(_props7, ['fullWidth', 'block', 'style', 'className', 'listStyle', 'listClassName', 'textFieldStyle', 'textFieldClassName', 'inline']);

        delete props.value;
        delete props.defaultValue;
        delete props.dataLabel;
        delete props.dataValue;
        delete props.filter;
        delete props.data;
        delete props.onAutocomplete;
        delete props.onMenuOpen;
        delete props.onMenuClose;
        delete props.onBlur;
        delete props.onFocus;
        delete props.onKeyDown;
        delete props.onMouseDown;
        delete props.onChange;
        delete props.findInlineSuggestion;
        delete props.clearOnAutocomplete;
        delete props.deleteKeys;

        var value = (0, _getField2.default)(this.props, this.state, 'value');

        var autocomplete = _react2.default.createElement(_TextField2.default, _extends({}, props, {
          style: textFieldStyle,
          className: (0, _classnames2.default)('md-autocomplete', textFieldClassName),
          key: 'autocomplete',
          ref: this._setField,
          value: value,
          onKeyDown: this._handleTextFieldKeyDown,
          onMouseDown: this._toggleMenu,
          onChange: this._handleChange,
          onFocus: this._handleFocus,
          onBlur: this._handleBlur,
          fullWidth: fullWidth,
          block: block
        }));

        if (inline) {
          var suggestion = void 0;
          if (focus && this.state.suggestion) {
            suggestion = _react2.default.createElement(
              'span',
              {
                ref: this._setSuggestion,
                key: 'suggestion',
                style: suggestionStyle,
                className: (0, _classnames2.default)('md-autocomplete-suggestion', {
                  'md-autocomplete-suggestion--floating': props.label,
                  'md-autocomplete-suggestion--block': block
                })
              },
              this.state.suggestion
            );
          }

          return _react2.default.createElement(
            _CSSTransitionGroup2.default,
            {
              component: 'div',
              style: style,
              className: (0, _classnames2.default)('md-menu-container md-autocomplete-container', className, {
                'md-full-width': fullWidth || block
              }),
              transitionName: 'opacity',
              transitionEnterTimeout: 150,
              transitionLeave: !tabbed,
              transitionLeaveTimeout: 150,
              onTouchStart: this._handleTouchStart
            },
            autocomplete,
            suggestion
          );
        }

        return _react2.default.createElement(
          _Menu2.default,
          {
            ref: this._setMenu,
            toggle: autocomplete,
            isOpen: isOpen,
            onClick: this._handleClick,
            onClose: this._close,
            onKeyDown: this._handleMenuKeyDown,
            position: _Menu2.default.Positions.BELOW,
            fullWidth: fullWidth || block,
            style: style,
            className: (0, _classnames2.default)('md-autocomplete-container', className),
            listStyle: listStyle,
            listClassName: (0, _classnames2.default)('md-autocomplete-list', listClassName)
          },
          matches.map(this._mapToListItem)
        );
      }
    }]);

    return Autocomplete;
  }(_react.PureComponent);

  Autocomplete.propTypes = {
    /**
     * An optional style to apply to the menu that contains the autocomplete.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply to the menu that contains the autocomplete.
     */
    className: _propTypes2.default.string,

    /**
     * An optional style to apply to the autocomplete's text field.
     */
    textFieldStyle: _propTypes2.default.object,

    /**
     * An optional className to apply to the autocomplete's text field.
     */
    textFieldClassName: _propTypes2.default.string,

    /**
     * An optional style to apply to the autocomplete's text field input itself.
     */
    inputStyle: _propTypes2.default.object,

    /**
     * An optional className to apply to the autocomplete's input field iteself.
     */
    inputClassName: _propTypes2.default.string,

    /**
     * The optional style to apply to the opened menu List if the
     * `Autocomplete` is not using `inline` suggestions.
     */
    listStyle: _propTypes2.default.object,

    /**
     * The optional className to apply to the opened menu List if the
     * `Autocomplete` is not using `inline` suggestions.
     */
    listClassName: _propTypes2.default.string,

    /**
     * Boolean if the autocomplete is disabled.
     */
    disabled: _propTypes2.default.bool,

    /**
     * A label to display with the autocomplete.
     */
    label: _propTypes2.default.node,

    /**
     * An optional value to use for the text field. This will force this component
     * to be controlled and require the `onChange` function.
     */
    value: (0, _controlled2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]), 'onChange'),

    /**
     * The default value for the autocomplete's text field.
     */
    defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),

    /**
     * An object key to use to extract the text to be compared for filtering.
     * This will only be applied if the the given `data` prop is an array of objects.
     */
    dataLabel: _propTypes2.default.string.isRequired,

    /**
     * An optional object key to use to extract the `value` of the given `data` prop.
     * This is really only used with generating a unique react key. The unique react
     * key with either be:
     * - the datum if it is a string or number
     * - the `key` attribute of the datum object
     * - the `datum[dataValue]`
     * - or the `datum[dataLabel]`
     */
    dataValue: _propTypes2.default.string,

    /**
     * A single key or an array of keys to delete from your data object before passing
     * to the `ListItem` component.
     */
    deleteKeys: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),

    /**
     * The data that will be used for autocomplete suggestions. This can either be
     * an array of string, number, or object. If it is an array of objects, the key
     * `dataLabel` is required.
     *
     * ```docgen
     * PropTypes.arrayOf(PropTypes.oneOfType([
     *   PropTypes.element,
     *   PropTypes.string,
     *   PropTypes.number,
     *   PropTypes.shape({
     *     [dataLabel]: PropTypes.oneOfType([
     *       PropTypes.string,
     *       PropTypes.number,
     *     ]).isRequired,
     *   }),
     * ])).isRequired
     * ```
     */
    data: function data(props, propName, component) {
      for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        others[_key - 3] = arguments[_key];
      }

      var _PropTypes$arrayOf;

      var dataLabel = props.dataLabel;

      return (_PropTypes$arrayOf = _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.shape(_defineProperty({}, dataLabel, _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired))]))).isRequired.apply(_PropTypes$arrayOf, [props, propName, component].concat(others));
    },

    /**
     * An optional function to use to filter the `data`. If you have a sexy backend
     * using solr or some other seach/indexer, it is recommended to set this prop to
     * `null` or `false`-ish.
     */
    filter: _propTypes2.default.func,

    /**
     * An optional function to call when the `Autocomplete`'s text field has a `keydown` event.
     */
    onKeyDown: _propTypes2.default.func,

    /**
     * An optional function to call when the `Autocomplete`'s text field has a `mousedown` event.
     */
    onMouseDown: _propTypes2.default.func,

    /**
     * An optional function to call when the `Autocomplete`'s text field value changes.
     * The callback will be given the new value and the change event.
     *
     * `onChange(textFeldValue, event)`
     */
    onChange: _propTypes2.default.func,

    /**
     * An optional function to call when the `Autocomplete`'s text field is focused.
     */
    onFocus: _propTypes2.default.func,

    /**
     * An optional function to call when the entire `Autocomplete` component is blurred.
     * This will be triggered when the window is clicked or when a user tabs away from
     * the autocomplete.
     */
    onBlur: _propTypes2.default.func,

    /**
     * Boolean if this text field should be styled as a full width text field.
     * Floating labels and the text field indicator will be removed automatically.
     */
    block: _propTypes2.default.bool,

    /**
     * Boolean if the autocomplete should span the entire width.
     */
    fullWidth: _propTypes2.default.bool,

    /**
     * Boolean if the `Autocomplete` should display suggestions inline instead
     * of in a `Menu`.
     */
    inline: _propTypes2.default.bool,

    /**
     * The function to call to find a suggestion for an inline autocomplete. This function
     * expects to return a single result of a number or a string.
     *
     * ```js
     * @param {Array<Object|String|Number>} data - The data prop to search.
     * @param {String} value - The current value to use for searching.
     * @param {String} dataLabel - The `dataLabel` prop to use if a datum is an object.
     * @return {String|Number} the found suggestion or false-ish
     * ```
     */
    findInlineSuggestion: _propTypes2.default.func,

    /**
     * An optional function to call when an autocomplete suggestion is clicked either
     * by using the mouse, the enter/space key, or touch. The match index and current
     * `dataLabel` will be given back.
     *
     * `onAutocomplete(suggestion[dataLabel] || suggestion, suggestionIndex, matches);`
     */
    onAutocomplete: _propTypes2.default.func,

    /**
     * A boolean if the text field's value should be reset to the empty string when
     * an item is auto-completed. This is usefull if you do not want a fully controlled
     * component and the values are stored outside of the `TextField`. (like `Chips`).
     */
    clearOnAutocomplete: _propTypes2.default.bool,

    /**
     * An optional function to call when the `Autocomplete` suggestion menu opens.
     */
    onMenuOpen: _propTypes2.default.func,

    /**
     * An optional function to call when the `Autocomplete` suggestion menu closes.
     */
    onMenuClose: _propTypes2.default.func,

    /**
     * This prop is used for disabling the browser's default autocomplete suggestions
     * of previously typed values in the text field. By default, this is disabled.
     */
    autoComplete: _propTypes2.default.oneOf(['on', 'off'])
  };
  Autocomplete.defaultProps = {
    fullWidth: true,
    defaultValue: '',
    dataLabel: 'primaryText',
    filter: Autocomplete.fuzzyFilter,
    findInlineSuggestion: Autocomplete.findIgnoreCase,
    autoComplete: 'off'
  };
  exports.default = Autocomplete;
});

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(1199)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('../utils/PropTypes/oneRequiredForA11yIf'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.oneRequiredForA11yIf);
    global.Avatar = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _oneRequiredForA11yIf) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _oneRequiredForA11yIf2 = _interopRequireDefault(_oneRequiredForA11yIf);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Avatar = function (_PureComponent) {
    _inherits(Avatar, _PureComponent);

    function Avatar(props) {
      _classCallCheck(this, Avatar);

      var _this = _possibleConstructorReturn(this, (Avatar.__proto__ || Object.getPrototypeOf(Avatar)).call(this, props));

      _this.state = { color: null };

      _this._setRandomColor = _this._setRandomColor.bind(_this);
      return _this;
    }

    _createClass(Avatar, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        if (this.props.random) {
          this._setRandomColor();
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (nextProps.random && (this.props.src !== nextProps.src || this.props.icon !== nextProps.icon)) {
          this._setRandomColor();
        } else if (this.props.random && !nextProps.random) {
          this.setState({ color: null });
        }
      }
    }, {
      key: '_setRandomColor',
      value: function _setRandomColor() {
        var suffixes = this.props.suffixes;


        var i = Math.floor(Math.random() * (suffixes.length - 1)) + 1;
        this.setState({ color: suffixes[i] });
      }
    }, {
      key: '_getColor',
      value: function _getColor(suffix, suffixes, color) {
        if (suffix) {
          return 'md-avatar--' + suffix;
        } else if (!!suffixes && !color) {
          return 'md-avatar--default';
        }

        return 'md-avatar--' + color;
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            className = _props.className,
            src = _props.src,
            alt = _props.alt,
            icon = _props.icon,
            children = _props.children,
            suffix = _props.suffix,
            suffixes = _props.suffixes,
            iconSized = _props.iconSized,
            role = _props.role,
            props = _objectWithoutProperties(_props, ['className', 'src', 'alt', 'icon', 'children', 'suffix', 'suffixes', 'iconSized', 'role']);

        delete props.random;

        return _react2.default.createElement(
          'div',
          _extends({}, props, {
            className: (0, _classnames2.default)('md-inline-block md-avatar', this._getColor(suffix, suffixes, this.state.color), {
              'md-avatar--icon-sized': iconSized
            }, className)
          }),
          src && _react2.default.createElement('img', { src: src, alt: alt, role: role, className: 'md-avatar-img' }),
          !src && _react2.default.createElement(
            'div',
            { className: 'md-avatar-content' },
            icon || children
          )
        );
      }
    }]);

    return Avatar;
  }(_react.PureComponent);

  Avatar.propTypes = {
    /**
     * An optional className to apply to the avatar.
     */
    className: _propTypes2.default.string,

    /**
     * An optional image source to use for the avatar.
     */
    src: _propTypes2.default.string,

    /**
     * An optional image alt to use for the avatar if it is
     * an image.
     */
    alt: _propTypes2.default.string,

    /**
     * An optional `FontIcon` to convert into an avatar.
     */
    icon: _propTypes2.default.node,

    /**
     * An optional letter to display in the avatar.
     */
    children: _propTypes2.default.node,

    /**
     * A boolean if a random color should be applied to the avatar.
     * This will be one of the `suffixes`.
     */
    random: _propTypes2.default.bool,

    /**
     * A list of available suffixes to use when generating a random
     * color for the avatar.
     */
    suffixes: _propTypes2.default.arrayOf(_propTypes2.default.string),

    /**
     * The suffix to use for a color. This can be any value but
     * *should* be one of the available `suffixes`.
     */
    suffix: _propTypes2.default.string,

    /**
     * Boolean if the `Avatar` should be sized to a `FontIcon` size. This
     * will just set the width and height to the `$md-font-icon-size`.
     */
    iconSized: _propTypes2.default.bool,

    /**
     * A role for the avatar's image. When the `src` prop is set, either a `role` of `presentation`
     * or the `alt` prop must be defined for a11y.
     */
    role: (0, _oneRequiredForA11yIf2.default)(_propTypes2.default.oneOf(['presentation']), 'src', 'alt')
  };
  Avatar.defaultProps = {
    suffixes: ['red', 'pink', 'purple', 'deep-purple', 'indigo', 'blue', 'light-blue', 'cyan', 'teal', 'green', 'light-green', 'lime', 'yellow', 'amber', 'orange', 'deep-orange', 'brown', 'grey', 'blue-grey']
  };
  exports.default = Avatar;
});

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1094)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./Avatar'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.Avatar);
    global.index = mod.exports;
  }
})(this, function (exports, _Avatar) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _Avatar2 = _interopRequireDefault(_Avatar);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _Avatar2.default;
});

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(37), __webpack_require__(62), __webpack_require__(36)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('../Helpers/AccessibleFakeInkedButton'), require('../Helpers/Collapse'), require('../FontIcons'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.AccessibleFakeInkedButton, global.Collapse, global.FontIcons);
    global.BottomNav = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _AccessibleFakeInkedButton, _Collapse, _FontIcons) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);

  var _Collapse2 = _interopRequireDefault(_Collapse);

  var _FontIcons2 = _interopRequireDefault(_FontIcons);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var BottomNav = function (_PureComponent) {
    _inherits(BottomNav, _PureComponent);

    function BottomNav(props) {
      _classCallCheck(this, BottomNav);

      var _this = _possibleConstructorReturn(this, (BottomNav.__proto__ || Object.getPrototypeOf(BottomNav)).call(this, props));

      _this.state = {};
      _this._handleClick = _this._handleClick.bind(_this);
      return _this;
    }

    _createClass(BottomNav, [{
      key: '_handleClick',
      value: function _handleClick(e) {
        var _props = this.props,
            onClick = _props.onClick,
            onNavChange = _props.onNavChange,
            index = _props.index;

        if (onClick) {
          onClick(index, e);
        }

        if (onNavChange) {
          onNavChange(index, e);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _props2 = this.props,
            active = _props2.active,
            fixed = _props2.fixed,
            className = _props2.className,
            iconClassName = _props2.iconClassName,
            iconChildren = _props2.iconChildren,
            colored = _props2.colored,
            props = _objectWithoutProperties(_props2, ['active', 'fixed', 'className', 'iconClassName', 'iconChildren', 'colored']);

        delete props.index;
        delete props.label;
        delete props.onClick;
        delete props.onNavChange;

        var label = this.props.label;

        var labelClassName = (0, _classnames2.default)('md-bottom-nav-label', { 'md-bottom-nav-label--shifting-inactive': !active && !fixed });
        if (_react.Children.count(label) === 1 && (0, _react.isValidElement)(label)) {
          var labelEl = _react.Children.only(label);
          label = (0, _react.cloneElement)(label, {
            className: (0, _classnames2.default)(labelClassName, labelEl.props.className)
          });
        } else {
          label = _react2.default.createElement(
            'div',
            { className: labelClassName },
            label
          );
        }

        return _react2.default.createElement(
          _AccessibleFakeInkedButton2.default,
          _extends({}, props, {
            onClick: this._handleClick,
            className: (0, _classnames2.default)('md-bottom-nav', {
              'md-bottom-nav--active': active,
              'md-bottom-nav--fixed': fixed,
              'md-bottom-nav--shifting': !fixed,
              'md-bottom-nav--shifting-active': !fixed && active,
              'md-bottom-nav--shifting-inactive': !fixed && !active,
              'md-text': !active && !colored,
              'md-text--theme-primary': active && !colored
            }, className)
          }),
          _react2.default.createElement(
            _FontIcons2.default,
            { iconClassName: iconClassName, className: 'md-icon--inherit' },
            iconChildren
          ),
          _react2.default.createElement(
            _Collapse2.default,
            { collapsed: !fixed && !active },
            label
          )
        );
      }
    }]);

    return BottomNav;
  }(_react.PureComponent);

  BottomNav.propTypes = {
    style: _propTypes2.default.object,
    className: _propTypes2.default.string,
    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
    active: _propTypes2.default.bool,
    fixed: _propTypes2.default.bool,
    children: _propTypes2.default.node,
    index: _propTypes2.default.number.isRequired,
    label: _propTypes2.default.node.isRequired,
    colored: _propTypes2.default.bool,
    iconChildren: _propTypes2.default.node,
    iconClassName: _propTypes2.default.string,
    onClick: _propTypes2.default.func,
    onNavChange: _propTypes2.default.func,
    role: _propTypes2.default.string
  };
  BottomNav.defaultProps = {
    component: 'a',
    role: null
  };
  exports.default = BottomNav;
});

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(12), __webpack_require__(16), __webpack_require__(20), __webpack_require__(82), __webpack_require__(46), __webpack_require__(1096)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('react-prop-types/lib/deprecated'), require('../utils/getField'), require('../utils/PropTypes/controlled'), require('../Helpers/Portal'), require('../Papers/Paper'), require('./BottomNav'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.deprecated, global.getField, global.controlled, global.Portal, global.Paper, global.BottomNav);
    global.BottomNavigation = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _deprecated, _getField, _controlled, _Portal, _Paper, _BottomNav) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _deprecated2 = _interopRequireDefault(_deprecated);

  var _getField2 = _interopRequireDefault(_getField);

  var _controlled2 = _interopRequireDefault(_controlled);

  var _Portal2 = _interopRequireDefault(_Portal);

  var _Paper2 = _interopRequireDefault(_Paper);

  var _BottomNav2 = _interopRequireDefault(_BottomNav);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var BottomNavigation = function (_PureComponent) {
    _inherits(BottomNavigation, _PureComponent);

    function BottomNavigation(props) {
      _classCallCheck(this, BottomNavigation);

      var _this = _possibleConstructorReturn(this, (BottomNavigation.__proto__ || Object.getPrototypeOf(BottomNavigation)).call(this, props));

      var visible = typeof props.initiallyVisible === 'boolean' ? props.initiallyVisible : props.defaultVisible;
      _this.state = {
        visible: visible,
        portalVisible: visible
      };
      if (typeof props.activeIndex === 'undefined') {
        _this.state.activeIndex = props.defaultActiveIndex;
      }

      _this._handleNavChange = _this._handleNavChange.bind(_this);
      _this._addTouchEvents = _this._addTouchEvents.bind(_this);
      _this._removeTouchEvents = _this._removeTouchEvents.bind(_this);
      _this._handleTouchStart = _this._handleTouchStart.bind(_this);
      _this._handleTouchMove = _this._handleTouchMove.bind(_this);
      _this._handleTouchEnd = _this._handleTouchEnd.bind(_this);
      return _this;
    }

    _createClass(BottomNavigation, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (this.props.dynamic) {
          this._addTouchEvents();
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var dynamic = nextProps.dynamic;

        if (this.props.dynamic === dynamic) {
          return;
        }

        if (dynamic) {
          this._addTouchEvents();
        } else {
          this._removeTouchEvents();
        }
      }
    }, {
      key: 'componentWillUpdate',
      value: function componentWillUpdate(nextProps, nextState) {
        if (this.state.visible !== nextState.visible && nextProps.onVisibilityChange) {
          nextProps.onVisibilityChange(nextState.visible);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.props.dynamic) {
          this._removeTouchEvents();
        }

        if (this._timeout) {
          clearTimeout(this._timeout);
        }
      }
    }, {
      key: '_addTouchEvents',
      value: function _addTouchEvents() {
        window.addEventListener('touchstart', this._handleTouchStart);
        window.addEventListener('touchmove', this._handleTouchMove);
        window.addEventListener('touchend', this._handleTouchEnd);
      }
    }, {
      key: '_removeTouchEvents',
      value: function _removeTouchEvents() {
        window.removeEventListener('touchstart', this._handleTouchStart);
        window.removeEventListener('touchmove', this._handleTouchMove);
        window.removeEventListener('touchend', this._handleTouchEnd);
      }
    }, {
      key: '_handleTouchStart',
      value: function _handleTouchStart(e) {
        var pageY = e.changedTouches[0].pageY;


        this._pageY = pageY;
        this._scrolling = true;
      }
    }, {
      key: '_handleTouchMove',
      value: function _handleTouchMove(e) {
        var _this2 = this;

        var visible = this.state.visible;

        if (!this._scrolling) {
          return;
        }

        var touchY = e.changedTouches[0].pageY;
        var _props = this.props,
            transitionDuration = _props.transitionDuration,
            dynamicThreshold = _props.dynamicThreshold;

        var passedThreshold = Math.abs(this._pageY - touchY) >= dynamicThreshold;
        if (this._pageY > touchY && visible && passedThreshold) {
          if (this._timeout) {
            clearTimeout(this._timeout);
          }

          this._timeout = setTimeout(function () {
            _this2._timeout = null;
            _this2.setState({ portalVisible: false });
          }, transitionDuration);

          this._pageY = touchY;
          this.setState({ visible: false });
        } else if (this._pageY < touchY && !visible && passedThreshold) {
          if (this._timeout) {
            clearTimeout(this._timeout);
          }

          this._timeout = setTimeout(function () {
            _this2._timeout = null;
            _this2.setState({ visible: true });
          }, 17);

          this._pageY = touchY;
          this.setState({ portalVisible: true });
        }
      }
    }, {
      key: '_handleTouchEnd',
      value: function _handleTouchEnd() {
        this._scrolling = false;
      }
    }, {
      key: '_handleNavChange',
      value: function _handleNavChange(index, e) {
        if (this.props.onNavChange || this.props.onChange) {
          (this.props.onNavChange || this.props.onChange)(index, e);
        }

        if (typeof this.props.activeIndex === 'undefined') {
          this.setState({ activeIndex: index });
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this3 = this;

        var _state = this.state,
            visible = _state.visible,
            portalVisible = _state.portalVisible;

        var _props2 = this.props,
            className = _props2.className,
            actions = _props2.actions,
            colored = _props2.colored,
            dynamic = _props2.dynamic,
            lastChild = _props2.lastChild,
            props = _objectWithoutProperties(_props2, ['className', 'actions', 'colored', 'dynamic', 'lastChild']);

        delete props.links;
        delete props.activeIndex;
        delete props.onNavChange;
        delete props.onVisibilityChange;
        delete props.defaultVisible;
        delete props.defaultActiveIndex;
        delete props.dynamicThreshold;
        delete props.transitionDuration;
        delete props.renderNode;

        // Delete deprecated
        delete props.onChange;
        delete props.initiallyVisible;
        delete props.containerStyle;
        delete props.containerClassName;
        delete props.transitionName;
        delete props.transitionEnterTimeout;
        delete props.transitionLeaveTimeout;

        var links = this.props.links;

        if (actions) {
          links = actions;
        }

        var fixed = links.length === 3;
        var activeIndex = (0, _getField2.default)(this.props, this.state, 'activeIndex');
        var renderNode = (0, _getField2.default)(this.props, this.context, 'renderNode');

        return _react2.default.createElement(
          _Portal2.default,
          { renderNode: renderNode, visible: portalVisible, lastChild: lastChild },
          _react2.default.createElement(
            _Paper2.default,
            _extends({}, props, {
              className: (0, _classnames2.default)('md-bottom-navigation', {
                'md-background--card': !colored,
                'md-background--primary': colored,
                'md-bottom-navigation--dynamic': dynamic,
                'md-bottom-navigation--dynamic-inactive': dynamic && !visible
              }, className),
              role: 'navigation'
            }),
            links.map(function (action, index) {
              return _react2.default.createElement(_BottomNav2.default, _extends({}, action, {
                key: action.key || index,
                index: index,
                onNavChange: _this3._handleNavChange,
                active: activeIndex === index,
                colored: colored,
                fixed: fixed
              }));
            })
          )
        );
      }
    }]);

    return BottomNavigation;
  }(_react.PureComponent);

  BottomNavigation.propTypes = {
    /**
     * An optional style to apply.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply.
     */
    className: _propTypes2.default.string,

    /**
     * A list of objects to generate a bottom navigation link. There must be at least 3 and no more
     * than 5 links. A link gets rendered as the `AccessibleFakeButton` component, so any additional
     * props in the link's shape will be passed along.
     *
     * ```docgen
     * PropTypes.arrayOf(PropTypes.shape({
     *   label: PropTypes.node.isRequired,
     *   iconChildren: PropTypes.node,
     *   iconClassName: PropTypes.string,
     *   component: PropTypes.oneOfType([
     *      PropTypes.func,
     *      PropTypes.string,
     *   ]),
     * }).isRequired
     * ```
     */
    links: function links(props, propName, component) {
      for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        args[_key - 3] = arguments[_key];
      }

      var _PropTypes$arrayOf;

      var links = props[propName] || props.actions;
      var len = links.length;

      if (len < 3) {
        return new Error('Only ' + len + ' `' + propName + '` were given to the ' + component + '. At least 3 are required.');
      } else if (len > 5) {
        return new Error(len + ' `' + propName + '` were given to the ' + component + '. No more than 5 may be given.');
      }

      return (_PropTypes$arrayOf = _propTypes2.default.arrayOf(_propTypes2.default.shape({
        label: _propTypes2.default.node.isRequired,
        iconChildren: _propTypes2.default.node,
        iconClassName: _propTypes2.default.string,
        component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string])
      }))).isRequired.apply(_PropTypes$arrayOf, [props, propName, component].concat(args));
    },

    /**
     * Boolean if the bottom navigation should be colored with the primary color or whatever color
     * was a result of the `react-md-theme-bottom-navigations-colored` mixin.
     */
    colored: _propTypes2.default.bool,

    /**
     * Boolean if the bottom navigation should dynamically appear based on scrolling. When the user
     * scrolls the `dynamicThreshold` amount, this component will either disappear (scrolling down)
     * or appera (scrolling up).
     */
    dynamic: _propTypes2.default.bool,

    /**
     * The distance a user must scroll before the bottom navigation appears or disappears when it is `dyanamic`.
     */
    dynamicThreshold: _propTypes2.default.number.isRequired,

    /**
     * An optional function to call when a link has been clicked. The callback will
     * include the new active index and the click event.
     *
     * ```js
     * onNavChange(newActiveIndex, event);
     * ```
     */
    onNavChange: _propTypes2.default.func,

    /**
     * An optional active index to use. This will make the component controlled and require the
     * `onNavChange` prop to be defined.
     */
    activeIndex: (0, _controlled2.default)(_propTypes2.default.number, 'onNavChange', 'defaultActiveIndex'),

    /**
     * The index for the link that is active by default.
     */
    defaultActiveIndex: _propTypes2.default.number.isRequired,

    /**
     * Boolean if the bottom navigation is visible by default. This *should* probably always
     * be true.
     */
    defaultVisible: _propTypes2.default.bool.isRequired,

    /**
     * The component to render the bottom navigation as.
     */
    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,

    /**
     * Since the `BottomNavigation` component uses the `Portal` component, you can pass an optional
     * HTML Node to render in.
     */
    renderNode: _propTypes2.default.object,

    /**
     * Boolean if the bottom navigation should render as the last child in the `renderNode` or `body`
     * instead of as the first.
     */
    lastChild: _propTypes2.default.bool,

    /**
     * The transition duration for the dynamic bottom navigation to appear or disappear. This should
     * match the `$md-bottom-navigation-transition-time` variable.
     */
    transitionDuration: _propTypes2.default.number.isRequired,

    /**
     * An optional function to call when the visibility of the bottom navigation changes. The callback
     * will include the new visibility.
     *
     * ```js
     * onVisibilityChange(!visible);
     * ```
     */
    onVisibilityChange: _propTypes2.default.func,

    onChange: (0, _deprecated2.default)(_propTypes2.default.func, 'Use `onNavChange` instead'),
    initiallyVisible: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `defaultVisible` instead'),
    initialActiveIndex: (0, _deprecated2.default)(_propTypes2.default.number, 'Use `defaultActiveIndex` instead'),
    containerStyle: (0, _deprecated2.default)(_propTypes2.default.object, 'Use `style` instead'),
    containerClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `className` instead'),
    transitionName: (0, _deprecated2.default)(_propTypes2.default.string, 'There is no CSSTransitionGroup used anymore'),
    transitionEnterTimeout: (0, _deprecated2.default)(_propTypes2.default.number, 'Use `transitionDuration` instead'),
    transitionLeaveTimeout: (0, _deprecated2.default)(_propTypes2.default.number, 'Use `transitionDuration` instead'),
    actions: (0, _deprecated2.default)(_propTypes2.default.array, 'Use `links` instead')
  };
  BottomNavigation.defaultProps = {
    defaultActiveIndex: 0,
    component: 'footer',
    defaultVisible: true,
    transitionDuration: 300,
    dynamicThreshold: 20
  };
  BottomNavigation.contextTypes = {
    renderNode: _propTypes2.default.object
  };
  exports.default = BottomNavigation;
});

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1097)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./BottomNavigation'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.BottomNavigation);
    global.index = mod.exports;
  }
})(this, function (exports, _BottomNavigation) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _BottomNavigation2 = _interopRequireDefault(_BottomNavigation);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _BottomNavigation2.default;
});

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(64), __webpack_require__(11)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('../utils/PropTypes/componentDeprecated'), require('./Button'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.componentDeprecated, global.Button);
    global.FlatButton = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _componentDeprecated, _Button) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _componentDeprecated2 = _interopRequireDefault(_componentDeprecated);

  var _Button2 = _interopRequireDefault(_Button);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var FlatButton = function (_PureComponent) {
    _inherits(FlatButton, _PureComponent);

    function FlatButton() {
      _classCallCheck(this, FlatButton);

      return _possibleConstructorReturn(this, (FlatButton.__proto__ || Object.getPrototypeOf(FlatButton)).apply(this, arguments));
    }

    _createClass(FlatButton, [{
      key: 'render',
      value: function render() {
        return _react2.default.createElement(_Button2.default, _extends({}, this.props, { flat: true }));
      }
    }]);

    return FlatButton;
  }(_react.PureComponent);

  FlatButton.propTypes = {
    /**
     * The label to display in the button.
     */
    label: _propTypes2.default.node.isRequired,

    /**
     * An optional className to apply to the button.
     */
    className: _propTypes2.default.string,

    /**
     * Boolean if the icon should be displayed before the label.
     */
    iconBefore: _propTypes2.default.bool,

    /**
     * A `FontIcon` to display in the button. It can be placed before
     * or after the label.
     */
    children: _propTypes2.default.node,

    /**
     * The button type.
     */
    type: _propTypes2.default.string,

    /**
     * Boolean if the button should be styled with the primary color.
     */
    primary: _propTypes2.default.bool,

    /**
     * Boolean if the button should be styled with the secondary color.
     */
    secondary: _propTypes2.default.bool,

    /**
     * Boolean if the button is disabled.
     */
    disabled: _propTypes2.default.bool,

    /**
     * An optional href to convert the button into a link button.
     */
    href: _propTypes2.default.string,

    /**
     * An optional function to call when the button is clicked.
     */
    onClick: _propTypes2.default.func,

    deprecated: (0, _componentDeprecated2.default)('The behavior of the `FlatButton` can be achieved with the `Button` component ' + 'without the additional bundle size. Switch to the `Button` compnent and add a ' + 'prop `flat`.')
  };
  FlatButton.defaultProps = {
    type: 'button',
    iconBefore: true
  };
  exports.default = FlatButton;
});

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(64), __webpack_require__(551)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('../utils/PropTypes/componentDeprecated'), require('./IconButton'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.componentDeprecated, global.IconButton);
    global.FloatingButton = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _componentDeprecated, _IconButton) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _componentDeprecated2 = _interopRequireDefault(_componentDeprecated);

  var _IconButton2 = _interopRequireDefault(_IconButton);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var FloatingButton = function (_PureComponent) {
    _inherits(FloatingButton, _PureComponent);

    function FloatingButton() {
      _classCallCheck(this, FloatingButton);

      return _possibleConstructorReturn(this, (FloatingButton.__proto__ || Object.getPrototypeOf(FloatingButton)).apply(this, arguments));
    }

    _createClass(FloatingButton, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            className = _props.className,
            fixed = _props.fixed,
            mini = _props.mini,
            children = _props.children,
            iconClassName = _props.iconClassName,
            props = _objectWithoutProperties(_props, ['className', 'fixed', 'mini', 'children', 'iconClassName']);

        return _react2.default.createElement(
          _IconButton2.default,
          _extends({}, props, {
            className: (0, _classnames2.default)({
              'md-btn--floating-fixed': fixed,
              'md-btn--floating-mini': mini
            }, className),
            iconClassName: iconClassName,
            floating: true
          }),
          children
        );
      }
    }]);

    return FloatingButton;
  }(_react.PureComponent);

  FloatingButton.propTypes = {
    /**
     * The className to use for rendering the `FontIcon`.
     */
    iconClassName: _propTypes2.default.string,

    /**
     * Any children to use to render the `FontIcon`.
     */
    children: _propTypes2.default.node,

    /**
     * An optional className to apply to the button.
     */
    className: _propTypes2.default.string,

    /**
     * The button type.
     */
    type: _propTypes2.default.string,

    /**
     * Boolean if the button is disabled.
     */
    disabled: _propTypes2.default.bool,

    /**
     * An optional href to convert the button into a link button.
     */
    href: _propTypes2.default.string,

    /**
     * An optional function to call when the button is clicked.
     */
    onClick: _propTypes2.default.func,

    /**
     * An optional label to use if you would like a tooltip to display
     * on hover or touch hold.
     */
    tooltipLabel: _propTypes2.default.node,

    /**
     * The position that the tooltip should be displayed relative to
     * the button.
     */
    tooltipPosition: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),

    /**
     * An optional amount of delay before the tooltip appears.
     */
    tooltipDelay: _propTypes2.default.number,

    /**
     * Boolean if the floating button is fixed.
     */
    fixed: _propTypes2.default.bool,

    /**
     * Boolean if the floating button should be displayed as the mini
     * version.
     */
    mini: _propTypes2.default.bool,

    /**
     * Boolean if the floating button should be styled with the primary color.
     */
    primary: _propTypes2.default.bool,

    /**
     * Boolean if the floating button should be styled with the secondary color.
     */
    secondary: _propTypes2.default.bool,

    deprecated: (0, _componentDeprecated2.default)('The behavior of the `FloatingButton` can be achieved with the `Button` component ' + 'without the additional bundle size. Switch to the `Button` compnent and add a ' + 'prop `floating`.')
  };
  exports.default = FloatingButton;
});

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(64), __webpack_require__(11)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('../utils/PropTypes/componentDeprecated'), require('./Button'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.componentDeprecated, global.Button);
    global.RaisedButton = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _componentDeprecated, _Button) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _componentDeprecated2 = _interopRequireDefault(_componentDeprecated);

  var _Button2 = _interopRequireDefault(_Button);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var RaisedButton = function (_PureComponent) {
    _inherits(RaisedButton, _PureComponent);

    function RaisedButton() {
      _classCallCheck(this, RaisedButton);

      return _possibleConstructorReturn(this, (RaisedButton.__proto__ || Object.getPrototypeOf(RaisedButton)).apply(this, arguments));
    }

    _createClass(RaisedButton, [{
      key: 'render',
      value: function render() {
        return _react2.default.createElement(_Button2.default, _extends({}, this.props, { raised: true }));
      }
    }]);

    return RaisedButton;
  }(_react.PureComponent);

  RaisedButton.propTypes = {
    /**
     * The label to display in the button.
     */
    label: _propTypes2.default.node.isRequired,

    /**
     * An optional className to apply to the button.
     */
    className: _propTypes2.default.string,

    /**
     * Boolean if the icon should be displayed before the label.
     */
    iconBefore: _propTypes2.default.bool,

    /**
     * A `FontIcon` to display in the button. It can be placed before
     * or after the label.
     */
    children: _propTypes2.default.node,

    /**
     * The button type.
     */
    type: _propTypes2.default.string,

    /**
     * Boolean if the button should be styled with the primary color.
     */
    primary: _propTypes2.default.bool,

    /**
     * Boolean if the button should be styled with the secondary color.
     */
    secondary: _propTypes2.default.bool,

    /**
     * Boolean if the button is disabled.
     */
    disabled: _propTypes2.default.bool,

    /**
     * An optional href to convert the button into a link button.
     */
    href: _propTypes2.default.string,

    /**
     * An optional function to call when the button is clicked.
     */
    onClick: _propTypes2.default.func,

    deprecated: (0, _componentDeprecated2.default)('The behavior of the `RaisedButton` can be achieved with the `Button` component ' + 'without the additional bundle size. Switch to the `Button` compnent and add a ' + 'prop `raised`.')
  };
  RaisedButton.defaultProps = {
    type: 'button',
    iconBefore: true
  };
  exports.default = RaisedButton;
});

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(554), __webpack_require__(552), __webpack_require__(11), __webpack_require__(64)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('./CardTitle'), require('./CardActions'), require('../Buttons/Button'), require('../utils/PropTypes/componentDeprecated'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.CardTitle, global.CardActions, global.Button, global.componentDeprecated);
    global.CardActionOverlay = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _CardTitle, _CardActions, _Button, _componentDeprecated) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _CardTitle2 = _interopRequireDefault(_CardTitle);

  var _CardActions2 = _interopRequireDefault(_CardActions);

  var _Button2 = _interopRequireDefault(_Button);

  var _componentDeprecated2 = _interopRequireDefault(_componentDeprecated);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var CardActionOverlay = function (_PureComponent) {
    _inherits(CardActionOverlay, _PureComponent);

    function CardActionOverlay() {
      _classCallCheck(this, CardActionOverlay);

      return _possibleConstructorReturn(this, (CardActionOverlay.__proto__ || Object.getPrototypeOf(CardActionOverlay)).apply(this, arguments));
    }

    _createClass(CardActionOverlay, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            actions = _props.actions,
            titleProps = _objectWithoutProperties(_props, ['actions']);

        return _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(_CardTitle2.default, titleProps),
          _react2.default.createElement(
            _CardActions2.default,
            null,
            actions.map(function (actionProps, i) {
              return _react2.default.createElement(_Button2.default, _extends({ flat: true, key: i }, actionProps));
            })
          )
        );
      }
    }]);

    return CardActionOverlay;
  }(_react.PureComponent);

  CardActionOverlay.propTypes = {
    /**
     * The title to use.
     */
    title: _propTypes2.default.node,

    /**
     * The optional subtitle to use.
     */
    subtitle: _propTypes2.default.node,

    /**
     * An array of flat button props.
     */
    actions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      label: _propTypes2.default.node.isRequired
    })),

    /**
     * Any children to display in the `CardTitle` component.
     */
    children: _propTypes2.default.node,
    deprecated: (0, _componentDeprecated2.default)('It is not a worthwhile component since the same thing can be accomplished with the `MediaOverlay` component.')
  };
  exports.default = CardActionOverlay;
});

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(12), __webpack_require__(64), __webpack_require__(564), __webpack_require__(565)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('react-prop-types/lib/deprecated'), require('../utils/PropTypes/componentDeprecated'), require('../Media/Media'), require('../Media/MediaOverlay'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.deprecated, global.componentDeprecated, global.Media, global.MediaOverlay);
    global.CardMedia = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _deprecated, _componentDeprecated, _Media, _MediaOverlay) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _deprecated2 = _interopRequireDefault(_deprecated);

  var _componentDeprecated2 = _interopRequireDefault(_componentDeprecated);

  var _Media2 = _interopRequireDefault(_Media);

  var _MediaOverlay2 = _interopRequireDefault(_MediaOverlay);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var CardMedia = function (_PureComponent) {
    _inherits(CardMedia, _PureComponent);

    function CardMedia() {
      _classCallCheck(this, CardMedia);

      return _possibleConstructorReturn(this, (CardMedia.__proto__ || Object.getPrototypeOf(CardMedia)).apply(this, arguments));
    }

    _createClass(CardMedia, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            className = _props.className,
            children = _props.children,
            props = _objectWithoutProperties(_props, ['className', 'children']);

        delete props.overlay;

        var overlay = this.props.overlay;

        if (overlay) {
          overlay = _react2.default.createElement(
            _MediaOverlay2.default,
            null,
            overlay
          );
        }

        return _react2.default.createElement(
          _Media2.default,
          _extends({ className: (0, _classnames2.default)('md-card-media', className) }, props),
          children,
          overlay
        );
      }
    }]);

    return CardMedia;
  }(_react.PureComponent);

  CardMedia.aspect = {
    equal: '1-1',
    wide: '16-9'
  };
  CardMedia.propTypes = {
    /**
     * An optional className to apply to the card media component.
     */
    className: _propTypes2.default.string,

    /**
     * An optional overlay component to be rendered over the media. This *should*
     * be A `CardTitle`, `CardActions` or both.
     */
    overlay: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `MediaOverlay` component as a child instead'),

    /**
     * Any media to display.
     */
    children: _propTypes2.default.node,

    /**
     * Boolean if the aspect ratio should be forced.
     */
    forceAspect: _propTypes2.default.bool,

    /**
     * The aspect ratio to use.
     */
    aspectRatio: _propTypes2.default.oneOf([CardMedia.aspect.equal, CardMedia.aspect.wide]).isRequired,

    /**
     * Boolean if this component should be expandable when there is a `CardExpander`
     * above it in the `Card`.
     */
    expandable: _propTypes2.default.bool,

    /**
     * The component to render the card media as.
     */
    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,

    deprecated: (0, _componentDeprecated2.default)('There were no unique styles for media in cards so it is simpler to just use the ' + '`Media` component.')
  };
  CardMedia.defaultProps = {
    forceAspect: true,
    aspectRatio: CardMedia.aspect.wide,
    component: 'section'
  };
  exports.default = CardMedia;
});

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames);
    global.CardText = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var CardText = function (_PureComponent) {
    _inherits(CardText, _PureComponent);

    function CardText() {
      _classCallCheck(this, CardText);

      return _possibleConstructorReturn(this, (CardText.__proto__ || Object.getPrototypeOf(CardText)).apply(this, arguments));
    }

    _createClass(CardText, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            Component = _props.component,
            className = _props.className,
            props = _objectWithoutProperties(_props, ['component', 'className']);

        delete props.expandable;

        return _react2.default.createElement(Component, _extends({}, props, { className: (0, _classnames2.default)('md-card-text', className) }));
      }
    }]);

    return CardText;
  }(_react.PureComponent);

  CardText.propTypes = {
    /**
     * An optional style to apply.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply.
     */
    className: _propTypes2.default.string,

    /**
     * The children to display.
     */
    children: _propTypes2.default.node,

    /**
     * The component to render as.
     */
    component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,

    /**
     * Boolean if this component should be expandable when there is a `CardExpander`
     * above it in the `Card`.
     */
    expandable: _propTypes2.default.bool
  };
  CardText.defaultProps = {
    component: 'section'
  };
  exports.default = CardText;
});

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(152), __webpack_require__(554), __webpack_require__(1103), __webpack_require__(552), __webpack_require__(1104), __webpack_require__(1102)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./Card'), require('./CardTitle'), require('./CardMedia'), require('./CardActions'), require('./CardText'), require('./CardActionOverlay'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.Card, global.CardTitle, global.CardMedia, global.CardActions, global.CardText, global.CardActionOverlay);
    global.index = mod.exports;
  }
})(this, function (exports, _Card2, _CardTitle2, _CardMedia2, _CardActions2, _CardText2, _CardActionOverlay2) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.CardActionOverlay = exports.CardText = exports.CardActions = exports.CardMedia = exports.CardTitle = exports.Card = undefined;

  var _Card3 = _interopRequireDefault(_Card2);

  var _CardTitle3 = _interopRequireDefault(_CardTitle2);

  var _CardMedia3 = _interopRequireDefault(_CardMedia2);

  var _CardActions3 = _interopRequireDefault(_CardActions2);

  var _CardText3 = _interopRequireDefault(_CardText2);

  var _CardActionOverlay3 = _interopRequireDefault(_CardActionOverlay2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _Card3.default;
  exports.Card = _Card3.default;
  exports.CardTitle = _CardTitle3.default;
  exports.CardMedia = _CardMedia3.default;
  exports.CardActions = _CardActions3.default;
  exports.CardText = _CardText3.default;
  exports.CardActionOverlay = _CardActionOverlay3.default;
});

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(12), __webpack_require__(28)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('react-prop-types/lib/deprecated'), require('../FontIcons/FontIcon'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.deprecated, global.FontIcon);
    global.Chip = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _deprecated, _FontIcon) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _deprecated2 = _interopRequireDefault(_deprecated);

  var _FontIcon2 = _interopRequireDefault(_FontIcon);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Chip = function (_PureComponent) {
    _inherits(Chip, _PureComponent);

    function Chip(props) {
      _classCallCheck(this, Chip);

      var _this = _possibleConstructorReturn(this, (Chip.__proto__ || Object.getPrototypeOf(Chip)).call(this, props));

      _this.state = { hover: false };
      _this._handleMouseOver = _this._handleMouseOver.bind(_this);
      _this._handleMouseLeave = _this._handleMouseLeave.bind(_this);
      return _this;
    }

    _createClass(Chip, [{
      key: '_handleMouseOver',
      value: function _handleMouseOver(e) {
        if (this.props.onMouseOver) {
          this.props.onMouseOver(e);
        }

        this.setState({ hover: true });
      }
    }, {
      key: '_handleMouseLeave',
      value: function _handleMouseLeave(e) {
        if (this.props.onMouseLeave) {
          this.props.onMouseLeave(e);
        }

        this.setState({ hover: false });
      }
    }, {
      key: 'render',
      value: function render() {
        var hover = this.state.hover;

        var _props = this.props,
            label = _props.label,
            className = _props.className,
            iconClassName = _props.iconClassName,
            avatar = _props.avatar,
            children = _props.children,
            removable = _props.removable,
            remove = _props.remove,
            onClick = _props.onClick,
            rotateIcon = _props.rotateIcon,
            props = _objectWithoutProperties(_props, ['label', 'className', 'iconClassName', 'avatar', 'children', 'removable', 'remove', 'onClick', 'rotateIcon']);

        delete props.removeIconChildren;
        delete props.removeIconClassName;

        var icon = void 0;
        if (removable || remove) {
          icon = _react2.default.createElement(
            _FontIcon2.default,
            {
              className: (0, _classnames2.default)('md-chip-icon', {
                'md-chip-icon--rotate': rotateIcon,
                'md-chip-text--hover': hover
              }),
              iconClassName: iconClassName
            },
            children
          );
        }

        return _react2.default.createElement(
          'button',
          _extends({
            type: 'button'
          }, props, {
            className: (0, _classnames2.default)('md-chip', {
              'md-chip--avatar': avatar,
              'md-chip--remove': removable,
              'md-chip--hover': hover
            }, className),
            onClick: remove || onClick,
            onMouseOver: this._handleMouseOver,
            onMouseLeave: this._handleMouseLeave
          }),
          avatar,
          _react2.default.createElement(
            'span',
            {
              className: (0, _classnames2.default)('md-chip-text', {
                'md-chip-text--hover': hover
              })
            },
            label
          ),
          icon
        );
      }
    }]);

    return Chip;
  }(_react.PureComponent);

  Chip.propTypes = {
    /**
     * An optional style to apply.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply.
     */
    className: _propTypes2.default.string,

    /**
     * An optional icon className to use for the remove icon when `removable`.
     */
    iconClassName: _propTypes2.default.string,

    /**
     * Boolean if the `.md-chip-icon--rotate` style should be applied to the remove icon.
     * The `.md-chip-icon--rotate` just rotates the icon 45 degrees.
     */
    rotateIcon: _propTypes2.default.bool,

    /**
     * Any children used to display the remove icon when `removable`.
     */
    children: _propTypes2.default.node,

    /**
     * The label to display on the chip.
     */
    label: _propTypes2.default.node.isRequired,

    /**
     * Boolean if the chip is removable.
     */
    removable: _propTypes2.default.bool,

    /**
     * An optional avatar to display on the chip.
     */
    avatar: _propTypes2.default.element,

    /**
     * An optional function to call when the `click` event is triggered.
     */
    onClick: _propTypes2.default.func,

    /**
     * An optional function to call when the `mouseover` event is triggered.
     */
    onMouseOver: _propTypes2.default.func,

    /**
     * An optional function to call when the `mouseleave` event is triggered.
     */
    onMouseLeave: _propTypes2.default.func,
    remove: (0, _deprecated2.default)(_propTypes2.default.func, 'Use `removable` and `onClick` instead'),
    removeIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `iconChildren` instead'),
    removeIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `iconClassName` instead')
  };
  Chip.defaultProps = {
    rotateIcon: true,
    children: 'add_circle'
  };
  exports.default = Chip;
});

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1106)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./Chip'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.Chip);
    global.index = mod.exports;
  }
})(this, function (exports, _Chip) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _Chip2 = _interopRequireDefault(_Chip);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _Chip2.default;
});

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(9), __webpack_require__(3), __webpack_require__(14), __webpack_require__(38), __webpack_require__(16), __webpack_require__(119), __webpack_require__(65), __webpack_require__(115), __webpack_require__(114), __webpack_require__(84), __webpack_require__(28), __webpack_require__(154)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('react-dom'), require('classnames'), require('../constants/keyCodes'), require('../constants/CSSTransitionGroupTick'), require('../utils/getField'), require('../utils/EventUtils/handleWindowClickListeners'), require('../utils/PropTypes/invalidIf'), require('../Dialogs/DialogFooter'), require('./TableColumn'), require('../TextFields/TextField'), require('../FontIcons/FontIcon'), require('./findTable'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.reactDom, global.classnames, global.keyCodes, global.CSSTransitionGroupTick, global.getField, global.handleWindowClickListeners, global.invalidIf, global.DialogFooter, global.TableColumn, global.TextField, global.FontIcon, global.findTable);
    global.EditDialogColumn = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _reactDom, _classnames, _keyCodes, _CSSTransitionGroupTick, _getField, _handleWindowClickListeners, _invalidIf, _DialogFooter, _TableColumn, _TextField, _FontIcon, _findTable) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);

  var _getField2 = _interopRequireDefault(_getField);

  var _handleWindowClickListeners2 = _interopRequireDefault(_handleWindowClickListeners);

  var _invalidIf2 = _interopRequireDefault(_invalidIf);

  var _DialogFooter2 = _interopRequireDefault(_DialogFooter);

  var _TableColumn2 = _interopRequireDefault(_TableColumn);

  var _TextField2 = _interopRequireDefault(_TextField);

  var _FontIcon2 = _interopRequireDefault(_FontIcon);

  var _findTable2 = _interopRequireDefault(_findTable);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var EditDialogColumn = function (_PureComponent) {
    _inherits(EditDialogColumn, _PureComponent);

    function EditDialogColumn(props, context) {
      _classCallCheck(this, EditDialogColumn);

      var _this = _possibleConstructorReturn(this, (EditDialogColumn.__proto__ || Object.getPrototypeOf(EditDialogColumn)).call(this, props, context));

      _this.state = {
        value: props.defaultValue,
        active: false,
        absolute: false,
        animating: false
      };

      _this._table = null;
      _this._column = null;
      _this._field = null;

      _this._setColumn = _this._setColumn.bind(_this);
      _this._setDialog = _this._setDialog.bind(_this);
      _this._setField = _this._setField.bind(_this);
      _this._setOkButton = _this._setOkButton.bind(_this);
      _this._save = _this._save.bind(_this);
      _this._overrideTab = _this._overrideTab.bind(_this);
      _this._handleKeyUp = _this._handleKeyUp.bind(_this);
      _this._handleKeyDown = _this._handleKeyDown.bind(_this);
      _this._handleChange = _this._handleChange.bind(_this);
      _this._handleTouchStart = _this._handleTouchStart.bind(_this);
      _this._handleCancelClick = _this._handleCancelClick.bind(_this);
      _this._handleClickOutside = _this._handleClickOutside.bind(_this);
      _this._handleMouseOver = _this._handleMouseOver.bind(_this);
      _this._handleMouseLeave = _this._handleMouseLeave.bind(_this);
      _this._positionCell = _this._positionCell.bind(_this);
      _this._repositionCell = _this._repositionCell.bind(_this);
      _this._activateDialog = _this._activateDialog.bind(_this);
      return _this;
    }

    _createClass(EditDialogColumn, [{
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps, prevState) {
        var active = this.state.active;

        if (active === prevState.active) {
          return;
        } else if (this._table) {
          this._table[(active ? 'add' : 'remove') + 'EventListener']('scroll', this._repositionCell);
          this._left = active ? this.state.left : null;
          this._scrollLeft = active ? this._table.scrollLeft : null;
        }

        (0, _handleWindowClickListeners2.default)(this._handleClickOutside, active);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        (0, _handleWindowClickListeners2.default)(this._handleClickOutside, false);

        if (this._timeout) {
          clearTimeout(this._timeout);
        }
      }
    }, {
      key: '_getDialogPosition',
      value: function _getDialogPosition(dialog) {
        var left = null;
        var width = null;
        if (dialog) {
          left = dialog.getBoundingClientRect().left - 1;
          width = dialog.offsetWidth;
        }

        return { width: width, left: left };
      }
    }, {
      key: '_setColumn',
      value: function _setColumn(column) {
        this._column = (0, _reactDom.findDOMNode)(column);
        this._table = (0, _findTable2.default)(this._column);
      }
    }, {
      key: '_setDialog',
      value: function _setDialog(dialog) {
        this._dialog = dialog;
      }
    }, {
      key: '_setField',
      value: function _setField(field) {
        if (field) {
          this._field = field.getField();
        }
      }
    }, {
      key: '_setOkButton',
      value: function _setOkButton(okButton) {
        this._okButton = (0, _reactDom.findDOMNode)(okButton);
      }
    }, {
      key: '_positionCell',
      value: function _positionCell() {
        if (this.props.inline) {
          return;
        }

        var position = void 0;
        if (!this.state.absolute) {
          position = this._getDialogPosition(this._dialog, this._table);
        }

        this.setState(_extends({ absolute: true }, position));
      }
    }, {
      key: '_repositionCell',
      value: function _repositionCell() {
        var _this2 = this;

        if (!this._ticking) {
          requestAnimationFrame(function () {
            _this2._ticking = false;

            var left = _this2._left;
            var scrolledOut = false;
            if (_this2._table) {
              var _table = _this2._table,
                  scrollLeft = _table.scrollLeft,
                  offsetWidth = _table.offsetWidth;

              left -= scrollLeft - _this2._scrollLeft;
              scrolledOut = left < 16 || offsetWidth - left < _this2.state.width * _this2.props.scrollThreshold;
            }

            var _state = _this2.state,
                absolute = _state.absolute,
                active = _state.active;

            if (!_this2._timeout && scrolledOut) {
              _this2._timeout = setTimeout(function () {
                _this2._timeout = null;
                _this2.setState({ absolute: false, left: null, width: null });
              }, _this2.props.transitionDuration);
              active = false;
              absolute = true;
            }

            _this2.setState({ left: left, absolute: absolute, active: active });
          });
        }

        this._ticking = true;
      }
    }, {
      key: '_activateDialog',
      value: function _activateDialog(e) {
        if (e) {
          var callback = void 0;
          if (e.type === 'click') {
            callback = 'onClick';
          } else if (e.type === 'touchend') {
            callback = 'onTouchEnd';
          }

          if (callback && this.props[callback]) {
            this.props[callback](e);
          }
        }

        if (this.props.inline || this.state.active) {
          return;
        }

        this.setState({ active: true, cancelValue: (0, _getField2.default)(this.props, this.state, 'value') });
      }
    }, {
      key: '_handleClickOutside',
      value: function _handleClickOutside(e) {
        if (this._column && !this._column.contains(e.target)) {
          if (this.props.onOutsideClick) {
            this.props.onOutsideClick(e);
          }

          if (this.props.okOnOutsideClick) {
            this._save(e);
          } else {
            this._handleCancelClick(e);
          }
        }
      }
    }, {
      key: '_handleMouseOver',
      value: function _handleMouseOver(e) {
        if (this.props.onMouseOver) {
          this.props.onMouseOver(e);
        }

        this._positionCell();
      }
    }, {
      key: '_handleMouseLeave',
      value: function _handleMouseLeave(e) {
        if (this.props.onMouseLeave) {
          this.props.onMouseLeave(e);
        }

        if (this.props.inline) {
          return;
        }

        var position = void 0;
        if (!this.state.active) {
          position = { width: null, left: null };
        }

        this.setState(_extends({ absolute: false }, position));
      }
    }, {
      key: '_handleKeyUp',
      value: function _handleKeyUp(e) {
        var _this3 = this;

        if (this.props.onKeyUp) {
          this.props.onKeyUp(e);
        }

        // Make sure this is really a _focus_ event from keyboard
        if ((e.which || e.keyCode) !== _keyCodes.TAB || this.state.active || this.props.inline) {
          return;
        }

        // To get a smooth transition with keybaord, need to _emulate_ how the mouse interaction works.
        // Basically position the edit field absolutely, wait for a re-render, then activate the dialog.
        this._timeout = setTimeout(function () {
          _this3._timeout = null;
          _this3._activateDialog();
        }, _CSSTransitionGroupTick2.default);
        this._positionCell();
      }
    }, {
      key: '_handleTouchStart',
      value: function _handleTouchStart(e) {
        if (this.props.onTouchStart) {
          this.props.onTouchStart(e);
        }

        this._positionCell();
      }
    }, {
      key: '_handleKeyDown',
      value: function _handleKeyDown(e) {
        var onKeyDown = this.props.onKeyDown;

        if (onKeyDown) {
          onKeyDown(e);
        }

        var key = e.which || e.keyCode;
        if (key === _keyCodes.ENTER) {
          this._save(e);
        } else if (key === _keyCodes.TAB) {
          this._overrideTab(e);
        } else if (key === _keyCodes.ESC) {
          this._handleCancelClick(e);
        }
      }
    }, {
      key: '_overrideTab',
      value: function _overrideTab(e) {
        var _props = this.props,
            large = _props.large,
            inline = _props.inline,
            okOnOutsideClick = _props.okOnOutsideClick;

        var key = e.which || e.keyCode;
        if (key !== _keyCodes.TAB) {
          return;
        } else if (inline) {
          this._save(e);
          return;
        } else if (!large) {
          if (okOnOutsideClick) {
            this._save(e);
          } else {
            this._handleCancelClick(e);
          }
          return;
        }

        var shiftKey = e.shiftKey;
        var classList = e.target.classList;


        var nextFocus = void 0;
        if (classList.contains('md-text-field') && shiftKey) {
          nextFocus = this._okButton;
        } else if (classList.contains('md-btn') && !shiftKey) {
          nextFocus = this._field;
        }

        if (nextFocus) {
          e.preventDefault();
          nextFocus.focus();
        }
      }
    }, {
      key: '_save',
      value: function _save(e) {
        var _this4 = this;

        if (this.props.onOkClick) {
          this.props.onOkClick((0, _getField2.default)(this.props, this.state, 'value'), e);
        }

        this._timeout = setTimeout(function () {
          _this4._timeout = null;
          _this4.setState({ absolute: false, left: null, width: null });
        }, this.props.transitionDuration);
        this.setState({ active: false, absolute: true });
      }
    }, {
      key: '_handleCancelClick',
      value: function _handleCancelClick(e) {
        var _this5 = this;

        if (this.props.onCancelClick) {
          this.props.onCancelClick(this.state.cancelValue, e);
        }

        var state = { absolute: true, active: false };
        if (typeof this.props.value === 'undefined') {
          state.value = this.state.cancelValue;
        }

        this._timeout = setTimeout(function () {
          _this5._timeout = null;
          _this5.setState({ absolute: false, left: null, width: null });
        }, this.props.transitionDuration);

        this.setState(state);
      }
    }, {
      key: '_handleChange',
      value: function _handleChange(value, e) {
        if (this.props.onChange) {
          this.props.onChange(value, e);
        }

        if (typeof this.props.value === 'undefined') {
          this.setState({ value: value });
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var rowId = this.context.rowId;
        var _state2 = this.state,
            active = _state2.active,
            absolute = _state2.absolute,
            animating = _state2.animating,
            left = _state2.left,
            width = _state2.width;

        var _props2 = this.props,
            style = _props2.style,
            className = _props2.className,
            dialogStyle = _props2.dialogStyle,
            dialogClassName = _props2.dialogClassName,
            textFieldStyle = _props2.textFieldStyle,
            textFieldClassName = _props2.textFieldClassName,
            inputStyle = _props2.inputStyle,
            inputClassName = _props2.inputClassName,
            maxLength = _props2.maxLength,
            title = _props2.title,
            okLabel = _props2.okLabel,
            cancelLabel = _props2.cancelLabel,
            large = _props2.large,
            label = _props2.label,
            placeholder = _props2.placeholder,
            inline = _props2.inline,
            inlineIconChildren = _props2.inlineIconChildren,
            inlineIconClassName = _props2.inlineIconClassName,
            noIcon = _props2.noIcon,
            header = _props2.header,
            enforceMinWidth = _props2.enforceMinWidth,
            props = _objectWithoutProperties(_props2, ['style', 'className', 'dialogStyle', 'dialogClassName', 'textFieldStyle', 'textFieldClassName', 'inputStyle', 'inputClassName', 'maxLength', 'title', 'okLabel', 'cancelLabel', 'large', 'label', 'placeholder', 'inline', 'inlineIconChildren', 'inlineIconClassName', 'noIcon', 'header', 'enforceMinWidth']);

        delete props.id;
        delete props.onMouseOver;
        delete props.onMouseLeave;
        delete props.onTouchStart;
        delete props.onTouchEnd;
        delete props.value;
        delete props.defaultValue;
        delete props.onOkClick;
        delete props.onCancelClick;
        delete props.header;
        delete props.okOnOutsideClick;
        delete props.transitionDuration;
        delete props.scrollThreshold;

        var value = (0, _getField2.default)(this.props, this.state, 'value');
        var id = this.props.id;

        if (!id) {
          id = rowId + '-edit-dialog';
        }

        var actions = void 0;
        var largeTitle = void 0;
        if (!inline && large && active) {
          actions = [{
            label: cancelLabel,
            onClick: this._handleCancelClick,
            primary: true
          }, {
            label: okLabel,
            onClick: this._save,
            primary: true,
            ref: this._setOkButton,
            onKeyDown: this._overrideTab
          }];

          actions = _react2.default.createElement(_DialogFooter2.default, { actions: actions });

          largeTitle = _react2.default.createElement(
            'h3',
            { className: 'md-title' },
            title
          );
        }

        var pointer = (0, _classnames2.default)({ 'md-pointer--hover': !active });
        var inlineEditIcon = void 0;
        if (inline && !noIcon) {
          inlineEditIcon = _react2.default.createElement(
            _FontIcon2.default,
            { key: 'edit-icon', iconClassName: inlineIconClassName },
            inlineIconChildren
          );
        }

        var ariaProps = {};
        if (!inline) {
          ariaProps.id = id + '-container';
          ariaProps['aria-haspopup'] = true;
          ariaProps['aria-expanded'] = active;
          ariaProps['aria-owns'] = id;
        }

        return _react2.default.createElement(
          _TableColumn2.default,
          {
            style: _extends({ left: left }, style),
            className: (0, _classnames2.default)('prevent-grow md-edit-dialog-column', {
              'md-table-column--fixed': !inline && (absolute || active || animating),
              'md-table-column--fixed-active': active
            }, className),
            header: header,
            ref: this._setColumn,
            onMouseOver: this._handleMouseOver,
            onMouseLeave: this._handleMouseLeave,
            onClick: this._activateDialog,
            onTouchStart: this._handleTouchStart,
            onTouchEnd: this._activateDialog,
            __fixedColumn: true
          },
          _react2.default.createElement(
            'div',
            _extends({}, ariaProps, {
              ref: this._setDialog,
              style: _extends({ width: width }, dialogStyle),
              className: (0, _classnames2.default)('md-edit-dialog', {
                'md-edit-dialog--active': active,
                'md-edit-dialog--inline': inline,
                'md-edit-dialog--min-width': typeof enforceMinWidth === 'undefined' ? props.type === 'text' : enforceMinWidth,
                'md-background': active
              }, dialogClassName)
            }),
            largeTitle,
            _react2.default.createElement(_TextField2.default, _extends({}, props, {
              id: id,
              ref: this._setField,
              label: active ? label : null,
              active: active,
              floating: active,
              placeholder: active ? placeholder : placeholder || label,
              block: !active,
              paddedBlock: false,
              style: textFieldStyle,
              className: (0, _classnames2.default)(pointer, textFieldClassName),
              inputStyle: inputStyle,
              inputClassName: (0, _classnames2.default)(pointer, {
                'md-text-right': props.type === 'number'
              }, inputClassName),
              onKeyUp: this._handleKeyUp,
              onKeyDown: this._handleKeyDown,
              value: value,
              onChange: this._handleChange,
              maxLength: active ? maxLength : null,
              rightIcon: inlineEditIcon
            })),
            actions
          )
        );
      }
    }]);

    return EditDialogColumn;
  }(_react.PureComponent);

  EditDialogColumn.propTypes = {
    /**
     * An optional id to provide to the text field in the column. If this is omitted,
     * the id will be the current row id and `-edit-dialog`.
     */
    id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),

    /**
     * The optional style to apply to the edit dialog's column.
     */
    style: _propTypes2.default.object,

    /**
     * The optional className to apply to the edit dialog's column.
     */
    className: _propTypes2.default.string,

    /**
     * The optional style to apply to the edit dialog.
     */
    dialogStyle: _propTypes2.default.object,

    /**
     * The optional className to apply to the edit dialog.
     */
    dialogClassName: _propTypes2.default.string,

    /**
     * An optional style to apply to the text field.
     */
    textFieldStyle: _propTypes2.default.object,

    /**
     * An optional class name to apply to the text field.
     */
    textFieldClassName: _propTypes2.default.string,

    /**
     * An optional style to apply to the text field's input.
     */
    inputStyle: _propTypes2.default.object,

    /**
     * An optional class name to apply to the text field's input.
     */
    inputClassName: _propTypes2.default.string,

    /**
     * The transition duration when the dialog is moving from
     * active to inactive.
     */
    transitionDuration: _propTypes2.default.number.isRequired,

    /**
     * Boolean if the edit dialog is disabled.
     */
    disabled: _propTypes2.default.bool,

    /**
     * The optional max length for the edit dialog.
     */
    maxLength: _propTypes2.default.number,

    /**
     * A value to use for the edit dialog text field. This
     * will make the component controlled so you will need
     * to provide an `onChange` function.
     */
    value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),

    /**
     * An optional function to call when the text field's value
     * is changed. It is called with `(newValue, changeEvent)`.
     */
    onChange: _propTypes2.default.func,

    /**
     * The default value for the column.
     */
    defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),

    /**
     * An optional function to call when the input is clicked.
     */
    onClick: _propTypes2.default.func,

    /**
     * An optional function to call when the keyup event is triggered.
     */
    onKeyUp: _propTypes2.default.func,

    /**
     * An optional function to call when the keydown event is triggered.
     */
    onKeyDown: _propTypes2.default.func,

    /**
     * An optional function to call when the mouseover event is triggered.
     */
    onMouseOver: _propTypes2.default.func,

    /**
     * An optional function to call when the mouseleave event is triggered.
     */
    onMouseLeave: _propTypes2.default.func,

    /**
     * An optional function to call when the touchstart event is triggered.
     */
    onTouchStart: _propTypes2.default.func,

    /**
     * An optional function to call when the touchend event is triggered.
     */
    onTouchEnd: _propTypes2.default.func,

    /**
     * Boolean if the edit dialog should be large.
     */
    large: _propTypes2.default.bool,

    /**
     * The title for the large edit dialog. The custom validation changes to required
     * when the `large` prop is set to true.
     */
    title: function title(props, propName, component) {
      for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        others[_key - 3] = arguments[_key];
      }

      if (props.large) {
        var _PropTypes$node;

        return (_PropTypes$node = _propTypes2.default.node).isRequired.apply(_PropTypes$node, [props, propName, component].concat(others));
      } else {
        return _propTypes2.default.node.apply(_propTypes2.default, [props, propName, component].concat(others));
      }
    },

    /**
     * An optional function to call when the OK button is clicked.
     * It is called with `(textFieldValue, clickEvent)`. This function
     * will also be called when a user pressed the enter key.
     */
    onOkClick: _propTypes2.default.func,

    /**
     * The label to use for the OK button.
     */
    okLabel: _propTypes2.default.node.isRequired,

    /**
     * An optional function to call when the Cancel button is clicked.
     * It is called with `(textFieldValueBeforeEdit, clickEvent)`. This
     * function will also be called when the user presses the escape key.
     */
    onCancelClick: _propTypes2.default.func,

    /**
     * The label to use for the Cancel button.
     */
    cancelLabel: _propTypes2.default.node.isRequired,

    /**
     * An optional function to call when the edit dialog is open and the user clicks
     * somewhere else on the page.
     */
    onOutsideClick: _propTypes2.default.func,

    /**
     * A boolean if the action when the edit dialog is open and the user clicks somewhere
     * else on the page should be to confirm the current changes.
     *
     * If this is set to `true`, `onOkClick` will be called. Otherwise `onCancelClick` will
     * be called.
     */
    okOnOutsideClick: _propTypes2.default.bool.isRequired,

    /**
     * An optional label for the text field.
     */
    label: _propTypes2.default.node,

    /**
     * An optional placeholder for the text field.
     */
    placeholder: _propTypes2.default.string,

    /**
     * Boolean if the text field should not appear in a dialog.
     */
    inline: (0, _invalidIf2.default)(_propTypes2.default.bool, 'title', 'large'),

    /**
     * Any children used to display an inline edit dialog's edit icon.
     */
    inlineIconChildren: _propTypes2.default.node,

    /**
     * The icon className used to display the inline edit dialog's edit icon.
     */
    inlineIconClassName: _propTypes2.default.string,

    /**
     * Boolean if an inline edit text field should not include an icon.
     */
    noIcon: (0, _invalidIf2.default)(_propTypes2.default.bool, 'title', 'large'),

    /**
     * This is injected by the `TableRow` component.
     */
    header: _propTypes2.default.bool,

    /**
     * The type for the text field.
     */
    type: _TextField2.default.propTypes.type,

    /**
     * Boolean if the min width of the dialog should be set to the `$md-edit-dialog-column-min-width` variable.
     * If this is undefined, the min width will be enforced when the `type` prop is `text`.
     */
    enforceMinWidth: _propTypes2.default.bool,

    /**
     * When the dialog is open and a user scrolls the dialog offscreen, this is the amount
     * of the dialog that should be offscreen before hiding the dialog (inverse). The default
     * is to have 25% of the dialog offscreen.
     */
    scrollThreshold: _propTypes2.default.number.isRequired
  };
  EditDialogColumn.contextTypes = {
    rowId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired
  };
  EditDialogColumn.defaultProps = {
    type: 'text',
    defaultValue: '',
    transitionDuration: 300,
    okOnOutsideClick: true,
    okLabel: 'Save',
    cancelLabel: 'Cancel',
    inlineIconChildren: 'edit',
    scrollThreshold: 0.75
  };
  exports.default = EditDialogColumn;
});

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(258), __webpack_require__(114), __webpack_require__(154)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('../SelectFields/SelectField'), require('./TableColumn'), require('./findTable'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.SelectField, global.TableColumn, global.findTable);
    global.SelectFieldColumn = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _SelectField, _TableColumn, _findTable) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _SelectField2 = _interopRequireDefault(_SelectField);

  var _TableColumn2 = _interopRequireDefault(_TableColumn);

  var _findTable2 = _interopRequireDefault(_findTable);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var SelectFieldColumn = function (_PureComponent) {
    _inherits(SelectFieldColumn, _PureComponent);

    function SelectFieldColumn(props, context) {
      _classCallCheck(this, SelectFieldColumn);

      var _this = _possibleConstructorReturn(this, (SelectFieldColumn.__proto__ || Object.getPrototypeOf(SelectFieldColumn)).call(this, props, context));

      _this.state = {
        active: !!props.defaultOpen,
        left: null,
        width: null
      };

      _this._wrapper = null;
      _this._table = null;
      _this._left = null;
      _this._scrollLeft = null;

      _this._setWrapper = _this._setWrapper.bind(_this);
      _this._repositionCell = _this._repositionCell.bind(_this);
      _this._handleMenuToggle = _this._handleMenuToggle.bind(_this);
      return _this;
    }

    _createClass(SelectFieldColumn, [{
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps, prevState) {
        var active = this.state.active;

        if (active === prevState.active) {
          return;
        } else if (this._table) {
          this._table[(active ? 'add' : 'remove') + 'EventListener']('scroll', this._repositionCell);
          this._left = active ? this.state.left : null;
          this._scrollLeft = active ? this._table.scrollLeft : null;
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.table && this.state.active) {
          this._table.removeEventListener('scroll', this._repositionCell);
        }
      }
    }, {
      key: '_setWrapper',
      value: function _setWrapper(wrapper) {
        this._wrapper = wrapper;
        this._table = (0, _findTable2.default)(this._wrapper);
      }
    }, {
      key: '_repositionCell',
      value: function _repositionCell() {
        var _this2 = this;

        if (!this._ticking) {
          requestAnimationFrame(function () {
            _this2._ticking = false;

            var left = _this2._left;
            var scrolledOut = false;
            if (_this2._table) {
              var _table = _this2._table,
                  scrollLeft = _table.scrollLeft,
                  offsetWidth = _table.offsetWidth;

              left -= scrollLeft - _this2._scrollLeft;
              scrolledOut = left < 16 || offsetWidth - left < _this2.state.width * _this2.props.scrollThreshold;
            }

            var active = _this2.state.active;

            if (!_this2._timeout && scrolledOut) {
              active = false;
            }

            _this2.setState({ left: left, active: active });
          });
        }

        this._ticking = true;
      }
    }, {
      key: '_handleMenuToggle',
      value: function _handleMenuToggle(active, e) {
        if (this.props.onMenuToggle) {
          this.props.onMenuToggle(active, e);
        }

        var width = null;
        var left = null;
        if (this._wrapper && active) {
          left = this._wrapper.getBoundingClientRect().left - 1; // 1px for box shadow
          width = this._wrapper.offsetWidth;
        }

        this.setState({ active: active, width: width, left: left });
      }
    }, {
      key: 'render',
      value: function render() {
        var rowId = this.context.rowId;
        var _state = this.state,
            active = _state.active,
            width = _state.width,
            left = _state.left;

        var _props = this.props,
            style = _props.style,
            className = _props.className,
            menuStyle = _props.menuStyle,
            menuClassName = _props.menuClassName,
            wrapperStyle = _props.wrapperStyle,
            wrapperClassName = _props.wrapperClassName,
            header = _props.header,
            props = _objectWithoutProperties(_props, ['style', 'className', 'menuStyle', 'menuClassName', 'wrapperStyle', 'wrapperClassName', 'header']);

        delete props.id;
        delete props.scrollThreshold;

        var id = this.props.id;

        if (!id) {
          id = rowId + '-select';
        }

        return _react2.default.createElement(
          _TableColumn2.default,
          {
            style: _extends({ left: left }, style),
            className: (0, _classnames2.default)('md-select-field-column', {
              'md-table-column--fixed md-table-column--fixed-active': active
            }, className),
            header: header,
            __fixedColumn: true
          },
          _react2.default.createElement(
            'div',
            {
              ref: this._setWrapper,
              style: _extends({}, wrapperStyle, { width: width }),
              className: wrapperClassName
            },
            _react2.default.createElement(_SelectField2.default, _extends({
              id: id
            }, props, {
              style: menuStyle,
              className: menuClassName,
              onMenuToggle: this._handleMenuToggle,
              fullWidth: true
            }))
          )
        );
      }
    }]);

    return SelectFieldColumn;
  }(_react.PureComponent);

  SelectFieldColumn.propTypes = {
    /**
     * An optional id to use for the select field in the column. If this is omitted,
     * the id will be generated from the `baseId` from the `DataTable`.
     */
    id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),

    /**
     * An optional style to apply to the `TableColumn`.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply to the `TableColumn`.
     */
    className: _propTypes2.default.string,

    /**
     * An optional style to apply to the select field's wrapper in the column.
     */
    wrapperStyle: _propTypes2.default.object,

    /**
     * An optional className to apply to the select field's wrapper in the column.
     */
    wrapperClassName: _propTypes2.default.string,

    /**
     * An optional style to apply to the select field's menu component.
     */
    menuStyle: _propTypes2.default.object,

    /**
     * An optional className to apply to the select field's menu component.
     */
    menuClassName: _propTypes2.default.string,

    /**
     * An optional style to apply to the select field's input.
     */
    inputStyle: _propTypes2.default.object,

    /**
     * An optional className to apply to the select field's input.
     */
    inputClassName: _propTypes2.default.string,

    /**
     * Boolean if the `SelectFieldColumn` is in the `TableHeader` component. This is
     * injected from the `TableRow` component. Should not be used.
     */
    header: _propTypes2.default.bool,

    /**
     * An optional function to call when the select field's menu is toggled open.
     * See the select field component for the callback information.
     */
    onMenuToggle: _propTypes2.default.func,

    /**
     * The position of the select field. It is ideal to keep this as the default.
     */
    position: _SelectField2.default.propTypes.position,

    /**
     * Boolean if the select field is open by default.
     */
    defaultOpen: _propTypes2.default.bool,

    /**
     * When the dialog is open and a user scrolls the dialog offscreen, this is the amount
     * of the dialog that should be offscreen before hiding the dialog (inverse). The default
     * is to have 25% of the dialog offscreen.
     */
    scrollThreshold: _propTypes2.default.number.isRequired
  };
  SelectFieldColumn.defaultProps = {
    position: _SelectField2.default.Positions.BELOW,
    scrollThreshold: 0.75
  };
  SelectFieldColumn.contextTypes = {
    rowId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
  };
  exports.default = SelectFieldColumn;
});

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(66), __webpack_require__(3), __webpack_require__(38), __webpack_require__(589), __webpack_require__(65), __webpack_require__(555)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('react-transition-group/CSSTransitionGroup'), require('classnames'), require('../constants/CSSTransitionGroupTick'), require('../utils/PropTypes/oneRequired'), require('../utils/PropTypes/invalidIf'), require('../Cards/CardTitleBlock'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.CSSTransitionGroup, global.classnames, global.CSSTransitionGroupTick, global.oneRequired, global.invalidIf, global.CardTitleBlock);
    global.TableCardHeader = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _CSSTransitionGroup, _classnames, _CSSTransitionGroupTick, _oneRequired, _invalidIf, _CardTitleBlock) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);

  var _oneRequired2 = _interopRequireDefault(_oneRequired);

  var _invalidIf2 = _interopRequireDefault(_invalidIf);

  var _CardTitleBlock2 = _interopRequireDefault(_CardTitleBlock);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var TableCardHeader = function (_PureComponent) {
    _inherits(TableCardHeader, _PureComponent);

    function TableCardHeader(props) {
      _classCallCheck(this, TableCardHeader);

      var _this = _possibleConstructorReturn(this, (TableCardHeader.__proto__ || Object.getPrototypeOf(TableCardHeader)).call(this, props));

      _this.state = { animating: false };
      return _this;
    }

    _createClass(TableCardHeader, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var _this2 = this;

        var visible = this.props.visible;
        var nVisible = nextProps.visible,
            transitionEnterTimeout = nextProps.transitionEnterTimeout,
            transitionLeaveTimeout = nextProps.transitionLeaveTimeout;

        var timeout = !nVisible ? transitionLeaveTimeout : transitionEnterTimeout;
        if (visible !== nVisible) {
          if (this._timeout) {
            clearTimeout(this._timeout);
          }

          this._timeout = setTimeout(function () {
            _this2._timeout = setTimeout(function () {
              _this2._timeout = null;
              _this2.setState({ animating: false });
            }, timeout);
          }, _CSSTransitionGroupTick2.default);

          if (!this.state.animating) {
            this.setState({ animating: true });
          }
        }
      }
    }, {
      key: '_cloneCellRight',
      value: function _cloneCellRight(noAdjust, children) {
        if (noAdjust || !children) {
          return children;
        }

        return _react.Children.map(_react.Children.toArray(children), function (child, i) {
          if (i === 0) {
            return (0, _react.cloneElement)(child, { className: (0, _classnames2.default)('md-cell--right', child.props.className) });
          }

          return child;
        });
      }
    }, {
      key: '_cloneLeftChildren',
      value: function _cloneLeftChildren(noClone, children) {
        if (noClone || !children) {
          return children;
        }

        return _react.Children.map(_react.Children.toArray(children), function (child) {
          return (0, _react.cloneElement)(child, {
            className: (0, _classnames2.default)('md-btn--dialog', child.props.className)
          });
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var animating = this.state.animating;

        var _props = this.props,
            style = _props.style,
            className = _props.className,
            title = _props.title,
            actions = _props.actions,
            contextualChildren = _props.contextualChildren,
            noActionsAdjust = _props.noActionsAdjust,
            noChildrenAdjust = _props.noChildrenAdjust,
            noLeftChildrenClone = _props.noLeftChildrenClone,
            visible = _props.visible,
            props = _objectWithoutProperties(_props, ['style', 'className', 'title', 'actions', 'contextualChildren', 'noActionsAdjust', 'noChildrenAdjust', 'noLeftChildrenClone', 'visible']);

        delete props.children;
        delete props.leftChildren;
        delete props.contextualTitle;

        var _props2 = this.props,
            children = _props2.children,
            leftChildren = _props2.leftChildren,
            contextualTitle = _props2.contextualTitle;

        children = this._cloneCellRight(noChildrenAdjust, children);
        leftChildren = this._cloneLeftChildren(noLeftChildrenClone, leftChildren);

        if (title) {
          children = _react2.default.createElement(
            'div',
            { className: 'md-card-title', key: 'main-title' },
            _react2.default.createElement(_CardTitleBlock2.default, { title: title }),
            children
          );
        } else if (leftChildren) {
          leftChildren = _react.Children.toArray(leftChildren);

          if (children) {
            children = leftChildren.concat(_react.Children.toArray(children));
          } else {
            children = leftChildren;
          }
        }

        if (contextualTitle) {
          contextualTitle = _react2.default.createElement(
            'h2',
            { className: 'md-card-title--title md-card-title--title-contextual' },
            contextualTitle
          );
        }

        var contextualHeader = _react2.default.createElement(
          'div',
          { key: 'contextual-header', className: 'md-card-title md-card-title--contextual' },
          contextualTitle,
          contextualChildren,
          this._cloneCellRight(noActionsAdjust, actions)
        );

        var mergedStyles = style;
        if (animating) {
          mergedStyles = Object.assign({}, style, { overflow: 'hidden' });
        }

        return _react2.default.createElement(
          _CSSTransitionGroup2.default,
          _extends({}, props, {
            style: mergedStyles,
            className: (0, _classnames2.default)('md-table-card-header', {
              'md-table-card-header--no-title': !title
            }, className)
          }),
          children,
          visible ? contextualHeader : null
        );
      }
    }]);

    return TableCardHeader;
  }(_react.PureComponent);

  TableCardHeader.propTypes = {
    /**
     * An optional style to apply.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply.
     */
    className: _propTypes2.default.string,

    /**
     * The component to render as.
     */
    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,

    /**
     * The transition name to use when the contextual header appears.
     */
    transitionName: _propTypes2.default.string.isRequired,

    /**
     * The transition time to use when the contextual header appears.
     */
    transitionEnterTimeout: _propTypes2.default.number.isRequired,

    /**
     * The transition time to use when the contextual header disappears.
     */
    transitionLeaveTimeout: _propTypes2.default.number.isRequired,

    /**
     * An optional title to display. It is invalid to have both `title` and `leftChildren`
     * defined as only one will be used.
     */
    title: (0, _oneRequired2.default)(_propTypes2.default.node, 'leftChildren', 'children'),

    /**
     * An optional title to display in the contextual header. This will get wrapped in an `h2`
     * tag and additional styles applied.
     */
    contextualTitle: _propTypes2.default.node,

    /**
     * Any additional children to display in the contextual header. This will be displayed after
     * the optional `contextualTile` and before the `actions`.
     */
    contextualChildren: _propTypes2.default.node,

    /**
     * An optional button or list of buttons to display instead of a title.
     */
    leftChildren: (0, _invalidIf2.default)(_propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)]), 'title'),

    /**
     * An additional children to display after the `title` or `leftChildren` prop.
     * This is _normally_ a list of icon button or menu button.
     */
    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)]),

    /**
     * An optional button/menu button or a list of button/menu button to display in the
     * contextual header once the user has selected a row or multiple rows.
     */
    actions: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)]),

    /**
     * Boolean if the `actions` prop should not have each element cloned with additional
     * class names.
     */
    noActionsAdjust: _propTypes2.default.bool,

    /**
     * Boolean if the `children` prop should not have each element cloned with additional
     * class names.
     */
    noChildrenAdjust: _propTypes2.default.bool,

    /**
     * Boolean if the `leftChildren` prop should not have each element cloned with additional
     * class names.
     */
    noLeftChildrenClone: _propTypes2.default.bool,

    /**
     * Boolean if the contextual header is currently visible.
     */
    visible: _propTypes2.default.bool.isRequired
  };
  TableCardHeader.defaultProps = {
    component: 'header',
    transitionName: 'md-drop-down',
    transitionEnterTimeout: 150,
    transitionLeaveTimeout: 150
  };
  exports.default = TableCardHeader;
});

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(83), __webpack_require__(1112), __webpack_require__(154)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('../SelectionControls/SelectionControl'), require('./checkboxContextTypes'), require('./findTable'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.SelectionControl, global.checkboxContextTypes, global.findTable);
    global.TableCheckbox = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _SelectionControl, _checkboxContextTypes, _findTable) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _SelectionControl2 = _interopRequireDefault(_SelectionControl);

  var _checkboxContextTypes2 = _interopRequireDefault(_checkboxContextTypes);

  var _findTable2 = _interopRequireDefault(_findTable);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var TableCheckbox = function (_Component) {
    _inherits(TableCheckbox, _Component);

    function TableCheckbox(props, context) {
      _classCallCheck(this, TableCheckbox);

      var _this = _possibleConstructorReturn(this, (TableCheckbox.__proto__ || Object.getPrototypeOf(TableCheckbox)).call(this, props, context));

      _this._td = null;
      _this._header = false;
      _this._handleMount = _this._handleMount.bind(_this);
      return _this;
    }

    _createClass(TableCheckbox, [{
      key: '_handleMount',
      value: function _handleMount(td) {
        if (td) {
          var header = (0, _findTable2.default)(td).querySelector('thead');
          var index = td.parentNode.rowIndex - (header ? 1 : 0);

          if (td.parentNode.parentNode.tagName === 'TBODY') {
            this.context.createCheckbox(index);
          }
          this._td = td;
          this._header = header;
        } else if (this._td) {
          var _index = this._td.parentNode.rowIndex;
          this.context.removeCheckbox(_index - (this._header ? 1 : 0));
          this._td = null;
          this._header = false;
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            checked = _props.checked,
            props = _objectWithoutProperties(_props, ['checked']);

        var _context = this.context,
            uncheckedIconChildren = _context.uncheckedIconChildren,
            uncheckedIconClassName = _context.uncheckedIconClassName,
            checkedIconChildren = _context.checkedIconChildren,
            checkedIconClassName = _context.checkedIconClassName,
            rowId = _context.rowId,
            baseName = _context.baseName,
            header = _context.header;


        var Cell = header ? 'th' : 'td';

        return _react2.default.createElement(
          Cell,
          { className: 'md-table-checkbox', ref: this._handleMount },
          _react2.default.createElement(_SelectionControl2.default, _extends({}, props, {
            id: rowId,
            name: baseName + '-checkbox',
            type: 'checkbox',
            checked: checked,
            uncheckedCheckboxIconChildren: uncheckedIconChildren,
            uncheckedCheckboxIconClassName: uncheckedIconClassName,
            checkedCheckboxIconChildren: checkedIconChildren,
            checkedCheckboxIconClassName: checkedIconClassName
          }))
        );
      }
    }]);

    return TableCheckbox;
  }(_react.Component);

  TableCheckbox.propTypes = {
    checked: _propTypes2.default.bool
  };
  TableCheckbox.contextTypes = _checkboxContextTypes2.default;
  exports.default = TableCheckbox;
});

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('prop-types'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.propTypes);
    global.checkboxContextTypes = mod.exports;
  }
})(this, function (exports, _propTypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = {
    uncheckedIconClassName: _propTypes2.default.string.isRequired,
    uncheckedIconChildren: _propTypes2.default.node,
    checkedIconClassName: _propTypes2.default.string.isRequired,
    checkedIconChildren: _propTypes2.default.node,
    rowId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
    header: _propTypes2.default.bool,
    baseName: _propTypes2.default.string.isRequired,
    createCheckbox: _propTypes2.default.func.isRequired,
    removeCheckbox: _propTypes2.default.func.isRequired
  };
});

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(243), __webpack_require__(245), __webpack_require__(244), __webpack_require__(246), __webpack_require__(114), __webpack_require__(1108), __webpack_require__(557), __webpack_require__(1110), __webpack_require__(1109)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./DataTable'), require('./TableHeader'), require('./TableBody'), require('./TableRow'), require('./TableColumn'), require('./EditDialogColumn'), require('./TablePagination'), require('./TableCardHeader'), require('./SelectFieldColumn'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.DataTable, global.TableHeader, global.TableBody, global.TableRow, global.TableColumn, global.EditDialogColumn, global.TablePagination, global.TableCardHeader, global.SelectFieldColumn);
    global.index = mod.exports;
  }
})(this, function (exports, _DataTable2, _TableHeader2, _TableBody2, _TableRow2, _TableColumn2, _EditDialogColumn2, _TablePagination2, _TableCardHeader2, _SelectFieldColumn2) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.SelectFieldColumn = exports.TableCardHeader = exports.TablePagination = exports.EditDialogColumn = exports.TableColumn = exports.TableRow = exports.TableBody = exports.TableHeader = exports.DataTable = undefined;

  var _DataTable3 = _interopRequireDefault(_DataTable2);

  var _TableHeader3 = _interopRequireDefault(_TableHeader2);

  var _TableBody3 = _interopRequireDefault(_TableBody2);

  var _TableRow3 = _interopRequireDefault(_TableRow2);

  var _TableColumn3 = _interopRequireDefault(_TableColumn2);

  var _EditDialogColumn3 = _interopRequireDefault(_EditDialogColumn2);

  var _TablePagination3 = _interopRequireDefault(_TablePagination2);

  var _TableCardHeader3 = _interopRequireDefault(_TableCardHeader2);

  var _SelectFieldColumn3 = _interopRequireDefault(_SelectFieldColumn2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _DataTable3.default;
  exports.DataTable = _DataTable3.default;
  exports.TableHeader = _TableHeader3.default;
  exports.TableBody = _TableBody3.default;
  exports.TableRow = _TableRow3.default;
  exports.TableColumn = _TableColumn3.default;
  exports.EditDialogColumn = _EditDialogColumn3.default;
  exports.TablePagination = _TablePagination3.default;
  exports.TableCardHeader = _TableCardHeader3.default;
  exports.SelectFieldColumn = _SelectFieldColumn3.default;
});

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(247)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('prop-types'), require('./headerContextTypes'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.propTypes, global.headerContextTypes);
    global.rowContextTypes = mod.exports;
  }
})(this, function (exports, _propTypes, _headerContextTypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _headerContextTypes2 = _interopRequireDefault(_headerContextTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var rowContextTypes = Object.assign({}, _headerContextTypes2.default, {
    rowId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
  });

  delete rowContextTypes.baseId;
  exports.default = rowContextTypes;
});

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(9), __webpack_require__(3), __webpack_require__(587), __webpack_require__(561), __webpack_require__(46), __webpack_require__(1116), __webpack_require__(115)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('react-dom'), require('classnames'), require('../utils/EventUtils/isValidFocusKeypress'), require('../Helpers/FocusContainer'), require('../Papers/Paper'), require('./DialogTitle'), require('./DialogFooter'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.reactDom, global.classnames, global.isValidFocusKeypress, global.FocusContainer, global.Paper, global.DialogTitle, global.DialogFooter);
    global.Dialog = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _reactDom, _classnames, _isValidFocusKeypress, _FocusContainer, _Paper, _DialogTitle, _DialogFooter) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _isValidFocusKeypress2 = _interopRequireDefault(_isValidFocusKeypress);

  var _FocusContainer2 = _interopRequireDefault(_FocusContainer);

  var _Paper2 = _interopRequireDefault(_Paper);

  var _DialogTitle2 = _interopRequireDefault(_DialogTitle);

  var _DialogFooter2 = _interopRequireDefault(_DialogFooter);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _toArray(arr) {
    return Array.isArray(arr) ? arr : Array.from(arr);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Dialog = function (_PureComponent) {
    _inherits(Dialog, _PureComponent);

    function Dialog(props) {
      _classCallCheck(this, Dialog);

      var _this = _possibleConstructorReturn(this, (Dialog.__proto__ || Object.getPrototypeOf(Dialog)).call(this, props));

      _this._setRenderNode = function (dialog) {
        _this._renderNode = (0, _reactDom.findDOMNode)(dialog);
      };

      _this.state = { transformOrigin: null };
      _this._setContent = _this._setContent.bind(_this);
      _this._handleKeyDown = _this._handleKeyDown.bind(_this);
      return _this;
    }

    _createClass(Dialog, [{
      key: 'getChildContext',
      value: function getChildContext() {
        return { renderNode: this._renderNode };
      }
    }, {
      key: 'componentWillMount',
      value: function componentWillMount() {
        var _props = this.props,
            pageX = _props.pageX,
            containerX = _props.containerX,
            pageY = _props.pageY,
            containerY = _props.containerY;

        if (!pageX || !pageY) {
          return;
        }

        this.setState({
          transformOrigin: pageX - containerX + 'px ' + (pageY - containerY) + 'px'
        });
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (this.props.onOpen) {
          this.props.onOpen();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.props.onLeave) {
          this.props.onLeave();
        }
      }
    }, {
      key: '_setContent',
      value: function _setContent(content) {
        if (content !== null) {
          this._content = (0, _reactDom.findDOMNode)(content);
          var contentPadded = this._content.querySelectorAll('.md-list').length === 0;

          this.setState({ contentPadded: contentPadded });
        }
      }
    }, {
      key: '_handleKeyDown',
      value: function _handleKeyDown(e) {
        if (!(0, _isValidFocusKeypress2.default)(e)) {
          return;
        }

        var target = e.target,
            shiftKey = e.shiftKey;

        var _innerFocusables = _toArray(this._innerFocusables),
            first = _innerFocusables[0],
            focusables = _innerFocusables.slice(1);

        var last = focusables[focusables.length - 1];

        if (shiftKey && target === first) {
          e.preventDefault();
          last.focus();
        } else if (!shiftKey && target === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _state = this.state,
            contentPadded = _state.contentPadded,
            transformOrigin = _state.transformOrigin;

        var _props2 = this.props,
            id = _props2.id,
            className = _props2.className,
            contentStyle = _props2.contentStyle,
            contentClassName = _props2.contentClassName,
            title = _props2.title,
            Content = _props2.contentComponent,
            actions = _props2.actions,
            children = _props2.children,
            fullPage = _props2.fullPage,
            props = _objectWithoutProperties(_props2, ['id', 'className', 'contentStyle', 'contentClassName', 'title', 'contentComponent', 'actions', 'children', 'fullPage']);

        delete props.pageX;
        delete props.pageY;
        delete props.containerX;
        delete props.containerY;
        delete props.style;
        delete props.onOpen;
        delete props.onLeave;

        var _props3 = this.props,
            labelledBy = _props3['aria-labelledby'],
            style = _props3.style;

        var titleId = id + 'Title';
        if (!labelledBy && title) {
          labelledBy = titleId;
        }

        var dialogChildren = fullPage ? children : [_react2.default.createElement(
          _DialogTitle2.default,
          { key: 'title', id: titleId },
          title
        ), _react2.default.createElement(
          Content,
          {
            ref: this._setContent,
            key: 'content',
            style: contentStyle,
            className: (0, _classnames2.default)('md-dialog-content', {
              'md-dialog-content--padded': contentPadded
            }, contentClassName)
          },
          children
        ), _react2.default.createElement(_DialogFooter2.default, { key: 'footer', actions: actions })];

        if (transformOrigin) {
          style = Object.assign({}, style, { transformOrigin: transformOrigin });
        }

        return _react2.default.createElement(
          _Paper2.default,
          _extends({}, props, {
            id: id,
            component: _FocusContainer2.default,
            ref: this._setRenderNode,
            style: style,
            className: (0, _classnames2.default)('md-background--card md-dialog', {
              'md-dialog--full-page': fullPage,
              'md-dialog--centered': !fullPage
            }, className),
            role: 'dialog',
            'aria-labelledby': labelledBy
          }),
          dialogChildren
        );
      }
    }]);

    return Dialog;
  }(_react.PureComponent);

  Dialog.propTypes = {
    id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    'aria-labelledby': _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    style: _propTypes2.default.object,
    className: _propTypes2.default.string,
    contentStyle: _propTypes2.default.object,
    contentClassName: _propTypes2.default.string,
    title: _propTypes2.default.node,
    children: _propTypes2.default.node,
    contentComponent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
    actions: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.object, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.object]))]),
    initialFocus: _propTypes2.default.string,
    pageX: _propTypes2.default.number,
    pageY: _propTypes2.default.number,
    containerX: _propTypes2.default.number,
    containerY: _propTypes2.default.number,
    fullPage: _propTypes2.default.bool,
    onLeave: _propTypes2.default.func,
    zDepth: _propTypes2.default.number.isRequired,
    focusOnMount: _propTypes2.default.bool,
    onOpen: _propTypes2.default.func
  };
  Dialog.defaultProps = {
    contentComponent: 'section',
    zDepth: 5
  };
  Dialog.childContextTypes = {
    renderNode: _propTypes2.default.object
  };
  exports.default = Dialog;
});

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(0), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('prop-types'), require('react'), require('classnames'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.propTypes, global.react, global.classnames);
    global.DialogTitle = mod.exports;
  }
})(this, function (exports, _propTypes, _react, _classnames) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _react2 = _interopRequireDefault(_react);

  var _classnames2 = _interopRequireDefault(_classnames);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var DialogTitle = function (_PureComponent) {
    _inherits(DialogTitle, _PureComponent);

    function DialogTitle() {
      _classCallCheck(this, DialogTitle);

      return _possibleConstructorReturn(this, (DialogTitle.__proto__ || Object.getPrototypeOf(DialogTitle)).apply(this, arguments));
    }

    _createClass(DialogTitle, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            children = _props.children,
            className = _props.className,
            props = _objectWithoutProperties(_props, ['children', 'className']);

        if (!children) {
          return null;
        }

        return _react2.default.createElement(
          'h2',
          _extends({}, props, { className: (0, _classnames2.default)('md-title md-title--dialog', className) }),
          children
        );
      }
    }]);

    return DialogTitle;
  }(_react.PureComponent);

  DialogTitle.propTypes = {
    id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    className: _propTypes2.default.string,
    children: _propTypes2.default.node
  };
  exports.default = DialogTitle;
});

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(250)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./Divider'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.Divider);
    global.index = mod.exports;
  }
})(this, function (exports, _Divider) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _Divider2 = _interopRequireDefault(_Divider);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _Divider2.default;
});

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(82)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('../Helpers/Portal'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.Portal);
    global.Overlay = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _Portal) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _Portal2 = _interopRequireDefault(_Portal);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Overlay = function (_PureComponent) {
    _inherits(Overlay, _PureComponent);

    function Overlay() {
      _classCallCheck(this, Overlay);

      return _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).apply(this, arguments));
    }

    _createClass(Overlay, [{
      key: 'getChildContext',
      value: function getChildContext() {
        // Always want the overlay to render in a separate subtree until 1.1.0
        return { isInPortal: false };
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            active = _props.active,
            visible = _props.visible,
            renderNode = _props.renderNode,
            onClick = _props.onClick;

        return _react2.default.createElement(
          _Portal2.default,
          { visible: visible, renderNode: renderNode },
          _react2.default.createElement('div', {
            className: (0, _classnames2.default)('md-overlay md-overlay--drawer md-pointer--hover', {
              'md-overlay--active': active
            }),
            onClick: onClick
          })
        );
      }
    }]);

    return Overlay;
  }(_react.PureComponent);

  Overlay.propTypes = {
    active: _propTypes2.default.bool,
    visible: _propTypes2.default.bool.isRequired,
    renderNode: _propTypes2.default.object,
    onClick: _propTypes2.default.func
  };
  Overlay.childContextTypes = {
    isInPortal: _propTypes2.default.bool
  };
  exports.default = Overlay;
});

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(251)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./Drawer'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.Drawer);
    global.index = mod.exports;
  }
})(this, function (exports, _Drawer) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _Drawer2 = _interopRequireDefault(_Drawer);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _Drawer2.default;
});

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(9), __webpack_require__(3), __webpack_require__(14), __webpack_require__(119)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('react-dom'), require('classnames'), require('../constants/keyCodes'), require('../utils/EventUtils/handleWindowClickListeners'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.reactDom, global.classnames, global.keyCodes, global.handleWindowClickListeners);
    global.ExpansionList = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _reactDom, _classnames, _keyCodes, _handleWindowClickListeners) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _handleWindowClickListeners2 = _interopRequireDefault(_handleWindowClickListeners);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var ExpansionList = function (_PureComponent) {
    _inherits(ExpansionList, _PureComponent);

    function ExpansionList(props) {
      _classCallCheck(this, ExpansionList);

      var _this = _possibleConstructorReturn(this, (ExpansionList.__proto__ || Object.getPrototypeOf(ExpansionList)).call(this, props));

      _this.state = { columnWidths: [], focusedIndex: -1 };

      _this._setContainer = _this._setContainer.bind(_this);
      _this._removeFocus = _this._removeFocus.bind(_this);
      _this._calcColumnWidths = _this._calcColumnWidths.bind(_this);
      _this._determineTabFocus = _this._determineTabFocus.bind(_this);
      return _this;
    }

    _createClass(ExpansionList, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (this.props.children !== nextProps.children) {
          this._calcColumnWidths();
        }
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps, prevState) {
        var focusedIndex = this.state.focusedIndex;

        if (prevState.focusedIndex === focusedIndex || prevState.focusedIndex > -1 && focusedIndex > -1) {
          return;
        }

        (0, _handleWindowClickListeners2.default)(this._removeFocus, this.state.focusedIndex !== -1);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.state.focusedIndex === -1) {
          (0, _handleWindowClickListeners2.default)(this._removeFocus, false);
        }

        window.removeEventListener('keyup', this._determineTabFocus);
      }
    }, {
      key: '_setContainer',
      value: function _setContainer(container) {
        if (container !== null) {
          this._container = (0, _reactDom.findDOMNode)(container);
          window.addEventListener('keyup', this._determineTabFocus);

          this._calcColumnWidths();
        }
      }
    }, {
      key: '_determineTabFocus',
      value: function _determineTabFocus(e) {
        if ((e.which || e.keyCode) === _keyCodes.TAB) {
          var panels = Array.prototype.slice.call((0, _reactDom.findDOMNode)(this).querySelectorAll('.md-panel-header'));
          this.setState({ focusedIndex: panels.indexOf(e.target) });
        }
      }
    }, {
      key: '_removeFocus',
      value: function _removeFocus() {
        this.setState({ focusedIndex: -1 });
      }
    }, {
      key: '_calcColumnWidths',
      value: function _calcColumnWidths() {
        if (!this._container) {
          return;
        }

        var columnWidths = Array.prototype.slice.call(this._container.querySelectorAll('.md-panel-header')).reduce(function (maxes, row) {
          var columns = row.querySelectorAll('.md-panel-column');
          for (var i = 0; i < columns.length; i++) {
            // Only need to include the offsetWidth of the column because the child will really
            // determine the width of the column. Since it has already been defined at this point,
            // no additional work needs to be done.
            maxes[i] = Math.max(columns[i].offsetWidth, maxes[i] || 0);
          }

          return maxes;
        }, [0]);

        this.setState({ columnWidths: columnWidths });
      }
    }, {
      key: 'render',
      value: function render() {
        var _state = this.state,
            columnWidths = _state.columnWidths,
            focusedIndex = _state.focusedIndex;

        var _props = this.props,
            children = _props.children,
            className = _props.className,
            component = _props.component,
            props = _objectWithoutProperties(_props, ['children', 'className', 'component']);

        return (0, _react.createElement)(component, _extends({}, props, {
          ref: this._setContainer,
          className: (0, _classnames2.default)('md-expansion-panel-list', className)
        }), _react.Children.map(children, function (child, i) {
          return (0, _react.cloneElement)(child, {
            key: child.key || i,
            columnWidths: columnWidths,
            focused: focusedIndex === i
          });
        }));
      }
    }]);

    return ExpansionList;
  }(_react.PureComponent);

  ExpansionList.propTypes = {
    /**
     * An optional style object to apply to the list.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply to the list.
     */
    className: _propTypes2.default.string,

    /**
     * The children should be a list or singular `ExpansionPanel` component
     * to render with some additional props injected.
     */
    children: _propTypes2.default.node,

    /**
     * The component to render the list as.
     */
    component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired
  };
  ExpansionList.defaultProps = {
    component: 'ul'
  };
  exports.default = ExpansionList;
});

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(9), __webpack_require__(3), __webpack_require__(20), __webpack_require__(46), __webpack_require__(252), __webpack_require__(155), __webpack_require__(62), __webpack_require__(1122)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('react-dom'), require('classnames'), require('../utils/PropTypes/controlled'), require('../Papers/Paper'), require('../FontIcons/Collapser'), require('../Helpers/AccessibleFakeButton'), require('../Helpers/Collapse'), require('./PanelContent'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.reactDom, global.classnames, global.controlled, global.Paper, global.Collapser, global.AccessibleFakeButton, global.Collapse, global.PanelContent);
    global.ExpansionPanel = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _reactDom, _classnames, _controlled, _Paper, _Collapser, _AccessibleFakeButton, _Collapse, _PanelContent) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _controlled2 = _interopRequireDefault(_controlled);

  var _Paper2 = _interopRequireDefault(_Paper);

  var _Collapser2 = _interopRequireDefault(_Collapser);

  var _AccessibleFakeButton2 = _interopRequireDefault(_AccessibleFakeButton);

  var _Collapse2 = _interopRequireDefault(_Collapse);

  var _PanelContent2 = _interopRequireDefault(_PanelContent);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var LABEL_FONT_SIZE = 15;
  var LINE_HEIGHT = 1.42857;
  var SINGLE_LINE_HEIGHT = LABEL_FONT_SIZE * LINE_HEIGHT;

  /**
   * The `ExpansionPanel` component needs to be used with the `ExpansionList`
   * component. The only reason is that the `ExpansionPanel` should really
   * be rendered as a table, but it was a bit hard to have a single component
   * dynamically rendering another row when expanded. It couldn't be in the
   * same row since the expanded content might not have the same columns.
   */

  var ExpansionPanel = function (_PureComponent) {
    _inherits(ExpansionPanel, _PureComponent);

    function ExpansionPanel(props) {
      _classCallCheck(this, ExpansionPanel);

      var _this = _possibleConstructorReturn(this, (ExpansionPanel.__proto__ || Object.getPrototypeOf(ExpansionPanel)).call(this, props));

      _this.state = {
        received: false,
        twoLine: false
      };

      if (typeof props.expanded === 'undefined') {
        _this.state.expanded = props.defaultExpanded;
      }

      _this._handleSave = _this._handleSave.bind(_this);
      _this._handleCancel = _this._handleCancel.bind(_this);
      _this._handleClick = _this._handleClick.bind(_this);
      _this._determineIfTwoLine = _this._determineIfTwoLine.bind(_this);
      return _this;
    }

    _createClass(ExpansionPanel, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this._determineIfTwoLine();
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (false) {
          if (nextProps.columnWidths.length === 0) {
            // Hopefully a nice warning about fixing the missing props injected from ExpansionList
            /* eslint-disable no-console */
            console.error('The `ExpansionPanel` component expects the `columnWidths` prop to be injected from the ' + '`ExpansionList` component. It could be missing because:' + '\n - you have a wrapper component with extra functionality' + '\n - the `ExpansionPanel` is not a direct child of the `ExpansonList` component' + '\n\nYou can fix this by making sure to pass `this.props.focused` and `this.props.columWidths` ' + 'within your wrapper component and making the `ExpansionPanel` a direct child of `ExpansionList`.');
          }

          this.setState({ received: true });
        }
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.label === prevProps.label && this.props.secondaryLabel === prevProps.secondaryLabel) {
          return;
        }

        this._determineIfTwoLine();
      }
    }, {
      key: '_isExpanded',
      value: function _isExpanded(props, state) {
        return typeof props.expanded === 'undefined' ? state.expanded : props.expanded;
      }
    }, {
      key: '_determineIfTwoLine',
      value: function _determineIfTwoLine() {
        var twoLine = false;
        Array.prototype.slice.call((0, _reactDom.findDOMNode)(this).querySelectorAll('.md-panel-column')).some(function (el) {
          return twoLine = el.offsetHeight > SINGLE_LINE_HEIGHT;
        });

        this.setState({ twoLine: twoLine });
      }
    }, {
      key: '_handleClick',
      value: function _handleClick() {
        var expanded = !this._isExpanded(this.props, this.state);
        if (this.props.onExpandToggle) {
          this.props.onExpandToggle(expanded);
        }

        if (typeof this.props.expanded === 'undefined') {
          this.setState({ expanded: expanded });
        }
      }
    }, {
      key: '_handleSave',
      value: function _handleSave(e) {
        var _props = this.props,
            onSave = _props.onSave,
            onExpandToggle = _props.onExpandToggle,
            closeOnSave = _props.closeOnSave;

        if (onSave) {
          onSave(e);
        }

        if (closeOnSave) {
          if (onExpandToggle) {
            onExpandToggle(false);
          }

          if (typeof this.props.expanded === 'undefined') {
            this.setState({ expanded: false });
          }
        }
      }
    }, {
      key: '_handleCancel',
      value: function _handleCancel(e) {
        var _props2 = this.props,
            onCancel = _props2.onCancel,
            onExpandToggle = _props2.onExpandToggle,
            closeOnCancel = _props2.closeOnCancel;

        if (onCancel) {
          onCancel(e);
        }

        if (closeOnCancel) {
          if (onExpandToggle) {
            onExpandToggle(false);
          }

          if (typeof this.props.expanded === 'undefined') {
            this.setState({ expanded: false });
          }
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _props3 = this.props,
            className = _props3.className,
            label = _props3.label,
            secondaryLabel = _props3.secondaryLabel,
            expandedSecondaryLabel = _props3.expandedSecondaryLabel,
            children = _props3.children,
            expandIconChildren = _props3.expandIconChildren,
            expandIconClassName = _props3.expandIconClassName,
            focused = _props3.focused,
            columnWidths = _props3.columnWidths,
            saveType = _props3.saveType,
            saveLabel = _props3.saveLabel,
            savePrimary = _props3.savePrimary,
            saveSecondary = _props3.saveSecondary,
            cancelType = _props3.cancelType,
            cancelLabel = _props3.cancelLabel,
            cancelPrimary = _props3.cancelPrimary,
            cancelSecondary = _props3.cancelSecondary,
            headerStyle = _props3.headerStyle,
            headerClassName = _props3.headerClassName,
            contentStyle = _props3.contentStyle,
            contentClassName = _props3.contentClassName,
            tabIndex = _props3.tabIndex,
            props = _objectWithoutProperties(_props3, ['className', 'label', 'secondaryLabel', 'expandedSecondaryLabel', 'children', 'expandIconChildren', 'expandIconClassName', 'focused', 'columnWidths', 'saveType', 'saveLabel', 'savePrimary', 'saveSecondary', 'cancelType', 'cancelLabel', 'cancelPrimary', 'cancelSecondary', 'headerStyle', 'headerClassName', 'contentStyle', 'contentClassName', 'tabIndex']);

        delete props.defaultExpanded;
        delete props.expanded;
        delete props.onSave;
        delete props.onCancel;
        delete props.onExpandToggle;
        delete props.closeOnSave;
        delete props.closeOnCancel;

        var twoLine = this.state.twoLine;

        var expanded = this._isExpanded(this.props, this.state);

        var columns = _react.Children.map(expanded && expandedSecondaryLabel || secondaryLabel, function (panelLabel, i) {
          return _react2.default.createElement(
            'div',
            { className: 'md-panel-column md-text', style: { minWidth: columnWidths[i + 1] } },
            panelLabel
          );
        });

        if (!Array.isArray(columns)) {
          columns = [columns];
        }

        columns.unshift(_react2.default.createElement(
          'div',
          { className: 'md-panel-column md-text', style: { minWidth: columnWidths[0] }, key: 'main-label' },
          label
        ));

        return _react2.default.createElement(
          _Paper2.default,
          _extends({}, props, {
            className: (0, _classnames2.default)('md-expansion-panel', {
              'md-expansion-panel--expanded': expanded
            }, className),
            'aria-expanded': expanded
          }),
          _react2.default.createElement(
            _AccessibleFakeButton2.default,
            {
              onClick: this._handleClick,
              style: headerStyle,
              className: (0, _classnames2.default)('md-panel-header', {
                'md-panel-header--expanded': expanded || twoLine,
                'md-panel-header--focused': focused
              }, headerClassName),
              tabIndex: tabIndex
            },
            columns,
            _react2.default.createElement(
              _Collapser2.default,
              { flipped: expanded, iconClassName: expandIconClassName, className: 'md-cell--right' },
              expandIconChildren
            )
          ),
          _react2.default.createElement(
            _Collapse2.default,
            { collapsed: !expanded },
            _react2.default.createElement(
              _PanelContent2.default,
              {
                style: contentStyle,
                className: contentClassName,
                onSave: this._handleSave,
                onCancel: this._handleCancel,
                saveType: saveType,
                saveLabel: saveLabel,
                savePrimary: savePrimary,
                saveSecondary: saveSecondary,
                cancelType: cancelType,
                cancelLabel: cancelLabel,
                cancelPrimary: cancelPrimary,
                cancelSecondary: cancelSecondary
              },
              children
            )
          )
        );
      }
    }]);

    return ExpansionPanel;
  }(_react.PureComponent);

  ExpansionPanel.propTypes = {
    /**
     * An optional style to apply to the panel.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply to the panel.
     */
    className: _propTypes2.default.string,

    /**
     * An options style to apply to the panel's header content. This is the
     * section that toggles the children to be visible and label columns.
     */
    headerStyle: _propTypes2.default.object,

    /**
     * An optional className to apply to the panel's header content. This is the
     * section that toggles the children to be visible and label columns.
     */
    headerClassName: _propTypes2.default.string,

    /**
     * An optional style to applt to the element surrounding the children when expanded.
     */
    contentStyle: _propTypes2.default.object,

    /**
     * An optional className to applt to the element surrounding the children when expanded.
     */
    contentClassName: _propTypes2.default.string,

    /**
     * The main label to display in the unexpanded panel.
     */
    label: _propTypes2.default.node.isRequired,

    /**
     * Any additional columns to display after the main label. If this is a `list`
     * instead of a singular item, they will each be formatted as a column.
     */
    secondaryLabel: _propTypes2.default.node,

    /**
     * Any additional columns to display after the main label when the panel is
     * expanded. If this is omitted, the default `secondaryLabel` will be displayed
     * instead.
     */
    expandedSecondaryLabel: _propTypes2.default.node,

    /**
     * The component to render the panel as.
     */
    component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,

    /**
     * The content to display once the panel is toggled open.
     */
    children: _propTypes2.default.node,

    /**
     * A boolean if the panel is currently expanded. This will force the component
     * to be controlled and require's the `onExpandToggle` function to be defined.
     */
    expanded: (0, _controlled2.default)(_propTypes2.default.bool, 'onExpandToggle', 'defaultExpanded'),

    /**
     * Boolean if an uncontrolled panel should be expanded by default.
     */
    defaultExpanded: _propTypes2.default.bool.isRequired,

    /**
     * Any children required to render the expand icon.
     */
    expandIconChildren: _propTypes2.default.node,

    /**
     * The icon className to use to render the expand icon.
     */
    expandIconClassName: _propTypes2.default.string,

    /**
     * Boolean if the `ExpansionPanel` is currently tab focused. This is injected
     * and managed by the `ExpansionList` component. Do not set yourself.
     */
    focused: _propTypes2.default.bool.isRequired,

    /**
     * A list of min-widths to apply to each column in the panel header. This is injected
     * and managed by the `ExpansionList` component. Do not set yourself.
     */
    columnWidths: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,

    /**
     * A function to call when the expansion panel's expanded state is toggled.
     * The callback for this function will include the new expanded state.
     *
     * `onExpandToggle(expanded)`
     */
    onExpandToggle: _propTypes2.default.func,

    /**
     * An optional function to call when the Save button is clicked on the expanded panel.
     */
    onSave: _propTypes2.default.func,

    /**
     * An optional function to call when the Cancel button is clicked on the expanded panel.
     */
    onCancel: _propTypes2.default.func,

    /**
     * Boolean if the panel should close when the Save button is clicked.
     */
    closeOnSave: _propTypes2.default.bool,

    /**
     * Boolean if the panel should close when the Cancel button is clicked.
     */
    closeOnCancel: _propTypes2.default.bool,

    /**
     * An optional button type to apply to the Save button. This will get
     * passed to the `FlatButton`.
     */
    saveType: _propTypes2.default.oneOf(['button', 'submit', 'reset']),

    /**
     * The label for the Save button.
     */
    saveLabel: _propTypes2.default.node.isRequired,

    /**
     * Boolean if the Save button should be styled with the primary color.
     */
    savePrimary: _propTypes2.default.bool,

    /**
     * Boolean if the Save button should be styled with the secondary color,
     */
    saveSecondary: _propTypes2.default.bool,

    /**
     * An optional button type to apply to the Cancel button. This will get
     * passed to the `FlatButton`.
     */
    cancelType: _propTypes2.default.oneOf(['button', 'submit', 'reset']),

    /**
     * The label for the Cancel button.
     */
    cancelLabel: _propTypes2.default.node.isRequired,

    /**
     * Boolean if the Cancel button should be styled with the primary color,
     */
    cancelPrimary: _propTypes2.default.bool,

    /**
     * Boolean if the Cancel button should be styled with the secondary color,
     */
    cancelSecondary: _propTypes2.default.bool,

    /**
     * The tab index for the panel's header. This allows keyboard navigation.
     */
    tabIndex: _propTypes2.default.number.isRequired
  };
  ExpansionPanel.defaultProps = {
    defaultExpanded: false,
    expandIconChildren: 'keyboard_arrow_down',
    component: 'li',
    saveLabel: 'Save',
    cancelLabel: 'Cancel',
    savePrimary: true,
    tabIndex: 0,
    closeOnSave: true,
    closeOnCancel: true,
    focused: false,
    columnWidths: []
  };
  exports.default = ExpansionPanel;
});

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(115)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('../Dialogs/DialogFooter'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.DialogFooter);
    global.PanelContent = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _DialogFooter) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _DialogFooter2 = _interopRequireDefault(_DialogFooter);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var PanelContent = function (_PureComponent) {
    _inherits(PanelContent, _PureComponent);

    function PanelContent() {
      _classCallCheck(this, PanelContent);

      return _possibleConstructorReturn(this, (PanelContent.__proto__ || Object.getPrototypeOf(PanelContent)).apply(this, arguments));
    }

    _createClass(PanelContent, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            style = _props.style,
            contentStyle = _props.contentStyle,
            className = _props.className,
            children = _props.children,
            onSave = _props.onSave,
            onCancel = _props.onCancel,
            saveType = _props.saveType,
            saveLabel = _props.saveLabel,
            savePrimary = _props.savePrimary,
            saveSecondary = _props.saveSecondary,
            cancelType = _props.cancelType,
            cancelLabel = _props.cancelLabel,
            cancelPrimary = _props.cancelPrimary,
            cancelSecondary = _props.cancelSecondary;


        var actions = [{
          type: cancelType,
          label: cancelLabel,
          onClick: onCancel,
          primary: cancelPrimary,
          secondary: cancelSecondary
        }, {
          type: saveType,
          label: saveLabel,
          onClick: onSave,
          primary: savePrimary,
          secondary: saveSecondary
        }];

        return _react2.default.createElement(
          'div',
          { style: style },
          _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)('md-panel-content', className), style: contentStyle },
            children
          ),
          _react2.default.createElement(_DialogFooter2.default, { actions: actions, className: 'md-divider-border md-divider-border--top' })
        );
      }
    }]);

    return PanelContent;
  }(_react.PureComponent);

  PanelContent.propTypes = {
    style: _propTypes2.default.object,
    className: _propTypes2.default.string,
    contentStyle: _propTypes2.default.object,
    children: _propTypes2.default.node,
    onSave: _propTypes2.default.func.isRequired,
    onCancel: _propTypes2.default.func.isRequired,
    saveType: _propTypes2.default.string,
    saveLabel: _propTypes2.default.node.isRequired,
    savePrimary: _propTypes2.default.bool,
    saveSecondary: _propTypes2.default.bool,
    cancelType: _propTypes2.default.string,
    cancelLabel: _propTypes2.default.node.isRequired,
    cancelPrimary: _propTypes2.default.bool,
    cancelSecondary: _propTypes2.default.bool
  };
  exports.default = PanelContent;
});

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1121), __webpack_require__(1120)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./ExpansionPanel'), require('./ExpansionList'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.ExpansionPanel, global.ExpansionList);
    global.index = mod.exports;
  }
})(this, function (exports, _ExpansionPanel, _ExpansionList2) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.ExpansionList = exports.ExpansionPanel = undefined;

  var _ExpansionPanel2 = _interopRequireDefault(_ExpansionPanel);

  var _ExpansionList3 = _interopRequireDefault(_ExpansionList2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _ExpansionPanel2.default;
  exports.ExpansionPanel = _ExpansionPanel2.default;
  exports.ExpansionList = _ExpansionList3.default;
});

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(66), __webpack_require__(3), __webpack_require__(11)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('react-transition-group/CSSTransitionGroup'), require('classnames'), require('../Buttons/Button'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.CSSTransitionGroup, global.classnames, global.Button);
    global.SpeedDial = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _CSSTransitionGroup, _classnames, _Button) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _Button2 = _interopRequireDefault(_Button);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var SpeedDial = function (_PureComponent) {
    _inherits(SpeedDial, _PureComponent);

    function SpeedDial(props) {
      _classCallCheck(this, SpeedDial);

      var _this = _possibleConstructorReturn(this, (SpeedDial.__proto__ || Object.getPrototypeOf(SpeedDial)).call(this, props));

      _this.state = { isOpen: props.initiallyOpen };
      _this._handleClick = _this._handleClick.bind(_this);
      return _this;
    }

    _createClass(SpeedDial, [{
      key: '_isOpen',
      value: function _isOpen(props, state) {
        return typeof props.isOpen === 'undefined' ? state.isOpen : props.isOpen;
      }
    }, {
      key: '_handleClick',
      value: function _handleClick(e) {
        var _props = this.props,
            onClick = _props.onClick,
            onPassiveClick = _props.onPassiveClick,
            onActiveClick = _props.onActiveClick;

        if (onClick) {
          onClick(e);
        }

        var isOpen = this._isOpen(this.props, this.state);
        if (isOpen && onActiveClick) {
          onActiveClick(e);
        } else if (!isOpen && onPassiveClick) {
          onPassiveClick(e);
        }

        if (typeof this.props.isOpen === 'undefined') {
          this.setState({ isOpen: !isOpen });
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _props2 = this.props,
            fabs = _props2.fabs,
            passiveIconChildren = _props2.passiveIconChildren,
            passiveIconClassName = _props2.passiveIconClassName,
            activeIconChildren = _props2.activeIconChildren,
            activeIconClassName = _props2.activeIconClassName,
            transitionName = _props2.transitionName,
            transitionEnterTimeout = _props2.transitionEnterTimeout,
            speedDialTransitionName = _props2.speedDialTransitionName,
            speedDialTransitionEnterTimeout = _props2.speedDialTransitionEnterTimeout,
            speedDialTransitionLeaveTimeout = _props2.speedDialTransitionLeaveTimeout,
            containerProps = _props2.containerProps,
            props = _objectWithoutProperties(_props2, ['fabs', 'passiveIconChildren', 'passiveIconClassName', 'activeIconChildren', 'activeIconClassName', 'transitionName', 'transitionEnterTimeout', 'speedDialTransitionName', 'speedDialTransitionEnterTimeout', 'speedDialTransitionLeaveTimeout', 'containerProps']);

        delete props.isOpen;
        delete props.initiallyOpen;

        var isOpen = this._isOpen(this.props, this.state);

        var speedDialFabs = void 0;
        if (isOpen) {
          speedDialFabs = fabs.map(function (fab, i) {
            var fn = void 0;
            var el = void 0;
            var fabProps = void 0;
            if (_react2.default.isValidElement(fab)) {
              el = _react2.default.Children.only(fab);
              fn = _react2.default.cloneElement;
              fabProps = fab.props;
            } else {
              el = _Button2.default;
              fn = _react2.default.createElement;
              fabProps = fab;
            }

            var created = fn(el, _extends({
              floating: true,
              mini: true
            }, fabProps));
            return _react2.default.createElement(
              'div',
              { key: i, className: 'md-speed-dial-fab' },
              created
            );
          });
        }

        props.iconClassName = isOpen ? activeIconClassName : passiveIconClassName;
        props.children = isOpen ? activeIconChildren : passiveIconChildren;
        return _react2.default.createElement(
          _CSSTransitionGroup2.default,
          _extends({}, containerProps, {
            component: 'div',
            className: (0, _classnames2.default)('md-speed-dial', !!containerProps && containerProps.className),
            transitionName: transitionName + '-' + (isOpen ? 'right' : 'left'),
            transitionEnterTimeout: transitionEnterTimeout,
            transitionLeave: false,
            ref: 'container'
          }),
          _react2.default.createElement(
            _CSSTransitionGroup2.default,
            {
              component: 'div',
              key: 'speed-dial-fabs',
              transitionName: speedDialTransitionName,
              transitionEnterTimeout: speedDialTransitionEnterTimeout,
              transitionLeaveTimeout: speedDialTransitionLeaveTimeout
            },
            speedDialFabs
          ),
          _react2.default.createElement(_Button2.default, _extends({}, props, {
            floating: true,
            key: (isOpen ? 'open' : 'closed') + '-fab',
            onClick: this._handleClick
          }))
        );
      }
    }]);

    return SpeedDial;
  }(_react.PureComponent);

  SpeedDial.propTypes = {
    /**
     * A boolean if the speed dial is currently open. This will make
     * the speed dial into a controlled component.
     */
    isOpen: _propTypes2.default.bool,

    /**
     * Boolean if the uncontrolled speed dial is initially open.
     */
    initiallyOpen: _propTypes2.default.bool,

    /**
     * An optional className to apply to the speed dial.
     */
    className: _propTypes2.default.string,

    /**
     * The speed dial's floating action button transition name when the button's
     * open state changes. If the button is open, `-right` is appened, otherwise
     * `-left`.
     */
    transitionName: _propTypes2.default.string.isRequired,

    /**
     * The timeout for the speed dial's floating action button transition.
     */
    transitionEnterTimeout: _propTypes2.default.number.isRequired,

    /**
     * The name for the flinging animation of the speed dial.
     */
    speedDialTransitionName: _propTypes2.default.string.isRequired,

    /**
     * The timeout for the flinging animation of the speed dial when opening.
     */
    speedDialTransitionEnterTimeout: _propTypes2.default.number.isRequired,

    /**
     * The timeout for the flinging animation when the speed dial is closing.
     */
    speedDialTransitionLeaveTimeout: _propTypes2.default.number.isRequired,

    /**
     * The optional children to display for unopened speed dial floating action button.
     */
    passiveIconChildren: _propTypes2.default.node,

    /**
     * The optional icon className to display for unopened speed dial floating action button.
     */
    passiveIconClassName: _propTypes2.default.node,

    /**
     * The optional children to display for opened speed dial floating action button.
     */
    activeIconChildren: _propTypes2.default.node,

    /**
     * The optional icon className to display for opened speed dial floating action button.
     */
    activeIconClassName: _propTypes2.default.string,

    /**
     * A list of `FloatingButton` or props to generate the `FloatinButton` when the
     * `SpeedDial` is open. The buttons will automatically be converted to the `mini`
     * version.
     */
    fabs: function fabs(props, propName, component) {
      for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        others[_key - 3] = arguments[_key];
      }

      var size = props.fabs.length;
      if (size >= 3 && size <= 5) {
        var _PropTypes$arrayOf;

        return (_PropTypes$arrayOf = _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.shape({
          onClick: _propTypes2.default.func,
          iconClassName: _propTypes2.default.string,
          children: _propTypes2.default.node
        })]))).isRequired.apply(_PropTypes$arrayOf, [props, propName, component].concat(others));
      }

      var middle = size < 3 ? 'at least 3' : 'no more than 5';
      return new Error('A speed dial requires ' + middle + ' floating action buttons to fling. ' + ('However, only ' + size + ' were given.'));
    },

    /**
     * An optional function to call when the main floating action button is clicked.
     */
    onClick: _propTypes2.default.func,

    /**
     * An optional function to call when the main floating action button is clicked.
     */
    onPassiveClick: _propTypes2.default.func,

    /**
     * An optional function to call when the main floating action button is clicked.
     */
    onActiveClick: _propTypes2.default.func,

    /**
     * Any additional props to apply to the speed dial itself.
     */
    containerProps: _propTypes2.default.object
  };
  SpeedDial.defaultProps = {
    initiallyOpen: false,
    transitionName: 'md-fab-rotate',
    transitionEnterTimeout: 150,
    speedDialTransitionName: 'md-speed-dial',
    speedDialTransitionEnterTimeout: 450,
    speedDialTransitionLeaveTimeout: 150,
    passiveIconClassName: 'material-icons',
    activeIconClassName: 'material-icons'
  };
  exports.default = SpeedDial;
});

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1124)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./SpeedDial'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.SpeedDial);
    global.index = mod.exports;
  }
})(this, function (exports, _SpeedDial2) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.SpeedDial = undefined;

  var _SpeedDial3 = _interopRequireDefault(_SpeedDial2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.SpeedDial = _SpeedDial3.default;
});

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(9), __webpack_require__(560)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('react-dom'), require('./FileInput'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.reactDom, global.FileInput);
    global.FileUpload = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _reactDom, _FileInput) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _FileInput2 = _interopRequireDefault(_FileInput);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var FileUpload = function (_PureComponent) {
    _inherits(FileUpload, _PureComponent);

    function FileUpload(props) {
      _classCallCheck(this, FileUpload);

      var _this = _possibleConstructorReturn(this, (FileUpload.__proto__ || Object.getPrototypeOf(FileUpload)).call(this, props));

      _this.state = {};
      _this.abort = _this.abort.bind(_this);
      _this._uploadFile = _this._uploadFile.bind(_this);
      _this._handleUpload = _this._handleUpload.bind(_this);
      return _this;
    }

    /**
     * Attempts to abort the upload of a file. This function takes an optional `file` or `fileName`
     * as it's parameter. If the parameter is omitted, it attempts to abort the first file that was
     * added. If the `onAbort` function was given, it will be called as well.
     *
     * @param {Object|string=} file - The file or the file name to use to find the
     *     correct `FileReader`.
     */


    _createClass(FileUpload, [{
      key: 'abort',
      value: function abort(file) {
        var fileName = file;
        if (!file) {
          // Attempt to remove first file added...
          fileName = Object.keys(this.state)[0];
        } else if (typeof file.name === 'string') {
          fileName = file.name;
        }

        var reader = this.state[fileName];
        if (reader) {
          reader.abort();
          var state = this.state;
          delete state[fileName];

          (0, _reactDom.findDOMNode)(this).querySelector('.md-file-input').value = '';

          this.setState(state);
        }
      }
    }, {
      key: '_uploadFile',
      value: function _uploadFile(file) {
        var _this2 = this;

        var _props = this.props,
            onAbort = _props.onAbort,
            onError = _props.onError,
            onLoad = _props.onLoad,
            onLoadStart = _props.onLoadStart,
            onLoadEnd = _props.onLoadEnd,
            onProgress = _props.onProgress,
            readAs = _props.readAs;
        var name = file.name,
            type = file.type;


        var fr = new FileReader();
        if (onError) {
          fr.onerror = function (e) {
            onError(file, e.target.error, e);
          };
        }

        if (onAbort) {
          fr.onabort = function (e) {
            onAbort(file, e);
          };
        }

        if (onLoadStart) {
          fr.onloadstart = function (e) {
            onLoadStart(file, e);
          };
        }

        if (onLoadEnd) {
          fr.onloadend = function (e) {
            onLoadEnd(file, e);
          };
        }

        fr.onload = function (e) {
          if (onLoad) {
            onLoad(file, e.target.result, e);
          }

          var state = Object.assign({}, _this2.state);
          delete state[name];
          _this2.setState(state);
        };

        if (onProgress) {
          fr.onprogress = function (e) {
            if (e.lengthComputable) {
              onProgress(file, e.loaded / e.total * 100, e);
            }
          };
        }

        if (readAs) {
          if (typeof readAs === 'function') {
            readAs(file.type, file, fr);
          } else {
            fr['readAs' + readAs](file);
          }
        } else if (type.match(/image|video|audio/)) {
          fr.readAsDataURL(file);
        } else if (type.match(/json$/)) {
          fr.readAsText(file);
        } else if (type.match(/application|model|multipart/) || name.match(/(w|e)ar$/)) {
          fr.readAsArrayBuffer(file);
        } else {
          fr.readAsText(file);
        }

        return fr;
      }
    }, {
      key: '_handleUpload',
      value: function _handleUpload(fileList, e) {
        var _this3 = this;

        if (this.props.onChange) {
          this.props.onChange(fileList, e);
        }

        if (!fileList) {
          return;
        }
        var _props2 = this.props,
            maxSize = _props2.maxSize,
            onSizeError = _props2.onSizeError;

        var files = Array.isArray(fileList) ? fileList : [fileList];

        var errorFiles = [];
        if (maxSize) {
          errorFiles = files.filter(function (file) {
            return file.size > maxSize;
          });
          files = files.filter(function (file) {
            return file.size <= maxSize;
          });
        }

        if (errorFiles.length) {
          onSizeError(errorFiles);
        }

        if (!files.length) {
          return;
        }

        var nextState = {};
        files.forEach(function (file) {
          var fileReader = _this3._uploadFile(file);
          nextState[file.name] = fileReader;
        });

        this.setState(nextState);
      }
    }, {
      key: 'render',
      value: function render() {
        var props = _objectWithoutProperties(this.props, []);

        // Remove invalid input props
        delete props.maxSize;
        delete props.onLoad;
        delete props.onLoadStart;
        delete props.onLoadEnd;
        delete props.onProgress;
        delete props.onAbort;
        delete props.onError;
        delete props.maxSize;
        delete props.onSizeError;
        delete props.readAs;

        return _react2.default.createElement(_FileInput2.default, _extends({}, props, { onChange: this._handleUpload }));
      }
    }]);

    return FileUpload;
  }(_react.PureComponent);

  FileUpload.propTypes = {
    /**
     * An optional style to apply.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply.
     */
    className: _propTypes2.default.string,

    /**
     * Boolean if the `FileInput` should be styled with the primary color.
     */
    primary: _propTypes2.default.bool,

    /**
     * Boolean if the `FileInput` should be styled with the secondary color.
     */
    secondary: _propTypes2.default.bool,

    /**
     * Boolean if the `FileInput` should be styled as a flat button instead of a
     * raised button.
     */
    flat: _propTypes2.default.bool,

    /**
     * This should be a comma separated list of Media Types that the `FileInput` can
     * accept. If this prop is left blank, any file will be accepted.
     *
     * The values can either be:
     * - A file extension
     * - audio/*
     * - video/*
     * - image/*
     * - any valid [IANA Media Type](http://www.iana.org/assignments/media-types/media-types.xhtml)
     */
    accept: _propTypes2.default.string,

    /**
     * Boolean if multiple files will be accepted.
     */
    multiple: _propTypes2.default.bool,

    /**
     * A label to display on the `FileInput`.
     */
    label: _propTypes2.default.node,

    /**
     * The icon children to use for the upload icon.
     */
    iconChildren: _propTypes2.default.node,

    /**
     * The icon className to use for the upload icon.
     */
    iconClassName: _propTypes2.default.string,

    /**
     * An optional max size for the file. If the file is greater than
     * this limit, the file will not be uploaded.
     */
    maxSize: _propTypes2.default.number,

    /**
     * A required function to call when the `maxSize` prop is set. It will
     * be given a list of files that were too big.
     */
    onSizeError: function onSizeError(props, propName, component) {
      for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        others[_key - 3] = arguments[_key];
      }

      if (typeof props.maxSize === 'number') {
        var _PropTypes$func;

        return (_PropTypes$func = _propTypes2.default.func).isRequired.apply(_PropTypes$func, [props, propName, component].concat(others));
      }

      return null;
    },

    /**
     * You can force the `FileReader` to read the file as a specific type
     * if you do not trust the *amazing* regex I have for choosing the correct
     * one.
     *
     * ```js
     * if(type.match(/image|video|audio/)) {
     *   fr.readAsDataURL(file);
     * } else if(type.match(/application|model|multipart/)) {
     *   fr.readAsArrayBuffer(file);
     * } else {
     *   fr.readAsText(file);
     * }
     * ```
     *
     * > `.yml` and `.js` both are considered `application`, so it definitely fails there.
     *
     * If this prop is a function, you will be given the file's type, the file object, and
     * the file reader. You will then need to call `fileReader.readAsYOUR_CORRECT_TYPE(file)`.
     */
    readAs: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['DataURL', 'ArrayBuffer', 'Text']), _propTypes2.default.func]),

    /**
     * An optional function to call when the `FileUpload` aborts. The current
     * file and the abort event are given. This might not be the most useful
     * function to use since you will need to manually call abort yourself anyways.
     */
    onAbort: _propTypes2.default.func,

    /**
     * An optional function to call when the `FileUpload` errors. The current
     * file, the error, and the error event are given.
     *
     * ```js
     * onError(file, event.target.error, event);
     * ```
     */
    onError: _propTypes2.default.func,

    /**
     * An optional function to call when the `FileUpload` loads. The current
     * file, the load result, and the load event are given.
     *
     * ```js
     * onLoad(file, event.target.result, event);
     * ```
     *
     * The load result will either be:
     * - a data url
     * - a plain text string
     * - an array buffer
     *
     * depending on what type the file is.
     */
    onLoad: _propTypes2.default.func,

    /**
     * An optional function to call when the `FileUpload` starts loading. The current
     * file and the load start event are given.
     */
    onLoadStart: _propTypes2.default.func,

    /**
     * An optional function to call when the `FileUpload` finishes loading. The
     * current file and the load end event are given.
     */
    onLoadEnd: _propTypes2.default.func,

    /**
     * An optional function to call when the `FileUpload` progress. The current
     * file, upload progress, and the progress event are given. The progress
     * will be a number between 0 and 100 that has not been rounded.
     *
     * ```js
     * onProgress(file, progress, event);
     * ```
     */
    onProgress: _propTypes2.default.func,

    /**
     * An optional function to call when a file selects or unselects a file.
     * This will be called before any local uploading occurs.
     *
     * ```js
     * onChange(file(s) || null, event);
     * ```
     */
    onChange: _propTypes2.default.func
  };
  exports.default = FileUpload;
});

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(560), __webpack_require__(1126)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./FileInput'), require('./FileUpload'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.FileInput, global.FileUpload);
    global.index = mod.exports;
  }
})(this, function (exports, _FileInput, _FileUpload2) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.FileUpload = exports.FileInput = undefined;

  var _FileInput2 = _interopRequireDefault(_FileInput);

  var _FileUpload3 = _interopRequireDefault(_FileUpload2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _FileInput2.default;
  exports.FileInput = _FileInput2.default;
  exports.FileUpload = _FileUpload3.default;
});

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(155), __webpack_require__(37), __webpack_require__(62), __webpack_require__(561), __webpack_require__(81), __webpack_require__(82)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./AccessibleFakeButton'), require('./AccessibleFakeInkedButton'), require('./Collapse'), require('./FocusContainer'), require('./IconSeparator'), require('./Portal'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.AccessibleFakeButton, global.AccessibleFakeInkedButton, global.Collapse, global.FocusContainer, global.IconSeparator, global.Portal);
    global.index = mod.exports;
  }
})(this, function (exports, _AccessibleFakeButton2, _AccessibleFakeInkedButton2, _Collapse2, _FocusContainer2, _IconSeparator2, _Portal2) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Portal = exports.IconSeparator = exports.FocusContainer = exports.Collapse = exports.AccessibleFakeInkedButton = exports.AccessibleFakeButton = undefined;

  var _AccessibleFakeButton3 = _interopRequireDefault(_AccessibleFakeButton2);

  var _AccessibleFakeInkedButton3 = _interopRequireDefault(_AccessibleFakeInkedButton2);

  var _Collapse3 = _interopRequireDefault(_Collapse2);

  var _FocusContainer3 = _interopRequireDefault(_FocusContainer2);

  var _IconSeparator3 = _interopRequireDefault(_IconSeparator2);

  var _Portal3 = _interopRequireDefault(_Portal2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.AccessibleFakeButton = _AccessibleFakeButton3.default;
  exports.AccessibleFakeInkedButton = _AccessibleFakeInkedButton3.default;
  exports.Collapse = _Collapse3.default;
  exports.FocusContainer = _FocusContainer3.default;
  exports.IconSeparator = _IconSeparator3.default;
  exports.Portal = _Portal3.default;
});

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(38)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('../constants/CSSTransitionGroupTick'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.CSSTransitionGroupTick);
    global.Ink = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _CSSTransitionGroupTick) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Ink = function (_PureComponent) {
    _inherits(Ink, _PureComponent);

    function Ink(props) {
      _classCallCheck(this, Ink);

      var _this = _possibleConstructorReturn(this, (Ink.__proto__ || Object.getPrototypeOf(Ink)).call(this, props));

      _this.state = {
        active: false,
        expanded: false,
        pulsing: false,
        leaving: false
      };
      return _this;
    }

    _createClass(Ink, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (!this.props.aborted && nextProps.aborted) {
          if (this._timeout) {
            clearTimeout(this._timeout);
          }

          if (this._abort) {
            this._abort();
          }

          this.setState({ active: false, expanding: false, pulsing: false, leaving: false });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this._timeout) {
          clearTimeout(this._timeout);
        }
      }
    }, {
      key: 'componentWillEnter',
      value: function componentWillEnter(cb) {
        var _this2 = this;

        if (this.props.aborted) {
          cb();
          return;
        }

        var _props = this.props,
            transitionOverlap = _props.transitionOverlap,
            transitionEnterTimeout = _props.transitionEnterTimeout;

        this._abort = cb;

        this._timeout = setTimeout(function () {
          _this2._timeout = setTimeout(function () {
            _this2._timeout = null;
            _this2._abort = null;

            cb();
          }, transitionEnterTimeout - transitionOverlap);

          _this2.setState({ expanded: true });
        }, _CSSTransitionGroupTick2.default);

        this.setState({ active: true });
      }
    }, {
      key: 'componentDidEnter',
      value: function componentDidEnter() {
        var _this3 = this;

        this._timeout = setTimeout(function () {
          _this3._timeout = null;

          _this3.setState({ pulsing: true });
        }, this.props.transitionEnterTimeout);
      }
    }, {
      key: 'componentWillLeave',
      value: function componentWillLeave(cb) {
        var _this4 = this;

        if (this.props.aborted) {
          cb();
          return;
        }

        if (this._timeout) {
          clearTimeout(this._timeout);
        }

        this._abort = cb;
        this._timeout = setTimeout(function () {
          _this4._timeout = null;

          cb();
        }, this.props.transitionLeaveTimeout);

        this.setState({ pulsing: false, leaving: true });
      }
    }, {
      key: 'componentDidLeave',
      value: function componentDidLeave() {
        if (!this.props.aborted && this.props.onRemove) {
          this.props.onRemove();
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _props2 = this.props,
            style = _props2.style,
            className = _props2.className,
            left = _props2.left,
            top = _props2.top,
            size = _props2.size;
        var _state = this.state,
            active = _state.active,
            expanded = _state.expanded,
            pulsing = _state.pulsing,
            leaving = _state.leaving;


        return _react2.default.createElement('span', {
          style: Object.assign({}, style, {
            left: left,
            top: top,
            height: size,
            width: size
          }),
          className: (0, _classnames2.default)('md-ink', {
            'md-ink--active': active,
            'md-ink--expanded': expanded,
            'md-ink--pulsing': pulsing,
            'md-ink--leaving': leaving
          }, className)
        });
      }
    }]);

    return Ink;
  }(_react.PureComponent);

  Ink.propTypes = {
    style: _propTypes2.default.object,
    className: _propTypes2.default.string,
    aborted: _propTypes2.default.bool,
    onRemove: _propTypes2.default.func,
    left: _propTypes2.default.number.isRequired,
    top: _propTypes2.default.number.isRequired,
    size: _propTypes2.default.number.isRequired,
    transitionOverlap: _propTypes2.default.number.isRequired,
    transitionEnterTimeout: _propTypes2.default.number.isRequired,
    transitionLeaveTimeout: _propTypes2.default.number.isRequired
  };
  exports.default = Ink;
});

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(9), __webpack_require__(277), __webpack_require__(3), __webpack_require__(14), __webpack_require__(592), __webpack_require__(594), __webpack_require__(267), __webpack_require__(117), __webpack_require__(1192), __webpack_require__(1129)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('react-dom'), require('react-transition-group/TransitionGroup'), require('classnames'), require('../constants/keyCodes'), require('../utils/calcPageOffset'), require('../utils/isFormPartRole'), require('../utils/EventUtils/isValidClick'), require('../utils/EventUtils/captureNextEvent'), require('../utils/NumberUtils/calculateHypotenuse'), require('./Ink'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.reactDom, global.TransitionGroup, global.classnames, global.keyCodes, global.calcPageOffset, global.isFormPartRole, global.isValidClick, global.captureNextEvent, global.calculateHypotenuse, global.Ink);
    global.InkContainer = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _reactDom, _TransitionGroup, _classnames, _keyCodes, _calcPageOffset, _isFormPartRole, _isValidClick, _captureNextEvent, _calculateHypotenuse, _Ink) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _calcPageOffset2 = _interopRequireDefault(_calcPageOffset);

  var _isFormPartRole2 = _interopRequireDefault(_isFormPartRole);

  var _isValidClick2 = _interopRequireDefault(_isValidClick);

  var _captureNextEvent2 = _interopRequireDefault(_captureNextEvent);

  var _calculateHypotenuse2 = _interopRequireDefault(_calculateHypotenuse);

  var _Ink2 = _interopRequireDefault(_Ink);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var InkContainer = function (_PureComponent) {
    _inherits(InkContainer, _PureComponent);

    function InkContainer(props) {
      _classCallCheck(this, InkContainer);

      var _this = _possibleConstructorReturn(this, (InkContainer.__proto__ || Object.getPrototypeOf(InkContainer)).call(this, props));

      _this.state = { inks: [] };
      _this.createInk = _this.createInk.bind(_this);
      _this.focus = _this.focus.bind(_this);
      _this._handleFocus = _this._handleFocus.bind(_this);
      _this._createInk = _this._createInk.bind(_this);
      _this._removeInk = _this._removeInk.bind(_this);
      _this._setContainers = _this._setContainers.bind(_this);
      _this._maybeDelayClick = _this._maybeDelayClick.bind(_this);
      _this._handleBlur = _this._handleBlur.bind(_this);
      _this._handleMouseDown = _this._handleMouseDown.bind(_this);
      _this._handleMouseUp = _this._handleMouseUp.bind(_this);
      _this._handleMouseLeave = _this._handleMouseLeave.bind(_this);
      _this._handleTouchStart = _this._handleTouchStart.bind(_this);
      _this._handleTouchMove = _this._handleTouchMove.bind(_this);
      _this._handleTouchEnd = _this._handleTouchEnd.bind(_this);
      _this._handleRemove = _this._handleRemove.bind(_this);
      _this._handleSubmit = _this._handleSubmit.bind(_this);
      _this._handleKeyDown = _this._handleKeyDown.bind(_this);
      _this._getKeyboardContainer = _this._getKeyboardContainer.bind(_this);
      _this._stopPropagationToFocus = _this._stopPropagationToFocus.bind(_this);
      _this._initOrRemoveEvents = _this._initOrRemoveEvents.bind(_this);
      return _this;
    }

    _createClass(InkContainer, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var di = this.props.disabledInteractions;
        var ndi = nextProps.disabledInteractions;

        if (di === ndi || !this._container) {
          return;
        }

        var mouseDisabledDiff = this._isListenerDisabledDiff('mouse', di, ndi);
        var touchDisabledDiff = this._isListenerDisabledDiff('touch', di, ndi);
        var keyboardDisabledDiff = this._isListenerDisabledDiff('keyboard', di, ndi);
        this._initOrRemoveEvents(nextProps, keyboardDisabledDiff, mouseDisabledDiff, touchDisabledDiff);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this._removeTimeout) {
          clearTimeout(this._removeTimeout);
        }

        if (this._container) {
          this._initOrRemoveEvents({ disabledInteractions: ['keyboard', 'mouse', 'touch'] });
          this._getKeyboardContainer().removeEventListener('blur', this._handleBlur);
        }
      }
    }, {
      key: 'createInk',
      value: function createInk(pageX, pageY) {
        var _this2 = this;

        this._createInk(pageX, pageY);
        this._removeTimeout = setTimeout(function () {
          _this2._removeTimeout = null;
          _this2._removeInk();
        }, this.props.transitionOverlap);
      }
    }, {
      key: 'focus',
      value: function focus() {
        this._getKeyboardContainer().focus();
      }
    }, {
      key: '_createInk',
      value: function _createInk(pageX, pageY) {
        var _inkContainer = this._inkContainer,
            offsetWidth = _inkContainer.offsetWidth,
            offsetHeight = _inkContainer.offsetHeight;


        var x = void 0;
        var y = void 0;
        if (typeof pageX !== 'undefined' && typeof pageY !== 'undefined') {
          var pageOffset = (0, _calcPageOffset2.default)(this._inkContainer);

          x = pageX - pageOffset.left;
          y = pageY - pageOffset.top;
        } else {
          x = offsetWidth / 2;
          y = offsetHeight / 2;
        }

        var r = Math.max((0, _calculateHypotenuse2.default)(x, y), (0, _calculateHypotenuse2.default)(offsetWidth - x, y), (0, _calculateHypotenuse2.default)(offsetWidth - x, offsetHeight - y), (0, _calculateHypotenuse2.default)(x, offsetHeight - y));

        var ink = {
          left: x - r,
          top: y - r,
          size: r * 2,
          key: Date.now()
        };

        var inks = this.state.inks.slice();
        inks.push(ink);
        this.setState({ inks: inks });
      }
    }, {
      key: '_removeInk',
      value: function _removeInk() {
        var inks = this.state.inks.slice();
        inks.pop();

        this.setState({ inks: inks });
      }
    }, {
      key: '_getKeyboardContainer',
      value: function _getKeyboardContainer() {
        if (this._container.classList.contains('md-text-field-container')) {
          return this._container.querySelector('.md-text-field');
        }

        return this._container;
      }
    }, {
      key: '_setContainers',
      value: function _setContainers(inkContainer) {
        if (inkContainer !== null) {
          this._inkContainer = (0, _reactDom.findDOMNode)(inkContainer);
          this._container = this._inkContainer.parentNode;

          if (this._container) {
            this._initOrRemoveEvents(this.props);
          }
        }
      }
    }, {
      key: '_initOrRemoveEvents',
      value: function _initOrRemoveEvents(props) {
        var keyboardDiff = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        var mouseDiff = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        var touchDiff = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

        var mouseDisabled = this._isListenerDisabled('mouse', props.disabledInteractions);
        var touchDisabled = this._isListenerDisabled('touch', props.disabledInteractions);
        var keyboardDisabled = this._isListenerDisabled('keyboard', props.disabledInteractions);

        if (keyboardDiff) {
          var fn = (keyboardDisabled ? 'remove' : 'add') + 'EventListener';
          this._getKeyboardContainer()[fn]('focus', this._handleFocus);
          this._getKeyboardContainer()[fn]('keydown', this._handleKeyDown);

          if (this._container.getAttribute('type') === 'submit') {
            window[fn]('submit', this._handleSubmit);
          }

          if (mouseDiff) {
            this._container[(mouseDisabled ? 'add' : 'remove') + 'EventListener']('mousedown', this._stopPropagationToFocus);
          }

          if (touchDiff) {
            this._container[(touchDisabled ? 'add' : 'remove') + 'EventListener']('touchstart', this._stopPropagationToFocus);
          }
        }

        if (mouseDiff) {
          var _fn = (mouseDisabled ? 'remove' : 'add') + 'EventListener';
          this._container[_fn]('mousedown', this._handleMouseDown);
          this._container[_fn]('mouseup', this._handleMouseUp);
        }

        if (touchDiff) {
          var _fn2 = (touchDisabled ? 'remove' : 'add') + 'EventListener';
          this._container[_fn2]('touchstart', this._handleTouchStart);
          this._container[_fn2]('touchend', this._handleTouchEnd);
        }
      }
    }, {
      key: '_isListenerDisabledDiff',
      value: function _isListenerDisabledDiff(interaction, disabledInteractions, nextDisabledInteractions) {
        var i = disabledInteractions.indexOf(interaction);
        var ni = nextDisabledInteractions.indexOf(interaction);

        return i < 0 && ni >= 0 || i >= 0 && ni < 0;
      }
    }, {
      key: '_isListenerDisabled',
      value: function _isListenerDisabled(interaction, disabledInteractions) {
        return disabledInteractions && disabledInteractions.indexOf(interaction) !== -1;
      }
    }, {
      key: '_maybeDelayClick',
      value: function _maybeDelayClick() {
        if (!this.props.waitForInkTransition) {
          return;
        }

        (0, _captureNextEvent2.default)('click', this._container);
      }
    }, {
      key: '_handleRemove',
      value: function _handleRemove() {
        var _this3 = this;

        if (this._clicked && this.props.waitForInkTransition) {
          // For some reason if the click event will make the ink unmount, it will no longer
          // have a debug id in the TransitionGroup and it displays a warning. Adding a 1ms timeout
          // fixes that issue... It only happens on an actual click instead of an enter click.
          setTimeout(function () {
            _this3._container.click();
          }, 1);
        }

        this._clicked = false;
      }
    }, {
      key: '_handleKeyDown',
      value: function _handleKeyDown(e) {
        var key = e.which || e.keyCode;
        var enter = key === _keyCodes.ENTER;
        var space = key === _keyCodes.SPACE;
        // Don't trigger ink when enter key is pressed and the target has an input inside of it (SelectField)
        if (space || enter && !(0, _isFormPartRole2.default)(e.target) && !e.target.querySelector('input')) {
          this._clicked = true;
          this.createInk();
          this._maybeDelayClick();
        }
      }
    }, {
      key: '_handleFocus',
      value: function _handleFocus() {
        if (this._clicked) {
          return;
        }

        this._createInk();
        this._getKeyboardContainer().addEventListener('blur', this._handleBlur);
      }
    }, {
      key: '_handleBlur',
      value: function _handleBlur() {
        this._getKeyboardContainer().removeEventListener('blur', this._handleBlur);
        this._removeInk();
      }
    }, {
      key: '_handleMouseDown',
      value: function _handleMouseDown(e) {
        this._clicked = true;
        if (!(0, _isValidClick2.default)(e) || this._skipNextMouse) {
          this._skipNextMouse = false;
          return;
        }

        this._mouseLeave = false;
        this._container.addEventListener('mouseleave', this._handleMouseLeave);
        this._createInk(e.pageX, e.pageY);
      }
    }, {
      key: '_handleMouseLeave',
      value: function _handleMouseLeave() {
        this._container.removeEventListener('mouseleave', this._handleMouseLeave);
        this._mouseLeave = true;
        this._removeInk();
      }
    }, {
      key: '_handleMouseUp',
      value: function _handleMouseUp() {
        if (this._mouseLeave) {
          return;
        }

        this._maybeDelayClick();
        this._container.removeEventListener('mouseleave', this._handleMouseLeave);
        this._removeInk();
      }
    }, {
      key: '_handleTouchStart',
      value: function _handleTouchStart(e) {
        this._aborted = false;
        this._clicked = true;
        this._skipNextMouse = true;
        window.addEventListener('touchmove', this._handleTouchMove);

        var _e$changedTouches$ = e.changedTouches[0],
            pageX = _e$changedTouches$.pageX,
            pageY = _e$changedTouches$.pageY;

        this._createInk(pageX, pageY);
      }
    }, {
      key: '_handleTouchMove',
      value: function _handleTouchMove() {
        window.removeEventListener('touchmove', this._handleTouchMove);
        var lastInk = this.state.inks[this.state.inks.length - 1];
        if (!lastInk || Date.now() > lastInk.key + 200) {
          this._aborted = false;
          return;
        }

        var inks = this.state.inks.slice();
        var index = inks.length - 1;

        var abortedInk = Object.assign({}, lastInk, { aborted: true });
        inks.splice(index, 1, abortedInk);

        this._aborted = true;
        this.setState({ inks: inks }, this._removeInk);
      }
    }, {
      key: '_handleTouchEnd',
      value: function _handleTouchEnd() {
        this._skipNextMouse = true;

        if (this._aborted) {
          return;
        } else {
          window.removeEventListener('touchmove', this._handleTouchMove);
        }

        this._removeInk();
      }
    }, {
      key: '_handleSubmit',
      value: function _handleSubmit(e) {
        if (document.activeElement === this._container || !e.target.contains(this._container)) {
          return;
        }

        this._maybeDelayClick();
        this.createInk();
      }
    }, {
      key: '_stopPropagationToFocus',
      value: function _stopPropagationToFocus(e) {
        var type = e.type;

        var mousedown = type === 'mousedown';
        this._clicked = mousedown || type === 'touchstart';

        if (this._clicked) {
          window.addEventListener(mousedown ? 'mouseup' : 'touchend', this._stopPropagationToFocus, true);
        } else {
          window.removeEventListener(e.type, this._stopPropagationToFocus, true);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this4 = this;

        var _props = this.props,
            style = _props.style,
            className = _props.className,
            inkStyle = _props.inkStyle,
            inkClassName = _props.inkClassName,
            transitionOverlap = _props.transitionOverlap,
            transitionEnterTimeout = _props.transitionEnterTimeout,
            transitionLeaveTimeout = _props.transitionLeaveTimeout;

        var inks = this.state.inks.map(function (props) {
          return _react2.default.createElement(_Ink2.default, _extends({}, props, {
            style: inkStyle,
            className: inkClassName,
            onRemove: _this4._handleRemove,
            transitionOverlap: transitionOverlap,
            transitionEnterTimeout: transitionEnterTimeout,
            transitionLeaveTimeout: transitionLeaveTimeout
          }));
        });

        return _react2.default.createElement(
          _TransitionGroup2.default,
          {
            ref: this._setContainers,
            component: 'div',
            style: style,
            className: (0, _classnames2.default)('md-ink-container', className)
          },
          inks
        );
      }
    }]);

    return InkContainer;
  }(_react.PureComponent);

  InkContainer.propTypes = {
    style: _propTypes2.default.object,
    className: _propTypes2.default.string,
    inkStyle: _propTypes2.default.object,
    inkClassName: _propTypes2.default.string,
    waitForInkTransition: _propTypes2.default.bool,
    disabledInteractions: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['keyboard', 'mouse', 'touch'])),
    transitionOverlap: _propTypes2.default.number.isRequired,
    transitionEnterTimeout: _propTypes2.default.number.isRequired,
    transitionLeaveTimeout: _propTypes2.default.number.isRequired
  };
  InkContainer.defaultProps = {
    transitionOverlap: 150,
    transitionEnterTimeout: 450,
    transitionLeaveTimeout: 300
  };
  exports.default = InkContainer;
});

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(253)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./injectInk'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.injectInk);
    global.index = mod.exports;
  }
})(this, function (exports, _injectInk) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _injectInk2 = _interopRequireDefault(_injectInk);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _injectInk2.default;
});

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(564), __webpack_require__(565)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./Media'), require('./MediaOverlay'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.Media, global.MediaOverlay);
    global.index = mod.exports;
  }
})(this, function (exports, _Media, _MediaOverlay2) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.MediaOverlay = exports.Media = undefined;

  var _Media2 = _interopRequireDefault(_Media);

  var _MediaOverlay3 = _interopRequireDefault(_MediaOverlay2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _Media2.default;
  exports.Media = _Media2.default;
  exports.MediaOverlay = _MediaOverlay3.default;
});

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(116), __webpack_require__(566)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./Menu'), require('./MenuButton'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.Menu, global.MenuButton);
    global.index = mod.exports;
  }
})(this, function (exports, _Menu, _MenuButton2) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.MenuButton = exports.Menu = undefined;

  var _Menu2 = _interopRequireDefault(_Menu);

  var _MenuButton3 = _interopRequireDefault(_MenuButton2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _Menu2.default;
  exports.Menu = _Menu2.default;
  exports.MenuButton = _MenuButton3.default;
});

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(37), __webpack_require__(255)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('../Helpers/AccessibleFakeInkedButton'), require('../Lists/TileAddon'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.AccessibleFakeInkedButton, global.TileAddon);
    global.MiniListItem = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _AccessibleFakeInkedButton, _TileAddon) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);

  var _TileAddon2 = _interopRequireDefault(_TileAddon);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var MiniListItem = function (_PureComponent) {
    _inherits(MiniListItem, _PureComponent);

    function MiniListItem(props) {
      _classCallCheck(this, MiniListItem);

      var _this = _possibleConstructorReturn(this, (MiniListItem.__proto__ || Object.getPrototypeOf(MiniListItem)).call(this, props));

      _this.state = { active: false };
      _this._handleTouchStart = _this._handleTouchStart.bind(_this);
      _this._handleTouchEnd = _this._handleTouchEnd.bind(_this);
      _this._handleMouseOver = _this._handleMouseOver.bind(_this);
      _this._handleMouseLeave = _this._handleMouseLeave.bind(_this);
      return _this;
    }

    _createClass(MiniListItem, [{
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this._touchTimeout) {
          clearTimeout(this._touchTimeout);
        }
      }
    }, {
      key: '_handleMouseOver',
      value: function _handleMouseOver(e) {
        if (this.props.onMouseOver) {
          this.props.onMouseOver(e);
        }

        if (!this.props.disabled) {
          this.setState({ active: true });
        }
      }
    }, {
      key: '_handleMouseLeave',
      value: function _handleMouseLeave(e) {
        if (this.props.onMouseLeave) {
          this.props.onMouseLeave(e);
        }

        if (!this.props.disabled) {
          this.setState({ active: false });
        }
      }
    }, {
      key: '_handleTouchStart',
      value: function _handleTouchStart(e) {
        if (this.props.onTouchStart) {
          this.props.onTouchStart(e);
        }

        this._touched = true;

        this.setState({ active: true, touchedAt: Date.now() });
      }
    }, {
      key: '_handleTouchEnd',
      value: function _handleTouchEnd(e) {
        var _this2 = this;

        if (this.props.onTouchEnd) {
          this.props.onTouchEnd(e);
        }

        var time = Date.now() - this.state.touchedAt;
        this._touchTimeout = setTimeout(function () {
          _this2._touchTimeout = null;

          _this2.setState({ active: false });
        }, time > 450 ? 0 : 450 - time);
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            style = _props.style,
            className = _props.className,
            tileStyle = _props.tileStyle,
            tileClassName = _props.tileClassName,
            leftIcon = _props.leftIcon,
            leftAvatar = _props.leftAvatar,
            active = _props.active,
            activeClassName = _props.activeClassName,
            props = _objectWithoutProperties(_props, ['style', 'className', 'tileStyle', 'tileClassName', 'leftIcon', 'leftAvatar', 'active', 'activeClassName']);

        delete props.defaultOpen;
        return _react2.default.createElement(
          'li',
          { style: style, className: className },
          _react2.default.createElement(
            _AccessibleFakeInkedButton2.default,
            _extends({}, props, {
              style: tileStyle,
              className: (0, _classnames2.default)('md-list-tile md-list-tile--icon md-list-tile--mini', {
                'md-list-tile--active': this.state.active && !this._touched
              }, tileClassName),
              onMouseOver: this._handleMouseOver,
              onMouseLeave: this._handleMouseLeave,
              onTouchStart: this._handleTouchStart,
              onTouchEnd: this._handleTouchEnd
            }),
            _react2.default.createElement(_TileAddon2.default, {
              active: active,
              activeClassName: activeClassName,
              icon: leftIcon,
              avatar: leftAvatar
            })
          )
        );
      }
    }]);

    return MiniListItem;
  }(_react.PureComponent);

  MiniListItem.propTypes = {
    style: _propTypes2.default.object,
    className: _propTypes2.default.string,
    tileStyle: _propTypes2.default.object,
    tileClassName: _propTypes2.default.string,
    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
    active: _propTypes2.default.bool,
    activeClassName: _propTypes2.default.string,
    leftIcon: _propTypes2.default.node,
    leftAvatar: _propTypes2.default.node,
    disabled: _propTypes2.default.bool,
    onTouchStart: _propTypes2.default.func,
    onTouchEnd: _propTypes2.default.func,
    onMouseOver: _propTypes2.default.func,
    onMouseLeave: _propTypes2.default.func
  };
  MiniListItem.defaultProps = {
    activeClassName: 'md-text--theme-primary',
    component: 'div'
  };
  exports.default = MiniListItem;
});

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(66), __webpack_require__(12), __webpack_require__(17), __webpack_require__(16), __webpack_require__(20), __webpack_require__(65), __webpack_require__(11), __webpack_require__(251), __webpack_require__(45), __webpack_require__(579), __webpack_require__(559), __webpack_require__(569), __webpack_require__(568), __webpack_require__(1134)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('react-transition-group/CSSTransitionGroup'), require('react-prop-types/lib/deprecated'), require('react-prop-types/lib/isRequiredForA11y'), require('../utils/getField'), require('../utils/PropTypes/controlled'), require('../utils/PropTypes/invalidIf'), require('../Buttons/Button'), require('../Drawers/Drawer'), require('../Lists/List'), require('../Toolbars/Toolbar'), require('../Drawers/isType'), require('./JumpToContentLink'), require('./CloseButton'), require('./MiniListItem'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.CSSTransitionGroup, global.deprecated, global.isRequiredForA11y, global.getField, global.controlled, global.invalidIf, global.Button, global.Drawer, global.List, global.Toolbar, global.isType, global.JumpToContentLink, global.CloseButton, global.MiniListItem);
    global.NavigationDrawer = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _CSSTransitionGroup, _deprecated, _isRequiredForA11y, _getField, _controlled, _invalidIf, _Button, _Drawer, _List, _Toolbar, _isType, _JumpToContentLink, _CloseButton, _MiniListItem) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);

  var _deprecated2 = _interopRequireDefault(_deprecated);

  var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);

  var _getField2 = _interopRequireDefault(_getField);

  var _controlled2 = _interopRequireDefault(_controlled);

  var _invalidIf2 = _interopRequireDefault(_invalidIf);

  var _Button2 = _interopRequireDefault(_Button);

  var _Drawer2 = _interopRequireDefault(_Drawer);

  var _List2 = _interopRequireDefault(_List);

  var _Toolbar2 = _interopRequireDefault(_Toolbar);

  var _JumpToContentLink2 = _interopRequireDefault(_JumpToContentLink);

  var _CloseButton2 = _interopRequireDefault(_CloseButton);

  var _MiniListItem2 = _interopRequireDefault(_MiniListItem);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var DrawerTypes = _Drawer2.default.DrawerTypes;


  function getNonMiniType(type) {
    var pMini = DrawerTypes.PERSISTENT_MINI,
        tMini = DrawerTypes.TEMPORARY_MINI;

    if ([pMini, tMini].indexOf(type) === -1) {
      return type;
    }

    return pMini === type ? DrawerTypes.PERSISTENT : DrawerTypes.TEMPORARY;
  }

  function toMiniListItem(item, index) {
    if ((0, _react.isValidElement)(item)) {
      return item;
    }

    var divider = item.divider,
        subheader = item.subheader,
        key = item.key,
        itemProps = _objectWithoutProperties(item, ['divider', 'subheader', 'key']);

    if (divider || subheader) {
      return null;
    }

    delete itemProps.primaryText;
    delete itemProps.secondaryText;
    delete itemProps.rightIcon;
    delete itemProps.rightAvatar;
    delete itemProps.threeLines;
    delete itemProps.nestedItems;
    delete itemProps.expanderIconChildren;
    delete itemProps.expanderIconClassName;
    delete itemProps.children;

    return _react2.default.createElement(_MiniListItem2.default, _extends({ key: key || index }, itemProps));
  }

  /**
   * The `NavigationDrawer` is used when you want a full layout configuration. It is a combination
   * of the `Toolbar` component and the `Drawer` component.
   *
   * The main benfit of using this component is that it will manage adding respective offset
   * classes automatically for you to the content and the drawer. It will also manage using
   * a mini drawer type for you.
   */

  var NavigationDrawer = function (_PureComponent) {
    _inherits(NavigationDrawer, _PureComponent);

    _createClass(NavigationDrawer, null, [{
      key: 'getCurrentMedia',
      value: function getCurrentMedia() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NavigationDrawer.defaultProps;

        var mobileType = props.mobileDrawerType,
            tabletType = props.tabletDrawerType,
            desktopType = props.desktopDrawerType,
            constantType = props.constantDrawerType,
            others = _objectWithoutProperties(props, ['mobileDrawerType', 'tabletDrawerType', 'desktopDrawerType', 'constantDrawerType']);

        return _Drawer2.default.getCurrentMedia(_extends({ mobileType: mobileType, tabletType: tabletType, desktopType: desktopType, constantType: constantType }, others));
      }
    }]);

    function NavigationDrawer(props) {
      _classCallCheck(this, NavigationDrawer);

      var _this = _possibleConstructorReturn(this, (NavigationDrawer.__proto__ || Object.getPrototypeOf(NavigationDrawer)).call(this, props));

      var defaultMedia = props.defaultMedia,
          defaultVisible = props.defaultVisible,
          initialDrawerType = props.initialDrawerType;


      _this.state = {
        mobile: initialDrawerType || defaultMedia === 'mobile',
        tablet: initialDrawerType || defaultMedia === 'tablet',
        desktop: initialDrawerType || defaultMedia === 'desktop'
      };

      if (typeof props.drawerType === 'undefined') {
        _this.state.drawerType = props[(initialDrawerType || defaultMedia) + 'DrawerType'];
      }

      var type = (0, _getField2.default)(props, _this.state, 'drawerType');

      if (typeof props.visible === 'undefined') {
        _this.state.visible = typeof defaultVisible !== 'undefined' ? defaultVisible : (0, _isType.isPermanent)(type);
      }

      _this._handleTypeChange = _this._handleTypeChange.bind(_this);
      _this._handleVisibility = _this._handleVisibility.bind(_this);
      _this._toggleVisibility = _this._toggleVisibility.bind(_this);
      return _this;
    }

    _createClass(NavigationDrawer, [{
      key: 'getChildContext',
      value: function getChildContext() {
        var _props = this.props,
            persistentIconChildren = _props.persistentIconChildren,
            persistentIconClassName = _props.persistentIconClassName,
            closeIconChildren = _props.closeIconChildren,
            closeIconClassName = _props.closeIconClassName,
            id = _props.contentId,
            label = _props.jumpLabel;


        return {
          id: id,
          label: label,
          closeChildren: closeIconChildren || persistentIconChildren,
          closeIconClassName: closeIconClassName || persistentIconClassName,
          onCloseClick: this._toggleVisibility,
          renderNode: this.context.renderNode
        };
      }
    }, {
      key: 'componentWillUpdate',
      value: function componentWillUpdate(nextProps, nextState) {
        var _this2 = this;

        var visible = (0, _getField2.default)(this.props, this.state, 'visible');
        var nVisible = (0, _getField2.default)(nextProps, nextState, 'visible');
        var drawerType = (0, _getField2.default)(nextProps, nextState, 'drawerType');

        if (!(0, _isType.isTemporary)(drawerType) && visible !== nVisible) {
          if (this._timeout) {
            clearTimeout(this._timeout);
          }

          this._timeout = setTimeout(function () {
            _this2.setState({ contentActive: false });
          }, nextProps.drawerTransitionDuration);

          this.setState({ contentActive: true });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this._timeout) {
          clearTimeout(this._timeout);
        }
      }
    }, {
      key: '_toggleVisibility',
      value: function _toggleVisibility(e) {
        var _props2 = this.props,
            onVisibilityToggle = _props2.onVisibilityToggle,
            onDrawerChange = _props2.onDrawerChange;

        var visible = !(0, _getField2.default)(this.props, this.state, 'visible');
        if (onVisibilityToggle || onDrawerChange) {
          (onDrawerChange || onVisibilityToggle)(visible, e);
        }

        if (typeof this.props.visible === 'undefined') {
          this.setState({ visible: visible });
        }
      }
    }, {
      key: '_handleVisibility',
      value: function _handleVisibility(visible) {
        if (this.props.onVisibilityToggle) {
          this.props.onVisibilityToggle(visible);
        }

        if (typeof this.props.visible === 'undefined') {
          this.setState({ visible: visible });
        }
      }
    }, {
      key: '_handleTypeChange',
      value: function _handleTypeChange(drawerType, mediaState) {
        var onMediaTypeChange = this.props.onMediaTypeChange;

        var state = mediaState;
        if (onMediaTypeChange) {
          onMediaTypeChange(drawerType, mediaState);
        }

        if (typeof this.props.drawerType === 'undefined') {
          state = _extends({}, mediaState, { drawerType: drawerType });
        }

        this.setState(state);
      }
    }, {
      key: 'render',
      value: function render() {
        var _props3 = this.props,
            style = _props3.style,
            className = _props3.className,
            toolbarStyle = _props3.toolbarStyle,
            toolbarClassName = _props3.toolbarClassName,
            drawerStyle = _props3.drawerStyle,
            drawerClassName = _props3.drawerClassName,
            contentStyle = _props3.contentStyle,
            contentClassName = _props3.contentClassName,
            Content = _props3.contentComponent,
            navItems = _props3.navItems,
            children = _props3.children,
            drawerTitle = _props3.drawerTitle,
            drawerChildren = _props3.drawerChildren,
            drawerHeaderChildren = _props3.drawerHeaderChildren,
            drawerTransitionDuration = _props3.drawerTransitionDuration,
            toolbarTitle = _props3.toolbarTitle,
            toolbarTitleMenu = _props3.toolbarTitleMenu,
            toolbarTitleStyle = _props3.toolbarTitleStyle,
            toolbarTitleClassName = _props3.toolbarTitleClassName,
            toolbarActions = _props3.toolbarActions,
            toolbarProminent = _props3.toolbarProminent,
            toolbarProminentTitle = _props3.toolbarProminentTitle,
            toolbarThemeType = _props3.toolbarThemeType,
            toolbarSingleColor = _props3.toolbarSingleColor,
            toolbarChildren = _props3.toolbarChildren,
            mobileType = _props3.mobileDrawerType,
            tabletType = _props3.tabletDrawerType,
            desktopType = _props3.desktopDrawerType,
            transitionName = _props3.transitionName,
            transitionEnterTimeout = _props3.transitionEnterTimeout,
            transitionLeaveTimeout = _props3.transitionLeaveTimeout,
            extractMini = _props3.extractMini,
            miniDrawerHeader = _props3.miniDrawerHeader,
            miniDrawerChildren = _props3.miniDrawerChildren,
            temporaryIconChildren = _props3.temporaryIconChildren,
            temporaryIconClassName = _props3.temporaryIconClassName,
            menuIconChildren = _props3.menuIconChildren,
            menuIconClassName = _props3.menuIconClassName,
            footer = _props3.footer,
            includeDrawerHeader = _props3.includeDrawerHeader,
            contentId = _props3.contentId,
            contentProps = _props3.contentProps,
            constantDrawerType = _props3.constantDrawerType,
            props = _objectWithoutProperties(_props3, ['style', 'className', 'toolbarStyle', 'toolbarClassName', 'drawerStyle', 'drawerClassName', 'contentStyle', 'contentClassName', 'contentComponent', 'navItems', 'children', 'drawerTitle', 'drawerChildren', 'drawerHeaderChildren', 'drawerTransitionDuration', 'toolbarTitle', 'toolbarTitleMenu', 'toolbarTitleStyle', 'toolbarTitleClassName', 'toolbarActions', 'toolbarProminent', 'toolbarProminentTitle', 'toolbarThemeType', 'toolbarSingleColor', 'toolbarChildren', 'mobileDrawerType', 'tabletDrawerType', 'desktopDrawerType', 'transitionName', 'transitionEnterTimeout', 'transitionLeaveTimeout', 'extractMini', 'miniDrawerHeader', 'miniDrawerChildren', 'temporaryIconChildren', 'temporaryIconClassName', 'menuIconChildren', 'menuIconClassName', 'footer', 'includeDrawerHeader', 'contentId', 'contentProps', 'constantDrawerType']);

        delete props.drawerType;
        delete props.drawerHeader;
        delete props.persistentIconChildren;
        delete props.persistentIconClassName;
        delete props.jumpLabel;
        delete props.renderNode;

        // Deprecated deletes
        delete props.onDrawerChange;
        delete props.closeIconChildren;
        delete props.closeIconClassName;

        var drawerHeader = this.props.drawerHeader;
        var _state = this.state,
            desktop = _state.desktop,
            tablet = _state.tablet,
            contentActive = _state.contentActive;


        var drawerType = (0, _getField2.default)(this.props, this.state, 'drawerType');
        var visible = (0, _getField2.default)(this.props, this.state, 'visible');
        var renderNode = (0, _getField2.default)(this.props, this.context, 'renderNode');
        var mini = (0, _isType.isMini)(drawerType);
        var temporary = (0, _isType.isTemporary)(drawerType);
        var persistent = (0, _isType.isPersistent)(drawerType);
        var clipped = drawerType === DrawerTypes.CLIPPED;
        var floating = drawerType === DrawerTypes.FLOATING;

        var offset = desktop || tablet ? !temporary && visible : visible;
        var toolbarRelative = (0, _classnames2.default)({
          'md-toolbar-relative': !toolbarProminent && !toolbarProminentTitle,
          'md-toolbar-relative--prominent': toolbarProminent || toolbarProminentTitle
        });

        var nav = void 0;
        if (temporary || persistent) {
          nav = _react2.default.createElement(
            _Button2.default,
            {
              key: 'nav',
              onClick: this._toggleVisibility,
              disabled: persistent && visible,
              icon: true,
              iconClassName: menuIconClassName || temporaryIconClassName
            },
            menuIconChildren || temporaryIconChildren
          );
        }

        var closeButton = void 0;
        if (persistent) {
          closeButton = _react2.default.createElement(_CloseButton2.default, null);
        }

        if (!drawerHeader && includeDrawerHeader) {
          drawerHeader = _react2.default.createElement(
            _Toolbar2.default,
            {
              key: 'drawer-header',
              title: drawerTitle,
              actions: visible && nav ? closeButton : null,
              className: (0, _classnames2.default)('md-divider-border md-divider-border--bottom', _defineProperty({}, toolbarRelative, clipped || floating))
            },
            drawerHeaderChildren,
            _react2.default.createElement(_JumpToContentLink2.default, null)
          );
        }
        var miniDrawer = void 0;
        if (mini) {
          var miniList = void 0;
          if (extractMini) {
            miniList = navItems.map(toMiniListItem);
            miniList = _react2.default.createElement(
              _List2.default,
              { key: 'mini-nav-items', className: toolbarRelative },
              miniList
            );
          }

          miniDrawer = _react2.default.createElement(
            _Drawer2.default,
            { key: 'mini-drawer', type: drawerType, renderNode: renderNode, 'aria-hidden': visible },
            miniDrawerHeader,
            miniList,
            miniDrawerChildren
          );
        }

        var desktopOffset = !clipped && !floating && offset;

        return _react2.default.createElement(
          'div',
          { style: style, className: className },
          _react2.default.createElement(
            _Toolbar2.default,
            {
              colored: toolbarThemeType === 'colored',
              themed: toolbarThemeType === 'themed',
              singleColor: toolbarSingleColor,
              style: toolbarStyle,
              className: (0, _classnames2.default)({
                'md-toolbar--over-drawer': clipped || floating || mini && !visible
              }, toolbarClassName),
              title: toolbarTitle,
              titleMenu: toolbarTitleMenu,
              prominent: toolbarProminent,
              prominentTitle: toolbarProminentTitle,
              titleStyle: toolbarTitleStyle,
              titleClassName: (0, _classnames2.default)({
                'md-title--drawer-active': contentActive,
                'md-transition--decceleration': offset && visible,
                'md-transition--acceleration': offset && !visible,
                'md-title--permanent-offset': desktopOffset && (0, _isType.isPermanent)(drawerType),
                'md-title--persistent-offset': desktopOffset && persistent
              }, toolbarTitleClassName),
              nav: nav,
              actions: toolbarActions,
              fixed: true
            },
            toolbarChildren
          ),
          miniDrawer,
          _react2.default.createElement(
            _Drawer2.default,
            _extends({}, props, {
              constantType: constantDrawerType,
              transitionDuration: drawerTransitionDuration,
              header: drawerHeader,
              style: drawerStyle,
              className: drawerClassName,
              navItems: navItems,
              renderNode: renderNode,
              mobileType: mobileType,
              tabletType: tabletType,
              desktopType: desktopType,
              type: getNonMiniType(drawerType),
              visible: visible,
              onVisibilityToggle: this._handleVisibility,
              onMediaTypeChange: this._handleTypeChange
            }),
            drawerChildren
          ),
          _react2.default.createElement(
            _CSSTransitionGroup2.default,
            _extends({}, contentProps, {
              id: contentId,
              component: Content,
              transitionName: transitionName,
              transitionEnter: !!transitionEnterTimeout,
              transitionEnterTimeout: transitionEnterTimeout,
              transitionLeave: !!transitionLeaveTimeout,
              transitionLeaveTimeout: transitionLeaveTimeout,
              tabIndex: -1,
              style: contentStyle,
              className: (0, _classnames2.default)('md-navigation-drawer-content', {
                'md-navigation-drawer-content--active': contentActive,
                'md-navigation-drawer-content--inactive': !visible,
                'md-navigation-drawer-content--prominent-offset': toolbarProminent || toolbarProminentTitle,
                'md-transition--decceleration': visible,
                'md-transition--acceleration': !visible,
                'md-drawer-relative': offset,
                'md-drawer-relative--mini': mini && (!visible || temporary)
              }, toolbarRelative, contentClassName)
            }),
            children
          ),
          footer
        );
      }
    }]);

    return NavigationDrawer;
  }(_react.PureComponent);

  NavigationDrawer.DrawerType = { // deprecated
    /* eslint-disable no-console */
    _warned: false,
    _msg: 'Invalid use of `NavigationDrawer.DrawerType.{{TYPE}}`. The `NavigationDrawer.DrawerType` ' + 'has been deprecated and will be removed in the next release. Please use the ' + '`NavigationDrawer.DrawerTypes.{{TYPE}}` instead.',

    get FULL_HEIGHT() {
      if (!this._warned) {
        console.error(this._msg.replace(/{{TYPE}}/g, 'FULL_HEIGHT'));
      }
      this._warned = true;

      return DrawerTypes.FULL_HEIGHT;
    },

    get CLIPPED() {
      if (!this._warned) {
        console.error(this._msg.replace(/{{TYPE}}/g, 'CLIPPED'));
      }
      this._warned = true;

      return DrawerTypes.CLIPPED;
    },

    get FLOATING() {
      if (!this._warned) {
        console.error(this._msg.replace(/{{TYPE}}/g, 'FLOATING'));
      }
      this._warned = true;

      return DrawerTypes.FLOATING;
    },

    get PERSISTENT() {
      if (!this._warned) {
        console.error(this._msg.replace(/{{TYPE}}/g, 'PERSISTENT'));
      }
      this._warned = true;

      return DrawerTypes.PERSISTENT;
    },

    get PERSISTENT_MINI() {
      if (!this._warned) {
        console.error(this._msg.replace(/{{TYPE}}/g, 'PERSISTENT_MINI'));
      }
      this._warned = true;

      return DrawerTypes.PERSISTENT_MINI;
    },

    get TEMPORARY() {
      if (!this._warned) {
        console.error(this._msg.replace(/{{TYPE}}/g, 'TEMPORARY'));
      }
      this._warned = true;

      return DrawerTypes.TEMPORARY;
    },

    get TEMPORARY_MINI() {
      if (!this._warned) {
        console.error(this._msg.replace(/{{TYPE}}/g, 'TEMPORARY_MINI'));
      }
      this._warned = true;

      return DrawerTypes.TEMPORARY_MINI;
    }
  };
  NavigationDrawer.DrawerTypes = DrawerTypes;
  NavigationDrawer.propTypes = {
    /**
     * An optional style to apply to the surrounding container.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply to the surrounding container.
     */
    className: _propTypes2.default.string,

    /**
     * An optional style to apply to the main toolbar.
     */
    toolbarStyle: _propTypes2.default.object,

    /**
     * An optional className to apply to the toolbar.
     */
    toolbarClassName: _propTypes2.default.string,

    /**
     * An optional style to apply to the main toolbar's title.
     */
    toolbarTitleStyle: _propTypes2.default.object,

    /**
     * An optional className to apply to the main toolbar's title.
     */
    toolbarTitleClassName: _propTypes2.default.string,

    /**
     * An optional style to apply to the drawer.
     */
    drawerStyle: _propTypes2.default.object,

    /**
     * An optional className to apply to the drawer.
     */
    drawerClassName: _propTypes2.default.string,

    /**
     * An optional style to apply to the content. This is the container surrounding whatever
     * `children` are passed in.
     */
    contentStyle: _propTypes2.default.object,

    /**
     * An optional className to apply to the content. This is the container surrounding whatever
     * `children` are passed in.
     */
    contentClassName: _propTypes2.default.string,

    /**
     * The children to display in the main content.
     */
    children: _propTypes2.default.node,

    /**
     * Boolean if the `drawerHeader` component should be built if the `drawerHeader` prop is not
     * passed in.
     */
    includeDrawerHeader: _propTypes2.default.bool,

    /**
     * An optional header to display in the drawer. This will normally be the `Toolbar` component
     * or any other type of header. You can either use this prop with the `CloseButton` component
     * when displaying a persistent drawer, or use the `drawerTitle` and `drawerHeaderChildren` prop
     * to build a toolbar.
     */
    drawerHeader: _propTypes2.default.node,

    /**
     * An optional title to use for the drawer's header toolbar. If the `drawerHeader` prop is defined,
     * this is invalid.
     */
    drawerTitle: (0, _invalidIf2.default)(_propTypes2.default.node, 'drawerHeader'),

    /**
     * Any additional children to display in the drawer's header `Toolbar`. If the `drawerHeader` prop is defined,
     * this is invalud.
     */
    drawerHeaderChildren: (0, _invalidIf2.default)(_propTypes2.default.node, 'drawerHeader'),

    /**
     * Any additional children to display after the `drawerHeader` and `navItems` list in the drawer.
     */
    drawerChildren: _propTypes2.default.node,

    /**
     * The position for the drawer to be displayed.
     */
    position: _propTypes2.default.oneOf(['left', 'right']).isRequired,

    /**
     * An optional list of elements or props to use to build a navigational list in the drawer.
     * When the item is an object of props, it will build a `ListItem` component unless a key of
     * `divider` or `subheader` is set to true. It will then create the Divider or Subheader component
     * with any other remaining keys.
     */
    navItems: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.shape({
      divider: _propTypes2.default.bool,
      subheader: _propTypes2.default.bool,
      primaryText: _propTypes2.default.node
    })])),

    /**
     * The drawer type to use for mobile devices.
     */
    mobileDrawerType: _propTypes2.default.oneOf([DrawerTypes.TEMPORARY, DrawerTypes.TEMPORARY_MINI]).isRequired,

    /**
     * The drawer tye to use for tablets.
     */
    tabletDrawerType: _propTypes2.default.oneOf([DrawerTypes.FULL_HEIGHT, DrawerTypes.CLIPPED, DrawerTypes.FLOATING, DrawerTypes.PERSISTENT, DrawerTypes.PERSISTENT_MINI, DrawerTypes.TEMPORARY, DrawerTypes.TEMPORARY_MINI]).isRequired,

    /**
     * The drawer type to use for desktop displays.
     */
    desktopDrawerType: _propTypes2.default.oneOf([DrawerTypes.FULL_HEIGHT, DrawerTypes.CLIPPED, DrawerTypes.FLOATING, DrawerTypes.PERSISTENT, DrawerTypes.PERSISTENT_MINI, DrawerTypes.TEMPORARY, DrawerTypes.TEMPORARY_MINI]).isRequired,

    /**
     * An optional drawer type to enforce on all screen sizes. If the drawer type is not
     * `temporary`, you are required to define the `onMediaTypeChange` prop to handle switching
     * to temporary when the media matches a mobile device.
     * ```
     */
    drawerType: _propTypes2.default.oneOf([DrawerTypes.FULL_HEIGHT, DrawerTypes.CLIPPED, DrawerTypes.FLOATING, DrawerTypes.PERSISTENT, DrawerTypes.PERSISTENT_MINI, DrawerTypes.TEMPORARY, DrawerTypes.TEMPORARY_MINI]),

    /**
     * The default media match for the drawer. This will be what is displayed on first render.
     * The component will adjust itself to the current media after it has mounted, but this
     * is mostly used for server side rendering.
     */
    defaultMedia: _propTypes2.default.oneOf(['mobile', 'tablet', 'desktop']),

    /**
     * The min width to use for a mobile media query. This prop should match the `md-mobile-min-width`
     * variable.
     *
     * The media query for a mobile device will be:
     *
     * ```js
     * window.matchMedia(
     *   `screen and (min-width: ${mobileMinWidth}px) and (max-width: ${tabletMinWidth - 1}px`
     * ).matches;
     * ```
     */
    mobileMinWidth: _propTypes2.default.number.isRequired,

    /**
     * The min width to use for a tablet media query. This prop should match the `md-tablet-min-width`
     * variable.
     *
     * The media query for a tablet device will be:
     *
     * ```js
     * window.matchMedia(
     *   `screen and (min-width: ${tabletMinWidth}px) and (max-width: ${desktopWidth - 1}px`
     * ).matches;
     * ```
     */
    tabletMinWidth: _propTypes2.default.number.isRequired,

    /**
     * The min width to use for a desktop media query. This prop should match the `md-desktop-min-width`
     * variable.
     *
     * The media query for a tablet device will be:
     *
     * ```js
     * window.matchMedia(`screen and (min-width: ${tabletMinWidth}px)`).matches;
     * ```
     */
    desktopMinWidth: _propTypes2.default.number.isRequired,

    /**
     * An optional function to call when the type of the drawer changes because of the
     * new media queries. The callback will include the newly selected drawer type
     * and an object containing the media matches of `mobile`, `tablet`, and `desktop`.
     *
     * ```js
     * this.props.onMediaTypeChange(NavigationDrawer.DrawerTypes.TEMPORARY, {
     *   mobile: true,
     *   tablet: false,
     *   desktop: false,
     * });
     * ```
     */
    onMediaTypeChange: _propTypes2.default.func,

    /**
     * Boolean if the temporary or persistent drawers are visible by default.
     */
    defaultVisible: _propTypes2.default.bool,

    /**
     * Boolean if the temporary or persistent drawers are visible. If this is defined,
     * it will make the component controlled and require the `onVisibilityToggle` prop
     * to be defined.
     */
    visible: (0, _controlled2.default)(_propTypes2.default.bool, 'onVisibilityToggle', 'defaultVisible'),

    /**
     * An optional function to call when the visibility of the drawer changes. The callback
     * will include the new visibility.
     *
     * ```js
     * this.props.onVisibilityToggle(false);
     * ```
     */
    onVisibilityToggle: _propTypes2.default.func,

    /**
     * A boolean if the mini drawer's list should be generated from the `navItems` prop. When building
     * the list, it will extract the `leftIcon` or `leftAvatar` from the `navItem` and then create a
     * mini `ListItem` containing only that icon or image. Any other event listeners will also be applied.
     *
     *
     * @see miniDrawerHeader
     * @see miniDrawerChildren
     */
    extractMini: _propTypes2.default.bool,

    /**
     * An optional header to display in the mini drawer. This will be displayed above the optional
     * mini nav list that get generated if the `extractMini` prop is `true` and the `miniDrawerChildren`.
     *
     * @see extractMini
     */
    miniDrawerHeader: _propTypes2.default.node,

    /**
     * Any additional children to display in the mini drawer. This will be displayed after the `miniDrawerHeader`
     * and the optional mini nav list that gets generated if the `extractMini` prop is `true`.
     *
     * @see extractMini
     */
    miniDrawerChildren: _propTypes2.default.node,

    /**
     * Boolean if the drawer should automatically close after a nav item has been clicked for `temporary` drawers.
     */
    autoclose: _propTypes2.default.bool,

    /**
     * An optional title to display in the main toolbar. Either the `toolbarTitle` or the `toolbarTitleMenu`
     * may be defined, not both.
     */
    toolbarTitle: (0, _invalidIf2.default)(_propTypes2.default.node, 'toolbarTitleMenu'),

    /**
     * An optional select field menu to display in the main toolbar. Either the `toolbarTitle` or the `toolbarTitleMenu`
     * may be defined, not both.
     */
    toolbarTitleMenu: _propTypes2.default.element,

    /**
     * The theme style for the main toolbar.
     *
     * @see [toolbars](/components/toolbars#prop-types-toolbar)
     */
    toolbarThemeType: _propTypes2.default.oneOf(['default', 'colored', 'themed']).isRequired,

    /**
     * Boolean if the toolbar's nav, actions, and title should share the same color.
     */
    toolbarSingleColor: _propTypes2.default.bool,

    /**
     * A boolean if the toolbar should be prominent.
     */
    toolbarProminent: _propTypes2.default.bool,

    /**
     * A boolean if the toolbar's title should be prominent.
     */
    toolbarProminentTitle: _propTypes2.default.bool,

    /**
     * A list of elements or a single element to display to the right of the
     * toolbar's nav, title, and children.
     *
     * @see [toolbars](/components/toolbars#prop-types-toolbar)
     */
    toolbarActions: _Toolbar2.default.propTypes.actions,

    /**
     * Any children to display in the toolbar. This will be displayed between the optional title and
     * actions.
     */
    toolbarChildren: _Toolbar2.default.propTypes.children,

    /**
     * The component to render the content in.
     */
    contentComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,

    /**
     * An optional footer display after the main content.
     */
    footer: _propTypes2.default.node,

    /**
     * Any children used to render a button that will toggle the visibility of the
     * navigation drawer for `temporary` and `persistent` drawers. This is normally a
     * hamburger menu.
     */
    temporaryIconChildren: _propTypes2.default.node,

    /**
     * The icon className used to render a button that will toggle the visibility of the
     * navigation drawer for `temporary` and `persistent` drawers. This is normally a
     * hamburger menu.
     */
    temporaryIconClassName: _propTypes2.default.string,

    /**
     * Any children used to render a button that appears on a persistent drawer's open
     * header. This is used to create the `CloseButton` for drawers. When a persistent
     * drawer is closed, the `temporaryIconChildren` and `temporaryIconClassName` props
     * will be used to create a button to open the drawer.
     *
     * If the `drawerHeader` prop is defined, you will have to either include the `CloseButton`
     * in your header manually, or create your own controlled button to close the drawer.
     */
    persistentIconChildren: _propTypes2.default.node,

    /**
     * The icon classNameused to render a button that appears on a persistent drawer's open
     * header. This is used to create the `CloseButton` for drawers. When a persistent
     * drawer is closed, the `temporaryIconChildren` and `temporaryIconClassName` props
     * will be used to create a button to open the drawer.
     *
     * If the `drawerHeader` prop is defined, you will have to either include the `CloseButton`
     * in your header manually, or create your own controlled button to close the drawer.
     */
    persistentIconClassName: _propTypes2.default.string,

    /**
     * The transition name to use when the page's content changes. If you want to disable
     * transitions, set both the `transitionEnterTimeout` and `transitionLeaveTimeout` props
     * to a false-ish value. (`null`, `undefined`, or `0`).
     */
    transitionName: _propTypes2.default.string.isRequired,

    /**
     * The transition enter timeout when the page's content changes. If you want to disable
     * the enter transition, set this to a false-ish value (`null`, `undefined`, or `0`).
     */
    transitionEnterTimeout: _propTypes2.default.number,

    /**
     * The transition leave timeout when the page's content changes. If you want to disable
     * the leave transition, set this to a false-ish value (`null`, `undefined`, or `0`).
     */
    transitionLeaveTimeout: _propTypes2.default.number,

    /**
     * The transition duration for the drawer when sliding in and out of view.
     */
    drawerTransitionDuration: _propTypes2.default.number.isRequired,

    /**
     * Any additional props to provide to the main content. This will be applied before any of the generated props,
     * so this should not include `style`, `className`, or `component`.
     */
    contentProps: _propTypes2.default.object,

    /**
     * An id to give the main content. A hidden link is created in the main drawer's header that links to the main
     * content. This is used for keyboard only users to jump the navigation and jump straight to the content.
     *
     * If you provide your own `drawerHeader`, it is suggested to include the link yourself.
     */
    contentId: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),

    /**
     * The label to use for a keyboard accessibility link that jumps all the navigation and allows a user to focus
     * the main content. This is created in the drawer's header.
     */
    jumpLabel: _propTypes2.default.node.isRequired,

    /**
     * An optional DOM Node to render the drawer into. The default is to render as
     * the first child in the `body`.
     *
     * > This prop will not be used when the drawer is of the permanent type or `inline` is specified
     * since the `Portal` component will not be used.
     */
    renderNode: _propTypes2.default.object,

    /**
     * Boolean if the drawer should be rendered as the last child instead of the first child
     * in the `renderNode` or `body`.
     *
     * > This prop will not be used when the drawer is of the permanent type or `inline` is specified
     * since the `Portal` component will not be used.
     */
    lastChild: _propTypes2.default.bool,

    /**
     * Boolean if the `drawerType` should remain constant across all media. This is really only valid
     * if the `drawerType` is one of the temporary types.
     */
    constantDrawerType: _propTypes2.default.bool,

    menuIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `temporaryIconChildren` instead'),
    menuIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `temporaryIconClassName` instead'),
    closeIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `persistentIconChildren` instead'),
    closeIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `persistentIconClassName` instead'),
    onDrawerChange: (0, _deprecated2.default)(_propTypes2.default.func, 'Use `onVisibilityToggle` or `onMediaTypeChange` instead'),
    contentTransitionName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `transitionName` instead'),
    contentTransitionEnterTimeout: (0, _deprecated2.default)(_propTypes2.default.number, 'Use `transtionEnterTimeout` instead'),
    contentTransitionLeaveTimeout: (0, _deprecated2.default)(_propTypes2.default.number, 'Use `transtionLeaveTimeout` instead'),
    initialDrawerType: (0, _deprecated2.default)(_propTypes2.default.oneOf(['mobile', 'tablet', 'desktop']), 'Use `defaultMedia` instead')
  };
  NavigationDrawer.contextTypes = {
    renderNode: _propTypes2.default.object
  };
  NavigationDrawer.childContextTypes = {
    closeIconClassName: _propTypes2.default.string,
    closeChildren: _propTypes2.default.node,
    onCloseClick: _propTypes2.default.func,
    id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
    label: _propTypes2.default.node.isRequired,
    renderNode: _propTypes2.default.object
  };
  NavigationDrawer.defaultProps = {
    autoclose: _Drawer2.default.defaultProps.autoclose,
    contentId: 'main-content',
    // Defaults to false since it keeps the state of the drawerType in sync and makes the Drawer
    // controlled. On initial mount without any defaultMedia updates, it would always be considered
    // temporary
    constantDrawerType: false,
    jumpLabel: 'Jump to content',
    extractMini: true,
    position: _Drawer2.default.defaultProps.position,
    defaultMedia: _Drawer2.default.defaultProps.defaultMedia,
    mobileDrawerType: _Drawer2.default.defaultProps.mobileType,
    tabletDrawerType: _Drawer2.default.defaultProps.tabletType,
    desktopDrawerType: _Drawer2.default.defaultProps.desktopType,
    mobileMinWidth: _Drawer2.default.defaultProps.mobileMinWidth,
    tabletMinWidth: _Drawer2.default.defaultProps.tabletMinWidth,
    desktopMinWidth: _Drawer2.default.defaultProps.desktopMinWidth,
    includeDrawerHeader: true,
    contentComponent: 'main',
    temporaryIconChildren: 'menu',
    toolbarThemeType: 'colored',
    persistentIconChildren: 'arrow_back',
    transitionName: 'md-cross-fade',
    transitionEnterTimeout: 300,
    drawerTransitionDuration: _Drawer2.default.defaultProps.transitionDuration
  };
  exports.default = NavigationDrawer;
});

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1135), __webpack_require__(568), __webpack_require__(569)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./NavigationDrawer'), require('./CloseButton'), require('./JumpToContentLink'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.NavigationDrawer, global.CloseButton, global.JumpToContentLink);
    global.index = mod.exports;
  }
})(this, function (exports, _NavigationDrawer, _CloseButton2, _JumpToContentLink2) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.JumpToContentLink = exports.CloseButton = exports.NavigationDrawer = undefined;

  var _NavigationDrawer2 = _interopRequireDefault(_NavigationDrawer);

  var _CloseButton3 = _interopRequireDefault(_CloseButton2);

  var _JumpToContentLink3 = _interopRequireDefault(_JumpToContentLink2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _NavigationDrawer2.default;
  exports.NavigationDrawer = _NavigationDrawer2.default;
  exports.CloseButton = _CloseButton3.default;
  exports.JumpToContentLink = _JumpToContentLink3.default;
});

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames);
    global.CalendarDate = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var CalendarDate = function (_PureComponent) {
    _inherits(CalendarDate, _PureComponent);

    function CalendarDate(props) {
      _classCallCheck(this, CalendarDate);

      var _this = _possibleConstructorReturn(this, (CalendarDate.__proto__ || Object.getPrototypeOf(CalendarDate)).call(this, props));

      _this.state = _this._getFormattedDate(props);
      _this.state.desktopActive = false;
      _this._handleClick = _this._handleClick.bind(_this);
      _this._setActive = _this._setActive.bind(_this);
      _this._setInactive = _this._setInactive.bind(_this);
      _this._setFocus = _this._setFocus.bind(_this);
      return _this;
    }

    _createClass(CalendarDate, [{
      key: 'componentWillUpdate',
      value: function componentWillUpdate(nextProps) {
        var _props = this.props,
            DateTimeFormat = _props.DateTimeFormat,
            locales = _props.locales,
            date = _props.date;

        if (DateTimeFormat !== nextProps.DateTimeFormat || locales !== nextProps.locales || date !== nextProps.date) {
          this.setState(this._getFormattedDate(nextProps));
        }
      }
    }, {
      key: '_setFocus',
      value: function _setFocus(btn) {
        if (btn && this.props.active) {
          btn.focus();
        }
      }
    }, {
      key: '_getFormattedDate',
      value: function _getFormattedDate(_ref) {
        var DateTimeFormat = _ref.DateTimeFormat,
            locales = _ref.locales,
            date = _ref.date;

        return {
          date: new DateTimeFormat(locales, { day: 'numeric' }).format(date)
        };
      }
    }, {
      key: '_handleClick',
      value: function _handleClick(e) {
        this.props.onClick(new Date(this.props.date), e);
      }
    }, {
      key: '_setActive',
      value: function _setActive() {
        if (!this.props.disabled) {
          this.setState({ desktopActive: true });
        }
      }
    }, {
      key: '_setInactive',
      value: function _setInactive() {
        if (!this.props.disabled) {
          this.setState({ desktopActive: false });
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _state = this.state,
            date = _state.date,
            desktopActive = _state.desktopActive;
        var _props2 = this.props,
            disabled = _props2.disabled,
            active = _props2.active,
            today = _props2.today,
            className = _props2.className;


        var fullyActive = today && !active && !desktopActive;
        return _react2.default.createElement(
          'button',
          {
            type: 'button',
            ref: this._setFocus,
            onFocus: this._setActive,
            onBlur: this._setInactive,
            onMouseOver: this._setActive,
            onMouseLeave: this._setInactive,
            className: (0, _classnames2.default)('md-btn md-calendar-date md-calendar-date--btn', {
              'md-text--disabled': disabled,
              'md-pointer--hover': !disabled,
              'md-text--theme-primary': fullyActive,
              'md-calendar-date--btn-active': active || desktopActive
            }, className),
            onClick: this._handleClick,
            disabled: disabled
          },
          _react2.default.createElement(
            'span',
            {
              className: (0, _classnames2.default)('md-calendar-date--date', {
                'md-picker-text--active': active || desktopActive,
                'md-font-bold': fullyActive
              })
            },
            date
          )
        );
      }
    }]);

    return CalendarDate;
  }(_react.PureComponent);

  CalendarDate.propTypes = {
    className: _propTypes2.default.string,
    date: _propTypes2.default.instanceOf(Date).isRequired,
    DateTimeFormat: _propTypes2.default.func.isRequired,
    locales: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,
    disabled: _propTypes2.default.bool,
    onClick: _propTypes2.default.func.isRequired,
    active: _propTypes2.default.bool,
    today: _propTypes2.default.bool
  };
  exports.default = CalendarDate;
});

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(1190), __webpack_require__(585), __webpack_require__(266), __webpack_require__(11)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('../utils/DateUtils/isMonthBefore'), require('../utils/DateUtils/getDayOfWeek'), require('../utils/DateUtils/addDate'), require('../Buttons/Button'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.isMonthBefore, global.getDayOfWeek, global.addDate, global.Button);
    global.CalendarHeader = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _isMonthBefore, _getDayOfWeek, _addDate, _Button) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _isMonthBefore2 = _interopRequireDefault(_isMonthBefore);

  var _getDayOfWeek2 = _interopRequireDefault(_getDayOfWeek);

  var _addDate2 = _interopRequireDefault(_addDate);

  var _Button2 = _interopRequireDefault(_Button);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var CalendarHeader = function (_PureComponent) {
    _inherits(CalendarHeader, _PureComponent);

    function CalendarHeader(props) {
      _classCallCheck(this, CalendarHeader);

      var _this = _possibleConstructorReturn(this, (CalendarHeader.__proto__ || Object.getPrototypeOf(CalendarHeader)).call(this, props));

      _this.state = _this._createState(props);
      return _this;
    }

    _createClass(CalendarHeader, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var _props = this.props,
            DateTimeFormat = _props.DateTimeFormat,
            locales = _props.locales,
            date = _props.date;

        if (DateTimeFormat !== nextProps.DateTimeFormat || locales !== nextProps.locales || date !== nextProps.date) {
          this.setState(this._createState(nextProps));
        }
      }
    }, {
      key: '_createState',
      value: function _createState() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props,
            DateTimeFormat = _ref.DateTimeFormat,
            locales = _ref.locales,
            date = _ref.date;

        var sunday = (0, _getDayOfWeek2.default)(date, 0);
        var formatter = new DateTimeFormat(locales, { weekday: 'narrow' });
        var dows = [];
        for (var i = 0; i < 7; i++) {
          var dow = formatter.format((0, _addDate2.default)(sunday, i, 'D'));
          dows.push(_react2.default.createElement(
            'h4',
            { className: 'md-calendar-date md-text--disabled md-calendar-dow', key: i },
            dow
          ));
        }

        return {
          dows: dows,
          title: new DateTimeFormat(locales, { month: 'long', year: 'numeric' }).format(date)
        };
      }
    }, {
      key: 'render',
      value: function render() {
        var _state = this.state,
            dows = _state.dows,
            title = _state.title;
        var _props2 = this.props,
            date = _props2.date,
            minDate = _props2.minDate,
            maxDate = _props2.maxDate,
            onPreviousClick = _props2.onPreviousClick,
            previousIconChildren = _props2.previousIconChildren,
            previousIconClassName = _props2.previousIconClassName,
            onNextClick = _props2.onNextClick,
            nextIconChildren = _props2.nextIconChildren,
            nextIconClassName = _props2.nextIconClassName;


        var isPreviousDisabled = (0, _isMonthBefore2.default)(minDate, date);
        var isNextDisabled = (0, _isMonthBefore2.default)(date, maxDate);
        return _react2.default.createElement(
          'header',
          { className: 'md-calendar-header' },
          _react2.default.createElement(
            'div',
            { className: 'md-calendar-controls' },
            _react2.default.createElement(
              _Button2.default,
              {
                icon: true,
                onClick: onPreviousClick,
                disabled: isPreviousDisabled,
                className: 'md-calendar-control',
                iconClassName: previousIconClassName
              },
              previousIconChildren
            ),
            _react2.default.createElement(
              'h4',
              { className: 'md-title' },
              title
            ),
            _react2.default.createElement(
              _Button2.default,
              {
                icon: true,
                onClick: onNextClick,
                disabled: isNextDisabled,
                className: 'md-calendar-control',
                iconClassName: nextIconClassName
              },
              nextIconChildren
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'md-calendar-dows' },
            dows
          )
        );
      }
    }]);

    return CalendarHeader;
  }(_react.PureComponent);

  CalendarHeader.propTypes = {
    className: _propTypes2.default.string,
    children: _propTypes2.default.node,
    date: _propTypes2.default.instanceOf(Date).isRequired,
    minDate: _propTypes2.default.instanceOf(Date),
    maxDate: _propTypes2.default.instanceOf(Date),
    previousIconChildren: _propTypes2.default.node,
    previousIconClassName: _propTypes2.default.string,
    onPreviousClick: _propTypes2.default.func.isRequired,
    nextIconChildren: _propTypes2.default.node,
    nextIconClassName: _propTypes2.default.string,
    onNextClick: _propTypes2.default.func.isRequired,
    DateTimeFormat: _propTypes2.default.func.isRequired,
    locales: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired
  };
  exports.default = CalendarHeader;
});

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(266), __webpack_require__(586), __webpack_require__(1188), __webpack_require__(585), __webpack_require__(1137)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('../utils/DateUtils/addDate'), require('../utils/DateUtils/stripTime'), require('../utils/DateUtils/getLastDay'), require('../utils/DateUtils/getDayOfWeek'), require('./CalendarDate'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.addDate, global.stripTime, global.getLastDay, global.getDayOfWeek, global.CalendarDate);
    global.CalendarMonth = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _addDate, _stripTime, _getLastDay, _getDayOfWeek, _CalendarDate) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _addDate2 = _interopRequireDefault(_addDate);

  var _stripTime2 = _interopRequireDefault(_stripTime);

  var _getLastDay2 = _interopRequireDefault(_getLastDay);

  var _getDayOfWeek2 = _interopRequireDefault(_getDayOfWeek);

  var _CalendarDate2 = _interopRequireDefault(_CalendarDate);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var CalendarMonth = function (_PureComponent) {
    _inherits(CalendarMonth, _PureComponent);

    function CalendarMonth() {
      _classCallCheck(this, CalendarMonth);

      return _possibleConstructorReturn(this, (CalendarMonth.__proto__ || Object.getPrototypeOf(CalendarMonth)).apply(this, arguments));
    }

    _createClass(CalendarMonth, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            calendarDate = _props.calendarDate,
            calendarTempDate = _props.calendarTempDate,
            onCalendarDateClick = _props.onCalendarDateClick,
            minDate = _props.minDate,
            maxDate = _props.maxDate,
            DateTimeFormat = _props.DateTimeFormat,
            locales = _props.locales,
            className = _props.className,
            props = _objectWithoutProperties(_props, ['calendarDate', 'calendarTempDate', 'onCalendarDateClick', 'minDate', 'maxDate', 'DateTimeFormat', 'locales', 'className']);

        var days = [];
        var currentDate = (0, _stripTime2.default)((0, _getDayOfWeek2.default)(new Date(calendarDate).setDate(1), 0));
        var endDate = (0, _stripTime2.default)((0, _getDayOfWeek2.default)((0, _getLastDay2.default)(calendarDate), 6));
        var activeDate = (0, _stripTime2.default)(new Date(calendarTempDate));
        var today = (0, _stripTime2.default)(new Date());

        while (currentDate <= endDate) {
          var key = currentDate.getMonth() + '-' + currentDate.getDate();

          var date = void 0;
          if (currentDate.getMonth() === calendarDate.getMonth()) {
            var time = currentDate.getTime();
            var isMinDateDisabled = minDate && minDate.getTime() > time;
            var isMaxDateDisbaled = maxDate && maxDate.getTime() < time;
            date = _react2.default.createElement(_CalendarDate2.default, {
              key: key,
              today: time === today.getTime(),
              active: time === activeDate.getTime(),
              disabled: isMinDateDisabled || isMaxDateDisbaled,
              onClick: onCalendarDateClick,
              date: currentDate,
              DateTimeFormat: DateTimeFormat,
              locales: locales
            });
          } else {
            date = _react2.default.createElement('div', { key: key, className: 'md-calendar-date' });
          }

          days.push(date);
          currentDate = (0, _addDate2.default)(currentDate, 1, 'D');
        }

        return _react2.default.createElement(
          'div',
          _extends({ className: (0, _classnames2.default)('md-calendar-month', className) }, props),
          days
        );
      }
    }]);

    return CalendarMonth;
  }(_react.PureComponent);

  CalendarMonth.propTypes = {
    /**
     * A className to apply.
     */
    className: _propTypes2.default.string,

    /**
     * The current selected date of the calendar. This is
     * the date after hitting the Ok button or `value` || `defaultValue`.
     */
    calendarDate: _propTypes2.default.instanceOf(Date).isRequired,

    /**
     * The current selected date of the calendar before verifying
     * the new date.
     */
    calendarTempDate: _propTypes2.default.instanceOf(Date).isRequired,

    /**
     * An optional min date for the calendar. This will disable any
     * dates that come before this date in the month.
     */
    minDate: _propTypes2.default.instanceOf(Date),

    /**
     * An optional max date for the calendar. This will disable any
     * dates that come after this date in the month.
     */
    maxDate: _propTypes2.default.instanceOf(Date),

    /**
     * A function to call that will select a new date.
     */
    onCalendarDateClick: _propTypes2.default.func.isRequired,
    DateTimeFormat: _propTypes2.default.func.isRequired,
    locales: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired
  };
  exports.default = CalendarMonth;
});

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(267), __webpack_require__(117), __webpack_require__(1191), __webpack_require__(592), __webpack_require__(1142), __webpack_require__(1141)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('../utils/EventUtils/isValidClick'), require('../utils/EventUtils/captureNextEvent'), require('../utils/NumberUtils/calcTimeFromPoint'), require('../utils/calcPageOffset'), require('./ClockTime'), require('./ClockHand'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.isValidClick, global.captureNextEvent, global.calcTimeFromPoint, global.calcPageOffset, global.ClockTime, global.ClockHand);
    global.ClockFace = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _isValidClick, _captureNextEvent, _calcTimeFromPoint, _calcPageOffset, _ClockTime, _ClockHand) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _isValidClick2 = _interopRequireDefault(_isValidClick);

  var _captureNextEvent2 = _interopRequireDefault(_captureNextEvent);

  var _calcTimeFromPoint2 = _interopRequireDefault(_calcTimeFromPoint);

  var _calcPageOffset2 = _interopRequireDefault(_calcPageOffset);

  var _ClockTime2 = _interopRequireDefault(_ClockTime);

  var _ClockHand2 = _interopRequireDefault(_ClockHand);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var ClockFace = function (_PureComponent) {
    _inherits(ClockFace, _PureComponent);

    function ClockFace(props) {
      _classCallCheck(this, ClockFace);

      var _this = _possibleConstructorReturn(this, (ClockFace.__proto__ || Object.getPrototypeOf(ClockFace)).call(this, props));

      _this.state = { radius: 136, moving: false };
      _this._center = {};
      _this._setFace = _this._setFace.bind(_this);
      _this._calcNewTime = _this._calcNewTime.bind(_this);
      _this._handleMouseUp = _this._handleMouseUp.bind(_this);
      _this._handleMouseDown = _this._handleMouseDown.bind(_this);
      _this._handleMouseMove = _this._handleMouseMove.bind(_this);
      _this._handleTouchEnd = _this._handleTouchEnd.bind(_this);
      _this._handleTouchMove = _this._handleTouchMove.bind(_this);
      _this._handleTouchStart = _this._handleTouchStart.bind(_this);
      return _this;
    }

    _createClass(ClockFace, [{
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        window.removeEventListener('mousemove', this._handleMouseMove);
        window.removeEventListener('mouseup', this._handleMouseMove);
        window.removeEventListener('touchmove', this._handleTouchMove);
        window.removeEventListener('touchend', this._handleTouchEnd);
      }
    }, {
      key: '_setFace',
      value: function _setFace(face) {
        this._face = face;

        if (face !== null) {
          var radius = face.offsetWidth / 2;
          var offset = (0, _calcPageOffset2.default)(face);
          this._center = { x: offset.left + radius, y: offset.top + radius };
          this._left = offset.left;
          this._top = offset.top;
          this.setState({ radius: radius });
        }
      }
    }, {
      key: '_handleMouseDown',
      value: function _handleMouseDown(e) {
        if (!(0, _isValidClick2.default)(e)) {
          return;
        }

        window.addEventListener('mousemove', this._handleMouseMove);
        window.addEventListener('mouseup', this._handleMouseUp);
        this.setState({ moving: true });
      }
    }, {
      key: '_handleMouseMove',
      value: function _handleMouseMove(e) {
        if (!this.state.moving) {
          return;
        }

        e.preventDefault();
        this._calcNewTime(e);
      }
    }, {
      key: '_handleMouseUp',
      value: function _handleMouseUp(e) {
        if (!(0, _isValidClick2.default)(e)) {
          return;
        }

        if (this._face && !this._face.contains(e.target)) {
          (0, _captureNextEvent2.default)('click');
        }

        window.removeEventListener('mousemove', this._handleMouseMove);
        window.removeEventListener('mouseup', this._handleMouseUp);

        this._calcNewTime(e);
        this.setState({ moving: false });
      }
    }, {
      key: '_handleTouchStart',
      value: function _handleTouchStart() {
        (0, _captureNextEvent2.default)('mousedown');

        window.addEventListener('touchmove', this._handleTouchMove);
        window.addEventListener('touchend', this._handleTouchEnd);
        this.setState({ moving: true });
      }
    }, {
      key: '_handleTouchMove',
      value: function _handleTouchMove(e) {
        if (!this.state.moving) {
          return;
        }
        e.preventDefault();

        this._calcNewTime(e);
      }
    }, {
      key: '_handleTouchEnd',
      value: function _handleTouchEnd(e) {
        this._calcNewTime(e);
        if (this._face && !this._face.contains(e.target)) {
          (0, _captureNextEvent2.default)('click');
        }

        window.removeEventListener('touchmove', this._handleTouchMove);
        window.removeEventListener('touchend', this._handleTouchEnd);

        this.setState({ moving: false });
      }
    }, {
      key: '_calcNewTime',
      value: function _calcNewTime(e) {
        var _ref = e.changedTouches ? e.changedTouches[0] : e,
            x = _ref.pageX,
            y = _ref.pageY;

        var innerRadius = this.state.radius - 48;
        var _props = this.props,
            onChange = _props.onChange,
            minutes = _props.minutes,
            timePeriod = _props.timePeriod;

        onChange((0, _calcTimeFromPoint2.default)({ x: x, y: y }, this._center, innerRadius, minutes, timePeriod));
      }
    }, {
      key: 'render',
      value: function render() {
        var _props2 = this.props,
            time = _props2.time,
            minutes = _props2.minutes,
            timePeriod = _props2.timePeriod,
            onChange = _props2.onChange;
        var radius = this.state.radius;

        var size = !minutes && !timePeriod ? 24 : 12;
        var times = Array.apply(null, new Array(size)).map(function (_, i) {
          var clockTime = i + 1;
          if (minutes) {
            clockTime = clockTime * 5 % 60;
          } else {
            clockTime %= 24;
          }

          return _react2.default.createElement(_ClockTime2.default, {
            key: 'time-' + i,
            index: i + 1,
            time: clockTime,
            active: clockTime === time,
            radius: radius,
            onKeyboardFocus: onChange
          });
        });

        return _react2.default.createElement(
          'div',
          {
            ref: this._setFace,
            className: 'md-clock-face md-block-centered md-pointer--hover',
            onMouseDown: this._handleMouseDown,
            onTouchStart: this._handleTouchStart
          },
          times,
          _react2.default.createElement(_ClockHand2.default, { time: time, coords: radius, minutes: minutes })
        );
      }
    }]);

    return ClockFace;
  }(_react.PureComponent);

  ClockFace.propTypes = {
    /**
     * The current time for the clock.
     */
    time: _propTypes2.default.number.isRequired,

    /**
     * Boolean if the clock is on the minutes view.
     */
    minutes: _propTypes2.default.bool.isRequired,

    /**
     * A function to call when a new time is selected. It gives the
     * new time value. If it is 12 o'clock, 0 will be given.
     */
    onChange: _propTypes2.default.func.isRequired,

    /**
     * An optional time period string. This should be either AM or PM
     * if the locale uses them.
     */
    timePeriod: _propTypes2.default.string
  };
  exports.default = ClockFace;
});

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames);
    global.ClockHand = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var ClockHand = function (_PureComponent) {
    _inherits(ClockHand, _PureComponent);

    function ClockHand(props) {
      _classCallCheck(this, ClockHand);

      var _this = _possibleConstructorReturn(this, (ClockHand.__proto__ || Object.getPrototypeOf(ClockHand)).call(this, props));

      _this.state = { active: false };
      return _this;
    }

    _createClass(ClockHand, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var _this2 = this;

        if (this.props.minutes !== nextProps.minutes) {
          if (this.state.timeout) {
            clearTimeout(this.state.timeout);
          }

          this.setState({
            active: true,
            timeout: setTimeout(function () {
              return _this2.setState({ active: false, timeout: null });
            }, 150)
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.state.timeout) {
          clearTimeout(this.state.timeout);
        }
      }
    }, {
      key: '_calcCurrentDegrees',
      value: function _calcCurrentDegrees(_ref) {
        var time = _ref.time,
            minutes = _ref.minutes;

        var timeAt0Deg = minutes ? 15 : 3;
        var sectors = minutes ? 60 : 12;

        return (time % sectors - timeAt0Deg) * (360 / sectors);
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            coords = _props.coords,
            time = _props.time,
            minutes = _props.minutes;


        var degrees = this._calcCurrentDegrees(this.props);
        var invisibleMinute = false;
        if (minutes) {
          invisibleMinute = degrees % (360 / 12) !== 0;
        }

        var rotateTransform = 'rotate3d(0, 0, 1, ' + degrees + 'deg)';
        return _react2.default.createElement('div', {
          className: (0, _classnames2.default)('md-clock-hand md-background--primary', {
            'md-clock-hand--active': this.state.active,
            'md-clock-hand--minute-hover': invisibleMinute,
            'md-clock-hand--inner': !minutes && (time > 12 || time === 0)
          }),
          style: {
            left: coords,
            top: coords,
            WebkitTransform: rotateTransform,
            MozTransform: rotateTransform,
            msTransform: rotateTransform,
            transform: rotateTransform
          }
        });
      }
    }]);

    return ClockHand;
  }(_react.PureComponent);

  ClockHand.propTypes = {
    /**
     * This is the x and y coordinate to use for the center of the `ClockFace`.
     * This should really be whatever the radius of the `ClockFace` is.
     */
    coords: _propTypes2.default.number,

    /**
     * The current time of the clock.
     */
    time: _propTypes2.default.number.isRequired,

    /**
     * Boolean if the clock is displaying minutes instead of hours.
     */
    minutes: _propTypes2.default.bool.isRequired
  };
  exports.default = ClockHand;
});

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(14)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('../constants/keyCodes'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.keyCodes);
    global.ClockTime = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _keyCodes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var CLOCK_PADDING = 4;

  /**
   * The `ClockTime` component is used for positioning hours or minutes
   * in a clock. The time will be positioned based on it's given index
   * and the radius of the clock.
   */

  var ClockTime = function (_PureComponent) {
    _inherits(ClockTime, _PureComponent);

    function ClockTime(props) {
      _classCallCheck(this, ClockTime);

      var _this = _possibleConstructorReturn(this, (ClockTime.__proto__ || Object.getPrototypeOf(ClockTime)).call(this, props));

      _this.state = {
        // default size in scss
        size: 18
      };

      _this._setTime = _this._setTime.bind(_this);
      _this._setPosition = _this._setPosition.bind(_this);
      _this._handleKeyUp = _this._handleKeyUp.bind(_this);
      return _this;
    }

    _createClass(ClockTime, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (this.props.radius !== nextProps.radius || this.props.index !== nextProps.index) {
          this._setPosition(nextProps, this._time);
        }
      }
    }, {
      key: '_handleKeyUp',
      value: function _handleKeyUp(e) {
        if ((e.which || e.keyCode) === _keyCodes.TAB) {
          this.props.onKeyboardFocus(this.props.time);
        }
      }
    }, {
      key: '_setTime',
      value: function _setTime(time) {
        this._time = time;
        if (time !== null) {
          this._setPosition(this.props, time);

          if (this.props.active) {
            time.focus();
          }
        }
      }
    }, {
      key: '_setPosition',
      value: function _setPosition(_ref, time) {
        var radius = _ref.radius,
            index = _ref.index;

        // 36 is default size for the time
        var size = (time.offsetWidth || 36) / 2;
        var timeRadians = Math.PI / 2 - index * (Math.PI / 6);
        var innerCircle = index > 12;

        var outerRadius = radius - size;
        var innerRadius = outerRadius - CLOCK_PADDING - (innerCircle ? size * 2 : 0);

        this.setState({
          style: {
            top: outerRadius - innerRadius * Math.sin(timeRadians),
            left: outerRadius + innerRadius * Math.cos(timeRadians)
          }
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            time = _props.time,
            active = _props.active;

        return _react2.default.createElement(
          'div',
          {
            ref: this._setTime,
            tabIndex: 0,
            className: (0, _classnames2.default)('md-clock-time md-text-no-select md-pointer--none', {
              'md-text': !active,
              'md-picker-text--active': active
            }),
            style: this.state.style,
            onKeyUp: this._handleKeyUp
          },
          _react2.default.createElement(
            'span',
            { className: 'md-clock-time-value' },
            time
          )
        );
      }
    }]);

    return ClockTime;
  }(_react.PureComponent);

  ClockTime.propTypes = {
    /**
     * The index of the current time to be displayed. This
     * should be a number between 1 and 24.
     */
    index: _propTypes2.default.number.isRequired,

    /**
     * The time number to display.
     */
    time: _propTypes2.default.number.isRequired,

    /**
     * Boolean if this time is currently selected.
     */
    active: _propTypes2.default.bool.isRequired,

    /**
     * The radius of the clock.
     */
    radius: _propTypes2.default.number.isRequired,

    onKeyboardFocus: _propTypes2.default.func.isRequired
  };
  exports.default = ClockTime;
});

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(115), __webpack_require__(1146), __webpack_require__(1144), __webpack_require__(1152)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('../Dialogs/DialogFooter'), require('./DatePickerHeader'), require('./DatePickerCalendar'), require('./YearPicker'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.DialogFooter, global.DatePickerHeader, global.DatePickerCalendar, global.YearPicker);
    global.DatePicker = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _DialogFooter, _DatePickerHeader, _DatePickerCalendar, _YearPicker) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _DialogFooter2 = _interopRequireDefault(_DialogFooter);

  var _DatePickerHeader2 = _interopRequireDefault(_DatePickerHeader);

  var _DatePickerCalendar2 = _interopRequireDefault(_DatePickerCalendar);

  var _YearPicker2 = _interopRequireDefault(_YearPicker);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var DatePicker = function (_PureComponent) {
    _inherits(DatePicker, _PureComponent);

    function DatePicker() {
      _classCallCheck(this, DatePicker);

      return _possibleConstructorReturn(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).apply(this, arguments));
    }

    _createClass(DatePicker, [{
      key: 'render',
      value: function render() {
        var _cn;

        var _props = this.props,
            okLabel = _props.okLabel,
            okPrimary = _props.okPrimary,
            onOkClick = _props.onOkClick,
            cancelLabel = _props.cancelLabel,
            cancelPrimary = _props.cancelPrimary,
            onCancelClick = _props.onCancelClick,
            DateTimeFormat = _props.DateTimeFormat,
            locales = _props.locales,
            calendarTempDate = _props.calendarTempDate,
            calendarMode = _props.calendarMode,
            changeCalendarMode = _props.changeCalendarMode,
            style = _props.style,
            className = _props.className,
            inline = _props.inline,
            icon = _props.icon,
            displayMode = _props.displayMode,
            props = _objectWithoutProperties(_props, ['okLabel', 'okPrimary', 'onOkClick', 'cancelLabel', 'cancelPrimary', 'onCancelClick', 'DateTimeFormat', 'locales', 'calendarTempDate', 'calendarMode', 'changeCalendarMode', 'style', 'className', 'inline', 'icon', 'displayMode']);

        var picker = void 0;
        if (calendarMode === 'calendar') {
          picker = _react2.default.createElement(_DatePickerCalendar2.default, _extends({}, props, {
            key: 'calendar',
            calendarTempDate: calendarTempDate,
            DateTimeFormat: DateTimeFormat,
            locales: locales
          }));
        } else {
          picker = _react2.default.createElement(_YearPicker2.default, _extends({}, props, {
            key: 'year',
            calendarTempDate: calendarTempDate,
            DateTimeFormat: DateTimeFormat,
            locales: locales
          }));
        }

        var actions = [{
          key: 'cancel',
          onClick: onCancelClick,
          primary: cancelPrimary,
          secondary: !cancelPrimary,
          label: cancelLabel
        }, {
          key: 'ok',
          onClick: onOkClick,
          primary: okPrimary,
          secondary: !okPrimary,
          label: okLabel
        }];

        return _react2.default.createElement(
          'div',
          {
            style: style,
            className: (0, _classnames2.default)('md-picker md-picker--date', (_cn = {}, _defineProperty(_cn, 'md-picker--' + displayMode, displayMode), _defineProperty(_cn, 'md-picker--inline', inline), _defineProperty(_cn, 'md-picker--inline-icon', inline && icon), _cn), className)
          },
          _react2.default.createElement(_DatePickerHeader2.default, {
            DateTimeFormat: DateTimeFormat,
            locales: locales,
            calendarTempDate: calendarTempDate,
            calendarMode: calendarMode,
            changeCalendarMode: changeCalendarMode
          }),
          _react2.default.createElement(
            'div',
            { className: 'md-picker-content-container' },
            picker,
            _react2.default.createElement(_DialogFooter2.default, { actions: actions })
          )
        );
      }
    }]);

    return DatePicker;
  }(_react.PureComponent);

  DatePicker.propTypes = {
    style: _propTypes2.default.object,
    className: _propTypes2.default.string,
    okLabel: _propTypes2.default.node.isRequired,
    okPrimary: _propTypes2.default.bool.isRequired,
    onOkClick: _propTypes2.default.func.isRequired,
    cancelLabel: _propTypes2.default.node.isRequired,
    cancelPrimary: _propTypes2.default.bool.isRequired,
    onCancelClick: _propTypes2.default.func.isRequired,
    DateTimeFormat: _propTypes2.default.func.isRequired,
    locales: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,
    calendarDate: _propTypes2.default.instanceOf(Date).isRequired,
    calendarTempDate: _propTypes2.default.instanceOf(Date).isRequired,
    calendarMode: _propTypes2.default.oneOf(['calendar', 'year']).isRequired,
    changeCalendarMode: _propTypes2.default.func.isRequired,
    icon: _propTypes2.default.bool,
    inline: _propTypes2.default.bool,
    displayMode: _propTypes2.default.oneOf(['landscape', 'portrait'])
  };
  exports.default = DatePicker;
});

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(1139), __webpack_require__(1138)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('./CalendarMonth'), require('./CalendarHeader'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.CalendarMonth, global.CalendarHeader);
    global.DatePickerCalendar = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _CalendarMonth, _CalendarHeader) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _CalendarMonth2 = _interopRequireDefault(_CalendarMonth);

  var _CalendarHeader2 = _interopRequireDefault(_CalendarHeader);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var DatePickerCalendar = function (_PureComponent) {
    _inherits(DatePickerCalendar, _PureComponent);

    function DatePickerCalendar() {
      _classCallCheck(this, DatePickerCalendar);

      return _possibleConstructorReturn(this, (DatePickerCalendar.__proto__ || Object.getPrototypeOf(DatePickerCalendar)).apply(this, arguments));
    }

    _createClass(DatePickerCalendar, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            previousIconChildren = _props.previousIconChildren,
            previousIconClassName = _props.previousIconClassName,
            onPreviousClick = _props.onPreviousClick,
            nextIconChildren = _props.nextIconChildren,
            nextIconClassName = _props.nextIconClassName,
            onNextClick = _props.onNextClick,
            calendarDate = _props.calendarDate,
            calendarTempDate = _props.calendarTempDate,
            onCalendarDateClick = _props.onCalendarDateClick,
            DateTimeFormat = _props.DateTimeFormat,
            locales = _props.locales,
            minDate = _props.minDate,
            maxDate = _props.maxDate;


        return _react2.default.createElement(
          'section',
          { className: 'md-picker-content md-picker-content--calendar' },
          _react2.default.createElement(_CalendarHeader2.default, {
            date: calendarDate,
            minDate: minDate,
            maxDate: maxDate,
            DateTimeFormat: DateTimeFormat,
            locales: locales,
            onPreviousClick: onPreviousClick,
            previousIconChildren: previousIconChildren,
            previousIconClassName: previousIconClassName,
            onNextClick: onNextClick,
            nextIconChildren: nextIconChildren,
            nextIconClassName: nextIconClassName
          }),
          _react2.default.createElement(_CalendarMonth2.default, {
            key: new DateTimeFormat(locales).format(calendarDate),
            calendarDate: calendarDate,
            calendarTempDate: calendarTempDate,
            onCalendarDateClick: onCalendarDateClick,
            minDate: minDate,
            maxDate: maxDate,
            DateTimeFormat: DateTimeFormat,
            locales: locales
          })
        );
      }
    }]);

    return DatePickerCalendar;
  }(_react.PureComponent);

  DatePickerCalendar.propTypes = {
    previousIconChildren: _propTypes2.default.node,
    previousIconClassName: _propTypes2.default.string,
    onPreviousClick: _propTypes2.default.func.isRequired,
    nextIconChildren: _propTypes2.default.node,
    nextIconClassName: _propTypes2.default.string,
    onNextClick: _propTypes2.default.func.isRequired,
    onCalendarDateClick: _propTypes2.default.func.isRequired,
    calendarDate: _propTypes2.default.instanceOf(Date).isRequired,
    calendarTempDate: _propTypes2.default.instanceOf(Date).isRequired,
    DateTimeFormat: _propTypes2.default.func.isRequired,
    locales: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,
    minDate: _propTypes2.default.instanceOf(Date),
    maxDate: _propTypes2.default.instanceOf(Date)
  };
  exports.default = DatePickerCalendar;
});

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(17), __webpack_require__(12), __webpack_require__(14), __webpack_require__(16), __webpack_require__(119), __webpack_require__(118), __webpack_require__(20), __webpack_require__(1189), __webpack_require__(266), __webpack_require__(583), __webpack_require__(62), __webpack_require__(28), __webpack_require__(84), __webpack_require__(248), __webpack_require__(1143)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('react-prop-types/lib/isRequiredForA11y'), require('react-prop-types/lib/deprecated'), require('../constants/keyCodes'), require('../utils/getField'), require('../utils/EventUtils/handleWindowClickListeners'), require('../utils/EventUtils/handleKeyboardAccessibility'), require('../utils/PropTypes/controlled'), require('../utils/DateUtils/isDateEqual'), require('../utils/DateUtils/addDate'), require('../utils/DateUtils/DateTimeFormat'), require('../Helpers/Collapse'), require('../FontIcons/FontIcon'), require('../TextFields/TextField'), require('../Dialogs/DialogContainer'), require('./DatePicker'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.isRequiredForA11y, global.deprecated, global.keyCodes, global.getField, global.handleWindowClickListeners, global.handleKeyboardAccessibility, global.controlled, global.isDateEqual, global.addDate, global.DateTimeFormat, global.Collapse, global.FontIcon, global.TextField, global.DialogContainer, global.DatePicker);
    global.DatePickerContainer = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _isRequiredForA11y, _deprecated, _keyCodes, _getField, _handleWindowClickListeners, _handleKeyboardAccessibility, _controlled, _isDateEqual, _addDate, _DateTimeFormat, _Collapse, _FontIcon, _TextField, _DialogContainer, _DatePicker) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);

  var _deprecated2 = _interopRequireDefault(_deprecated);

  var _getField2 = _interopRequireDefault(_getField);

  var _handleWindowClickListeners2 = _interopRequireDefault(_handleWindowClickListeners);

  var _handleKeyboardAccessibility2 = _interopRequireDefault(_handleKeyboardAccessibility);

  var _controlled2 = _interopRequireDefault(_controlled);

  var _isDateEqual2 = _interopRequireDefault(_isDateEqual);

  var _addDate2 = _interopRequireDefault(_addDate);

  var _DateTimeFormat2 = _interopRequireDefault(_DateTimeFormat);

  var _Collapse2 = _interopRequireDefault(_Collapse);

  var _FontIcon2 = _interopRequireDefault(_FontIcon);

  var _TextField2 = _interopRequireDefault(_TextField);

  var _DialogContainer2 = _interopRequireDefault(_DialogContainer);

  var _DatePicker2 = _interopRequireDefault(_DatePicker);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var DatePickerContainer = function (_PureComponent) {
    _inherits(DatePickerContainer, _PureComponent);

    function DatePickerContainer(props) {
      _classCallCheck(this, DatePickerContainer);

      var _this = _possibleConstructorReturn(this, (DatePickerContainer.__proto__ || Object.getPrototypeOf(DatePickerContainer)).call(this, props));

      var date = void 0;
      var value = void 0;
      var defaultValue = props.defaultValue,
          DateTimeFormat = props.DateTimeFormat,
          locales = props.locales,
          formatOptions = props.formatOptions,
          initialCalendarDate = props.initialCalendarDate,
          minDate = props.minDate,
          maxDate = props.maxDate;

      if (typeof props.value !== 'undefined' && props.value !== null) {
        date = typeof props.value === 'string' ? new Date(props.value) : props.value;
      } else if (defaultValue) {
        date = typeof defaultValue === 'string' ? new Date(defaultValue) : defaultValue;
        value = typeof defaultValue === 'string' ? defaultValue : DateTimeFormat(locales, formatOptions).format(defaultValue);
      } else {
        date = new Date();
      }

      date = _this._validateDateRange(date, minDate, maxDate);

      var calendarTempDate = date;
      if (typeof initialCalendarDate !== 'undefined' && !props.value && !props.defaultValue) {
        calendarTempDate = typeof initialCalendarDate === 'string' ? new Date(initialCalendarDate) : initialCalendarDate;
        date = calendarTempDate;
      } else if (calendarTempDate === null) {
        calendarTempDate = new Date();
        date = new Date();
      }

      var visible = typeof props.initiallyOpen !== 'undefined' ? props.initiallyOpen : !!props.defaultVisible;

      _this.state = {
        value: value,
        visible: visible,
        calendarDate: date,
        calendarTempDate: calendarTempDate,
        calendarMode: props.initialCalendarMode || props.defaultCalendarMode
      };

      _this._setContainer = _this._setContainer.bind(_this);
      _this._toggleOpen = _this._toggleOpen.bind(_this);
      _this._closeOnEsc = _this._closeOnEsc.bind(_this);
      _this._handleOutsideClick = _this._handleOutsideClick.bind(_this);
      _this._handleOkClick = _this._handleOkClick.bind(_this);
      _this._handleCancelClick = _this._handleCancelClick.bind(_this);
      _this._changeCalendarMode = _this._changeCalendarMode.bind(_this);
      _this._nextMonth = _this._nextMonth.bind(_this);
      _this._previousMonth = _this._previousMonth.bind(_this);
      _this._setCalendarTempDate = _this._setCalendarTempDate.bind(_this);
      _this._setCalendarTempYear = _this._setCalendarTempYear.bind(_this);
      _this._validateDateRange = _this._validateDateRange.bind(_this);
      _this._handleKeyDown = _this._handleKeyDown.bind(_this);
      return _this;
    }

    _createClass(DatePickerContainer, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var value = nextProps.value,
            minDate = nextProps.minDate,
            maxDate = nextProps.maxDate;

        var minEqual = (0, _isDateEqual2.default)(this.props.minDate, minDate);
        var maxEqual = (0, _isDateEqual2.default)(this.props.maxDate, maxDate);
        if (this.props.value !== value || !minEqual || !maxEqual) {
          var calendarDate = this.state.calendarDate;

          if (typeof value !== 'undefined') {
            calendarDate = typeof value === 'string' ? new Date(value) : value;
          }

          calendarDate = this._validateDateRange(calendarDate, minDate, maxDate);

          if (!(0, _isDateEqual2.default)(this.state.calendarDate, calendarDate)) {
            this.setState({ calendarDate: calendarDate, calendarTempDate: calendarDate });
          }
        }
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps, prevState) {
        var _props = this.props,
            inline = _props.inline,
            isOpen = _props.isOpen;

        var visible = typeof isOpen !== 'undefined' ? isOpen : (0, _getField2.default)(this.props, this.state, 'visible');
        var pVisible = typeof prevProps.isOpen !== 'undefined' ? prevProps.isOpen : (0, _getField2.default)(prevProps, prevState, 'visible');

        if (visible === pVisible) {
          return;
        }

        if (visible) {
          if (inline) {
            (0, _handleWindowClickListeners2.default)(this._handleOutsideClick, true);
            window.addEventListener('keydown', this._closeOnEsc);
          }
        } else if (inline) {
          (0, _handleWindowClickListeners2.default)(this._handleOutsideClick, false);
          window.removeEventListener('keydown', this._closeOnEsc);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var visible = typeof this.props.isOpen !== 'undefined' ? this.props.isOpen : (0, _getField2.default)(this.props, this.state, 'visible');

        if (visible && this.props.inline) {
          (0, _handleWindowClickListeners2.default)(this._handleOutsideClick, false);
          window.removeEventListener('keydown', this._closeOnEsc);
        }
      }
    }, {
      key: '_setContainer',
      value: function _setContainer(container) {
        this._container = container;
      }
    }, {
      key: '_closeOnEsc',
      value: function _closeOnEsc(e) {
        if ((e.which || e.keyCode) === _keyCodes.ESC) {
          this._handleCancelClick(e);
        }
      }
    }, {
      key: '_handleOutsideClick',
      value: function _handleOutsideClick(e) {
        if (this._container && !this._container.contains(e.target)) {
          this._handleCancelClick(e);
        }
      }
    }, {
      key: '_toggleOpen',
      value: function _toggleOpen(e) {
        if (this.props.disabled || this.props.readOnly) {
          return;
        }

        var visible = !(typeof this.props.isOpen !== 'undefined' ? this.props.isOpen : (0, _getField2.default)(this.props, this.state, 'visible'));

        if (this.props.onVisibilityChange) {
          this.props.onVisibilityChange(visible, e);
        }

        if (typeof this.props.isOpen === 'undefined' && typeof this.props.visible === 'undefined') {
          this.setState({ visible: visible });
        }
      }
    }, {
      key: '_handleKeyDown',
      value: function _handleKeyDown(e) {
        (0, _handleKeyboardAccessibility2.default)(e, this._toggleOpen, true, true);

        if ((e.which || e.keyCode) === _keyCodes.TAB && this.state.active) {
          this.setState({ active: false });
        }
      }
    }, {
      key: '_handleOkClick',
      value: function _handleOkClick(e) {
        var _props2 = this.props,
            DateTimeFormat = _props2.DateTimeFormat,
            locales = _props2.locales,
            onChange = _props2.onChange,
            formatOptions = _props2.formatOptions,
            onVisibilityChange = _props2.onVisibilityChange;

        var value = DateTimeFormat(locales, formatOptions).format(this.state.calendarTempDate);
        if (onChange) {
          onChange(value, new Date(this.state.calendarTempDate), e);
        }

        if (onVisibilityChange) {
          onVisibilityChange(false, e);
        }

        var state = void 0;
        if (typeof this.props.value === 'undefined') {
          state = { value: value };
        }

        if (typeof this.props.visible === 'undefined' && typeof this.props.isOpen === 'undefined') {
          state = state || {};
          state.visible = false;
        }

        if (state) {
          this.setState(state);
        }
      }
    }, {
      key: '_handleCancelClick',
      value: function _handleCancelClick(e) {
        var state = { calendarTempDate: this.state.calendarDate };
        if (typeof this.props.isOpen === 'undefined' && typeof this.props.isOpen === 'undefined') {
          state.visible = false;
        }

        if (this.props.onVisibilityChange) {
          this.props.onVisibilityChange(false, e);
        }

        this.setState(state);
      }
    }, {
      key: '_changeCalendarMode',
      value: function _changeCalendarMode(calendarMode) {
        if (this.state.calendarMode === calendarMode) {
          return;
        }

        this.setState({ calendarMode: calendarMode });
      }
    }, {
      key: '_previousMonth',
      value: function _previousMonth() {
        var calendarDate = (0, _addDate2.default)(this.state.calendarDate, -1, 'M');
        this.setState({ calendarDate: calendarDate });
      }
    }, {
      key: '_nextMonth',
      value: function _nextMonth() {
        var calendarDate = (0, _addDate2.default)(this.state.calendarDate, 1, 'M');
        this.setState({ calendarDate: calendarDate });
      }
    }, {
      key: '_setCalendarTempDate',
      value: function _setCalendarTempDate(calendarTempDate) {
        var _this2 = this;

        var _props3 = this.props,
            autoOk = _props3.autoOk,
            DateTimeFormat = _props3.DateTimeFormat,
            locales = _props3.locales,
            onChange = _props3.onChange,
            formatOptions = _props3.formatOptions;


        var state = { calendarTempDate: calendarTempDate };
        if (autoOk) {
          var value = DateTimeFormat(locales, formatOptions).format(calendarTempDate);
          if (onChange) {
            onChange(value, new Date(calendarTempDate));
          }

          if (typeof this.props.value === 'undefined') {
            state.value = value;
          }

          this._timeout = setTimeout(function () {
            _this2._timeout = null;

            if (_this2.props.onVisibilityChange) {
              _this2.props.onVisibilityChange(false);
            }

            if (typeof _this2.props.visible === 'undefined' && typeof _this2.props.isOpen === 'undefined') {
              _this2.setState({ visible: false });
            }
          });
        }
        this.setState(state);
      }
    }, {
      key: '_setCalendarTempYear',
      value: function _setCalendarTempYear(year) {
        var _state = this.state,
            calendarTempDate = _state.calendarTempDate,
            calendarDate = _state.calendarDate;

        if (calendarTempDate.getFullYear() === year) {
          return;
        }

        var _props4 = this.props,
            minDate = _props4.minDate,
            maxDate = _props4.maxDate;

        var nextDate = new Date(calendarDate.setFullYear(year));
        var nextTemp = new Date(calendarTempDate.setFullYear(year));

        if (minDate && nextTemp < minDate) {
          nextDate = new Date(minDate);
          nextTemp = new Date(minDate);
        }

        if (maxDate && nextTemp > maxDate) {
          nextDate = new Date(maxDate);
          nextTemp = new Date(maxDate);
        }

        this.setState({
          calendarDate: nextDate,
          calendarTempDate: nextTemp
        });
      }
    }, {
      key: '_getFormattedValue',
      value: function _getFormattedValue(props, state) {
        var DateTimeFormat = props.DateTimeFormat,
            locales = props.locales,
            formatOptions = props.formatOptions;

        var value = (0, _getField2.default)(props, state, 'value');
        if (!value) {
          return '';
        } else if (value instanceof Date) {
          return DateTimeFormat(locales, formatOptions).format(new Date(value));
        } else {
          return value;
        }
      }
    }, {
      key: '_validateDateRange',
      value: function _validateDateRange(calendarDate, minDate, maxDate) {
        var date = calendarDate;
        if (minDate && minDate > calendarDate) {
          date = new Date(minDate);
        }

        if (maxDate && maxDate < calendarDate) {
          date = new Date(maxDate);
        }

        return date;
      }
    }, {
      key: 'render',
      value: function render() {
        var _props5 = this.props,
            style = _props5.style,
            className = _props5.className,
            pickerStyle = _props5.pickerStyle,
            pickerClassName = _props5.pickerClassName,
            inputStyle = _props5.inputStyle,
            inputClassName = _props5.inputClassName,
            textFieldStyle = _props5.textFieldStyle,
            textFieldClassName = _props5.textFieldClassName,
            label = _props5.label,
            placeholder = _props5.placeholder,
            icon = _props5.icon,
            inline = _props5.inline,
            displayMode = _props5.displayMode,
            fullWidth = _props5.fullWidth,
            lineDirection = _props5.lineDirection,
            id = _props5.id,
            disabled = _props5.disabled,
            closeOnEsc = _props5.closeOnEsc,
            renderNode = _props5.renderNode,
            lastChild = _props5.lastChild,
            block = _props5.block,
            paddedBlock = _props5.paddedBlock,
            active = _props5.active,
            error = _props5.error,
            floating = _props5.floating,
            required = _props5.required,
            leftIconStateful = _props5.leftIconStateful,
            rightIcon = _props5.rightIcon,
            rightIconStateful = _props5.rightIconStateful,
            customSize = _props5.customSize,
            errorText = _props5.errorText,
            helpText = _props5.helpText,
            helpOnFocus = _props5.helpOnFocus,
            inlineIndicator = _props5.inlineIndicator,
            ariaLabel = _props5['aria-label'],
            isOpen = _props5.isOpen,
            props = _objectWithoutProperties(_props5, ['style', 'className', 'pickerStyle', 'pickerClassName', 'inputStyle', 'inputClassName', 'textFieldStyle', 'textFieldClassName', 'label', 'placeholder', 'icon', 'inline', 'displayMode', 'fullWidth', 'lineDirection', 'id', 'disabled', 'closeOnEsc', 'renderNode', 'lastChild', 'block', 'paddedBlock', 'active', 'error', 'floating', 'required', 'leftIconStateful', 'rightIcon', 'rightIconStateful', 'customSize', 'errorText', 'helpText', 'helpOnFocus', 'inlineIndicator', 'aria-label', 'isOpen']);

        delete props.value;
        delete props.onChange;
        delete props.visible;
        delete props.readOnly;
        delete props.onVisibilityToggle;
        delete props.defaultValue;
        delete props.defaultVisible;

        // Delete deprecated
        delete props.initiallyOpen;
        delete props.adjustMinWidth;
        delete props.nextIcon;
        delete props.previousIcon;

        var visible = typeof isOpen !== 'undefined' ? isOpen : (0, _getField2.default)(this.props, this.state, 'visible');

        var picker = _react2.default.createElement(_DatePicker2.default, _extends({}, this.state, props, {
          icon: !!icon,
          inline: inline,
          style: pickerStyle,
          className: pickerClassName,
          displayMode: displayMode,
          onCancelClick: this._handleCancelClick,
          onOkClick: this._handleOkClick,
          changeCalendarMode: this._changeCalendarMode,
          onPreviousClick: this._previousMonth,
          onNextClick: this._nextMonth,
          onCalendarDateClick: this._setCalendarTempDate,
          onCalendarYearClick: this._setCalendarTempYear
        }));

        var content = void 0;
        if (inline) {
          content = _react2.default.createElement(
            _Collapse2.default,
            { collapsed: !visible },
            picker
          );
        } else {
          content = _react2.default.createElement(
            _DialogContainer2.default,
            {
              id: id + 'Dialog',
              visible: visible,
              onHide: this._handleCancelClick,
              dialogClassName: 'md-dialog--picker',
              contentClassName: 'md-dialog-content--picker',
              'aria-label': ariaLabel,
              closeOnEsc: closeOnEsc,
              renderNode: renderNode,
              lastChild: lastChild,
              focusOnMount: false
            },
            picker
          );
        }

        return _react2.default.createElement(
          'div',
          { style: style, className: (0, _classnames2.default)('md-picker-container', className), ref: this._setContainer },
          _react2.default.createElement(_TextField2.default, {
            id: id,
            style: textFieldStyle,
            className: (0, _classnames2.default)({ 'md-pointer--hover': !disabled }, textFieldClassName),
            inputStyle: inputStyle,
            inputClassName: (0, _classnames2.default)({ 'md-pointer--hover': !disabled }, inputClassName),
            active: active || visible,
            error: error,
            floating: floating || visible,
            required: required,
            disabled: disabled,
            leftIcon: icon,
            leftIconStateful: leftIconStateful,
            rightIcon: rightIcon,
            rightIconStateful: rightIconStateful,
            inlineIndicator: inlineIndicator,
            block: block,
            paddedBlock: paddedBlock,
            fullWidth: fullWidth,
            lineDirection: lineDirection,
            customSize: customSize,
            helpText: helpText,
            helpOnFocus: helpOnFocus,
            errorText: errorText,
            label: label,
            placeholder: placeholder,
            onClick: this._toggleOpen,
            onKeyDown: this._handleKeyDown,
            value: this._getFormattedValue(this.props, this.state),
            readOnly: true
          }),
          content
        );
      }
    }]);

    return DatePickerContainer;
  }(_react.PureComponent);

  DatePickerContainer.propTypes = {
    /**
     * An id for the text field in the date picker. This is require for a11u.
     */
    id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),

    /**
     * An aria label for the dialog. This is required for a11y.
     */
    'aria-label': (0, _isRequiredForA11y2.default)(_propTypes2.default.string),

    /**
     * An optional style to apply to the date picker's container.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply to the date picker's container.
     */
    className: _propTypes2.default.string,

    /**
     * An optional style to apply to the date picker.
     */
    pickerStyle: _propTypes2.default.object,

    /**
     * An optional className to apply to the date picker.
     */
    pickerClassName: _propTypes2.default.string,

    /**
     * An optional style to apply to the input tag.
     */
    inputStyle: _propTypes2.default.object,

    /**
     * An optional className to apply to the input tag.
     */
    inputClassName: _propTypes2.default.string,

    /**
     * An optional style to apply to the text field's container.
     */
    textFieldStyle: _propTypes2.default.object,

    /**
     * An optional className to apply to the text field's container.
     */
    textFieldClassName: _propTypes2.default.string,

    /**
     * An optional icon to display with the date picker.
     */
    icon: _propTypes2.default.node,

    /**
     * Boolean if the date picker is open by default.
     */
    defaultVisible: _propTypes2.default.bool,

    /**
     * An optional label to be displayed in the date picker's text
     * field.
     */
    label: _propTypes2.default.node,

    /**
     * An optional placeholder to be displayed in the date picker's text field.
     */
    placeholder: _propTypes2.default.string,

    /**
     * The value of the date picker. This will make the date picker
     * be a controlled component. This value should either be a
     * formatted date string or a date object.
     */
    value: (0, _controlled2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]), 'onChange', 'defaultValue'),

    /**
     * An optional default value to give for the date picker. This should
     * either be a formatted date string or a date object.
     */
    defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]),

    /**
     * An optional date to use when the calendar is opened for the first time.
     * If this is omitted, it will either be the `defaultValue`, `value`, or
     * today.
     */
    initialCalendarDate: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]),

    /**
     * An optional function to call when the selected date is changed
     * by hitting the OK button. The newly formatted date string,
     * the new Date object, and the change event will be given.
     *
     * `onChange(dateString, dateObject, event)`.
     */
    onChange: _propTypes2.default.func,

    /**
     * A function to format the dates since it should be formatted to the user's
     * locale. This _should_ be the `Intl.DateTimeFormat` function. You
     * can also create your own if you really wanted. Unadvisable though.
     *
     * See [intl-polyfill](https://github.com/andyearnshaw/Intl.js/) for more info.
     */
    DateTimeFormat: _propTypes2.default.func.isRequired,

    /**
     * The locales to use for formatting the date. This will default to using
     * the user's language in the browser or `'en-US'` when server renering.
     */
    locales: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,

    /**
     * The label to use for the ok button on the date picker.
     */
    okLabel: _propTypes2.default.node.isRequired,

    /**
     * Boolean if the ok button should be styled with the primary color.
     */
    okPrimary: _propTypes2.default.bool,

    /**
     * The label to use for the cancel button on the date picker.
     */
    cancelLabel: _propTypes2.default.node.isRequired,

    /**
     * Boolean if the cancel button should be styled with the primary color.
     */
    cancelPrimary: _propTypes2.default.bool,

    /**
     * The initial mode to open the calendar in.
     */
    defaultCalendarMode: _propTypes2.default.oneOf(['calendar', 'year']),

    /**
     * Any children used to render the previous icon button in the calendar.
     */
    previousIconChildren: _propTypes2.default.node,

    /**
     * The icon className to use to render the previous icon button in the calendar.
     */
    previousIconClassName: _propTypes2.default.string,

    /**
     * Any children used to render the next icon button in the calendar.
     */
    nextIconChildren: _propTypes2.default.node,

    /**
     * The icon className to use to render the next icon button in the calendar.
     */
    nextIconClassName: _propTypes2.default.string,

    /**
     * An optional min date to use for the date picker. This will prevent
     * any dates before this time to be chosen.
     */
    minDate: _propTypes2.default.instanceOf(Date),

    /**
     * An optional max date to use for the date picker. This will prevent
     * any dates after this time to be chosen.
     */
    maxDate: function maxDate(props, propName, component) {
      for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        others[_key - 3] = arguments[_key];
      }

      var err = _propTypes2.default.instanceOf(Date).apply(undefined, [props, propName, component].concat(others));
      if (err || !props.minDate || !props[propName]) {
        return err;
      }

      var minDate = props.minDate,
          maxDate = props.maxDate;

      if (minDate > maxDate) {
        return new Error('The min date: \'' + minDate + '\' is greater than the max date: \'' + maxDate + '\'');
      }

      return null;
    },

    /**
     * Boolean if the date should automatically be selected when a user clicks
     * on a new date instead of making them hit the ok button.
     */
    autoOk: _propTypes2.default.bool,

    /**
     * The number of years to display.
     */
    yearsDisplayed: _propTypes2.default.number,

    /**
     * Boolean if the date picker should be displayed inline instead of in a
     * dialog.
     */
    inline: _propTypes2.default.bool,

    /**
     * An optional force of the display mode of the date picker.
     * This _should_ not really be used since there are media queries
     * to use the correct mode based on device orientation.
     */
    displayMode: _propTypes2.default.oneOf(['landscape', 'portrait']),

    /**
     * The DateTimeFormat options to apply to format the date.
     */
    formatOptions: _propTypes2.default.shape({
      weekday: _propTypes2.default.oneOf(['narrow', 'short', 'long']),
      era: _propTypes2.default.oneOf(['narrow', 'short', 'long']),
      year: _propTypes2.default.oneOf(['numeric', '2-digit']),
      month: _propTypes2.default.oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
      day: _propTypes2.default.oneOf(['numeric', '2-digit']),
      hour: _propTypes2.default.oneOf(['numeric', '2-digit']),
      minute: _propTypes2.default.oneOf(['numeric', '2-digit']),
      second: _propTypes2.default.oneOf(['numeric', '2-digit']),
      timeZoneName: _propTypes2.default.oneOf(['short', 'long'])
    }),

    /**
     * Boolean if the text field for the Date Picker should be displayed as full width.
     */
    fullWidth: _propTypes2.default.bool,

    /**
     * The direction that the text field divider expands from when the text field
     * in the date picker gains focus.
     */
    lineDirection: _propTypes2.default.oneOf(['left', 'center', 'right']),

    /**
     * An optional boolean if the time picker is current visible by dialog or inline.
     * If this is set, the `onOpenToggle` function is required.
     */
    visible: (0, _controlled2.default)(_propTypes2.default.bool, 'onVisibilityChange', 'defaultVisible'),

    /**
     * An optional function to call when the date picker is opened in either a dialog, or
     * inline. The callback will include the next state.
     *
     * ```js
     * onVisibilityChange(!visible, e);
     * ```
     */
    onVisibilityChange: _propTypes2.default.func,

    /**
     * Boolean if the time picker is disabled.
     */
    disabled: _propTypes2.default.bool,

    /**
     * Boolean if the dialog should be able to close if a keyboard user presses the escape key.
     */
    closeOnEsc: _propTypes2.default.bool,

    /**
     * Boolean if the time is required.
     *
     * @see [TextField](/components/text-fields?tab=1)
     */
    required: _propTypes2.default.bool,

    /**
     * @see [TextField](/components/text-fields?tab=1)
     */
    block: _TextField2.default.propTypes.block,

    /**
     * @see [TextField](/components/text-fields?tab=1)
     */
    paddedBlock: _TextField2.default.propTypes.paddedBlock,

    /**
     * @see [TextField](/components/text-fields?tab=1)
     */
    active: _TextField2.default.propTypes.active,

    /**
     * @see [TextField](/components/text-fields?tab=1)
     */
    error: _TextField2.default.propTypes.error,

    /**
     * @see [TextField](/components/text-fields?tab=1)
     */
    floating: _TextField2.default.propTypes.floating,

    /**
     * @see [TextField](/components/text-fields?tab=1)
     */
    leftIconStateful: _TextField2.default.propTypes.leftIconStateful,

    /**
     * @see [TextField](/components/text-fields?tab=1)
     */
    rightIcon: _TextField2.default.propTypes.rightIcon,

    /**
     * @see [TextField](/components/text-fields?tab=1)
     */
    rightIconStateful: _TextField2.default.propTypes.rightIconStateful,

    /**
     * @see [TextField](/components/text-fields?tab=1)
     */
    customSize: _TextField2.default.propTypes.customSize,

    /**
     * @see [TextField](/components/text-fields?tab=1)
     */
    errorText: _TextField2.default.propTypes.errorText,

    /**
     * @see [TextField](/components/text-fields?tab=1)
     */
    helpText: _TextField2.default.propTypes.helpText,

    /**
     * @see [TextField](/components/text-fields?tab=1)
     */
    helpOnFocus: _TextField2.default.propTypes.helpOnFocus,

    /**
     * @see [TextField](/components/text-fields?tab=1)
     */
    inlineIndicator: _TextField2.default.propTypes.helpOnFocus,

    /**
     * An optional DOM Node to render the dialog into. The default is to render as the first child
     * in the `body`.
     */
    renderNode: _propTypes2.default.object,

    /**
     * Boolean if the DatePicker should be read only. This will prevent the user from opening the picker
     * and only display the current date in the text field.
     */
    readOnly: _propTypes2.default.bool,

    /**
     * Boolean if the dialog should be rendered as the last child of the `renderNode` or `body` instead
     * of the first.
     */
    lastChild: _propTypes2.default.bool,
    previousIcon: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `previousIconChildren` and `previousIconClassName` instead'),
    nextIcon: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `nextIconChildren` and `nextIconClassName` instead'),
    adjustMinWidth: (0, _deprecated2.default)(_propTypes2.default.bool, 'No longer valid for a text field'),
    initiallyOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `defaultVisible` instead'),
    isOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `visible` instead'),
    initialCalendarMode: (0, _deprecated2.default)(_propTypes2.default.oneOf(['calendar', 'year']), 'Use `defaultCalendarMode` instead'),
    initialYearsDisplayed: (0, _deprecated2.default)(_propTypes2.default.number, 'Use `yearsDisplayed` instead. I have not implemented infinite loading years')
  };
  DatePickerContainer.defaultProps = {
    previousIconChildren: 'chevron_left',
    nextIconChildren: 'chevron_right',
    autoOk: false,
    icon: _react2.default.createElement(
      _FontIcon2.default,
      null,
      'date_range'
    ),
    yearsDisplayed: 100,
    defaultCalendarMode: 'calendar',
    DateTimeFormat: _DateTimeFormat2.default, // eslint-disable-line object-shorthand
    locales: typeof window !== 'undefined' ? window.navigator.userLanguage || window.navigator.language : 'en-US',
    okLabel: 'Ok',
    okPrimary: true,
    cancelLabel: 'Cancel',
    cancelPrimary: true,
    closeOnEsc: true,
    'aria-label': 'Pick a date'
  };
  exports.default = DatePickerContainer;
});

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(257)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('./PickerControl'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.PickerControl);
    global.DatePickerHeader = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _PickerControl) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _PickerControl2 = _interopRequireDefault(_PickerControl);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var DatePickerHeader = function (_PureComponent) {
    _inherits(DatePickerHeader, _PureComponent);

    function DatePickerHeader(props) {
      _classCallCheck(this, DatePickerHeader);

      var _this = _possibleConstructorReturn(this, (DatePickerHeader.__proto__ || Object.getPrototypeOf(DatePickerHeader)).call(this, props));

      _this.state = _this._getFormattedDate(props);
      _this._selectYear = _this._selectYear.bind(_this);
      _this._selectCalendar = _this._selectCalendar.bind(_this);
      return _this;
    }

    _createClass(DatePickerHeader, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var _props = this.props,
            DateTimeFormat = _props.DateTimeFormat,
            locales = _props.locales,
            calendarTempDate = _props.calendarTempDate,
            changeCalendarMode = _props.changeCalendarMode;

        if (DateTimeFormat !== nextProps.DateTimeFormat || locales !== nextProps.locales || calendarTempDate !== nextProps.calendarTempDate || changeCalendarMode !== nextProps.changeCalendarMode) {
          this.setState(this._getFormattedDate(nextProps));
        }
      }
    }, {
      key: '_getFormattedDate',
      value: function _getFormattedDate(_ref) {
        var DateTimeFormat = _ref.DateTimeFormat,
            locales = _ref.locales,
            calendarTempDate = _ref.calendarTempDate;

        return {
          year: DateTimeFormat(locales, { year: 'numeric' }).format(calendarTempDate),
          weekday: DateTimeFormat(locales, { weekday: 'short' }).format(calendarTempDate),
          date: DateTimeFormat(locales, { month: 'short', day: '2-digit' }).format(calendarTempDate)
        };
      }
    }, {
      key: '_selectYear',
      value: function _selectYear(e) {
        this.props.changeCalendarMode('year', e);
      }
    }, {
      key: '_selectCalendar',
      value: function _selectCalendar(e) {
        this.props.changeCalendarMode('calendar', e);
      }
    }, {
      key: 'render',
      value: function render() {
        var _state = this.state,
            year = _state.year,
            weekday = _state.weekday,
            date = _state.date;
        var calendarMode = this.props.calendarMode;

        return _react2.default.createElement(
          'header',
          { className: 'md-picker-header' },
          _react2.default.createElement(
            _PickerControl2.default,
            { onClick: this._selectYear, active: calendarMode === 'year' },
            _react2.default.createElement(
              'h6',
              { className: 'md-subheading-1' },
              year
            )
          ),
          _react2.default.createElement(
            _PickerControl2.default,
            { onClick: this._selectCalendar, active: calendarMode === 'calendar' },
            _react2.default.createElement(
              'h4',
              { className: 'md-display-1' },
              weekday + ',',
              '\xA0'
            ),
            _react2.default.createElement(
              'h4',
              { className: 'md-display-1' },
              date
            )
          )
        );
      }
    }]);

    return DatePickerHeader;
  }(_react.PureComponent);

  DatePickerHeader.propTypes = {
    DateTimeFormat: _propTypes2.default.func.isRequired,
    locales: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,
    calendarTempDate: _propTypes2.default.instanceOf(Date).isRequired,
    calendarMode: _propTypes2.default.oneOf(['calendar', 'year']).isRequired,
    changeCalendarMode: _propTypes2.default.func.isRequired
  };
  exports.default = DatePickerHeader;
});

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(1186), __webpack_require__(257)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('../utils/DateUtils/addHours'), require('./PickerControl'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.addHours, global.PickerControl);
    global.TimePeriods = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _addHours, _PickerControl) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _addHours2 = _interopRequireDefault(_addHours);

  var _PickerControl2 = _interopRequireDefault(_PickerControl);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var TimePeriods = function (_PureComponent) {
    _inherits(TimePeriods, _PureComponent);

    function TimePeriods(props) {
      _classCallCheck(this, TimePeriods);

      var _this = _possibleConstructorReturn(this, (TimePeriods.__proto__ || Object.getPrototypeOf(TimePeriods)).call(this, props));

      _this._setAM = _this._setAM.bind(_this);
      _this._setPM = _this._setPM.bind(_this);
      return _this;
    }

    _createClass(TimePeriods, [{
      key: '_setAM',
      value: function _setAM() {
        if (this.props.timePeriod !== 'AM') {
          this.props.setTempTime((0, _addHours2.default)(this.props.tempTime, 12));
        }
      }
    }, {
      key: '_setPM',
      value: function _setPM() {
        if (this.props.timePeriod !== 'PM') {
          this.props.setTempTime((0, _addHours2.default)(this.props.tempTime, -12));
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var timePeriod = this.props.timePeriod;

        return _react2.default.createElement(
          'div',
          { className: 'md-time-periods' },
          _react2.default.createElement(
            _PickerControl2.default,
            { onClick: this._setAM, active: timePeriod === 'AM' },
            _react2.default.createElement(
              'h6',
              { className: 'md-time-period' },
              'AM'
            )
          ),
          _react2.default.createElement(
            _PickerControl2.default,
            { onClick: this._setPM, active: timePeriod === 'PM' },
            _react2.default.createElement(
              'h6',
              { className: 'md-time-period' },
              'PM'
            )
          )
        );
      }
    }]);

    return TimePeriods;
  }(_react.PureComponent);

  TimePeriods.propTypes = {
    /**
     * The current time for the time picker.
     */
    tempTime: _propTypes2.default.instanceOf(Date).isRequired,

    /**
     * A function to update the time for the time picker.
     */
    setTempTime: _propTypes2.default.func.isRequired,

    /**
     * The current time period.
     */
    timePeriod: _propTypes2.default.string.isRequired
  };
  exports.default = TimePeriods;
});

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(1140), __webpack_require__(115), __webpack_require__(1150)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('./ClockFace'), require('../Dialogs/DialogFooter'), require('./TimePickerHeader'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.ClockFace, global.DialogFooter, global.TimePickerHeader);
    global.TimePicker = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _ClockFace, _DialogFooter, _TimePickerHeader) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _ClockFace2 = _interopRequireDefault(_ClockFace);

  var _DialogFooter2 = _interopRequireDefault(_DialogFooter);

  var _TimePickerHeader2 = _interopRequireDefault(_TimePickerHeader);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var TimePicker = function (_PureComponent) {
    _inherits(TimePicker, _PureComponent);

    function TimePicker(props) {
      _classCallCheck(this, TimePicker);

      var _this = _possibleConstructorReturn(this, (TimePicker.__proto__ || Object.getPrototypeOf(TimePicker)).call(this, props));

      _this._updateTime = _this._updateTime.bind(_this);
      return _this;
    }

    /**
     * Takes in the new time (number o'clock or minutes), updates the temp time
     * with that new time, and then calls the setTempTime prop.
     */


    _createClass(TimePicker, [{
      key: '_updateTime',
      value: function _updateTime(newTime) {
        var timePart = newTime;
        var _props = this.props,
            tempTime = _props.tempTime,
            setTempTime = _props.setTempTime,
            timeMode = _props.timeMode,
            timePeriod = _props.timePeriod;

        var time = new Date(tempTime);
        if (timeMode === 'hour') {
          var isAM = timePeriod === 'AM';
          var is12 = timePart === 12;
          if (timePeriod && isAM && is12) {
            timePart = 0;
          } else if (timePeriod && !isAM && !is12) {
            timePart += 12;
          }

          time.setHours(timePart);
        } else {
          time.setMinutes(timePart);
        }

        setTempTime(time);
      }
    }, {
      key: 'render',
      value: function render() {
        var _cn;

        var _props2 = this.props,
            okLabel = _props2.okLabel,
            okPrimary = _props2.okPrimary,
            onOkClick = _props2.onOkClick,
            cancelLabel = _props2.cancelLabel,
            cancelPrimary = _props2.cancelPrimary,
            onCancelClick = _props2.onCancelClick,
            style = _props2.style,
            className = _props2.className,
            setTimeMode = _props2.setTimeMode,
            setTempTime = _props2.setTempTime,
            timeMode = _props2.timeMode,
            tempTime = _props2.tempTime,
            hours = _props2.hours,
            minutes = _props2.minutes,
            timePeriod = _props2.timePeriod,
            displayMode = _props2.displayMode,
            inline = _props2.inline,
            icon = _props2.icon;


        var hoursInt = parseInt(hours, 10);
        var minutesInt = parseInt(minutes.replace(/[^0-9]/g, ''), 10);
        var actions = [{
          key: 'cancel',
          onClick: onCancelClick,
          primary: cancelPrimary,
          secondary: !cancelPrimary,
          label: cancelLabel
        }, {
          key: 'ok',
          onClick: onOkClick,
          primary: okPrimary,
          secondary: !okPrimary,
          label: okLabel
        }];

        return _react2.default.createElement(
          'div',
          {
            style: style,
            className: (0, _classnames2.default)('md-picker md-picker--time', (_cn = {}, _defineProperty(_cn, 'md-picker--' + displayMode, displayMode), _defineProperty(_cn, 'md-picker--inline', inline), _defineProperty(_cn, 'md-picker--inline-icon', inline && icon), _cn), className)
          },
          _react2.default.createElement(_TimePickerHeader2.default, {
            tempTime: tempTime,
            timeMode: timeMode,
            setTimeMode: setTimeMode,
            setTempTime: setTempTime,
            hours: hours,
            minutes: minutes,
            timePeriod: timePeriod
          }),
          _react2.default.createElement(
            'div',
            { className: 'md-picker-content-container' },
            _react2.default.createElement(
              'div',
              { className: 'md-picker-content md-picker-content--clock' },
              _react2.default.createElement(_ClockFace2.default, {
                time: timeMode === 'hour' ? hoursInt : minutesInt,
                minutes: timeMode === 'minute',
                onChange: this._updateTime,
                timePeriod: timePeriod
              })
            ),
            _react2.default.createElement(_DialogFooter2.default, { actions: actions })
          )
        );
      }
    }]);

    return TimePicker;
  }(_react.PureComponent);

  TimePicker.propTypes = {
    style: _propTypes2.default.object,
    className: _propTypes2.default.string,
    okLabel: _propTypes2.default.node.isRequired,
    okPrimary: _propTypes2.default.bool.isRequired,
    onOkClick: _propTypes2.default.func.isRequired,
    cancelLabel: _propTypes2.default.node.isRequired,
    cancelPrimary: _propTypes2.default.bool.isRequired,
    onCancelClick: _propTypes2.default.func.isRequired,
    DateTimeFormat: _propTypes2.default.func.isRequired,
    locales: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,
    icon: _propTypes2.default.bool,
    inline: _propTypes2.default.bool,
    displayMode: _propTypes2.default.oneOf(['landscape', 'portrait']),

    /**
     * A function that will switch the state from hour to minute.
     */
    setTimeMode: _propTypes2.default.func.isRequired,

    /**
     * A function that will update the time for the TimePicker before
     * the user selects ok. This function will be given a new Date object
     * with a modified time.
     */
    setTempTime: _propTypes2.default.func.isRequired,

    /**
     * The current display mode of the time picker.
     */
    timeMode: _propTypes2.default.oneOf(['hour', 'minute']).isRequired,

    /**
     * The current time as a date object that is being displayed in the
     * time picker.
     */
    tempTime: _propTypes2.default.instanceOf(Date).isRequired,

    /**
     * A string that is a representation of the hours in the user's locale.
     */
    hours: _propTypes2.default.string.isRequired,

    /**
     * A string that is a representation of the minutes in the user's locale.
     * This will also include any separator the locale uses.
     *
     * Example: ':15' in '3:15 PM' for 'en-US'
     */
    minutes: _propTypes2.default.string.isRequired,

    /**
     * An optional time period if a user's locale uses it.
     */
    timePeriod: _propTypes2.default.string
  };
  exports.default = TimePicker;
});

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(17), __webpack_require__(12), __webpack_require__(14), __webpack_require__(16), __webpack_require__(119), __webpack_require__(118), __webpack_require__(20), __webpack_require__(583), __webpack_require__(584), __webpack_require__(1187), __webpack_require__(248), __webpack_require__(28), __webpack_require__(84), __webpack_require__(62), __webpack_require__(1148)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('react-prop-types/lib/isRequiredForA11y'), require('react-prop-types/lib/deprecated'), require('../constants/keyCodes'), require('../utils/getField'), require('../utils/EventUtils/handleWindowClickListeners'), require('../utils/EventUtils/handleKeyboardAccessibility'), require('../utils/PropTypes/controlled'), require('../utils/DateUtils/DateTimeFormat'), require('../utils/DateUtils/formatTime'), require('../utils/DateUtils/extractTimeParts'), require('../Dialogs/DialogContainer'), require('../FontIcons/FontIcon'), require('../TextFields/TextField'), require('../Helpers/Collapse'), require('./TimePicker'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.isRequiredForA11y, global.deprecated, global.keyCodes, global.getField, global.handleWindowClickListeners, global.handleKeyboardAccessibility, global.controlled, global.DateTimeFormat, global.formatTime, global.extractTimeParts, global.DialogContainer, global.FontIcon, global.TextField, global.Collapse, global.TimePicker);
    global.TimePickerContainer = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _isRequiredForA11y, _deprecated, _keyCodes, _getField, _handleWindowClickListeners, _handleKeyboardAccessibility, _controlled, _DateTimeFormat, _formatTime, _extractTimeParts, _DialogContainer, _FontIcon, _TextField, _Collapse, _TimePicker) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);

  var _deprecated2 = _interopRequireDefault(_deprecated);

  var _getField2 = _interopRequireDefault(_getField);

  var _handleWindowClickListeners2 = _interopRequireDefault(_handleWindowClickListeners);

  var _handleKeyboardAccessibility2 = _interopRequireDefault(_handleKeyboardAccessibility);

  var _controlled2 = _interopRequireDefault(_controlled);

  var _DateTimeFormat2 = _interopRequireDefault(_DateTimeFormat);

  var _formatTime2 = _interopRequireDefault(_formatTime);

  var _extractTimeParts2 = _interopRequireDefault(_extractTimeParts);

  var _DialogContainer2 = _interopRequireDefault(_DialogContainer);

  var _FontIcon2 = _interopRequireDefault(_FontIcon);

  var _TextField2 = _interopRequireDefault(_TextField);

  var _Collapse2 = _interopRequireDefault(_Collapse);

  var _TimePicker2 = _interopRequireDefault(_TimePicker);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var TimePickerContainer = function (_PureComponent) {
    _inherits(TimePickerContainer, _PureComponent);

    function TimePickerContainer(props) {
      _classCallCheck(this, TimePickerContainer);

      var _this = _possibleConstructorReturn(this, (TimePickerContainer.__proto__ || Object.getPrototypeOf(TimePickerContainer)).call(this, props));

      var initialDate = void 0;
      if (props.defaultValue) {
        initialDate = new Date(props.defaultValue);
      } else if (props.value) {
        initialDate = new Date(props.value);
      } else {
        initialDate = new Date();
      }

      var visible = typeof props.initiallyOpen !== 'undefined' ? props.initiallyOpen : !!props.defaultVisible;

      _this.state = _extends({
        visible: visible
      }, _this._getTimeParts(initialDate, props), {
        value: props.defaultValue,
        time: initialDate,
        timeMode: props.initialTimeMode || props.defaultTimeMode,
        tempTime: initialDate
      });

      _this._setContainer = _this._setContainer.bind(_this);
      _this._toggleOpen = _this._toggleOpen.bind(_this);
      _this._closeOnEsc = _this._closeOnEsc.bind(_this);
      _this._handleOutsideClick = _this._handleOutsideClick.bind(_this);
      _this._getTextFieldValue = _this._getTextFieldValue.bind(_this);
      _this._setTimeMode = _this._setTimeMode.bind(_this);
      _this._setTempTime = _this._setTempTime.bind(_this);
      _this._handleOkClick = _this._handleOkClick.bind(_this);
      _this._handleKeyDown = _this._handleKeyDown.bind(_this);
      _this._handleCancelClick = _this._handleCancelClick.bind(_this);
      return _this;
    }

    _createClass(TimePickerContainer, [{
      key: 'componentWillUpdate',
      value: function componentWillUpdate(nextProps, nextState) {
        if ((0, _getField2.default)(this.props, this.state, 'value') !== (0, _getField2.default)(nextProps, nextState, 'value')) {
          this.setState(this._getTimeParts((0, _getField2.default)(nextProps, nextState, 'value'), nextProps));
        } else if (this.state.tempValue !== nextState.tempTime) {
          this.setState(this._getTimeParts(nextState.tempTime, nextProps));
        }
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps, prevState) {
        var _props = this.props,
            inline = _props.inline,
            isOpen = _props.isOpen;

        var visible = typeof isOpen !== 'undefined' ? isOpen : (0, _getField2.default)(this.props, this.state, 'visible');
        var pVisible = typeof prevProps.isOpen !== 'undefined' ? prevProps.isOpen : (0, _getField2.default)(prevProps, prevState, 'visible');

        if (visible === pVisible) {
          return;
        }

        if (visible) {
          if (inline) {
            (0, _handleWindowClickListeners2.default)(this._handleOutsideClick, true);
            window.addEventListener('keydown', this._closeOnEsc);
          }
        } else if (inline) {
          (0, _handleWindowClickListeners2.default)(this._handleOutsideClick, false);
          window.removeEventListener('keydown', this._closeOnEsc);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var visible = typeof this.props.isOpen !== 'undefined' ? this.props.isOpen : (0, _getField2.default)(this.props, this.state, 'visible');
        if (visible && this.props.inline) {
          (0, _handleWindowClickListeners2.default)(this._handleOutsideClick, false);
          window.removeEventListener('keydown', this._closeOnEsc);
        }
      }
    }, {
      key: '_setContainer',
      value: function _setContainer(container) {
        this._container = container;
      }
    }, {
      key: '_getTimeParts',
      value: function _getTimeParts(date, props) {
        return (0, _extractTimeParts2.default)(props.DateTimeFormat, props.locales, date);
      }
    }, {
      key: '_closeOnEsc',
      value: function _closeOnEsc(e) {
        if ((e.which || e.keyCode) === _keyCodes.ESC) {
          this._handleCancelClick(e);
        }
      }
    }, {
      key: '_handleOutsideClick',
      value: function _handleOutsideClick(e) {
        if (this._container && !this._container.contains(e.target)) {
          this._handleCancelClick(e);
        }
      }
    }, {
      key: '_toggleOpen',
      value: function _toggleOpen(e) {
        if (this.props.disabled || this.props.readOnly) {
          return;
        }

        var visible = !(typeof this.props.isOpen !== 'undefined' ? this.props.isOpen : (0, _getField2.default)(this.props, this.state, 'visible'));

        if (this.props.onVisibilityChange) {
          this.props.onVisibilityChange(visible, e);
        }

        if (typeof this.props.isOpen === 'undefined' && typeof this.props.visible === 'undefined') {
          this.setState({ visible: visible });
        }
      }
    }, {
      key: '_setTimeMode',
      value: function _setTimeMode(timeMode) {
        if (this.state.timeMode === timeMode) {
          return;
        }

        this.setState({ timeMode: timeMode });
      }
    }, {
      key: '_setTempTime',
      value: function _setTempTime(time) {
        if (this.state.tempTime === time) {
          return;
        }

        this.setState({ tempTime: time });
      }
    }, {
      key: '_handleKeyDown',
      value: function _handleKeyDown(e) {
        (0, _handleKeyboardAccessibility2.default)(e, this._toggleOpen, true, true);

        if ((e.which || e.keyCode) === _keyCodes.TAB && this.state.active) {
          this.setState({ active: false });
        }
      }
    }, {
      key: '_handleOkClick',
      value: function _handleOkClick(e) {
        var _props2 = this.props,
            onVisibilityChange = _props2.onVisibilityChange,
            onChange = _props2.onChange,
            DateTimeFormat = _props2.DateTimeFormat,
            locales = _props2.locales;

        var value = new Date(this.state.tempTime);
        if (onChange) {
          onChange((0, _formatTime2.default)(DateTimeFormat, locales, value), value, e);
        }

        if (onVisibilityChange) {
          onVisibilityChange(false, e);
        }

        var state = void 0;
        if (typeof this.props.value === 'undefined') {
          state = { value: value };
        }

        if (typeof this.props.isOpen === 'undefined' && typeof this.props.visible === 'undefined') {
          state = state || {};
          state.visible = false;
        }

        if (state) {
          this.setState(state);
        }
      }
    }, {
      key: '_handleCancelClick',
      value: function _handleCancelClick(e) {
        if (this.props.onVisibilityChange) {
          this.props.onVisibilityChange(false, e);
        }

        var state = { visible: false, tempTime: this.state.time };
        if (typeof this.props.isOpen !== 'undefined' || typeof this.props.visible !== 'undefined') {
          delete state.visible;
        }

        this.setState(state);
      }
    }, {
      key: '_getTextFieldValue',
      value: function _getTextFieldValue(props, state) {
        var DateTimeFormat = props.DateTimeFormat,
            locales = props.locales;

        var value = (0, _getField2.default)(props, state, 'value');
        if (!value) {
          return '';
        } else if (value instanceof Date) {
          return (0, _formatTime2.default)(DateTimeFormat, locales, value);
        } else {
          // currently don't support value of string
          return value;
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _state = this.state,
            timeMode = _state.timeMode,
            tempTime = _state.tempTime,
            hours = _state.hours,
            minutes = _state.minutes,
            timePeriod = _state.timePeriod;

        var _props3 = this.props,
            style = _props3.style,
            className = _props3.className,
            pickerStyle = _props3.pickerStyle,
            pickerClassName = _props3.pickerClassName,
            inputStyle = _props3.inputStyle,
            inputClassName = _props3.inputClassName,
            textFieldStyle = _props3.textFieldStyle,
            textFieldClassName = _props3.textFieldClassName,
            id = _props3.id,
            disabled = _props3.disabled,
            label = _props3.label,
            placeholder = _props3.placeholder,
            icon = _props3.icon,
            inline = _props3.inline,
            displayMode = _props3.displayMode,
            fullWidth = _props3.fullWidth,
            lineDirection = _props3.lineDirection,
            closeOnEsc = _props3.closeOnEsc,
            renderNode = _props3.renderNode,
            lastChild = _props3.lastChild,
            block = _props3.block,
            paddedBlock = _props3.paddedBlock,
            active = _props3.active,
            error = _props3.error,
            floating = _props3.floating,
            required = _props3.required,
            leftIconStateful = _props3.leftIconStateful,
            rightIcon = _props3.rightIcon,
            rightIconStateful = _props3.rightIconStateful,
            customSize = _props3.customSize,
            errorText = _props3.errorText,
            helpText = _props3.helpText,
            helpOnFocus = _props3.helpOnFocus,
            inlineIndicator = _props3.inlineIndicator,
            ariaLabel = _props3['aria-label'],
            props = _objectWithoutProperties(_props3, ['style', 'className', 'pickerStyle', 'pickerClassName', 'inputStyle', 'inputClassName', 'textFieldStyle', 'textFieldClassName', 'id', 'disabled', 'label', 'placeholder', 'icon', 'inline', 'displayMode', 'fullWidth', 'lineDirection', 'closeOnEsc', 'renderNode', 'lastChild', 'block', 'paddedBlock', 'active', 'error', 'floating', 'required', 'leftIconStateful', 'rightIcon', 'rightIconStateful', 'customSize', 'errorText', 'helpText', 'helpOnFocus', 'inlineIndicator', 'aria-label']);

        delete props.value;
        delete props.onVisibilityChange;
        delete props.onChange;
        delete props.readOnly;
        delete props.defaultValue;
        delete props.defaultVisible;
        delete props.defaultTimeMode;

        // Delete deprecated
        delete props.isOpen;
        delete props.initialTimeMode;
        delete props.initiallyOpen;

        var visible = typeof this.props.isOpen !== 'undefined' ? this.props.isOpen : (0, _getField2.default)(this.props, this.state, 'visible');

        var picker = _react2.default.createElement(_TimePicker2.default, _extends({}, props, {
          inline: inline,
          icon: !!icon,
          tempTime: tempTime,
          timeMode: timeMode,
          hours: hours,
          minutes: minutes,
          timePeriod: timePeriod,
          style: pickerStyle,
          className: pickerClassName,
          displayMode: displayMode,
          onOkClick: this._handleOkClick,
          onCancelClick: this._handleCancelClick,
          setTimeMode: this._setTimeMode,
          setTempTime: this._setTempTime
        }));

        var content = void 0;
        if (inline) {
          content = _react2.default.createElement(
            _Collapse2.default,
            { collapsed: !visible },
            picker
          );
        } else {
          content = _react2.default.createElement(
            _DialogContainer2.default,
            {
              id: id + 'Dialog',
              visible: visible,
              onHide: this._handleCancelClick,
              dialogClassName: 'md-dialog--picker',
              contentClassName: 'md-dialog-content--picker',
              'aria-label': ariaLabel,
              closeOnEsc: closeOnEsc,
              lastChild: lastChild,
              renderNode: renderNode,
              focusOnMount: false
            },
            picker
          );
        }

        return _react2.default.createElement(
          'div',
          { style: style, className: (0, _classnames2.default)('md-picker-container', className), ref: this._setContainer },
          _react2.default.createElement(_TextField2.default, {
            id: id,
            style: textFieldStyle,
            className: (0, _classnames2.default)({ 'md-pointer--hover': !disabled }, textFieldClassName),
            inputStyle: inputStyle,
            inputClassName: (0, _classnames2.default)({ 'md-pointer--hover': !disabled }, inputClassName),
            active: active || visible,
            error: error,
            floating: floating || visible,
            required: required,
            disabled: disabled,
            leftIcon: icon,
            leftIconStateful: leftIconStateful,
            rightIcon: rightIcon,
            rightIconStateful: rightIconStateful,
            inlineIndicator: inlineIndicator,
            block: block,
            paddedBlock: paddedBlock,
            fullWidth: fullWidth,
            lineDirection: lineDirection,
            customSize: customSize,
            helpText: helpText,
            helpOnFocus: helpOnFocus,
            errorText: errorText,
            label: label,
            placeholder: placeholder,
            onClick: this._toggleOpen,
            onKeyDown: this._handleKeyDown,
            value: this._getTextFieldValue(this.props, this.state),
            readOnly: true
          }),
          content
        );
      }
    }]);

    return TimePickerContainer;
  }(_react.PureComponent);

  TimePickerContainer.propTypes = {
    /**
     * An id for the text field in the time picker. This is require for a11u.
     */
    id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),

    /**
     * An aria-label to apply to the dialog when it has been opened. This is required for
     * a11y.
     */
    'aria-label': (0, _isRequiredForA11y2.default)(_propTypes2.default.string),

    /**
     * An optional style to apply to the time picker's container.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply to the time picker's container.
     */
    className: _propTypes2.default.string,

    /**
     * An optional style to apply to the time picker.
     */
    pickerStyle: _propTypes2.default.object,

    /**
     * An optional className to apply to the time picker.
     */
    pickerClassName: _propTypes2.default.string,

    /**
     * An optional style to apply to the input tag.
     */
    inputStyle: _propTypes2.default.object,

    /**
     * An optional className to apply to the input tag.
     */
    inputClassName: _propTypes2.default.string,

    /**
     * An optional style to apply to the text field's container.
     */
    textFieldStyle: _propTypes2.default.object,

    /**
     * An optional className to apply to the text field's container.
     */
    textFieldClassName: _propTypes2.default.string,

    /**
     * An optional icon to display with the time picker.
     */
    icon: _propTypes2.default.node,

    /**
     * Boolean if the time picker is open by default.
     */
    defaultVisible: _propTypes2.default.bool,

    /**
     * An optional label to be displayed in the time picker's text
     * field.
     */
    label: _propTypes2.default.node,

    /**
     * An optional placeholder to be displayed in the time picker's text field.
     */
    placeholder: _propTypes2.default.string,

    /**
     * The value of the time picker. This will make the time picker
     * be a controlled component.
     */
    value: (0, _controlled2.default)(_propTypes2.default.instanceOf(Date), 'onChange', 'defaultValue'),

    /**
     * An optional function to call when the selected date is changed
     * by hitting the OK button. The newly formatted time string,
     * the new Date object, and the change event will be given.
     *
     * `onChange(timeString, dateObject, event)`.
     */
    onChange: _propTypes2.default.func,

    /**
     * An optional default value to give for the year picker.
     */
    defaultValue: _propTypes2.default.instanceOf(Date),

    /**
     * A function to format the dates since it should be formatted to the user's
     * locale. This _should_ be the `Intl.DateTimeFormat` function. You
     * can also create your own if you really wanted. Unadvisable though.
     *
     * See [intl-polyfill](https://github.com/andyearnshaw/Intl.js/) for more info.
     */
    DateTimeFormat: _propTypes2.default.func.isRequired,

    /**
     * The locales to use for formatting the date. This will default to using
     * the user's language in the browser or `'en-US'` when server renering.
     */
    locales: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,

    /**
     * The label to use for the ok button on the year picker.
     */
    okLabel: _propTypes2.default.node.isRequired,

    /**
     * Boolean if the ok button should be styled with the primary color.
     */
    okPrimary: _propTypes2.default.bool,

    /**
     * The label to use for the cancel button on the year picker.
     */
    cancelLabel: _propTypes2.default.node.isRequired,

    /**
     * Boolean if the cancel button should be styled with the primary color.
     */
    cancelPrimary: _propTypes2.default.bool,

    /**
     * The default mode to open the time picker in.
     */
    defaultTimeMode: _propTypes2.default.oneOf(['hour', 'minute']),

    /**
     * Boolean if the date should automatically be selected when a user clicks
     * on a new date instead of making them hit the ok button.
     */
    autoOk: _propTypes2.default.bool,

    /**
     * Boolean if the date picker should be displayed inline instead of in a
     * dialog.
     */
    inline: _propTypes2.default.bool,

    /**
     * An optional force of the display mode of the date picker.
     * This _should_ not really be used since there are media queries
     * to use the correct mode based on device orientation.
     */
    displayMode: _propTypes2.default.oneOf(['landscape', 'portrait']),

    /**
     * Boolean if the text field for the Time Picker should be displayed as full width.
     */
    fullWidth: _propTypes2.default.bool,

    /**
     * The direction that the text field divider expands from when the text field
     * in the date picker gains focus.
     */
    lineDirection: _propTypes2.default.oneOf(['left', 'center', 'right']),

    /**
     * An optional boolean if the time picker is current visible by dialog or inline.
     * If this is set, the `onVisibilityChange` function is required.
     */
    visible: (0, _controlled2.default)(_propTypes2.default.bool, 'onVisibilityChange', 'defaultVisible'),

    /**
     * An optional function to call when the date picker is opened in either a dialog, or
     * inline. The callback will include the next state.
     *
     * ```js
     * onVisibilityChange(!visible, e);
     * ```
     */
    onVisibilityChange: _propTypes2.default.func,

    /**
     * Boolean if the time picker is disabled.
     */
    disabled: _propTypes2.default.bool,

    /**
     * Boolean if the dialog should be able to close if a keyboard user presses the escape key.
     */
    closeOnEsc: _propTypes2.default.bool,

    /**
     * Boolean if the time is required.
     *
     * @see [TextField](/components/text-fields?tab=1)
     */
    required: _propTypes2.default.bool,

    /**
     * @see [TextField](/components/text-fields?tab=1)
     */
    block: _TextField2.default.propTypes.block,

    /**
     * @see [TextField](/components/text-fields?tab=1)
     */
    paddedBlock: _TextField2.default.propTypes.paddedBlock,

    /**
     * @see [TextField](/components/text-fields?tab=1)
     */
    active: _TextField2.default.propTypes.active,

    /**
     * @see [TextField](/components/text-fields?tab=1)
     */
    error: _TextField2.default.propTypes.error,

    /**
     * @see [TextField](/components/text-fields?tab=1)
     */
    floating: _TextField2.default.propTypes.floating,

    /**
     * @see [TextField](/components/text-fields?tab=1)
     */
    leftIconStateful: _TextField2.default.propTypes.leftIconStateful,

    /**
     * @see [TextField](/components/text-fields?tab=1)
     */
    rightIcon: _TextField2.default.propTypes.rightIcon,

    /**
     * @see [TextField](/components/text-fields?tab=1)
     */
    rightIconStateful: _TextField2.default.propTypes.rightIconStateful,

    /**
     * @see [TextField](/components/text-fields?tab=1)
     */
    customSize: _TextField2.default.propTypes.customSize,

    /**
     * @see [TextField](/components/text-fields?tab=1)
     */
    errorText: _TextField2.default.propTypes.errorText,

    /**
     * @see [TextField](/components/text-fields?tab=1)
     */
    helpText: _TextField2.default.propTypes.helpText,

    /**
     * @see [TextField](/components/text-fields?tab=1)
     */
    helpOnFocus: _TextField2.default.propTypes.helpOnFocus,

    /**
     * @see [TextField](/components/text-fields?tab=1)
     */
    inlineIndicator: _TextField2.default.propTypes.helpOnFocus,

    /**
     * An optional DOM Node to render the dialog into. The default is to render as the first child
     * in the `body`.
     */
    renderNode: _propTypes2.default.object,

    /**
     * Boolean if the dialog should be rendered as the last child of the `renderNode` or `body` instead
     * of the first.
     */
    lastChild: _propTypes2.default.bool,

    /**
     * Boolean if the TimePicker should be read only. This will prevent the user from opening the picker
     * and only display the current date in the text field.
     */
    readOnly: _propTypes2.default.bool,

    isOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `visible` instead'),
    initiallyOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `defaultVisible` instead'),
    initialTimeMode: (0, _deprecated2.default)(_propTypes2.default.oneOf(['hour', 'minute']), 'Use `defaultTimeMode` instead')
  };
  TimePickerContainer.defaultProps = {
    defaultTimeMode: 'hour',
    icon: _react2.default.createElement(
      _FontIcon2.default,
      null,
      'access_time'
    ),
    DateTimeFormat: _DateTimeFormat2.default, // eslint-disable-line object-shorthand
    locales: typeof window !== 'undefined' ? window.navigator.userLanguage || window.navigator.language : 'en-US',
    okLabel: 'Ok',
    okPrimary: true,
    cancelLabel: 'Cancel',
    cancelPrimary: true,
    closeOnEsc: true,
    'aria-label': 'Select a time'
  };
  exports.default = TimePickerContainer;
});

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(1147), __webpack_require__(257)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('./TimePeriods'), require('./PickerControl'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.TimePeriods, global.PickerControl);
    global.TimePickerHeader = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _TimePeriods, _PickerControl) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _TimePeriods2 = _interopRequireDefault(_TimePeriods);

  var _PickerControl2 = _interopRequireDefault(_PickerControl);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var TimePickerHeader = function (_PureComponent) {
    _inherits(TimePickerHeader, _PureComponent);

    function TimePickerHeader(props) {
      _classCallCheck(this, TimePickerHeader);

      var _this = _possibleConstructorReturn(this, (TimePickerHeader.__proto__ || Object.getPrototypeOf(TimePickerHeader)).call(this, props));

      _this._setHour = _this._setHour.bind(_this);
      _this._setMinute = _this._setMinute.bind(_this);
      return _this;
    }

    _createClass(TimePickerHeader, [{
      key: '_setHour',
      value: function _setHour() {
        this.props.setTimeMode('hour');
      }
    }, {
      key: '_setMinute',
      value: function _setMinute() {
        this.props.setTimeMode('minute');
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            timeMode = _props.timeMode,
            hours = _props.hours,
            minutes = _props.minutes,
            timePeriod = _props.timePeriod,
            setTempTime = _props.setTempTime,
            tempTime = _props.tempTime;

        var timePeriods = void 0;
        if (timePeriod) {
          timePeriods = _react2.default.createElement(_TimePeriods2.default, { tempTime: tempTime, setTempTime: setTempTime, timePeriod: timePeriod });
        }

        return _react2.default.createElement(
          'header',
          { className: 'md-picker-header md-text-right' },
          _react2.default.createElement(
            _PickerControl2.default,
            { onClick: this._setHour, active: timeMode === 'hour' },
            _react2.default.createElement(
              'h4',
              { className: 'md-display-3' },
              hours
            )
          ),
          _react2.default.createElement(
            _PickerControl2.default,
            { onClick: this._setMinute, active: timeMode === 'minute' },
            _react2.default.createElement(
              'h4',
              { className: 'md-display-3' },
              minutes
            )
          ),
          timePeriods
        );
      }
    }]);

    return TimePickerHeader;
  }(_react.PureComponent);

  TimePickerHeader.propTypes = {
    /**
     * The current time of the time picker.
     */
    tempTime: _propTypes2.default.instanceOf(Date).isRequired,

    /**
     * The current time type that is being changed.
     */
    timeMode: _propTypes2.default.oneOf(['hour', 'minute']).isRequired,

    /**
     * A function to update the time mode.
     */
    setTimeMode: _propTypes2.default.func.isRequired,

    /**
     * A function to update the time for the time picker.
     */
    setTempTime: _propTypes2.default.func.isRequired,

    /**
     * A formatted hours string for the user's locale. This
     * would be '3' for en-US if the time was '3:15'
     */
    hours: _propTypes2.default.string.isRequired,

    /**
     * A formatted minutes string for the user's locale.
     * This would be ':15' for en-US if the time was '3:15'.
     */
    minutes: _propTypes2.default.string.isRequired,

    /**
     * An optional time period to use for locales that use
     * 12 hour clocks and AM/PM.
     */
    timePeriod: _propTypes2.default.string
  };
  exports.default = TimePickerHeader;
});

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames);
    global.Year = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Year = function (_PureComponent) {
    _inherits(Year, _PureComponent);

    function Year(props) {
      _classCallCheck(this, Year);

      var _this = _possibleConstructorReturn(this, (Year.__proto__ || Object.getPrototypeOf(Year)).call(this, props));

      _this.state = { desktopActive: false };
      _this._handleClick = _this._handleClick.bind(_this);
      _this._setActive = _this._setActive.bind(_this);
      _this._setInactive = _this._setInactive.bind(_this);
      _this._setActiveFocus = _this._setActiveFocus.bind(_this);
      return _this;
    }

    _createClass(Year, [{
      key: '_setActiveFocus',
      value: function _setActiveFocus(btn) {
        if (btn && this.props.active) {
          btn.focus();
        }
      }
    }, {
      key: '_setActive',
      value: function _setActive() {
        this.setState({ desktopActive: true });
      }
    }, {
      key: '_setInactive',
      value: function _setInactive() {
        this.setState({ desktopActive: false });
      }
    }, {
      key: '_handleClick',
      value: function _handleClick(e) {
        this.props.onClick(this.props.year, e);
      }
    }, {
      key: 'render',
      value: function render() {
        var desktopActive = this.state.desktopActive;
        var _props = this.props,
            active = _props.active,
            className = _props.className,
            year = _props.year;

        return _react2.default.createElement(
          'button',
          {
            type: 'button',
            ref: this._setActiveFocus,
            className: (0, _classnames2.default)('md-btn md-pointer--hover md-full-width md-year', {
              'md-text': !active && !desktopActive,
              'md-text--theme-primary': active || desktopActive,
              'md-year--active': active
            }, className),
            onClick: this._handleClick
          },
          year
        );
      }
    }]);

    return Year;
  }(_react.PureComponent);

  Year.propTypes = {
    className: _propTypes2.default.string,
    active: _propTypes2.default.bool.isRequired,
    onClick: _propTypes2.default.func.isRequired,
    year: _propTypes2.default.number.isRequired
  };
  exports.default = Year;
});

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(1151)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('./Year'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.Year);
    global.YearPicker = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _Year) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _Year2 = _interopRequireDefault(_Year);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var YearPicker = function (_PureComponent) {
    _inherits(YearPicker, _PureComponent);

    function YearPicker(props) {
      _classCallCheck(this, YearPicker);

      var _this = _possibleConstructorReturn(this, (YearPicker.__proto__ || Object.getPrototypeOf(YearPicker)).call(this, props));

      _this.state = _this._getYearRange(props);
      _this._setContainer = _this._setContainer.bind(_this);
      return _this;
    }

    _createClass(YearPicker, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (this.props.yearsDisplayed !== nextProps.yearsDisplayed) {
          this.setState(this._getFullYear(nextProps));
        }
      }
    }, {
      key: '_getYearRange',
      value: function _getYearRange(_ref) {
        var minDate = _ref.minDate,
            maxDate = _ref.maxDate,
            yearsDisplayed = _ref.yearsDisplayed,
            calendarTempDate = _ref.calendarTempDate;

        var year = calendarTempDate.getFullYear();
        var range = !minDate && !maxDate ? parseInt(yearsDisplayed / 2, 10) : yearsDisplayed;

        var startYear = void 0;
        var endYear = void 0;
        if (minDate && maxDate) {
          startYear = minDate.getFullYear();
          endYear = maxDate.getFullYear();
        } else if (!minDate && !maxDate) {
          startYear = year - range;
          endYear = year + range;
          if (yearsDisplayed % 2 === 0) {
            endYear -= 1;
          }
        } else if (!maxDate) {
          startYear = minDate.getFullYear();
          endYear = startYear + yearsDisplayed - 1;
        } else {
          endYear = maxDate.getFullYear();
          startYear = endYear - yearsDisplayed + 1;
        }

        return { startYear: startYear, endYear: endYear };
      }
    }, {
      key: '_setContainer',
      value: function _setContainer(container) {
        if (container === null) {
          return;
        }

        var offsetHeight = container.offsetHeight,
            offsetWidth = container.offsetWidth;

        var _container$querySelec = container.querySelector('.md-year--active'),
            top = _container$querySelec.offsetTop,
            height = _container$querySelec.offsetHeight;

        // Portrait seems to be 3/4 of the way while landscape is about 1/2
        if (offsetHeight > offsetWidth) {
          container.scrollTop = top - offsetHeight * 3 / 4;
        } else {
          container.scrollTop = top - offsetHeight / 2 + height / 2;
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _state = this.state,
            startYear = _state.startYear,
            endYear = _state.endYear;


        var currentYear = this.props.calendarTempDate.getFullYear();
        var years = [];
        for (var year = startYear; year <= endYear; year++) {
          years.push(_react2.default.createElement(_Year2.default, {
            key: year,
            year: year,
            active: year === currentYear,
            onClick: this.props.onCalendarYearClick
          }));
        }

        return _react2.default.createElement(
          'section',
          { className: 'md-picker-content md-picker-content--year', ref: this._setContainer },
          _react2.default.createElement(
            'ol',
            { className: 'md-years' },
            years
          )
        );
      }
    }]);

    return YearPicker;
  }(_react.PureComponent);

  YearPicker.propTypes = {
    calendarTempDate: _propTypes2.default.instanceOf(Date).isRequired,
    onCalendarYearClick: _propTypes2.default.func.isRequired,
    yearsDisplayed: _propTypes2.default.number.isRequired,
    minDate: _propTypes2.default.instanceOf(Date),
    maxDate: _propTypes2.default.instanceOf(Date)
  };
  exports.default = YearPicker;
});

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1145), __webpack_require__(1149)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./DatePickerContainer'), require('./TimePickerContainer'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.DatePickerContainer, global.TimePickerContainer);
    global.index = mod.exports;
  }
})(this, function (exports, _DatePickerContainer, _TimePickerContainer) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.TimePicker = exports.DatePicker = undefined;

  var _DatePickerContainer2 = _interopRequireDefault(_DatePickerContainer);

  var _TimePickerContainer2 = _interopRequireDefault(_TimePickerContainer);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.DatePicker = _DatePickerContainer2.default;
  exports.TimePicker = _TimePickerContainer2.default;
});

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(17), __webpack_require__(120)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('react-prop-types/lib/isRequiredForA11y'), require('../utils/PropTypes/between'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.isRequiredForA11y, global.between);
    global.LinearProgress = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _isRequiredForA11y, _between) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);

  var _between2 = _interopRequireDefault(_between);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var LinearProgress = function (_PureComponent) {
    _inherits(LinearProgress, _PureComponent);

    function LinearProgress() {
      _classCallCheck(this, LinearProgress);

      return _possibleConstructorReturn(this, (LinearProgress.__proto__ || Object.getPrototypeOf(LinearProgress)).apply(this, arguments));
    }

    _createClass(LinearProgress, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            className = _props.className,
            value = _props.value,
            query = _props.query,
            centered = _props.centered,
            props = _objectWithoutProperties(_props, ['className', 'value', 'query', 'centered']);

        var isDeterminate = typeof value === 'number';

        var accessibilityProps = {
          role: 'progressbar',
          'aria-valuemin': 0,
          'aria-valuemax': 100
        };

        var style = void 0;
        if (isDeterminate) {
          style = { width: value + '%' };
          accessibilityProps['aria-valuenow'] = value;
        }

        return _react2.default.createElement(
          'div',
          _extends({}, props, {
            className: (0, _classnames2.default)('md-progress md-progress--linear', { 'md-block-centered': centered }, className)
          }),
          _react2.default.createElement('div', _extends({}, accessibilityProps, {
            style: style,
            className: (0, _classnames2.default)('md-progress--linear-active', {
              'md-progress--linear-query': query,
              'md-progress--linear-determinate': isDeterminate,
              'md-progress--linear-indeterminate': !isDeterminate
            })
          }))
        );
      }
    }]);

    return LinearProgress;
  }(_react.PureComponent);

  LinearProgress.propTypes = {
    /**
     * The `id` prop is required for accessibility concerns.
     * [Progress Bar Role](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_progressbar_role)
     *
     * > If the progressbar is describing the loading progress of a particular region of a page, the author
     * __SHOULD__ use aria-describedby to point to the status, and set the aria-busy attribute to true on the
     * region until it is finished loading. It is not possible for the user to alter the value of a progressbar
     * because it is always readonly.
     */
    id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),

    /* eslint-enable max-len */
    /**
     * An optional className to apply to the linear progress container.
     */
    className: _propTypes2.default.string,

    /**
     * The current value of the progress. If this value is defined, it will
     * be converted to a determinate circular progress. The progress will not
     * advance unless this value changes.
     *
     * This value should also be a number between 0 and 100.
     */
    value: (0, _between2.default)(_propTypes2.default.number, 0, 100),

    /**
     * Boolean if this should be a query indeterminate progress bar.
     */
    query: _propTypes2.default.bool,

    /**
     * Boolean if the Linear Progress should be centered. This
     * will only work if the `max-width` style is set.
     */
    centered: _propTypes2.default.bool
  };
  LinearProgress.defaultProps = {
    query: false
  };
  exports.default = LinearProgress;
});

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1154), __webpack_require__(570)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./LinearProgress'), require('./CircularProgress'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.LinearProgress, global.CircularProgress);
    global.index = mod.exports;
  }
})(this, function (exports, _LinearProgress2, _CircularProgress2) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.CircularProgress = exports.LinearProgress = undefined;

  var _LinearProgress3 = _interopRequireDefault(_LinearProgress2);

  var _CircularProgress3 = _interopRequireDefault(_CircularProgress2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.LinearProgress = _LinearProgress3.default;
  exports.CircularProgress = _CircularProgress3.default;
});

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(38), __webpack_require__(28), __webpack_require__(37), __webpack_require__(81), __webpack_require__(46), __webpack_require__(577)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('../constants/CSSTransitionGroupTick'), require('../FontIcons/FontIcon'), require('../Helpers/AccessibleFakeInkedButton'), require('../Helpers/IconSeparator'), require('../Papers/Paper'), require('../TextFields/TextFieldDivider'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.CSSTransitionGroupTick, global.FontIcon, global.AccessibleFakeInkedButton, global.IconSeparator, global.Paper, global.TextFieldDivider);
    global.Field = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _CSSTransitionGroupTick, _FontIcon, _AccessibleFakeInkedButton, _IconSeparator, _Paper, _TextFieldDivider) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);

  var _FontIcon2 = _interopRequireDefault(_FontIcon);

  var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);

  var _IconSeparator2 = _interopRequireDefault(_IconSeparator);

  var _Paper2 = _interopRequireDefault(_Paper);

  var _TextFieldDivider2 = _interopRequireDefault(_TextFieldDivider);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Field = function (_PureComponent) {
    _inherits(Field, _PureComponent);

    function Field(props) {
      _classCallCheck(this, Field);

      var _this = _possibleConstructorReturn(this, (Field.__proto__ || Object.getPrototypeOf(Field)).call(this, props));

      _this.state = { droppingClassName: null };
      _this._transitionNewValue = _this._transitionNewValue.bind(_this);
      return _this;
    }

    _createClass(Field, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (this.props.value !== nextProps.value) {
          this._transitionNewValue();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this._timeout) {
          clearTimeout(this._timeout);
        }
      }
    }, {
      key: '_transitionNewValue',
      value: function _transitionNewValue() {
        var _this2 = this;

        if (this._timeout) {
          clearTimeout(this._timeout);
        }

        this._timeout = setTimeout(function () {
          _this2._timeout = setTimeout(function () {
            _this2._timeout = null;

            _this2.setState({ droppingClassName: null });
          }, 300);

          _this2.setState({ droppingClassName: _this2.state.droppingClassName + ' md-drop-enter-active ' });
        }, _CSSTransitionGroupTick2.default);

        this.setState({ droppingClassName: 'md-drop-enter' });
      }
    }, {
      key: 'render',
      value: function render() {
        var droppingClassName = this.state.droppingClassName;

        var _props = this.props,
            id = _props.id,
            name = _props.name,
            value = _props.value,
            active = _props.active,
            below = _props.below,
            style = _props.style,
            className = _props.className,
            label = _props.label,
            disabled = _props.disabled,
            placeholder = _props.placeholder,
            activeLabel = _props.activeLabel,
            iconChildren = _props.iconChildren,
            iconClassName = _props.iconClassName,
            lineDirection = _props.lineDirection,
            required = _props.required,
            error = _props.error,
            toolbar = _props.toolbar,
            props = _objectWithoutProperties(_props, ['id', 'name', 'value', 'active', 'below', 'style', 'className', 'label', 'disabled', 'placeholder', 'activeLabel', 'iconChildren', 'iconClassName', 'lineDirection', 'required', 'error', 'toolbar']);

        var divider = void 0;
        if (!below && !toolbar) {
          divider = _react2.default.createElement(_TextFieldDivider2.default, {
            key: 'text-divider',
            active: active,
            error: error,
            lineDirection: lineDirection,
            className: 'md-divider--select-field'
          });
        }

        return _react2.default.createElement(
          _AccessibleFakeInkedButton2.default,
          _extends({}, props, {
            role: 'listbox',
            disabled: disabled,
            component: _Paper2.default,
            zDepth: below && active ? 1 : 0,
            inkDisabled: !below,
            style: style,
            className: (0, _classnames2.default)('md-select-field', {
              'md-text': activeLabel,
              'md-text--secondary': !activeLabel && placeholder,
              'md-text--disabled': disabled
            }, className)
          }),
          _react2.default.createElement(
            _IconSeparator2.default,
            {
              label: activeLabel || (label && active || !label) && placeholder || '',
              labelClassName: droppingClassName,
              className: (0, _classnames2.default)('md-text-field', {
                'md-select-field--text-field': !below,
                'md-select-field--btn': below,
                'md-text-field--margin': !below && !label,
                'md-text-field--floating-margin': label,
                'md-text-field--toolbar': toolbar && !below
              })
            },
            _react2.default.createElement(
              _FontIcon2.default,
              { iconClassName: iconClassName },
              iconChildren
            )
          ),
          divider,
          _react2.default.createElement('input', {
            key: 'value',
            type: 'hidden',
            id: id,
            name: name,
            value: value,
            required: required
          })
        );
      }
    }]);

    return Field;
  }(_react.PureComponent);

  Field.propTypes = {
    style: _propTypes2.default.object,
    className: _propTypes2.default.string,
    active: _propTypes2.default.bool,
    below: _propTypes2.default.bool,
    label: _propTypes2.default.node,
    placeholder: _propTypes2.default.string,
    iconChildren: _propTypes2.default.node,
    iconClassName: _propTypes2.default.string,
    activeLabel: _propTypes2.default.node,
    id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    name: _propTypes2.default.string,
    value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    lineDirection: _TextFieldDivider2.default.propTypes.lineDirection,
    disabled: _propTypes2.default.bool,
    required: _propTypes2.default.bool,
    error: _propTypes2.default.bool,
    toolbar: _propTypes2.default.bool
  };
  exports.default = Field;
});

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(12), __webpack_require__(17), __webpack_require__(20), __webpack_require__(83)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('react-prop-types/lib/deprecated'), require('react-prop-types/lib/isRequiredForA11y'), require('../utils/PropTypes/controlled'), require('./SelectionControl'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.deprecated, global.isRequiredForA11y, global.controlled, global.SelectionControl);
    global.Checkbox = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _deprecated, _isRequiredForA11y, _controlled, _SelectionControl) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _deprecated2 = _interopRequireDefault(_deprecated);

  var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);

  var _controlled2 = _interopRequireDefault(_controlled);

  var _SelectionControl2 = _interopRequireDefault(_SelectionControl);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Checkbox = function (_PureComponent) {
    _inherits(Checkbox, _PureComponent);

    function Checkbox() {
      _classCallCheck(this, Checkbox);

      return _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).apply(this, arguments));
    }

    _createClass(Checkbox, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            checkedIconChildren = _props.checkedIconChildren,
            checkedIconClassName = _props.checkedIconClassName,
            uncheckedIconChildren = _props.uncheckedIconChildren,
            uncheckedIconClassName = _props.uncheckedIconClassName,
            props = _objectWithoutProperties(_props, ['checkedIconChildren', 'checkedIconClassName', 'uncheckedIconChildren', 'uncheckedIconClassName']);

        return _react2.default.createElement(_SelectionControl2.default, _extends({
          type: 'checkbox',
          checkedCheckboxIconChildren: checkedIconChildren,
          checkedCheckboxIconClassName: checkedIconClassName,
          uncheckedCheckboxIconChildren: uncheckedIconChildren,
          uncheckedCheckboxIconClassName: uncheckedIconClassName,
          __superSecreteProp: true
        }, props));
      }
    }]);

    return Checkbox;
  }(_react.PureComponent);

  Checkbox.propTypes = {
    /**
     * An id to use with the checkbox. This is used for accessibility and so that the label
     * triggers the checkbox toggle.
     */
    id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),

    /**
     * An optional style to apply to the checkbox's container.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply to the checkbox's container.
     */
    className: _propTypes2.default.string,

    /**
     * A label to display with the checkbox. This is required for accessibility and triggering
     * the toggle.
     */
    label: _propTypes2.default.node,

    /**
     * Boolean if the label should appear before the checkbox icon.
     */
    labelBefore: _propTypes2.default.bool,

    /**
     * A name to use for the `Checkbox`. This is required for accessibility. If the checkbox is
     * part of a group, it is recommended to make this a string ending in `[]` so that the
     * value can be found from `document.querySelector('input[name="someName[]"]').value`.
     */
    name: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),

    /**
     * Boolean if the `Checkbox` is disabled.
     */
    disabled: _propTypes2.default.bool,

    /**
     * An optional function to call when the `checked` state of the `Checkbox` changes.
     * The callback will incude the new checked state and the changeEvent.
     *
     * ```js
     * onChange(changeEvent.target.checked, changeEvent);
     * ```
     */
    onChange: _propTypes2.default.func,

    /**
     * An optional value for the `Checkbox`. It is recommended to use a value though.
     */
    value: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.string]),

    /**
     * Boolean if the `Checkbox` is checked by default.
     */
    defaultChecked: _propTypes2.default.bool,

    /**
     * A boolean if the `Checkbox` is currently checked. This will required the `onChange` prop
     * to be defined.
     */
    checked: (0, _controlled2.default)(_propTypes2.default.bool, 'onChange', 'defaultChecked'),

    /**
     * Boolean if the `Checkbox` should be displayed inline.
     */
    inline: _propTypes2.default.bool,

    /**
     * Any children to use for the checked `FontIcon` of the `Checkbox`.
     */
    checkedIconChildren: _propTypes2.default.node,

    /**
     * An icon className to use for the checked `FontIcon` of the `Checkbox`.
     */
    checkedIconClassName: _propTypes2.default.string,

    /**
     * Any children to use for the unchecked `FontIcon` of the `Checkbox`.
     */
    uncheckedIconChildren: _propTypes2.default.node,

    /**
     * An icon className to use for the unchecked `FontIcon` of the `Checkbox`.
     */
    uncheckedIconClassName: _propTypes2.default.string,

    checkedIcon: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `checkedIconChildren` and `checkedIconClassName` props instead'),
    uncheckedIcon: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `uncheckedIconChildren` and `uncheckedIconClassName` props instead')
  };
  Checkbox.defaultProps = {
    checkedIconChildren: 'check_box',
    uncheckedIconChildren: 'check_box_outline_blank'
  };
  exports.default = Checkbox;
});

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(12), __webpack_require__(261)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('react-prop-types/lib/deprecated'), require('./SelectionControlGroup'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.deprecated, global.SelectionControlGroup);
    global.RadioGroup = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _deprecated, _SelectionControlGroup) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _deprecated2 = _interopRequireDefault(_deprecated);

  var _SelectionControlGroup2 = _interopRequireDefault(_SelectionControlGroup);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var RadioGroup = function (_PureComponent) {
    _inherits(RadioGroup, _PureComponent);

    function RadioGroup() {
      _classCallCheck(this, RadioGroup);

      return _possibleConstructorReturn(this, (RadioGroup.__proto__ || Object.getPrototypeOf(RadioGroup)).apply(this, arguments));
    }

    _createClass(RadioGroup, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            children = _props.children,
            props = _objectWithoutProperties(_props, ['children']);

        delete props.id;
        delete props.defaultValue;

        var _props2 = this.props,
            id = _props2.id,
            defaultValue = _props2.defaultValue;

        if (!id) {
          id = props.name + 'RadiosUniquePlease';
        }

        if (typeof props.value === 'undefined') {
          if (typeof defaultValue === 'undefined') {
            defaultValue = _react.Children.map(children, function (_ref) {
              var value = _ref.props.value;
              return value;
            })[0];
          }
        }

        var controls = _react.Children.map(children, function (radio) {
          var props = Object.assign({}, radio.props);
          delete props.checkedIcon;
          delete props.uncheckedIcon;
          delete props.checkedIconChildren;
          delete props.checkedIconClassName;
          delete props.uncheckedIconChildren;
          delete props.uncheckedIconClassName;
          return _extends({}, props);
        });
        return _react2.default.createElement(_SelectionControlGroup2.default, _extends({}, props, { id: id, defaultValue: defaultValue, type: 'radio', controls: controls }));
      }
    }]);

    return RadioGroup;
  }(_react.PureComponent);

  RadioGroup.propTypes = {
    id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    defaultValue: _propTypes2.default.string,
    className: _propTypes2.default.string,
    children: _propTypes2.default.arrayOf(_propTypes2.default.node).isRequired,
    inline: _propTypes2.default.bool,
    onChange: _propTypes2.default.func,
    name: _propTypes2.default.string,
    value: _propTypes2.default.string,

    _deprecated: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use the `SelectionControlGroup` component instead')
  };
  exports.default = RadioGroup;
});

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(37)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('../Helpers/AccessibleFakeInkedButton'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.AccessibleFakeInkedButton);
    global.SwitchThumb = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _AccessibleFakeInkedButton) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var disabledInteractions = ['mouse'];

  /**
   * This is the `Thumb` for the switch. The `ink` in the Thumb is only active on touch and keyboard
   * interactions, so the `AccessibleFakeInkButton` does not work for this case.
   *
   * This component really just is used for custom inkage.
   */

  var SwitchThumb = function (_PureComponent) {
    _inherits(SwitchThumb, _PureComponent);

    function SwitchThumb() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, SwitchThumb);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SwitchThumb.__proto__ || Object.getPrototypeOf(SwitchThumb)).call.apply(_ref, [this].concat(args))), _this), _this._handleClick = function (e) {
        // The switch's thumb needs to have an onClick handler to enable keyboard accessibility, however,
        // this actually triggers two click events since the slider's track needs to be clickable as well.
        // Stop propagation to prevent the thumb click AND track propagation click.
        e.stopPropagation();
        _this.props.onClick(e);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SwitchThumb, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            disabled = _props.disabled,
            checked = _props.checked,
            className = _props.className,
            props = _objectWithoutProperties(_props, ['disabled', 'checked', 'className']);

        return _react2.default.createElement(_AccessibleFakeInkedButton2.default, _extends({}, props, {
          onClick: this._handleClick,
          disabled: disabled,
          disabledInteractions: disabledInteractions,
          inkContainerClassName: 'md-ink-container--2x',
          className: (0, _classnames2.default)('md-switch-thumb', {
            'md-switch-thumb--disabled': disabled,
            'md-switch-thumb--on': checked,
            'md-switch-thumb--off': !checked
          }, className)
        }));
      }
    }]);

    return SwitchThumb;
  }(_react.PureComponent);

  SwitchThumb.propTypes = {
    className: _propTypes2.default.string,
    disabled: _propTypes2.default.bool,
    checked: _propTypes2.default.bool,
    onClick: _propTypes2.default.func.isRequired
  };
  exports.default = SwitchThumb;
});

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(1159)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('./SwitchThumb'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.SwitchThumb);
    global.SwitchTrack = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _SwitchThumb) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _SwitchThumb2 = _interopRequireDefault(_SwitchThumb);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var SwitchTrack = function (_PureComponent) {
    _inherits(SwitchTrack, _PureComponent);

    function SwitchTrack() {
      _classCallCheck(this, SwitchTrack);

      return _possibleConstructorReturn(this, (SwitchTrack.__proto__ || Object.getPrototypeOf(SwitchTrack)).apply(this, arguments));
    }

    _createClass(SwitchTrack, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            disabled = _props.disabled,
            checked = _props.checked,
            className = _props.className,
            props = _objectWithoutProperties(_props, ['disabled', 'checked', 'className']);

        return _react2.default.createElement(
          'div',
          _extends({}, props, {
            className: (0, _classnames2.default)('md-switch-track', {
              'md-pointer--hover': !disabled,
              'md-switch-track--disabled': disabled,
              'md-switch-track--on': checked,
              'md-switch-track--off': !checked
            }, className)
          }),
          _react2.default.createElement(_SwitchThumb2.default, { disabled: disabled, checked: checked, onClick: props.onClick })
        );
      }
    }]);

    return SwitchTrack;
  }(_react.PureComponent);

  SwitchTrack.propTypes = {
    className: _propTypes2.default.string,
    disabled: _propTypes2.default.bool,
    checked: _propTypes2.default.bool
  };
  exports.default = SwitchTrack;
});

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(83), __webpack_require__(261), __webpack_require__(1157), __webpack_require__(260), __webpack_require__(1158), __webpack_require__(571)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./SelectionControl'), require('./SelectionControlGroup'), require('./Checkbox'), require('./Radio'), require('./RadioGroup'), require('./Switch'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.SelectionControl, global.SelectionControlGroup, global.Checkbox, global.Radio, global.RadioGroup, global.Switch);
    global.index = mod.exports;
  }
})(this, function (exports, _SelectionControl, _SelectionControlGroup2, _Checkbox2, _Radio2, _RadioGroup2, _Switch2) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Switch = exports.RadioGroup = exports.Radio = exports.Checkbox = exports.SelectionControlGroup = exports.SelectionControl = undefined;

  var _SelectionControl2 = _interopRequireDefault(_SelectionControl);

  var _SelectionControlGroup3 = _interopRequireDefault(_SelectionControlGroup2);

  var _Checkbox3 = _interopRequireDefault(_Checkbox2);

  var _Radio3 = _interopRequireDefault(_Radio2);

  var _RadioGroup3 = _interopRequireDefault(_RadioGroup2);

  var _Switch3 = _interopRequireDefault(_Switch2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _SelectionControl2.default;
  exports.SelectionControl = _SelectionControl2.default;
  exports.SelectionControlGroup = _SelectionControlGroup3.default;
  exports.Checkbox = _Checkbox3.default;
  exports.Radio = _Radio3.default;
  exports.RadioGroup = _RadioGroup3.default;
  exports.Switch = _Switch3.default;
});

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(251), __webpack_require__(64)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('../Drawers/Drawer'), require('../utils/PropTypes/componentDeprecated'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.Drawer, global.componentDeprecated);
    global.Sidebar = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _Drawer, _componentDeprecated) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _Drawer2 = _interopRequireDefault(_Drawer);

  var _componentDeprecated2 = _interopRequireDefault(_componentDeprecated);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Sidebar = function (_PureComponent) {
    _inherits(Sidebar, _PureComponent);

    function Sidebar() {
      _classCallCheck(this, Sidebar);

      return _possibleConstructorReturn(this, (Sidebar.__proto__ || Object.getPrototypeOf(Sidebar)).apply(this, arguments));
    }

    _createClass(Sidebar, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            isOpen = _props.isOpen,
            header = _props.header,
            overlay = _props.overlay,
            children = _props.children,
            onOverlayClick = _props.onOverlayClick,
            align = _props.align,
            items = _props.items,
            fixed = _props.fixed,
            props = _objectWithoutProperties(_props, ['isOpen', 'header', 'overlay', 'children', 'onOverlayClick', 'align', 'items', 'fixed']);

        delete props.responsive;

        return _react2.default.createElement(
          _Drawer2.default,
          _extends({}, props, {
            visible: isOpen,
            onVisibilityChange: onOverlayClick,
            navItems: items,
            position: align,
            overflay: overlay,
            header: header,
            inline: !fixed
          }),
          children
        );
      }
    }]);

    return Sidebar;
  }(_react.PureComponent);

  Sidebar.propTypes = {
    deprecated: (0, _componentDeprecated2.default)('All the functionality and responsiveness of a `Sidebar` can be handled by the `Drawer` instead.' + ' Switch to the `Drawer` component instead.'),

    /**
     * Boolean if the overlay should appear when opened.
     */
    overlay: _propTypes2.default.bool,

    /**
     * Boolean if the sidebar is visible and open.
     */
    isOpen: _propTypes2.default.bool,

    /**
     * Boolean if the sidebar is fixed to the side of the page.
     */
    fixed: _propTypes2.default.bool,

    /**
     * Boolean if sidebar should be responsive.
     */
    responsive: _propTypes2.default.bool,

    /**
     * An optional header to display above the children or list items.
     */
    header: _propTypes2.default.node,

    /**
     * Any children to display after the generated list of items.
     */
    children: _propTypes2.default.node,

    /**
     * An optional className to apply.
     */
    className: _propTypes2.default.string,

    /**
     * The transition name to use for the overlay.
     */
    transitionName: _propTypes2.default.string,

    /**
     * The enter timeout for the overlay transition.
     */
    transitionEnterTimeout: _propTypes2.default.number,

    /**
     * The leave timeout for the overlay transition.
     */
    transitionLeaveTimeout: _propTypes2.default.number,

    /**
     * An optional function to call when the overlay is clicked.
     * This should normally close the sidebar.
     */
    onOverlayClick: _propTypes2.default.func,

    /**
     * The position to align the sidebar of the screen to.
     */
    align: _propTypes2.default.oneOf(['left', 'right']),

    /**
     * A list of item props to convert into `ListItem`, `Divider`, or
     * `Subheader` components.
     *
     * ##### Item Descriptions
     */
    items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      /**
       * Boolean if this item is a divider.
       */
      divider: _propTypes2.default.bool,

      /**
       * Boolean if this item is a subheader.
       */
      subheader: _propTypes2.default.bool,

      /**
       * The primary text to display in a `ListItem` or a `Subheader`.
       */
      primaryText: _propTypes2.default.node
    }))
  };
  Sidebar.defaultProps = {
    align: 'left'
  };
  exports.default = Sidebar;
});

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1162)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./Sidebar'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.Sidebar);
    global.index = mod.exports;
  }
})(this, function (exports, _Sidebar) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _Sidebar2 = _interopRequireDefault(_Sidebar);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _Sidebar2.default;
});

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames);
    global.DiscreteValue = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _slicedToArray = function () {
    function sliceIterator(arr, i) {
      var _arr = [];
      var _n = true;
      var _d = false;
      var _e = undefined;

      try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);

          if (i && _arr.length === i) break;
        }
      } catch (err) {
        _d = true;
        _e = err;
      } finally {
        try {
          if (!_n && _i["return"]) _i["return"]();
        } finally {
          if (_d) throw _e;
        }
      }

      return _arr;
    }

    return function (arr, i) {
      if (Array.isArray(arr)) {
        return arr;
      } else if (Symbol.iterator in Object(arr)) {
        return sliceIterator(arr, i);
      } else {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }
    };
  }();

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var DiscreteValue = function (_PureComponent) {
    _inherits(DiscreteValue, _PureComponent);

    function DiscreteValue() {
      _classCallCheck(this, DiscreteValue);

      return _possibleConstructorReturn(this, (DiscreteValue.__proto__ || Object.getPrototypeOf(DiscreteValue)).apply(this, arguments));
    }

    _createClass(DiscreteValue, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            style = _props.style,
            className = _props.className,
            discrete = _props.discrete,
            dragging = _props.dragging,
            thumbLeft = _props.thumbLeft,
            active = _props.active,
            value = _props.value,
            valuePrecision = _props.valuePrecision,
            props = _objectWithoutProperties(_props, ['style', 'className', 'discrete', 'dragging', 'thumbLeft', 'active', 'value', 'valuePrecision']);

        if (!discrete || !active) {
          return null;
        }

        var valueStr = value.toFixed(valuePrecision);
        if (valuePrecision > 0) {
          var _valueStr$split = valueStr.split('.'),
              _valueStr$split2 = _slicedToArray(_valueStr$split, 2),
              w = _valueStr$split2[0],
              d = _valueStr$split2[1];

          if (parseInt(d, 10) === 0) {
            valueStr = w;
          }
        }
        return _react2.default.createElement(
          'span',
          _extends({}, props, {
            style: Object.assign({}, style, { left: thumbLeft }),
            className: (0, _classnames2.default)('md-slider-discrete-value', className, {
              'md-slider-discrete-value--dragging': dragging
            })
          }),
          valueStr
        );
      }
    }]);

    return DiscreteValue;
  }(_react.PureComponent);

  DiscreteValue.propTypes = {
    style: _propTypes2.default.object,
    className: _propTypes2.default.string,
    discrete: _propTypes2.default.bool,
    dragging: _propTypes2.default.bool,
    active: _propTypes2.default.bool,
    value: _propTypes2.default.number.isRequired,
    thumbLeft: _propTypes2.default.string.isRequired,
    valuePrecision: _propTypes2.default.number.isRequired
  };
  exports.default = DiscreteValue;
});

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(9), __webpack_require__(3), __webpack_require__(12), __webpack_require__(17), __webpack_require__(14), __webpack_require__(16), __webpack_require__(267), __webpack_require__(1193), __webpack_require__(1194), __webpack_require__(20), __webpack_require__(1166), __webpack_require__(1169), __webpack_require__(84)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('react-dom'), require('classnames'), require('react-prop-types/lib/deprecated'), require('react-prop-types/lib/isRequiredForA11y'), require('../constants/keyCodes'), require('../utils/getField'), require('../utils/EventUtils/isValidClick'), require('../utils/NumberUtils/calculateValueDistance'), require('../utils/NumberUtils/isWithinStep'), require('../utils/PropTypes/controlled'), require('./SliderLabel'), require('./Track'), require('../TextFields/TextField'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.reactDom, global.classnames, global.deprecated, global.isRequiredForA11y, global.keyCodes, global.getField, global.isValidClick, global.calculateValueDistance, global.isWithinStep, global.controlled, global.SliderLabel, global.Track, global.TextField);
    global.Slider = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _reactDom, _classnames, _deprecated, _isRequiredForA11y, _keyCodes, _getField, _isValidClick, _calculateValueDistance, _isWithinStep, _controlled, _SliderLabel, _Track, _TextField) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _deprecated2 = _interopRequireDefault(_deprecated);

  var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);

  var _getField2 = _interopRequireDefault(_getField);

  var _isValidClick2 = _interopRequireDefault(_isValidClick);

  var _calculateValueDistance2 = _interopRequireDefault(_calculateValueDistance);

  var _isWithinStep2 = _interopRequireDefault(_isWithinStep);

  var _controlled2 = _interopRequireDefault(_controlled);

  var _SliderLabel2 = _interopRequireDefault(_SliderLabel);

  var _Track2 = _interopRequireDefault(_Track);

  var _TextField2 = _interopRequireDefault(_TextField);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Slider = function (_PureComponent) {
    _inherits(Slider, _PureComponent);

    function Slider(props) {
      _classCallCheck(this, Slider);

      var _this = _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));

      var scale = Math.abs(props.max - props.min) / props.step;

      var value = typeof props.value !== 'undefined' ? props.value : props.defaultValue;

      var distance = value;
      if (distance === props.min) {
        distance = 0;
      } else if (distance === props.max) {
        distance = 100;
      } else if (props.min > 1 && props.defaultValue !== 0) {
        distance = Math.max(0, Math.min(100, (props.defaultValue - props.min) / (props.max - props.min) * 100));
      } else {
        distance = value / props.max * 100;
      }

      var thumbLeft = _this._calcLeft(distance);
      var trackFillWidth = distance + '%';

      if (typeof props.value !== 'undefined') {
        value = undefined;
      }

      var trackWidth = void 0;
      if (props.label && !props.editable && !props.leftIcon && !props.rightIcon) {
        trackWidth = '100%';
      }

      _this.state = {
        value: value,
        scale: scale,
        distance: distance,
        thumbLeft: thumbLeft,
        trackWidth: trackWidth,
        trackFillWidth: trackFillWidth,
        active: false,
        dragging: false,
        maskInked: false
      };
      _this._dragAdded = false;

      _this._focusThumb = _this._focusThumb.bind(_this);
      _this._updatePosition = _this._updatePosition.bind(_this);
      _this._handleDragStart = _this._handleDragStart.bind(_this);
      _this._handleDragMove = _this._handleDragMove.bind(_this);
      _this._handleDragEnd = _this._handleDragEnd.bind(_this);
      _this._handleFocus = _this._handleFocus.bind(_this);
      _this._handleKeyUp = _this._handleKeyUp.bind(_this);
      _this._handleKeyDown = _this._handleKeyDown.bind(_this);
      _this._handleIncrement = _this._handleIncrement.bind(_this);
      _this._handleTextFieldChange = _this._handleTextFieldChange.bind(_this);
      _this._blurOnOutsideClick = _this._blurOnOutsideClick.bind(_this);
      _this._calcTrackWidth = _this._calcTrackWidth.bind(_this);
      _this._animateDiscreteInk = _this._animateDiscreteInk.bind(_this);
      _this._setTrack = _this._setTrack.bind(_this);
      _this._setField = _this._setField.bind(_this);
      _this._setNode = _this._setNode.bind(_this);
      return _this;
    }

    _createClass(Slider, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var _props = this.props,
            leftIcon = _props.leftIcon,
            rightIcon = _props.rightIcon,
            label = _props.label,
            min = _props.min,
            max = _props.max,
            step = _props.step;

        if (leftIcon !== nextProps.leftIcon || rightIcon !== nextProps.rightIcon || label !== nextProps.label) {
          this._calcTrackWidth(nextProps);
        }

        if (min !== nextProps.min || max !== nextProps.max || step !== nextProps.step) {
          this.setState({ scale: Math.abs(nextProps.max - nextProps.min) / nextProps.step });
        }
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps, prevState) {
        var _state = this.state,
            active = _state.active,
            manualIncrement = _state.manualIncrement;

        var fn = window[(active ? 'add' : 'remove') + 'EventListener'];
        if (active !== prevState.active) {
          fn('click', this._blurOnOutsideClick);

          if (active) {
            this._focusThumb();
          }
        }

        var addDrag = active && !manualIncrement;
        fn = window[(addDrag ? 'add' : 'remove') + 'EventListener'];
        if (this._dragAdded !== addDrag) {
          fn('mousemove', this._handleDragMove);
          fn('mouseup', this._handleDragEnd);
          fn('touchmove', this._handleDragMove);
          fn('touchend', this._handleDragEnd);

          this._dragAdded = addDrag;
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this._dragAdded) {
          var rm = window.removeEventListener;
          rm('mousemove', this._handleMouseMove);
          rm('mouseup', this._handleMouseUp);
          rm('touchmove', this._handleDragMove);
          rm('touchend', this._handleDragEnd);
          rm('click', this._blurOnOutsideClick);
        }

        if (this._inkTimeout) {
          clearTimeout(this._inkTimeout);
        }

        if (this._focusTimeout) {
          clearTimeout(this._focusTimeout);
        }
      }
    }, {
      key: '_calcLeft',
      value: function _calcLeft(value) {
        return 'calc(' + value + '% - 6px)';
      }
    }, {
      key: '_isTextField',
      value: function _isTextField(target) {
        return this._textField && this._textField.contains(target);
      }
    }, {
      key: '_isValidClassList',
      value: function _isValidClassList(classList) {
        var invalid = false;
        ['md-slider-label', 'md-slider-ind', 'md-icon'].some(function (cl) {
          invalid = classList.contains(cl);
          return invalid;
        });

        return !invalid;
      }
    }, {
      key: '_updatePosition',
      value: function _updatePosition(e, normalize) {
        var x = (e.changedTouches ? e.changedTouches[0] : e).clientX;
        var scale = this.state.scale;
        var _props2 = this.props,
            onChange = _props2.onChange,
            onDragChange = _props2.onDragChange,
            min = _props2.min,
            max = _props2.max,
            step = _props2.step;

        var _calculateValueDistan = (0, _calculateValueDistance2.default)(x, this._track.offsetWidth, this._track.getBoundingClientRect().left, scale, step, min, max, normalize),
            value = _calculateValueDistan.value,
            distance = _calculateValueDistan.distance;

        if (onChange) {
          onChange(value, e);
        }

        if (!normalize && onDragChange) {
          onDragChange(distance, value, e);
        }

        var state = {
          value: value,
          active: true,
          distance: distance,
          manualIncrement: false,
          dragging: !normalize,
          thumbLeft: this._calcLeft(distance),
          trackFillWidth: distance + '%'
        };

        if (e.type === 'touchend' || e.type === 'mousedown') {
          state.maskInked = false;
        }

        if (typeof this.props.value !== 'undefined') {
          delete state.value;
        }

        this.setState(state);
      }
    }, {
      key: '_handleDragStart',
      value: function _handleDragStart(e) {
        if (e.type === 'mousedown' && this.props.onMouseDown) {
          this.props.onMouseDown(e);
        } else if (e.type === 'touchstart' && this.props.onTouchStart) {
          this.props.onTouchStart(e);
        }

        if (this.props.disabled || e.type === 'mousedown' && !(0, _isValidClick2.default)(e, 'mousedown') || e.target.className.match(/text-field/)) {
          return;
        }

        var classList = e.target.classList;

        var isDiscreteValue = classList.contains('md-slider-discrete-value');
        if (classList.contains('md-slider-thumb') || isDiscreteValue) {
          // Prevents text highlighting while dragging.
          e.preventDefault();
          this.setState({ dragging: true, active: true, manualIncrement: false, maskInked: false });
        } else if (!this._isTextField(e.target) && this._isValidClassList(classList)) {
          this._updatePosition(e, true);
        }
      }
    }, {
      key: '_setNode',
      value: function _setNode(node) {
        this._node = (0, _reactDom.findDOMNode)(node);
      }
    }, {
      key: '_setTrack',
      value: function _setTrack(track) {
        this._track = (0, _reactDom.findDOMNode)(track);
      }
    }, {
      key: '_setField',
      value: function _setField(field) {
        this._field = (0, _reactDom.findDOMNode)(field);
        this._calcTrackWidth(this.props);
      }
    }, {
      key: '_handleDragMove',
      value: function _handleDragMove(e) {
        if (this.props.disabled || !this.state.dragging) {
          return;
        }

        // Stops the text highlighting while dragging
        e.preventDefault();

        this._updatePosition(e, false);
      }
    }, {
      key: '_handleDragEnd',
      value: function _handleDragEnd(e) {
        if (!this.state.dragging || this.props.disabled || e.type === 'mouseup' && !(0, _isValidClick2.default)(e)) {
          return;
        }

        this._updatePosition(e, true);
      }
    }, {
      key: '_blurOnOutsideClick',
      value: function _blurOnOutsideClick(e) {
        if (this.state.dragging && !this.state.manualIncrement || this.props.disabled) {
          return;
        }

        if (!this._node.contains(e.target)) {
          this.setState({ active: false, maskInked: false });
        }
      }
    }, {
      key: '_handleIncrement',
      value: function _handleIncrement(incrementedValue, e, disableTransition) {
        var _props3 = this.props,
            onChange = _props3.onChange,
            min = _props3.min,
            max = _props3.max,
            discrete = _props3.discrete;


        var distance = Math.max(0, Math.min(100, (incrementedValue - min) / (max - min) * 100));
        var value = Math.max(min, Math.min(max, incrementedValue));

        if (onChange) {
          onChange(value, e);
        }

        var state = {
          distance: distance,
          manualIncrement: true,
          thumbLeft: this._calcLeft(distance),
          trackFillWidth: distance + '%',
          dragging: Math.abs(this.state.distance - distance) < 2 && disableTransition
        };

        if (typeof this.props.value === 'undefined') {
          state.value = value;
        }

        if (e.type === 'keydown' && !discrete) {
          state.maskInked = true;
        }

        this.setState(state);
      }
    }, {
      key: '_handleTextFieldChange',
      value: function _handleTextFieldChange(newValue, e) {
        this._handleIncrement(newValue, e, false);
      }
    }, {
      key: '_handleKeyDown',
      value: function _handleKeyDown(e) {
        var key = e.which || e.keyCode;
        var _props4 = this.props,
            min = _props4.min,
            max = _props4.max,
            step = _props4.step,
            disabled = _props4.disabled;

        if (disabled) {
          return;
        }

        if (key === _keyCodes.TAB) {
          this.setState({ active: false, maskInked: false });
          return;
        } else if (key !== _keyCodes.LEFT && key !== _keyCodes.RIGHT) {
          return;
        }

        var nextValue = (0, _getField2.default)(this.props, this.state);
        nextValue = Math.max(min, Math.min((key === _keyCodes.LEFT ? -step : step) + nextValue, max));

        this._handleIncrement(nextValue, e, true);
      }
    }, {
      key: '_handleKeyUp',
      value: function _handleKeyUp(e) {
        if ((e.which || e.keyCode) !== _keyCodes.TAB) {
          return;
        }

        if (this.props.discrete) {
          this._animateDiscreteInk();
        }

        this.setState({ maskInked: true });
      }
    }, {
      key: '_handleFocus',
      value: function _handleFocus() {
        this.setState({ active: true });
      }
    }, {
      key: '_calcTrackWidth',
      value: function _calcTrackWidth(props) {
        var editable = props.editable,
            leftIcon = props.leftIcon,
            rightIcon = props.rightIcon,
            inputWidth = props.inputWidth,
            label = props.label;


        if (!label) {
          this.setState({ trackWidth: null });
          return;
        }

        var trackWidth = null;
        if (!leftIcon && !rightIcon && !editable) {
          trackWidth = '100%';
        } else if (editable && !leftIcon) {
          var cs = window.getComputedStyle(this._textField);
          var pl = parseInt(cs.getPropertyValue('padding-left'), 10);
          var ml = parseInt(cs.getPropertyValue('margin-left'), 10);

          trackWidth = pl + ml + inputWidth;
        }

        if (trackWidth) {
          this.setState({ trackWidth: trackWidth });
        }
      }
    }, {
      key: '_animateDiscreteInk',
      value: function _animateDiscreteInk() {
        var _this2 = this;

        var wait = this.props.discreteInkTransitionTime;
        if (this._inkTimeout) {
          clearTimeout(this._inkTimeout);
        }

        this._inkTimeout = setTimeout(function () {
          _this2.setState({ leaving: true, maskInked: false });

          _this2._inkTimeout = setTimeout(function () {
            _this2._inkTimeout = null;
            _this2.setState({ leaving: false });
          }, wait);
        }, wait);
      }
    }, {
      key: '_focusThumb',
      value: function _focusThumb() {
        var _this3 = this;

        if (this._focusTimeout) {
          clearTimeout(this._focusTimeout);
        }

        this._focusTimeout = setTimeout(function () {
          _this3._focusTimeout = null;
          if (!_this3._thumb) {
            _this3._thumb = _this3._node.querySelector('.md-slider-thumb');
          }

          _this3._thumb.focus();
        }, 100);
      }
    }, {
      key: 'render',
      value: function render() {
        var _state2 = this.state,
            dragging = _state2.dragging,
            active = _state2.active,
            thumbLeft = _state2.thumbLeft,
            trackFillWidth = _state2.trackFillWidth,
            maskInked = _state2.maskInked,
            trackWidth = _state2.trackWidth,
            scale = _state2.scale,
            distance = _state2.distance;

        var _props5 = this.props,
            id = _props5.id,
            min = _props5.min,
            max = _props5.max,
            disabled = _props5.disabled,
            className = _props5.className,
            trackStyle = _props5.trackStyle,
            trackClassName = _props5.trackClassName,
            thumbStyle = _props5.thumbStyle,
            thumbClassName = _props5.thumbClassName,
            discreteValueStyle = _props5.discreteValueStyle,
            discreteValueClassName = _props5.discreteValueClassName,
            label = _props5.label,
            editable = _props5.editable,
            step = _props5.step,
            inputWidth = _props5.inputWidth,
            leftIcon = _props5.leftIcon,
            rightIcon = _props5.rightIcon,
            discrete = _props5.discrete,
            discreteTicks = _props5.discreteTicks,
            tickWidth = _props5.tickWidth,
            valuePrecision = _props5.valuePrecision,
            props = _objectWithoutProperties(_props5, ['id', 'min', 'max', 'disabled', 'className', 'trackStyle', 'trackClassName', 'thumbStyle', 'thumbClassName', 'discreteValueStyle', 'discreteValueClassName', 'label', 'editable', 'step', 'inputWidth', 'leftIcon', 'rightIcon', 'discrete', 'discreteTicks', 'tickWidth', 'valuePrecision']);

        delete props.value;
        delete props.onChange;
        delete props.onDragChange;
        delete props.discreteInkTransitionTime;

        // delete deprecated
        delete props.stepPrecision;

        var value = (0, _getField2.default)(this.props, this.state);
        var rightChildren = rightIcon;
        if (editable) {
          rightChildren = _react2.default.createElement(_TextField2.default, {
            id: id + 'Editor',
            ref: this._setField,
            type: 'number',
            value: value,
            inputClassName: 'md-slider-editor',
            style: { width: inputWidth },
            onChange: this._handleTextFieldChange,
            step: step
          });
        }

        return _react2.default.createElement(
          'div',
          _extends({}, props, {
            ref: this._setNode,
            className: (0, _classnames2.default)('md-slider-container', className, {
              'md-pointer--hover': !disabled
            }),
            onMouseDown: this._handleDragStart,
            onTouchStart: this._handleDragStart
          }),
          _react2.default.createElement(
            _SliderLabel2.default,
            { htmlFor: id },
            label
          ),
          _react2.default.createElement('input', {
            id: id,
            type: 'range',
            className: 'md-slider-input',
            readOnly: true,
            min: min,
            max: max,
            value: value,
            disabled: disabled
          }),
          leftIcon,
          _react2.default.createElement(_Track2.default, {
            ref: this._setTrack,
            style: Object.assign({}, trackStyle, { width: trackWidth }),
            className: (0, _classnames2.default)(trackClassName, {
              'md-slider-track--ind-left': leftIcon,
              'md-slider-track--ind-right': rightIcon
            }),
            thumbStyle: thumbStyle,
            thumbClassName: thumbClassName,
            discreteValueStyle: discreteValueStyle,
            discreteValueClassName: discreteValueClassName,
            active: active,
            dragging: dragging,
            disabled: disabled,
            thumbLeft: thumbLeft,
            trackFillWidth: trackFillWidth,
            on: !disabled && distance > min,
            off: distance === 0,
            maskInked: maskInked,
            onThumbKeyUp: this._handleKeyUp,
            onThumbKeyDown: this._handleKeyDown,
            onThumbFocus: this._handleFocus,
            discrete: discrete,
            tickWidth: tickWidth,
            discreteTicks: discreteTicks,
            valuePrecision: valuePrecision,
            step: step,
            scale: scale,
            value: value
          }),
          rightChildren
        );
      }
    }]);

    return Slider;
  }(_react.PureComponent);

  Slider.propTypes = {
    /**
     * An id to use for the `Slider`. This is required if the `label` prop
     * is defined.
     */
    id: function id(props, propName, component) {
      for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        others[_key - 3] = arguments[_key];
      }

      if (typeof props.label === 'undefined') {
        return _propTypes2.default.string.apply(_propTypes2.default, [props, propName, component].concat(others));
      }

      return (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])).apply(undefined, [props, propName, component].concat(others));
    },

    /**
     * An optional style to apply to the slider's container.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply to the slider's container.
     */
    className: _propTypes2.default.string,

    /**
     * An optional style to apply to the slider's thumb.
     */
    thumbStyle: _propTypes2.default.object,

    /**
     * An optionl className to apply to the slider's thumb.
     */
    thumbClassName: _propTypes2.default.string,

    /**
     * An optional style to apply to the slider's track.
     */
    trackStyle: _propTypes2.default.object,

    /**
     * An optional className to apply to the slider's track.
     */
    trackClassName: _propTypes2.default.string,

    /**
     * An optional style to apply to the slider's track fill.
     */
    trackFillStyle: _propTypes2.default.object,

    /**
     * An optional className to apply to the slider's track fill.
     */
    trackFillClassName: _propTypes2.default.string,

    /**
     * An optional style to apply to a discrete slider's value.
     */
    discreteValueStyle: _propTypes2.default.object,

    /**
     * An optional className to apply to a discrete slider's value.
     */
    discreteValueClassName: _propTypes2.default.string,

    /**
     * The default value for the slider.
     */
    defaultValue: _propTypes2.default.number.isRequired,

    /**
     * The min value for the slider. The min and max values must be on the same
     * side of 0. It is currently invalid to have a range from negative to positive.
     */
    min: function min(props, propName, component) {
      for (var _len2 = arguments.length, others = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
        others[_key2 - 3] = arguments[_key2];
      }

      var _PropTypes$number;

      var err = (_PropTypes$number = _propTypes2.default.number).isRequired.apply(_PropTypes$number, [props, propName, component].concat(others));
      if (!err) {
        var min = props[propName];
        var name = void 0;
        if (min > props.value) {
          name = 'value';
        } else if (min > props.defaultValue) {
          name = 'defaultValue';
        }

        if (name) {
          err = new Error('The \'' + propName + '\' prop must be less than or equal to the \'' + name + '\' prop for the \'' + component + '\' but ' + ('received: \'min: ' + min + '\' and \'' + name + ': ' + props[name] + '\''));
        } else if (min < 0 && props.max > 0) {
          err = new Error('The \'' + component + '\' is unable to have a range spanning from negative to positive. The range ' + 'must either be all negative or all postive.');
        }
      }

      return err;
    },

    /**
     * The max value for the slider. The max value must be greater than the min value
     * and the min and max values must be on the same side of 0. It is currently
     * invalid to have a range from negative to positive.
     */
    max: function max(props, propName, component) {
      for (var _len3 = arguments.length, others = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
        others[_key3 - 3] = arguments[_key3];
      }

      var _PropTypes$number2;

      var err = (_PropTypes$number2 = _propTypes2.default.number).isRequired.apply(_PropTypes$number2, [props, propName, component].concat(others));
      if (!err) {
        var max = props[propName];
        var name = void 0;
        if (max < props.value) {
          name = 'value';
        } else if (max < props.defaultValue) {
          name = 'defaultValue';
        }

        if (name) {
          err = new Error('The \'' + propName + '\' prop must be greater than or equal to the \'' + name + '\' prop for the \'' + component + '\' but ' + ('received: \'' + propName + ': ' + max + '\' and \'' + name + ': ' + props[name] + '\''));
        }
      }

      return err;
    },

    /**
     * Boolean if the slider is disabled.
     */
    disabled: _propTypes2.default.bool,

    /**
     * An optional value for the slider. This will make the component controlled
     * and require the `onChange` function.
     */
    value: (0, _controlled2.default)(_propTypes2.default.number, 'onChange'),

    /**
     * This is called when the slider's value gets updated. The value can be updated
     * by one of the following:
     *
     * - Clicking a section of the slider
     * - Dragging the slider with the mouse
     * - Touching a section of the slider.
     * - Dragging the slider with touch
     * - Using the text field to update the value either by typing or incrementing
     * - Using the left or right arrow keys to increment/decrement the value.
     *
     * The callback for this function is as follows:
     *
     * ```js
     * onChange(value, event);
     * ```
     *
     * where the event can either be:
     * - a touch start event
     * - a touch move event
     * - a touch end event
     * - a mouse down event
     * - a mouse move event
     * - a mouse up event
     * - a key up event
     * - a key down event
     */
    onChange: _propTypes2.default.func,

    /**
     * This is only called when the user is dragging the slider with either
     * the mouse or touch. Probably not really usefull. It just includes the
     * new drag percentage while the `onChange` does not.
     *
     * The callback for this function is defined as:
     *
     * ```js
     * onDragChange(dragPercentage, value, (touchMove || mouseMove) event);
     * ```
     */
    onDragChange: _propTypes2.default.func,

    /**
     * An optional function to call when the slider's container has
     * the mousedown event.
     */
    onMouseDown: _propTypes2.default.func,

    /**
     * An optional function to call when the slider's container has
     * the touchstart event.
     */
    onTouchStart: _propTypes2.default.func,

    /**
     * An optional icon or letter to place to the left of the slider.
     * if you want to use a non-font icon or a letter, use the `md-slider-ind`
     * className on your element.
     */
    leftIcon: _propTypes2.default.element,

    /**
     * An optional icon or letter to place to the right of the slider.
     * if you want to use a non-font icon or a letter, use the `md-slider-ind`
     * className on your element.
     *
     * > NOTE: This can not be used if the `editable` prop is true.
     */
    rightIcon: _propTypes2.default.element,

    /**
     * An optional label to display above the slider. If this prop
     * is set, then an `id` must also be given.
     */
    label: _propTypes2.default.node,

    /**
     * The incremental amount when the user hits left or right with the
     * keyboard arrows, or the user hits the up or down buttons in the
     * editable number text field. This number must be a number between
     * 0 and 1 or a whole number above 1.
     */
    step: function step(props, propName, component) {
      for (var _len4 = arguments.length, others = Array(_len4 > 3 ? _len4 - 3 : 0), _key4 = 3; _key4 < _len4; _key4++) {
        others[_key4 - 3] = arguments[_key4];
      }

      var _PropTypes$number3;

      var err = (_PropTypes$number3 = _propTypes2.default.number).isRequired.apply(_PropTypes$number3, [props, propName, component].concat(others));
      if (!err) {
        var step = props[propName];
        if (step <= 0) {
          err = new Error('The \'' + propName + '\' for the \'' + component + '\' must be a number greater than 0. The ' + ('current value is \'' + step + '\'.'));
        } else {
          var valueDefined = typeof props.value !== 'undefined';
          var name = void 0;
          if (!(0, _isWithinStep2.default)(valueDefined ? props.value : props.defaultValue, step)) {
            name = valueDefined ? 'value' : 'defaultValue';
          }

          if (name) {
            err = new Error('The \'' + name + '\' prop on \'' + component + '\' should be a number divisible by the ' + ('\'' + propName + '\' prop. The current value is \'' + props[name] + '\' and the \'' + propName + '\' ') + ('is \'' + step + '\'.'));
          }
        }
      }

      return err;
    },

    /**
     * Boolean if the Slider should be editable. This will place a number text field
     * to the right of the slider. If this prop is set to `true`, the `rightIcon`
     * prop can not be set.
     */
    editable: function editable(props, propName, component) {
      for (var _len5 = arguments.length, others = Array(_len5 > 3 ? _len5 - 3 : 0), _key5 = 3; _key5 < _len5; _key5++) {
        others[_key5 - 3] = arguments[_key5];
      }

      var _PropTypes$bool;

      if (typeof props[propName] === 'undefined') {
        return null;
      }

      var err = (_PropTypes$bool = _propTypes2.default.bool).isRequired.apply(_PropTypes$bool, [props, propName, component].concat(others));
      if (!err && typeof props.rightIcon !== 'undefined') {
        err = new Error('The \'' + component + '\' is unable to be \'editable\' and include a \'rightIcon\'.');
      }

      return err;
    },

    /**
     * The width for the number text field when the Slider is editable.
     */
    inputWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,

    /**
     * Boolean if the slider should be discrete. This will update the slider to include a
     * _balloon_ with the current value inside. It will also not allow the `Slider` to be
     * editable.
     */
    discrete: function discrete(props, propName, component) {
      for (var _len6 = arguments.length, others = Array(_len6 > 3 ? _len6 - 3 : 0), _key6 = 3; _key6 < _len6; _key6++) {
        others[_key6 - 3] = arguments[_key6];
      }

      if (typeof props[propName] === 'undefined') {
        return null;
      }

      var err = _propTypes2.default.bool.apply(_propTypes2.default, [props, propName, component].concat(others));
      if (!err && typeof props.editable !== 'undefined') {
        err = new Error('The \'' + component + '\' cannot be \'discrete\' and \'editable\'. Please choose one.');
      }

      return err;
    },

    /**
     * The width of each tick for a discrete slider with ticks. This can either be a number
     * which gets converted to `px`, or a valid css unit.
     */
    tickWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,

    /**
     * This is number divisible by the total number of values included in the Slider. Every
     * value that is divisible by this number will include a tick mark. It is common recommended
     * to have this equal to the `step` prop.
     *
     * This prop is completely optional.
     */
    discreteTicks: function discreteTicks(props, propName, component) {
      for (var _len7 = arguments.length, others = Array(_len7 > 3 ? _len7 - 3 : 0), _key7 = 3; _key7 < _len7; _key7++) {
        others[_key7 - 3] = arguments[_key7];
      }

      if (typeof props[propName] === 'undefined') {
        return null;
      }

      var err = _propTypes2.default.number.apply(_propTypes2.default, [props, propName, component].concat(others));
      if (!err) {
        var min = props.min,
            max = props.max,
            step = props.step;

        var range = Math.abs(max - min);

        if (range / props[propName] % 1 !== 0) {
          err = new Error('The \'' + propName + '\' must be a number divisible by the range set by the \'min\' and ' + ('\'max\' props. The current range is \'' + range + '\' by including the min: \'' + min + '\' and ') + ('max: \'' + max + '\' values. The current value of \'' + propName + '\' is \'' + props[propName] + '\'.'));
        } else if (props[propName] % step !== 0) {
          err = new Error('The \'step\' prop must be a number divisible by the \'' + propName + '\'. It is common to have ' + ('them as the same value. The current \'step\' is \'' + step + '\' and the \'' + propName + '\' is \'' + props[propName] + '\'.'));
        }
      }

      return err;
    },

    /**
     * The transition time for a discrete Slider's keyboard focus ink. This should match the
     * `md-slider-discrete-ink-transition-time` value in your SCSS. This is used because
     * the ink is only visible temporarily for a discrete slider when keyboard focusing.
     */
    discreteInkTransitionTime: _propTypes2.default.number.isRequired,

    /**
     * The precision that the value should be rounded to when the Slider is updated. This
     * needs to be a whole number greater than or equal to 0.
     */
    valuePrecision: function valuePrecision(props, propName, component) {
      for (var _len8 = arguments.length, others = Array(_len8 > 3 ? _len8 - 3 : 0), _key8 = 3; _key8 < _len8; _key8++) {
        others[_key8 - 3] = arguments[_key8];
      }

      var _PropTypes$number4;

      var err = (_PropTypes$number4 = _propTypes2.default.number).isRequired.apply(_PropTypes$number4, [props, propName, component].concat(others));
      if (!err) {
        var precision = props[propName];

        if (precision % 1 !== 0 || precision < 0) {
          err = new Error('The \'' + propName + '\' must be a positive whole number or 0 on the \'' + component + '\'. ' + ('The current \'' + propName + '\' is \'' + precision + '\''));
        }
      }

      return err;
    },

    stepPrecision: (0, _deprecated2.default)(_propTypes2.default.number, 'Use `step` and `valuePreceision` instead')
  };
  Slider.defaultProps = {
    defaultValue: 0,
    min: 0,
    max: 100,
    step: 1,
    inputWidth: 40,
    tickWidth: 6,
    discreteInkTransitionTime: 300,
    valuePrecision: 0
  };
  exports.default = Slider;
});

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames);
    global.SliderLabel = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var SliderLabel = function (_PureComponent) {
    _inherits(SliderLabel, _PureComponent);

    function SliderLabel() {
      _classCallCheck(this, SliderLabel);

      return _possibleConstructorReturn(this, (SliderLabel.__proto__ || Object.getPrototypeOf(SliderLabel)).apply(this, arguments));
    }

    _createClass(SliderLabel, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            children = _props.children,
            className = _props.className,
            htmlFor = _props.htmlFor,
            props = _objectWithoutProperties(_props, ['children', 'className', 'htmlFor']);

        if (!children) {
          return null;
        }

        return _react2.default.createElement(
          'label',
          _extends({}, props, {
            htmlFor: htmlFor,
            className: (0, _classnames2.default)('md-slider-label md-text', className)
          }),
          children
        );
      }
    }]);

    return SliderLabel;
  }(_react.PureComponent);

  SliderLabel.propTypes = {
    className: _propTypes2.default.string,
    children: _propTypes2.default.node,
    htmlFor: function htmlFor(props, propName, component) {
      for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        others[_key - 3] = arguments[_key];
      }

      var _PropTypes$string;

      if (typeof props.children === 'undefined') {
        return null;
      }

      return (_PropTypes$string = _propTypes2.default.string).isRequired.apply(_PropTypes$string, [props, propName, component].concat(others));
    }
  };
  exports.default = SliderLabel;
});

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(155)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('../Helpers/AccessibleFakeButton'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.AccessibleFakeButton);
    global.Thumb = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _AccessibleFakeButton) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _AccessibleFakeButton2 = _interopRequireDefault(_AccessibleFakeButton);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Thumb = function (_PureComponent) {
    _inherits(Thumb, _PureComponent);

    function Thumb() {
      _classCallCheck(this, Thumb);

      return _possibleConstructorReturn(this, (Thumb.__proto__ || Object.getPrototypeOf(Thumb)).apply(this, arguments));
    }

    _createClass(Thumb, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            style = _props.style,
            className = _props.className,
            on = _props.on,
            off = _props.off,
            active = _props.active,
            disabled = _props.disabled,
            dragging = _props.dragging,
            thumbLeft = _props.thumbLeft,
            discrete = _props.discrete,
            props = _objectWithoutProperties(_props, ['style', 'className', 'on', 'off', 'active', 'disabled', 'dragging', 'thumbLeft', 'discrete']);

        return _react2.default.createElement(_AccessibleFakeButton2.default, _extends({
          disabled: disabled
        }, props, {
          style: Object.assign({}, style, { left: thumbLeft }),
          className: (0, _classnames2.default)('md-slider-thumb', className, {
            'md-slider-thumb--active': active,
            'md-slider-thumb--dragging': dragging,
            'md-slider-thumb--disabled': disabled,
            'md-slider-thumb--on': on,
            'md-slider-thumb--continuous-off': !discrete && off,
            'md-slider-thumb--discrete': discrete,
            'md-slider-thumb--discrete-on': discrete && active && on,
            'md-slider-thumb--discrete-off': discrete && !disabled && off,
            'md-slider-thumb--discrete-active': discrete && active,
            'md-slider-thumb--discrete-active-off': discrete && active && off
          })
        }));
      }
    }]);

    return Thumb;
  }(_react.PureComponent);

  Thumb.propTypes = {
    style: _propTypes2.default.object,
    className: _propTypes2.default.string,
    thumbLeft: _propTypes2.default.string.isRequired,
    on: _propTypes2.default.bool,
    off: _propTypes2.default.bool,
    active: _propTypes2.default.bool,
    disabled: _propTypes2.default.bool,
    dragging: _propTypes2.default.bool,
    discrete: _propTypes2.default.bool
  };
  exports.default = Thumb;
});

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames);
    global.ThumbMask = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var ThumbMask = function (_PureComponent) {
    _inherits(ThumbMask, _PureComponent);

    function ThumbMask() {
      _classCallCheck(this, ThumbMask);

      return _possibleConstructorReturn(this, (ThumbMask.__proto__ || Object.getPrototypeOf(ThumbMask)).apply(this, arguments));
    }

    _createClass(ThumbMask, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            style = _props.style,
            className = _props.className,
            thumbLeft = _props.thumbLeft,
            disabled = _props.disabled,
            dragging = _props.dragging,
            maskInked = _props.maskInked,
            discrete = _props.discrete,
            leaving = _props.leaving,
            props = _objectWithoutProperties(_props, ['style', 'className', 'thumbLeft', 'disabled', 'dragging', 'maskInked', 'discrete', 'leaving']);

        return _react2.default.createElement('span', _extends({}, props, {
          style: Object.assign({}, style, { left: thumbLeft }),
          className: (0, _classnames2.default)('md-slider-thumb md-slider-thumb--mask', className, {
            'md-slider-thumb--dragging': dragging,
            'md-slider-thumb--mask-inked': maskInked,
            'md-slider-thumb--mask-disabled': disabled,
            'md-slider-thumb--discrete-mask-inked': maskInked && discrete,
            'md-slider-thumb--discrete-mask-leaving': discrete && leaving
          })
        }));
      }
    }]);

    return ThumbMask;
  }(_react.PureComponent);

  ThumbMask.propTypes = {
    style: _propTypes2.default.object,
    className: _propTypes2.default.string,
    disabled: _propTypes2.default.bool,
    thumbLeft: _propTypes2.default.string.isRequired,
    maskInked: _propTypes2.default.bool,
    dragging: _propTypes2.default.bool,
    discrete: _propTypes2.default.bool,
    leaving: _propTypes2.default.bool
  };
  exports.default = ThumbMask;
});

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(1196), __webpack_require__(1170), __webpack_require__(1167), __webpack_require__(1168), __webpack_require__(1164)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('../utils/NumberUtils/updateUnit'), require('./TrackFill'), require('./Thumb'), require('./ThumbMask'), require('./DiscreteValue'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.updateUnit, global.TrackFill, global.Thumb, global.ThumbMask, global.DiscreteValue);
    global.Track = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _updateUnit, _TrackFill, _Thumb, _ThumbMask, _DiscreteValue) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _updateUnit2 = _interopRequireDefault(_updateUnit);

  var _TrackFill2 = _interopRequireDefault(_TrackFill);

  var _Thumb2 = _interopRequireDefault(_Thumb);

  var _ThumbMask2 = _interopRequireDefault(_ThumbMask);

  var _DiscreteValue2 = _interopRequireDefault(_DiscreteValue);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var half = function half(w) {
    return w / 2;
  };

  /**
   * The `Track` component is used for showing the current state of the slider.
   * It will render the `TrackFill`, `Thumb`, and `ThumbMask` components.
   */

  var Track = function (_PureComponent) {
    _inherits(Track, _PureComponent);

    function Track() {
      _classCallCheck(this, Track);

      return _possibleConstructorReturn(this, (Track.__proto__ || Object.getPrototypeOf(Track)).apply(this, arguments));
    }

    _createClass(Track, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            on = _props.on,
            off = _props.off,
            active = _props.active,
            disabled = _props.disabled,
            dragging = _props.dragging,
            className = _props.className,
            thumbLeft = _props.thumbLeft,
            trackFillWidth = _props.trackFillWidth,
            trackFillStyle = _props.trackFillStyle,
            trackFillClassName = _props.trackFillClassName,
            discreteValueStyle = _props.discreteValueStyle,
            discreteValueClassName = _props.discreteValueClassName,
            maskInked = _props.maskInked,
            maskLeaving = _props.maskLeaving,
            thumbStyle = _props.thumbStyle,
            thumbClassName = _props.thumbClassName,
            discrete = _props.discrete,
            onThumbFocus = _props.onThumbFocus,
            onThumbKeyUp = _props.onThumbKeyUp,
            onThumbKeyDown = _props.onThumbKeyDown,
            value = _props.value,
            tickWidth = _props.tickWidth,
            discreteTicks = _props.discreteTicks,
            scale = _props.scale,
            step = _props.step,
            valuePrecision = _props.valuePrecision,
            props = _objectWithoutProperties(_props, ['on', 'off', 'active', 'disabled', 'dragging', 'className', 'thumbLeft', 'trackFillWidth', 'trackFillStyle', 'trackFillClassName', 'discreteValueStyle', 'discreteValueClassName', 'maskInked', 'maskLeaving', 'thumbStyle', 'thumbClassName', 'discrete', 'onThumbFocus', 'onThumbKeyUp', 'onThumbKeyDown', 'value', 'tickWidth', 'discreteTicks', 'scale', 'step', 'valuePrecision']);

        var ticks = [];
        if (typeof discreteTicks !== 'undefined' && !disabled && discrete) {
          var amt = scale / (discreteTicks / step);
          var offset = (0, _updateUnit2.default)(tickWidth, half, 'px');
          var inc = 100 / amt;

          for (var i = 0; i <= amt; i++) {
            var left = i * inc + '%';
            var width = tickWidth;
            if (i === 0 || i === amt) {
              width = (0, _updateUnit2.default)(tickWidth, half);
            } else {
              left = 'calc(' + left + ' - ' + offset + ')';
            }

            ticks.push(_react2.default.createElement('span', {
              key: 'tick-' + i,
              className: 'md-slider-discrete-tick',
              style: { left: left, width: width }
            }));
          }
        }

        return _react2.default.createElement(
          'div',
          _extends({}, props, { className: (0, _classnames2.default)('md-slider-track', className) }),
          ticks,
          _react2.default.createElement(_TrackFill2.default, {
            style: trackFillStyle,
            className: trackFillClassName,
            disabled: disabled,
            dragging: dragging,
            trackFillWidth: trackFillWidth
          }),
          _react2.default.createElement(_Thumb2.default, {
            style: thumbStyle,
            className: thumbClassName,
            on: on,
            off: off,
            disabled: disabled,
            dragging: dragging,
            active: active,
            thumbLeft: thumbLeft,
            onFocus: onThumbFocus,
            onKeyUp: onThumbKeyUp,
            onKeyDown: onThumbKeyDown,
            discrete: discrete
          }),
          _react2.default.createElement(_DiscreteValue2.default, {
            style: discreteValueStyle,
            className: discreteValueClassName,
            discrete: discrete,
            dragging: dragging,
            active: active,
            value: value,
            thumbLeft: thumbLeft,
            valuePrecision: valuePrecision
          }),
          _react2.default.createElement(_ThumbMask2.default, {
            dragging: dragging,
            disabled: disabled,
            thumbLeft: thumbLeft,
            maskInked: maskInked,
            discrete: discrete,
            leaving: maskLeaving
          })
        );
      }
    }]);

    return Track;
  }(_react.PureComponent);

  Track.propTypes = {
    style: _propTypes2.default.object,
    className: _propTypes2.default.string,
    thumbStyle: _propTypes2.default.object,
    thumbClassName: _propTypes2.default.string,
    trackFillStyle: _propTypes2.default.object,
    trackFillClassName: _propTypes2.default.string,
    discreteValueStyle: _propTypes2.default.object,
    discreteValueClassName: _propTypes2.default.string,
    on: _propTypes2.default.bool,
    off: _propTypes2.default.bool,
    active: _propTypes2.default.bool,
    dragging: _propTypes2.default.bool,
    disabled: _propTypes2.default.bool,
    thumbLeft: _propTypes2.default.string.isRequired,
    trackFillWidth: _propTypes2.default.string.isRequired,
    value: _propTypes2.default.number.isRequired,
    discrete: _propTypes2.default.bool,
    maskInked: _propTypes2.default.bool,
    maskLeaving: _propTypes2.default.bool,
    onThumbKeyUp: _propTypes2.default.func.isRequired,
    onThumbKeyDown: _propTypes2.default.func.isRequired,
    onThumbFocus: _propTypes2.default.func.isRequired,
    scale: _propTypes2.default.number,
    step: _propTypes2.default.number,
    discreteTicks: _propTypes2.default.number,
    tickWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    valuePrecision: _propTypes2.default.number.isRequired
  };
  exports.default = Track;
});

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames);
    global.TrackFill = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var TrackFill = function (_PureComponent) {
    _inherits(TrackFill, _PureComponent);

    function TrackFill() {
      _classCallCheck(this, TrackFill);

      return _possibleConstructorReturn(this, (TrackFill.__proto__ || Object.getPrototypeOf(TrackFill)).apply(this, arguments));
    }

    _createClass(TrackFill, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            style = _props.style,
            className = _props.className,
            trackFillWidth = _props.trackFillWidth,
            dragging = _props.dragging,
            disabled = _props.disabled,
            props = _objectWithoutProperties(_props, ['style', 'className', 'trackFillWidth', 'dragging', 'disabled']);

        if (disabled) {
          return null;
        }

        return _react2.default.createElement('hr', _extends({}, props, {
          style: Object.assign({}, style, { width: trackFillWidth }),
          className: (0, _classnames2.default)('md-slider-track-fill', className, {
            'md-slider-track-fill--dragging': dragging
          })
        }));
      }
    }]);

    return TrackFill;
  }(_react.PureComponent);

  TrackFill.propTypes = {
    style: _propTypes2.default.object,
    className: _propTypes2.default.string,
    dragging: _propTypes2.default.bool,
    disabled: _propTypes2.default.bool,
    trackFillWidth: _propTypes2.default.string.isRequired
  };
  exports.default = TrackFill;
});

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1165)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./Slider'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.Slider);
    global.index = mod.exports;
  }
})(this, function (exports, _Slider) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _Slider2 = _interopRequireDefault(_Slider);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _Slider2.default;
});

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(11), __webpack_require__(572)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('../Buttons/Button'), require('./isInvalidAnimate'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.Button, global.isInvalidAnimate);
    global.Snackbar = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _Button, _isInvalidAnimate) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _Button2 = _interopRequireDefault(_Button);

  var _isInvalidAnimate2 = _interopRequireDefault(_isInvalidAnimate);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Snackbar = function (_PureComponent) {
    _inherits(Snackbar, _PureComponent);

    function Snackbar(props) {
      _classCallCheck(this, Snackbar);

      var _this = _possibleConstructorReturn(this, (Snackbar.__proto__ || Object.getPrototypeOf(Snackbar)).call(this, props));

      _this._clearTimeout = _this._clearTimeout.bind(_this);
      _this._handleClick = _this._handleClick.bind(_this);
      _this._handleAutohide = _this._handleAutohide.bind(_this);
      _this._handleWindowBlur = _this._handleWindowBlur.bind(_this);
      _this._handleWindowFocus = _this._handleWindowFocus.bind(_this);
      return _this;
    }

    _createClass(Snackbar, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        var _props = this.props,
            fab = _props.fab,
            multiline = _props.multiline,
            onAppear = _props.toast.onAppear;

        if (onAppear) {
          onAppear();
        }

        if (!fab || (0, _isInvalidAnimate2.default)(fab)) {
          return;
        }

        this._fab = fab.getComposedComponent().getComposedComponent();
        this._fab._animateForSnackbar(multiline);
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        this._handleAutohide();
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this._clearTimeout();

        if (this._eventType === 'focus') {
          window.removeEventListener('focus', this._handleWindowFocus);
        } else if (this._eventType === 'blur') {
          window.removeEventListener('blur', this._handleWindowBlur);
        }
      }
    }, {
      key: '_handleClick',
      value: function _handleClick(e) {
        var _props2 = this.props,
            onDismiss = _props2.onDismiss,
            action = _props2.toast.action,
            leaveTimeout = _props2.leaveTimeout,
            multiline = _props2.multiline;

        if (typeof action.onClick === 'function') {
          action.onClick(e);
        }

        if (this._fab) {
          this._fab._animateForSnackbar(multiline, leaveTimeout);
        }

        onDismiss();
      }
    }, {
      key: '_clearTimeout',
      value: function _clearTimeout() {
        if (this._timeout) {
          clearTimeout(this._timeout);
          this._timeout = null;
        }
      }
    }, {
      key: '_handleAutohide',
      value: function _handleAutohide() {
        var _this2 = this;

        var _props3 = this.props,
            autohide = _props3.autohide,
            autohideTimeout = _props3.autohideTimeout,
            onDismiss = _props3.onDismiss,
            multiline = _props3.multiline,
            leaveTimeout = _props3.leaveTimeout;

        if (!autohide) {
          return;
        }

        window.addEventListener('blur', this._handleWindowBlur);
        this._eventType = 'blur';
        this._timeout = setTimeout(function () {
          _this2._timeout = null;
          _this2._eventType = null;

          window.removeEventListener('blur', _this2._handleWindowBlur);

          if (_this2._fab) {
            _this2._fab._animateForSnackbar(multiline, leaveTimeout);
          }

          onDismiss();
        }, autohideTimeout || this.state.toast);
      }
    }, {
      key: '_handleWindowBlur',
      value: function _handleWindowBlur() {
        this._clearTimeout();
        window.removeEventListener('blur', this._handleWindowBlur);
        window.addEventListener('focus', this._handleWindowFocus);
        this._eventType = 'focus';
      }
    }, {
      key: '_handleWindowFocus',
      value: function _handleWindowFocus() {
        window.removeEventListener('focus', this._handleWindowFocus);
        this._eventType = null;
        this._handleAutohide();
      }
    }, {
      key: 'render',
      value: function render() {
        var _props4 = this.props,
            className = _props4.className,
            toast = _props4.toast,
            multiline = _props4.multiline,
            props = _objectWithoutProperties(_props4, ['className', 'toast', 'multiline']);

        delete props.id;
        delete props.fab;
        delete props.onDismiss;
        delete props.autohide;
        delete props.autohideTimeout;
        delete props.leaveTimeout;
        var text = toast.text,
            action = toast.action;
        var id = this.props.id;


        var Component = 'p';
        if (action) {
          Component = 'section';
          text = _react2.default.createElement(
            'p',
            { className: 'md-snackbar--toast md-snackbar--action' },
            text
          );

          var btnProps = {
            flat: true,
            onClick: this._handleClick,
            label: action,
            secondary: true,
            className: 'md-btn--snackbar'
          };

          if (typeof action !== 'string') {
            btnProps = Object.assign(btnProps, action, {
              className: (0, _classnames2.default)(btnProps.className, action.className)
            });
          }

          action = _react2.default.createElement(_Button2.default, btnProps);
        }

        if (!id) {
          id = 'snackbarAlert' + (action ? 'Dialog' : '');
        }

        var role = 'alert' + (action ? 'dialog' : '');
        return _react2.default.createElement(
          Component,
          _extends({}, props, {
            id: id,
            role: role,
            className: (0, _classnames2.default)('md-snackbar', {
              'md-snackbar--multiline': multiline,
              'md-snackbar--toast': !action
            }, className)
          }),
          text,
          action
        );
      }
    }]);

    return Snackbar;
  }(_react.PureComponent);

  Snackbar.propTypes = {
    id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    style: _propTypes2.default.object,
    className: _propTypes2.default.string,
    children: _propTypes2.default.node,
    onDismiss: _propTypes2.default.func.isRequired,
    toast: _propTypes2.default.shape({
      text: _propTypes2.default.node.isRequired,
      action: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.shape({
        label: _propTypes2.default.node.isRequired,
        onClick: _propTypes2.default.func
      })]),
      onAppear: _propTypes2.default.func
    }).isRequired,
    multiline: _propTypes2.default.bool,
    autohide: _propTypes2.default.bool,
    autohideTimeout: _propTypes2.default.number,
    fab: _propTypes2.default.object,
    leaveTimeout: _propTypes2.default.number.isRequired
  };
  exports.default = Snackbar;
});

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(9), __webpack_require__(66), __webpack_require__(12), __webpack_require__(16), __webpack_require__(38), __webpack_require__(572), __webpack_require__(82), __webpack_require__(1172)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('react-dom'), require('react-transition-group/CSSTransitionGroup'), require('react-prop-types/lib/deprecated'), require('../utils/getField'), require('../constants/CSSTransitionGroupTick'), require('./isInvalidAnimate'), require('../Helpers/Portal'), require('./Snackbar'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.reactDom, global.CSSTransitionGroup, global.deprecated, global.getField, global.CSSTransitionGroupTick, global.isInvalidAnimate, global.Portal, global.Snackbar);
    global.SnackbarContainer = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _reactDom, _CSSTransitionGroup, _deprecated, _getField, _CSSTransitionGroupTick, _isInvalidAnimate, _Portal, _Snackbar) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);

  var _deprecated2 = _interopRequireDefault(_deprecated);

  var _getField2 = _interopRequireDefault(_getField);

  var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);

  var _isInvalidAnimate2 = _interopRequireDefault(_isInvalidAnimate);

  var _Portal2 = _interopRequireDefault(_Portal);

  var _Snackbar2 = _interopRequireDefault(_Snackbar);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var _slicedToArray = function () {
    function sliceIterator(arr, i) {
      var _arr = [];
      var _n = true;
      var _d = false;
      var _e = undefined;

      try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);

          if (i && _arr.length === i) break;
        }
      } catch (err) {
        _d = true;
        _e = err;
      } finally {
        try {
          if (!_n && _i["return"]) _i["return"]();
        } finally {
          if (_d) throw _e;
        }
      }

      return _arr;
    }

    return function (arr, i) {
      if (Array.isArray(arr)) {
        return arr;
      } else if (Symbol.iterator in Object(arr)) {
        return sliceIterator(arr, i);
      } else {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }
    };
  }();

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var CHAINED_TOAST_DELAY = 50;

  /**
   * The `Snackbar` component is used for displaying a concise and small message to the user about
   * an operation performed.
   *
   * > The main component for the `Snackbar` is actually named the `SnackbarContainer`, so you need
   * to make sure the import is `react-md/lib/Snackbars` or `react-md/lib/Snackbars/SnackbarContainer`.
   * The first import is preferable.
   */

  var SnackbarContainer = function (_PureComponent) {
    _inherits(SnackbarContainer, _PureComponent);

    function SnackbarContainer(props) {
      _classCallCheck(this, SnackbarContainer);

      var _this = _possibleConstructorReturn(this, (SnackbarContainer.__proto__ || Object.getPrototypeOf(SnackbarContainer)).call(this, props));

      var visible = !!props.toasts.length;
      _this.state = {
        visible: visible,
        toast: null
      };

      _this._isMultiline = _this._isMultiline.bind(_this);
      _this._initAndToast = _this._initAndToast.bind(_this);
      _this._setContainer = _this._setContainer.bind(_this);
      _this._createSwapTimer = _this._createSwapTimer.bind(_this);
      _this._createLeaveTimer = _this._createLeaveTimer.bind(_this);
      return _this;
    }

    _createClass(SnackbarContainer, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var toasts = this.props.toasts;

        if (toasts.length) {
          this._initAndToast(toasts[0]);
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var _nextProps$toasts = _slicedToArray(nextProps.toasts, 1),
            toast = _nextProps$toasts[0];

        var _props$toasts = _slicedToArray(this.props.toasts, 1),
            prevToast = _props$toasts[0];

        if (toast === prevToast || toast === this.state.toast) {
          return;
        }

        if (!toast) {
          this._createLeaveTimer();
        } else if (!this.state.visible) {
          this._initAndToast(toast);
        } else {
          this._createSwapTimer(toast);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this._initTimeout) {
          clearTimeout(this._initTimeout);
        }

        if (this._leaveTimeout) {
          clearTimeout(this._leaveTimeout);
        }

        if (this._swapTimeout) {
          clearTimeout(this._swapTimeout);
        }

        if (this._dismissTimeout) {
          clearTimeout(this._dismissTimeout);
        }
      }
    }, {
      key: '_setContainer',
      value: function _setContainer(container) {
        this._container = (0, _reactDom.findDOMNode)(container);
      }
    }, {
      key: '_isMultiline',
      value: function _isMultiline(toast) {
        var container = this._container;
        if (container === null) {
          return false;
        }

        var message = document.createElement('p');
        message.classList.add('md-snackbar--toast');
        message.innerHTML = toast.text;

        var snackbar = void 0;
        if (toast.action) {
          message.classList.add('md-snackbar--action');

          snackbar = document.createElement('section');
          snackbar.className = 'md-snackbar';
          snackbar.appendChild(message);

          var action = document.createElement('button');
          action.innerHTML = typeof toast.action === 'string' ? toast.action : toast.action.label;
          action.className = 'md-btn md-btn--flat md-btn--text md-btn--snackbar';
          snackbar.appendChild(action);
        } else {
          snackbar = message;
        }

        // Only style we really want from the .md-snackbar
        snackbar.style.maxWidth = '568px';

        container.appendChild(snackbar);
        var multiline = message.offsetHeight > 20;
        container.removeChild(snackbar);

        return multiline;
      }
    }, {
      key: '_initAndToast',
      value: function _initAndToast(toast) {
        var _this2 = this;

        this._initTimeout = setTimeout(function () {
          _this2._initTimeout = null;

          _this2.setState({ toast: toast, multiline: _this2._isMultiline(toast) });
        }, _CSSTransitionGroupTick2.default);

        this.setState({ visible: true });
      }
    }, {
      key: '_createLeaveTimer',
      value: function _createLeaveTimer() {
        var _this3 = this;

        var time = this.props.transitionLeaveTimeout;

        this._leaveTimeout = setTimeout(function () {
          _this3._leaveTimeout = null;

          _this3.setState({ visible: false });
        }, time + _CSSTransitionGroupTick2.default);

        this.setState({ toast: null });
      }
    }, {
      key: '_createSwapTimer',
      value: function _createSwapTimer(toast) {
        var _this4 = this;

        this._swapTimeout = setTimeout(function () {
          _this4._swapTimeout = null;

          _this4.setState({ toast: toast, multiline: _this4._isMultiline(toast) });
        }, this.props.transitionLeaveTimeout + CHAINED_TOAST_DELAY);

        this.setState({ toast: null });
      }
    }, {
      key: 'render',
      value: function render() {
        var _state = this.state,
            visible = _state.visible,
            toast = _state.toast,
            multiline = _state.multiline;

        var _props = this.props,
            transitionName = _props.transitionName,
            transitionEnterTimeout = _props.transitionEnterTimeout,
            transitionLeaveTimeout = _props.transitionLeaveTimeout,
            dismiss = _props.dismiss,
            onDismiss = _props.onDismiss,
            lastChild = _props.lastChild,
            props = _objectWithoutProperties(_props, ['transitionName', 'transitionEnterTimeout', 'transitionLeaveTimeout', 'dismiss', 'onDismiss', 'lastChild']);

        delete props.toasts;
        delete props.renderNode;
        var renderNode = (0, _getField2.default)(this.props, this.context, 'renderNode');

        var snackbar = void 0;
        if (toast) {
          snackbar = _react2.default.createElement(_Snackbar2.default, _extends({}, props, {
            key: 'snackbar',
            leaveTimeout: transitionLeaveTimeout,
            toast: toast,
            multiline: multiline,
            onDismiss: onDismiss || dismiss
          }));
        }

        return _react2.default.createElement(
          _Portal2.default,
          { visible: visible, renderNode: renderNode, lastChild: lastChild },
          _react2.default.createElement(
            _CSSTransitionGroup2.default,
            {
              ref: this._setContainer,
              key: 'container',
              className: 'md-snackbar-container',
              transitionName: transitionName,
              transitionEnterTimeout: transitionEnterTimeout,
              transitionLeaveTimeout: transitionLeaveTimeout
            },
            snackbar
          )
        );
      }
    }]);

    return SnackbarContainer;
  }(_react.PureComponent);

  SnackbarContainer.propTypes = {
    /**
     * An id for the Snackbar once a toast has been added and is visible. This is a recommended
     * prop for accessibility concerns. If it is ommitted, the id will become `'snackbarAlert'`
     * when there is no action on the toast, or `'snackbarAlertDialog'` when there is an action
     * on the toast.
     */
    id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),

    /**
     * An optional style to apply to the snackbar once it appears.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply to the snackbar once it appears.
     */
    className: _propTypes2.default.string,

    /**
     * An immutable controlled queue of toasts that should appear in the snackbar.
     * The snackbar will always display the first toast in this list. When the user has
     * either clicked the action of the toast, or the `autohideTimeout` has been reached,
     * the `onDismiss` function will be called. The `onDismiss` function should remove the
     * the first toast and return a new list of remaining toasts.
     *
     * ```js
     * let toasts = [];
     * const onDismiss = () => {
     *   const [, ...remainingToasts] = toasts;
     *   toasts = remainingToasts;
     * };
     * ```
     */
    toasts: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      /**
       * The text to display in the toast.
       */
      text: _propTypes2.default.node.isRequired,

      /**
       * An optional action to take. If this value is a string, the `label` for the
       * button will be this value, Otherwise, all the keys in the action object will
       * be applied to the `Button`.
       */
      action: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.shape({
        onClick: _propTypes2.default.func,
        label: _propTypes2.default.node.isRequired
      })])
    })).isRequired,

    /**
     * A function to call that will dismiss a toast. This will automatically be bound to
     * any toast that has an `action` and it will also be called when the `autohideTimeout`
     * has been reached.
     */
    onDismiss: _propTypes2.default.func.isRequired,

    /**
     * Boolean if the snackbar's toasts should automatically be dismissed after the
     * `autohideTimeout` has been reached.
     */
    autohide: _propTypes2.default.bool,

    /**
     * The amount of time before the snackbar should be dequeued and the next toast
     * should be displayed.
     */
    autohideTimeout: _propTypes2.default.number.isRequired,

    /**
     * The transition name to use for the snackbar appearing and disappearing.
     */
    transitionName: _propTypes2.default.string.isRequired,

    /**
     * The transition time for the snackbar to enter. This should match the `$md-snackbar-transition-time`
     * sass variable.
     */
    transitionEnterTimeout: _propTypes2.default.number.isRequired,

    /**
     * The transition time for the snackbar to leave. This should match the `$md-snackbar-transition-time`
     * sass variable.
     */
    transitionLeaveTimeout: _propTypes2.default.number.isRequired,

    /**
     * When the app contains a floating action button that is fixed to the bottom of the screen,
     * you should set this to be a ref of the floating action button. When a snackbar appears,
     * the FAB will be moved to not overlay the snackbar.
     */
    fab: function fab(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

      if (!propValue) {
        return null;
      }

      if (propType !== 'object' || typeof propValue.render !== 'function' || (0, _isInvalidAnimate2.default)(propValue)) {
        var componentNameSafe = componentName || '<<anonymous>>';
        var propFullNameSafe = propFullName || propName;
        return new Error('Invalid ' + location + ' `' + propFullNameSafe + '` supplied to `' + componentNameSafe + '`, expected a ' + 'ref to a floating `Button` component. This should not be a DOMElement from `findDOMNode` but instead ' + 'the React ref object.');
      }

      return null;
    },

    /**
     * An optional DOM node to render the Snackbar in. If this is omitted, it will render as the first
     * child in the `body`.
     */
    renderNode: _propTypes2.default.object,

    /**
     * Boolean if the snackbar should render as the last child in the `renderNode` or `body` instead of
     * as the first.
     */
    lastChild: _propTypes2.default.bool,
    dismiss: (0, _deprecated2.default)(_propTypes2.default.func, 'Use `onDismiss` instead')
  };
  SnackbarContainer.defaultProps = {
    autohide: true,
    toasts: [],
    autohideTimeout: 3000,
    transitionName: 'md-snackbar',
    transitionEnterTimeout: 300,
    transitionLeaveTimeout: 300
  };
  SnackbarContainer.contextTypes = {
    renderNode: _propTypes2.default.object
  };
  exports.default = SnackbarContainer;
});

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1173)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./SnackbarContainer'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.SnackbarContainer);
    global.index = mod.exports;
  }
})(this, function (exports, _SnackbarContainer) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _SnackbarContainer2 = _interopRequireDefault(_SnackbarContainer);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _SnackbarContainer2.default;
});

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(597)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('react-motion'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.reactMotion);
    global.TabIndicator = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _reactMotion) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var TabIndicator = function (_PureComponent) {
    _inherits(TabIndicator, _PureComponent);

    function TabIndicator() {
      _classCallCheck(this, TabIndicator);

      return _possibleConstructorReturn(this, (TabIndicator.__proto__ || Object.getPrototypeOf(TabIndicator)).apply(this, arguments));
    }

    _createClass(TabIndicator, [{
      key: 'render',
      value: function render() {
        var visible = this.props.visible;

        return _react2.default.createElement(
          _reactMotion.Motion,
          {
            style: {
              x: (0, _reactMotion.spring)(this.props.offset),
              width: (0, _reactMotion.spring)(this.props.width),
              height: (0, _reactMotion.spring)(visible ? 2 : 0)
            }
          },
          function (_ref) {
            var x = _ref.x,
                height = _ref.height,
                width = _ref.width;

            var transform = 'translate3d(' + x + 'px, 0, 0)';
            return _react2.default.createElement('span', {
              style: {
                height: height,
                width: width,
                WebkitTransform: transform,
                MozTransform: transform,
                msTransform: transform,
                transform: transform
              },
              className: 'md-tab-indicator'
            });
          }
        );
      }
    }]);

    return TabIndicator;
  }(_react.PureComponent);

  TabIndicator.propTypes = {
    offset: _propTypes2.default.number.isRequired,
    width: _propTypes2.default.number.isRequired,
    visible: _propTypes2.default.bool
  };
  exports.default = TabIndicator;
});

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(11)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('../Buttons/Button'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.Button);
    global.TabOverflowButton = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _Button) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _Button2 = _interopRequireDefault(_Button);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var TabOverflowButton = function (_PureComponent) {
    _inherits(TabOverflowButton, _PureComponent);

    function TabOverflowButton() {
      _classCallCheck(this, TabOverflowButton);

      return _possibleConstructorReturn(this, (TabOverflowButton.__proto__ || Object.getPrototypeOf(TabOverflowButton)).apply(this, arguments));
    }

    _createClass(TabOverflowButton, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            left = _props.left,
            icon = _props.icon,
            props = _objectWithoutProperties(_props, ['left', 'icon']);

        return _react2.default.createElement(_Button2.default, _extends({}, props, {
          icon: true,
          className: (0, _classnames2.default)('md-icon--inherit md-btn--tab-overflow', {
            'md-btn--tab-overflow-left': left,
            'md-btn--tab-overflow-right': !left,
            'md-btn--tab-overflow-icon': icon
          })
        }));
      }
    }]);

    return TabOverflowButton;
  }(_react.PureComponent);

  TabOverflowButton.propTypes = {
    left: _propTypes2.default.bool,
    icon: _propTypes2.default.bool
  };
  exports.default = TabOverflowButton;
});

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(265), __webpack_require__(264), __webpack_require__(263), __webpack_require__(574), __webpack_require__(575)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./TabsContainer'), require('./Tabs'), require('./Tab'), require('./MenuTab'), require('./TabPanel'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.TabsContainer, global.Tabs, global.Tab, global.MenuTab, global.TabPanel);
    global.index = mod.exports;
  }
})(this, function (exports, _TabsContainer, _Tabs2, _Tab2, _MenuTab2, _TabPanel2) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.TabPanel = exports.MenuTab = exports.Tab = exports.Tabs = exports.TabsContainer = undefined;

  var _TabsContainer2 = _interopRequireDefault(_TabsContainer);

  var _Tabs3 = _interopRequireDefault(_Tabs2);

  var _Tab3 = _interopRequireDefault(_Tab2);

  var _MenuTab3 = _interopRequireDefault(_MenuTab2);

  var _TabPanel3 = _interopRequireDefault(_TabPanel2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _TabsContainer2.default;
  exports.TabsContainer = _TabsContainer2.default;
  exports.Tabs = _Tabs3.default;
  exports.Tab = _Tab3.default;
  exports.MenuTab = _MenuTab3.default;
  exports.TabPanel = _TabPanel3.default;
});

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(1181)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('./TextArea'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.TextArea);
    global.InputField = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _TextArea) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _TextArea2 = _interopRequireDefault(_TextArea);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var InputField = function (_PureComponent) {
    _inherits(InputField, _PureComponent);

    function InputField(props) {
      _classCallCheck(this, InputField);

      var _this = _possibleConstructorReturn(this, (InputField.__proto__ || Object.getPrototypeOf(InputField)).call(this, props));

      _this.getValue = _this.getValue.bind(_this);
      _this.getField = _this.getField.bind(_this);
      _this.focus = _this.focus.bind(_this);
      _this._setField = _this._setField.bind(_this);
      return _this;
    }

    _createClass(InputField, [{
      key: 'getField',
      value: function getField() {
        return typeof this.props.rows === 'undefined' ? this._field : this._field.getField();
      }
    }, {
      key: 'getValue',
      value: function getValue() {
        if (typeof this.props.rows === 'undefined') {
          return this._field.value;
        }

        return this._field.getValue();
      }
    }, {
      key: 'focus',
      value: function focus() {
        this._field.focus();
      }
    }, {
      key: '_setField',
      value: function _setField(field) {
        this._field = field;
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            className = _props.className,
            rows = _props.rows,
            label = _props.label,
            customSize = _props.customSize,
            fullWidth = _props.fullWidth,
            type = _props.type,
            passwordVisible = _props.passwordVisible,
            block = _props.block,
            inlineIndicator = _props.inlineIndicator,
            props = _objectWithoutProperties(_props, ['className', 'rows', 'label', 'customSize', 'fullWidth', 'type', 'passwordVisible', 'block', 'inlineIndicator']);

        var multiline = typeof rows !== 'undefined';
        var Component = multiline ? _TextArea2.default : 'input';
        if (!multiline) {
          props.type = passwordVisible ? 'text' : type;

          delete props.maxRows;
          delete props.onHeightChange;
        } else {
          props.label = label;
          props.block = block;
        }

        return (0, _react.createElement)(Component, _extends({}, props, {
          rows: rows,
          ref: this._setField,
          className: (0, _classnames2.default)('md-text-field', _defineProperty({
            'md-text': !props.disabled,
            'md-text--disabled': props.disabled,
            'md-text-field--inline-indicator': inlineIndicator || !multiline && type === 'password',
            'md-text-field--multiline': multiline,
            'md-full-width': fullWidth,
            'md-text-field--margin': !block && !multiline && !label,
            'md-text-field--floating-margin': !block && !multiline && label
          }, 'md-text-field--' + customSize, customSize), className)
        }));
      }
    }]);

    return InputField;
  }(_react.PureComponent);

  InputField.propTypes = {
    id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    style: _propTypes2.default.object,
    className: _propTypes2.default.string,
    type: _propTypes2.default.string,
    placeholder: _propTypes2.default.string,
    block: _propTypes2.default.bool,
    disabled: _propTypes2.default.bool,
    rows: _propTypes2.default.number,
    maxRows: _propTypes2.default.number,
    label: _propTypes2.default.node,
    fullWidth: _propTypes2.default.bool,
    customSize: _propTypes2.default.string,
    passwordVisible: _propTypes2.default.bool,
    inlineIndicator: _propTypes2.default.bool
  };
  exports.default = InputField;
});

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames);
    global.Message = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Message = function (_PureComponent) {
    _inherits(Message, _PureComponent);

    function Message() {
      _classCallCheck(this, Message);

      return _possibleConstructorReturn(this, (Message.__proto__ || Object.getPrototypeOf(Message)).apply(this, arguments));
    }

    _createClass(Message, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            active = _props.active,
            children = _props.children,
            className = _props.className;


        if (!children) {
          return null;
        }

        return _react2.default.createElement(
          'span',
          {
            'aria-hidden': !active,
            className: (0, _classnames2.default)('md-text-field-message', 'md-text-field-message--' + (active ? '' : 'in') + 'active', className)
          },
          children
        );
      }
    }]);

    return Message;
  }(_react.PureComponent);

  Message.propTypes = {
    active: _propTypes2.default.bool,
    className: _propTypes2.default.string,
    children: _propTypes2.default.node
  };
  exports.default = Message;
});

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(14), __webpack_require__(28)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('../constants/keyCodes'), require('../FontIcons/FontIcon'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.keyCodes, global.FontIcon);
    global.PasswordButton = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _keyCodes, _FontIcon) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _FontIcon2 = _interopRequireDefault(_FontIcon);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var PasswordButton = function (_PureComponent) {
    _inherits(PasswordButton, _PureComponent);

    function PasswordButton(props) {
      _classCallCheck(this, PasswordButton);

      var _this = _possibleConstructorReturn(this, (PasswordButton.__proto__ || Object.getPrototypeOf(PasswordButton)).call(this, props));

      _this.state = { keyboardFocus: false };

      _this._handleKeyUp = _this._handleKeyUp.bind(_this);
      _this._handleKeyDown = _this._handleKeyDown.bind(_this);
      _this._handleOutsideClick = _this._handleOutsideClick.bind(_this);
      return _this;
    }

    _createClass(PasswordButton, [{
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.state.keyboardFocus) {
          window.removeEventListener('click', this._handleOutsideClick);
        }
      }
    }, {
      key: '_handleOutsideClick',
      value: function _handleOutsideClick(e) {
        if (this._button && !this._button.contains(e.target)) {
          window.removeEventListener('click', this._handleOutsideClick);
          this.setState({ keyboardFocus: false });
        }
      }
    }, {
      key: '_handleKeyUp',
      value: function _handleKeyUp(e) {
        if (this.props.onKeyUp) {
          this.props.onKeyUp(e);
        }

        if ((e.which || e.keyCode) === _keyCodes.TAB) {
          window.addEventListener('click', this._handleOutsideClick);
          this.setState({ keyboardFocus: true });
        }
      }
    }, {
      key: '_handleKeyDown',
      value: function _handleKeyDown(e) {
        if (this.props.onKeyDown) {
          this.props.onKeyDown(e);
        }

        var key = e.which || e.keyCode;
        if (key === _keyCodes.TAB || key === _keyCodes.ENTER || key === _keyCodes.SPACE) {
          window.removeEventListener('click', this._handleOutsideClick);
          this.setState({ keyboardFocus: false });
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var keyboardFocus = this.state.keyboardFocus;

        var _props = this.props,
            active = _props.active,
            passwordVisible = _props.passwordVisible,
            iconClassName = _props.iconClassName,
            iconChildren = _props.iconChildren,
            block = _props.block,
            floating = _props.floating,
            props = _objectWithoutProperties(_props, ['active', 'passwordVisible', 'iconClassName', 'iconChildren', 'block', 'floating']);

        return _react2.default.createElement(
          'button',
          _extends({}, props, {
            onKeyDown: this._handleKeyDown,
            onKeyUp: this._handleKeyUp,
            type: 'button',
            className: (0, _classnames2.default)('md-text-field-inline-indicator md-password-btn md-pointer--hover', {
              'md-password-btn--focus': keyboardFocus,
              'md-password-btn--active': active,
              'md-password-btn--invisible': active && !passwordVisible,
              'md-text-field-inline-indicator--floating': floating,
              'md-text-field-inline-indicator--block': block
            })
          }),
          _react2.default.createElement(
            _FontIcon2.default,
            { iconClassName: iconClassName },
            iconChildren
          )
        );
      }
    }]);

    return PasswordButton;
  }(_react.PureComponent);

  PasswordButton.propTypes = {
    active: _propTypes2.default.bool,
    passwordVisible: _propTypes2.default.bool,
    iconClassName: _propTypes2.default.string,
    iconChildren: _propTypes2.default.node,
    onKeyUp: _propTypes2.default.func,
    onKeyDown: _propTypes2.default.func,
    block: _propTypes2.default.bool,
    floating: _propTypes2.default.bool
  };
  exports.default = PasswordButton;
});

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames);
    global.TextArea = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var TextArea = function (_PureComponent) {
    _inherits(TextArea, _PureComponent);

    function TextArea(props) {
      _classCallCheck(this, TextArea);

      var _this = _possibleConstructorReturn(this, (TextArea.__proto__ || Object.getPrototypeOf(TextArea)).call(this, props));

      _this.state = { height: null };
      _this.focus = _this.focus.bind(_this);
      _this.getField = _this.getField.bind(_this);
      _this.getValue = _this.getValue.bind(_this);
      _this._handleChange = _this._handleChange.bind(_this);
      _this._handleResize = _this._handleResize.bind(_this);
      _this._syncHeightWithMask = _this._syncHeightWithMask.bind(_this);
      return _this;
    }

    _createClass(TextArea, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this._rowHeight = this._calcRowHeight(this._field, this.props);
        this._syncHeightWithMask();
        window.addEventListener('resize', this._handleResize);
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (this.props.rows !== nextProps.rows) {
          this._rowHeight = this._calcRowHeight(this._field, this.props);
        }

        if (this.props.value !== nextProps.value || this.props.maxRows !== nextProps.maxRows) {
          this._syncHeightWithMask(nextProps.value);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        window.removeEventListener('resize', this._handleResize);
      }
    }, {
      key: 'getField',
      value: function getField() {
        return this._field;
      }
    }, {
      key: 'getValue',
      value: function getValue() {
        return this._field.value;
      }
    }, {
      key: 'focus',
      value: function focus() {
        this._field.focus();
      }
    }, {
      key: '_setMask',
      value: function _setMask(mask) {
        this._mask = mask;
      }
    }, {
      key: '_setField',
      value: function _setField(field) {
        this._field = field;
      }
    }, {
      key: '_calcRowHeight',
      value: function _calcRowHeight(field, props) {
        return field.offsetHeight / props.rows;
      }
    }, {
      key: '_handleResize',
      value: function _handleResize() {
        this._rowHeight = this._calcRowHeight(this._field, this.props);
        this._syncHeightWithMask();
      }
    }, {
      key: '_syncHeightWithMask',
      value: function _syncHeightWithMask(value) {
        if (value !== undefined) {
          this._mask.value = value;
        }

        var height = this._mask.scrollHeight;
        if (height === undefined) {
          return;
        }

        var _props = this.props,
            rows = _props.rows,
            maxRows = _props.maxRows;

        if (maxRows && maxRows > 0) {
          height = Math.min(height, this._rowHeight * maxRows);
        }

        height = Math.max(this._rowHeight * rows, height);

        if (this.props.onHeightChange) {
          // For some reason the md-text-field-multiline-container is 5px
          // larger than the textareas.. So just add 5 here and on the inline style
          this.props.onHeightChange(height + 5);
        }

        this.setState({ height: height });
      }
    }, {
      key: '_handleChange',
      value: function _handleChange(e) {
        this._syncHeightWithMask(e.target.value, e);

        if (this.props.onChange) {
          this.props.onChange(e);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var height = this.state.height;

        var _props2 = this.props,
            style = _props2.style,
            defaultValue = _props2.defaultValue,
            value = _props2.value,
            className = _props2.className,
            label = _props2.label,
            block = _props2.block,
            props = _objectWithoutProperties(_props2, ['style', 'defaultValue', 'value', 'className', 'label', 'block']);

        delete props.maxRows;
        delete props.onChange;
        delete props.onHeightChange;

        return _react2.default.createElement(
          'div',
          {
            style: { height: height && height + 5 },
            className: (0, _classnames2.default)('md-text-field-multiline-container', {
              'md-text-field--margin': !label && !block,
              'md-text-field--floating-margin': label && !block
            })
          },
          _react2.default.createElement('textarea', {
            ref: function ref(mask) {
              _this2._mask = mask;
            },
            className: (0, _classnames2.default)(className, 'md-text-field--multiline-mask'),
            readOnly: true,
            rows: props.rows,
            tabIndex: -1,
            style: style,
            defaultValue: defaultValue,
            'aria-hidden': true,
            value: value
          }),
          _react2.default.createElement('textarea', _extends({}, props, {
            ref: function ref(field) {
              _this2._field = field;
            },
            style: Object.assign({}, style, { height: height }),
            className: className,
            defaultValue: defaultValue,
            value: value,
            onChange: this._handleChange
          }))
        );
      }
    }]);

    return TextArea;
  }(_react.PureComponent);

  TextArea.propTypes = {
    id: _propTypes2.default.string,
    style: _propTypes2.default.object,
    className: _propTypes2.default.string,
    rows: _propTypes2.default.number.isRequired,
    maxRows: _propTypes2.default.number,
    onChange: _propTypes2.default.func,
    defaultValue: _propTypes2.default.string,
    floatingLabel: _propTypes2.default.bool,
    value: _propTypes2.default.string,
    onHeightChange: _propTypes2.default.func,
    block: _propTypes2.default.bool,
    label: _propTypes2.default.node
  };
  exports.default = TextArea;
});

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames);
    global.ToolbarTitle = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var ToolbarTitle = function (_PureComponent) {
    _inherits(ToolbarTitle, _PureComponent);

    function ToolbarTitle(props) {
      _classCallCheck(this, ToolbarTitle);

      var _this = _possibleConstructorReturn(this, (ToolbarTitle.__proto__ || Object.getPrototypeOf(ToolbarTitle)).call(this, props));

      _this.state = {};
      return _this;
    }

    _createClass(ToolbarTitle, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            title = _props.title,
            className = _props.className,
            prominent = _props.prominent,
            offset = _props.offset,
            props = _objectWithoutProperties(_props, ['title', 'className', 'prominent', 'offset']);

        if (!title) {
          return null;
        }

        var fullClassName = (0, _classnames2.default)('md-title md-title--toolbar', {
          'md-title--toolbar-prominent': prominent,
          'md-title--toolbar-offset': offset
        }, className);

        if ((0, _react.isValidElement)(title)) {
          var titleEl = _react.Children.only(title);
          return (0, _react.cloneElement)(title, {
            className: (0, _classnames2.default)(fullClassName, titleEl.props.className)
          });
        }

        return _react2.default.createElement(
          'h2',
          _extends({}, props, {
            className: fullClassName
          }),
          title
        );
      }
    }]);

    return ToolbarTitle;
  }(_react.PureComponent);

  ToolbarTitle.propTypes = {
    className: _propTypes2.default.string,
    prominent: _propTypes2.default.bool,
    offset: _propTypes2.default.bool,
    title: _propTypes2.default.node
  };
  exports.default = ToolbarTitle;
});

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(38)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('../constants/CSSTransitionGroupTick'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.CSSTransitionGroupTick);
    global.Tooltip = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _CSSTransitionGroupTick) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Tooltip = function (_PureComponent) {
    _inherits(Tooltip, _PureComponent);

    function Tooltip(props) {
      _classCallCheck(this, Tooltip);

      var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));

      _this.state = {
        entering: false,
        leaving: false,
        active: false,
        visible: false
      };

      _this._timeout = null;
      return _this;
    }

    _createClass(Tooltip, [{
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this._timeout) {
          clearTimeout(this._timeout);
        }
      }
    }, {
      key: 'componentWillEnter',
      value: function componentWillEnter(cb) {
        var _this2 = this;

        this._timeout = setTimeout(function () {
          _this2._timeout = setTimeout(function () {
            _this2._timeout = null;

            cb();
          }, _this2.props.enterTimeout);
          _this2.setState({ active: true });
        }, _CSSTransitionGroupTick2.default);

        this.setState({ entering: true });
      }
    }, {
      key: 'componentDidEnter',
      value: function componentDidEnter() {
        this.setState({ entering: false, active: false, visible: true });
      }
    }, {
      key: 'componentWillLeave',
      value: function componentWillLeave(cb) {
        var _this3 = this;

        if (this._timeout) {
          clearTimeout(this._timeout);
        }

        this._timeout = setTimeout(function () {
          _this3._timeout = setTimeout(function () {
            _this3._timeout = null;

            cb();
          }, _this3.props.leaveTimeout);

          _this3.setState({ active: true, visible: false });
        }, _CSSTransitionGroupTick2.default);

        this.setState({ leaving: true });
      }
    }, {
      key: 'render',
      value: function render() {
        var _state = this.state,
            active = _state.active,
            entering = _state.entering,
            leaving = _state.leaving,
            visible = _state.visible;
        var _props = this.props,
            style = _props.style,
            className = _props.className,
            children = _props.children,
            position = _props.position;


        var direction = position === 'top' || position === 'bottom' ? 'horizontal' : 'vertical';
        return _react2.default.createElement(
          'span',
          {
            style: style,
            className: (0, _classnames2.default)('md-tooltip md-tooltip--' + position + ' md-tooltip--' + direction, _defineProperty({
              'md-tooltip--active': active,
              'md-tooltip--enter': entering,
              'md-tooltip--enter-active': entering && active,
              'md-tooltip--leave': leaving,
              'md-tooltip--leave-active': leaving && active
            }, 'md-tooltip--' + position + '-active', visible || entering && active), className)
          },
          children
        );
      }
    }]);

    return Tooltip;
  }(_react.PureComponent);

  Tooltip.propTypes = {
    style: _propTypes2.default.object,
    className: _propTypes2.default.string,
    position: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']).isRequired,
    children: _propTypes2.default.node.isRequired,
    enterTimeout: _propTypes2.default.number.isRequired,
    leaveTimeout: _propTypes2.default.number.isRequired
  };
  exports.default = Tooltip;
});

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(9), __webpack_require__(277), __webpack_require__(3), __webpack_require__(14), __webpack_require__(117), __webpack_require__(1183)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('react-dom'), require('react-transition-group/TransitionGroup'), require('classnames'), require('../constants/keyCodes'), require('../utils/EventUtils/captureNextEvent'), require('./Tooltip'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.reactDom, global.TransitionGroup, global.classnames, global.keyCodes, global.captureNextEvent, global.Tooltip);
    global.TooltipContainer = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _reactDom, _TransitionGroup, _classnames, _keyCodes, _captureNextEvent, _Tooltip) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _captureNextEvent2 = _interopRequireDefault(_captureNextEvent);

  var _Tooltip2 = _interopRequireDefault(_Tooltip);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var TooltipContainer = function (_PureComponent) {
    _inherits(TooltipContainer, _PureComponent);

    function TooltipContainer(props) {
      _classCallCheck(this, TooltipContainer);

      var _this = _possibleConstructorReturn(this, (TooltipContainer.__proto__ || Object.getPrototypeOf(TooltipContainer)).call(this, props));

      _this.state = { visible: false };
      _this._delayedTimeout = null;

      _this._setContainers = _this._setContainers.bind(_this);
      _this._showTooltip = _this._showTooltip.bind(_this);
      _this._hideTooltip = _this._hideTooltip.bind(_this);
      _this._stopContextMenu = _this._stopContextMenu.bind(_this);
      _this._handleKeyUp = _this._handleKeyUp.bind(_this);
      return _this;
    }

    _createClass(TooltipContainer, [{
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this._container) {
          this._container.removeEventListener('mouseover', this._showTooltip);
          this._container.removeEventListener('mouseleave', this._hideTooltip);
          this._container.removeEventListener('touchstart', this._showTooltip);
          this._container.removeEventListener('touchend', this._hideTooltip);
          this._container.removeEventListener('keyup', this._handleKeyUp);
          this._container.removeEventListener('blur', this._hideTooltip);
        }

        if (this._delayedTimeout) {
          clearTimeout(this._delayedTimeout);
        }
      }
    }, {
      key: '_setContainers',
      value: function _setContainers(container) {
        if (container) {
          this._container = (0, _reactDom.findDOMNode)(container).parentNode;

          this._container.addEventListener('mouseover', this._showTooltip);
          this._container.addEventListener('mouseleave', this._hideTooltip);
          this._container.addEventListener('touchstart', this._showTooltip);
          this._container.addEventListener('touchend', this._hideTooltip);
          this._container.addEventListener('keyup', this._handleKeyUp);
          this._container.addEventListener('blur', this._hideTooltip);
        }
      }
    }, {
      key: '_stopContextMenu',
      value: function _stopContextMenu(e) {
        e.preventDefault();
        window.removeEventListener('contextmenu', this._stopContextMenu, true);
        (0, _captureNextEvent2.default)('click');
        this.setState({ visible: true });
      }
    }, {
      key: '_showTooltip',
      value: function _showTooltip(e) {
        var _this2 = this;

        if (e.type === 'mouseover' && this._touched) {
          return;
        }

        if (e.type === 'touchstart') {
          this._touched = true;

          window.addEventListener('contextmenu', this._stopContextMenu, true);
          return;
        }

        var delay = this.props.delay;

        if (this._delayedTimeout) {
          clearTimeout(this._delayedTimeout);
        }

        if (delay) {
          this._delayedTimeout = setTimeout(function () {
            _this2._delayedTimeout = null;

            _this2.setState({ visible: true });
          }, delay);
        } else {
          this.setState({ visible: true });
        }
      }
    }, {
      key: '_hideTooltip',
      value: function _hideTooltip(e) {
        if (this._delayedTimeout) {
          clearTimeout(this._delayedTimeout);
        }

        if (e.type === 'mouseover' && this._touched) {
          return;
        }

        this.setState({ visible: false });
      }
    }, {
      key: '_handleKeyUp',
      value: function _handleKeyUp(e) {
        if ((e.which || e.keyCode) === _keyCodes.TAB) {
          this._showTooltip(e);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var visible = this.state.visible;
        var _props = this.props,
            style = _props.style,
            className = _props.className,
            tooltipStyle = _props.tooltipStyle,
            tooltipClassName = _props.tooltipClassName,
            label = _props.label,
            position = _props.position,
            enterTimeout = _props.enterTimeout,
            leaveTimeout = _props.leaveTimeout;


        var tooltip = _react2.default.createElement(
          _Tooltip2.default,
          {
            key: 'tooltip',
            style: tooltipStyle,
            className: tooltipClassName,
            position: position,
            enterTimeout: enterTimeout,
            leaveTimeout: leaveTimeout
          },
          label
        );

        return _react2.default.createElement(
          _TransitionGroup2.default,
          {
            style: style,
            className: (0, _classnames2.default)('md-tooltip-container', className),
            ref: this._setContainers,
            component: 'div'
          },
          visible ? tooltip : null
        );
      }
    }]);

    return TooltipContainer;
  }(_react.PureComponent);

  TooltipContainer.propTypes = {
    style: _propTypes2.default.object,
    className: _propTypes2.default.string,
    tooltipStyle: _propTypes2.default.object,
    tooltipClassName: _propTypes2.default.string,
    label: _propTypes2.default.node.isRequired,
    position: _Tooltip2.default.propTypes.position,
    delay: _propTypes2.default.number.isRequired,
    enterTimeout: _propTypes2.default.number.isRequired,
    leaveTimeout: _propTypes2.default.number.isRequired
  };
  exports.default = TooltipContainer;
});

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(157)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./injectTooltip'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.injectTooltip);
    global.index = mod.exports;
  }
})(this, function (exports, _injectTooltip) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _injectTooltip2 = _interopRequireDefault(_injectTooltip);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _injectTooltip2.default;
});

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.addHours = mod.exports;
  }
})(this, function (exports) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = addHours;
  /**
   * Adds hours to a date.
   *
   * @param {Date} time the time to increment
   * @param {number} hours the number of hours to increment by.
   * @return a new Date with the new hours set.
   */
  function addHours(time, hours) {
    var t = new Date(time.getTime());
    t.setHours(t.getHours() + hours);
    return t;
  }
});

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(584)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./formatTime'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.formatTime);
    global.extractTimeParts = mod.exports;
  }
})(this, function (exports, _formatTime) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = extractTimeParts;

  var _formatTime2 = _interopRequireDefault(_formatTime);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _toArray(arr) {
    return Array.isArray(arr) ? arr : Array.from(arr);
  }

  var _slicedToArray = function () {
    function sliceIterator(arr, i) {
      var _arr = [];
      var _n = true;
      var _d = false;
      var _e = undefined;

      try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);

          if (i && _arr.length === i) break;
        }
      } catch (err) {
        _d = true;
        _e = err;
      } finally {
        try {
          if (!_n && _i["return"]) _i["return"]();
        } finally {
          if (_d) throw _e;
        }
      }

      return _arr;
    }

    return function (arr, i) {
      if (Array.isArray(arr)) {
        return arr;
      } else if (Symbol.iterator in Object(arr)) {
        return sliceIterator(arr, i);
      } else {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }
    };
  }();

  /**
   * Extracts the hours, minutes, and optional time period from
   * a date time.
   *
   * @param {function} DateTimeFormat the DateTimeFormat function to use.
   * @param {string|string[]} locales the locales to use.
   * @param {Date} time the time to extract from.
   * @return {Object} an object of { hours, minutes, timePeriod }
   */
  function extractTimeParts(DateTimeFormat, locales, time) {
    var formatted = (0, _formatTime2.default)(DateTimeFormat, locales, time);

    // IE does not like lookaheads or splitting on [^0-9]
    // it will include the non-printable characters..

    var _formatted$match = formatted.match(/[0-9]+/g),
        _formatted$match2 = _slicedToArray(_formatted$match, 2),
        hours = _formatted$match2[0],
        minutes = _formatted$match2[1];

    var _formatted$match3 = formatted.match(/[ ,.:A-z]+/g),
        _formatted$match4 = _toArray(_formatted$match3),
        separator = _formatted$match4[0],
        remaining = _formatted$match4.slice(1);

    var timePeriod = void 0;
    if (remaining && remaining.length) {
      timePeriod = remaining.join('').trim();
    }

    return {
      hours: hours,
      minutes: separator + minutes,
      timePeriod: timePeriod
    };
  }
});

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.getLastDay = mod.exports;
  }
})(this, function (exports) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = getLastDay;
  /**
   * Gets the last day in a month
   *
   * @param {Date} sourceDate the date to get the last day from.
   * @return a new Date as the last day of the month.
   */
  function getLastDay(sourceDate) {
    return new Date(sourceDate.getFullYear(), sourceDate.getMonth() + 1, 0);
  }
});

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.isDateEqual = mod.exports;
  }
})(this, function (exports) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = isDateEqual;

  /**
   * Checks if two dates are equal by comparing the exact time.
   * This allows null or undefined.
   *
   * @param {Date} d1 - The first date to compare.
   * @param {Date} d2 - The second date to compare.
   * @return {bool} - true if the dates are equal.
   */
  function isDateEqual(d1, d2) {
    if (!d1 && !d2) {
      return true;
    } else if (!d1 && d2 || d1 && !d2) {
      return false;
    }

    return d1.getTime() === d2.getTime();
  }
});

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(586)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./stripTime'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.stripTime);
    global.isMonthBefore = mod.exports;
  }
})(this, function (exports, _stripTime) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = isMonthBefore;

  var _stripTime2 = _interopRequireDefault(_stripTime);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Checks if a date is the month before another date without time
   *
   * @param {Date} date the date to check if it is before the other
   * @param {Date} toCompare the date to compare to
   * @return true if the date is before the other date's first day of month.
   */
  function isMonthBefore(date, toCompare) {
    if (!date || !toCompare) {
      return false;
    }

    var d1 = (0, _stripTime2.default)(new Date(date.getFullYear(), date.getMonth(), 1));
    var d2 = (0, _stripTime2.default)(new Date(toCompare.getFullYear(), toCompare.getMonth() - 1, 1));
    return d1 > d2;
  }
});

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.calcTimeFromPoint = mod.exports;
  }
})(this, function (exports) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = calcTimeFromPoint;
  function isPointInCircle(cx, cy, r, x, y) {
    var distance = Math.pow(cx - x, 2) + Math.pow(cy - y, 2);
    return distance <= Math.pow(r, 2);
  }

  function toDegrees(radians) {
    return radians * (180 / Math.PI);
  }

  /**
   * Takes a point from a mouse or touch event and a center point of a circle to determine
   * what the new time should be.
   *
   * If the point.y < center.y, the point is in the top half of the circle.
   * If the point.x < center.x, the point is in the left half of the circle.
   *
   * @param {Object} point - The mouse or touch event's point that contains an x and y coordinate.
   * @param {Object} center - The center point for the circle that contains an x and y coordinate.
   * @param {Number} innerRadius - An inner radius for clocks that have 24 hour times. This is
   *    a circle that contains hours 12-23.
   * @param {Boolean} minutes - Boolena if the current time to be calculated is minutes instead of
   *    hours.
   * @param {Boolean} hour12 - Boolean if the clock is a 12 hour clock.
   * @return {Number} the new time.
   */
  function calcTimeFromPoint(point, center, innerRadius, minutes, hour12) {
    var x = point.x - center.x;
    var y = point.y - center.y;
    var degrees = toDegrees(Math.atan2(y, x));
    var sectors = minutes ? 60 : 12;
    var sectorSize = 360 / sectors;
    var time = Math.round(degrees / sectorSize);

    // Since the css transform has 0π at π/2 place, we need to offset the
    // time to that location.
    time += minutes ? 15 : 3;

    // If time is still negative, it is in the top half of the circle
    if (time < 0) {
      time += sectors;
    }

    // Finally, if it is a 24 hour clock, need to check if the point is actually
    // selecting hours 13 - 24 (0).
    if (!minutes && !hour12) {
      var isInCircle = isPointInCircle(0, 0, innerRadius, x, y);

      if (time === 0 && !isInCircle || time !== 0 && isInCircle) {
        time += 12;
      }
    }

    return time;
  }
});

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.calculateHypotenuse = mod.exports;
  }
})(this, function (exports) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = calculateHypotenuse;
  /**
   * Calculates the hypotenuse using the x and y coordinates given.
   *
   * @param {number} a the x coordinate
   * @param {number} b the y coordinate
   * @return {number} the hypotenuse length for the given x and y coordinates.
   */
  function calculateHypotenuse(a, b) {
    return Math.sqrt(a * a + b * b);
  }
});

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.calculateValueDistance = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = calculateValueDistance;
  /**
   * This calculates the distance from a screen x location to a position in some element
   * by comparing the width of the element and the element's page position to the screen
   * x position.
   *
   * If the distance is not _normalized_ the distance will be updated to be a percentage
   * of the element's total width.
   *
   * @param {Number} x - the screen x location.
   * @param {Number} width - the element's width
   * @param {Number} left - the element's page x position.
   * @param {Boolean} normalize - boolean if the distance should be a percentage.
   *
   * @return {Number} the distance from the element's left position to the page x
   *    location.
   */
  function calculateDistance(x, width, left, normalize) {
    var distance = Math.min(width, Math.max(0, x - left));

    return normalize ? distance : distance / width * 100;
  }

  /**
   * This calculates the new value and distance for a slider. It will compare the page x
   * location of a touch or mouse event to the slider's track page x position. If the
   * final value and distance should be _normalized_, they will be updated to be rounded
   * with the scale and steps in mind.
   *
   * The distance will always be contained within a percentage of 0 - 100 while the
   * value will be contained within the min and max values.
   *
   * @param {Number} x - the page x location of the touch or mouse event.
   * @param {Number} width - the slider's width
   * @param {Number} left - the slider's left position in the page.
   * @param {Number} scale - the total number values included in the slider.
   * @param {Number} step - the amount to increment by.
   * @param {Number} min - the min value for the slider.
   * @param {Number} max - the max value for the slider.
   * @param {Boolean} normalize - boolean if the vaue and distance should be _normalized_.
   *
   * @return {Object} an object with the value and distance.
   */
  function calculateValueDistance(x, width, left, scale, step, min, max, normalize) {
    var value = void 0;
    var distance = calculateDistance(x, width, left, normalize);
    if (normalize) {
      value = Math.round(distance / (width / scale));
      if (step < 1) {
        var decimals = String(step).split('.')[1];
        var corrector = typeof decimals !== 'undefined' && decimals.length > 0 ? Math.pow(10, decimals.length) : 1;

        var modded = value * corrector % (step * corrector);
        if (modded !== 0 && modded >= step / 2) {
          value += step - modded;
        } else if (modded !== 0) {
          value -= modded;
        }
      }

      distance = value / scale * 100;
      value += min;
    } else {
      value = Math.round(distance / 100 * scale);
    }

    if (step > 1) {
      value *= step;
    } else if (step > 0 && step < 1) {
      value *= step;
    }

    return {
      distance: Math.max(0, Math.min(100, distance)),
      value: Math.max(min, Math.min(max, value))
    };
  }
});

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.isWithinStep = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = isWithinStep;
  function isWithinStep(value, step) {
    var decimals = String(step).split('.')[1];
    var corrector = typeof decimals !== 'undefined' && decimals.length > 0 ? Math.pow(10, decimals.length) : 1;

    return value * corrector % (step * corrector) === 0;
  }
});

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.minMaxLoop = mod.exports;
  }
})(this, function (exports) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = minMaxLoop;
  /**
   * Keeps a number within the min and max values. When the number becomes less
   * than the min, it will loop around and be the max value. When the number is
   * greater than the max, it will loop around and be the min value.
   *
   * @param {Number} current - the current number
   * @param {Number} min - the minimum number allowed
   * @param {Number} max - the maximum number allowed
   * @param {Boolean} increment - boolean if the value should be incremented or decremented by
   *    1.
   * @return {Number} the next number
   */
  function minMaxLoop(current, min, max) {
    var increment = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    var next = current + (increment ? 1 : -1);
    if (max < next) {
      next = min;
    } else if (next < min) {
      next = max;
    }

    return next;
  }
});

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.updateUnit = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = updateUnit;
  /**
   * Takes in a css unit (px, rem, em, etc) or a number and applies a function to the
   * number part of the unit.
   *
   * If the unit was a number to start with and a `toUnit` is given, the number will
   * be given the `toUnit`. Otherwise the number will be returned.
   *
   * If the unit was a string, the original units will be applied back to the updated
   * unit's value.
   *
   * @param {number|String} unit - the unit to apply a function to.
   * @param {function} fn - the function to apply to the number.
   * @param {String=} toUnit - an optional unit to cast the updated unit to.
   *
   * @return {String|number} the updated unit.
   */
  function updateUnit(unit, fn, toUnit) {
    var updated = fn(parseInt(unit, 10));

    if (typeof unit === 'number') {
      return toUnit ? '' + updated + toUnit : updated;
    }

    return '' + updated + unit.replace(/[0-9]/g, '');
  }
});

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('prop-types'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.propTypes);
    global.minNumber = mod.exports;
  }
})(this, function (exports, _propTypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = minNumber;

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Validates the a prop's value is greater than or equal to the minimum value.
   *
   * @param {Number} min - the minimum value for the prop.
   * @param {Boolean} required - Boolean if the prop is required.
   * @return {Error} an error or null.
   */
  function minNumber(min, required) {
    return function validate(props, propName, componentName, location, propFullName) {
      var componentNameSafe = componentName || '<<anonymous>>';
      var propFullNameSafe = propFullName || propName;

      var validator = _propTypes2.default.number;
      if (required) {
        validator = validator.isRequired;
      }

      for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
        args[_key - 5] = arguments[_key];
      }

      var err = validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
      if (!required && !err && props[propName] < min) {
        err = new Error('The ' + location + ' `' + propFullNameSafe + '` must be greater than or equal to the min value ' + ('`' + min + '` but received `' + props[propName] + '` for the `' + componentNameSafe + '` component.'));
      }

      return err;
    };
  }
});

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.oneRequiredForA11y = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = oneRequiredForA11y;
  /**
   * This validator checks that either the current prop is defined and valid or that one of the
   * other given prop names are defined. If it fails it returns an error for a11y.
   *
   * @param {function} validator - The React PropTypes validator to use for the given prop.
   * @param {String[]} otherPropNames - Any other prop names to validate against.
   * @return {Error} an error or null
   */
  function oneRequiredForA11y(validator) {
    for (var _len = arguments.length, otherPropNames = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      otherPropNames[_key - 1] = arguments[_key];
    }

    return function validate(props, propName, componentName, location, propFullName) {
      var componentNameSafe = componentName || '<<anonymous>>';
      var propFullNameSafe = propFullName || propName;
      var allPropNames = [propFullNameSafe].concat(otherPropNames);

      for (var _len2 = arguments.length, args = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
        args[_key2 - 5] = arguments[_key2];
      }

      var err = validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
      if (!err && !allPropNames.filter(function (pn) {
        return typeof props[pn] !== 'undefined';
      }).length) {
        err = new Error('One of the following props are required to make ' + componentNameSafe + ' accessible ' + ('for users of assistive technologies such as screen readers. `' + allPropNames.join('`, ') + '`.'));
      }

      return err;
    };
  }
});

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.oneRequiredForA11yIf = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = oneRequiredForA11yIf;
  function oneRequiredForA11yIf(validator, requiringProp) {
    for (var _len = arguments.length, otherPropNames = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      otherPropNames[_key - 2] = arguments[_key];
    }

    return function validate(props, propName, componentName, location, propFullName) {
      var filterUndefined = function filterUndefined(pn) {
        return typeof props[pn] !== 'undefined';
      };
      var componentNameSafe = componentName || '<<anonymous>>';
      var propFullNameSafe = propFullName || propName;
      var requiredDefined = typeof props[requiringProp] !== 'undefined';
      var allPropNames = [propFullNameSafe].concat(otherPropNames);

      for (var _len2 = arguments.length, args = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
        args[_key2 - 5] = arguments[_key2];
      }

      var err = validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
      if (!err && requiredDefined && !allPropNames.filter(filterUndefined).length) {
        err = new Error('One of the following props are required to make `' + componentNameSafe + '` accessible ' + ('for users of assistive technologies such as screen readers when using the `' + requiringProp + '` ') + ('prop. `' + allPropNames.join('`, `') + '`.'));
      }

      return err;
    };
  }
});

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.requiredForA11yIfNot = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = requiredForA11yIfNot;
  /**
   * This validator checkes that the current prop is valid and defined ONLY if
   * any of the `otherPropNames` are not true or defined.
   *
   * @param {function} validator - The React PropTypes validator to use for the given prop.
   * @param {String[]} otherPropNames - Any other prop names to validate against.
   * @return {Error} an error or null
   */
  function requiredForA11yIfNot(validator) {
    for (var _len = arguments.length, otherPropNames = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      otherPropNames[_key - 1] = arguments[_key];
    }

    return function validate(props, propName, componentName, location, propFullName) {
      var componentNameSafe = componentName || '<<anonymous>>';
      var propFullNameSafe = propFullName || propName;
      var defined = typeof props[propName] !== 'undefined';

      for (var _len2 = arguments.length, args = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
        args[_key2 - 5] = arguments[_key2];
      }

      var err = validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
      if (!err && !defined && !otherPropNames.filter(function (pn) {
        return !!props[pn];
      }).length) {
        err = new Error('The `' + propFullNameSafe + '` ' + location + ' is required to make `' + componentNameSafe + '` accessible ' + 'for users of assistive technologies such as screen readers.');
      }

      return err;
    };
  }
});

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.capitalizeFirst = mod.exports;
  }
})(this, function (exports) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = capitalizeFirst;
  /**
   * Capitalizes the first letter of a string. If the string is falsish, it will be
   * returned as is. If the string is only one letter long, it will be capitalized;
   *
   * @param {String} str - The string to capitalize.
   * @return {String} the updated string or false-ish self.
   */
  function capitalizeFirst(str) {
    if (!str) {
      return str;
    } else if (str.length === 1) {
      return str.toUpperCase();
    }

    return "" + str.charAt(0).toUpperCase() + str.substring(1, str.length);
  }
});

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.closest = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = closest;
  /**
   * A _very_ primitive polyfill for the Element.closest function. If this is a browser that doesn't
   * support it (IE, Edge, etc), it will just keep searching the parent elements until the nodeName
   * matches the provided type.
   *
   * @param {Element} el - the html element to find a closest node type for
   * @param {String} type - the html element type to find.
   * @return {Element} the found element or null.
   */
  function closest(el, type) {
    if (typeof el.closest === 'function') {
      return el.closest(type);
    }

    var nodeType = type.toUpperCase();
    var node = el.parentElement;
    while (node && node.parentElement) {
      if (node.nodeName === nodeType) {
        return node;
      }

      node = node.parentElement;
    }

    return null;
  }
});

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(593)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./getPagePosition'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.getPagePosition);
    global.toggleScroll = mod.exports;
  }
})(this, function (exports, _getPagePosition) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = toggleScroll;

  var _getPagePosition2 = _interopRequireDefault(_getPagePosition);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * A utility function for toggling the overflow visibility on an element. This will either target
   * the given `selector`, or the `body` tag to set a `className`.
   *
   * If the `visible` param is `undefined`, the className will be toggled.
   * If the `visible` param is `true`, the className will be added.
   * If the `visible` param is `false`, the className will be removed.
   *
   *
   * > This depends on the `classList` attribute on elements.
   *
   * @param {bool=} visible - An optional boolean to determine how the `className` will be applied.
   * @param {string|Object=} selector - An optional query selector string to use to select an element.
   * @param {string=} className - The className to apply. Defaults to 'md-overflow-hidden'
   */
  function toggleScroll(scrollable, selector) {
    var className = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'md-no-scroll';

    var queryable = !selector || typeof selector === 'string';
    var el = void 0;
    if (queryable) {
      el = selector ? document.querySelector(selector) : document.querySelector('html');
    } else {
      el = selector;
    }

    if (!el) {
      return;
    }

    if (typeof scrollable === 'undefined') {
      scrollable = !el.classList.contains(className);
    }

    if (scrollable && !el.classList.contains(className)) {
      el.style.top = '-' + (queryable ? (0, _getPagePosition2.default)('y') : el.scrollTop) + 'px';
      el.classList.add(className);
    } else if (!scrollable && el.classList.contains(className)) {
      var scrollTop = Math.abs(parseInt(el.style.top, 10));
      el.classList.remove(className);
      el.style.top = null;

      if (!selector) {
        window.scrollTo(0, scrollTop);
      } else {
        el.scrollTop = scrollTop;
      }
    }
  }
});

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(268);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(158);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(270);

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__(76);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(77);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(269);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

var Motion = (function (_React$Component) {
  _inherits(Motion, _React$Component);

  _createClass(Motion, null, [{
    key: 'propTypes',
    value: {
      // TOOD: warn against putting a config in here
      defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
      children: _propTypes2['default'].func.isRequired,
      onRest: _propTypes2['default'].func
    },
    enumerable: true
  }]);

  function Motion(props) {
    var _this = this;

    _classCallCheck(this, Motion);

    _React$Component.call(this, props);
    this.wasAnimating = false;
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyle = null;

    this.clearUnreadPropStyle = function (destStyle) {
      var dirty = false;
      var _state = _this.state;
      var currentStyle = _state.currentStyle;
      var currentVelocity = _state.currentVelocity;
      var lastIdealStyle = _state.lastIdealStyle;
      var lastIdealVelocity = _state.lastIdealVelocity;

      for (var key in destStyle) {
        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
          continue;
        }

        var styleValue = destStyle[key];
        if (typeof styleValue === 'number') {
          if (!dirty) {
            dirty = true;
            currentStyle = _extends({}, currentStyle);
            currentVelocity = _extends({}, currentVelocity);
            lastIdealStyle = _extends({}, lastIdealStyle);
            lastIdealVelocity = _extends({}, lastIdealVelocity);
          }

          currentStyle[key] = styleValue;
          currentVelocity[key] = 0;
          lastIdealStyle[key] = styleValue;
          lastIdealVelocity[key] = 0;
        }
      }

      if (dirty) {
        _this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
      }
    };

    this.startAnimationIfNecessary = function () {
      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        // check if we need to animate in the first place
        var propsStyle = _this.props.style;
        if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
          if (_this.wasAnimating && _this.props.onRest) {
            _this.props.onRest();
          }

          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.wasAnimating = false;
          _this.accumulatedTime = 0;
          return;
        }

        _this.wasAnimating = true;

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var newLastIdealStyle = {};
        var newLastIdealVelocity = {};
        var newCurrentStyle = {};
        var newCurrentVelocity = {};

        for (var key in propsStyle) {
          if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
            continue;
          }

          var styleValue = propsStyle[key];
          if (typeof styleValue === 'number') {
            newCurrentStyle[key] = styleValue;
            newCurrentVelocity[key] = 0;
            newLastIdealStyle[key] = styleValue;
            newLastIdealVelocity[key] = 0;
          } else {
            var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
            var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
            for (var i = 0; i < framesToCatchUp; i++) {
              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              newLastIdealStyleValue = _stepper[0];
              newLastIdealVelocityValue = _stepper[1];
            }

            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

            var nextIdealX = _stepper2[0];
            var nextIdealV = _stepper2[1];

            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
            newLastIdealStyle[key] = newLastIdealStyleValue;
            newLastIdealVelocity[key] = newLastIdealVelocityValue;
          }
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyle: newCurrentStyle,
          currentVelocity: newCurrentVelocity,
          lastIdealStyle: newLastIdealStyle,
          lastIdealVelocity: newLastIdealVelocity
        });

        _this.unreadPropStyle = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  Motion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyle = _props.defaultStyle;
    var style = _props.style;

    var currentStyle = defaultStyle || _stripStyle2['default'](style);
    var currentVelocity = _mapToZero2['default'](currentStyle);
    return {
      currentStyle: currentStyle,
      currentVelocity: currentVelocity,
      lastIdealStyle: currentStyle,
      lastIdealVelocity: currentVelocity
    };
  };

  // it's possible that currentStyle's value is stale: if props is immediately
  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
  // at 0 (didn't have time to tick and interpolate even once). If we naively
  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
  // In reality currentStyle should be 400

  Motion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyle != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyle);
    }

    this.unreadPropStyle = props.style;
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  Motion.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  Motion.prototype.render = function render() {
    var renderedChildren = this.props.children(this.state.currentStyle);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return Motion;
})(_react2['default'].Component);

exports['default'] = Motion;
module.exports = exports['default'];

// after checking for unreadPropStyle != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(268);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(158);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(270);

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__(76);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(77);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(269);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
  for (var i = 0; i < currentStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
      return false;
    }
  }
  return true;
}

var StaggeredMotion = (function (_React$Component) {
  _inherits(StaggeredMotion, _React$Component);

  _createClass(StaggeredMotion, null, [{
    key: 'propTypes',
    value: {
      // TOOD: warn against putting a config in here
      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
      styles: _propTypes2['default'].func.isRequired,
      children: _propTypes2['default'].func.isRequired
    },
    enumerable: true
  }]);

  function StaggeredMotion(props) {
    var _this = this;

    _classCallCheck(this, StaggeredMotion);

    _React$Component.call(this, props);
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyles = null;

    this.clearUnreadPropStyle = function (unreadPropStyles) {
      var _state = _this.state;
      var currentStyles = _state.currentStyles;
      var currentVelocities = _state.currentVelocities;
      var lastIdealStyles = _state.lastIdealStyles;
      var lastIdealVelocities = _state.lastIdealVelocities;

      var someDirty = false;
      for (var i = 0; i < unreadPropStyles.length; i++) {
        var unreadPropStyle = unreadPropStyles[i];
        var dirty = false;

        for (var key in unreadPropStyle) {
          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
            continue;
          }

          var styleValue = unreadPropStyle[key];
          if (typeof styleValue === 'number') {
            if (!dirty) {
              dirty = true;
              someDirty = true;
              currentStyles[i] = _extends({}, currentStyles[i]);
              currentVelocities[i] = _extends({}, currentVelocities[i]);
              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
            }
            currentStyles[i][key] = styleValue;
            currentVelocities[i][key] = 0;
            lastIdealStyles[i][key] = styleValue;
            lastIdealVelocities[i][key] = 0;
          }
        }
      }

      if (someDirty) {
        _this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
      }
    };

    this.startAnimationIfNecessary = function () {
      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        var destStyles = _this.props.styles(_this.state.lastIdealStyles);

        // check if we need to animate in the first place
        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.accumulatedTime = 0;
          return;
        }

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var newLastIdealStyles = [];
        var newLastIdealVelocities = [];
        var newCurrentStyles = [];
        var newCurrentVelocities = [];

        for (var i = 0; i < destStyles.length; i++) {
          var destStyle = destStyles[i];
          var newCurrentStyle = {};
          var newCurrentVelocity = {};
          var newLastIdealStyle = {};
          var newLastIdealVelocity = {};

          for (var key in destStyle) {
            if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
              continue;
            }

            var styleValue = destStyle[key];
            if (typeof styleValue === 'number') {
              newCurrentStyle[key] = styleValue;
              newCurrentVelocity[key] = 0;
              newLastIdealStyle[key] = styleValue;
              newLastIdealVelocity[key] = 0;
            } else {
              var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
              var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
              for (var j = 0; j < framesToCatchUp; j++) {
                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

                newLastIdealStyleValue = _stepper[0];
                newLastIdealVelocityValue = _stepper[1];
              }

              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              var nextIdealX = _stepper2[0];
              var nextIdealV = _stepper2[1];

              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
              newLastIdealStyle[key] = newLastIdealStyleValue;
              newLastIdealVelocity[key] = newLastIdealVelocityValue;
            }
          }

          newCurrentStyles[i] = newCurrentStyle;
          newCurrentVelocities[i] = newCurrentVelocity;
          newLastIdealStyles[i] = newLastIdealStyle;
          newLastIdealVelocities[i] = newLastIdealVelocity;
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyles: newCurrentStyles,
          currentVelocities: newCurrentVelocities,
          lastIdealStyles: newLastIdealStyles,
          lastIdealVelocities: newLastIdealVelocities
        });

        _this.unreadPropStyles = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  StaggeredMotion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;

    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
    var currentVelocities = currentStyles.map(function (currentStyle) {
      return _mapToZero2['default'](currentStyle);
    });
    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: currentStyles,
      lastIdealVelocities: currentVelocities
    };
  };

  StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyles != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  StaggeredMotion.prototype.render = function render() {
    var renderedChildren = this.props.children(this.state.currentStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return StaggeredMotion;
})(_react2['default'].Component);

exports['default'] = StaggeredMotion;
module.exports = exports['default'];

// it's possible that currentStyle's value is stale: if props is immediately
// changed from 0 to 400 to spring(0) again, the async currentStyle is still
// at 0 (didn't have time to tick and interpolate even once). If we naively
// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
// In reality currentStyle should be 400

// after checking for unreadPropStyles != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(268);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(158);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(270);

var _stepper4 = _interopRequireDefault(_stepper3);

var _mergeDiff = __webpack_require__(1207);

var _mergeDiff2 = _interopRequireDefault(_mergeDiff);

var _performanceNow = __webpack_require__(76);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(77);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(269);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

// the children function & (potential) styles function asks as param an
// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
// {key: string, data?: any, style: PlainStyle}. However, the way we keep
// internal states doesn't contain such a data structure (check the state and
// TransitionMotionState). So when children function and others ask for such
// data we need to generate them on the fly by combining mergedPropsStyles and
// currentStyles/lastIdealStyles
function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
  // Copy the value to a `const` so that Flow understands that the const won't
  // change and will be non-nullable in the callback below.
  var cUnreadPropStyles = unreadPropStyles;
  if (cUnreadPropStyles == null) {
    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
      return {
        key: mergedPropsStyle.key,
        data: mergedPropsStyle.data,
        style: plainStyles[i]
      };
    });
  }
  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
    for (var j = 0; j < cUnreadPropStyles.length; j++) {
      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
        return {
          key: cUnreadPropStyles[j].key,
          data: cUnreadPropStyles[j].data,
          style: plainStyles[i]
        };
      }
    }
    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
  });
}

function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
  if (mergedPropsStyles.length !== destStyles.length) {
    return false;
  }

  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (mergedPropsStyles[i].key !== destStyles[i].key) {
      return false;
    }
  }

  // we have the invariant that mergedPropsStyles and
  // currentStyles/currentVelocities/last* are synced in terms of cells, see
  // mergeAndSync comment for more info
  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
      return false;
    }
  }

  return true;
}

// core key merging logic

// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
// c}, previous current (interpolating) style is {a, b}
// **invariant**: current[i] corresponds to merged[i] in terms of key

// steps:
// turn merged style into {a?, b, c}
//    add c, value of c is destStyles.c
//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
// turn current (interpolating) style from {a, b} into {a?, b, c}
//    maybe remove a
//    certainly add c, value of c is willEnter(c)
// loop over merged and construct new current
// dest doesn't change, that's owner's
function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
    var leavingStyle = willLeave(oldMergedPropsStyle);
    if (leavingStyle == null) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
  });

  var newCurrentStyles = [];
  var newCurrentVelocities = [];
  var newLastIdealStyles = [];
  var newLastIdealVelocities = [];
  for (var i = 0; i < newMergedPropsStyles.length; i++) {
    var newMergedPropsStyleCell = newMergedPropsStyles[i];
    var foundOldIndex = null;
    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
        foundOldIndex = j;
        break;
      }
    }
    // TODO: key search code
    if (foundOldIndex == null) {
      var plainStyle = willEnter(newMergedPropsStyleCell);
      newCurrentStyles[i] = plainStyle;
      newLastIdealStyles[i] = plainStyle;

      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
      newCurrentVelocities[i] = velocity;
      newLastIdealVelocities[i] = velocity;
    } else {
      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
    }
  }

  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
}

var TransitionMotion = (function (_React$Component) {
  _inherits(TransitionMotion, _React$Component);

  _createClass(TransitionMotion, null, [{
    key: 'propTypes',
    value: {
      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
        key: _propTypes2['default'].string.isRequired,
        data: _propTypes2['default'].any,
        style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
      })),
      styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
        key: _propTypes2['default'].string.isRequired,
        data: _propTypes2['default'].any,
        style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
      }))]).isRequired,
      children: _propTypes2['default'].func.isRequired,
      willEnter: _propTypes2['default'].func,
      willLeave: _propTypes2['default'].func,
      didLeave: _propTypes2['default'].func
    },
    enumerable: true
  }, {
    key: 'defaultProps',
    value: {
      willEnter: function willEnter(styleThatEntered) {
        return _stripStyle2['default'](styleThatEntered.style);
      },
      // recall: returning null makes the current unmounting TransitionStyle
      // disappear immediately
      willLeave: function willLeave() {
        return null;
      },
      didLeave: function didLeave() {}
    },
    enumerable: true
  }]);

  function TransitionMotion(props) {
    var _this = this;

    _classCallCheck(this, TransitionMotion);

    _React$Component.call(this, props);
    this.unmounting = false;
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyles = null;

    this.clearUnreadPropStyle = function (unreadPropStyles) {
      var _mergeAndSync = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

      var mergedPropsStyles = _mergeAndSync[0];
      var currentStyles = _mergeAndSync[1];
      var currentVelocities = _mergeAndSync[2];
      var lastIdealStyles = _mergeAndSync[3];
      var lastIdealVelocities = _mergeAndSync[4];

      for (var i = 0; i < unreadPropStyles.length; i++) {
        var unreadPropStyle = unreadPropStyles[i].style;
        var dirty = false;

        for (var key in unreadPropStyle) {
          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
            continue;
          }

          var styleValue = unreadPropStyle[key];
          if (typeof styleValue === 'number') {
            if (!dirty) {
              dirty = true;
              currentStyles[i] = _extends({}, currentStyles[i]);
              currentVelocities[i] = _extends({}, currentVelocities[i]);
              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
              mergedPropsStyles[i] = {
                key: mergedPropsStyles[i].key,
                data: mergedPropsStyles[i].data,
                style: _extends({}, mergedPropsStyles[i].style)
              };
            }
            currentStyles[i][key] = styleValue;
            currentVelocities[i][key] = 0;
            lastIdealStyles[i][key] = styleValue;
            lastIdealVelocities[i][key] = 0;
            mergedPropsStyles[i].style[key] = styleValue;
          }
        }
      }

      // unlike the other 2 components, we can't detect staleness and optionally
      // opt out of setState here. each style object's data might contain new
      // stuff we're not/cannot compare
      _this.setState({
        currentStyles: currentStyles,
        currentVelocities: currentVelocities,
        mergedPropsStyles: mergedPropsStyles,
        lastIdealStyles: lastIdealStyles,
        lastIdealVelocities: lastIdealVelocities
      });
    };

    this.startAnimationIfNecessary = function () {
      if (_this.unmounting) {
        return;
      }

      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        // https://github.com/chenglou/react-motion/pull/420
        // > if execution passes the conditional if (this.unmounting), then
        // executes async defaultRaf and after that component unmounts and after
        // that the callback of defaultRaf is called, then setState will be called
        // on unmounted component.
        if (_this.unmounting) {
          return;
        }

        var propStyles = _this.props.styles;
        var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;

        // check if we need to animate in the first place
        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.accumulatedTime = 0;
          return;
        }

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var _mergeAndSync2 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

        var newMergedPropsStyles = _mergeAndSync2[0];
        var newCurrentStyles = _mergeAndSync2[1];
        var newCurrentVelocities = _mergeAndSync2[2];
        var newLastIdealStyles = _mergeAndSync2[3];
        var newLastIdealVelocities = _mergeAndSync2[4];

        for (var i = 0; i < newMergedPropsStyles.length; i++) {
          var newMergedPropsStyle = newMergedPropsStyles[i].style;
          var newCurrentStyle = {};
          var newCurrentVelocity = {};
          var newLastIdealStyle = {};
          var newLastIdealVelocity = {};

          for (var key in newMergedPropsStyle) {
            if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
              continue;
            }

            var styleValue = newMergedPropsStyle[key];
            if (typeof styleValue === 'number') {
              newCurrentStyle[key] = styleValue;
              newCurrentVelocity[key] = 0;
              newLastIdealStyle[key] = styleValue;
              newLastIdealVelocity[key] = 0;
            } else {
              var newLastIdealStyleValue = newLastIdealStyles[i][key];
              var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
              for (var j = 0; j < framesToCatchUp; j++) {
                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

                newLastIdealStyleValue = _stepper[0];
                newLastIdealVelocityValue = _stepper[1];
              }

              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              var nextIdealX = _stepper2[0];
              var nextIdealV = _stepper2[1];

              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
              newLastIdealStyle[key] = newLastIdealStyleValue;
              newLastIdealVelocity[key] = newLastIdealVelocityValue;
            }
          }

          newLastIdealStyles[i] = newLastIdealStyle;
          newLastIdealVelocities[i] = newLastIdealVelocity;
          newCurrentStyles[i] = newCurrentStyle;
          newCurrentVelocities[i] = newCurrentVelocity;
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyles: newCurrentStyles,
          currentVelocities: newCurrentVelocities,
          lastIdealStyles: newLastIdealStyles,
          lastIdealVelocities: newLastIdealVelocities,
          mergedPropsStyles: newMergedPropsStyles
        });

        _this.unreadPropStyles = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  TransitionMotion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;
    var willEnter = _props.willEnter;
    var willLeave = _props.willLeave;
    var didLeave = _props.didLeave;

    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;

    // this is special. for the first time around, we don't have a comparison
    // between last (no last) and current merged props. we'll compute last so:
    // say default is {a, b} and styles (dest style) is {b, c}, we'll
    // fabricate last as {a, b}
    var oldMergedPropsStyles = undefined;
    if (defaultStyles == null) {
      oldMergedPropsStyles = destStyles;
    } else {
      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
        // TODO: key search code
        for (var i = 0; i < destStyles.length; i++) {
          if (destStyles[i].key === defaultStyleCell.key) {
            return destStyles[i];
          }
        }
        return defaultStyleCell;
      });
    }
    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    });
    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    });

    var _mergeAndSync3 = mergeAndSync(
    // Because this is an old-style createReactClass component, Flow doesn't
    // understand that the willEnter and willLeave props have default values
    // and will always be present.
    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
    oldCurrentVelocities);

    var mergedPropsStyles = _mergeAndSync3[0];
    var currentStyles = _mergeAndSync3[1];
    var currentVelocities = _mergeAndSync3[2];
    var lastIdealStyles = _mergeAndSync3[3];
    var lastIdealVelocities = _mergeAndSync3[4];
    // oldLastIdealVelocities really

    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: lastIdealStyles,
      lastIdealVelocities: lastIdealVelocities,
      mergedPropsStyles: mergedPropsStyles
    };
  };

  // after checking for unreadPropStyles != null, we manually go set the
  // non-interpolating values (those that are a number, without a spring
  // config)

  TransitionMotion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyles) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    var styles = props.styles;
    if (typeof styles === 'function') {
      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
    } else {
      this.unreadPropStyles = styles;
    }

    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounting = true;
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  TransitionMotion.prototype.render = function render() {
    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
    var renderedChildren = this.props.children(hydratedStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return TransitionMotion;
})(_react2['default'].Component);

exports['default'] = TransitionMotion;
module.exports = exports['default'];

// list of styles, each containing interpolating values. Part of what's passed
// to children function. Notice that this is
// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
// contains the key & data info (so that we only have a single source of truth
// for these, and to save space). Check the comment for `rehydrateStyles` to
// see how we regenerate the entirety of what's passed to children function

// the array that keeps track of currently rendered stuff! Including stuff
// that you've unmounted but that's still animating. This is where it lives

// it's possible that currentStyle's value is stale: if props is immediately
// changed from 0 to 400 to spring(0) again, the async currentStyle is still
// at 0 (didn't have time to tick and interpolate even once). If we naively
// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
// In reality currentStyle should be 400

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// core keys merging algorithm. If previous render's keys are [a, b], and the
// next render's [c, b, d], what's the final merged keys and ordering?

// - c and a must both be before b
// - b before d
// - ordering between a and c ambiguous

// this reduces to merging two partially ordered lists (e.g. lists where not
// every item has a definite ordering, like comparing a and c above). For the
// ambiguous ordering we deterministically choose to place the next render's
// item after the previous'; so c after a

// this is called a topological sorting. Except the existing algorithms don't
// work well with js bc of the amount of allocation, and isn't optimized for our
// current use-case bc the runtime is linear in terms of edges (see wiki for
// meaning), which is huge when two lists have many common elements


exports.__esModule = true;
exports['default'] = mergeDiff;

function mergeDiff(prev, next, onRemove) {
  // bookkeeping for easier access of a key's index below. This is 2 allocations +
  // potentially triggering chrome hash map mode for objs (so it might be faster

  var prevKeyIndex = {};
  for (var i = 0; i < prev.length; i++) {
    prevKeyIndex[prev[i].key] = i;
  }
  var nextKeyIndex = {};
  for (var i = 0; i < next.length; i++) {
    nextKeyIndex[next[i].key] = i;
  }

  // first, an overly elaborate way of merging prev and next, eliminating
  // duplicates (in terms of keys). If there's dupe, keep the item in next).
  // This way of writing it saves allocations
  var ret = [];
  for (var i = 0; i < next.length; i++) {
    ret[i] = next[i];
  }
  for (var i = 0; i < prev.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
      // merge in keys that the user desires to kill
      var fill = onRemove(i, prev[i]);
      if (fill != null) {
        ret.push(fill);
      }
    }
  }

  // now all the items all present. Core sorting logic to have the right order
  return ret.sort(function (a, b) {
    var nextOrderA = nextKeyIndex[a.key];
    var nextOrderB = nextKeyIndex[b.key];
    var prevOrderA = prevKeyIndex[a.key];
    var prevOrderB = prevKeyIndex[b.key];

    if (nextOrderA != null && nextOrderB != null) {
      // both keys in next
      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
    } else if (prevOrderA != null && prevOrderB != null) {
      // both keys in prev
      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
    } else if (nextOrderA != null) {
      // key a in next, key b in prev

      // how to determine the order between a and b? We find a "pivot" (term
      // abuse), a key present in both prev and next, that is sandwiched between
      // a and b. In the context of our above example, if we're comparing a and
      // d, b's (the only) pivot
      for (var i = 0; i < next.length; i++) {
        var pivot = next[i].key;
        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
          continue;
        }

        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
          return -1;
        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
          return 1;
        }
      }
      // pluggable. default to: next bigger than prev
      return 1;
    }
    // prevOrderA, nextOrderB
    for (var i = 0; i < next.length; i++) {
      var pivot = next[i].key;
      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
        continue;
      }
      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
        return 1;
      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
        return -1;
      }
    }
    // pluggable. default to: next bigger than prev
    return -1;
  });
}

module.exports = exports['default'];
// to loop through and find a key's index each time), but I no longer care

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = reorderKeys;

var hasWarned = false;

function reorderKeys() {
  if (false) {
    if (!hasWarned) {
      hasWarned = true;
      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
    }
  }
}

module.exports = exports['default'];

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = spring;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _presets = __webpack_require__(596);

var _presets2 = _interopRequireDefault(_presets);

var defaultConfig = _extends({}, _presets2['default'].noWobble, {
  precision: 0.01
});

function spring(val, config) {
  return _extends({}, defaultConfig, config, { val: val });
}

module.exports = exports['default'];

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(2),__webpack_require__(0)):"function"==typeof define&&define.amd?define(["moment","react"],t):"object"==typeof exports?exports["react-moment"]=t(require("moment"),require("react")):e["react-moment"]=t(e.moment,e.react)}(this,function(e,t){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={exports:{},id:r,loaded:!1};return e[r].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var n={};return t.m=e,t.c=n,t.p="",t(0)}([function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},l=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(13),f=r(c),s=n(11),p=r(s),d=n(12),y=r(d),m=n(6),v=[p.default.string,p.default.number,p.default.array,p.default.object],h=[p.default.string,p.default.array],b=function(e){function t(e){o(this,t);var n=i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.setTimer=function(){n.clearTimer();var e=n.props.interval;t.pooledTimer||0===e||(n.timer=setInterval(function(){n.update(n.props)},e))},n.clearTimer=function(){!t.pooledTimer&&n.timer&&(clearInterval(n.timer),n.timer=null),t.pooledTimer&&!n.timer&&t.removePooledElement(n)},t.globalMoment||(t.globalMoment=y.default),n.state={content:""},n.timer=null,n}return a(t,e),l(t,null,[{key:"startPooledTimer",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:6e4;t.clearPooledTimer(),t.pooledTimer=setInterval(function(){t.pooledElements.forEach(function(e){0!==e.props.interval&&e.update()})},e)}},{key:"clearPooledTimer",value:function(){t.pooledTimer&&(clearInterval(t.pooledTimer),t.pooledTimer=null,t.pooledElements=[])}},{key:"pushPooledElement",value:function(e){return e instanceof t?void(t.pooledElements.indexOf(e)===-1&&t.pooledElements.push(e)):void console.error("Element not an instance of Moment.")}},{key:"removePooledElement",value:function(e){var n=t.pooledElements.indexOf(e);n!==-1&&t.pooledElements.splice(n,1)}},{key:"getDatetime",value:function(e){var n=e.utc,r=e.unix,o=e.tz,i=e.date,a=e.locale,u=e.parse;i=i||e.children,u=u||t.globalParse,a=t.globalLocale?t.globalLocale:a||t.globalMoment.locale();var l=null;return l=n?t.globalMoment.utc(i,u,a):r?t.globalMoment(1e3*i,u,a):t.globalMoment(i,u,a),o&&(l=l.tz(o)),l}}]),l(t,[{key:"componentWillMount",value:function(){this.update(this.props)}},{key:"componentDidMount",value:function(){this.setTimer(),t.pooledTimer&&t.pushPooledElement(this)}},{key:"componentWillReceiveProps",value:function(e){this.update(e)}},{key:"componentDidUpdate",value:function(e){e.interval!==this.props.interval&&this.setTimer()}},{key:"componentWillUnmount",value:function(){this.clearTimer()}},{key:"update",value:function(e){var n=this;e=e||this.props;var r=e,o=r.fromNow,i=r.from,a=r.add,u=r.subtract,l=r.toNow,c=r.to,f=r.ago,s=r.calendar,p=e,d=p.format;d=d||t.globalFormat;var y=t.getDatetime(e);a&&y.add(a),u&&y.subtract(u);var m="";m=d?y.format(d):i?y.from(i,f):o?y.fromNow(f):c?y.to(c,f):l?y.toNow(f):s?y.calendar():y.toString();var v=t.globalFilter||this.props.filter;m=v(m),this.setState({content:m},function(){n.props.onChange(m)})}},{key:"render",value:function(){var e=(0,m.objectKeyFilter)(this.props,t.propTypes);return f.default.createElement(t.globalElement||this.props.element,u({dateTime:t.getDatetime(this.props)},e),this.state.content)}}]),t}(f.default.Component);b.propTypes={element:p.default.any,date:p.default.oneOfType(v),parse:p.default.oneOfType(h),format:p.default.string,add:p.default.object,subtract:p.default.object,ago:p.default.bool,fromNow:p.default.bool,from:p.default.oneOfType(v),toNow:p.default.bool,to:p.default.oneOfType(v),calendar:p.default.bool,unix:p.default.bool,utc:p.default.bool,tz:p.default.string,locale:p.default.string,interval:p.default.number,filter:p.default.func,onChange:p.default.func},b.defaultProps={element:"time",fromNow:!1,toNow:!1,calendar:!1,ago:!1,unix:!1,utc:!1,interval:6e4,filter:function(e){return e},onChange:function(){}},b.globalMoment=null,b.globalLocale=null,b.globalFormat=null,b.globalParse=null,b.globalFilter=null,b.globalElement=null,b.pooledElements=[],b.pooledTimer=null,t.default=b},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(f===setTimeout)return setTimeout(e,0);if((f===n||!f)&&setTimeout)return f=setTimeout,setTimeout(e,0);try{return f(e,0)}catch(t){try{return f.call(null,e,0)}catch(t){return f.call(this,e,0)}}}function i(e){if(s===clearTimeout)return clearTimeout(e);if((s===r||!s)&&clearTimeout)return s=clearTimeout,clearTimeout(e);try{return s(e)}catch(t){try{return s.call(null,e)}catch(t){return s.call(this,e)}}}function a(){m&&d&&(m=!1,d.length?y=d.concat(y):v=-1,y.length&&u())}function u(){if(!m){var e=o(a);m=!0;for(var t=y.length;t;){for(d=y,y=[];++v<t;)d&&d[v].run();v=-1,t=y.length}d=null,m=!1,i(e)}}function l(e,t){this.fun=e,this.array=t}function c(){}var f,s,p=e.exports={};!function(){try{f="function"==typeof setTimeout?setTimeout:n}catch(e){f=n}try{s="function"==typeof clearTimeout?clearTimeout:r}catch(e){s=r}}();var d,y=[],m=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];y.push(new l(e,t)),1!==y.length||m||o(u)},l.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=c,p.addListener=c,p.once=c,p.off=c,p.removeListener=c,p.removeAllListeners=c,p.emit=c,p.prependListener=c,p.prependOnceListener=c,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){"use strict";function n(e){return function(){return e}}var r=function(){};r.thatReturns=n,r.thatReturnsFalse=n(!1),r.thatReturnsTrue=n(!0),r.thatReturnsNull=n(null),r.thatReturnsThis=function(){return this},r.thatReturnsArgument=function(e){return e},e.exports=r},function(e,t,n){(function(t){"use strict";function n(e,t,n,o,i,a,u,l){if(r(t),!e){var c;if(void 0===t)c=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var f=[n,o,i,a,u,l],s=0;c=new Error(t.replace(/%s/g,function(){return f[s++]})),c.name="Invariant Violation"}throw c.framesToPop=1,c}}var r=function(e){};"production"!==t.env.NODE_ENV&&(r=function(e){if(void 0===e)throw new Error("invariant requires an error message argument")}),e.exports=n}).call(t,n(1))},function(e,t){"use strict";var n="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=n},function(e,t,n){(function(t){"use strict";var r=n(2),o=r;if("production"!==t.env.NODE_ENV){var i=function(e){for(var t=arguments.length,n=Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];var o=0,i="Warning: "+e.replace(/%s/g,function(){return n[o++]});"undefined"!=typeof console&&console.error(i);try{throw new Error(i)}catch(e){}};o=function(e,t){if(void 0===t)throw new Error("`warning(condition, format, ...args)` requires a warning message argument");if(0!==t.indexOf("Failed Composite propType: ")&&!e){for(var n=arguments.length,r=Array(n>2?n-2:0),o=2;o<n;o++)r[o-2]=arguments[o];i.apply(void 0,[t].concat(r))}}}e.exports=o}).call(t,n(1))},function(e,t){"use strict";function n(e,t){var n=Object.keys(t),r=Object.assign({},e);return Object.keys(r).filter(function(e){return n.indexOf(e)!==-1}).forEach(function(e){return delete r[e]}),r}Object.defineProperty(t,"__esModule",{value:!0}),t.objectKeyFilter=n},function(e,t){/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
"use strict";function n(e){if(null===e||void 0===e)throw new TypeError("Object.assign cannot be called with null or undefined");return Object(e)}function r(){try{if(!Object.assign)return!1;var e=new String("abc");if(e[5]="de","5"===Object.getOwnPropertyNames(e)[0])return!1;for(var t={},n=0;n<10;n++)t["_"+String.fromCharCode(n)]=n;var r=Object.getOwnPropertyNames(t).map(function(e){return t[e]});if("0123456789"!==r.join(""))return!1;var o={};return"abcdefghijklmnopqrst".split("").forEach(function(e){o[e]=e}),"abcdefghijklmnopqrst"===Object.keys(Object.assign({},o)).join("")}catch(e){return!1}}var o=Object.getOwnPropertySymbols,i=Object.prototype.hasOwnProperty,a=Object.prototype.propertyIsEnumerable;e.exports=r()?Object.assign:function(e,t){for(var r,u,l=n(e),c=1;c<arguments.length;c++){r=Object(arguments[c]);for(var f in r)i.call(r,f)&&(l[f]=r[f]);if(o){u=o(r);for(var s=0;s<u.length;s++)a.call(r,u[s])&&(l[u[s]]=r[u[s]])}}return l}},function(e,t,n){(function(t){"use strict";function r(e,n,r,l,c){if("production"!==t.env.NODE_ENV)for(var f in e)if(e.hasOwnProperty(f)){var s;try{o("function"==typeof e[f],"%s: %s type `%s` is invalid; it must be a function, usually from the `prop-types` package, but received `%s`.",l||"React class",r,f,typeof e[f]),s=e[f](n,f,l,r,null,a)}catch(e){s=e}if(i(!s||s instanceof Error,"%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).",l||"React class",r,f,typeof s),s instanceof Error&&!(s.message in u)){u[s.message]=!0;var p=c?c():"";i(!1,"Failed %s type: %s%s",r,s.message,null!=p?p:"")}}}if("production"!==t.env.NODE_ENV)var o=n(3),i=n(5),a=n(4),u={};e.exports=r}).call(t,n(1))},function(e,t,n){"use strict";var r=n(2),o=n(3),i=n(4);e.exports=function(){function e(e,t,n,r,a,u){u!==i&&o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var n={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return n.checkPropTypes=r,n.PropTypes=n,n}},function(e,t,n){(function(t){"use strict";var r=n(2),o=n(3),i=n(5),a=n(7),u=n(4),l=n(8);e.exports=function(e,n){function c(e){var t=e&&(R&&e[R]||e[I]);if("function"==typeof t)return t}function f(e,t){return e===t?0!==e||1/e===1/t:e!==e&&t!==t}function s(e){this.message=e,this.stack=""}function p(e){function r(r,c,f,p,d,y,m){if(p=p||S,y=y||f,m!==u)if(n)o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");else if("production"!==t.env.NODE_ENV&&"undefined"!=typeof console){var v=p+":"+f;!a[v]&&l<3&&(i(!1,"You are manually calling a React.PropTypes validation function for the `%s` prop on `%s`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details.",y,p),a[v]=!0,l++)}return null==c[f]?r?new s(null===c[f]?"The "+d+" `"+y+"` is marked as required "+("in `"+p+"`, but its value is `null`."):"The "+d+" `"+y+"` is marked as required in "+("`"+p+"`, but its value is `undefined`.")):null:e(c,f,p,d,y)}if("production"!==t.env.NODE_ENV)var a={},l=0;var c=r.bind(null,!1);return c.isRequired=r.bind(null,!0),c}function d(e){function t(t,n,r,o,i,a){var u=t[n],l=P(u);if(l!==e){var c=k(u);return new s("Invalid "+o+" `"+i+"` of type "+("`"+c+"` supplied to `"+r+"`, expected ")+("`"+e+"`."))}return null}return p(t)}function y(){return p(r.thatReturnsNull)}function m(e){function t(t,n,r,o,i){if("function"!=typeof e)return new s("Property `"+i+"` of component `"+r+"` has invalid PropType notation inside arrayOf.");var a=t[n];if(!Array.isArray(a)){var l=P(a);return new s("Invalid "+o+" `"+i+"` of type "+("`"+l+"` supplied to `"+r+"`, expected an array."))}for(var c=0;c<a.length;c++){var f=e(a,c,r,o,i+"["+c+"]",u);if(f instanceof Error)return f}return null}return p(t)}function v(){function t(t,n,r,o,i){var a=t[n];if(!e(a)){var u=P(a);return new s("Invalid "+o+" `"+i+"` of type "+("`"+u+"` supplied to `"+r+"`, expected a single ReactElement."))}return null}return p(t)}function h(e){function t(t,n,r,o,i){if(!(t[n]instanceof e)){var a=e.name||S,u=_(t[n]);return new s("Invalid "+o+" `"+i+"` of type "+("`"+u+"` supplied to `"+r+"`, expected ")+("instance of `"+a+"`."))}return null}return p(t)}function b(e){function n(t,n,r,o,i){for(var a=t[n],u=0;u<e.length;u++)if(f(a,e[u]))return null;var l=JSON.stringify(e);return new s("Invalid "+o+" `"+i+"` of value `"+a+"` "+("supplied to `"+r+"`, expected one of "+l+"."))}return Array.isArray(e)?p(n):("production"!==t.env.NODE_ENV?i(!1,"Invalid argument supplied to oneOf, expected an instance of array."):void 0,r.thatReturnsNull)}function g(e){function t(t,n,r,o,i){if("function"!=typeof e)return new s("Property `"+i+"` of component `"+r+"` has invalid PropType notation inside objectOf.");var a=t[n],l=P(a);if("object"!==l)return new s("Invalid "+o+" `"+i+"` of type "+("`"+l+"` supplied to `"+r+"`, expected an object."));for(var c in a)if(a.hasOwnProperty(c)){var f=e(a,c,r,o,i+"."+c,u);if(f instanceof Error)return f}return null}return p(t)}function O(e){function n(t,n,r,o,i){for(var a=0;a<e.length;a++){var l=e[a];if(null==l(t,n,r,o,i,u))return null}return new s("Invalid "+o+" `"+i+"` supplied to "+("`"+r+"`."))}if(!Array.isArray(e))return"production"!==t.env.NODE_ENV?i(!1,"Invalid argument supplied to oneOfType, expected an instance of array."):void 0,r.thatReturnsNull;for(var o=0;o<e.length;o++){var a=e[o];if("function"!=typeof a)return i(!1,"Invalid argument supplied to oneOfType. Expected an array of check functions, but received %s at index %s.",N(a),o),r.thatReturnsNull}return p(n)}function T(){function e(e,t,n,r,o){return j(e[t])?null:new s("Invalid "+r+" `"+o+"` supplied to "+("`"+n+"`, expected a ReactNode."))}return p(e)}function w(e){function t(t,n,r,o,i){var a=t[n],l=P(a);if("object"!==l)return new s("Invalid "+o+" `"+i+"` of type `"+l+"` "+("supplied to `"+r+"`, expected `object`."));for(var c in e){var f=e[c];if(f){var p=f(a,c,r,o,i+"."+c,u);if(p)return p}}return null}return p(t)}function E(e){function t(t,n,r,o,i){var l=t[n],c=P(l);if("object"!==c)return new s("Invalid "+o+" `"+i+"` of type `"+c+"` "+("supplied to `"+r+"`, expected `object`."));var f=a({},t[n],e);for(var p in f){var d=e[p];if(!d)return new s("Invalid "+o+" `"+i+"` key `"+p+"` supplied to `"+r+"`.\nBad object: "+JSON.stringify(t[n],null,"  ")+"\nValid keys: "+JSON.stringify(Object.keys(e),null,"  "));var y=d(l,p,r,o,i+"."+p,u);if(y)return y}return null}return p(t)}function j(t){switch(typeof t){case"number":case"string":case"undefined":return!0;case"boolean":return!t;case"object":if(Array.isArray(t))return t.every(j);if(null===t||e(t))return!0;var n=c(t);if(!n)return!1;var r,o=n.call(t);if(n!==t.entries){for(;!(r=o.next()).done;)if(!j(r.value))return!1}else for(;!(r=o.next()).done;){var i=r.value;if(i&&!j(i[1]))return!1}return!0;default:return!1}}function x(e,t){return"symbol"===e||("Symbol"===t["@@toStringTag"]||"function"==typeof Symbol&&t instanceof Symbol)}function P(e){var t=typeof e;return Array.isArray(e)?"array":e instanceof RegExp?"object":x(t,e)?"symbol":t}function k(e){if("undefined"==typeof e||null===e)return""+e;var t=P(e);if("object"===t){if(e instanceof Date)return"date";if(e instanceof RegExp)return"regexp"}return t}function N(e){var t=k(e);switch(t){case"array":case"object":return"an "+t;case"boolean":case"date":case"regexp":return"a "+t;default:return t}}function _(e){return e.constructor&&e.constructor.name?e.constructor.name:S}var R="function"==typeof Symbol&&Symbol.iterator,I="@@iterator",S="<<anonymous>>",D={array:d("array"),bool:d("boolean"),func:d("function"),number:d("number"),object:d("object"),string:d("string"),symbol:d("symbol"),any:y(),arrayOf:m,element:v(),instanceOf:h,node:T(),objectOf:g,oneOf:b,oneOfType:O,shape:w,exact:E};return s.prototype=Error.prototype,D.checkPropTypes=l,D.PropTypes=D,D}}).call(t,n(1))},function(e,t,n){(function(t){if("production"!==t.env.NODE_ENV){var r="function"==typeof Symbol&&Symbol.for&&Symbol.for("react.element")||60103,o=function(e){return"object"==typeof e&&null!==e&&e.$$typeof===r},i=!0;e.exports=n(10)(o,i)}else e.exports=n(9)()}).call(t,n(1))},function(t,n){t.exports=e},function(e,n){e.exports=t}])});

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _mapToZero = __webpack_require__(271);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(159);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(273);

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__(76);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(77);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(272);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = __webpack_require__(185);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var msPerFrame = 1000 / 60;

var Motion = _createReactClass2['default']({
  propTypes: {
    // TOOD: warn against putting a config in here
    defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
    style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
    children: _propTypes2['default'].func.isRequired,
    onRest: _propTypes2['default'].func
  },

  getInitialState: function getInitialState() {
    var _props = this.props;
    var defaultStyle = _props.defaultStyle;
    var style = _props.style;

    var currentStyle = defaultStyle || _stripStyle2['default'](style);
    var currentVelocity = _mapToZero2['default'](currentStyle);
    return {
      currentStyle: currentStyle,
      currentVelocity: currentVelocity,
      lastIdealStyle: currentStyle,
      lastIdealVelocity: currentVelocity
    };
  },

  wasAnimating: false,
  animationID: null,
  prevTime: 0,
  accumulatedTime: 0,
  // it's possible that currentStyle's value is stale: if props is immediately
  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
  // at 0 (didn't have time to tick and interpolate even once). If we naively
  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
  // In reality currentStyle should be 400
  unreadPropStyle: null,
  // after checking for unreadPropStyle != null, we manually go set the
  // non-interpolating values (those that are a number, without a spring
  // config)
  clearUnreadPropStyle: function clearUnreadPropStyle(destStyle) {
    var dirty = false;
    var _state = this.state;
    var currentStyle = _state.currentStyle;
    var currentVelocity = _state.currentVelocity;
    var lastIdealStyle = _state.lastIdealStyle;
    var lastIdealVelocity = _state.lastIdealVelocity;

    for (var key in destStyle) {
      if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
        continue;
      }

      var styleValue = destStyle[key];
      if (typeof styleValue === 'number') {
        if (!dirty) {
          dirty = true;
          currentStyle = _extends({}, currentStyle);
          currentVelocity = _extends({}, currentVelocity);
          lastIdealStyle = _extends({}, lastIdealStyle);
          lastIdealVelocity = _extends({}, lastIdealVelocity);
        }

        currentStyle[key] = styleValue;
        currentVelocity[key] = 0;
        lastIdealStyle[key] = styleValue;
        lastIdealVelocity[key] = 0;
      }
    }

    if (dirty) {
      this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
    }
  },

  startAnimationIfNecessary: function startAnimationIfNecessary() {
    var _this = this;

    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
    // call cb? No, otherwise accidental parent rerender causes cb trigger
    this.animationID = _raf2['default'](function (timestamp) {
      // check if we need to animate in the first place
      var propsStyle = _this.props.style;
      if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
        if (_this.wasAnimating && _this.props.onRest) {
          _this.props.onRest();
        }

        // no need to cancel animationID here; shouldn't have any in flight
        _this.animationID = null;
        _this.wasAnimating = false;
        _this.accumulatedTime = 0;
        return;
      }

      _this.wasAnimating = true;

      var currentTime = timestamp || _performanceNow2['default']();
      var timeDelta = currentTime - _this.prevTime;
      _this.prevTime = currentTime;
      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
      // more than 10 frames? prolly switched browser tab. Restart
      if (_this.accumulatedTime > msPerFrame * 10) {
        _this.accumulatedTime = 0;
      }

      if (_this.accumulatedTime === 0) {
        // no need to cancel animationID here; shouldn't have any in flight
        _this.animationID = null;
        _this.startAnimationIfNecessary();
        return;
      }

      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

      var newLastIdealStyle = {};
      var newLastIdealVelocity = {};
      var newCurrentStyle = {};
      var newCurrentVelocity = {};

      for (var key in propsStyle) {
        if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
          continue;
        }

        var styleValue = propsStyle[key];
        if (typeof styleValue === 'number') {
          newCurrentStyle[key] = styleValue;
          newCurrentVelocity[key] = 0;
          newLastIdealStyle[key] = styleValue;
          newLastIdealVelocity[key] = 0;
        } else {
          var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
          var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
          for (var i = 0; i < framesToCatchUp; i++) {
            var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

            newLastIdealStyleValue = _stepper[0];
            newLastIdealVelocityValue = _stepper[1];
          }

          var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

          var nextIdealX = _stepper2[0];
          var nextIdealV = _stepper2[1];

          newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
          newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
          newLastIdealStyle[key] = newLastIdealStyleValue;
          newLastIdealVelocity[key] = newLastIdealVelocityValue;
        }
      }

      _this.animationID = null;
      // the amount we're looped over above
      _this.accumulatedTime -= framesToCatchUp * msPerFrame;

      _this.setState({
        currentStyle: newCurrentStyle,
        currentVelocity: newCurrentVelocity,
        lastIdealStyle: newLastIdealStyle,
        lastIdealVelocity: newLastIdealVelocity
      });

      _this.unreadPropStyle = null;

      _this.startAnimationIfNecessary();
    });
  },

  componentDidMount: function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  },

  componentWillReceiveProps: function componentWillReceiveProps(props) {
    if (this.unreadPropStyle != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyle);
    }

    this.unreadPropStyle = props.style;
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  },

  componentWillUnmount: function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  },

  render: function render() {
    var renderedChildren = this.props.children(this.state.currentStyle);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  }
});

exports['default'] = Motion;
module.exports = exports['default'];

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _mapToZero = __webpack_require__(271);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(159);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(273);

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__(76);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(77);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(272);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = __webpack_require__(185);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var msPerFrame = 1000 / 60;

function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
  for (var i = 0; i < currentStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
      return false;
    }
  }
  return true;
}

var StaggeredMotion = _createReactClass2['default']({
  propTypes: {
    // TOOD: warn against putting a config in here
    defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
    styles: _propTypes2['default'].func.isRequired,
    children: _propTypes2['default'].func.isRequired
  },

  getInitialState: function getInitialState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;

    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
    var currentVelocities = currentStyles.map(function (currentStyle) {
      return _mapToZero2['default'](currentStyle);
    });
    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: currentStyles,
      lastIdealVelocities: currentVelocities
    };
  },

  animationID: null,
  prevTime: 0,
  accumulatedTime: 0,
  // it's possible that currentStyle's value is stale: if props is immediately
  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
  // at 0 (didn't have time to tick and interpolate even once). If we naively
  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
  // In reality currentStyle should be 400
  unreadPropStyles: null,
  // after checking for unreadPropStyles != null, we manually go set the
  // non-interpolating values (those that are a number, without a spring
  // config)
  clearUnreadPropStyle: function clearUnreadPropStyle(unreadPropStyles) {
    var _state = this.state;
    var currentStyles = _state.currentStyles;
    var currentVelocities = _state.currentVelocities;
    var lastIdealStyles = _state.lastIdealStyles;
    var lastIdealVelocities = _state.lastIdealVelocities;

    var someDirty = false;
    for (var i = 0; i < unreadPropStyles.length; i++) {
      var unreadPropStyle = unreadPropStyles[i];
      var dirty = false;

      for (var key in unreadPropStyle) {
        if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
          continue;
        }

        var styleValue = unreadPropStyle[key];
        if (typeof styleValue === 'number') {
          if (!dirty) {
            dirty = true;
            someDirty = true;
            currentStyles[i] = _extends({}, currentStyles[i]);
            currentVelocities[i] = _extends({}, currentVelocities[i]);
            lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
            lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
          }
          currentStyles[i][key] = styleValue;
          currentVelocities[i][key] = 0;
          lastIdealStyles[i][key] = styleValue;
          lastIdealVelocities[i][key] = 0;
        }
      }
    }

    if (someDirty) {
      this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
    }
  },

  startAnimationIfNecessary: function startAnimationIfNecessary() {
    var _this = this;

    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
    // call cb? No, otherwise accidental parent rerender causes cb trigger
    this.animationID = _raf2['default'](function (timestamp) {
      var destStyles = _this.props.styles(_this.state.lastIdealStyles);

      // check if we need to animate in the first place
      if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
        // no need to cancel animationID here; shouldn't have any in flight
        _this.animationID = null;
        _this.accumulatedTime = 0;
        return;
      }

      var currentTime = timestamp || _performanceNow2['default']();
      var timeDelta = currentTime - _this.prevTime;
      _this.prevTime = currentTime;
      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
      // more than 10 frames? prolly switched browser tab. Restart
      if (_this.accumulatedTime > msPerFrame * 10) {
        _this.accumulatedTime = 0;
      }

      if (_this.accumulatedTime === 0) {
        // no need to cancel animationID here; shouldn't have any in flight
        _this.animationID = null;
        _this.startAnimationIfNecessary();
        return;
      }

      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

      var newLastIdealStyles = [];
      var newLastIdealVelocities = [];
      var newCurrentStyles = [];
      var newCurrentVelocities = [];

      for (var i = 0; i < destStyles.length; i++) {
        var destStyle = destStyles[i];
        var newCurrentStyle = {};
        var newCurrentVelocity = {};
        var newLastIdealStyle = {};
        var newLastIdealVelocity = {};

        for (var key in destStyle) {
          if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
            continue;
          }

          var styleValue = destStyle[key];
          if (typeof styleValue === 'number') {
            newCurrentStyle[key] = styleValue;
            newCurrentVelocity[key] = 0;
            newLastIdealStyle[key] = styleValue;
            newLastIdealVelocity[key] = 0;
          } else {
            var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
            var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
            for (var j = 0; j < framesToCatchUp; j++) {
              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              newLastIdealStyleValue = _stepper[0];
              newLastIdealVelocityValue = _stepper[1];
            }

            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

            var nextIdealX = _stepper2[0];
            var nextIdealV = _stepper2[1];

            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
            newLastIdealStyle[key] = newLastIdealStyleValue;
            newLastIdealVelocity[key] = newLastIdealVelocityValue;
          }
        }

        newCurrentStyles[i] = newCurrentStyle;
        newCurrentVelocities[i] = newCurrentVelocity;
        newLastIdealStyles[i] = newLastIdealStyle;
        newLastIdealVelocities[i] = newLastIdealVelocity;
      }

      _this.animationID = null;
      // the amount we're looped over above
      _this.accumulatedTime -= framesToCatchUp * msPerFrame;

      _this.setState({
        currentStyles: newCurrentStyles,
        currentVelocities: newCurrentVelocities,
        lastIdealStyles: newLastIdealStyles,
        lastIdealVelocities: newLastIdealVelocities
      });

      _this.unreadPropStyles = null;

      _this.startAnimationIfNecessary();
    });
  },

  componentDidMount: function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  },

  componentWillReceiveProps: function componentWillReceiveProps(props) {
    if (this.unreadPropStyles != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  },

  componentWillUnmount: function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  },

  render: function render() {
    var renderedChildren = this.props.children(this.state.currentStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  }
});

exports['default'] = StaggeredMotion;
module.exports = exports['default'];

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _mapToZero = __webpack_require__(271);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(159);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(273);

var _stepper4 = _interopRequireDefault(_stepper3);

var _mergeDiff = __webpack_require__(1214);

var _mergeDiff2 = _interopRequireDefault(_mergeDiff);

var _performanceNow = __webpack_require__(76);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(77);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(272);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = __webpack_require__(185);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var msPerFrame = 1000 / 60;

// the children function & (potential) styles function asks as param an
// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
// {key: string, data?: any, style: PlainStyle}. However, the way we keep
// internal states doesn't contain such a data structure (check the state and
// TransitionMotionState). So when children function and others ask for such
// data we need to generate them on the fly by combining mergedPropsStyles and
// currentStyles/lastIdealStyles
function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
  // Copy the value to a `const` so that Flow understands that the const won't
  // change and will be non-nullable in the callback below.
  var cUnreadPropStyles = unreadPropStyles;
  if (cUnreadPropStyles == null) {
    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
      return {
        key: mergedPropsStyle.key,
        data: mergedPropsStyle.data,
        style: plainStyles[i]
      };
    });
  }
  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
    for (var j = 0; j < cUnreadPropStyles.length; j++) {
      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
        return {
          key: cUnreadPropStyles[j].key,
          data: cUnreadPropStyles[j].data,
          style: plainStyles[i]
        };
      }
    }
    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
  });
}

function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
  if (mergedPropsStyles.length !== destStyles.length) {
    return false;
  }

  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (mergedPropsStyles[i].key !== destStyles[i].key) {
      return false;
    }
  }

  // we have the invariant that mergedPropsStyles and
  // currentStyles/currentVelocities/last* are synced in terms of cells, see
  // mergeAndSync comment for more info
  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
      return false;
    }
  }

  return true;
}

// core key merging logic

// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
// c}, previous current (interpolating) style is {a, b}
// **invariant**: current[i] corresponds to merged[i] in terms of key

// steps:
// turn merged style into {a?, b, c}
//    add c, value of c is destStyles.c
//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
// turn current (interpolating) style from {a, b} into {a?, b, c}
//    maybe remove a
//    certainly add c, value of c is willEnter(c)
// loop over merged and construct new current
// dest doesn't change, that's owner's
function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
    var leavingStyle = willLeave(oldMergedPropsStyle);
    if (leavingStyle == null) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
  });

  var newCurrentStyles = [];
  var newCurrentVelocities = [];
  var newLastIdealStyles = [];
  var newLastIdealVelocities = [];
  for (var i = 0; i < newMergedPropsStyles.length; i++) {
    var newMergedPropsStyleCell = newMergedPropsStyles[i];
    var foundOldIndex = null;
    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
        foundOldIndex = j;
        break;
      }
    }
    // TODO: key search code
    if (foundOldIndex == null) {
      var plainStyle = willEnter(newMergedPropsStyleCell);
      newCurrentStyles[i] = plainStyle;
      newLastIdealStyles[i] = plainStyle;

      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
      newCurrentVelocities[i] = velocity;
      newLastIdealVelocities[i] = velocity;
    } else {
      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
    }
  }

  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
}

var TransitionMotion = _createReactClass2['default']({
  propTypes: {
    defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
      key: _propTypes2['default'].string.isRequired,
      data: _propTypes2['default'].any,
      style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
    })),
    styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
      key: _propTypes2['default'].string.isRequired,
      data: _propTypes2['default'].any,
      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
    }))]).isRequired,
    children: _propTypes2['default'].func.isRequired,
    willEnter: _propTypes2['default'].func,
    willLeave: _propTypes2['default'].func,
    didLeave: _propTypes2['default'].func
  },

  getDefaultProps: function getDefaultProps() {
    return {
      willEnter: function willEnter(styleThatEntered) {
        return _stripStyle2['default'](styleThatEntered.style);
      },
      // recall: returning null makes the current unmounting TransitionStyle
      // disappear immediately
      willLeave: function willLeave() {
        return null;
      },
      didLeave: function didLeave() {}
    };
  },

  getInitialState: function getInitialState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;
    var willEnter = _props.willEnter;
    var willLeave = _props.willLeave;
    var didLeave = _props.didLeave;

    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;

    // this is special. for the first time around, we don't have a comparison
    // between last (no last) and current merged props. we'll compute last so:
    // say default is {a, b} and styles (dest style) is {b, c}, we'll
    // fabricate last as {a, b}
    var oldMergedPropsStyles = undefined;
    if (defaultStyles == null) {
      oldMergedPropsStyles = destStyles;
    } else {
      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
        // TODO: key search code
        for (var i = 0; i < destStyles.length; i++) {
          if (destStyles[i].key === defaultStyleCell.key) {
            return destStyles[i];
          }
        }
        return defaultStyleCell;
      });
    }
    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    });
    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    });

    var _mergeAndSync = mergeAndSync(
    // Because this is an old-style createReactClass component, Flow doesn't
    // understand that the willEnter and willLeave props have default values
    // and will always be present.
    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
    oldCurrentVelocities);

    var mergedPropsStyles = _mergeAndSync[0];
    var currentStyles = _mergeAndSync[1];
    var currentVelocities = _mergeAndSync[2];
    var lastIdealStyles = _mergeAndSync[3];
    var lastIdealVelocities = _mergeAndSync[4];
    // oldLastIdealVelocities really

    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: lastIdealStyles,
      lastIdealVelocities: lastIdealVelocities,
      mergedPropsStyles: mergedPropsStyles
    };
  },

  unmounting: false,
  animationID: null,
  prevTime: 0,
  accumulatedTime: 0,
  // it's possible that currentStyle's value is stale: if props is immediately
  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
  // at 0 (didn't have time to tick and interpolate even once). If we naively
  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
  // In reality currentStyle should be 400
  unreadPropStyles: null,
  // after checking for unreadPropStyles != null, we manually go set the
  // non-interpolating values (those that are a number, without a spring
  // config)
  clearUnreadPropStyle: function clearUnreadPropStyle(unreadPropStyles) {
    var _mergeAndSync2 = mergeAndSync(this.props.willEnter, this.props.willLeave, this.props.didLeave, this.state.mergedPropsStyles, unreadPropStyles, this.state.currentStyles, this.state.currentVelocities, this.state.lastIdealStyles, this.state.lastIdealVelocities);

    var mergedPropsStyles = _mergeAndSync2[0];
    var currentStyles = _mergeAndSync2[1];
    var currentVelocities = _mergeAndSync2[2];
    var lastIdealStyles = _mergeAndSync2[3];
    var lastIdealVelocities = _mergeAndSync2[4];

    for (var i = 0; i < unreadPropStyles.length; i++) {
      var unreadPropStyle = unreadPropStyles[i].style;
      var dirty = false;

      for (var key in unreadPropStyle) {
        if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
          continue;
        }

        var styleValue = unreadPropStyle[key];
        if (typeof styleValue === 'number') {
          if (!dirty) {
            dirty = true;
            currentStyles[i] = _extends({}, currentStyles[i]);
            currentVelocities[i] = _extends({}, currentVelocities[i]);
            lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
            lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
            mergedPropsStyles[i] = {
              key: mergedPropsStyles[i].key,
              data: mergedPropsStyles[i].data,
              style: _extends({}, mergedPropsStyles[i].style)
            };
          }
          currentStyles[i][key] = styleValue;
          currentVelocities[i][key] = 0;
          lastIdealStyles[i][key] = styleValue;
          lastIdealVelocities[i][key] = 0;
          mergedPropsStyles[i].style[key] = styleValue;
        }
      }
    }

    // unlike the other 2 components, we can't detect staleness and optionally
    // opt out of setState here. each style object's data might contain new
    // stuff we're not/cannot compare
    this.setState({
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      mergedPropsStyles: mergedPropsStyles,
      lastIdealStyles: lastIdealStyles,
      lastIdealVelocities: lastIdealVelocities
    });
  },

  startAnimationIfNecessary: function startAnimationIfNecessary() {
    var _this = this;

    if (this.unmounting) {
      return;
    }

    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
    // call cb? No, otherwise accidental parent rerender causes cb trigger
    this.animationID = _raf2['default'](function (timestamp) {
      // https://github.com/chenglou/react-motion/pull/420
      // > if execution passes the conditional if (this.unmounting), then
      // executes async defaultRaf and after that component unmounts and after
      // that the callback of defaultRaf is called, then setState will be called
      // on unmounted component.
      if (_this.unmounting) {
        return;
      }

      var propStyles = _this.props.styles;
      var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;

      // check if we need to animate in the first place
      if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
        // no need to cancel animationID here; shouldn't have any in flight
        _this.animationID = null;
        _this.accumulatedTime = 0;
        return;
      }

      var currentTime = timestamp || _performanceNow2['default']();
      var timeDelta = currentTime - _this.prevTime;
      _this.prevTime = currentTime;
      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
      // more than 10 frames? prolly switched browser tab. Restart
      if (_this.accumulatedTime > msPerFrame * 10) {
        _this.accumulatedTime = 0;
      }

      if (_this.accumulatedTime === 0) {
        // no need to cancel animationID here; shouldn't have any in flight
        _this.animationID = null;
        _this.startAnimationIfNecessary();
        return;
      }

      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

      var _mergeAndSync3 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

      var newMergedPropsStyles = _mergeAndSync3[0];
      var newCurrentStyles = _mergeAndSync3[1];
      var newCurrentVelocities = _mergeAndSync3[2];
      var newLastIdealStyles = _mergeAndSync3[3];
      var newLastIdealVelocities = _mergeAndSync3[4];

      for (var i = 0; i < newMergedPropsStyles.length; i++) {
        var newMergedPropsStyle = newMergedPropsStyles[i].style;
        var newCurrentStyle = {};
        var newCurrentVelocity = {};
        var newLastIdealStyle = {};
        var newLastIdealVelocity = {};

        for (var key in newMergedPropsStyle) {
          if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
            continue;
          }

          var styleValue = newMergedPropsStyle[key];
          if (typeof styleValue === 'number') {
            newCurrentStyle[key] = styleValue;
            newCurrentVelocity[key] = 0;
            newLastIdealStyle[key] = styleValue;
            newLastIdealVelocity[key] = 0;
          } else {
            var newLastIdealStyleValue = newLastIdealStyles[i][key];
            var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
            for (var j = 0; j < framesToCatchUp; j++) {
              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              newLastIdealStyleValue = _stepper[0];
              newLastIdealVelocityValue = _stepper[1];
            }

            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

            var nextIdealX = _stepper2[0];
            var nextIdealV = _stepper2[1];

            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
            newLastIdealStyle[key] = newLastIdealStyleValue;
            newLastIdealVelocity[key] = newLastIdealVelocityValue;
          }
        }

        newLastIdealStyles[i] = newLastIdealStyle;
        newLastIdealVelocities[i] = newLastIdealVelocity;
        newCurrentStyles[i] = newCurrentStyle;
        newCurrentVelocities[i] = newCurrentVelocity;
      }

      _this.animationID = null;
      // the amount we're looped over above
      _this.accumulatedTime -= framesToCatchUp * msPerFrame;

      _this.setState({
        currentStyles: newCurrentStyles,
        currentVelocities: newCurrentVelocities,
        lastIdealStyles: newLastIdealStyles,
        lastIdealVelocities: newLastIdealVelocities,
        mergedPropsStyles: newMergedPropsStyles
      });

      _this.unreadPropStyles = null;

      _this.startAnimationIfNecessary();
    });
  },

  componentDidMount: function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  },

  componentWillReceiveProps: function componentWillReceiveProps(props) {
    if (this.unreadPropStyles) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    var styles = props.styles;
    if (typeof styles === 'function') {
      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
    } else {
      this.unreadPropStyles = styles;
    }

    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  },

  componentWillUnmount: function componentWillUnmount() {
    this.unmounting = true;
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  },

  render: function render() {
    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
    var renderedChildren = this.props.children(hydratedStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  }
});

exports['default'] = TransitionMotion;
module.exports = exports['default'];

// list of styles, each containing interpolating values. Part of what's passed
// to children function. Notice that this is
// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
// contains the key & data info (so that we only have a single source of truth
// for these, and to save space). Check the comment for `rehydrateStyles` to
// see how we regenerate the entirety of what's passed to children function

// the array that keeps track of currently rendered stuff! Including stuff
// that you've unmounted but that's still animating. This is where it lives

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// core keys merging algorithm. If previous render's keys are [a, b], and the
// next render's [c, b, d], what's the final merged keys and ordering?

// - c and a must both be before b
// - b before d
// - ordering between a and c ambiguous

// this reduces to merging two partially ordered lists (e.g. lists where not
// every item has a definite ordering, like comparing a and c above). For the
// ambiguous ordering we deterministically choose to place the next render's
// item after the previous'; so c after a

// this is called a topological sorting. Except the existing algorithms don't
// work well with js bc of the amount of allocation, and isn't optimized for our
// current use-case bc the runtime is linear in terms of edges (see wiki for
// meaning), which is huge when two lists have many common elements


exports.__esModule = true;
exports['default'] = mergeDiff;

function mergeDiff(prev, next, onRemove) {
  // bookkeeping for easier access of a key's index below. This is 2 allocations +
  // potentially triggering chrome hash map mode for objs (so it might be faster

  var prevKeyIndex = {};
  for (var i = 0; i < prev.length; i++) {
    prevKeyIndex[prev[i].key] = i;
  }
  var nextKeyIndex = {};
  for (var i = 0; i < next.length; i++) {
    nextKeyIndex[next[i].key] = i;
  }

  // first, an overly elaborate way of merging prev and next, eliminating
  // duplicates (in terms of keys). If there's dupe, keep the item in next).
  // This way of writing it saves allocations
  var ret = [];
  for (var i = 0; i < next.length; i++) {
    ret[i] = next[i];
  }
  for (var i = 0; i < prev.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
      // merge in keys that the user desires to kill
      var fill = onRemove(i, prev[i]);
      if (fill != null) {
        ret.push(fill);
      }
    }
  }

  // now all the items all present. Core sorting logic to have the right order
  return ret.sort(function (a, b) {
    var nextOrderA = nextKeyIndex[a.key];
    var nextOrderB = nextKeyIndex[b.key];
    var prevOrderA = prevKeyIndex[a.key];
    var prevOrderB = prevKeyIndex[b.key];

    if (nextOrderA != null && nextOrderB != null) {
      // both keys in next
      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
    } else if (prevOrderA != null && prevOrderB != null) {
      // both keys in prev
      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
    } else if (nextOrderA != null) {
      // key a in next, key b in prev

      // how to determine the order between a and b? We find a "pivot" (term
      // abuse), a key present in both prev and next, that is sandwiched between
      // a and b. In the context of our above example, if we're comparing a and
      // d, b's (the only) pivot
      for (var i = 0; i < next.length; i++) {
        var pivot = next[i].key;
        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
          continue;
        }

        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
          return -1;
        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
          return 1;
        }
      }
      // pluggable. default to: next bigger than prev
      return 1;
    }
    // prevOrderA, nextOrderB
    for (var i = 0; i < next.length; i++) {
      var pivot = next[i].key;
      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
        continue;
      }
      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
        return 1;
      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
        return -1;
      }
    }
    // pluggable. default to: next bigger than prev
    return -1;
  });
}

module.exports = exports['default'];
// to loop through and find a key's index each time), but I no longer care

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }

var _Motion = __webpack_require__(1211);

exports.Motion = _interopRequire(_Motion);

var _StaggeredMotion = __webpack_require__(1212);

exports.StaggeredMotion = _interopRequire(_StaggeredMotion);

var _TransitionMotion = __webpack_require__(1213);

exports.TransitionMotion = _interopRequire(_TransitionMotion);

var _spring = __webpack_require__(1217);

exports.spring = _interopRequire(_spring);

var _presets = __webpack_require__(598);

exports.presets = _interopRequire(_presets);

var _stripStyle = __webpack_require__(159);

exports.stripStyle = _interopRequire(_stripStyle);

// deprecated, dummy warning function

var _reorderKeys = __webpack_require__(1216);

exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = reorderKeys;

var hasWarned = false;

function reorderKeys() {
  if (false) {
    if (!hasWarned) {
      hasWarned = true;
      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
    }
  }
}

module.exports = exports['default'];

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = spring;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _presets = __webpack_require__(598);

var _presets2 = _interopRequireDefault(_presets);

var defaultConfig = _extends({}, _presets2['default'].noWobble, {
  precision: 0.01
});

function spring(val, config) {
  return _extends({}, defaultConfig, config, { val: val });
}

module.exports = exports['default'];

/***/ }),
/* 1218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(274);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  Provider.displayName = 'Provider';

  return Provider;
}

/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 1219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(1226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(1222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(1223);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(600);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function (dispatch) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 1221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(600);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 1222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(602);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 1223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(1224);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 1224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(274);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 1225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 1226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 1227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createBrowserHistory__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(29);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_2_history_createBrowserHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["Router"], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 1228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createHashHistory__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(29);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_2_history_createHashHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["Router"], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['hashbang', 'noslash', 'slash']),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (HashRouter);

/***/ }),
/* 1229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(29);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["MemoryRouter"]; });


/***/ }),
/* 1230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(603);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [activeClassName, className].filter(function (i) {
          return i;
        }).join(' ') : className,
        style: isActive ? _extends({}, style, activeStyle) : style
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

NavLink.defaultProps = {
  activeClassName: 'active'
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 1231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(29);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["Prompt"]; });


/***/ }),
/* 1232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(29);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"]; });


/***/ }),
/* 1233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(29);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["Route"]; });


/***/ }),
/* 1234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(29);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["Router"]; });


/***/ }),
/* 1235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(29);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["StaticRouter"]; });


/***/ }),
/* 1236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(29);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["Switch"]; });


/***/ }),
/* 1237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(29);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["matchPath"]; });


/***/ }),
/* 1238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(29);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["withRouter"]; });


/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = routerMiddleware;

var _actions = __webpack_require__(605);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */
function routerMiddleware(history) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type !== _actions.CALL_HISTORY_METHOD) {
          return next(action);
        }

        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;

        history[method].apply(history, _toConsumableArray(args));
      };
    };
  };
}

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = syncHistoryWithStore;

var _reducer = __webpack_require__(606);

var defaultSelectLocationState = function defaultSelectLocationState(state) {
  return state.routing;
};

/**
 * This function synchronizes your history state with the Redux store.
 * Location changes flow from history to the store. An enhanced history is
 * returned with a listen method that responds to store updates for location.
 *
 * When this history is provided to the router, this means the location data
 * will flow like this:
 * history.push -> store.dispatch -> enhancedHistory.listen -> router
 * This ensures that when the store state changes due to a replay or other
 * event, the router will be updated appropriately and can transition to the
 * correct router state.
 */
function syncHistoryWithStore(history, store) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$selectLocationSt = _ref.selectLocationState,
      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;

  // Ensure that the reducer is mounted on the store and functioning properly.
  if (typeof selectLocationState(store.getState()) === 'undefined') {
    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
  }

  var initialLocation = void 0;
  var isTimeTraveling = void 0;
  var unsubscribeFromStore = void 0;
  var unsubscribeFromHistory = void 0;
  var currentLocation = void 0;

  // What does the store say about current location?
  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
    var locationState = selectLocationState(store.getState());
    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
  };

  // Init initialLocation with potential location in store
  initialLocation = getLocationInStore();

  // If the store is replayed, update the URL in the browser to match.
  if (adjustUrlOnReplay) {
    var handleStoreChange = function handleStoreChange() {
      var locationInStore = getLocationInStore(true);
      if (currentLocation === locationInStore || initialLocation === locationInStore) {
        return;
      }

      // Update address bar to reflect store state
      isTimeTraveling = true;
      currentLocation = locationInStore;
      history.transitionTo(_extends({}, locationInStore, {
        action: 'PUSH'
      }));
      isTimeTraveling = false;
    };

    unsubscribeFromStore = store.subscribe(handleStoreChange);
    handleStoreChange();
  }

  // Whenever location changes, dispatch an action to get it in the store
  var handleLocationChange = function handleLocationChange(location) {
    // ... unless we just caused that location change
    if (isTimeTraveling) {
      return;
    }

    // Remember where we are
    currentLocation = location;

    // Are we being called for the first time?
    if (!initialLocation) {
      // Remember as a fallback in case state is reset
      initialLocation = location;

      // Respect persisted location, if any
      if (getLocationInStore()) {
        return;
      }
    }

    // Tell the store to update by dispatching an action
    store.dispatch({
      type: _reducer.LOCATION_CHANGE,
      payload: location
    });
  };
  unsubscribeFromHistory = history.listen(handleLocationChange);

  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
  if (history.getCurrentLocation) {
    handleLocationChange(history.getCurrentLocation());
  }

  // The enhanced history uses store as source of truth
  return _extends({}, history, {
    // The listeners are subscribed to the store instead of history
    listen: function listen(listener) {
      // Copy of last location.
      var lastPublishedLocation = getLocationInStore(true);

      // Keep track of whether we unsubscribed, as Redux store
      // only applies changes in subscriptions on next dispatch
      var unsubscribed = false;
      var unsubscribeFromStore = store.subscribe(function () {
        var currentLocation = getLocationInStore(true);
        if (currentLocation === lastPublishedLocation) {
          return;
        }
        lastPublishedLocation = currentLocation;
        if (!unsubscribed) {
          listener(lastPublishedLocation);
        }
      });

      // History 2.x listeners expect a synchronous call. Make the first call to the
      // listener after subscribing to the store, in case the listener causes a
      // location change (e.g. when it redirects)
      if (!history.getCurrentLocation) {
        listener(lastPublishedLocation);
      }

      // Let user unsubscribe later
      return function () {
        unsubscribed = true;
        unsubscribeFromStore();
      };
    },


    // It also provides a way to destroy internal listeners
    unsubscribe: function unsubscribe() {
      if (adjustUrlOnReplay) {
        unsubscribeFromStore();
      }
      unsubscribeFromHistory();
    }
  });
}

/***/ }),
/* 1241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createMemoryHistory__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_createMemoryHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Router__ = __webpack_require__(275);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_2_history_createMemoryHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 1242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 1243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




/**
 * The public API for updating the location programatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var _props = this.props,
        push = _props.push,
        to = _props.to;


    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object])
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 1244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_PathUtils__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_PathUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_PathUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(275);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var normalizeLocation = function normalizeLocation(object) {
  var _object$pathname = object.pathname,
      pathname = _object$pathname === undefined ? '/' : _object$pathname,
      _object$search = object.search,
      search = _object$search === undefined ? '' : _object$search,
      _object$hash = object.hash,
      hash = _object$hash === undefined ? '' : _object$hash;


  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_history_PathUtils__["addLeadingSlash"])(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_history_PathUtils__["addLeadingSlash"])(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createLocation = function createLocation(location) {
  return typeof location === 'string' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_history_PathUtils__["parsePath"])(location) : normalizeLocation(location);
};

var createURL = function createURL(location) {
  return typeof location === 'string' ? location : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_history_PathUtils__["createPath"])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false, 'You cannot %s with <StaticRouter>', methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_history_PathUtils__["addLeadingSlash"])(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = 'PUSH';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = 'REPLACE';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);

    var history = {
      createHref: this.createHref,
      action: 'POP',
      location: stripBasename(basename, createLocation(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler('go'),
      goBack: staticHandler('goBack'),
      goForward: staticHandler('goForward'),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: '',
  location: '/'
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 1245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__matchPath__ = __webpack_require__(276);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) return;

      var _element$props = element.props,
          pathProp = _element$props.path,
          exact = _element$props.exact,
          strict = _element$props.strict,
          from = _element$props.from;

      var path = pathProp || from;

      if (match == null) {
        child = element;
        match = path ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict }) : route.match;
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 1246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(607);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], { render: function render(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
      } });
  };

  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _warning = __webpack_require__(33);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable flowtype/require-valid-file-annotation */

var checkIndexBounds = function checkIndexBounds(props) {
  var index = props.index,
      children = props.children;


  var childrenCount = _react.Children.count(children);

   false ? (0, _warning2.default)(index >= 0 && index <= childrenCount, 'react-swipeable-view: the new index: ' + index + ' is out of bounds: [0-' + childrenCount + '].') : void 0;
};

exports.default = checkIndexBounds;

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = computeIndex;

var _react = __webpack_require__(0);

var _constant = __webpack_require__(608);

var _constant2 = _interopRequireDefault(_constant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//  weak

function computeIndex(params) {
  var children = params.children,
      startIndex = params.startIndex,
      startX = params.startX,
      pageX = params.pageX,
      viewLength = params.viewLength,
      resistance = params.resistance;


  var indexMax = _react.Children.count(children) - 1;
  var index = startIndex + (startX - pageX) / viewLength;
  var newStartX = void 0;

  if (!resistance) {
    // Reset the starting point
    if (index < 0) {
      index = 0;
      newStartX = (index - startIndex) * viewLength + pageX;
    } else if (index > indexMax) {
      index = indexMax;
      newStartX = (index - startIndex) * viewLength + pageX;
    }
  } else if (index < 0) {
    index = Math.exp(index * _constant2.default.RESISTANCE_COEF) - 1;
  } else if (index > indexMax) {
    index = indexMax + 1 - Math.exp((indexMax - index) * _constant2.default.RESISTANCE_COEF);
  }

  return {
    index: index,
    startX: newStartX
  };
}

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//  weak

var getDisplaySameSlide = function getDisplaySameSlide(props, nextProps) {
  var displaySameSlide = false;

  if (props.children.length && nextProps.children.length) {
    var oldChildren = props.children[props.index];
    var oldKey = oldChildren ? oldChildren.key : 'empty';

    if (oldKey !== null) {
      var newChildren = nextProps.children[nextProps.index];
      var newKey = newChildren ? newChildren.key : 'empty';

      if (oldKey === newKey) {
        displaySameSlide = true;
      }
    }
  }

  return displaySameSlide;
};

exports.default = getDisplaySameSlide;

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _checkIndexBounds = __webpack_require__(1247);

Object.defineProperty(exports, 'checkIndexBounds', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_checkIndexBounds).default;
  }
});

var _computeIndex = __webpack_require__(1248);

Object.defineProperty(exports, 'computeIndex', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_computeIndex).default;
  }
});

var _constant = __webpack_require__(608);

Object.defineProperty(exports, 'constant', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_constant).default;
  }
});

var _getDisplaySameSlide = __webpack_require__(1249);

Object.defineProperty(exports, 'getDisplaySameSlide', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getDisplaySameSlide).default;
  }
});

var _mod = __webpack_require__(1251);

Object.defineProperty(exports, 'mod', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_mod).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable flowtype/require-valid-file-annotation */

function mod(n, m) {
  var q = n % m;
  return q < 0 ? q + m : q;
}

exports.default = mod;

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(675);

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__(295);

var _assign2 = _interopRequireDefault(_assign);

var _objectWithoutProperties2 = __webpack_require__(677);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(669);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(673);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(674);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(678);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(676);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.getDomTreeShapes = getDomTreeShapes;
exports.findNativeHandler = findNativeHandler;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(33);

var _warning2 = _interopRequireDefault(_warning);

var _properties = __webpack_require__(378);

var _properties2 = _interopRequireDefault(_properties);

var _on = __webpack_require__(889);

var _on2 = _interopRequireDefault(_on);

var _off = __webpack_require__(888);

var _off2 = _interopRequireDefault(_off);

var _reactSwipeableViewsCore = __webpack_require__(1250);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addEventListenerEnhanced(node, event, handler, options) {
  (0, _on2.default)(node, event, handler, options);
  return {
    remove: function remove() {
      (0, _off2.default)(node, event, handler, options);
    }
  };
} //  weak

var styleInjected = false;

// Support old version of iOS.
// To be deleted in 2018.
function injectStyle() {
  // Inject once for all the instances
  if (!styleInjected) {
    var style = document.createElement('style');
    style.innerHTML = '\n      .react-swipeable-view-container {\n        display: -webkit-box;\n      }\n    ';

    if (document.body) {
      document.body.appendChild(style);
    }
    styleInjected = true;
  }
}

var styles = {
  container: {
    direction: 'ltr',
    display: 'flex'
  },
  slide: {
    width: '100%',
    WebkitFlexShrink: 0,
    flexShrink: 0,
    overflow: 'auto'
  }
};

var axisProperties = {
  root: {
    x: {
      overflowX: 'hidden'
    },
    'x-reverse': {
      overflowX: 'hidden'
    },
    y: {
      overflowY: 'hidden'
    },
    'y-reverse': {
      overflowY: 'hidden'
    }
  },
  flexDirection: {
    x: 'row',
    'x-reverse': 'row-reverse',
    y: 'column',
    'y-reverse': 'column-reverse'
  },
  transform: {
    x: function x(translate) {
      return 'translate(' + -translate + '%, 0)';
    },
    'x-reverse': function xReverse(translate) {
      return 'translate(' + translate + '%, 0)';
    },
    y: function y(translate) {
      return 'translate(0, ' + -translate + '%)';
    },
    'y-reverse': function yReverse(translate) {
      return 'translate(0, ' + translate + '%)';
    }
  },
  length: {
    x: 'width',
    'x-reverse': 'width',
    y: 'height',
    'y-reverse': 'height'
  },
  rotationMatrix: {
    x: {
      x: [1, 0],
      y: [0, 1]
    },
    'x-reverse': {
      x: [-1, 0],
      y: [0, 1]
    },
    y: {
      x: [0, 1],
      y: [1, 0]
    },
    'y-reverse': {
      x: [0, -1],
      y: [1, 0]
    }
  },
  scrollPosition: {
    x: 'scrollLeft',
    'x-reverse': 'scrollLeft',
    y: 'scrollTop',
    'y-reverse': 'scrollTop'
  },
  scrollLength: {
    x: 'scrollWidth',
    'x-reverse': 'scrollWidth',
    y: 'scrollHeight',
    'y-reverse': 'scrollHeight'
  },
  clientLength: {
    x: 'clientWidth',
    'x-reverse': 'clientWidth',
    y: 'clientHeight',
    'y-reverse': 'clientHeight'
  }
};

function createTransition(property, options) {
  var duration = options.duration,
      easeFunction = options.easeFunction,
      delay = options.delay;


  return property + ' ' + duration + ' ' + easeFunction + ' ' + delay;
}

// We are using a 2x2 rotation matrix.
function applyRotationMatrix(touch, axis) {
  var rotationMatrix = axisProperties.rotationMatrix[axis];

  return {
    pageX: rotationMatrix.x[0] * touch.pageX + rotationMatrix.x[1] * touch.pageY,
    pageY: rotationMatrix.y[0] * touch.pageX + rotationMatrix.y[1] * touch.pageY
  };
}

function adaptMouse(event) {
  event.touches = [{ pageX: event.pageX, pageY: event.pageY }];
  return event;
}

function getDomTreeShapes(element, rootNode) {
  var domTreeShapes = [];

  while (element && element !== rootNode) {
    // We reach a Swipeable View, no need to look higher in the dom tree.
    if (element.hasAttribute('data-swipeable')) {
      break;
    }

    var style = window.getComputedStyle(element);

    if (
    // Ignore the scroll children if the element is absolute positioned.
    style.getPropertyValue('position') === 'absolute' ||
    // Ignore the scroll children if the element has an overflowX hidden
    style.getPropertyValue('overflow-x') === 'hidden') {
      domTreeShapes = [];
    } else if (element.clientWidth > 0 && element.scrollWidth > element.clientWidth || element.clientHeight > 0 && element.scrollHeight > element.clientHeight) {
      // Ignore the nodes that have no width.
      // Keep elements with a scroll
      domTreeShapes.push({
        element: element,
        scrollWidth: element.scrollWidth,
        scrollHeight: element.scrollHeight,
        clientWidth: element.clientWidth,
        clientHeight: element.clientHeight,
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
      });
    }

    element = element.parentNode;
  }

  return domTreeShapes;
}

// We can only have one node at the time claiming ownership for handling the swipe.
// Otherwise, the UX would be confusing.
// That's why we use a singleton here.
var nodeHowClaimedTheScroll = null;

function findNativeHandler(params) {
  var domTreeShapes = params.domTreeShapes,
      pageX = params.pageX,
      startX = params.startX,
      axis = params.axis;


  return domTreeShapes.some(function (shape) {
    // Determine if we are going backward or forward.
    var goingForward = pageX >= startX;
    if (axis === 'x' || axis === 'y') {
      goingForward = !goingForward;
    }

    var scrollPosition = shape[axisProperties.scrollPosition[axis]];

    var areNotAtStart = scrollPosition > 0;
    var areNotAtEnd = scrollPosition + shape[axisProperties.clientLength[axis]] < shape[axisProperties.scrollLength[axis]];

    if (goingForward && areNotAtEnd || !goingForward && areNotAtStart) {
      nodeHowClaimedTheScroll = shape.element;
      return true;
    }

    return false;
  });
}

var SwipeableViews = function (_Component) {
  (0, _inherits3.default)(SwipeableViews, _Component);

  function SwipeableViews() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SwipeableViews);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SwipeableViews.__proto__ || (0, _getPrototypeOf2.default)(SwipeableViews)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.rootNode = null, _this.containerNode = null, _this.ignoreNextScrollEvents = false, _this.viewLength = 0, _this.startX = 0, _this.lastX = 0, _this.vx = 0, _this.startY = 0, _this.isSwiping = undefined, _this.started = false, _this.startIndex = 0, _this.transitionListener = null, _this.touchMoveListener = null, _this.activeSlide = null, _this.handleSwipeStart = function (event) {
      var axis = _this.props.axis;

      // Latency and rapid rerenders on some devices can leave a period where rootNode briefly equals null

      if (_this.rootNode === null) {
        return;
      }

      var touch = applyRotationMatrix(event.touches[0], axis);

      _this.viewLength = _this.rootNode.getBoundingClientRect()[axisProperties.length[axis]];
      _this.startX = touch.pageX;
      _this.lastX = touch.pageX;
      _this.vx = 0;
      _this.startY = touch.pageY;
      _this.isSwiping = undefined;
      _this.started = true;

      var computedStyle = window.getComputedStyle(_this.containerNode);
      var transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');

      if (transform) {
        var transformValues = transform.split('(')[1].split(')')[0].split(',');
        var rootStyle = window.getComputedStyle(_this.rootNode);

        var tranformNormalized = applyRotationMatrix({
          pageX: parseInt(transformValues[4], 10),
          pageY: parseInt(transformValues[5], 10)
        }, axis);

        _this.startIndex = -tranformNormalized.pageX / (_this.viewLength - parseInt(rootStyle.paddingLeft, 10) - parseInt(rootStyle.paddingRight, 10));
      }
    }, _this.handleSwipeMove = function (event) {
      // The touch start event can be cancel.
      // Makes sure we set a starting point.
      if (!_this.started) {
        _this.handleTouchStart(event);
        return;
      }

      // Latency and rapid rerenders on some devices can leave a period where rootNode briefly equals null
      if (_this.rootNode === null) {
        return;
      }

      // We are not supposed to hanlde this touch move.
      if (nodeHowClaimedTheScroll !== null && nodeHowClaimedTheScroll !== _this.rootNode) {
        return;
      }

      var _this$props = _this.props,
          axis = _this$props.axis,
          children = _this$props.children,
          ignoreNativeScroll = _this$props.ignoreNativeScroll,
          onSwitching = _this$props.onSwitching,
          resistance = _this$props.resistance;


      var touch = applyRotationMatrix(event.touches[0], axis);

      // We don't know yet.
      if (_this.isSwiping === undefined) {
        var dx = Math.abs(_this.startX - touch.pageX);
        var dy = Math.abs(_this.startY - touch.pageY);

        var isSwiping = dx > dy && dx > _reactSwipeableViewsCore.constant.UNCERTAINTY_THRESHOLD;

        // We are likely to be swiping, let's prevent the scroll event.
        if (dx > dy) {
          event.preventDefault();
        }

        if (isSwiping === true || dy > _reactSwipeableViewsCore.constant.UNCERTAINTY_THRESHOLD) {
          _this.isSwiping = isSwiping;
          _this.startX = touch.pageX; // Shift the starting point.

          return; // Let's wait the next touch event to move something.
        }
      }

      if (_this.isSwiping !== true) {
        return;
      }

      // We are swiping, let's prevent the scroll event.
      event.preventDefault();

      // Low Pass filter.
      _this.vx = _this.vx * 0.5 + (touch.pageX - _this.lastX) * 0.5;
      _this.lastX = touch.pageX;

      var _computeIndex = (0, _reactSwipeableViewsCore.computeIndex)({
        children: children,
        resistance: resistance,
        pageX: touch.pageX,
        startIndex: _this.startIndex,
        startX: _this.startX,
        viewLength: _this.viewLength
      }),
          index = _computeIndex.index,
          startX = _computeIndex.startX;

      // Add support for native scroll elements.


      if (nodeHowClaimedTheScroll === null && !ignoreNativeScroll) {
        var domTreeShapes = getDomTreeShapes(event.target, _this.rootNode);
        var hasFoundNativeHandler = findNativeHandler({
          domTreeShapes: domTreeShapes,
          startX: _this.startX,
          pageX: touch.pageX,
          axis: axis
        });

        // We abort the touch move handler.
        if (hasFoundNativeHandler) {
          return;
        }
      }

      // We are moving toward the edges.
      if (startX) {
        _this.startX = startX;
      } else if (nodeHowClaimedTheScroll === null) {
        nodeHowClaimedTheScroll = _this.rootNode;
      }

      _this.setState({
        displaySameSlide: false,
        isDragging: true,
        indexCurrent: index
      }, function () {
        if (onSwitching) {
          onSwitching(index, 'move');
        }
      });
    }, _this.handleSwipeEnd = function () {
      nodeHowClaimedTheScroll = null;

      // The touch start event can be cancel.
      // Makes sure that a starting point is set.
      if (!_this.started) {
        return;
      }

      _this.started = false;

      if (_this.isSwiping !== true) {
        return;
      }

      var indexLatest = _this.state.indexLatest;
      var indexCurrent = _this.state.indexCurrent;
      var delta = indexLatest - indexCurrent;

      var indexNew = void 0;

      // Quick movement
      if (Math.abs(_this.vx) > _this.props.threshold) {
        if (_this.vx > 0) {
          indexNew = Math.floor(indexCurrent);
        } else {
          indexNew = Math.ceil(indexCurrent);
        }
      } else if (Math.abs(delta) > _this.props.hysteresis) {
        // Some hysteresis with indexLatest.
        indexNew = delta > 0 ? Math.floor(indexCurrent) : Math.ceil(indexCurrent);
      } else {
        indexNew = indexLatest;
      }

      var indexMax = _react.Children.count(_this.props.children) - 1;

      if (indexNew < 0) {
        indexNew = 0;
      } else if (indexNew > indexMax) {
        indexNew = indexMax;
      }

      _this.setState({
        indexCurrent: indexNew,
        indexLatest: indexNew,
        isDragging: false
      }, function () {
        if (_this.props.onSwitching) {
          _this.props.onSwitching(indexNew, 'end');
        }

        if (_this.props.onChangeIndex && indexNew !== indexLatest) {
          _this.props.onChangeIndex(indexNew, indexLatest);
        }

        // Manually calling handleTransitionEnd in that case as isn't otherwise.
        if (indexCurrent === indexLatest) {
          _this.handleTransitionEnd();
        }
      });
    }, _this.handleTouchStart = function (event) {
      if (_this.props.onTouchStart) {
        _this.props.onTouchStart(event);
      }
      _this.handleSwipeStart(event);
    }, _this.handleTouchEnd = function (event) {
      if (_this.props.onTouchEnd) {
        _this.props.onTouchEnd(event);
      }
      _this.handleSwipeEnd(event);
    }, _this.handleMouseDown = function (event) {
      if (_this.props.onMouseDown) {
        _this.props.onMouseDown(event);
      }
      event.persist();
      _this.handleSwipeStart(adaptMouse(event));
    }, _this.handleMouseUp = function (event) {
      if (_this.props.onMouseUp) {
        _this.props.onMouseUp(event);
      }
      _this.handleSwipeEnd(adaptMouse(event));
    }, _this.handleMouseLeave = function (event) {
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave(event);
      }

      // Filter out events
      if (_this.started) {
        _this.handleSwipeEnd(adaptMouse(event));
      }
    }, _this.handleMouseMove = function (event) {
      if (_this.props.onMouseMove) {
        _this.props.onMouseMove(event);
      }

      // Filter out events
      if (_this.started) {
        _this.handleSwipeMove(adaptMouse(event));
      }
    }, _this.handleScroll = function (event) {
      if (_this.props.onScroll) {
        _this.props.onScroll(event);
      }

      // Ignore events bubbling up.
      if (event.target !== _this.rootNode) {
        return;
      }

      if (_this.ignoreNextScrollEvents) {
        _this.ignoreNextScrollEvents = false;
        return;
      }

      var indexLatest = _this.state.indexLatest;
      var indexNew = Math.ceil(event.target.scrollLeft / event.target.clientWidth) + indexLatest;

      _this.ignoreNextScrollEvents = true;
      // Reset the scroll position.
      event.target.scrollLeft = 0;

      if (_this.props.onChangeIndex && indexNew !== indexLatest) {
        _this.props.onChangeIndex(indexNew, indexLatest);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }
  // Added as an ads.


  (0, _createClass3.default)(SwipeableViews, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var _this2 = this;

      return {
        swipeableViews: {
          slideUpdateHeight: function slideUpdateHeight() {
            _this2.updateHeight();
          }
        }
      };
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (false) {
        (0, _reactSwipeableViewsCore.checkIndexBounds)(this.props);
      }

      this.setState({
        indexCurrent: this.props.index,
        indexLatest: this.props.index,
        isDragging: false,
        isFirstRender: true,
        heightLatest: 0
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this3 = this;

      // Subscribe to transition end events.
      this.transitionListener = addEventListenerEnhanced(this.containerNode, _properties2.default.end, function () {
        _this3.handleTransitionEnd();
      });

      // Block the thread to handle that event.
      this.touchMoveListener = addEventListenerEnhanced(this.rootNode, 'touchmove', function (event) {
        // Handling touch events is disabled.
        if (_this3.props.disabled) {
          return;
        }
        _this3.handleSwipeMove(event);
      }, {
        passive: false
      });

      /* eslint-disable react/no-did-mount-set-state */
      this.setState({
        isFirstRender: false
      });
      /* eslint-enable react/no-did-mount-set-state */

      injectStyle();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var index = nextProps.index;


      if (typeof index === 'number' && index !== this.props.index) {
        if (false) {
          (0, _reactSwipeableViewsCore.checkIndexBounds)(nextProps);
        }

        this.setState({
          // If true, we are going to change the children. We shoudn't animate it.
          displaySameSlide: (0, _reactSwipeableViewsCore.getDisplaySameSlide)(this.props, nextProps),
          indexCurrent: index,
          indexLatest: index
        });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (!this.props.animateTransitions && prevState.indexCurrent !== this.state.indexCurrent) {
        this.handleTransitionEnd();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.transitionListener.remove();
      this.touchMoveListener.remove();
    }
  }, {
    key: 'handleTransitionEnd',
    value: function handleTransitionEnd() {
      if (!this.props.onTransitionEnd) {
        return;
      }

      // Filters out when changing the children
      if (this.state.displaySameSlide) {
        return;
      }

      // The rest callback is triggered when swiping. It's just noise.
      // We filter it out.
      if (!this.state.isDragging) {
        this.props.onTransitionEnd();
      }
    }
  }, {
    key: 'updateHeight',
    value: function updateHeight() {
      if (this.activeSlide !== null) {
        var child = this.activeSlide.children[0];
        if (child !== undefined && child.offsetHeight !== undefined && this.state.heightLatest !== child.offsetHeight) {
          this.setState({
            heightLatest: child.offsetHeight
          });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          animateHeight = _props.animateHeight,
          animateTransitions = _props.animateTransitions,
          axis = _props.axis,
          children = _props.children,
          containerStyleProp = _props.containerStyle,
          disabled = _props.disabled,
          enableMouseEvents = _props.enableMouseEvents,
          hysteresis = _props.hysteresis,
          ignoreNativeScroll = _props.ignoreNativeScroll,
          index = _props.index,
          onChangeIndex = _props.onChangeIndex,
          onSwitching = _props.onSwitching,
          onTransitionEnd = _props.onTransitionEnd,
          resistance = _props.resistance,
          slideStyleProp = _props.slideStyle,
          slideClassName = _props.slideClassName,
          springConfig = _props.springConfig,
          style = _props.style,
          threshold = _props.threshold,
          other = (0, _objectWithoutProperties3.default)(_props, ['animateHeight', 'animateTransitions', 'axis', 'children', 'containerStyle', 'disabled', 'enableMouseEvents', 'hysteresis', 'ignoreNativeScroll', 'index', 'onChangeIndex', 'onSwitching', 'onTransitionEnd', 'resistance', 'slideStyle', 'slideClassName', 'springConfig', 'style', 'threshold']);
      var _state = this.state,
          displaySameSlide = _state.displaySameSlide,
          heightLatest = _state.heightLatest,
          indexCurrent = _state.indexCurrent,
          isDragging = _state.isDragging,
          isFirstRender = _state.isFirstRender;


      var touchEvents = !disabled ? {
        onTouchStart: this.handleTouchStart,
        onTouchEnd: this.handleTouchEnd
      } : {};

      var mouseEvents = !disabled && enableMouseEvents ? {
        onMouseDown: this.handleMouseDown,
        onMouseUp: this.handleMouseUp,
        onMouseLeave: this.handleMouseLeave,
        onMouseMove: this.handleMouseMove
      } : {};

      // There is no point to animate if we are already providing a height.
       false ? (0, _warning2.default)(!animateHeight || !containerStyleProp || !containerStyleProp.height && !containerStyleProp.maxHeight && !containerStyleProp.minHeight, 'react-swipeable-view: You are setting animateHeight to true but you are also providing a custom height.\nThe custom height has a higher priority than the animateHeight property.\nSo animateHeight is most likely having no effect at all.') : void 0;

      var slideStyle = (0, _assign2.default)({}, styles.slide, slideStyleProp);

      var transition = void 0;
      var WebkitTransition = void 0;

      if (isDragging || !animateTransitions || displaySameSlide) {
        transition = 'all 0s ease 0s';
        WebkitTransition = 'all 0s ease 0s';
      } else {
        transition = createTransition('transform', springConfig);
        WebkitTransition = createTransition('-webkit-transform', springConfig);

        if (heightLatest !== 0) {
          var additionalTranstion = ', ' + createTransition('height', springConfig);
          transition += additionalTranstion;
          WebkitTransition += additionalTranstion;
        }
      }

      var transform = axisProperties.transform[axis](indexCurrent * 100);
      var containerStyle = {
        WebkitTransform: transform,
        transform: transform,
        height: null,
        WebkitFlexDirection: axisProperties.flexDirection[axis],
        flexDirection: axisProperties.flexDirection[axis],
        WebkitTransition: WebkitTransition,
        transition: transition
      };

      if (animateHeight) {
        containerStyle.height = heightLatest;
      }

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({
          ref: function ref(node) {
            _this4.rootNode = node;
          },
          style: (0, _assign2.default)({}, axisProperties.root[axis], style)
        }, other, touchEvents, mouseEvents, {
          onScroll: this.handleScroll
        }),
        _react2.default.createElement(
          'div',
          {
            ref: function ref(node) {
              _this4.containerNode = node;
            },
            style: (0, _assign2.default)({}, containerStyle, styles.container, containerStyleProp),
            className: 'react-swipeable-view-container'
          },
          _react.Children.map(children, function (child, indexChild) {
            if (isFirstRender && indexChild > 0) {
              return null;
            }

             false ? (0, _warning2.default)((0, _react.isValidElement)(child), 'react-swipeable-view: one of the children provided is invalid: ' + child + '.\nWe are expecting a valid React Element') : void 0;

            var ref = void 0;
            var hidden = true;

            if (indexChild === _this4.state.indexLatest) {
              hidden = false;

              if (animateHeight) {
                ref = function ref(node) {
                  _this4.activeSlide = node;
                  _this4.updateHeight();
                };
                slideStyle.overflowY = 'hidden';
              }
            }

            return _react2.default.createElement(
              'div',
              {
                ref: ref,
                style: slideStyle,
                className: slideClassName,
                'aria-hidden': hidden,
                'data-swipeable': 'true'
              },
              child
            );
          })
        )
      );
    }
  }]);
  return SwipeableViews;
}(_react.Component);

SwipeableViews.displayName = 'ReactSwipableView';
SwipeableViews.defaultProps = {
  animateHeight: false,
  animateTransitions: true,
  axis: 'x',
  disabled: false,
  enableMouseEvents: false,
  hysteresis: 0.6,
  ignoreNativeScroll: false,
  index: 0,
  threshold: 5,
  springConfig: {
    duration: '0.35s',
    easeFunction: 'cubic-bezier(0.15, 0.3, 0.25, 1)',
    delay: '0s'
  },
  resistance: false
};
SwipeableViews.childContextTypes = {
  swipeableViews: _propTypes2.default.shape({
    slideUpdateHeight: _propTypes2.default.func
  })
};
 false ? SwipeableViews.propTypes = {
  /**
   * If `true`, the height of the container will be animated to match the current slide height.
   * Animating another style property has a negative impact regarding performance.
   */
  animateHeight: _propTypes2.default.bool,
  /**
   * If `false`, changes to the index prop will not cause an animated transition.
   */
  animateTransitions: _propTypes2.default.bool,
  /**
   * The axis on which the slides will slide.
   */
  axis: _propTypes2.default.oneOf(['x', 'x-reverse', 'y', 'y-reverse']),
  /**
   * Use this property to provide your slides.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * This is the inlined style that will be applied
   * to each slide container.
   */
  containerStyle: _propTypes2.default.object,
  /**
   * If `true`, it will disable touch events.
   * This is useful when you want to prohibit the user from changing slides.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, it will enable mouse events.
   * This will allow the user to perform the relevant swipe actions with a mouse.
   */
  enableMouseEvents: _propTypes2.default.bool,
  /**
   * Configure hysteresis between slides. This value determines how far
   * should user swipe to switch slide.
   */
  hysteresis: _propTypes2.default.number,
  /**
   * If `true`, it will ignore native scroll container.
   * It can be used to filter out false positive that blocks the swipe.
   */
  ignoreNativeScroll: _propTypes2.default.bool,
  /**
   * This is the index of the slide to show.
   * This is useful when you want to change the default slide shown.
   * Or when you have tabs linked to each slide.
   */
  index: _propTypes2.default.number,
  /**
   * This is callback prop. It's call by the
   * component when the shown slide change after a swipe made by the user.
   * This is useful when you have tabs linked to each slide.
   *
   * @param {integer} index This is the current index of the slide.
   * @param {integer} indexLatest This is the oldest index of the slide.
   */
  onChangeIndex: _propTypes2.default.func,
  /**
   * @ignore
   */
  onMouseDown: _propTypes2.default.func,
  /**
   * @ignore
   */
  onMouseLeave: _propTypes2.default.func,
  /**
   * @ignore
   */
  onMouseMove: _propTypes2.default.func,
  /**
   * @ignore
   */
  onMouseUp: _propTypes2.default.func,
  /**
   * @ignore
   */
  onScroll: _propTypes2.default.func,
  /**
   * This is callback prop. It's called by the
   * component when the slide switching.
   * This is useful when you want to implement something corresponding to the current slide position.
   *
   * @param {integer} index This is the current index of the slide.
   * @param {string} type Can be either `move` or `end`.
   */
  onSwitching: _propTypes2.default.func,
  /**
   * @ignore
   */
  onTouchEnd: _propTypes2.default.func,
  /**
   * @ignore
   */
  onTouchMove: _propTypes2.default.func,
  /**
   * @ignore
   */
  onTouchStart: _propTypes2.default.func,
  /**
   * The callback that fires when the animation comes to a rest.
   * This is useful to defer CPU intensive task.
   */
  onTransitionEnd: _propTypes2.default.func,
  /**
   * If `true`, it will add bounds effect on the edges.
   */
  resistance: _propTypes2.default.bool,
  /**
   * This is the className that will be applied
   * on the slide component.
   */
  slideClassName: _propTypes2.default.string,
  /**
   * This is the inlined style that will be applied
   * on the slide component.
   */
  slideStyle: _propTypes2.default.object,
  /**
   * This is the config used to create CSS transitions.
   * This is useful to change the dynamic of the transition.
   */
  springConfig: _propTypes2.default.shape({
    duration: _propTypes2.default.string,
    easeFunction: _propTypes2.default.string,
    delay: _propTypes2.default.string
  }),
  /**
   * This is the inlined style that will be applied
   * on the root component.
   */
  style: _propTypes2.default.object,
  /**
   * This is the threshold used for detecting a quick swipe.
   * If the computed speed is above this value, the index change.
   */
  threshold: _propTypes2.default.number
} : void 0;
exports.default = SwipeableViews;

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SwipeableViews = __webpack_require__(1252);

var _SwipeableViews2 = _interopRequireDefault(_SwipeableViews);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SwipeableViews2.default; //  weak

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _addClass = __webpack_require__(885);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(887);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _requestAnimationFrame = __webpack_require__(890);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _properties = __webpack_require__(378);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(9);

var _PropTypes = __webpack_require__(609);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var events = [];
if (_properties.transitionEnd) events.push(_properties.transitionEnd);
if (_properties.animationEnd) events.push(_properties.animationEnd);

function addEndListener(node, listener) {
  if (events.length) {
    events.forEach(function (e) {
      return node.addEventListener(e, listener, false);
    });
  } else {
    setTimeout(listener, 0);
  }

  return function () {
    if (!events.length) return;
    events.forEach(function (e) {
      return node.removeEventListener(e, listener, false);
    });
  };
}

var propTypes = {
  children: _propTypes2.default.node,
  name: _PropTypes.nameShape.isRequired,

  // Once we require timeouts to be specified, we can remove the
  // boolean flags (appear etc.) and just accept a number
  // or a bool for the timeout flags (appearTimeout etc.)
  appear: _propTypes2.default.bool,
  enter: _propTypes2.default.bool,
  leave: _propTypes2.default.bool,
  appearTimeout: _propTypes2.default.number,
  enterTimeout: _propTypes2.default.number,
  leaveTimeout: _propTypes2.default.number
};

var CSSTransitionGroupChild = function (_React$Component) {
  _inherits(CSSTransitionGroupChild, _React$Component);

  function CSSTransitionGroupChild() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroupChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
      if (_this.props.appear) {
        _this.transition('appear', done, _this.props.appearTimeout);
      } else {
        done();
      }
    }, _this.componentWillEnter = function (done) {
      if (_this.props.enter) {
        _this.transition('enter', done, _this.props.enterTimeout);
      } else {
        done();
      }
    }, _this.componentWillLeave = function (done) {
      if (_this.props.leave) {
        _this.transition('leave', done, _this.props.leaveTimeout);
      } else {
        done();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
    this.classNameAndNodeQueue = [];
    this.transitionTimeouts = [];
  };

  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounted = true;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.transitionTimeouts.forEach(function (timeout) {
      clearTimeout(timeout);
    });

    this.classNameAndNodeQueue.length = 0;
  };

  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
    var node = (0, _reactDom.findDOMNode)(this);

    if (!node) {
      if (finishCallback) {
        finishCallback();
      }
      return;
    }

    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
    var timer = null;
    var removeListeners = void 0;

    (0, _addClass2.default)(node, className);

    // Need to do this to actually trigger a transition.
    this.queueClassAndNode(activeClassName, node);

    // Clean-up the animation after the specified delay
    var finish = function finish(e) {
      if (e && e.target !== node) {
        return;
      }

      clearTimeout(timer);
      if (removeListeners) removeListeners();

      (0, _removeClass2.default)(node, className);
      (0, _removeClass2.default)(node, activeClassName);

      if (removeListeners) removeListeners();

      // Usually this optional callback is used for informing an owner of
      // a leave animation and telling it to remove the child.
      if (finishCallback) {
        finishCallback();
      }
    };

    if (timeout) {
      timer = setTimeout(finish, timeout);
      this.transitionTimeouts.push(timer);
    } else if (_properties.transitionEnd) {
      removeListeners = addEndListener(node, finish);
    }
  };

  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
    var _this2 = this;

    this.classNameAndNodeQueue.push({
      className: className,
      node: node
    });

    if (!this.rafHandle) {
      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
        return _this2.flushClassNameAndNodeQueue();
      });
    }
  };

  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
    if (!this.unmounted) {
      this.classNameAndNodeQueue.forEach(function (obj) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        /* eslint-disable no-unused-expressions */
        obj.node.scrollTop;
        /* eslint-enable no-unused-expressions */
        (0, _addClass2.default)(obj.node, obj.className);
      });
    }
    this.classNameAndNodeQueue.length = 0;
    this.rafHandle = null;
  };

  CSSTransitionGroupChild.prototype.render = function render() {
    var props = _extends({}, this.props);
    delete props.name;
    delete props.appear;
    delete props.enter;
    delete props.leave;
    delete props.appearTimeout;
    delete props.enterTimeout;
    delete props.leaveTimeout;
    delete props.children;
    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
  };

  return CSSTransitionGroupChild;
}(_react2.default.Component);

CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';


CSSTransitionGroupChild.propTypes = propTypes;

exports.default = CSSTransitionGroupChild;
module.exports = exports['default'];

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  _react.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 1256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plot_series_abstract_series__ = __webpack_require__(8);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractSeries", function() { return __WEBPACK_IMPORTED_MODULE_0__plot_series_abstract_series__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plot_series_line_series__ = __webpack_require__(616);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LineSeries", function() { return __WEBPACK_IMPORTED_MODULE_1__plot_series_line_series__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plot_series_line_series_canvas__ = __webpack_require__(615);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LineSeriesCanvas", function() { return __WEBPACK_IMPORTED_MODULE_2__plot_series_line_series_canvas__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plot_series_horizontal_bar_series__ = __webpack_require__(1280);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "HorizontalBarSeries", function() { return __WEBPACK_IMPORTED_MODULE_3__plot_series_horizontal_bar_series__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plot_series_horizontal_bar_series_canvas__ = __webpack_require__(1279);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "HorizontalBarSeriesCanvas", function() { return __WEBPACK_IMPORTED_MODULE_4__plot_series_horizontal_bar_series_canvas__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plot_series_vertical_bar_series__ = __webpack_require__(1286);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VerticalBarSeries", function() { return __WEBPACK_IMPORTED_MODULE_5__plot_series_vertical_bar_series__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plot_series_vertical_bar_series_canvas__ = __webpack_require__(1285);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VerticalBarSeriesCanvas", function() { return __WEBPACK_IMPORTED_MODULE_6__plot_series_vertical_bar_series_canvas__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plot_series_vertical_rect_series__ = __webpack_require__(1288);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VerticalRectSeries", function() { return __WEBPACK_IMPORTED_MODULE_7__plot_series_vertical_rect_series__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plot_series_vertical_rect_series_canvas__ = __webpack_require__(1287);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VerticalRectSeriesCanvas", function() { return __WEBPACK_IMPORTED_MODULE_8__plot_series_vertical_rect_series_canvas__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__plot_series_horizontal_rect_series__ = __webpack_require__(1282);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "HorizontalRectSeries", function() { return __WEBPACK_IMPORTED_MODULE_9__plot_series_horizontal_rect_series__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__plot_series_horizontal_rect_series_canvas__ = __webpack_require__(1281);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "HorizontalRectSeriesCanvas", function() { return __WEBPACK_IMPORTED_MODULE_10__plot_series_horizontal_rect_series_canvas__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__plot_series_label_series__ = __webpack_require__(160);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LabelSeries", function() { return __WEBPACK_IMPORTED_MODULE_11__plot_series_label_series__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__plot_series_polygon_series__ = __webpack_require__(619);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PolygonSeries", function() { return __WEBPACK_IMPORTED_MODULE_12__plot_series_polygon_series__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__plot_series_rect_series__ = __webpack_require__(281);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RectSeries", function() { return __WEBPACK_IMPORTED_MODULE_13__plot_series_rect_series__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__plot_series_rect_series_canvas__ = __webpack_require__(280);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RectSeriesCanvas", function() { return __WEBPACK_IMPORTED_MODULE_14__plot_series_rect_series_canvas__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__plot_series_mark_series__ = __webpack_require__(618);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MarkSeries", function() { return __WEBPACK_IMPORTED_MODULE_15__plot_series_mark_series__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__plot_series_mark_series_canvas__ = __webpack_require__(617);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MarkSeriesCanvas", function() { return __WEBPACK_IMPORTED_MODULE_16__plot_series_mark_series_canvas__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__plot_series_heatmap_series__ = __webpack_require__(1278);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "HeatmapSeries", function() { return __WEBPACK_IMPORTED_MODULE_17__plot_series_heatmap_series__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__plot_series_contour_series__ = __webpack_require__(1276);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ContourSeries", function() { return __WEBPACK_IMPORTED_MODULE_18__plot_series_contour_series__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__plot_series_custom_svg_series__ = __webpack_require__(1277);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CustomSVGSeries", function() { return __WEBPACK_IMPORTED_MODULE_19__plot_series_custom_svg_series__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__plot_series_area_series__ = __webpack_require__(1274);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AreaSeries", function() { return __WEBPACK_IMPORTED_MODULE_20__plot_series_area_series__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__plot_series_arc_series__ = __webpack_require__(279);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ArcSeries", function() { return __WEBPACK_IMPORTED_MODULE_21__plot_series_arc_series__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__plot_series_line_mark_series__ = __webpack_require__(1284);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LineMarkSeries", function() { return __WEBPACK_IMPORTED_MODULE_22__plot_series_line_mark_series__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__plot_series_line_mark_series_canvas__ = __webpack_require__(1283);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LineMarkSeriesCanvas", function() { return __WEBPACK_IMPORTED_MODULE_23__plot_series_line_mark_series_canvas__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__plot_hint__ = __webpack_require__(1272);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Hint", function() { return __WEBPACK_IMPORTED_MODULE_24__plot_hint__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__plot_borders__ = __webpack_require__(1268);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Borders", function() { return __WEBPACK_IMPORTED_MODULE_25__plot_borders__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__plot_crosshair__ = __webpack_require__(1270);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Crosshair", function() { return __WEBPACK_IMPORTED_MODULE_26__plot_crosshair__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__plot_xy_plot__ = __webpack_require__(161);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "XYPlot", function() { return __WEBPACK_IMPORTED_MODULE_27__plot_xy_plot__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__plot_axis_decorative_axis__ = __webpack_require__(612);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DecorativeAxis", function() { return __WEBPACK_IMPORTED_MODULE_28__plot_axis_decorative_axis__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__plot_axis_x_axis__ = __webpack_require__(1266);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "XAxis", function() { return __WEBPACK_IMPORTED_MODULE_29__plot_axis_x_axis__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__plot_axis_y_axis__ = __webpack_require__(1267);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "YAxis", function() { return __WEBPACK_IMPORTED_MODULE_30__plot_axis_y_axis__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__plot_circular_grid_lines__ = __webpack_require__(1269);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CircularGridLines", function() { return __WEBPACK_IMPORTED_MODULE_31__plot_circular_grid_lines__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__plot_grid_lines__ = __webpack_require__(278);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "GridLines", function() { return __WEBPACK_IMPORTED_MODULE_32__plot_grid_lines__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__plot_gradient_defs__ = __webpack_require__(1271);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "GradientDefs", function() { return __WEBPACK_IMPORTED_MODULE_33__plot_gradient_defs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__plot_vertical_grid_lines__ = __webpack_require__(1289);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VerticalGridLines", function() { return __WEBPACK_IMPORTED_MODULE_34__plot_vertical_grid_lines__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__plot_horizontal_grid_lines__ = __webpack_require__(1273);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "HorizontalGridLines", function() { return __WEBPACK_IMPORTED_MODULE_35__plot_horizontal_grid_lines__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__plot_voronoi__ = __webpack_require__(620);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Voronoi", function() { return __WEBPACK_IMPORTED_MODULE_36__plot_voronoi__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__legends_discrete_color_legend__ = __webpack_require__(610);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DiscreteColorLegend", function() { return __WEBPACK_IMPORTED_MODULE_37__legends_discrete_color_legend__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__legends_searchable_discrete_color_legend__ = __webpack_require__(1260);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SearchableDiscreteColorLegend", function() { return __WEBPACK_IMPORTED_MODULE_38__legends_searchable_discrete_color_legend__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__legends_continuous_color_legend__ = __webpack_require__(1257);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ContinuousColorLegend", function() { return __WEBPACK_IMPORTED_MODULE_39__legends_continuous_color_legend__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__legends_continuous_size_legend__ = __webpack_require__(1258);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ContinuousSizeLegend", function() { return __WEBPACK_IMPORTED_MODULE_40__legends_continuous_size_legend__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__treemap__ = __webpack_require__(1294);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Treemap", function() { return __WEBPACK_IMPORTED_MODULE_41__treemap__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__radial_chart__ = __webpack_require__(1291);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RadialChart", function() { return __WEBPACK_IMPORTED_MODULE_42__radial_chart__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__radar_chart__ = __webpack_require__(1290);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RadarChart", function() { return __WEBPACK_IMPORTED_MODULE_43__radar_chart__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__sankey__ = __webpack_require__(1292);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Sankey", function() { return __WEBPACK_IMPORTED_MODULE_44__sankey__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__sunburst__ = __webpack_require__(1293);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Sunburst", function() { return __WEBPACK_IMPORTED_MODULE_45__sunburst__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__make_vis_flexible__ = __webpack_require__(1261);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "makeHeightFlexible", function() { return __WEBPACK_IMPORTED_MODULE_46__make_vis_flexible__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "makeVisFlexible", function() { return __WEBPACK_IMPORTED_MODULE_46__make_vis_flexible__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "makeWidthFlexible", function() { return __WEBPACK_IMPORTED_MODULE_46__make_vis_flexible__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__utils_axis_utils__ = __webpack_require__(31);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AxisUtils", function() { return __WEBPACK_IMPORTED_MODULE_47__utils_axis_utils__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__utils_scales_utils__ = __webpack_require__(25);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ScaleUtils", function() { return __WEBPACK_IMPORTED_MODULE_48__utils_scales_utils__["a"]; });
// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.






































































































/***/ }),
/* 1257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__theme__ = __webpack_require__(22);
// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.







var propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  endColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  endTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired,
  midColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  midTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  startColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  startTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var defaultProps = {
  className: '',
  startColor: __WEBPACK_IMPORTED_MODULE_2__theme__["c" /* CONTINUOUS_COLOR_RANGE */][0],
  endColor: __WEBPACK_IMPORTED_MODULE_2__theme__["c" /* CONTINUOUS_COLOR_RANGE */][1]
};

function ContinuousColorLegend(_ref) {
  var startColor = _ref.startColor,
      midColor = _ref.midColor,
      endColor = _ref.endColor,
      startTitle = _ref.startTitle,
      midTitle = _ref.midTitle,
      endTitle = _ref.endTitle,
      height = _ref.height,
      width = _ref.width,
      className = _ref.className;

  var colors = [startColor];
  if (midColor) {
    colors.push(midColor);
  }
  colors.push(endColor);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'rv-continuous-color-legend ' + className, style: { width: width, height: height } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
      className: 'rv-gradient',
      style: { background: 'linear-gradient(to right, ' + colors.join(',') + ')' } }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'rv-legend-titles' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'rv-legend-titles__left' },
        startTitle
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'rv-legend-titles__right' },
        endTitle
      ),
      midTitle ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'rv-legend-titles__center' },
        midTitle
      ) : null
    )
  );
}

ContinuousColorLegend.displayName = 'ContinuousColorLegend';
ContinuousColorLegend.propTypes = propTypes;
ContinuousColorLegend.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (ContinuousColorLegend);

/***/ }),
/* 1258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.





var propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  circlesTotal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  endSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  endTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  startSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  startTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var defaultProps = {
  circlesTotal: 10,
  className: '',
  endSize: 20,
  startSize: 2
};

function ContinuousSizeLegend(_ref) {
  var startTitle = _ref.startTitle,
      endTitle = _ref.endTitle,
      startSize = _ref.startSize,
      endSize = _ref.endSize,
      circlesTotal = _ref.circlesTotal,
      height = _ref.height,
      width = _ref.width,
      className = _ref.className;

  var circles = [];
  var step = (endSize - startSize) / (circlesTotal - 1);

  for (var i = 0; i < circlesTotal; i++) {
    var size = step * i + startSize;
    circles.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { key: i, className: 'rv-bubble', style: {
        width: size,
        height: size,
        borderRadius: size / 2
      } }));
    // Add the separator in order to justify the content (otherwise the tags
    // will be stacked together without any margins around).
    circles.push(' ');
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'rv-continuous-size-legend ' + className, style: { width: width, height: height } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'rv-bubbles', style: { height: endSize } },
      circles,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'rv-spacer' })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'rv-legend-titles' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'rv-legend-titles__left' },
        startTitle
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'rv-legend-titles__right' },
        endTitle
      )
    )
  );
}

ContinuousSizeLegend.displayName = 'ContinuousSizeLegend';
ContinuousSizeLegend.propTypes = propTypes;
ContinuousSizeLegend.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (ContinuousSizeLegend);

/***/ }),
/* 1259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.





var propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  orientation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['vertical', 'horizontal']).isRequired
};

var defaultProps = {
  disabled: false
};

function DiscreteColorLegendItem(_ref) {
  var onClick = _ref.onClick,
      title = _ref.title,
      color = _ref.color,
      disabled = _ref.disabled,
      orientation = _ref.orientation;

  var className = 'rv-discrete-color-legend-item ' + orientation;
  if (disabled) {
    className += ' disabled';
  }
  if (onClick) {
    className += ' clickable';
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: className, onClick: onClick },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', {
      className: 'rv-discrete-color-legend-item__color',
      style: disabled ? null : { background: color } }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: 'rv-discrete-color-legend-item__title' },
      title
    )
  );
}

DiscreteColorLegendItem.propTypes = propTypes;
DiscreteColorLegendItem.defaultProps = defaultProps;
DiscreteColorLegendItem.displayName = 'DiscreteColorLegendItem';

/* harmony default export */ __webpack_exports__["a"] = (DiscreteColorLegendItem);

/***/ }),
/* 1260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__discrete_color_legend__ = __webpack_require__(610);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.







var propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_2__discrete_color_legend__["a" /* default */].propTypes, {
  searchText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onSearchChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  searchPlaceholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  searchFn: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
});

var defaultProps = {
  className: '',
  searchText: '',
  searchFn: function searchFn(items, s) {
    return items.filter(function (item) {
      return String(item.title || item).toLowerCase().indexOf(s) !== -1;
    });
  }
};

function SearchableDiscreteColorLegend(props) {
  var className = props.className,
      colors = props.colors,
      height = props.height,
      items = props.items,
      onItemClick = props.onItemClick,
      onSearchChange = props.onSearchChange,
      orientation = props.orientation,
      searchFn = props.searchFn,
      searchPlaceholder = props.searchPlaceholder,
      searchText = props.searchText,
      width = props.width;

  var onChange = onSearchChange ? function (_ref) {
    var value = _ref.target.value;
    return onSearchChange(value);
  } : null;
  var filteredItems = searchFn(items, searchText);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'rv-search-wrapper ' + className, style: { width: width, height: height } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'form',
      { className: 'rv-search-wrapper__form' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
        type: 'search',
        placeholder: searchPlaceholder,
        className: 'rv-search-wrapper__form__input',
        value: searchText,
        onChange: onChange })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'rv-search-wrapper__contents' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__discrete_color_legend__["a" /* default */], {
        colors: colors,
        items: filteredItems,
        onItemClick: onItemClick,
        orientation: orientation
      })
    )
  );
}

SearchableDiscreteColorLegend.propTypes = propTypes;
SearchableDiscreteColorLegend.defaultProps = defaultProps;
SearchableDiscreteColorLegend.displayName = 'SearchableDiscreteColorLegend';

/* harmony default export */ __webpack_exports__["a"] = (SearchableDiscreteColorLegend);

/***/ }),
/* 1261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeHeightFlexible;
/* harmony export (immutable) */ __webpack_exports__["b"] = makeVisFlexible;
/* harmony export (immutable) */ __webpack_exports__["c"] = makeWidthFlexible;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_global_window__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_global_window___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_global_window__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_react_utils__ = __webpack_require__(621);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.






var CONTAINER_REF = 'container';

// As a performance enhancement, we want to only listen once
var resizeSubscribers = [];
var DEBOUNCE_DURATION = 100;
var timeoutId = null;

/**
 * Calls each subscriber, debounced to the
 */
function debounceEmitResize() {
  __WEBPACK_IMPORTED_MODULE_1_global_window___default.a.clearTimeout(timeoutId);
  timeoutId = __WEBPACK_IMPORTED_MODULE_1_global_window___default.a.setTimeout(emitResize, DEBOUNCE_DURATION);
}

/**
 * Calls each subscriber once syncronously.
 */
function emitResize() {
  resizeSubscribers.forEach(function (cb) {
    return cb();
  });
}

/**
 * Add the given callback to the list of subscribers to be caled when the
 * window resizes. Returns a function that, when called, removes the given
 * callback from the list of subscribers. This function is also resposible for
 * adding and removing the resize listener on `window`.
 *
 * @param {Function} cb - Subscriber callback function
 * @returns {Function} Unsubscribe function
 */
function subscribeToDebouncedResize(cb) {
  resizeSubscribers.push(cb);

  // if we go from zero to one Flexible components instances, add the listener
  if (resizeSubscribers.length === 1) {
    __WEBPACK_IMPORTED_MODULE_1_global_window___default.a.addEventListener('resize', debounceEmitResize);
  }
  return function unsubscribe() {
    removeSubscriber(cb);

    // if we have no Flexible components, remove the listener
    if (resizeSubscribers.length === 0) {
      __WEBPACK_IMPORTED_MODULE_1_global_window___default.a.clearTimeout(timeoutId);
      __WEBPACK_IMPORTED_MODULE_1_global_window___default.a.removeEventListener('resize', debounceEmitResize);
    }
  };
}

/**
 * Helper for removing the given callback from the list of subscribers.
 *
 * @param {Function} cb - Subscriber callback function
 */
function removeSubscriber(cb) {
  var index = resizeSubscribers.indexOf(cb);
  if (index > -1) {
    resizeSubscribers.splice(index, 1);
  }
}

/**
 * Add the ability to stretch the visualization on window resize.
 * @param {*} Component React class for the child component.
 * @returns {*} Flexible component.
 */

function makeFlexible(Component, isWidthFlexible, isHeightFlexible) {

  var ResultClass = function (_React$Component) {
    _inherits(ResultClass, _React$Component);

    _createClass(ResultClass, null, [{
      key: 'propTypes',
      get: function get() {
        var _Component$propTypes = Component.propTypes,
            height = _Component$propTypes.height,
            width = _Component$propTypes.width,
            otherPropTypes = _objectWithoutProperties(_Component$propTypes, ['height', 'width']); // eslint-disable-line no-unused-vars


        return otherPropTypes;
      }
    }]);

    function ResultClass(props) {
      _classCallCheck(this, ResultClass);

      var _this = _possibleConstructorReturn(this, (ResultClass.__proto__ || Object.getPrototypeOf(ResultClass)).call(this, props));

      _this.state = {
        height: 0,
        width: 0
      };
      _this._onResize = _this._onResize.bind(_this);
      return _this;
    }

    /**
     * Get the width of the container and assign the width.
     * @private
     */


    _createClass(ResultClass, [{
      key: '_onResize',
      value: function _onResize() {
        var containerElement = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_react_utils__["b" /* getDOMNode */])(this.refs[CONTAINER_REF]);
        var offsetHeight = containerElement.offsetHeight,
            offsetWidth = containerElement.offsetWidth;


        var newHeight = this.state.height === offsetHeight ? {} : { height: offsetHeight };

        var newWidth = this.state.width === offsetWidth ? {} : { width: offsetWidth };

        this.setState(_extends({}, newHeight, newWidth));
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        this._onResize();
        this.cancelSubscription = subscribeToDebouncedResize(this._onResize);
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps() {
        this._onResize();
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.cancelSubscription();
      }
    }, {
      key: 'render',
      value: function render() {
        var _state = this.state,
            height = _state.height,
            width = _state.width;

        var props = _extends({}, this.props, { animation: height === 0 && width === 0 ? null : this.props.animation });

        var updatedDimensions = _extends({}, isHeightFlexible ? { height: height } : {}, isWidthFlexible ? { width: width } : {});

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            ref: CONTAINER_REF,
            style: { width: '100%', height: '100%' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, updatedDimensions, props))
        );
      }
    }]);

    return ResultClass;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

  ResultClass.displayName = 'Flexible' + Component.displayName;

  return ResultClass;
}

function makeHeightFlexible(component) {
  return makeFlexible(component, false, true);
}

function makeVisFlexible(component) {
  return makeFlexible(component, true, true);
}

function makeWidthFlexible(component) {
  return makeFlexible(component, true, false);
}

/***/ }),
/* 1262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__ = __webpack_require__(31);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.







var LEFT = __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__["e" /* ORIENTATION */].LEFT,
    RIGHT = __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__["e" /* ORIENTATION */].RIGHT,
    TOP = __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__["e" /* ORIENTATION */].TOP,
    BOTTOM = __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__["e" /* ORIENTATION */].BOTTOM;


var propTypes = {
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  orientation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([LEFT, RIGHT, TOP, BOTTOM]).isRequired,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};

var defaultProps = {
  style: {}
};

function AxisLine(_ref) {
  var orientation = _ref.orientation,
      width = _ref.width,
      height = _ref.height,
      style = _ref.style;

  var lineProps = void 0;
  if (orientation === LEFT) {
    lineProps = {
      x1: width,
      x2: width,
      y1: 0,
      y2: height
    };
  } else if (orientation === RIGHT) {
    lineProps = {
      x1: 0,
      x2: 0,
      y1: 0,
      y2: height
    };
  } else if (orientation === TOP) {
    lineProps = {
      x1: 0,
      x2: width,
      y1: height,
      y2: height
    };
  } else {
    lineProps = {
      x1: 0,
      x2: width,
      y1: 0,
      y2: 0
    };
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line', _extends({}, lineProps, { className: 'rv-xy-plot__axis__line', style: style }));
}

AxisLine.defaultProps = defaultProps;
AxisLine.displayName = 'AxisLine';
AxisLine.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (AxisLine);

/***/ }),
/* 1263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__ = __webpack_require__(25);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.








var LEFT = __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__["e" /* ORIENTATION */].LEFT,
    RIGHT = __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__["e" /* ORIENTATION */].RIGHT,
    TOP = __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__["e" /* ORIENTATION */].TOP,
    BOTTOM = __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__["e" /* ORIENTATION */].BOTTOM;


var propTypes = {
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  orientation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([LEFT, RIGHT, TOP, BOTTOM]).isRequired,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};

var defaultProps = {
  style: {}
};

function _getTickFormatFn(scale, tickTotal, tickFormat) {
  return !tickFormat ? scale.tickFormat ? scale.tickFormat(tickTotal) : function (v) {
    return v;
  } : tickFormat;
}

var AxisTicks = function (_React$Component) {
  _inherits(AxisTicks, _React$Component);

  function AxisTicks() {
    _classCallCheck(this, AxisTicks);

    return _possibleConstructorReturn(this, (AxisTicks.__proto__ || Object.getPrototypeOf(AxisTicks)).apply(this, arguments));
  }

  _createClass(AxisTicks, [{
    key: '_isAxisVertical',


    /**
     * Gets if the axis is vertical.
     * @returns {boolean} True if vertical.
     * @private
     */
    value: function _isAxisVertical() {
      var orientation = this.props.orientation;

      return orientation === LEFT || orientation === RIGHT;
    }

    /**
     * Check if axis ticks should be mirrored (for the right and top positions.
     * @returns {boolean} True if mirrored.
     * @private
     */

  }, {
    key: '_areTicksWrapped',
    value: function _areTicksWrapped() {
      var orientation = this.props.orientation;

      return orientation === LEFT || orientation === TOP;
    }
  }, {
    key: '_getTickContainerPropsGetterFn',
    value: function _getTickContainerPropsGetterFn() {
      if (this._isAxisVertical()) {
        return function (pos) {
          return { transform: 'translate(0, ' + pos + ')' };
        };
      }
      return function (pos) {
        return { transform: 'translate(' + pos + ', 0)' };
      };
    }

    /**
     * Get the props of the tick line.
     * @returns {Object} Props.
     * @private
     */

  }, {
    key: '_getTickLineProps',
    value: function _getTickLineProps() {
      var _ref;

      var _props = this.props,
          tickSize = _props.tickSize,
          _props$tickSizeOuter = _props.tickSizeOuter,
          tickSizeOuter = _props$tickSizeOuter === undefined ? tickSize : _props$tickSizeOuter,
          _props$tickSizeInner = _props.tickSizeInner,
          tickSizeInner = _props$tickSizeInner === undefined ? tickSize : _props$tickSizeInner;

      var isVertical = this._isAxisVertical();
      var tickXAttr = isVertical ? 'y' : 'x';
      var tickYAttr = isVertical ? 'x' : 'y';
      var wrap = this._areTicksWrapped() ? -1 : 1;
      return _ref = {}, _defineProperty(_ref, tickXAttr + '1', 0), _defineProperty(_ref, tickXAttr + '2', 0), _defineProperty(_ref, tickYAttr + '1', -wrap * tickSizeInner), _defineProperty(_ref, tickYAttr + '2', wrap * tickSizeOuter), _ref;
    }

    /**
     * Get attributes for the label of the tick.
     * @returns {Object} Object with properties.
     * @private
     */

  }, {
    key: '_getTickLabelProps',
    value: function _getTickLabelProps() {
      var _props2 = this.props,
          orientation = _props2.orientation,
          tickLabelAngle = _props2.tickLabelAngle,
          tickSize = _props2.tickSize,
          _props2$tickSizeOuter = _props2.tickSizeOuter,
          tickSizeOuter = _props2$tickSizeOuter === undefined ? tickSize : _props2$tickSizeOuter,
          _props2$tickPadding = _props2.tickPadding,
          tickPadding = _props2$tickPadding === undefined ? tickSize : _props2$tickPadding;

      // Assign the text orientation inside the label of the tick mark.

      var textAnchor = void 0;
      if (orientation === LEFT || orientation === BOTTOM && tickLabelAngle) {
        textAnchor = 'end';
      } else if (orientation === RIGHT || orientation === TOP && tickLabelAngle) {
        textAnchor = 'start';
      } else {
        textAnchor = 'middle';
      }

      // The label's position is translated to the given padding and then the
      // label is rotated to the given angle.
      var isVertical = this._isAxisVertical();
      var wrap = this._areTicksWrapped() ? -1 : 1;

      var labelOffset = wrap * (tickSizeOuter + tickPadding);
      var transform = (isVertical ? 'translate(' + labelOffset + ', 0)' : 'translate(0, ' + labelOffset + ')') + (tickLabelAngle ? ' rotate(' + tickLabelAngle + ')' : '');

      // Set the vertical offset of the label according to the position of
      // the axis.
      var dy = orientation === TOP || tickLabelAngle ? '0' : orientation === BOTTOM ? '0.72em' : '0.32em';

      return {
        textAnchor: textAnchor,
        dy: dy,
        transform: transform
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          attr = _props3.attr,
          orientation = _props3.orientation,
          width = _props3.width,
          height = _props3.height,
          style = _props3.style,
          tickFormat = _props3.tickFormat,
          tickTotal = _props3.tickTotal,
          tickValues = _props3.tickValues;


      var x = orientation === LEFT ? width : 0;
      var y = orientation === TOP ? height : 0;

      var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["e" /* getAttributeScale */])(this.props, attr);

      var values = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__["d" /* getTickValues */])(scale, tickTotal, tickValues);
      var tickFormatFn = _getTickFormatFn(scale, tickTotal, tickFormat);

      var translateFn = this._getTickContainerPropsGetterFn();
      var pathProps = this._getTickLineProps();
      var textProps = this._getTickLabelProps();

      var ticks = values.map(function (v, i) {
        var pos = scale(v);
        var text = tickFormatFn(v);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          _extends({ key: i }, translateFn(pos, 0), {
            className: 'rv-xy-plot__axis__tick',
            style: style }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line', _extends({}, pathProps, {
            className: 'rv-xy-plot__axis__tick__line',
            style: _extends({}, style, style.line)
          })),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'text',
            _extends({}, textProps, {
              className: 'rv-xy-plot__axis__tick__text',
              style: _extends({}, style, style.text)
            }),
            text
          )
        );
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        {
          transform: 'translate(' + x + ', ' + y + ')',
          className: 'rv-xy-plot__axis__ticks' },
        ticks
      );
    }
  }]);

  return AxisTicks;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

AxisTicks.defaultProps = defaultProps;
AxisTicks.displayName = 'AxisTicks';
AxisTicks.propTypes = propTypes;
AxisTicks.requiresSVG = true;

/* harmony default export */ __webpack_exports__["a"] = (AxisTicks);

/***/ }),
/* 1264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__ = __webpack_require__(31);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.







// Assuming that 16px = 1em
var ADJUSTMENT_FOR_TEXT_SIZE = 16;
var LEFT = __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__["e" /* ORIENTATION */].LEFT,
    RIGHT = __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__["e" /* ORIENTATION */].RIGHT,
    TOP = __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__["e" /* ORIENTATION */].TOP,
    BOTTOM = __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__["e" /* ORIENTATION */].BOTTOM;

/**
 * Compute transformations, keyed by orientation
 * @param {number} width - width of axis
 * @param {number} height - height of axis
 * @returns {Object} Object of transformations, keyed by orientation
 */

var transformation = function transformation(width, height) {
  var _ref;

  return _ref = {}, _defineProperty(_ref, LEFT, {
    x: ADJUSTMENT_FOR_TEXT_SIZE,
    y: 0,
    rotation: -90,
    textAnchor: 'end'
  }), _defineProperty(_ref, RIGHT, {
    x: ADJUSTMENT_FOR_TEXT_SIZE * -0.5,
    y: height,
    rotation: -90,
    textAnchor: 'start'
  }), _defineProperty(_ref, TOP, {
    x: 0,
    y: ADJUSTMENT_FOR_TEXT_SIZE,
    rotation: 0,
    textAnchor: 'start'
  }), _defineProperty(_ref, BOTTOM, {
    x: width,
    y: -6,
    rotation: 0,
    textAnchor: 'end'
  }), _ref;
};

var propTypes = {
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  orientation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([LEFT, RIGHT, TOP, BOTTOM]).isRequired,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

function AxisTitle(_ref2) {
  var orientation = _ref2.orientation,
      width = _ref2.width,
      height = _ref2.height,
      style = _ref2.style,
      title = _ref2.title;

  var outerGroupTranslateX = orientation === LEFT ? width : 0;
  var outerGroupTranslateY = orientation === TOP ? height : 0;
  var outerGroupTransform = 'translate(' + outerGroupTranslateX + ', ' + outerGroupTranslateY + ')';
  var _transformation$orien = transformation(width, height)[orientation],
      x = _transformation$orien.x,
      y = _transformation$orien.y,
      rotation = _transformation$orien.rotation,
      textAnchor = _transformation$orien.textAnchor;

  var innerGroupTransform = 'translate(' + x + ', ' + y + ') rotate(' + rotation + ')';

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'g',
    { transform: outerGroupTransform, className: 'rv-xy-plot__axis__title' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      { style: _extends({ textAnchor: textAnchor }, style), transform: innerGroupTransform },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'text',
        null,
        title
      )
    )
  );
}

AxisTitle.displayName = 'AxisTitle';
AxisTitle.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (AxisTitle);

/***/ }),
/* 1265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = decorativeAxisTick;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_axis_utils__ = __webpack_require__(31);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Copyright (c) 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.




/**
 * Generate the actual polygons to be plotted
 * @param {Object} props
 - props.animation {Boolean}
 - props.axisDomain {Array} a pair of values specifying the domain of the axis
 - props.numberOfTicks{Number} the number of ticks on the axis
 - props.axisStart {Object} a object specify in cartesian space the the start of the axis
 example: {x: 0, y: 0}
 - props.axisEnd {Object} a object specify in cartesian space the the start of the axis
 - props.tickValue {Func} a formatting function for the tick values
 - props.tickSize {Number} a pixel size of the axis
 - props.style {Object} The style object for the axis
 * @return {Component} the plotted axis
 */
function decorativeAxisTick(props) {
  var axisDomain = props.axisDomain,
      numberOfTicks = props.numberOfTicks,
      axisStart = props.axisStart,
      axisEnd = props.axisEnd,
      tickValue = props.tickValue,
      tickSize = props.tickSize,
      style = props.style;

  var _generatePoints = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_axis_utils__["f" /* generatePoints */])({ axisStart: axisStart, axisEnd: axisEnd, numberOfTicks: numberOfTicks, axisDomain: axisDomain }),
      points = _generatePoints.points;
  // add a quarter rotation to make ticks orthogonal to axis


  var tickAngle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_axis_utils__["g" /* getAxisAngle */])(axisStart, axisEnd) + Math.PI / 2;
  return points.map(function (point, index) {
    var tickProps = _extends({
      x1: 0,
      y1: 0,
      x2: tickSize * Math.cos(tickAngle),
      y2: tickSize * Math.sin(tickAngle)
    }, style.ticks);

    var textProps = _extends({
      x: tickSize * Math.cos(tickAngle),
      y: tickSize * Math.sin(tickAngle),
      textAnchor: 'start'
    }, style.text);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      { key: index, transform: 'translate(' + point.x + ', ' + point.y + ')', className: 'rv-xy-plot__axis__tick' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line', _extends({}, tickProps, { className: 'rv-xy-plot__axis__tick__line' })),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'text',
        _extends({}, textProps, { className: 'rv-xy-plot__axis__tick__text' }),
        tickValue(point.text)
      )
    );
  });
}

/***/ }),
/* 1266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__axis__ = __webpack_require__(611);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.









var TOP = __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__["e" /* ORIENTATION */].TOP,
    BOTTOM = __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__["e" /* ORIENTATION */].BOTTOM;


var propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_3__axis__["a" /* default */].propTypes, {
  orientation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([TOP, BOTTOM])
});

var defaultProps = {
  orientation: BOTTOM,
  attr: 'x'
};

function XAxis(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__axis__["a" /* default */], props);
}

XAxis.displayName = 'XAxis';
XAxis.propTypes = propTypes;
XAxis.defaultProps = defaultProps;
XAxis.requiresSVG = true;

/* harmony default export */ __webpack_exports__["a"] = (XAxis);

/***/ }),
/* 1267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__axis__ = __webpack_require__(611);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.









var LEFT = __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__["e" /* ORIENTATION */].LEFT,
    RIGHT = __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__["e" /* ORIENTATION */].RIGHT;


var propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_3__axis__["a" /* default */].propTypes, {
  orientation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([LEFT, RIGHT])
});

var defaultProps = {
  orientation: LEFT,
  attr: 'y'
};

function YAxis(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__axis__["a" /* default */], props);
}

YAxis.displayName = 'YAxis';
YAxis.propTypes = propTypes;
YAxis.defaultProps = defaultProps;
YAxis.requiresSVG = true;

/* harmony default export */ __webpack_exports__["a"] = (YAxis);

/***/ }),
/* 1268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.





var propTypes = {
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    bottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    left: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    right: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }),
  // supplied by xyplot
  marginTop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  marginBottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  marginLeft: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  marginRight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  innerWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  innerHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var CLASSES = {
  bottom: 'rv-xy-plot__borders-bottom',
  container: 'rv-xy-plot__borders',
  left: 'rv-xy-plot__borders-left',
  right: 'rv-xy-plot__borders-right',
  top: 'rv-xy-plot__borders-top'
};

var Borders = function (_PureComponent) {
  _inherits(Borders, _PureComponent);

  function Borders() {
    _classCallCheck(this, Borders);

    return _possibleConstructorReturn(this, (Borders.__proto__ || Object.getPrototypeOf(Borders)).apply(this, arguments));
  }

  _createClass(Borders, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          marginTop = _props.marginTop,
          marginBottom = _props.marginBottom,
          marginLeft = _props.marginLeft,
          marginRight = _props.marginRight,
          innerWidth = _props.innerWidth,
          innerHeight = _props.innerHeight,
          style = _props.style,
          className = _props.className;

      var height = innerHeight + marginTop + marginBottom;
      var width = innerWidth + marginLeft + marginRight;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        { className: CLASSES.container + ' ' + className },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', {
          className: CLASSES.bottom + ' ' + className + '-bottom',
          style: _extends({}, style.all, style.bottom),
          x: 0,
          y: height - marginBottom,
          width: width,
          height: marginBottom }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', {
          className: CLASSES.left + ' ' + className + '-left',
          style: _extends({}, style.all, style.left),
          x: 0,
          y: 0,
          width: marginLeft,
          height: height }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', {
          className: CLASSES.right + ' ' + className + '-right',
          style: _extends({}, style.all, style.right),
          x: width - marginRight,
          y: 0,
          width: marginRight,
          height: height }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', {
          className: CLASSES.top + ' ' + className + '-top',
          style: _extends({}, style.all, style.top),
          x: 0,
          y: 0,
          width: width,
          height: marginTop })
      );
    }
  }]);

  return Borders;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Borders.displayName = 'Borders';
Borders.defaultProps = {
  className: '',
  style: {
    all: {},
    bottom: {},
    left: {},
    right: {},
    top: {}
  }
};
Borders.propTypes = propTypes;
Borders.requiresSVG = true;

/* harmony default export */ __webpack_exports__["a"] = (Borders);

/***/ }),
/* 1269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_scales_utils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__animation__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_axis_utils__ = __webpack_require__(31);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.










var animatedProps = ['xRange', 'yRange', 'xDomain', 'yDomain', 'width', 'height', 'marginLeft', 'marginTop', 'marginRight', 'marginBottom', 'tickTotal'];

var CircularGridLines = function (_PureComponent) {
  _inherits(CircularGridLines, _PureComponent);

  function CircularGridLines() {
    _classCallCheck(this, CircularGridLines);

    return _possibleConstructorReturn(this, (CircularGridLines.__proto__ || Object.getPrototypeOf(CircularGridLines)).apply(this, arguments));
  }

  _createClass(CircularGridLines, [{
    key: '_getDefaultProps',
    value: function _getDefaultProps() {
      var _props = this.props,
          innerWidth = _props.innerWidth,
          innerHeight = _props.innerHeight,
          marginTop = _props.marginTop,
          marginLeft = _props.marginLeft;

      return {
        left: marginLeft,
        top: marginTop,
        width: innerWidth,
        height: innerHeight,
        style: {},
        tickTotal: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_axis_utils__["c" /* getTicksTotalFromSize */])(Math.min(innerWidth, innerHeight))
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          animation = _props2.animation,
          centerX = _props2.centerX,
          centerY = _props2.centerY;

      if (animation) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__animation__["b" /* default */],
          _extends({}, this.props, { animatedProps: animatedProps }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CircularGridLines, _extends({}, this.props, { animation: null }))
        );
      }

      var props = _extends({}, this._getDefaultProps(), this.props);

      var tickTotal = props.tickTotal,
          tickValues = props.tickValues,
          marginLeft = props.marginLeft,
          marginTop = props.marginTop,
          rRange = props.rRange,
          style = props.style;


      var xScale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_scales_utils__["e" /* getAttributeScale */])(props, 'x');
      var yScale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_scales_utils__["e" /* getAttributeScale */])(props, 'y');
      var values = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_axis_utils__["d" /* getTickValues */])(xScale, tickTotal, tickValues);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        {
          transform: 'translate(' + (xScale(centerX) + marginLeft) + ',' + (yScale(centerY) + marginTop) + ')',
          className: 'rv-xy-plot__circular-grid-lines' },
        values.reduce(function (res, value, index) {
          var radius = xScale(value);
          if (rRange && (radius < rRange[0] || radius > rRange[1])) {
            return res;
          }
          return res.concat([__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle', _extends({ cx: 0, cy: 0, r: radius }, {
            key: index,
            className: 'rv-xy-plot__circular-grid-lines__line',
            style: style }))]);
        }, [])
      );
    }
  }]);

  return CircularGridLines;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

CircularGridLines.displayName = 'CircularGridLines';
CircularGridLines.propTypes = {
  centerX: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  centerY: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  left: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  rRange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number),

  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  tickValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number),
  tickTotal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  animation: __WEBPACK_IMPORTED_MODULE_3__animation__["a" /* AnimationPropType */],
  // generally supplied by xyplot
  marginTop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  marginBottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  marginLeft: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  marginRight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  innerWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  innerHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};
CircularGridLines.defaultProps = {
  centerX: 0,
  centerY: 0
};
CircularGridLines.requiresSVG = true;

/* harmony default export */ __webpack_exports__["a"] = (CircularGridLines);

/***/ }),
/* 1270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_scales_utils__ = __webpack_require__(25);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.







/**
 * Format title by detault.
 * @param {Array} values List of values.
 * @returns {*} Formatted value or undefined.
 */
function defaultTitleFormat(values) {
  var value = getFirstNonEmptyValue(values);
  if (value) {
    return {
      title: 'x',
      value: value.x
    };
  }
}

/**
 * Format items by default.
 * @param {Array} values Array of values.
 * @returns {*} Formatted list of items.
 */
function defaultItemsFormat(values) {
  return values.map(function (v, i) {
    if (v) {
      return { value: v.y, title: i };
    }
  });
}

/**
 * Get the first non-empty item from an array.
 * @param {Array} values Array of values.
 * @returns {*} First non-empty value or undefined.
 */
function getFirstNonEmptyValue(values) {
  return (values || []).find(function (v) {
    return Boolean(v);
  });
}

var Crosshair = function (_PureComponent) {
  _inherits(Crosshair, _PureComponent);

  function Crosshair() {
    _classCallCheck(this, Crosshair);

    return _possibleConstructorReturn(this, (Crosshair.__proto__ || Object.getPrototypeOf(Crosshair)).apply(this, arguments));
  }

  _createClass(Crosshair, [{
    key: '_renderCrosshairTitle',


    /**
     * Render crosshair title.
     * @returns {*} Container with the crosshair title.
     * @private
     */
    value: function _renderCrosshairTitle() {
      var _props = this.props,
          values = _props.values,
          titleFormat = _props.titleFormat;

      var titleItem = titleFormat(values);
      if (!titleItem) {
        return null;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'rv-crosshair__title', key: 'title' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'rv-crosshair__title__title' },
          titleItem.title
        ),
        ': ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'rv-crosshair__title__value' },
          titleItem.value
        )
      );
    }

    /**
     * Render crosshair items (title + value for each series).
     * @returns {*} Array of React classes with the crosshair values.
     * @private
     */

  }, {
    key: '_renderCrosshairItems',
    value: function _renderCrosshairItems() {
      var _props2 = this.props,
          values = _props2.values,
          itemsFormat = _props2.itemsFormat;

      var items = itemsFormat(values);
      if (!items) {
        return null;
      }
      return items.filter(function (i) {
        return i;
      }).map(function renderValue(item, i) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'rv-crosshair__item', key: 'item' + i },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'rv-crosshair__item__title' },
            item.title
          ),
          ': ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'rv-crosshair__item__value' },
            item.value
          )
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          children = _props3.children,
          values = _props3.values,
          marginTop = _props3.marginTop,
          marginLeft = _props3.marginLeft,
          innerWidth = _props3.innerWidth,
          innerHeight = _props3.innerHeight;

      var value = getFirstNonEmptyValue(values);
      if (!value) {
        return null;
      }
      var x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_scales_utils__["c" /* getAttributeFunctor */])(this.props, 'x');
      var innerLeft = x(value);

      var _props$orientation = this.props.orientation,
          orientation = _props$orientation === undefined ? innerLeft > innerWidth / 2 ? 'left' : 'right' : _props$orientation;

      var left = marginLeft + innerLeft;
      var top = marginTop;
      var innerClassName = 'rv-crosshair__inner rv-crosshair__inner--' + orientation;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: 'rv-crosshair',
          style: { left: left + 'px', top: top + 'px' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
          className: 'rv-crosshair__line',
          style: { height: innerHeight + 'px' } }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: innerClassName },
          children ? children : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'rv-crosshair__inner__content' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              this._renderCrosshairTitle(),
              this._renderCrosshairItems()
            )
          )
        )
      );
    }
  }], [{
    key: 'propTypes',
    get: function get() {
      return {
        values: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
        series: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
        innerWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
        innerHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
        marginLeft: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
        marginTop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
        orientation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['left', 'right']),
        itemsFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
        titleFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
      };
    }
  }, {
    key: 'defaultProps',
    get: function get() {
      return {
        titleFormat: defaultTitleFormat,
        itemsFormat: defaultItemsFormat
      };
    }
  }]);

  return Crosshair;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Crosshair.displayName = 'Crosshair';

/* harmony default export */ __webpack_exports__["a"] = (Crosshair);

/***/ }),
/* 1271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.




var predefinedClassName = 'rv-gradient-defs';

var GradientDefs = function (_PureComponent) {
  _inherits(GradientDefs, _PureComponent);

  function GradientDefs() {
    _classCallCheck(this, GradientDefs);

    return _possibleConstructorReturn(this, (GradientDefs.__proto__ || Object.getPrototypeOf(GradientDefs)).apply(this, arguments));
  }

  _createClass(GradientDefs, [{
    key: 'render',
    value: function render() {
      var className = this.props.className;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'defs',
        { className: predefinedClassName + ' ' + className },
        this.props.children
      );
    }
  }]);

  return GradientDefs;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

GradientDefs.displayName = 'GradientDefs';
GradientDefs.requiresSVG = true;
GradientDefs.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
GradientDefs.defaultProps = {
  className: ''
};

/* harmony default export */ __webpack_exports__["a"] = (GradientDefs);

/***/ }),
/* 1272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_scales_utils__ = __webpack_require__(25);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.







/*
 * Hint provides two options for placement of hint:
 * a) around a data point in one of four quadrants (imagine the point bisected
 *    by two axes -vertical, horizontal- creating 4 quadrants around a data
 *    point).
 * b) **New** pin to an edge of chart/plot area and position along that edge
 *    using data point's other dimension value.
 *
 * To support these two options, deprecate one Hint props (orientation) with two
 * new Hint align prop object (horizontal, vertical) with following values:
 *
 *   horizontal: auto, left, right, leftEdge, rightEdge
 *   vertical: auto, bottom, top, bottomEdge, topEdge
 *
 * Thus, the following ALIGN constants are the values for horizontal
 * and vertical
 */
var ALIGN = {
  AUTO: 'auto',
  LEFT: 'left',
  RIGHT: 'right',
  LEFT_EDGE: 'leftEdge',
  RIGHT_EDGE: 'rightEdge',
  BOTTOM: 'bottom',
  TOP: 'top',
  BOTTOM_EDGE: 'bottomEdge',
  TOP_EDGE: 'topEdge'
};

/**
 * For backwards support, retain the ORIENTATION prop constants
 */
var ORIENTATION = {
  BOTTOM_LEFT: 'bottomleft',
  BOTTOM_RIGHT: 'bottomright',
  TOP_LEFT: 'topleft',
  TOP_RIGHT: 'topright'
};

/**
 * Default format function for the value.
 * @param {Object} value Value.
 * @returns {Array} title-value pairs.
 */
function defaultFormat(value) {
  return Object.keys(value).map(function getProp(key) {
    return { title: key, value: value[key] };
  });
}

var Hint = function (_PureComponent) {
  _inherits(Hint, _PureComponent);

  function Hint() {
    _classCallCheck(this, Hint);

    return _possibleConstructorReturn(this, (Hint.__proto__ || Object.getPrototypeOf(Hint)).apply(this, arguments));
  }

  _createClass(Hint, [{
    key: '_getCSSRight',


    /**
     * Get the right coordinate of the hint.
     * When x undefined or null, edge case, pin right.
     * @param {number} x X.
     * @returns {{right: *}} Mixin.
     * @private
     */
    value: function _getCSSRight(x) {
      if (x === undefined || x === null) {
        return {
          right: 0
        };
      }

      var _props = this.props,
          innerWidth = _props.innerWidth,
          marginRight = _props.marginRight;

      return {
        right: marginRight + innerWidth - x
      };
    }

    /**
     * Get the left coordinate of the hint.
     * When x undefined or null, edge case, pin left.
     * @param {number} x X.
     * @returns {{left: *}} Mixin.
     * @private
     */

  }, {
    key: '_getCSSLeft',
    value: function _getCSSLeft(x) {
      if (x === undefined || x === null) {
        return {
          left: 0
        };
      }

      var marginLeft = this.props.marginLeft;

      return {
        left: marginLeft + x
      };
    }

    /**
     * Get the bottom coordinate of the hint.
     * When y undefined or null, edge case, pin bottom.
     * @param {number} y Y.
     * @returns {{bottom: *}} Mixin.
     * @private
     */

  }, {
    key: '_getCSSBottom',
    value: function _getCSSBottom(y) {
      if (y === undefined || y === null) {
        return {
          bottom: 0
        };
      }

      var _props2 = this.props,
          innerHeight = _props2.innerHeight,
          marginBottom = _props2.marginBottom;

      return {
        bottom: marginBottom + innerHeight - y
      };
    }

    /**
     * Get the top coordinate of the hint.
     * When y undefined or null, edge case, pin top.
     * @param {number} y Y.
     * @returns {{top: *}} Mixin.
     * @private
     */

  }, {
    key: '_getCSSTop',
    value: function _getCSSTop(y) {
      if (y === undefined || y === null) {
        return {
          top: 0
        };
      }

      var marginTop = this.props.marginTop;

      return {
        top: marginTop + y
      };
    }
  }, {
    key: '_mapOrientationToAlign',
    value: function _mapOrientationToAlign(orientation) {
      // TODO: print warning that this feature is deprecated and support will be
      // removed in next major release.
      switch (orientation) {
        case ORIENTATION.BOTTOM_LEFT:
          return {
            horizontal: ALIGN.LEFT,
            vertical: ALIGN.BOTTOM
          };
        case ORIENTATION.BOTTOM_RIGHT:
          return {
            horizontal: ALIGN.RIGHT,
            vertical: ALIGN.BOTTOM
          };
        case ORIENTATION.TOP_LEFT:
          return {
            horizontal: ALIGN.LEFT,
            vertical: ALIGN.TOP
          };
        case ORIENTATION.TOP_RIGHT:
          return {
            horizontal: ALIGN.RIGHT,
            vertical: ALIGN.TOP
          };
        default:
          // fall back to horizontalAlign, verticalAlign that are either
          // provided or defaulted to AUTO.  So, don't change things
          break;
      }
    }

    /**
     * Obtain align object with horizontal and vertical settings
     * but convert any AUTO values to the non-auto ALIGN depending on the
     * values of x and y.
     * @param {number} x X value.
     * @param {number} y Y value.
     * @returns {Object} Align object w/ horizontal, vertical prop strings.
     * @private
     */

  }, {
    key: '_getAlign',
    value: function _getAlign(x, y) {
      var _props3 = this.props,
          innerWidth = _props3.innerWidth,
          innerHeight = _props3.innerHeight,
          orientation = _props3.orientation,
          _props3$align = _props3.align,
          horizontal = _props3$align.horizontal,
          vertical = _props3$align.vertical;

      var align = orientation ? this._mapOrientationToAlign(orientation) : { horizontal: horizontal, vertical: vertical };
      if (horizontal === ALIGN.AUTO) {
        align.horizontal = x > innerWidth / 2 ? ALIGN.LEFT : ALIGN.RIGHT;
      }
      if (vertical === ALIGN.AUTO) {
        align.vertical = y > innerHeight / 2 ? ALIGN.TOP : ALIGN.BOTTOM;
      }
      return align;
    }

    /**
     * Get a CSS mixin for a proper positioning of the element.
     * @param {Object} align object with horizontal and vertical prop strings.
     * @param {number} x X position.
     * @param {number} y Y position.
     * @returns {Object} Object, that may contain `left` or `right, `top` or
     * `bottom` properties.
     * @private
     */

  }, {
    key: '_getAlignStyle',
    value: function _getAlignStyle(align, x, y) {
      return _extends({}, this._getXCSS(align.horizontal, x), this._getYCSS(align.vertical, y));
    }
  }, {
    key: '_getYCSS',
    value: function _getYCSS(verticalAlign, y) {
      // obtain yCSS
      switch (verticalAlign) {
        case ALIGN.TOP_EDGE:
          // this pins x to top edge
          return this._getCSSTop(null);
        case ALIGN.BOTTOM_EDGE:
          // this pins x to bottom edge
          return this._getCSSBottom(null);
        case ALIGN.BOTTOM:
          // this places hint text to the bottom of center, so set its top edge
          return this._getCSSTop(y);
        case ALIGN.TOP:
        default:
          // this places hint text to the top of center, so set its bottom edge
          // default case should not be possible but if it happens set to BOTTOM
          return this._getCSSBottom(y);
      }
    }
  }, {
    key: '_getXCSS',
    value: function _getXCSS(horizontal, x) {
      // obtain xCSS
      switch (horizontal) {
        case ALIGN.LEFT_EDGE:
          // this pins x to left edge
          return this._getCSSLeft(null);
        case ALIGN.RIGHT_EDGE:
          // this pins x to left edge
          return this._getCSSRight(null);
        case ALIGN.LEFT:
          // this places hint text to the left of center, so set its right edge
          return this._getCSSRight(x);
        case ALIGN.RIGHT:
        default:
          // this places hint text to the right of center, so set its left edge
          // default case should not be possible but if it happens set to RIGHT
          return this._getCSSLeft(x);
      }
    }

    /**
     * Get the class names from align values.
     * @param {Object} align object with horizontal and vertical prop strings.
     * @returns {string} Class names.
     * @private
     */

  }, {
    key: '_getAlignClassNames',
    value: function _getAlignClassNames(align) {
      var orientation = this.props.orientation;

      var orientationClass = orientation ? 'rv-hint--orientation-' + orientation : '';
      return orientationClass + ' rv-hint--horizontalAlign-' + align.horizontal + '\n     rv-hint--verticalAlign-' + align.vertical;
    }

    /**
     * Get the position for the hint and the appropriate class name.
     * @returns {{style: Object, className: string}} Style and className for the
     * hint.
     * @private
     */

  }, {
    key: '_getPositionInfo',
    value: function _getPositionInfo() {
      var _props4 = this.props,
          value = _props4.value,
          getAlignStyle = _props4.getAlignStyle;


      var x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_scales_utils__["c" /* getAttributeFunctor */])(this.props, 'x')(value);
      var y = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_scales_utils__["c" /* getAttributeFunctor */])(this.props, 'y')(value);

      var align = this._getAlign(x, y);

      return {
        position: getAlignStyle ? getAlignStyle(align, x, y) : this._getAlignStyle(align, x, y),
        className: this._getAlignClassNames(align)
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props5 = this.props,
          value = _props5.value,
          format = _props5.format,
          children = _props5.children,
          style = _props5.style;

      var _getPositionInfo2 = this._getPositionInfo(),
          position = _getPositionInfo2.position,
          className = _getPositionInfo2.className;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: 'rv-hint ' + className,
          style: _extends({}, style, position, {
            position: 'absolute'
          }) },
        children ? children : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'rv-hint__content', style: style.content },
          format(value).map(function (formattedProp, i) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { key: 'rv-hint' + i, style: style.row },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'rv-hint__title', style: style.title },
                formattedProp.title
              ),
              ': ',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'rv-hint__value', style: style.value },
                formattedProp.value
              )
            );
          })
        )
      );
    }
  }], [{
    key: 'propTypes',
    get: function get() {
      return {
        marginTop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
        marginLeft: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
        innerWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
        innerHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
        scales: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
        value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
        format: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
        style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
        align: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
          horizontal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([ALIGN.AUTO, ALIGN.LEFT, ALIGN.RIGHT, ALIGN.LEFT_EDGE, ALIGN.RIGHT_EDGE]),
          vertical: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([ALIGN.AUTO, ALIGN.BOTTOM, ALIGN.TOP, ALIGN.BOTTOM_EDGE, ALIGN.TOP_EDGE])
        }),
        getAlignStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
        orientation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([ORIENTATION.BOTTOM_LEFT, ORIENTATION.BOTTOM_RIGHT, ORIENTATION.TOP_LEFT, ORIENTATION.TOP_RIGHT])
      };
    }
  }, {
    key: 'defaultProps',
    get: function get() {
      return {
        format: defaultFormat,
        align: {
          horizontal: ALIGN.AUTO,
          vertical: ALIGN.AUTO
        },
        style: {}
      };
    }
  }]);

  return Hint;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Hint.displayName = 'Hint';
Hint.ORIENTATION = ORIENTATION;
Hint.ALIGN = ALIGN;

/* harmony default export */ __webpack_exports__["a"] = (Hint);

/***/ }),
/* 1273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__grid_lines__ = __webpack_require__(278);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.








var HORIZONTAL = __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__["b" /* DIRECTION */].HORIZONTAL;


var propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_3__grid_lines__["a" /* default */].propTypes, {
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([HORIZONTAL])
});

var defaultProps = {
  direction: HORIZONTAL,
  attr: 'y'
};

function HorizontalGridLines(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__grid_lines__["a" /* default */], props);
}

HorizontalGridLines.displayName = 'HorizontalGridLines';
HorizontalGridLines.propTypes = propTypes;
HorizontalGridLines.defaultProps = defaultProps;
HorizontalGridLines.requiresSVG = true;

/* harmony default export */ __webpack_exports__["a"] = (HorizontalGridLines);

/***/ }),
/* 1274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_shape__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__animation__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__theme__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_series_utils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__abstract_series__ = __webpack_require__(8);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.










var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--line';

var AreaSeries = function (_AbstractSeries) {
  _inherits(AreaSeries, _AbstractSeries);

  function AreaSeries() {
    _classCallCheck(this, AreaSeries);

    return _possibleConstructorReturn(this, (AreaSeries.__proto__ || Object.getPrototypeOf(AreaSeries)).apply(this, arguments));
  }

  _createClass(AreaSeries, [{
    key: '_renderArea',
    value: function _renderArea(data, x, y0, y, curve) {
      var area = __WEBPACK_IMPORTED_MODULE_1_d3_shape__["area"]();
      if (curve !== null) {
        if (typeof curve === 'string' && __WEBPACK_IMPORTED_MODULE_1_d3_shape__[curve]) {
          area = area.curve(__WEBPACK_IMPORTED_MODULE_1_d3_shape__[curve]);
        } else if (typeof curve === 'function') {
          area = area.curve(curve);
        }
      }
      area = area.x(x).y0(y0).y1(y);
      return area(data);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          animation = _props.animation,
          className = _props.className,
          curve = _props.curve,
          data = _props.data,
          marginLeft = _props.marginLeft,
          marginTop = _props.marginTop,
          style = _props.style;

      if (!data) {
        return null;
      }
      if (animation) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__animation__["b" /* default */],
          _extends({}, this.props, { animatedProps: __WEBPACK_IMPORTED_MODULE_4__utils_series_utils__["e" /* ANIMATED_SERIES_PROPS */] }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AreaSeries, _extends({}, this.props, { animation: null }))
        );
      }

      var x = this._getAttributeFunctor('x');
      var y = this._getAttributeFunctor('y');
      var y0 = this._getAttr0Functor('y');
      var stroke = this._getAttributeValue('stroke') || this._getAttributeValue('color');
      var fill = this._getAttributeValue('fill') || this._getAttributeValue('color');
      var newOpacity = this._getAttributeValue('opacity');
      var opacity = Number.isFinite(newOpacity) ? newOpacity : __WEBPACK_IMPORTED_MODULE_3__theme__["a" /* DEFAULT_OPACITY */];
      var d = this._renderArea(data, x, y0, y, curve);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
        d: d,
        className: predefinedClassName + ' ' + className,
        transform: 'translate(' + marginLeft + ',' + marginTop + ')',
        onMouseOver: this._seriesMouseOverHandler,
        onMouseOut: this._seriesMouseOutHandler,
        onClick: this._seriesClickHandler,
        style: _extends({
          opacity: opacity,
          stroke: stroke,
          fill: fill
        }, style) });
    }
  }]);

  return AreaSeries;
}(__WEBPACK_IMPORTED_MODULE_5__abstract_series__["a" /* default */]);

AreaSeries.displayName = 'AreaSeries';

/* harmony default export */ __webpack_exports__["a"] = (AreaSeries);

/***/ }),
/* 1275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_interpolate__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__animation__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_series_utils__ = __webpack_require__(23);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.








var MAX_DRAWS = 30;

/**
 * Draw loop draws each of the layers until it should draw more
 * @param {CanvasContext} ctx - the context where the drawing will take place
 * @param {Number} height - height of the canvas
 * @param {Number} width - width of the canvas
 * @param {Array} layers - the layer objects to render
 */
function engageDrawLoop(ctx, height, width, layers) {
  var drawIteration = 0;
  // using setInterval because request animation frame goes too fast
  var drawCycle = setInterval(function () {
    if (!ctx) {
      clearInterval(drawCycle);
      return;
    }
    drawLayers(ctx, height, width, layers, drawIteration);
    if (drawIteration > MAX_DRAWS) {
      clearInterval(drawCycle);
    }
    drawIteration += 1;
  }, 1);
}

/**
 * Loops across each of the layers to be drawn and draws them
 * @param {CanvasContext} ctx - the context where the drawing will take place
 * @param {Number} height - height of the canvas
 * @param {Number} width - width of the canvas
 * @param {Array} layers - the layer objects to render
 * @param {Number} drawIteration - width of the canvas
 */
function drawLayers(ctx, height, width, layers, drawIteration) {
  ctx.clearRect(0, 0, width, height);
  layers.forEach(function (layer) {
    var interpolator = layer.interpolator,
        newProps = layer.newProps,
        animation = layer.animation;
    // return an empty object if dont need to be animating

    var interpolatedProps = animation ? interpolator ? interpolator(drawIteration / MAX_DRAWS) : interpolator : function () {
      return {};
    };
    layer.renderLayer(_extends({}, newProps, interpolatedProps), ctx);
  });
}

/**
 * Build an array of layer of objects the contain the method for drawing each series
 * as well as an interpolar (specifically a d3-interpolate interpolator)
 * @param {Object} newChildren the new children to be rendered.
 * @param {Object} oldChildren the old children to be rendered.
 * @returns {Array} Object for rendering
 */
function buildLayers(newChildren, oldChildren) {
  return newChildren.map(function (child, index) {
    var oldProps = oldChildren[index] ? oldChildren[index].props : {};
    var newProps = child.props;

    var oldAnimatedProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__animation__["c" /* extractAnimatedPropValues */])(_extends({}, oldProps, {
      animatedProps: __WEBPACK_IMPORTED_MODULE_4__utils_series_utils__["e" /* ANIMATED_SERIES_PROPS */]
    }));
    var newAnimatedProps = newProps ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__animation__["c" /* extractAnimatedPropValues */])(_extends({}, newProps, {
      animatedProps: __WEBPACK_IMPORTED_MODULE_4__utils_series_utils__["e" /* ANIMATED_SERIES_PROPS */]
    })) : null;
    var interpolator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_d3_interpolate__["b" /* interpolate */])(oldAnimatedProps, newAnimatedProps);

    return {
      renderLayer: child.type.renderLayer,
      newProps: child.props,
      animation: child.props.animation,
      interpolator: interpolator
    };
  });
}

var CanvasWrapper = function (_Component) {
  _inherits(CanvasWrapper, _Component);

  function CanvasWrapper() {
    _classCallCheck(this, CanvasWrapper);

    return _possibleConstructorReturn(this, (CanvasWrapper.__proto__ || Object.getPrototypeOf(CanvasWrapper)).apply(this, arguments));
  }

  _createClass(CanvasWrapper, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.drawChildren(this.props, null, this.refs.canvas.getContext('2d'));
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(nextProps) {
      this.drawChildren(nextProps, this.props, this.refs.canvas.getContext('2d'));
    }

    /**
     * Check that we can and should be animating, then kick off animations as apporpriate
     * @param {Object} newProps the new props to be interpolated to
     * @param {Object} oldProps the old props to be interpolated against
     * @param {DomRef} ctx the canvas context to be drawn on.
     * @returns {Array} Object for rendering
     */

  }, {
    key: 'drawChildren',
    value: function drawChildren(newProps, oldProps, ctx) {
      var children = newProps.children,
          innerHeight = newProps.innerHeight,
          innerWidth = newProps.innerWidth,
          marginBottom = newProps.marginBottom,
          marginLeft = newProps.marginLeft,
          marginRight = newProps.marginRight,
          marginTop = newProps.marginTop;

      if (!ctx) {
        return;
      }

      var childrenShouldAnimate = children.find(function (child) {
        return child.props.animation;
      });

      var height = innerHeight + marginTop + marginBottom;
      var width = innerWidth + marginLeft + marginRight;
      var layers = buildLayers(newProps.children, oldProps ? oldProps.children : []);
      // if we don't need to be animating, dont! cut short
      if (!childrenShouldAnimate) {
        drawLayers(ctx, height, width, layers);
        return;
      }

      engageDrawLoop(ctx, height, width, layers);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          marginBottom = _props.marginBottom,
          marginLeft = _props.marginLeft,
          marginRight = _props.marginRight,
          marginTop = _props.marginTop,
          innerHeight = _props.innerHeight,
          innerWidth = _props.innerWidth;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { left: 0, top: 0 }, className: 'rv-xy-canvas' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('canvas', {
          className: 'rv-xy-canvas-element',
          height: innerHeight + marginTop + marginBottom,
          width: innerWidth + marginLeft + marginRight,
          ref: 'canvas' })
      );
    }
  }]);

  return CanvasWrapper;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

CanvasWrapper.displayName = 'CanvasWrapper';
CanvasWrapper.propTypes = {
  marginBottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  marginLeft: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  marginRight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  marginTop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  innerHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  innerWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (CanvasWrapper);

/***/ }),
/* 1276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_contour__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_geo__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_scale__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__abstract_series__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__animation__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_series_utils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__theme__ = __webpack_require__(22);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.












var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--contour';

function getDomain(data) {
  return data.reduce(function (acc, row) {
    return {
      min: Math.min(acc.min, row.value),
      max: Math.max(acc.max, row.value)
    };
  }, { min: Infinity, max: -Infinity });
}

var ContourSeries = function (_AbstractSeries) {
  _inherits(ContourSeries, _AbstractSeries);

  function ContourSeries() {
    _classCallCheck(this, ContourSeries);

    return _possibleConstructorReturn(this, (ContourSeries.__proto__ || Object.getPrototypeOf(ContourSeries)).apply(this, arguments));
  }

  _createClass(ContourSeries, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          animation = _props.animation,
          bandwidth = _props.bandwidth,
          className = _props.className,
          colorRange = _props.colorRange,
          data = _props.data,
          innerHeight = _props.innerHeight,
          innerWidth = _props.innerWidth,
          marginLeft = _props.marginLeft,
          marginTop = _props.marginTop,
          style = _props.style;


      if (!data || !innerWidth || !innerHeight) {
        return null;
      }

      if (animation) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__animation__["b" /* default */],
          _extends({}, this.props, { animatedProps: __WEBPACK_IMPORTED_MODULE_7__utils_series_utils__["e" /* ANIMATED_SERIES_PROPS */] }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContourSeries, _extends({}, this.props, { animation: null }))
        );
      }

      var x = this._getAttributeFunctor('x');
      var y = this._getAttributeFunctor('y');

      var contouredData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_d3_contour__["a" /* contourDensity */])().x(function (d) {
        return x(d);
      }).y(function (d) {
        return y(d);
      }).size([innerWidth, innerHeight]).bandwidth(bandwidth)(data);

      var geo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_d3_geo__["a" /* geoPath */])();

      var _getDomain = getDomain(contouredData),
          min = _getDomain.min,
          max = _getDomain.max;

      var colorScale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_d3_scale__["a" /* scaleLinear */])().domain([min, max]).range(colorRange || __WEBPACK_IMPORTED_MODULE_8__theme__["c" /* CONTINUOUS_COLOR_RANGE */]);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        { className: predefinedClassName + ' ' + className,
          ref: 'container',
          transform: 'translate(' + marginLeft + ',' + marginTop + ')' },
        contouredData.map(function (polygon, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
            className: 'rv-xy-plot__series--contour-line',
            key: 'rv-xy-plot__series--contour-line-' + index,
            d: geo(polygon),
            style: _extends({
              fill: colorScale(polygon.value)
            }, style)
          });
        })
      );
    }
  }]);

  return ContourSeries;
}(__WEBPACK_IMPORTED_MODULE_5__abstract_series__["a" /* default */]);

ContourSeries.propTypes = {
  animation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  bandwidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    y: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
  })).isRequired,
  marginLeft: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  marginTop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

ContourSeries.defaultProps = {
  bandwidth: 40,
  style: {}
};

/* harmony default export */ __webpack_exports__["a"] = (ContourSeries);

/***/ }),
/* 1277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__abstract_series__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__animation__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_series_utils__ = __webpack_require__(23);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// Copyright (c) 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.








var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--custom-svg-wrapper';

var DEFAULT_STYLE = {
  stroke: 'blue',
  fill: 'blue'
};

function predefinedComponents(type) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var style = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_STYLE;

  switch (type) {
    case 'diamond':
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon', {
        style: style,
        points: '0 0 ' + size / 2 + ' ' + size / 2 + ' 0 ' + size + ' ' + -size / 2 + ' ' + size / 2 + ' 0 0' });
    case 'star':
      var starPoints = [].concat(_toConsumableArray(new Array(5))).map(function (c, index) {
        var angle = index / 5 * Math.PI * 2;
        var innerAngle = angle + Math.PI / 10;
        var outerAngle = angle - Math.PI / 10;
        // ratio of inner polygon to outer polgyon
        var innerRadius = size / 2.61;
        return '\n        ' + Math.cos(outerAngle) * size + ' ' + Math.sin(outerAngle) * size + '\n        ' + Math.cos(innerAngle) * innerRadius + ' ' + Math.sin(innerAngle) * innerRadius + '\n      ';
      }).join(' ');
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon', {
        points: starPoints,
        x: '0', y: '0', height: size, width: size, style: style });
    case 'square':
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { x: '' + -size / 2, y: '' + -size / 2, height: size, width: size, style: style });
    default:
    case 'circle':
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle', { cx: '0', cy: '0', r: size / 2, style: style });
  }
}

function getInnerComponent(_ref) {
  var customComponent = _ref.customComponent,
      positionInPixels = _ref.positionInPixels,
      defaultType = _ref.defaultType,
      positionFunctions = _ref.positionFunctions;
  var size = customComponent.size,
      style = customComponent.style;

  var innerComponent = customComponent.customComponent;
  if (!innerComponent && typeof defaultType === 'string') {
    return predefinedComponents(defaultType, size, style);
  }
  // if default component is a function
  if (!innerComponent) {
    return innerComponent(defaultType, positionInPixels);
  }
  if (typeof innerComponent === 'string') {
    return predefinedComponents(innerComponent || defaultType, size, style);
  }
  // if inner component is a function
  return innerComponent(customComponent, positionInPixels);
}

var CustomSVGSeries = function (_AbstractSeries) {
  _inherits(CustomSVGSeries, _AbstractSeries);

  function CustomSVGSeries() {
    _classCallCheck(this, CustomSVGSeries);

    return _possibleConstructorReturn(this, (CustomSVGSeries.__proto__ || Object.getPrototypeOf(CustomSVGSeries)).apply(this, arguments));
  }

  _createClass(CustomSVGSeries, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          animation = _props.animation,
          className = _props.className,
          customComponent = _props.customComponent,
          data = _props.data,
          innerHeight = _props.innerHeight,
          innerWidth = _props.innerWidth,
          marginLeft = _props.marginLeft,
          marginTop = _props.marginTop,
          style = _props.style;


      if (!data || !innerWidth || !innerHeight) {
        return null;
      }

      if (animation) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__animation__["b" /* default */],
          _extends({}, this.props, { animatedProps: __WEBPACK_IMPORTED_MODULE_4__utils_series_utils__["e" /* ANIMATED_SERIES_PROPS */] }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CustomSVGSeries, _extends({}, this.props, { animation: false }))
        );
      }

      var x = this._getAttributeFunctor('x');
      var y = this._getAttributeFunctor('y');
      var contents = data.map(function (seriesComponent, index) {
        var positionInPixels = {
          x: x({ x: seriesComponent.x }),
          y: y({ y: seriesComponent.y })
        };
        var innerComponent = getInnerComponent({
          customComponent: seriesComponent,
          positionInPixels: positionInPixels,
          defaultType: customComponent,
          positionFunctions: { x: x, y: y }
        });
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          {
            className: 'rv-xy-plot__series--custom-svg',
            key: 'rv-xy-plot__series--custom-svg-' + index,
            transform: 'translate(' + positionInPixels.x + ',' + positionInPixels.y + ')'
          },
          innerComponent
        );
      });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        { className: predefinedClassName + ' ' + className,
          ref: 'container',
          transform: 'translate(' + marginLeft + ',' + marginTop + ')',
          style: style },
        contents
      );
    }
  }]);

  return CustomSVGSeries;
}(__WEBPACK_IMPORTED_MODULE_2__abstract_series__["a" /* default */]);

CustomSVGSeries.propTypes = {
  animation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  customComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    y: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
  })).isRequired,
  marginLeft: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  marginTop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

CustomSVGSeries.defaultProps = {
  animation: false,
  customComponent: 'circle',
  style: {}
};

/* harmony default export */ __webpack_exports__["a"] = (CustomSVGSeries);

/***/ }),
/* 1278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__animation__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_series_utils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__abstract_series__ = __webpack_require__(8);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.








var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--heatmap';

var HeatmapSeries = function (_AbstractSeries) {
  _inherits(HeatmapSeries, _AbstractSeries);

  function HeatmapSeries() {
    _classCallCheck(this, HeatmapSeries);

    return _possibleConstructorReturn(this, (HeatmapSeries.__proto__ || Object.getPrototypeOf(HeatmapSeries)).apply(this, arguments));
  }

  _createClass(HeatmapSeries, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          animation = _props.animation,
          className = _props.className,
          data = _props.data,
          marginLeft = _props.marginLeft,
          marginTop = _props.marginTop,
          style = _props.style;

      if (!data) {
        return null;
      }
      if (animation) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1__animation__["b" /* default */],
          _extends({}, this.props, { animatedProps: __WEBPACK_IMPORTED_MODULE_2__utils_series_utils__["e" /* ANIMATED_SERIES_PROPS */] }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeatmapSeries, _extends({}, this.props, { animation: null }))
        );
      }
      var xFunctor = this._getAttributeFunctor('x');
      var yFunctor = this._getAttributeFunctor('y');
      var opacityFunctor = this._getAttributeFunctor('opacity');
      var fillFunctor = this._getAttributeFunctor('fill') || this._getAttributeFunctor('color');
      var strokeFunctor = this._getAttributeFunctor('stroke') || this._getAttributeFunctor('color');
      var xDistance = this._getScaleDistance('x');
      var yDistance = this._getScaleDistance('y');
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        {
          className: predefinedClassName + ' ' + className,
          ref: 'container',
          transform: 'translate(' + marginLeft + ',' + marginTop + ')' },
        data.map(function (d, i) {
          var attrs = {
            style: _extends({
              stroke: strokeFunctor && strokeFunctor(d),
              fill: fillFunctor && fillFunctor(d),
              opacity: opacityFunctor && opacityFunctor(d)
            }, style),
            x: xFunctor(d) - xDistance / 2,
            y: yFunctor(d) - yDistance / 2,
            width: xDistance,
            height: yDistance,
            key: i,
            onClick: function onClick(e) {
              return _this2._valueClickHandler(d, e);
            },
            onMouseOver: function onMouseOver(e) {
              return _this2._valueMouseOverHandler(d, e);
            },
            onMouseOut: function onMouseOut(e) {
              return _this2._valueMouseOutHandler(d, e);
            }
          };
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', attrs);
        })
      );
    }
  }], [{
    key: 'getParentConfig',
    value: function getParentConfig(attr) {
      var isDomainAdjustmentNeeded = attr === 'x' || attr === 'y';
      return { isDomainAdjustmentNeeded: isDomainAdjustmentNeeded };
    }
  }]);

  return HeatmapSeries;
}(__WEBPACK_IMPORTED_MODULE_3__abstract_series__["a" /* default */]);

HeatmapSeries.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_3__abstract_series__["a" /* default */].propTypes);

HeatmapSeries.displayName = 'HeatmapSeries';

/* harmony default export */ __webpack_exports__["a"] = (HeatmapSeries);

/***/ }),
/* 1279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__abstract_series__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bar_series_canvas__ = __webpack_require__(613);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.




var HorizontalBarSeriesCanvas = function (_AbstractSeries) {
  _inherits(HorizontalBarSeriesCanvas, _AbstractSeries);

  function HorizontalBarSeriesCanvas() {
    _classCallCheck(this, HorizontalBarSeriesCanvas);

    return _possibleConstructorReturn(this, (HorizontalBarSeriesCanvas.__proto__ || Object.getPrototypeOf(HorizontalBarSeriesCanvas)).apply(this, arguments));
  }

  _createClass(HorizontalBarSeriesCanvas, [{
    key: 'render',
    value: function render() {
      return null;
    }
  }], [{
    key: 'getParentConfig',
    value: function getParentConfig(attr) {
      var isDomainAdjustmentNeeded = attr === 'y';
      var zeroBaseValue = attr === 'x';
      return {
        isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
        zeroBaseValue: zeroBaseValue
      };
    }
  }, {
    key: 'renderLayer',
    value: function renderLayer(props, ctx) {
      __WEBPACK_IMPORTED_MODULE_1__bar_series_canvas__["a" /* default */].renderLayer(_extends({}, props, {
        linePosAttr: 'y',
        valuePosAttr: 'x',
        lineSizeAttr: 'height',
        valueSizeAttr: 'width'
      }), ctx);
    }
  }, {
    key: 'requiresSVG',
    get: function get() {
      return false;
    }
  }, {
    key: 'isCanvas',
    get: function get() {
      return true;
    }
  }]);

  return HorizontalBarSeriesCanvas;
}(__WEBPACK_IMPORTED_MODULE_0__abstract_series__["a" /* default */]);

HorizontalBarSeriesCanvas.displayName = 'HorizontalBarSeriesCanvas';
HorizontalBarSeriesCanvas.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_0__abstract_series__["a" /* default */].propTypes);

/* harmony default export */ __webpack_exports__["a"] = (HorizontalBarSeriesCanvas);

/***/ }),
/* 1280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__abstract_series__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bar_series__ = __webpack_require__(614);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.






var HorizontalBarSeries = function (_AbstractSeries) {
  _inherits(HorizontalBarSeries, _AbstractSeries);

  function HorizontalBarSeries() {
    _classCallCheck(this, HorizontalBarSeries);

    return _possibleConstructorReturn(this, (HorizontalBarSeries.__proto__ || Object.getPrototypeOf(HorizontalBarSeries)).apply(this, arguments));
  }

  _createClass(HorizontalBarSeries, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bar_series__["a" /* default */], _extends({}, this.props, {
        linePosAttr: 'y',
        valuePosAttr: 'x',
        lineSizeAttr: 'height',
        valueSizeAttr: 'width'
      }));
    }
  }], [{
    key: 'getParentConfig',
    value: function getParentConfig(attr) {
      var isDomainAdjustmentNeeded = attr === 'y';
      var zeroBaseValue = attr === 'x';
      return {
        isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
        zeroBaseValue: zeroBaseValue
      };
    }
  }]);

  return HorizontalBarSeries;
}(__WEBPACK_IMPORTED_MODULE_1__abstract_series__["a" /* default */]);

HorizontalBarSeries.displayName = 'HorizontalBarSeries';

/* harmony default export */ __webpack_exports__["a"] = (HorizontalBarSeries);

/***/ }),
/* 1281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__abstract_series__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rect_series_canvas__ = __webpack_require__(280);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.




var HorizontalRectSeriesCanvas = function (_AbstractSeries) {
  _inherits(HorizontalRectSeriesCanvas, _AbstractSeries);

  function HorizontalRectSeriesCanvas() {
    _classCallCheck(this, HorizontalRectSeriesCanvas);

    return _possibleConstructorReturn(this, (HorizontalRectSeriesCanvas.__proto__ || Object.getPrototypeOf(HorizontalRectSeriesCanvas)).apply(this, arguments));
  }

  _createClass(HorizontalRectSeriesCanvas, [{
    key: 'render',
    value: function render() {
      return null;
    }
  }], [{
    key: 'getParentConfig',
    value: function getParentConfig(attr) {
      var isDomainAdjustmentNeeded = false;
      var zeroBaseValue = attr === 'x';
      return {
        isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
        zeroBaseValue: zeroBaseValue
      };
    }
  }, {
    key: 'renderLayer',
    value: function renderLayer(props, ctx) {
      __WEBPACK_IMPORTED_MODULE_1__rect_series_canvas__["a" /* default */].renderLayer(_extends({}, props, {
        linePosAttr: 'y',
        valuePosAttr: 'x',
        lineSizeAttr: 'height',
        valueSizeAttr: 'width'
      }), ctx);
    }
  }, {
    key: 'requiresSVG',
    get: function get() {
      return false;
    }
  }, {
    key: 'isCanvas',
    get: function get() {
      return true;
    }
  }]);

  return HorizontalRectSeriesCanvas;
}(__WEBPACK_IMPORTED_MODULE_0__abstract_series__["a" /* default */]);

HorizontalRectSeriesCanvas.displayName = 'HorizontalRectSeriesCanvas';
HorizontalRectSeriesCanvas.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_0__abstract_series__["a" /* default */].propTypes);

/* harmony default export */ __webpack_exports__["a"] = (HorizontalRectSeriesCanvas);

/***/ }),
/* 1282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__abstract_series__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rect_series__ = __webpack_require__(281);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.






var HorizontalRectSeries = function (_AbstractSeries) {
  _inherits(HorizontalRectSeries, _AbstractSeries);

  function HorizontalRectSeries() {
    _classCallCheck(this, HorizontalRectSeries);

    return _possibleConstructorReturn(this, (HorizontalRectSeries.__proto__ || Object.getPrototypeOf(HorizontalRectSeries)).apply(this, arguments));
  }

  _createClass(HorizontalRectSeries, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__rect_series__["a" /* default */], _extends({}, this.props, {
        linePosAttr: 'y',
        valuePosAttr: 'x',
        lineSizeAttr: 'height',
        valueSizeAttr: 'width'
      }));
    }
  }], [{
    key: 'getParentConfig',
    value: function getParentConfig(attr) {
      var isDomainAdjustmentNeeded = false;
      var zeroBaseValue = attr === 'x';
      return {
        isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
        zeroBaseValue: zeroBaseValue
      };
    }
  }]);

  return HorizontalRectSeries;
}(__WEBPACK_IMPORTED_MODULE_1__abstract_series__["a" /* default */]);

HorizontalRectSeries.displayName = 'HorizontalRectSeries';

/* harmony default export */ __webpack_exports__["a"] = (HorizontalRectSeries);

/***/ }),
/* 1283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__abstract_series__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mark_series_canvas__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__line_series_canvas__ = __webpack_require__(615);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.





var LineMarkSeriesCanvas = function (_AbstractSeries) {
  _inherits(LineMarkSeriesCanvas, _AbstractSeries);

  function LineMarkSeriesCanvas() {
    _classCallCheck(this, LineMarkSeriesCanvas);

    return _possibleConstructorReturn(this, (LineMarkSeriesCanvas.__proto__ || Object.getPrototypeOf(LineMarkSeriesCanvas)).apply(this, arguments));
  }

  _createClass(LineMarkSeriesCanvas, [{
    key: 'render',
    value: function render() {
      return null;
    }
  }], [{
    key: 'renderLayer',
    value: function renderLayer(props, ctx) {
      __WEBPACK_IMPORTED_MODULE_2__line_series_canvas__["a" /* default */].renderLayer(props, ctx);
      __WEBPACK_IMPORTED_MODULE_1__mark_series_canvas__["a" /* default */].renderLayer(props, ctx);
    }
  }, {
    key: 'requiresSVG',
    get: function get() {
      return false;
    }
  }, {
    key: 'isCanvas',
    get: function get() {
      return true;
    }
  }]);

  return LineMarkSeriesCanvas;
}(__WEBPACK_IMPORTED_MODULE_0__abstract_series__["a" /* default */]);

LineMarkSeriesCanvas.displayName = 'LineMarkSeriesCanvas';
LineMarkSeriesCanvas.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_0__abstract_series__["a" /* default */].propTypes);

/* harmony default export */ __webpack_exports__["a"] = (LineMarkSeriesCanvas);

/***/ }),
/* 1284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__abstract_series__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__line_series__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mark_series__ = __webpack_require__(618);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.








var propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_3__line_series__["a" /* default */].propTypes, {
  lineStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  markStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
});

var LineMarkSeries = function (_AbstractSeries) {
  _inherits(LineMarkSeries, _AbstractSeries);

  function LineMarkSeries() {
    _classCallCheck(this, LineMarkSeries);

    return _possibleConstructorReturn(this, (LineMarkSeries.__proto__ || Object.getPrototypeOf(LineMarkSeries)).apply(this, arguments));
  }

  _createClass(LineMarkSeries, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          lineStyle = _props.lineStyle,
          markStyle = _props.markStyle,
          style = _props.style;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        { className: 'rv-xy-plot__series rv-xy-plot__series--linemark' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__line_series__["a" /* default */], _extends({}, this.props, { style: _extends({}, style, lineStyle) })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__mark_series__["a" /* default */], _extends({}, this.props, { style: _extends({}, style, markStyle) }))
      );
    }
  }], [{
    key: 'defaultProps',
    get: function get() {
      return _extends({}, __WEBPACK_IMPORTED_MODULE_3__line_series__["a" /* default */].defaultProps, {
        lineStyle: {},
        markStyle: {}
      });
    }
  }]);

  return LineMarkSeries;
}(__WEBPACK_IMPORTED_MODULE_2__abstract_series__["a" /* default */]);

LineMarkSeries.displayName = 'LineMarkSeries';
LineMarkSeries.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (LineMarkSeries);

/***/ }),
/* 1285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__abstract_series__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bar_series_canvas__ = __webpack_require__(613);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.




var HorizontalBarSeriesCanvas = function (_AbstractSeries) {
  _inherits(HorizontalBarSeriesCanvas, _AbstractSeries);

  function HorizontalBarSeriesCanvas() {
    _classCallCheck(this, HorizontalBarSeriesCanvas);

    return _possibleConstructorReturn(this, (HorizontalBarSeriesCanvas.__proto__ || Object.getPrototypeOf(HorizontalBarSeriesCanvas)).apply(this, arguments));
  }

  _createClass(HorizontalBarSeriesCanvas, [{
    key: 'render',
    value: function render() {
      return null;
    }
  }], [{
    key: 'getParentConfig',
    value: function getParentConfig(attr) {
      var isDomainAdjustmentNeeded = attr === 'x';
      var zeroBaseValue = attr === 'y';
      return {
        isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
        zeroBaseValue: zeroBaseValue
      };
    }
  }, {
    key: 'renderLayer',
    value: function renderLayer(props, ctx) {
      __WEBPACK_IMPORTED_MODULE_1__bar_series_canvas__["a" /* default */].renderLayer(_extends({}, props, {
        linePosAttr: 'x',
        valuePosAttr: 'y',
        lineSizeAttr: 'width',
        valueSizeAttr: 'height'
      }), ctx);
    }
  }, {
    key: 'requiresSVG',
    get: function get() {
      return false;
    }
  }, {
    key: 'isCanvas',
    get: function get() {
      return true;
    }
  }]);

  return HorizontalBarSeriesCanvas;
}(__WEBPACK_IMPORTED_MODULE_0__abstract_series__["a" /* default */]);

HorizontalBarSeriesCanvas.displayName = 'HorizontalBarSeriesCanvas';
HorizontalBarSeriesCanvas.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_0__abstract_series__["a" /* default */].propTypes);

/* harmony default export */ __webpack_exports__["a"] = (HorizontalBarSeriesCanvas);

/***/ }),
/* 1286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__abstract_series__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bar_series__ = __webpack_require__(614);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.






var VerticalBarSeries = function (_AbstractSeries) {
  _inherits(VerticalBarSeries, _AbstractSeries);

  function VerticalBarSeries() {
    _classCallCheck(this, VerticalBarSeries);

    return _possibleConstructorReturn(this, (VerticalBarSeries.__proto__ || Object.getPrototypeOf(VerticalBarSeries)).apply(this, arguments));
  }

  _createClass(VerticalBarSeries, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bar_series__["a" /* default */], _extends({}, this.props, {
        linePosAttr: 'x',
        valuePosAttr: 'y',
        lineSizeAttr: 'width',
        valueSizeAttr: 'height'
      }));
    }
  }], [{
    key: 'getParentConfig',
    value: function getParentConfig(attr) {
      var isDomainAdjustmentNeeded = attr === 'x';
      var zeroBaseValue = attr === 'y';
      return {
        isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
        zeroBaseValue: zeroBaseValue
      };
    }
  }]);

  return VerticalBarSeries;
}(__WEBPACK_IMPORTED_MODULE_1__abstract_series__["a" /* default */]);

VerticalBarSeries.displayName = 'VerticalBarSeries';

/* harmony default export */ __webpack_exports__["a"] = (VerticalBarSeries);

/***/ }),
/* 1287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__abstract_series__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rect_series_canvas__ = __webpack_require__(280);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.




var HorizontalRectSeriesCanvas = function (_AbstractSeries) {
  _inherits(HorizontalRectSeriesCanvas, _AbstractSeries);

  function HorizontalRectSeriesCanvas() {
    _classCallCheck(this, HorizontalRectSeriesCanvas);

    return _possibleConstructorReturn(this, (HorizontalRectSeriesCanvas.__proto__ || Object.getPrototypeOf(HorizontalRectSeriesCanvas)).apply(this, arguments));
  }

  _createClass(HorizontalRectSeriesCanvas, [{
    key: 'render',
    value: function render() {
      return null;
    }
  }], [{
    key: 'getParentConfig',
    value: function getParentConfig(attr) {
      var isDomainAdjustmentNeeded = false;
      var zeroBaseValue = attr === 'y';
      return {
        isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
        zeroBaseValue: zeroBaseValue
      };
    }
  }, {
    key: 'renderLayer',
    value: function renderLayer(props, ctx) {
      __WEBPACK_IMPORTED_MODULE_1__rect_series_canvas__["a" /* default */].renderLayer(_extends({}, props, {
        linePosAttr: 'x',
        valuePosAttr: 'y',
        lineSizeAttr: 'width',
        valueSizeAttr: 'height'
      }), ctx);
    }
  }, {
    key: 'requiresSVG',
    get: function get() {
      return false;
    }
  }, {
    key: 'isCanvas',
    get: function get() {
      return true;
    }
  }]);

  return HorizontalRectSeriesCanvas;
}(__WEBPACK_IMPORTED_MODULE_0__abstract_series__["a" /* default */]);

HorizontalRectSeriesCanvas.displayName = 'HorizontalRectSeriesCanvas';
HorizontalRectSeriesCanvas.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_0__abstract_series__["a" /* default */].propTypes);

/* harmony default export */ __webpack_exports__["a"] = (HorizontalRectSeriesCanvas);

/***/ }),
/* 1288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__abstract_series__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rect_series__ = __webpack_require__(281);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.






var VerticalRectSeries = function (_AbstractSeries) {
  _inherits(VerticalRectSeries, _AbstractSeries);

  function VerticalRectSeries() {
    _classCallCheck(this, VerticalRectSeries);

    return _possibleConstructorReturn(this, (VerticalRectSeries.__proto__ || Object.getPrototypeOf(VerticalRectSeries)).apply(this, arguments));
  }

  _createClass(VerticalRectSeries, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__rect_series__["a" /* default */], _extends({}, this.props, {
        linePosAttr: 'x',
        valuePosAttr: 'y',
        lineSizeAttr: 'width',
        valueSizeAttr: 'height'
      }));
    }
  }], [{
    key: 'getParentConfig',
    value: function getParentConfig(attr) {
      var isDomainAdjustmentNeeded = false;
      var zeroBaseValue = attr === 'y';
      return {
        isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
        zeroBaseValue: zeroBaseValue
      };
    }
  }]);

  return VerticalRectSeries;
}(__WEBPACK_IMPORTED_MODULE_1__abstract_series__["a" /* default */]);

VerticalRectSeries.displayName = 'VerticalRectSeries';

/* harmony default export */ __webpack_exports__["a"] = (VerticalRectSeries);

/***/ }),
/* 1289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__grid_lines__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_axis_utils__ = __webpack_require__(31);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.








var VERTICAL = __WEBPACK_IMPORTED_MODULE_3__utils_axis_utils__["b" /* DIRECTION */].VERTICAL;


var propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_2__grid_lines__["a" /* default */].propTypes, {
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([VERTICAL])
});

var defaultProps = {
  direction: VERTICAL,
  attr: 'x'
};

function VerticalGridLines(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__grid_lines__["a" /* default */], props);
}

VerticalGridLines.displayName = 'VerticalGridLines';
VerticalGridLines.propTypes = propTypes;
VerticalGridLines.defaultProps = defaultProps;
VerticalGridLines.requiresSVG = true;

/* harmony default export */ __webpack_exports__["a"] = (VerticalGridLines);

/***/ }),
/* 1290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_scale__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_format__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__animation__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plot_xy_plot__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__theme__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_chart_utils__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plot_series_polygon_series__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__plot_series_label_series__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__plot_axis_decorative_axis__ = __webpack_require__(612);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.














var predefinedClassName = 'rv-radar-chart';
var DEFAULT_FORMAT = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_d3_format__["f" /* format */])('.2r');
/**
 * Generate axes for each of the domains
 * @param {Object} props
 - props.animation {Boolean}
 - props.domains {Array} array of object specifying the way each axis is to be plotted
 - props.style {object} style object for the whole chart
 - props.tickFormat {Function} formatting function for axes
 - props.startingAngle {number} the initial angle offset
 * @return {Array} the plotted axis components
 */
function getAxes(props) {
  var animation = props.animation,
      domains = props.domains,
      startingAngle = props.startingAngle,
      style = props.style,
      tickFormat = props.tickFormat,
      hideInnerMostValues = props.hideInnerMostValues;

  return domains.map(function (domain, index) {
    var angle = index / domains.length * Math.PI * 2 + startingAngle;
    var sortedDomain = domain.domain;

    var domainTickFormat = function domainTickFormat(t) {
      if (hideInnerMostValues && t === sortedDomain[0]) {
        return '';
      }
      return domain.tickFormat ? domain.tickFormat(t) : tickFormat(t);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__plot_axis_decorative_axis__["a" /* default */], {
      animation: animation,
      key: index + '-axis',
      axisStart: { x: 0, y: 0 },
      axisEnd: { x: Math.cos(angle), y: Math.sin(angle) },
      axisDomain: sortedDomain,
      numberOfTicks: 5,
      tickValue: domainTickFormat,
      style: style.axes
    });
  });
}

/**
 * Generate labels for the ends of the axes
 * @param {Object} props
 - props.domains {Array} array of object specifying the way each axis is to be plotted
  - props.startingAngle {number} the initial angle offset
 - props.style {object} style object for just the labels
 * @return {Array} the prepped data for the labelSeries
 */
function getLabels(props) {
  var domains = props.domains,
      startingAngle = props.startingAngle,
      style = props.style;

  return domains.map(function (domain, index) {
    var angle = index / domains.length * Math.PI * 2 + startingAngle;
    var radius = 1.2;
    return {
      x: radius * Math.cos(angle),
      y: radius * Math.sin(angle),
      label: domain.name,
      style: style
    };
  });
}

/**
 * Generate the actual polygons to be plotted
 * @param {Object} props
 - props.animation {Boolean}
 - props.data {Array} array of object specifying what values are to be plotted
 - props.domains {Array} array of object specifying the way each axis is to be plotted
 - props.startingAngle {number} the initial angle offset
 - props.style {object} style object for the whole chart
 * @return {Array} the plotted axis components
 */
function getPolygons(props) {
  var animation = props.animation,
      domains = props.domains,
      data = props.data,
      style = props.style,
      startingAngle = props.startingAngle;

  var scales = domains.reduce(function (acc, domain) {
    acc[domain.name] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_d3_scale__["a" /* scaleLinear */])().domain(domain.domain).range([0, 1]);
    return acc;
  }, {});

  return data.map(function (row, rowIndex) {
    var mappedData = domains.map(function (domain, index) {
      var dataPoint = row[domain.name];
      // error handling if point doesn't exisit
      var angle = index / domains.length * Math.PI * 2 + startingAngle;
      // dont let the radius become negative
      var radius = Math.max(scales[domain.name](dataPoint), 0);
      return { x: radius * Math.cos(angle), y: radius * Math.sin(angle) };
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__plot_series_polygon_series__["a" /* default */], {
      animation: animation,
      className: predefinedClassName + '-polygon',
      key: rowIndex + '-polygon',
      data: mappedData,
      style: _extends({
        stroke: row.color || row.stroke || __WEBPACK_IMPORTED_MODULE_6__theme__["b" /* DISCRETE_COLOR_RANGE */][rowIndex],
        fill: row.color || row.fill || __WEBPACK_IMPORTED_MODULE_6__theme__["b" /* DISCRETE_COLOR_RANGE */][rowIndex]
      }, style.polygons)
    });
  });
}

var RadarChart = function (_Component) {
  _inherits(RadarChart, _Component);

  function RadarChart() {
    _classCallCheck(this, RadarChart);

    return _possibleConstructorReturn(this, (RadarChart.__proto__ || Object.getPrototypeOf(RadarChart)).apply(this, arguments));
  }

  _createClass(RadarChart, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          animation = _props.animation,
          className = _props.className,
          children = _props.children,
          data = _props.data,
          domains = _props.domains,
          height = _props.height,
          hideInnerMostValues = _props.hideInnerMostValues,
          margin = _props.margin,
          onMouseLeave = _props.onMouseLeave,
          onMouseEnter = _props.onMouseEnter,
          startingAngle = _props.startingAngle,
          style = _props.style,
          tickFormat = _props.tickFormat,
          width = _props.width;


      var axes = getAxes({
        domains: domains,
        animation: animation,
        hideInnerMostValues: hideInnerMostValues,
        startingAngle: startingAngle,
        style: style,
        tickFormat: tickFormat
      });

      var polygons = getPolygons({
        animation: animation,
        domains: domains,
        data: data,
        startingAngle: startingAngle,
        style: style
      });
      var labelSeries = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__plot_series_label_series__["a" /* default */], {
        animation: true,
        key: className,
        className: predefinedClassName + '-label',
        data: getLabels({ domains: domains, style: style.labels, startingAngle: startingAngle }) });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__plot_xy_plot__["a" /* default */],
        {
          height: height,
          width: width,
          margin: margin,
          dontCheckIfEmpty: true,
          className: className + ' ' + predefinedClassName,
          onMouseLeave: onMouseLeave,
          onMouseEnter: onMouseEnter,
          xDomain: [-1, 1],
          yDomain: [-1, 1] },
        children,
        axes.concat(polygons).concat(labelSeries)
      );
    }
  }]);

  return RadarChart;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

RadarChart.displayName = 'RadarChart';
RadarChart.propTypes = {
  animation: __WEBPACK_IMPORTED_MODULE_4__animation__["a" /* AnimationPropType */],
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  colorType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,
  domains: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    domain: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number).isRequired,
    tickFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  })).isRequired,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  hideInnerMostValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  margin: __WEBPACK_IMPORTED_MODULE_7__utils_chart_utils__["b" /* MarginPropType */],
  startingAngle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    axes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    labels: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    polygons: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }),
  tickFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};
RadarChart.defaultProps = {
  className: '',
  colorType: 'category',
  colorRange: __WEBPACK_IMPORTED_MODULE_6__theme__["b" /* DISCRETE_COLOR_RANGE */],
  hideInnerMostValues: true,
  startingAngle: Math.PI / 2,
  style: {
    axes: {
      line: {},
      ticks: {},
      text: {}
    },
    labels: {
      fontSize: 10,
      textAnchor: 'middle'
    },
    polygons: {
      strokeWidth: 0.5,
      strokeOpacity: 1,
      fillOpacity: 0.1
    }
  },
  tickFormat: DEFAULT_FORMAT
};

/* harmony default export */ __webpack_exports__["a"] = (RadarChart);

/***/ }),
/* 1291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_shape__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__animation__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plot_series_arc_series__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plot_series_label_series__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plot_xy_plot__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__theme__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_chart_utils__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_series_utils__ = __webpack_require__(23);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.













var predefinedClassName = 'rv-radial-chart';

var DEFAULT_RADIUS_MARGIN = 15;

/**
 * Create the list of wedges to render.
 * @param {Object} props
   props.data {Object} - tree structured data (each node has a name anc an array of children)
 * @returns {Array} Array of nodes.
 */
function getWedgesToRender(_ref) {
  var data = _ref.data;

  var pie = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_d3_shape__["pie"])().sort(null).value(function (d) {
    return d.angle;
  });
  var pieData = pie(data).reverse();
  return pieData.map(function (row, index) {
    return _extends({}, row.data, {
      angle0: row.startAngle,
      angle: row.endAngle,
      radius0: row.data.innerRadius || 0,
      radius: row.data.radius || 1,
      color: row.data.color || index
    });
  });
}

function generateLabels(mappedData) {
  return mappedData.reduce(function (res, row) {
    var angle = row.angle,
        angle0 = row.angle0,
        radius = row.radius,
        label = row.label,
        subLabel = row.subLabel;

    var centeredAngle = (angle + angle0) / 2;

    // unfortunate, but true fact: d3 starts its radians at 12 oclock rather than 3
    // and move clockwise rather than counter clockwise. why why why!
    var updatedAngle = -1 * centeredAngle + Math.PI / 2;
    var newLabels = [];
    if (row.label) {
      newLabels.push({
        angle: updatedAngle,
        radius: radius * 1.1,
        label: label,
        style: { fontSize: '12px' }
      });
    }

    if (subLabel) {
      newLabels.push({
        angle: updatedAngle,
        radius: radius * 1.1,
        label: subLabel,
        yOffset: 12,
        style: { fontSize: '10px' }
      });
    }
    return res.concat(newLabels);
  }, []);
  // could add force direction here to make sure the labels dont overlap
}

/**
 * Get the max radius so the chart can extend to the margin.
 * @param  {Number} width - container width
 * @param  {Number} height - container height
 * @return {Number} radius
 */
function getMaxRadius(width, height) {
  return Math.min(width, height) / 2 - DEFAULT_RADIUS_MARGIN;
}

var RadialChart = function (_Component) {
  _inherits(RadialChart, _Component);

  function RadialChart() {
    _classCallCheck(this, RadialChart);

    return _possibleConstructorReturn(this, (RadialChart.__proto__ || Object.getPrototypeOf(RadialChart)).apply(this, arguments));
  }

  _createClass(RadialChart, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          animation = _props.animation,
          className = _props.className,
          children = _props.children,
          data = _props.data,
          height = _props.height,
          hideRootNode = _props.hideRootNode,
          width = _props.width,
          colorType = _props.colorType,
          radius = _props.radius,
          innerRadius = _props.innerRadius,
          showLabels = _props.showLabels,
          margin = _props.margin,
          onMouseLeave = _props.onMouseLeave,
          onMouseEnter = _props.onMouseEnter,
          labelsAboveChildren = _props.labelsAboveChildren;

      var mappedData = getWedgesToRender({ data: data, height: height, hideRootNode: hideRootNode, width: width });
      var radialDomain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_series_utils__["a" /* getRadialDomain */])(mappedData);
      var arcProps = _extends({
        colorType: colorType
      }, this.props, {
        animation: animation,
        radiusDomain: [0, radialDomain],
        data: mappedData,
        radiusNoFallBack: true,
        arcClassName: 'rv-radial-chart__series--pie__slice'
      });
      if (radius) {
        arcProps.radiusDomain = [0, 1];
        arcProps.radiusRange = [innerRadius || 0, radius];
        arcProps.radiusType = 'linear';
      }
      var maxRadius = radius ? radius : getMaxRadius(width, height);
      var defaultMargin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_chart_utils__["a" /* getRadialLayoutMargin */])(width, height, maxRadius);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__plot_xy_plot__["a" /* default */],
        {
          height: height,
          width: width,
          margin: _extends({}, margin, defaultMargin),
          className: className + ' ' + predefinedClassName,
          onMouseLeave: onMouseLeave,
          onMouseEnter: onMouseEnter,
          xDomain: [-radialDomain, radialDomain],
          yDomain: [-radialDomain, radialDomain] },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__plot_series_arc_series__["a" /* default */], arcProps),
        showLabels && !labelsAboveChildren && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__plot_series_label_series__["a" /* default */], { data: generateLabels(mappedData) }),
        children,
        showLabels && labelsAboveChildren && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__plot_series_label_series__["a" /* default */], { data: generateLabels(mappedData) })
      );
    }
  }]);

  return RadialChart;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

RadialChart.displayName = 'RadialChart';
RadialChart.propTypes = {
  animation: __WEBPACK_IMPORTED_MODULE_3__animation__["a" /* AnimationPropType */],
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  colorType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    angle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    radius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  })).isRequired,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  labelsAboveChildren: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  margin: __WEBPACK_IMPORTED_MODULE_8__utils_chart_utils__["b" /* MarginPropType */],
  onValueClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onValueMouseOver: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onValueMouseOut: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  showLabels: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
RadialChart.defaultProps = {
  className: '',
  colorType: 'category',
  colorRange: __WEBPACK_IMPORTED_MODULE_7__theme__["b" /* DISCRETE_COLOR_RANGE */]
};

/* harmony default export */ __webpack_exports__["a"] = (RadialChart);

/***/ }),
/* 1292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_sankey_align__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_sankey_align___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_d3_sankey_align__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plot_voronoi__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__theme__ = __webpack_require__(22);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var NOOP = function NOOP(f) {
  return f;
};

var DEFAULT_LINK_COLOR = __WEBPACK_IMPORTED_MODULE_4__theme__["b" /* DISCRETE_COLOR_RANGE */][1];
var DEFAULT_LINK_OPACITY = 0.7;
var DEFAULT_NODE_COLOR = __WEBPACK_IMPORTED_MODULE_4__theme__["b" /* DISCRETE_COLOR_RANGE */][0];
var DEFAULT_NODE_OPACITY = 1;

var Sankey = function (_Component) {
  _inherits(Sankey, _Component);

  function Sankey() {
    _classCallCheck(this, Sankey);

    return _possibleConstructorReturn(this, (Sankey.__proto__ || Object.getPrototypeOf(Sankey)).apply(this, arguments));
  }

  _createClass(Sankey, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          align = _props.align,
          className = _props.className,
          hasVoronoi = _props.hasVoronoi,
          height = _props.height,
          hideLabels = _props.hideLabels,
          layout = _props.layout,
          links = _props.links,
          margin = _props.margin,
          nodePadding = _props.nodePadding,
          nodes = _props.nodes,
          nodeWidth = _props.nodeWidth,
          onBlur = _props.onBlur,
          _onClick = _props.onClick,
          onHover = _props.onHover,
          width = _props.width;


      var sankeyInstance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_d3_sankey_align__["sankey"])().size([width, height]).nodeWidth(nodeWidth).nodePadding(nodePadding).nodes(nodes).links(links).align(align).layout(layout);

      var nWidth = sankeyInstance.nodeWidth();
      var path = sankeyInstance.link();

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        { height: height + margin, width: width + margin, className: 'rv-sankey ' + className },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          { transform: 'translate(' + margin / 2 + ', ' + margin / 2 + ')' },
          links.map(function (link, i) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
              d: path(link),
              className: 'rv-sankey__link',
              opacity: Number.isFinite(link.opacity) ? link.opacity : DEFAULT_LINK_OPACITY,
              stroke: link.color || DEFAULT_LINK_COLOR,
              strokeWidth: Math.max(1, link.dy),
              fill: 'none',
              key: link.id || link.key || 'link-' + i });
          }),
          nodes.map(function (node, i) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'g',
              {
                transform: 'translate(' + node.x + ', ' + node.y + ')',
                className: 'rv-sankey__node',
                opacity: Number.isFinite(node.opacity) ? node.opacity : DEFAULT_NODE_OPACITY,
                key: node.id || node.key || 'node-' + i },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', {
                onClick: function onClick() {
                  return _onClick(node);
                },
                onMouseOver: function onMouseOver() {
                  return onHover(node);
                },
                onMouseOut: function onMouseOut() {
                  return onBlur(node);
                },
                fill: node.color || DEFAULT_NODE_COLOR,
                height: node.dy,
                width: nWidth }),
              !hideLabels && node.name && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'text',
                {
                  textAnchor: node.x < width / 2 ? 'start' : 'end',
                  dy: '.35em',
                  x: node.x < width / 2 ? nWidth + 10 : -10,
                  y: node.dy / 2
                },
                node.name
              )
            );
          }),
          hasVoronoi && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__plot_voronoi__["a" /* default */], {
            className: 'rv-sankey__voronoi',
            extent: [[-margin, -margin], [width + margin, height + margin]],
            nodes: nodes,
            onBlur: onBlur,
            onClick: _onClick,
            onHover: onHover,
            x: function x(d) {
              return d.x + d.dx / 2;
            },
            y: function y(d) {
              return d.y + d.dy / 2;
            }
          })
        )
      );
    }
  }]);

  return Sankey;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Sankey.defaultProps = {
  align: 'justify',
  className: '',
  hasVoronoi: false,
  hideLabels: false,
  layout: 50,
  margin: 20,
  nodePadding: 10,
  nodeWidth: 10,
  onBlur: NOOP,
  onClick: NOOP,
  onHover: NOOP
};
Sankey.propTypes = {
  align: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['justify', 'left', 'right', 'center']),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  hasVoronoi: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  hideLabels: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  layout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  links: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    source: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
    target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
  })).isRequired,
  margin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  nodePadding: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  nodes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,
  nodeWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onHover: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Sankey);

/***/ }),
/* 1293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_hierarchy__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_scale__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__animation__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plot_series_label_series__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plot_series_arc_series__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plot_xy_plot__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_series_utils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_chart_utils__ = __webpack_require__(162);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.














var predefinedClassName = 'rv-sunburst';

/**
 * Create the list of nodes to render.
 * @param {Object} props
   props.data {Object} - tree structured data (each node has a name anc an array of children)
   props.height {number} - the height of the graphic to be rendered
   props.hideRootNode {boolean} - whether or not to hide the root node
   props.width {number} - the width of the graphic to be rendered
 * @returns {Array} Array of nodes.
 */
function getNodesToRender(_ref) {
  var data = _ref.data,
      height = _ref.height,
      hideRootNode = _ref.hideRootNode,
      width = _ref.width;

  var partitionFunction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_d3_hierarchy__["a" /* partition */])();
  var structuredInput = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_d3_hierarchy__["b" /* hierarchy */])(data).sum(function (d) {
    return d.size;
  });
  var radius = Math.min(width, height) / 2 - 10;
  var x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_d3_scale__["a" /* scaleLinear */])().range([0, 2 * Math.PI]);
  var y = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_d3_scale__["g" /* scaleSqrt */])().range([0, radius]);

  return partitionFunction(structuredInput).descendants().reduce(function (res, cell, index) {
    if (hideRootNode && index === 0) {
      return res;
    }

    return res.concat([_extends({
      angle0: Math.max(0, Math.min(2 * Math.PI, x(cell.x0))),
      angle: Math.max(0, Math.min(2 * Math.PI, x(cell.x1))),
      radius0: Math.max(0, y(cell.y0)),
      radius: Math.max(0, y(cell.y1)),
      depth: cell.depth,
      parent: cell.parent
    }, cell.data)]);
  }, []);
}

/**
 * Convert arc nodes into label rows.
 * Important to use mappedData rather than regular data, bc it is already unrolled
 * @param {Array} mappedData - Array of nodes.
 * @returns {Array} array of node for rendering as labels
 */
function buildLabels(mappedData) {
  return mappedData.filter(function (row) {
    return row.label;
  }).map(function (row) {
    var truedAngle = -1 * row.angle + Math.PI / 2;
    var truedAngle0 = -1 * row.angle0 + Math.PI / 2;
    var angle = (truedAngle0 + truedAngle) / 2;
    return _extends({}, row, {
      children: null,
      angle: null,
      radius: null,
      x: row.radius * Math.cos(angle),
      y: row.radius * Math.sin(angle),
      style: row.labelStyle
    });
  });
}

var Sunburst = function (_React$Component) {
  _inherits(Sunburst, _React$Component);

  function Sunburst() {
    _classCallCheck(this, Sunburst);

    return _possibleConstructorReturn(this, (Sunburst.__proto__ || Object.getPrototypeOf(Sunburst)).apply(this, arguments));
  }

  _createClass(Sunburst, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          animation = _props.animation,
          className = _props.className,
          children = _props.children,
          data = _props.data,
          height = _props.height,
          hideRootNode = _props.hideRootNode,
          width = _props.width,
          colorType = _props.colorType;

      var mappedData = getNodesToRender({ data: data, height: height, hideRootNode: hideRootNode, width: width });
      var radialDomain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_series_utils__["a" /* getRadialDomain */])(mappedData);
      var margin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_chart_utils__["a" /* getRadialLayoutMargin */])(width, height, radialDomain);

      var labelData = buildLabels(mappedData);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__plot_xy_plot__["a" /* default */],
        {
          height: height,
          width: width,
          className: predefinedClassName + ' ' + className,
          margin: margin,
          xDomain: [-radialDomain, radialDomain],
          yDomain: [-radialDomain, radialDomain] },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__plot_series_arc_series__["a" /* default */], _extends({
          colorType: colorType
        }, this.props, {
          animation: animation,
          radiusDomain: [0, radialDomain],
          // need to present a stripped down version for interpolation
          data: animation ? mappedData.map(function (row) {
            return _extends({}, row, { parent: null, children: null });
          }) : mappedData,
          _data: animation ? mappedData : null,
          arcClassName: predefinedClassName + '__series--radial__arc'
        })),
        labelData.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__plot_series_label_series__["a" /* default */], { data: labelData }),
        children
      );
    }
  }]);

  return Sunburst;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Sunburst.displayName = 'Sunburst';
Sunburst.propTypes = {
  animation: __WEBPACK_IMPORTED_MODULE_4__animation__["a" /* AnimationPropType */],
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  colorType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  hideRootNode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onValueClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onValueMouseOver: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onValueMouseOut: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};
Sunburst.defaultProps = {
  className: '',
  colorType: 'literal',
  hideRootNode: false
};

/* harmony default export */ __webpack_exports__["a"] = (Sunburst);

/***/ }),
/* 1294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_hierarchy__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__theme__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__animation__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_scales_utils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__treemap_leaf__ = __webpack_require__(1295);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.











var TREEMAP_TILE_MODES = {
  squarify: __WEBPACK_IMPORTED_MODULE_2_d3_hierarchy__["c" /* treemapSquarify */],
  resquarify: __WEBPACK_IMPORTED_MODULE_2_d3_hierarchy__["d" /* treemapResquarify */],
  slice: __WEBPACK_IMPORTED_MODULE_2_d3_hierarchy__["e" /* treemapSlice */],
  dice: __WEBPACK_IMPORTED_MODULE_2_d3_hierarchy__["f" /* treemapDice */],
  slicedice: __WEBPACK_IMPORTED_MODULE_2_d3_hierarchy__["g" /* treemapSliceDice */],
  binary: __WEBPACK_IMPORTED_MODULE_2_d3_hierarchy__["h" /* treemapBinary */]
};

var TREEMAP_LAYOUT_MODES = ['circlePack', 'partition', 'partition-pivot'];

var NOOP = function NOOP(d) {
  return d;
};

var ATTRIBUTES = ['opacity', 'color'];

/**
 * Get the map of scale functions from the given props.
 * @param {Object} props Props for the component.
 * @returns {Object} Map of scale functions.
 * @private
 */
function _getScaleFns(props) {
  var data = props.data;

  var allData = data.children || [];

  // Adding _allData property to the object to reuse the existing
  // getAttributeFunctor function.
  var compatibleProps = _extends({}, props, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_scales_utils__["b" /* getMissingScaleProps */])(props, allData, ATTRIBUTES), {
    _allData: allData
  });
  return {
    opacity: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_scales_utils__["c" /* getAttributeFunctor */])(compatibleProps, 'opacity'),
    color: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_scales_utils__["c" /* getAttributeFunctor */])(compatibleProps, 'color')
  };
}

var Treemap = function (_React$Component) {
  _inherits(Treemap, _React$Component);

  _createClass(Treemap, null, [{
    key: 'propTypes',
    get: function get() {
      return {
        animation: __WEBPACK_IMPORTED_MODULE_4__animation__["a" /* AnimationPropType */],
        className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
        height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
        mode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(Object.keys(TREEMAP_TILE_MODES).concat(TREEMAP_LAYOUT_MODES)),
        onLeafClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
        onLeafMouseOver: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
        onLeafMouseOut: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
        useCirclePacking: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
        padding: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
        width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
      };
    }
  }, {
    key: 'defaultProps',
    get: function get() {
      return {
        className: '',
        colorRange: __WEBPACK_IMPORTED_MODULE_3__theme__["c" /* CONTINUOUS_COLOR_RANGE */],
        _colorValue: __WEBPACK_IMPORTED_MODULE_3__theme__["d" /* DEFAULT_COLOR */],
        data: {
          children: []
        },
        mode: 'squarify',
        onLeafClick: NOOP,
        onLeafMouseOver: NOOP,
        onLeafMouseOut: NOOP,
        opacityType: __WEBPACK_IMPORTED_MODULE_3__theme__["e" /* OPACITY_TYPE */],
        _opacityValue: __WEBPACK_IMPORTED_MODULE_3__theme__["a" /* DEFAULT_OPACITY */],
        padding: 1
      };
    }
  }]);

  function Treemap(props) {
    _classCallCheck(this, Treemap);

    var _this = _possibleConstructorReturn(this, (Treemap.__proto__ || Object.getPrototypeOf(Treemap)).call(this, props));

    _this.state = { scales: _getScaleFns(props) };
    return _this;
  }

  _createClass(Treemap, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.setState({ scales: _getScaleFns(props) });
    }

    /**
     * Create the list of nodes to render.
     * @returns {Array} Array of nodes.
     * @private
     */

  }, {
    key: '_getNodesToRender',
    value: function _getNodesToRender() {
      var _props = this.props,
          data = _props.data,
          height = _props.height,
          width = _props.width,
          mode = _props.mode,
          padding = _props.padding;

      if (data && (mode === 'partition' || mode === 'partition-pivot')) {
        var partitionFunction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_d3_hierarchy__["a" /* partition */])().size([width, height]).padding(padding);
        var structuredInput = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_d3_hierarchy__["b" /* hierarchy */])(data).sum(function (d) {
          return d.size;
        });
        var mappedNodes = partitionFunction(structuredInput).descendants();
        if (mode === 'partition-pivot') {
          return mappedNodes.map(function (node) {
            return _extends({}, node, {
              x0: node.y0,
              x1: node.y1,
              y0: node.x0,
              y1: node.x1
            });
          });
        }
        return mappedNodes;
      }
      if (data && mode === 'circlePack') {
        var packingFunction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_d3_hierarchy__["i" /* pack */])().size([width, height]).padding(padding);
        var _structuredInput = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_d3_hierarchy__["b" /* hierarchy */])(data).sort(function (a, b) {
          return a.size - b.size;
        }).sum(function (d) {
          return d.size;
        });
        return packingFunction(_structuredInput).descendants();
      }
      if (data) {
        var tileFn = TREEMAP_TILE_MODES[mode];
        var treemapingFunction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_d3_hierarchy__["j" /* treemap */])(tileFn).tile(tileFn).size([width, height]).padding(padding);
        var _structuredInput2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_d3_hierarchy__["b" /* hierarchy */])(data).sort(function (a, b) {
          return a.size - b.size;
        }).sum(function (d) {
          return d.size;
        });

        return treemapingFunction(_structuredInput2).descendants();
      }
      return [];
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          animation = _props2.animation,
          className = _props2.className,
          height = _props2.height,
          mode = _props2.mode,
          width = _props2.width;

      var nodes = this._getNodesToRender();
      var useCirclePacking = mode === 'circlePack';
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: 'rv-treemap ' + (useCirclePacking ? 'rv-treemap-circle-packed' : '') + ' ' + className,
          style: {
            width: width + 'px',
            height: height + 'px'
          } },
        nodes.map(function (node, index) {
          // throw out the rootest node
          if (!useCirclePacking && !index) {
            return null;
          }

          var nodeProps = _extends({
            animation: animation,
            node: node
          }, _this2.props, {
            x0: useCirclePacking ? node.x : node.x0,
            x1: useCirclePacking ? node.x : node.x1,
            y0: useCirclePacking ? node.y : node.y0,
            y1: useCirclePacking ? node.y : node.y1,
            r: useCirclePacking ? node.r : 1,
            scales: _this2.state.scales
          });
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__treemap_leaf__["a" /* default */], _extends({}, nodeProps, { key: 'leaf-' + index }));
        })
      );
    }
  }]);

  return Treemap;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Treemap.displayName = 'Treemap';

/* harmony default export */ __webpack_exports__["a"] = (Treemap);

/***/ }),
/* 1295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__animation__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__ = __webpack_require__(25);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.








var ANIMATED_PROPS = ['colorRange', 'colorDomain', 'color', 'opacityRange', 'opacityDomain', 'opacity', 'x0', 'x1', 'y0', 'y1', 'r'];

var TreemapLeaf = function (_React$Component) {
  _inherits(TreemapLeaf, _React$Component);

  function TreemapLeaf() {
    _classCallCheck(this, TreemapLeaf);

    return _possibleConstructorReturn(this, (TreemapLeaf.__proto__ || Object.getPrototypeOf(TreemapLeaf)).apply(this, arguments));
  }

  _createClass(TreemapLeaf, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          animation = _props.animation,
          mode = _props.mode,
          node = _props.node,
          onLeafClick = _props.onLeafClick,
          onLeafMouseOver = _props.onLeafMouseOver,
          onLeafMouseOut = _props.onLeafMouseOut,
          r = _props.r,
          scales = _props.scales,
          x0 = _props.x0,
          x1 = _props.x1,
          y0 = _props.y0,
          y1 = _props.y1;


      if (animation) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__animation__["b" /* default */],
          _extends({}, this.props, { animatedProps: ANIMATED_PROPS }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TreemapLeaf, _extends({}, this.props, { animation: null }))
        );
      }
      var useCirclePacking = mode === 'circlePack';
      var background = scales.color(node);
      var opacity = scales.opacity(node);
      var color = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["d" /* getFontColorFromBackground */])(background);
      var title = node.data.title;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: 'rv-treemap__leaf ' + (useCirclePacking ? 'rv-treemap__leaf--circle' : ''),
          onMouseEnter: function onMouseEnter(event) {
            return onLeafMouseOver(node, event);
          },
          onMouseLeave: function onMouseLeave(event) {
            return onLeafMouseOut(node, event);
          },
          onClick: function onClick(event) {
            return onLeafClick(node, event);
          },
          style: {
            top: useCirclePacking ? y0 - r : y0,
            left: useCirclePacking ? x0 - r : x0,
            width: useCirclePacking ? r * 2 : x1 - x0,
            height: useCirclePacking ? r * 2 : y1 - y0,
            background: background,
            opacity: opacity,
            color: color
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'rv-treemap__leaf__content' },
          title
        )
      );
    }
  }], [{
    key: 'propTypes',
    get: function get() {
      return {
        animation: __WEBPACK_IMPORTED_MODULE_2__animation__["a" /* AnimationPropType */],
        height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
        mode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
        onLeafClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
        onLeafMouseOver: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
        onLeafMouseOut: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
        scales: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
        width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
        r: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
        x0: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
        x1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
        y0: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
        y1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
      };
    }
  }]);

  return TreemapLeaf;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (TreemapLeaf);

/***/ }),
/* 1296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getObjectValueAccessor */
/* harmony export (immutable) */ __webpack_exports__["b"] = getUniquePropertyValues;
/* harmony export (immutable) */ __webpack_exports__["a"] = addValueToArray;
// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

/**
 * Get the value accessor function that gets a property from an object.
 * @param {string} propertyName Property name.
 * @returns {Function} Value accessor.
 */
function getObjectValueAccessor(propertyName) {
  return function (obj) {
    return obj[propertyName];
  };
}

/**
 * Get unique property values from an array.
 * @param {Array} arr Array of data.
 * @param {string} propertyName Prop name.
 * @returns {Array} Array of unique values.
 */
function getUniquePropertyValues(arr, propertyName) {
  var setOfValues = new Set(arr.map(getObjectValueAccessor(propertyName)));
  return Array.from(setOfValues);
}

/**
 * Add zero to the domain.
 * @param {Array} arr Add zero to the domain.
 * @param {Number} value Add zero to domain.
 * @returns {Array} Adjusted domain.
 */
function addValueToArray(arr, value) {
  var result = [].concat(arr);
  if (result[0] > value) {
    result[0] = value;
  }
  if (result[result.length - 1] < value) {
    result[result.length - 1] = value;
  }
  return result;
}

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(87);

var invariant = __webpack_require__(4);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var PooledClass = __webpack_require__(1298);
var ReactElement = __webpack_require__(86);

var emptyFunction = __webpack_require__(30);
var traverseAllChildren = __webpack_require__(1309);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(87),
    _assign = __webpack_require__(10);

var ReactComponent = __webpack_require__(282);
var ReactElement = __webpack_require__(86);
var ReactPropTypeLocationNames = __webpack_require__(1302);
var ReactNoopUpdateQueue = __webpack_require__(283);

var emptyObject = __webpack_require__(74);
var invariant = __webpack_require__(4);
var warning = __webpack_require__(6);

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

/**
 * Policies that describe methods in `ReactClassInterface`.
 */


var injectedMixins = [];

/**
 * Composite components are higher-level components that compose other composite
 * or host components.
 *
 * To create a new type of `ReactClass`, pass a specification of
 * your new class to `React.createClass`. The only requirement of your class
 * specification is that you implement a `render` method.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return <div>Hello World</div>;
 *     }
 *   });
 *
 * The class specification supports a specific protocol of methods that have
 * special meaning (e.g. `render`). See `ReactClassInterface` for
 * more the comprehensive protocol. Any other properties and methods in the
 * class specification will be available on the prototype.
 *
 * @interface ReactClassInterface
 * @internal
 */
var ReactClassInterface = {

  /**
   * An array of Mixin objects to include when defining your component.
   *
   * @type {array}
   * @optional
   */
  mixins: 'DEFINE_MANY',

  /**
   * An object containing properties and methods that should be defined on
   * the component's constructor instead of its prototype (static methods).
   *
   * @type {object}
   * @optional
   */
  statics: 'DEFINE_MANY',

  /**
   * Definition of prop types for this component.
   *
   * @type {object}
   * @optional
   */
  propTypes: 'DEFINE_MANY',

  /**
   * Definition of context types for this component.
   *
   * @type {object}
   * @optional
   */
  contextTypes: 'DEFINE_MANY',

  /**
   * Definition of context types this component sets for its children.
   *
   * @type {object}
   * @optional
   */
  childContextTypes: 'DEFINE_MANY',

  // ==== Definition methods ====

  /**
   * Invoked when the component is mounted. Values in the mapping will be set on
   * `this.props` if that prop is not specified (i.e. using an `in` check).
   *
   * This method is invoked before `getInitialState` and therefore cannot rely
   * on `this.state` or use `this.setState`.
   *
   * @return {object}
   * @optional
   */
  getDefaultProps: 'DEFINE_MANY_MERGED',

  /**
   * Invoked once before the component is mounted. The return value will be used
   * as the initial value of `this.state`.
   *
   *   getInitialState: function() {
   *     return {
   *       isOn: false,
   *       fooBaz: new BazFoo()
   *     }
   *   }
   *
   * @return {object}
   * @optional
   */
  getInitialState: 'DEFINE_MANY_MERGED',

  /**
   * @return {object}
   * @optional
   */
  getChildContext: 'DEFINE_MANY_MERGED',

  /**
   * Uses props from `this.props` and state from `this.state` to render the
   * structure of the component.
   *
   * No guarantees are made about when or how often this method is invoked, so
   * it must not have side effects.
   *
   *   render: function() {
   *     var name = this.props.name;
   *     return <div>Hello, {name}!</div>;
   *   }
   *
   * @return {ReactComponent}
   * @required
   */
  render: 'DEFINE_ONCE',

  // ==== Delegate methods ====

  /**
   * Invoked when the component is initially created and about to be mounted.
   * This may have side effects, but any external subscriptions or data created
   * by this method must be cleaned up in `componentWillUnmount`.
   *
   * @optional
   */
  componentWillMount: 'DEFINE_MANY',

  /**
   * Invoked when the component has been mounted and has a DOM representation.
   * However, there is no guarantee that the DOM node is in the document.
   *
   * Use this as an opportunity to operate on the DOM when the component has
   * been mounted (initialized and rendered) for the first time.
   *
   * @param {DOMElement} rootNode DOM element representing the component.
   * @optional
   */
  componentDidMount: 'DEFINE_MANY',

  /**
   * Invoked before the component receives new props.
   *
   * Use this as an opportunity to react to a prop transition by updating the
   * state using `this.setState`. Current props are accessed via `this.props`.
   *
   *   componentWillReceiveProps: function(nextProps, nextContext) {
   *     this.setState({
   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
   *     });
   *   }
   *
   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
   * transition may cause a state change, but the opposite is not true. If you
   * need it, you are probably looking for `componentWillUpdate`.
   *
   * @param {object} nextProps
   * @optional
   */
  componentWillReceiveProps: 'DEFINE_MANY',

  /**
   * Invoked while deciding if the component should be updated as a result of
   * receiving new props, state and/or context.
   *
   * Use this as an opportunity to `return false` when you're certain that the
   * transition to the new props/state/context will not require a component
   * update.
   *
   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
   *     return !equal(nextProps, this.props) ||
   *       !equal(nextState, this.state) ||
   *       !equal(nextContext, this.context);
   *   }
   *
   * @param {object} nextProps
   * @param {?object} nextState
   * @param {?object} nextContext
   * @return {boolean} True if the component should update.
   * @optional
   */
  shouldComponentUpdate: 'DEFINE_ONCE',

  /**
   * Invoked when the component is about to update due to a transition from
   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
   * and `nextContext`.
   *
   * Use this as an opportunity to perform preparation before an update occurs.
   *
   * NOTE: You **cannot** use `this.setState()` in this method.
   *
   * @param {object} nextProps
   * @param {?object} nextState
   * @param {?object} nextContext
   * @param {ReactReconcileTransaction} transaction
   * @optional
   */
  componentWillUpdate: 'DEFINE_MANY',

  /**
   * Invoked when the component's DOM representation has been updated.
   *
   * Use this as an opportunity to operate on the DOM when the component has
   * been updated.
   *
   * @param {object} prevProps
   * @param {?object} prevState
   * @param {?object} prevContext
   * @param {DOMElement} rootNode DOM element representing the component.
   * @optional
   */
  componentDidUpdate: 'DEFINE_MANY',

  /**
   * Invoked when the component is about to be removed from its parent and have
   * its DOM representation destroyed.
   *
   * Use this as an opportunity to deallocate any external resources.
   *
   * NOTE: There is no `componentDidUnmount` since your component will have been
   * destroyed by that point.
   *
   * @optional
   */
  componentWillUnmount: 'DEFINE_MANY',

  // ==== Advanced methods ====

  /**
   * Updates the component's currently mounted DOM representation.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   * @overridable
   */
  updateComponent: 'OVERRIDE_BASE'

};

/**
 * Mapping from class specification keys to special processing functions.
 *
 * Although these are declared like instance properties in the specification
 * when defining classes using `React.createClass`, they are actually static
 * and are accessible on the constructor instead of the prototype. Despite
 * being static, they must be defined outside of the "statics" key under
 * which all other static methods are defined.
 */
var RESERVED_SPEC_KEYS = {
  displayName: function (Constructor, displayName) {
    Constructor.displayName = displayName;
  },
  mixins: function (Constructor, mixins) {
    if (mixins) {
      for (var i = 0; i < mixins.length; i++) {
        mixSpecIntoComponent(Constructor, mixins[i]);
      }
    }
  },
  childContextTypes: function (Constructor, childContextTypes) {
    if (false) {
      validateTypeDef(Constructor, childContextTypes, 'childContext');
    }
    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
  },
  contextTypes: function (Constructor, contextTypes) {
    if (false) {
      validateTypeDef(Constructor, contextTypes, 'context');
    }
    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
  },
  /**
   * Special case getDefaultProps which should move into statics but requires
   * automatic merging.
   */
  getDefaultProps: function (Constructor, getDefaultProps) {
    if (Constructor.getDefaultProps) {
      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
    } else {
      Constructor.getDefaultProps = getDefaultProps;
    }
  },
  propTypes: function (Constructor, propTypes) {
    if (false) {
      validateTypeDef(Constructor, propTypes, 'prop');
    }
    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
  },
  statics: function (Constructor, statics) {
    mixStaticSpecIntoComponent(Constructor, statics);
  },
  autobind: function () {} };

function validateTypeDef(Constructor, typeDef, location) {
  for (var propName in typeDef) {
    if (typeDef.hasOwnProperty(propName)) {
      // use a warning instead of an invariant so components
      // don't show up in prod but only in __DEV__
       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
    }
  }
}

function validateMethodOverride(isAlreadyDefined, name) {
  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;

  // Disallow overriding of base class methods unless explicitly allowed.
  if (ReactClassMixin.hasOwnProperty(name)) {
    !(specPolicy === 'OVERRIDE_BASE') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
  }

  // Disallow defining methods more than once unless explicitly allowed.
  if (isAlreadyDefined) {
    !(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
  }
}

/**
 * Mixin helper which handles policy validation and reserved
 * specification keys when building React classes.
 */
function mixSpecIntoComponent(Constructor, spec) {
  if (!spec) {
    if (false) {
      var typeofSpec = typeof spec;
      var isMixinValid = typeofSpec === 'object' && spec !== null;

      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
    }

    return;
  }

  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;

  var proto = Constructor.prototype;
  var autoBindPairs = proto.__reactAutoBindPairs;

  // By handling mixins before any other properties, we ensure the same
  // chaining order is applied to methods with DEFINE_MANY policy, whether
  // mixins are listed before or after these methods in the spec.
  if (spec.hasOwnProperty(MIXINS_KEY)) {
    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
  }

  for (var name in spec) {
    if (!spec.hasOwnProperty(name)) {
      continue;
    }

    if (name === MIXINS_KEY) {
      // We have already handled mixins in a special case above.
      continue;
    }

    var property = spec[name];
    var isAlreadyDefined = proto.hasOwnProperty(name);
    validateMethodOverride(isAlreadyDefined, name);

    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
      RESERVED_SPEC_KEYS[name](Constructor, property);
    } else {
      // Setup methods on prototype:
      // The following member methods should not be automatically bound:
      // 1. Expected ReactClass methods (in the "interface").
      // 2. Overridden methods (that were mixed in).
      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
      var isFunction = typeof property === 'function';
      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;

      if (shouldAutoBind) {
        autoBindPairs.push(name, property);
        proto[name] = property;
      } else {
        if (isAlreadyDefined) {
          var specPolicy = ReactClassInterface[name];

          // These cases should already be caught by validateMethodOverride.
          !(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY')) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;

          // For methods which are defined more than once, call the existing
          // methods before calling the new property, merging if appropriate.
          if (specPolicy === 'DEFINE_MANY_MERGED') {
            proto[name] = createMergedResultFunction(proto[name], property);
          } else if (specPolicy === 'DEFINE_MANY') {
            proto[name] = createChainedFunction(proto[name], property);
          }
        } else {
          proto[name] = property;
          if (false) {
            // Add verbose displayName to the function, which helps when looking
            // at profiling tools.
            if (typeof property === 'function' && spec.displayName) {
              proto[name].displayName = spec.displayName + '_' + name;
            }
          }
        }
      }
    }
  }
}

function mixStaticSpecIntoComponent(Constructor, statics) {
  if (!statics) {
    return;
  }
  for (var name in statics) {
    var property = statics[name];
    if (!statics.hasOwnProperty(name)) {
      continue;
    }

    var isReserved = name in RESERVED_SPEC_KEYS;
    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;

    var isInherited = name in Constructor;
    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
    Constructor[name] = property;
  }
}

/**
 * Merge two objects, but throw if both contain the same key.
 *
 * @param {object} one The first object, which is mutated.
 * @param {object} two The second object
 * @return {object} one after it has been mutated to contain everything in two.
 */
function mergeIntoWithNoDuplicateKeys(one, two) {
  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;

  for (var key in two) {
    if (two.hasOwnProperty(key)) {
      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
      one[key] = two[key];
    }
  }
  return one;
}

/**
 * Creates a function that invokes two functions and merges their return values.
 *
 * @param {function} one Function to invoke first.
 * @param {function} two Function to invoke second.
 * @return {function} Function that invokes the two argument functions.
 * @private
 */
function createMergedResultFunction(one, two) {
  return function mergedResult() {
    var a = one.apply(this, arguments);
    var b = two.apply(this, arguments);
    if (a == null) {
      return b;
    } else if (b == null) {
      return a;
    }
    var c = {};
    mergeIntoWithNoDuplicateKeys(c, a);
    mergeIntoWithNoDuplicateKeys(c, b);
    return c;
  };
}

/**
 * Creates a function that invokes two functions and ignores their return vales.
 *
 * @param {function} one Function to invoke first.
 * @param {function} two Function to invoke second.
 * @return {function} Function that invokes the two argument functions.
 * @private
 */
function createChainedFunction(one, two) {
  return function chainedFunction() {
    one.apply(this, arguments);
    two.apply(this, arguments);
  };
}

/**
 * Binds a method to the component.
 *
 * @param {object} component Component whose method is going to be bound.
 * @param {function} method Method to be bound.
 * @return {function} The bound method.
 */
function bindAutoBindMethod(component, method) {
  var boundMethod = method.bind(component);
  if (false) {
    boundMethod.__reactBoundContext = component;
    boundMethod.__reactBoundMethod = method;
    boundMethod.__reactBoundArguments = null;
    var componentName = component.constructor.displayName;
    var _bind = boundMethod.bind;
    boundMethod.bind = function (newThis) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      // User is trying to bind() an autobound method; we effectively will
      // ignore the value of "this" that the user is trying to use, so
      // let's warn.
      if (newThis !== component && newThis !== null) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
      } else if (!args.length) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
        return boundMethod;
      }
      var reboundMethod = _bind.apply(boundMethod, arguments);
      reboundMethod.__reactBoundContext = component;
      reboundMethod.__reactBoundMethod = method;
      reboundMethod.__reactBoundArguments = args;
      return reboundMethod;
    };
  }
  return boundMethod;
}

/**
 * Binds all auto-bound methods in a component.
 *
 * @param {object} component Component whose method is going to be bound.
 */
function bindAutoBindMethods(component) {
  var pairs = component.__reactAutoBindPairs;
  for (var i = 0; i < pairs.length; i += 2) {
    var autoBindKey = pairs[i];
    var method = pairs[i + 1];
    component[autoBindKey] = bindAutoBindMethod(component, method);
  }
}

/**
 * Add more to the ReactClass base class. These are all legacy features and
 * therefore not already part of the modern ReactComponent.
 */
var ReactClassMixin = {

  /**
   * TODO: This will be deprecated because state should always keep a consistent
   * type signature and the only use case for this, is to avoid that.
   */
  replaceState: function (newState, callback) {
    this.updater.enqueueReplaceState(this, newState);
    if (callback) {
      this.updater.enqueueCallback(this, callback, 'replaceState');
    }
  },

  /**
   * Checks whether or not this composite component is mounted.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function () {
    return this.updater.isMounted(this);
  }
};

var ReactClassComponent = function () {};
_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);

var didWarnDeprecated = false;

/**
 * Module for creating composite components.
 *
 * @class ReactClass
 */
var ReactClass = {

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  createClass: function (spec) {
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(didWarnDeprecated, '%s: React.createClass is deprecated and will be removed in version 16. ' + 'Use plain JavaScript classes instead. If you\'re not yet ready to ' + 'migrate, create-react-class is available on npm as a ' + 'drop-in replacement.', spec && spec.displayName || 'A Component') : void 0;
      didWarnDeprecated = true;
    }

    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function (props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (initialState === undefined && this.getInitialState._isMockFunction) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, spec);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  },

  injection: {
    injectMixin: function (mixin) {
      injectedMixins.push(mixin);
    }
  }

};

module.exports = ReactClass;

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactElement = __webpack_require__(86);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 * This is also accessible via `React.DOM`.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactPropTypeLocationNames = {};

if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
}

module.exports = ReactPropTypeLocationNames;

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _require = __webpack_require__(86),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(528);

module.exports = factory(isValidElement);

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(10);

var ReactComponent = __webpack_require__(282);
var ReactNoopUpdateQueue = __webpack_require__(283);

var emptyObject = __webpack_require__(74);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = ReactPureComponent;

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.5.4';

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var nextDebugID = 1;

function getNextDebugID() {
  return nextDebugID++;
}

module.exports = getNextDebugID;

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */


var _prodInvariant = __webpack_require__(87);

var ReactElement = __webpack_require__(86);

var invariant = __webpack_require__(4);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(87);

var ReactCurrentOwner = __webpack_require__(48);
var REACT_ELEMENT_TYPE = __webpack_require__(623);

var getIteratorFn = __webpack_require__(1306);
var invariant = __webpack_require__(4);
var KeyEscapeUtils = __webpack_require__(1297);
var warning = __webpack_require__(6);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.reduxLogger=e.reduxLogger||{})}(this,function(e){"use strict";function t(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function n(e,t,r){n.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:r,enumerable:!0})}function o(e,t){o.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function i(e,t){i.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function a(e,t,r){a.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:r,enumerable:!0})}function f(e,t,r){var n=e.slice((r||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,n),e}function u(e){var t="undefined"==typeof e?"undefined":N(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function l(e,t,r,c,s,d,p){s=s||[],p=p||[];var g=s.slice(0);if("undefined"!=typeof d){if(c){if("function"==typeof c&&c(g,d))return;if("object"===("undefined"==typeof c?"undefined":N(c))){if(c.prefilter&&c.prefilter(g,d))return;if(c.normalize){var h=c.normalize(g,d,e,t);h&&(e=h[0],t=h[1])}}}g.push(d)}"regexp"===u(e)&&"regexp"===u(t)&&(e=e.toString(),t=t.toString());var y="undefined"==typeof e?"undefined":N(e),v="undefined"==typeof t?"undefined":N(t),b="undefined"!==y||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),m="undefined"!==v||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&m)r(new o(g,t));else if(!m&&b)r(new i(g,e));else if(u(e)!==u(t))r(new n(g,e,t));else if("date"===u(e)&&e-t!==0)r(new n(g,e,t));else if("object"===y&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&r(new n(g,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var w;e.length;for(w=0;w<e.length;w++)w>=t.length?r(new a(g,w,new i(void 0,e[w]))):l(e[w],t[w],r,c,g,w,p);for(;w<t.length;)r(new a(g,w,new o(void 0,t[w++])))}else{var x=Object.keys(e),S=Object.keys(t);x.forEach(function(n,o){var i=S.indexOf(n);i>=0?(l(e[n],t[n],r,c,g,n,p),S=f(S,i)):l(e[n],void 0,r,c,g,n,p)}),S.forEach(function(e){l(void 0,t[e],r,c,g,e,p)})}p.length=p.length-1}else e!==t&&("number"===y&&isNaN(e)&&isNaN(t)||r(new n(g,e,t)))}function c(e,t,r,n){return n=n||[],l(e,t,function(e){e&&n.push(e)},r),n.length?n:void 0}function s(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":s(o[r.path[n]],r.index,r.item);break;case"D":delete o[r.path[n]];break;case"E":case"N":o[r.path[n]]=r.rhs}}else switch(r.kind){case"A":s(e[t],r.index,r.item);break;case"D":e=f(e,t);break;case"E":case"N":e[t]=r.rhs}return e}function d(e,t,r){if(e&&t&&r&&r.kind){for(var n=e,o=-1,i=r.path?r.path.length-1:0;++o<i;)"undefined"==typeof n[r.path[o]]&&(n[r.path[o]]="number"==typeof r.path[o]?[]:{}),n=n[r.path[o]];switch(r.kind){case"A":s(r.path?n[r.path[o]]:n,r.index,r.item);break;case"D":delete n[r.path[o]];break;case"E":case"N":n[r.path[o]]=r.rhs}}}function p(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":p(o[r.path[n]],r.index,r.item);break;case"D":o[r.path[n]]=r.lhs;break;case"E":o[r.path[n]]=r.lhs;break;case"N":delete o[r.path[n]]}}else switch(r.kind){case"A":p(e[t],r.index,r.item);break;case"D":e[t]=r.lhs;break;case"E":e[t]=r.lhs;break;case"N":e=f(e,t)}return e}function g(e,t,r){if(e&&t&&r&&r.kind){var n,o,i=e;for(o=r.path.length-1,n=0;n<o;n++)"undefined"==typeof i[r.path[n]]&&(i[r.path[n]]={}),i=i[r.path[n]];switch(r.kind){case"A":p(i[r.path[n]],r.index,r.item);break;case"D":i[r.path[n]]=r.lhs;break;case"E":i[r.path[n]]=r.lhs;break;case"N":delete i[r.path[n]]}}}function h(e,t,r){if(e&&t){var n=function(n){r&&!r(e,t,n)||d(e,t,n)};l(e,t,n)}}function y(e){return"color: "+F[e].color+"; font-weight: bold"}function v(e){var t=e.kind,r=e.path,n=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[r.join("."),n,"→",o];case"N":return[r.join("."),o];case"D":return[r.join(".")];case"A":return[r.join(".")+"["+i+"]",a];default:return[]}}function b(e,t,r,n){var o=c(e,t);try{n?r.groupCollapsed("diff"):r.group("diff")}catch(e){r.log("diff")}o?o.forEach(function(e){var t=e.kind,n=v(e);r.log.apply(r,["%c "+F[t].text,y(t)].concat(P(n)))}):r.log("—— no diff ——");try{r.groupEnd()}catch(e){r.log("—— diff end —— ")}}function m(e,t,r,n){switch("undefined"==typeof e?"undefined":N(e)){case"object":return"function"==typeof e[n]?e[n].apply(e,P(r)):e[n];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,r=e.duration;return function(e,n,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+n),r&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var r=t.logger,n=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,f=t.colors,u=t.level,l=t.diff,c="undefined"==typeof t.titleFormatter;e.forEach(function(o,s){var d=o.started,p=o.startedTime,g=o.action,h=o.prevState,y=o.error,v=o.took,w=o.nextState,x=e[s+1];x&&(w=x.prevState,v=x.started-d);var S=n(g),k="function"==typeof a?a(function(){return w},g,o):a,j=D(p),E=f.title?"color: "+f.title(S)+";":"",A=["color: gray; font-weight: lighter;"];A.push(E),t.timestamp&&A.push("color: gray; font-weight: lighter;"),t.duration&&A.push("color: gray; font-weight: lighter;");var O=i(S,j,v);try{k?f.title&&c?r.groupCollapsed.apply(r,["%c "+O].concat(A)):r.groupCollapsed(O):f.title&&c?r.group.apply(r,["%c "+O].concat(A)):r.group(O)}catch(e){r.log(O)}var N=m(u,S,[h],"prevState"),P=m(u,S,[S],"action"),C=m(u,S,[y,h],"error"),F=m(u,S,[w],"nextState");if(N)if(f.prevState){var L="color: "+f.prevState(h)+"; font-weight: bold";r[N]("%c prev state",L,h)}else r[N]("prev state",h);if(P)if(f.action){var T="color: "+f.action(S)+"; font-weight: bold";r[P]("%c action    ",T,S)}else r[P]("action    ",S);if(y&&C)if(f.error){var M="color: "+f.error(y,h)+"; font-weight: bold;";r[C]("%c error     ",M,y)}else r[C]("error     ",y);if(F)if(f.nextState){var _="color: "+f.nextState(w)+"; font-weight: bold";r[F]("%c next state",_,w)}else r[F]("next state",w);l&&b(h,w,r,k);try{r.groupEnd()}catch(e){r.log("—— log end ——")}})}function S(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},L,e),r=t.logger,n=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,f=t.diffPredicate;if("undefined"==typeof r)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var u=[];return function(e){var r=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(r,l))return e(l);var c={};u.push(c),c.started=O.now(),c.startedTime=new Date,c.prevState=n(r()),c.action=l;var s=void 0;if(a)try{s=e(l)}catch(e){c.error=o(e)}else s=e(l);c.took=O.now()-c.started,c.nextState=n(r());var d=t.diff&&"function"==typeof f?f(r,l):t.diff;if(x(u,Object.assign({},t,{diff:d})),u.length=0,c.error)throw c.error;return s}}}}var k,j,E=function(e,t){return new Array(t+1).join(e)},A=function(e,t){return E("0",t-e.toString().length)+e},D=function(e){return A(e.getHours(),2)+":"+A(e.getMinutes(),2)+":"+A(e.getSeconds(),2)+"."+A(e.getMilliseconds(),3)},O="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},P=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},C=[];k="object"===("undefined"==typeof global?"undefined":N(global))&&global?global:"undefined"!=typeof window?window:{},j=k.DeepDiff,j&&C.push(function(){"undefined"!=typeof j&&k.DeepDiff===c&&(k.DeepDiff=j,j=void 0)}),t(n,r),t(o,r),t(i,r),t(a,r),Object.defineProperties(c,{diff:{value:c,enumerable:!0},observableDiff:{value:l,enumerable:!0},applyDiff:{value:h,enumerable:!0},applyChange:{value:d,enumerable:!0},revertChange:{value:g,enumerable:!0},isConflict:{value:function(){return"undefined"!=typeof j},enumerable:!0},noConflict:{value:function(){return C&&(C.forEach(function(e){e()}),C=null),c},enumerable:!0}});var F={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},L={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},T=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,r=e.getState;return"function"==typeof t||"function"==typeof r?S()({dispatch:t,getState:r}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};e.defaults=L,e.createLogger=S,e.logger=T,e.default=T,Object.defineProperty(e,"__esModule",{value:!0})});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)))

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;

/***/ }),
/* 1312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(625);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 1313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 1314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(627);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["b" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerSanity(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["b" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["b" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  if (false) {
    var unexpectedKeyCache = {};
  }

  var sanityError;
  try {
    assertReducerSanity(finalReducers);
  } catch (e) {
    sanityError = e;
  }

  return function combination() {
    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
    var action = arguments[1];

    if (sanityError) {
      throw sanityError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var i = 0; i < finalReducerKeys.length; i++) {
      var key = finalReducerKeys[i];
      var reducer = finalReducers[key];
      var previousStateForKey = state[key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(key, action);
        throw new Error(errorMessage);
      }
      nextState[key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsolute = function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
};

// About 1.5x faster than the two-arg version of Array#splice()
var spliceOne = function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }list.pop();
};

// This implementation is based heavily on node's url.parse
var resolvePathname = function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
};

module.exports = resolvePathname;

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1318);


/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ponyfill = __webpack_require__(1319);

var _ponyfill2 = _interopRequireDefault(_ponyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var root; /* global window */


if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = (0, _ponyfill2['default'])(root);
exports['default'] = result;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68), __webpack_require__(163)(module)))

/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports['default'] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),
/* 1320 */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  return  bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]];
}

module.exports = bytesToUuid;


/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
var rng;

var crypto = global.crypto || global.msCrypto; // for IE 11
if (crypto && crypto.getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16);
  rng = function whatwgRNG() {
    crypto.getRandomValues(rnds8);
    return rnds8;
  };
}

if (!rng) {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var  rnds = new Array(16);
  rng = function() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}

module.exports = rng;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)))

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(1321);
var bytesToUuid = __webpack_require__(1320);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options == 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var valueEqual = function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
    return valueEqual(item, b[index]);
  });

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
};

exports.default = valueEqual;

/***/ }),
/* 1324 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(628);
module.exports = __webpack_require__(629);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// js/app.js